webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_linkifyjs_html__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_linkifyjs_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_regex__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_regex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_domain_regex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_punycode__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_punycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_punycode__);








var Helper = {
	toFormData: function toFormData(obj, form, namespace) {
		var fd = form || new FormData();
		var formKey = void 0;

		for (var property in obj) {
			if (obj.hasOwnProperty(property) && obj[property] !== undefined && obj[property] !== null) {
				if (namespace) {
					formKey = namespace + '[' + property + ']';
				} else {
					formKey = property;
				}

				if (obj[property] instanceof Date) {
					fd.append(formKey, obj[property].toISOString());
				} else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj[property]) === 'object' && !(obj[property] instanceof File)) {
					this.toFormData(obj[property], fd, formKey);
				} else {
					fd.append(formKey, obj[property]);
				}
			}
		}

		return fd;
	},

	sortByProp: function sortByProp(row) {
		var sortName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'order';
		var needGenerate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var model = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

		var newRow = [];
		var num = 0;
		var tmp = void 0;
		var _deletedFields = [];

		var _genNum = 0;

		for (var field in row) {
			if (row.hasOwnProperty(field)) {
				if (/_delete$/i.test(field) && model !== 'TicketMessageUpdateForm') {
					_deletedFields.push(field);
					continue;
				}

				tmp = row[field];

				__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(tmp, '_field_name', field);
				__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(tmp, '_errMsg', '');
				__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(tmp, '_visible', true);
				__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(tmp, '_visibleRowNumber', 0);

				if (needGenerate === true) __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(tmp, sortName, _genNum++);

				if (!(sortName in row[field]) || !row[field][sortName]) {
					if (field === 'cps_email' && row[field]['type'] === 'email') {
						if (newRow[1] === undefined) newRow[1] = [];
						newRow[1].push(tmp);
					} else {
						if (newRow[0] === undefined) newRow[0] = [];
						newRow[0].push(tmp);
					}
				} else {
						num = row[field][sortName];
						if (newRow[num] === undefined) newRow[num] = [];
						newRow[num].push(tmp);
					}
			}
		}
		var _rowNum = 1;
		var _isVisible = false;
		for (var k = 0; k < newRow.length; k++) {
			_isVisible = false;

			if (newRow[k]) {
				for (var l = 0; l < newRow[k].length; l++) {
					newRow[k][l]['_row_count'] = newRow[k].length;

					if (_deletedFields.indexOf(newRow[k][l]['_field_name'] + '_delete') > -1) __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(newRow[k][l], '_canDelete', true);

					if (newRow[k][l]['type'] === 'boolean') {
						if ('value' in newRow[k][l]) newRow[k][l]['_oldValue'] = this.normalizeBooleanValue(newRow[k][l]['value']);else newRow[k][l]['_oldValue'] = false;
					}

					if (newRow[k][l]['type'] !== 'hidden') _isVisible = true;
				}

				if (newRow[k].length === 1 && (newRow[k][0]['type'] === 'money' || newRow[k][0]['type'] === 'float' || newRow[k][0]['type'] === 'int' || newRow[k][0]['type'] === 'integer')) {
					newRow[k][0]['_row_count'] = 4;

					for (var _i = 1; _i < 4; _i++) {
						newRow[k].push({
							'type': 'fake',
							'title': '',
							'readonly': true,
							'order': newRow[k][0].order,
							'_field_name': 'fake_' + k + '_' + _i,
							'_visible': true,
							'_row_count': 4
						});
					}
				}

				newRow[k][0]['_visibleRowNumber'] = _rowNum;
				if (_isVisible) _rowNum++;
			}
		}

		return newRow;
	},

	hideFakeFields: function hideFakeFields(fields) {
		fields.forEach(function (row) {
			if (row && Array.isArray(row) && row.length) {
				row.forEach(function (field) {
					if (field && field.type === 'fake') {
						field._visible = false;
					}
				});
			}
		});
	},

	unixTime: function unixTime(ext) {
		if (ext) return new Date().getTime();else return Math.floor(new Date().getTime() / 1000);
	},

	localeFtc: function localeFtc(str) {
		if (str === null || str === undefined || str === '') return '';

		return String(str).split(' ').map(function (s) {
			var m = s.match(/\w+\/\w+/);

			if (m !== null) return m in __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase && __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase[m] ? s.replace(m, __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase[m]) : s;

			return s in __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase && __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase[s] ? __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localeBase[s] : s;
		}).join(' ');
	},

	methodsToValue: function methodsToValue(value, methods) {
		var _value = value;

		if (methods && Array.isArray(methods)) {
			if (methods.indexOf('ftc') >= 0) _value = this.localeFtc(_value);
			if (methods.indexOf('lower') >= 0) {
				if (_value !== 'PKH') _value = _value.toLowerCase();
			}
		}

		return _value;
	},

	cellValue: function cellValue(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return '';
		var _value = row[field];
		return this.methodsToValue(_value, methods);
	},

	cellStatus: function cellStatus(field, row, raw) {
		var _extField = field + '_text';

		if (field === 'service_status') _extField = 'service_status_text';

		var _answer = {
			'loader': false,
			'timer': false,
			'status': ''
		};

		if (row[_extField]) {
			var _extValue = row[_extField].replace('request/status_processing', '').trim();

			_answer['status'] = this.localeFtc(_extValue).toLowerCase();
			_answer['loader'] = true;

			if (_extValue.indexOf('request/status_queue') > -1) {
				_extValue = _extValue.replace('request/status_queue', '').trim();
				_answer['status'] = this.localeFtc(_extValue).toLowerCase();
				_answer['loader'] = false;
				_answer['timer'] = true;
			}

			return _answer;
		}

		if (row[field] === null || row[field] === undefined) {
			_answer['status'] = 'unknown';
			return _answer;
		}
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) {
			_answer['status'] = row[field];
			return _answer;
		}

		var _list = raw['filters'][field]['list'];

		if ((typeof _list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_list)) === 'object' && row[field] in _list) _answer['status'] = raw['filters'][field]['list'][row[field]];else _answer['status'] = 'unknown';

		_answer['status'] = this.localeFtc(_answer['status']).toLowerCase();

		if (row[field] === 'processing') _answer['loader'] = true;

		return _answer;
	},

	cellStatusInView: function cellStatusInView(raw) {
		var _field = 'value';
		var _extField = 'text';

		var _answer = {
			'loader': false,
			'timer': false,
			'status': ''
		};

		if (raw[_extField]) {
			var _extValue = raw[_extField].replace('request/status_processing', '').trim();

			_answer['status'] = this.localeFtc(_extValue).toLowerCase();
			_answer['loader'] = true;

			if (_extValue.indexOf('request/status_queue') > -1) {
				_extValue = _extValue.replace('request/status_queue', '').trim();
				_answer['status'] = this.localeFtc(_extValue).toLowerCase();
				_answer['loader'] = false;
				_answer['timer'] = true;
			}

			return _answer;
		}

		if (raw[_field] === null || raw[_field] === undefined) {
			_answer['status'] = 'unknown';
			return _answer;
		}

		_answer['status'] = raw[_field];

		if (!raw['list'] || !raw['list'][_answer['status']]) return _answer;

		_answer['status'] = raw['list'][_answer['status']];
		_answer['status'] = this.localeFtc(_answer['status']).toLowerCase();

		if (raw[_field] === 'processing') _answer['loader'] = true;

		return _answer;
	},

	cellValueFromList: function cellValueFromList(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return '';
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field];

		var _value = '';
		var _list = raw['filters'][field]['list'];

		if ((typeof _list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_list)) === 'object' && row[field] in _list) _value = raw['filters'][field]['list'][row[field]];else _value = 'Unknown';

		return this.methodsToValue(_value, methods);
	},

	cellUserStatusValue: function cellUserStatusValue(row, raw, methods) {
		var field = 'user_status';
		var fieldText = 'user_status_text';

		if (!(field in row) || row[field] === undefined || row[field] === null) return '';

		if (fieldText in row && row[fieldText]) return this.methodsToValue(row[fieldText], methods);

		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field];

		var _value = '';
		var _list = raw['filters'][field]['list'];

		if ((typeof _list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_list)) === 'object' && row[field] in _list) _value = raw['filters'][field]['list'][row[field]];else _value = 'Unknown';

		return this.methodsToValue(_value, methods);
	},

	cellValueFromArrayObj: function cellValueFromArrayObj(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return '';
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field];

		var _value = '';
		var _list = raw['filters'][field]['list'];
		if ((typeof _list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_list)) === 'object' && Array.isArray(_list)) {
			_list.some(function (item) {
				if ('id' in item && 'name' in item && item['id'] === row[field]) {
					_value = item['name'];
					return true;
				}
			});
		} else _value = 'Unknown';

		return this.methodsToValue(_value, methods);
	},

	cellOperationPayment_Text: function cellOperationPayment_Text(row, raw, methods) {
		var _text1 = Helper.cellValueFromArrayObj('payment_id', row, raw);
		var _text2 = row.operation_comment;
		var _text3 = row.payer_name;

		var _value1 = _text1 !== null && _text1 !== undefined ? String(_text1).trim() : '';
		var _value2 = _text2 !== null && _text2 !== undefined ? String(_text2).trim() : '';
		var _value3 = _text3 !== null && _text3 !== undefined ? String(_text3).trim() : '';

		if (_value1 === '' && row['payment_name']) _value1 = row['payment_name'];

		var _value = _value1;
		if (_value2 !== '') {
			if (_value !== '') _value += '<br>' + _value2;else _value += _value2;
		}

		if (_value3 !== '') {
			if (_value !== '') _value += '<br>' + _value3;else _value += _value3;
		}

		return this.methodsToValue(_value, methods);
	},

	cellOperationPayment_Url: function cellOperationPayment_Url(row, raw) {
		var _url = '#';

		if (row.operation_status !== null && row.operation_status !== undefined && row.operation_status === 0 && __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user_type === 'client') {
			if (!('can_pay' in row) || !row.can_pay) _url = '/operation/view/' + row.operation_id;else _url = '/operation/view/' + row.operation_id;
		} else {
			_url = '/operation/view/' + row.operation_id;
		}

		return _url;
	},

	cellValueServiceTypeCost: function cellValueServiceTypeCost(row, raw, methods) {
		var _value = {};

		if (row['service_type_cost'] !== null && row['service_type_cost'] !== undefined) _value['cost'] = String(this.FormatMoney2(row['service_type_cost']));

		if (row['service_type_period'] && raw['filters']['service_type_period'] && raw['filters']['service_type_period']['list'] && raw['filters']['service_type_period']['list'][row['service_type_period']]) {
			_value['period'] = this.localeFtc(String(raw['filters']['service_type_period']['list'][row['service_type_period']]));
		}

		if (row['service_type_for']) {
			_value['for'] = '1 ' + this.localeFtc(String(row['service_type_for']));
		}

		return _value;
	},

	cellValuePlanCost: function cellValuePlanCost(row, raw) {
		var _value = {
			'cost': '0',
			'period': this.localeFtc('s/day')
		};

		if (row['plan_cost'] !== null && row['plan_cost'] !== undefined) _value['cost'] = String(this.FormatMoney2(row['plan_cost']));

		if (row['plan_period'] && raw['filters']['plan_period'] && raw['filters']['plan_period']['list'] && raw['filters']['plan_period']['list'][row['plan_period']]) _value['period'] = this.localeFtc(String(raw['filters']['plan_period']['list'][row['plan_period']]));

		return _value;
	},

	makeUrlForApi: function makeUrlForApi(url) {
		return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].APIServerUrl + url;
	},

	localGroupFromApiGroup: function localGroupFromApiGroup(groupId) {
		var group = 1;
		groupId = parseInt(groupId, 10);
		if (isNaN(groupId)) groupId = 0;

		if (groupId) {
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru') {
				if (groupId === 5) group = 1;else if (groupId === 12) group = 2;else if (groupId === 19) group = 3;else if (groupId === 17 || groupId === 18) group = 4;
			}

			if (window.location.host === 'cp.vdsina.ru' || window.location.host === 'cp.macloud.ru') {
				if (groupId === 1) group = 1;else if (groupId === 3) group = 2;else if (groupId === 4) group = 3;else if (groupId === 7 || groupId === 8) group = 4;
			}
		}

		return group;
	},

	postPonseDepartmentId: function postPonseDepartmentId() {
		var _depId = -1;

		if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru') {
			_depId = 13;
		}

		if (window.location.host === 'cpdev.macloud.ru') {
			_depId = 1;
		}

		if (window.location.host === 'cp.vdsina.ru') {
			_depId = 14;
		}

		if (window.location.host === 'cp.macloud.ru') {
			_depId = 10;
		}

		return _depId;
	},

	apiGroupFromLocalGroup: function apiGroupFromLocalGroup(group) {
		var groupId = null;
		group = parseInt(group, 10);
		if (isNaN(group)) group = 0;

		if (group) {
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru') {
				if (group === 1) groupId = 5;else if (group === 2) groupId = 12;else if (group === 3) groupId = 19;else if (group === 4) groupId = [17, 18];
			}

			if (window.location.host === 'cp.vdsina.ru' || window.location.host === 'cp.macloud.ru') {
				if (group === 1) groupId = 1;else if (group === 2) groupId = 3;else if (group === 3) groupId = 4;else if (group === 4) groupId = [7, 8];
			}
		}

		return groupId;
	},

	apiGroupFromOneGroup: function apiGroupFromOneGroup(id) {
		var groupId = null;
		id = parseInt(id, 10);
		if (isNaN(id)) id = 0;

		if (id) {
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru') {
				if ([17, 18].indexOf(id) > -1) groupId = [17, 18];else groupId = id;
			}

			if (window.location.host === 'cp.vdsina.ru') {
				if ([7, 8].indexOf(id) > -1) groupId = [7, 8];else groupId = id;
			}

			if (window.location.host === 'cp.vdsina.com' || window.location.host === 'cp.macloud.ru') {
				groupId = id;
			}
		}

		return groupId;
	},

	vdsGroupImage: function vdsGroupImage(row) {
		if (row && row.service_data && row.service_data.plangroup && row.service_data.plangroup.image) {
			return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].APIServerUrl + row.service_data.plangroup.image;
		}

		var path = '/static/img/vds/vds-';
		var group = '1';

		if (row && row.localGroupId) group = row.localGroupId;else if (row && row.group_id) group = this.localGroupFromApiGroup(row.group_id);

		return path + group + '.png';
	},

	vdsGroupImageTitle: function vdsGroupImageTitle(row, data) {
		var title = '';

		if (row && row.service_data && row.service_data.plangroup && row.service_data.plangroup.name) {
			return row.service_data.plangroup.name;
		}

		if (row && data && row.group_id && data.filters && data.filters.group_id && data.filters.group_id.list && data.filters.group_id.list.length) {
			data.filters.group_id.list.some(function (c) {
				if (c && c.id === row.group_id) {
					title = c.name;
					return true;
				}
			});
		}

		return title;
	},

	cellValueFromServiceData: function cellValueFromServiceData(field, row) {
		if (row['service_data'] === null || row['service_data'] === undefined) return '';

		if (field === 'template:image') {
			if (row['service_data'] !== null && row['service_data'] !== undefined && row['service_data']['template'] !== null && row['service_data']['template'] !== undefined && row['service_data']['template']['image'] !== null && row['service_data']['template']['image'] !== undefined) {
				var _url = row['service_data']['template']['image'];
				return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].APIServerUrl + (_url.charAt(0) === '/' ? _url : '/' + _url);
			}
		}

		if (field === 'ip:ip') {
			if (row['service_data'] !== null && row['service_data'] !== undefined && row['service_data']['ip'] !== null && row['service_data']['ip'] !== undefined && row['service_data']['ip']['ip'] !== null && row['service_data']['ip']['ip'] !== undefined) {
				return row['service_data']['ip']['ip'];
			}
		}

		if (field === 'ip:ip:active') {
			if (row['service_data'] !== null && row['service_data'] !== undefined && row['service_data']['ip'] !== null && row['service_data']['ip'] !== undefined && 'active' in row['service_data']['ip']) {
				return row['service_data']['ip']['active'];
			} else return true;
		}

		if (field === 'datacenter:country') {
			if (row['service_data'] !== null && row['service_data'] !== undefined && row['service_data']['datacenter'] !== null && row['service_data']['datacenter'] !== undefined && row['service_data']['datacenter']['country'] !== null && row['service_data']['datacenter']['country'] !== undefined) {
				return row['service_data']['datacenter']['country'];
			} else return 'null';
		}

		if (field === 'datacenter:name') {
			if (row['service_data'] !== null && row['service_data'] !== undefined && row['service_data']['datacenter'] !== null && row['service_data']['datacenter'] !== undefined && row['service_data']['datacenter']['name'] !== null && row['service_data']['datacenter']['name'] !== undefined) {
				return this.localeFtc(row['service_data']['datacenter']['name']);
			}
		}

		if (field === 'plan:data') {
			var _ram = '';
			var _cpu = '';
			var _disk = '';

			if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['data']) {
				if (row['service_data']['plan']['data']['ram']) {
					_ram = (row['service_data']['plan']['data']['ram']['total'] ? row['service_data']['plan']['data']['ram']['total'] : row['service_data']['plan']['data']['ram']['value']) + ' ' + row['service_data']['plan']['data']['ram']['for'] + ' ' + this.localeFtc(row['service_data']['plan']['data']['ram']['title']);
				}

				if (row['service_data']['plan']['data']['cpu']) {
					_cpu = (row['service_data']['plan']['data']['cpu']['total'] ? row['service_data']['plan']['data']['cpu']['total'] : row['service_data']['plan']['data']['cpu']['value']) + ' ' + row['service_data']['plan']['data']['cpu']['for'] + ' ' + this.localeFtc(row['service_data']['plan']['data']['cpu']['title']);
				}

				if (row['service_data']['plan']['data']['disk']) {
					_disk = (row['service_data']['plan']['data']['disk']['total'] ? row['service_data']['plan']['data']['disk']['total'] : row['service_data']['plan']['data']['disk']['value']) + ' ' + row['service_data']['plan']['data']['disk']['for'] + ' ' + this.localeFtc(row['service_data']['plan']['data']['disk']['title']);
				}
			}

			return _ram + ' / ' + _cpu + ' / ' + _disk;
		}

		return '';
	},

	FormatMoney: function FormatMoney(value) {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	},

	FormatMoney2: function FormatMoney2(money) {
		var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
		var grp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
		var del = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

		var _money = money;
		if (typeof money !== 'number') _money = Number(money);
		if (_money === null || _money === undefined || isNaN(_money)) return money;

		_money = parseFloat(_money.toFixed(4));

		var _str = void 0;
		if (places < 0) {
			_str = String(_money);
		} else _str = String(_money.toFixed(places));

		if (_str.trim() === '') return '';

		if (this.SmallAmounts) {
			if (places >= 0 && _money !== 0) {
				_str = String(_money.toFixed(4));
				if (_str.slice(-1) === '0' && places < 4) {
					_str = String(_money.toFixed(3));
					if (_str.slice(-1) === '0' && places < 3) {
						_str = String(_money.toFixed(2));
						if (_str.slice(-1) === '0' && places < 2) {
							_str = String(_money.toFixed(1));
							if (_str.slice(-1) === '0' && places < 1) {
								_str = String(_money.toFixed(0));
							}
						}
					}
				}
			}
		} else {
			if (places >= 0 && Number(_str) === 0 && _money !== 0) {
				places++;
				_str = String(_money.toFixed(places));

				if (Number(_str) === 0) {
					places++;
					_str = String(_money.toFixed(places));

					if (Number(_str) === 0) {
						places++;
						_str = String(_money.toFixed(places));

						if (Number(_str) === 0) {
							places++;
							_str = String(_money.toFixed(places));
						}
					}
				}
			}
		}

		var _parts = _str.split('.');

		_str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
		if (_parts[1] && _parts[1].length) _str += del + _parts[1];

		return _str;
	},

	String2Money: function String2Money(money) {
		if (money === null || money === undefined) return '';
		if (typeof money !== 'string') return String(money);
		if (money.trim() === '') return '';

		var _parts = money.split('.');

		var _str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		if (_parts[1] && _parts[1].length) {
			var _dec = parseFloat('0.' + _parts[1]);
			if (!isNaN(_dec) && _dec > 0) {
				_parts = String(_dec).split('.');
				if (_parts[1] && _parts[1].length) _str += '.' + _parts[1];
			}
		}

		return _str;
	},

	Num2Money: function Num2Money(money, digs) {
		if (typeof money !== 'number') money = Number(money);
		if (money === null || money === undefined || isNaN(money)) return money;

		money = String(money.toFixed(digs));
		var _parts = money.split('.');

		var _str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		if (_parts[1] && _parts[1].length) _str += '.' + _parts[1];

		return _str;
	},

	FormatBytes: function FormatBytes(bytes) {
		if (!bytes || bytes <= 0) return '0 Б';
		var k = 1000;
		var dm = 1;
		var sizes = ['main/traffic_b', 'main/traffic_kb', 'main/traffic_mb', 'main/traffic_gb', 'main/traffic_tb', 'main/traffic_pb', 'main/traffic_eb', 'ZB', 'YB'];
		var i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + this.localeFtc(sizes[i]);
	},

	FormatDateTime: function FormatDateTime(date) {
		var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'd.m.y H:M:S';

		if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
			var _date = date.split('-');

			return format.replace('d', _date[2]).replace('m', _date[1]).replace('Y', _date[0]).replace('y', _date[0].substr(2, 2)).replace('H', '').replace('M', '').replace('S', '');
		}

		if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date)) {
			var _parts = date.split(/\s/);
			var _date2 = _parts[0].split('-');
			var _time = _parts[1].split(':');

			return format.replace('d', _date2[2]).replace('m', _date2[1]).replace('Y', _date2[0]).replace('y', _date2[0].substr(2, 2)).replace('H', _time[0]).replace('M', _time[1]).replace('S', _time[2]);
		}

		return date;
	},

	FormatedStrDate2Date: function FormatedStrDate2Date(date, format) {
		var _str = date;

		if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date) && !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
			var _delimeter = '';
			var _expDelimeter = null;
			if (format.indexOf('.') > 0) {
				_delimeter = '.';
				_expDelimeter = '\\.';
			} else if (format.indexOf('-') > 0) {
				_delimeter = '-';
				_expDelimeter = '-';
			} else if (format.indexOf('/') > 0) {
				_delimeter = '/';
				_expDelimeter = '\\/';
			}

			var _formatParts = format.split(_delimeter);
			var _exp = '';
			var _index = {};

			_formatParts.forEach(function (_key, _idx) {
				if (_exp) _exp += _expDelimeter;

				if (_key === 'd' || _key === 'm' || _key === 'y') _exp += '(\\d{2})';else if (_key === 'Y') _exp += '(\\d{4})';

				_index[_key] = _idx + 1;
			});

			var _match = null;
			try {
				var _reg = new RegExp(_exp);
				_match = date.match(_reg);
				if (!_match) return null;
			} catch (e) {
				return null;
			}

			if (!_index['d'] || !_index['m']) return null;
			if (!_index['Y'] && !_index['y']) return null;

			_str = '';

			if (_index['Y']) _str += _match[_index['Y']];
			if (_index['y']) _str += String(1900 + _match[_index['y']]);

			if (_str) _str += '-';

			if (_index['m']) _str += _match[_index['m']];

			if (_str) _str += '-';

			if (_index['d']) _str += _match[_index['d']];
		}

		if (/^\d{4}-\d{2}-\d{2}$/.test(_str)) _str = _str + ' 00:00:00';

		if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_str)) return null;

		var _parts = _str.split(/\s/);
		var _date = _parts[0].split('-');
		var _time = _parts[1].split(':');

		return new Date(parseInt(_date[0]), parseInt(_date[1]) - 1, parseInt(_date[2]), parseInt(_time[0]), parseInt(_time[1]), parseInt(_time[2]));
	},
	calculateAge: function calculateAge(birthday) {
		var ageDifMs = Date.now() - birthday.getTime();
		var ageDate = new Date(ageDifMs);
		var yearDif = ageDate.getUTCFullYear() - 1970;
		if (yearDif < 0) yearDif = 0;
		return yearDif;
	},

	normalizeBooleanValue: function normalizeBooleanValue(value) {
		if (value === null || value === undefined) return false;

		if (typeof value === 'boolean') return value;

		if (typeof value === 'string') {
			value = String(value).trim().toLowerCase();

			if (value === 'yes' || value === 'true' || value === '+' || value === '1') return true;
			if (value === 'no' || value === 'false' || value === '-' || value === '0' || value === '') return false;
		}

		return Boolean(value);
	},

	removeBrowserSelectionText: function removeBrowserSelectionText() {
		if (window.getSelection) {
			if (window.getSelection().empty) {
				window.getSelection().empty();
			} else if (window.getSelection().removeAllRanges) {
				window.getSelection().removeAllRanges();
			}
		} else if (document.selection) {
			document.selection.empty();
		}
	},

	copyToClipboard: function copyToClipboard(el) {
		if (document.body.createTextRange) {
			var textRange = document.body.createTextRange();
			textRange.moveToElementText(el);
			textRange.select();
			textRange.execCommand('Copy');
			return true;
		} else if (window.getSelection && document.createRange) {
			var range = document.createRange();
			range.selectNodeContents(el);
			var sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(range);
			try {
				document.execCommand('copy');
				return true;
			} catch (err) {}
		}

		return false;
	},

	findObj: function findObj(name, obj, crud) {
		if (obj === null || obj === undefined) return false;
		if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return false;
		if (name in obj && obj[name]) {
			if (crud !== 'email' || name !== 'email') return obj[name];
		}

		var fnd = false;
		var i = void 0;
		for (i in obj) {
			if (obj.hasOwnProperty(i)) {
				fnd = this.findObj(name, obj[i]);
				if (fnd) return fnd;
			}
		}return false;
	},

	getRandomInt: function getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	},

	isStrHaveNum: function isStrHaveNum(str) {
		return (/\d/g.test(str)
		);
	},

	isNumeric: function isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	},

	validateEmail: function validateEmail(email) {
		if (!email) return false;

		email = String(email).trim();

		if (email.length <= 0) return false;
		if (email.indexOf('@') === -1) return false;

		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	},

	setCookie: function setCookie(name, value, options) {
		options = options || {};
		var expires = options.expires;

		if (typeof expires === 'number' && expires) {
			var d = new Date();
			d.setTime(d.getTime() + expires * 1000);
			expires = options.expires = d;
		}
		if (expires && expires.toUTCString) options.expires = expires.toUTCString();

		value = encodeURIComponent(value);
		var updatedCookie = name + '=' + value;

		for (var propName in options) {
			updatedCookie += '; ' + propName;
			var propValue = options[propName];
			if (propValue !== true) {
				updatedCookie += '=' + propValue;
			}
		}

		document.cookie = updatedCookie;
	},
	getCookie: function getCookie(name) {
		var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	},
	deleteCookie: function deleteCookie(name) {
		this.setCookie(name, '', {
			'expires': new Date(0),
			'path': '/',
			'domain': __WEBPACK_IMPORTED_MODULE_2_vue__["default"].CookieDomain
		});
	},

	generatePassword: function generatePassword(length) {
		if (!length || length < 1) length = 14;

		var i = void 0;
		var n = void 0;
		var c = 'qQwWeErRtTyYuUipPaAsSdDfFgGhHjJkKLzZxXcCvVbBnNmM123456789qQwWeErRtTyYuUipPaAsSdDfFgGhHjJkKLzZxXcCvVbBnNmM123456789';
		var pass = '';

		for (i = 1; i <= length; i++) {
			n = Math.floor(Math.random() * 100);

			if (n >= c.length || c[n] === undefined || c[n] === null) {
				continue;
			}

			pass += c[n];
		}

		if (pass.length < length) {
			pass += this.generatePassword(length - pass.length);
		}

		if (!this.isStrHaveNum(pass)) {
			n = this.getRandomInt(2, length - 2);
			pass = pass.substring(0, n) + this.getRandomInt(0, 9) + pass.substring(n + 1);
		}

		return pass;
	},

	Money2String: function Money2String(n, c, d, t) {
		c = isNaN(c = Math.abs(c)) ? 2 : c;
		d = d === undefined ? '.' : d;
		t = t === undefined ? ',' : t;
		var s = n < 0 ? '-' : '';
		var i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
		var j = (j = i.length) > 3 ? j % 3 : 0;

		return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
	},
	MoneyForPrint: function MoneyForPrint(value) {
		var rub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'руб.';
		var kop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'коп.';

		var _parts = value.split('.');
		var _str = _parts[0] + ' ' + rub;
		if (_parts[1]) _str += ' ' + _parts[1] + ' ' + kop;else _str += ' 00 ' + kop;
		return _str;
	},
	RusDate2Date: function RusDate2Date(value) {
		if (!/^\d{2}.\d{2}.\d{4}$/.test(value)) return value;
		var _parts = value.split('.');
		return new Date(parseInt(_parts[2]), parseInt(_parts[1]) - 1, parseInt(_parts[0]));
	},
	Str2Float: function Str2Float(val) {
		if (!val) return NaN;

		var str = val.replace(/ /g, '');

		var m = str.match(/,/g);

		if (m != null && m.length > 1) return NaN;

		m = str.match(/\./g);

		if (m != null && m.length > 1) return NaN;

		str = str.replace(',', '.');

		return parseFloat(str);
	},
	Str2Int: function Str2Int(val) {
		if (!val) return NaN;

		var str = val.replace(/ /g, '');

		var m = str.match(/,/g);

		if (m != null && m.length > 1) return NaN;

		m = str.match(/\./g);

		if (m != null && m.length > 1) return NaN;

		return parseInt(str);
	},
	toUpperCaseFirstSymbol: function toUpperCaseFirstSymbol(str) {
		if (!str) return '';
		var value = String(str).toLowerCase().trim();
		return value.charAt(0).toUpperCase() + value.slice(1);
	},
	FirstSymbolToUpperAndLatin: function FirstSymbolToUpperAndLatin(str) {
		if (!str) return '';
		var value = String(str).replace(/[а-яА-ЯёЁ]/ig, '');
		return value.charAt(0).toUpperCase() + value.slice(1);
	},
	onlyLatin: function onlyLatin(str) {
		if (!str) return '';
		return String(str).replace(/[а-яА-ЯёЁ]/ig, '');
	},
	onlyRussia: function onlyRussia(str) {
		if (!str) return '';
		return String(str).replace(/[a-z]/ig, '');
	},
	prepareTemplateList: function prepareTemplateList(field) {
		if (!field || !field['list']) return;

		var _newList = {};
		var _images = {};

		field.list.forEach(function (item, idx, arr) {
			if (item['id'] && item['name'] && String(item['id']).length && String(item['name']).length) {
				var _nm = false;
				var _vr = false;

				var _parts = item['name'].split(' ');
				for (var j = 0; j < _parts.length; j++) {
					if (/^[0-9.-]+$/.test(_parts[j])) {
						_vr = _parts.slice(j).join(' ');
						break;
					} else {
						if (!_nm) _nm = _parts[j];else _nm += ' ' + _parts[j];
					}
				}

				if (_nm && _nm.length) {
					_nm = _nm.replace(/os/i, 'OS').replace(/bsd/i, 'BSD').replace(/server/i, 'Server').replace(/web/i, 'Web');

					item['version'] = _vr;

					if (!(_nm in _newList)) _newList[_nm] = [];
					if (!(_nm in _images)) _images[_nm] = item['image'];

					_newList[_nm].push(item);
				}
			}
		});

		field['list'] = _newList;

		field['images'] = _images;
	},
	validateHostnameForFQDN: function validateHostnameForFQDN(hostname) {
		var hostExp = /^(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/i;
		hostname = String(hostname).trim();
		if (hostname.length === 0) return false;

		if (hostExp.test(hostname)) return true;

		return __WEBPACK_IMPORTED_MODULE_5_domain_regex___default()().test(__WEBPACK_IMPORTED_MODULE_6_punycode___default.a.toASCII(hostname));
	},
	getSelectedTextDocument: function getSelectedTextDocument() {
		var t = '';
		if (window.getSelection) {
			t = window.getSelection().toString();
		} else if (document.getSelection) {
			t = document.getSelection().toString();
		} else if (document.selection) {
			t = document.selection.createRange().text;
		}

		return t;
	},
	getSelectedTextWithin: function getSelectedTextWithin(el) {
		var selectedText = '';
		if (typeof window.getSelection !== 'undefined') {
			var sel = window.getSelection();
			var rangeCount = void 0;

			if ((rangeCount = sel.rangeCount) > 0) {
				var range = document.createRange();
				for (var i = 0, selRange; i < rangeCount; ++i) {
					range.selectNodeContents(el);
					selRange = sel.getRangeAt(i);

					if (selRange.compareBoundaryPoints(range.START_TO_END, range) === 1 && selRange.compareBoundaryPoints(range.END_TO_START, range) === -1) {
						if (selRange.compareBoundaryPoints(range.START_TO_START, range) === 1) {
							range.setStart(selRange.startContainer, selRange.startOffset);
						}
						if (selRange.compareBoundaryPoints(range.END_TO_END, range) === -1) {
							range.setEnd(selRange.endContainer, selRange.endOffset);
						}
						selectedText += range.toString();
					}
				}
			}
		} else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
			var selTextRange = document.selection.createRange();
			var textRange = selTextRange.duplicate();

			textRange.moveToElementText(el);

			if (selTextRange.compareEndPoints('EndToStart', textRange) === 1 && selTextRange.compareEndPoints('StartToEnd', textRange) === -1) {
				if (selTextRange.compareEndPoints('StartToStart', textRange) === 1) {
					textRange.setEndPoint('StartToStart', selTextRange);
				}
				if (selTextRange.compareEndPoints('EndToEnd', textRange) === -1) {
					textRange.setEndPoint('EndToEnd', selTextRange);
				}
				selectedText = textRange.text;
			}
		}

		return selectedText;
	},
	nl2br: function nl2br(str) {
		if (str === undefined || str === null || str === '') return '';
		return String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>');
	},
	escapeHtml: function escapeHtml(str) {
		return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	},

	markStringInText: function markStringInText(searchString, Text, replaceBefore, replaceAfter) {
		if (searchString === null || searchString === undefined || searchString === '') return Text;

		var type = typeof Text === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Text);
		if (type === 'object' || type === 'function') return Text;
		var text = String(Text);

		var replace_str_before = replaceBefore || '<strong class="w5-selected-text">';
		var replace_str_after = replaceAfter || '</strong>';

		var findString = searchString.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

		return text.replace(new RegExp(findString, 'ig'), function (str, offset, s) {
			var _before = s.substr(0, offset) + str;
			var _reg = new RegExp('\<([^\>]*?)' + str + '$', 'ig');
			var _in_tag = _reg.test(_before);

			if (_in_tag) return str;

			return replace_str_before + str + replace_str_after;
		});
	},
	formatTicketMessage: function formatTicketMessage(messageContent, fastSearch) {
		var needFtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		if (!messageContent || messageContent === '') return messageContent;
		if (needFtc) messageContent = this.localeFtc(messageContent);

		var _txt1 = this.escapeHtml(messageContent);

		_txt1 = __WEBPACK_IMPORTED_MODULE_4_linkifyjs_html___default()(_txt1, {
			defaultProtocol: 'https',
			validate: {
				url: function url(value) {
					return (/^(http|ftp)s?:\/\//.test(value)
					);
				}
			}
		});

		_txt1 = this.nl2br(_txt1);

		var _strings = _txt1.split('<br>');
		var _newStrings = [];
		var _level = 0;
		var _cnt = _strings.length;

		for (var _i = 0; _i < _cnt; _i++) {
			if (/^\s*\&gt;/i.test(_strings[_i])) {
				_level = 1;

				if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 6;else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 5;else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 4;else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 3;else if (/^\s*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 2;else _level = 1;

				_newStrings.push('<span class="w5-quoted-text-level-' + _level + '">' + _strings[_i] + '</span>');
			} else {
					_newStrings.push(_strings[_i]);
				}
		}

		var _beginBlock = false;
		_cnt = _newStrings.length;
		var _textWithQuotesBlock = [];
		var _beginBlockRowIndex = 0;
		var _l = 0;
		for (var _i2 = 0; _i2 < _cnt; _i2++) {
			if (_newStrings[_i2].substr(0, 5) === '<span') {
				if (!_beginBlock) {
					_textWithQuotesBlock.push('<div class="toggle-quote-block-hided">' + Helper.localeFtc('main/show_quote') + '</div><div class="clearfix"></div><div class="quote-block">' + _newStrings[_i2]);

					_beginBlock = true;

					_beginBlockRowIndex = _l;

					_l++;
				} else {
					_textWithQuotesBlock.push(_newStrings[_i2]);
					_l++;
				}
			} else {
				if (_beginBlock) {
					_textWithQuotesBlock.push('</div>' + _newStrings[_i2]);

					if (_l - _beginBlockRowIndex >= 10) {
						var _t = _textWithQuotesBlock[_beginBlockRowIndex].replace('<div class="toggle-quote-block-hided', '<div class="toggle-quote-block');

						_t = _t.replace('<div class="quote-block">', '<div class="quote-block-hided">');

						_textWithQuotesBlock[_beginBlockRowIndex] = _t;
					}

					_beginBlock = false;

					_beginBlockRowIndex = 0;

					_l++;
				} else {
					_textWithQuotesBlock.push(_newStrings[_i2]);
					_l++;
				}
			}
		}

		var _txt2 = _textWithQuotesBlock.join('<br>');

		var _txt3 = _txt2;
		if (fastSearch && fastSearch !== '') {
			var _fnd = this.escapeHtml(fastSearch);

			_txt3 = this.markStringInText(_fnd, _txt2);
		}

		return _txt3;
	},
	getFileExt: function getFileExt(str) {
		if (str.indexOf('.') > -1) {
			var _ext = str.split('.').pop();
			if (!_ext) _ext = 'file';
			return _ext;
		}

		return 'file';
	},
	simpleQueryStringFromObject: function simpleQueryStringFromObject(obj) {
		var str = [];
		for (var p in obj) {
			if (obj.hasOwnProperty(p)) {
				str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
			}
		}return str.join('&');
	},
	arrayCompare: function arrayCompare(arr1, arr2, otherField) {
		if (!arr1 || !arr2) return false;
		if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
		if (arr1.length !== arr2.length) return false;

		for (var i = 0, l = arr1.length; i < l; i++) {
			if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
				var _ans = this.arrayCompare(arr1[i], arr2[i]);
				if (!_ans) return false;
			} else {
				var _val1 = arr1[i];
				if ((typeof _val1 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_val1)) === 'object' && 'id' in _val1) _val1 = String(_val1['id']);
				var _val2 = arr2[i];
				if ((typeof _val2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_val2)) === 'object' && 'id' in _val2) _val2 = String(_val2['id']);

				if (String(_val1) !== String(_val2)) return false;

				if (otherField && otherField.length) {
					for (var j = 0; j < otherField.length; j++) {
						if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(arr1[i]) === 'object' && otherField[j] in arr1[i]) _val1 = String(arr1[i][otherField[j]]);else _val1 = null;

						if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(arr2[i]) === 'object' && otherField[j] in arr2[i]) _val2 = String(arr2[i][otherField[j]]);else _val2 = null;

						if (String(_val1) !== String(_val2)) return false;
					}
				}
			}
		}

		return true;
	},
	listAsArray: function listAsArray(obj) {
		if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return [obj];
		if (Array.isArray(obj)) return obj;

		var _answer = [];
		for (var p in obj) {
			if (obj.hasOwnProperty(p)) {
				var _item = { id: p };
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj[p]) !== 'object') _item['name'] = obj[p];else {
					if (Array.isArray(obj[p])) {
						if (obj[p].length) _item['name'] = obj[p][0];
					} else {
						if (obj[p] && obj[p]['name']) _item['name'] = obj[p]['name'];
					}
				}
				_answer.push(_item);
			}
		}return _answer;
	},
	htmlInstructionPasswordButton: function htmlInstructionPasswordButton(currentClassName) {
		if (currentClassName.indexOf('instruction-password shown') > 0) {
			return '<div id="btn-inst-copy" class="w5-access-tab-button for-instruction"><svg aria-labelledby="svg-inline--fa-title-oy4dN0fHB6Nh" data-prefix="fas" data-icon="copy" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-copy fa-w-14"><title id="svg-inline--fa-title-oy4dN0fHB6Nh" class="">\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430</title><path fill="currentColor" d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z" class=""></path></svg></div>';
		}

		return '<div id="btn-inst-show" class="w5-access-tab-button for-instruction"><svg aria-labelledby="svg-inline--fa-title-LC3YyTPWeaz4" data-prefix="fas" data-icon="eye" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-eye fa-w-18"><title id="svg-inline--fa-title-LC3YyTPWeaz4" class="">\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435</title><path fill="currentColor" d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" class=""></path></svg></div>';
	},
	_replaceTag: function _replaceTag(tag) {
		var tagsToReplace = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;'
		};

		return tagsToReplace[tag] || tag;
	},
	safe_tags_replace: function safe_tags_replace(str) {
		str = String(str);
		return str.replace(/[&<>"']/g, this._replaceTag);
	},
	isFormChanged: function isFormChanged(formData, crud, action, $store) {
		var _this = this;

		if (!formData) return false;

		if (crud === 'operation' && $store.state.user_type === 'client') return false;

		var _rows = formData['fields'];
		if (!_rows || !Array.isArray(_rows)) return false;

		if ($store.state.uploadFileCounter > 0) return true;

		var _answer = _rows.some(function (item) {
			var _found = false;

			if (item && Array.isArray(item)) {
				_found = item.some(function (field) {
					var _normValue = _this.normValueForCheckChanges(field, crud, action, $store);

					if (Array.isArray(field['_oldValue']) || Array.isArray(_normValue)) {
						if ((typeof _normValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_normValue)) === 'object' && !Array.isArray(_normValue)) {
							var _arr = [];
							for (var _p in _normValue) {
								if (_normValue.hasOwnProperty(_p)) {
									_arr.push(_p);
								}
							}_normValue = _arr;
						}

						if (!_this.arrayCompare(field['_oldValue'], _normValue)) {
							if ($store.state.isDebug) window.DEBUG.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
								'field': field['_field_name'],
								'old': field['_oldValue'],
								'cur': _normValue
							}));
							return true;
						}
					} else if (field['_oldValue'] != _normValue) {
							if (!(_this.crud === 'vds' && field['_field_name'] === 'template_id')) {
								if ($store.state.isDebug) window.DEBUG.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
									'field': field['_field_name'],
									'old': field['_oldValue'],
									'cur': _normValue
								}));
								return true;
							}
						}
				});
			}

			if (_found) return true;
		});

		return _answer;
	},
	normValueForCheckChanges: function normValueForCheckChanges(field, crud, action, $store) {
		if (!field || !field['type']) return undefined;

		return field['value'] !== null && field['value'] !== undefined ? field['value'] : field['_emptyValue'];
	},
	isRetina: function isRetina() {
		var _el = document.getElementById('for-retina-detection');
		if (!_el) return false;
		var _rect = _el.getBoundingClientRect();
		if (!_rect) return false;
		return _rect.top > 0;
	},
	valueInList: function valueInList(Value, List) {
		if (!Value || !List || (typeof List === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(List)) !== 'object') return false;

		if (Array.isArray(List) && !List.length) return false;

		var _value = null;
		if ((typeof Value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Value)) === 'object') {
			if ('id' in Value) _value = Value['id'];
		} else _value = Value;
		if (!_value) return false;

		if (Array.isArray(List)) {
			return List.some(function (item) {
				if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) === 'object') {
					if (String(item['id']) === String(_value)) return true;
				} else {
						if (String(item) === String(_value)) return true;
					}
			});
		} else {
			return _value in List;
		}
	},
	checkINN: function checkINN(inn) {
		if (inn.match(/\D/)) return false;

		inn = String(inn);

		inn = inn.split('');

		if (inn.length === 10) {
			var _control = String((2 * inn[0] + 4 * inn[1] + 10 * inn[2] + 3 * inn[3] + 5 * inn[4] + 9 * inn[5] + 4 * inn[6] + 6 * inn[7] + 8 * inn[8]) % 11 % 10);

			return inn[9] === _control;
		} else if (inn.length === 12) {
				var _control1 = String((7 * inn[0] + 2 * inn[1] + 4 * inn[2] + 10 * inn[3] + 3 * inn[4] + 5 * inn[5] + 9 * inn[6] + 4 * inn[7] + 6 * inn[8] + 8 * inn[9]) % 11 % 10);

				var _control2 = String((3 * inn[0] + 7 * inn[1] + 2 * inn[2] + 4 * inn[3] + 10 * inn[4] + 3 * inn[5] + 5 * inn[6] + 9 * inn[7] + 4 * inn[8] + 6 * inn[9] + 8 * inn[10]) % 11 % 10);

				return inn[10] === _control1 && inn[11] === _control2;
			}

		return false;
	},
	checkOGRN: function checkOGRN(ogrn) {
		if (ogrn.match(/\D/)) return false;

		ogrn = String(ogrn);

		if (ogrn.length === 13) {
			return ogrn.slice(12, 13) === String(1 * ogrn.slice(0, -1) % 11).slice(-1);
		} else if (ogrn.length === 15) {
				return ogrn.slice(14, 15) === String(1 * ogrn.slice(0, -1) % 13).slice(-1);
			}

		return false;
	},
	checkBIC: function checkBIC(bic) {
		bic = String(bic);
		return (/^\d{9}$/.test(bic)
		);
	},
	checkKS: function checkKS(ks, bic) {
		ks = String(ks);
		bic = String(bic);

		if (!this.checkBIC(bic) || !/^\d{20}$/.test(ks)) return false;

		var bikKs = '0' + bic.slice(4, 6) + ks;
		var checksum = 0;
		var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];

		for (var i in coefficients) {
			checksum += coefficients[i] * (bikKs[i] % 10);
		}if (checksum % 10 === 0) return true;

		return false;
	},
	checkRS: function checkRS(rs, bic) {
		rs = String(rs);
		bic = String(bic);

		if (!this.checkBIC(bic) || !/^\d{20}$/.test(rs)) return false;

		var bikRs = bic.slice(-3) + rs;
		var checksum = 0;
		var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];

		for (var i in coefficients) {
			checksum += coefficients[i] * (bikRs[i] % 10);
		}if (checksum % 10 === 0) return true;

		return false;
	},
	toTrimString: function toTrimString(str) {
		if (str === undefined || str === null) return '';
		return String(str).trim();
	},
	verifyPermissions: function verifyPermissions(userRole, currentRoute) {
		if (!userRole || !userRole.permissions || !userRole.permissions.length || !currentRoute || !currentRoute.path) return false;

		return userRole.permissions.some(function (curdAction) {
			if (currentRoute.path.indexOf(curdAction) > 0) return true;
		});
	},
	naturalCompare: function naturalCompare(a, b) {
		var ax = [];
		var bx = [];

		a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
			ax.push([$1 || Infinity, $2 || '']);
		});
		b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
			bx.push([$1 || Infinity, $2 || '']);
		});

		while (ax.length && bx.length) {
			var an = ax.shift();
			var bn = bx.shift();
			var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
			if (nn) return nn;
		}

		return ax.length - bx.length;
	},
	naturalCompareObjectField: function naturalCompareObjectField(fieldName) {
		var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		return function (a, b) {
			var ax = [];
			var bx = [];

			a[fieldName].replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
				ax.push([$1 || Infinity, $2 || '']);
			});
			b[fieldName].replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
				bx.push([$1 || Infinity, $2 || '']);
			});

			while (ax.length && bx.length) {
				var an = ax.shift();
				var bn = bx.shift();
				var nn;
				if (direction > 0) nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);else nn = bn[0] - an[0] || bn[1].localeCompare(an[1]);
				if (nn) return nn;
			}

			if (direction > 0) return ax.length - bx.length;else return bx.length - ax.length;
		};
	},
	validateIPv4: function validateIPv4(ip) {
		var blocks = ip.split('.');
		if (blocks.length !== 4) return false;

		return blocks.every(function (block) {
			var intVal = parseInt(block, 10);
			if (isNaN(intVal)) return false;

			return intVal >= 0 && intVal <= 255;
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)
__webpack_require__(341)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  "data-v-4dd73f47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAALAPQAAP///zMzM+Li4tra2u7u7jk5OTMzM1hYWJubm4CAgMjIyE9PT29vb6KiooODg8vLy1JSUjc3N3Jycuvr6+Dg4Pb29mBgYOPj4/X19cXFxbOzs9XV1fHx8TMzMzMzMzMzMyH5BAkLAAAAIf4aQ3JlYXRlZCB3aXRoIGFqYXhsb2FkLmluZm8AIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAALAAAFLSAgjmRpnqSgCuLKAq5AEIM4zDVw03ve27ifDgfkEYe04kDIDC5zrtYKRa2WQgAh+QQJCwAAACwAAAAAEAALAAAFJGBhGAVgnqhpHIeRvsDawqns0qeN5+y967tYLyicBYE7EYkYAgAh+QQJCwAAACwAAAAAEAALAAAFNiAgjothLOOIJAkiGgxjpGKiKMkbz7SN6zIawJcDwIK9W/HISxGBzdHTuBNOmcJVCyoUlk7CEAAh+QQJCwAAACwAAAAAEAALAAAFNSAgjqQIRRFUAo3jNGIkSdHqPI8Tz3V55zuaDacDyIQ+YrBH+hWPzJFzOQQaeavWi7oqnVIhACH5BAkLAAAALAAAAAAQAAsAAAUyICCOZGme1rJY5kRRk7hI0mJSVUXJtF3iOl7tltsBZsNfUegjAY3I5sgFY55KqdX1GgIAIfkECQsAAAAsAAAAABAACwAABTcgII5kaZ4kcV2EqLJipmnZhWGXaOOitm2aXQ4g7P2Ct2ER4AMul00kj5g0Al8tADY2y6C+4FIIACH5BAkLAAAALAAAAAAQAAsAAAUvICCOZGme5ERRk6iy7qpyHCVStA3gNa/7txxwlwv2isSacYUc+l4tADQGQ1mvpBAAIfkECQsAAAAsAAAAABAACwAABS8gII5kaZ7kRFGTqLLuqnIcJVK0DeA1r/u3HHCXC/aKxJpxhRz6Xi0ANAZDWa+kEAA7"

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__admin__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__ = __webpack_require__(3);






var _this = this;









__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* default */]);

var ticketCountersTimer = null;

var ticketPushesCounter = 0;

var isTicketTimerRequesting = false;
var requestTicketCountersFunction = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(commit) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!isTicketTimerRequesting) {
							_context.next = 2;
							break;
						}

						return _context.abrupt('return');

					case 2:
						commit('needShowLoader', false);
						isTicketTimerRequesting = true;

						_context.prev = 4;
						_context.next = 7;
						return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/ticket/list?additional=getCounters');

					case 7:
						response = _context.sent;

						if (response && response.data && response.data.status === 'ok' && response.data.result) commit('setTicketCounters', response.data.result);
						_context.next = 13;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](4);

					case 13:
						commit('needShowLoader', true);
						isTicketTimerRequesting = false;

					case 15:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this, [[4, 11]]);
	}));

	return function requestTicketCountersFunction(_x) {
		return _ref.apply(this, arguments);
	};
}();

var requestTicketAgain = function requestTicketAgain(commit) {
	ticketPushesCounter = 0;

	requestTicketCountersFunction(commit);

	ticketCountersTimer = setTimeout(function () {
		ticketCountersTimer = null;

		if (!ticketPushesCounter) return;

		requestTicketAgain(commit);
	}, 3000);
};

var requestCountersTimer = null;

var requestPushesCounter = 0;

var isRequestTimerRequesting = false;
var requestRequestCountersFunction = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(commit) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (!isRequestTimerRequesting) {
							_context2.next = 2;
							break;
						}

						return _context2.abrupt('return');

					case 2:
						commit('needShowLoader', false);
						isRequestTimerRequesting = true;

						_context2.prev = 4;
						_context2.next = 7;
						return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/request/list?additional=getCounters');

					case 7:
						response = _context2.sent;

						if (response && response.data && response.data.status === 'ok' && response.data.result) commit('setRequestCounter', response.data.result);
						_context2.next = 13;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](4);

					case 13:
						commit('needShowLoader', true);
						isRequestTimerRequesting = false;

					case 15:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, _this, [[4, 11]]);
	}));

	return function requestRequestCountersFunction(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var requestRequestAgain = function requestRequestAgain(commit) {
	requestPushesCounter = 0;

	requestRequestCountersFunction(commit);

	requestCountersTimer = setTimeout(function () {
		requestCountersTimer = null;

		if (!requestPushesCounter) return;

		requestRequestAgain(commit);
	}, 3000);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* default */].Store({
	state: {
		isDebug: false,

		applicationBlocked: false,

		longRequest: false,
		ajaxRequestsCounter: 0,
		showLongLoader: true,

		currentAppId: 'none',

		lang: 'en',

		pageTitle: 'menu/cp',

		isListTableLoading: false,

		ItIsMe: false,

		changedForm: false,
		isInitFormsValue: 0,

		uploadFileCounter: 0,

		apiVersion: '',

		is_auth: false,

		user_id: false,
		user_type: false,
		user_login: false,
		user_avatar: false,
		user_session: false,
		user_role: false,

		user_balance: {
			real: '',
			bonus: '',
			partner: ''
		},

		user_account: false,
		user_forecast: false,

		userServerOptions: {},

		user_need: null,

		adminConfig: __WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */],
		clientConfig: __WEBPACK_IMPORTED_MODULE_6__client__["a" /* default */],

		lastWorkedRowID: {},

		lastWorkedPage: {},

		lastWindowY: {},

		windowWidth: 0,
		windowHeight: 0,

		returnURL: false,

		workerPush: false,

		crudFilter: false,

		modelFilter: false,

		createNoteData: false,

		bonusActivateData: false,

		vdsCommand: false,

		operationSumNew: 10000,

		ticketData: {
			departments: [],

			currentDepartmentId: false,

			counters: {},
			countersQueue: null,
			ticketViewId: false,
			ticketUpdateId: false,

			needUpperTab: {}
		},

		vdsGroup: {
			groups: [],

			firstGroupId: null,

			currentGroupId: null
		},
		filteredGroupId: null,

		requestCounter: false,
		requestCounterQueue: null,

		accountGlobalFilter: false,

		errorHttpCode: 0,

		qaCache: {
			time: null,
			popList: null,
			newList: null,
			tagList: null
		},

		tableCurrentPage: 1,

		domainRecordId: null,

		createTicketEmail: null,

		menuSelectingPreset: '',

		lastFormCache: {},

		isLastTemplateGroupCacheLoaded: false,
		lastTemplateGroupCache: [{
			'id': 99999,
			'name': 'main/list_all',
			'active': true
		}],

		getClientData: function getClientData(state) {
			if (!state.is_auth) return;

			state.showLongLoader = false;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl).then(function (response) {
				state.showLongLoader = true;

				if (response.data && response.data.status === 'ok') {
					if (response.data.balance && response.data.balance.real && 'value' in response.data.balance.real && response.data.balance.bonus && 'value' in response.data.balance.bonus && response.data.balance.partner && 'value' in response.data.balance.partner) {
						state.user_balance['real'] = response.data.balance.real.value;
						state.user_balance['bonus'] = response.data.balance.bonus.value;
						state.user_balance['partner'] = response.data.balance.partner.value;
					}

					if (response.data.account && 'value' in response.data.account && response.data.account['value']) {
						state.user_account = response.data.account['value'];
					}

					if (response.data.forecast && 'value' in response.data.forecast && response.data.forecast['value']) {
						state.user_forecast = response.data.forecast['value'];
					}

					if (response.data.title) {
						state.pageTitle = response.data.title;
					}
				}
			}, function () {
				state.showLongLoader = true;
			});
		},
		getUserOptionsOnServer: function getUserOptionsOnServer(state) {
			if (!state.is_auth) return;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/option/get').then(function (response) {
				if (response.data && response.data.status === 'ok' && response.data.option && Array.isArray(response.data.option) && response.data.option.length) {
					response.data.option.forEach(function (item) {
						if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object') {
							for (var _prop in item) {
								if (item.hasOwnProperty(_prop)) {
									state.userServerOptions[_prop] = item[_prop];
								}
							}
						}
					});

					__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-user-options-on-server');
					__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-user-options-on-server-get');
				}
			}).catch(function (data) {});
		},
		updateUserOptionsOnServer: function updateUserOptionsOnServer(state, data) {
			if (!state.is_auth) return;

			if (!data || !data.key || !('value' in data)) return;

			var key = data.key,
			    value = data.value;

			state.userServerOptions[key] = value;

			__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-user-options-on-server');
		},
		setUserOptionOnServer: function setUserOptionOnServer(state, option, value) {
			if (!state.is_auth) return;

			var _post = { 'value': value };

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/option/set/' + option, __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].toFormData(_post)).then(function (response) {
				if (response.data && response.data.status === 'ok') {
					state.userServerOptions[option] = value;

					__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-user-options-on-server');
				}
			});
		},
		clearUserOptionsOnServer: function clearUserOptionsOnServer(state) {
			if (!state.is_auth) return;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/option/flush');

			state.userServerOptions = {};
		},
		getTicketDepartments: function getTicketDepartments(state, tabs) {
			if (state.user_type !== 'admin') return;

			if (state.ticketData && state.ticketData.departments && Array.isArray(state.ticketData.departments) && state.ticketData.departments.length) {
				__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-ticket-departments');

				return;
			}

			state.showLongLoader = false;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/ticket/list?search=department').then(function (response) {
				state.showLongLoader = true;

				if (response.data && response.data.status === 'ok' && response.data.result && Array.isArray(response.data.result) && response.data.result.length) {
					state.ticketData.departments = [];
					response.data.result.forEach(function (item) {
						state.ticketData.departments.push(item);
					});

					var _firstId = false;
					__WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */].leftMenu.ticket.tabs = {};

					state.ticketData.departments.forEach(function (item) {
						if (item && 'access' in item && 'id' in item && item['access'] === true && item['id']) {
							if (!_firstId) _firstId = item['id'];

							__WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */].leftMenu.ticket.tabs['ticket/department/' + item['id']] = item['name'];
						}
					});

					__WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */].leftMenu.ticket.tabs['ticket'] = 'main/list_all';

					if (_firstId) __WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */].leftMenu.ticket.link = '/ticket/department/' + _firstId;

					__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-ticket-departments');
				}
			}, function () {
				state.showLongLoader = true;
			});
		},
		getTicketState: function getTicketState(state, ticketId) {
			if (!ticketId) return;

			if (state.user_type !== 'admin') return;

			state.showLongLoader = false;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/ticket/view/' + ticketId + '?additional=getState').then(function (response) {
				state.showLongLoader = true;

				if (response.data && response.data.status === 'ok') {
					var _view = '';
					var _post = '';

					if (response.data.view && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response.data.view) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.view).length) {
						for (var i in response.data.view) {
							if (response.data.view.hasOwnProperty(i)) {
								var _user = response.data.view[i];

								if (String(_user['user_id']) === String(state.user_id)) continue;

								if (_view === '') _view = __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].localeFtc(_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client').toLowerCase() + ' <b>' + _user['user_name'] + '</b>';else _view += '<br>' + __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].localeFtc(_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client').toLowerCase() + ' <b>' + _user['user_name'] + '</b>';
							}
						}
					}

					if (response.data.post && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response.data.post) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.post).length) {
						for (var _i in response.data.post) {
							if (response.data.post.hasOwnProperty(_i)) {
								var _user2 = response.data.post[_i];

								if (String(_user2['user_id']) === String(state.user_id)) continue;

								if (_post === '') _post = __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].localeFtc(_user2['user_type'] === 'admin' ? 'admin/admin' : 'main/client').toLowerCase() + ' <b>' + _user2['user_name'] + '</b>';else _post += '<br>' + __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].localeFtc(_user2['user_type'] === 'admin' ? 'admin/admin' : 'main/client').toLowerCase() + ' <b>' + _user2['user_name'] + '</b>';
							}
						}
					}

					if (_view !== '') __WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-notificator-add-special', {
							'title': 'ticket/who_view',
							'message': _view,
							'class': 'default',
							'type': 'ticket',
							'special': 'view',
							'timeout': 65000
						});else __WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-notificator-del-special', 'view');

					if (_post !== '') __WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-notificator-add-special', {
							'title': 'ticket/who_write',
							'message': _post,
							'class': 'default',
							'type': 'ticket',
							'special': 'post',
							'timeout': 65000
						});else __WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-notificator-del-special', 'post');
				}
			}, function () {
				state.showLongLoader = true;
			});
		}
	},

	mutations: {
		currentAppId: function currentAppId(state) {
			state.currentAppId = new Date().getTime() + '-' + __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].getRandomInt(100000, 999999);
		},
		operateAjaxRequestsCounter: function operateAjaxRequestsCounter(state, value) {
			state.ajaxRequestsCounter += value;
			if (state.ajaxRequestsCounter < 0) state.ajaxRequestsCounter = 0;
		},
		setLang: function setLang(state, value) {
			if (state.lang !== value) state.lang = value;
		},
		hideLongRequestLoader: function hideLongRequestLoader(state, data) {
			state.longRequest = data;
		},
		needShowLoader: function needShowLoader(state, data) {
			state.showLongLoader = data;
		},
		dropAuth: function dropAuth(state) {
			state.is_auth = false;
			state.user_id = false;
			state.user_type = false;
			state.user_login = false;
			state.user_avatar = false;
			state.user_session = false;
			state.user_role = false;

			state.user_balance['real'] = '';
			state.user_balance['bonus'] = '';
			state.user_balance['partner'] = '';

			state.user_account = false;
			state.user_forecast = false;
			state.user_need = null;

			if (window.localStorage) {
				__WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].deleteCookie('w5-user-type');
				window.localStorage.removeItem('user_id');
				window.localStorage.removeItem('user_login');
				window.localStorage.removeItem('user_type');
			}
		},
		setAuth: function setAuth(state, data) {
			if (data && 'user' in data && data['user'] && '_session' in data && data['_session'] && 'user_id' in data['user'] && 'user_email' in data['user'] && 'user_avatar_path' in data['user']) {
				state.is_auth = true;
				state.user_id = data['user']['user_id'];
				state.user_login = data['user']['user_email'];
				state.user_avatar = data['user']['user_avatar_path'];
				state.user_session = data['_session'];
				state.user_type = __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].validateEmail(data['user']['user_email']) ? 'client' : 'admin';
				state.user_role = false;

				if ('role' in data && data['role']) {
					state.user_role = data['role'];
				}

				if ('need' in data && data['need'] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data['need']) === 'object') {
					state.user_need = data['need'];
				}

				if ('user_type' in data['user'] && data['user']['user_type'] && (data['user']['user_type'] === 'admin' || data['user']['user_type'] === 'user')) state.user_type = data['user']['user_type'] === 'admin' ? 'admin' : 'client';

				__WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].setCookie('w5-user-type', state.user_type === 'admin' ? 's' : 'c', { 'expires': 60 * 60 * 24 * 365, 'domain': __WEBPACK_IMPORTED_MODULE_7_vue__["default"].CookieDomain, 'path': '/' });
				if (window.localStorage) {
					window.localStorage.setItem('user_id', state.user_id);
					window.localStorage.setItem('user_login', state.user_login);
					window.localStorage.setItem('user_type', state.user_type);
				}

				if (state.user_type === 'client') state.getClientData(state);

				state.getUserOptionsOnServer(state);
			} else {
				state.is_auth = false;
				state.user_id = false;
				state.user_type = false;
				state.user_login = false;
				state.user_avatar = false;
				state.user_session = false;
				state.user_role = false;

				state.user_balance['real'] = '';
				state.user_balance['bonus'] = '';
				state.user_balance['partner'] = '';

				state.user_account = false;
				state.user_forecast = false;
				state.user_need = null;

				if (window.localStorage) {
					__WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].deleteCookie('w5-user-type');
					window.localStorage.removeItem('user_id');
					window.localStorage.removeItem('user_login');
					window.localStorage.removeItem('user_type');
				}
			}
		},
		setLastRow: function setLastRow(state, data) {
			if (!data || !data['crud']) return;

			if (data['id']) {
				state.lastWorkedRowID[data['crud']] = data['id'];
			} else {
				delete state.lastWorkedRowID[data['crud']];
			}
		},
		setLastPage: function setLastPage(state, data) {
			if (!data || !data['crud']) return;

			if (data['page']) {
				state.lastWorkedPage[data['crud']] = data['page'];
			} else {
				delete state.lastWorkedPage[data['crud']];
			}
		},
		setLastWindowY: function setLastWindowY(state, data) {
			if (!data || !data['url']) return;

			if (data['y']) {
				state.lastWindowY[data['url']] = data['y'];
			} else {
				delete state.lastWindowY[data['url']];
			}
		},
		setWindowSize: function setWindowSize(state, data) {
			state.windowWidth = data.width;
			state.windowHeight = data.height;
		},
		setCrudFilter: function setCrudFilter(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.crudFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.crudFilter = data;
		},
		setModelFilter: function setModelFilter(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.modelFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.modelFilter = data;
		},
		setVdsCommand: function setVdsCommand(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.vdsCommand = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.vdsCommand = data;
		},
		createNoteData: function createNoteData(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.createNoteData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.createNoteData = data;
		},
		bonusActivateData: function bonusActivateData(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.bonusActivateData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.bonusActivateData = data;
		},
		setReturnURL: function setReturnURL(state, value) {
			state.returnURL = value;
		},
		setOperationSumNew: function setOperationSumNew(state, value) {
			state.operationSumNew = value;
		},
		pushStart: function pushStart(state) {
			if (!state.workerPush) {
				state.workerPush = new Worker('/static/js/worker-push.js?_=' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].AppVersion);

				state.workerPush.onmessage = function (e) {
					if (e.data && e.data.cmd && e.data.cmd === 'lid' && e.data.id && window.localStorage) {
						window.localStorage.setItem('push_last_id', e.data.id);
					}

					if (e.data && e.data.cmd && e.data.cmd === 'msg' && e.data.msg) {
						if (state.isDebug) window.DEBUG.log('Push-message: ' + e.data.msg);
						__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-push', e.data.msg);
					}

					if (e.data && e.data.cmd && e.data.cmd === 'terminate') {
						state.workerPush.terminate();
						if (state.isDebug) window.DEBUG.log('PUSH: terminated');
					}
				};
			}

			if (state.workerPush) {
				var _lastMsgId = false;
				if (window.localStorage) _lastMsgId = window.localStorage.getItem('push_last_id');

				state.workerPush.postMessage({
					cmd: 'start',
					url: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].PushUrl,
					sid: state.user_session,
					lid: _lastMsgId
				});
			}
		},
		pushStop: function pushStop(state) {
			if (state.workerPush) {
				state.workerPush.postMessage({
					cmd: 'stop'
				});
			}
		},
		getUserData: function getUserData(state) {
			state.getClientData(state);
		},
		getTicketDepartments: function getTicketDepartments(state, tabs) {
			state.getTicketDepartments(state, tabs);
		},
		getTicketState: function getTicketState(state, ticketId) {
			state.getTicketState(state, ticketId);
		},
		setTicketDepartmentId: function setTicketDepartmentId(state, id) {
			state.ticketData.currentDepartmentId = id;
		},
		setTicketViewId: function setTicketViewId(state, id) {
			state.ticketData.ticketViewId = id;

			if (state.ticketData.needUpperTab[id] === true) {
				state.ticketData.currentDepartmentId = false;

				delete state.ticketData.needUpperTab[id];
			}
		},
		setTicketUpdateId: function setTicketUpdateId(state, id) {
			state.ticketData.ticketUpdateId = id;
		},
		setVdsGroupId: function setVdsGroupId(state, Id) {
			var id = parseInt(Id);
			state.vdsGroup.currentGroupId = isNaN(id) || id <= 0 ? null : id;
		},
		setFilteredGroupId: function setFilteredGroupId(state, id) {
			state.filteredGroupId = id;
		},
		ItIsMe: function ItIsMe(state, value) {
			state.ItIsMe = value;
		},
		blockApplication: function blockApplication(state) {
			__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			state.longRequest = false;
			state.applicationBlocked = true;
		},
		changedForm: function changedForm(state, value) {
			state.changedForm = value;
		},
		isInitFormsValue: function isInitFormsValue(state, value) {
			if (value === true) state.isInitFormsValue++;else state.isInitFormsValue--;
			if (state.isInitFormsValue < 0) state.isInitFormsValue = 0;
		},
		uploadFileCounter: function uploadFileCounter(state, value) {
			if (value === '-') state.uploadFileCounter--;else if (value === '+') state.uploadFileCounter++;

			if (state.uploadFileCounter < 0) state.uploadFileCounter = 0;
		},
		toggleAudioNitificationOption: function toggleAudioNitificationOption(state) {
			var _value = __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].normalizeBooleanValue(state.userServerOptions['play_audio_on_notification']);

			if (!('play_audio_on_notification' in state.userServerOptions)) _value = true;

			state.setUserOptionOnServer(state, 'play_audio_on_notification', !_value);
		},
		setAudioTrackNitificationOption: function setAudioTrackNitificationOption(state, value) {
			var _value = '0' + String(value);

			state.setUserOptionOnServer(state, 'audio_track_on_notification', _value);
		},
		clearUserOptionsOnServer: function clearUserOptionsOnServer(state) {
			state.clearUserOptionsOnServer(state);
		},
		updateUserOptionsOnServer: function updateUserOptionsOnServer(state, data) {
			state.updateUserOptionsOnServer(state, data);
		},
		setAvatarPath: function setAvatarPath(state, path) {
			state.user_avatar = path;
		},
		ListTableLoading: function ListTableLoading(state, value) {
			state.isListTableLoading = value;
		},
		accountGlobalFilter: function accountGlobalFilter(state, data) {
			if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object') state.accountGlobalFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);else state.accountGlobalFilter = data;
		},
		errorHttpCode: function errorHttpCode(state, value) {
			if (value) state.errorHttpCode = value;else state.errorHttpCode = 0;
		},
		needUpperTab: function needUpperTab(state, value) {
			state.ticketData.needUpperTab[value] = true;
		},
		debugMode: function debugMode(state, value) {
			state.isDebug = value;
		},
		setApiVersion: function setApiVersion(state, data) {
			state.apiVersion = '';

			if (data && data.title) state.pageTitle = data.title;

			if (!data || !data.version || !data.yii) return;

			state.apiVersion = 'api ' + data.version + ' (' + data.yii + ')';
		},
		setQACache: function setQACache(state, value) {
			if (!value || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) !== 'object' || !value.popList || !value.newList || !value.tagList) {
				state.qaCache = {
					time: null,
					popList: null,
					newList: null,
					tagList: null
				};

				return;
			}

			state.qaCache = {
				time: __WEBPACK_IMPORTED_MODULE_10__helper_helper_js__["a" /* default */].unixTime() + 600,
				popList: value.popList,
				newList: value.newList,
				tagList: value.tagList
			};
		},
		tableCurrentPage: function tableCurrentPage(state, value) {
			state.tableCurrentPage = value;
		},
		domainRecordId: function domainRecordId(state, value) {
			state.domainRecordId = value;
		},
		createTicketEmail: function createTicketEmail(state, value) {
			state.createTicketEmail = value;
		},
		setTicketCounters: function setTicketCounters(state, value) {
			state.ticketData.counters = value;
		},
		setRequestCounter: function setRequestCounter(state, value) {
			state.requestCounter = value;
		},
		updateUserBalance: function updateUserBalance(state, data) {
			if (data && data.balance && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.balance) === 'object') {
				if ('real' in data.balance && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.balance.real) === 'object' && 'value' in data.balance.real) {
					state.user_balance['real'] = data.balance.real.value;
				}

				if ('bonus' in data.balance && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.balance.bonus) === 'object' && 'value' in data.balance.bonus) {
					state.user_balance['bonus'] = data.balance.bonus.value;
				}

				if ('partner' in data.balance && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.balance.partner) === 'object' && 'value' in data.balance.partner) {
					state.user_balance['partner'] = data.balance.partner.value;
				}
			}
		},
		setMenuSelectingPreset: function setMenuSelectingPreset(state, value) {
			state.menuSelectingPreset = value;
		},
		saveFormCache: function saveFormCache(state, value) {
			if (!state.lastFormCache) state.lastFormCache = {};
			if (!value || !value.formName || !value.data) return;

			state.lastFormCache[value.formName] = {
				data: value.data,
				ttl: new Date().getTime() + (value.ttl ? value.ttl : 500)
			};
		},
		clearFormCache: function clearFormCache(state, value) {
			if (!value || !state.lastFormCache || !state.lastFormCache[value]) return;

			delete state.lastFormCache[value];
		},
		saveTemplateGroupCache: function saveTemplateGroupCache(state, value) {
			state.isLastTemplateGroupCacheLoaded = false;
			state.lastTemplateGroupCache = [{
				'id': 99999,
				'name': 'main/list_all',
				'active': true
			}];

			if (!value || value.status !== 'ok' || !value.groups || !value.groups.length) return;

			state.isLastTemplateGroupCacheLoaded = true;
			state.lastTemplateGroupCache = value.groups;
		}
	},

	actions: {
		getTemplateGroupCache: function getTemplateGroupCache(_ref3) {
			var _this2 = this;

			var state = _ref3.state,
			    commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _dt, i;

				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_dt = false;
								i = 0;

							case 2:
								if (!(i < 3)) {
									_context3.next = 15;
									break;
								}

								_context3.prev = 3;
								_context3.next = 6;
								return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/templategroup/export').then(function (res) {
									_dt = res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' && res.data['status'] === 'ok' ? res.data : false;
									commit('saveTemplateGroupCache', _dt);
								});

							case 6:
								if (!_dt) {
									_context3.next = 8;
									break;
								}

								return _context3.abrupt('return');

							case 8:
								_context3.next = 12;
								break;

							case 10:
								_context3.prev = 10;
								_context3.t0 = _context3['catch'](3);

							case 12:
								i++;
								_context3.next = 2;
								break;

							case 15:
								commit('saveTemplateGroupCache', false);

							case 16:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this2, [[3, 10]]);
			}))();
		},
		getApiVersion: function getApiVersion(_ref4) {
			var state = _ref4.state,
			    commit = _ref4.commit;

			if (state.user_type !== 'admin') return;

			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/admin/index').then(function (res) {
				var _dt = res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' && res.data['status'] === 'ok' ? res.data : false;
				commit('setApiVersion', _dt);
			});
		},
		getTicketCounters: function getTicketCounters(_ref5, isPush) {
			var state = _ref5.state,
			    commit = _ref5.commit;

			if (!state.is_auth) return;

			if (!isPush) {
				requestTicketCountersFunction(commit);
				return;
			}

			if (!ticketCountersTimer) {
				requestTicketAgain(commit);
			} else {
					ticketPushesCounter++;
				}
		},
		getRequestCounter: function getRequestCounter(_ref6, isPush) {
			var state = _ref6.state,
			    commit = _ref6.commit;

			if (state.user_type !== 'admin') return;

			if (!isPush) {
				requestRequestCountersFunction(commit);
				return;
			}

			if (!requestCountersTimer) {
				requestRequestAgain(commit);
			} else {
					requestPushesCounter++;
				}
		}
	}
}));

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-83f80650",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notFound__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_notFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Login__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_forms_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_Registration__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_Registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_forms_Registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_Remember__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_Remember___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_forms_Remember__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_UserCheck__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_UserCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_forms_UserCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_EmailCheck__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_EmailCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_forms_EmailCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_Unsubscribe__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_Unsubscribe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_forms_Unsubscribe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_crud_List__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_crud_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_crud_View__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_crud_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_crud_vdsView__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_crud_vdsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_crud_vdsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_crud_sslView__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_crud_sslView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_crud_sslView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_crud_domainView__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_crud_domainView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_crud_domainView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_crud_Bonus__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_crud_Bonus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_crud_Bonus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_crud_Update__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_crud_Update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_crud_Report__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_crud_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_crud_Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_crud_ReportList__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_crud_ReportList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_crud_ReportList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_crud_Role__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_crud_Role___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_crud_Role__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_crud_ClientPay__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_crud_ClientPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_crud_ClientPay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_crud_TicketView__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_crud_TicketView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_crud_TicketView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_crud_QA__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_crud_QA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_crud_QA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_crud_Info__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_crud_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_crud_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_crud_Users__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_crud_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_crud_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_crud_error500__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_crud_error500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_crud_error500__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_crud_error503__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_crud_error503___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_crud_error503__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_filterUser__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_filterUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_filterUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_oldRoutes__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_oldRoutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_oldRoutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_crud_operationView__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_crud_operationView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_crud_operationView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__bus_js__ = __webpack_require__(4);






































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var _router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',

	routes: [{ path: '/',
		redirect: function redirect(to) {
			if (!__WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.is_auth) return '/login';

			var redirectPath = null;

			if (__WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_role && __WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_role.permissions && __WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_role.permissions.length) {
				__WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_role.permissions.some(function (path) {
					if (path === 'service/list') {
						redirectPath = '/vds/list';
						return true;
					}
				});

				if (redirectPath) return redirectPath;

				__WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_role.permissions.some(function (path) {
					if (/\w+\/list$/i.test(path)) {
						redirectPath = path;
						return true;
					}
				});
			}

			return redirectPath || '/qa/list';
		}
	}, { path: '/vds/:vdsGroupId/list', component: __WEBPACK_IMPORTED_MODULE_27__components_oldRoutes___default.a }, { path: '/vds/:vdsGroupId/list/:page', component: __WEBPACK_IMPORTED_MODULE_27__components_oldRoutes___default.a }, { path: '/logout',
		beforeEnter: function beforeEnter(to, from, next) {
			__WEBPACK_IMPORTED_MODULE_30__bus_js__["a" /* EventBus */].$emit('w5-logout');
		}
	}, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_3__components_forms_Login___default.a }, { path: '/register', component: __WEBPACK_IMPORTED_MODULE_4__components_forms_Registration___default.a }, { path: '/forget', component: __WEBPACK_IMPORTED_MODULE_5__components_forms_Remember___default.a }, { path: '/user/forget', component: __WEBPACK_IMPORTED_MODULE_5__components_forms_Remember___default.a }, { path: '/user/check', component: __WEBPACK_IMPORTED_MODULE_6__components_forms_UserCheck___default.a }, { path: '/unsubscribe/:type/:code', component: __WEBPACK_IMPORTED_MODULE_8__components_forms_Unsubscribe___default.a }, { path: '/qa/list', component: __WEBPACK_IMPORTED_MODULE_21__components_crud_QA___default.a }, { path: '/filter/user/:id', component: __WEBPACK_IMPORTED_MODULE_26__components_filterUser___default.a }, { path: '/options', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/user/alerts', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/user/alerts/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/email/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/email/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/email/check', component: __WEBPACK_IMPORTED_MODULE_7__components_forms_EmailCheck___default.a }, { path: '/vds/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/vds/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/vds/create/:groupId/:planId', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/vds/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/vds/view/:id', component: __WEBPACK_IMPORTED_MODULE_11__components_crud_vdsView___default.a }, { path: '/certificate/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/certificate/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/certificate/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/certificate/view/:id', component: __WEBPACK_IMPORTED_MODULE_12__components_crud_sslView___default.a }, { path: '/domains/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/domains/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/domains/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/domains/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/domains/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/dns/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/dns/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/dns/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/dns/view/:id', component: __WEBPACK_IMPORTED_MODULE_13__components_crud_domainView___default.a }, { path: '/dns-records/create/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/dns-records/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ipptrpool/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ipptrpool/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ipptrpool/create/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ipptrpool/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ipptrpool/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/iphistory/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/iphistory/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/backups/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/backups/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/backups/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/disks/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/disks/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/disks/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/disks/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/disks/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/sshkey/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/sshkey/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/sshkey/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/sshkey/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/sshkey/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/iso/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/iso/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/iso/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/iso/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/additional-services/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/additional-services/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/additional-services/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/service/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/account/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/account/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/account/view/:id', component: __WEBPACK_IMPORTED_MODULE_22__components_crud_Info___default.a }, { path: '/account/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/dashboard/info', component: __WEBPACK_IMPORTED_MODULE_22__components_crud_Info___default.a }, { path: '/users/list', component: __WEBPACK_IMPORTED_MODULE_23__components_crud_Users___default.a }, { path: '/user/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/user/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/user/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/user/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/user/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/notes/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/notes/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/notes/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/notes/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/notes/create/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/operation/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/operation/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/operation/view/:id', component: __WEBPACK_IMPORTED_MODULE_28__components_crud_operationView___default.a }, { path: '/operation/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/operation/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/operation/pay/:id', component: __WEBPACK_IMPORTED_MODULE_19__components_crud_ClientPay___default.a }, { path: '/operation/select/:id', component: __WEBPACK_IMPORTED_MODULE_19__components_crud_ClientPay___default.a }, { path: '/document/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/document/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/document/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/document/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/document/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/paymentauto/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/paymentauto/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/paymentauto/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/paymentauto/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/paymentauto/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/paymentsaved/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/paymentsaved/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/paymentsaved/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/payer/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/payer/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/payer/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/payer/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/payer/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/request/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/request/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/request/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/request/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/partner/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partner/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partner/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/partner/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/partner/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/partnerprogram/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partnerprogram/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partnerprogram/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/partnerprogram/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/partnerprogram/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/partneractions/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partneractions/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/partneractions/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/partneractions/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/bonus/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/bonus/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/bonus/convert', component: __WEBPACK_IMPORTED_MODULE_14__components_crud_Bonus___default.a }, { path: '/bonus/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/bonus/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/bonus/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/bonus/activate', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ticket/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticket/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticket/view/:id', component: __WEBPACK_IMPORTED_MODULE_20__components_crud_TicketView___default.a }, { path: '/ticket/view/:id/:page', component: __WEBPACK_IMPORTED_MODULE_20__components_crud_TicketView___default.a }, { path: '/ticket/department/:depid', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticket/department/:depid/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticket/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ticketmessage/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/ticketmessage/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/logs/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/logs/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/logs/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/chart/list', component: __WEBPACK_IMPORTED_MODULE_17__components_crud_ReportList___default.a }, { path: '/chart/view/:id', component: __WEBPACK_IMPORTED_MODULE_16__components_crud_Report___default.a }, { path: '/template/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/template/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/template/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/template/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/template/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/template/clone/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ippool/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ippool/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ippool/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/ippool/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ippool/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/text/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/text/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/text/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/text/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/text/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/admin/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/admin/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/admin/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/admin/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/admin/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/role/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/role/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/role/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/role/update/:id', component: __WEBPACK_IMPORTED_MODULE_18__components_crud_Role___default.a }, { path: '/role/create', component: __WEBPACK_IMPORTED_MODULE_18__components_crud_Role___default.a }, { path: '/payment/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/payment/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/payment/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/payment/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/payment/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/payment/clone/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/datacenter/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/datacenter/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/datacenter/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/datacenter/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/datacenter/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/servergroup/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/servergroup/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/servergroup/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/servergroup/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/servergroup/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/plangroup/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/plangroup/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/plangroup/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/plangroup/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/plangroup/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/templategroup/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/templategroup/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/templategroup/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/templategroup/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/templategroup/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/server/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/server/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/server/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/server/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/server/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/server/clone/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/servicetype/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/servicetype/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/servicetype/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/servicetype/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/servicetype/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/plan/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/plan/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/plan/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/plan/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/plan/create/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/plan/clone/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/planarchive/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/planarchive/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/planarchive/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/department/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/department/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/department/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/department/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/department/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ticketrule/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticketrule/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/ticketrule/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/ticketrule/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/ticketrule/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/zone/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/zone/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/zone/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/person/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/person/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/person/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/person/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/person/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rack/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rack/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rack/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/rack/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rack/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackdevice/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackdevice/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackdevice/links/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackdevice/clone/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackdevice/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/rackdevice/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackdevice/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackdevice/create/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackspare/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackspare/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackspare/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/rackspare/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackspare/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackservice/list', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackservice/list/:page', component: __WEBPACK_IMPORTED_MODULE_9__components_crud_List___default.a }, { path: '/rackservice/view/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_crud_View___default.a }, { path: '/rackservice/update/:id', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/rackservice/create', component: __WEBPACK_IMPORTED_MODULE_15__components_crud_Update___default.a }, { path: '/500', component: __WEBPACK_IMPORTED_MODULE_24__components_crud_error500___default.a }, { path: '/503', component: __WEBPACK_IMPORTED_MODULE_25__components_crud_error503___default.a }, { path: '/404', component: __WEBPACK_IMPORTED_MODULE_2__components_notFound___default.a }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_2__components_notFound___default.a }]
});

_router.beforeEach(function (to, from, next) {
	var preset = '';

	if (to && from) {
		if (to.fullPath.indexOf('/ipptrpool/view') === 0 && from.fullPath.indexOf('/logs/list') === 0 && __WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].state.user_type === 'admin') {
			preset = 'admin_view_ipptrpool';
		}
	}

	__WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */].commit('setMenuSelectingPreset', preset);

	next();
});

/* harmony default export */ __webpack_exports__["a"] = (_router);

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  "data-v-5f404dfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  "data-v-6b869e8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  "data-v-5fa618a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)
__webpack_require__(479)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  "data-v-33ec7b46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);


var AdditionalServicesFilter = {
	all_ids: '',

	init: function init() {
		var ids = [__WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_IP4, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_RAM, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_SSD, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_CPU, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_TRAFF, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_IP6, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_VDS_LOAD, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_RESERVE_IP, __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants.SERVICE_TYPE_GPU];

		ids.map(function (a) {
			return parseInt(String(a), 10);
		}).sort();

		this.all_ids = ids.join(',');
	},
	is_all_ids: function is_all_ids(arr) {
		if (!arr || !arr.length) return false;

		arr.map(function (a) {
			return parseInt(String(a), 10);
		}).sort();

		return arr.join(',') === this.all_ids;
	},
	filterValue: function filterValue(arr) {
		if (!arr || !arr.length) return null;

		var ids = arr.map(function (a) {
			return a.id;
		}).filter(function (a) {
			return String(a) !== '-1';
		});
		ids.map(function (a) {
			return parseInt(String(a), 10);
		}).sort();
		return ids.join(',');
	},
	list: function list(arr) {
		var _this = this;

		if (!arr || !arr.length) return null;
		return arr.filter(function (a) {
			return a && 'id' in a && _this.all_ids.indexOf(String(a.id)) > -1;
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (AdditionalServicesFilter);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  "data-v-e979b6d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var Mixin = {
	data: function data() {
		return {
			isLoading: false,
			loaderTimer: null
		};
	},
	beforeDestroy: function beforeDestroy() {
		clearTimeout(this.loaderTimer);
	},

	methods: {
		setLoader: function setLoader(what) {
			var _this = this;

			clearTimeout(this.loaderTimer);

			if (what) {
				if (this.isLoading) return;
			} else {
				if (!this.isLoading) return;
			}

			this.loaderTimer = setTimeout(function () {
				_this.isLoading = what;
			}, 400);
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (Mixin);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper_js__ = __webpack_require__(3);





var Mixins = {
	methods: {
		remoteStorageGet: function remoteStorageGet(key) {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
				if (!_this.$store.state.is_auth) return resolve(null);

				_this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].APIServerUrl + '/option/get').then(function (response) {
					if (response && response.data && response.data.status === 'ok' && response.data.option && Array.isArray(response.data.option) && response.data.option.length) {
						response.data.option.some(function (item) {
							if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
								for (var _prop in item) {
									if (item.hasOwnProperty(_prop)) {
										if (_prop === key) return resolve(item[_prop]);
									}
								}
							}
						});
					}

					resolve(null);
				}).catch(function () {
					return resolve(null);
				});
			});
		},

		remoteStorageSet: function remoteStorageSet(key, value) {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (!_this2.$store.state.is_auth) return resolve(null);

				_this2.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].APIServerUrl + '/option/set/' + key, __WEBPACK_IMPORTED_MODULE_3__helper_helper_js__["a" /* default */].toFormData({ value: value })).then(function (response) {
					if (response && response.data && response.data.status === 'ok') return resolve();

					reject({ name: 'remoteStorage', message: 'error/api_incorrect' });
				}).catch(function (res) {
					var _errMsg = 'error/api_incorrect';

					if (res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' && 'title' in res.data && res.data['title'] && res.data['title'].length) _errMsg = 'main/error_desc ' + res.data['title'];

					if (res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' && 'content' in res.data && res.data['content'] && res.data['content'].length) _errMsg = 'main/error_desc ' + res.data['content'];

					reject({ name: 'remoteStorage', message: _errMsg });
				});
			});
		}

	}

};

/* harmony default export */ __webpack_exports__["a"] = (Mixins);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-2ed4a4df",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
	props: ['data', 'options'],
	mounted: function mounted() {
		this.renderChart(this.data, this.options);
	}
}));

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
	props: ['data', 'options'],
	mounted: function mounted() {
		this.renderChart(this.data, this.options);
	}
}));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-e0b78ea8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  "data-v-6b3a3ced",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_locale_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_forms_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_formater_js__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_helper_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__App__);










__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add([__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_35" /* faUserSecret */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_6" /* faPlus */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_13" /* faRubleSign */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_3" /* faPiggyBank */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["D" /* faExclamationCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["X" /* faLock */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["l" /* faChevronDown */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_26" /* faTimes */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_27" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["x" /* faDollarSign */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["C" /* faExchangeAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["p" /* faClock */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["d" /* faAsterisk */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["j" /* faCheck */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["k" /* faCheckCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["B" /* faEnvelope */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["T" /* faLink */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["z" /* faEject */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["c" /* faArrowRight */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["a" /* faArrowDown */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["O" /* faHdd */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_28" /* faTrash */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_29" /* faTrashAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_2" /* faPencilAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["V" /* faListAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["U" /* faList */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["W" /* faListUl */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["f" /* faBars */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["A" /* faEllipsisV */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_11" /* faRandom */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["E" /* faEye */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["F" /* faEyeSlash */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_22" /* faTerminal */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_12" /* faRedo */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["t" /* faCompactDisc */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_5" /* faPlayCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_38" /* faVolumeUp */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_37" /* faVolumeMute */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["J" /* faFilter */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["m" /* faChevronRight */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_9" /* faQuestionCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["Z" /* faLongArrowAltUp */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["Y" /* faLongArrowAltDown */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_4" /* faPlay */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_19" /* faStop */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_32" /* faUpload */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["n" /* faCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["q" /* faClone */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_25" /* faThumbtack */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["h" /* faCalendarAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_20" /* faSun */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_36" /* faUsers */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["N" /* faHandshake */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_16" /* faServer */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_8" /* faPowerOff */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_21" /* faTasks */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["P" /* faHistory */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["e" /* faBan */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["u" /* faCompressAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_33" /* faUserCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_30" /* faTrophy */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["H" /* faFileDownload */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_17" /* faShare */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_18" /* faShareSquare */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["I" /* faFileInvoice */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["g" /* faBriefcase */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["K" /* faGift */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_34" /* faUserGraduate */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["v" /* faCopy */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["b" /* faArrowLeft */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["S" /* faInfoCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_10" /* faQuoteRight */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_7" /* faPlusCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["L" /* faGlobeAmericas */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_1" /* faPaperclip */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["R" /* faImage */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["w" /* faCut */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["y" /* faDownload */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["i" /* faCaretSquareRight */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["Q" /* faHourglassHalf */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_24" /* faThumbsUp */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_23" /* faThumbsDown */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_14" /* faSearch */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["s" /* faCommentDollar */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_31" /* faUniversalAccess */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["M" /* faGripVertical */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["r" /* faCloudDownloadAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_15" /* faSearchDollar */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["_0" /* faNetworkWired */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["o" /* faClipboard */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["G" /* faFileCsv */]]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('font-awesome-layers', __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__["b" /* FontAwesomeLayers */]);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_locale_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__plugins_forms_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__plugins_formater_js__["a" /* default */]);

window.DEBUG = function () {
	function _log(str) {
		var _dt = new Date().toLocaleTimeString();
		console.log('[DEBUG ' + _dt + '] ' + str);
	}

	function _error(str) {
		var _dt = new Date().toLocaleTimeString();
		console.error('[DEBUG ' + _dt + '] ' + str);
	}

	return {
		log: _log,
		error: _error
	};
}();

var _locale = __WEBPACK_IMPORTED_MODULE_11__helper_helper_js__["a" /* default */].getCookie('ln');
if (!_locale) _locale = 'ru';

__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setLang', _locale);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_12__App___default.a }
});

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'notFoundPage'
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-error-page"
  }, [(!_vm.$store.state.is_auth) ? [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br')] : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("К сожалению, запрашиваемая страница не найдена.")]), _vm._v(" "), (_vm.$store.state.is_auth) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Вы можете вернуться на главную страницу.")]) : _vm._e()], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-404"
  }, [_vm._v("4"), _c('div', {
    staticClass: "bird-map"
  }), _vm._v("4")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'loginForm',

	data: function data() {
		return {
			formData: null,

			isInputDisabled: false,

			show2FADialogModal: false,
			fields2FA: null
		};
	},

	computed: {
		emailValue: function emailValue() {
			if (!this.formData || !this.formData['fields']) return null;

			var field = this.findFormField('email', this.formData['fields']);
			if (field) return field['value'];

			return null;
		},
		is_admin: function is_admin() {
			return !__WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].validateEmail(this.emailValue);
		}
	},

	created: function created() {
		if (this.$store.state.is_auth) {
			return this.$router.push('/');
		}

		this.formRequest();
	},

	methods: {
		formRequest: function formRequest() {
			var _this = this;

			this.getFormFromCache('/login').then(function (formData) {
				if (formData && formData.title && formData.fields && formData._csrf && formData.model) {
					var newData = _this.parseFormData(formData, _this.formData);
					if (newData) _this.formData = newData;

					if (_this.formData && _this.formData['fields']) {
						var field = _this.findFormField('remember_me', _this.formData['fields']);
						if (field) field['value'] = 1;
					}
				}

				if (formData && formData.status === 'error' && formData.message && formData.message.length) {
					_this.form_ErrorMessage = _this.localeFtc(formData.message);

					if (String(formData.message).toLowerCase().indexOf('blacklisted') !== -1) {
						_this.formData = null;
					}
				}
			});
		},
		failRequest: function failRequest(error) {
			this.form_ErrorMessage = false;

			var _msg = this.localeFtc('main/validation_error');
			var _isError = false;

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['email']) {
				_isError = true;

				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0]);else _msg = this.localeFtc(error['email']);

				var field = this.findFormField('email', this.formData['fields']);
				if (field) field['_errMsg'] = _msg;
			}

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['password']) {
				_isError = true;

				if (Array.isArray(error['password']) && error['password'].length) _msg = this.localeFtc(error['password'][0]);else _msg = this.localeFtc(error['password']);

				var _field2 = this.findFormField('password', this.formData['fields']);
				if (_field2) _field2['_errMsg'] = _msg;
			}

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['captcha']) {
				_isError = true;

				if (Array.isArray(error['captcha']) && error['captcha'].length) _msg = this.localeFtc(error['captcha'][0]);else _msg = this.localeFtc(error['email']);

				var _field3 = this.findFormField('captcha', this.formData['fields']);
				if (_field3) _field3['_errMsg'] = _msg;
			}

			this.$store.commit('dropAuth');

			if (!_isError) {
				this.form_ErrorMessage = _msg;
			}

			this.formRequest();
		},
		localValidation: function localValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			return true;
		},
		login: function login() {
			var _this2 = this;

			if (this.form_Loading) return;

			if (!this.formData || !this.formData['fields']) return;

			this.form_ErrorMessage = false;

			var _data = this.collectFormData(this.formData['fields'], this.localValidation);

			if (_data === false) return;

			if (!this.is_admin) {
				var field = this.findFormField('rememberMe', this.formData['fields']);
				if (field) {
					_data['rememberMe'] = __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].normalizeBooleanValue(field['value']) ? 1 : 0;
				}
			}

			var _url = '/login';
			this.forms_GetThenPost(_url, _data, function (data) {
				if (data && 'user' in data && data['user'] && '_session' in data && data['_session'] && 'user_id' in data['user'] && 'user_email' in data['user'] && 'user_avatar_path' in data['user'] && window.localStorage && window.sessionStorage) {
					var _type = _this2.is_admin ? 'admin' : 'client';

					if ('user_type' in data && data['user_type'] && (data['user_type'] === 'admin' || data['user_type'] === 'user')) _type = data['user_type'] === 'admin' ? 'admin' : 'client';

					window.localStorage.setItem('user_type', _type);

					var _url2 = '/';

					if (_this2.$store.state.returnURL) {
						window.sessionStorage.setItem('_ru', _this2.$store.state.returnURL);

						_url2 = _this2.$store.state.returnURL;
						_this2.$store.commit('setReturnURL', false);
					}

					window.location.href = _url2;
					window.location.reload(true);

					return;
				}

				_this2.failRequest(data);
			}, function (res) {
				if (res && res.status === 403 && res.data && res.data.content === 'Blacklisted') {
					_this2.form_ErrorMessage = _this2.localeFtc('login/blacklisted');

					_this2.$store.commit('dropAuth');

					_this2.formData = null;
				} else if (res && res.status === 511 && res.data && res.data.content === 'Need 2FA Verify') {
						_this2.form_ErrorMessage = false;

						_this2.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + '/twofa/check').then(function (res) {
							var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

							if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
								_this2.fields2FA = _this2.parseFormData(_dt);

								_this2.show2FADialog();
								return;
							}

							throw res;
						}).catch(function (err) {
							var _msg = 'register/error';
							if (err) _msg = _this2.formatRequestError(err);
							_this2.form_ErrorMessage = _msg;
						});

						return;
					} else _this2.failRequest(res);
			});
		},
		onFocus2FA: function onFocus2FA(field) {
			if (field) field['_errMsg'] = '';
		},
		hide2FADialogModal: function hide2FADialogModal() {
			var _this3 = this;

			this.isInputDisabled = false;
			this.$nextTick(function () {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
				_this3.show2FADialogModal = false;
				_this3.hideModalMask();
			});
		},
		show2FADialog: function show2FADialog() {
			var _this4 = this;

			this.isInputDisabled = true;
			this.$nextTick(function () {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
				_this4.show2FADialogModal = true;
				_this4.$nextTick(function () {
					var _block = null;
					if (_this4.$refs && _this4.$refs.code) {
						if (_this4.$refs.code.length) _block = _this4.$refs.code[0];else _block = _this4.$refs.code;
					}

					if (_block && _block.$el) {
						var _input = _block.$el.querySelector('input');
						if (_input && _input.focus) {
							try {
								_input.focus();
							} catch (e) {}
						}
					}
				});
			});
		},
		isVisibleField: function isVisibleField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		find2FAField: function find2FAField(name) {
			var _rows = this.fields2FA.fields;
			if (!_rows || !Array.isArray(_rows)) return null;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		submit2FAForm: function submit2FAForm() {
			var _this5 = this;

			var _field = this.find2FAField('code');
			if (!_field) return;
			if (!_field.value) {
				_field['_errMsg'] = 'error/required_field';
				return;
			}

			this.form_ErrorMessage = false;

			var _isErr = this.fields2FA.fields.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true) {
							if (fld.value === undefined || fld.value === null) {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});
			if (_isErr) return;

			var _url = this.APIServerUrl + '/twofa/check';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					_this5.fields2FA.fields.forEach(function (row) {
						if (row && Array.isArray(row) && row.length) {
							row.forEach(function (fld) {
								var _value = fld['value'];
								if (fld['type'] === 'boolean') {
									_value = __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].normalizeBooleanValue(fld['value']) ? 1 : 0;
								}
								_post[_dt['model']][fld['_field_name']] = _value;
							});
						}
					});

					_this5.$http.post(_url, __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this5.hide2FADialogModal();
							_this5.login();

							return;
						}

						if (_dt && _dt['status'] === 'error' && _dt['fields'] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt['fields']) === 'object') {
							for (var f in _dt['fields']) {
								if (_dt['fields'].hasOwnProperty(f)) {
									var _fld = _this5.find2FAField(f);
									if (_fld) {
										_fld['_errMsg'] = _this5.localeFtc('main/error_desc').replace(':', '');

										if (Array.isArray(_dt['fields'][f])) {
											if (_dt['fields'][f].length) _fld['_errMsg'] = _this5.localeFtc(_dt['fields'][f][0]);
										} else _fld['_errMsg'] = _this5.localeFtc(_dt['fields'][f]);
									}
								}
							}return;
						}

						_this5.hide2FADialogModal();

						_this5.form_ErrorMessage = _this5.formatRequestError(resPost);
					}, function (resPost) {
						_this5.hide2FADialogModal();

						_this5.form_ErrorMessage = _this5.formatRequestError(resPost);
					});

					return;
				}

				_this5.hide2FADialogModal();

				_this5.form_ErrorMessage = _this5.formatRequestError(resGet);
			}, function (resGet) {
				_this5.hide2FADialogModal();

				_this5.form_ErrorMessage = _this5.formatRequestError(resGet);
			});
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default.a
	}

});

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__admin_left_menu_vdsina__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__admin_left_menu_vdsina_com__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_left_menu_macloud__ = __webpack_require__(323);






var leftMenu = function leftMenu() {
	if (Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).APP_NAME === 'macloud') return __WEBPACK_IMPORTED_MODULE_3__admin_left_menu_macloud__["a" /* default */];
	if (Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).APP_NAME === 'vdsina.com') return __WEBPACK_IMPORTED_MODULE_2__admin_left_menu_vdsina_com__["a" /* default */];
	return __WEBPACK_IMPORTED_MODULE_1__admin_left_menu_vdsina__["a" /* default */];
};

var adminData = {
	leftMenu: leftMenu(),

	'vds': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/create_vds',
				'off': 'service_name',
				'on': 'service_name',
				'migrate': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status',
					'plan_group_id': 'plangroup/plangroup'
				},
				'select': {
					'plan_id': 'plan/plan',
					'datacenter_id': 'datacenter/datacenter',
					'template_id': 'template/template',
					'ip_net': 'ippool/view_net',
					'server_group_id': 'servergroup/servergroup',
					'server_view_type': 'server/server'
				},
				'planParams': {},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'group': {
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'title': 'main/type',
					'component-row': 'imageGroupVds',
					'component-param-title': function componentParamTitle(row, data) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].vdsGroupImageTitle(row, data);
					},
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].vdsGroupImage(row);
					}
				},
				'os': {
					'title': 'template/os',
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'component-row': 'image',
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('template:image', row);
					}
				},
				'vds': {
					'title': 'service/service',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'vds_info',
					'component-param-data': function componentParamData(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('plan:data', row);
					},
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/vds/view/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name'];
					}
				},
				'ip': {
					'title': 'ippool/ippool',
					'class-col': 'aw5-vds-column-ip',
					'function-row': function functionRow(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('ip:ip', row);
					},
					'function-cell-class': function functionCellClass(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('ip:ip:active', row) ? '' : 'text-strike';
					}
				},
				'service_status': {
					'sort': true,
					'class-col': 'aw5-vds-column-status',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center aw5-vds-column-created',
					'class-row': 'text-center vds-date',
					'formater-row': 'formater_StrDateOnly'
				},
				'server_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-server'
				},
				'account_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-account',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'vdsReboot': {
					'title': 'service/reboot',
					'action': 'func:GoToVds:reboot'
				},
				'vdsPlan': {
					'title': 'service/plan_change',
					'action': 'func:GoToVds:plan'
				},
				'vdsReinstall': {
					'title': 'service/reinstall',
					'action': 'func:GoToVds:reinstall'
				},
				'vdsChangePassword': {
					'title': 'service/password_change',
					'action': 'func:GoToVds:password'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'removeFilter': {
					'title': 'service/remove_filter',
					'action': 'func:removeFilter'
				},
				'vdsClone': {
					'title': 'main/clone',
					'action': 'func:vdsClone'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		},
		'hint-link': {
			'create': [{
				position: 'before-button',
				title: 'field/hint_ssh_key_before',
				link: "https://vdsina.ru/qa" + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu',
				afterText: 'field/hint_ssh_key_after',
				showIfField: 'sshkey_id'
			}, {
				position: 'before-button',
				title: 'field/hint_backup_auto',
				link: "https://vdsina.ru/qa" + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
				showIfField: 'backup_auto'
			}]
		}
	},

	'disks': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/extdisk_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				},
				'diskType': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name': {
					'title': 'service/extdisk',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/disks/' + (row['service_status'] === 'active' ? 'update' : 'view') + '/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name_full'];
					}
				},
				'attached': {
					'title': 'service/extdisk_attached',
					'component-row': 'outer_disk_info'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/disks/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'connectOuterDisk': {
					'title': 'main/attach main/disk',
					'action': 'func:connectOuterDisk'
				},
				'ejectOuterDisk': {
					'title': 'main/detach main/disk',
					'action': 'func:ejectOuterDisk'
				},
				'cloneOuterDisk': {
					'title': 'main/clone',
					'action': 'func:cloneOuterDisk'
				},
				'backupOuterDisk': {
					'title': 'service/backup_create',
					'action': 'func:backupOuterDisk'
				},
				'restoreBackupOuterDisk': {
					'title': 'service/backup_restore',
					'action': 'func:restoreBackupOuterDisk'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'scheduleOuterDisk': {
					'title': 'schedule/create_title',
					'action': 'func:scheduleOuterDisk'
				},
				'scheduleOuterDiskUpdate': {
					'title': 'schedule/update_title',
					'action': 'func:scheduleOuterDisk'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				}
			}
		},
		'hint-link': {
			'create': [{
				position: 'before-button',
				title: 'field/hint_backup_auto',
				link: "https://vdsina.ru/qa" + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
				showIfField: 'backup_auto'
			}]
		}
	},

	'backups': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/backup_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter',
					'server_view_type': 'server/server'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'backup_name': {
					'title': 'service/backup',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/backups/view/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name_full'];
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'server_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-server'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'restoreBackup': {
					'title': 'main/restore',
					'action': 'func:restoreBackup'
				},
				'createFromBackup': {
					'title': 'main/create server/server',
					'action': 'func:createFromBackup'
				},
				'createFromBackupOuterDisk': {
					'title': 'service/extdisk_create',
					'action': 'func:createFromBackupOuterDisk'
				},
				'renameBackup': {
					'title': 'service/rename_action',
					'action': 'func:renameBackup'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				},
				'copyToDc': {
					'title': 'main/copy',
					'action': 'func:copyToDc'
				},
				'downloadBackup': {
					'title': 'backup/download_title',
					'action': 'func:downloadBackup'
				}
			}
		}
	},

	'sshkey': {
		'model': 'SshKeySearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'sshkey/create_title'
			},
			'column_id': 'key_id',
			'columns': {
				'key_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.key_id ? '/sshkey/view/' + row.key_id : '';
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/sshkey/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'key_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:sshkey:log_sub'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'iso': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/iso_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/iso/view/' + row.service_id : '';
					}
				},
				'attached': {
					'style-col': 'width: 170px',
					'title': 'service/iso_inserting_data',
					'component-row': 'iso_info'
				},
				'size': {
					'style-col': 'width: 85px',
					'title': 'service/iso_size',
					'function-row': function functionRow(row, raw) {
						if (row && row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['filesize']) return row['service_data']['iso']['filesize'];else return 'main/unknown';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'connectISOOper': {
					'title': 'service/iso_insert',
					'action': 'func:connectISOOper'
				},
				'ejectISOOper': {
					'title': 'service/iso_eject',
					'action': 'func:ejectISOOper'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'additional-services': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'off': 'service_name',
				'on': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/additional-services/view/' + row.service_id : '';
					}
				},
				'parent_name': {
					'title': 'service/parent',
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.parent_id ? '/service/view/' + row.parent_id : '';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'certificate': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',

				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'title': 'service/cert_crt',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/certificate/view/' + row.service_id : '';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': function functionCellClass(row) {
						return 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase();
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'dns': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'dns/create_domain',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'sort': true,
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/dns/view/' + row.service_id : '';
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'domain-online-status': function domainOnlineStatus(row) {
						return row && row['service_data'] && row['service_data']['real'] === true;
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/dns/view'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		},
		'hint-link': {
			'create': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: "https://vdsina.ru/qa" + '/q/kakie-ns-servery-ispolzovat'
			}
		}
	},

	'account': {
		'list': {
			'can_select_rows': false,
			'column_id': 'account_id',
			'filters': {
				'period': {
					'begin_field': 'account_date_start',
					'end_field': 'account_date_end'
				}
			},
			'columns': {
				'account_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				},
				'account_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_partner_name': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_partner_id ? '/account/view/' + row.account_partner_id : '';
					}
				},
				'real_balance': {
					'sort': true,
					'style-col': 'width: 100px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell-class': function componentParamCellClass(row) {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return false;
						if (row['real_balance'].charAt(0) !== '-') return false;else return 'color-red';
					},
					'component-param-cell': function componentParamCell(row, digits) {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return '';
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].Num2Money(row['real_balance'], digits);
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/account/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'account_name'
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::account_id'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes::account_id'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:account:log_sub'
				},
				'user': {
					'title': 'account/users',
					'action': 'func:GoTo:user::account_id'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::account_id'
				},
				'bonusActivate': {
					'title': 'bonus/convert',
					'action': 'func:bonusActivateFromMenu'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				},
				'accountReport': {
					'title': 'main/text_report',
					'action': 'func:accountReport'
				}
			}
		}
	},

	'user': {
		'list': {
			'buttons': {
				'create': 'user/create_title',
				'off': 'user_email',
				'on': 'user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'filters': {
				'period': {
					'begin_field': 'user_date_start',
					'end_field': 'user_date_end'
				},
				'radio': {
					'user_status': 'main/status'
				}
			},
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.user_id ? '/user/view/' + row.user_id : '';
					},
					'user-online-status': 'user_online'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellUserStatusValue(row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['user_status'];
					}
				},
				'user_full_access': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return row['user_full_access'] === true ? __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].localeFtc('main/yes') : __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].localeFtc('main/no');
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-user-accesses';
					}
				},
				'user_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/user/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email'
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::account_id'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:user:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:user:log_sub'
				},
				'logOver': {
					'title': 'user/actions',
					'action': 'func:GoTo:logs::user_id'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'notes': {
		'list': {
			'can_select_rows': false,
			'column_id': 'note_id',
			'filters': {
				'period': {
					'begin_field': 'note_date_start',
					'end_field': 'note_date_end'
				},
				'radio': {
					'note_type': 'notes/type',
					'note_object': 'main/object'
				}
			},
			'columns': {
				'note_date': {
					'sort': true,
					'style-col': 'width: 140px',
					'title': 'notes/info',
					'component-row': 'note_info',
					'component-param-date': function componentParamDate(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].FormatDateTime(row['note_date'], 'd.m.y H:M');
					},
					'component-param-url1': function componentParamUrl1(row) {
						return '/account/view/' + row['account_id'];
					},
					'component-param-text1': function componentParamText1(row) {
						return row['account_name'];
					},
					'component-param-url2': function componentParamUrl2(row) {
						return '/' + row['user_type'] + '/view/' + row['user_id'];
					},
					'component-param-text2': function componentParamText2(row) {
						return row['user_email'];
					},
					'user-online-status': 'user_online'
				},
				'note_object': {
					'sort': true,
					'style-col': 'width: 220px',
					'title': 'main/object',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						if (row['object_link'] === null || row['object_link'] === undefined) return '';
						if (row['object_id'] === null || row['object_id'] === undefined) return '';

						return String(row['object_link']).trim().replace('%ID%', String(row['object_id']).trim());
					},
					'component-param-text': function componentParamText(row) {
						var _value1 = row['object_type_text'] !== null && row['object_type_text'] !== undefined ? String(row['object_type_text']).trim() : '';
						var _value2 = row['object_name'] !== null && row['object_name'] !== undefined ? String(row['object_name']).trim() : '';

						var _value = _value1;
						if (_value2 !== '') {
							if (_value !== '') _value += '<br>' + _value2;else _value += _value2;
						}

						return _value;
					}
				},
				'note_text': {
					'title': 'notes/text',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.note_id ? '/notes/view/' + row.note_id : '';
					},
					'component-param-icon': function componentParamIcon(row) {
						return row && row.note_file ? 'file-download' : null;
					},
					'component-param-text': function componentParamText(row) {
						if (!row) return;

						var _text = row.note_text && row.note_text.length > 0 ? row.note_text.length > 120 ? row.note_text.substr(0, 120) + '...' : row.note_text : '';
						if (row.note_file && (!_text || _text === '')) {
							_text = '';
							if (row && 'note_type' in row) _text += row['note_type'];
							if (row && 'note_size' in row) _text += ' (' + row['note_size'] + ')';
						}

						return _text;
					},
					'function-cell-class': function functionCellClass() {
						return 'white-space-normal';
					}
				}
			},
			'opers': {
				'create': {
					'action': 'url:/notes/create'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'notes/delete_request_1',
						'note': 'object_id'
					}
				}
			}
		}
	},

	'operation': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'operation/create_title',
				'exportCsv': 'main/export CSV'
			},
			'column_id': 'operation_id',
			'filters': {
				'period': {
					'begin_field': 'operation_date_start',
					'end_field': 'operation_date_end'
				},

				'radio': {
					'operation_purse': 'operation/purse',
					'operation_type': 'main/type',
					'operation_status': 'main/status'
				},
				'select': {
					'payment_id': 'payment/payment',
					'payment_type': 'main/type payment/payment'
				}
			},
			'columns': {
				'operation_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.operation_id ? '/operation/view/' + row.operation_id : '';
					}
				},
				'operation_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 100px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'operation_summa': {
					'sort': true,
					'style-col': 'width: 90px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell': function componentParamCell(row, digits) {
						if (!row || !('operation_summa' in row) || row['operation_summa'] === null || row['operation_summa'] === undefined) return '';
						if (!row || !('operation_type' in row) || row['operation_type'] === null || row['operation_type'] === undefined) return row['operation_summa'];
						return row['operation_type'] === 1 ? '+' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].Num2Money(row['operation_summa'], digits) : '-' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].Num2Money(row['operation_summa'], digits);
					}
				},
				'operation_purse': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('operation_purse', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-operation-purse';
					}
				},
				'payment_id': {
					'sort': true,
					'title': 'payment/details',
					'component-row': 'linkComponent',
					'component-param-text': function componentParamText(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellOperationPayment_Text(row, raw);
					},
					'component-param-url': function componentParamUrl(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellOperationPayment_Url(row, raw);
					}
				},
				'operation_status': {
					'sort': true,
					'style-col': 'width: 90px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('operation_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['operation_status'];
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/operation/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'operation_id'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:operation:log_sub'
				},
				'paymentLink': {
					'title': 'operation/get_payment_link',
					'action': 'func:showPaymentLink'
				}
			}
		}
	},

	'paymentsaved': {
		'model': 'PaymentSavedSearch',
		'list': {
			'column_id': 'saved_id',
			'columns': {
				'saved_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].makeUrlForApi(row.saved_image);
					}
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.saved_id ? '/paymentsaved/view/' + row.saved_id : '';
					}
				},
				'saved_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentsaved:log_sub'
				}
			}
		}
	},

	'paymentauto': {
		'model': 'PaymentAutoSearch',
		'list': {
			'buttons': {
				'create': 'paymentauto/create_title',
				'off': '-saved_name',
				'on': '-saved_name'
			},
			'on-off': 'payments',
			'column_id': 'auto_id',
			'filters': {
				'radio': {
					'auto_status': 'main/status'
				}
			},
			'columns': {
				'auto_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].makeUrlForApi(row.saved_image);
					}
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.auto_id ? '/paymentauto/update/' + row.auto_id : '';
					}
				},
				'auto_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('auto_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['auto_status'];
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/paymentauto/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentauto:log_sub'
				}
			}
		}
	},

	'document': {
		'model': 'DocumentSearch',
		'list': {
			'buttons': {
				'create': 'document/create_title'
			},
			'column_id': 'document_id',
			'filters': {
				'period': {
					'begin_field': 'doc_date_start',
					'end_field': 'doc_date_end'
				},
				'radio': {
					'document_status': 'main/status',
					'document_type': 'main/type'
				},
				'select': {
					'payer_id': 'payer/payer'
				}
			},
			'columns': {
				'document_name': {
					'sort': true,
					'component-row': 'document_html'
				},
				'document_status': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('document_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['document_status'];
					}
				},
				'document_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'document_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/document/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'document_name',
						'timer': 5
					}
				},
				'operLink': {
					'title': 'operation/operation',
					'action': 'func:goOperLink'
				},
				'mailDocument': {
					'title': 'document/mail',
					'action': 'func:goMailDocument'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:document:log_sub'
				},
				'pdfLink': {
					'title': 'main/download PDF',
					'action': 'func:goPdfLink'
				},
				'xmlLink': {
					'title': 'main/download XML',
					'action': 'func:goXmlLink'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	'payer': {
		'model': 'PayerSearch',
		'list': {
			'buttons': {
				'create': 'payer/create_title'
			},
			'column_id': 'payer_id',
			'filters': {
				'period': {
					'begin_field': 'payer_date_start',
					'end_field': 'payer_date_end'
				},
				'radio': {
					'payer_status': 'main/status'
				}
			},
			'columns': {
				'payer_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'payer_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.payer_id ? '/payer/view/' + row.payer_id : '';
					}
				},
				'payer_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'payer_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('payer_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['payer_status'];
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payer/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payer_name',
						'timer': 5
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::payer_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payer:log_sub'
				}
			}
		}
	},

	'request': {
		'list': {
			'fast_search': false,
			'can_select_rows': false,
			'column_id': 'request_id',
			'filters': {
				'period': {
					'begin_field': 'request_date_start',
					'end_field': 'request_date_end'
				},

				'radio': {
					'request_type': 'main/type',
					'request_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype'
				}
			},
			'columns': {
				'request_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.request_id ? '/request/view/' + row.request_id : '';
					}
				},
				'request_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/service/view/' + row.service_id : '';
					}
				},
				'request_type_text': {
					'title': 'main/type',
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValue('request_type_text', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						var _status = row['request_type'];
						var _tmp = String(row['request_type_text']).split('/').pop();
						return 'w5-breaked-text w5-status-color-' + (_tmp !== null && _tmp !== undefined && _tmp !== '' ? _tmp : _status);
					}
				},
				'request_status': {
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('request_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['request_status'];
					}
				},
				'account_name': {
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/request/update'
				},
				'serviceRequest': {
					'title': 'service/filter',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:request:log_sub'
				}
			}
		}
	},

	'partner': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'partner/create_title'
			},
			'fast_search': true,
			'column_id': 'p2a_id',
			'columns': {
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.program_id ? '/partnerprogram/view/' + row.program_id : '';
					}
				},
				'p2a_code': {
					'sort': true,
					'title': 'partner/code',
					'component-row': 'partner_code'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/partner/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'program_name',
						'timer': 5
					}
				},
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions::p2a_id'
				}
			}
		}
	},

	'partnerprogram': {
		'model': 'PartnerProgramSearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'partnerprogram/create_title'
			},
			'fast_search': true,
			'column_id': 'program_id',
			'columns': {
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.program_id ? '/partnerprogram/view/' + row.program_id : '';
					}
				},
				'program_status': {
					'sort': true,
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('program_status', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['program_status'];
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/partnerprogram/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'program_name',
						'timer': 5
					}
				},
				'partner': {
					'title': 'partner/title',
					'action': 'func:GoTo:partner::program_id'
				},
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions'
				}
			}
		}
	},

	'partneractions': {
		'model': 'PartnerActionsSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'click_id',
			'filters': {
				'period': {
					'begin_field': 'click_date_start',
					'end_field': 'click_date_end'
				}
			},
			'columns': {
				'owner_account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.owner_account_id ? '/account/view/' + row.owner_account_id : '';
					}
				},
				'created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.program_id ? '/partnerprogram/view/' + row.program_id : '';
					}
				},
				'http_referer': {
					'sort': true,
					'component-row': 'http_referer'
				},
				'ip': {
					'sort': true,
					'style-col': 'width: 120px'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				},
				'real_balance': {
					'sort': true,
					'style-col': 'width: 100px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell-class': function componentParamCellClass(row) {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return false;
						if (row['real_balance'].charAt(0) !== '-') return false;else return 'color-red';
					},
					'component-param-cell': function componentParamCell(row, digits) {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return '';
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].Num2Money(row['real_balance'], digits);
					}
				}
			}
		}
	},

	'bonus': {
		'list': {
			'buttons': {
				'create': 'bonus/create_title',
				'off': '-bonus_name',
				'on': '-bonus_name'
			},
			'on-off': 'bonuses',
			'column_id': 'bonus_id',
			'filters': {
				'period': {
					'begin_field': 'bonus_date_start',
					'end_field': 'bonus_date_end'
				},

				'radio': {
					'bonus_status': 'main/status',
					'bonus_type': 'main/type'
				}
			},
			'columns': {
				'bonus_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.bonus_id ? '/bonus/view/' + row.bonus_id : '';
					}
				},
				'bonus_start': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': function functionCellStyle(row) {
						return row['bonus_start_color'] ? 'color: ' + row['bonus_start_color'] : null;
					}
				},
				'bonus_stop': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': function functionCellStyle(row) {
						return row['bonus_stop_color'] ? 'color: ' + row['bonus_stop_color'] : null;
					}
				},
				'bonus_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': function functionCellStyle(row) {
						return row['bonus_end_color'] ? 'color: ' + row['bonus_end_color'] : null;
					}
				},
				'bonus_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('bonus_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['bonus_status'];
					}
				},
				'bonus_type': {
					'sort': true,
					'style-col': 'width: 140px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('bonus_type', row, raw, ['ftc']);
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/bonus/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'bonus_name'
					}
				},
				'account': {
					'title': 'account/title',
					'action': 'func:GoTo:account::bonus_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:bonus:log_sub'
				},
				'bonusActivate': {
					'title': 'bonus/convert',
					'action': 'func:bonusActivateFromMenu'
				}
			}
		}
	},

	'ticket': {
		'list': {
			'buttons': {
				'create': 'ticket/create_title',
				'blockTicket': 'ticket/blacklist',
				'closeTicket': 'main/closing',
				'replaceTicket': 'ticketrule/action_move'
			},
			'column_id': 'ticket_id',
			'filters': {
				'period': {
					'begin_field': 'ticket_date_start',
					'end_field': 'ticket_date_end'
				},
				'radio': {
					'ticket_status': 'main/status'
				},
				'select': {
					'has_mark': 'ticketmessage/mark'
				},
				'ticketLabel': {},
				'myTickets': {},
				'bool': {
					'title_false': 'ticket/show_closed',
					'title_true': 'ticket/hide_closed',
					'field': 'show_closed'
				}
			},
			'columns': {
				'ticket_label': {
					'style-col': 'width: 30px',
					'component-row': 'ticket_label',
					'function-cell-class': function functionCellClass(row) {
						return 'cursor-pointer ticket-label-color-' + String(row['ticket_label']).toLowerCase();
					},
					'function-cell-style': function functionCellStyle(row) {
						return 'background-color: ' + String(row['ticket_label']).toLowerCase();
					}
				},
				'ticket_subject': {
					'sort': true,
					'component-row': 'ticket_subject'
				},
				'ticket_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('ticket_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + String(row['ticket_status_color']).toLowerCase() + ' ticket-status-name-' + String(row['ticket_status']).toLowerCase();
					}
				},
				'ticket_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ticket:log_sub'
				},
				'ticketMerge': {
					'title': 'ticket/merge',
					'action': 'func:ticketMergeFromMenu'
				}
			}
		}
	},

	'logs': {
		'list': {
			'can_select_rows': false,
			'column_id': 'log_id',
			'filters': {
				'period': {
					'begin_field': 'log_date_start',
					'end_field': 'log_date_end'
				},
				'logs': {
					'field': 'log_action'
				}
			},
			'columns': {
				'log_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.log_id ? '/logs/view/' + row.log_id : '';
					}
				},
				'log_date': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'log_action': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': function functionRow(row, listData, ftc) {
						return row && row.log_action_text ? ftc && typeof ftc === 'function' ? ftc(row.log_action_text) : row.log_action_text : '';
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'log_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				},
				'log_sub': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.object_link ? row.object_link.replace('%ID%', row.object_id) : '';
					},
					'component-param-text': function componentParamText(row) {
						return row && row.object_name ? row.object_name : '';
					}
				},
				'user_email': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.user_type && row.user_id ? '/' + row.user_type + '/view/' + row.user_id : '';
					},
					'user-online-status': 'user_online'
				}
			}
		}
	},

	'chart': {
		'list': {
			'can_select_rows': false,
			'fast_search': false,
			'column_id': 'chart_id',
			'columns': {
				'chart_name': {
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.chart_id ? '/chart/view/' + row.chart_id : '';
					}
				}
			}
		}
	},

	'template': {
		'list': {
			'buttons': {
				'create': 'template/create_title',
				'off': '-template_name',
				'on': '-template_name'
			},
			'on-off': 'templates',
			'column_id': 'template_id',
			'filters': {
				'radio': {
					'template_status': 'main/status'
				},
				'select': {
					'server_group_id': 'server/groups',
					'template_group_id': 'templategroup/templategroup'
				}
			},
			'columns': {
				'template_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'template_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.template_id ? '/template/view/' + row.template_id : '';
					}
				},
				'template_group_id': {
					'sort': true,
					'component-row': 'template_groups_view'
				},
				'template_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('template_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['template_status'];
					}
				},
				'template_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/template/update'
				},
				'clone': {
					'action': 'url:/template/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'template_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:template:log_sub'
				}
			}
		}
	},

	'ippool': {
		'model': 'IpPoolSearch',
		'list': {
			'buttons': {
				'create': 'ippool/create_title',
				'ip_off': 'ip_address',
				'ip_on': 'ip_address'
			},
			'on-off': 'ips',
			'column_id': 'ip_id',
			'filters': {
				'radio': {
					'ip_status': 'main/status',
					'ip_type': 'main/type',
					'view_type': 'ippool/view_type',
					'ip_owner': 'rackdevice/owner'
				},
				'select': {
					'view_net': 'ippool/view_net',
					'datacenter_id': 'datacenter/datacenter',
					'ip_server_type': 'server/type',
					'ip_bridge': 'Bridge'
				}
			},
			'columns': {
				'ip_address': {
					'sort': true,
					'style-col': 'width: 140px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.ip_id ? '/ippool/view/' + row.ip_id : '';
					}
				},
				'ip_host': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.ip_id ? '/ipptrpool/list?id=' + row.ip_id : '';
					}
				},
				'ip_server_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('ip_server_type', row, raw, ['ftc']);
					}
				},
				'datacenter_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					},
					'component-param-flagicon': function componentParamFlagicon(row) {
						return 'flag-icon-' + String(row['datacenter_country']);
					}
				},
				'ip_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('ip_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['ip_status'];
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/ippool/update'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'url:/ipptrpool/list'
				},
				'ipHistory': {
					'title': 'service/history IP',
					'action': 'url:/iphistory/list'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ippool:log_sub'
				}
			}
		}
	},

	'ipptrpool': {
		'model': 'IpPtrPoolSearch',
		'list': {
			'buttons': {
				'create': 'ipptrpool/create_title'
			},
			'column_id': 'ptr_id',
			'columns': {
				'ptr_address': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.ptr_id ? '/ipptrpool/view/' + row.ptr_id : '';
					}
				},
				'ptr_host': {
					'sort': true
				},
				'ptr_timestamp': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'oneOper': {
				'columnWidth': '60px',
				'update': {
					'action': 'url:/ipptrpool/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'ptr_address'
					}
				}
			}
		}
	},

	'iphistory': {
		'model': 'IpHistorySearch',
		'list': {
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'period': {
					'begin_field': 'history_date_start',
					'end_field': 'history_date_end'
				}
			},
			'columns': {
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/service/view/' + row.service_id : '';
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('service_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['service_status'];
					}
				},
				'history_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'history_deleted': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			}
		}
	},

	'text': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'text/create_title'
			},
			'column_id': 'id',
			'filters': {
				'select': {
					'fast_filter': 'text/fast_filter'
				}
			},
			'columns': {
				'category': {
					'sort': true
				},
				'message': {
					'sort': true
				},
				'translation': {
					'sort': true
				}
			},
			'opers': {
				'update': {
					'action': 'url:/text/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'message'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:text:log_sub'
				}
			}
		}
	},

	'admin': {
		'list': {
			'buttons': {
				'create': 'admin/create_title',
				'off': 'user_email',
				'on': 'user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.user_id ? '/admin/view/' + row.user_id : '';
					},
					'user-online-status': 'user_online'
				},
				'user_name': {
					'sort': true
				},
				'user_role': {
					'sort': true,
					'component-row': 'admin_roles'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('user_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['user_status'];
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/admin/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:admin:log_sub'
				},
				'logOver': {
					'title': 'admin/actions',
					'action': 'func:GoTo:logs::user_id'
				},
				'note': {
					'title': 'admin/notes',
					'action': 'func:GoTo:notes:admin:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				}
			}
		}
	},

	'role': {
		'list': {
			'fast_search': false,
			'can_select_rows': false,
			'buttons': {
				'create': 'role/create_title'
			},
			'column_id': 'role_name',
			'columns': {
				'role_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.role_name ? '/role/view/' + row.role_name : '';
					}
				},
				'role_type': {
					'sort': true,
					'function-cell-class': function functionCellClass(row) {
						return 'role_actions' in row && row['role_actions'] === false ? 'color-light-gray' : false;
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/role/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'role_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:role:log_sub'
				}
			}
		}
	},

	'payment': {
		'list': {
			'buttons': {
				'create': 'payment/create_title',
				'off': '-payment_name',
				'on': '-payment_name'
			},
			'on-off': 'payments',
			'column_id': 'payment_id',
			'columns': {
				'payment_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.payment_id ? '/payment/view/' + row.payment_id : '';
					}
				},
				'payment_type': {
					'sort': true,
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('payment_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'payment_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('payment_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['payment_status'];
					}
				},
				'payment_comission': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'function-row': function functionRow(row) {
						return row['payment_comission'] + '%';
					}
				},
				'payment_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payment/update'
				},
				'clone': {
					'action': 'url:/payment/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payment_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payment:log_sub'
				}
			}
		}
	},

	'datacenter': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'datacenter/create_title'
			},
			'column_id': 'datacenter_id',
			'columns': {
				'datacenter_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					}
				},
				'datacenter_country': {
					'sort': true,
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('datacenter_country', row, raw, ['ftc']);
					},
					'function-flagicon': function functionFlagicon(row) {
						return 'flag-icon-' + row['datacenter_country'];
					}
				},
				'datacenter_racks': {
					'sort': true,
					'style-col': 'width: 75px',
					'function-row': function functionRow(row, raw) {
						return row['datacenter_racks'] || '-';
					},
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'datacenter_racks',
					'component-param-crud': 'rack',
					'component-param-filter-field': 'datacenter_id'
				},
				'datacenter_servers': {
					'sort': true,
					'style-col': 'width: 75px',
					'function-row': function functionRow(row, raw) {
						return row['datacenter_servers'] || '-';
					},
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'datacenter_servers',
					'component-param-crud': 'server',
					'component-param-filter-field': 'datacenter_id'
				},
				'datacenter_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/datacenter/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'datacenter_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:datacenter:log_sub'
				},
				'server': {
					'title': 'server/title',
					'action': 'filter:server::datacenter_id'
				}
			}
		}
	},

	'servergroup': {
		'model': 'ServerGroupSearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'servergroup/create_title'
			},
			'column_id': 'group_id',
			'filters': {
				'radio': {
					'group_type': 'main/type'
				}
			},
			'columns': {
				'group_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.group_id ? '/servergroup/view/' + row.group_id : '';
					}
				},
				'group_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('group_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'group_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/servergroup/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'group_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:servergroup:log_sub'
				},
				'server': {
					'title': 'server/title',
					'action': 'filter:server::server_group_id'
				}
			}
		}
	},

	'plangroup': {
		'model': 'PlanGroupSearch',
		'list': {
			'buttons': {
				'create': 'plangroup/create_title',
				'off': '-group_name',
				'on': '-group_name'
			},
			'on-off': 'plangroups',
			'column_id': 'group_id',
			'filters': {
				'radio': {
					'group_type': 'main/type'
				}
			},
			'columns': {
				'group_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.group_id ? '/plangroup/view/' + row.group_id : '';
					}
				},
				'group_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('group_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'group_status': {
					'sort': true,
					'style-col': 'width: 110px',
					'class-col': 'aw5-vds-column-status',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('group_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['group_status'];
					}
				},
				'group_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/plangroup/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'group_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plangroup:log_sub'
				},
				'plan': {
					'title': 'plan/title',
					'action': 'filter:plan::plan_group_id'
				}
			}
		}
	},

	'templategroup': {
		'model': 'TemplateGroupSearch',
		'list': {
			'buttons': {
				'create': 'templategroup/create_title',
				'off': '-group_name',
				'on': '-group_name'
			},
			'on-off': 'templategroups',
			'column_id': 'group_id',
			'filters': {
				'radio': {
					'group_status': 'main/status'
				}
			},
			'columns': {
				'group_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.group_id ? '/templategroup/view/' + row.group_id : '';
					}
				},
				'group_status': {
					'sort': true,
					'style-col': 'width: 110px',
					'class-col': 'aw5-vds-column-status',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('group_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['group_status'];
					}
				},
				'group_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/templategroup/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'group_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:templategroup:log_sub'
				},
				'template': {
					'title': 'template/title',
					'action': 'filter:template::template_group_id'
				}
			}
		}
	},

	'server': {
		'list': {
			'buttons': {
				'create': 'server/create_title',
				'r_off': 'server_name',
				'r_on': 'server_name'
			},
			'on-off': 'servers',
			'column_id': 'server_id',
			'filters': {
				'radio': {
					'server_type': 'server/type',
					'server_status': 'main/status',
					'server_register': 'server/register'
				},
				'select': {
					'server_group_id': 'server/groups',
					'datacenter_id': 'datacenter/datacenter',
					'server_view_type': 'main/type'
				}
			},
			'columns': {
				'server_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.server_id ? '/server/view/' + row.server_id : '';
					}
				},
				'server_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('server_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					},
					'component-param-flagicon': function componentParamFlagicon(row) {
						return 'flag-icon-' + String(row['datacenter_country']);
					}
				},
				'server_view_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('server_view_type', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text color-type-' + row['server_view_type'];
					}
				},
				'server_register': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('server_register', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['server_register'];
					}
				},
				'server_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('server_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['server_status'];
					}
				},
				'server_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/server/update'
				},
				'clone': {
					'action': 'url:/server/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'server_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:server:log_sub'
				}
			}
		}
	},

	'servicetype': {
		'model': 'ServiceTypeSearch',
		'list': {
			'buttons': {
				'off': '-service_type_name',
				'on': '-service_type_name'
			},
			'on-off': 'servicetypes',
			'column_id': 'service_type_id',
			'filters': {
				'radio': {
					'service_type_status': 'main/status',
					'parent_type_id': 'servicetype/parent'
				}
			},
			'columns': {
				'service_type_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_type_id ? '/servicetype/view/' + row.service_type_id : '';
					}
				},
				'parent_type_name': {
					'title': 'servicetype/parent',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.parent_type_id ? '/servicetype/view/' + row.parent_type_id : '';
					}
				},
				'service_type_cost': {
					'sort': true,
					'component-row': 'service_type_cost',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueServiceTypeCost(row, raw);
					}
				},
				'service_type_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('service_type_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['service_type_status'];
					}
				},
				'service_type_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'create': {
					'title': 'servicetype/create_plan',
					'action': 'url:/plan/create'
				},
				'update': {
					'action': 'url:/servicetype/update'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:servicetype:log_sub'
				}
			}
		}
	},

	'plan': {
		'list': {
			'buttons': {
				'off': '-plan_name',
				'on': '-plan_name'
			},
			'on-off': 'plans',
			'column_id': 'plan_id',
			'filters': {
				'period': {
					'begin_field': 'plan_date_start',
					'end_field': 'plan_date_end'
				},
				'radio': {
					'plan_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype',
					'server_group_id': 'servergroup/servergroup',
					'plan_group_id': 'plangroup/plangroup'
				}
			},
			'columns': {
				'plan_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.plan_id ? '/plan/view/' + row.plan_id : '';
					}
				},
				'server_group_id': {
					'sort': true,
					'component-row': 'server_groups_view'
				},
				'plan_group_id': {
					'sort': true,
					'component-row': 'plan_groups_view'
				},
				'plan_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('plan_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['plan_status'];
					}
				},
				'plan_cost': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'plan_cost',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValuePlanCost(row, raw);
					}
				},
				'plan_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/plan/update'
				},
				'clone': {
					'action': 'url:/plan/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'plan_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plan:log_sub'
				}
			}
		}
	},

	'planarchive': {
		'model': 'PlanSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'plan_id',
			'filters': {
				'period': {
					'begin_field': 'plan_date_start',
					'end_field': 'plan_date_end'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype',
					'server_group_id': 'servergroup/servergroup'
				}
			},
			'columns': {
				'plan_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.plan_id ? '/planarchive/view/' + row.plan_id : '';
					}
				},
				'server_group_id': {
					'sort': true,
					'component-row': 'server_groups_view'
				},
				'plan_cost': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'plan_cost',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValuePlanCost(row, raw);
					}
				},
				'plan_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plan:log_sub'
				}
			}
		}
	},

	'department': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'department/create_title'
			},
			'column_id': 'department_id',
			'filters': {
				'select': {
					'department_type': 'department/type'
				}
			},
			'columns': {
				'department_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'department_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.department_id ? '/department/view/' + row.department_id : '';
					}
				},
				'department_type': {
					'sort': true,
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('department_type', row, raw, ['ftc']);
					}
				},
				'department_manager_name': {
					'sort': true,
					'title': 'department/manager',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.department_manager ? '/admin/view/' + row.department_manager : '';
					}
				},
				'department_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/department/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'department_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:department:log_sub'
				}
			}
		}
	},

	'ticketrule': {
		'model': 'TicketRuleSearch',
		'list': {
			'buttons': {
				'create': 'ticketrule/create_title',
				'off': '-rule_name',
				'on': '-rule_name'
			},
			'on-off': 'rules',
			'column_id': 'rule_id',
			'filters': {
				'radio': {
					'rule_status': 'main/status',
					'rule_action': 'ticketrule/action'
				}
			},
			'columns': {
				'rule_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'rule_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.rule_id ? '/ticketrule/view/' + row.rule_id : '';
					}
				},
				'rule_action': {
					'sort': true,
					'style-col': 'width: 220px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('rule_action', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'department_name': {
					'sort': true,
					'style-col': 'width: 220px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.department_id ? '/department/view/' + row.department_id : '';
					}
				},
				'rule_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('rule_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['rule_status'];
					}
				},
				'rule_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/ticketrule/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'rule_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ticketrule:log_sub'
				}
			}
		}
	},

	'zone': {
		'model': 'ZoneSearch',
		'list': {
			'column_id': 'zone_name',
			'columns': {
				'zone_name': {
					'sort': true
				}
			},
			'opers': {
				'update': {
					'action': 'url:/zone/update'
				}
			}
		}
	},

	'person': {
		'model': 'PersonSearch',
		'list': {
			'buttons': {
				'create': 'person/create_title'
			},
			'column_id': 'person_id',
			'filters': {
				'select': {
					'person_type': 'main/type'
				},
				'period': {
					'begin_field': 'person_date_start',
					'end_field': 'person_date_end'
				}
			},
			'columns': {
				'person_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'person_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.person_id ? '/person/update/' + row.person_id : '';
					}
				},
				'person_type': {
					'sort': true,
					'style-col': 'width: 205px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('person_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'person_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'person_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:person:log_sub'
				}
			}
		}
	},

	'domains': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/register_domain',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				},
				'period': {
					'begin_field': 'service_date_start',
					'end_field': 'service_date_end'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/domains/update/' + row.service_id : '';
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': function functionCellClass(row) {
						return 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase();
					}
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.account_id ? '/account/view/' + row.account_id : '';
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'domainReboot': {
					'title': 'service/reboot',
					'action': 'func:RebootDomain'
				}
			}
		}
	},

	'rack': {
		'model': 'RackSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'rack_id',
			'filters': {
				'radio': {
					'rack_type': 'main/type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'rack_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.rack_id ? '/rack/view/' + row.rack_id : '';
					}
				},
				'rack_type': {
					'sort': true,
					'style-col': 'width: 60px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('rack_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					},
					'component-param-flagicon': function componentParamFlagicon(row) {
						return 'flag-icon-' + String(row['datacenter_country']);
					}
				},
				'rack_units': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'rack_units',
					'component-param-crud': 'rackdevice',
					'component-param-filter-field': 'rack_id'
				},
				'rack_power': {
					'sort': true,
					'style-col': 'width: 80px'
				},
				'rack_price': {
					'sort': true,
					'style-col': 'width: 80px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rack/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'rack_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rack:log_sub'
				},
				'createDevice': {
					'title': 'rackdevice/create_title',
					'action': 'func:redirectUrl:/rackdevice/create:rack_id'
				},
				'rackGraphic': {
					'title': 'rack/rack',
					'action': 'func:showRackGraphic::rack_id'
				}
			}
		}
	},

	'rackdevice': {
		'model': 'RackDeviceSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'device_id',
			'filters': {
				'radio': {
					'device_type': 'main/type',
					'device_owner': 'rackdevice/owner',
					'device_server_type': 'rackdevice/server_type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'device_unit': {
					'sort': true,
					'style-col': 'width: 25px'
				},
				'device_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.device_id ? '/rackdevice/view/' + row.device_id : '';
					}
				},
				'device_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('device_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'rack_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.rack_id ? '/rack/view/' + row.rack_id : '';
					}
				},
				'device_server_type': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('device_server_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'device_owner': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('device_owner', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'device_ports': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.device_id ? '/rackdevice/links/' + row.device_id : '';
					},
					'online-status-before': 'device_ports_active'
				},
				'server_name': {
					'sort': true,
					'style-col': 'width: 140px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.server_id ? '/server/view/' + row.server_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackdevice/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'device_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackdevice:log_sub'
				},
				'deviceLinks': {
					'title': 'rackdevice/links_title',
					'action': 'func:redirectUrl:/rackdevice/links:device_id'
				},
				'clone': {
					'action': 'url:/rackdevice/clone'
				}
			}
		}
	},

	'rackspare': {
		'model': 'RackSpareSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'spare_id',
			'filters': {
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'spare_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.spare_id ? '/rackspare/view/' + row.spare_id : '';
					}
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					},
					'component-param-flagicon': function componentParamFlagicon(row) {
						return 'flag-icon-' + String(row['datacenter_country']);
					}
				},
				'spare_count': {
					'sort': true,
					'style-col': 'width: 90px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackspare/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'spare_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackspare:log_sub'
				}
			}
		}
	},

	'rackservice': {
		'model': 'RackServiceSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_type': 'main/type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/rackservice/view/' + row.service_id : '';
					}
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '';
					},
					'component-param-flagicon': function componentParamFlagicon(row) {
						return 'flag-icon-' + String(row['datacenter_country']);
					}
				},
				'service_type': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('service_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'service_price': {
					'sort': true,
					'style-col': 'width: 80px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackservice/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackservice:log_sub'
				}
			}
		}
	},

	'pageSizes': [10, 20, 50, 100, 500, 1000]

};

/* harmony default export */ __webpack_exports__["a"] = (adminData);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'menu/vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},

	domains: {
		title: 'menu/domains_and_dns',
		link: '/domains/list',
		tabs: {
			'domains': 'main/domains',
			'dns': 'menu/dns',
			'person': 'menu/persons'
		}
	},
	account: {
		title: 'menu/clients',
		link: '/account/list',
		tabs: {
			'account': 'account/title',
			'user': 'user/title',
			'notes': 'notes/title'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentsaved': 'paymentsaved/title',
			'paymentauto': 'paymentauto/title',
			'document': 'document/title',
			'payer': 'payer/title'
		}
	},
	request: {
		title: 'request/title',
		link: '/request/list',
		tabs: {
			'request': 'request/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partnerprogram': 'partnerprogram/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/list',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'ticket/tickets',
		link: '/ticket/list',
		tabs: {
			'ticket': 'main/list_all'
		}
	},
	logs: {
		title: 'logs/title',
		link: '/logs/list',
		tabs: {
			'logs': 'logs/title'
		}
	},
	chart: {
		title: 'menu/charts',
		link: '/chart/list',
		tabs: {
			'chart': 'chart/title'
		}
	},
	template: {
		title: 'menu/settings',
		link: '/template/list',
		tabs: {
			'template': 'template/title',
			'server': 'server/title',
			'ippool': 'ippool/title',
			'text': 'text/title',
			'admin': 'admin/title',
			'role': 'role/title',
			'payment': 'payment/title',
			'servergroup': 'servergroup/title',
			'plangroup': 'plangroup/title',
			'templategroup': 'templategroup/title',
			'servicetype': 'servicetype/title',
			'plan': 'plan/title',
			'planarchive': 'plan/archive_title',
			'department': 'department/title',
			'ticketrule': 'ticketrule/title',
			'zone': 'zone/title'
		}
	},
	datacenter: {
		title: 'menu/equipment',
		link: '/datacenter/list',
		tabs: {
			'datacenter': 'datacenter/title',
			'rack': 'rack/title',
			'rackdevice': 'rackdevice/title',
			'rackspare': 'rackspare/title',
			'rackservice': 'rackservice/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'menu/vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	dns: {
		title: 'menu/dns',
		link: '/dns/list',
		tabs: {
			'dns': 'menu/dns'
		}
	},
	account: {
		title: 'menu/clients',
		link: '/account/list',
		tabs: {
			'account': 'account/title',
			'user': 'user/title',
			'notes': 'notes/title'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentsaved': 'paymentsaved/title'
		}
	},
	request: {
		title: 'request/title',
		link: '/request/list',
		tabs: {
			'request': 'request/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partnerprogram': 'partnerprogram/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/list',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'ticket/tickets',
		link: '/ticket/list',
		tabs: {
			'ticket': 'main/list_all'
		}
	},
	logs: {
		title: 'logs/title',
		link: '/logs/list',
		tabs: {
			'logs': 'logs/title'
		}
	},
	chart: {
		title: 'menu/charts',
		link: '/chart/list',
		tabs: {
			'chart': 'chart/title'
		}
	},
	template: {
		title: 'menu/settings',
		link: '/template/list',
		tabs: {
			'template': 'template/title',
			'server': 'server/title',
			'ippool': 'ippool/title',
			'text': 'text/title',
			'admin': 'admin/title',
			'role': 'role/title',
			'payment': 'payment/title',
			'servergroup': 'servergroup/title',
			'plangroup': 'plangroup/title',
			'templategroup': 'templategroup/title',
			'servicetype': 'servicetype/title',
			'plan': 'plan/title',
			'planarchive': 'plan/archive_title',
			'department': 'department/title',
			'ticketrule': 'ticketrule/title',
			'zone': 'zone/title'
		}
	},
	datacenter: {
		title: 'menu/equipment',
		link: '/datacenter/list',
		tabs: {
			'datacenter': 'datacenter/title',
			'rack': 'rack/title',
			'rackdevice': 'rackdevice/title',
			'rackspare': 'rackspare/title',
			'rackservice': 'rackservice/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'menu/vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	dns: {
		title: 'menu/dns',
		link: '/dns/list',
		tabs: {
			'dns': 'menu/dns'
		}
	},
	account: {
		title: 'menu/clients',
		link: '/account/list',
		tabs: {
			'account': 'account/title',
			'user': 'user/title',
			'notes': 'notes/title'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentsaved': 'paymentsaved/title',
			'paymentauto': 'paymentauto/title',
			'document': 'document/title',
			'payer': 'payer/title'
		}
	},
	request: {
		title: 'request/title',
		link: '/request/list',
		tabs: {
			'request': 'request/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partnerprogram': 'partnerprogram/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/list',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'ticket/tickets',
		link: '/ticket/list',
		tabs: {
			'ticket': 'main/list_all'
		}
	},
	logs: {
		title: 'logs/title',
		link: '/logs/list',
		tabs: {
			'logs': 'logs/title'
		}
	},
	chart: {
		title: 'menu/charts',
		link: '/chart/list',
		tabs: {
			'chart': 'chart/title'
		}
	},
	template: {
		title: 'menu/settings',
		link: '/template/list',
		tabs: {
			'template': 'template/title',
			'server': 'server/title',
			'ippool': 'ippool/title',
			'text': 'text/title',
			'admin': 'admin/title',
			'role': 'role/title',
			'payment': 'payment/title',
			'servergroup': 'servergroup/title',
			'plangroup': 'plangroup/title',
			'templategroup': 'templategroup/title',
			'servicetype': 'servicetype/title',
			'plan': 'plan/title',
			'planarchive': 'plan/archive_title',
			'department': 'department/title',
			'ticketrule': 'ticketrule/title',
			'zone': 'zone/title'
		}
	},
	datacenter: {
		title: 'menu/equipment',
		link: '/datacenter/list',
		tabs: {
			'datacenter': 'datacenter/title',
			'rack': 'rack/title',
			'rackdevice': 'rackdevice/title',
			'rackspare': 'rackspare/title',
			'rackservice': 'rackservice/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client_left_menu_vdsina__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client_left_menu_vdsina_com__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client_left_menu_macloud__ = __webpack_require__(327);






var leftMenu = function leftMenu() {
	if (Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).APP_NAME === 'macloud') return __WEBPACK_IMPORTED_MODULE_3__client_left_menu_macloud__["a" /* default */];
	if (Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).APP_NAME === 'vdsina.com') return __WEBPACK_IMPORTED_MODULE_2__client_left_menu_vdsina_com__["a" /* default */];
	return __WEBPACK_IMPORTED_MODULE_1__client_left_menu_vdsina__["a" /* default */];
};

var clientData = {
	leftMenu: leftMenu(),

	'vds': {
		'model': 'ServiceSearch',

		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/create_vds'
			},

			'column_id': 'service_id',

			'filters': {
				'radio': {
					'plan_group_id': 'plangroup/plangroup'
				},

				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},

			'columns': {
				'group': {
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'title': 'main/type',
					'component-row': 'imageGroupVds',
					'component-param-title': function componentParamTitle(row, data) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].vdsGroupImageTitle(row, data);
					},
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].vdsGroupImage(row);
					}
				},
				'os': {
					'title': 'template/os',
					'style-col': 'width: 50px',
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('template:image', row);
					}
				},
				'vds': {
					'title': 'service/service',
					'component-row': 'vds_info',
					'component-param-data': function componentParamData(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('plan:data', row);
					},
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/vds/view/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name'];
					}
				},
				'ip': {
					'title': 'ippool/ippool',
					'style-col': 'width: 150px',
					'function-row': function functionRow(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('ip:ip', row);
					},
					'function-cell-class': function functionCellClass(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('ip:ip:active', row) ? '' : 'text-strike';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center vds-date',
					'formater-row': 'formater_StrDateOnly'
				}
			},

			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'vdsReboot': {
					'title': 'service/reboot',
					'action': 'func:GoToVds:reboot'
				},
				'vdsPlan': {
					'title': 'service/plan_change',
					'action': 'func:GoToVds:plan'
				},
				'vdsReinstall': {
					'title': 'service/reinstall',
					'action': 'func:GoToVds:reinstall'
				},
				'vdsChangePassword': {
					'title': 'service/password_change',
					'action': 'func:GoToVds:password'
				},
				'vdsClone': {
					'title': 'main/clone',
					'action': 'func:vdsClone' },
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'create': [{
				position: 'before-button',
				title: 'field/hint_ssh_key_before',
				link: "https://vdsina.ru/qa" + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu',
				afterText: 'field/hint_ssh_key_after',
				showIfField: 'sshkey_id'
			}, {
				position: 'before-button',
				title: 'field/hint_backup_auto',
				link: "https://vdsina.ru/qa" + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
				showIfField: 'backup_auto'
			}]
		}
	},

	'disks': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/extdisk_create'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'diskType': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name': {
					'title': 'service/extdisk',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/disks/' + (row['service_status'] === 'active' ? 'update' : 'view') + '/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name_full'];
					}
				},
				'attached': {
					'title': 'service/extdisk_attached',
					'component-row': 'outer_disk_info'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/disks/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'connectOuterDisk': {
					'title': 'main/attach main/disk',
					'action': 'func:connectOuterDisk'
				},
				'ejectOuterDisk': {
					'title': 'main/detach main/disk',
					'action': 'func:ejectOuterDisk'
				},
				'cloneOuterDisk': {
					'title': 'main/clone',
					'action': 'func:cloneOuterDisk'
				},
				'backupOuterDisk': {
					'title': 'service/backup_create',
					'action': 'func:backupOuterDisk'
				},
				'restoreBackupOuterDisk': {
					'title': 'service/backup_restore',
					'action': 'func:restoreBackupOuterDisk'
				},
				'scheduleOuterDisk': {
					'title': 'schedule/create_title',
					'action': 'func:scheduleOuterDisk'
				},
				'scheduleOuterDiskUpdate': {
					'title': 'schedule/update_title',
					'action': 'func:scheduleOuterDisk'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'create': [{
				position: 'before-button',
				title: 'field/hint_backup_auto',
				link: "https://vdsina.ru/qa" + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
				showIfField: 'backup_auto'
			}]
		}
	},

	'backups': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/backup_create'
			},
			'column_id': 'service_id',
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'backup_name': {
					'title': 'service/backup',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': function componentParamFlag(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:country', row);
					},
					'component-param-flag-name': function componentParamFlagName(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromServiceData('datacenter:name', row);
					},
					'component-param-url': function componentParamUrl(row) {
						return '/backups/view/' + row['service_id'];
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'component-param-text': function componentParamText(row) {
						return row['service_name_full'];
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'restoreBackup': {
					'title': 'main/restore',
					'action': 'func:restoreBackup'
				},
				'createFromBackup': {
					'title': 'main/create server/server',
					'action': 'func:createFromBackup'
				},
				'createFromBackupOuterDisk': {
					'title': 'service/extdisk_create',
					'action': 'func:createFromBackupOuterDisk'
				},
				'renameBackup': {
					'title': 'service/rename_action',
					'action': 'func:renameBackup'
				},
				'copyToDc': {
					'title': 'main/copy',
					'action': 'func:copyToDc'
				},
				'downloadBackup': {
					'title': 'backup/download_title',
					'action': 'func:downloadBackup'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	'sshkey': {
		'model': 'SshKeySearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'sshkey/create_title'
			},
			'column_id': 'key_id',
			'columns': {
				'key_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.key_id ? '/sshkey/view/' + row.key_id : '';
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/sshkey/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'key_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:sshkey:log_sub'
				}
			}
		},
		'hint-link': {
			'list': {
				position: 'bottom',
				title: 'field/hint_ssh_key_before_client',
				link: "https://vdsina.ru/qa" + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu'
			}
		}
	},

	'iso': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/iso_create'
			},
			'column_id': 'service_id',
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/iso_name',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/iso/view/' + row.service_id : '';
					}
				},
				'attached': {
					'title': 'service/iso_inserting_data',
					'component-row': 'iso_info'
				},
				'size': {
					'style-col': 'width: 80px',
					'title': 'service/iso_size',
					'function-row': function functionRow(row, raw) {
						if (row && row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['filesize']) return row['service_data']['iso']['filesize'];else return 'main/unknown';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'connectISOOper': {
					'title': 'service/iso_insert',
					'action': 'func:connectISOOper'
				},
				'ejectISOOper': {
					'title': 'service/iso_eject',
					'action': 'func:ejectISOOper'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	'additional-services': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name'
			},
			'column_id': 'service_id',
			'filters': {
				'select': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/additional-services/view/' + row.service_id : '';
					}
				},
				'parent_name': {
					'title': 'service/parent',
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.parent_id ? '/service/view/' + row.parent_id : '';
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	'request': {
		'list': {
			'can_select_rows': false,
			'fast_search': false,
			'column_id': 'request_id',
			'filters': {
				'period': {
					'begin_field': 'request_date_start',
					'end_field': 'request_date_end'
				},

				'radio': {
					'request_type': 'main/type',
					'request_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype'
				}
			},
			'columns': {
				'request_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/service/view/' + row.service_id : '';
					}
				},
				'request_type_text': {
					'style-col': 'width: 110px',
					'title': 'main/type',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValue('request_type_text', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						var _status = row['request_type'];
						var _tmp = String(row['request_type_text']).split('/').pop();
						return 'w5-breaked-text w5-status-color-' + (_tmp !== null && _tmp !== undefined && _tmp !== '' ? _tmp : _status);
					}
				},
				'request_status': {
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('request_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['request_status'];
					}
				}
			}
		}
	},

	'certificate': {
		'model': 'ServiceSearch',
		'list': {
			'column_id': 'service_id',
			'buttons': {
				'bulkDel': 'service_name' },
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/cert_crt',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/certificate/view/' + row.service_id : '';
					}
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	'dns': {
		'model': 'ServiceSearch',
		'list': {
			'column_id': 'service_id',
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'dns/create_domain'
			},
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'sort': true,
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/dns/view/' + row.service_id : '';
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					},
					'domain-online-status': function domainOnlineStatus(row) {
						return row && row['service_data'] && row['service_data']['real'] === true;
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('service_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['service_status'];
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/dns/view'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'list': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: "https://vdsina.ru/qa" + '/q/kakie-ns-servery-ispolzovat'
			},
			'create': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: "https://vdsina.ru/qa" + '/q/kakie-ns-servery-ispolzovat'
			}
		}
	},

	'operation': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'balance': 'operation/replenishment',
				'calculator': 'service/calculator',
				'exportCsv': 'main/export CSV'
			},
			'column_id': 'operation_id',
			'filters': {
				'period': {
					'begin_field': 'operation_date_start',
					'end_field': 'operation_date_end'
				},

				'radio': {
					'operation_purse': 'operation/purse',
					'operation_type': 'main/type',
					'operation_status': 'main/status'
				},
				'select': {
					'payment_id': 'payment/payment'
				}
			},
			'columns': {
				'operation_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.operation_id ? '/operation/view/' + row.operation_id : '';
					}
				},
				'operation_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 100px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'operation_summa': {
					'sort': true,
					'style-col': 'width: 90px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell': function componentParamCell(row, digits) {
						if (!row || !('operation_summa' in row) || row['operation_summa'] === null || row['operation_summa'] === undefined) return '';
						if (!row || !('operation_type' in row) || row['operation_type'] === null || row['operation_type'] === undefined) return row['operation_summa'];
						return row['operation_type'] === 1 ? '+' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].FormatMoney2(row['operation_summa'], 2) : '-' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].FormatMoney2(row['operation_summa'], 2);
					}
				},
				'operation_purse': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('operation_purse', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-operation-purse';
					}
				},
				'payment_id': {
					'sort': true,
					'title': 'payment/details',
					'component-row': 'linkComponent',
					'component-param-text': function componentParamText(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellOperationPayment_Text(row, raw);
					},
					'component-param-url': function componentParamUrl(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellOperationPayment_Url(row, raw);
					}
				},
				'operation_status': {
					'sort': true,
					'style-col': 'width: 90px',

					'component-row': 'operation_status',
					'component-param-data': function componentParamData(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('operation_status', row, raw, ['lower', 'ftc']);
					},
					'component-param-cell-class': function componentParamCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['operation_status'];
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'operation_id'
					}
				},
				'paymentLink': {
					'title': 'operation/get_payment_link',
					'action': 'func:showPaymentLink'
				}
			}
		}
	},

	'paymentauto': {
		'model': 'PaymentAutoSearch',
		'list': {
			'buttons': {
				'create': 'paymentauto/create_title',
				'off': '-saved_name',
				'on': '-saved_name'
			},
			'on-off': 'payments',
			'column_id': 'auto_id',
			'filters': {
				'radio': {
					'auto_status': 'main/status'
				}
			},
			'columns': {
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': function componentParamUrl(row) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].makeUrlForApi(row.saved_image);
					}
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.auto_id ? '/paymentauto/update/' + row.auto_id : '';
					}
				},
				'auto_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('auto_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['auto_status'];
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/paymentauto/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentauto:log_sub'
				}
			}
		}
	},

	'document': {
		'model': 'DocumentSearch',
		'list': {
			'buttons': {
				'create': 'document/create_title'
			},
			'column_id': 'document_id',
			'filters': {
				'period': {
					'begin_field': 'doc_date_start',
					'end_field': 'doc_date_end'
				},
				'radio': {
					'document_status': 'main/status',
					'document_type': 'main/type'
				},
				'select': {
					'payer_id': 'payer/payer'
				}
			},
			'columns': {
				'document_name': {
					'sort': true,
					'component-row': 'document_html'
				},
				'document_status': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('document_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['document_status'];
					}
				},
				'document_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'document_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'operLink': {
					'title': 'operation/operation',
					'action': 'func:goOperLink'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:document:log_sub'
				},
				'pdfLink': {
					'title': 'main/download PDF',
					'action': 'func:goPdfLink'
				}
			}
		}
	},

	'payer': {
		'model': 'PayerSearch',
		'list': {
			'buttons': {
				'create': 'payer/create_title'
			},
			'column_id': 'payer_id',
			'filters': {
				'period': {
					'begin_field': 'payer_date_start',
					'end_field': 'payer_date_end'
				},
				'radio': {
					'payer_status': 'main/status'
				}
			},
			'columns': {
				'payer_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'payer_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.payer_id ? '/payer/view/' + row.payer_id : '';
					}
				},
				'payer_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'payer_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellStatus('payer_status', row, raw);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-status-color-' + row['payer_status'];
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payer/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payer_name',
						'timer': 5
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::payer_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payer:log_sub'
				}
			}
		}
	},

	'partner': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'transfer': 'operation/convert'
			},
			'fast_search': false,
			'column_id': 'p2a_id',
			'columns': {
				'program_name': {
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.program_id ? '/partnerprogram/view/' + row.program_id : '';
					}
				},
				'p2a_code': {
					'sort': false,
					'title': 'partner/code',
					'component-row': 'partner_code'
				}
			},
			'opers': {
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions::program_id'
				}
			}
		}
	},

	'partneractions': {
		'model': 'PartnerActionsSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'click_id',
			'filters': {
				'period': {
					'begin_field': 'click_date_start',
					'end_field': 'click_date_end'
				}
			},
			'columns': {
				'created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.program_id ? '/partnerprogram/view/' + row.program_id : '';
					}
				},
				'http_referer': {
					'sort': true
				},
				'ip': {
					'sort': true,
					'style-col': 'width: 120px'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 120px'
				}
			}
		}
	},

	'ticket': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'ticket/create_title'
			},
			'column_id': 'ticket_id',
			'filters': {
				'period': {
					'begin_field': 'ticket_date_start',
					'end_field': 'ticket_date_end'
				} },
			'columns': {
				'ticket_label': {
					'title': 'ticketmessage/read',
					'style-col': 'width: 30px',
					'component-row': 'ticket_read'
				},
				'ticket_subject': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.ticket_id ? '/ticket/view/' + row.ticket_id : '';
					}
				},
				'ticket_status': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('ticket_status', row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['ticket_status'];
					}
				},
				'ticket_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				}
			}
		}
	},

	'logs': {
		'list': {
			'can_select_rows': false,
			'column_id': 'log_id',
			'filters': {
				'period': {
					'begin_field': 'log_date_start',
					'end_field': 'log_date_end'
				},
				'logs': {
					'field': 'log_action'
				}
			},
			'columns': {
				'log_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.log_id ? '/logs/view/' + row.log_id : '';
					}
				},
				'log_date': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'log_action': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': function functionRow(row, listData, ftc) {
						return row && row.log_action_text ? ftc && typeof ftc === 'function' ? ftc(row.log_action_text) : row.log_action_text : '';
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text';
					}
				},
				'log_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				},
				'log_sub': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.object_link ? row.object_link.replace('%ID%', row.object_id) : '';
					},
					'component-param-text': function componentParamText(row) {
						return row && row.object_name ? row.object_name : '';
					}
				},
				'user_email': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.user_type && row.user_id ? '/' + row.user_type + '/view/' + row.user_id : '';
					},
					'user-online-status': 'user_online'
				}
			}
		}
	},

	'user': {
		'list': {
			'fast_search': false,
			'buttons': {
				'create': 'user/create_title',
				'off': '-user_email',
				'on': '-user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.user_id ? '/user/view/' + row.user_id : '';
					},
					'user-online-status': 'user_online'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellUserStatusValue(row, raw, ['lower', 'ftc']);
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-breaked-text w5-status-color-' + row['user_status'];
					}
				},
				'user_full_access': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': function functionRow(row, raw) {
						return row['user_full_access'] === true ? __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].localeFtc('main/yes') : __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].localeFtc('main/no');
					},
					'function-cell-class': function functionCellClass(row) {
						return 'w5-user-accesses';
					}
				},
				'user_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/user/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:user:log_sub'
				},
				'logOver': {
					'title': 'user/actions',
					'action': 'func:GoTo:logs::user_id'
				}
			}
		}
	},

	'person': {
		'model': 'PersonSearch',
		'list': {
			'buttons': {
				'create': 'person/create_title'
			},
			'column_id': 'person_id',
			'columns': {
				'person_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'person_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.person_id ? '/person/update/' + row.person_id : '';
					}
				},
				'person_type': {
					'sort': true,
					'style-col': 'width: 205px',
					'function-row': function functionRow(row, raw) {
						return __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].cellValueFromList('person_type', row, raw, ['ftc']);
					},
					'function-cell-class': function functionCellClass() {
						return 'w5-breaked-text';
					}
				},
				'person_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'person_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:person:log_sub'
				}
			}
		}
	},

	'domains': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/register_domain'
			},
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': function componentParamUrl(row) {
						return row && row.service_id ? '/domains/update/' + row.service_id : '';
					},
					'component-param-statusService': function componentParamStatusService(row) {
						return row['service_status'];
					},
					'component-param-statusServiceText': function componentParamStatusServiceText(row) {
						return row['service_status_text'];
					}
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': function functionCellClass(row) {
						return 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase();
					}
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	'pageSizes': [10, 20, 50, 100]
};

/* harmony default export */ __webpack_exports__["a"] = (clientData);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'service/your_vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},

	domains: {
		title: 'menu/domains_and_dns',
		link: '/domains/list',
		tabs: {
			'domains': 'main/domains',
			'dns': 'menu/dns',
			'person': 'menu/persons'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentauto': 'paymentauto/title',
			'document': 'document/title',
			'payer': 'payer/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/convert',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'menu/support',
		link: '/qa/list',
		tabs: {
			'qa': 'menu/support',
			'ticket': 'ticket/tickets'
		}
	},
	dashboard: {
		title: 'main/my_account',
		link: '/dashboard/info',
		tabs: {
			'dashboard': 'main/my_account_info',
			'options': 'options/edit_title',
			'user': 'user/title',
			'alerts': 'main/email_subs_mini',
			'request': 'request/history',
			'logs': 'logs/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'service/your_vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	dns: {
		title: 'menu/dns',
		link: '/dns/list',
		tabs: {
			'dns': 'menu/dns'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/convert',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'menu/support',
		link: '/qa/list',
		tabs: {
			'qa': 'menu/support',
			'ticket': 'ticket/tickets'
		}
	},
	dashboard: {
		title: 'main/my_account',
		link: '/dashboard/info',
		tabs: {
			'dashboard': 'main/my_account_info',
			'options': 'options/edit_title',
			'user': 'user/title',
			'alerts': 'main/email_subs_mini',
			'request': 'request/history',
			'logs': 'logs/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftMenu = {
	vds: {
		title: 'service/your_vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	dns: {
		title: 'menu/dns',
		link: '/dns/list',
		tabs: {
			'dns': 'menu/dns'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentauto': 'paymentauto/title',
			'document': 'document/title',
			'payer': 'payer/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/convert',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'menu/support',
		link: '/qa/list',
		tabs: {
			'qa': 'menu/support',
			'ticket': 'ticket/tickets'
		}
	},
	dashboard: {
		title: 'main/my_account',
		link: '/dashboard/info',
		tabs: {
			'dashboard': 'main/my_account_info',
			'options': 'options/edit_title',
			'user': 'user/title',
			'alerts': 'main/email_subs_mini',
			'request': 'request/history',
			'logs': 'logs/title'
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (leftMenu);

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_number__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_domain__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_domain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_file__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_directFile__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_directFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_elements_directFile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_elements_planNew__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_elements_planNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_elements_planNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_elements_groupPlan__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_elements_groupPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_elements_groupPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_elements_planssl__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_elements_planssl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_elements_planssl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_planDomain__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_planDomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_elements_planDomain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_template__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_elements_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_tempNew__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_tempNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_elements_tempNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_elements_payment__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_elements_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_elements_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_elements_urlbtn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_elements_urlbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_elements_urlbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_elements_country__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_elements_country___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_elements_country__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_elements_backupList__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_elements_backupList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_elements_backupList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_elements_radio__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_elements_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_elements_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_elements_date__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_elements_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_elements_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_elements_phone__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_elements_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_elements_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_passport__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_passport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_elements_passport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_address__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_elements_address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_elements_savedPayments__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_elements_savedPayments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_elements_savedPayments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_role__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_role___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_elements_role__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_elements_datetime__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_elements_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_elements_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuejs_datepicker__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_inputmask__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_inputmask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_inputmask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_elements_outerdisktype__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_elements_outerdisktype___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_elements_outerdisktype__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_slider_component__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_slider_component_theme_default_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_slider_component_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__bus_js__ = __webpack_require__(4);






































/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'formField',

	props: ['isVisibleRow', 'countVisibleFieldsInRow', 'crud', 'action', 'Field', 'objID', 'clearButton', 'searchButton', 'fontawesomeButton', 'removeRightPadding', 'value', 'needReact', 'listBlockToOut', 'fieldInModal', 'needButtonSubmit', 'bigButton', 'bigButtonTitle', 'bigButtonHandler', 'bigButtonEnabled', 'linkButton', 'linkButtonTitle', 'linkButtonUrl', 'linkButtonVisible', 'linkHint', 'groupField', 'nameField', 'actionField', 'backupField', 'accountField', 'planField', 'planParams', 'templateField', 'formFields', 'progress', 'dc', 'diskTypeValue', 'diskQuantity', 'ipInfo'],

	computed: {
		placeholder: function placeholder() {
			if (this.Field.required === true) return this.Field.title + ' *';else return this.Field.title;
		},
		generateAfterUrl: function generateAfterUrl() {
			if (!this.Field.after_url) return '#';
			if (this.crud === 'options') return this.Field.after_url.replace('%ID%', this.$store.state.user_id);
			if (this.crud === 'user' && this.objID) return this.Field.after_url.replace('%ID%', this.objID);
			return '#';
		},
		fieldError: function fieldError() {
			if (typeof this.Field['_errMsg'] === 'string' && this.Field['_errMsg'].length) return this.Field['_errMsg'];
			return false;
		},
		fieldVisible: function fieldVisible() {
			if (this.crud === 'domains' && this.action === 'create') {
				if (this.Field['_field_name'] === 'plan_group_id') {
					if (this.Field.type === 'list' && this.Field.list && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.Field.list) === 'object' && Array.isArray(this.Field.list) && this.Field.list.length === 1) return false;
				}

				if (this.Field['_field_name'] === 'name') return false;
			}

			if (this.crud === 'vds' && this.action === 'create') {
				if (this.Field['_field_name'] === 'backup_auto') return true;
			}

			if (this.Field.type === 'savedPayments') {
				if (this.crud === 'paymentauto') return true;else return this.Field.list && this.Field.list.length;
			}

			return this.Field['_visible'];
		},
		isFieldGreyed: function isFieldGreyed() {
			if (this.crud === 'vds' && this.action === 'create') {
				if (this.Field._field_name === 'backup_auto' && !this.Field._visible) return true;
			}

			return false;
		},
		fieldLabelStyle: function fieldLabelStyle() {
			if (this.Field['_is_short'] === true) return 'left: 11px';

			var _style = false;
			if (this.Field['readonly'] === true) _style = 'z-index: 1';
			return _style;
		},
		fieldPlaceholderStyle: function fieldPlaceholderStyle() {
			if (this.Field['_is_short'] === true) return 'left: 10px';

			var _style = false;
			if (this.Field['readonly'] === true) _style = 'z-index: 1';
			return _style;
		},
		fieldPlaceholderVisible: function fieldPlaceholderVisible() {
			if (this.isUniqueInVds()) return false;
			if (this.isUniqueInOperation()) return false;
			if (this.isUniqueInCertificate()) return false;
			if (this.isUniqueInDomains()) return false;

			if (this.Field._field_name === 'role_items') return false;
			if (this.Field.type === 'hidden') return false;
			if (this.Field.type === 'file') return false;
			if (this.Field.type === 'image') return false;
			if (this.Field.type === 'simpleButton') return false;
			if (this.Field.type === 'urlButton') return false;
			if (this.Field.type === 'boolean') return false;
			if (this.Field.type === 'radio') return false;
			if (this.Field.type === 'passport') return false;
			if (this.Field.type === 'address') return false;
			if (this.Field.type === 'savedPayments') return false;
			if (this.Field.type === 'header') return false;
			if (this.Field.type === 'clearText') return false;
			if (this.Field.type === 'slider') return false;

			return true;
		},
		listOptions: function listOptions() {
			return this.curList;
		},
		isLatin: function isLatin() {
			if (this.crud === 'certificate' && this.Field['_field_name'] === 'org_address') return true;

			if (this.Field['validator'] === 'low_name_english' || this.Field['validator'] === 'phis_name_english' || this.Field['validator'] === 'phis_name_english_2' || this.Field['validator'] === 'text_english') return true;

			return false;
		},
		isRussia: function isRussia() {
			if (this.Field['validator'] === 'phis_name_russian' || this.Field['validator'] === 'low_name_russian') return true;

			return false;
		},
		isLatinCapitalize: function isLatinCapitalize() {
			if (this.crud === 'certificate' && (this.Field['_field_name'] === 'province' || this.Field['_field_name'] === 'city' || this.Field['_field_name'] === 'owner')) return true;

			if (this.Field['validator'] === 'phis_name_english') return true;

			return false;
		},
		QAURL: function QAURL() {
			return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].QAUrl;
		},
		planSelectedItem: function planSelectedItem() {
			var _this2 = this;

			if (!this.planField || !this.planField.value || !this.planField.list || !this.planField.list.length) return null;

			var _result = null;
			this.planField.list.some(function (item) {
				if (item && String(item.id) === String(_this2.planField.value)) {
					_result = item;
					return true;
				}
			});

			return _result;
		},
		isBackupItemDiscountCost: function isBackupItemDiscountCost() {
			if (this.crud === 'disks' && this.Field && this.Field._field_name === 'backup_auto') {
				if (this.diskQuantity && 'backup' in this.diskQuantity && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.diskQuantity.backup) === 'object' && 'cost' in this.diskQuantity.backup && 'full_cost' in this.diskQuantity.backup && 'for' in this.diskQuantity.backup && 'period' in this.diskQuantity.backup && 'value' in this.diskQuantity) {
					var _cost2 = parseFloat(this.diskQuantity.backup.cost);
					if (isNaN(_cost2)) _cost2 = 0;

					var _fullCost2 = parseFloat(this.diskQuantity.backup.full_cost);
					if (isNaN(_fullCost2)) _fullCost2 = 0;

					return _fullCost2.toFixed(4) !== _cost2.toFixed(4);
				}

				return false;
			}

			if (!this.planSelectedItem || !this.planSelectedItem.backup || !('cost' in this.planSelectedItem.backup) || !('full_cost' in this.planSelectedItem.backup) || !('period_name' in this.planSelectedItem.backup) || !this.planSelectedItem.data || !this.planSelectedItem.data.disk || !('value' in this.planSelectedItem.data.disk)) return false;

			var _cost = parseFloat(this.planSelectedItem.backup.cost);
			if (isNaN(_cost)) _cost = 0;

			var _fullCost = parseFloat(this.planSelectedItem.backup.full_cost);
			if (isNaN(_fullCost)) _fullCost = 0;

			return _fullCost.toFixed(4) !== _cost.toFixed(4);
		},
		BackupItemDiscountCost: function BackupItemDiscountCost() {
			if (this.crud === 'disks' && this.Field && this.Field._field_name === 'backup_auto') {
				if (this.diskQuantity && 'backup' in this.diskQuantity && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.diskQuantity.backup) === 'object' && 'cost' in this.diskQuantity.backup && 'full_cost' in this.diskQuantity.backup && 'for' in this.diskQuantity.backup && 'period' in this.diskQuantity.backup && 'value' in this.diskQuantity) {
					var _cost3 = parseFloat(this.diskQuantity.backup.cost);
					if (isNaN(_cost3)) _cost3 = 0;

					var _fullCost3 = parseFloat(this.diskQuantity.backup.full_cost);
					if (isNaN(_fullCost3)) _fullCost3 = 0;

					var _val2 = this.diskQuantityValue;
					if (isNaN(_val2) || _val2 <= 0) {
						_val2 = parseInt(this.diskQuantity.value, 10);
						if (isNaN(_val2) || _val2 <= 0) return '';
					}

					var period = this.diskQuantity.backup.period;
					var _for = this.diskQuantity.backup.for;

					return this.localeFtc('service/creating_backup_cost <p>{discount}</p> <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>').replace('{cost}', '&nbsp;' + __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_fullCost3 * _val2, 2)) + ' ' + this.localeFtc('main/ruble')).replace('{discount}', __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_cost3 * _val2, 2))).replace('{period}', this.localeFtc(period)).replace('{size}', _val2 + ' ' + this.localeFtc(_for));
				}

				return '';
			}

			if (!this.planSelectedItem || !this.planSelectedItem.backup || !('cost' in this.planSelectedItem.backup) || !('full_cost' in this.planSelectedItem.backup) || !('period_name' in this.planSelectedItem.backup) || !this.planSelectedItem.data || !this.planSelectedItem.data.disk || !('value' in this.planSelectedItem.data.disk)) return '';

			var _cost = parseFloat(this.planSelectedItem.backup.cost);
			if (isNaN(_cost)) _cost = 0;
			var _fullCost = parseFloat(this.planSelectedItem.backup.full_cost);
			if (isNaN(_fullCost)) _fullCost = 0;
			var _val = parseInt(this.planSelectedItem.data.disk.value, 10);
			if (isNaN(_val)) _val = 0;

			if (this.planSelectedItem.has_params === true && this.planParams && 'params[disk]' in this.planParams && !isNaN(this.planParams['params[disk]']) && this.planParams['params[disk]'] > 0) {
				_val = parseInt(this.planParams['params[disk]'], 10);
				if (isNaN(_val)) _val = 0;
			}

			return this.localeFtc('service/creating_backup_cost <p>{discount}</p> <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>').replace('{cost}', '&nbsp;' + __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_fullCost * _val, 2)) + ' ' + this.localeFtc('main/ruble')).replace('{discount}', __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_cost * _val, 2))).replace('{period}', this.localeFtc(this.planSelectedItem.backup.period_name)).replace('{size}', _val + ' ' + this.localeFtc(this.planSelectedItem.data.disk.for));
		},
		BackupItemCost: function BackupItemCost() {
			if (this.crud === 'disks' && this.Field && this.Field._field_name === 'backup_auto') {
				if (this.diskQuantity && 'backup' in this.diskQuantity && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.diskQuantity.backup) === 'object' && 'cost' in this.diskQuantity.backup && 'for' in this.diskQuantity.backup && 'period' in this.diskQuantity.backup && 'value' in this.diskQuantity) {
					var _cost4 = parseFloat(this.diskQuantity.backup.cost);
					if (isNaN(_cost4)) _cost4 = 0;

					var _val3 = this.diskQuantityValue;
					if (isNaN(_val3) || _val3 <= 0) {
						_val3 = parseInt(this.diskQuantity.value, 10);
						if (isNaN(_val3) || _val3 <= 0) return '';
					}

					var period = this.diskQuantity.backup.period;
					var _for = this.diskQuantity.backup.for;

					return this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>').replace('{cost}', __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_cost4 * _val3, 2))).replace('{period}', this.localeFtc(period)).replace('{size}', _val3 + ' ' + this.localeFtc(_for));
				}

				return '';
			}

			if (!this.planSelectedItem || !this.planSelectedItem.backup || !('cost' in this.planSelectedItem.backup) || !('period_name' in this.planSelectedItem.backup) || !this.planSelectedItem.data || !this.planSelectedItem.data.disk || !('value' in this.planSelectedItem.data.disk)) return '';

			var _cost = parseFloat(this.planSelectedItem.backup.cost);
			if (isNaN(_cost)) _cost = 0;
			var _val = parseInt(this.planSelectedItem.data.disk.value, 10);
			if (isNaN(_val)) _val = 0;

			if (this.planSelectedItem.has_params === true && this.planParams && 'params[disk]' in this.planParams && !isNaN(this.planParams['params[disk]']) && this.planParams['params[disk]'] > 0) {
				_val = parseInt(this.planParams['params[disk]'], 10);
				if (isNaN(_val)) _val = 0;
			}

			return this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>').replace('{cost}', __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_cost * _val, 2))).replace('{period}', this.localeFtc(this.planSelectedItem.backup.period_name)).replace('{size}', _val + ' ' + this.localeFtc(this.planSelectedItem.data.disk.for));
		},
		BooleanFieldCost: function BooleanFieldCost() {
			if (!this.Field || !this.Field.period || !('cost' in this.Field)) return null;

			if (this.Field.info) return this.localeFtc('plan/cost <b>{cost} main/ruble</b> / <b>{period}</b> (' + this.Field.info + ')').replace('{cost}', this.Field.cost).replace('{period}', this.localeFtc(this.Field.period)).toLowerCase();else return this.localeFtc('plan/cost <b>{cost} main/ruble</b> / <b>{period}</b>').replace('{cost}', this.Field.cost).replace('{period}', this.localeFtc(this.Field.period)).toLowerCase();
		},
		isUrlWithQuery: function isUrlWithQuery() {
			return this.Field && this.Field.url && this.Field.url.indexOf('q=') > -1;
		},
		isSelectSearchable: function isSelectSearchable() {
			if (this.isUrlWithQuery) return true;

			if (this.curList.length > 15) return true;

			return false;
		},
		sliderMarks: function sliderMarks() {
			var answer = [];

			if (!this.Field || !('max' in this.Field)) return answer;

			answer.push(1);

			var marksCount = 10;
			if (this.$store.state.windowWidth < 1000) marksCount = 8;
			if (this.$store.state.windowWidth < 800) marksCount = 4;
			if (this.$store.state.windowWidth < 600) marksCount = 2;

			if (this.fieldInModal) {
				marksCount = 4;
				if (this.$store.state.windowWidth < 600) marksCount = 2;
			}

			var delta = Math.ceil(this.Field.max / marksCount);
			for (var i = 0; i < 10; i++) {
				var value = i * delta;
				if (value > 1 && value < this.Field.max) {
					answer.push(value);
				}
			}

			answer.push(this.Field.max);

			return answer;
		},
		outerDisksPrice: function outerDisksPrice() {
			if (!this.Field || !('cost' in this.Field)) return 0;

			var _value = parseFloat(this.Field.cost * this.fieldCurValue);
			if (isNaN(_value) || _value < 0) return 0;

			return _value;
		},
		outerDisksPriceDiscount: function outerDisksPriceDiscount() {
			if (!this.Field || !('cost' in this.Field) || !('full_cost' in this.Field)) return 0;

			if (Number(this.Field.full_cost).toFixed(4) === Number(this.Field.cost).toFixed(4)) return 0;

			var _value = parseFloat(this.Field.full_cost * this.fieldCurValue);
			if (isNaN(_value) || _value < 0) return 0;

			return _value;
		},
		minRangeWidthStyle: function minRangeWidthStyle() {
			var min = 0;
			var minRangeValue = 1;
			if ('min' in this.Field) {
				minRangeValue = parseFloat(this.Field.min);
				if (isNaN(minRangeValue)) minRangeValue = 1;
			}

			var max = 1;
			if ('max' in this.Field) {
				max = parseFloat(this.Field.max);
				if (isNaN(max) || max === 0) max = 1;
			}

			var total = max - min;
			if (isNaN(total) || total === 0) total = 1;
			var rangeValue = minRangeValue - min;

			return 'width: ' + rangeValue / total * 100.0 + '%';
		},
		captchaUrl: function captchaUrl() {
			if (!this.Field || this.Field.type !== 'captcha' || !('image' in this.Field) || !this.Field['image']) return '';

			var url = String(this.Field['image']);
			if (url.indexOf('?') > 0) url += '&r=' + this.refreshCaptchaCounter;else url += '?r=' + this.refreshCaptchaCounter;

			return url;
		}
	},
	data: function data() {
		return {
			fieldCurValue: null,

			fieldAnimated: false,

			fieldFocused: false,

			curList: [],

			searchText: '',

			listValue: null,

			$listTag: null,
			statusListRequestResult: '',
			statusListRequestProcess: '',

			$ulBlock: null,

			$errorBlock: null,

			$tooltipBlock: null,

			isDateSelected: false,

			textInputTimer: null,

			serachInputTimer: null,

			topHint: false,

			bottomHint: false,

			rightHint: false,

			insteadFieldHint: false,

			qaResult: false,

			dnsFixedValue: '',

			timerBooleanFieldError: null,

			params: null,

			outerDiskValue: 0,
			outerDiskError: '',

			passwordIsShown: true,

			diskQuantityValue: 0,

			refreshCaptchaCounter: 0
		};
	},
	created: function created() {
		var _this3 = this;

		this.getTopHint();

		if (this.Field.value !== undefined && this.Field.value !== null) {
			this.fieldCurValue = this.Field.value;
		}

		if (this.Field.type === 'text' || this.Field.type === 'integer' || this.Field.type === 'money' || this.Field.type === 'float') {
			if (this.value !== undefined && this.value !== null) this.fieldCurValue = this.value;

			if (this.crud === 'dns-records' && this.Field['_field_name'] === 'host' && !this.Field.readonly) {
				this.Field['_emptyValue'] = '';
				this.Field['_oldValue'] = '';
				this.Field['value'] = '';
				this.fieldCurValue = '';
				this.dnsFixedValue = this.value;
			}
		}

		if (this.Field.type === 'date') {
			if (this.Field.format) this.fieldCurValue = this.formater_FormatedStrDate2Date(this.Field.value, this.Field.format);else this.fieldCurValue = this.formater_StrDate2Date(this.Field.value);
		}

		if (this.Field.type === 'datetime') {
			if (!this.fieldCurValue) this.fieldCurValue = null;
		}

		if (this.Field.type === 'slider') {
			if (!('value' in this.Field)) {
				if ('min' in this.Field) {
					this.Field['_emptyValue'] = this.Field.min;
					this.Field['_oldValue'] = this.Field.min;
					this.Field['value'] = this.Field.min;
					this.fieldCurValue = this.Field.min;
				}
			} else {
				this.Field['_emptyValue'] = this.Field.value;
				this.Field['_oldValue'] = this.Field.value;
				this.fieldCurValue = this.Field.value;
			}

			this.outerDiskValue = this.fieldCurValue;
			this.outerDiskError = '';
		}

		if (this.Field.type === 'boolean') {
			this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].normalizeBooleanValue(this.fieldCurValue);

			if (this.Field._storeValue) {
				if (this.crud === 'disks' && this.Field._storeValue.field === 'options' && 'value' in this.Field._storeValue) {
					this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].normalizeBooleanValue(this.Field._storeValue.value);

					this.$emit('input', this.fieldCurValue);
					return;
				}
			}
		}

		if (this.Field.type === 'list') {
			var _valueDone = false;

			if (this.Field.value !== null && this.Field.value !== undefined) {
				_valueDone = true;

				if (Array.isArray(this.Field.value)) {
					this.listValue = [];
					this.fieldCurValue = [];

					if (this.crud === 'user' && this.Field._field_name === 'role_items' && this.Field.value.length) this.fieldCurValue = this.Field.value;

					if (this.Field.list) {
						this.Field.value.forEach(function (item) {
							for (var k in _this3.Field.list) {
								if (_this3.Field.list[k]['id'] === item) {
									_this3.listValue.push({
										'id': item,
										'name': _this3.localeFtc(_this3.Field.list[k]['name'])
									});
									_this3.fieldCurValue.push(item);
									break;
								}
							}
						});
					} else {
							this.Field.value.forEach(function (item) {
								if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object' && 'id' in item && 'name' in item) {
									_this3.listValue.push({
										'id': String(item['id']),
										'name': _this3.localeFtc(item['name']),
										'archive': item['archive'],
										'status': item['status'],
										'max': item['max'],
										'min': item['min'],
										'type': item['type']
									});
									_this3.fieldCurValue.push(String(item['id']));
								} else {
									_this3.listValue.push(String(item));
									_this3.fieldCurValue.push(String(item));
								}
							});
						}
				} else if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.Field.value) === 'object') {
						_valueDone = true;

						this.listValue = [];
						this.fieldCurValue = [];

						for (var _o in this.Field.value) {
							this.listValue.push({
								'id': String(_o),
								'name': this.localeFtc(this.Field.value[_o])
							});
							this.fieldCurValue.push(String(_o));
						}
					} else {
						if (this.Field.value === '') {
							if (this.crud === 'datacenter') {
								this.listValue = { 'id': 'noValue' };
							} else this.listValue = { 'id': 'emptyValue', 'name': ' ' };
						} else {
							this.listValue = { 'id': String(this.Field.value) };

							if (this.Field['__valueName']) this.listValue = { 'id': String(this.Field.value), 'name': this.localeFtc(this.Field['__valueName']) };

							if (this.Field['text']) this.listValue = { 'id': String(this.Field.value), 'name': this.localeFtc(this.Field['text']) };
						}

						this.fieldCurValue = this.listValue['id'];
					}
			} else {
				if (this.Field.multiselect) this.listValue = [];else this.listValue = {};
			}

			if (this.Field.list) {
				if (Array.isArray(this.Field.list)) {
					this.Field.list.forEach(function (item) {
						if (item) {
							var _access = true;
							if ('access' in item) _access = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].normalizeBooleanValue(item['access']);

							if (_access) {
								_this3.curList.push({
									'id': String(item.id),
									'name': _this3.localeFtc(item.name),
									'archive': item['archive'],
									'status': item['status'],
									'max': item['max'],
									'min': item['min'],
									'type': item['type'],
									'active': _this3.activeItem(item)
								});

								if (_this3.listValue['id'] === String(item.id)) _this3.listValue['name'] = _this3.localeFtc(item.name);

								if (_this3.crud === 'datacenter' && _this3.listValue['id'] === 'noValue' && String(item.id).trim() === '') _this3.listValue['name'] = _this3.localeFtc(item.name);
							}
						}
					});
				} else {
					for (var _id in this.Field.list) {
						if (_id === '') {
							if (this.crud === 'datacenter') {
								this.curList.push({
									'id': 'noValue',
									'name': this.localeFtc(this.Field.list[_id])
								});
							} else {
									this.curList.push({
										'id': 'emptyValue',
										'name': ' '
									});
								}
						} else {
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(this.Field.list[_id])
							});
						}

						if (this.listValue['id'] === String(_id)) this.listValue['name'] = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].localeFtc(this.Field.list[_id]);

						if (this.crud === 'datacenter' && this.listValue['id'] === 'noValue' && _id === '') this.listValue['name'] = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].localeFtc(this.Field.list[_id]);
					}
				}
			}

			if (this.Field._storeValue) {
				if (this.Field._storeValue.field === 'account_id' && this.Field._storeValue.value && this.Field._storeValue.name) {
					var _id2 = String(this.Field._storeValue.value);
					this.listValue = { 'id': _id2, 'name': this.Field._storeValue.name };
					this.fieldCurValue = _id2;
					_valueDone = true;

					this.$emit('input', this.fieldCurValue);
					return;
				}
			}

			if (!_valueDone) {
				if (!this.Field.multiselect && !this.Field.url) {
					if (this.curList.length) {
						this.listValue = this.curList[0];
						this.fieldCurValue = this.listValue['id'];

						if (this.fieldCurValue === 'emptyValue') {
							this.fieldCurValue = '';
							this.listValue = {};
						} else if (this.fieldCurValue === 'noValue') {
							this.fieldCurValue = '';
						} else if (this.crud === 'vds' && this.Field['_field_name'] === 'template_id' && this.action === 'create') {
							this.listValue = null;
							this.fieldCurValue = null;
						}

						this.$emit('input', this.fieldCurValue);
					}
				}
			}

			if (this.crud === 'account' && this.Field._field_name === 'partner_id') {
				if (this.Field.value === undefined || this.Field.value === null || this.Field.value === 0 || String(this.Field.value).trim() === '') {
					this.listValue = { 'id': 'zeroValue', 'name': this.Field.text ? this.localeFtc(this.Field.text) : this.localeFtc('main/nobody') };
					this.fieldCurValue = 0;

					this.$emit('input', this.fieldCurValue);
				} else {
					this.listValue = { 'id': this.Field.value, 'name': this.Field.text ? this.localeFtc(this.Field.text) : this.localeFtc('main/nobody') };
					this.fieldCurValue = this.Field.value;
				}
			}

			if (this.crud === 'department' && this.Field._field_name === 'manager') {
				if (this.fieldCurValue) {
					if (this.Field['text']) this.listValue['name'] = this.localeFtc(this.Field['text']);else this.listValue['name'] = this.fieldCurValue;
				}
			}

			if (this.crud === 'operation' && (this.action === 'select' || this.action === 'create') && this.Field._field_name === 'payer') {
				if (!this.Field.list || !this.Field.list.length) {
					if (this.$store.state.user_type !== 'admin') {
						this.Field.type = 'urlButton';
						this.Field.urlLink = '/payer/create';
						this.Field.urlText = 'payer/create_title';
					}
				}
			}

			if (this.Field._field_name === 'set_label') this.$nextTick(function () {
				_this3.ticketLabelSelected(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this3.$el));
			});
		}
	},
	mounted: function mounted() {
		var _this4 = this;

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-crop-data', this.getCropData);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-text-field-value', this.setTextValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-date-field-value', this.setDateValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-list-field-value', this.setListValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-bool-field-value', this.setBoolValueByEvent);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-init-form-data', this.initOldValue);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-field-data-from-block', this.fromBlock);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-field-emit-blur', this.emitBlurEvent);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-transliterate', this.transliterate);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-get-field-value', this.emitFieldValue);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-clear-list-field', this.clearListField);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-field-error', this.setFieldError);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-recount-field-blocks', this.recountBlocksInModal);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-animate-field', this.animationFieldRequested);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('w5-set-error-message', this.setErrorToField);

		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('diskQuantityValue', this.onDiskQuantityValue);

		document.addEventListener('keydown', this.keyDownHandler);

		if (this.crud === 'ticket' && this.action === 'create' && this.Field._field_name === 'subject' || this.crud === 'qa' && this.action === 'list' && this.Field._field_name === 'qaSearch') __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$on('form-ticket-serach-result', this.qaSearchResult);

		if (this.Field.type === 'list' && this.listBlockToOut) {
			if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove();

			var $component = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
			if (!$component.length) return;

			this.$ulBlock = $component.find('ul:first').parent();
			if (!this.$ulBlock.length) return;

			var _css = {
				'position': 'absolute',
				'display': 'none',
				'width': this.removeRightPadding ? '100%' : 'calc(100% - 10px)',
				'z-index': 99
			};

			var hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight;
			if (!hasEnoughSpace) {
				$component.addClass('multiselect--above');
				_css['margin-bottom'] = '-10px';
			}

			if (this.crud === 'vds') $component.removeClass('multiselect--above');

			this.$ulBlock.css(_css);

			$component.on('mousedown', function (event) {
				if (event.target.nodeName === 'DIV' && event.target.className.indexOf('multiselect__tags__focused') > -1) {
					_this4.$children[0].deactivate();
					return false;
				}
			});

			if (this.listBlockToOut === true) this.$ulBlock.detach().appendTo($component);else this.$ulBlock.detach().appendTo(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('body'));
		}

		if (this.fieldInModal) {
			var _$component = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
			if (_$component.length) {
				if (this.$errorBlock && this.$errorBlock.length) this.$errorBlock.remove();

				this.$errorBlock = _$component.find('div.w5-alert-valid:first');

				if (this.$errorBlock && this.$errorBlock.length) this.$errorBlock.detach().appendTo(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('body'));

				if (this.$tooltipBlock && this.$tooltipBlock.length) this.$tooltipBlock.remove();

				this.$tooltipBlock = _$component.find('div.w5-tooltip-wrapper:first');

				if (this.$tooltipBlock && this.$tooltipBlock.length) this.$tooltipBlock.detach().appendTo(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('body'));
			}

			this.$nextTick(function () {
				return _this4.recountBlocksInModal();
			});
		}

		if (this.crud === 'service' && this.action === 'calc' && this.Field._field_name === 'period') {
			var _$component2 = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
			if (_$component2 && _$component2.length) _$component2.addClass('multiselect--above');
		}

		if (this.Field.type === 'slider') {
			this.setSliderHandlers();
		}

		if (this.Field.type === 'list' && this.Field['_visible'] && !this.Field['readonly']) this.setColorOfItems();

		this.specialForm();
	},
	updated: function updated() {
		if (this.Field.type === 'slider') {
			this.setSliderHandlers();
		}

		if (this.Field.type === 'list' && this.Field['_visible'] && !this.Field['readonly']) this.setColorOfItems();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-crop-data', this.getCropData);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-text-field-value', this.setTextValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-date-field-value', this.setDateValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-list-field-value', this.setListValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-bool-field-value', this.setBoolValueByEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-init-form-data', this.initOldValue);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-field-data-from-block', this.fromBlock);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-field-emit-blur', this.emitBlurEvent);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-transliterate', this.transliterate);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-get-field-value', this.emitFieldValue);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-clear-list-field', this.clearListField);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-field-error', this.setFieldError);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-recount-field-blocks', this.recountBlocksInModal);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-animate-field', this.animationFieldRequested);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('w5-set-error-message', this.setErrorToField);
		__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('diskQuantityValue', this.onDiskQuantityValue);

		document.removeEventListener('keydown', this.keyDownHandler);

		if (this.crud === 'ticket' && this.action === 'create' && this.Field._field_name === 'subject' || this.crud === 'qa' && this.action === 'list' && this.Field._field_name === 'qaSearch') __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$off('form-ticket-serach-result', this.qaSearchResult);

		if (this.textInputTimer) clearTimeout(this.textInputTimer);
		if (this.timerBooleanFieldError) clearTimeout(this.timerBooleanFieldError);

		if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove();
		if (this.$errorBlock && this.$errorBlock.length) this.$errorBlock.remove();
		if (this.$tooltipBlock && this.$tooltipBlock.length) this.$tooltipBlock.remove();
	},

	methods: {
		onCaptchaClick: function onCaptchaClick() {
			this.refreshCaptchaCounter++;
		},
		onDiskQuantityValue: function onDiskQuantityValue(value) {
			this.diskQuantityValue = value;
		},
		linkHintHtml: function linkHintHtml(data) {
			if (!data || !data.link || !data.title) return '';

			var title = this.localeFtc(data.title);
			var begin = title.indexOf('[URL]');
			var end = title.indexOf('[/URL]');
			var answer = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].escapeHtml(title);

			if (begin > -1 && end > -1) {
				answer = answer.replace('[URL]', '<a href="' + data.link + '" target="_blank" style="margin: 0">').replace('[/URL]', '</a>');
			}

			return answer;
		},
		isUniqueInVds: function isUniqueInVds() {
			if (this.crud === 'vds' && (this.Field['_field_name'] === 'plan_group_id' || this.Field['_field_name'] === 'plan_id' || this.Field['_field_name'] === 'template_id' || this.Field['_field_name'] === 'datacenter_id')) {
				return true;
			}

			if (this.crud === 'disks' && (this.Field['_field_name'] === 'datacenter_id' || this.Field['_field_name'] === 'backup_id')) {
				return true;
			}

			return false;
		},
		isUniqueInOperation: function isUniqueInOperation() {
			if (this.crud === 'operation' && this.Field['_field_name'] === 'payment') {
				if (this.$store.state.user_type === 'admin') {
					if (this.action === 'select' || this.action === 'pay') return true;
					return false;
				}
				return true;
			}

			return false;
		},
		isUniqueInCertificate: function isUniqueInCertificate() {
			if (this.crud === 'certificate' && this.Field['_field_name'] === 'plan_id') return true;
			return false;
		},
		isUniqueInDomains: function isUniqueInDomains() {
			if (this.crud === 'domains' && this.Field['_field_name'] === 'plan_id') return true;
			return false;
		},
		notEmpty: function notEmpty(value) {
			if (this.Field['type'] === 'datetime') return true;

			if (this.Field['type'] === 'passport') return true;

			if (value === undefined || value === null) return false;

			if (this.crud === 'datacenter' && String(value) === '' && this.Field['_field_name'] !== 'fastSearch') return true;
			if (this.crud === 'account' && String(value) === '0') return true;

			if (this.Field['type'] === 'list') {
				if (!value || value === '' || value === 'emptyValue') return false;
				if (this.crud === 'servicetype' && value === 'none') return false;
			}

			if (this.crud === 'person' && (this.Field._field_name === 'data[ru_phis][birth_date]' || this.Field._field_name === 'data[birth_date]')) {
				if (!value) return false;else if (value === 'not-date') return true;else return true;
			}

			if (String(value) === '') return false;

			return true;
		},
		textAreaStyle: function textAreaStyle() {
			if (this.Field._field_name === 'data' && this.crud === 'sshkey') {
				if (this.fieldInModal) return 'height: 340px';else return 'height: 240px';
			}
			if (this.Field._field_name === 'content' && this.crud === 'ticketmessage') return 'height: 100px';
			return false;
		},
		onChange: function onChange() {
			var _this5 = this;

			if (this.Field.type === 'text') {
				if (this.isLatin) this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].onlyLatin(this.fieldCurValue);else if (this.isLatinCapitalize) this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FirstSymbolToUpperAndLatin(this.fieldCurValue);else if (this.isRussia) this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].onlyRussia(this.fieldCurValue);
			}

			if (this.Field.type === 'slider') {
				this.Field._errMsg = '';

				var _min = 'min' in this.Field ? this.Field.min : 0;
				if (this.fieldCurValue < _min) {
					this.fieldCurValue = _min;

					if (this.$refs && this.$refs[this.Field._field_name] && 'setValue' in this.$refs[this.Field._field_name]) {
						this.$refs[this.Field._field_name].setValue(this.fieldCurValue);
					}
				}

				this.outerDiskValue = this.fieldCurValue;
				this.outerDiskError = '';
			}

			if (this.crud === 'vds' && (this.Field._field_name === 'plan_id' || this.Field._field_name === 'template_id' || this.Field._field_name === 'backup_id' || this.Field._field_name === 'iso_id')) {
				this.Field._errMsg = '';

				if (this.Field._field_name === 'plan_id') {
					var found = null;
					if (this.Field && this.Field.list && this.Field.list.length) {
						this.Field.list.some(function (plan) {
							if (plan && String(plan.id) === String(_this5.fieldCurValue)) {
								found = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, plan);
								return true;
							}
						});
					}

					__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-new-vds-plan-notice', {
						id: this.fieldCurValue,
						plan: found
					});
				}
			}

			if (this.crud === 'disks' && this.action === 'create' && this.Field._field_name === 'backup_id') {
				this.Field._errMsg = '';

				if (this.fieldCurValue === '' || this.fieldCurValue === null || this.fieldCurValue === undefined) {
					this.fieldCurValue = null;
					this.listValue = null;
				}
			}
			if (this.crud === 'disks' && this.action === 'create' && this.Field._field_name === 'quantity') {
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('diskQuantityValue', this.fieldCurValue);
			}

			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', this.Field);

			if (this.Field.type === 'text' && this.Field._field_name === 'fastSearch') this.$emit('fastSearchInput', this.fieldCurValue);
		},
		onParams: function onParams(params) {
			if (!params || !params['01']) return;

			var _newParams = {};
			for (var idx in params) {
				var data = params[idx];
				if (!data || !data.__prop) continue;

				if (data.type === 'boolean') {
					_newParams['params[' + data.__prop + ']'] = data.value ? 1 : 0;
				} else {
					_newParams['params[' + data.__prop + ']'] = data.value;
				}
			}

			this.params = _newParams;
			this.$emit('params', _newParams);
		},
		onGroupChanged: function onGroupChanged(newGroup) {
			this.$emit('groupChanged', newGroup);
		},
		onDomainName: function onDomainName(value) {
			this.Field._errMsg = '';

			this.$emit('domainName', value);
		},
		copyAddress: function copyAddress(data) {
			var _fieldToCopy = '';

			if (this.crud === 'person') {
				_fieldToCopy = this.Field._field_name.replace('residence', 'p_addr').replace('address_r', 'p_addr');
			}

			if (this.crud === 'payer') {
				_fieldToCopy = this.Field._field_name.replace('address', 'post_addr');
			}

			if (!_fieldToCopy) return;

			__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-copy-address-field-value', {
				name: _fieldToCopy,
				fields: data
			});
		},
		onError: function onError(text) {
			if (text && this.Field._errMsg !== text) this.Field._errMsg = text;
		},
		onStartData: function onStartData(value) {
			if (!this.Field['_emptyValue']) this.Field['_emptyValue'] = value;

			if (!this.Field['_oldValue']) this.Field['_oldValue'] = value;
		},
		onUploadFinished: function onUploadFinished() {
			this.$emit('uploadFinished');
		},
		onIsoUploadFinished: function onIsoUploadFinished() {
			this.$emit('isoUploadFinished');
		},
		onIsoUploadCanceled: function onIsoUploadCanceled() {
			this.$emit('isoUploadCanceled');
		},
		onIsoUploadError: function onIsoUploadError(text) {
			this.$emit('isoUploadError', text);
		},
		recountBlocksInModal: function recountBlocksInModal() {
			if (this.fieldInModal) {
				var $component = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
				if ($component && $component.length) {
					var _elHeight = $component.height();
					var _elOffset = $component.offset();
					var _elWidth = $component.width();
					if (_elWidth <= 0) _elWidth = '100%';

					if (this.$errorBlock && this.$errorBlock.length) {
						var _css = {
							top: _elOffset.top + _elHeight + 10,
							left: _elOffset.left,
							maxWidth: _elWidth,
							zIndex: 9998
						};
						if (this.$store.state.windowWidth <= 767) _css.width = _elWidth;

						this.$errorBlock.css(_css);
					}

					if (this.$tooltipBlock && this.$tooltipBlock.length) {
						var _css2 = {
							position: 'absolute',
							top: _elOffset.top + _elHeight + 10,
							left: _elOffset.left,
							maxWidth: _elWidth,
							zIndex: 9998
						};
						if (this.$store.state.windowWidth <= 767) _css2.width = _elWidth;

						this.$tooltipBlock.css(_css2);
					}
				}
			}
		},
		fieldFocus: function fieldFocus(e) {
			if (this.Field._field_name === 'fastSearch' && this.Field.type === 'text' && e && e.target && e.target.removeAttribute) {
				e.target.removeAttribute('readonly');
			}

			this.recountBlocksInModal();

			this.fieldAnimated = true;

			this.fieldFocused = true;

			this.$emit('focus');
		},
		emitFocus: function emitFocus() {
			this.$emit('focus');
		},
		emitBlure: function emitBlure(field) {
			if (!field) return this.$emit('blur');else __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-field-emit-blur', field);
		},
		emitBlurEvent: function emitBlurEvent(field) {
			if (this.Field['_field_name'] === field) this.$emit('blur');
		},
		__transliterate: function __transliterate(str) {
			if (!str) return str;
			str = String(str);
			if (!str.length) return str;

			var srcLetter = {
				'А': 'A',
				'Б': 'B',
				'В': 'V',
				'Г': 'G',
				'Д': 'D',
				'Е': 'E',
				'Ё': 'Yo',
				'Ж': 'Zh',
				'З': 'Z',
				'И': 'I',
				'Й': 'Y',
				'К': 'K',
				'Л': 'L',
				'М': 'M',
				'Н': 'N',
				'О': 'O',
				'П': 'P',
				'Р': 'R',
				'С': 'S',
				'Т': 'T',
				'У': 'U',
				'Ф': 'F',
				'Х': 'Kh',
				'Ц': 'Ts',
				'Ч': 'Ch',
				'Ш': 'Sh',
				'Щ': 'Sch',
				'Ь': '',
				'Э': 'E',
				'Ю': 'Yu',
				'Я': 'Ya'
			};

			var answer = '';
			var letters = str.split('');
			for (var i = 0; i < letters.length; i++) {
				var ch = String(letters[i]).trim().toUpperCase();

				if (ch === 'Ь') {
					continue;
				}

				if (srcLetter[ch]) {
					if (ch !== String(letters[i]).trim()) answer += srcLetter[ch].toLowerCase();else {
							if (i === letters.length - 1) {
								answer += srcLetter[ch].toUpperCase();
							} else {
									var nextCh = String(letters[i + 1]).trim().toUpperCase();

									if (srcLetter[nextCh]) {
										if (nextCh !== String(letters[i + 1]).trim()) answer += srcLetter[ch];else answer += srcLetter[ch].toUpperCase();
									} else if (nextCh === 'Ъ') {
											if (letters[i + 1] === 'ъ') answer += srcLetter[ch];else answer += srcLetter[ch].toUpperCase();
										} else if (nextCh === 'Ы') {
												if (letters[i + 1] === 'ы') answer += srcLetter[ch];else answer += srcLetter[ch].toUpperCase();
											} else answer += srcLetter[ch].toUpperCase();
								}
						}
				} else if (ch === 'Ъ') {
						if (i < letters.length - 1 && (letters[i + 1] === 'Е' || letters[i + 1] === 'е')) {
							if (letters[i] === 'ъ') answer += 'y';else answer += 'Y';
						}
					} else if (ch === 'Ы') {
							if (i < letters.length - 1 && (letters[i + 1] === 'Й' || letters[i + 1] === 'й')) {
								if (letters[i] === 'ы') answer += 'i';else answer += 'I';
							} else {
								if (letters[i] === 'ы') answer += 'y';else answer += 'Y';
							}
						} else answer += letters[i];
			}

			return answer;
		},
		transliterate: function transliterate(data) {
			if (!data || !data.field || !data.value) return;

			if (this.Field['_field_name'] !== data.field) return;

			if (data.what === 'fio') {
				var _fio = String(data.value).split(' ');
				var _forTrans = '';
				if (_fio.length === 1) {
					_forTrans = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(data.value);
				} else if (_fio.length === 2) {
					_forTrans = (__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(_fio[1]) + ' ' + __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(_fio[0])).trim();
				} else if (_fio.length >= 3) {
					var _part2 = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(_fio[2]);
					_forTrans = (__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(_fio[1]) + (_part2 && _part2.length ? ' ' + _part2[0] + ' ' : ' ') + __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toTrimString(_fio[0])).trim();
				}

				this.Field.value = this.__transliterate(_forTrans);
				this.fieldCurValue = this.Field.value;
				return;
			}

			this.Field.value = this.__transliterate(data.value);
			this.fieldCurValue = this.Field.value;
		},
		emitFieldValue: function emitFieldValue(fieldName) {
			if (this.Field._field_name !== fieldName) return;
			__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-get-field-value-answer', {
				name: this.Field._field_name,
				value: this.fieldCurValue
			});
		},
		fieldBlur: function fieldBlur(e) {
			this.fieldFocused = false;

			this.$emit('blur');
		},
		getTopHint: function getTopHint() {
			this.topHint = false;
			this.bottomHint = false;
			this.rightHint = false;
			this.insteadFieldHint = false;

			if (this.Field.warning) this.topHint = this.Field.warning;

			if (this.crud === 'twofa' && this.Field.hint) this.topHint = this.Field.hint;
			if (this.crud === 'operation' && this.Field._field_name === 'save' && this.Field.hint) {
				this.bottomHint = this.Field.hint;

				this.Field.hint = '';
			}
			if (this.crud === 'paymentauto' && this.Field._field_name === 'saved_id' && (this.Field.hint || this.Field.__hint)) {
				if (this.Field && this.Field.list && this.Field.list.length) this.bottomHint = this.Field.hint || this.Field.__hint;else this.insteadFieldHint = this.Field.hint || this.Field.__hint;

				if (this.Field.hint) this.Field.__hint = this.Field.hint;
				this.Field.hint = '';
			}
			if (this.crud === 'paymentauto' && this.Field.type === 'money' && this.Field.hint) {
				this.rightHint = this.Field.hint;
				this.Field.hint = '';
			}
		},
		clearButtonClick: function clearButtonClick(e) {
			this.fieldCurValue = '';
			this.$emit('event_ClearButtonClicked');
			this.$refs[this.Field._field_name].focus();
		},
		searchButtonClick: function searchButtonClick(e) {
			this.$emit('event_SearchButtonClicked');
			this.$refs[this.Field._field_name].focus();
		},
		generatePasswordHandler: function generatePasswordHandler() {
			this.fieldCurValue = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].generatePassword();
			this.$refs[this.Field._field_name].focus();
			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', this.Field);
		},
		togglePasswordVisibility: function togglePasswordVisibility() {
			this.passwordIsShown = !this.passwordIsShown;
		},
		clickBooleanLabel: function clickBooleanLabel(e) {
			if (this.Field.readonly === true) return;

			this.$emit('focus');

			if (this.crud === 'options' && this.Field._field_name === 'twofa') {
				this.$emit('value2FA', this.fieldCurValue);
				return;
			}

			if (this.crud === 'disks' && this.Field._field_name === 'autoprolong') {
				if (this.fieldCurValue) {
					this.$emit('autoprolongWarning');
					return;
				}
			}

			this.fieldCurValue = !this.fieldCurValue;
			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', this.Field);
		},
		onDateSelect: function onDateSelect(e) {
			if (e === undefined || e === null || String(e).trim() === '') {
				this.fieldCurValue = null;
			} else {
				this.fieldCurValue = e;
				this.isDateSelected = true;
			}

			this.$emit('input', this.formater_Date2StrDate(this.fieldCurValue, true));
			this.$emit('valueChanged', this.Field);
			this.$emit('blur');
		},
		onDateOpen: function onDateOpen() {
			__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs[this.Field._field_name].$el).find('input:first').focus();

			this.fieldAnimated = true;

			this.fieldFocused = true;

			if (!this.value) this.fieldCurValue = this.formater_Date2StrDate(new Date(), true);

			this.$emit('focus');
		},
		onDateClose: function onDateClose(e) {
			__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs[this.Field._field_name].$el).find('input:first').blur();

			this.fieldFocused = false;

			if (this.isDateSelected) {
				this.isDateSelected = false;
				return;
			}

			if (!this.value) this.fieldCurValue = null;
		},
		onSelect: function onSelect(e) {
			var _this6 = this;

			if (!e) return;

			if (this.Field.multiselect === true) {
				if (!Array.isArray(e)) return;

				this.fieldCurValue = [];

				if (this.Field.queryList !== undefined && this.Field.queryList !== null && this.Field.queryList !== false) {
					if (this.Field.queryList !== this.curList.length) this.Field.warningList = this.localeFtc('main/found_less').replace('{find}', this.Field.queryList).replace('{found}', this.curList.length);else this.Field.warningList = null;

					this.Field.queryList = false;

					this.listValue = [];
					this.curList.forEach(function (item) {
						if (item['id']) {
							_this6.fieldCurValue.push(item['id']);
							_this6.listValue.push(item);
						}
					});
				} else {
					e.forEach(function (item) {
						if (item['id']) _this6.fieldCurValue.push(item['id']);
					});
				}
			} else {
					if (e.id === 'emptyValue' || e.id === 'noValue') this.fieldCurValue = '';else if (e.id === 'zeroValue') this.fieldCurValue = 0;else this.fieldCurValue = e.id;

					if (this.crud === 'vds' && this.Field['_field_name'] === 'sshkey_id' || this.crud === 'domains' && this.Field['_field_name'] === 'person_id') {
						if (e.id === 'emptyValue') this.listValue = {};
					}

					if (this.Field && this.Field._field_name && this.crud === 'rackdevice' && this.action === 'links') {
						if (this.Field._field_name.indexOf('device_id') === 0) {
							if (e.id === 'emptyValue') {
								this.listValue = null;
								this.fieldCurValue = null;

								var m = this.Field._field_name.match(/^device_id\[(\d+)\]$/);
								if (m && m.length && m[1]) {
									__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-clear-list-field', 'port_id[' + m[1] + ']');
									this.$emit('freePort', 'from[' + m[1] + ']');
								}
							}
						} else if (this.Field._field_name.indexOf('port_id') === 0) {
								if (!e.active) {
									if (this.Field.perviousValues) {
										this.fieldCurValue = this.Field.perviousValues.id;
										this.listValue = this.Field.perviousValues.obj;
									}

									return false;
								}
							}
					}

					if (this.Field && this.Field._field_name === 'vdsId' && this.crud === 'disks' && this.fieldInModal) {
						if (!e.active) {
							this.listValue = null;
							this.fieldCurValue = null;

							if (this.Field.perviousValues) {
								this.fieldCurValue = this.Field.perviousValues.id;
								this.listValue = this.Field.perviousValues.obj;
							}

							return false;
						}
					}
				}

			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.Field, { 'listValue': this.listValue }));

			if (this.Field._field_name === 'set_label') this.$nextTick(function () {
				_this6.ticketLabelSelected(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this6.$el));
			});

			if (this.crud === 'person' && this.Field._field_name.indexOf('country')) __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-get-field-value-answer', {
				name: this.Field._field_name,
				value: this.fieldCurValue
			});
		},
		onListOpen: function onListOpen() {
			this.countUlBlockForListInModal();

			this.Field.__listOpened = true;

			this.Field.perviousValues = {
				id: this.fieldCurValue,
				obj: this.listValue
			};

			this.fieldAnimated = true;

			this.fieldFocused = true;

			if (!this.$listTag) this.$listTag = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('div.multiselect__tags:first');
			if (this.$listTag.length) this.$listTag.addClass('multiselect__tags__focused');

			if ('warningList' in this.Field) this.Field.warningList = null;

			this.$emit('focus');
		},
		specialForm: function specialForm() {
			if (this.Field._field_name === 'set_label') {
				var $block = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
				if ($block.length) {
					$block.find('li.multiselect__element').each(function () {
						var _span = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).find('span.multiselect__option:first');

						if (_span.length) {
							if (!_span.children('div:first').length) {
								var _color = _span.text().toLowerCase().trim();

								_span.html(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div class="w5-ticket-label" />').addClass('w5-ticket-label-color-' + _color).css('background-color', _color));
							}
						}
					});
				}
			}

			if (this.crud === 'logs' && this.Field._field_name === 'ipBlackList') {
				var _$block = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
				if (_$block.length) {
					var $input = _$block.find('input:first');
					if ($input.length) {
						__WEBPACK_IMPORTED_MODULE_30_inputmask___default()({
							mask: '9{1,3}.9{1,3}.9{1,3}.9{1,3}',
							placeholder: '_',
							showMaskOnHover: false,
							undoOnEscape: false
						}).mask($input);
					}
				}
			}

			if (this.linkHint && this.linkHint.showIfField === this.Field._field_name && this.Field.type === 'list') {
				var _$block2 = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
				if (_$block2.length) {
					__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div class="w5-info-link margin-top-5">' + '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="link" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-link fa-w-16"><path data-v-4dd73f47="" fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z" class=""></path></svg>' + '<span>' + this.linkHintHtml(this.linkHint) + '<span class="font-weight-500"> ' + this.localeFtc(this.linkHint.afterText) + '</span></span></div>').appendTo(_$block2);
				}
			}
		},
		countUlBlockForListInModal: function countUlBlockForListInModal() {
			if (this.listBlockToOut && this.listBlockToOut !== true) {
				var $el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
				if ($el.length && this.$ulBlock && this.$ulBlock.length) {
					var _elHeight = $el.height();
					var _elOffset = $el.offset();
					this.$ulBlock.css({
						top: _elOffset.top + _elHeight + 10,
						left: _elOffset.left,
						zIndex: 9998,
						width: $el.width() + 'px'
					});
				}
			}
		},
		listOpenDirection: function listOpenDirection() {
			var $component = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el);
			if ($component && $component.length) {
				var _css = {
					'width': this.removeRightPadding ? '100%' : 'calc(100% - 10px)',
					'z-index': 99
				};

				var hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight;
				if (!hasEnoughSpace) {
					$component.addClass('multiselect--above');
					_css['margin-bottom'] = '-10px';
				}

				if (this.crud === 'vds') $component.removeClass('multiselect--above');

				if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.css(_css);
			}

			this.countUlBlockForListInModal();
		},
		onListClose: function onListClose(e) {
			this.Field.__listOpened = false;

			this.fieldFocused = false;

			if (!this.$listTag) this.$listTag = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('div.multiselect__tags:first');
			if (this.$listTag.length) this.$listTag.removeClass('multiselect__tags__focused');
		},
		onBackupValueChanged: function onBackupValueChanged(value) {
			__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'backup_id', value: value });
		},
		onTemplateTab: function onTemplateTab(tab) {
			this.$emit('templateTab', tab);
		},
		onBackupList: function onBackupList(list) {
			this.$emit('backupList', list);
		},
		onTemplateInput: function onTemplateInput(data) {
			if (!data || !data.tab) return;

			if (data.tab !== 'backup' && data.tab !== 'iso') {
				if (data.value) {
					__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
						name: 'template_id',
						value: { id: data.value }
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'template_id', value: null });
				}

				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'backup_id', value: null });
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'iso_id', value: null });
			} else if (data.tab === 'backup') {
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'template_id', value: null });
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
					name: 'backup_id',
					value: { id: data.value }
				});
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'iso_id', value: null });
			} else if (data.tab === 'iso') {
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'template_id', value: null });
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', { name: 'backup_id', value: null });
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
					name: 'iso_id',
					value: { id: data.value }
				});
			}

			if (this.action === 'view') this.$emit('templateInput', data);
		},
		createBackup: function createBackup() {
			this.$emit('createBackup');
		},
		ticketLabelSelected: function ticketLabelSelected($block) {
			if (!$block || !$block.length) return;

			var _valBlock = $block.find('span.multiselect__single:first');

			if (_valBlock.length) {
				var _color = _valBlock.text().toLowerCase().trim();

				if (_color !== '') {
					_valBlock.html(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div class="w5-ticket-label" />').addClass('w5-ticket-label-color-' + _color).css('background-color', _color));
				}
			}
		},
		countrySelected: function countrySelected($block, id) {
			if (!$block || !$block.length) return;
			if (!id || id === '' || id === 'noValue') return;

			var _valBlock = $block.find('span.multiselect__single:first');

			if (_valBlock.length) {
				__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<span class="flag-icon flag-icon-' + id.toLowerCase() + '" style="margin-right: 10px;"></span>').prependTo(_valBlock);
			} else {
				_valBlock = $block.find('div.multiselect__tags:first');

				if (_valBlock.length) {
					_valBlock.find('span.flag-icon').remove();

					_valBlock.find('input:first').css({ 'width': '70%', 'padding-left': '6px' });
					__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<span class="flag-icon flag-icon-' + id.toLowerCase() + '" style="margin-left: 12px"></span>').prependTo(_valBlock);
				}
			}
		},
		asyncListFind: function asyncListFind(query) {
			var _this7 = this;

			if (!this.Field.url) return;

			if (!query) {
				this.$set(this, 'curList', []);
				return;
			}

			if (this.serachInputTimer) clearTimeout(this.serachInputTimer);

			this.serachInputTimer = setTimeout(function () {
				var _url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].APIServerUrl + _this7.Field.url;

				if (_this7.Field.multiselect === true && query.indexOf(',') > 0) {
					_url += query.replace(/ /g, '');
					var _values = query.split(',').filter(function (item) {
						return item && item.length;
					});
					_this7.Field.queryList = _values.length;
				} else {
					_this7.Field.queryList = false;
					_url += query;
				}

				_this7.$store.commit('needShowLoader', false);

				_this7.statusListRequestResult = '';
				_this7.statusListRequestProcess = 'Поиск...';
				_this7.$http.get(_url, {
					before: function before(request) {
						if (this.previousRequest) this.previousRequest.abort();

						this.previousRequest = request;
					}
				}).then(function (response) {
					_this7.statusListRequestProcess = '';
					_this7.$store.commit('needShowLoader', true);

					_this7.curList = [];

					if (response && (typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response)) === 'object' && response.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response.data) === 'object' && response.data['status'] === 'ok' && response.data['result'] && Array.isArray(response.data['result'])) {
						response.data['result'].forEach(function (item) {
							var _item = {
								'id': String(item.id),
								'name': item.name,
								'active': _this7.activeItem(item)
							};

							if ('type' in item) {
								_item['type'] = item.type;
							}

							if ('active' in item) {
								_item['$isDisabled'] = !_this7.activeItem(item);
							}

							_this7.curList.push(_item);
						});
					}

					if (_this7.curList.length <= 0) _this7.statusListRequestResult = 'main/search_not_found';
				}, function () {
					return _this7.$store.commit('needShowLoader', true);
				});
			}, 500);
		},
		activeItem: function activeItem(item) {
			if (this.$store.state.user_type === 'admin' && this.crud === 'ticket' && this.action === 'create' && this.Field.type === 'list' && this.Field._field_name.indexOf('multi_value') > -1) {
				return true;
			}

			if (!('active' in item)) return true;

			return item['active'] === true;
		},
		filterActiveList: function filterActiveList(list) {
			var _this8 = this;

			if (!list) return list;

			if (this.$store.state.user_type === 'admin') {
				if (this.Field.type === 'radio') list = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].listAsArray(list);
				return list;
			}

			list = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].listAsArray(list);

			return list.filter(function (item) {
				if (_this8.action === 'create' || _this8.action === 'view') {
					if (_this8.crud === 'vds' && _this8.action === 'view' && String(item['id']) === String(_this8.fieldCurValue)) return true;

					if (item['active'] === false) return false;
				} else if (_this8.action === 'update') {
					if (_this8.Field.value !== item['id']) return false;
				}

				return true;
			});
		},
		mySearchFunction: function mySearchFunction(txt) {
			this.searchText = txt;
		},
		preparedStaticList: function preparedStaticList(list) {
			if (!this.searchText) return list;

			var txt = this.searchText.toLowerCase();

			if (!txt) return list;

			if (this.crud === 'dns') {
				return list.filter(function (item) {
					return String(item['name']).toLowerCase().indexOf(txt) > -1;
				});
			}

			var _foundList = list.filter(function (item) {
				return String(item['name']).toLowerCase().indexOf(txt) === 0;
			});

			if (_foundList && _foundList.length) return _foundList;

			return list.filter(function (item) {
				return String(item['name']).toLowerCase().indexOf(txt) > -1;
			});
		},
		filterListForDataCenterInVds: function filterListForDataCenterInVds(list) {
			return list;
		},
		onSelectUserRole: function onSelectUserRole(values) {
			this.Field['value'] = values;
		},
		setColorOfItems: function setColorOfItems() {
			var _this9 = this;

			this.$nextTick(function () {
				setTimeout(function () {
					var options = _this9.Field.list;
					if (!options) return;
					if (Array.isArray(options) && !options.length) return;
					if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(options)) === 'object' && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).length) return;

					var $comp = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this9);
					if ($comp && $comp.length) $comp = $comp[0];

					if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0];
					if (!$comp) return;

					$comp.isSelected = function (option) {
						var opt = this.trackBy ? option[this.trackBy] : option;

						var Keys = this.valueKeys && this.valueKeys.length ? this.valueKeys.map(String) : [];

						return Keys.indexOf(String(opt)) > -1;
					};

					$comp.optionHighlight = function (index, option) {
						return {
							'multiselect__option--highlight': index === this.pointer && this.showPointer,
							'multiselect__option--selected': this.isSelected(option),
							'multiselect__option--notactive': option.active === false || option.archive === true
						};
					};

					if (!_this9.Field.multiselect && $comp.getValue) {
						var _val = $comp.getValue();
						if (_val && _val.id && $comp.options && $comp.options.length) {
							for (var _idx in $comp.options) {
								var _option = $comp.options[_idx];
								if (_option && _option.id === _val.id) {
									$comp.pointer = _idx;
									$comp.pointerDirty = true;
									var _position = _idx * $comp.optionHeight;
									if ($comp.$refs.list.scrollTop <= _position) $comp.$refs.list.scrollTop = _position;
									break;
								}
							}
						}
					}
				}, 10);
			});
		},
		scopedRemoveElement: function scopedRemoveElement(element) {
			var $comp = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this);
			if ($comp && $comp.length) $comp = $comp[0];

			if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0];

			if ($comp && $comp.removeElement) $comp.removeElement(element);
		},
		scopedGetOptionLabel: function scopedGetOptionLabel(element) {
			var $comp = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this);
			if ($comp && $comp.length) $comp = $comp[0];

			if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0];

			if ($comp && $comp.getOptionLabel) return $comp.getOptionLabel(element);else return '';
		},
		getPlanInfo: function getPlanInfo(plan) {
			if (!plan) return '';

			var answer = '';
			if (plan.ram_text && plan.ram_name) answer = plan.ram_text + ' ' + plan.ram_name;
			if (plan.cpu_text && plan.cpu_name) {
				if (answer) answer += ' / ' + plan.cpu_text + ' ' + plan.cpu_name;else answer = plan.cpu_text + ' ' + plan.cpu_name;
			}
			if (plan.disk_text && plan.disk_name) {
				if (answer) answer += ' / ' + plan.disk_text + ' ' + plan.disk_name;else answer = plan.disk_text + ' ' + plan.disk_name;
			}

			return answer;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (this.Field.type === 'list' && this.fieldInModal) {
				if (e && e.keyCode === 27) {
					if (this.Field.__listOpened) {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
					}

					var $comp = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this);
					if ($comp && $comp.length) $comp = $comp[0];

					if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0];
					if (!$comp || !$comp.deactivate) return;

					$comp.deactivate();

					return false;
				}
			}
		},
		blockFormButton: function blockFormButton() {
			this.$emit('blockFormButton');
		},
		unblockFormButton: function unblockFormButton() {
			this.$emit('unblockFormButton');
		},
		cropCoords: function cropCoords(data) {
			this.$emit('cropCoords', data);
		},
		getCropData: function getCropData(data) {
			if (this.Field['_field_name'] !== 'a_x' && this.Field['_field_name'] !== 'a_y' && this.Field['_field_name'] !== 'a_w' && this.Field['_field_name'] !== 'a_h') return;

			if (!data) return;

			if (this.Field['_field_name'] === 'a_x') this.fieldCurValue = Math.round(data['x']);else if (this.Field['_field_name'] === 'a_y') this.fieldCurValue = Math.round(data['y']);else if (this.Field['_field_name'] === 'a_w' || this.Field['_field_name'] === 'a_h') this.fieldCurValue = Math.round(data['w']);

			this.$emit('input', this.fieldCurValue);
		},
		setTextValueByEvent: function setTextValueByEvent(data) {
			if (this.Field['type'] !== 'text' && this.Field['type'] !== 'address') return;

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['name'] || !('value' in data)) return;

			if (data['name'] !== this.Field['_field_name']) return;

			this.fieldCurValue = data['value'];

			this.$emit('input', this.fieldCurValue);
		},
		clearListField: function clearListField(fieldName) {
			if (this.Field['type'] !== 'list' && this.Field['type'] !== 'savedPayments') return;

			if (fieldName !== this.Field['_field_name']) return;

			this.curList = [];
			this.listValue = null;
			this.fieldCurValue = null;
			this.Field.value = null;

			if (this.crud === 'vds') {
				this.Field.list = [];
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-vds-create-field-reloaded', this.Field._field_name);
			}
		},
		setFieldError: function setFieldError() {
			var _this10 = this;

			if (this.Field['type'] !== 'boolean') return;
			this.timerBooleanFieldError = setTimeout(function () {
				_this10.Field['_errMsg'] = '';
			}, 30000);
		},
		setDateValueByEvent: function setDateValueByEvent(data) {
			if (this.Field['type'] !== 'date') return;

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['name'] || !('value' in data)) return;

			if (data['name'] !== this.Field['_field_name']) return;

			if (this.Field.format) this.fieldCurValue = this.formater_FormatedStrDate2Date(data['value'], this.Field.format);else this.fieldCurValue = this.formater_StrDate2Date(data['value']);

			this.$emit('input', this.formater_Date2StrDate(this.fieldCurValue, true));
		},
		setBoolValueByEvent: function setBoolValueByEvent(data) {
			if (this.Field['type'] !== 'boolean') return;

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['name'] || !('value' in data)) return;

			if (data['name'] !== this.Field['_field_name']) return;

			this.fieldCurValue = data['value'];

			this.$emit('input', this.fieldCurValue);
		},
		setListValueByEvent: function setListValueByEvent(data) {
			if (this.Field['type'] !== 'list') return;

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['name'] || !('value' in data)) return;

			if (data['name'] !== this.Field['_field_name']) return;

			this.fieldCurValue = data.value && data.value.id ? data.value.id : null;
			this.listValue = data.value && data.value.id ? data.value : null;

			this.$emit('input', this.fieldCurValue);

			if (this.crud === 'vds' && this.action === 'create') {
				if (this.Field._field_name === 'template_id' || this.Field._field_name === 'backup_id' || this.Field._field_name === 'iso_id') {
					this.$emit('valueChanged', this.Field);
				}
			}
		},
		enterKeyDown: function enterKeyDown(e) {
			this.$emit('enterKeyDown', e);
		},
		deleteFileValue: function deleteFileValue(data) {
			this.$emit('deleteFileValue', data);
		},
		onSubmitButton: function onSubmitButton(e) {
			this.$emit('onSubmit', e);
		},
		onClientOperationNextStep: function onClientOperationNextStep(id) {
			this.$emit('operationNextStep', id);
		},
		onDeleteSavedPayment: function onDeleteSavedPayment(id) {
			this.$emit('deleteSavedPayment', id);
		},
		templateDialog: function templateDialog() {
			this.$emit('answerTemplateDialog');
		},
		datetimeInput: function datetimeInput(e) {
			this.$emit('input', e);
		},
		emptyFieldValue: function emptyFieldValue() {
			var _emptyValue = void 0;

			if (this.Field._field_name === 'plan_id' && this.crud === 'vds') {
				var selected = null;
				if (this.Field.list && this.Field.list.length) {
					this.Field.list.some(function (item) {
						if (item.selected === true && item.id) {
							selected = String(item.id);
							return true;
						}
					});
				}

				if (selected) _emptyValue = selected;else _emptyValue = '16';
			} else if (this.Field._field_name === 'template_id' && this.crud === 'vds') {
				_emptyValue = undefined;
			} else if (this.Field.type === 'slider' && 'min' in this.Field) {
				_emptyValue = this.Field.min;
				if ('value' in this.Field && this.action !== 'create') _emptyValue = this.Field.value;
			} else if (this.Field._field_name === 'payment' && this.crud === 'operation' && this.$store.state.user_type !== 'admin') {
				_emptyValue = null;
			} else if (this.Field._field_name === 'plan_id' && this.crud === 'certificate' || this.Field._field_name === 'plan_group_id' && this.crud === 'vds') {
				_emptyValue = '';
				if (this.Field.list && this.Field.list.length && this.Field.list[0] && this.Field.list[0]['id']) _emptyValue = this.Field.list[0]['id'];
			} else if (this.Field._field_name === 'host' && this.crud === 'dns-records') {
				_emptyValue = '';
			} else {
					if (this.Field['type'] === 'hidden' || this.Field['type'] === 'text' || this.Field['type'] === 'password' || this.Field['type'] === 'email' || this.Field['type'] === 'textarea') _emptyValue = '';else if (this.Field['type'] === 'money' || this.Field['type'] === 'integer' || this.Field['type'] === 'float') _emptyValue = null;else if (this.Field['type'] === 'date') _emptyValue = null;else if (this.Field['type'] === 'datetime') _emptyValue = null;else if (this.Field['type'] === 'boolean') {
						if ('_oldValue' in this.Field) _emptyValue = this.Field._oldValue;else _emptyValue = false;
					} else if (this.Field['type'] === 'image' || this.Field['type'] === 'file') _emptyValue = null;else if (this.Field['type'] === 'list') {
						if (this.Field['multiselect'] === true) _emptyValue = [];else _emptyValue = '';
					}
				}

			return _emptyValue;
		},
		initOldValue: function initOldValue() {
			var _this11 = this;

			this.$store.commit('isInitFormsValue', true);

			setTimeout(function () {
				if (!('_emptyValue' in _this11.Field)) {
					var _emptyValue = _this11.emptyFieldValue();

					_this11.Field['_emptyValue'] = _emptyValue;

					if (_this11.fieldCurValue !== null && _this11.fieldCurValue !== undefined) {
						if (_this11.Field['type'] === 'date') {
							_this11.Field['_oldValue'] = _this11.formater_Date2StrDate(_this11.fieldCurValue, true);
						} else if (_this11.Field['type'] === 'boolean' || _this11.Field['type'] === 'slider') {
							_this11.Field['_oldValue'] = _emptyValue;
						} else if (_this11.fieldCurValue === 'noValue' || _this11.fieldCurValue === 'emptyValue') {
							_this11.Field['_oldValue'] = '';
						} else if (_this11.Field['_field_name'] === 'plan_id') {
							_this11.Field['_oldValue'] = _emptyValue;
						} else {
							_this11.Field['_oldValue'] = _this11.fieldCurValue;
						}
					} else _this11.Field['_oldValue'] = _emptyValue;
				}

				_this11.$store.commit('isInitFormsValue', false);
			}, 400);
		},
		fromBlock: function fromBlock() {
			if (this.Field['type'] === 'list' && this.Field['listValue']) {
				this.listValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.Field['listValue']);
				return;
			}
		},
		qaSearchResult: function qaSearchResult(arr) {
			this.qaResult = false;
			if (this.crud === 'ticket' && this.action === 'create' || this.crud === 'qa' && this.action === 'list' && this.$store.state.user_type === 'client') if (arr && Array.isArray(arr)) {
				this.qaResult = arr.map(function (item) {
					return {
						'ans': item.ans.replace('<span>', '').replace('</span>', ''),
						'url': item.url,
						'cap': item.cap
					};
				});
			}
		},
		bigButtonHandlerFunc: function bigButtonHandlerFunc(e) {
			if (!this.bigButtonEnabled) return;

			if (this.bigButtonHandler && typeof this.bigButtonHandler === 'function') this.bigButtonHandler(e);else this.enterKeyDown(e);
		},
		animationRequested: function animationRequested() {
			var _this12 = this;

			this.$nextTick(function () {
				var _el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this12.$el);
				if (!_el || !_el.length) return;

				if (_this12.Field.type === 'money') {
					var _inp = _el.find('input:first');
					if (_inp.length) {
						_inp.css({ 'background-color': 'rgba(54, 155, 242, .6)' });
						setTimeout(function () {
							return _inp.css({ 'background-color': 'rgba(54, 155, 242, .2)' });
						}, 100);
						setTimeout(function () {
							return _inp.css({ 'background-color': 'rgba(0,0,0,0)' });
						}, 300);
					}

					_el.animate({ left: 5 }, 100).animate({ left: 0 }, 50).animate({ left: 4 }, 100).animate({ left: 0 }, 50).animate({ left: 3 }, 50).animate({ left: 0 }, 50);
				}
			});
		},
		animationFieldRequested: function animationFieldRequested(data) {
			if (!data || !data.field) return;
			if (this.Field._field_name !== data.field) return;

			this.animationHighlightField();
		},
		setErrorToField: function setErrorToField(data) {
			if (!data || !data.field || !data.text) return;
			if (this.Field._field_name !== data.field) return;

			this.Field._errMsg = data.text;
		},
		animationHighlightField: function animationHighlightField() {
			var _this13 = this;

			this.$nextTick(function () {
				var _el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this13.$el);
				if (!_el || !_el.length) return;

				if (_this13.Field.type === 'list') {
					var _div = _el.find('div.multiselect:first');
					if (_div && _div.length) {
						_div.css({ 'background-color': 'rgba(54, 155, 242, .6)' });
						setTimeout(function () {
							return _div.css({ 'background-color': 'rgba(54, 155, 242, .2)' });
						}, 100);
						setTimeout(function () {
							return _div.css({ 'background-color': 'rgba(0,0,0,0)' });
						}, 200);
					}
				}

				if (_this13.Field.type === 'urlButton' || _this13.Field.type === 'boolean') {
					_el.css({ 'background-color': 'rgba(54, 155, 242, .6)' });
					setTimeout(function () {
						return _el.css({ 'background-color': 'rgba(54, 155, 242, .2)' });
					}, 100);
					setTimeout(function () {
						return _el.css({ 'background-color': 'rgba(0,0,0,0)' });
					}, 200);
				}

				_el.animate({ left: 5 }, 100).animate({ left: 0 }, 50).animate({ left: 3 }, 50).animate({ left: 0 }, 50);
			});
		},
		onOuterDiskTypeChanged: function onOuterDiskTypeChanged(value) {
			this.Field._errMsg = '';

			this.$emit('outerDiskTypeChanged', value);
		},
		setSliderHandlers: function setSliderHandlers() {
			var _this14 = this;

			if (!this.$refs || !this.$refs['field-' + this.Field._field_name]) return;

			var $el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs['field-' + this.Field._field_name]);
			var _this = this;

			if (!$el.data('autoNumeric')) {
				$el.autoNumeric('init', { aSep: '', mDec: 0, vMin: 0, vMax: 99999 });

				$el.off('keydown').on('keydown', function (e) {
					var text = e.target;
					var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart);
					if (t && t.length) {
						__WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this14).val('');
					}
				});

				$el.off('keyup').on('keyup', function (e) {
					_this.onInputFieldChanged(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(e.target));
				});
			}
		},
		onInputFieldChanged: function onInputFieldChanged($input) {
			var value = $input.autoNumeric('get');

			this.outerDiskError = '';

			var _value = parseInt(value, 10);
			if (isNaN(_value)) {
				this.outerDiskError = 'validators/error_int';
				this.outerDiskValue = value;
				return;
			}

			this.outerDiskValue = _value;

			if (!value || !value.length) return;

			if (_value < this.Field.min || _value > this.Field.max) {
				this.outerDiskError = 'Min: ' + this.Field.min + ', Max: ' + this.Field.max;
				return;
			}

			this.Field._errMsg = '';
			this.fieldCurValue = this.outerDiskValue;

			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', this.Field);
		},
		onSliderFieldBlurNew: function onSliderFieldBlurNew() {
			if (!this.outerDiskValue || this.outerDiskError) {
				this.outerDiskError = '';
				this.outerDiskValue = this.fieldCurValue;
			}

			if (this.Field.step > 1) {
				this.outerDiskValue = parseInt(Math.round(this.outerDiskValue / this.Field.step) * this.Field.step);
				this.fieldCurValue = this.outerDiskValue;
			}

			var $input = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs['field-' + this.Field._field_name]);
			if ($input && $input.length && $input.autoNumeric) {
				$input.autoNumeric('set', this.fieldCurValue);
			}

			this.$emit('input', this.fieldCurValue);
			this.$emit('valueChanged', this.Field);
		}
	},

	watch: {
		crud: function crud() {
			this.getTopHint();
		},
		action: function action() {
			this.getTopHint();
		},

		'value': function value(_value2) {
			if (this.Field.type === 'textarea' || this.Field.type === 'text' || this.Field.type === 'hidden' || this.Field.type === 'password') {
				this.fieldCurValue = _value2;
				return;
			}

			if (this.Field.type === 'list') {
				if (_value2 && (typeof _value2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_value2)) === 'object' && 'id' in _value2 && 'name' in _value2) {
					this.fieldCurValue = _value2.id;
					this.listValue = _value2;
					return;
				} else if (_value2 === null) {
					if (this.crud === 'ticket') this.listValue = {};
				} else if (_value2 === false) {
					this.listValue = null;
					this.fieldCurValue = null;
				}
			}

			if (this.Field.type === 'int' || this.Field.type === 'integer' || this.Field.type === 'float' || this.Field.type === 'money') {
				this.fieldCurValue = _value2;
				return;
			}

			if (this.Field.type === 'file' || this.Field.type === 'image') {
				this.fieldCurValue = _value2;
				return;
			}

			if (this.Field.type === 'date') {
				if (_value2 !== null && _value2 !== undefined) {
					if (_value2 === 'not-date') {
						this.fieldCurValue = _value2;
						return;
					}

					if (this.Field.format) this.fieldCurValue = this.formater_FormatedStrDate2Date(_value2, this.Field.format);else this.fieldCurValue = this.formater_StrDate2Date(_value2);
				} else this.fieldCurValue = null;
				return;
			}

			if (this.Field.type === 'datetime') {
				if (_value2 === null || _value2 === undefined) this.fieldCurValue = null;
				return;
			}

			this.fieldCurValue = _value2;
		},

		'Field.list': function FieldList(list) {
			var _this15 = this;

			if (list) {
				this.curList = [];

				if (Array.isArray(list)) {
					list.forEach(function (item) {
						if (item) {
							var _item = {
								'id': String(item.id),
								'name': _this15.localeFtc(item.name),
								'archive': item.archive,
								'status': item.status,
								'max': item.max,
								'min': item.min,
								'type': item['type'],
								'plan': item.plan,
								'template': item.template,
								'datacenter': item.datacenter,
								'active': _this15.activeItem(item)
							};

							if ('active' in item) {
								_item['$isDisabled'] = !_this15.activeItem(item);
							}

							_this15.curList.push(_item);
						}
					});
				} else {
					for (var _id in list) {
						if (_id === '') {
							if (this.crud === 'datacenter') {
								this.curList.push({
									'id': 'noValue',
									'name': this.localeFtc(this.Field.list[_id])
								});
							} else this.curList.push({
									'id': 'emptyValue',
									'name': ' '
								});
						} else {
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(list[_id])
							});
						}
					}
				}

				if (this.Field['_field_name'] === 'plans' || this.Field['_field_name'] === 'templates') {
					var _values = [];
					if (this.fieldCurValue && Array.isArray(this.fieldCurValue)) this.fieldCurValue.forEach(function (i) {
						_values.push(i);
					});

					this.listValue = null;
					this.fieldCurValue = null;

					_values.forEach(function (v) {
						_this15.curList.some(function (item) {
							if (String(item['id']) === String(v)) {
								if (!_this15.listValue) _this15.listValue = [];
								if (!_this15.fieldCurValue) _this15.fieldCurValue = [];

								_this15.listValue.push(item);
								_this15.fieldCurValue.push(v);
								return true;
							}
						});
					});

					this.$emit('input', this.fieldCurValue);
				} else if (this.crud === 'vds' && (this.Field['_field_name'] === 'plan_id' || this.Field['_field_name'] === 'sshkey_id')) {
						var _oldValue = this.Field.value;

						var _found = false;

						for (var i in list) {
							if (list[i] && list[i]['id']) {
								this.fieldCurValue = list[i]['id'];

								if (this.Field['_field_name'] !== 'sshkey_id') this.$emit('input', this.fieldCurValue);

								break;
							} else if (list[i][0] && list[i][0]['id']) {
								this.fieldCurValue = list[i][0]['id'];
								break;
							}
						}

						if (_oldValue) {
							this.fieldCurValue = _oldValue;
							this.listValue = { 'id': _oldValue };

							for (var _i in list) {
								if (list[_i]['id'] && String(list[_i]['id']) === String(this.fieldCurValue)) {
									this.listValue['name'] = this.localeFtc(list[_i]['name']);
									_found = true;
									break;
								} else if (list[_i][0] && list[_i][0]['id'] && String(list[_i][0]['id']) === String(this.fieldCurValue)) {
									this.listValue['name'] = this.localeFtc(list[_i][0]['name']);
									_found = true;
									break;
								}
							}

							if (_found) this.$emit('input', this.fieldCurValue);
						}

						if (!_found && this.Field['value']) {
							this.fieldCurValue = this.Field['value'];
							this.listValue = { 'id': this.Field['value'] };

							for (var _i2 in list) {
								if (list[_i2]['id'] && String(list[_i2]['id']) === String(this.fieldCurValue)) {
									this.listValue['name'] = this.localeFtc(list[_i2]['name']);
									_found = true;
									break;
								}
							}

							if (_found) this.$emit('input', this.fieldCurValue);
						}

						if (!_found) {
							if (this.Field['_field_name'] === 'sshkey_id') {
								this.fieldCurValue = 'emptyValue';
								this.listValue = { 'id': 'emptyValue' };
							}
						}
					} else {
							if (this.Field.value !== undefined && this.Field.value !== null) {
								if (this.crud === 'server' && this.Field['_field_name'] === 'groups' && this.Field.value.length) {
									this.listValue = [];
									this.fieldCurValue = [];

									this.Field.value.forEach(function (item) {
										if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object' && 'id' in item && 'name' in item) {} else {
											_this15.curList.some(function (grp) {
												if (grp && String(grp['id']) === String(item)) {
													_this15.listValue.push(grp);
													_this15.fieldCurValue.push(String(item));
												}
											});
										}
									});

									this.$emit('input', this.fieldCurValue);
								} else if (this.crud === 'domains' && this.Field['_field_name'] === 'person_id' && this.Field.value.length) {
										this.listValue = null;
										this.fieldCurValue = null;

										this.curList.some(function (prsn) {
											if (prsn && String(prsn.id) === _this15.Field.value) {
												_this15.listValue = prsn;
												_this15.fieldCurValue = String(prsn.id);
												return true;
											}
										});

										this.$emit('input', this.fieldCurValue);
									}
							} else if (this.curList && this.curList.length) {
									if (this.Field.multiselect) {
										this.listValue = [];
										this.fieldCurValue = [];
									} else {
											if (this.crud === 'domains' && this.Field['_field_name'] === 'person_id' || this.crud === 'vds' && this.Field['_field_name'] === 'template_id' || this.crud === 'vds' && this.Field['_field_name'] === 'backup_id' || this.crud === 'disks' && this.Field['_field_name'] === 'backup_id' || this.crud === 'vds' && this.Field['_field_name'] === 'iso_id' || this.crud === 'operation' && this.Field['_field_name'] === 'saved' && this.$store.state.user_type === 'client' || this.crud === 'paymentauto' && this.Field['_field_name'] === 'saved_id') {} else if (this.crud === 'rackdevice' && this.action === 'links' && this.Field['_field_name'] && this.Field['_field_name'].indexOf('port_id') === 0) {} else {
														this.listValue = this.curList[0];
														this.fieldCurValue = this.listValue['id'];

														if (this.crud === 'vds' && this.action === 'create' && this.Field['_field_name'] === 'datacenter_id') {
															var _recordWithSelect = null;
															list.some(function (el) {
																if (el && el.select === true) {
																	_recordWithSelect = el;
																	return true;
																}
															});

															if (_recordWithSelect) {
																this.curList.some(function (el) {
																	if (el && String(el.id) === String(_recordWithSelect.id)) {
																		_this15.listValue = el;
																		_this15.fieldCurValue = _this15.listValue['id'];
																	}
																});
															}
														}

														this.$emit('input', this.fieldCurValue);

														if (this.crud === 'document' && this.Field['_field_name'] === 'payer_id') this.$emit('valueChanged', this.Field);
													}
										}
								}

							if (this.crud === 'domains' && this.action === 'create' && this.Field['_field_name'] === 'person_id') {
								if (!this.curList.length) {
									this.listValue = null;
									this.fieldCurValue = null;

									this.curList.push({
										'id': 'emptyValue',
										'name': this.localeFtc('person/empty_list')
									});
								}

								this.$nextTick(function () {
									if (_this15.$ulBlock) {
										var _css = {
											width: _this15.$ulBlock.parent().css('display') === 'block' ? 'calc(100% - 150px)' : '100%'
										};
										if (!_this15.$ulBlock.parent().hasClass('multiselect--above')) _css['top'] = '55px';
										_this15.$ulBlock.css(_css);
									}
								});
							}
						}
			}

			this.getTopHint();
		},

		'listOptions': function listOptions() {
			if (this.$store.state.user_type === 'admin' && this.crud === 'ticket' && this.action === 'create' && this.Field.type === 'list' && this.Field._field_name.indexOf('multi_value') > -1) {
				if (this.curList && this.curList.length) {
					for (var idx = 0; idx < this.curList.length; idx++) {
						var _item = this.curList[idx];

						if ('archive' in _item) {
							this.$set(this.curList[idx], 'archive', true);
						}
						if ('active' in _item) {
							this.$set(this.curList[idx], 'active', true);
						}
					}
				}
			}

			if (this.crud === 'document' && (this.Field['_field_name'] === 'payer_id' || this.Field['_field_name'] === 'operation_id')) {
				if (this.curList && this.curList.length) {
					this.listValue = this.curList[0];
					this.fieldCurValue = this.listValue['id'];
				} else {
					this.listValue = null;
					this.fieldCurValue = null;

					if (this.Field['_field_name'] === 'payer_id') __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-clear-list-field', 'operation_id');
				}

				this.$emit('input', this.fieldCurValue);
				this.$emit('valueChanged', this.Field);
			}

			if (this.crud === 'operation' && this.Field['_field_name'] === 'payer') {
				if (this.curList && this.curList.length) {
					if (this.Field['value'] === null || this.Field['value'] === undefined) {
						this.listValue = null;
						this.fieldCurValue = null;
					} else {
						this.listValue = this.curList[0];
						this.fieldCurValue = this.listValue['id'];

						for (var i = 0; i < this.curList.length; i++) {
							var item = this.curList[i];
							if (String(this.Field['value']) === String(item.id)) {
								this.listValue = this.curList[i];
								this.fieldCurValue = item.id;
								break;
							}
						}
					}
				} else {
					this.listValue = null;
					this.fieldCurValue = null;
				}

				this.$emit('input', this.fieldCurValue);
				this.$emit('valueChanged', this.Field);
			}

			this.listOpenDirection();
		},

		'Field._visible': function Field_visible(value, oldValue) {
			if (this.crud === 'vds' && this.action === 'create') {
				if (this.Field._field_name === 'backup_auto') {
					if (value && !oldValue) {
						if ('_initFirstValue' in this.Field) {
							this.fieldCurValue = this.Field._initFirstValue;
							this.$emit('input', this.fieldCurValue);
						} else this.Field._initFirstValue = this.fieldCurValue;
					}

					if (!value && oldValue) {
						this.Field._initFirstValue = this.fieldCurValue;
						this.fieldCurValue = false;
						this.$emit('input', this.fieldCurValue);
					}
				}
			}
		},

		'fieldVisible': function fieldVisible() {
			var _this16 = this;

			if (this.Field._field_name === 'set_label') this.$nextTick(function () {
				_this16.ticketLabelSelected(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this16.$el));
			});

			if (this.crud === 'operation' && this.Field._field_name === 'payer' && (this.Field.type === 'list' || this.Field.type === 'urlButton') && this.Field._visible) {
				if (!this.Field.list || !this.Field.list.length) {
					if (this.$store.state.user_type === 'client') __WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('w5-show-payer-dialog');
				}
			}
		},
		outerDiskValue: {
			handler: function handler(value) {
				__WEBPACK_IMPORTED_MODULE_34__bus_js__["a" /* EventBus */].$emit('diskQuantityValue', value);
			},
			deep: true,
			immediate: true
		}
	},

	components: {
		numberInput: __WEBPACK_IMPORTED_MODULE_6__components_elements_number___default.a,
		domainInput: __WEBPACK_IMPORTED_MODULE_7__components_elements_domain___default.a,
		Multiselect: __WEBPACK_IMPORTED_MODULE_28_vue_multiselect___default.a,
		fileComponent: __WEBPACK_IMPORTED_MODULE_8__components_elements_file___default.a,
		directFileComponent: __WEBPACK_IMPORTED_MODULE_9__components_elements_directFile___default.a,
		planComponent: __WEBPACK_IMPORTED_MODULE_10__components_elements_planNew___default.a,
		groupPlanComponent: __WEBPACK_IMPORTED_MODULE_11__components_elements_groupPlan___default.a,
		planSslComponent: __WEBPACK_IMPORTED_MODULE_12__components_elements_planssl___default.a,
		planDomainComponent: __WEBPACK_IMPORTED_MODULE_13__components_elements_planDomain___default.a,
		templateComponent: __WEBPACK_IMPORTED_MODULE_14__components_elements_template___default.a,
		templateImageComponent: __WEBPACK_IMPORTED_MODULE_15__components_elements_tempNew___default.a,
		paymentComponent: __WEBPACK_IMPORTED_MODULE_16__components_elements_payment___default.a,
		urlButtonComponent: __WEBPACK_IMPORTED_MODULE_17__components_elements_urlbtn___default.a,
		countryComponent: __WEBPACK_IMPORTED_MODULE_18__components_elements_country___default.a,
		radioListComponent: __WEBPACK_IMPORTED_MODULE_20__components_elements_radio___default.a,
		manualDateComponent: __WEBPACK_IMPORTED_MODULE_21__components_elements_date___default.a,
		phoneComponent: __WEBPACK_IMPORTED_MODULE_22__components_elements_phone___default.a,
		passportComponent: __WEBPACK_IMPORTED_MODULE_23__components_elements_passport___default.a,
		addressComponent: __WEBPACK_IMPORTED_MODULE_24__components_elements_address___default.a,
		Datepicker: __WEBPACK_IMPORTED_MODULE_29_vuejs_datepicker___default.a,
		userRole: __WEBPACK_IMPORTED_MODULE_26__components_elements_role___default.a,
		DateTime: __WEBPACK_IMPORTED_MODULE_27__components_elements_datetime___default.a,
		savedPaymentsComponent: __WEBPACK_IMPORTED_MODULE_25__components_elements_savedPayments___default.a,
		VueSlider: __WEBPACK_IMPORTED_MODULE_32_vue_slider_component___default.a,
		OuterDiskType: __WEBPACK_IMPORTED_MODULE_31__components_elements_outerdisktype___default.a,
		backupComponent: __WEBPACK_IMPORTED_MODULE_19__components_elements_backupList___default.a
	}

});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autonumeric__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'numberInput',

	props: ['value', 'type', 'needReact', 'crud'],
	data: function data() {
		return {
			numberValue: 0,

			$input: null
		};
	},
	mounted: function mounted() {
		this.$input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

		if (this.type === 'integer') this.$input.autoNumeric('init', { aSep: '', mDec: 0 });else if (this.type === 'money') {
				if (this.crud === 'paymentauto') {
					this.$input.autoNumeric('init', { aSep: ' ', aDec: '.', aPad: false, mDec: 2 });
				} else {
					if (this.$store.state.user_type === 'admin') this.$input.autoNumeric('init', { aSep: ' ', aDec: '.', mDec: 4 });else this.$input.autoNumeric('init', { aSep: ' ', aDec: '.' });
				}
			} else this.$input.autoNumeric('init', { aSep: ' ', aDec: '.' });

		this.numberValue = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.clearFormatValue(this.value)).value();

		if (isNaN(this.numberValue)) this.numberValue = null;
		if (this.numberValue !== null && this.numberValue !== undefined) {
			this.$input.autoNumeric('set', this.numberValue);
		}

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-set-money-field-value', this.setValueByEvent);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-set-money-field-value', this.setValueByEvent);
	},

	methods: {
		setValueByEvent: function setValueByEvent(data) {
			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['type'] || !data['name'] || !('value' in data)) return;

			if (data['name'] !== this.$el.name || data['type'] !== this.type) return;

			this.numberValue = data['value'];

			if (this.numberValue !== null && this.numberValue !== undefined) {
				this.$input.autoNumeric('set', this.numberValue);
			} else {
				this.$input.autoNumeric('set', '');
			}

			this.$emit('input', this.numberValue);

			if (data.animation) this.$emit('animation');
		},
		clearFormatValue: function clearFormatValue(value) {
			var _val = '';
			if (value !== undefined && value !== null) _val = String(value);else _val = String(this.$input.autoNumeric('get'));

			var _str = _val.replace(/ /g, '');

			_val = _str.replace(',', '.');

			return _val;
		},
		onFocus: function onFocus() {
			var _this = this;

			this.numberValue = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.clearFormatValue()).value();

			if (isNaN(this.numberValue)) this.numberValue = null;
			if (this.numberValue !== null && this.numberValue !== undefined) {
				this.$input.autoNumeric('set', this.numberValue);
			}

			setTimeout(function () {
				return _this.$input.select();
			}, 100);

			this.$emit('focus');
		},
		onBlur: function onBlur() {
			this.numberValue = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.clearFormatValue()).value();

			if (isNaN(this.numberValue)) this.numberValue = null;
			if (this.numberValue !== null && this.numberValue !== undefined) {
				this.$input.autoNumeric('set', this.numberValue);
			}

			this.$emit('input', this.numberValue);

			this.$emit('blur');
		},
		onKeyDown: function onKeyDown(e) {
			if (e.keyCode === 13 || e.which === 13) this.$emit('keydownEnter', e);
		},
		onKeyUp: function onKeyUp(e) {
			this.numberValue = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.clearFormatValue()).value();

			if (isNaN(this.numberValue)) this.numberValue = null;

			this.$emit('input', this.numberValue);
		}
	},

	watch: {
		'value': function value(_value) {
			if (this.needReact) {
				this.numberValue = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.clearFormatValue(_value)).value();

				if (isNaN(this.numberValue)) this.numberValue = null;
				if (this.numberValue !== null && this.numberValue !== undefined) {
					this.$input.autoNumeric('set', this.numberValue);
				}
			}
		}
	}

});

/***/ }),
/* 344 */,
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown,
      "keyup": function($event) {
        $event.stopPropagation();
        return _vm.onKeyUp($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  "data-v-843031fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'domainInput',

	props: ['value', 'fixed'],
	data: function data() {
		return {
			Value: ''
		};
	},
	created: function created() {
		this.Value = this.value;
	},

	methods: {
		onFocus: function onFocus() {
			this.$emit('focus');
		},
		onBlur: function onBlur() {
			this.$emit('input', this.Value);

			this.$emit('blur');
		},
		onKeyDown: function onKeyDown(e) {
			if (e.keyCode === 13 || e.which === 13) this.$emit('keydownEnter');
		},
		onInput: function onInput(e) {
			this.$emit('input', this.Value);
		}
	}
});

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Value),
      expression: "Value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Value)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.Value = $event.target.value
      }, _vm.onInput]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fix"
  }, [_vm._v(_vm._s(_vm.fixed))])])
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jcrop__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jcrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jcrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'fileComponent',

	props: ['name', 'title', 'value', 'multiple', 'crud', 'accept', 'maxsize', 'maxcnt', 'candel'],
	data: function data() {
		return {
			currentValue: [],

			maxcount: 1,

			errors: '',

			showModal: false,

			modalWidth: 0,

			modalText: '',

			modalCrop: false,

			modalItemID: 0,

			imageWidth: 0,
			imageHeight: 0,

			imageNaturalWidth: 0,
			imageNaturalHeight: 0,

			$square: null,
			$round: null,

			cropCoords: null,

			scaleKoeff: 1
		};
	},
	created: function created() {
		if (this.maxcnt) this.maxcount = this.maxcnt;

		if (this.multiple) {
			if (this.value && Array.isArray(this.value) && this.value.length) {}
		} else {
				if (this.value) {
					if (this.crud === 'options' && this.value === '/uploads/avatars/default.jpg') {} else {
						var _id = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].unixTime(true);

						this.currentValue.push({
							'id': _id,
							'url': this.value,
							'ext': __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].getFileExt(this.value).toUpperCase().substr(0, 4),
							'type': this.getTypeByName(this.value),
							'title': 'main/loaded_image',
							'status': '',
							'size': 0,
							'local': false,
							'keyfile': null
						});

						this.loadFile(_id);
					}
				}
			}
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			document.addEventListener('keydown', this.keyDownHandler);

			window.addEventListener('paste', this.pasteFromClipboard);
		});
	},
	beforeDestroy: function beforeDestroy() {
		var _this2 = this;

		document.removeEventListener('keydown', this.keyDownHandler);
		window.removeEventListener('paste', this.pasteFromClipboard);

		this.currentValue.forEach(function (item) {
			_this2.cancelUploading(item);
		});
	},

	computed: {
		buttonTitle: function buttonTitle() {
			var _title = '';

			if (this.multiple === true) {
				_title = this.localeFtc('main/attach' + ' ' + (this.title ? this.title : 'main/files')).toLowerCase();
			} else {
				if (this.crud !== 'iso') _title = this.localeFtc('main/attach' + ' ' + (this.title ? this.title : 'ticketattach/path')).toLowerCase();else _title = this.localeFtc(this.title).toLowerCase();
			}

			return this.formater_capitalizeFirstChar(_title);
		},
		buttonVisibility: function buttonVisibility() {
			if (this.multiple === true) return true;

			if (this.currentValue && this.currentValue.length) return false;else return true;
		}
	},

	methods: {
		loadFile: function loadFile(id, crossDomain) {
			this.errors = '';

			if (!id) {
				this.errors = 'main/no_data';
				return;
			}

			var _el = false;
			this.currentValue.some(function (item) {
				if (item.id === id) {
					_el = item;
					return true;
				}
			});

			if (!_el) {
				this.errors = 'main/no_data';
				return;
			}

			_el['size'] = _el['local'] && _el['local']['size'] ? _el['local']['size'] : 0;
			_el['imgWidth'] = 0;
			_el['imgHeight'] = 0;

			if (_el['type'] && String(_el['type']).substr(0, 5).toLowerCase() === 'image') {
				_el['image'] = new Image();
				var _this = this;

				_el['image'].onload = function (e) {
					var _w = _el['image'].naturalWidth;
					var _h = _el['image'].naturalHeight;

					var _k = 1;
					if (_w > _h) _k = 35 / _w;else _k = 35 / _h;

					_el['imgWidth'] = parseInt(_k * _w);
					_el['imgHeight'] = parseInt(_k * _h);

					if (_this.crud === 'options') {
						if (_el['local']) {
							_el['status'] = 'crop';

							_this.modalCrop = true;

							_this.previewImage(_el);
						} else {
							_el['status'] = 'done';
						}
					} else _el['status'] = 'done';

					_this.$forceUpdate();
				};

				if (_el['local']) {
					_el['image'].src = window.URL.createObjectURL(_el['local']);
				} else {
						if (_el['url'].indexOf('data:image/') === 0) {
							_el['image'].src = _el['url'];
						} else {
							var xmlHTTP = new XMLHttpRequest();

							var _url = '';
							if (_el['url'].indexOf('http://') === 0 || _el['url'].indexOf('https://') === 0) {
								_url = _el['url'];
								crossDomain = true;
							} else _url = this.APIServerUrl + _el['url'];
							xmlHTTP.open('GET', _url, true);

							if (crossDomain) xmlHTTP.withCredentials = true;

							xmlHTTP.responseType = 'arraybuffer';

							xmlHTTP.onload = function (e) {
								var blob = new Blob([this.response]);
								_el['size'] = e.loaded;
								_el['image'].src = window.URL.createObjectURL(blob);
							};

							xmlHTTP.send();
						}
					}
			}
		},
		uploadFile: function uploadFile(id) {
			this.errors = '';

			if (!id) {
				this.errors = 'main/no_data';
				return;
			}

			var _el = false;
			this.currentValue.some(function (item) {
				if (item.id === id) {
					_el = item;
					return true;
				}
			});

			if (!_el) {
				this.errors = 'main/no_data';
				return;
			}

			var _this = this;
			var _url = this.APIServerUrl + '/upload/set';
			if (_el['type'] && String(_el['type']).substr(0, 5) === 'image') _url += '/image';

			var _formData = new FormData();
			_formData.append('file', _el['local']);

			_el['status'] = 'uploading';
			_el['progress'] = 0;

			_el['xhr'] = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
				type: 'POST',
				url: _url,
				data: _formData,
				crossDomain: true,
				cache: false,
				contentType: false,
				processData: false,
				xhrFields: {
					withCredentials: true
				},

				xhr: function xhr() {
					var xhr = new XMLHttpRequest();

					xhr.upload.addEventListener('progress', function (evt) {
						if (evt.lengthComputable) {
							var percentComplete = evt.loaded / (evt.total ? evt.total : 1) * 100.0;
							_el['progress'] = percentComplete.toFixed(0) + '%';
							_this.$forceUpdate();
						}
					}, false);
					return xhr;
				},

				beforeSend: function beforeSend(xhr, obj) {
					_this.$store.commit('uploadFileCounter', '+');

					_this.$store.commit('changedForm', _this.$route.path);

					_this.$emit('blockFormButton');
				},

				success: function success(data, txt, xhr) {
					if (data && 'status' in data && data['status'] === 'ok' && 'file' in data && data['file'] && 'key' in data['file'] && data['file']['key']) {
						_el['keyfile'] = data['file']['key'];

						_this.$emit('input', _this.makeCurValue());

						_this.$emit('deleteFileValue', { 'field': _this.name, 'value': false });

						_this.$forceUpdate();

						_this.$emit('uploadFinished');

						return;
					}

					_this.errors = 'upload/some_error';
				},

				error: function error(data) {
					if (data.statusText === 'abort') return;

					_this.errors = 'upload/some_error';
				},

				complete: function complete(jqXHR, textStatus) {
					_this.$store.commit('uploadFileCounter', '-');

					_el['status'] = 'done';

					_this.$emit('unblockFormButton');
				}
			});
		},
		deleteItem: function deleteItem(item) {
			this.errors = '';

			if (!item) return;
			if (!this.currentValue || !this.currentValue.length) return;

			if (this.multiple) {
				var _idx = this.currentValue.indexOf(item);

				if (_idx < 0) return;

				if (item['keyfile'] && item['keyfile'] !== '') this.deleteFromServer(item['keyfile']);

				this.currentValue.splice(_idx, 1);
			} else {
					if (this.candel) this.$emit('deleteFileValue', { 'field': this.name, 'value': true });

					if (this.currentValue && this.currentValue[0] && this.currentValue[0]['keyfile']) this.deleteFromServer(this.currentValue[0]['keyfile']);

					this.currentValue = [];
				}

			this.$emit('input', this.makeCurValue());
		},
		deleteFromServer: function deleteFromServer(keyfile) {
			var _this3 = this;

			if (!keyfile) return;

			this.$store.commit('needShowLoader', false);
			this.$http.get(this.APIServerUrl + '/upload/delete/' + keyfile).then(function () {
				return _this3.$store.commit('needShowLoader', true);
			}, function () {
				return _this3.$store.commit('needShowLoader', true);
			}).catch(function () {
				if (_this3.$store.state.isDebug) window.DEBUG.error('FILE (dfs01): файл не найден');
			});
		},
		cancelUploading: function cancelUploading(item) {
			if (!item) return;

			if (item['xhr']) {
				item['xhr'].abort();

				this.$emit('abortUpload', true);
			}

			if (item['id']) {
				for (var i = 0; i < this.currentValue.length; i++) {
					if (this.currentValue[i] && String(this.currentValue[i]['id']) === String(item['id'])) {
						this.currentValue.splice(i, 1);
						break;
					}
				}
			}
		},
		previewImage: function previewImage(item) {
			var _this4 = this;

			if (!item || !item['image'] || !item['image'].src) return;

			this.modalItemID = item['id'];
			this.modalText = item['title'];

			var image = new Image();
			image.src = item['image'].src;

			image.onload = function () {
				_this4.$refs['imageInDialog'].src = image.src;

				_this4.imageNaturalWidth = image.naturalWidth;
				_this4.imageNaturalHeight = image.naturalHeight;

				_this4.imageWidth = image.naturalWidth;
				_this4.imageHeight = image.naturalHeight;

				var windowWidth = _this4.$store.state.windowWidth;
				var windowHeight = _this4.$store.state.windowHeight;

				var _delta = 40;

				if (windowWidth <= 420) {
					_delta = 20;
				}
				if (windowWidth > 420 && windowWidth <= 767) {
					_delta = 30;
				}
				if (windowWidth > 767 && windowWidth <= 900) {
					_delta = 40;
				} else _delta = 60;

				var maxWidth = windowWidth - _delta;
				var maxHeight = windowHeight - 190;
				if (maxWidth < 100) maxWidth = 100;
				if (maxHeight < 100) maxHeight = 100;

				var _k = 1;
				if (_this4.imageWidth > maxWidth || _this4.imageHeight > maxHeight) {
					if (_this4.imageWidth > _this4.imageHeight) _k = maxWidth / _this4.imageWidth;else _k = maxHeight / _this4.imageHeight;

					_this4.imageWidth = parseInt(_this4.imageWidth * _k);
					_this4.imageHeight = parseInt(_this4.imageHeight * _k);

					if (_this4.imageHeight > maxHeight) {
						_k = maxHeight / _this4.imageHeight;
						_this4.imageWidth = parseInt(_this4.imageWidth * _k);
						_this4.imageHeight = parseInt(_this4.imageHeight * _k);
					}
				}

				_this4.scaleKoeff = _k;

				_this4.modalWidth = _this4.imageWidth + 30;
				if (_this4.modalWidth < 200) _this4.modalWidth = 200;

				if (_this4.modalCrop) {
					_this4.$refs['previewCropSquare'].src = image.src;
					_this4.$refs['previewCropRound'].src = image.src;

					_this4.$square = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this4.$refs['previewCropSquare']);
					_this4.$round = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this4.$refs['previewCropRound']);

					if (typeof window.jcrop_api !== 'undefined') {
						if (window.jcrop_api) window.jcrop_api.destroy();
						window.jcrop_api = null;
					}

					var _side = 100;
					if (_this4.imageNaturalWidth > _this4.imageNaturalHeight) _side = _this4.imageNaturalHeight;else _side = _this4.imageNaturalWidth;

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this4.$refs['imageInDialog']).Jcrop({
						aspectRatio: 1,
						setSelect: [0, 0, _side, _side],
						onChange: _this4.renderCropPreview,
						bgColor: '',
						bgOpacity: 0.3,
						boxWidth: _this4.imageWidth,
						boxHeight: _this4.imageHeight
					}, function () {
						window.jcrop_api = this;
					});
				}

				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
				_this4.showModal = true;
			};
		},
		renderCropPreview: function renderCropPreview(coords) {
			if (coords.w < 40 || coords.h < 40) {
				coords.w = 40;
				coords.h = 40;
				window.jcrop_api.setSelect([coords.x, coords.y, coords.x + coords.w, coords.y + coords.h]);
			}

			this.cropCoords = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
				'naturalWidth': this.imageNaturalWidth,
				'naturalHeight': this.imageNaturalHeight,
				'imageWidth': this.imageWidth,
				'imageHeight': this.imageHeight
			}, coords);

			var rx = 40 / coords.w;
			var ry = 40 / coords.h;

			this.$square.css({
				width: Math.round(rx * this.imageNaturalWidth) + 'px',
				height: Math.round(ry * this.imageNaturalHeight) + 'px',
				marginLeft: '-' + Math.round(rx * coords.x) + 'px',
				marginTop: '-' + Math.round(ry * coords.y) + 'px'
			});

			this.$round.css({
				width: Math.round(rx * this.imageNaturalWidth) + 'px',
				height: Math.round(ry * this.imageNaturalHeight) + 'px',
				marginLeft: '-' + Math.round(rx * coords.x) + 'px',
				marginTop: '-' + Math.round(ry * coords.y) + 'px'
			});
		},
		onSelect: function onSelect(e) {
			this.errors = '';
			var files = e.target.files;
			var len = files['length'];

			if (len <= 0) return;

			var _id = '';
			var _type = '';
			var _isAcceptType = false;
			var _ans = null;

			for (var i = 0; i < len; i++) {
				_isAcceptType = false;

				_ans = this.verifyFileType(files[i]);
				_isAcceptType = _ans['isAccept'];
				_type = _ans['type'];

				if (!_isAcceptType) {
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype';
					continue;
				} else {
					if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.isArray(_type) && _type.length) _type = _type[0];
				}

				if (_type === undefined || _type === null || __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.trim(_type) === '') {
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype';
					continue;
				}

				if (files[i]['size'] > this.maxsize) {
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].FormatBytes(this.maxsize) + ')';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].FormatBytes(this.maxsize) + ')';
					continue;
				}

				if (this.currentValue.length >= this.maxcount) {
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount);else this.errors += '<br><b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount);
					continue;
				}

				_id = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].unixTime(true);

				this.currentValue.push({
					'id': _id,
					'url': files[i]['name'],
					'type': _type,
					'ext': __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].getFileExt(files[i]['name']).toUpperCase().substr(0, 4),
					'title': files[i]['name'],
					'status': '',
					'size': 0,
					'local': files[i]
				});

				this.loadFile(_id);

				if (this.crud !== 'options' || this.multiple) this.uploadFile(_id);
			}
			this.$refs['fileUploaderInput'].value = '';
		},
		verifyFileType: function verifyFileType(File) {
			var _ans = {
				'isAccept': false,
				'type': null
			};

			var _type = this.getTypeByName(File['name'], true);

			for (var x = 0; x < _type.length; x++) {
				var _v = _type[x];

				if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.isArray(this.accept)) {
					if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.inArray(_v, this.accept) >= 0) {
						_ans['isAccept'] = true;
						_ans['type'] = _v;
						return _ans;
					}
				} else if (typeof this.accept === 'string') {
						if (_v.match(this.accept)) {
							_ans['isAccept'] = true;
							_ans['type'] = _v;
							return _ans;
						}
					}
			}

			if (File['type'] !== '') {
				_type = File['type'];

				if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.isArray(this.accept)) {
					if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.inArray(_type, this.accept) >= 0) {
						_ans['isAccept'] = true;
						_ans['type'] = _type;
						return _ans;
					}
				} else if (typeof this.accept === 'string') {
					if (_type.match(this.accept)) {
						_ans['isAccept'] = true;
						_ans['type'] = _type;
						return _ans;
					}
				}
			}

			return _ans;
		},
		getTypeByName: function getTypeByName(value, all) {
			var _ext = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].getFileExt(value).toLowerCase();

			var _arr = [];
			_arr.push(_ext);

			var _type = this.getMimes(_arr);

			if (!all) {
				if (_type.length) _type = _type[0];else _type = 'unknown';
			}

			return _type;
		},
		getMimes: function getMimes(extensions) {
			var _mimeTypes = {
				'csv': ['text/x-comma-separated-values', 'text/comma-separated-values', 'application/octet-stream', 'text/csv', 'application/csv'],
				'bin': 'application/octet-stream',
				'psd': 'application/x-photoshop',
				'oda': 'application/oda',
				'pdf': ['application/pdf', 'application/x-download'],
				'ai': 'application/postscript',
				'eps': 'application/postscript',
				'ps': 'application/postscript',
				'xls': ['application/excel', 'application/vnd.ms-excel', 'application/msexcel'],
				'ppt': ['application/powerpoint', 'application/vnd.ms-powerpoint'],
				'wbxml': 'application/wbxml',
				'wmlc': 'application/wmlc',
				'gtar': 'application/x-gtar',
				'gz': 'application/x-gzip',
				'swf': 'application/x-shockwave-flash',
				'tar': 'application/x-tar',
				'tgz': 'application/x-tar',
				'xhtml': 'application/xhtml+xml',
				'xht': 'application/xhtml+xml',
				'zip': ['application/x-zip', 'application/zip', 'application/x-zip-compressed'],
				'mid': 'audio/midi',
				'midi': 'audio/midi',
				'mpga': 'audio/mpeg',
				'mp2': 'audio/mpeg',
				'mp3': ['audio/mpeg', 'audio/mpg'],
				'aif': 'audio/x-aiff',
				'aiff': 'audio/x-aiff',
				'aifc': 'audio/x-aiff',
				'ram': 'audio/x-pn-realaudio',
				'rm': 'audio/x-pn-realaudio',
				'rpm': 'audio/x-pn-realaudio-plugin',
				'ra': 'audio/x-realaudio',
				'rv': 'video/vnd.rn-realvideo',
				'wav': 'audio/x-wav',
				'bmp': 'image/bmp',
				'gif': 'image/gif',
				'jpeg': ['image/jpeg', 'image/pjpeg'],
				'jpg': ['image/jpeg', 'image/pjpeg'],
				'jpe': ['image/jpeg', 'image/pjpeg'],
				'png': ['image/png', 'image/x-png'],
				'tiff': 'image/tiff',
				'tif': 'image/tiff',
				'css': 'text/css',
				'html': 'text/html',
				'htm': 'text/html',
				'shtml': 'text/html',
				'txt': 'text/plain',
				'text': 'text/plain',
				'log': ['text/plain', 'text/x-log'],
				'rtx': 'text/richtext',
				'rtf': 'text/rtf',
				'xml': 'text/xml',
				'xsl': 'text/xml',
				'mpeg': 'video/mpeg',
				'mpg': 'video/mpeg',
				'mpe': 'video/mpeg',
				'qt': 'video/quicktime',
				'mov': 'video/quicktime',
				'avi': 'video/x-msvideo',
				'movie': 'video/x-sgi-movie',
				'doc': 'application/msword',
				'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'word': ['application/msword', 'application/octet-stream'],
				'xl': 'application/excel',
				'eml': 'message/rfc822',
				'iso': ['application/x-iso9660-image', 'application/x-iso-image'],
				'sig': 'application/octet-stream'
			};

			var mimes = [];
			for (var i in extensions) {
				var ext = extensions[i];

				if (ext in _mimeTypes) {
					var mime = _mimeTypes[ext];

					if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.isArray(mime)) __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.merge(mimes, mime);else mimes.push(mime);
				}
			}

			return mimes;
		},
		pasteFromClipboard: function pasteFromClipboard(e) {
			if (!e || !e.clipboardData || !e.clipboardData.items) {
				return;
			}

			var items = e.clipboardData.items;
			var files = [];
			for (var i = 0; i < items.length; i++) {
				if (items[i].type.indexOf('image') !== 0) continue;

				var blob = items[i].getAsFile();

				files.push(blob);
			}

			this.onSelect({
				target: {
					files: files
				}
			});
		},
		keyDownHandler: function keyDownHandler(e) {
			if (this.showModal && e.keyCode === 27) {
				this.closeDialog();
			}
		},
		closeDialog: function closeDialog(event, endCrop, onMask) {
			if (this.modalCrop) {
				if (onMask) return;

				if (!endCrop) {
					for (var i in this.currentValue) {
						this.deleteItem(this.currentValue[i]);
					}
				}
			}

			var canCloseMask = true;
			if (this.crud === 'twofa' && this.name === 'image') canCloseMask = false;

			if (canCloseMask) __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showModal = false;
			if (canCloseMask) this.hideModalMask();
		},
		finishCrop: function finishCrop(e) {
			this.modalCrop = false;

			if (typeof window.jcrop_api !== 'undefined') {
				if (window.jcrop_api) window.jcrop_api.destroy();
				window.jcrop_api = null;
			}

			this.$emit('cropCoords', this.cropCoords);

			this.uploadFile(this.modalItemID);

			this.closeDialog(e, true);
		},
		makeCurValue: function makeCurValue() {
			if (this.multiple) {
				if (this.currentValue && this.currentValue.length) {
					var _value = [];
					this.currentValue.forEach(function (item) {
						if (item['keyfile'] && item['keyfile'] !== '') _value.push(item['keyfile']);else _value.push(item['url']);
					});

					return _value.length > 0 ? _value : null;
				}
			} else {
				if (this.currentValue && this.currentValue[0]) {
					if (this.currentValue[0]['keyfile'] && this.currentValue[0]['keyfile'] !== '') return this.currentValue[0]['keyfile'];else return this.currentValue[0]['url'];
				}
			}

			return null;
		},
		clearErrors: function clearErrors() {
			this.errors = '';
		}
	},

	watch: {
		'value': function value(_value2) {
			if (this.multiple) {
				if (_value2) {} else {
					this.currentValue = [];
				}
			} else {
				if (_value2) {
					if (this.crud === 'options' && _value2.indexOf('/uploads/avatars/default') === 0) {
						this.currentValue = [];
						return;
					}

					if (this.currentValue && Array.isArray(this.currentValue) && this.currentValue[0] && this.currentValue[0]['keyfile'] === _value2) {
						return;
					}

					this.currentValue = [];

					var _id = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].unixTime(true);

					this.currentValue.push({
						'id': _id,
						'url': _value2,
						'ext': __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].getFileExt(_value2).toUpperCase().substr(0, 4),
						'type': this.getTypeByName(_value2),
						'title': 'main/loaded_image',
						'status': '',
						'size': 0,
						'local': false,
						'keyfile': null
					});

					this.loadFile(_id);
				} else {
					this.currentValue = [];
				}
			}
		},

		'$route': function $route(to, from) {
			var _this5 = this;

			this.currentValue.forEach(function (item) {
				_this5.cancelUploading(item);
			});
		}

	}

});

/***/ }),
/* 353 */,
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-file-component",
    attrs: {
      "name": _vm.name
    },
    on: {
      "click": _vm.clearErrors
    }
  }, [_vm._l((_vm.currentValue), function(item, indx) {
    return _c('div', {
      key: 'item-' + indx,
      staticClass: "w5-file-uploader-item",
      class: {
        'multiple-item': _vm.multiple
      }
    }, [_c('div', {
      staticClass: "w5-file-uploader-item-image-wrapper",
      on: {
        "click": function($event) {
          return _vm.previewImage(item)
        }
      }
    }, [(item.type && String(item.type).substr(0, 5).toLowerCase() === 'image') ? [(item.image.src) ? _c('img', {
      style: ('width:' + item.imgWidth + 'px;height:' + item.imgHeight + 'px;'),
      attrs: {
        "src": item.image.src
      }
    }) : _c('font-awesome-icon', {
      attrs: {
        "icon": "image"
      }
    })] : [_c('div', {
      staticClass: "attach-no-image-preview-file-uploader"
    }, [_vm._v(_vm._s(item.ext))])]], 2), _vm._v(" "), _c('div', {
      staticClass: "w5-file-uploader-item-title"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "w5-file-uploader-item-size"
    }, [(item.status === 'done' && item.size) ? _c('span', [_vm._v(_vm._s(_vm._f("bytes")(item.size)))]) : _vm._e(), _vm._v(" "), (item.status === 'loading' || item.status === 'uploading') ? _c('span', {
      staticClass: "font-size-85"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/loading-hor16.gif"
      }
    }), _c('br'), _vm._v(_vm._s(item.progress ? item.progress : ''))]) : _vm._e()]), _vm._v(" "), (_vm.crud !== 'twofa') ? _c('div', {
      staticClass: "w5-file-uploader-item-buttons"
    }, [(item.status === 'done') ? _c('font-awesome-icon', {
      attrs: {
        "title": _vm._f("ftc")('main/delete'),
        "icon": "trash-alt"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.status === 'loading' || item.status === 'uploading') ? _c('font-awesome-icon', {
      attrs: {
        "title": _vm._f("ftc")('main/cancel'),
        "icon": "times-circle"
      },
      on: {
        "click": function($event) {
          return _vm.cancelUploading(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.status === 'crop') ? _c('font-awesome-icon', {
      staticClass: "miganie-animation",
      attrs: {
        "title": "Обрезка",
        "icon": "cut"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.keyfile) ? _c('input', {
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": item.keyfile
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibility),
      expression: "buttonVisibility"
    }],
    staticClass: "w5-file-add-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "paperclip"
    }
  }), _c('div', {
    staticClass: "w5-file-add-button-caption"
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), (_vm.multiple) ? _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader[]",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onSelect
    }
  }) : _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader"
    },
    on: {
      "change": _vm.onSelect
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors !== ''),
      expression: "errors !== ''"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errors)),
      expression: "localeFtc(errors)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.closeDialog($event, false, true)
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "imageInDialog",
    style: ('width:' + _vm.imageWidth + 'px; height:' + _vm.imageHeight + 'px;')
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalCrop),
      expression: "modalCrop"
    }],
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px 5px 7px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "w5-image-preview-crop-wrapper"
  }, [_c('img', {
    ref: "previewCropSquare",
    staticClass: "w5-image-preview-crop"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w5-image-preview-crop-wrapper round"
  }, [_c('img', {
    ref: "previewCropRound",
    staticClass: "w5-image-preview-crop"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submut-small",
    on: {
      "click": _vm.finishCrop
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('notes/file_type')))])])])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'directFileComponent',

	props: ['name', 'title', 'value', 'accept', 'maxsize', 'maxcnt', 'formFields'],

	computed: {
		buttonTitle: function buttonTitle() {
			var _title = this.localeFtc(this.title).toLowerCase();
			return this.formater_capitalizeFirstChar(_title);
		},
		buttonVisibility: function buttonVisibility() {
			if (this.currentValue) return false;else return true;
		}
	},

	data: function data() {
		return {
			currentValue: null,

			errors: ''
		};
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-iso-form-upload', this.startUpload);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-iso-form-upload', this.startUpload);
	},

	methods: {
		onSelect: function onSelect(e) {
			this.errors = '';
			var files = e.target.files;
			var len = files['length'];

			if (len <= 0) return;

			var _id = '';
			var _type = '';
			var _isAcceptType = false;
			var _ans = null;
			var i = 0;

			_isAcceptType = false;

			_ans = this.verifyFileType(files[i]);
			_isAcceptType = _ans['isAccept'];
			_type = _ans['type'];

			if (!_isAcceptType) {
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype';
				return;
			} else {
				if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isArray(_type) && _type.length) _type = _type[0];
			}

			if (_type === undefined || _type === null || __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(_type) === '') {
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype';
				return;
			}

			if (files[i]['size'] > this.maxsize) {
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].FormatBytes(this.maxsize) + ')';else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].FormatBytes(this.maxsize) + ')';
				return;
			}

			if (len >= this.maxcount) {
				if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount);else this.errors += '<br><b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount);
				return;
			}

			_id = __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].unixTime(true);

			this.currentValue = {
				'id': _id,
				'url': files[i]['name'],
				'type': _type,
				'ext': __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].getFileExt(files[i]['name']).toUpperCase().substr(0, 4),
				'title': files[i]['name'],
				'status': 'done',
				'size': files[i] && files[i]['size'] ? files[i]['size'] : 0,
				'local': files[i]
			};

			this.$emit('focus');
			this.$emit('input', _id);
		},
		clearErrors: function clearErrors() {
			this.errors = '';
		},
		deleteItem: function deleteItem() {
			this.errors = '';

			this.currentValue = null;

			this.$emit('input', null);
		},
		startUpload: function startUpload(url) {
			this.errors = '';

			if (!this.currentValue) {
				this.errors = 'main/no_data';
				return;
			}

			var _this = this;

			var _formData = new FormData();
			_formData.append('file', this.currentValue['local']);

			this.currentValue['status'] = 'uploading';
			this.currentValue['progress'] = 0;

			this.currentValue['xhr'] = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
				type: 'POST',
				url: url,
				data: _formData,
				cache: false,
				contentType: false,
				processData: false,

				xhr: function xhr() {
					var xhr = new XMLHttpRequest();

					xhr.upload.addEventListener('progress', function (evt) {
						if (evt.lengthComputable && _this.currentValue) {
							var percentComplete = evt.loaded / (evt.total ? evt.total : 1) * 100.0;
							_this.currentValue['progress'] = percentComplete.toFixed(0) + '%';
							_this.$forceUpdate();
						}
					}, false);
					return xhr;
				},

				beforeSend: function beforeSend(xhr, obj) {
					_this.$store.commit('uploadFileCounter', '+');

					_this.$store.commit('changedForm', _this.$route.path);
				},

				success: function success(data, txt, xhr) {
					if (data && 'status' in data && data['status'] === 'ok') {
						_this.$forceUpdate();

						_this.$emit('uploadFinished');

						return;
					}

					_this.currentValue = null;
					_this.$emit('input', null);
					_this.$emit('uploadError', 'upload/some_error');
				},

				error: function error(data) {
					if (data.statusText === 'abort') return;

					_this.currentValue = null;
					_this.$emit('input', null);
					_this.$emit('uploadError', 'upload/some_error');
				},

				complete: function complete(jqXHR, textStatus) {
					_this.$store.commit('uploadFileCounter', '-');

					if (this.currentValue && this.currentValue['status']) this.currentValue['status'] = 'done';
				}
			});
		},
		cancelUploading: function cancelUploading() {
			if (!this.currentValue || !this.currentValue.xhr) return;

			this.currentValue.xhr.abort();

			this.currentValue = null;
			this.$emit('input', null);

			this.$emit('uploadCanceled');
		},
		verifyFileType: function verifyFileType(File) {
			var _ans = {
				'isAccept': false,
				'type': null
			};

			var _type = this.getTypeByName(File['name'], true);

			for (var x = 0; x < _type.length; x++) {
				var _v = _type[x];

				if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isArray(this.accept)) {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.inArray(_v, this.accept) >= 0) {
						_ans['isAccept'] = true;
						_ans['type'] = _v;
						return _ans;
					}
				} else if (typeof this.accept === 'string') {
						if (_v.match(this.accept)) {
							_ans['isAccept'] = true;
							_ans['type'] = _v;
							return _ans;
						}
					}
			}

			if (File['type'] !== '') {
				_type = File['type'];

				if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isArray(this.accept)) {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.inArray(_type, this.accept) >= 0) {
						_ans['isAccept'] = true;
						_ans['type'] = _type;
						return _ans;
					}
				} else if (typeof this.accept === 'string') {
					if (_type.match(this.accept)) {
						_ans['isAccept'] = true;
						_ans['type'] = _type;
						return _ans;
					}
				}
			}

			return _ans;
		},
		getTypeByName: function getTypeByName(value, all) {
			var _ext = __WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].getFileExt(value).toLowerCase();

			var _arr = [];
			_arr.push(_ext);

			var _type = this.getMimes(_arr);

			if (!all) {
				if (_type.length) _type = _type[0];else _type = 'unknown';
			}

			return _type;
		},
		getMimes: function getMimes(extensions) {
			var _mimeTypes = {
				'csv': ['text/x-comma-separated-values', 'text/comma-separated-values', 'application/octet-stream', 'text/csv', 'application/csv'],
				'bin': 'application/octet-stream',
				'psd': 'application/x-photoshop',
				'oda': 'application/oda',
				'pdf': ['application/pdf', 'application/x-download'],
				'ai': 'application/postscript',
				'eps': 'application/postscript',
				'ps': 'application/postscript',
				'xls': ['application/excel', 'application/vnd.ms-excel', 'application/msexcel'],
				'ppt': ['application/powerpoint', 'application/vnd.ms-powerpoint'],
				'wbxml': 'application/wbxml',
				'wmlc': 'application/wmlc',
				'gtar': 'application/x-gtar',
				'gz': 'application/x-gzip',
				'swf': 'application/x-shockwave-flash',
				'tar': 'application/x-tar',
				'tgz': 'application/x-tar',
				'xhtml': 'application/xhtml+xml',
				'xht': 'application/xhtml+xml',
				'zip': ['application/x-zip', 'application/zip', 'application/x-zip-compressed'],
				'mid': 'audio/midi',
				'midi': 'audio/midi',
				'mpga': 'audio/mpeg',
				'mp2': 'audio/mpeg',
				'mp3': ['audio/mpeg', 'audio/mpg'],
				'aif': 'audio/x-aiff',
				'aiff': 'audio/x-aiff',
				'aifc': 'audio/x-aiff',
				'ram': 'audio/x-pn-realaudio',
				'rm': 'audio/x-pn-realaudio',
				'rpm': 'audio/x-pn-realaudio-plugin',
				'ra': 'audio/x-realaudio',
				'rv': 'video/vnd.rn-realvideo',
				'wav': 'audio/x-wav',
				'bmp': 'image/bmp',
				'gif': 'image/gif',
				'jpeg': ['image/jpeg', 'image/pjpeg'],
				'jpg': ['image/jpeg', 'image/pjpeg'],
				'jpe': ['image/jpeg', 'image/pjpeg'],
				'png': ['image/png', 'image/x-png'],
				'tiff': 'image/tiff',
				'tif': 'image/tiff',
				'css': 'text/css',
				'html': 'text/html',
				'htm': 'text/html',
				'shtml': 'text/html',
				'txt': 'text/plain',
				'text': 'text/plain',
				'log': ['text/plain', 'text/x-log'],
				'rtx': 'text/richtext',
				'rtf': 'text/rtf',
				'xml': 'text/xml',
				'xsl': 'text/xml',
				'mpeg': 'video/mpeg',
				'mpg': 'video/mpeg',
				'mpe': 'video/mpeg',
				'qt': 'video/quicktime',
				'mov': 'video/quicktime',
				'avi': 'video/x-msvideo',
				'movie': 'video/x-sgi-movie',
				'doc': 'application/msword',
				'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'word': ['application/msword', 'application/octet-stream'],
				'xl': 'application/excel',
				'eml': 'message/rfc822',
				'iso': ['application/x-iso9660-image', 'application/x-iso-image'],
				'sig': 'application/octet-stream'
			};

			var mimes = [];
			for (var i in extensions) {
				var ext = extensions[i];

				if (ext in _mimeTypes) {
					var mime = _mimeTypes[ext];

					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isArray(mime)) __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.merge(mimes, mime);else mimes.push(mime);
				}
			}

			return mimes;
		}
	}

});

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-file-component",
    attrs: {
      "name": _vm.name
    },
    on: {
      "click": _vm.clearErrors
    }
  }, [(_vm.currentValue && typeof _vm.currentValue === 'object') ? _c('div', {
    staticClass: "w5-file-uploader-item"
  }, [_c('div', {
    staticClass: "w5-file-uploader-item-image-wrapper"
  }, [_c('div', {
    staticClass: "attach-no-image-preview-file-uploader"
  }, [_vm._v(_vm._s(_vm.currentValue.ext))])]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.currentValue.title)))]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-size"
  }, [((_vm.currentValue.status === '' || _vm.currentValue.status === 'done') && _vm.currentValue.size) ? _c('span', [_vm._v(_vm._s(_vm._f("bytes")(_vm.currentValue.size)))]) : _vm._e(), _vm._v(" "), (_vm.currentValue.status === 'loading' || _vm.currentValue.status === 'uploading') ? _c('span', {
    staticClass: "font-size-85"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading-hor16.gif"
    }
  }), _c('br'), _vm._v(_vm._s(_vm.currentValue.progress ? _vm.currentValue.progress : ''))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-buttons"
  }, [(_vm.currentValue.status === 'done') ? _c('font-awesome-icon', {
    attrs: {
      "title": _vm._f("ftc")('main/delete'),
      "icon": "trash-alt"
    },
    on: {
      "click": _vm.deleteItem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentValue.status === 'loading' || _vm.currentValue.status === 'uploading') ? _c('font-awesome-icon', {
    attrs: {
      "title": _vm._f("ftc")('main/cancel'),
      "icon": "times-circle"
    },
    on: {
      "click": _vm.cancelUploading
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibility),
      expression: "buttonVisibility"
    }],
    staticClass: "w5-file-add-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "paperclip"
    }
  }), _c('div', {
    staticClass: "w5-file-add-button-caption"
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader"
    },
    on: {
      "change": _vm.onSelect
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors !== ''),
      expression: "errors !== ''"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errors)),
      expression: "localeFtc(errors)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autonumeric__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slider_component_theme_default_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_slider_component_theme_default_css__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'planComponent',

	props: ['items', 'value', 'action', 'groups', 'groupValue', 'cookieValue', 'templateField', 'ipInfo'],
	data: function data() {
		return {
			curValue: null,

			curGroup: null,

			curTemplate: null,

			availablePlans: null,

			params: null,

			paramsCached: {},

			sliderTimerHandler: null,

			inputFieldValues: {
				cpu: 0,
				ram: 0,
				disk: 0,
				gpu: 0
			},

			inputFieldErrors: {
				cpu: '',
				ram: '',
				disk: '',
				gpu: ''
			},

			manualSliderChanged: false,

			initValueCounter: 0,

			isSlidersWasRecounted: false,

			currentMultiConstructorValue: {}
		};
	},

	computed: {
		Groups: function Groups() {
			var _this2 = this;

			if (!this.groups || !this.groups.length) return null;

			return this.groups.filter(function (g) {
				if (g.active === false) {
					if (_this2.$store.state.user_type === 'admin') return true;else return false;
				}

				return true;
			});
		},
		Items: function Items() {
			var _this3 = this;

			if (this.action === 'view') {
				return this.items && this.items.length ? this.items : [];
			}

			if (!this.items || !this.items.length) return [];
			return this.items.filter(function (item) {
				if (item.plan_group === _this3.curGroup) {
					if (!('active' in item)) return true;

					if (_this3.$store.state.user_type === 'admin') {
						if (item.has_params) {
							return item.active === true;
						}

						return true;
					}

					return item.active === true;
				}

				return false;
			});
		},
		groupDescription: function groupDescription() {
			var _this4 = this;

			if (!this.groups || !this.groups.length) return;

			var desc = '';
			this.groups.some(function (group) {
				if (_this4.curGroup === group.id) {
					desc = group.description;
					return true;
				}
			});

			return desc;
		},
		isSeveralConstructors: function isSeveralConstructors() {
			if (!this.Items || !this.Items.length) return false;

			var count = 0;
			for (var i = 0; i < this.Items.length; i++) {
				if (this.Items[i] && this.Items[i].id && this.Items[i].has_params && this.isItemActive(this.Items[i])) {
					count++;
					if (count > 1) return true;
				}
			}

			return false;
		},
		severalConstructorsList: function severalConstructorsList() {
			if (!this.Items || !this.Items.length) return [];

			var answer = [];
			for (var i = 0; i < this.Items.length; i++) {
				if (this.Items[i].has_params) {
					answer.push(this.Items[i]);
				}
			}

			return answer;
		},
		mobileShowUpperTab: function mobileShowUpperTab() {
			if (!this.isSeveralConstructors || !this.severalConstructorsList || !this.severalConstructorsList.length) {
				return '';
			}

			for (var i = 0; i < this.severalConstructorsList.length; i++) {
				if (String(this.severalConstructorsList[i].id) === String(this.curValue)) {
					return this.severalConstructorsList[i].name;
				}
			}

			return '';
		}
	},
	created: function created() {
		var _this5 = this;

		this.onSliderFieldChangeNew = __WEBPACK_IMPORTED_MODULE_5_debounce___default()(this.onSliderFieldChangeNew, 20);

		this.curGroup = this.formater_StrToInt(this.groupValue);

		if (this.action === 'view') {
			if (this.value) this.curValue = String(this.value);else {
				if (this.Items && this.Items.length) {
					this.Items.some(function (item) {
						if (item && item.active && item.enable && item.id) {
							_this5.curValue = String(item.id);

							_this5.$emit('input', _this5.curValue);
							return true;
						}
					});
				}
			}

			if (this.templateField && this.templateField.value && this.templateField.list && this.templateField.list.length) {
				this.templateField.list.some(function (t) {
					if (t && String(t.id) === String(_this5.templateField.value)) {
						_this5.curTemplate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, t);
						_this5.availablePlans = [];

						if (t.plans) {
							if (Array.isArray(t.plans) && t.plans.length) {
								_this5.availablePlans = t.plans.slice();
							} else {
								for (var prop in t.plans) {
									if (t.plans.hasOwnProperty(prop)) {
										_this5.availablePlans.push(t.plans[prop]);
									}
								}
							}
						}
					}
				});
			}

			this.initValue(false);

			if (this.params && this.params[this.curValue]) {
				__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-plan-constructor-changed', false);
			}
		}

		__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$on('w5-new-vds-template-notice-what', this.handleTemplateChanged);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$off('w5-new-vds-template-notice-what', this.handleTemplateChanged);

		if (this.sliderTimerHandler) {
			clearTimeout(this.sliderTimerHandler);
			this.sliderTimerHandler = null;
		}

		__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.slider-input-field').each(function (idx) {
			try {
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keydown');
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keyup');
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('blur');
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).autoNumeric('destroy');
			} catch (e) {}
		});
	},
	mounted: function mounted() {
		if (this.action === 'view') {
			this.setHandles();
		}
	},
	updated: function updated() {
		this.setHandles();
	},

	methods: {
		planAdditionalText: function planAdditionalText(item) {
			if (!item || !item.id || !item.description || item.has_params) return '';
			return item.description + '<br>';
		},
		calculatorFormatingFieldFor: function calculatorFormatingFieldFor(field) {
			var _title = String(field.title).toLowerCase();

			if (_title === 'ram' || _title === 'память') return this.localeFtc(field.for) + ' RAM';else if (_title === 'nvme' || _title === 'хранилище') return this.localeFtc(field.for) + ' NVMe';

			return this.localeFtc(field.for);
		},
		onGroupClick: function onGroupClick(group) {
			if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

			this.$emit('focus');

			this.curGroup = group.id;

			this.$emit('groupChanged', this.curGroup);
		},
		onItemClick: function onItemClick(id, enable, Item) {
			this.$emit('focus');

			if (!enable) return;

			if (Item.enable === false || !this.isPlanSupportedByTemplate(Item.id)) return;

			this.curValue = String(id);

			this.$emit('input', this.curValue);
		},
		initValue: function initValue() {
			var _this6 = this;

			var withSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this.initValueCounter++;

			var _cookieParams = null;
			if (this.action === 'create') {
				var _cookie = __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].getCookie('crtvdsplanparams');

				if (this.initValueCounter > 1) __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].deleteCookie('crtvdsplanparams');

				if (_cookie) {
					try {
						_cookieParams = JSON.parse(_cookie);
					} catch (e) {
						_cookieParams = null;
					}
				}
			}

			if (this.items && this.items.length) {
				this.items.forEach(function (item) {
					if (item.params && item.id) {
						if (!_this6.params) _this6.params = {};

						if (!_this6.params[item.id]) _this6.params[item.id] = {};

						var _loop = function _loop(prop) {
							var name = String(item.params[prop].order);
							if (name.length <= 1) name = '0' + name;

							_this6.params[item.id][name] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item.params[prop]);
							_this6.params[item.id][name].__prop = prop;

							if (item.params[prop].type === 'slider') {
								_this6.params[item.id][name].__realMin = item.params[prop].min;
								_this6.params[item.id][name].__initMin = Math.min(item.params[prop].min, item.data[prop].value);

								if (!_this6.params[item.id][name].value) {
									if (_this6.paramsCached && _this6.paramsCached[item.id] && _this6.paramsCached[item.id][name] && _this6.paramsCached[item.id][name].value) {
										_this6.params[item.id][name].value = _this6.paramsCached[item.id][name].value;
									} else {
											_this6.params[item.id][name].value = item.params[prop].min;
											_this6.params[item.id][name].__initValue = _this6.params[item.id][name].value;
										}
								} else {
									_this6.params[item.id][name].__initValue = _this6.params[item.id][name].value;
								}

								if (_cookieParams && (typeof _cookieParams === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_cookieParams)) === 'object' && prop in _cookieParams) {
									if (_cookieParams[prop] >= item.params[prop].min && _cookieParams[prop] <= item.params[prop].max) {
										_this6.params[item.id][name].value = _cookieParams[prop];
										_this6.params[item.id][name].__initValue = _this6.params[item.id][name].value;
									}
								}

								if (prop === 'cpu' || prop === 'ram' || prop === 'disk') {
									if (item.params[prop].max > 0) {
										var delta = Math.floor(item.params[prop].max / 4);
										_this6.params[item.id][name].marks = function (value) {
											if (value === 0) return _this6.params[item.id][name].__realMin === 0;
											if (value === 1) return _this6.params[item.id][name].__realMin > 0;
											if (value === item.params[prop].max) return true;

											if (value % delta === 0 && value + delta <= item.params[prop].max) return true;

											return false;
										};
									}
								} else {
									if (item.params[prop].max > 0) {
										var _delta = 1;
										_this6.params[item.id][name].marks = function (value) {
											if (value === 0) return _this6.params[item.id][name].__realMin === 0;
											if (value === item.params[prop].max) return true;

											if (value % _delta === 0 && value + _delta <= item.params[prop].max) return true;

											return false;
										};
									}
								}
							} else if (item.params[prop].type === 'boolean') {
								if (!('value' in _this6.params[item.id][name])) {
									if (_this6.paramsCached && _this6.paramsCached[item.id] && _this6.paramsCached[item.id][name] && 'value' in _this6.paramsCached[item.id][name]) _this6.params[item.id][name].value = _this6.paramsCached[item.id][name].value;else _this6.params[item.id][name].value = true;
								} else {
									_this6.params[item.id][name].__initValue = _this6.params[item.id][name].value;
								}
							}
						};

						for (var prop in item.params) {
							_loop(prop);
						}
					}
				});
			}

			var first = null;
			var selected = null;
			var initPlan = null;
			var emitParams = false;

			var needSelected = false;
			if (withSelect) needSelected = true;

			if (this.Items && this.Items.length) {
				this.Items.forEach(function (item) {
					if (!first && item.id && _this6.isItemActive(item) && _this6.isPlanSupportedByTemplate(item.id)) {
						initPlan = item;
						first = String(item.id);
					}

					if (_this6.action === 'view' && String(item.id) === String(_this6.value)) {
						selected = String(item.id);
						emitParams = true;
					}

					if (needSelected) {
						if (item.selected === true && item.id && _this6.isItemActive(item) && _this6.isPlanSupportedByTemplate(item.id)) {
							initPlan = item;
							selected = String(item.id);
						}
					}
				});
			}

			if (!first && !selected) {
				if (this.curTemplate && this.Items && this.Items.length) {
					var construct = null;
					this.Items.some(function (item) {
						if (item && item.has_params && item.params && item.active && item.enable) {
							construct = item;
							return true;
						}
					});

					if (construct && this.curTemplate.plans && this.curTemplate.plans.length && this.curTemplate.plans.indexOf(construct.id) > -1) {
						first = String(construct.id);

						this.restoreConstructMins(construct);

						emitParams = true;
					}
				}
			} else {
				if (initPlan && initPlan.has_params) {
					this.restoreConstructMins(initPlan);
				}
			}

			var choicedByCookie = this.cookieValue ? String(this.cookieValue) : null;
			if (!needSelected) choicedByCookie = null;

			this.curValue = null;

			if (choicedByCookie) this.curValue = choicedByCookie;else if (selected) this.curValue = selected;else this.curValue = first;

			if (this.isSeveralConstructors && this.currentMultiConstructorValue && this.curGroup in this.currentMultiConstructorValue) {
				this.curValue = this.currentMultiConstructorValue[this.curGroup];
			}

			if (this.params && this.curValue && this.params[this.curValue]) {
				for (var _name2 in this.params[this.curValue]) {
					var param = this.params[this.curValue][_name2];
					if (param.type === 'slider' && param.value) {
						this.inputFieldValues[param.__prop] = param.value;
					}
				}
			}

			this.$emit('params', this.params && this.curValue && this.params[this.curValue] ? this.params[this.curValue] : null);
			this.$emit('input', this.curValue);
			this.$emit('startData', this.curValue);
			if (emitParams) this.$nextTick(function () {
				return _this6.handleEvent();
			});
		},
		restoreConstructMins: function restoreConstructMins(construct) {
			var _this7 = this;

			if (construct && this.curTemplate && this.curTemplate.plans && this.curTemplate.plans.length && this.curTemplate.plans.indexOf(construct.id) > -1) {
				if (this.curTemplate && this.curTemplate.limits && this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu && this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram && this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk) {
					var _field = this.findParamsField(construct, 'cpu');
					if (_field) {
						if (_field.min !== this.curTemplate.limits.cpu.min) _field.min = Math.max(_field.min, this.curTemplate.limits.cpu.min);

						if (_field.value < _field.min && this.action !== 'view') {
							_field.value = _field.min;
							this.inputFieldValues['cpu'] = _field.value;
						}
					}

					_field = this.findParamsField(construct, 'ram');
					if (_field) {
						if (_field.min !== this.curTemplate.limits.ram.min) _field.min = Math.max(_field.min, this.curTemplate.limits.ram.min);

						if (_field.value < _field.min && this.action !== 'view') {
							_field.value = _field.min;
							this.inputFieldValues['ram'] = _field.value;
						}
					}

					_field = this.findParamsField(construct, 'gpu');
					if (_field && this.curTemplate.limits.gpu && 'min' in this.curTemplate.limits.gpu) {
						if (_field.min !== this.curTemplate.limits.gpu.min) _field.min = Math.max(_field.min, this.curTemplate.limits.gpu.min);

						if (_field.value < _field.min && this.action !== 'view') {
							_field.value = _field.min;
							this.inputFieldValues['gpu'] = _field.value;
						}
					}

					_field = this.findParamsField(construct, 'disk');
					if (_field) {
						if (_field.min !== this.curTemplate.limits.disk.min) _field.min = Math.max(_field.min, this.curTemplate.limits.disk.min);

						if (_field.value < _field.min && this.action !== 'view') {
							_field.value = _field.min;
							this.inputFieldValues['disk'] = _field.value;
						}
					}
				} else {}

				this.$nextTick(function () {
					return _this7.$forceUpdate();
				});
			}
		},
		handleEvent: function handleEvent() {
			var _this8 = this;

			var found = null;
			if (this.Items && this.Items.length) {
				this.Items.some(function (plan) {
					if (plan && String(plan.id) === String(_this8.curValue)) {
						found = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, plan);
						return true;
					}
				});
			}

			if (found && found.data && found.data.cpu && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(found.data.cpu) === 'object' && found.data.disk && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(found.data.disk) === 'object' && found.data.ram && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(found.data.ram) === 'object' && this.params && this.params[found.id]) {
				for (var numProp in this.params[found.id]) {
					var prop = this.params[found.id][numProp]['__prop'];
					if (found.data[prop]) {
						found.data[prop].value = this.params[found.id][numProp].value;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-new-vds-plan-notice', {
				id: this.curValue,
				plan: found
			});
		},
		handleTemplateChanged: function handleTemplateChanged(template) {
			var _this9 = this;

			if (this.action === 'view') return;

			this.curTemplate = null;

			this.availablePlans = null;

			if (template) {
				this.curTemplate = template;

				if (template.plans) {
					if (Array.isArray(template.plans) && template.plans.length) {
						this.availablePlans = template.plans.slice();
					} else {
						this.availablePlans = [];

						for (var prop in template.plans) {
							if (template.plans.hasOwnProperty(prop)) {
								this.availablePlans.push(template.plans[prop]);
							}
						}
					}
				} else if (template.__type === 'iso') {
						this.availablePlans = this.Items.map(function (i) {
							return parseInt(i.id, 10);
						});
						this.curTemplate.plans = this.availablePlans;
					}
			} else {
				this.initValue();
				return;
			}

			if (this.isPlanSupportedByTemplate(this.curValue)) {
				if (this.Items && this.Items.length) {
					var construct = null;
					this.Items.some(function (item) {
						if (item && item.has_params && item.params && item.active && item.enable && String(item.id) === _this9.curValue) {
							construct = item;
							return true;
						}
					});

					if (construct) {
						var cpuMin = 1;
						var ramMin = 1;
						var diskMin = 1;
						var gpuMin = 0;

						if (construct.params && construct.params.cpu && 'min' in construct.params.cpu && construct.params.ram && 'min' in construct.params.ram && construct.params.disk && 'min' in construct.params.disk) {
							cpuMin = construct.params.cpu.min;
							ramMin = construct.params.ram.min;
							diskMin = construct.params.disk.min;
						}

						if (construct.params && construct.params.gpu && 'min' in construct.params.gpu) {
							gpuMin = construct.params.gpu.min;
						}

						if (this.curTemplate && this.curTemplate.limits && this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu && this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram && this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk) {
							cpuMin = Math.max(this.curTemplate.limits.cpu.min, construct.params.cpu.min);
							ramMin = Math.max(this.curTemplate.limits.ram.min, construct.params.ram.min);
							diskMin = Math.max(this.curTemplate.limits.disk.min, construct.params.disk.min);
						}

						if (this.curTemplate && this.curTemplate.limits && this.curTemplate.limits.gpu && 'min' in this.curTemplate.limits.gpu) {
							gpuMin = Math.max(this.curTemplate.limits.gpu.min, gpuMin);
						}

						var _valueChanged = false;

						var _field = this.findParamsField(construct, 'cpu');
						if (_field) {
							if (_field.min !== cpuMin) _field.min = cpuMin;
							if (_field.value < _field.min) {
								_field.value = _field.min;
								this.inputFieldValues['cpu'] = _field.value;
								_valueChanged = true;
							}
						}

						_field = this.findParamsField(construct, 'ram');
						if (_field) {
							if (_field.min !== ramMin) _field.min = ramMin;
							if (_field.value < _field.min) {
								_field.value = _field.min;
								this.inputFieldValues['ram'] = _field.value;
								_valueChanged = true;
							}
						}

						_field = this.findParamsField(construct, 'gpu');
						if (_field) {
							if (_field.min !== gpuMin) _field.min = gpuMin;
							if (_field.value < _field.min) {
								_field.value = _field.min;
								this.inputFieldValues['gpu'] = _field.value;
								_valueChanged = true;
							}
						}

						_field = this.findParamsField(construct, 'disk');
						if (_field) {
							if (_field.min !== diskMin) _field.min = diskMin;
							if (_field.value < _field.min) {
								_field.value = _field.min;
								this.inputFieldValues['disk'] = _field.value;
								_valueChanged = true;
							}
						}

						if (_valueChanged && this.params && this.params[this.curValue]) {
							this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

							this.handleEvent();

							this.$emit('params', this.params[this.curValue]);
						}

						this.$nextTick(function () {
							return _this9.$forceUpdate();
						});
					}
				}

				return;
			}

			this.initValue(false);
		},
		isItemActive: function isItemActive(item) {
			if ('active' in item) return item.active;
			return true;
		},
		isPlanSupportedByTemplate: function isPlanSupportedByTemplate(planId) {
			var _this10 = this;

			if (!planId) return false;

			if (!this.curTemplate || !this.availablePlans || !this.availablePlans.length) {
				return false;
			}

			var _data = null;
			if (this.Items && this.Items.length) {
				this.Items.some(function (plan) {
					if (plan && plan.data && String(plan.id) === String(planId)) {
						if (plan.has_params && _this10.params[plan.id]) {
							_data = {
								cpu: _this10.params[plan.id]['01'],
								ram: _this10.params[plan.id]['02'],
								disk: _this10.params[plan.id]['03'],
								has_params: true
							};
						} else {
							_data = plan.data;
						}

						_data.id = plan.id;

						return true;
					}
				});
			}

			if (!_data) {
				return false;
			}

			var _isAvailablePlan = false;
			if (this.availablePlans && this.availablePlans.length) {
				this.availablePlans.some(function (k) {
					if (String(k) === String(_data.id)) {
						_isAvailablePlan = true;
						return true;
					}
				});
			}

			if (_isAvailablePlan || this.curTemplate.__type === 'iso') {
				if (this.curTemplate && this.curTemplate.limits && this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu && this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram && this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk) {
					if (!_data.cpu || !_data.disk || !_data.ram) {
						return false;
					}

					if (_data.has_params) {
						return true;
					} else {
							if (_data.cpu.value >= this.curTemplate.limits.cpu.min && _data.disk.value >= this.curTemplate.limits.disk.min && _data.ram.value >= this.curTemplate.limits.ram.min) {
								return true;
							} else {
								return false;
							}
						}
				} else {
						return true;
					}
			}

			return false;
		},
		getDomSlider: function getDomSlider(name) {
			if (!name || !name.length) return null;

			var _slider = null;
			var _name = 'slider-' + name;

			if (this.$refs && this.$refs[_name]) {
				if (Array.isArray(this.$refs[_name]) && this.$refs[_name].length) {
					_slider = this.$refs[_name][0];
				} else {
					_slider = this.$refs[_name];
				}
			}

			return _slider;
		},
		isContructorWasChanged: function isContructorWasChanged() {
			if (!this.params || !this.params[this.curValue]) return false;

			for (var prop in this.params[this.curValue]) {
				var param = this.params[this.curValue][prop];

				if (!('__initValue' in param)) return false;

				if (param.__initValue !== param.value) return true;
			}

			return false;
		},
		sliderDragging: function sliderDragging(planItem, obj, value) {
			var _this11 = this;

			if (!this.curValue) return;

			if (!planItem || !planItem.id || !planItem.enable) return;
			if (!obj || !obj.__prop) return;

			this.inputFieldValues[obj.__prop] = value;

			this.checkSliderValues(planItem, obj);

			if (this.sliderTimerHandler) {
				clearTimeout(this.sliderTimerHandler);
			}

			this.sliderTimerHandler = setTimeout(function () {
				_this11.sliderChangeHandler(planItem, obj, _this11.inputFieldValues[obj.__prop]);

				if (_this11.action === 'view' && !_this11.isSlidersWasRecounted) {
					_this11.isSlidersWasRecounted = true;

					for (var p in _this11.params[planItem.id]) {
						var o = _this11.params[planItem.id][p];
						if (o.__prop !== obj.__prop) {
							_this11.sliderChangeHandler(planItem, o, _this11.inputFieldValues[o.__prop]);
						}
					}
				}
			}, 200);
		},
		sliderChangeHandler: function sliderChangeHandler(planItem, obj, value) {
			if (!this.curValue) return;

			if (!planItem || !planItem.id || !planItem.enable) return;

			this.$emit('focus');

			this.checkSliderValues(planItem, obj);

			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-plan-constructor-changed', this.isContructorWasChanged());

			if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

			this.handleEvent();

			this.curValue = String(planItem.id);

			this.$emit('input', this.curValue);

			this.$emit('params', this.params[planItem.id]);

			this.$forceUpdate();
		},
		checkSliderValues: function checkSliderValues(planItem, obj) {
			if (obj && (obj.__prop === 'cpu' || obj.__prop === 'ram')) {
				var ramValue = 0.0;
				var cpuValue = 0.0;
				var ramForCpu = 0;
				var cpuMin = 1;
				var ramMin = 1;
				var cpuMax = -1;
				var ramMax = -1;

				var _Pow2 = [2, 4, 8, 12, 16, 20, 24, 32, 36, 48, 52, 54, 64, 68, 72, 78, 82, 84, 88, 92, 96, 128, 132, 148, 192, 200, 224, 248, 256, 300, 320, 360, 420, 480, 512, 640, 1024];

				var ramField = this.findParamsField(planItem, 'ram');
				var cpuField = this.findParamsField(planItem, 'cpu');

				if (obj.__prop === 'ram') {
					ramForCpu = parseFloat(obj.ram_for_cpu);
					if (isNaN(ramForCpu)) ramForCpu = 0.0;

					ramValue = parseFloat(obj.value);
					if (isNaN(ramValue)) ramValue = 0.0;

					ramMin = parseFloat(obj.min);
					if (isNaN(ramMin)) ramMin = 1.0;

					ramMax = parseInt(obj.max);
					if (isNaN(ramMax)) ramMax = -1;

					if (cpuField) {
						cpuValue = parseFloat(cpuField.value);
						if (isNaN(cpuValue)) cpuValue = 0.0;

						cpuMin = parseFloat(cpuField.min);
						if (isNaN(cpuMin)) cpuMin = 1.0;

						cpuMax = parseInt(cpuField.max);
						if (isNaN(cpuMax)) cpuMax = -1;
					}
				} else if (obj.__prop === 'cpu') {
					cpuValue = parseFloat(obj.value);
					if (isNaN(cpuValue)) cpuValue = 0.0;

					cpuMin = parseFloat(obj.min);
					if (isNaN(cpuMin)) cpuMin = 1.0;

					cpuMax = parseInt(obj.max);
					if (isNaN(cpuMax)) cpuMax = -1;

					if (ramField) {
						ramForCpu = parseFloat(ramField.ram_for_cpu);
						if (isNaN(ramForCpu)) ramForCpu = 0.0;

						ramValue = parseFloat(ramField.value);
						if (isNaN(ramValue)) ramValue = 0.0;

						ramMin = parseFloat(ramField.min);
						if (isNaN(ramMin)) ramMin = 1.0;

						ramMax = parseInt(ramField.max);
						if (isNaN(ramMax)) ramMax = -1;
					}
				}

				if (cpuValue > 2 && cpuValue > cpuMin && !this.manualSliderChanged) {
					var pow2 = _Pow2.slice();

					if (cpuMax > 0 && pow2.indexOf(cpuMax) < 0) {
						pow2.push(cpuMax);
					}

					for (var l = 1; l < pow2.length; l++) {
						if (pow2[l - 1] < cpuValue && cpuValue < pow2[l]) {
							var _len = pow2[l] - pow2[l - 1];
							var _proc = _len > 20 ? 25 : 35;
							var _reqDelta = Math.ceil(_len * _proc / 100.0);
							var _deltaLow = cpuValue - pow2[l - 1];
							var _deltaHigh = pow2[l] - cpuValue;
							var _newValue = -1;

							if (_deltaLow < _reqDelta) {
								_newValue = pow2[l - 1];
							} else if (_deltaHigh < _reqDelta) {
								_newValue = pow2[l];
							}

							if (_newValue > -1) {
								cpuValue = _newValue;
								if (cpuField) {
									cpuField.value = cpuValue;
									var _slider = this.getDomSlider('cpu');
									if (_slider && _slider.setValue) {
										_slider.setValue(cpuValue);
									}
								}
							}

							break;
						}
					}
				}

				if (ramValue > 2 && ramValue > ramMin && !this.manualSliderChanged) {
					var _pow = _Pow2.slice();

					if (ramMax > 0 && _pow.indexOf(ramMax) < 0) {
						_pow.push(ramMax);
					}

					for (var _l = 1; _l < _pow.length; _l++) {
						if (_pow[_l - 1] < ramValue && ramValue < _pow[_l]) {
							var _len2 = _pow[_l] - _pow[_l - 1];
							var _proc2 = _len2 > 20 ? 20 : 30;
							var _reqDelta2 = Math.ceil(_len2 * _proc2 / 100.0);
							var _deltaLow2 = ramValue - _pow[_l - 1];
							var _deltaHigh2 = _pow[_l] - ramValue;
							var _newValue2 = -1;
							if (_deltaLow2 < _reqDelta2) {
								_newValue2 = _pow[_l - 1];
							} else if (_deltaHigh2 < _reqDelta2) {
								_newValue2 = _pow[_l];
							}

							if (_newValue2 > -1) {
								ramValue = _newValue2;
								if (ramField) {
									ramField.value = ramValue;
									var _slider2 = this.getDomSlider('ram');
									if (_slider2 && _slider2.setValue) {
										_slider2.setValue(ramValue);
									}
								}
							}

							break;
						}
					}
				}

				if (ramValue < ramMin) {
					ramValue = ramMin;
					if (ramField) {
						ramField.value = ramValue;
						var _slider3 = this.getDomSlider('ram');
						if (_slider3 && _slider3.setValue) {
							_slider3.setValue(ramValue);
						}
					}
				}

				if (cpuValue < cpuMin) {
					cpuValue = cpuMin;
					if (cpuField) {
						cpuField.value = cpuValue;
						var _slider4 = this.getDomSlider('cpu');
						if (_slider4 && _slider4.setValue) {
							_slider4.setValue(cpuValue);
						}
					}
				}

				if (obj.__prop === 'cpu') {
					this.inputFieldValues[obj.__prop] = cpuValue;

					var ramMustBe = cpuValue * ramForCpu;

					if (ramValue < ramMustBe) {
						if (ramField) {
							ramField.value = ramMustBe;
							var _slider5 = this.getDomSlider('ram');
							if (_slider5 && _slider5.setValue) {
								_slider5.setValue(ramMustBe);
							}

							this.inputFieldValues['ram'] = ramMustBe;
						}
					}
				} else if (obj.__prop === 'ram') {
						this.inputFieldValues[obj.__prop] = ramValue;

						var cpuMustBe = Math.floor(ramValue / ramForCpu);
						if (isNaN(cpuMustBe) || cpuMustBe <= 0) cpuMustBe = cpuMin;

						if (cpuValue > cpuMustBe) {
							if (cpuField) {
								cpuField.value = cpuMustBe;
								var _slider6 = this.getDomSlider('cpu');
								if (_slider6 && _slider6.setValue) {
									_slider6.setValue(cpuMustBe);
								}

								this.inputFieldValues['cpu'] = cpuMustBe;
							}
						}
					}
			}

			if (obj && obj.__prop !== 'cpu' && obj.__prop !== 'ram') {
				var _Value = 0.0;
				var _Min = 1;
				var _Max = 1;

				_Value = parseFloat(obj.value);
				if (isNaN(_Value)) _Value = 0.0;

				_Min = parseFloat(obj.min);
				if (isNaN(_Min)) _Min = 1.0;

				_Max = parseFloat(obj.max);
				if (isNaN(_Max)) _Max = 1.0;

				this.inputFieldValues[obj.__prop] = _Value;

				var _changeValue = false;

				if (obj.__prop === 'disk' && _Value > _Min) {
					var _val = Math.floor(_Value / 10) * 10;
					if (_val !== _Value) {
						_changeValue = true;
						_Value = _val;
					}
				}

				if (_Value < _Min) {
					_changeValue = true;
					_Value = _Min;
				}

				if (_changeValue) {
					var _Field = this.findParamsField(planItem, obj.__prop);
					if (_Field) {
						_Field.value = _Value;
						var _slider7 = this.getDomSlider(obj.__prop);
						if (_slider7 && _slider7.setValue) {
							_slider7.setValue(_Value);
						}

						this.inputFieldValues[obj.__prop] = _Value;
					}
				}
			}
		},
		booleanChangeHandler: function booleanChangeHandler(planItem, obj) {
			if (!this.curValue) return;

			this.$emit('focus');

			if (!planItem || !planItem.enable) return;

			obj.value = !__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].normalizeBooleanValue(obj.value);

			if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-plan-constructor-changed', this.isContructorWasChanged());

			this.curValue = String(planItem.id);

			this.$emit('input', this.curValue);

			this.$emit('params', this.params[planItem.id]);

			this.$forceUpdate();
		},
		findParamsField: function findParamsField(item, fieldName) {
			if (!fieldName || !this.params || !item || !item.id || !this.params[item.id]) {
				return null;
			}

			for (var prop in this.params[item.id]) {
				var data = this.params[item.id][prop];
				if (data && data.__prop === fieldName) {
					return data;
				}
			}

			return null;
		},
		paramsPlanItogo: function paramsPlanItogo(item) {
			var priceField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cost';
			var withFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			if (!item || !item.params || !item.params.cpu || !item.params.ram || !item.params.disk) {
				return '';
			}

			var planCost = parseFloat(item[priceField]);
			if (isNaN(planCost)) planCost = 0.0;

			var sum = 0.0;

			for (var prop in item.params) {
				var data = item.params[prop];
				if (!data || !data.type) continue;

				var costEd = parseFloat(data[priceField]);
				if (isNaN(costEd)) costEd = 0.0;

				var field = this.findParamsField(item, prop);
				if (field) {
					if (data.type === 'slider') {
						var value = parseFloat(field.value);
						if (isNaN(value)) value = 0.0;

						value = value - field.__initMin;
						if (value < 0) value = 0.0;

						sum += value * costEd;
					} else if (data.type === 'boolean' && __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].normalizeBooleanValue(field.value)) {
						sum += costEd;
					}
				}
			}

			var ipCost = 0;
			if (this.ipInfo && this.ipInfo.ip4) {
				var _costEd = parseFloat(this.ipInfo.ip4[priceField]);
				if (isNaN(_costEd)) _costEd = 0.0;

				var _value2 = parseFloat(this.ipInfo.ip4['count']);
				if (isNaN(_value2)) _value2 = 0.0;

				ipCost += _value2 * _costEd;
			}

			if (this.ipInfo && this.ipInfo.ip6) {
				var _costEd2 = parseFloat(this.ipInfo.ip6[priceField]);
				if (isNaN(_costEd2)) _costEd2 = 0.0;

				var _value3 = parseFloat(this.ipInfo.ip6['count']);
				if (isNaN(_value3)) _value3 = 0.0;

				ipCost += _value3 * _costEd2;
			}

			if (!withFormat) return planCost + sum + ipCost;

			sum = __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].FormatMoney2(planCost + sum + ipCost, 2);
			return __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].String2Money(sum);
		},
		minRangeWidthStyle: function minRangeWidthStyle(obj) {
			var min = 1;
			var minRangeValue = 1;
			if ('min' in obj) {
				minRangeValue = parseFloat(obj.min);
				if (isNaN(minRangeValue)) minRangeValue = 1;
			}

			var max = 1;
			if ('max' in obj) {
				max = parseFloat(obj.max);
				if (isNaN(max) || max === 0) max = 1;
			}

			var total = max - min;
			if (isNaN(total) || total === 0) total = 1;
			var rangeValue = minRangeValue - min;

			return 'width: ' + rangeValue / total * 100.0 + '%';
		},
		onSliderFieldChange: function onSliderFieldChange($input) {
			if (!this.curValue) return;

			var value = $input.autoNumeric('get');
			var itemId = $input.data('itemId');
			var objProp = $input.data('obj');

			if (!value || !value.length) return;

			var _field = this.findParamsField({ id: itemId }, objProp);
			if (_field) {
				var _value = parseInt(value, 10);

				if (isNaN(_value) || _value < _field.min) _value = _field.min;
				if (_value > _field.max) _value = _field.max;

				_field.value = _value;
				this.inputFieldValues[objProp] = _field.value;

				if (objProp === 'cpu' || objProp === 'ram') {
					var ramValue = 0.0;
					var cpuValue = 0.0;
					var ramForCpu = 0;
					var cpuMin = 1;
					var ramMin = 1;

					var ramField = this.findParamsField({ id: itemId }, 'ram');
					var cpuField = this.findParamsField({ id: itemId }, 'cpu');
					var obj = _field;

					if (obj.__prop === 'ram') {
						ramForCpu = parseFloat(obj.ram_for_cpu);
						if (isNaN(ramForCpu)) ramForCpu = 0.0;

						ramValue = parseFloat(obj.value);
						if (isNaN(ramValue)) ramValue = 0.0;

						ramMin = parseFloat(obj.min);
						if (isNaN(ramMin)) ramMin = 1.0;

						if (cpuField) {
							cpuValue = parseFloat(cpuField.value);
							if (isNaN(cpuValue)) cpuValue = 0.0;

							cpuMin = parseFloat(cpuField.min);
							if (isNaN(cpuMin)) cpuMin = 1.0;
						}
					} else if (obj.__prop === 'cpu') {
						cpuValue = parseFloat(obj.value);
						if (isNaN(cpuValue)) cpuValue = 0.0;

						cpuMin = parseFloat(obj.min);
						if (isNaN(cpuMin)) cpuMin = 1.0;

						if (ramField) {
							ramForCpu = parseFloat(ramField.ram_for_cpu);
							if (isNaN(ramForCpu)) ramForCpu = 0.0;

							ramValue = parseFloat(ramField.value);
							if (isNaN(ramValue)) ramValue = 0.0;

							ramMin = parseFloat(ramField.min);
							if (isNaN(ramMin)) ramMin = 1.0;
						}
					}

					if (ramValue < ramMin) {
						ramValue = ramMin;
						if (ramField) {
							ramField.value = ramValue;
							var _slider = this.getDomSlider('ram');
							if (_slider && _slider.setValue) {
								_slider.setValue(ramValue);
							}
						}
					}

					if (cpuValue < cpuMin) {
						cpuValue = cpuMin;
						if (cpuField) {
							cpuField.value = cpuValue;
							var _slider8 = this.getDomSlider('cpu');
							if (_slider8 && _slider8.setValue) {
								_slider8.setValue(cpuValue);
							}
						}
					}

					if (obj.__prop === 'cpu') {
						this.inputFieldValues[obj.__prop] = cpuValue;

						var ramMustBe = cpuValue * ramForCpu;

						if (ramValue < ramMustBe) {
							if (ramField) {
								ramField.value = ramMustBe;
								var _slider9 = this.getDomSlider('ram');
								if (_slider9 && _slider9.setValue) {
									_slider9.setValue(ramMustBe);
								}

								this.inputFieldValues['ram'] = ramMustBe;
							}
						}
					} else if (obj.__prop === 'ram') {
							this.inputFieldValues[obj.__prop] = ramValue;

							var cpuMustBe = Math.floor(ramValue / ramForCpu);
							if (isNaN(cpuMustBe) || cpuMustBe <= 0) cpuMustBe = cpuMin;

							if (cpuValue > cpuMustBe) {
								if (cpuField) {
									cpuField.value = cpuMustBe;
									var _slider10 = this.getDomSlider('cpu');
									if (_slider10 && _slider10.setValue) {
										_slider10.setValue(cpuMustBe);
									}

									this.inputFieldValues['cpu'] = cpuMustBe;
								}
							}
						}
				}

				__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-plan-constructor-changed', this.isContructorWasChanged());

				if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

				this.handleEvent();

				this.$emit('params', this.params[itemId]);

				this.$forceUpdate();
			}
		},
		onSliderFieldChangeNew: function onSliderFieldChangeNew(objProp, itemId) {
			if (!this.curValue) return;

			var value = this.inputFieldValues[objProp];

			var _field = this.findParamsField({ id: itemId }, objProp);

			if (!_field) return;

			if (isNaN(value)) {
				this.inputFieldErrors[objProp] = 'validators/error_int';
				this.inputFieldValues[objProp] = value;
				return;
			}

			if (!value) {
				if (_field.min > 0) {
					return;
				}
			}

			if (value < _field.min || value > _field.max) {
				this.inputFieldErrors[objProp] = 'Min: ' + _field.min + ', Max: ' + _field.max;
				return;
			}

			_field.value = value;

			if (objProp === 'cpu' || objProp === 'ram') {
				var ramValue = 0.0;
				var cpuValue = 0.0;
				var ramForCpu = 0;
				var cpuMin = 1;
				var ramMin = 1;

				var ramField = this.findParamsField({ id: itemId }, 'ram');
				var cpuField = this.findParamsField({ id: itemId }, 'cpu');
				var obj = _field;

				if (obj.__prop === 'ram') {
					ramForCpu = parseFloat(obj.ram_for_cpu);
					if (isNaN(ramForCpu)) ramForCpu = 0.0;

					ramValue = parseFloat(obj.value);
					if (isNaN(ramValue)) ramValue = 0.0;

					ramMin = parseFloat(obj.min);
					if (isNaN(ramMin)) ramMin = 1.0;

					if (cpuField) {
						cpuValue = parseFloat(cpuField.value);
						if (isNaN(cpuValue)) cpuValue = 0.0;

						cpuMin = parseFloat(cpuField.min);
						if (isNaN(cpuMin)) cpuMin = 1.0;
					}
				} else if (obj.__prop === 'cpu') {
					cpuValue = parseFloat(obj.value);
					if (isNaN(cpuValue)) cpuValue = 0.0;

					cpuMin = parseFloat(obj.min);
					if (isNaN(cpuMin)) cpuMin = 1.0;

					if (ramField) {
						ramForCpu = parseFloat(ramField.ram_for_cpu);
						if (isNaN(ramForCpu)) ramForCpu = 0.0;

						ramValue = parseFloat(ramField.value);
						if (isNaN(ramValue)) ramValue = 0.0;

						ramMin = parseFloat(ramField.min);
						if (isNaN(ramMin)) ramMin = 1.0;
					}
				}

				if (obj.__prop === 'cpu') {
					var ramMustBe = cpuValue * ramForCpu;

					if (ramValue < ramMustBe) {
						if (ramField) {
							ramField.value = ramMustBe;
							var _slider = this.getDomSlider('ram');
							if (_slider && _slider.setValue) {
								this.manualSliderChanged = true;
								_slider.setValue(ramMustBe);
							}

							this.inputFieldValues['ram'] = ramMustBe;
						}
					}
				} else if (obj.__prop === 'ram') {
						var cpuMustBe = Math.floor(ramValue / ramForCpu);
						if (isNaN(cpuMustBe) || cpuMustBe <= 0) cpuMustBe = cpuMin;

						if (cpuValue > cpuMustBe) {
							if (cpuField) {
								cpuField.value = cpuMustBe;
								var _slider11 = this.getDomSlider('cpu');
								if (_slider11 && _slider11.setValue) {
									this.manualSliderChanged = true;
									_slider11.setValue(cpuMustBe);
								}

								this.inputFieldValues['cpu'] = cpuMustBe;
							}
						}
					}
			}

			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-plan-constructor-changed', this.isContructorWasChanged());

			if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

			this.handleEvent();

			this.$emit('params', this.params[itemId]);

			this.$forceUpdate();
		},
		onSliderFieldBlur: function onSliderFieldBlur($input) {
			if (!this.curValue) return;

			var value = $input.val();

			if (!value || !value.length) {
				var itemId = $input.data('itemId');
				var objProp = $input.data('obj');
				var _field = this.findParamsField({ id: itemId }, objProp);
				if (_field) {
					this.inputFieldValues[objProp] = _field.value;
					this.inputFieldErrors[objProp] = '';
					$input.autoNumeric('set', _field.value);
				}
			}
		},
		onSliderFieldBlurNew: function onSliderFieldBlurNew(objProp, itemId) {
			var _field = this.findParamsField({ id: itemId }, objProp);
			if (!_field) return;

			if (!this.inputFieldValues[objProp] || this.inputFieldErrors[objProp]) {
				if (Number(this.inputFieldValues[objProp]) === 0 && !this.inputFieldErrors[objProp]) {
					if (_field.min <= 0) {
						return;
					}
				}

				this.inputFieldErrors[objProp] = '';

				var _newValue = _field.value;
				if (this.inputFieldValues[objProp] <= _field.min) _newValue = _field.min;
				if (this.inputFieldValues[objProp] >= _field.max) _newValue = _field.max;

				_field.value = _newValue;

				this.inputFieldValues[objProp] = _field.value;
				var $input = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs['field-' + objProp]);
				if ($input && $input.length && $input.autoNumeric) {
					$input.autoNumeric('set', _field.value);
				}
			}
		},
		onInputFieldChanged: function onInputFieldChanged($input) {
			var value = $input.autoNumeric('get');
			var itemId = $input.data('itemId');
			var objProp = $input.data('obj');

			this.inputFieldErrors[objProp] = '';

			var _value = parseInt(value, 10);
			if (isNaN(_value)) {
				this.inputFieldErrors[objProp] = 'validators/error_int';
				this.inputFieldValues[objProp] = value;
				return;
			}

			this.inputFieldValues[objProp] = _value;

			var _field = this.findParamsField({ id: itemId }, objProp);

			if (!value || !value.length) {
				if (_field && _field.min > 0) {
					return;
				}
			}

			if (_field) {
				if (_value < _field.min || _value > _field.max) {
					this.inputFieldErrors[objProp] = 'Min: ' + _field.min + ', Max: ' + _field.max;
					return;
				}
			}

			this.onSliderFieldChangeNew(objProp, itemId);
		},
		setHandlesOld: function setHandlesOld() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.slider-input-field').each(function (idx) {
				var _this12 = this;

				if (!__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).data('autoNumeric')) {
					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).autoNumeric('init', { aSep: '', mDec: 0 });

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keydown').on('keydown', function (e) {
						var text = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12)[0];
						var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart);
						if (t && t.length) {
							__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12).val('');
						}

						if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12).val().length >= 5) {
							e.preventDefault();
							return false;
						}
					});

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keyup').on('keyup', function (e) {
						var value = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12).autoNumeric('get');
						var itemId = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12).data('itemId');
						var objProp = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12).data('obj');

						if (!value || !value.length) return;

						var _field = _this.findParamsField({ id: itemId }, objProp);
						if (_field) {
							var _value = parseInt(value, 10);

							if (isNaN(_value) || _value < _field.min) _value = _field.min;
							if (_value > _field.max) _value = _field.max;

							_this.inputFieldValues[objProp] = _value;
						}

						_this.onSliderFieldChange(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12));
					});

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('blur').on('blur', function (e) {
						_this.onSliderFieldBlur(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this12));
					});
				}
			});
		},
		setHandles: function setHandles() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.slider-input-field').each(function (idx) {
				var _this13 = this;

				if (!__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).data('autoNumeric')) {
					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).autoNumeric('init', { aSep: '', mDec: 0, vMin: 0, vMax: 9999 });

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keydown').on('keydown', function (e) {
						var text = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this13)[0];
						var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart);
						if (t && t.length) {
							__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this13).val('');
						}
					});

					__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).off('keyup').on('keyup', function () {
						_this.onInputFieldChanged(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this13));
					});
				}
			});
		},
		isDiscountIp: function isDiscountIp() {
			if (!this.ipInfo) return false;

			if (this.ipInfo.ip4) {
				if (isNaN(Number(this.ipInfo.ip4.cost)) || isNaN(Number(this.ipInfo.ip4.full_cost))) return false;

				if (Number(this.ipInfo.ip4.cost).toFixed(6) !== Number(this.ipInfo.ip4.full_cost).toFixed(6)) return true;
			}

			if (this.ipInfo.ip6) {
				if (isNaN(Number(this.ipInfo.ip6.cost)) || isNaN(Number(this.ipInfo.ip6.full_cost))) return false;

				if (Number(this.ipInfo.ip6.cost).toFixed(6) !== Number(this.ipInfo.ip6.full_cost).toFixed(6)) return true;
			}

			return false;
		},
		isDiscountPlan: function isDiscountPlan(item) {
			if (!item) return false;
			if (!('cost' in item) || !('full_cost' in item)) return false;
			if (isNaN(Number(item.cost)) || isNaN(Number(item.full_cost))) return false;

			if (Number(item.cost).toFixed(6) !== Number(item.full_cost).toFixed(6)) return true;

			if (item.has_params && item.params) {
				if (Number(item.params.cpu.cost).toFixed(6) !== Number(item.params.cpu.full_cost).toFixed(6)) return true;
				if (Number(item.params.ram.cost).toFixed(6) !== Number(item.params.ram.full_cost).toFixed(6)) return true;
				if (Number(item.params.disk.cost).toFixed(6) !== Number(item.params.disk.full_cost).toFixed(6)) return true;
				if (item.params.ip4) {
					if (Number(item.params.ip4.cost).toFixed(6) !== Number(item.params.ip4.full_cost).toFixed(6)) return true;
				}
			}

			return false;
		},
		isDiscountParam: function isDiscountParam(item) {
			if (!item) return false;
			if (!('cost' in item) || !('full_cost' in item)) return false;

			if (item.type === 'slider') {
				var value = Number(item.value) - item.__initMin <= 0 ? 0 : Number(item.value) - item.__initMin;

				if (isNaN(value) || value === 0) return false;
			}

			if (item.type === 'boolean') {
				var _value4 = Boolean(item.value) === false ? 0 : 1;

				if (isNaN(_value4) || _value4 === 0) return false;
			}

			if (item.cost !== item.full_cost) return true;

			return false;
		},
		planBaseValues: function planBaseValues(item) {
			if (!item || !item.id || !item.data || !this.params[item.id]) return {};

			var _obj = {};
			for (var prop in item.data) {
				_obj[prop] = {};
				_obj[prop].title = item.data[prop].title;
				_obj[prop].for = item.data[prop].for;
				_obj[prop].value = item.data[prop].value;

				for (var n in this.params[item.id]) {
					var param = this.params[item.id][n];
					if (param.__prop === prop) {
						_obj[prop].title = param.title;
						_obj[prop].for = param.for;
						_obj[prop].value = param.__initMin;
						break;
					}
				}
			}

			return _obj;
		},
		isVisibleParamsItog: function isVisibleParamsItog(obj) {
			if (!obj || !obj.type) return false;
			if (obj.type === 'boolean' && obj.value) return true;
			if (obj.type === 'slider') {
				return Number(obj.value) - obj.__initMin > 0;
			}
			return false;
		},
		isVisibleAnyParamsItog: function isVisibleAnyParamsItog(data) {
			for (var p in data) {
				if (this.isVisibleParamsItog(data[p])) return true;
			}

			return false;
		},
		onSeveralConstructorSelect: function onSeveralConstructorSelect(id, enable, Item, event) {
			event.preventDefault();

			this.$emit('focus');

			if (!enable) return;

			if (Item.enable === false || !this.isPlanSupportedByTemplate(Item.id)) return;

			if (this.params && this.params[this.curValue]) this.paramsCached[this.curValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.params[this.curValue]);

			var oldValue = this.curValue;

			this.copyParamsFromConstructor(String(id), oldValue);

			this.$emit('input', this.curValue);
		},
		copyParamsFromConstructor: function copyParamsFromConstructor(newValue, oldValue) {
			var needUpdateCurValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			if (needUpdateCurValue) this.curValue = String(newValue);

			var curValue = this.curValue;

			if (this.params && this.params[oldValue] && this.params[curValue]) {
				for (var idx in this.params[oldValue]) {
					var param = this.params[oldValue][idx];
					if (!param || !param.__prop) continue;

					var _name3 = param.__prop;

					for (var jdx in this.params[curValue]) {
						var _param = this.params[curValue][jdx];
						if (!_param || !_param.__prop) continue;

						var _name = _param.__prop;

						if (_name3 !== _name) continue;

						if (_param.type === 'slider' && 'min' in _param && 'max' in _param) {
							if (param.value < _param.min) {
								_param.value = _param.min;
							} else if (param.value > _param.max) {
									_param.value = _param.max;
								} else {
										_param.value = param.value;
									}

							this.inputFieldValues[_name] = _param.value;
						} else {
							_param.value = param.value;
						}

						break;
					}
				}
			}
		}
	},

	watch: {
		'items': function items(_items, old) {
			if (!__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].arrayCompare(_items, old)) {
				this.initValue();
			}
		},

		groupValue: function groupValue(value) {
			this.curGroup = this.formater_StrToInt(value);
		},
		value: function value(_value5, old) {
			if (this.isSeveralConstructors && this.curGroup) {
				this.currentMultiConstructorValue[this.curGroup] = this.curValue;
			}

			this.copyParamsFromConstructor(String(_value5), old, false);

			if (this.action === 'view') {
				if (_value5) this.curValue = String(_value5);
			}
		}
	},

	components: {
		VueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default.a
	}

});

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-wrapper",
    class: {
      'in-view': _vm.action === 'view'
    }
  }, [(_vm.action !== 'create') ? _c('div', {
    staticClass: "w5-component-field-title"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.action !== 'create' && _vm.Groups && _vm.Groups.length > 1) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, _vm._l((_vm.Groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "w5-vds-plan-list-item groups",
      class: {
        'selected': group.id == _vm.curGroup, 'not-active-item': group.active === false
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onGroupClick(group)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      staticClass: "local-group",
      attrs: {
        "src": _vm.APIServerUrl + group.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(group.name)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.groupDescription)),
      expression: "localeFtc(groupDescription)"
    }]
  })])]) : [(_vm.action !== 'create') ? _c('div', {
    staticClass: "margin-top-5"
  }) : _vm._e()], _vm._v(" "), (_vm.isSeveralConstructors) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper multi-construct",
    class: _vm.action
  }, _vm._l((_vm.severalConstructorsList), function(el) {
    return _c('span', {
      key: el.id,
      staticClass: "w5-vds-plan-list-filter first",
      class: {
        'active': _vm.curValue == el.id || _vm.currentMultiConstructorValue[_vm.curGroup] == el.id,
          'disabled': !el.enable || !el.active || !_vm.isPlanSupportedByTemplate(el.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onSeveralConstructorSelect(el.id, el.enable && el.active, el, $event)
        }
      }
    }, [_vm._v("\r\n\t\t\t" + _vm._s(_vm._f("ftc")(el.name)) + "\r\n\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, [_vm._l((_vm.Items), function(item) {
    return [(item && item.id && item.params && item.has_params && _vm.params && _vm.params[item.id] && (String(item.id) === String(_vm.curValue) || String(item.id) === String(_vm.currentMultiConstructorValue[_vm.curGroup]))) ? _c('div', {
      staticClass: "construct-plan",
      class: {
        'disabled': item.enable === false || !_vm.isPlanSupportedByTemplate(item.id), 'in-view': _vm.action === 'view', 'multi-construct': _vm.isSeveralConstructors
      }
    }, [_c('div', {
      staticClass: "fields-values"
    }, [_vm._l((_vm.params[item.id]), function(obj, prop) {
      return [_c('div', {
        staticClass: "w5-vds-plan-list-params-item"
      }, [(obj.type === 'slider') ? [_c('div', {
        key: String(obj.__prop) + '_' + String(item.id),
        staticClass: "graph-slider"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.title)))]), _vm._v(" "), _c('div', {
        staticClass: "text-slider"
      }, [_c('div', {
        staticClass: "text-slider-field-wrapper"
      }, [_c('input', {
        ref: 'field-' + obj.__prop,
        refInFor: true,
        staticClass: "slider-input-field",
        attrs: {
          "type": "text",
          "data-item-id": item.id,
          "data-obj": obj.__prop,
          "disabled": item.enable === false || !_vm.isPlanSupportedByTemplate(item.id),
          "id": String(obj.__prop) + '_' + String(item.id),
          "name": String(obj.__prop) + '_' + String(item.id)
        },
        domProps: {
          "value": _vm.inputFieldValues[obj.__prop]
        },
        on: {
          "blur": function($event) {
            return _vm.onSliderFieldBlurNew(obj.__prop, item.id)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "field-postfix-wrapper"
      }, [_c('span', [_vm._v(_vm._s(_vm.calculatorFormatingFieldFor(obj)))])])]), _vm._v(" "), (_vm.inputFieldErrors[obj.__prop]) ? _c('div', {
        staticClass: "text-slider-field-error"
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.inputFieldErrors[obj.__prop])) + "\r\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "slider"
      }, [_c('vue-slider', {
        ref: 'slider-' + obj.__prop,
        refInFor: true,
        attrs: {
          "min": obj.__realMin <= 0 ? 0 : 1,
          "max": obj.max,
          "duration": 0.2,
          "marks": obj.marks,
          "interval": obj.step,
          "tooltip": "none",
          "disabled": item.enable === false || !_vm.isPlanSupportedByTemplate(item.id),
          "labelStyle": {
            fontSize: '9px',
            fontWeight: 300,
            color: '#666',
            top: '2px'
          }
        },
        on: {
          "dragging": function($event) {
            _vm.manualSliderChanged = false
          },
          "change": function (value) { return _vm.sliderDragging(item, obj, value); }
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var innerValue = ref.value;

            return [_c('div', {
              staticClass: "process-minimum",
              style: (_vm.minRangeWidthStyle(obj))
            })]
          }
        }], null, true),
        model: {
          value: (obj.value),
          callback: function($$v) {
            _vm.$set(obj, "value", $$v)
          },
          expression: "obj.value"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "cost"
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / 1 " + _vm._s(_vm._f("ftc")(obj.for)) + "\r\n\t\t\t\t\t\t\t\t\t")])])] : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? [_c('div', {
        key: String(obj.__prop) + '_' + String(item.id),
        staticClass: "checkbox params"
      }, [_c('div', {
        staticClass: "w5-boolean-field-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (obj.value),
          expression: "obj.value"
        }],
        staticClass: "w5-checkbox-field",
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(obj.value) ? _vm._i(obj.value, null) > -1 : (obj.value)
        },
        on: {
          "change": function($event) {
            var $$a = obj.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(obj, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(obj, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(obj, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "w5-boolean-label construct-label",
        on: {
          "click": function($event) {
            return _vm.booleanChangeHandler(item, obj)
          }
        }
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.title)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t"), (obj.hint) ? [_c('span', {
        staticClass: "hidden-xs params-boolean-hint"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.hint)))]), _vm._v(" "), _c('div', {
        staticClass: "visible-xs params-boolean-hint"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.hint)))])] : _vm._e()], 2)])])] : _vm._e()], 2)]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "fields-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "itogo-values"
    }, [_c('div', {
      staticClass: "values"
    }, [(String(item.cost) == String(item.full_cost)) ? _c('div', {
      staticClass: "itog-item base-cost"
    }, [_c('div', {
      staticClass: "itog-item-base-cost"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("ftc")((item.description || item.text))))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cost) + "\r\n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), (_vm.action === 'create' && item && item.data) ? _c('div', {
      staticClass: "w5-vds-plan-list-params-base"
    }, [_c('div', {
      staticClass: "values"
    }, _vm._l((_vm.planBaseValues(item)), function(item, name, idx) {
      return _c('span', {
        key: 'base-values' + idx
      }, [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("ftc")(item.title)) + " " + _vm._s(item.value) + " " + _vm._s(_vm.calculatorFormatingFieldFor(item)))])
    }), 0)]) : _vm._e()]) : _c('div', {
      staticClass: "itog-item base-cost"
    }, [_c('div', {
      staticClass: "itog-item-base-cost"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("ftc")((item.description || item.text))))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(item.full_cost)) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), (_vm.action === 'create' && item && item.data) ? _c('div', {
      staticClass: "w5-vds-plan-list-params-base"
    }, [_c('div', {
      staticClass: "values"
    }, _vm._l((_vm.planBaseValues(item)), function(item, name, idx) {
      return _c('span', {
        key: 'base-values' + idx
      }, [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("ftc")(item.title)) + " " + _vm._s(item.value) + " " + _vm._s(_vm.calculatorFormatingFieldFor(item)))])
    }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.isVisibleAnyParamsItog(_vm.params[item.id])) ? _c('div', {
      staticClass: "itog-item add-cost"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/additionally')) + ":\r\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.params[item.id]), function(obj, prop) {
      return [(_vm.isVisibleParamsItog(obj)) ? _c('div', {
        staticClass: "itog-item"
      }, [_c('div', {
        staticClass: "title"
      }, [(obj.type === 'boolean') ? [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.st_name)) + " " + _vm._s(Number(obj.value)) + " " + _vm._s(_vm._f("ftc")(obj.for ? _vm.calculatorFormatingFieldFor(obj) : 'main/sht')) + "\r\n\t\t\t\t\t\t\t\t\t")] : [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.st_name)) + " " + _vm._s(Number(obj.value) - obj.__initMin) + " " + _vm._s(_vm._f("ftc")(obj.for ? _vm.calculatorFormatingFieldFor(obj) : 'main/sht')) + "\r\n\t\t\t\t\t\t\t\t\t")]], 2), _vm._v(" "), _c('div', {
        staticClass: "value"
      }, [(_vm.isDiscountParam(obj)) ? [(obj.type === 'slider') ? _c('span', {
        staticClass: "sm"
      }, [_c('span', {
        staticClass: "full-cost"
      }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.full_cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.cost)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)))]) : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? _c('span', {
        staticClass: "sm"
      }, [(obj.value) ? [_c('span', {
        staticClass: "full-cost"
      }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(obj.full_cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")] : _c('span')], 2) : _vm._e()] : [(obj.type === 'slider') ? _c('span', {
        staticClass: "sm"
      }, [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)))]) : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? _c('span', {
        staticClass: "sm"
      }, [(obj.value) ? [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")] : _c('span')], 2) : _vm._e()]], 2)]) : _vm._e()]
    }), _vm._v(" "), (_vm.ipInfo) ? [(_vm.isDiscountIp()) ? [(_vm.ipInfo.ip4 && _vm.ipInfo.ip4.title && _vm.ipInfo.ip4.count) ? [_c('div', {
      staticClass: "itog-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.title)) + " " + _vm._s(_vm.ipInfo.ip4.count) + " " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.for)) + "\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [(_vm.ipInfo.ip4.full_cost) ? _c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip4.full_cost)) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip4.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.period)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])] : _vm._e(), _vm._v(" "), (_vm.ipInfo.ip6 && _vm.ipInfo.ip6.title && _vm.ipInfo.ip6.count) ? [_c('div', {
      staticClass: "itog-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.title)) + " " + _vm._s(_vm.ipInfo.ip6.count) + " " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.for)) + "\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [(_vm.ipInfo.ip6.full_cost) ? _c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip6.full_cost)) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip6.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.period)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])] : _vm._e()] : [(_vm.ipInfo.ip4 && _vm.ipInfo.ip4.title && _vm.ipInfo.ip4.count) ? [_c('div', {
      staticClass: "itog-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.title)) + " " + _vm._s(_vm.ipInfo.ip4.count) + " " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.for)) + "\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip4.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip4.period)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])] : _vm._e(), _vm._v(" "), (_vm.ipInfo.ip6 && _vm.ipInfo.ip6.title && _vm.ipInfo.ip6.count) ? [_c('div', {
      staticClass: "itog-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.title)) + " " + _vm._s(_vm.ipInfo.ip6.count) + " " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.for)) + "\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.ipInfo.ip6.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.ipInfo.ip6.period)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])] : _vm._e()]] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "itogo"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(_vm._f("ftc")('chart/total')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [(_vm.isDiscountPlan(item)) ? [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item, 'full_cost'))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item))))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t")] : [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(30.0 * _vm.paramsPlanItogo(item, 'cost', false))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")('main/month')) + "\r\n\t\t\t\t\t\t\t")]], 2)])])]) : (item && item['data'] && !item.has_params) ? [_c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item",
      class: {
        'selected': item.id == _vm.curValue,
          'disabled': item.enable === false || !_vm.isPlanSupportedByTemplate(item.id),
          'w5-vds-plan-not-active': !_vm.isItemActive(item)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onItemClick(item.id, item.enable, item)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc(_vm.planAdditionalText(item))),
        expression: "localeFtc(planAdditionalText(item))"
      }]
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['cpu']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['cpu']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['cpu']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['ram']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['ram']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['ram']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['disk']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['disk']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['disk']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['traff']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['traff']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['traff']['title'])) + "\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [(_vm.isDiscountPlan(item)) ? [_c('strong', [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(item['full_cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['period_name'])) + "\r\n\t\t\t\t\t\t")] : [_c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['period_name'])) + "\r\n\t\t\t\t\t\t")]], 2)])] : _vm._e()]
  })], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'groupPlanComponent',

	props: ['action', 'groups', 'value'],
	data: function data() {
		return {
			curGroup: null
		};
	},

	computed: {
		Groups: function Groups() {
			var _this = this;

			if (!this.groups || !this.groups.length) return null;

			return this.groups.filter(function (g) {
				if (g.active === false) {
					if (_this.$store.state.user_type === 'admin') return true;else return false;
				}

				return true;
			});
		},
		groupDescription: function groupDescription() {
			var _this2 = this;

			if (!this.groups || !this.groups.length) return;

			var desc = '';
			this.groups.some(function (group) {
				if (_this2.curGroup === group.id) {
					desc = group.description;
					return true;
				}
			});

			return desc;
		}
	},
	created: function created() {
		this.curGroup = this.formater_StrToInt(this.value);
	},

	methods: {
		onGroupClick: function onGroupClick(group) {
			this.$emit('focus');

			this.curGroup = group.id;

			this.$emit('groupChanged', this.curGroup);
		}
	},

	watch: {
		value: function value(_value) {
			this.curGroup = this.formater_StrToInt(_value);
		}
	}

});

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Groups && _vm.Groups.length > 1) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, _vm._l((_vm.Groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "w5-vds-plan-list-item groups",
      class: {
        'selected': group.id == _vm.curGroup, 'not-active-item': group.active === false
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onGroupClick(group)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      staticClass: "local-group",
      attrs: {
        "src": _vm.APIServerUrl + group.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(group.name)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.groupDescription)),
      expression: "localeFtc(groupDescription)"
    }]
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'planSslComponent',

	props: ['items', 'value', 'title', 'required', 'groups', 'groupValue', 'cookieValue'],
	data: function data() {
		return {
			curValue: null,

			mainList: {}
		};
	},
	created: function created() {
		this.curGroup = this.groupValue;
	},

	methods: {
		groupDescription: function groupDescription() {
			var _this = this;

			var desc = '';
			if (this.groups && this.groups.length) {
				this.groups.some(function (group) {
					if (String(_this.curGroup) === String(group.id)) {
						desc = group.description;
						return true;
					}
				});
			}

			return desc;
		},
		onGroupClick: function onGroupClick(id) {
			this.$emit('focus');

			this.curGroup = String(id);

			this.$emit('groupChanged', this.curGroup);
		},
		onItemClick: function onItemClick(item, event) {
			this.$emit('focus');

			if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) !== 'object' || !('price' in item)) return;

			for (var p in item.price) {
				if (item.price[p].enable === true) {
					this.curValue = String(item.price[p].id);

					this.$emit('input', this.curValue);

					return;
				}
			}
		},
		onPriceClick: function onPriceClick(id, enable) {
			this.$emit('focus');

			if (!enable) return;

			this.curValue = String(id);

			this.$emit('input', this.curValue);
		},
		isItemSelected: function isItemSelected(id) {
			if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.mainList).length) return false;
			for (var p in this.mainList[id]['price']) {
				if (String(this.mainList[id]['price'][p]['id']) === String(this.curValue)) return true;
			}

			return false;
		},
		initValue: function initValue() {
			var _this2 = this;

			if (this.items && this.items.length) {
				this.items.forEach(function (item) {
					if (!(item.name in _this2.mainList)) _this2.mainList[item.name] = {
						'description': item.description,
						'data': item.data,
						'price': {}
					};

					var _price = String(item.cost) + '_' + item.period_name.replace(/\s/g, '_');
					_this2.mainList[item.name]['price'][_price] = {
						'id': item.id,
						'enable': item.enable,
						'min_money': item.min_money,
						'can_bonus': item.can_bonus,
						'cost': item.cost,
						'period_name': item.period_name
					};
				});

				if (this.value !== undefined && this.value !== null) {
					this.curValue = this.value;
					this.$emit('input', this.curValue);
				}

				if (this.cookieValue !== undefined && this.cookieValue !== null) {
					this.curValue = String(this.cookieValue);
					this.$emit('input', this.curValue);
				}
			} else {
				this.curValue = null;
				this.$emit('input', this.curValue);
			}
		}
	},

	watch: {
		'value': function value(_value) {
			this.curValue = String(_value);
		},

		'items': function items(_items, old) {
			if (!__WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].arrayCompare(_items, old)) this.initValue();
		}
	}

});

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.groups && _vm.groups.length > 1) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_vm._l((_vm.groups), function(group, gIdx) {
    return _c('span', {
      key: 'group-' + gIdx,
      staticClass: "w5-vds-plan-list-filter",
      class: {
        'first': gIdx === 0, 'last': gIdx === (_vm.groups.length - 1), 'active': String(_vm.curGroup) === String(group.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onGroupClick(group.id)
        }
      }
    }, [_vm._v(_vm._s(group.name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.groupDescription()))])], 2) : _c('div', {
    staticClass: "margin-top-5"
  }), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('div', {
    staticClass: "w5-ssl-plan-list-block"
  }, _vm._l((_vm.mainList), function(item, prop, idx) {
    return _c('div', {
      key: 'item-' + idx,
      staticClass: "w5-ssl-plan-list-item",
      class: {
        'selected': _vm.isItemSelected(prop), 'first': idx === 0
      },
      on: {
        "click": function($event) {
          return _vm.onItemClick(item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "w5-ssl-plan-list-item-cell middle"
    }, [_c('strong', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('br', {
      staticClass: "visible-xs"
    }), _vm._v(" "), _c('span', {
      staticClass: "ssl-prop-wrapper"
    }, [_vm._v("\r\n\t\t\t\t\t\t  \r\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "ssl-prop",
      class: !item['data'] || !item['data']['EV'] ? 'disabled' : false
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "lock"
      }
    }), _vm._v(" EV")], 1), _vm._v("\r\n\t\t\t\t\t\t  \r\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "ssl-prop",
      class: !item['data'] || !item['data']['Wildcard'] ? 'disabled' : false
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "globe-americas"
      }
    }), _vm._v(" Wildcard")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item['description']))]), _vm._v(" "), _c('div', {
      staticClass: "w5-ssl-plan-list-item-cell bottom visible-xs"
    }, _vm._l((item.price), function(price, prp, pix) {
      return _c('div', {
        key: 'price-visible-xs-' + pix,
        staticClass: "price-wrapper",
        class: {
          'first': pix === 0, 'selected': price.id == _vm.curValue, 'disabled': !price.enable
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onPriceClick(price.id, price.enable)
          }
        }
      }, [_c('div', {
        staticClass: "choice",
        class: {
          'selected': price.id == _vm.curValue
        }
      }, [_c('span')]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(price['cost'])) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })]), _vm._v(" / " + _vm._s(price['period_name']) + "\r\n\t\t\t\t\t\t")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "w5-ssl-plan-list-item-cell right hidden-xs"
    }, _vm._l((item.price), function(price, prp, pix) {
      return _c('div', {
        key: 'price-hidden-xs-' + pix,
        staticClass: "price-wrapper",
        class: {
          'first': pix === 0, 'selected': price.id == _vm.curValue, 'disabled': !price.enable
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onPriceClick(price.id, price.enable)
          }
        }
      }, [_c('div', {
        staticClass: "choice",
        class: {
          'selected': price.id == _vm.curValue
        }
      }, [_c('span')]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(price['cost'])) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })]), _vm._v(" / " + _vm._s(price['period_name']) + "\r\n\t\t\t\t\t")])
    }), 0)])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  "data-v-d993f8e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'planDomainComponent',

	props: ['Field', 'items', 'nameField', 'actionField', 'value'],

	computed: {
		fieldError: function fieldError() {
			var _answer = '';

			if (this.nameField['_errMsg']) _answer = this.nameField['_errMsg'];

			if (this.Field['_errMsg']) _answer += (_answer ? ' <br/>' : '') + this.Field['_errMsg'];

			return _answer;
		}
	},

	data: function data() {
		return {
			nameValue: null,

			planValue: null,

			actionValue: null,

			fieldFocused: false
		};
	},
	created: function created() {
		this.Init();
	},
	mounted: function mounted() {
		this.parseDomainNameValueDebounce = __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.parseDomainNameValueDebounce, 700);
	},

	methods: {
		Init: function Init() {
			var _this = this;

			this.nameValue = this.nameField.value;
			this.actionValue = this.actionField.value;
			this.planValue = null;

			var _firstItem = null;

			if (this.items && this.items.length) this.items.some(function (item) {
					if (!_firstItem) _firstItem = item;

					if (_this.value === String(item.id)) {
						_this.planValue = item;
						return true;
					}
				});

			if (_firstItem && !this.planValue) this.planValue = _firstItem;

			if (this.planValue && this.planValue.id) this.$emit('startData', String(this.planValue.id));

			this.$emit('input', this.planValue && this.planValue.id ? this.planValue.id : null);
		},
		onNameChange: function onNameChange() {
			this.nameValue = this.nameValue.toLowerCase();

			this.$emit('onDomainName', this.nameValue);

			this.parseDomainNameValueDebounce(this.nameValue);
		},
		onNameFocus: function onNameFocus() {
			this.fieldFocused = true;

			this.$emit('focus');
		},
		onNameBlur: function onNameBlur() {
			this.fieldFocused = false;

			this.$emit('blur', 'name');
		},
		parseDomainNameValue: function parseDomainNameValue(value) {
			if (!value) return;

			if (!__WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].validateHostnameForFQDN(value)) return;

			var parts = value.split('.');
			if (parts.length <= 1) return;

			var zone = parts.pop();
			zone = String(zone).trim().toLowerCase();
			var domain = parts.join('.');

			if (zone && zone.length > 1 && domain) {
				this.nameValue = domain.trim().toLowerCase();
				this.$emit('onDomainName', this.nameValue);

				var _item = null;

				if (this.items && this.items.length) this.items.some(function (item) {
						if (!_item) _item = item;

						if (zone === String(item.name).toLowerCase()) {
							_item = item;
							return true;
						}
					});

				if (_item) {
					this.planValue = _item;
					this.$emit('input', this.planValue && this.planValue.id ? this.planValue.id : null);
				}
			}
		},
		parseDomainNameValueDebounce: function parseDomainNameValueDebounce(value) {
			this.parseDomainNameValue(value);
		},
		onNamePaste: function onNamePaste(e) {
			var content = null;

			if (e.clipboardData) {
				content = e.clipboardData.getData('text/plain');
			} else if (window.clipboardData) {
				content = window.clipboardData.getData('Text');
			}

			this.parseDomainNameValue(content);
		},
		enterKeyDown: function enterKeyDown() {
			this.$emit('keydownEnter');
		},
		onListOpen: function onListOpen() {
			this.onNameFocus();
		},
		onListClose: function onListClose() {
			this.onNameBlur();

			this.$emit('blur', 'plan_id');
		},
		onPlanSelect: function onPlanSelect(item) {
			this.$emit('input', String(item.id));
		}
	},

	watch: {
		'items': function items(_items, old) {
			if (!__WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].arrayCompare(_items, old)) this.Init();
		},

		'actionField.value': function actionFieldValue(value, oldValue) {
			if (value !== oldValue) this.Init();
		}
	},

	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
	}

});

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper",
    class: {
      'active': _vm.fieldFocused,
      'haserror': _vm.fieldError
    }
  }, [_c('div', {
    staticClass: "domains-name-field-wrapper"
  }, [_c('div', {
    staticClass: "w5-field-placeholder",
    class: {
      'active': _vm.fieldFocused || _vm.nameValue,
        'readonly': _vm.Field.readonly === true || _vm.nameField.readonly === true
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.nameField.title))), (_vm.nameField.required === true) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameValue),
      expression: "nameValue"
    }],
    ref: _vm.nameField._field_name,
    staticClass: "name-field",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": _vm.nameField._field_name,
      "disabled": _vm.nameField.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.nameValue)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
        return _vm.onNamePaste($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.nameValue = $event.target.value
      }, _vm.onNameChange],
      "focus": _vm.onNameFocus,
      "blur": _vm.onNameBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.nameValue
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "domains-plan-field-wrapper"
  }, [_c('multiselect', {
    staticClass: "domains-plan-field",
    attrs: {
      "placeholder": "",
      "label": "fullName",
      "options": _vm.items && typeof _vm.items === 'object' && Array.isArray(_vm.items) ? _vm.items : [],
      "showLabels": false,
      "allowEmpty": false,
      "searchable": false,
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "input": _vm.onPlanSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return _c('span', {
          staticClass: "domains-plan-option"
        }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(slotProps.option.name)))]), _vm._v(" "), (_vm.actionValue === 'register') ? _c('span', [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.cost)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        }), _vm._v(" / " + _vm._s(_vm._f("ftc")(slotProps.option.period_name)) + "\r\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slotProps.option.data && _vm.actionValue === 'transfer') ? _c('span', [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.data.Transfer)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        })]) : _vm._e()])
      }
    }, {
      key: "singleLabel",
      fn: function(slotProps) {
        return _c('div', {
          staticClass: "domains-plan-label"
        }, [(slotProps.option && slotProps.option.name) ? [_c('div', {
          staticClass: "name"
        }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(slotProps.option.name)))])]), _vm._v(" "), _c('div', {
          staticClass: "info"
        }, [(slotProps.option.cost > 0 && _vm.actionValue === 'register') ? _c('div', [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.cost)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        }), _vm._v(" / " + _vm._s(_vm._f("ftc")(slotProps.option.period_name)) + "\r\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slotProps.option.data && slotProps.option.data.Transfer > 0 && _vm.actionValue === 'transfer') ? _c('div', [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.data.Transfer)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        })]) : _vm._e()])] : _vm._e()], 2)
      }
    }]),
    model: {
      value: (_vm.planValue),
      callback: function($$v) {
        _vm.planValue = $$v
      },
      expression: "planValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper for-error"
  }, [(_vm.fieldError) ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldError)),
      expression: "localeFtc(fieldError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  "data-v-3c0e45f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_backup__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_backup__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'templateComponent',

	props: ['Field', 'crud', 'action', 'value', 'oldValue', 'backupField', 'accountField'],
	data: function data() {
		return {
			activeFilter: '',

			Groups: {
				'without-panel': {},
				'with-panel': {}
			},

			curValue: null,

			oldValues: {
				'without-panel': null,
				'with-panel': null
			},

			curBackup: null,

			fieldFocused: false,

			curPlan: null
		};
	},

	computed: {
		List: function List() {
			if (!this.activeFilter) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.Groups['without-panel']).length ? this.Groups['without-panel'] : this.Groups['with-panel'];
			} else if (this.activeFilter === 'without-panel') {
				return this.Groups['without-panel'];
			} else if (this.activeFilter === 'with-panel') {
				return this.Groups['with-panel'];
			}
		},
		isNeedShowFilter: function isNeedShowFilter() {
			var k1 = this.Groups['without-panel'] ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.Groups['without-panel']).length : 0;
			var k2 = this.Groups['with-panel'] ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.Groups['with-panel']).length : 0;

			if (k1 > 0 && k2 > 0) return true;

			if (this.backupField && this.backupField.list && this.backupField.list.length) return true;

			return false;
		}
	},
	created: function created() {
		this.initAllData();

		if (this.Field && this.Field.value) {
			this.setValue(this.Field.value, true);
		} else this.findSupportedTemplate();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-new-vds-plan-notice', this.handleChangePlan);

		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-change-active-tab', this.handleChangeActiveTab);

		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-plan-notice-what');

		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-new-vds-plan-notice', this.handleChangePlan);
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-change-active-tab', this.handleChangeActiveTab);

		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);
	},

	methods: {
		isTemplateVisible: function isTemplateVisible(Group) {
			var _this = this;

			if (!Group || !Group['list'] || !Group['list'].length) return false;

			if (this.$store.state.user_type === 'admin') return true;

			if (this.action === 'create') {
				if (this.isActiveTemplate(Group) === false) return false;
			} else if (this.action === 'update' || this.action === 'view') {
				if (this.isActiveTemplate(Group) === true) return true;else return Group.list.some(function (el) {
						if (String(_this.Field['_oldValue']) === String(el['id'])) return true;
					});
			}

			return true;
		},
		isActiveTemplate: function isActiveTemplate(Group) {
			if (!Group || !Group['list'] || !Group['list'].length) return false;

			return Group['list'].some(function (el) {
				if (el['id'] !== undefined && el['id'] !== null && el['id'] !== false && el['active'] === true) return true;
			});
		},
		isSelectedVersion: function isSelectedVersion(List) {
			var _this2 = this;

			if (!List || !List.length) return false;
			var answer = false;
			List.some(function (el) {
				if (String(el['id']) === String(_this2.curValue)) {
					answer = el;
					return true;
				}
			});

			return answer;
		},
		isNotGroupForPlan: function isNotGroupForPlan(Group) {
			var _this3 = this;

			if (!Group || !Group.list || !Group.list.length) return true;

			if (!this.curPlan) return true;

			return !Group.list.some(function (item) {
				if (item && item.plans && item.plans.length && item.plans.indexOf(_this3.curPlan) > -1) return true;
			});
		},
		findTemplateById: function findTemplateById(ID) {
			var onlyInActiveFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var answer = null;
			var curFilter = '';

			if (onlyInActiveFilter) {
				curFilter = this.activeFilter;
				for (var key in this.Groups[curFilter]) {
					var group = this.Groups[curFilter][key];
					if (group && group.list) {
						group.list.some(function (item) {
							if (String(item.id) === String(ID)) {
								answer = item;
								return true;
							}
						});
					}

					if (answer) break;
				}

				return answer;
			}

			curFilter = 'without-panel';
			for (var _key in this.Groups[curFilter]) {
				var _group = this.Groups[curFilter][_key];
				if (_group && _group.list) {
					_group.list.some(function (item) {
						if (String(item.id) === String(ID)) {
							answer = item;
							return true;
						}
					});
				}

				if (answer) break;
			}

			if (!answer) {
				curFilter = 'with-panel';
				for (var _key2 in this.Groups[curFilter]) {
					var _group2 = this.Groups[curFilter][_key2];
					if (_group2 && _group2.list) {
						_group2.list.some(function (item) {
							if (String(item.id) === String(ID)) {
								answer = item;
								return true;
							}
						});
					}

					if (answer) break;
				}
			}

			return answer;
		},
		findSupportedTemplate: function findSupportedTemplate() {
			var _this4 = this;

			var id = this.value;

			var template = this.findTemplateById(id);

			if (template && template.plans && template.plans.indexOf(this.curPlan) > -1) {
				this.setValue(id, true);
				return;
			}

			id = this.Field['_oldValue'];

			template = this.findTemplateById(id);

			if (template && template.plans && template.plans.indexOf(this.curPlan) > -1) {
				this.setValue(id, true);
				return;
			}

			id = false;

			var curFilter = 'without-panel';
			for (var key in this.Groups[curFilter]) {
				var group = this.Groups[curFilter][key];
				if (group && group.list) {
					group.list.some(function (item) {
						if (item && item.plans && item.plans.indexOf(_this4.curPlan) > -1) {
							id = item.id;
							return true;
						}
					});
				}

				if (id) break;
			}

			if (!id) {
				curFilter = 'with-panel';
				for (var _key3 in this.Groups[curFilter]) {
					var _group3 = this.Groups[curFilter][_key3];
					if (_group3 && _group3.list) {
						_group3.list.some(function (item) {
							if (item && item.plans && item.plans.indexOf(_this4.curPlan) > -1) {
								id = item.id;
								return true;
							}
						});
					}

					if (id) break;
				}
			}

			if (id) {
				this.activeFilter = curFilter;

				this.setValue(id, true);
			}
		},
		findSupportedTemplateWithFilter: function findSupportedTemplateWithFilter() {
			var _this5 = this;

			if (this.curValue) {
				var template = this.findTemplateById(this.curValue, true);

				if (template && template.plans && template.plans.indexOf(this.curPlan) > -1) {
					return;
				}
			}

			var id = false;

			var curFilter = this.activeFilter;
			for (var key in this.Groups[curFilter]) {
				var group = this.Groups[curFilter][key];
				if (group && group.list) {
					group.list.some(function (item) {
						if (item && item.plans && item.plans.indexOf(_this5.curPlan) > -1) {
							id = item.id;
							return true;
						}
					});
				}

				if (id) break;
			}

			if (id) {
				this.setValue(id, true);
			} else this.setValue(null, true);
		},
		getGroupAndVersion: function getGroupAndVersion(Name) {
			var _nm = false;
			var _vr = false;

			var _parts = Name.split(' ');
			for (var j = 0; j < _parts.length; j++) {
				if (/^[0-9.-]+$/.test(_parts[j])) {
					_vr = _parts.slice(j).join(' ');

					break;
				} else {
					if (!_nm) _nm = _parts[j];else _nm += ' ' + _parts[j];
				}
			}

			_nm = _nm.replace(/centos/i, 'CentOS').replace(/ubuntu/i, 'Ubuntu').replace(/debian/i, 'Debian').replace(/windows/i, 'Windows').replace(/bsd/i, 'BSD').replace(/server/i, 'Server').replace(/web/i, 'Web');

			return {
				name: _nm,
				version: _vr
			};
		},
		initAllData: function initAllData() {
			var _this6 = this;

			var _oldTab = this.activeFilter;

			this.activeFilter = '';
			this.Groups = {
				'without-panel': {},
				'with-panel': {}
			};
			this.curValue = null;

			if (!this.Field || !this.Field.list || !this.Field.list.length) {
				this.setValue(this.curValue, true);
				return;
			}

			var valueWithPanel = false;
			for (var idx in this.Field.list) {
				var template = this.Field.list[idx];

				var groupAndVersion = this.getGroupAndVersion(template['name']);

				if (!groupAndVersion) continue;
				if (!groupAndVersion['name']) continue;

				var group = this.Groups['without-panel'];
				var withInstruction = false;
				if ('has_instruction' in template && template['has_instruction'] === true) {
					group = this.Groups['with-panel'];
					withInstruction = true;
				}

				if (!group) group = {};
				if (!group[groupAndVersion['name']]) group[groupAndVersion['name']] = {};

				var data = group[groupAndVersion['name']];

				data['showList'] = false;
				data['image'] = template['image'];

				if (this.$store.state.user_type === 'admin') {
					if (!data['list']) data['list'] = [];

					data['list'].push({
						id: template['id'],
						fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
						version: groupAndVersion['version'],
						active: template['active'],
						sshkey: template['sshkey'],
						plans: template['plans'],
						limits: template['limits']
					});
				} else {
						if ('active' in template && template['active'] === true) {
							if (!data['list']) data['list'] = [];

							data['list'].push({
								id: template['id'],
								fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
								version: groupAndVersion['version'],
								active: template['active'],
								sshkey: template['sshkey'],
								plans: template['plans'],
								limits: template['limits']
							});
						} else {
								if (this.action === 'update' || this.action === 'view') {
									if (String(this.Field['_oldValue']) === String(template['id'])) {
										if (!data['list']) data['list'] = [];

										data['list'].push({
											id: template['id'],
											fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
											version: groupAndVersion['version'],
											active: template['active'],
											sshkey: template['sshkey'],
											plans: template['plans'],
											limits: template['limits']
										});
									}
								}
							}
					}

				if (String(this.value) === String(template['id'])) valueWithPanel = withInstruction ? 'with-panel' : 'without-panel';
			}

			if (_oldTab === 'backup' && this.curBackup && this.curBackup.id) {
				var _curBackupInList = false;

				if (this.backupField && this.backupField.list && this.backupField.list.length) {
					_curBackupInList = this.backupField.list.some(function (b) {
						if (b && b.id === _this6.curBackup.id) {
							return true;
						}
					});
				}

				if (_curBackupInList) {
					this.setValue(null, true);
					this.activeFilter = 'backup';

					this.$emit('templateTab', this.activeFilter);
					return;
				}
			}

			var k1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.Groups['without-panel']).length;
			var k2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.Groups['with-panel']).length;

			if (k1 > 0 && k2 > 0) {
				if (valueWithPanel) {
					this.activeFilter = valueWithPanel;
				} else {
						this.activeFilter = 'without-panel';
					}
			} else if (k1 > 0) this.activeFilter = 'without-panel';else if (k2 > 0) this.activeFilter = 'with-panel';

			this.$emit('templateTab', this.activeFilter);
		},
		setValue: function setValue(Value) {
			var needEmitInputEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
			var needTemplateToBus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			if (Value !== undefined && Value !== null) {
				this.$emit('focus');

				var val = parseInt(Value);
				if (!isNaN(val)) {
					this.curValue = val;

					if (needEmitInputEvent) this.$emit('input', String(this.curValue));

					if (needTemplateToBus) {
						__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.findTemplateById(val));
					}
				}
			} else {
				this.curValue = null;
				if (needEmitInputEvent) this.$emit('input', null);

				if (needTemplateToBus) __WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', null);
			}
		},
		restoreTemplateValue: function restoreTemplateValue() {
			if (this.oldValues[this.activeFilter]) {
				var template = this.findTemplateById(this.oldValues[this.activeFilter]);

				if (template) {
					this.setValue(this.oldValues[this.activeFilter], true);
					return;
				}
			}

			var id = false;

			var curFilter = this.activeFilter;
			for (var key in this.Groups[curFilter]) {
				var group = this.Groups[curFilter][key];
				if (group && group.list) {
					group.list.some(function (item) {
						if (item && item.id) {
							id = item.id;
							return true;
						}
					});
				}
				if (id) break;
			}

			if (id) {
				this.setValue(id, true);
			} else this.setValue(null, true);
		},
		toggleFilter: function toggleFilter(filterValue) {
			this.$emit('focus');

			if (this.activeFilter === filterValue) return;

			this.handleClick(null);

			if (this.activeFilter !== 'backup') this.oldValues[this.activeFilter] = this.curValue;

			this.activeFilter = filterValue;

			this.$emit('templateTab', filterValue);

			if (this.activeFilter !== 'backup') {
				this.$emit('backupValueChanged', null);

				this.restoreTemplateValue();
			} else {
					this.setValue(null, true);
					__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.curBackup);
				}
		},
		handleClick: function handleClick(groupName) {
			var selected = null;

			var curFilter = 'without-panel';
			for (var key in this.Groups[curFilter]) {
				if (groupName === key) selected = this.Groups[curFilter][key];

				this.$set(this.Groups[curFilter][key], 'showList', false);
			}

			curFilter = 'with-panel';
			for (var _key4 in this.Groups[curFilter]) {
				if (groupName === _key4) selected = this.Groups[curFilter][_key4];

				this.$set(this.Groups[curFilter][_key4], 'showList', false);
			}

			if (selected && selected.list) {
				if (selected.list.length === 1) {
					if (!this.isNotGroupForPlan(selected)) {
						var temp = selected.list[0];
						if (temp && temp.id) this.setValue(temp.id, true);
					}
				} else {
						if (!this.isNotGroupForPlan(selected)) selected['showList'] = true;else selected['showList'] = false;
					}
			}

			this.$forceUpdate();
		},
		handleChangePlan: function handleChangePlan(data) {
			var planId = parseInt(data);

			if (!data || isNaN(planId)) {
				this.curPlan = null;
				this.setValue(null, true);
				this.curBackup = null;
				this.$emit('backupValueChanged', null);
				return;
			}

			this.curPlan = planId;

			if (this.activeFilter !== 'backup') {
				this.findSupportedTemplateWithFilter();

				if (this.action === 'view') __WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-new-vds-plan-notice', this.handleChangePlan);
			}
		},
		handleChangeActiveTab: function handleChangeActiveTab(tab) {
			var _this7 = this;

			if (this.activeFilter === tab) return;
			this.$nextTick(function () {
				return _this7.toggleFilter(tab);
			});
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.handleClick(null);
			}
		},
		clickHandler: function clickHandler(e) {
			this.handleClick(null);
		},
		handleSelectTemplate: function handleSelectTemplate(Template) {
			if (!Template || !Template.id || !Template.plans || !Template.plans.length) return;

			if (Template.plans.indexOf(this.curPlan) > -1) {
				this.setValue(Template.id, true);

				this.handleClick(null);
			}
		},
		onSelectValue: function onSelectValue(value) {
			this.$emit('backupValueChanged', value);

			__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', value);
		},
		onBackupFocus: function onBackupFocus() {
			this.$emit('focus');
		},
		notEmpty: function notEmpty(value) {
			if (value === undefined || value === null) return false;
			if (!value || value === '' || value === 'emptyValue') return false;

			if (String(value) === '') return false;

			return true;
		},
		backupCreateButtonClick: function backupCreateButtonClick() {
			this.$emit('createBackup');
		}
	},

	watch: {
		'Field.list': function FieldList(list) {
			this.initAllData();

			if (this.activeFilter === 'backup' && this.curBackup) {
				return;
			}

			if (!this.curValue) this.findSupportedTemplate();
		},

		'backupField.list': function backupFieldList(newList, oldList) {
			var _this8 = this;

			if (!newList || !newList.length) {
				this.curBackup = null;
				this.$nextTick(function () {
					_this8.$emit('backupValueChanged', _this8.curBackup);
					__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', _this8.curBackup);
				});
				return;
			}

			if (__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].arrayCompare(newList, oldList, ['active', 'enable'])) {
				__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.curBackup);
				return;
			}

			if (window && window.sessionStorage) {
				var _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup');
				if (_crtFromBackup) {
					window.sessionStorage.removeItem('create-vds-from-backup');

					var _crtStore = null;
					try {
						_crtStore = JSON.parse(_crtFromBackup);
					} catch (e) {
						_crtStore = null;
					}

					if (_crtStore && _crtStore.service_id) {
						this.curBackup = { id: String(_crtStore.service_id), isStore: true };
					}
				}
			}

			if (this.activeFilter === 'backup') {
				var _oldId = this.curBackup && this.curBackup.id ? String(this.curBackup.id) : '';
				this.curBackup = null;

				newList.some(function (item) {
					if (item.active && item.enable && item.plans && item.plans.length && item.plans.indexOf(_this8.curPlan) > -1) {
						if (_oldId === '' && !_this8.curBackup) _this8.curBackup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

						if (String(item.id) === _oldId) {
							_this8.curBackup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
							return true;
						}
					}
				});
			} else {
					this.curBackup = null;
				}

			this.$nextTick(function () {
				_this8.$emit('backupValueChanged', _this8.curBackup);
				__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', _this8.curBackup);
			});
		}
	},

	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
		backupChoiceComponent: __WEBPACK_IMPORTED_MODULE_5__components_elements_backup___default.a
	}

});

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'backupChoiceComponent',

	props: {
		value: {
			required: true
		},
		list: {
			type: Array,
			required: true
		},
		plan: {
			required: true
		},
		action: {
			required: true
		},
		datacenters: {
			type: Array
		},
		dc: {
			required: true
		}
	},

	data: function data() {
		return {
			curValue: null,
			showedTopHintId: null
		};
	},
	created: function created() {
		this.initValue();
	},

	methods: {
		initValue: function initValue() {
			this.curValue = null;

			var item = null;
			if (this.value && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value) === 'object' && 'id' in this.value) item = this.value;else {
				var id = String(this.value);
				this.list.some(function (i) {
					if (i && String(i.id) === id) {
						item = i;
						return true;
					}
				});
			}

			if (item && this.isEnabled(item)) this.curValue = String(item.id);
		},
		onItemClick: function onItemClick(item) {
			this.$emit('focus');

			if (!item || !item.id || !this.isEnabled(item)) return;

			this.curValue = String(item.id);

			this.$emit('input', item);
		},
		mouseOver: function mouseOver(item) {
			if (!item || this.isEnabled(item)) return;
			if (this.showedTopHintId === item.id) return;
			this.showedTopHintId = item.id;
		},
		mouseLeave: function mouseLeave() {
			this.showedTopHintId = null;
		},
		makeReason: function makeReason(item) {
			if (!item) return;

			if (!item.active) return this.localeFtc('service/not_active');

			if (!item.enable || !item.plans || !item.plans.length || item.plans.indexOf(this.plan) < 0) return this.localeFtc('backup/create_vds_error');

			return '';
		},
		isEnabled: function isEnabled(Item) {
			var item = null;
			if (Item && (typeof Item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Item)) === 'object' && 'id' in Item) item = Item;else {
				var id = String(Item);
				this.list.some(function (i) {
					if (i && String(i.id) === id) {
						item = i;
						return true;
					}
				});
			}

			if (this.action !== 'view') {
				return item && item.id && item.enable && item.active;
			}

			return item && item.id && item.enable && item.active && item.plans && item.plans.length && item.plans.indexOf(this.plan) > -1;
		},
		generateTitle: function generateTitle(item) {
			var title = '';
			if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) !== 'object') return title;

			if (item.id) title = '#' + item.id;
			if (item.name) title += (title ? ' ' : '') + this.localeFtc(item.name);
			if (item.size || item.created) title += '\n';
			if (item.size) title += this.localeFtc('service/iso_size') + ': ' + item.size + (item.created ? ', ' : '');
			if (item.created) title += this.localeFtc('main/created') + ': ' + this.formater_StrDateFormat(item.created, 'd.m.Y');

			return title;
		},
		countryOfDc: function countryOfDc(item) {
			if (!item || !item.datacenter_id || !this.datacenters || !this.datacenters.length) {
				return false;
			}

			var country = false;
			this.datacenters.some(function (d) {
				if (d && d.id === item.datacenter_id) {
					country = d;
					if (item.datacenter_country) country.country = item.datacenter_country;
					if (item.datacenter_name) country.name = item.datacenter_name;
					return true;
				}
			});

			return country;
		},
		canCopyToDc: function canCopyToDc(item) {
			return item && item.datacenter_id && item.active && this.dc && String(item.datacenter_id) !== String(this.dc);
		},
		goToBackupsForCopy: function goToBackupsForCopy(item) {
			if (!item || !item.id) return;
			if (!window.sessionStorage) return;

			window.sessionStorage.setItem('copy-backup', item.id);
			this.$router.push('/backups/list');
		}
	},

	watch: {
		value: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		},
		plan: {
			handler: function handler() {
				if (!this.value || !this.isEnabled(this.value)) {
					this.curValue = null;
					this.$emit('input', null);
				}
			},
			immediate: true
		},
		list: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		}
	}

});

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.list && _vm.list.length) ? _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'selected': String(item.id) === _vm.curValue,
          'disabled': !_vm.isEnabled(item),
          'can-copy': _vm.canCopyToDc(item)
      },
      attrs: {
        "title": _vm.generateTitle(item)
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item)
        }
      }
    }, [(item['image'] && item['image'].length) ? _c('div', {
      staticClass: "left-part"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + item['image']
      }
    })]) : _c('div', {
      staticClass: "left-part clmn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [(item['name']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v("#" + _vm._s(item['id']) + " " + _vm._s(_vm._f("ftc")(item['name'])))]) : _vm._e(), _vm._v(" "), (item['size'] || item['created']) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.countryOfDc(item)) ? _c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + _vm.countryOfDc(item).country,
      staticStyle: {
        "width": "12px",
        "top": "-1px",
        "margin-right": "3px"
      },
      attrs: {
        "alt": _vm._f("ftc")(_vm.countryOfDc(item).name),
        "title": _vm._f("ftc")(_vm.countryOfDc(item).name)
      }
    }) : _vm._e(), _vm._v(" "), (item['size']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso_size')) + ": " + _vm._s(item['size']))]) : _vm._e(), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')) + ": " + _vm._s(_vm._f("date")(item['created'], 'd.m.Y')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.makeReason(item)),
        expression: "makeReason(item)"
      }]
    })]), _vm._v(" "), (_vm.canCopyToDc(item)) ? _c('font-awesome-icon', {
      staticClass: "copy-to-dc-btn",
      attrs: {
        "icon": "share",
        "title": _vm.localeFtc('backup/copy')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToBackupsForCopy(item)
        }
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isNeedShowFilter) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper"
  }, [_c('span', {
    staticClass: "w5-vds-plan-list-filter first",
    class: {
      'active': _vm.activeFilter === 'without-panel'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleFilter('without-panel')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/without_panel')))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "w5-vds-plan-list-filter",
    class: {
      'active': _vm.activeFilter === 'with-panel'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleFilter('with-panel')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/with_panel')))]), _vm._v(" "), (_vm.action === 'create') ? _c('br', {
    staticClass: "visible-xs"
  }) : _vm._e(), _vm._v(" "), (_vm.action === 'create' || _vm.action === 'view') ? _c('span', {
    staticClass: "w5-vds-plan-list-filter last",
    class: {
      'active': _vm.activeFilter === 'backup'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleFilter('backup')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/backup')))]) : _vm._e()]) : _c('div', {
    staticClass: "margin-top-5"
  }), _vm._v(" "), (_vm.activeFilter === 'without-panel' || _vm.activeFilter === 'with-panel') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, _vm._l((_vm.List), function(group, key, idx) {
    return (_vm.isTemplateVisible(group)) ? _c('div', {
      key: key,
      staticClass: "w5-vds-plan-list-item template_id",
      class: {
        'not-active-item': !_vm.isActiveTemplate(group),
          'not-for-current-plan': _vm.isNotGroupForPlan(group),
          'for-users': _vm.$store.state.user_type === 'client',
          'selected': _vm.isSelectedVersion(group.list)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick(key)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up",
      class: {
        'full-and-round': _vm.activeFilter === 'with-panel'
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + group.image,
        "width": "64"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gourp-title"
    }, [_c('strong', [_vm._v(_vm._s(group.list.length === 1 && group.list[0].fullName ? group.list[0].fullName : key))])])]), _vm._v(" "), (_vm.activeFilter === 'without-panel') ? [(group.list.length > 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id",
      class: {
        'border-none': group.showList
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "corner",
      class: {
        'for-open-block': group.showList
      }
    }), _vm._v(" "), (group.showList) ? _c('div', {
      staticClass: "selector"
    }, _vm._l((group.list), function(temp, idx) {
      return (temp.version) ? _c('div', {
        class: {
          'last': idx === group.list.length - 1, 'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || temp.plans.indexOf(_vm.curPlan) < 0
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleSelectTemplate(temp)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(temp.version) + "\n\t\t\t\t\t\t")]) : _vm._e()
    }), 0) : (_vm.isSelectedVersion(group.list)) ? _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm.isSelectedVersion(group.list).version))]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")('template/select_version')))])]) : (group.list.length === 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id"
    }, [(!group.list[0].version) ? _c('span', {
      staticClass: "item-with-only-line"
    }, [_c('div', {
      staticClass: "line"
    })]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(group.list[0].version))])]) : _vm._e()] : _vm._e()], 2) : _vm._e()
  }), 0) : (_vm.activeFilter === 'backup') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.backupField && _vm.backupField.list && _vm.backupField.list.length) ? _c('div', {
    staticClass: "w5-field removeRightPadding"
  }, [_c('backupChoiceComponent', {
    attrs: {
      "list": _vm.backupField && _vm.backupField.list ? _vm.backupField.list : [],
      "plan": _vm.curPlan
    },
    on: {
      "focus": _vm.onBackupFocus,
      "input": _vm.onSelectValue
    },
    model: {
      value: (_vm.curBackup),
      callback: function($$v) {
        _vm.curBackup = $$v
      },
      expression: "curBackup"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backupField._errMsg),
      expression: "backupField._errMsg"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.backupField._errMsg)),
      expression: "localeFtc(backupField._errMsg)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })], 1) : _c('div', {
    staticClass: "empty-backup-list"
  }, [(_vm.accountField && _vm.accountField.value) ? _c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/backup_list_empty')) + "\n\t\t\t\t"), _c('br'), _vm._v(" "), (_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t")]) : _vm._e()]) : _c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))]), _vm._v(" "), (_vm.backupField && _vm.backupField._errMsg) ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.backupField._errMsg)),
      expression: "localeFtc(backupField._errMsg)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  }) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  "data-v-38f37cfd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_backup__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_backup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_isoChoice__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_isoChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_isoChoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debounce__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'templateNewComponent',

	props: ['formFields', 'planField', 'action', 'cookieValue', 'dc'],
	data: function data() {
		return {
			currentTab: '',

			tabsData: {},

			currentPlan: null,

			currentPlanData: null,

			initValieInitiated: false,

			counterPlanChanged: 0
		};
	},

	computed: {
		templateGroups: function templateGroups() {
			var list = this.$store.state.lastTemplateGroupCache || [];
			if (this.$store.state.user_type === 'admin') return list;

			return list.filter(function (g) {
				return g && g.id && g.active;
			});
		},
		templateGroupsCommon: function templateGroupsCommon() {
			var list = this.templateGroups && this.templateGroups.length ? this.templateGroups.slice() : [];

			var _found = false;
			list.some(function (g) {
				if (g && g.id === 'backup') {
					_found = true;
					return true;
				}
			});
			if (!_found) {
				list.push({
					id: 'backup',
					name: 'service/backup',
					active: true
				});
			}

			_found = false;
			list.some(function (g) {
				if (g && g.id === 'iso') {
					_found = true;
					return true;
				}
			});
			if (!_found) {
				list.push({
					id: 'iso',
					name: 'service/service_iso',
					active: true
				});
			}

			return list;
		},
		accountField: function accountField() {
			var field = this.findField('account_id');
			if (!field) {
				if (this.$store.state.user_account) {
					var _accountID = parseInt(String(this.$store.state.user_account).replace(/[a-z]/ig, ''), 10);
					if (!isNaN(_accountID) && _accountID > 0) {
						field = {
							name: 'account_id',
							value: _accountID
						};
					}
				}
			}

			return field;
		},
		dataCenterField: function dataCenterField() {
			var field = this.findField('datacenter_id');
			if (!field) {
				if (this.dc) {
					field = {
						name: 'datacenter_id',
						title: 'datacenter/datacenter',
						list: [{
							id: this.dc
						}],
						value: this.dc
					};
				}
			}

			return field;
		}
	},
	created: function created() {
		var _this = this;

		this.tabListChanged = __WEBPACK_IMPORTED_MODULE_8_debounce___default()(this.tabListChanged, 200);

		if (this.action === 'view') {
			this.initTabsData();

			if (this.planField) {
				this.currentPlan = this.planField.value;

				if (this.planField.value && this.planField.list && this.planField.list.length) {
					this.planField.list.some(function (p) {
						if (p && p.id === _this.planField.value) {
							_this.currentPlanData = p;
							return true;
						}
					});
				}
			}
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-new-vds-plan-notice', this.handleChangePlan);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-change-active-tab', this.handleChangeActiveTab);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-vds-create-field-reloaded', this.handleFieldReloaded);

		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-new-vds-plan-notice', this.handleChangePlan);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-change-active-tab', this.handleChangeActiveTab);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-vds-create-field-reloaded', this.handleFieldReloaded);

		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);
	},

	methods: {
		initTabsData: function initTabsData() {
			if (!this.formFields || !this.formFields.length) {
				return;
			}

			this.initTemplates();
			this.initBackups();
			this.initIsos();

			this.initCurrentTab();

			if (!this.initValieInitiated) {
				var field = this.findField('template_id');
				if (field && field.list) {
					this.initValieInitiated = true;

					var _findValue = field.value;

					if (this.cookieValue) {
						_findValue = this.cookieValue;
					}

					this.findSupportedTemplate(_findValue, field.list);
				}
			}
		},
		getNameAndVersion: function getNameAndVersion(Name) {
			var matches = Name.match(/^(.*)\((.*)\)$/);
			if (matches && matches.length >= 3) {
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim()
				};
			}

			matches = Name.match(/^([a-zA-Z.-\s]+)([0-9.-]+)$/);
			if (matches && matches.length >= 3) {
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim()
				};
			}

			matches = Name.match(/^([a-zA-Z.-\s]+)([0-9.-]+)([a-zA-Z.-\s0-9]+)$/);
			if (matches && matches.length >= 4) {
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim() + ' ' + String(matches[3]).trim()
				};
			}

			return {
				name: Name,
				version: false
			};
		},
		initTemplates: function initTemplates() {
			var _this2 = this;

			var field = this.findField('template_id');
			if (!field || !field.list || !field.list.length) {
				return;
			}

			var _listReset = {};

			var _loop = function _loop(idx) {
				var template = field.list[idx];

				if (!template || !template.name || !template.image || !template.id || !('template_group' in template)) {
					return 'continue';
				}

				var nameAndVersion = _this2.getNameAndVersion(template.name);

				if (!nameAndVersion || !nameAndVersion.name) {
					return 'continue';
				}

				var templateGroup = null;
				if (_this2.templateGroups && _this2.templateGroups.length) {
					_this2.templateGroups.some(function (group) {
						if (group && (group.id === 99999 || group.id === template.template_group)) {
							templateGroup = group;
							return true;
						}
					});
				}

				if (!templateGroup || !templateGroup.id || !templateGroup.name) {
					return 'continue';
				}

				var tab = templateGroup.id;

				if (!_this2.tabsData[tab]) {
					_this2.$set(_this2.tabsData, tab, {
						active: templateGroup.active,
						title: templateGroup.name,
						list: [],
						tab: tab,
						value: null,
						oldValue: null
					});
					_listReset[tab] = true;
				} else {
					if (!_listReset[tab]) {
						_listReset[tab] = true;
						_this2.tabsData[tab].list = [];
					}
				}

				var tempNameGroup = null;
				_this2.tabsData[tab].list.some(function (temp) {
					if (temp.name === nameAndVersion.name) {
						tempNameGroup = temp;
						return true;
					}
				});

				if (!tempNameGroup) {
					_this2.tabsData[tab].list.push({ name: nameAndVersion.name });

					_this2.tabsData[tab].list.some(function (temp) {
						if (temp.name === nameAndVersion.name) {
							tempNameGroup = temp;
							return true;
						}
					});
				}

				tempNameGroup.showList = false;

				tempNameGroup.image = template.image;

				if (!('list' in tempNameGroup) || !tempNameGroup.list) tempNameGroup.list = [];

				var _find = tempNameGroup.list.some(function (i) {
					return String(i.id) === String(template.id);
				});

				if (_find) return 'continue';

				if (_this2.$store.state.user_type === 'admin') {
					tempNameGroup.list.push({
						id: template.id,
						fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
						version: nameAndVersion.version,
						active: template.active,
						sshkey: template.sshkey,
						plans: template.plans,
						limits: template.limits
					});
				} else {
						if (template.active) {
							tempNameGroup.list.push({
								id: template.id,
								fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
								version: nameAndVersion.version,
								active: template.active,
								sshkey: template.sshkey,
								plans: template.plans,
								limits: template.limits
							});
						} else {
								if (_this2.action === 'update' || _this2.action === 'view') {
									if (String(field._oldValue) === String(template.id)) {
										tempNameGroup.list.push({
											id: template.id,
											fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
											version: nameAndVersion.version,
											active: template.active,
											sshkey: template.sshkey,
											plans: template.plans,
											limits: template.limits
										});
									}
								}
							}
					}

				if (field.value && tempNameGroup && tempNameGroup.list && tempNameGroup.list.length) {
					tempNameGroup.list.some(function (i) {
						if (String(i.id) === String(field.value)) {
							_this2.tabsData[tab].value = i.id;
							return true;
						}
					});
				}
			};

			for (var idx in field.list) {
				var _ret = _loop(idx);

				if (_ret === 'continue') continue;
			}
		},
		initBackups: function initBackups() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				var field, _result, _crtFromBackup, _crtStore;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!_this3.tabsData || !_this3.tabsData['backup']) {
									_this3.$set(_this3.tabsData, 'backup', {
										title: 'service/backup',
										list: [],
										tab: 'backup',
										value: null,
										oldValue: null
									});
								}

								field = _this3.findField('backup_id');

								if (field) {
									_context.next = 4;
									break;
								}

								return _context.abrupt('return');

							case 4:
								if (!(_this3.action === 'view' && !field.title)) {
									_context.next = 14;
									break;
								}

								field.type = 'list';
								field.title = 'service/backup';
								field.reload = ['account_id', 'datacenter_id'];
								field.list = [];

								if (!(_this3.accountField && _this3.accountField.value && _this3.dataCenterField && _this3.dataCenterField.value)) {
									_context.next = 14;
									break;
								}

								_context.next = 12;
								return _this3.$http.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].APIServerUrl + ('/service/create?search=backup&datacenter_id=' + _this3.dataCenterField.value + '&account_id=' + _this3.accountField.value));

							case 12:
								_result = _context.sent;

								if (_result && _result.body && _result.body.status === 'ok' && _result.body.result && _result.body.result.length) {
									field.list = _result.body.result.filter(function (backup) {
										if (!backup || !backup.id || !backup.name || !backup.active || !backup.enable || !backup.plans || !backup.plans.length) {
											return false;
										}

										if (backup.plans.indexOf(_this3.currentPlan) === -1) {
											return false;
										}

										if (_this3.currentPlanData && _this3.currentPlanData.data && _this3.currentPlanData.data.disk) {
											var size = 'total' in _this3.currentPlanData.data.disk && _this3.currentPlanData.data.disk.total ? _this3.currentPlanData.data.disk.total : _this3.currentPlanData.data.disk.value;
											size = parseInt(size, 10);
											if (!isNaN(size) && size > 0) {
												if (backup.limits && backup.limits.disk && backup.limits.disk.min > size) {
													return false;
												}
											}
										}

										return true;
									});

									_this3.$emit('backupList', field.list);
								}

							case 14:

								_this3.tabsData['backup'].title = field.title;

								_this3.tabsData['backup'].list = field.list;

								if (field.list && field.list.length && window && window.sessionStorage) {
									_crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup');

									if (_crtFromBackup) {
										window.sessionStorage.removeItem('create-vds-from-backup');

										_crtStore = null;

										try {
											_crtStore = JSON.parse(_crtFromBackup);
										} catch (e) {
											_crtStore = null;
										}

										if (_crtStore && _crtStore.service_id) {
											field.list.some(function (b) {
												if (b && String(b.id) === String(_crtStore.service_id)) {
													_this3.currentTab = 'backup';

													_this3.$emit('templateTab', _this3.tabsData[_this3.currentTab].tab);

													_this3.tabsData[_this3.currentTab].value = b.id;

													_this3.$emit('templateInput', {
														tab: _this3.tabsData[_this3.currentTab].tab,
														value: _this3.tabsData[_this3.currentTab].value ? String(_this3.tabsData[_this3.currentTab].value) : _this3.tabsData[_this3.currentTab].value
													});

													__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', _this3.findBackupById(_this3.tabsData[_this3.currentTab].value));
													return true;
												}
											});
										}
									}
								}

							case 17:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		initIsos: function initIsos() {
			if (!this.tabsData || !this.tabsData['iso']) {
				this.$set(this.tabsData, 'iso', {
					title: 'service/service_iso',
					list: [],
					tab: 'iso',
					value: null,
					oldValue: null
				});
			}

			var field = this.findField('iso_id');
			if (!field) return;

			this.tabsData['iso'].title = field.title;

			this.tabsData['iso'].list = field.list;
		},
		initCurrentTab: function initCurrentTab() {
			if (this.currentTab) {
				if (this.tabsData && this.tabsData[this.currentTab] && this.tabsData[this.currentTab].tab) {
					this.$emit('templateTab', this.tabsData[this.currentTab].tab);
					return;
				}
			}

			for (var t in this.templateGroupsCommon) {
				var group = this.templateGroupsCommon[t];

				if (group && group.id && this.tabsData[group.id] && this.tabsData[group.id].list && this.tabsData[group.id].list.length) {
					this.currentTab = group.id;
					this.$emit('templateTab', this.tabsData[this.currentTab].tab);
					return;
				}
			}
		},
		handleChangePlan: function handleChangePlan(data) {
			var _this4 = this;

			if (!this.tabsData || !this.currentTab || !this.tabsData[this.currentTab]) {
				return;
			}

			if (this.action === 'view') {
				if (this.planField) {
					this.currentPlan = this.planField.value;

					if (this.planField.data && 'cost' in this.planField) {
						this.currentPlanData = this.planField;
					} else if (this.planField.value && this.planField.list && this.planField.list.length) {
						this.planField.list.some(function (p) {
							if (p && p.id === _this4.planField.value) {
								_this4.currentPlanData = p;
								return true;
							}
						});
					}
				}

				return;
			}

			if (!data || !data.id || !data.plan) {
				this.currentPlan = null;
				this.currentPlanData = null;

				if (this.counterPlanChanged > 0) {
					this.$emit('templateInput', {
						tab: this.tabsData[this.currentTab].tab,
						value: null
					});
				}

				this.counterPlanChanged++;

				return;
			}

			var planId = parseInt(data.id);
			if (isNaN(planId)) {
				this.currentPlan = null;
				this.currentPlanData = null;

				this.$emit('templateInput', {
					tab: this.tabsData[this.currentTab].tab,
					value: null
				});

				return;
			}

			this.currentPlan = planId;
			this.currentPlanData = data.plan;

			if ('value' in this.tabsData[this.currentTab] && this.tabsData[this.currentTab].value !== null && this.tabsData[this.currentTab].value !== undefined) {
				var templateValue = this.tabsData[this.currentTab].value;

				var _template = this.findTemplateById(templateValue);

				if (_template && _template.plans && _template.plans.length) {
					if (_template.plans.indexOf(this.currentPlan) === -1) {
						this.$emit('templateInput', {
							tab: this.tabsData[this.currentTab].tab,
							value: null
						});
					}
				}
			}
		},
		handleChangeActiveTab: function handleChangeActiveTab(extTabName) {
			var _this5 = this;

			if (!this.tabsData) return;

			var tab = '';
			for (var t in this.tabsData) {
				if (this.tabsData[t].tab === extTabName) {
					tab = t;
					break;
				}
			}

			if (!tab || this.currentTab === tab) return;
			this.$nextTick(function () {
				return _this5.handleTabChange(tab, false);
			});
		},
		findField: function findField(fieldName) {
			if (!this.formFields || !this.formFields.length) {
				return null;
			}

			var _field = null;
			this.formFields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === fieldName) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.handleClick(null);
			}
		},
		clickHandler: function clickHandler(e) {
			this.handleClick(null);
		},
		handleClick: function handleClick(templateName) {
			if (!this.tabsData) return;

			var selected = null;

			for (var t in this.tabsData) {
				if (t === 'backup' || t === 'iso') continue;

				if (this.tabsData[t] && this.tabsData[t].list && this.tabsData[t].list.length) {
					this.tabsData[t].list.forEach(function (item) {
						if (templateName === item.name) selected = item;

						item.showList = false;
					});
				}
			}

			if (selected && selected.list) {
				if (this.action === 'view') {
					if (selected.list.length === 1) {
						if (!this.isNotTemplateForPlan(selected)) {
							var temp = selected.list[0];
							if (temp && temp.id) this.setValue(temp.id, true);
						}
					} else {
							if (!this.isNotTemplateForPlan(selected)) selected['showList'] = true;else selected['showList'] = false;
						}
				} else {
					if (selected.list.length === 1) {
						var _temp2 = selected.list[0];
						if (_temp2 && _temp2.id) this.setValue(_temp2.id, true);
					} else {
							selected['showList'] = true;
						}
				}
			}

			this.$forceUpdate();
		},
		handleSelectTemplate: function handleSelectTemplate(Template) {
			if (!Template || !Template.id || !Template.plans || !Template.plans.length) return;

			if (this.action === 'view') {
				if (this.isNotTemplateForPlan(Template)) return;
			}

			this.setValue(Template.id, true);

			this.handleClick(null);
		},
		isActiveTemplate: function isActiveTemplate(Template) {
			if (!Template || !Template.list || !Template.list.length) {
				return false;
			}

			return Template.list.some(function (el) {
				if (el && el.id && el.active === true) return true;
			});
		},
		isSelectedVersion: function isSelectedVersion(List) {
			var _this6 = this;

			if (!List || !List.length) return false;

			var answer = false;
			List.some(function (el) {
				if (el && String(el.id) === String(_this6.tabsData[_this6.currentTab].value)) {
					answer = el;
					return true;
				}
			});

			return answer;
		},
		isNotTemplateForPlan: function isNotTemplateForPlan(Template) {
			var _this7 = this;

			if (!Template) return true;

			if (!this.currentPlan) return true;

			if (Template && Template.id && Template.fullName && Template.plans) {
				if (!Template.plans.length) return true;

				if (Template.plans.indexOf(this.currentPlan) < 0) return true;

				if (Template.limits && Template.limits.cpu && 'min' in Template.limits.cpu && Template.limits.disk && 'min' in Template.limits.disk && Template.limits.ram && 'min' in Template.limits.ram) {
					if (!this.currentPlanData || !this.currentPlanData.data || !this.currentPlanData.data.cpu || !this.currentPlanData.data.disk || !this.currentPlanData.data.ram) {
						return true;
					}

					if (this.currentPlanData.data.cpu.value < Template.limits.cpu.min) return true;else if (this.currentPlanData.data.disk.value < Template.limits.disk.min) return true;else if (this.currentPlanData.data.ram.value < Template.limits.ram.min) return true;

					return false;
				} else {
					return false;
				}
			} else if (Template && Template.name && Template.list) {
					if (!Template.list.length) return true;

					return !Template.list.some(function (item) {
						if (item && item.plans && item.plans.length && item.plans.indexOf(_this7.currentPlan) > -1) {
							if (!item.limits) return true;

							if (item.limits && item.limits.cpu && 'min' in item.limits.cpu && item.limits.disk && 'min' in item.limits.disk && item.limits.ram && 'min' in item.limits.ram) {
								if (!_this7.currentPlanData) return false;

								if (_this7.currentPlanData.has_params) {
									if (!_this7.currentPlanData.params || !_this7.currentPlanData.params.cpu || !_this7.currentPlanData.params.disk || !_this7.currentPlanData.params.ram) {
										return false;
									}

									if (_this7.currentPlanData.params.cpu.value < item.limits.cpu.min) return false;else if (_this7.currentPlanData.params.disk.value < item.limits.disk.min) return false;else if (_this7.currentPlanData.params.ram.value < item.limits.ram.min) return false;
								} else {
										if (!_this7.currentPlanData.data || !_this7.currentPlanData.data.cpu || !_this7.currentPlanData.data.disk || !_this7.currentPlanData.data.ram) {
											return false;
										}

										if (_this7.currentPlanData.data.cpu.value < item.limits.cpu.min) return false;else if (_this7.currentPlanData.data.disk.value < item.limits.disk.min) return false;else if (_this7.currentPlanData.data.ram.value < item.limits.ram.min) return false;
									}

								return true;
							} else return true;
						}
					});
				}

			if (Template && Template.id && Template.name && Template.plans && this.currentTab === 'backup') {
				if (!Template.plans.length) return true;

				if (Template.plans.indexOf(this.currentPlan) < 0) return true;

				if (Template.limits && Template.limits.cpu && Template.limits.cpu.min && Template.limits.disk && Template.limits.disk.min && Template.limits.ram && Template.limits.ram.min) {
					if (!this.currentPlanData || !this.currentPlanData.data || !this.currentPlanData.data.cpu || !this.currentPlanData.data.disk || !this.currentPlanData.data.ram) {
						return true;
					}

					if (this.currentPlanData.data.cpu.value < Template.limits.cpu.min) return true;else if (this.currentPlanData.data.disk.value < Template.limits.disk.min) return true;else if (this.currentPlanData.data.ram.value < Template.limits.ram.min) return true;

					return false;
				} else {
					return false;
				}
			}

			if (Template && Template.id && Template.name && this.currentTab === 'iso') {
				return false;
			}

			return true;
		},
		isTemplateVisible: function isTemplateVisible(Template) {
			if (!Template || !Template.list || !Template.list.length) {
				return false;
			}

			if (this.$store.state.user_type === 'admin') return true;

			if (this.action === 'create') {
				if (!this.isActiveTemplate(Template)) return false;
			} else if (this.action === 'update' || this.action === 'view') {
				if (this.isActiveTemplate(Template)) return true;else {
						var field = this.findField('template_id');
						if (!field || !field._oldValue) {
							return false;
						}

						return Template.list.some(function (el) {
							if (String(field._oldValue) === String(el.id)) return true;
						});
					}
			}

			return true;
		},
		handleTabChange: function handleTabChange(newTabName) {
			var _this8 = this;

			var emitChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			this.$emit('focus');

			if (this.currentTab === newTabName) return;

			if (!this.tabsData || !this.tabsData[newTabName] || !this.tabsData[newTabName].tab) return;

			this.handleClick(null);

			this.tabsData[this.currentTab].oldValue = this.tabsData[this.currentTab].value;

			this.currentTab = newTabName;

			if (emitChanged) {
				this.$emit('templateTab', this.tabsData[this.currentTab].tab);
			}

			if (this.tabsData[this.currentTab].oldValue) {
				this.tabsData[this.currentTab].value = this.tabsData[this.currentTab].oldValue;
			}

			if (!this.tabsData[this.currentTab].value) {
				if (this.tabsData && this.tabsData[this.currentTab] && this.tabsData[this.currentTab].list) {
					var found = false;
					var list = this.tabsData[this.currentTab].list;

					for (var key in list) {
						var obj = list[key];

						if (this.currentTab !== 'backup' && this.currentTab !== 'iso') {
							var _template2 = obj;
							if (_template2 && _template2.list) {
								_template2.list.some(function (item) {
									if (item.active === true) {
										found = true;

										_this8.tabsData[_this8.currentTab].value = item.id;

										return true;
									}
								});
							}
						} else {
								if (obj && obj.id && obj.active === true && obj.enable === true) {
									found = true;

									this.tabsData[this.currentTab].value = obj.id;
								}
							}

						if (found) break;
					}
				} else {
					this.setValue(null, true);
					return;
				}
			} else {}

			if (this.action === 'view') {
				if (this.tabsData[this.currentTab].value) {
					var _template3 = this.findTemplateById(this.tabsData[this.currentTab].value);

					if (this.isNotTemplateForPlan(_template3)) {
						this.setValue(null, true);
					}
				}
			}

			this.$emit('templateInput', {
				tab: this.tabsData[this.currentTab].tab,
				value: this.tabsData[this.currentTab].value ? String(this.tabsData[this.currentTab].value) : this.tabsData[this.currentTab].value
			});

			if (this.currentTab !== 'backup' && this.currentTab !== 'iso') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.findTemplateById(this.tabsData[this.currentTab].value));
			} else if (this.currentTab === 'backup') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.findBackupById(this.tabsData[this.currentTab].value));
			} else if (this.currentTab === 'iso') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', this.findIsoById(this.tabsData[this.currentTab].value));
			}
		},
		onTabComponentFocus: function onTabComponentFocus() {
			this.$emit('focus');
		},
		onSelectBackup: function onSelectBackup(value) {
			this.setValue(value, true);
		},
		onSelectIso: function onSelectIso(value) {
			this.setValue(value, true);
		},
		setValue: function setValue(Value) {
			var needEmitInputEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
			var needTemplateToBus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			if (!this.tabsData || !this.tabsData[this.currentTab]) return;

			this.tabsData[this.currentTab].valueName = null;

			if (Value !== undefined && Value !== null) {
				this.$emit('focus');

				var val = '';
				if (Value && (typeof Value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Value)) === 'object' && 'id' in Value) val = parseInt(Value.id);else val = parseInt(Value);

				if (!isNaN(val)) {
					var _temp = this.findTemplateById(val);
					if (_temp) {
						if (_temp.fullName && this.currentTab !== 'backup' && this.currentTab !== 'iso') {
							this.tabsData[this.currentTab].valueName = _temp.fullName;
						}

						this.tabsData[this.currentTab].value = val;

						if (needEmitInputEvent) this.$emit('templateInput', {
							tab: this.tabsData[this.currentTab].tab,
							value: String(val)
						});

						if (needTemplateToBus) {
							__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', _temp);
						}
					}
				}
			} else {
				this.tabsData[this.currentTab].value = null;
				if (needEmitInputEvent) this.$emit('templateInput', {
					tab: this.tabsData[this.currentTab].tab,
					value: null
				});

				if (needTemplateToBus) {
					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', null);
				}
			}
		},
		findTemplateById: function findTemplateById(ID) {
			if (this.currentTab === 'backup' || this.currentTab === 'iso') {
				if (this.currentTab === 'backup') return this.findBackupById(ID);else if (this.currentTab === 'iso') return this.findIsoById(ID);else return null;
			}

			if (!this.tabsData || !this.tabsData[this.currentTab] || !this.tabsData[this.currentTab].list || !this.tabsData[this.currentTab].list.length) {
				return null;
			}

			var answer = null;
			var list = this.tabsData[this.currentTab].list;

			for (var key in list) {
				var _template4 = list[key];
				if (_template4 && _template4.list) {
					_template4.list.some(function (item) {
						if (String(item.id) === String(ID)) {
							answer = item;
							return true;
						}
					});
				}

				if (answer) break;
			}

			return answer;
		},
		findBackupById: function findBackupById(ID) {
			if (this.currentTab !== 'backup') {
				return null;
			}

			if (!this.tabsData || !this.tabsData[this.currentTab] || !this.tabsData[this.currentTab].list || !this.tabsData[this.currentTab].list.length) {
				return null;
			}

			var answer = null;
			var list = this.tabsData[this.currentTab].list;

			for (var key in list) {
				var obj = list[key];
				if (obj && String(obj.id) === String(ID)) {
					answer = obj;
					break;
				}
			}

			return answer;
		},
		findIsoById: function findIsoById(ID) {
			if (this.currentTab !== 'iso') {
				return null;
			}

			if (!this.tabsData || !this.tabsData[this.currentTab] || !this.tabsData[this.currentTab].list || !this.tabsData[this.currentTab].list.length) {
				return null;
			}

			var answer = null;
			var list = this.tabsData[this.currentTab].list;

			for (var key in list) {
				var obj = list[key];
				if (obj && String(obj.id) === String(ID)) {
					answer = obj;
					answer.__type = 'iso';
					break;
				}
			}

			return answer;
		},
		handleFieldReloaded: function handleFieldReloaded(name) {
			var _this9 = this;

			if (name === 'backup_id' || name === 'iso_id') {
				this.initTabsData();

				if (this.currentTab !== 'backup' && this.currentTab !== 'iso') return;

				var reloadedFieldtab = '';
				if (name === 'backup_id' && this.tabsData && this.tabsData['backup']) {
					reloadedFieldtab = 'backup';
				} else if (name === 'iso_id' && this.tabsData && this.tabsData['iso']) {
					reloadedFieldtab = 'iso';
				}

				var found = false;
				if (this.tabsData[reloadedFieldtab].list && this.tabsData[reloadedFieldtab].list.length) {
					this.tabsData[reloadedFieldtab].list.some(function (item) {
						if (item && String(item.id) === String(_this9.tabsData[reloadedFieldtab].value)) {
							found = item;
							return true;
						}
					});
				}

				if (found === false && this.tabsData[reloadedFieldtab].value !== null) {
					this.tabsData[reloadedFieldtab].value = null;

					this.$emit('templateInput', {
						tab: this.tabsData[reloadedFieldtab].tab,
						value: null
					});

					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-new-vds-template-notice-what', null);
				}
			}
		},
		findSupportedTemplate: function findSupportedTemplate(initValue, initList) {
			var _this10 = this;

			if (initValue) {
				var _ret2 = function () {
					var temp = null;

					if (initList && initList.length) {
						initList.some(function (t) {
							if (String(t.id) === String(initValue)) {
								temp = t;
								return true;
							}
						});

						if (temp && (temp.active === true || _this10.action === 'view')) {
							var _loop2 = function _loop2(t) {
								if (t === 'backup' || t === 'iso') return 'continue';

								if (_this10.tabsData[t] && _this10.tabsData[t].list) {
									var found = false;
									var list = _this10.tabsData[t].list;
									for (var key in list) {
										var _template5 = list[key];
										if (_template5 && _template5.list) {
											_template5.list.some(function (item) {
												if (String(item.id) === String(temp.id)) {
													found = true;

													_this10.currentTab = t;

													_this10.setValue(item, true);

													return true;
												}
											});
										}

										if (found) return {
												v: {
													v: void 0
												}
											};
									}
								}
							};

							for (var t in _this10.tabsData) {
								var _ret3 = _loop2(t);

								switch (_ret3) {
									case 'continue':
										continue;

									default:
										if ((typeof _ret3 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
								}
							}
						}
					}
				}();

				if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
			}

			var _loop3 = function _loop3(idx) {
				var group = _this10.templateGroupsCommon[idx];
				if (!group || !group.id) return 'continue';

				var t = group.id;
				if (t === 'backup' || t === 'iso') return 'continue';
				if (!_this10.tabsData[t] || !_this10.tabsData[t].list) return 'continue';

				var found = false;
				var list = _this10.tabsData[t].list;
				for (var key in list) {
					var _template6 = list[key];
					if (_template6 && _template6.list) {
						_template6.list.some(function (item) {
							if (item.active === true) {
								found = true;

								_this10.currentTab = t;

								_this10.setValue(item, true);

								_this10.$emit('startData', String(item.id));

								return true;
							}
						});
					}

					if (found) return {
							v: void 0
						};
				}
			};

			for (var idx in this.templateGroupsCommon) {
				var _ret4 = _loop3(idx);

				switch (_ret4) {
					case 'continue':
						continue;

					default:
						if ((typeof _ret4 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret4)) === "object") return _ret4.v;
				}
			}
		},
		tabListChanged: function tabListChanged() {
			var _this11 = this;

			var tab = this.currentTab;

			if (!tab || !this.tabsData || !this.tabsData[tab] || !this.tabsData[tab].list || !this.tabsData[tab].list.length) {
				return;
			}

			if (!('value' in this.tabsData[tab]) || !this.tabsData[tab].value) {
				return;
			}

			var _oldValueName = this.tabsData[tab].valueName;

			var _inList = false;
			var _firstId = null;

			this.tabsData[tab].list.some(function (temp) {
				if (temp && temp.list && temp.list.length) {
					return temp.list.some(function (i) {
						if (i && i.id) {
							if (!_firstId) {
								if (_this11.$store.state.user_type === 'admin') _firstId = i.id;else if (i.active) _firstId = i.id;
							}

							if (String(i.id) === String(_this11.tabsData[tab].value)) {
								if (_this11.$store.state.user_type === 'admin') _inList = true;else if (i.active) _inList = true;

								if (_inList) return true;
							}
						}
					});
				} else {
					if (temp && temp.id) {
						if (!_firstId) {
							if (_this11.$store.state.user_type === 'admin') _firstId = temp.id;else if (temp.active) _firstId = temp.id;
						}

						if (String(temp.id) === String(_this11.tabsData[tab].value)) {
							if (_this11.$store.state.user_type === 'admin') _inList = true;else if (temp.active) _inList = true;

							if (_inList) return true;
						}
					}
				}
			});

			if (!_inList) {
				if (_oldValueName) {
					this.tabsData[tab].list.some(function (temp) {
						if (temp.list && temp.list.length) {
							return temp.list.some(function (i) {
								if (i.fullName === _oldValueName) {
									if (_this11.$store.state.user_type === 'admin') {
										_firstId = i.id;
										return true;
									} else if (i.active) {
										_firstId = i.id;
										return true;
									}
								}
							});
						}
					});
				}

				this.setValue(_firstId, true);
			}
		}
	},

	watch: {
		'formFields': {
			handler: function handler() {
				this.initTabsData();
			},
			deep: true
		},
		'tabsData': {
			handler: function handler() {
				this.tabListChanged();
			},
			deep: true
		}
	},

	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
		backupChoiceComponent: __WEBPACK_IMPORTED_MODULE_6__components_elements_backup___default.a,
		isoChoiceComponent: __WEBPACK_IMPORTED_MODULE_7__components_elements_isoChoice___default.a
	}

});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  "data-v-7cf0d9d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'isoChoiceComponent',

	props: {
		value: {
			required: true
		},
		list: {
			type: Array,
			required: true
		}
	},

	data: function data() {
		return {
			curValue: null,
			showedTopHintId: null
		};
	},
	created: function created() {
		this.initValue();
	},

	methods: {
		initValue: function initValue() {
			this.curValue = null;

			if (this.value && this.isEnabled(this.value)) this.curValue = String(this.value);
		},
		onItemClick: function onItemClick(item) {
			this.$emit('focus');

			if (!item || !item.id || !this.isEnabled(item)) return;

			this.curValue = String(item.id);

			this.$emit('input', item);
		},
		mouseOver: function mouseOver(item) {
			if (!item || this.isEnabled(item)) return;
			if (this.showedTopHintId === item.id) return;
			this.showedTopHintId = item.id;
		},
		mouseLeave: function mouseLeave() {
			this.showedTopHintId = null;
		},
		makeReason: function makeReason(item) {
			if (!item) return;

			if (!item.active) return this.localeFtc('service/iso_not_active');

			if (!item.enable) return this.localeFtc('service/iso_already_used');

			return '';
		},
		isEnabled: function isEnabled(Item) {
			var item = null;
			if (Item && (typeof Item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Item)) === 'object' && 'id' in Item) item = Item;else {
				var id = String(Item);
				this.list.some(function (i) {
					if (i && String(i.id) === id) {
						item = i;
						return true;
					}
				});
			}

			return item && item.id && item.enable && item.active && item.status === 'active' && !item.status_text;
		},
		generateTitle: function generateTitle(item) {
			var title = '';
			if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) !== 'object') return title;

			if (item.id) title = '#' + item.id;
			if (item.name) title += (title ? ' ' : '') + item.name;
			if (item.size || item.created) title += '\n';
			if (item.size) title += this.localeFtc('service/iso_size') + ': ' + item.size + (item.created ? ', ' : '');
			if (item.created) title += this.localeFtc('main/created') + ': ' + this.formater_StrDateFormat(item.created, 'd.m.Y');

			return title;
		}
	},

	watch: {
		value: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		},
		list: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		}
	}

});

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.list && _vm.list.length) ? _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'selected': String(item.id) === _vm.curValue,
          'disabled': !_vm.isEnabled(item)
      },
      attrs: {
        "title": _vm.generateTitle(item)
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "left-part"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "compact-disc"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [(item['name']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v("#" + _vm._s(item['id']) + " " + _vm._s(item['name']))]) : _vm._e(), _vm._v(" "), (item['size'] || item['created']) ? _c('br') : _vm._e(), _vm._v(" "), (item['size']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso_size')) + ": " + _vm._s(item['size']))]) : _vm._e(), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')) + ": " + _vm._s(_vm._f("date")(item['created'], 'd.m.Y')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.makeReason(item)),
        expression: "makeReason(item)"
      }]
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "template-wrapper",
    class: {
      'in-view': _vm.action === 'view'
    }
  }, [(_vm.tabsData && Object.keys(_vm.tabsData).length && _vm.templateGroupsCommon && _vm.templateGroupsCommon.length) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper",
    class: _vm.action
  }, _vm._l((_vm.templateGroupsCommon), function(group) {
    return (group && group.id && group.name && _vm.tabsData[group.id]) ? _c('span', {
      key: group.id,
      staticClass: "w5-vds-plan-list-filter first",
      class: {
        'active': _vm.currentTab == group.id, 'not-active-group': group.active === false
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleTabChange(group.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(group.name)) + "\n\t\t")]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.tabsData && _vm.tabsData[_vm.currentTab]) ? [(_vm.currentTab != 'backup' && _vm.currentTab != 'iso') ? [(_vm.tabsData[_vm.currentTab].list && _vm.tabsData[_vm.currentTab].list.length) ? _vm._l((_vm.tabsData[_vm.currentTab].list), function(Template, idx) {
    return (_vm.isTemplateVisible(Template)) ? _c('div', {
      key: 'temp' + idx + String(Template.name),
      staticClass: "w5-vds-plan-list-item template_id",
      class: {
        'not-active-item': !_vm.isActiveTemplate(Template),
          'not-for-current-plan': _vm.action === 'view' && _vm.isNotTemplateForPlan(Template),
          'for-users': _vm.$store.state.user_type === 'client',
          'selected': _vm.isSelectedVersion(Template.list)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick(Template.name)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up twi",
      class: {
        'full-and-round': Template.list.length <= 0 || (Template.list.length === 1 && !Template.list[0].version)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + Template.image,
        "width": "64"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gourp-title"
    }, [_c('strong', [_vm._v(_vm._s(Template.name))])])]), _vm._v(" "), (Template.list.length > 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id",
      class: {
        'border-none': Template.showList
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "corner",
      class: {
        'for-open-block': Template.showList
      }
    }), _vm._v(" "), (Template.showList) ? _c('div', {
      staticClass: "selector"
    }, _vm._l((Template.list), function(temp, idx) {
      return (temp.version) ? _c('div', {
        class: {
          'last': idx === Template.list.length - 1,
            'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || (_vm.action === 'view' && _vm.isNotTemplateForPlan(temp))
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleSelectTemplate(temp)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(temp.version) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()
    }), 0) : (_vm.isSelectedVersion(Template.list)) ? _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm.isSelectedVersion(Template.list).version))]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")('template/select_version')))])]) : (Template.list.length === 1 && Template.list[0].version) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id"
    }, [_c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(Template.list[0].version))])]) : _vm._e()]) : _vm._e()
  }) : _c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])] : (_vm.currentTab == 'backup') ? [(_vm.tabsData[_vm.currentTab].list && _vm.tabsData[_vm.currentTab].list.length) ? _c('div', {
    staticClass: "w5-field removeRightPadding"
  }, [_c('backupChoiceComponent', {
    attrs: {
      "action": _vm.action,
      "list": _vm.tabsData[_vm.currentTab].list,
      "plan": _vm.currentPlan,
      "datacenters": _vm.dataCenterField && _vm.dataCenterField.list && _vm.dataCenterField.list.length ? _vm.dataCenterField.list : [],
      "dc": _vm.dataCenterField && 'value' in _vm.dataCenterField ? _vm.dataCenterField.value : (_vm.dc ? _vm.dc : null)
    },
    on: {
      "focus": _vm.onTabComponentFocus,
      "input": _vm.onSelectBackup
    },
    model: {
      value: (_vm.tabsData[_vm.currentTab].value),
      callback: function($$v) {
        _vm.$set(_vm.tabsData[_vm.currentTab], "value", $$v)
      },
      expression: "tabsData[currentTab].value"
    }
  })], 1) : _c('div', {
    staticClass: "empty-backup-list",
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, [(!_vm.dataCenterField || !_vm.dataCenterField.value) ? _c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('datacenter/not_selected')) + "\n\t\t\t\t\t")]) : (_vm.accountField && _vm.accountField.value) ? _c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/backup_list_empty')) + "\n\t\t\t\t\t")]) : _c('span', {
    staticClass: "empty-message",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [(_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t\t\t")]) : _vm._e()])] : (_vm.currentTab == 'iso') ? [(_vm.tabsData[_vm.currentTab].list && _vm.tabsData[_vm.currentTab].list.length) ? _c('div', {
    staticClass: "w5-field removeRightPadding"
  }, [_c('isoChoiceComponent', {
    attrs: {
      "list": _vm.tabsData[_vm.currentTab].list
    },
    on: {
      "focus": _vm.onTabComponentFocus,
      "input": _vm.onSelectIso
    },
    model: {
      value: (_vm.tabsData[_vm.currentTab].value),
      callback: function($$v) {
        _vm.$set(_vm.tabsData[_vm.currentTab], "value", $$v)
      },
      expression: "tabsData[currentTab].value"
    }
  })], 1) : _c('div', {
    staticClass: "empty-backup-list",
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [(_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t\t\t")]) : _vm._e()])] : _vm._e()] : _c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])], 2)])
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'paymentComponent',

	props: ['items', 'value', 'title'],
	data: function data() {
		return {
			curValue: null,
			curSumma: 0,
			Props: {}
		};
	},
	created: function created() {
		var _this = this;

		this.items.forEach(function (item) {
			_this.Props[item['id']] = {
				'active': item['active'],
				'disabled': false,
				'summa': 0
			};
		});

		if (this.value !== undefined && this.value !== null) this.curValue = this.value;
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('form-client-operation-create', this.summaChanged);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('form-client-operation-create', this.summaChanged);
	},

	methods: {
		onItemClick: function onItemClick(id) {
			var isNextStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			this.$emit('focus');

			if (!this.Props || !this.Props[id] || this.Props[id]['summa'] === undefined || this.Props[id]['summa'] === null || isNaN(this.Props[id]['summa']) || this.Props[id]['summa'] <= 0) {
				return;
			}

			var _item = null;
			this.items.some(function (item) {
				if (String(item.id) === String(id)) {
					_item = item;
					return true;
				}
			});

			if (!_item) {
				return;
			}

			if (this.$store.state.user_type !== 'admin' && this.Props[id]['active'] !== true) {
				if (_item.type === 'bank_legal' && this.$store.state.user_type === 'client') {
					__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$emit('w5-payment-bank-legal', id);
				}

				return;
			}

			if (this.Props[id]['disabled'] === true) {
				return;
			}

			this.curValue = id;

			this.$emit('input', this.curValue);
		},
		summaChanged: function summaChanged(summa) {
			if (summa === undefined || summa === null || isNaN(summa)) summa = 0;
			if (String(summa).length === 0) summa = 0;

			summa = parseFloat(summa);

			this.$set(this, 'curSumma', summa);

			this.recountSum();

			this.$forceUpdate();
		},
		recountSum: function recountSum() {
			var _this2 = this;

			if (!this.items || !this.items.length) return;

			var curPayment = null;

			this.items.forEach(function (item) {
				if (item && String(item.id) === String(_this2.curValue)) {
					curPayment = item;
				}

				var _com = item['comission'];
				if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0;
				_com = parseFloat(_com);

				var _price = (_this2.curSumma + _com * _this2.curSumma / 100.0).toFixed(2);
				_price = parseFloat(_price);

				_this2.Props[item['id']]['summa'] = _price;

				var _min = item['min'];
				if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0;
				_min = parseFloat(_min);

				var _max = item['max'];
				if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0;
				_max = parseFloat(_max);

				if (_this2.curSumma <= 0 || _this2.curSumma < _min || _max && _this2.curSumma > _max) _this2.Props[item['id']]['disabled'] = true;else _this2.Props[item['id']]['disabled'] = false;
			});

			if (curPayment && curPayment.id) {
				if (curPayment.active !== true || this.Props[curPayment.id].disabled === true) this.$emit('input', null);else this.$emit('input', this.curValue);
			}
		},
		getMin: function getMin(item) {
			if (!item || !('min' in item) || item.min < 0) return null;
			return item.min;
		},
		getMax: function getMax(item) {
			if (!item || !('max' in item) || item.max < 0) return null;
			if (item.max >= 1000000) return null;
			return item.max;
		}
	},

	watch: {
		'value': function value(_value) {
			this.curValue = _value;
			this.recountSum();
		},
		'items': function items(_items) {
			var _this3 = this;

			_items.forEach(function (item) {
				_this3.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				};
			});
		}
	}

});

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-payment-create-block"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "w5-payment-create-list-item",
      class: {
        'selected': item.id == _vm.curValue, 'disabled': _vm.Props[item['id']]['disabled'], 'not-active-item': item.active !== true
      },
      on: {
        "click": function($event) {
          return _vm.onItemClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "w5-payment-create-list-item-up"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + '/uploads/payment/' + item['image']
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "payment-name"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(item['name'])))])])]), _vm._v(" "), _c('div', {
      staticClass: "w5-payment-create-list-item-down"
    }, [(item['comission'] > 0) ? _c('div', {
      staticClass: "w5-payment-create-list-item-down-info"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/comission')) + ": " + _vm._s(item['comission']) + "%\n\t\t\t")]) : _vm._e(), _vm._v(" "), (item['bonus'] > 0) ? _c('div', {
      staticClass: "w5-payment-create-list-item-down-info"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/bonus')) + ": " + _vm._s(item['bonus']) + "%\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.Props[item['id']]['summa'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])]), _vm._v(" "), (_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " — " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.getMin(item) && !_vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_from')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (!_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_to')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e()], 2)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'urlButton',

	props: ['crud', 'name', 'url', 'text'],

	methods: {
		onClick: function onClick(e) {
			if (this.url === '/person/create') {
				__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$emit('w5-goto-url', this.url);
				return;
			}
			this.$router.push(this.url);
		}
	}
});

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "url-button",
    on: {
      "click": _vm.onClick
    }
  }, [((_vm.crud === 'vds' || _vm.crud === 'domains' || _vm.crud === 'operation') &&
    (_vm.name === 'sshkey_id' || _vm.name === 'create_iso' || _vm.name === 'person_id' || _vm.name === 'payer')) ? _c('font-awesome-icon', {
    attrs: {
      "icon": "plus-circle"
    }
  }) : _vm._e(), _vm._v("\n\t" + _vm._s(_vm._f("ftc")(_vm.text)) + "\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(402),
  /* scopeId */
  "data-v-b909bb32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'countryComponent',

	props: ['value', 'items', 'action', 'crud', 'readonly'],
	data: function data() {
		return {
			curValue: null,
			showedTopHintId: null
		};
	},
	created: function created() {
		if (this.crud === 'disks') {
			this.initValue();
		}
	},

	methods: {
		onItemClick: function onItemClick(id, enable) {
			if (this.readonly) return;

			this.$emit('focus');

			if (!enable) return;

			this.curValue = String(id);

			this.$emit('input', this.curValue);
		},
		initValue: function initValue() {
			var value = null;

			if (this.items && this.items.length) {
				this.items.some(function (item) {
					if (item.active === true && item.id) {
						value = String(item.id);
						return true;
					}
				});
			}

			this.curValue = value;
			this.$emit('input', this.curValue);
			this.$emit('startData', this.curValue);
		},
		mouseOver: function mouseOver(item) {
			if (!item || item.active) return;
			if (this.showedTopHintId === item.id) return;
			this.showedTopHintId = item.id;
		},
		mouseLeave: function mouseLeave() {
			this.showedTopHintId = null;
		}
	},

	watch: {
		'value': function value(_value) {
			this.curValue = String(_value);
		},

		'items': function items(_items) {
			this.initValue();
		}
	}
});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action !== 'create') ? _c('div', {
    staticClass: "w5-component-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('datacenter/datacenter')) + ":")]) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('div', {
    staticClass: "w5-vds-plan-list-block country",
    style: (_vm.readonly ? 'opacity: 0.6' : null)
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item",
      class: {
        'selected': item.id == _vm.curValue, 'disabled': item.active === false, 'readonly-item': this.readonly
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item.id, item.active)
        }
      }
    }, [_c('div', {
      staticClass: "left-part"
    }, [_c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + item['country']
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item['name'])))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "w5-field-top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('service/no_hardware')),
        expression: "localeFtc('service/no_hardware')"
      }]
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(406),
  /* scopeId */
  "data-v-15e7db82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'backupChoiceComponent',

	props: {
		value: {
			required: true
		},
		list: {
			type: Array,
			required: true
		},
		action: {
			required: true
		},
		readonly: {
			type: Boolean
		}
	},

	data: function data() {
		return {
			curValue: null,
			showedTopHintId: null
		};
	},
	created: function created() {
		this.initValue();
	},

	methods: {
		initValue: function initValue() {
			var _this = this;

			this.curValue = null;

			var item = null;
			if (this.value && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value) === 'object' && 'id' in this.value) item = this.value;else {
				var id = String(this.value);
				if (this.list && this.list.length) {
					this.list.some(function (i) {
						if (i && String(i.id) === id) {
							item = i;
							return true;
						}
					});
				}
			}

			if (item && this.isEnabled(item)) this.curValue = String(item.id);

			if (this.list && this.list.length && window && window.sessionStorage) {
				var _crtFromBackup = window.sessionStorage.getItem('create-outer-disk-from-backup');
				if (_crtFromBackup) {
					window.sessionStorage.removeItem('create-outer-disk-from-backup');

					var _crtStore = null;
					try {
						_crtStore = JSON.parse(_crtFromBackup);
					} catch (e) {
						_crtStore = null;
					}

					if (_crtStore && _crtStore.service_id) {
						this.list.some(function (b) {
							if (b && String(b.id) === String(_crtStore.service_id)) {
								_this.curValue = String(b.id);
								_this.$emit('input', _this.curValue);
								return true;
							}
						});
					}
				}
			}
		},
		onItemClick: function onItemClick(item) {
			this.$emit('focus');

			if (!item || !item.id || !this.isEnabled(item)) return;

			if (this.curValue === String(item.id)) {
				this.curValue = null;
				this.$emit('input', null);
				return;
			}

			this.curValue = String(item.id);
			this.$emit('input', item.id);
		},
		mouseOver: function mouseOver(item) {
			if (!item || this.isEnabled(item)) return;
			if (this.showedTopHintId === item.id) return;
			this.showedTopHintId = item.id;
		},
		mouseLeave: function mouseLeave() {
			this.showedTopHintId = null;
		},
		makeReason: function makeReason(item) {
			if (!item) return;

			if (!item.active) return this.localeFtc('service/not_active');

			if (!item.enable || !item.plans || !item.plans.length) return this.localeFtc('backup/create_vds_error');

			return '';
		},
		isEnabled: function isEnabled(Item) {
			var item = null;
			if (Item && (typeof Item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Item)) === 'object' && 'id' in Item) item = Item;else {
				var id = String(Item);
				this.list.some(function (i) {
					if (i && String(i.id) === id) {
						item = i;
						return true;
					}
				});
			}

			return item && item.id && item.enable && item.active;
		},
		generateTitle: function generateTitle(item) {
			var title = '';
			if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) !== 'object') return title;

			if (item.id) title = '#' + item.id;
			if (item.name) title += (title ? ' ' : '') + this.localeFtc(item.name);
			if (item.size || item.created) title += '\n';
			if (item.size) title += this.localeFtc('service/iso_size') + ': ' + item.size + (item.created ? ', ' : '');
			if (item.created) title += this.localeFtc('main/created') + ': ' + this.formater_StrDateFormat(item.created, 'd.m.Y');

			return title;
		}
	},

	watch: {
		value: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		},
		list: {
			handler: function handler() {
				this.initValue();
			},
			immediate: true
		}
	}

});

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-weight": "400",
      "margin-bottom": "4px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/backup')) + ":")]), _vm._v(" "), (_vm.list && _vm.list.length) ? _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'selected': String(item.id) === _vm.curValue,
          'disabled': !_vm.isEnabled(item)
      },
      attrs: {
        "title": _vm.generateTitle(item)
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item)
        }
      }
    }, [(item['image'] && item['image'].length) ? _c('div', {
      staticClass: "left-part"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + item['image']
      }
    })]) : _c('div', {
      staticClass: "left-part clmn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [(item['name']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v("#" + _vm._s(item['id']) + " " + _vm._s(_vm._f("ftc")(item['name'])))]) : _vm._e(), _vm._v(" "), (item['size'] || item['created']) ? _c('br') : _vm._e(), _vm._v(" "), (item.datacenter_country) ? _c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + item.datacenter_country,
      staticStyle: {
        "width": "12px",
        "top": "-1px",
        "margin-right": "3px"
      },
      attrs: {
        "alt": _vm._f("ftc")(item.datacenter_name || item.datacenter_country),
        "title": _vm._f("ftc")(item.datacenter_name || item.datacenter_country)
      }
    }) : _vm._e(), _vm._v(" "), (item['size']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso_size')) + ": " + _vm._s(item['size']))]) : _vm._e(), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')) + ": " + _vm._s(_vm._f("date")(item['created'], 'd.m.Y')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.makeReason(item)),
        expression: "makeReason(item)"
      }]
    })])])
  }), 0) : _c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")('service/backup_list_empty')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'radioListComponent',

	props: ['title', 'required', 'value', 'items', 'disabled'],

	data: function data() {
		return {
			Value: null
		};
	},
	created: function created() {
		this.Init();
	},

	methods: {
		Init: function Init() {
			var _this = this;

			if (this.disabled) return;

			this.Value = null;

			var _firstItem = null;
			if (this.items && this.items.length) {
				this.items.some(function (item) {
					if (!_firstItem) _firstItem = item;
					if (_this.value === String(item.id)) {
						_this.Value = item;
						return true;
					}
				});
			}

			if (_firstItem && !this.Value) this.Value = _firstItem;

			if (this.Value && this.Value.id) this.$emit('startData', String(this.Value.id));

			this.$emit('input', this.Value && this.Value.id ? String(this.Value.id) : null);
		},
		onClickItem: function onClickItem(val) {
			if (this.disabled) return;

			this.Value = val;
			this.$emit('input', this.Value && this.Value.id ? String(this.Value.id) : null);
		}
	},

	watch: {
		'items': function items(_items, old) {
			if (!__WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].arrayCompare(_items, old)) this.Init();
		},
		'value': function value(val) {
			this.Init();
		}
	}

});

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-field-wrapper"
  }, _vm._l((_vm.items), function(item, idx) {
    return (item) ? _c('div', {
      key: idx,
      staticClass: "item",
      class: {
        'selected': _vm.Value && (_vm.Value === item || _vm.Value.id === item.id)
      },
      on: {
        "click": function($event) {
          return _vm.onClickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "choice"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.name)))])]) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_inputmask__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_inputmask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_inputmask__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'manualDateComponent',

	props: ['value'],

	data: function data() {
		return {
			Value: null
		};
	},
	created: function created() {
		this.Init(this.value);
	},
	mounted: function mounted() {
		this.$el.value = this.Value;
		__WEBPACK_IMPORTED_MODULE_1_inputmask___default()({
			mask: '99.99.9999',
			placeholder: '_',
			showMaskOnHover: false,
			undoOnEscape: false
		}).mask(this.$el);
	},

	methods: {
		Init: function Init(value) {
			var _val = null;
			if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && value instanceof Date && 'getMonth' in value) _val = this.formater_Date2StrDate(value);else _val = String(value);

			if (/^\d{2}.\d{2}.\d{4}/.test(_val)) this.Value = _val.substr(0, 10);else if (/^\d{4}-\d{2}-\d{2}/.test(_val)) {
				this.Value = _val.substr(8, 2) + '.' + _val.substr(5, 2) + '.' + _val.substr(0, 4);
			}
		},
		onFocus: function onFocus() {
			this.$emit('focus');
		},
		onBlur: function onBlur() {
			var _val = this.makeValue(this.Value);
			if (_val === 'not-date') this.$emit('error', 'person/error_date');
			this.$emit('blur');
		},
		onKeyDown: function onKeyDown(e) {
			if (e.keyCode === 13 || e.which === 13) this.$emit('keydownEnter');
		},
		onInput: function onInput(event) {
			this.Value = event && event.target && 'value' in event.target ? event.target.value : null;
			this.$emit('error', '');
			this.$emit('input', this.makeValue(this.Value));
		},
		validateValue: function validateValue(Value) {
			if (!Value) return false;

			var _match = Value.match(/^(\d{2}).(\d{2}).(\d{4})$/);
			if (!_match) return false;

			var _day = parseInt(_match[1]);
			var _month = parseInt(_match[2]);
			var _year = parseInt(_match[3]);

			if (isNaN(_day) || isNaN(_month) || isNaN(_year)) return false;
			if (_day < 1 || _day > 31) return false;
			if (_month < 1 || _month > 12) return false;

			var _date = new Date(_year, _month - 1, _day);
			return Boolean(+_date) && _date.getDate() === _day && _date.getMonth() === _month - 1;
		},
		makeValue: function makeValue(MaskedValue) {
			var _result = 'not-date';

			if (MaskedValue) {
				var _val = String(MaskedValue).trim().replace(/_/g, '');
				if (this.validateValue(_val)) _result = _val.substr(6, 4) + '-' + _val.substr(3, 2) + '-' + _val.substr(0, 2) + ' 00:00:00';else if (!_val) _result = null;
			} else _result = null;

			return _result;
		}
	}

});

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown,
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inputmask__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inputmask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inputmask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_phone_codes_json__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_phone_codes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_phone_codes_json__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'phoneComponent',

	props: ['value', 'name'],

	data: function data() {
		return {
			Value: '',
			phoneCodes: __WEBPACK_IMPORTED_MODULE_1__assets_phone_codes_json___default.a
		};
	},
	created: function created() {
		if (this.value && typeof this.value === 'string') this.Value = this.value.replace(/[+()_\s]/g, '');
	},
	mounted: function mounted() {
		var _this = this;

		this.$el.value = this.Value;

		__WEBPACK_IMPORTED_MODULE_0_inputmask___default()({
			mask: function mask() {
				return _this.mask();
			},
			skipOptionalPartCharacter: ' ',
			clearMaskOnLostFocus: true,
			greedy: false,
			placeholder: ' ',
			showMaskOnHover: false,
			undoOnEscape: false
		}).mask(this.$el);
	},

	methods: {
		searchPrefix: function searchPrefix() {
			for (var i = 4; i >= 1; i--) {
				var prefix = this.Value.substr(0, i);
				if (this.phoneCodes[prefix]) return prefix;
			}

			return '';
		},
		mask: function mask() {
			var prefix = this.searchPrefix();
			var len = prefix.length;
			var max = this.phoneCodes[prefix] && this.phoneCodes[prefix].max ? this.phoneCodes[prefix].max : 0;

			if (max === 10) {
				if (len === 1) return '+9 999 999999';

				if (len === 2) return '+99 999 99999';

				if (len === 3) return '+999 99 99999';

				if (len === 4) return '+9999 99 9999';
			} else if (max === 11) {
				if (len === 1) return '+9 999 999999[9]';

				if (len === 2) return '+99 999 99999[9]';

				if (len === 3) return '+999 999 9999[9]';

				if (len === 4) return '+9999 999 999[9]';
			} else if (max === 12) {
				if (len === 1) return '+9 9999 999999[9]';

				if (len === 2) return '+99 9999 99999[9]';

				if (len === 3) {
					if (prefix === '380') return '+999 999 99999[9]';
					return '+999 9999 9999[9]';
				}

				if (len === 4) return '+9999 9999 999[9]';
			} else if (max === 13) {
				if (len === 1) return '+9 9999 9999999[9]';

				if (len === 2) return '+99 9999 999999[9]';

				if (len === 3) return '+999 9999 99999[9]';

				if (len === 4) return '+9999 9999 9999[9]';
			} else if (max === 14) {
				if (len === 1) return '+9 9999 9999999[99]';

				if (len === 2) return '+99 9999 999999[99]';

				if (len === 3) return '+999 9999 99999[99]';

				if (len === 4) return '+9999 9999 9999[99]';
			}

			return '+9999 9999 999999';
		},
		onFocus: function onFocus() {
			this.$emit('focus');
		},
		onBlur: function onBlur() {
			this.$emit('blur');
		},
		onKeyDown: function onKeyDown(e) {
			this.$emit('keydownEnter');
		},
		onInput: function onInput(event) {
			var oldPrefix = this.searchPrefix();
			this.Value = this.$el.inputmask.unmaskedvalue();
			var newPrefix = this.searchPrefix();

			if (oldPrefix !== newPrefix) {
				this.$el.inputmask.option({ mask: this.mask() });
			}

			this.$emit('error', '');
			this.$emit('input', String(event.target.value).trim());
		}
	}

});

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = {"1":{"max":11},"7":{"max":11},"20":{"max":12},"21":{"max":9},"27":{"max":11},"30":{"max":10},"31":{"max":12},"32":{"max":10},"33":{"max":11},"34":{"max":11},"36":{"max":11},"39":{"max":12},"40":{"max":11},"41":{"max":11},"43":{"max":12},"44":{"max":12},"45":{"max":10},"46":{"max":13},"47":{"max":10},"48":{"max":11},"49":{"max":13},"51":{"max":11},"52":{"max":13},"53":{"max":10},"54":{"max":12},"55":{"max":13},"56":{"max":11},"57":{"max":12},"58":{"max":12},"60":{"max":12},"61":{"max":11},"62":{"max":14},"63":{"max":12},"64":{"max":11},"65":{"max":10},"66":{"max":11},"81":{"max":12},"82":{"max":12},"84":{"max":12},"86":{"max":13},"90":{"max":12},"91":{"max":13},"92":{"max":12},"93":{"max":11},"94":{"max":11},"95":{"max":12},"98":{"max":12},"189":{"max":11},"212":{"max":12},"213":{"max":12},"216":{"max":11},"220":{"max":10},"221":{"max":12},"222":{"max":12},"223":{"max":11},"224":{"max":12},"225":{"max":11},"226":{"max":11},"227":{"max":11},"228":{"max":11},"229":{"max":11},"230":{"max":12},"231":{"max":12},"232":{"max":11},"233":{"max":12},"234":{"max":13},"235":{"max":12},"236":{"max":11},"237":{"max":12},"238":{"max":10},"239":{"max":10},"240":{"max":10},"241":{"max":11},"242":{"max":12},"243":{"max":12},"244":{"max":12},"245":{"max":12},"246":{"max":12},"247":{"max":12},"248":{"max":12},"249":{"max":12},"250":{"max":12},"251":{"max":12},"252":{"max":12},"253":{"max":12},"254":{"max":12},"255":{"max":12},"256":{"max":12},"257":{"max":11},"258":{"max":12},"259":{"max":12},"260":{"max":12},"261":{"max":12},"262":{"max":12},"263":{"max":12},"264":{"max":12},"265":{"max":12},"266":{"max":12},"267":{"max":11},"268":{"max":11},"269":{"max":10},"291":{"max":12},"297":{"max":10},"298":{"max":12},"299":{"max":12},"350":{"max":12},"351":{"max":12},"352":{"max":14},"353":{"max":12},"354":{"max":12},"355":{"max":12},"356":{"max":11},"357":{"max":11},"358":{"max":10},"359":{"max":12},"370":{"max":11},"371":{"max":12},"372":{"max":11},"373":{"max":11},"374":{"max":11},"375":{"max":12},"376":{"max":12},"377":{"max":12},"378":{"max":12},"380":{"max":12},"381":{"max":12},"382":{"max":12},"383":{"max":11},"385":{"max":12},"386":{"max":11},"387":{"max":12},"389":{"max":11},"420":{"max":12},"421":{"max":13},"500":{"max":12},"501":{"max":10},"502":{"max":11},"503":{"max":11},"504":{"max":11},"505":{"max":11},"506":{"max":11},"507":{"max":11},"508":{"max":12},"509":{"max":11},"590":{"max":12},"591":{"max":11},"592":{"max":10},"593":{"max":12},"594":{"max":12},"595":{"max":12},"596":{"max":12},"597":{"max":10},"598":{"max":11},"599":{"max":11},"670":{"max":12},"671":{"max":12},"672":{"max":12},"673":{"max":12},"674":{"max":10},"675":{"max":11},"676":{"max":10},"677":{"max":12},"678":{"max":10},"679":{"max":10},"680":{"max":12},"681":{"max":12},"682":{"max":12},"683":{"max":12},"684":{"max":12},"685":{"max":10},"686":{"max":12},"687":{"max":12},"688":{"max":12},"689":{"max":12},"690":{"max":12},"691":{"max":12},"692":{"max":12},"850":{"max":12},"852":{"max":11},"853":{"max":12},"855":{"max":12},"856":{"max":13},"880":{"max":13},"886":{"max":12},"960":{"max":12},"961":{"max":11},"962":{"max":12},"963":{"max":12},"964":{"max":13},"965":{"max":11},"966":{"max":12},"967":{"max":12},"968":{"max":11},"969":{"max":12},"970":{"max":12},"971":{"max":12},"972":{"max":12},"973":{"max":11},"974":{"max":11},"975":{"max":11},"976":{"max":12},"977":{"max":13},"992":{"max":12},"993":{"max":12},"994":{"max":12},"995":{"max":13},"996":{"max":12},"998":{"max":12},"1242":{"max":11},"1246":{"max":11},"1264":{"max":11},"1268":{"max":11},"1284":{"max":11},"1340":{"max":11},"1345":{"max":11},"1441":{"max":11},"1473":{"max":11},"1649":{"max":11},"1664":{"max":11},"1670":{"max":11},"1671":{"max":11},"1684":{"max":11},"1758":{"max":11},"1767":{"max":11},"1784":{"max":11},"1787":{"max":12},"1809":{"max":12},"1868":{"max":11},"1869":{"max":11},"1876":{"max":12}}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeyDown($event)
      },
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_date__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'passportComponent',

	props: ['title', 'required', 'readonly', 'value', 'name', 'errorMessage'],

	data: function data() {
		return {
			fields: {
				ser: {
					focused: false,
					title: 'passport/series',
					hint: 'person/pattern: 1234',
					value: ''
				},
				num: {
					focused: false,
					title: 'passport/number',
					hint: 'person/pattern: 123456',
					value: ''
				},
				issuer: {
					focused: false,
					title: 'passport/who',
					hint: 'person/pattern: 48 отделом милиции г. Москвы',
					value: ''
				},
				date: {
					focused: false,
					title: 'passport/when',
					hint: 'person/pattern: 31.12.2000',
					value: null
				}
			},
			Value: null,
			country: null
		};
	},
	created: function created() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$on('w5-get-field-value-answer', this.countryValue);
		this.Init();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-get-field-value', this.name.replace('passport', 'country'));
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$off('w5-get-field-value-answer', this.countryValue);
	},

	methods: {
		Init: function Init() {
			if (this.value !== undefined && this.value !== null) {
				var _match = String(this.value).match(/^([0-9 a-zA-Z\-а-яёА-ЯЁ]+) выдан (.{4,}), (\d{2}\.\d{2}\.\d{4})$/i);
				if (_match && _match.length === 4) {
					this.fields.issuer.value = _match[2];
					this.fields.date.value = _match[3];

					if (this.country === 'RU') {
						this.fields.num.title = 'Номер';
						this.fields.num.hint = 'person/pattern: 123456';

						if (_match[1].indexOf(' ') > -1) {
							var _parts = _match[1].split(' ');
							this.fields.num.value = _parts.pop();
							this.fields.ser.value = _parts.join(' ');
						} else {
							this.fields.num.value = _match[1];
						}
					} else {
						this.fields.num.title = 'Серия и/или номер';
						this.fields.num.hint = 'person/pattern: 1234 123456';
						this.fields.num.value = _match[1];
					}
				}
				this.makeValue();
			}
		},
		onFocus: function onFocus(fieldName) {
			this.fields[fieldName].focused = true;
			this.fields[fieldName].error = '';

			this.$emit('focus');
		},
		onBlur: function onBlur(fieldName) {
			this.fields[fieldName].focused = false;
			this.makeValue();

			if (this.Value) {
				if (fieldName === 'date' && this.fields.date.value === 'not-date') {
					this.fields.date.error = 'person/error_date';
					return;
				}

				if (this.country === 'RU') {
					if (!this.fields.ser.value || !this.fields.num.value) return this.$emit('error', 'person/error_passport_reg');
				} else {
					if (!this.fields.num.value) return this.$emit('error', 'person/error_passport_reg');
				}
			}

			this.$emit('blur');
		},
		enterKeyDown: function enterKeyDown(e) {
			this.$emit('enterKeyDown', e);
		},
		onDateError: function onDateError(text) {
			if (text && this.fields.date.error !== text) this.fields.date.error = text;
		},
		onInput: function onInput(what, event) {
			if (!what) return;

			if (event && event.target && (what === 'ser' || what === 'num' || what === 'issuer')) this.$set(this.fields[what], 'value', event.target.value);

			this.makeValue();
			this.$emit('input', this.Value);
		},
		fieldVisibility: function fieldVisibility(name) {
			if (name !== 'ser') return true;
			return this.country === 'RU';
		},
		countryValue: function countryValue(data) {
			if (!data || !data.name) return;
			if (data.name !== this.name.replace('passport', 'country')) return;

			this.country = data.value ? data.value : null;
			this.Init();
		},
		makeValue: function makeValue() {
			if (this.country === 'RU') {
				this.Value = this.fields.ser.value;
				if (this.fields.num.value) this.Value += ' ' + this.fields.num.value;
			} else {
				this.Value = this.fields.num.value;
			}

			if (this.fields.issuer.value) this.Value += ' выдан ' + this.fields.issuer.value;
			if (this.fields.date.value) {
				if (/^\d{2}.\d{2}.\d{4}/.test(this.fields.date.value)) this.Value += ', ' + this.fields.date.value;else if (/^\d{4}-\d{2}-\d{2}/.test(this.fields.date.value)) {
					var _val = this.fields.date.value;
					_val = _val.substr(8, 2) + '.' + _val.substr(5, 2) + '.' + _val.substr(0, 4);
					this.Value += ', ' + _val;
				}
			}
		}
	},

	components: {
		manualDateComponent: __WEBPACK_IMPORTED_MODULE_0__components_elements_date___default.a
	}

});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passport-field"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, _vm._l((_vm.fields), function(field, idx) {
    return (_vm.fieldVisibility(idx)) ? _c('div', {
      key: idx,
      staticClass: "w5-field",
      class: idx + (idx === 'num' && _vm.country !== 'RU' ? ' union' : '')
    }, [_c('div', {
      staticClass: "w5-field-placeholder",
      class: {
        'active': field.focused || field.value, 'readonly': _vm.readonly === true
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(field.title))), (_vm.required) ? _c('span', {
      staticClass: "required-field"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), (idx === 'date') ? [_c('manualDateComponent', {
      class: {
        'haserror': _vm.errorMessage || field.error
      },
      attrs: {
        "disabled": _vm.readonly === true ? 'disabled' : false
      },
      on: {
        "error": _vm.onDateError,
        "focus": function($event) {
          return _vm.onFocus('date')
        },
        "blur": function($event) {
          return _vm.onBlur('date')
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.enterKeyDown($event)
        },
        "input": function($event) {
          return _vm.onInput('date', $event)
        }
      },
      model: {
        value: (_vm.fields.date.value),
        callback: function($$v) {
          _vm.$set(_vm.fields.date, "value", $$v)
        },
        expression: "fields.date.value"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.error),
        expression: "field.error"
      }, {
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc(field.error)),
        expression: "localeFtc(field.error)"
      }],
      staticClass: "alert alert-danger w5-alert-valid",
      attrs: {
        "role": "alert"
      }
    })] : (_vm.fieldVisibility(idx)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      ref: idx,
      refInFor: true,
      class: {
        'haserror': _vm.errorMessage || _vm.fields.date.error
      },
      attrs: {
        "type": "text",
        "disabled": _vm.readonly === true ? 'disabled' : false
      },
      domProps: {
        "value": (field.value)
      },
      on: {
        "focus": function($event) {
          return _vm.onFocus(idx)
        },
        "blur": function($event) {
          return _vm.onBlur(idx)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.enterKeyDown($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "value", $event.target.value)
        }, function($event) {
          return _vm.onInput(idx, $event)
        }]
      }
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.focused && !field.error),
        expression: "field.focused && !field.error"
      }],
      staticClass: "w5-tooltip-wrapper"
    }, [_c('span', {
      staticClass: "w5-tooltip"
    }, [_vm._v(_vm._s(_vm._f("ftc")(field.hint)))])])])], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && !_vm.fields.date.error),
      expression: "errorMessage && !fields.date.error"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorMessage)),
      expression: "localeFtc(errorMessage)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  "data-v-ad33f076",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'addressComponent',

	props: ['title', 'required', 'readonly', 'name', 'crud', 'value', 'validator', 'errorMessage', 'disabled'],

	data: function data() {
		return {
			fields: {
				index: {
					focused: false,
					title: this.localeFtc('mail/postcode'),
					Title: this.localeFtc('mail/postcode'),
					hint: 'person/pattern: 101000',
					value: ''
				},
				address: {
					focused: false,
					title: this.localeFtc('mail/address'),
					Title: this.localeFtc('mail/address'),
					hint: 'person/pattern: Москва, ул. Воробьянинова, д. 15, кв. 22',
					value: ''
				},
				receiver: {
					focused: false,
					title: 'main/whom',
					Title: 'main/whom',
					hint: 'person/pattern: Лоханкину Денису Валерьяновичу',
					value: ''
				}
			},
			Value: null
		};
	},
	created: function created() {
		this.Init(this.value);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-copy-address-field-value', this.onChangeValueEvent);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-copy-address-field-value', this.onChangeValueEvent);
	},

	methods: {
		fieldVisibility: function fieldVisibility(fieldName) {
			if (fieldName === 'index' || fieldName === 'address') return true;

			return this.validator === 'address_post_russian';
		},
		needCopyButton: function needCopyButton(fieldName) {
			if (this.crud === 'person' && fieldName === 'address' && !this.fieldVisibility('receiver')) return true;

			if (this.crud === 'payer' && fieldName === 'address' && !this.fieldVisibility('receiver') && this.name.indexOf('post_addr') < 0) return true;

			return false;
		},
		Init: function Init(Value) {
			this.fields.index.value = '';
			this.fields.address.value = '';
			this.fields.receiver.value = '';

			this.fields.address.title = this.title;

			if (Value !== undefined && Value !== null) {
				var _parts = String(Value).split(',');
				if (_parts.length === 1) {
					this.fields.index.value = _parts[0];
				} else if (_parts.length === 2) {
					this.fields.index.value = _parts[0].trim();
					this.fields.address.value = _parts[1].trim();
				} else if (_parts.length >= 3) {
					var _end = '';
					this.fields.index.value = _parts.shift().trim();
					if (this.fieldVisibility('receiver')) {
						var _tmp = '';
						var _words = _parts.pop().trim().split(' ');

						for (var _idx = _words.length - 1; _idx >= 0; _idx--) {
							if (/^[а-яёa-z.-]+$/i.test(_words[_idx])) {
								_tmp = (_words[_idx] + ' ' + _tmp).trim();
							} else {
								_end = _words.slice(0, _idx + 1).join(' ').trim();
								break;
							}
						}

						this.fields.receiver.value = _tmp;
					}
					this.fields.address.value = (_parts.join(',').trim() + ' ' + _end).trim();
				}

				this.makeValue();
			}
		},
		onChangeValueEvent: function onChangeValueEvent(data) {
			if (!data || !data.fields || data.name !== this.name) return;

			this.fields.index.value = data.fields.index && data.fields.index.value ? data.fields.index.value : '';
			this.fields.address.value = data.fields.address && data.fields.address.value ? data.fields.address.value : '';

			this.makeValue();
			this.$emit('input', this.Value);
		},
		onFocus: function onFocus(fieldName) {
			this.fields[fieldName].focused = true;
			this.fields[fieldName].error = '';
			this.$emit('focus');
		},
		onBlur: function onBlur(fieldName) {
			this.fields[fieldName].focused = false;
			this.$emit('blur');
		},
		enterKeyDown: function enterKeyDown(e) {
			this.$emit('enterKeyDown', e);
		},
		onInput: function onInput(what, event) {
			if (!what) return;

			if (event && event.target && this.fields[what]) {
				var _val = event.target.value;
				if (what === 'receiver') _val = String(_val).replace(/[^ а-яёa-z.-]/ig, '');

				this.$set(this.fields[what], 'value', _val);

				this.makeValue();
				this.$emit('input', this.Value);
			}
		},
		makeValue: function makeValue() {
			this.Value = this.fields.index.value;
			if (this.fields.address.value) this.Value += ', ' + this.fields.address.value;
			if (this.fieldVisibility('receiver') && this.fields.receiver.value) this.Value += ', ' + this.fields.receiver.value;
		},
		copyAddress: function copyAddress() {
			if (this.readonly) return;
			this.$emit('copyAddress', this.fields);
		}
	}

});

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passport-field"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, _vm._l((_vm.fields), function(field, idx) {
    return (_vm.fieldVisibility(idx)) ? _c('div', {
      key: idx,
      staticClass: "w5-field",
      class: idx
    }, [_c('div', {
      staticClass: "w5-field-placeholder",
      class: {
        'active': field.focused || field.value, 'readonly': _vm.readonly
      }
    }, [_c('span', {
      staticClass: "short-title"
    }, [_vm._v(_vm._s(_vm._f("ftc")(field.title))), (_vm.required) ? _c('span', {
      staticClass: "required-field"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "long-title"
    }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.title + ': ' + _vm.localeFtc(field.Title).toLowerCase()))), (_vm.required) ? _c('span', {
      staticClass: "required-field"
    }, [_vm._v(" *")]) : _vm._e()])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      ref: idx,
      refInFor: true,
      class: {
        'padded-for-btn': _vm.needCopyButton(idx), 'haserror': _vm.errorMessage
      },
      attrs: {
        "type": "text",
        "disabled": _vm.readonly === true ? 'disabled' : false
      },
      domProps: {
        "value": (field.value)
      },
      on: {
        "focus": function($event) {
          return _vm.onFocus(idx)
        },
        "blur": function($event) {
          return _vm.onBlur(idx)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.enterKeyDown($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "value", $event.target.value)
        }, function($event) {
          return _vm.onInput(idx, $event)
        }]
      }
    }), _vm._v(" "), (_vm.needCopyButton(idx) && !_vm.readonly) ? _c('div', {
      staticClass: "field-button-wrapper field-button-password-wrapper",
      attrs: {
        "title": _vm._f("ftc")('main/copy')
      },
      on: {
        "click": _vm.copyAddress
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "copy"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.focused && !field.error),
        expression: "field.focused && !field.error"
      }],
      staticClass: "w5-tooltip-wrapper"
    }, [_c('span', {
      staticClass: "w5-tooltip"
    }, [_vm._v(_vm._s(_vm._f("ftc")(field.hint)))])])])], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorMessage)),
      expression: "localeFtc(errorMessage)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'savedPaymentsComponent',

	props: ['value', 'items', 'title', 'crud', 'action', 'readonly'],

	computed: {
		currentItem: function currentItem() {
			var _this = this;

			if (!this.items || !this.items.length || !this.curValue) return null;
			var item = null;
			this.items.some(function (i) {
				if (i && i.id === _this.curValue) {
					item = i;
					return true;
				}
			});

			return item;
		}
	},

	data: function data() {
		return {
			curValue: null,
			curSumma: 0,
			Props: {}
		};
	},
	created: function created() {
		var _this2 = this;

		if (this.items && this.items.length) {
			this.items.forEach(function (item) {
				_this2.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				};
			});
		}

		if (this.value !== undefined && this.value !== null) this.curValue = this.value;
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$on('form-client-operation-create', this.summaChanged);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$off('form-client-operation-create', this.summaChanged);
	},

	methods: {
		onItemClick: function onItemClick(id) {
			var isNextStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			this.$emit('focus');

			if (!this.Props[id] || this.Props[id]['summa'] === undefined || this.Props[id]['summa'] === null || isNaN(this.Props[id]['summa']) || this.Props[id]['summa'] <= 0) {
				return;
			}

			var _item = null;
			this.items.some(function (item) {
				if (String(item.id) === String(id)) {
					_item = item;
					return true;
				}
			});

			if (!_item) {
				return;
			}

			if (this.$store.state.user_type !== 'admin' && this.Props[id]['active'] !== true) {
				return;
			}

			if (this.Props[id]['disabled'] === true) {
				return;
			}

			this.curValue = id;

			this.$emit('input', this.curValue);
		},
		summaChanged: function summaChanged(summa) {
			if (summa === undefined || summa === null || isNaN(summa)) summa = 0;
			if (String(summa).length === 0) summa = 0;

			summa = parseFloat(summa);

			this.$set(this, 'curSumma', summa);

			this.recountSum();

			this.$forceUpdate();
		},
		recountSum: function recountSum() {
			var _this3 = this;

			if (!this.items || !this.items.length) return;
			if (!this.Props || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.Props).length) return;

			var curPayment = null;

			this.items.forEach(function (item) {
				if (item && String(item.id) === String(_this3.curValue)) {
					curPayment = item;
				}

				var _com = item['comission'];
				if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0;
				_com = parseFloat(_com);

				var _price = (_this3.curSumma + _com * _this3.curSumma / 100.0).toFixed(2);
				_price = parseFloat(_price);

				_this3.Props[item['id']]['summa'] = _price;

				var _min = item['min'];
				if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0;
				_min = parseFloat(_min);

				var _max = item['max'];
				if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0;
				_max = parseFloat(_max);

				if (_this3.curSumma <= 0 || _this3.curSumma < _min || _max && _this3.curSumma > _max) {
					_this3.Props[item['id']]['disabled'] = true;
					_this3.Props[item['id']]['error'] = 'request/status_error: ' + (_max && _this3.curSumma > _max ? 'payment/max' : 'payment/min');
				} else {
					_this3.Props[item['id']]['disabled'] = false;
					_this3.Props[item['id']]['error'] = '';
				}
			});

			if (curPayment && curPayment.id) {
				if (curPayment.active !== true || this.Props[curPayment.id].disabled === true) {
					if (this.crud === 'paymentauto' && this.action === 'update' && this.readonly) {
						__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-set-error-message', {
							field: 'summa',
							text: this.formater_capitalizeFirstChar(this.localeFtc(this.Props[curPayment['id']]['error']))
						});

						return;
					}

					this.$emit('input', null);
				} else this.$emit('input', this.curValue);
			}
		},
		getMin: function getMin(item) {
			if (!item || !('min' in item) || item.min < 0) return null;
			return item.min;
		},
		getMax: function getMax(item) {
			if (!item || !('max' in item) || item.max < 0) return null;
			if (item.max >= 1000000) return null;
			return item.max;
		},
		deleteSavedPayment: function deleteSavedPayment(id) {
			if (!this.Props[id] || !this.Props[id].active || this.Props[id].disabled) return;

			this.$emit('deleteSavedPayment', id);
		}
	},

	watch: {
		'value': function value(_value) {
			this.curValue = _value;
			this.recountSum();
		},
		'items': function items(_items) {
			var _this4 = this;

			if (!_items || !_items.length) return;

			_items.forEach(function (item) {
				_this4.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				};
			});

			this.recountSum();
		}
	}

});

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-wrapper spc"
  }, [(_vm.items && _vm.items.length) ? _vm._l(((_vm.readonly ? _vm.items.filter(function (fi) { return fi.id == _vm.curValue; }) : _vm.items)), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "spc__item",
      class: {
        'selected': item.id == _vm.curValue,
          'disabled': _vm.readonly || _vm.Props[item['id']]['disabled'],
          'not-active-item': item.active !== true,
          'narrow': _vm.crud === 'paymentauto' && _vm.action === 'create'
      },
      on: {
        "click": function($event) {
          return _vm.onItemClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "spc__item-text"
    }, [_c('div', {
      staticClass: "spc__item-name"
    }, [_c('div', {
      staticClass: "spc__item-logo"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + item.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "spc__item-pay-name"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.name)))])])]), _vm._v(" "), _c('div', {
      staticClass: "spc__item-info"
    }, [(item['comission'] > 0) ? _c('div', {
      staticClass: "spc__item-selector-info"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/comission')) + ": " + _vm._s(item['comission']) + "%\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item['bonus'] > 0) ? _c('div', {
      staticClass: "spc__item-selector-info"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/bonus')) + ": " + _vm._s(item['bonus']) + "%\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sm-sum"
    }, [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.Props[item['id']]['summa'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" "), (_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " — " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.getMin(item) && !_vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_from')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (!_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_to')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "spc__item-trash",
      class: {
        empty: _vm.crud === 'paymentauto'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteSavedPayment(item.id)
        }
      }
    }, [(_vm.crud !== 'paymentauto') ? _c('font-awesome-icon', {
      attrs: {
        "icon": "trash-alt"
      }
    }) : _vm._e()], 1)])
  }) : (_vm.crud === 'paymentauto') ? void 0 : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'userRoleComponent',

	props: ['title', 'name', 'value', 'master', 'slave'],
	data: function data() {
		return {
			Items: {},
			checkValues: []
		};
	},
	created: function created() {
		if (this.master && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.master) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.master).length) {
			this.Items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.master);
		}

		if (this.slave && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.slave) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.slave).length) {
			for (var role in this.slave) {
				if (this.slave.hasOwnProperty(role)) {
					var _parts = role.split('/');
					var _master = _parts[0];
					if (!_master || !_parts[1]) continue;

					if (this.Items[_master] && this.Items[_master]['actions'][_parts[1]]) {
						if (!('roles' in this.Items[_master])) this.Items[_master]['roles'] = {};

						this.Items[_master]['roles'][_parts[1]] = this.Items[_master]['actions'][_parts[1]];
					}
				}
			}
		}

		if (this.value && Array.isArray(this.value) && this.value.length) this.checkValues = this.value;
	},

	methods: {
		selectStatus: function selectStatus(name, role) {
			var _isValue = false;
			if (role && role['actions']) {
				for (var action in role['actions']) {
					var _value = name + '/' + action;

					if (this.checkValues.indexOf(_value) > -1) {
						_isValue = true;
						break;
					}
				}
			}

			return _isValue ? 'main/deselect_all' : 'main/select_all';
		},
		selectDeselect: function selectDeselect(e, name, role) {
			this.$emit('focus');

			if (role && role['actions']) {
				var _status = this.selectStatus(name, role);

				for (var action in role['actions']) {
					var _value = name + '/' + action;

					var _idx = this.checkValues.indexOf(_value);

					if (_status === 'main/deselect_all') {
						if (_idx > -1) this.checkValues.splice(_idx, 1);
					} else if (_status === 'main/select_all') {
							if (_idx < 0) this.checkValues.push(_value);
						}
				}
			}
		}
	},

	watch: {
		checkValues: function checkValues(values) {
			this.$emit('focus');
			this.$emit('input', values);
		}
	}

});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "role-items-wrapper"
  }, _vm._l((_vm.Items), function(category, key) {
    return _c('div', {
      staticClass: "w5-role-wrapper"
    }, [_c('div', {
      staticClass: "w5-role-item-name"
    }, [_c('span', {
      attrs: {
        "title": _vm._f("ftc")(_vm.selectStatus(key, category))
      },
      on: {
        "click": function($event) {
          return _vm.selectDeselect($event, key, category)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(category.name)))])]), _vm._v(" "), _c('div', {
      staticClass: "w5-role-item-value"
    }, _vm._l((category.roles), function(role, action) {
      return _c('div', {
        staticClass: "w5-checkbox"
      }, [_c('label', {
        staticClass: "checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkValues),
          expression: "checkValues"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": key + '/' + action,
          "checked": Array.isArray(_vm.checkValues) ? _vm._i(_vm.checkValues, key + '/' + action) > -1 : (_vm.checkValues)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.checkValues,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = key + '/' + action,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.checkValues = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.checkValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkValues = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(_vm._f("ftc")(role)) + "\n\t\t\t\t")])])
    }), 0)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'myDateTimeComponent',

	props: ['value', 'disabled'],
	data: function data() {
		return {
			dateValue: null,
			timeValue: '00:00',
			valueSelected: false,

			showTimeChoicer: false,

			hTop: 0,
			hTimer: null,
			hModel: 0,
			hModelError: false,

			mTop: 0,
			mTimer: null,
			mModel: 0,
			mModelError: false,

			mouseWheelTimer: null,
			mouseWheelDelta: {
				'H': 0,
				'M': 0
			}
		};
	},

	components: {
		Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
	},
	created: function created() {
		this.init(this.value);
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);
	},

	watch: {
		value: function value(val) {
			this.init(val);
		}
	},

	methods: {
		init: function init(value) {
			this.dateValue = null;
			this.timeValue = '00:00';

			if (value) {
				var _div = value.indexOf(' ') > -1 ? ' ' : 'T';
				var _parts = value.split(_div);
				if (_parts[0] && /^\d{4}-\d{2}-\d{2}$/.test(_parts[0])) {
					this.dateValue = this.formater_StrDate2Date(_parts[0]);
				}
				if (_parts[1] && /^\d{2}:\d{2}:\d{2}$/.test(_parts[1])) {
					this.timeValue = _parts[1].substr(0, 5);
				}
			}

			var h = this.timeValue.substr(0, 2);
			var m = this.timeValue.substr(-2);

			h = parseInt(h);
			m = parseInt(m);

			this.hModel = h;
			this.mModel = m;

			this.hModelError = false;
			this.mModelError = false;
		},
		zeroTime: function zeroTime() {
			this.timeValue = '00:00';
			this.hModel = 0;
			this.mModel = 0;
			this.hModelError = false;
			this.mModelError = false;
			this.$emit('input', this.makeValue());
		},
		makeValue: function makeValue() {
			if (!this.dateValue) return null;
			return this.formater_Date2StrDate(this.dateValue) + ' ' + this.timeValue + ':00';
		},
		focusInput: function focusInput(what) {
			if (this.$refs['input' + what]) this.$refs['input' + what].select();
		},
		onDateSelect: function onDateSelect(e) {
			if (!e) this.init();else {
				this.valueSelected = true;
				var _val = this.formater_Date2StrDate(e) + ' ' + this.timeValue + ':00';
				this.init(_val);
			}

			this.$emit('input', this.makeValue());
		},
		onDateOpen: function onDateOpen() {
			this.$emit('focus');
			if (!this.value) {
				var _val = this.formater_Date2StrDate(new Date(), true);
				this.init(_val);
			}
		},
		onDateClose: function onDateClose(e) {
			if (this.valueSelected) {
				this.valueSelected = false;
				return;
			}
			if (!this.value) this.init();
		},
		onChangeModel: function onChangeModel(what) {
			var _val = void 0;
			if (what === 'H') {
				this.hModelError = false;
				_val = parseInt(this.hModel);
				if (isNaN(_val) || _val < 0 || _val > 23) this.hModelError = true;else {
					this.hTop = -35 * _val;
					this.$refs['hours'].style.top = this.hTop + 'px';
				}

				return;
			}

			this.mModelError = false;
			_val = parseInt(this.mModel);
			if (isNaN(_val) || _val < 0 || _val > 59) this.mModelError = true;else {
				this.mTop = -35 * _val;
				this.$refs['minutes'].style.top = this.mTop + 'px';
			}
		},
		timeChoicerShow: function timeChoicerShow() {
			if (this.disabled) return;
			var h = this.timeValue.substr(0, 2);
			var m = this.timeValue.substr(-2);

			h = parseInt(h);
			m = parseInt(m);

			this.hModel = h;
			this.mModel = m;

			this.hModelError = false;
			this.mModelError = false;

			this.hTop = -35 * h;
			this.mTop = -35 * m;

			this.$refs['hours'].style.top = this.hTop + 'px';
			this.$refs['minutes'].style.top = this.mTop + 'px';

			this.showTimeChoicer = true;

			this.$emit('focus');
		},
		timeChoicerValue: function timeChoicerValue() {
			var h = Math.abs(parseInt(this.hTop / 35));
			var m = Math.abs(parseInt(this.mTop / 35));
			this.hModel = h;
			this.mModel = m;
			this.hModelError = false;
			this.mModelError = false;
			if (h < 10) h = '0' + h;
			if (m < 10) m = '0' + m;
			return h + ':' + m;
		},
		timeChoiced: function timeChoiced() {
			if (this.hModelError || this.mModelError) return;
			if (this.hTimer) clearInterval(this.hTimer);
			if (this.mTimer) clearInterval(this.mTimer);
			this.showTimeChoicer = false;
			this.timeValue = this.timeChoicerValue();
			this.$emit('input', this.makeValue());
		},
		timeCanceled: function timeCanceled() {
			if (this.hTimer) clearInterval(this.hTimer);
			if (this.mTimer) clearInterval(this.mTimer);
			this.showTimeChoicer = false;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.timeCanceled();
			}
		},
		clickHandler: function clickHandler(e) {
			if (e && e.target && e.target.tagName.toLowerCase() === 'span' && e.target.className.indexOf('datetime-component-time') > -1) return true;
			this.timeCanceled();
		},
		moveUpStart: function moveUpStart(what) {
			var _this = this;

			if (what === 'H') {
				if (this.hTimer) clearInterval(this.hTimer);
				this.hTimer = setInterval(function () {
					_this.hTop -= 35;
					if (_this.hTop < -805) _this.hTop = 0;
					_this.$refs['hours'].style.top = _this.hTop + 'px';
					_this.timeChoicerValue();
					_this.hModelError = false;
				}, 50);
				return;
			}

			if (this.mTimer) clearInterval(this.mTimer);
			this.mTimer = setInterval(function () {
				_this.mTop -= 35;
				if (_this.mTop < -2065) _this.mTop = 0;
				_this.$refs['minutes'].style.top = _this.mTop + 'px';
				_this.timeChoicerValue();
				_this.mModelError = false;
			}, 50);
		},
		moveStop: function moveStop(what) {
			if (what === 'H') {
				if (this.hTimer) clearInterval(this.hTimer);
			} else {
				if (this.mTimer) clearInterval(this.mTimer);
			}
		},
		moveDownStart: function moveDownStart(what) {
			var _this2 = this;

			if (what === 'H') {
				if (this.hTimer) clearInterval(this.hTimer);
				this.hTimer = setInterval(function () {
					_this2.hTop += 35;
					if (_this2.hTop > 0) _this2.hTop = -805;
					_this2.$refs['hours'].style.top = _this2.hTop + 'px';
					_this2.timeChoicerValue();
					_this2.hModelError = false;
				}, 50);
				return;
			}

			if (this.mTimer) clearInterval(this.mTimer);
			this.mTimer = setInterval(function () {
				_this2.mTop += 35;
				if (_this2.mTop > 0) _this2.mTop = -2065;
				_this2.$refs['minutes'].style.top = _this2.mTop + 'px';
				_this2.timeChoicerValue();
				_this2.mModelError = false;
			}, 50);
		},
		moveBySteps: function moveBySteps(what, steps) {
			var _top = void 0;

			if (what === 'H') {
				_top = this.hTop;
				_top += steps * 35;
				if (_top < -805) _top = 0;
				if (_top > 0) _top = -805;

				this.hTop = _top;
				this.$refs['hours'].style.top = _top + 'px';
				this.timeChoicerValue();

				return;
			}

			_top = this.mTop;
			_top += steps * 35;
			if (_top < -2065) _top = 0;
			if (_top > 0) _top = -2065;

			this.mTop = _top;
			this.$refs['minutes'].style.top = _top + 'px';
			this.timeChoicerValue();
		},
		mouseWheel: function mouseWheel(what, e) {
			var _this3 = this;

			var _delta = 0;
			if (e && 'deltaY' in e) _delta = parseInt(e.deltaY);
			if (isNaN(_delta)) _delta = 0;

			if (_delta > 0) this.mouseWheelDelta[what]++;else this.mouseWheelDelta[what]--;

			if (this.mouseWheelTimer) clearTimeout(this.mouseWheelTimer);
			this.mouseWheelTimer = setTimeout(function () {
				clearTimeout(_this3.mouseWheelTimer);
				_this3.moveBySteps(what, _this3.mouseWheelDelta[what]);
				_this3.mouseWheelDelta[what] = 0;
			}, 30);
		}
	}
});

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datetime-component"
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.disabled,
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": _vm.disabled ? 'datetime-component-date-wrapper readonly' : 'datetime-component-date-wrapper',
      "input-class": "datetime-component-date-input",
      "monday-first": true,
      "clear-button": !_vm.disabled
    },
    on: {
      "opened": _vm.onDateOpen,
      "closed": _vm.onDateClose,
      "selected": _vm.onDateSelect
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  }), _vm._v(" "), (_vm.dateValue) ? _c('span', {
    staticClass: "datetime-component-time",
    class: {
      'focused': _vm.showTimeChoicer, 'readonly': _vm.disabled
    },
    on: {
      "click": _vm.timeChoicerShow
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.timeValue) + "\n\t\t\t"), (!_vm.disabled) ? _c('span', {
    staticClass: "view-close",
    on: {
      "click": _vm.zeroTime
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTimeChoicer),
      expression: "showTimeChoicer"
    }],
    staticClass: "datetime-component-time-choice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "datetime-component-time-choice-spiners"
  }, [_c('div', {
    staticClass: "datetime-component-time-wrapper",
    staticStyle: {
      "width": "50%",
      "float": "left"
    },
    on: {
      "mousewheel": function($event) {
        return _vm.mouseWheel('H', $event)
      }
    }
  }, [_c('div', {
    staticClass: "datetime-component-time-choice-spiners-button",
    on: {
      "mousedown": function($event) {
        return _vm.moveUpStart('H')
      },
      "mouseup": function($event) {
        return _vm.moveStop('H')
      }
    }
  }, [_vm._v("↑")]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-choice-spiners-item"
  }, [_c('div', {
    ref: "hours",
    staticClass: "datetime-component-time-choice-spiners-hours"
  }, _vm._l((24), function(i) {
    return _c('div', {
      staticClass: "datetime-component-time-choice-spiners-item"
    }, [_vm._v(_vm._s(i - 1))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-choice-spiners-button",
    on: {
      "mousedown": function($event) {
        return _vm.moveDownStart('H')
      },
      "mouseup": function($event) {
        return _vm.moveStop('H')
      }
    }
  }, [_vm._v("↓")]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-input",
    class: {
      'haserror': _vm.hModelError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hModel),
      expression: "hModel"
    }],
    ref: "inputH",
    attrs: {
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.hModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hModel = $event.target.value
      }, function($event) {
        return _vm.onChangeModel('H')
      }],
      "focus": function($event) {
        return _vm.focusInput('H')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-wrapper",
    staticStyle: {
      "width": "50%",
      "float": "left"
    },
    on: {
      "mousewheel": function($event) {
        return _vm.mouseWheel('M', $event)
      }
    }
  }, [_c('div', {
    staticClass: "datetime-component-time-choice-spiners-button",
    on: {
      "mousedown": function($event) {
        return _vm.moveUpStart('M')
      },
      "mouseup": function($event) {
        return _vm.moveStop('M')
      }
    }
  }, [_vm._v("↑")]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-choice-spiners-item"
  }, [_c('div', {
    ref: "minutes",
    staticClass: "datetime-component-time-choice-spiners-minutes"
  }, _vm._l((60), function(i) {
    return _c('div', {
      staticClass: "datetime-component-time-choice-spiners-item"
    }, [_vm._v(_vm._s(i - 1))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-choice-spiners-button",
    on: {
      "mousedown": function($event) {
        return _vm.moveDownStart('M')
      },
      "mouseup": function($event) {
        return _vm.moveStop('M')
      }
    }
  }, [_vm._v("↓")]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-input",
    class: {
      'haserror': _vm.mModelError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mModel),
      expression: "mModel"
    }],
    ref: "inputM",
    attrs: {
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.mModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mModel = $event.target.value
      }, function($event) {
        return _vm.onChangeModel('M')
      }],
      "focus": function($event) {
        return _vm.focusInput('M')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "datetime-component-time-choice-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.timeChoiced($event)
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'outerDiskType',

	props: ['value'],
	data: function data() {
		return {
			List: [{
				id: 17,
				name: 'NVMe',
				description: 'service/extdisk_nvme_description',
				img: '/static/img/nvme.svg'
			}, {
				id: 16,
				name: 'HDD',
				description: 'service/extdisk_hdd_description',
				img: '/static/img/hdd.svg'
			}],
			curValue: null
		};
	},

	computed: {
		Description: function Description() {
			return this.curValue ? this.curValue.description : '';
		}
	},
	created: function created() {
		this.initValue(this.value);
	},

	methods: {
		initValue: function initValue(value) {
			var _this = this;

			if (this.curValue && 'id' in this.curValue && String(this.curValue.id) === String(value)) {
				return;
			}

			this.curValue = null;
			this.List.some(function (i) {
				if (String(i.id) === String(value)) {
					_this.curValue = i;
					return true;
				}
			});
		},
		onClick: function onClick(item) {
			this.curValue = item;
			this.$emit('focus');
			this.$emit('input', item.id);
		}
	},

	watch: {
		value: function value(newValue) {
			this.initValue(newValue);
		}
	}
});

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.List && _vm.List.length) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, _vm._l((_vm.List), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item outer-disks",
      class: {
        'selected': item.id == _vm.curValue.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      staticClass: "local-group disks",
      class: {
        'selected': item.id == _vm.curValue.id, 'macloud': _vm.AppName === 'macloud'
      },
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [_c('strong', [_vm._v(_vm._s(item.name))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Description)),
      expression: "localeFtc(Description)"
    }]
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    class: {
      'w5-field': _vm.isVisibleRow && _vm.Field._field_name !== 'role_items',
        'padding-for-submit-button': _vm.needButtonSubmit === true,
        'removeRightPadding': _vm.removeRightPadding,
        'removeAllPadding': _vm.Field.type === 'passport' || _vm.Field.type === 'address',
        'w5-disabled-field': _vm.Field.readonly === true,
        'w5-vds-plan': _vm.isUniqueInVds() || _vm.isUniqueInOperation() || _vm.isUniqueInCertificate(),
        'w5-filed-with-top-hint': _vm.topHint,
        'w5-filed-with-bottom-hint': _vm.bottomHint,
        'w5-fake-field': _vm.Field.type === 'fake',
        'w5-combo-list': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id',
        'w5-field-greyed': _vm.isFieldGreyed,
        'with-awesome-button': _vm.fontawesomeButton,
        'with-big-button': (_vm.Field.type != 'text' && _vm.Field.type != 'boolean') && _vm.bigButton,
        'header': _vm.Field.type === 'header',
        'clear-text': _vm.Field.type === 'clearText',
        'w5-iso-download-field': _vm.crud === 'iso' && (_vm.Field['_field_name'] === 'download' || _vm.Field['_field_name'] === 'library'),
        'w5-autoprolong-field': _vm.crud === 'disks' && _vm.Field['_field_name'] === 'autoprolong',
        'w5-with-info-link': _vm.linkHint && _vm.linkHint.showIfField === _vm.Field._field_name && _vm.Field.type !== 'list',
        'w5-input-with-number-divider': (_vm.crud === 'dns' && (_vm.Field.type === 'text' || _vm.Field.type === 'money' || _vm.Field.type === 'integer' || _vm.Field.type === 'float' || _vm.Field._field_name === 'account_id')) ||
        ((_vm.crud === 'vds' || _vm.crud === 'disks' || _vm.crud === 'iso') && _vm.Field._field_name === 'account_id')
    }
  }, [(_vm.isFieldGreyed) ? _c('div', {
    staticClass: "w5-field-greyed-back"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-input-type": _vm.Field.type
    }
  }), _vm._v(" "), (_vm.topHint) ? _c('div', {
    staticClass: "w5-field-top-hint"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.topHint)),
      expression: "localeFtc(topHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldPlaceholderVisible),
      expression: "fieldPlaceholderVisible"
    }],
    staticClass: "w5-field-placeholder",
    class: {
      'active': _vm.fieldFocused || _vm.notEmpty(_vm.fieldCurValue),
        'textarea': _vm.Field.type === 'textarea',
        'short': _vm.Field._is_short === true,
        'readonly': _vm.Field.readonly === true,
        'field-in-modal': _vm.fieldInModal,
        'search-in-modal': _vm.fieldInModal && _vm.Field && _vm.Field._field_name === 'fastSearch',
        'for-captcha': _vm.Field.type === 'captcha'
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.title))), (_vm.Field.required === true) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), (_vm.Field.type === 'hidden') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    attrs: {
      "type": "hidden",
      "name": _vm.Field._field_name
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'clearText') ? _c('span', {
    staticClass: "shown-text"
  }, [(_vm.Field.__subtype === 'rackdevice-from') ? _c('div', {
    staticClass: "lamp",
    class: {
      active: _vm.Field.__isPortActive
    }
  }) : _vm._e(), _vm._v("\n\t\t" + _vm._s(_vm.fieldCurValue) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'text') ? [(_vm.crud === 'dns-records' && _vm.Field['_field_name'] === 'host' && !_vm.Field.readonly) ? [_c('domainInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'with-submit-button': _vm.needButtonSubmit === true
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "fixed": _vm.dnsFixedValue
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "text-field",
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.clearButton, 'bitbtn-in-field': _vm.bigButton
    },
    attrs: {
      "type": "text",
      "name": _vm.Field._field_name,
      "autocomplete": _vm.Field._field_name === 'fastSearch' ? 'off' : null,
      "readonly": _vm.Field._field_name === 'fastSearch',
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autofocus": _vm.Field._field_name === 'code' && _vm.crud === 'twofa'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })], _vm._v(" "), (_vm.clearButton) ? _c('div', {
    staticClass: "field-button-wrapper",
    class: {
      'bitbtn-in-field': _vm.bigButton, 'search-in-modal': _vm.fieldInModal && _vm.Field && _vm.Field._field_name === 'fastSearch'
    },
    on: {
      "click": _vm.clearButtonClick
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchButton) ? _c('div', {
    staticClass: "field-button-wrapper",
    on: {
      "click": _vm.searchButtonClick
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "search"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bigButton) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field",
    on: {
      "click": _vm.enterKeyDown
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e(), _vm._v(" "), ((_vm.crud === 'ticket' && _vm.action === 'create') || (_vm.crud === 'qa' && _vm.action === 'list')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qaResult),
      expression: "qaResult"
    }],
    staticClass: "w5-field-qa-result"
  }, [_c('strong', [_vm._v("В нашем QA есть похожие вопросы")]), _vm._v(": "), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.qaResult), function(qa, indx) {
    return _c('li', {
      key: 'qa-item-' + indx
    }, [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + qa.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(qa.cap) + " (" + _vm._s(qa.ans) + ")")])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'captcha') ? _c('div', {
    staticClass: "captcha-block"
  }, [_c('div', {
    staticClass: "captcha-block-image",
    on: {
      "click": _vm.onCaptchaClick
    }
  }, [(_vm.Field.image) ? _c('img', {
    attrs: {
      "src": _vm.captchaUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "text-field",
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.clearButton, 'bitbtn-in-field': _vm.bigButton
    },
    attrs: {
      "type": "text",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autofocus": _vm.Field._field_name === 'code' && _vm.crud === 'twofa'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'money') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton",
    class: {
      'haserror': _vm.fieldError, 'with-submit-button': _vm.needButtonSubmit === true
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "crud": _vm.crud,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "animation": _vm.animationRequested,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper",
    class: {
      'with-top-hint': _vm.topHint
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _c('div', {
    staticClass: "field-postfix-wrapper",
    class: {
      'with-top-hint': _vm.topHint
    },
    style: (_vm.needButtonSubmit === true ? 'right: 76px !important' : false)
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'integer') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.Field.for
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "needReact": _vm.needReact
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'float') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.Field.for
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'radio') ? [_c('radioListComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.filterActiveList(_vm.Field.list),
      "placeholder": ""
    },
    on: {
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'list' && !_vm.isUniqueInVds() && !_vm.isUniqueInOperation() && !_vm.isUniqueInCertificate() && !_vm.isUniqueInDomains()) ? [(_vm.Field.multiselect === true) ? [(_vm.crud === 'user' && _vm.Field['_field_name'] === 'role_items') ? _c('userRole', {
    ref: _vm.Field['_field_name'],
    attrs: {
      "title": _vm.Field['title'],
      "name": _vm.Field['_field_name'],
      "master": _vm.Field['list_description'],
      "slave": _vm.Field['list']
    },
    on: {
      "focus": _vm.fieldFocus,
      "input": _vm.onSelectUserRole
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : (_vm.Field.url && _vm.Field['_field_name'] !== 'plans' && _vm.Field['_field_name'] !== 'templates') ? _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-multiselecting w5-selecting-by-url",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": true,
      "searchable": true,
      "multiple": true,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true,
      "internalSearch": false,
      "showNoOptions": false
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "search-change": _vm.asyncListFind
    },
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestProcess.trim().length),
      expression: "statusListRequestProcess.trim().length"
    }],
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "slot": "beforeList"
    },
    slot: "beforeList"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestProcess)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestResult.trim().length),
      expression: "statusListRequestResult.trim().length"
    }],
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestResult)))])]) : _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-multiselecting w5-selecting-by-static",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": true,
      "searchable": false,
      "multiple": true,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag",
          class: {
            'multiselect__option--notactive-tag': props.option.active === false || props.option.archive === true
          }
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.scopedGetOptionLabel(props.option))
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "multiselect__tag-icon",
          attrs: {
            "aria-hidden": "true",
            "tabindex": "1"
          },
          on: {
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              $event.preventDefault();
              return _vm.scopedRemoveElement(props.option)
            },
            "mousedown": function($event) {
              $event.preventDefault();
              return _vm.scopedRemoveElement(props.option)
            }
          }
        })])]
      }
    }], null, false, 422227897),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  })] : [(_vm.Field.url && (_vm.Field._field_name !== 'sshkey_id' && _vm.Field._field_name !== 'person_id' && _vm.Field._field_name !== 'operation_id')) ? _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-singleselecting w5-selecting-by-url",
    class: {
      'haserror': _vm.fieldError, 'short-list': _vm.Field._is_short === true
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.isUrlWithQuery ? _vm.curList : _vm.preparedStaticList(_vm.curList),
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.isSelectSearchable,
      "disabled": _vm.Field.readonly === true ? true : false,
      "internalSearch": false,
      "showNoOptions": false,
      "track-by": "id"
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "search-change": function (str) { return _vm.isUrlWithQuery ? _vm.asyncListFind(str) : _vm.mySearchFunction(str); }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm.Field._field_name === 'server_id' && props.option.type) ? _c('span', {
          class: 'color-type-' + String(props.option.type),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t")]
      }
    }], null, false, 3738823343),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestProcess.trim().length),
      expression: "statusListRequestProcess.trim().length"
    }],
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "slot": "beforeList"
    },
    slot: "beforeList"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestProcess)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestResult.trim().length),
      expression: "statusListRequestResult.trim().length"
    }],
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestResult)))])]) : _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-singleselecting",
    class: {
      'haserror': _vm.fieldError,
      'short-list': _vm.Field._is_short === true,
        'domains-person-with-button': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id'
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.preparedStaticList(_vm.curList),
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.curList.length > 15 && _vm.crud !== 'backupschedule',
      "internalSearch": false,
      "maxHeight": _vm.$store.state.windowWidth <= 767 ? 200 : 300,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "search-change": _vm.mySearchFunction,
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [((_vm.crud === 'certificate' || _vm.crud === 'datacenter' || _vm.crud === 'person') && _vm.Field._field_name.indexOf('country') > -1) ? [_c('span', {
          staticClass: "flag-icon",
          class: 'flag-icon-' + props.option.id.toLowerCase(),
          staticStyle: {
            "margin-right": "10px",
            "top": "-1px"
          }
        }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t\t")] : (_vm.crud === 'backupDialog' && _vm.Field._field_name === 'service_id') ? [_c('div', {
          staticClass: "backup-dialog-service-option"
        }, [(props.option.template && props.option.template.image) ? _c('img', {
          attrs: {
            "src": _vm.APIServerUrl + props.option.template.image
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "plan"
        }, [_c('div', [_c('span', {
          staticClass: "flag-icon",
          class: 'flag-icon-' + props.option.datacenter.country.toLowerCase()
        }), _vm._v(" "), _c('span', {
          class: {
            not: !props.option.active
          }
        }, [_vm._v(_vm._s(props.option.name))])]), _vm._v(" "), (props.option.plan && props.option.plan.data) ? _c('div', [_c('span', {
          staticClass: "plan-info"
        }, [_vm._v(_vm._s(_vm.getPlanInfo(props.option.plan.data)))])]) : _vm._e()])])] : [(_vm.Field._field_name === 'migrateModalServerValue' && props.option.type) ? _c('span', {
          class: 'color-type-' + String(props.option.type),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t\t")]]
      }
    }], null, false, 1016398154),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/search_not_found')))])])]] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'plan_group_id' && _vm.crud === 'vds' && _vm.action === 'create') ? [_c('groupPlanComponent', {
    attrs: {
      "action": _vm.action,
      "groups": _vm.filterActiveList(_vm.Field['list'])
    },
    on: {
      "focus": _vm.emitFocus,
      "groupChanged": _vm.onGroupChanged
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'plan_id' && _vm.crud === 'vds') ? [_c('planComponent', {
    attrs: {
      "items": _vm.filterActiveList(_vm.Field.list),
      "action": _vm.action,
      "groups": _vm.groupField && _vm.groupField['list'] ? _vm.groupField['list'] : null,
      "groupValue": _vm.groupField && _vm.groupField['value'] ? _vm.groupField['value'] : null,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null,
      "templateField": _vm.templateField,
      "ipInfo": _vm.ipInfo ? _vm.ipInfo : null
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "groupChanged": _vm.onGroupChanged,
      "input": _vm.onChange,
      "params": _vm.onParams
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'template_id' && _vm.crud === 'vds') ? _c('templateImageComponent', {
    attrs: {
      "action": _vm.action,
      "formFields": _vm.formFields,
      "planField": _vm.planField,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null,
      "dc": _vm.dc
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "templateTab": _vm.onTemplateTab,
      "templateInput": _vm.onTemplateInput,
      "backupList": _vm.onBackupList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'datacenter_id' && (_vm.crud === 'vds' || _vm.crud === 'disks')) ? [_c('countryComponent', {
    attrs: {
      "items": _vm.filterListForDataCenterInVds(_vm.Field.list),
      "crud": _vm.crud,
      "action": _vm.action,
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'backup_id' && _vm.crud === 'disks') ? [_c('backupComponent', {
    attrs: {
      "action": _vm.action,
      "list": _vm.Field && _vm.Field.list && _vm.Field.list.length ? _vm.Field.list : [],
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.emitFocus,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInCertificate()) ? [_c('planSslComponent', {
    attrs: {
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.filterActiveList(_vm.Field.list),
      "groups": _vm.groupField && _vm.groupField['list'] ? _vm.groupField['list'] : null,
      "groupValue": _vm.groupField && _vm.groupField['value'] ? _vm.groupField['value'] : null,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "groupChanged": _vm.onGroupChanged,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInDomains()) ? [_c('planDomainComponent', {
    attrs: {
      "Field": _vm.Field,
      "items": _vm.filterActiveList(_vm.Field.list),
      "nameField": _vm.nameField,
      "actionField": _vm.actionField
    },
    on: {
      "focus": _vm.emitFocus,
      "blur": _vm.emitBlure,
      "onDomainName": _vm.onDomainName,
      "keydownEnter": _vm.enterKeyDown,
      "startData": _vm.onStartData,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInOperation()) ? [_c('paymentComponent', {
    attrs: {
      "items": _vm.Field.list,
      "title": _vm.Field.title
    },
    on: {
      "focus": _vm.emitFocus,
      "input": _vm.onChange,
      "operationNextStep": _vm.onClientOperationNextStep
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'password') ? [((_vm.passwordIsShown ? 'text' : 'password') === 'checkbox' && (_vm.Field.generator)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldCurValue) ? _vm._i(_vm.fieldCurValue, null) > -1 : (_vm.fieldCurValue)
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      },
      "change": function($event) {
        var $$a = _vm.fieldCurValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldCurValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fieldCurValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fieldCurValue = $$c
        }
      }
    }
  }) : ((_vm.passwordIsShown ? 'text' : 'password') === 'radio' && (_vm.Field.generator)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.fieldCurValue, null)
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      },
      "change": function($event) {
        _vm.fieldCurValue = null
      }
    }
  }) : (_vm.Field.generator) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": _vm.passwordIsShown ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "type": "password",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }), _vm._v(" "), (_vm.Field.generator) ? _c('div', {
    staticClass: "field-button-wrapper field-button-password-wrapper eye",
    class: {
      'in-modal': _vm.fieldInModal, 'slash': _vm.passwordIsShown
    },
    attrs: {
      "title": _vm._f("ftc")(((_vm.passwordIsShown ? 'main/hide' : 'main/show') + " main/password"))
    },
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.passwordIsShown ? 'eye-slash' : 'eye'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Field.generator) ? _c('div', {
    staticClass: "field-button-wrapper field-button-password-wrapper",
    class: {
      'in-modal': _vm.fieldInModal
    },
    attrs: {
      "title": _vm._f("ftc")('main/password_generation')
    },
    on: {
      "click": _vm.generatePasswordHandler
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "random"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'email') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "type": "email",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope"
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'textarea') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    style: (_vm.textAreaStyle()),
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && (_vm.crud === 'ticketmessage' || _vm.crud === 'ticket') && _vm.action === 'create') ? _c('font-awesome-icon', {
    staticClass: "ticket-answer-template-btn",
    attrs: {
      "icon": "list-alt",
      "title": _vm._f("ftc")('mails/templates')
    },
    on: {
      "click": _vm.templateDialog
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'slider') ? [(_vm.crud === 'disks' && _vm.action === 'create' && _vm.Field._field_name === 'quantity') ? _c('OuterDiskType', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "-10px"
    },
    attrs: {
      "value": _vm.diskTypeValue
    },
    on: {
      "input": _vm.onOuterDiskTypeChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "graph-slider-wrapper",
    class: _vm.action
  }, [_c('div', {
    staticClass: "input-text-slider",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('div', {
    staticClass: "input-text-slider-field-wrapper"
  }, [_c('div', {
    staticClass: "input-slider-field-placeholder"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.title))), (_vm.Field.required) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: 'field-' + _vm.Field._field_name,
    staticClass: "input-slider-field",
    attrs: {
      "type": "text",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": _vm.outerDiskValue
    },
    on: {
      "blur": _vm.onSliderFieldBlurNew
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-slider-field-postfix"
  }, [_c('span', [_vm._v(_vm._s(_vm.Field.for))])])]), _vm._v(" "), (_vm.outerDiskError) ? _c('div', {
    staticClass: "input-slider-field-error"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.outerDiskError)) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "graph-slider",
    staticStyle: {
      "width": "calc(100% - 160px)"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.outerDisksPriceDiscount) ? _c('span', {
    staticClass: "price-with-discount pull-right"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPriceDiscount)))]), _vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPrice)) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.Field.period)) + "\n\t\t\t\t\t")]) : ('cost' in _vm.Field && 'period' in _vm.Field) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPrice)) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.Field.period)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', {
    ref: _vm.Field._field_name,
    attrs: {
      "min": 0,
      "max": 'max' in _vm.Field ? _vm.Field.max : 1,
      "duration": 0.2,
      "marks": _vm.sliderMarks,
      "interval": 'step' in _vm.Field ? _vm.Field.step : 1,
      "silent": true,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "labelStyle": {
        fontSize: '10px',
        fontWeight: 300,
        color: '#666',
        top: '2px'
      },
      "tooltip": "none"
    },
    on: {
      "drag-start": function($event) {
        return _vm.$emit('dragStart')
      },
      "drag-end": function($event) {
        return _vm.$emit('dragEnd')
      },
      "change": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }, [_c('div', {
    staticClass: "process-minimum",
    style: (_vm.minRangeWidthStyle)
  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'datetime') ? _c('DateTime', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true
    },
    on: {
      "input": _vm.datetimeInput
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'date') ? [(_vm.crud === 'person' && (_vm.Field._field_name === 'data[ru_phis][birth_date]' || _vm.Field._field_name === 'data[birth_date]')) ? _c('manualDateComponent', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "required": _vm.Field.required,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _c('datepicker', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "id": _vm.Field._field_name,
      "placeholder": "",
      "disabled-picker": _vm.Field.readonly === true ? 'disabled' : false,
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "w5-field-date-wrapper",
      "input-class": "w5-field-date-input",
      "typeable": true,
      "monday-first": true,
      "clear-button": true
    },
    on: {
      "opened": _vm.onDateOpen,
      "closed": _vm.onDateClose,
      "selected": _vm.onDateSelect
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'passport') ? _c('passportComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "required": _vm.Field.required,
      "readonly": _vm.Field.readonly,
      "errorMessage": _vm.Field._errMsg
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "enterKeyDown": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'phone') ? _c('phoneComponent', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "required": _vm.Field.required,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'address') ? _c('addressComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "validator": _vm.Field.validator,
      "required": _vm.Field.required,
      "readonly": _vm.Field.readonly,
      "errorMessage": _vm.Field._errMsg,
      "crud": _vm.crud
    },
    on: {
      "copyAddress": _vm.copyAddress,
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "enterKeyDown": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'boolean') ? _c('div', {
    staticClass: "w5-boolean-field-wrapper",
    class: {
      'outer-disks-update': _vm.crud === 'disks' && _vm.action === 'update'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": _vm.Field._field_name
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldCurValue) ? _vm._i(_vm.fieldCurValue, null) > -1 : (_vm.fieldCurValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fieldCurValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldCurValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fieldCurValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fieldCurValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "w5-boolean-label",
    on: {
      "click": _vm.clickBooleanLabel
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.title)) + "\n\t\t\t\t"), ((_vm.crud === 'vds' || _vm.crud === 'disks') && _vm.action === 'create' && _vm.Field._field_name === 'backup_auto') ? [(_vm.BackupItemCost) ? _c('span', {
    staticClass: "backup-item-cost"
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("→")]), _vm._v(" "), _c('span', {
    staticClass: "visible-xs",
    staticStyle: {
      "margin": "5px"
    }
  }, [_vm._v("↓")])]) : _vm._e(), _vm._v(" "), (_vm.isBackupItemDiscountCost) ? _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BackupItemDiscountCost),
      expression: "BackupItemDiscountCost"
    }],
    staticClass: "price-with-discount"
  }) : _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BackupItemCost),
      expression: "BackupItemCost"
    }]
  })] : _vm._e(), _vm._v(" "), (_vm.crud === 'domains' && _vm.action === 'update' && _vm.Field._field_name === 'privacy_set' && _vm.Field.period && 'cost' in _vm.Field) ? [_vm._m(0), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BooleanFieldCost),
      expression: "BooleanFieldCost"
    }]
  })] : _vm._e(), _vm._v(" "), (_vm.Field.hint) ? [(_vm.crud === 'vds' && _vm.action === 'create' && _vm.Field._field_name === 'options') ? _c('span', {
    staticClass: "w5-boolean-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.hint)))]) : (_vm.crud === 'disks' && _vm.action === 'update' && _vm.Field._field_name === 'autoprolong') ? _c('span') : (_vm.fieldCurValue === true) ? _c('span', {
    staticClass: "w5-boolean-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.hint)))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.crud === 'disks' && _vm.action === 'update' && _vm.Field._field_name === 'autoprolong') ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/autoprolong_off')),
      expression: "localeFtc('service/autoprolong_off')"
    }],
    staticClass: "outer-disks-hint"
  }) : _vm._e(), _vm._v(" "), (_vm.bigButton) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field not-text",
    class: {
      'disabled': _vm.bigButtonEnabled !== true
    },
    on: {
      "click": _vm.bigButtonHandlerFunc
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e(), _vm._v(" "), (_vm.Field.after_text && _vm.Field.after_url && _vm.$store.state.user_type === 'admin') ? _c('span', [_vm._v(" ")]) : _vm._e(), (_vm.Field.after_text && _vm.Field.after_url && _vm.$store.state.user_type === 'admin') ? _c('linkComponent', {
    staticClass: "link-by-boolean",
    attrs: {
      "url": _vm.generateAfterUrl,
      "text": _vm._f("ftc")('(' + _vm.Field.after_text + ')')
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'image' || _vm.Field.type === 'file') ? [(_vm.crud === 'iso' && _vm.action === 'create') ? _c('directFileComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "accept": _vm.Field.accept,
      "maxsize": _vm.Field.maxsize,
      "maxcnt": _vm.Field.max ? _vm.Field.max : 1
    },
    on: {
      "input": _vm.onChange,
      "focus": function($event) {
        _vm.Field._errMsg = ''
      },
      "uploadCanceled": _vm.onIsoUploadCanceled,
      "uploadFinished": _vm.onIsoUploadFinished,
      "uploadError": _vm.onIsoUploadError
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _c('fileComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "accept": _vm.Field.accept,
      "maxsize": _vm.Field.maxsize,
      "maxcnt": _vm.Field.max,
      "multiple": _vm.Field.multifile,
      "candel": _vm.Field._canDelete
    },
    on: {
      "input": _vm.onChange,
      "abortUpload": _vm.onChange,
      "uploadFinished": _vm.onUploadFinished,
      "blockFormButton": _vm.blockFormButton,
      "unblockFormButton": _vm.unblockFormButton,
      "deleteFileValue": _vm.deleteFileValue,
      "cropCoords": _vm.cropCoords
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'urlButton') ? [_c('urlButtonComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "url": _vm.Field.urlLink,
      "text": _vm.Field.urlText
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'simpleButton') ? [_c('span', {
    ref: _vm.Field._field_name,
    staticClass: "url-button",
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.Field.buttonFunction($event)
      }
    }
  }, [(_vm.crud === 'vds' && _vm.Field._field_name === 'sshkey_id') ? _c('font-awesome-icon', {
    staticStyle: {
      "font-size": "24px",
      "top": "3px"
    },
    attrs: {
      "icon": "plus-circle"
    }
  }) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.buttonText)) + "\n\t\t")], 1)] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'savedPayments') ? [_c('savedPaymentsComponent', {
    attrs: {
      "crud": _vm.crud,
      "action": _vm.action,
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.Field.list,
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.fieldFocus,
      "input": _vm.onChange,
      "deleteSavedPayment": _vm.onDeleteSavedPayment,
      "operationNextStep": _vm.onClientOperationNextStep
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.hint && _vm.Field.type !== 'boolean' && _vm.Field.type !== 'passport' && _vm.Field.type !== 'address') ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Field.hint && _vm.fieldFocused && !_vm.fieldError),
      expression: "Field.hint && fieldFocused && !fieldError"
    }],
    staticClass: "w5-tooltip-wrapper"
  }, [_c('span', {
    staticClass: "w5-tooltip"
  }, [_vm._v(_vm._s(_vm._f("ftc")((_vm.crud === 'person' ? 'person/pattern: ' : '') + _vm.Field.hint)))])])]) : _vm._e(), _vm._v(" "), (_vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id') ? [_c('urlButtonComponent', {
    staticClass: "domains-person-create-button",
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "url": "/person/create",
      "text": "Создать персону"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'header') ? _c('div', {
    staticClass: "header"
  }, [(_vm.Field.number && !(_vm.crud === 'disks' && _vm.fieldInModal)) ? _c('span', {
    staticClass: "step"
  }, [_vm._v(_vm._s(_vm.Field.number))]) : _vm._e(), _vm._v("\n\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.title)) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.fontawesomeButton) ? _c('font-awesome-icon', {
    staticClass: "fontawesome-btn",
    class: _vm.fontawesomeButton,
    attrs: {
      "icon": _vm.fontawesomeButton
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return (function () { return _vm.$emit('fontawesomeButton', {
          button: _vm.fontawesomeButton,
          field: _vm.Field._field_name
        }); })($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isUniqueInDomains() && _vm.Field.type !== 'passport' && _vm.Field.type !== 'address') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldError),
      expression: "fieldError"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldError)),
      expression: "localeFtc(fieldError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    class: {
      'domains-person-error-message': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id', 'url-btn': _vm.Field.type == 'urlButton'
    },
    attrs: {
      "role": "alert"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.warningList) ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Field.warningList)),
      expression: "localeFtc(Field.warningList)"
    }],
    staticClass: "alert alert-danger w5-alert-valid warning",
    attrs: {
      "role": "alert"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bottomHint) ? _c('div', {
    staticClass: "w5-field-bottom-hint"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.bottomHint)),
      expression: "localeFtc(bottomHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), (_vm.rightHint) ? _c('div', {
    staticClass: "w5-field-right-hint",
    class: 'count-' + _vm.countVisibleFieldsInRow
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.rightHint)),
      expression: "localeFtc(rightHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), (_vm.insteadFieldHint) ? _c('div', {
    staticClass: "w5-field-instead-hint",
    class: {
      error: _vm.crud === 'paymentauto' && _vm.Field._field_name === 'saved_id' && (!_vm.Field.list || !_vm.Field.list.length)
    }
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.insteadFieldHint)),
      expression: "localeFtc(insteadFieldHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), ((_vm.Field.type != 'text' && _vm.Field.type != 'boolean') && _vm.bigButton) ? [(_vm.Field.type == 'fake' || _vm.Field.value) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field not-text",
    class: {
      'disabled': _vm.bigButtonEnabled !== true
    },
    on: {
      "click": _vm.bigButtonHandlerFunc
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.linkButton && _vm.linkButtonVisible && _vm.linkButtonUrl) ? [_c('router-link', {
    staticClass: "btn btn-submit bitbtn-in-field not-text green",
    attrs: {
      "to": _vm.linkButtonUrl
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkButtonTitle)))])] : _vm._e(), _vm._v(" "), (_vm.needButtonSubmit === true) ? [_c('button', {
    staticClass: "btn btn-submit btn-in-field",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitButton
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.progress) ? [_c('span', {
    staticClass: "w5-field-progress"
  }, [_c('div', {
    staticClass: "indicator"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading-hor16.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(_vm.progress) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.onIsoUploadCanceled
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "title": _vm._f("ftc")('main/cancel'),
      "icon": "times-circle"
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.linkHint && _vm.linkHint.showIfField === _vm.Field._field_name && _vm.Field.type !== 'list') ? _c('div', {
    staticClass: "w5-info-link margin-top-5"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.linkHintHtml(_vm.linkHint)),
      expression: "linkHintHtml(linkHint)"
    }]
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "backup-item-cost"
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("→")]), _c('span', {
    staticClass: "visible-xs",
    staticStyle: {
      "margin": "5px"
    }
  }, [_vm._v("↓")])])
}]}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData && _vm.formData.title ? _vm.formData.title : 'login/title')))]), _vm._v(" "), (_vm.form_ErrorMessage) ? _c('div', [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "padding": "10px",
      "margin": "20px 0 20px"
    },
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.softReloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])]) : _vm._e(), _vm._v(" "), (_vm.formData) ? _c('form', {
    staticClass: "w5-from",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "w5-form-row"
    }, [(row && row.length) ? [_vm._l((row), function(field) {
      return [(field._field_name == 'remember_me') ? [(!_vm.is_admin) ? _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field,
          "disabled": _vm.isInputDisabled
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _vm._e()] : _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field,
          "disabled": _vm.isInputDisabled
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.form_Loading) ? _c('img', {
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }) : _c('button', {
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])])], 2)]) : _c('div', {
    style: (_vm.form_ErrorMessage ? 'height: 0' : 'height: 195px')
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData && !_vm.form_Loading && !_vm.form_ErrorMessage),
      expression: "formData && !form_Loading && !form_ErrorMessage"
    }],
    staticClass: "w5-field"
  }, [_c('router-link', {
    staticClass: "pull-left",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('page/user_register')))]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/forget"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/forgot')))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2FADialogModal),
      expression: "show2FADialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container narrow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fields2FA && _vm.fields2FA.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.fields2FA.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "twofa",
          "action": "check",
          "Field": field
        },
        on: {
          "focus": function($event) {
            return _vm.onFocus2FA(field)
          },
          "enterKeyDown": _vm.submit2FAForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.submit2FAForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check')))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'registrationForm',

	data: function data() {
		return {
			successMessage: '',

			errorWithLogout: '',

			formData: null
		};
	},
	created: function created() {
		if (this.$store.state.is_auth) {
			return this.$router.push('/');
		}

		this.formRequest();
	},

	methods: {
		formRequest: function formRequest() {
			var _this = this;

			this.getFormFromCache('/user/register').then(function (formData) {
				if (formData && formData.title && formData.fields && formData._csrf && formData.model) {
					var newData = _this.parseFormData(formData, _this.formData);
					if (newData) _this.formData = newData;
				}

				if (formData && formData.status === 'error' && formData.message && formData.message.length) {
					_this.form_ErrorMessage = _this.localeFtc(formData.message);

					if (String(formData.message).toLowerCase().indexOf('blacklisted') !== -1) {
						_this.formData = null;
					}
				}
			});
		},
		failRequest: function failRequest(error) {
			this.form_ErrorMessage = false;
			this.errorWithLogout = '';

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error.data && error.data.status === 'error' && error.data.content && error.data.title && error.data.content === 'user/need_logout') {
				this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content);
				return;
			}

			var _msg = this.localeFtc('main/validation_error');
			var _isError = false;

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['email']) {
				_isError = true;

				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0]);else _msg = this.localeFtc(error['email']);

				var field = this.findFormField('email', this.formData['fields']);
				if (field) field['_errMsg'] = _msg;
			}

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['captcha']) {
				_isError = true;

				if (Array.isArray(error['captcha']) && error['captcha'].length) _msg = this.localeFtc(error['captcha'][0]);else _msg = this.localeFtc(error['email']);

				var _field = this.findFormField('captcha', this.formData['fields']);
				if (_field) _field['_errMsg'] = _msg;
			}

			if (!_isError) {
				this.form_ErrorMessage = _msg;
			}

			this.formRequest();
		},
		registration: function registration() {
			var _this2 = this;

			if (this.form_Loading) return;

			if (!this.formData || !this.formData['fields']) return;

			this.form_ErrorMessage = false;
			this.successMessage = '';

			var _data = this.collectFormData(this.formData['fields'], this.localFormValidation);

			if (_data === false) return;

			_data['locale'] = this.$store.state.lang;

			var _url = '/user/register';
			this.forms_GetThenPost(_url, _data, function () {
				_this2.successMessage = _this2.localeFtc('register/success<br><br> register/email_sent');
			}, function (error) {
				if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted') {
					_this2.form_ErrorMessage = _this2.localeFtc('login/blacklisted');

					_this2.formData = null;
				} else _this2.failRequest(error);
			});
		},
		successToPanel: function successToPanel() {
			window.location.href = '/';
			window.location.reload(true);
		},
		logOut: function logOut() {
			var _this3 = this;

			this.forms_GetThenPost('/logout', false, function () {
				_this3.$store.commit('dropAuth');
				_this3.$router.push('/login');
			}, function () {
				_this3.$router.push('/');
			});
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default.a
	}

});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData && _vm.formData.title ? _vm.formData.title : 'register/title')))]), _vm._v(" "), (_vm.errorWithLogout) ? [_c('div', {
    staticClass: "text-center alert alert-danger",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.errorWithLogout),
      expression: "errorWithLogout"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/logout')))])] : _vm._e(), _vm._v(" "), (!_vm.errorWithLogout) ? [(_vm.form_ErrorMessage) ? _c('div', [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "padding": "10px",
      "margin": "20px 0 20px"
    },
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.softReloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.successMessage) ? _c('form', {
    staticClass: "w5-from",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "w5-form-row"
    }, [(row && row.length) ? [_vm._l((row), function(field) {
      return [(['locale', 'code'].indexOf(field._field_name) < 0) ? _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _vm._e()]
    })] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.form_Loading) ? _c('img', {
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }) : _c('button', {
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.registration
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('page/user_register')))])])], 2)]) : _c('div', {
    style: (_vm.form_ErrorMessage || _vm.successMessage ? 'height: 0' : 'height: 135px')
  }), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "text-center alert alert-success",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.form_Loading && !_vm.form_ErrorMessage) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [(!_vm.successMessage) ? [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('login/already_registered')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])] : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.successToPanel
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])], 2) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'rememberForm',

	data: function data() {
		return {
			successMessage: '',

			errorWithLogout: '',

			formData: null,

			isCodeArive: false,
			isCodeError: '',
			isCode: null
		};
	},
	created: function created() {
		if (this.$route.path === '/user/forget') {
			this.isCodeArive = true;

			var _keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.query);

			if (!_keys.length) {
				this.isCodeError = 'forget/notcode';
				return;
			}

			var _code = _keys[0];

			if (_code === undefined || _code === null || String(_code).trim() === '') {
				this.isCodeError = 'forget/notcode';
				return;
			}

			this.isCode = _code;
		}

		if (this.isCodeArive) return;

		this.formRequest();
	},
	mounted: function mounted() {
		var _this = this;

		if (this.isCodeArive && this.isCode) {
			var _url = '/user/forget?' + this.isCode;

			this.forms_GetThenPost(_url, null, function (data) {
				if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object' && 'status' in data && data['status'] === 'ok' && data.content) {
					_this.successMessage = data.content;

					return;
				}

				_this.isCodeError = _this.localeFtc('<b>main/error_desc</b><br>');
				if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object' && data.content) _this.isCodeError += data.content;else _this.isCodeError = _this.isCodeError.replace(':', '.').replace(/strong/g, 'span');
			}, function (error) {
				_this.isCodeError = _this.localeFtc('<b>main/error_desc</b><br>');
				var _cnt = 0;
				if (error.status === 'error') {
					for (var k in error) {
						if (error.hasOwnProperty(k)) {
							_this.isCodeError += error[k] + ' <br> ';
							_cnt++;
						}
					}
				}

				if (_cnt === 0) _this.isCodeError = _this.isCodeError.replace(':', '.').replace(/strong/g, 'span');else if (_cnt > 1) _this.isCodeError = _this.isCodeError.replace('Возникла ошибка', 'Возникли ошибки');
			});
		}
	},

	methods: {
		formRequest: function formRequest() {
			var _this2 = this;

			this.getFormFromCache('/user/forget').then(function (formData) {
				if (formData && formData.title && formData.fields && formData._csrf && formData.model) {
					var newData = _this2.parseFormData(formData, _this2.formData);
					if (newData) _this2.formData = newData;
				}

				if (formData && formData.status === 'error' && formData.message && formData.message.length) {
					_this2.form_ErrorMessage = _this2.localeFtc(formData.message);

					if (String(formData.message).toLowerCase().indexOf('blacklisted') !== -1) {
						_this2.formData = null;
					}
				}
			});
		},
		failRequest: function failRequest(error) {
			this.form_ErrorMessage = false;
			this.errorWithLogout = '';

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error.data && error.data.status === 'error' && error.data.content && error.data.title && error.data.content === 'user/need_logout') {
				this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content);
				return;
			}

			var _msg = this.localeFtc('main/validation_error');
			var _isError = false;

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['email']) {
				_isError = true;

				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0]);else _msg = this.localeFtc(error['email']);

				var field = this.findFormField('email', this.formData['fields']);
				if (field) field['_errMsg'] = _msg;
			}

			if (error && (typeof error === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error)) === 'object' && error['captcha']) {
				_isError = true;

				if (Array.isArray(error['captcha']) && error['captcha'].length) _msg = this.localeFtc(error['captcha'][0]);else _msg = this.localeFtc(error['email']);

				var _field = this.findFormField('captcha', this.formData['fields']);
				if (_field) _field['_errMsg'] = _msg;
			}

			if (!_isError) {
				this.form_ErrorMessage = _msg;
			}

			this.formRequest();
		},
		request: function request() {
			var _this3 = this;

			if (this.form_Loading) return;

			if (!this.formData || !this.formData['fields']) return;

			this.form_ErrorMessage = false;
			this.successMessage = '';

			var _data = this.collectFormData(this.formData['fields'], this.localFormValidation);

			if (_data === false) return;

			var _url = '/user/forget';
			this.forms_GetThenPost(_url, _data, function () {
				_this3.successMessage = _this3.localeFtc('forget/success<br><br> forget/email_sent');
			}, function (error) {
				if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted') {
					_this3.form_ErrorMessage = _this3.localeFtc('login/blacklisted');

					_this3.formData = null;
				} else _this3.failRequest(error);
			});
		},
		logOut: function logOut() {
			var _this4 = this;

			this.forms_GetThenPost('/logout', false, function () {
				_this4.$store.commit('dropAuth');
				_this4.$router.push('/login');
			}, function () {
				_this4.$router.push('/');
			});
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default.a
	}

});

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCodeArive === false) ? _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData && _vm.formData.title ? _vm.formData.title : 'forget/title')))]), _vm._v(" "), (_vm.errorWithLogout) ? [_c('div', {
    staticClass: "text-center alert alert-danger",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.errorWithLogout),
      expression: "errorWithLogout"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/logout')))])] : _vm._e(), _vm._v(" "), (!_vm.errorWithLogout) ? [(_vm.form_ErrorMessage) ? _c('div', [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "padding": "10px",
      "margin": "20px 0 20px"
    },
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.softReloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.successMessage) ? _c('form', {
    staticClass: "w5-from",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "w5-form-row"
    }, [(row && row.length) ? [_vm._l((row), function(field) {
      return [(['locale', 'code'].indexOf(field._field_name) < 0) ? _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _vm._e()]
    })] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.form_Loading) ? _c('img', {
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }) : _c('button', {
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.request
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/remind')))])])], 2)]) : _c('div', {
    style: (_vm.form_ErrorMessage || _vm.successMessage ? 'height: 0' : 'height: 135px')
  }), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "text-center alert alert-success",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.form_Loading && !_vm.form_ErrorMessage) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [(!_vm.successMessage) ? [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('login/remembered')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])] : _vm._e()], 2) : _vm._e()] : _vm._e()], 2) : _c('div', {
    staticClass: "user-forget-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("ftc")('forget/title')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCodeError !== ''),
      expression: "isCodeError !== ''"
    }],
    staticClass: "alert alert-danger code-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isCodeError)),
      expression: "localeFtc(isCodeError)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== '' && _vm.successMessage !== false),
      expression: "successMessage !== '' && successMessage !== false"
    }],
    staticClass: "alert alert-success code-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.successMessage)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'userCheckForm',
	data: function data() {
		return {
			successMessage: false,
			isCodeError: '',
			isCode: null
		};
	},
	created: function created() {
		var _keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.query);

		if (!_keys.length) {
			this.isCodeError = 'user/check_notcode';
			return;
		}

		var _code = _keys[0];

		if (_code === undefined || _code === null || String(_code).trim() === '') {
			this.isCodeError = 'user/check_notcode';
			return;
		}

		this.isCode = _code;
	},
	mounted: function mounted() {
		var _this = this;

		if (this.isCode) {
			var _url = this.APIServerUrl + '/user/check?' + this.isCode;

			this.$http.get(_url).then(function (data) {
				var _dt = data && data.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.data) === 'object' ? data.data : false;
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && 'status' in _dt && _dt['status'] === 'ok') {
					_this.successMessage = _dt.content;

					return;
				}

				_this.isCodeError = _this.localeFtc('main/error_desc');
				var _msg = '';

				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['title']) _msg = _dt['title'];
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['content']) _msg = _dt['content'];

				if (!_msg) _this.isCodeError = _this.isCodeError.replace(':', '.');else {
					_msg = '<b>' + _msg + '</b>';
					_this.isCodeError += ' <br> ' + _msg;
				}
			}, function (error) {
				var _dt = error && error.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.data) === 'object' ? error.data : false;
				_this.isCodeError = _this.localeFtc('main/error_desc');
				var _msg = '';

				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['title']) _msg = _dt['title'];
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['content']) _msg = _dt['content'];

				if (!_msg) _this.isCodeError = _this.isCodeError.replace(':', '.');else {
					_msg = '<b>' + _msg + '</b>';
					_this.isCodeError += ' <br> ' + _msg;
				}
			});
		}
	}
});

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-forget-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("ftc")('user/check_title')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCodeError !== ''),
      expression: "isCodeError !== ''"
    }],
    staticClass: "alert alert-danger code-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isCodeError)),
      expression: "localeFtc(isCodeError)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== '' && _vm.successMessage !== false),
      expression: "successMessage !== '' && successMessage !== false"
    }],
    staticClass: "alert alert-success code-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.successMessage)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'emailCheckForm',
	data: function data() {
		return {
			successMessage: false,
			isCodeError: '',
			isCode: null
		};
	},
	created: function created() {
		var _keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.query);

		if (!_keys.length) {
			this.isCodeError = 'email/check_notcode';
			return;
		}

		var _code = _keys[0];

		if (_code === undefined || _code === null || String(_code).trim() === '') {
			this.isCodeError = 'email/check_notcode';
			return;
		}

		this.isCode = _code;
	},
	mounted: function mounted() {
		var _this = this;

		if (this.isCode) {
			var _url = this.APIServerUrl + '/email/check?' + this.isCode;

			this.$http.get(_url).then(function (data) {
				var _dt = data && data.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.data) === 'object' ? data.data : false;
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && 'status' in _dt && _dt['status'] === 'ok') {
					_this.successMessage = _dt.content;

					return;
				}

				_this.isCodeError = _this.localeFtc('main/error_desc');
				var _msg = '';

				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['title']) _msg = _dt['title'];
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['content']) _msg = _dt['content'];

				if (!_msg) _this.isCodeError = _this.isCodeError.replace(':', '.');else {
					_msg = '<b>' + _msg + '</b>';
					_this.isCodeError += ' <br> ' + _msg;
				}
			}, function (error) {
				var _dt = error && error.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.data) === 'object' ? error.data : false;
				_this.isCodeError = _this.localeFtc('main/error_desc');
				var _msg = '';

				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['title']) _msg = _dt['title'];
				if (_dt && (typeof _dt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_dt)) === 'object' && _dt['content']) _msg = _dt['content'];

				if (!_msg) _this.isCodeError = _this.isCodeError.replace(':', '.');else {
					_msg = '<b>' + _msg + '</b>';
					_this.isCodeError += ' <br> ' + _msg;
				}
			});
		}
	}
});

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-forget-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("ftc")('email/title')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCodeError !== ''),
      expression: "isCodeError !== ''"
    }],
    staticClass: "alert alert-danger code-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isCodeError)),
      expression: "localeFtc(isCodeError)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== '' && _vm.successMessage !== false),
      expression: "successMessage !== '' && successMessage !== false"
    }],
    staticClass: "alert alert-success code-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.successMessage)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'unsubscribeForm',
	data: function data() {
		return {
			successMessage: false,
			errorMessage: false,
			isCode: null,
			isType: null,
			showQuestion: false
		};
	},
	created: function created() {
		var _$route$params = this.$route.params,
		    _type = _$route$params.type,
		    _code = _$route$params.code;

		if (_type === undefined || _type === null || String(_type).trim() === '' || _code === undefined || _code === null || String(_code).trim() === '' || String(_code).length !== 32) {
			this.errorMessage = 'main/unsubscribe_error';
			return;
		}

		this.isType = _type;
		this.isCode = _code;

		this.showQuestion = true;
	},

	methods: {
		unsubscribeStart: function unsubscribeStart() {
			var _this = this;

			this.showQuestion = false;

			var _url = this.APIServerUrl + '/ticket/unsubscribe/' + this.isType + '/' + this.isCode;

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this.successMessage = 'main/unsubscribe_done';

					return;
				}

				_this.errorMessage = _this.localeFtc('<b>main/error_desc</b>');
				if (_dt && _dt.content) _this.errorMessage += '<br><br>' + _dt.content;else _this.errorMessage = _this.errorMessage.replace(':', '.').replace(/strong/g, 'span');
			}, function (res) {
				_this.errorMessage = _this.formatRequestError(res);
			});
		}
	}

});

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form unsubscribe-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/unsubscribe')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== false),
      expression: "successMessage !== false"
    }],
    staticClass: "w5-field text-center alert alert-success margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.successMessage)),
      expression: "localeFtc(successMessage)"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage !== false),
      expression: "errorMessage !== false"
    }],
    staticClass: "w5-field text-center alert alert-danger margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorMessage)),
      expression: "localeFtc(errorMessage)"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), (_vm.showQuestion === false) ? [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])] : [_c('div', {
    staticClass: "w5-field text-left margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/unsubscribe_question')),
      expression: "localeFtc('main/unsubscribe_question')"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/unsubscribe_text')),
      expression: "localeFtc('main/unsubscribe_text')"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unsubscribeStart($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/unsubscribe_button')))])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_filterPeriod__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_filterPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_filterPeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_filterRadio__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_filterRadio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_filterRadio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_filterBool__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_filterBool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_filterBool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_filterSelect__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_filterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_filterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_filterLogs__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_filterLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_widgets_filterLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_filterLabel__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_filterLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_filterLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_filterDisk__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_filterDisk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_widgets_filterDisk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_filterParams__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_filterParams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_widgets_filterParams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_paginator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_widgets_paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_elements_btndropdown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_elements_btndropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_elements_btndropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_elements_oneoper__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_elements_oneoper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_elements_oneoper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_elements_money__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_elements_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_elements_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_elements_backupdialog__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_elements_backupdialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_elements_backupdialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_calc__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_elements_calc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_elements_calc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_rack__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_elements_rack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_elements_rack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_elements_radio__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_elements_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_elements_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_view__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_elements_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_elements_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mixins__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_elements_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_elements_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_elements_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__helper_additional_services_filters__ = __webpack_require__(126);


































/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'List',

	mixins: [__WEBPACK_IMPORTED_MODULE_27__mixins__["a" /* default */]],
	data: function data() {
		return {
			listData: false,

			crud: null,

			action: 'list',

			page: 1,

			paginationPages: [],

			lastPage: 1,

			localErrorMessage: '',

			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			table_Loading: false,

			silenceRequestTimer: null,

			silenceRequestTimerCounter: 0,

			renderRows: false,
			initRows: false,

			buildTableSpiner: false,

			fastSearchValue: '',

			ipBlackListValue: '',

			viewData: null,
			viewSortDATA: null,
			viewKeys: null,
			showViewModal: false,

			filters: {
				period: {
					visible: -1,

					valueBegin: false,
					valueEnd: false
				},
				radio: [],
				bool: {
					visible: -1,
					value: false
				},
				select: [],
				logs: {
					visible: -1,
					value: false
				},
				ticketLabel: {
					visible: -1,
					value: null
				},
				diskType: {
					visible: -1,
					value: null
				},
				planParams: {
					visible: -1,
					value: {
						cpu_min: null,
						cpu_max: null,
						ram_min: null,
						ram_max: null,
						disk_min: null,
						disk_max: null
					}
				}
			},

			sortedColumn: false,

			buttons: {
				'on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'off': {
					visible: false,
					active: false,
					icone: 'stop'
				},
				'close': {
					visible: false,
					active: false,
					icone: 'lock'
				},
				'blockTicket': {
					visible: false,
					active: false,
					icone: 'times-circle',
					title: 'ticket/blacklist'
				},
				'migrate': {
					visible: false,
					active: false,
					icone: 'upload',
					title: 'service/migrate'
				},
				'closeTicket': {
					visible: false,
					active: false,
					icone: 'lock',
					title: 'main/closing'
				},
				'replaceTicket': {
					visible: false,
					active: false,
					icone: 'upload',
					title: 'ticketrule/action_move'
				},
				'serviceMove': {
					visible: false,
					active: false,
					icone: 'share-square',
					title: 'service/move'
				},
				'bulkDel': {
					visible: false,
					active: false,
					icone: 'trash-alt',
					title: 'main/deleting'
				},
				'exportCsv': {
					visible: false,
					active: false,
					icone: 'file-csv',
					title: 'main/export CSV'
				},
				'r_on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'r_off': {
					visible: false,
					active: false,
					icone: 'stop'
				},
				'ip_on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'ip_off': {
					visible: false,
					active: false,
					icone: 'stop'
				}
			},

			buttonCreateVisibe: false,

			lastWorkedRowID: false,

			totalSelectedRowsCount: 0,

			showDeleteModal: false,
			deleteModalTitle: '',
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteRecordIdInProcess: [],

			deleteModalCallback: function deleteModalCallback() {},

			showConfirmModalDialog: false,
			confirmModalDialogTitle: '',
			confirmModalDialogText: '',
			confirmModalDialogCallback: function confirmModalDialogCallback() {},

			domainRebootProcessing: false,

			outerDiskCloneProcessing: {},

			showBlockModal: false,
			blockModalNoteRequired: false,
			blockModalWhat: '',
			blockRows: [],
			blockModalTitle: '',
			blockModalText: '',
			blockModalButtonTitle: '',
			blockModalSelectNoteValue: '',
			blockModalTextNoteValue: '',
			blockModalTextField: {
				type: 'textarea',
				title: 'notes/write_note',
				_field_name: 'blockModalTextNoteValue',
				_visible: true,
				_errMsg: ''
			},

			showRegisterModal: false,
			registerRows: [],
			registerModalWhat: '',
			registerModalText: '',
			registerModalButtonTitle: '',
			registerModalTitle: '',

			ippoolBlockValue: null,

			showMigrateModal: false,
			migrateRows: [],
			migrateModalSelectServerValue: false,
			migrateModalButtonDisabled: true,
			migrateModalServerField: {
				required: true,
				type: 'list',
				list: [],
				title: 'server/server',
				_field_name: 'migrateModalServerValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			showServiceMoveModal: false,
			serviceMoveRows: [],
			serviceMoveModalSelectAccountValue: false,
			serviceMoveModalButtonDisabled: true,
			serviceMoveModalButtonCounter: 0,
			serviceMoveModalButtonHandler: null,
			serviceMoveModalButtonTitle: 'service/move',
			serviceMoveModalAccountField: {
				required: true,
				type: 'list',
				list: [],
				title: 'account/account',
				url: '/service/move?search=account&q=',
				_field_name: 'serviceMoveModalAccountValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			serviceBulkDelRows: [],
			showServiceBulkDelModal: false,
			serviceBulkDelModalButtonDisabled: true,
			serviceBulkDelModalButtonCounter: 0,
			serviceBulkDelModalButtonHandler: null,
			serviceBulkDelModalButtonTitle: '',

			showTicketMoveModal: false,
			ticketRows: [],
			ticketMoveModalSelectDepartmentValue: false,
			ticketMoveModalButtonDisabled: true,
			ticketMoveModalDepartmentField: {
				required: true,
				type: 'list',
				list: [],
				title: 'department/department',
				_field_name: 'ticketMoveModalDepartmentValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			showTicketBlockModal: false,
			ticketBlockRows: [],
			ticketBlockModalBody: '',
			ticketBlockModalTimer: 0,
			ticketBlockModalButtonTitle: '',
			ticketBlockModalTimerHandle: null,

			showDocumentModalDialog: false,
			documentModalDialogLinkPdf: null,
			documentModalDialogLinkXml: null,

			crudFilter: false,

			httpGetFilter: false,

			crudHttpGetFilter: false,

			accountGlobalFilter: false,

			isoModalTitle: '',
			showISOModal: false,
			isoModalText: '',
			isoID: null,
			isoParentID: null,
			isoBlockModalButtonTitle: '',

			blockModalTimer: null,
			blockModalTimerHandler: null,

			showPaymentModal: false,
			paymentFields: null,
			paymentMax: 0,
			paymentMin: 0,
			PaymentWarrning: false,
			PaymentWarrningAdditional: false,
			isPaymentModalButtonDisabled: false,

			showCalcModal: false,

			showRackGraphicModal: false,
			rackGraphicModalData: null,

			showBalancePopup: false,
			balanceValue: 0,
			balanceContainerStyle: false,
			balanceField: {
				required: true,
				type: 'money',
				title: 'operation/summa',
				_field_name: 'summa',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: 0
			},

			curWindowY: 0,

			showChoiceTicketLabelBlock: false,
			ticketLabelBlockStyle: '',
			ticketLabelItems: {},
			ticketLabelId: null,

			ticketDepartmentId: false,

			showMarkTicketsAsReadedDialog: false,

			showMergeTicketsDialog: false,
			mergeTicketsField: {
				required: true,
				_field_name: 'mergeTicketsSelectTicket',
				type: 'list',
				title: 'ticket/ticket',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				url: '/ticket/update/%ID%?search=ticket&q=',
				value: null
			},
			mergeTicketsOldId: null,

			countDigits: 2,

			canProlongProcessing: false,

			showPaymentLinkDialog: false,
			paymentLinkUrl: '',

			fastSearchTimer: null,

			ticketLastCommentator: '',
			ticketLastCommentatorStyle: { display: 'none', top: 0, left: 0 },

			showConnectOuterDiskDialog: false,
			connectOuterDiskDialogMode: 'disk',
			connectOuterDiskDialogId: false,
			connectOuterDiskValue: '',
			connectOuterDiskField: {
				required: true,
				type: 'list',
				title: 'service/vds',
				_field_name: 'vdsId',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				list: [],
				value: ''
			},

			showBackupDialog: false,
			backupDialogType: 'create-backup',
			backupDialogAccount: false,
			backupDialogId: false,
			backupDialogName: '',

			showRenameBackupDialog: false,
			renameBackupId: false,
			renameBackupValue: '',
			renameBackupField: {
				required: true,
				type: 'text',
				title: 'service/backup',
				_field_name: 'backupName',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},

			showRestoreBackupOuterDiskDialog: false,
			restoreBackupOuterDiskData: null,
			restoreBackupOuterDiskValue: '',
			restoreBackupOuterDiskField: {
				required: true,
				type: 'list',
				title: 'service/backup',
				_field_name: 'backup_id_for_outer_disk',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},
			restoreBackupOuterDiskWarning: '',
			restoreBackupOuterDiskNotice: '',

			clientPartnerData: null,

			showRemoveFilterModal: false,
			removeFilterValue: null,
			removeFilterID: null,
			removeFilterProcess: false,

			showCopyToDcModal: false,
			copyToDcID: null,
			copyToDcForm: null,
			copyToDcFields: null,
			copyToDcCostInfo: '',
			copyToDcErrorMessage: '',

			showVdsCloneModal: false,
			vdsCloneModalFieldBoolean: {
				type: 'boolean',
				title: 'main/vds_clone_field_boolean_title',
				_field_name: 'vdsCloneFieldBoolean',
				_visible: true,
				_errMsg: '',
				value: false
			},
			vdsCloneModalFieldBooleanValue: false,
			vdsCloneModalFieldList: {
				required: true,
				_field_name: 'vdsCloneFieldList',
				type: 'list',
				title: 'datacenter/datacenter',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				value: null
			},
			vdsCloneModalFieldListValue: null,
			vdsCloneID: null,
			vdsCloneName: null,
			vdsCloneProcessData: [],
			vdsCloneShowProcessDataValue: false,
			vdsCloneShowProcessDataInfo: null,

			showDownloadBackupModal: false,
			downloadBackupID: null,

			FD: false,
			FD_count: 0,

			afterRequestDataCallbacks: [],

			reserveIpLocalData: null,
			reserveIpValue: false,
			reserveIpProcessing: false,
			reserveIpCost: '',
			reserveIpVdsId: null,

			backupScheduleTableTitle: '',
			backupScheduleId: null,
			backupScheduleRows: [],
			backupScheduleMode: 'create',
			showBackupScheduleModal: false,
			backupScheduleForm: null,

			timerDownloadFile: null
		};
	},

	computed: {
		createScheduleEmpty: function createScheduleEmpty() {
			if (this.backupScheduleMode !== 'create') return false;

			if (!this.backupScheduleForm || !this.backupScheduleForm.fields || !this.backupScheduleForm.fields.length) return false;

			var _result = true;
			this.backupScheduleForm.fields.some(function (row) {
				if (row && row.length) {
					var _found = row.some(function (field) {
						if (field && field.type === 'boolean' && field.value) {
							return true;
						}
					});

					if (_found) {
						_result = false;
						return true;
					}
				}
			});

			return _result;
		},
		ippoolBlockStatuses: function ippoolBlockStatuses() {
			var _answer = [];

			if (!this.form_GetData || !this.form_GetData.filters || !this.form_GetData.filters.ip_status || !this.form_GetData.filters.ip_status.list || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.form_GetData.filters.ip_status.list) !== 'object') return _answer;

			for (var id in this.form_GetData.filters.ip_status.list) {
				if (id === 'active') continue;
				_answer.push({ id: id, name: this.form_GetData.filters.ip_status.list[id] });
			}

			return _answer;
		},
		isCrudFilterOnMyTicket: function isCrudFilterOnMyTicket() {
			if (!this.crudFilter || !this.crudFilter.crud) return false;

			if (this.crudFilter.crud === 'ticket' && this.crudFilter.field === 'has_user_id' && this.crudFilter.object) return true;else return false;
		},
		isPrintReady: function isPrintReady() {
			return window && window.print;
		},
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		listConfig: function listConfig() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['list']) return this.Config[this.crud]['list'];
			return false;
		},
		linkHint: function linkHint() {
			if (this.crud && this.action && this.Config && this.Config[this.crud] && this.Config[this.crud]['hint-link'] && this.Config[this.crud]['hint-link'][this.action]) return this.Config[this.crud]['hint-link'][this.action];

			return false;
		},
		model: function model() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['model']) return this.Config[this.crud]['model'];
			return this.formater_capitalizeFirstChar(this.crud) + 'Search';
		},
		UserType: function UserType() {
			return this.$store.state.user_type;
		},
		AppServerUrl: function AppServerUrl() {
			return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].AppServerUrl;
		},
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		},
		isUnreadedTickets: function isUnreadedTickets() {
			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' || !this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false;

			return this.renderRows.some(function (row) {
				if ('message_unread_count' in row && row['message_unread_count'] > 0) return true;
			});
		},
		crudHttpFilterTitle: function crudHttpFilterTitle() {
			var _title = '';
			if (this.crudHttpGetFilter) {
				if ('has_user_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['has_user_id'] && this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['has_user_id'] && this.form_GetData.filters['has_user_id']['title'] && this.form_GetData.filters['has_user_id']['text']) {
					if (_title === '') _title = this.form_GetData.filters['has_user_id']['title'] + ' = ' + this.form_GetData.filters['has_user_id']['text'];else _title += ', ' + this.form_GetData.filters['has_user_id']['title'] + ' = ' + this.form_GetData.filters['has_user_id']['text'];
				}

				if ('server_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['server_id'] && this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['server_id'] && this.form_GetData.filters['server_id']['title'] && this.form_GetData.filters['server_id']['text']) {
					if (_title === '') _title = this.form_GetData.filters['server_id']['title'] + ' = ' + this.form_GetData.filters['server_id']['text'];else _title += ', ' + this.form_GetData.filters['server_id']['title'] + ' = ' + this.form_GetData.filters['server_id']['text'];
				}

				if ('service_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['service_id'] && this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['service_id'] && this.form_GetData.filters['service_id']['title'] && this.form_GetData.filters['service_id']['text']) {
					if (_title === '') _title = this.form_GetData.filters['service_id']['title'] + ' = ' + this.form_GetData.filters['service_id']['text'];else _title += ', ' + this.form_GetData.filters['service_id']['title'] + ' = ' + this.form_GetData.filters['service_id']['text'];
				}

				if ('bonus_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['bonus_id'] && this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['bonus_id'] && this.form_GetData.filters['bonus_id']['title'] && this.form_GetData.filters['bonus_id']['text']) {
					if (_title === '') _title = this.form_GetData.filters['bonus_id']['title'] + ' = ' + this.form_GetData.filters['bonus_id']['text'];else _title += ', ' + this.form_GetData.filters['bonus_id']['title'] + ' = ' + this.form_GetData.filters['bonus_id']['text'];
				}

				if ('p2a_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['p2a_id'] && this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['p2a_id'] && this.form_GetData.filters['p2a_id']['title'] && this.form_GetData.filters['p2a_id']['text']) {
					if (_title === '') _title = this.form_GetData.filters['p2a_id']['title'] + ' = ' + this.form_GetData.filters['p2a_id']['text'];else _title += ', ' + this.form_GetData.filters['p2a_id']['title'] + ' = ' + this.form_GetData.filters['p2a_id']['text'];
				}
			}
			return _title;
		},
		countActiveFilters: function countActiveFilters() {
			var _answer = 0;

			for (var _type in this.filters) {
				if (this.filters.hasOwnProperty(_type)) {
					var _filter = this.filters[_type];

					if ((typeof _filter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_filter)) !== 'object' || _type === 'bool') continue;

					if ('visible' in _filter) {
						if (_filter['visible'] === true) _answer++;
					} else {
						for (var _idx in _filter) {
							if (_filter.hasOwnProperty(_idx)) {
								var __filter = _filter[_idx];

								if ('visible' in __filter) {
									if (__filter['visible'] === true) _answer++;
								}
							}
						}
					}
				}
			}return _answer;
		},
		browserSupportCopy: function browserSupportCopy() {
			return document.queryCommandSupported('copy') || parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2]) >= 42;
		},
		showCloseTicketButton: function showCloseTicketButton() {
			return false;
		}
	},
	created: function created() {
		this.afterRequestListData = __WEBPACK_IMPORTED_MODULE_29_debounce___default()(this.afterRequestListData, 200);

		__WEBPACK_IMPORTED_MODULE_31__helper_additional_services_filters__["a" /* default */].init();

		if (!this.$store.state.is_auth) {
			if (this.$route.path === '/operation/list') {
				var hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null;

				if (hash) {
					return this.$router.push('/operation/view/' + hash);
				}
			}

			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.maskModalFlag = false;

		this.getFilterFromUrl();

		this.initData(this.$route.path);

		this.initFilters();

		this.getLocalStorage();

		this.getDataFromVuex();

		this.getDataFromUrl();

		if (this.crud) {
			this.requestListData();
			this.getClientPartnerInfo();

			this.vdsCloneProcessDataGet();
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);
		window.addEventListener('scroll', this.windowScroll);
		window.addEventListener('resize', this.windowResize);
		window.addEventListener('storage', this.onLocalStorageEvent);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$on('w5-user-options-on-server-get', this.getLocalStorage);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$on('w5-block-application', this.blockApplicationHandler);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$on('w5-cron-task-answer', this.cronTaskAnswer);

		this.windowResize();

		if (this.crud === 'backups') {
			var _data = window && window.sessionStorage ? window.sessionStorage.getItem('create-backup') : null;

			if (_data) {
				window.sessionStorage.removeItem('create-backup');

				this.backupDialogType = 'create-backup';
				this.backupDialogId = false;
				this.backupDialogName = '';
				this.backupDialogAccount = false;
				if (this.$store.state.user_type !== 'admin') this.backupDialogAccount = true;else {
					if (this.accountGlobalFilter && this.accountGlobalFilter.text) {
						var _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '');
						var _num = parseInt(_numStr);
						if (!isNaN(_num)) this.backupDialogAccount = _num;
					}
				}

				__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
				this.showBackupDialog = true;
			}

			_data = window && window.sessionStorage ? window.sessionStorage.getItem('copy-backup') : null;

			if (_data) {
				window.sessionStorage.removeItem('copy-backup');
				this.afterRequestDataCallbacks.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
					var _result;

					return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return _this2.$http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/service/list?ServiceSearch[service_id]=' + _data);

								case 2:
									_result = _context.sent;

									if (!(!_result || !_result.body || _result.body.status !== 'ok' || !_result.body.rows || !_result.body.rows.length)) {
										_context.next = 5;
										break;
									}

									return _context.abrupt('return');

								case 5:

									_this2.copyToDc(_result.body.rows[0]);

								case 6:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this2);
				})));
			}
		}
	},
	updated: function updated() {
		var _pathRoute = this.crud + this.page;
		if (this.$store.state.lastWindowY && this.$store.state.lastWindowY[_pathRoute]) {
			var _y = this.$store.state.lastWindowY[_pathRoute];
			if (_y) setTimeout(function () {
				return window.scrollTo(0, _y);
			}, 200);

			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': false
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);
		window.removeEventListener('scroll', this.windowScroll);
		window.removeEventListener('resize', this.windowResize);
		window.removeEventListener('storage', this.onLocalStorageEvent);

		this.stopAllTimers();

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$off('w5-user-options-on-server-get', this.getLocalStorage);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$off('w5-block-application', this.blockApplicationHandler);

		__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$off('w5-cron-task-answer', this.cronTaskAnswer);
	},

	watch: {
		'$route': function $route(to, from) {
			var _oldCRUD = this.crud;
			var _oldAction = this.action;
			var _oldTicketDepartmentId = this.ticketDepartmentId;
			var _oldVdsGroupId = from.params['groupId'];
			var _oldPage = this.page;

			this.getFilterFromUrl();

			this.initData(to.path);

			var _isChanged = false;

			if (_oldCRUD !== this.crud) _isChanged = true;else {
				if (this.crud === 'certificate' || this.crud === 'domains') {
					if (to && to.params && 'groupId' in to.params && from && from.params && 'groupId' in from.params && to.params['groupId'] !== from.params['groupId']) _isChanged = true;
				}
			}

			if (_isChanged) {
				this.listData = false;

				this.renderRows = false;
				this.initRows = false;

				this.fastSearchValue = null;

				this.sortedColumn = false;

				this.initFilters();

				this.getLocalStorage();

				this.getDataFromVuex();
			}

			this.getDataFromUrl();

			if (this.crud) {
				if (this.crud === 'ticket') {
					if (_oldCRUD !== this.crud || _oldAction !== this.action || _oldTicketDepartmentId !== this.ticketDepartmentId || _oldPage !== this.page) this.requestListData();
				} else if (this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains') {
					if (_oldCRUD !== this.crud || _oldAction !== this.action || _oldPage !== this.page || _oldVdsGroupId !== to.params['groupId']) this.requestListData();
				} else this.requestListData();

				this.getClientPartnerInfo();

				this.vdsCloneProcessDataGet();
			}
		}
	},

	methods: {
		blockApplicationHandler: function blockApplicationHandler() {
			this.stopAllTimers();
		},
		stopAllTimers: function stopAllTimers() {
			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = null;
			}

			if (this.blockModalTimerHandler) {
				clearInterval(this.blockModalTimerHandler);
				this.blockModalTimerHandler = null;
			}

			if (this.ticketBlockModalTimerHandle) {
				clearInterval(this.ticketBlockModalTimerHandle);
				this.ticketBlockModalTimerHandle = null;
			}

			if (this.silenceRequestTimer) {
				clearTimeout(this.silenceRequestTimer);
				this.silenceRequestTimer = null;
			}

			if (this.fastSearchTimer) {
				clearTimeout(this.fastSearchTimer);
				this.fastSearchTimer = null;
			}

			if (this.serviceMoveModalButtonHandler) {
				clearInterval(this.serviceMoveModalButtonHandler);
				this.serviceMoveModalButtonHandler = null;
			}

			if (this.serviceBulkDelModalButtonHandler) {
				clearInterval(this.serviceBulkDelModalButtonHandler);
				this.serviceBulkDelModalButtonHandler = null;
			}

			if (this.timerDownloadFile) {
				clearInterval(this.timerDownloadFile);
				this.timerDownloadFile = null;
			}
		},
		getClientPartnerInfo: function getClientPartnerInfo() {
			var _this3 = this;

			if (this.crud === 'partner' && this.$store.state.user_type !== 'admin') {
				this.clientPartnerData = null;
				this.$http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/partner/list?additional=getCounters').then(function (res) {
					if (res && res.data && res.data.status === 'ok' && res.data.result && res.data.result.accounts) {
						_this3.clientPartnerData = res.data.result.accounts;
					}
				}).catch(function () {});
			}
		},
		vdsCloneVdsInProcess: function vdsCloneVdsInProcess(vdsId) {
			if (this.crud !== 'vds') return null;
			if (!this.vdsCloneProcessData || !this.vdsCloneProcessData.length) return null;

			for (var i = 0; i < this.vdsCloneProcessData.length; i++) {
				if (this.vdsCloneProcessData[i].id === vdsId) return this.vdsCloneProcessData[i];
			}

			return null;
		},
		exportCsvButtonInit: function exportCsvButtonInit() {
			this.buttons['exportCsv']['visible'] = true;

			if (this.$store.state.user_type !== 'admin') {
				this.buttons['exportCsv']['active'] = true;
			} else {
				this.buttons['exportCsv']['active'] = Boolean(this.accountGlobalFilter && this.accountGlobalFilter.text);
			}
		},
		closeAllFilters: function closeAllFilters() {
			for (var _type in this.filters) {
				if (this.filters.hasOwnProperty(_type)) {
					var _filter = this.filters[_type];

					if ((typeof _filter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_filter)) !== 'object' || _type === 'bool') continue;

					if ('visible' in _filter) {
						if (_filter['visible'] === true) this.toggleFilter(_type);
					} else {
						for (var _idx in _filter) {
							if (_filter.hasOwnProperty(_idx)) {
								var __filter = _filter[_idx];

								if ('visible' in __filter) {
									if (__filter['visible'] === true) this.toggleFilter(_type, _idx);
								}
							}
						}
					}
				}
			}
			this.$set(this, 'crudHttpGetFilter', false);
		},
		initData: function initData(path) {
			this.crud = null;
			this.localErrorMessage = '';
			this.deleteRecordIdInProcess = [];

			this.ticketDepartmentId = null;

			if (this.fastSearchTimer) {
				clearTimeout(this.fastSearchTimer);
				this.fastSearchTimer = null;
			}

			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}

			if (this.ticketBlockModalTimerHandle) {
				clearInterval(this.ticketBlockModalTimerHandle);
				this.ticketBlockModalTimerHandle = false;
			}

			if (this.blockModalTimerHandler) {
				clearInterval(this.blockModalTimerHandler);
				this.blockModalTimerHandler = null;
			}

			if (this.silenceRequestTimer) {
				clearTimeout(this.silenceRequestTimer);
				this.silenceRequestTimer = null;
			}

			this.hideDeleteModal();
			this.hideConfirmModalDialog();
			this.hideBlockModal();
			this.hideRegisterModal();
			this.hideRemoveFilterModal();
			this.hideMigrateModal();
			this.hideServiceMoveModal();
			this.hideServiceBulkDelModal();
			this.hideTicketMoveModal();
			this.hideTicketBlockModal();
			this.hideISOModal();
			this.hideViewModal();
			this.hidePaymentModal();
			this.hideCalcModal();
			this.hideRackGraphicModal();
			this.hideBalancePopup();
			this.hideTicketLabelBlock();
			this.hideDocumentModalDialog();
			this.hideBackupDialog();
			this.hideConnectOuterDiskDialog();
			this.hideCopyToDcModal();
			this.hideVdsCloneModal();
			this.hideVdsCloneProcessInfoModal();
			this.hideDownloadBackupModal();
			this.hideRenameBackupDialog();
			this.hideRestoreBackupOuterDiskDialog();
			this.hideBackupScheduleModal();

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 2 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'list' && _urlParts[1] !== 'department') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.crud = _urlParts[0];
			this.action = _urlParts[1];

			if (this.crud === 'ticket' && this.action === 'department') {
				this.ticketDepartmentId = this.$route.params['depid'] && this.$route.params['depid'].length ? parseInt(this.$route.params['depid']) : false;
				if (isNaN(this.ticketDepartmentId) || this.ticketDepartmentId <= 0) this.ticketDepartmentId = false;

				if (!this.ticketDepartmentId) {
					this.$router.push('/ticket/list');
					return;
				}
			}

			this.$store.commit('setTicketDepartmentId', this.ticketDepartmentId);

			this.page = this.$route.params['page'] && this.$route.params['page'].length ? parseInt(this.$route.params['page']) : 1;
			if (isNaN(this.page)) this.page = 1;

			if (this.page <= 1) {
				this.page = 1;

				if (this.crud === 'ticket' && this.action === 'department') this.$router.replace('/ticket/department/' + this.ticketDepartmentId);else if (this.crud === 'ipptrpool' || this.crud === 'iphistory') {} else this.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] : ''));
			}

			if (this.crud && this.page) this.$store.commit('setLastPage', { 'crud': this.crud, 'page': this.page });

			for (var b in this.listConfig['buttons']) {
				if (b === 'create') this.buttonCreateVisibe = this.isAccess('/' + this.crud + '/create');

				if (b in this.buttons) {
					if (b === 'migrate') this.buttons[b]['visible'] = this.isAccess('service/migrate');else if (b === 'serviceMove') this.buttons[b]['visible'] = this.isAccess('service/move');else if (b === 'bulkDel') this.buttons[b]['visible'] = this.isAccess('service/delete');else this.buttons[b]['visible'] = this.isAccess(this.crud + '/update');

					this.buttons[b]['active'] = false;

					if (b === 'exportCsv') this.exportCsvButtonInit();
				}
			}

			this.blockRows = [];
			this.migrateRows = [];
			this.serviceMoveRows = [];
			this.serviceBulkDelRows = [];

			if (!this.listConfig) {
				this.crud = null;
				this.$router.push('/404');
			}
		},
		initFilters: function initFilters() {
			this.filters.period.visible = -1;
			this.filters.period.valueBegin = false;
			this.filters.period.valueEnd = false;

			this.filters.radio = [];

			this.filters.bool.visible = -1;
			this.filters.bool.value = false;

			this.filters.select = [];

			this.filters.logs.visible = -1;
			this.filters.logs.value = false;

			this.filters.ticketLabel.visible = -1;
			this.filters.ticketLabel.value = null;

			this.filters.diskType.visible = -1;
			this.filters.diskType.value = null;

			if (!this.listConfig['filters']) return;

			for (var f in this.listConfig['filters']) {
				if (f === 'period' || f === 'bool' || f === 'logs' || f === 'ticketLabel' || f === 'diskType') continue;

				if (f === 'radio' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.listConfig['filters']['radio']) === 'object') {
					var _radio = this.listConfig['filters']['radio'];

					for (var r in _radio) {
						this.filters.radio.push({
							'field': r,
							'title': _radio[r],
							'visible': -1,

							'value': null
						});
					}
				}

				if (f === 'select' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.listConfig['filters']['select']) === 'object') {
					var _select = this.listConfig['filters']['select'];

					for (var s in _select) {
						this.filters.select.push({
							'field': s,
							'title': _select[s],
							'visible': -1,
							'value': { id: -1, name: 'main/list_all' }
						});
					}
				}
			}
		},
		moveRows: function moveRows() {
			var _this4 = this;

			if (!this.initRows || !this.initRows.length) {
				this.initRows = false;
				this.buildTableSpiner = false;
				this.buttonsForSelectedRow();
				return;
			}

			setTimeout(function () {
				_this4.renderRows = _this4.renderRows.concat(_this4.initRows.slice(0, 50));
				_this4.initRows = _this4.initRows.slice(50);

				if (_this4.renderRows.length > 100) _this4.buildTableSpiner = true;

				_this4.moveRows();
			}, 100);
		},
		PreRequestListDataRadioFilter: function PreRequestListDataRadioFilter(data) {
			if (this.crud === 'notes' && data['field'] === 'note_object') {
				if (this.crudFilter && this.crudFilter['crud'] === 'notes') {
					this.$set(this, 'crudFilter', false);
					this.$store.commit('setCrudFilter', false);
				}
			}

			this.setLocalStorage();
			this.requestListData();
		},
		PreRequestListDataSelectFilter: function PreRequestListDataSelectFilter(data) {
			this.setLocalStorage();
			this.requestListData();
		},
		initRequestFilters: function initRequestFilters() {
			var _this5 = this;

			var _getParams = {};
			_getParams[this.model] = {};

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['period'] && this.filters.period.visible !== -1) {
				var _filter = this.filters.period;
				if (_filter.valueBegin) _getParams[this.model][this.listConfig['filters']['period']['begin_field']] = _filter.valueBegin;
				if (_filter.valueEnd) _getParams[this.model][this.listConfig['filters']['period']['end_field']] = _filter.valueEnd;
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['radio'] && this.filters.radio) {
				this.filters.radio.forEach(function (item) {
					if (item.visible === true && item.value !== null && item.value !== undefined) {
						_getParams[_this5.model][item.field] = item.value;
					}
				});
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['select'] && this.filters.select) {
				this.filters.select.forEach(function (item) {
					if (item.multiselect) {
						if (item.visible === true && item.value !== null && item.value !== undefined && item.value.length) {
							var _filterValue = __WEBPACK_IMPORTED_MODULE_31__helper_additional_services_filters__["a" /* default */].filterValue(item.value);
							if (_filterValue) {
								_getParams[_this5.model][item.field] = _filterValue;
							}
						}
					} else {
						if (item.visible === true && item.value !== null && item.value !== undefined && item.value.id !== null && item.value.id !== undefined && String(item.value.id) !== '-1') {
							_getParams[_this5.model][item.field] = item.value.id;
						}
					}
				});
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['bool'] && this.listConfig['filters']['bool']['field'] && this.filters.bool && this.filters.bool.visible !== -1 && this.filters.bool['value'] === true) {
				_getParams[this.model][this.listConfig['filters']['bool']['field']] = true;
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['logs'] && this.listConfig['filters']['logs']['field'] && this.filters.logs && this.filters.logs.visible !== -1 && this.filters.logs.value) {
				_getParams[this.model][this.listConfig['filters']['logs']['field']] = this.filters.logs.value;
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['ticketLabel'] && this.filters.ticketLabel && this.filters.ticketLabel.visible !== -1 && this.filters.ticketLabel.value) {
				_getParams[this.model]['ticket_label'] = this.filters.ticketLabel.value;
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['diskType']) {
				if (this.filters.diskType.visible === true && this.filters.diskType.value) {
					_getParams[this.model]['service_type_id'] = this.filters.diskType.value;
				} else {
					_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_EXTDISK_HDD + ',' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_EXTDISK_NVME;
				}
			}

			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['planParams'] && this.filters.planParams && this.filters.planParams.visible !== -1 && this.filters.planParams.value) {
				if (this.filters.planParams.value.cpu_min !== null && this.filters.planParams.value.cpu_min !== undefined && this.filters.planParams.value.cpu_max !== null && this.filters.planParams.value.cpu_max !== undefined) {
					_getParams[this.model]['cpu_min'] = this.filters.planParams.value.cpu_min;
					_getParams[this.model]['cpu_max'] = this.filters.planParams.value.cpu_max;
				}

				if (this.filters.planParams.value.ram_min !== null && this.filters.planParams.value.ram_min !== undefined && this.filters.planParams.value.ram_max !== null && this.filters.planParams.value.ram_max !== undefined) {
					_getParams[this.model]['ram_min'] = this.filters.planParams.value.ram_min;
					_getParams[this.model]['ram_max'] = this.filters.planParams.value.ram_max;
				}

				if (this.filters.planParams.value.disk_min !== null && this.filters.planParams.value.disk_min !== undefined && this.filters.planParams.value.disk_max !== null && this.filters.planParams.value.disk_max !== undefined) {
					_getParams[this.model]['disk_min'] = this.filters.planParams.value.disk_min;
					_getParams[this.model]['disk_max'] = this.filters.planParams.value.disk_max;
				}
			}

			if (this.crudFilter && this.crudFilter['crud'] === this.crud) {
				var _crudField = this.crudFilter['field'] ? this.crudFilter['field'] : this.crudFilterField();
				if (this.$store.state.accountGlobalFilter === true && _crudField === 'account_id') {
					this.crudFilter = false;
				} else if (_crudField) _getParams[this.model][_crudField] = this.crudFilter['object'];
			}

			if (this.$store.state.modelFilter) {
				if (!_getParams[this.model][this.$store.state.modelFilter['field']]) _getParams[this.model][this.$store.state.modelFilter['field']] = this.$store.state.modelFilter['value'];
			}

			this.$store.commit('setModelFilter', false);

			if (this.crud === 'vds' && this.$store.state.filteredGroupId) {
				_getParams[this.model]['group_id'] = this.$store.state.filteredGroupId;
				this.filters.radio.some(function (item) {
					if (item.field === 'group_id') {
						item.value = _this5.$store.state.filteredGroupId;
						item.visible = true;
						return true;
					}
				});
				this.setLocalStorage();
				this.$store.commit('setFilteredGroupId', null);
			}

			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '') _getParams[this.model]['fast_search'] = this.fastSearchValue;

			if (this.crudHttpGetFilter && this.crudHttpGetFilter['__crud'] === this.crud) {
				for (var _prop in this.crudHttpGetFilter) {
					if (this.crudHttpGetFilter.hasOwnProperty(_prop)) {
						if (_prop.substr(0, 2) === '__') continue;

						if (!(_prop in _getParams[this.model])) _getParams[this.model][_prop] = this.crudHttpGetFilter[_prop];
					}
				}
			}

			if (this.sortedColumn !== false) _getParams['sort'] = this.sortedColumn.charAt(0) === '+' ? this.sortedColumn.substr(1) : this.sortedColumn;

			return _getParams;
		},
		requestListData: function requestListData() {
			var _this6 = this;

			var silenceMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (!this.crud) return;

			if (!silenceMode) this.table_Loading = true;
			this.$store.commit('ListTableLoading', true);

			this.totalSelectedRowsCount = 0;

			for (var _b in this.buttons) {
				this.buttons[_b]['active'] = false;
			}
			this.exportCsvButtonInit();

			var _selectedRows = {};
			if (this.renderRows && this.renderRows.length) this.renderRows.forEach(function (row) {
				if (row && row['w5-row-selected'] === true) {
					_selectedRows[String(row[_this6.listConfig['column_id']])] = 1;
				}
			});

			var _getParams = this.initRequestFilters();

			var _url = '/';

			if (this.crud === 'vds') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS;
			} else if (this.crud === 'iso') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_ISO;
			} else if (this.crud === 'backups') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS;
			} else if (this.crud === 'disks') {
				_url += 'service';
			} else if (this.crud === 'additional-services') {
				_url += 'service';
				if (!_getParams[this.model]['service_type_id']) {
					_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_31__helper_additional_services_filters__["a" /* default */].all_ids;
				}
			} else if (this.crud === 'certificate') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_SSL;
			} else if (this.crud === 'domains') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DOMAIN;
			} else if (this.crud === 'dns') {
				_url += 'service';
				_getParams[this.model]['service_type_id'] = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DNS;
			} else if (this.crud === 'ipptrpool') {
				_url += 'ipptrpool';
				_getParams['ip_id'] = this.$route.query.id;
			} else if (this.crud === 'iphistory') {
				_url += 'ippool';
				_getParams['ip_id'] = this.$route.query.id;
			} else if (this.crud === 'planarchive') {
				_url += 'plan';
			} else if (this.crud === 'ticket' && this.action === 'department') {
				_url += 'ticket';
				_getParams[this.model]['department_id'] = this.ticketDepartmentId;
			} else _url += this.crud;

			if (this.crud === 'planarchive') {
				_url += '/archive';
			} else if (this.crud === 'iphistory') {
				_url += '/history';
			} else _url += '/list';

			_url += this.page > 1 ? '/' + this.page : '';

			if (this.crud === 'ticket' && this.action === 'department' && !this.$store.state.ticketData.departments.length) {
				setTimeout(function () {
					return _this6.requestListData(silenceMode);
				}, 200);
				return;
			}

			var _currentFullPath = this.$router.currentRoute.fullPath;

			this.forms_Get(_url, _getParams, function (data) {
				if (_currentFullPath !== _this6.$router.currentRoute.fullPath) return;

				if (!data || data['status'] !== 'ok' || !data['columns'] || data['rows'] === undefined || _this6.crud !== 'chart' && _this6.crud !== 'role' && !data['filters'] || data['pageCount'] === undefined || data['pageSize'] === undefined || data['totalCount'] === undefined) {
					if (!silenceMode) {
						_this6.form_ErrorMessage = _this6.localeFtc('error/api_incorrect');
					}

					_this6.table_Loading = false;
					_this6.$store.commit('ListTableLoading', false);
				} else {
					if (_this6.crud === 'ticket' && _this6.action === 'department') {
						var _departmentData = false;
						_this6.$store.state.ticketData.departments.some(function (item) {
							if (String(item['id']) === String(_this6.ticketDepartmentId)) {
								_departmentData = item;

								return true;
							}
						});

						if (_departmentData && _departmentData['type'] === 'alerts') {
							_this6.buttonCreateVisibe = false;
							_this6.buttons['replaceTicket']['visible'] = false;
						}

						if (!data['rows'] || !Array.isArray(data['rows']) || !data['rows'].length) {
							var _foundDepartment = _departmentData && _departmentData['access'] === true;

							if (!_foundDepartment) {
								_this6.$router.push('/404');
								return;
							}
						} else {
							data['rows'].forEach(function (item, idx, arr) {
								arr[idx]['department_id'] = _departmentData['id'];
								arr[idx]['department_type'] = _departmentData['type'];
							});
						}

						if (data['filters'] && data['filters']['has_user_id'] && data['filters']['has_user_id']['value'] !== null && data['filters']['has_user_id']['value'] !== undefined) {
							_this6.crudFilter = {
								'crud': 'ticket',
								'object': data['filters']['has_user_id']['value'],
								'field': 'has_user_id'
							};
							_this6.setLocalStorage();
							_this6.$store.commit('setCrudFilter', false);
						}
					}

					_this6.countDigits = 2;
					if (_this6.crud === 'operation' && _this6.$store.state.user_type === 'admin') {
						data['rows'].forEach(function (item) {
							if (item && 'operation_summa' in item && item['operation_summa'] !== null && item['operation_summa'] !== undefined) _this6.recountDigitsForString(item['operation_summa']);
						});
					}
					if (_this6.crud === 'account' && _this6.$store.state.user_type === 'admin') {
						data['rows'].forEach(function (item) {
							if (item && 'real_balance' in item && item['real_balance'] !== null && item['real_balance'] !== undefined) _this6.recountDigitsForString(item['real_balance']);
						});
					}

					if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_selectedRows).length) {
						data['rows'].forEach(function (item, idx, arr) {
							var _id = String(item[_this6.listConfig['column_id']]);
							if (_selectedRows[_id]) arr[idx]['w5-row-selected'] = true;
						});
					}

					_this6.listData = _this6.form_GetData;

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['period']) {
						if (_this6.filters.period.visible === -1) _this6.filters.period.visible = false;

						if (data['filters'][_this6.listConfig['filters']['period']['begin_field']] && data['filters'][_this6.listConfig['filters']['period']['begin_field']]['value']) {
							_this6.filters.period.visible = true;
							_this6.filters.period.valueBegin = data['filters'][_this6.listConfig['filters']['period']['begin_field']]['value'];
						}

						if (data['filters'][_this6.listConfig['filters']['period']['end_field']] && data['filters'][_this6.listConfig['filters']['period']['end_field']]['value']) {
							_this6.filters.period.visible = true;
							_this6.filters.period.valueEnd = data['filters'][_this6.listConfig['filters']['period']['end_field']]['value'];
						}
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['radio'] && _this6.filters.radio) {
						_this6.filters.radio.forEach(function (item) {

							if (data['filters'] && data['filters'][item.field]) {
								if (item.visible === -1) item.visible = false;
							}

							if (data['filters'] && data['filters'][item.field] && data['filters'][item.field]['value'] !== null && data['filters'][item.field]['value'] !== undefined) {
								item.visible = true;
								item.value = data['filters'][item.field]['value'];

								if (_this6.crud === 'notes' && item.field === 'note_object') {
									if (data['filters'][item.field]['list']) {
										if (!(item.value in data['filters'][item.field]['list'])) {
											item.visible = false;
											item.value = null;
										}
									} else {
										item.visible = false;
										item.value = null;
									}
								}
							}
						});
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['bool'] && _this6.listConfig['filters']['bool']['field']) {
						_this6.filters.bool.value = false;

						if (data['filters'] && data['filters'][_this6.listConfig['filters']['bool']['field']]) {
							if (_this6.filters.bool['visible'] === -1) _this6.filters.bool['visible'] = true;
						}

						if (data['filters'][_this6.listConfig['filters']['bool']['field']] && __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].normalizeBooleanValue(data['filters'][_this6.listConfig['filters']['bool']['field']]['value']) === true) {
							_this6.filters.bool['value'] = true;
						}
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['select'] && _this6.filters.select) {
						_this6.filters.select.forEach(function (item) {
							if (data['filters'] && data['filters'][item.field]) {
								if (item.visible === -1) item.visible = false;
							}

							if (_this6.crud === 'server') {
								if (data['filters'] && data['filters'][item.field] && data['filters'][item.field]['title']) {
									item.title = data['filters'][item.field]['title'];
								}
							}

							if (data['filters'] && data['filters'][item.field] && data['filters'][item.field]['value'] !== null && data['filters'][item.field]['value'] !== undefined && data['filters'][item.field]['list'] !== null && data['filters'][item.field]['list'] !== undefined) {
								var _val = data['filters'][item.field]['value'];
								if (_val === null || _val === undefined) _val = -1;

								if (data['filters'][item.field]['multiselect'] === true) item.multiselect = true;else item.multiselect = undefined;

								if (_val !== -1) {
									item.visible = true;

									if (item.multiselect) {
										if (Array.isArray(_val) && _val.length) {
											item.value = [];
											_val.forEach(function (id) {
												var _name = id;

												if (Array.isArray(data['filters'][item.field]['list'])) {
													data['filters'][item.field]['list'].some(function (itm) {
														if (String(itm.id) === String(id)) {
															_name = itm.name;
															return true;
														}
													});
												} else {
													for (var o in data['filters'][item.field]['list']) {
														if (String(o) === String(id)) {
															_name = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].localeFtc(data['filters'][item.field]['list'][o]);
															break;
														}
													}
												}

												item.value.push({
													id: id,
													name: _name
												});
											});
										}
									} else {
										item.value = { id: _val };

										if (Array.isArray(data['filters'][item.field]['list'])) {
											data['filters'][item.field]['list'].some(function (itm) {
												if (String(itm.id) === String(item.value.id)) {
													item.value['name'] = itm.name;
													return true;
												}
											});
										} else {
											for (var o in data['filters'][item.field]['list']) {
												if (String(o) === String(item.value.id)) {
													item.value['name'] = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].localeFtc(data['filters'][item.field]['list'][o]);
													break;
												}
											}
										}
									}

									if (_this6.crud === 'additional-services' && item.field === 'service_type_id' && _val && Array.isArray(_val)) {
										if (__WEBPACK_IMPORTED_MODULE_31__helper_additional_services_filters__["a" /* default */].is_all_ids(_val) || _val.length === 1 && String(_val[0]['id'] === '-1')) {
											item.visible = false;
											item.value = null;
										}
									}
								}
							}
						});
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['logs'] && _this6.listConfig['filters']['logs']['field']) {
						if (_this6.filters.logs.visible !== -1) _this6.filters.logs.visible = false;

						if (data['filters'][_this6.listConfig['filters']['logs']['field']]) {
							if (_this6.filters.logs.visible === -1) _this6.filters.logs.visible = false;
						}

						if (data['filters'][_this6.listConfig['filters']['logs']['field']] && data['filters'][_this6.listConfig['filters']['logs']['field']]['value']) {
							_this6.filters.logs['value'] = data['filters'][_this6.listConfig['filters']['logs']['field']]['value'];
							_this6.filters.logs.visible = true;
						}
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['ticketLabel']) {
						if (_this6.filters.ticketLabel.visible !== -1) _this6.filters.ticketLabel.visible = false;

						if (data['filters']['ticket_label']) {
							if (_this6.filters.ticketLabel.visible === -1) _this6.filters.ticketLabel.visible = false;
						}

						if (data['filters']['ticket_label'] && data['filters']['ticket_label']['value']) {
							_this6.filters.ticketLabel['value'] = data['filters']['ticket_label']['value'];
							_this6.filters.ticketLabel.visible = true;
						}
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['diskType']) {
						if (_this6.filters.diskType.visible !== -1) _this6.filters.diskType.visible = false;

						if (data['filters']['service_type_id']) {
							if (_this6.filters.diskType.visible === -1) _this6.filters.diskType.visible = false;
						}

						_this6.filters.diskType['value'] = null;

						if (data['filters']['service_type_id'] && data['filters']['service_type_id']['value']) {
							if (Array.isArray(data['filters']['service_type_id']['value']) && data['filters']['service_type_id']['value'].length === 1) {
								_this6.filters.diskType['value'] = String(data['filters']['service_type_id']['value'][0]);
								_this6.filters.diskType.visible = true;
							} else if (typeof data['filters']['service_type_id']['value'] === 'string') {
								_this6.filters.diskType['value'] = data['filters']['service_type_id']['value'];
								_this6.filters.diskType.visible = true;
							}
						}
					}

					if (_this6.listConfig && _this6.listConfig['filters'] && _this6.listConfig['filters']['planParams']) {

						if (data['filters']['cpu_min'] || data['filters']['cpu_max'] || data['filters']['ram_min'] || data['filters']['ram_max'] || data['filters']['disk_min'] || data['filters']['disk_max']) {
							if (_this6.filters.planParams.visible === -1) _this6.filters.planParams.visible = false;
						}

						if (data['filters']['cpu_min'] && 'value' in data['filters']['cpu_min'] && data['filters']['cpu_min']['value'] !== null && data['filters']['cpu_min']['value'] !== undefined) {
							_this6.filters.planParams['value']['cpu_min'] = data['filters']['cpu_min']['value'];
							_this6.filters.planParams.visible = true;
						}
						if (data['filters']['cpu_max'] && 'value' in data['filters']['cpu_max'] && data['filters']['cpu_max']['value'] !== null && data['filters']['cpu_max']['value'] !== undefined) {
							_this6.filters.planParams['value']['cpu_max'] = data['filters']['cpu_max']['value'];
							_this6.filters.planParams.visible = true;
						}

						if (data['filters']['ram_min'] && 'value' in data['filters']['ram_min'] && data['filters']['ram_min']['value'] !== null && data['filters']['ram_min']['value'] !== undefined) {
							_this6.filters.planParams['value']['ram_min'] = data['filters']['ram_min']['value'];
							_this6.filters.planParams.visible = true;
						}
						if (data['filters']['ram_max'] && 'value' in data['filters']['ram_max'] && data['filters']['ram_max']['value'] !== null && data['filters']['ram_max']['value'] !== undefined) {
							_this6.filters.planParams['value']['ram_max'] = data['filters']['ram_max']['value'];
							_this6.filters.planParams.visible = true;
						}

						if (data['filters']['disk_min'] && 'value' in data['filters']['disk_min'] && data['filters']['disk_min']['value'] !== null && data['filters']['disk_min']['value'] !== undefined) {
							_this6.filters.planParams['value']['disk_min'] = data['filters']['disk_min']['value'];
							_this6.filters.planParams.visible = true;
						}
						if (data['filters']['disk_max'] && 'value' in data['filters']['disk_max'] && data['filters']['disk_max']['value'] !== null && data['filters']['disk_max']['value'] !== undefined) {
							_this6.filters.planParams['value']['disk_max'] = data['filters']['disk_max']['value'];
							_this6.filters.planParams.visible = true;
						}
					}

					_this6.accountGlobalFilter = false;

					if (data['globalFilter'] && data['globalFilter']['id'] && data['globalFilter']['name']) {
						_this6.accountGlobalFilter = {
							'title': _this6.localeFtc('filter/global').replace(' {client}', ''),
							'text': data['globalFilter']['name']
						};
					}

					_this6.$store.commit('accountGlobalFilter', _this6.accountGlobalFilter !== false);

					if (_this6.crudFilter && _this6.crudFilter['crud'] === _this6.crud) {
						var _crudField = _this6.crudFilter['field'] ? _this6.crudFilter['field'] : _this6.crudFilterField();

						if (_this6.accountGlobalFilter && _crudField === 'account_id') {
							_this6.crudFilter = false;
						} else if (_this6.crud === 'server' && _crudField === 'datacenter_id' || _this6.crud === 'rack' && _crudField === 'datacenter_id') {
								_this6.crudFilter = false;
							} else if (_crudField && data['filters'][_crudField] && data['filters'][_crudField]['value']) {
									_this6.crudFilter['text'] = data['filters'][_crudField]['text'];
								}
					}

					var _urlParts = _this6.$route.path.substr(_this6.$route.path.charAt(0) === '/' ? 1 : 0).split('/');
					if (!_urlParts[0]) _urlParts[0] = _this6.crud;

					_this6.paginationPages = [];
					_this6.lastPage = 1;

					var _total = parseInt(data['totalCount']);
					var _size = parseInt(data['pageSize']);

					if (_total > _size) {
						var _pagesCount = Math.ceil(_total / _size);
						if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1;

						if (_this6.page > _pagesCount) {
							_this6.page = _pagesCount;

							if (_this6.crud === 'ticket' && _this6.action === 'department') _this6.$router.replace('/ticket/department/' + _this6.ticketDepartmentId + '/' + _this6.page);else if (_this6.crud === 'ipptrpool' || _this6.crud === 'iphistory') {} else _this6.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] + '/' + _this6.page : ''));
						}

						if (_pagesCount > 1 && _this6.crud !== 'chart') {
							_this6.lastPage = _pagesCount;

							var _begin = _this6.page - 8;
							if (_begin < 1) _begin = 1;
							var _end = _this6.page + 8;
							if (_end > _pagesCount) _end = _pagesCount;

							for (var k = _begin; k <= _pagesCount; k++) {
								if (k > _end) break;
								_this6.paginationPages.push(k);
							}
						}
					} else {
						if (_this6.crud === 'ticket' && _this6.action === 'department') _this6.$router.replace('/ticket/department/' + _this6.ticketDepartmentId);else if (_this6.crud === 'ipptrpool' || _this6.crud === 'iphistory') {} else _this6.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] : ''));
					}

					_this6.renderRows = [];
					_this6.initRows = [];

					_this6.$nextTick(function () {
						_this6.renderRows = data['rows'].slice(0, 20);

						_this6.initRows = data['rows'].slice(20);

						if (_this6.initRows && _this6.initRows.length) _this6.moveRows();else {
							_this6.buttonsForSelectedRow();
						}
					});

					_this6.table_Loading = false;
					_this6.$store.commit('ListTableLoading', false);

					_this6.afterRequestListData();
				}
			}, function (res) {
				if (_currentFullPath !== _this6.$router.currentRoute.fullPath) return;

				_this6.table_Loading = false;
				_this6.$store.commit('ListTableLoading', false);

				_this6.afterRequestDataCallbacks = [];
			});
		},
		myTicketsActivate: function myTicketsActivate() {
			var _this7 = this;

			if (this.isCrudFilterOnMyTicket) return;

			var _obj = {
				'crud': 'ticket',
				'object': '',
				'field': 'has_user_id'
			};

			this.$store.commit('setCrudFilter', _obj);
			this.$nextTick(function () {
				return _this7.GoTo({ id: _this7.$store.state.user_id }, 'ticket', '', 'has_user_id');
			});
		},
		toggleFilter: function toggleFilter(name, index) {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _needRefresh, _needRefresh2, item, _needRefresh3;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!(name === 'period')) {
									_context2.next = 10;
									break;
								}

								_this8.filters.period.visible = !_this8.filters.period.visible;

								if (_this8.filters.period.visible) {
									_context2.next = 9;
									break;
								}

								if (!(_this8.filters.period.valueBegin || _this8.filters.period.valueEnd)) {
									_context2.next = 9;
									break;
								}

								_this8.filters.period.valueBegin = false;
								_this8.filters.period.valueEnd = false;
								_context2.next = 8;
								return _this8.setLocalStorage();

							case 8:
								_this8.requestListData();

							case 9:
								return _context2.abrupt('return');

							case 10:
								if (!(name === 'radio')) {
									_context2.next = 20;
									break;
								}

								_this8.filters.radio[index].visible = !_this8.filters.radio[index].visible;

								if (_this8.filters.radio[index].visible) {
									_context2.next = 19;
									break;
								}

								_needRefresh = false;

								if (_this8.filters.radio[index].value !== null && _this8.filters.radio[index].value !== undefined) {
									_needRefresh = true;
								}

								_this8.filters.radio[index].value = null;
								_context2.next = 18;
								return _this8.setLocalStorage(true);

							case 18:
								if (_needRefresh) _this8.requestListData();

							case 19:
								return _context2.abrupt('return');

							case 20:
								if (!(name === 'select')) {
									_context2.next = 31;
									break;
								}

								_this8.filters.select[index].visible = !_this8.filters.select[index].visible;

								if (_this8.filters.select[index].visible) {
									_context2.next = 30;
									break;
								}

								_needRefresh2 = false;
								item = _this8.filters.select[index];

								if (item.value !== undefined && item.value !== null) {
									if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.value) === 'object' && 'id' in item.value) {
										if (item.value.id !== undefined && item.value.id !== null && item.value.id !== '' && item.value.id !== -1) {
											_needRefresh2 = true;
										}
									} else {
										if (item.value !== undefined && item.value !== null && item.value !== '' && item.value !== -1) {
											_needRefresh2 = true;
										}
									}
								}

								_this8.filters.select[index].value = { id: -1, name: 'main/list_all' };
								_context2.next = 29;
								return _this8.setLocalStorage(true);

							case 29:
								if (_needRefresh2) _this8.requestListData();

							case 30:
								return _context2.abrupt('return');

							case 31:
								if (!(name === 'logs')) {
									_context2.next = 40;
									break;
								}

								_this8.filters.logs.visible = !_this8.filters.logs.visible;

								if (_this8.filters.logs.visible) {
									_context2.next = 39;
									break;
								}

								if (!_this8.filters.logs.value) {
									_context2.next = 39;
									break;
								}

								_this8.filters.logs.value = false;
								_context2.next = 38;
								return _this8.setLocalStorage();

							case 38:
								_this8.requestListData();

							case 39:
								return _context2.abrupt('return');

							case 40:
								if (!(name === 'ticketLabel')) {
									_context2.next = 49;
									break;
								}

								_this8.filters.ticketLabel.visible = !_this8.filters.ticketLabel.visible;

								if (_this8.filters.ticketLabel.visible) {
									_context2.next = 48;
									break;
								}

								if (!_this8.filters.ticketLabel.value) {
									_context2.next = 48;
									break;
								}

								_this8.filters.ticketLabel.value = null;
								_context2.next = 47;
								return _this8.setLocalStorage();

							case 47:
								_this8.requestListData();

							case 48:
								return _context2.abrupt('return');

							case 49:
								if (!(name === 'diskType')) {
									_context2.next = 58;
									break;
								}

								_this8.filters.diskType.visible = !_this8.filters.diskType.visible;

								if (_this8.filters.diskType.visible) {
									_context2.next = 57;
									break;
								}

								if (!_this8.filters.diskType.value) {
									_context2.next = 57;
									break;
								}

								_this8.filters.diskType.value = null;
								_context2.next = 56;
								return _this8.setLocalStorage();

							case 56:
								_this8.requestListData();

							case 57:
								return _context2.abrupt('return');

							case 58:
								if (!(name === 'planParams')) {
									_context2.next = 68;
									break;
								}

								_this8.filters.planParams.visible = !_this8.filters.planParams.visible;

								if (_this8.filters.planParams.visible) {
									_context2.next = 67;
									break;
								}

								_needRefresh3 = false;

								if (_this8.filters.planParams.value.cpu_min || _this8.filters.planParams.value.cpu_max || _this8.filters.planParams.value.ram_min || _this8.filters.planParams.value.ram_max || _this8.filters.planParams.value.disk_min || _this8.filters.planParams.value.disk_max) {
									_needRefresh3 = true;
								}

								_this8.filters.planParams.value = {
									cpu_min: null,
									cpu_max: null,
									ram_min: null,
									ram_max: null,
									disk_min: null,
									disk_max: null
								};
								_context2.next = 66;
								return _this8.setLocalStorage(true);

							case 66:
								if (_needRefresh3) _this8.requestListData();

							case 67:
								return _context2.abrupt('return');

							case 68:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this8);
			}))();
		},
		closeDirectlyFilter: function closeDirectlyFilter(name) {
			if (name === 'planParams') {
				var _oldVisibleValue = this.filters.planParams.visible;
				this.filters.planParams.visible = false;

				this.filters.planParams.value = {
					cpu_min: null,
					cpu_max: null,
					ram_min: null,
					ram_max: null,
					disk_min: null,
					disk_max: null
				};

				if (_oldVisibleValue === true) {
					this.setLocalStorage();
					this.requestListData();
				}
			}
		},
		formater: function formater(formaterName, value) {
			return this[formaterName](value);
		},
		cellClass: function cellClass(field, column) {
			var _class = [];

			if (column['class-row']) _class.push(column['class-row']);

			var _sortedCell = false;

			if (this.sortedColumn) {
				if (field === 'account_name') _sortedCell = this.sortedColumn.indexOf('account_id') >= 0;else if (field === 'parent_name_full') _sortedCell = this.sortedColumn.indexOf('parent_id') >= 0;else if (field === 'owner_account_name') _sortedCell = this.sortedColumn.indexOf('owner_account_id') >= 0;else _sortedCell = this.sortedColumn.indexOf(field) >= 0;
			} else {
					if (this.listData && this.listData.defaultSort) _sortedCell = this.listData.defaultSort.indexOf(field) >= 0;
				}

			if (_sortedCell) _class.push('w5-table-cell-sorted');

			return _class.join(' ');
		},
		setLocalStorage: function setLocalStorage() {
			var _this9 = this;

			var withHiddeningFiletsr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _key, _model, _modelString;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (window.localStorage) {
									_context3.next = 3;
									break;
								}

								if (_this9.$store.state.isDebug) window.DEBUG.error('localStorage недоступен');
								return _context3.abrupt('return', false);

							case 3:
								if (_this9.$store.state.user_id) {
									_context3.next = 6;
									break;
								}

								if (_this9.$store.state.isDebug) window.DEBUG.error('пользователь неавторизован');
								return _context3.abrupt('return', false);

							case 6:
								if (_this9.crud) {
									_context3.next = 9;
									break;
								}

								if (_this9.$store.state.isDebug) window.DEBUG.error('CRUD неопределен');
								return _context3.abrupt('return', false);

							case 9:
								_key = 'w5_' + _this9.$store.state.user_id + '_' + _this9.crud;

								if ((_this9.crud === 'certificate' || _this9.crud === 'domains') && _this9.$route.params['groupId']) _key = 'w5_' + _this9.$store.state.user_id + '_' + _this9.crud + '_' + _this9.$route.params['groupId'];

								_model = {};

								_model['fast_search'] = _this9.fastSearchValue;

								if (!_this9.filters.period.valueBegin && !_this9.filters.period.valueEnd) _this9.filters.period.visible = false;

								_model['filters'] = window.ObjDeepClone(_this9.filters);

								if (withHiddeningFiletsr) {
									if (_model['filters']['radio'] && _model['filters']['radio'].length) {
										_model['filters']['radio'].forEach(function (item) {
											item.visible = false;

											if (item.value !== undefined && item.value !== null) {
												item.visible = true;
											}
										});
									}

									if (_model['filters']['select'] && _model['filters']['select'].length) {
										_model['filters']['select'].forEach(function (item) {
											item.visible = false;

											if (item.value !== undefined && item.value !== null) {
												if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.value) === 'object' && 'id' in item.value) {
													if (item.value.id !== undefined && item.value.id !== null && item.value.id !== '' && item.value.id !== -1) {
														item.visible = true;
													}
												} else {
													if (item.value !== undefined && item.value !== null && item.value !== '' && item.value !== -1) {
														item.visible = true;
													}
												}
											}
										});
									}

									if (_model['filters']['planParams'] && _model['filters']['planParams']['value']) {
										_model['filters']['planParams'].visible = false;

										if (_model['filters']['planParams']['value']['cpu_min'] !== undefined && _model['filters']['planParams']['value']['cpu_min'] !== null || (_model['filters']['planParams']['value']['cpu_max'] !== undefined && _model['filters']['planParams']['value']['cpu_max']) !== null) {
											_model['filters']['planParams'].visible = true;
										}

										if (_model['filters']['planParams']['value']['ram_min'] !== undefined && _model['filters']['planParams']['value']['ram_min'] !== null || (_model['filters']['planParams']['value']['ram_max'] !== undefined && _model['filters']['planParams']['value']['ram_max']) !== null) {
											_model['filters']['planParams'].visible = true;
										}

										if (_model['filters']['planParams']['value']['disk_min'] !== undefined && _model['filters']['planParams']['value']['disk_min'] !== null || (_model['filters']['planParams']['value']['disk_max'] !== undefined && _model['filters']['planParams']['value']['disk_max']) !== null) {
											_model['filters']['planParams'].visible = true;
										}
									}
								}

								if (_model['filters']['select'] && _model['filters']['select'].length) {
									_model['filters']['select'].forEach(function (item) {
										if (item.value !== undefined && item.value !== null) {
											if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.value) === 'object' && 'id' in item.value) {
												if (String(item.value.id) === '-1') {
													item.value.name = 'main/list_all';
												}
											}
										}
									});
								}

								_model['sort'] = _this9.sortedColumn;

								if (_this9.crudFilter && _this9.crudFilter['crud'] === _this9.crud) _model['crud'] = _this9.crudFilter;

								if (_this9.crudHttpGetFilter && _this9.crudHttpGetFilter['__crud'] === _this9.crud) _model['http'] = _this9.crudHttpGetFilter;

								_modelString = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_model);
								_context3.prev = 21;
								_context3.next = 24;
								return _this9.remoteStorageSet(_key, _modelString);

							case 24:
								_this9.$store.commit('updateUserOptionsOnServer', {
									key: _key,
									value: _modelString
								});

								window.localStorage.setItem(_key, _modelString);
								_context3.next = 32;
								break;

							case 28:
								_context3.prev = 28;
								_context3.t0 = _context3['catch'](21);

								if (_this9.$store.state.isDebug) window.DEBUG.error(_context3.t0.name + ': ' + _context3.t0.message);
								return _context3.abrupt('return', false);

							case 32:
								return _context3.abrupt('return', true);

							case 33:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this9, [[21, 28]]);
			}))();
		},
		getLocalStorage: function getLocalStorage() {
			if (!this.crud) {
				if (this.$store.state.isDebug) window.DEBUG.error('CRUD неопределен');
				return false;
			}

			var _key = 'w5_' + this.$store.state.user_id + '_' + this.crud;

			if ((this.crud === 'certificate' || this.crud === 'domains') && this.$route.params['groupId']) _key = 'w5_' + this.$store.state.user_id + '_' + this.crud + '_' + this.$route.params['groupId'];

			var data = this.$store.state.userServerOptions && this.$store.state.userServerOptions[_key] ? this.$store.state.userServerOptions[_key] : '';

			if (!data && !window.localStorage) {
				if (this.$store.state.isDebug) window.DEBUG.error('данные недоступны');
				return false;
			}

			if (!this.$store.state.user_id) {
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован');
				return false;
			}

			var _json = null;
			if (data) {
				_json = data;
			} else {
				_json = window.localStorage.getItem(_key);
				if (!_json) return true;
			}

			try {
				var _data = JSON.parse(_json);

				if (_data) {
					if (_data['fast_search']) this.setFastSearchValue(_data['fast_search']);

					if (_data['filters']) this.restoreFilters(_data['filters']);

					if (_data['sort']) this.sortedColumn = _data['sort'];

					if (_data['crud'] && _data['crud']['crud'] === this.crud) {
						if (this.$store.state.accountGlobalFilter === true && _data['crud']['field'] === 'account_id') {} else this.crudFilter = _data['crud'];
					}

					if (_data['http'] && _data['http']['__crud'] === this.crud) this.crudHttpGetFilter = _data['http'];
				}
			} catch (_err) {
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message);
				return false;
			}

			return true;
		},
		restoreFilters: function restoreFilters(filters) {
			if (!filters) return;

			if (filters['period'] && 'visible' in filters['period'] && 'valueBegin' in filters['period'] && 'valueEnd' in filters['period']) {
				this.filters.period = filters['period'];
			}

			if (filters['bool'] && filters['bool']['value'] && this.listConfig['filters'] && this.listConfig['filters']['bool'] && this.listConfig['filters']['bool']['field'] && __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].normalizeBooleanValue(filters['bool']['value']) === true) {
				this.filters.bool = filters['bool'];
			}

			if (filters['radio'] && Array.isArray(filters['radio']) && this.listConfig['filters'] && this.listConfig['filters']['radio'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.listConfig['filters']['radio']) === 'object') {
				this.filters.radio = filters['radio'];

				if (this.filters.radio && this.filters.radio.length) {
					this.filters.radio.forEach(function (item) {
						item.visible = false;

						if (item.value !== undefined && item.value !== null) {
							item.visible = true;
						}
					});
				}
			}

			if (filters['select'] && Array.isArray(filters['select']) && this.listConfig['filters'] && this.listConfig['filters']['select'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.listConfig['filters']['select']) === 'object') {
				this.filters.select = filters['select'];

				if (this.filters.select && this.filters.select.length) {
					this.filters.select.forEach(function (item) {
						item.visible = false;

						if (item.value !== undefined && item.value !== null) {
							if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.value) === 'object' && 'id' in item.value) {
								if (item.value.id !== undefined && item.value.id !== null && item.value.id !== '' && item.value.id !== -1) {
									item.visible = true;
								}
							} else {
								if (item.value !== undefined && item.value !== null && item.value !== '' && item.value !== -1) {
									item.visible = true;
								}
							}
						}
					});
				}
			}

			if (filters['logs'] && 'visible' in filters['logs'] && 'value' in filters['logs']) {
				this.filters.logs = filters['logs'];
			}

			if (filters['ticketLabel'] && 'visible' in filters['ticketLabel'] && 'value' in filters['ticketLabel']) {
				this.filters.ticketLabel = filters['ticketLabel'];
			}

			if (filters['diskType'] && 'visible' in filters['diskType'] && 'value' in filters['diskType']) {
				this.filters.diskType = filters['diskType'];
			}

			if (filters['planParams'] && 'visible' in filters['planParams'] && filters['planParams']['value']) {
				this.filters.planParams = filters['planParams'];

				if (this.filters.planParams && this.filters.planParams['value']) {
					this.filters.planParams.visible = false;

					if (this.filters.planParams['value']['cpu_min'] !== undefined && this.filters.planParams['value']['cpu_min'] !== null || (this.filters.planParams['value']['cpu_max'] !== undefined && this.filters.planParams['value']['cpu_max']) !== null) {
						this.filters.planParams.visible = true;
					}

					if (this.filters.planParams['value']['ram_min'] !== undefined && this.filters.planParams['value']['ram_min'] !== null || (this.filters.planParams['value']['ram_max'] !== undefined && this.filters.planParams['value']['ram_max']) !== null) {
						this.filters.planParams.visible = true;
					}

					if (this.filters.planParams['value']['disk_min'] !== undefined && this.filters.planParams['value']['disk_min'] !== null || (this.filters.planParams['value']['disk_max'] !== undefined && this.filters.planParams['value']['disk_max']) !== null) {
						this.filters.planParams.visible = true;
					}
				}
			}
		},
		buttonsUrl: function buttonsUrl(buttonType) {
			if (buttonType === 'create') {
				if (this.crud === 'rackdevice' && this.crudFilter && this.crudFilter.crud === 'rackdevice' && this.crudFilter.field === 'rack_id' && this.crudFilter.object) {
					return '/' + this.crud + '/create/' + this.crudFilter.object;
				}

				if (this.crud === 'ipptrpool' && this.$route.query.id) {
					return '/' + this.crud + '/create/' + this.$route.query.id;
				}

				return '/' + this.crud + '/create';
			}

			return '#';
		},
		buttonsClass: function buttonsClass(buttonType) {
			var _classes = [];
			if (buttonType === 'create' || buttonType === 'balance' || buttonType === 'calculator' || buttonType === 'transfer') _classes = ['btn', 'btn-submit', 'font-weight-400', 'position-relative'];else {
				_classes.push(this.buttons[buttonType]['icone']);

				if (this.buttons[buttonType]['active'] === true) _classes.push('w5-list-button-active');
			}

			return _classes.join(' ');
		},
		buttonsClick: function buttonsClick(e, buttonType) {
			var _this10 = this;

			if (buttonType === 'balance') {
				if (this.$store.state.user_type === 'client' && this.crud === 'operation') {
					this.balanceContainerStyle = false;
					if (this.$refs && this.$refs['buttonBalance'] && this.$refs['buttonBalance'][0]) {
						var _coord = this.getElementOffset(this.$refs['buttonBalance'][0]);
						this.balanceContainerStyle = 'left:' + _coord.left + 'px; top:' + (_coord.top + 50 - this.curWindowY) + 'px;';
					}

					this.balanceValue = this.AppName === 'vdsina.com' ? 100 : 10000;
					this.balanceField['value'] = this.AppName === 'vdsina.com' ? 100 : 10000;

					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					this.showBalancePopup = true;

					return;
				}
			} else if (buttonType === 'calculator') {
					if (this.$store.state.user_type === 'client' && this.crud === 'operation') {
						__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
						this.showCalcModal = true;
						return;
					}
				} else if (buttonType === 'transfer') {
						if (this.$store.state.user_balance.partner === 0) return;

						this.$http.get(this.APIServerUrl + '/operation/convert').then(function (res) {
							var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

							if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
								var _flds = _this10.parseFormData(_dt);

								if (_flds && _flds.fields) __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].hideFakeFields(_flds.fields);

								if (!_this10.paymentFields) _this10.paymentFields = _flds;else {
									_flds.fields.forEach(function (row) {
										if (row && Array.isArray(row) && row.length) {
											row.forEach(function (fld) {
												var _f = _this10.findField(fld['_field_name']);
												if (_f) _f = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_f, fld);
											});
										}
									});
								}

								__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this10.showPaymentModal = true;

								_this10.$nextTick(function () {
									var _field = _this10.findField('type');

									if (_field && _field['value']) {
										_field['list'].some(function (item) {
											if (String(item['id']) === String(_field['value'])) {
												_this10.paymentMax = item['max'];
												_this10.paymentMin = item['min'];
												return true;
											}
										});
									}

									if (_this10.paymentMax > 0) {
										__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
											'type': 'money',
											'name': 'summa',
											'value': _this10.paymentMax
										});
									}

									var _f = _this10.findField('type');
									if (_f) _this10.fieldChangedPayment(_f);

									_this10.showifPayment();
								});

								return;
							}

							_this10.localErrorMessage = _this10.formatRequestError(res);
						}, function (res) {
							_this10.localErrorMessage = _this10.formatRequestError(res);
						});
						return;
					} else if (buttonType === 'on' || buttonType === 'off') {
							if (!this.isAccess('service/update')) {
								this.buttons[buttonType]['active'] = false;
								return;
							}

							if (this.buttons[buttonType]['active'] === true) {
								if (!this.listConfig['column_id']) {
									if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id');
									return;
								}

								if (!this.listConfig['on-off']) {
									if (this.$store.state.isDebug) window.DEBUG.error('Lbc1: не задано значение on-off');
									return;
								}

								var _nameField = this.listConfig['buttons'][buttonType];
								var _nameFieldMinus = false;
								if (_nameField.charAt(0) === '-') {
									_nameField = _nameField.substr(1);
									_nameFieldMinus = true;
								}
								var _selectedNames = [];
								this.blockRows = [];

								if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
								this.renderRows.forEach(function (item, idx, arr) {
									if (item['w5-row-selected'] === true) {
										_this10.blockRows.push(item);
										_selectedNames.push(item[_nameField]);
									}
								});

								if (!this.blockRows.length) return;

								this.blockModalNoteRequired = false;

								if (!_nameFieldMinus) this.blockModalNoteRequired = true;

								this.blockModalWhat = buttonType;

								this.blockModalSelectNoteValue = { id: null, name: '' };
								this.blockModalTextNoteValue = '';

								if (buttonType === 'off') {
									this.blockModalTitle = 'main/block_process';
									this.blockModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames.join(', ') + '?';
									this.blockModalButtonTitle = 'main/block_action';

									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
									this.showBlockModal = true;
								}

								if (buttonType === 'on') {
									this.blockModalTitle = 'main/unblock_process';
									this.blockModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames.join(', ') + '?';
									this.blockModalButtonTitle = 'main/unblock_action';

									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
									this.showBlockModal = true;
								}
							}
						} else if (buttonType === 'r_on' || buttonType === 'r_off') {
								if (!this.isAccess('service/update')) {
									this.buttons[buttonType]['active'] = false;
									return;
								}

								if (this.buttons[buttonType]['active'] === true) {
									if (!this.listConfig['column_id']) {
										if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id');
										return;
									}

									var _nameField2 = this.listConfig['buttons'][buttonType];
									var _selectedNames2 = [];
									this.registerRows = [];

									if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
									this.renderRows.forEach(function (item, idx, arr) {
										if (item['w5-row-selected'] === true) {
											_this10.registerRows.push(item);
											_selectedNames2.push(item[_nameField2]);
										}
									});

									if (!this.registerRows.length) return;

									this.registerModalWhat = buttonType;

									this.registerModalText = '';
									this.registerModalTitle = '';

									if (buttonType === 'r_off') {
										this.registerModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames2.join(', ') + '?';
										this.registerModalButtonTitle = 'main/block_action';
									}

									if (buttonType === 'r_on') {
										this.registerModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames2.join(', ') + '?';
										this.registerModalButtonTitle = 'main/unblock_action';
									}

									this.registerRowsInModalDialog();
								}
							} else if (buttonType === 'ip_on' || buttonType === 'ip_off') {
									if (!this.isAccess('ippool/update')) {
										this.buttons[buttonType]['active'] = false;
										return;
									}

									if (this.buttons[buttonType]['active'] === true) {
										if (!this.listConfig['column_id']) {
											if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id');
											return;
										}

										var _nameField3 = this.listConfig['buttons'][buttonType];
										var _selectedNames3 = [];
										this.registerRows = [];

										if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
										this.renderRows.forEach(function (item, idx, arr) {
											if (item['w5-row-selected'] === true) {
												_this10.registerRows.push(item);
												_selectedNames3.push(item[_nameField3]);
											}
										});

										if (!this.registerRows.length) return;

										this.registerModalWhat = buttonType;

										this.registerModalText = '';
										this.registerModalTitle = '';

										if (buttonType === 'ip_off') {
											this.ippoolBlockValue = 'block';

											this.registerModalTitle = 'main/block_process';
											this.registerModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames3.join(', ') + '?';
											this.registerModalButtonTitle = 'main/block_action';

											__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
											this.showRegisterModal = true;
										}

										if (buttonType === 'ip_on') {
											this.ippoolBlockValue = null;
											this.registerModalTitle = 'main/unblock_process';
											this.registerModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames3.join(', ') + '?';
											this.registerModalButtonTitle = 'main/unblock_action';

											__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
											this.showRegisterModal = true;
										}
									}
								} else if (buttonType === 'migrate') {
										if (!this.isAccess('service/migrate')) {
											this.buttons[buttonType]['active'] = false;
											return;
										}

										if (this.buttons[buttonType]['active'] === true) {
											this.migrateRows = [];
											if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
											this.renderRows.forEach(function (item, idx, arr) {
												if (item['w5-row-selected'] === true) _this10.migrateRows.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ 'migrate_active': false }, item));
											});

											if (!this.migrateRows.length) return;

											this.$store.commit('needShowLoader', false);
											this.$http.get(this.APIServerUrl + '/service/migrate?search=server&type=vds&q=').then(function (resGet) {
												_this10.$store.commit('needShowLoader', true);

												var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
												if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result'])) {
													if (_dt['result'].length) {
														_this10.$set(_this10.migrateModalServerField, 'list', _dt['result']);

														_this10.migrateModalServerField['listValue'] = _dt['result'][0];
														_this10.migrateModalSelectServerValue = _dt['result'][0];

														_this10.migrateModalValueChanged({
															'listValue': _this10.migrateModalSelectServerValue
														});

														__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
														_this10.showMigrateModal = true;
													} else _this10.localErrorMessage = 'main/data_not_found';

													return;
												}

												_this10.localErrorMessage = 'error/api_incorrect';
											}, function (resGet) {
												_this10.$store.commit('needShowLoader', true);

												_this10.localErrorMessage = 'error/api_incorrect';
											});
										}
									} else if (buttonType === 'serviceMove') {
											if (!this.isAccess('service/move')) {
												this.buttons[buttonType]['active'] = false;
												return;
											}

											if (this.buttons[buttonType]['active'] === true) {
												this.serviceMoveRows = [];
												if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
												this.renderRows.forEach(function (item, idx, arr) {
													if (item['w5-row-selected'] === true && item['can_move'] === true) _this10.serviceMoveRows.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ 'move_active': false }, item));
												});

												if (!this.serviceMoveRows.length) return;

												this.$set(this.serviceMoveModalAccountField, 'list', []);
												this.serviceMoveModalAccountField['listValue'] = false;
												this.serviceMoveModalSelectAccountValue = false;

												this.serviceMoveModalButtonCounter = 5;
												if (this.serviceMoveModalButtonHandler) clearInterval(this.serviceMoveModalButtonHandler);
												this.serviceMoveModalButtonTitle = 'service/move';

												__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
												this.showServiceMoveModal = true;
											}
										} else if (buttonType === 'bulkDel') {
												if (!this.isAccess('service/delete')) {
													this.buttons[buttonType]['active'] = false;
													return;
												}

												if (this.buttons[buttonType]['active'] === true) {
													this.serviceBulkDelRows = [];
													if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
													this.renderRows.forEach(function (item, idx, arr) {
														if (item['w5-row-selected'] === true && (item['can_delete'] === true || item['can_delete'] === undefined)) _this10.serviceBulkDelRows.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item));
													});

													if (!this.serviceBulkDelRows.length) return;

													this.serviceBulkDelModalButtonCounter = 10;
													if (this.serviceBulkDelModalButtonHandler) clearInterval(this.serviceBulkDelModalButtonHandler);

													this.serviceBulkDelModalButtonDisabled = true;
													this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete') + ' - ' + this.serviceBulkDelModalButtonCounter;

													__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
													this.showServiceBulkDelModal = true;

													this.serviceBulkDelModalButtonHandler = setInterval(function () {
														_this10.serviceBulkDelModalButtonCounter--;
														_this10.serviceBulkDelModalButtonTitle = _this10.localeFtc('main/delete') + ' - ' + _this10.serviceBulkDelModalButtonCounter;
														if (_this10.serviceBulkDelModalButtonCounter <= 0) {
															_this10.serviceBulkDelModalButtonTitle = _this10.localeFtc('main/delete');
															clearInterval(_this10.serviceBulkDelModalButtonHandler);
															_this10.serviceBulkDelModalButtonHandler = null;
															_this10.serviceBulkDelModalButtonDisabled = false;
														}
													}, 1000);
												}
											} else if (buttonType === 'replaceTicket') {
													if (!this.isAccess('ticket/update')) {
														this.buttons[buttonType]['active'] = false;
														return;
													}

													if (this.buttons[buttonType]['active'] === true) {
														this.ticketRows = [];
														if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
														this.renderRows.forEach(function (item, idx, arr) {
															if (item['w5-row-selected'] === true) _this10.ticketRows.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ 'ticket_move_active': false }, item));
														});

														if (!this.ticketRows.length) return;

														if (!this.ticketMoveModalDepartmentField['list'] || !Array.isArray(this.ticketMoveModalDepartmentField['list']) || !this.ticketMoveModalDepartmentField['list'].length) this.ticketMoveModalDepartmentField['list'] = this.$store.state.ticketData.departments;

														this.ticketMoveModalDepartmentField['listValue'] = this.$store.state.ticketData.departments[0];
														this.ticketMoveModalSelectDepartmentValue = this.ticketMoveModalDepartmentField['listValue'];

														this.ticketMoveModalValueChanged({
															'listValue': this.ticketMoveModalDepartmentField['listValue']
														});

														__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
														this.showTicketMoveModal = true;
													}
												} else if (buttonType === 'closeTicket') {
														if (!this.isAccess('ticket/close')) {
															this.buttons[buttonType]['active'] = false;
															return;
														}

														if (this.buttons[buttonType]['active'] === true) {
															var _tickets = {};
															if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
															this.renderRows.forEach(function (item) {
																if (item['w5-row-selected'] === true && item['can_close'] !== false) _tickets[item['ticket_id']] = 1;
															});

															this.$http.get(this.APIServerUrl + '/ticket/close?additional=setClose').then(function (res) {
																var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

																if (_dt && _dt['_csrf']) {
																	var _post = { '_csrf': _dt['_csrf'], tickets: _tickets };

																	_this10.$http.post(res.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
																		_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;
																		if (_dt && _dt['status'] === 'ok') {
																			_this10.buttons['closeTicket']['active'] = false;

																			_this10.requestListData(true);

																			return;
																		}

																		_this10.localErrorMessage = _this10.formatRequestError(resPost);
																	}, function (resPost) {
																		_this10.localErrorMessage = _this10.formatRequestError(resPost);
																	});

																	return;
																}

																_this10.localErrorMessage = _this10.formatRequestError(res);
															}, function (res) {
																_this10.localErrorMessage = _this10.formatRequestError(res);
															});
														}
													} else if (buttonType === 'blockTicket') {
															if (!this.isAccess('ticket/update')) {
																this.buttons[buttonType]['active'] = false;
																return;
															}

															if (this.buttons[buttonType]['active'] === true) {
																this.ticketBlockRows = [];
																if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
																this.renderRows.forEach(function (item, idx, arr) {
																	if (item['w5-row-selected'] === true && item['can_blacklist'] === true) _this10.ticketBlockRows.push(item);
																});

																if (!this.ticketBlockRows.length) return;

																this.ticketBlockModalTimer = 5;
																this.ticketBlockModalButtonTitle = this.localeFtc('ticketrule/block_timer').replace('{count}', 5);
																if (this.ticketBlockRows.length > 1) {
																	var txt = [];
																	this.ticketBlockRows.forEach(function (item) {
																		if (item['ticket_email']) txt.push(item['ticket_email']);else if (item['ticket_code']) txt.push(item['ticket_code']);else if (item['ticket_subject']) txt.push(item['ticket_subject']);
																	});

																	this.ticketBlockModalBody = this.localeFtc('ticketrule/blacklist_prompt_plural');
																	this.ticketBlockModalBody = this.ticketBlockModalBody.replace('{tickets}', txt.join(', '));
																} else {
																	var _txt2 = '';
																	if (this.ticketBlockRows[0]['ticket_email']) _txt2 = this.ticketBlockRows[0]['ticket_email'];else if (this.ticketBlockRows[0]['ticket_code']) _txt2 = this.ticketBlockRows[0]['ticket_code'];else if (this.ticketBlockRows[0]['ticket_subject']) _txt2 = this.ticketBlockRows[0]['ticket_subject'];

																	this.ticketBlockModalBody = this.localeFtc('ticketrule/blacklist_prompt');
																	this.ticketBlockModalBody = this.ticketBlockModalBody.replace('{email}', _txt2);
																}

																__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
																this.showTicketBlockModal = true;

																this.ticketBlockModalTimerHandle = setInterval(function () {
																	_this10.ticketBlockModalTimer--;
																	_this10.ticketBlockModalButtonTitle = _this10.localeFtc('ticketrule/block_timer').replace('{count}', _this10.ticketBlockModalTimer);
																	if (_this10.ticketBlockModalTimer <= 0) {
																		_this10.ticketBlockModalButtonTitle = _this10.localeFtc('main/block_action');
																		clearInterval(_this10.ticketBlockModalTimerHandle);
																		_this10.ticketBlockModalTimerHandle = null;
																	}
																}, 1000);

																return;
															}
														} else if (buttonType === 'create') {
																if (this.crud === 'vds') {
																	this.$router.push('/vds/create');
																} else if (this.crud === 'backups') {
																	this.backupDialogType = 'create-backup';
																	this.backupDialogId = false;
																	this.backupDialogName = '';
																	this.backupDialogAccount = false;
																	if (this.$store.state.user_type !== 'admin') this.backupDialogAccount = true;else {
																		if (this.accountGlobalFilter && this.accountGlobalFilter.text) {
																			var _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '');
																			var _num = parseInt(_numStr);
																			if (!isNaN(_num)) this.backupDialogAccount = _num;
																		}
																	}

																	__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
																	this.showBackupDialog = true;
																}
															} else if (buttonType === 'exportCsv') {
																	var _weCan = false;
																	if (this.$store.state.user_type !== 'admin') {
																		_weCan = true;
																	} else {
																		_weCan = Boolean(this.accountGlobalFilter && this.accountGlobalFilter.text);
																	}

																	if (!_weCan) return;

																	if (!this.buttons['exportCsv']['active']) return;

																	this.buttons['exportCsv']['active'] = false;

																	var data = this.initRequestFilters();

																	this.$http.get(this.APIServerUrl + '/operation/list/csv', { params: data, responseType: 'arraybuffer' }).then(function (res) {
																		var fileName = 'export.csv';
																		var contentDisposition = res.headers.get('content-disposition');
																		if (contentDisposition) {
																			var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
																			if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
																		}

																		var blob = new Blob([res.data], { type: res.headers.get('content-type') });
																		var url = window.URL.createObjectURL(blob);
																		var link = document.createElement('a');
																		link.href = url;
																		link.download = fileName;
																		document.body.appendChild(link);
																		link.click();

																		_this10.buttons['exportCsv']['active'] = true;
																		_this10.$nextTick(function () {
																			link.remove();
																			window.URL.revokeObjectURL(url);
																		});
																	});
																}
		},
		blockModalValueChanged: function blockModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(field['listValue']) === 'object' && field['listValue']['name']) {
				this.$set(this, 'blockModalTextNoteValue', field['listValue']['name']);
			}
		},
		migrateModalValueChanged: function migrateModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(field['listValue']) === 'object' && field['listValue']['id']) {
				var _serverID = field['listValue']['id'];

				var _unselected = 0;

				this.migrateRows.forEach(function (item, idx, arr) {
					if (String(item['server_id']) === String(_serverID)) {
						_unselected++;
						arr[idx]['migrate_active'] = false;
					} else {
						arr[idx]['migrate_active'] = true;
					}
				});

				if (_unselected === this.migrateRows.length) this.migrateModalButtonDisabled = true;else this.migrateModalButtonDisabled = false;
			}
		},
		serviceMoveModalValueChanged: function serviceMoveModalValueChanged(field) {
			var _this11 = this;

			this.serviceMoveModalButtonDisabled = true;

			this.serviceMoveModalButtonCounter = 5;
			if (this.serviceMoveModalButtonHandler) clearInterval(this.serviceMoveModalButtonHandler);
			this.serviceMoveModalButtonTitle = 'service/move';

			if ('listValue' in field && field['listValue'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(field['listValue']) === 'object' && field['listValue']['id']) {
				var _accountID = field['listValue']['id'];

				var _unselected = 0;

				this.serviceMoveRows.forEach(function (item, idx, arr) {
					if (String(item['account_id']) === String(_accountID)) {
						_unselected++;
						arr[idx]['move_active'] = false;
					} else {
						arr[idx]['move_active'] = true;
					}
				});

				if (_unselected === this.serviceMoveRows.length) this.serviceMoveModalButtonDisabled = true;else {
						this.serviceMoveModalButtonTitle = this.serviceMoveModalButtonCounter + ' - service/move';

						this.serviceMoveModalButtonHandler = setInterval(function () {
							_this11.serviceMoveModalButtonCounter--;

							if (_this11.serviceMoveModalButtonCounter <= 0) {
								clearInterval(_this11.serviceMoveModalButtonHandler);

								_this11.serviceMoveModalButtonTitle = 'service/move';

								_this11.serviceMoveModalButtonDisabled = false;

								return;
							}

							_this11.serviceMoveModalButtonTitle = _this11.serviceMoveModalButtonCounter + ' - service/move';
						}, 1000);
					}
			}
		},
		ticketMoveModalValueChanged: function ticketMoveModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(field['listValue']) === 'object' && field['listValue']['id']) {
				var _ID = field['listValue']['id'];
				var _TYPE = field['listValue']['type'];

				var _unselected = 0;

				this.ticketRows.forEach(function (item, idx, arr) {
					arr[idx]['ticket_move_active'] = false;

					if (String(item['department_id']) !== String(_ID)) {
						if (_TYPE === item['department_type']) arr[idx]['ticket_move_active'] = true;else {
							if ((item['department_type'] === 'normal' || item['department_type'] === 'silent') && (_TYPE === 'normal' || _TYPE === 'silent')) arr[idx]['ticket_move_active'] = true;
						}
					}

					if (!arr[idx]['ticket_move_active']) _unselected++;
				});

				if (_unselected === this.ticketRows.length) this.ticketMoveModalButtonDisabled = true;else this.ticketMoveModalButtonDisabled = false;
			}
		},
		blockModalTextFieldFocus: function blockModalTextFieldFocus() {
			this.blockModalTextField['_errMsg'] = '';
		},
		migrateInModalDialog: function migrateInModalDialog(e) {
			var _this12 = this;

			if (this.migrateModalButtonDisabled) {
				if (e) e.preventDefault();
				return;
			}

			var _services = {};
			this.migrateRows.forEach(function (item) {
				if (item['migrate_active'] === true) _services[item['service_id']] = 1;
			});

			if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_services).length) {
				if (e) e.preventDefault();
				return;
			}

			this.hideMigrateModal();

			var _paramsGet = {
				additional: 'setMigrate',
				server_id: this.migrateModalSelectServerValue
			};

			this.$http.get(this.APIServerUrl + '/service/migrate', { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = {
						'_csrf': _dt['_csrf'],
						services: _services
					};

					_this12.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this12.buttons['migrate']['active'] = false;

							if (_this12.crud !== 'iso' && _this12.crud !== 'additional-services' && _this12.crud !== 'backups') _this12.requestListData(true);

							return;
						}

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					}, function (resPost) {
						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					});

					return;
				}

				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			}, function (resGet) {
				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			});
		},
		serviceBulkDelInModalDialog: function serviceBulkDelInModalDialog(e) {
			var _this13 = this;

			if (this.serviceBulkDelModalButtonDisabled) {
				if (e) e.preventDefault();
				return;
			}

			var _services = {};
			this.serviceBulkDelRows.forEach(function (item) {
				_services[item['service_id']] = 1;
			});

			if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_services).length) {
				if (e) e.preventDefault();
				return;
			}

			this.hideServiceBulkDelModal();

			var _paramsGet = {
				additional: 'setDelete'
			};

			this.$http.get(this.APIServerUrl + '/service/delete', { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = {
						'_csrf': _dt['_csrf'],
						services: _services
					};

					_this13.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && 'result' in _dt && _dt['result']) {
							_this13.buttons['bulkDel']['active'] = false;

							_this13.requestListData(true);

							return;
						}

						_this13.localErrorMessage = _this13.formatRequestError(resPost);
					}, function (resPost) {
						_this13.localErrorMessage = _this13.formatRequestError(resPost);
					});

					return;
				}

				_this13.localErrorMessage = _this13.formatRequestError(resGet);
			}, function (resGet) {
				_this13.localErrorMessage = _this13.formatRequestError(resGet);
			});
		},
		serviceMoveInModalDialog: function serviceMoveInModalDialog(e) {
			var _this14 = this;

			if (this.serviceMoveModalButtonDisabled) {
				if (e) e.preventDefault();
				return;
			}

			var _services = {};
			this.serviceMoveRows.forEach(function (item) {
				if (item['move_active'] === true) _services[item['service_id']] = 1;
			});

			if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_services).length) {
				if (e) e.preventDefault();
				return;
			}

			this.hideServiceMoveModal();

			var _paramsGet = {
				additional: 'setMove',
				account_id: this.serviceMoveModalSelectAccountValue
			};

			this.$http.get(this.APIServerUrl + '/service/move', { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = {
						'_csrf': _dt['_csrf'],
						services: _services
					};

					_this14.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && 'result' in _dt && _dt['result']) {
							_this14.buttons['serviceMove']['active'] = false;

							_this14.requestListData(true);

							return;
						}

						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					}, function (resPost) {
						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					});

					return;
				}

				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			}, function (resGet) {
				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			});
		},
		ticketMoveInModalDialog: function ticketMoveInModalDialog(e) {
			var _this15 = this;

			if (this.ticketMoveModalButtonDisabled) {
				if (e) e.preventDefault();
				return;
			}

			var _tickets = {};
			this.ticketRows.forEach(function (item) {
				if (item['ticket_move_active'] === true) _tickets[item['ticket_id']] = 1;
			});

			if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_tickets).length) {
				if (e) e.preventDefault();
				return;
			}

			this.hideTicketMoveModal();

			var _paramsGet = {
				additional: 'setMove',
				department_id: this.ticketMoveModalSelectDepartmentValue
			};

			var _depType = null;
			if (this.ticketMoveModalDepartmentField['list'] && this.ticketMoveModalDepartmentField['list'].length) this.ticketMoveModalDepartmentField['list'].some(function (dep) {
				if (String(dep.id) === String(_this15.ticketMoveModalSelectDepartmentValue)) {
					_depType = dep.type;
					return true;
				}
			});

			this.$http.get(this.APIServerUrl + '/ticket/update', { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = {
						'_csrf': _dt['_csrf'],
						tickets: _tickets
					};

					_this15.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this15.buttons['replaceTicket']['active'] = false;

							if (_depType === 'silent') _this15.$store.dispatch('getTicketCounters');

							_this15.requestListData(true);

							return;
						}

						_this15.localErrorMessage = _this15.formatRequestError(resPost);
					}, function (resPost) {
						_this15.localErrorMessage = _this15.formatRequestError(resPost);
					});

					return;
				}

				_this15.localErrorMessage = _this15.formatRequestError(resGet);
			}, function (resGet) {
				_this15.localErrorMessage = _this15.formatRequestError(resGet);
			});
		},
		ticketBlockInModalDialog: function ticketBlockInModalDialog(e) {
			var _this16 = this;

			if (this.ticketBlockModalTimer > 0) {
				if (e) e.preventDefault();
				return;
			}

			var _tickets = {};
			this.ticketBlockRows.forEach(function (item) {
				_tickets[item['ticket_id']] = 1;
			});

			if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_tickets).length) {
				if (e) e.preventDefault();
				return;
			}

			this.hideTicketBlockModal();

			this.$http.get(this.APIServerUrl + '/ticket/update?additional=setBlacklist').then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'], tickets: _tickets };

					_this16.$http.post(res.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this16.buttons['blockTicket']['active'] = false;

							_this16.requestListData(true);

							return;
						}

						_this16.localErrorMessage = _this16.formatRequestError(resPost);
					}, function (resPost) {
						_this16.localErrorMessage = _this16.formatRequestError(resPost);
					});

					return;
				}

				_this16.localErrorMessage = _this16.formatRequestError(res);
			}, function (res) {
				_this16.localErrorMessage = _this16.formatRequestError(res);
			});
		},
		blockRowsInModalDialog: function blockRowsInModalDialog(e) {
			var _this17 = this;

			if (this.blockModalNoteRequired) {
				if (!this.blockModalTextNoteValue || String(this.blockModalTextNoteValue).trim() === '') {
					this.blockModalTextField['_errMsg'] = 'notes/required_note';
					return;
				}
			}

			this.hideBlockModal();

			if (!this.blockRows || !Array.isArray(this.blockRows) || !this.blockRows.length) {
				this.localErrorMessage = 'main/choose_records';
				return;
			}

			var _url = this.APIServerUrl + '/' + this.getRealCrud(this.crud) + '/update';

			var _paramsGet = {
				'additional': this.blockModalWhat === 'on' ? 'setUnBlock' : 'setBlock'

			};

			var _field = this.listConfig['on-off'];
			var _ids = {};
			this.blockRows.forEach(function (item) {
				if (item[_this17.listConfig['column_id']]) _ids[item[_this17.listConfig['column_id']]] = 1;
			});

			this.$http.get(_url, { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
						'_csrf': _dt['_csrf']
					}, _field, _ids);

					_this17.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this17.buttons[_this17.blockModalWhat]['active'] = false;

							if (!_this17.blockModalNoteRequired) {
								if (_this17.crud !== 'iso' && _this17.crud !== 'additional-services' && _this17.crud !== 'backups') _this17.requestListData(true);
							} else {
									_this17.createNotesAfterBlock(function () {
										if (_this17.crud !== 'iso' && _this17.crud !== 'additional-services' && _this17.crud !== 'backups') _this17.requestListData(true);
									});
								}

							return;
						}

						_this17.localErrorMessage = 'error/api_incorrect';
					}, function (resPost) {
						_this17.localErrorMessage = 'error/api_incorrect';
					});

					return;
				}

				_this17.localErrorMessage = 'error/api_incorrect';
			}, function (resGet) {
				_this17.localErrorMessage = 'error/api_incorrect';
			});
		},
		createNotesAfterBlock: function createNotesAfterBlock(successCallback, failCallback) {
			var _this18 = this;

			var _data = {
				'additional': 'setCreateMultiNote',
				'type': this.getRealCrud(this.crud),
				'text': this.blockModalTextNoteValue,
				'action': this.blockModalWhat === 'on' ? 'unblock' : 'block',
				'objects': {}
			};

			this.blockRows.forEach(function (item) {
				if (item[_this18.listConfig['column_id']]) _data['objects'][item[_this18.listConfig['column_id']]] = 1;
			});

			this.$http.get(this.APIServerUrl + '/notes/create').then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_data['_csrf'] = _dt['_csrf'];

					_this18.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_data)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							if (successCallback && typeof successCallback === 'function') successCallback();

							return;
						}

						if (failCallback && typeof failCallback === 'function') failCallback();
					}, function (resPost) {
						if (failCallback && typeof failCallback === 'function') failCallback();
					});

					return;
				}

				if (failCallback && typeof failCallback === 'function') failCallback();
			}, function (resGet) {
				if (failCallback && typeof failCallback === 'function') failCallback();
			});
		},
		registerRowsInModalDialog: function registerRowsInModalDialog(e) {
			var _this19 = this;

			this.hideRegisterModal();

			if (!this.registerRows || !Array.isArray(this.registerRows) || !this.registerRows.length) {
				this.localErrorMessage = 'main/choose_records';
				return;
			}

			var _url = void 0;
			var _paramsGet = void 0;

			if (this.registerModalWhat === 'r_on' || this.registerModalWhat === 'r_off') {
				_url = this.APIServerUrl + '/server/update';

				_paramsGet = {
					'additional': this.registerModalWhat === 'r_on' ? 'setActive' : 'setReserve'
				};
			} else if (this.registerModalWhat === 'ip_on' || this.registerModalWhat === 'ip_off') {
				_url = this.APIServerUrl + '/ippool/update';

				_paramsGet = {
					'additional': this.registerModalWhat === 'ip_on' ? 'setUnBlock' : 'setBlock'
				};
				if (_paramsGet.additional === 'setBlock') {
					if (this.ippoolBlockValue !== 'block') _paramsGet.type = this.ippoolBlockValue;
				}
			}

			var _field = this.listConfig['on-off'];
			var _ids = {};
			this.registerRows.forEach(function (item) {
				if (item[_this19.listConfig['column_id']]) _ids[item[_this19.listConfig['column_id']]] = 1;
			});

			this.$http.get(_url, { 'params': _paramsGet }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _paramsPost = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
						'_csrf': _dt['_csrf']
					}, _field, _ids);

					_this19.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_paramsPost)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this19.buttons[_this19.registerModalWhat]['active'] = false;

							_this19.requestListData(true);

							return;
						}

						_this19.localErrorMessage = 'error/api_incorrect';
					}, function (resPost) {
						_this19.localErrorMessage = 'error/api_incorrect';
					});

					return;
				}

				_this19.localErrorMessage = 'error/api_incorrect';
			}, function (resGet) {
				_this19.localErrorMessage = 'error/api_incorrect';
			});
		},
		selectRowInTable: function selectRowInTable(e, rowID) {
			if (this.crud && rowID) this.$store.commit('setLastRow', { 'crud': this.crud, 'id': rowID });

			var _pathRoute = this.crud + this.page;
			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': this.curWindowY
			});

			if (this.listConfig['can_select_rows'] === false) return;

			if (this.lastWorkedRowID === rowID) this.lastWorkedRowID = false;

			var _status = false;

			for (var _b in this.buttons) {
				this.buttons[_b]['active'] = false;
			}
			this.exportCsvButtonInit();

			var _columnID = this.listConfig['column_id'];

			var _foundIndex = -1;
			if (this.renderRows && this.renderRows.length) {
				this.renderRows.some(function (item, index, arr) {
					if (item[_columnID] && item[_columnID] === rowID) {
						_foundIndex = index;

						if (item['w5-row-selected'] === true) item['w5-row-selected'] = false;else item['w5-row-selected'] = true;

						return true;
					}
				});
			}

			if (_foundIndex >= 0) {
				var k = 0;
				var _startIndex = -1;
				var _len = this.renderRows.length;
				var _start = false;
				var _end = false;

				if (e.shiftKey) {
					for (k = _foundIndex - 1; k >= 0; k--) {
						if (this.renderRows[k]['w5-row-selected'] === true) {
							_startIndex = k;
							break;
						}
					}

					if (_startIndex < 0) {
						for (k = _foundIndex + 1; k < _len; k++) {
							if (this.renderRows[k]['w5-row-selected'] === true) {
								_startIndex = k;
								break;
							}
						}
					}

					if (_startIndex >= 0) {
						_start = _startIndex <= _foundIndex ? _startIndex : _foundIndex;
						_end = _startIndex <= _foundIndex ? _foundIndex : _startIndex;
					}
				}

				this.totalSelectedRowsCount = 0;

				var _statusField = false;
				if (_len > 0) {
					for (var _s in this.renderRows[0]) {
						if (/_status$/ig.test(_s)) {
							_statusField = _s;
							break;
						}
					}
				}

				for (k = 0; k < _len; k++) {
					if (_start !== false && _end !== false) {
						if (k >= _start && k <= _end && k !== _foundIndex) this.renderRows[k]['w5-row-selected'] = true;
					}

					if (this.renderRows[k]['w5-row-selected'] === true) {
						this.totalSelectedRowsCount++;

						if (_status !== -1 && _statusField && _statusField in this.renderRows[k]) {
							if (!_status) _status = this.renderRows[k][_statusField];else if (_status !== this.renderRows[k][_statusField]) {
									_status = -1;
								}

							if (this.renderRows[k]['service_status_text'] !== undefined && this.renderRows[k]['service_status_text'] !== null && String(this.renderRows[k]['service_status_text']).length) _status = -1;
						}
					}
				}

				if (_status !== false && _status !== -1) {
					if (_status === 'block') {
						var _result = true;

						if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
						this.renderRows.some(function (item, index, arr) {
							if (item['w5-row-selected'] === true && item['can_unblock'] === false) {
								_result = false;
								return true;
							}
						});

						this.$set(this.buttons['on'], 'active', _result);
					}
					if (_status === 'notpaid') {
						var _buttonOnTurn = true;
						var _buttonOffTurn = true;

						if (!this.renderRows || !this.renderRows.length) this.renderRows = [];

						for (var _idx = 0; _idx < this.renderRows.length; _idx++) {
							var item = this.renderRows[_idx];

							if (item['w5-row-selected'] === true && item['can_unblock'] === false) {
								_buttonOnTurn = false;
							}

							if (item['w5-row-selected'] === true && item['can_block'] === false) {
								_buttonOffTurn = false;
							}
						}

						if (_buttonOnTurn) {
							this.$set(this.buttons['on'], 'active', true);
						}

						if (_buttonOffTurn) {
							this.$set(this.buttons['off'], 'active', true);
						}
					}
					if (_status === 'active') {
						var _result2 = true;

						if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
						this.renderRows.some(function (item, index, arr) {
							if (item['w5-row-selected'] === true && item['can_block'] === false) {
								_result2 = false;
								return true;
							}
						});

						this.$set(this.buttons['off'], 'active', _result2);
					}
				} else {}

				this.$forceUpdate();
			}

			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'])) return true;
				});

				if (!_found) this.$set(this.buttons['migrate'], 'active', true);
			}

			this.$set(this.buttons['bulkDel'], 'active', false);

			if ((this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'additional-services' || this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups' || this.crud === 'disks') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found2 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'] || item['can_delete'] === false)) return true;
				});

				if (!_found2) this.$set(this.buttons['bulkDel'], 'active', true);
			}

			this.$set(this.buttons['serviceMove'], 'active', false);

			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups' || this.crud === 'disks') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found3 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'])) return true;
				});

				if (!_found3) this.$set(this.buttons['serviceMove'], 'active', true);
			}

			if (this.crud === 'ticket' && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found4 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['ticket_status'] === 'closed' || item['ticket_status'] === 'deleted')) return true;
				});

				if (!_found4) this.$set(this.buttons['closeTicket'], 'active', true);

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				_found4 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && item['ticket_status'] === 'deleted') return true;
				});

				if (!_found4) this.$set(this.buttons['replaceTicket'], 'active', true);

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				_found4 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (!('can_blacklist' in item) || item['can_blacklist'] !== true)) return true;
				});

				if (!_found4) this.$set(this.buttons['blockTicket'], 'active', true);
			}

			if (this.crud === 'server' && this.totalSelectedRowsCount > 0) {
				var regStatus = {};

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				this.renderRows.forEach(function (item) {
					if (item['w5-row-selected'] === true) {
						var curStatus = String(item['server_status']);
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1;else regStatus[curStatus]++;
					}
				});

				var curStatuses = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(regStatus);
				if (curStatuses.length === 1) {
					if (curStatuses[0] === 'active') this.$set(this.buttons['r_off'], 'active', true);else if (curStatuses[0] === 'reserve') this.$set(this.buttons['r_on'], 'active', true);
				}
			}

			if (this.crud === 'ippool' && this.totalSelectedRowsCount > 0) {
				var _regStatus = {};

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				this.renderRows.forEach(function (item) {
					if (item['w5-row-selected'] === true) {
						var curStatus = String(item['ip_status']);
						if (_regStatus[curStatus] === undefined) _regStatus[curStatus] = 1;else _regStatus[curStatus]++;
					}
				});

				var _curStatuses = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_regStatus);

				if (_curStatuses.length) {
					this.$set(this.buttons['ip_off'], 'active', true);

					var _isActive = _curStatuses.some(function (i) {
						return i === 'active';
					});
					if (!_isActive) this.$set(this.buttons['ip_on'], 'active', true);
				}
			}
		},
		buttonsForSelectedRow: function buttonsForSelectedRow() {
			for (var _b in this.buttons) {
				this.buttons[_b]['active'] = false;
			}
			this.exportCsvButtonInit();

			this.totalSelectedRowsCount = 0;

			var _statusField = false;
			var _len = this.renderRows.length;
			var _status = false;

			if (_len > 0) {
				for (var _s in this.renderRows[0]) {
					if (/_status$/ig.test(_s)) {
						_statusField = _s;
						break;
					}
				}
			}

			for (var k = 0; k < _len; k++) {
				if (this.renderRows[k]['w5-row-selected'] === true) {
					this.totalSelectedRowsCount++;

					if (_status !== -1 && _statusField && _statusField in this.renderRows[k]) {
						if (!_status) _status = this.renderRows[k][_statusField];else if (_status !== this.renderRows[k][_statusField]) {
								_status = -1;
							}

						if (this.renderRows[k]['service_status_text'] !== undefined && this.renderRows[k]['service_status_text'] !== null && String(this.renderRows[k]['service_status_text']).length) _status = -1;
					}
				}
			}

			if (_status !== false && _status !== -1) {
				if (_status === 'block') {
					var _result = true;

					if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
					this.renderRows.some(function (item, index, arr) {
						if (item['w5-row-selected'] === true && item['can_unblock'] === false) {
							_result = false;
							return true;
						}
					});

					this.$set(this.buttons['on'], 'active', _result);
				}
				if (_status === 'notpaid' && (this.crud === 'vds' || this.crud === 'hi-cpu-vds')) {
					this.$set(this.buttons['on'], 'active', true);

					var _result3 = true;

					if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
					this.renderRows.some(function (item, index, arr) {
						if (item['w5-row-selected'] === true && item['can_block'] === false) {
							_result3 = false;
							return true;
						}
					});

					this.$set(this.buttons['off'], 'active', _result3);
				}
				if (_status === 'active') {
					var _result4 = true;

					if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
					this.renderRows.some(function (item, index, arr) {
						if (item['w5-row-selected'] === true && item['can_block'] === false) {
							_result4 = false;
							return true;
						}
					});

					this.$set(this.buttons['off'], 'active', _result4);
				}
			} else {}

			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'])) return true;
				});

				if (!_found) this.$set(this.buttons['migrate'], 'active', true);
			}

			this.$set(this.buttons['serviceMove'], 'active', false);

			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found5 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'])) return true;
				});

				if (!_found5) this.$set(this.buttons['serviceMove'], 'active', true);
			}

			if (this.crud === 'ticket' && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found6 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['ticket_status'] === 'closed' || item['ticket_status'] === 'deleted')) return true;
				});

				if (!_found6) this.$set(this.buttons['closeTicket'], 'active', true);

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				_found6 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && item['ticket_status'] === 'deleted') return true;
				});

				if (!_found6) this.$set(this.buttons['replaceTicket'], 'active', true);

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				_found6 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (!('can_blacklist' in item) || item['can_blacklist'] !== true)) return true;
				});

				if (!_found6) this.$set(this.buttons['blockTicket'], 'active', true);
			}

			if (this.crud === 'server' && this.totalSelectedRowsCount > 0) {
				var regStatus = {};

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				this.renderRows.forEach(function (item) {
					if (item['w5-row-selected'] === true) {
						var curStatus = String(item['server_status']);
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1;else regStatus[curStatus]++;
					}
				});

				var curStatuses = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(regStatus);
				if (curStatuses.length === 1) {
					if (curStatuses[0] === 'active') this.$set(this.buttons['r_off'], 'active', true);else if (curStatuses[0] === 'reserve') this.$set(this.buttons['r_on'], 'active', true);
				}
			}

			if (this.crud === 'ippool' && this.totalSelectedRowsCount > 0) {
				var _regStatus2 = {};

				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				this.renderRows.forEach(function (item) {
					if (item['w5-row-selected'] === true) {
						var curStatus = String(item['ip_status']);
						if (_regStatus2[curStatus] === undefined) _regStatus2[curStatus] = 1;else _regStatus2[curStatus]++;
					}
				});

				var _curStatuses2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_regStatus2);

				if (_curStatuses2.length) {
					this.$set(this.buttons['ip_off'], 'active', true);

					var _isActive = _curStatuses2.some(function (i) {
						return i === 'active';
					});
					if (!_isActive) this.$set(this.buttons['ip_on'], 'active', true);
				}
			}

			this.$set(this.buttons['bulkDel'], 'active', false);

			if ((this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'additional-services' || this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups') && this.totalSelectedRowsCount > 0) {
				if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
				var _found7 = this.renderRows.some(function (item) {
					if (item['w5-row-selected'] === true && (item['service_status'] === 'deleted' || item['service_status_text'] || 'can_delete' in item && item['can_delete'] !== true)) return true;
				});

				if (!_found7) this.$set(this.buttons['bulkDel'], 'active', true);
			}

			this.exportCsvButtonInit();

			this.$forceUpdate();
		},
		ipBlackListClick: function ipBlackListClick() {
			var _this20 = this;

			this.localErrorMessage = '';
			this.localSuccessMessage = '';
			this.viewData = null;
			this.viewSortDATA = null;
			this.viewKeys = null;

			if (!this.ipBlackListValue || !/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.ipBlackListValue) || !__WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].validateIPv4(this.ipBlackListValue)) {
				this.localErrorMessage = 'server/ip_error';
				return;
			}

			var _url = this.APIServerUrl + '/logs/get/' + this.ipBlackListValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this20.viewData = _dt;

					delete _this20.viewData.status;

					_this20.viewData.__ip = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this20.viewData.ip);
					delete _this20.viewData.ip;

					_this20.viewSortDATA = _this20.makeViewByOrder();

					_this20.viewKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this20.viewSortDATA).sort(function (a, b) {
						return a - b;
					});

					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this20.showViewModal = true;

					return;
				}

				_this20.localErrorMessage = _this20.formatRequestError(resGet);
			}, function (resGet) {
				_this20.localErrorMessage = _this20.formatRequestError(resGet);
			});
		},
		viewButtonProcedure: function viewButtonProcedure() {
			var _this21 = this;

			this.hideViewModal();

			if (!this.ipBlackListValue || !/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.ipBlackListValue) || !__WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].validateIPv4(this.ipBlackListValue) || !this.viewData || !this.viewData.__ip || this.viewData.__ip.can_flush !== true) {
				this.localErrorMessage = 'server/ip_error';
				return;
			}

			var _url = this.APIServerUrl + '/logs/flush/' + this.ipBlackListValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this21.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this21.setLocalSuccessMessage('forget/success');

							return;
						}

						_this21.localErrorMessage = _this21.formatRequestError(resPost);
					}, function (resPost) {
						_this21.localErrorMessage = _this21.formatRequestError(resPost);
					});

					return;
				}

				_this21.localErrorMessage = _this21.formatRequestError(resGet);
			}, function (resGet) {
				_this21.localErrorMessage = _this21.formatRequestError(resGet);
			});
		},
		hideViewModal: function hideViewModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showViewModal = false;
			this.hideModalMask();
		},
		makeViewByOrder: function makeViewByOrder() {
			if (!this.viewData) return null;

			var obj = void 0;
			var __obj = void 0;
			var ____obj = void 0;
			var tmp = void 0;
			var order = void 0;
			var isLink = 0;
			var nm = '';
			var sortDATA = {};

			for (var idx in this.viewData) {
				if (this.viewData.hasOwnProperty(idx)) {
					obj = this.viewData[idx];

					if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
						if ('order' in obj && obj['type'] !== 'hidden') {
							tmp = parseInt(obj['order']);
							order = isNaN(tmp) ? 0 : tmp;

							if (!sortDATA[order]) {
								sortDATA[order] = [];
								sortDATA[order].push(idx);
							} else sortDATA[order].push(idx);
						} else {
								isLink = 0;
								nm = '';

								for (var i in obj) {
									if (obj.hasOwnProperty(i)) if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i)) {
										nm = i.match(/(.*?)_name$/);
										if (nm === null) {
											nm = i.match(/(.*?)_id$/);
											if (nm === null) {
												nm = i.match(/(.*?)_login$/);
												if (nm == null) {
													if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле');
												} else nm = nm[1];
											} else nm = nm[1];
										} else nm = nm[1];

										isLink++;
									}
								}
								if (isLink === 2 && idx !== this.__realCrudName(this.crud)) isLink = true;else isLink = false;

								if (isLink) {
									tmp = parseInt(obj[nm + '_id']['order']);
									order = isNaN(tmp) ? 0 : tmp;

									if (!sortDATA[order]) {
										sortDATA[order] = [];
										sortDATA[order].push(idx);
									} else sortDATA[order].push(idx);
								} else {
										for (var _i in obj) {
											if (obj.hasOwnProperty(_i)) {
												__obj = obj[_i];

												if (__obj && (typeof __obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(__obj)) === 'object' && 'order' in __obj && 'title' in __obj && 'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined && 'type' in __obj && __obj['type'] !== 'hidden') {
													tmp = parseInt(__obj['order']);
													order = isNaN(tmp) ? 0 : tmp;

													if (!sortDATA[order]) {
														sortDATA[order] = [];
														sortDATA[order].push(_i);
													} else sortDATA[order].push(_i);
												} else {
													if (idx === 'role' && _i === 'permissions') sortDATA[9999] = [_i];else if (idx === 'service' && _i === 'service_data' && this.$store.state.user_type === 'admin') {
															tmp = parseInt(__obj['order']);
															order = isNaN(tmp) ? 0 : tmp;

															if (!sortDATA[order]) {
																sortDATA[order] = [];
																sortDATA[order].push(_i);
															} else sortDATA[order].push(_i);
														} else {
																for (var w in __obj) {
																	if (__obj.hasOwnProperty(w)) {
																		____obj = __obj[w];

																		if (____obj && (typeof ____obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(____obj)) === 'object' && 'order' in ____obj && 'title' in ____obj && 'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined && 'type' in ____obj && ____obj['type'] !== 'hidden') {
																			tmp = parseInt(____obj['order']);
																			order = isNaN(tmp) ? 0 : tmp;

																			if (!sortDATA[order]) {
																				sortDATA[order] = [];
																				sortDATA[order].push(w);
																			} else sortDATA[order].push(w);
																		}
																	}
																}
															}
												}
											}
										}
									}
							}
					}
				}
			}
			return sortDATA;
		},
		fastSearchClear: function fastSearchClear() {
			this.fastSearchValue = '';
			this.setLocalStorage();
			this.requestListData();
		},
		fastSearchEvent: function fastSearchEvent() {
			var _this22 = this;

			if (this.fastSearchValue === null || this.fastSearchValue === undefined) return;

			if (this.fastSearchTimer) clearTimeout(this.fastSearchTimer);

			this.fastSearchTimer = setTimeout(function () {
				_this22.fastSearchTimer = null;
				_this22.fastSearchEventStart();
			}, 500);
		},
		fastSearchEventStart: function fastSearchEventStart() {
			var text = String(this.fastSearchValue);

			if (text === '') return this.fastSearchClear();

			var _canRequest = false;

			if (this.$store.state.accountGlobalFilter === true) {
				_canRequest = true;
			} else {
				if (this.$store.state.user_type !== 'admin') {
					if (text.length >= 2) _canRequest = true;
				} else {
					if (text.length >= 3) _canRequest = true;
				}
			}

			if (_canRequest) {
				this.setLocalStorage();
				this.requestListData();
			}
		},
		filterPeriodEvent: function filterPeriodEvent(value) {
			this.filters.period.valueBegin = value['begin'] ? this.formater_Date2StrDate(value['begin']) + ' 00:00:00' : false;
			this.filters.period.valueEnd = value['end'] ? this.formater_Date2StrDate(value['end']) + ' 23:59:59' : false;
			this.setLocalStorage();
			this.requestListData();
		},
		filterBoolEvent: function filterBoolEvent(value) {
			this.filters.bool.value = value;
			this.setLocalStorage();
			this.requestListData();
		},
		filterLogsEvent: function filterLogsEvent(value) {
			this.filters.logs.value = value;
			this.setLocalStorage();
			this.requestListData();
		},
		filterTicketLabelEvent: function filterTicketLabelEvent(value) {
			this.filters.ticketLabel.value = value;
			this.setLocalStorage();
			this.requestListData();
		},
		filterDiskTypeEvent: function filterDiskTypeEvent(value) {
			this.filters.diskType.value = value === '-1' ? null : value;
			this.setLocalStorage();
			this.requestListData();
		},
		filterParamsEvent: function filterParamsEvent(value) {
			this.filters.planParams.value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, value);
			this.setLocalStorage();
			this.requestListData();
		},
		onGroupVdsChanged: function onGroupVdsChanged(value) {
			this.requestListData();
		},
		operationTripleFilter: function operationTripleFilter() {
			if (this.crud !== 'operation') return;
			if (this.$store.state.user_type !== 'admin') return;

			var _find = false;
			this.filters.radio.forEach(function (item, idx, arr) {
				if (item.field === 'operation_purse') {
					_find = true;
					arr[idx]['value'] = 'partner';
					arr[idx]['visible'] = true;
				} else if (item.field === 'operation_type') {
					_find = true;
					arr[idx]['value'] = '-1';
					arr[idx]['visible'] = true;
				} else if (item.field === 'operation_status') {
					_find = true;
					arr[idx]['value'] = '0';
					arr[idx]['visible'] = true;
				}
			});

			if (_find) {
				this.setLocalStorage();
				this.requestListData();
			}
		},
		setPageSize: function setPageSize(size) {
			var _this23 = this;

			if (size === this.listData.pageSize) return;

			if (this.Config.pageSizes.indexOf(size) === -1) return;

			var _params = {
				'additional': 'setPageSize',
				'size': size,
				'dontAbort': true
			};
			this.forms_Get('/user/index', _params, function (data) {
				if (!data || data['status'] !== 'ok') _this23.localErrorMessage = _this23.localeFtc('register/error');
				_this23.requestListData();
			}, function () {
				return _this23.requestListData();
			});
		},
		sortTable: function sortTable(field, column) {
			if (field === 'account_name') field = 'account_id';
			if (field === 'parent_name_full') field = 'parent_id';
			if (field === 'owner_account_name') field = 'owner_account_id';
			if (field === 'service_name_full' && this.crud === 'dns') field = 'service_name';

			if (column['sort'] !== true) return;

			if (this.sortedColumn === false) this.sortedColumn = '-' + field;else if (this.sortedColumn === '+' + field || this.sortedColumn === field) this.sortedColumn = '-' + field;else if (this.sortedColumn === '-' + field) this.sortedColumn = '+' + field;else this.sortedColumn = '-' + field;

			this.setLocalStorage();
			this.requestListData();
		},
		partnerActivate: function partnerActivate(row) {
			var _this24 = this;

			this.localErrorMessage = '';
			this.localSuccessMessage = '';

			if (!row['account_id'] || !row['program_id']) {
				this.localErrorMessage = 'error/required_field';
				return;
			}

			var _url = this.APIServerUrl + '/partner/create';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'account_id': row['account_id'],
						'program_id': row['program_id']
					};

					_this24.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['partner'] && _dt['partner']['p2a_id']) {
							__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-push', 'update partner ' + _dt['partner']['p2a_id']);

							_this24.setLocalSuccessMessage('bonus/converted');

							return;
						}

						_this24.localErrorMessage = _this24.formatRequestError(resPost);
					}, function (resPost) {
						_this24.localErrorMessage = _this24.formatRequestError(resPost);
					});

					return;
				}

				_this24.localErrorMessage = _this24.formatRequestError(resGet);
			}, function (resGet) {
				_this24.localErrorMessage = _this24.formatRequestError(resGet);
			});
		},
		actionOperButton: function actionOperButton(data) {
			var _this25 = this;

			if (this.$store.state.isListTableLoading) return;

			var _error = [];

			if (!data['row']) _error.push('"row" not found');

			var _actionName = data['action'];
			if (!_actionName) _error.push('"name of action" not found');

			var _action = data && data['data'] && data['data']['action'] && data['data']['action'].indexOf(':') >= 0 ? data['data']['action'] : false;
			if (!_action) _error.push('"action" not found');

			var _actionParts = _action.split(':');
			if (_actionParts.length < 2) _error.push('"action" is not correct');

			if (_error.length) {
				if (this.$store.state.isDebug) window.DEBUG.error(_error.join(', '));
				return;
			}

			var _ID = data['row'][this.listConfig['column_id']];
			if (this.crud && _ID) this.$store.commit('setLastRow', { 'crud': this.crud, 'id': _ID });

			var _pathRoute = this.crud + this.page;
			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': this.curWindowY
			});

			if (_actionParts[0].toLowerCase() === 'url' && _actionParts[1]) {
				if (_actionParts[1].charAt(0) !== '/') _actionParts[1] = '/' + _actionParts[1];

				if (_ID && _actionParts[1] !== '/options' && _actionParts[1] !== '/ipptrpool/list' && _actionParts[1] !== '/iphistory/list') _actionParts[1] += '/' + _ID;

				if (_actionParts[1] === '/ipptrpool/list') _actionParts[1] += '?id=' + _ID;

				if (_actionParts[1] === '/iphistory/list') _actionParts[1] += '?id=' + _ID;

				this.$router.push(_actionParts[1]);

				return;
			} else if (_actionParts[0].toLowerCase() === 'filter' && _actionParts[1]) {
					var _url = _actionParts[1];

					if (_actionParts[1].charAt(0) !== '/') _url = '/' + _url + '/list';

					var _fld = this.listConfig['column_id'];
					if (this.crud === 'servergroup') _fld = 'server_group_id';
					if (this.crud === 'plangroup') _fld = 'plan_group_id';
					if (this.crud === 'templategroup') _fld = 'template_group_id';
					var _obj = {
						'field': _fld,
						'value': _ID
					};
					this.$store.commit('setModelFilter', _obj);

					this.$router.push(_url);

					return;
				} else if (_actionName === 'delete') {
						var _id = data['row'][this.listConfig['column_id']];

						if (this.deleteRecordIdInProcess && Array.isArray(this.deleteRecordIdInProcess) && this.deleteRecordIdInProcess.indexOf(_id) > -1) return;

						this.deleteModalTitle = 'main/deleting';
						if (data['data']['dialog'] && data['data']['dialog']['header']) this.deleteModalTitle = data['data']['dialog']['header'];

						this.deleteModalText = 'main/delete_msg';
						if (data['data']['dialog'] && data['data']['dialog']['body']) this.deleteModalText = data['data']['dialog']['body'];

						this.deleteModalText = this.localeFtc(this.deleteModalText);

						if (data['data']['dialog'] && data['data']['dialog']['name']) this.deleteModalText = this.deleteModalText.replace('{name}', data['row'][data['data']['dialog']['name']]);else if (data['data']['dialog'] && data['data']['dialog']['note']) this.deleteModalText = this.deleteModalText.replace('{note}', data['row'][data['data']['dialog']['note']]);

						if (this.crud === 'iso') {
							if (data['row'] && data['row']['service_data'] && data['row']['service_data']['iso'] && data['row']['service_data']['iso']['attached'] === true) this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning');
						} else if (this.crud === 'disks') {
							if (data['row'] && data['row']['service_data'] && data['row']['service_data']['extdisk'] && data['row']['service_data']['extdisk']['attached'] === true) this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning');
						}

						this.deleteModalTimer = false;
						if (data['data']['dialog'] && data['data']['dialog']['timer']) {
							this.deleteModalTimer = parseInt(data['data']['dialog']['timer']);
							if (isNaN(this.deleteModalTimer) || !this.deleteModalTimer) this.deleteModalTimer = 5;
						}

						if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1]) {
							if (_actionParts[1] in this) this.deleteModalCallback = this[_actionParts[1]](data['row']);
						}

						this.reserveIpLocalData = null;
						this.reserveIpProcessing = false;
						this.reserveIpCost = '';
						this.reserveIpVdsId = null;

						if (this.crud === 'vds' && data['row']['service_status'] === 'active' && !data['row']['service_status_text'] && this.isAccess('service/update')) {
							this.reserveIpLocalData = 1;
							this.reserveIpVdsId = _id;

							this.$http.get(this.APIServerUrl + '/service/update/' + _id).then(function (res) {
								var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
								if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['reserve_ip']) {
									_this25.reserveIpLocalData = _dt['fields']['reserve_ip'];

									_this25.reserveIpValue = 'value' in _this25.reserveIpLocalData ? _this25.reserveIpLocalData.value : false;

									if ('cost' in _this25.reserveIpLocalData && _this25.reserveIpLocalData['cost'] > 0) {
										_this25.reserveIpCost = _this25.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>').replace('{cost}', _this25.reserveIpLocalData['cost']).replace('{period}', _this25.localeFtc(_this25.reserveIpLocalData['period'])).replace('{for}', _this25.localeFtc(_this25.reserveIpLocalData['for']));
									}
								}
							}).catch(function () {
								_this25.reserveIpLocalData = null;
								_this25.reserveIpProcessing = false;
								_this25.reserveIpCost = '';
								_this25.reserveIpVdsId = null;
							});
						}

						__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
						this.showDeleteModal = true;

						if (this.deleteModalTimer && this.deleteModalTimer > 0) {
							this.deleteModalTimerHandle = setInterval(function () {
								_this25.deleteModalTimer--;
								if (_this25.deleteModalTimer <= 0) {
									clearInterval(_this25.deleteModalTimerHandle);
									_this25.deleteModalTimerHandle = false;
								}
							}, 1000);
						}

						return;
					} else if (_actionName === 'log' || _actionName === 'logOver' || _actionName === 'note' || _actionName === 'request' || _actionName === 'serviceRequest' || _actionName === 'operation' || _actionName === 'user' || _actionName === 'partnerAction' || _actionName === 'partner' || _actionName === 'filter' || _actionName === 'vdsReboot' || _actionName === 'vdsPlan' || _actionName === 'vdsReinstall' || _actionName === 'vdsChangePassword' || _actionName === 'prolong' || _actionName === 'account' || _actionName === 'paymentLink' || _actionName === 'domainReboot' || _actionName === 'restoreBackup' || _actionName === 'renameBackup' || _actionName === 'createFromBackup' || _actionName === 'createFromBackupOuterDisk' || _actionName === 'pdfLink' || _actionName === 'xmlLink' || _actionName === 'operLink' || _actionName === 'mailDocument' || _actionName === 'clientTicket' || _actionName === 'removeFilter' || _actionName === 'copyToDc' || _actionName === 'createDevice' || _actionName === 'deviceLinks' || _actionName === 'rackGraphic' || _actionName === 'downloadBackup' || _actionName === 'connectOuterDisk' || _actionName === 'ejectOuterDisk' || _actionName === 'cloneOuterDisk' || _actionName === 'backupOuterDisk' || _actionName === 'restoreBackupOuterDisk' || _actionName === 'scheduleOuterDisk' || _actionName === 'scheduleOuterDiskUpdate' || _actionName === 'connectISOOper' || _actionName === 'ejectISOOper' || _actionName === 'accountReport') {
							if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1]) {
								if (_actionName === 'accountReport' && data.data && data.data.w) {
									data['row']['w'] = data.data.w;
									this.accountReport(data['row']);
								} else if (_actionParts[1] in this) this[_actionParts[1]](data['row'], _actionParts[2], _actionParts[3], _actionParts[4]);
							}
						} else if (_actionName === 'createNote' || _actionName === 'ticketMerge' || _actionName === 'bonusActivate' || _actionName === 'vdsClone') {
								if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1]) {
									if (_actionParts[1] in this) this[_actionParts[1]](data['row']);
								}
							}
		},
		hideConfirmModalDialog: function hideConfirmModalDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModalDialog = false;
			this.hideModalMask();
		},
		openDocumentModalDialog: function openDocumentModalDialog(linkHtml, linkPdf, linkXml) {
			if (!linkHtml) return;

			var _frm = document ? document.getElementById('documentFrame') : null;
			if (!_frm) return;

			_frm.srcdoc = '<html><body></body></html>';

			this.windowResize();

			this.documentModalDialogLinkPdf = linkPdf;
			this.documentModalDialogLinkXml = linkXml;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDocumentModalDialog = true;

			this.$http.get(linkHtml).then(function (resGet) {
				var _dt = resGet && resGet.data ? resGet.data : false;
				if (!_dt || !_frm) throw new Error();
				_frm.srcdoc = _dt;
			}).catch(function () {
				_frm.srcdoc = '<html><body>Не удалось получить документ...</body></html>';
			});
		},
		hideDocumentModalDialog: function hideDocumentModalDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDocumentModalDialog = false;
			this.documentModalDialogLinkPdf = null;
			this.documentModalDialogLinkXml = null;
			this.hideModalMask();

			var _frm = document ? document.getElementById('documentFrame') : null;
			if (!_frm) return;
			_frm.srcdoc = '<html><body></body></html>';
		},
		documentPrint: function documentPrint() {
			if (window && window.print) {
				var frm = document.getElementById('documentFrame').contentWindow;
				frm.focus();
				frm.print();
			}
		},
		reserveIpStart: function reserveIpStart() {
			var _this26 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.reserveIpVdsId) return;

			if (!this.isAccess('service/update')) return;

			if (this.reserveIpProcessing) return;

			this.reserveIpProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.reserveIpVdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'reserve_ip': _this26.reserveIpValue ? 0 : 1
					};

					_this26.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this26.reserveIpProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this26.reserveIpValue = !_this26.reserveIpValue;

							_this26.setLocalSuccessMessage('main/updated');
							return;
						}

						_this26.localErrorMessage = _this26.formatRequestError(resPost);
					}, function (resPost) {
						_this26.reserveIpProcessing = false;

						_this26.localErrorMessage = _this26.formatRequestError(resPost);
					});

					return;
				}

				_this26.reserveIpProcessing = false;

				_this26.localErrorMessage = _this26.formatRequestError(resGet);
			}, function (resGet) {
				_this26.reserveIpProcessing = false;

				_this26.localErrorMessage = _this26.formatRequestError(resGet);
			});
		},
		hideDeleteModal: function hideDeleteModal() {
			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteCrudObject: function deleteCrudObject(data) {
			var _this = this;

			return function (e) {
				if (_this.deleteModalTimer && _this.deleteModalTimer > 0) {
					if (e) e.preventDefault();
					return;
				}

				if (_this.crud) {
					_this.lastWorkedRowID = false;
					_this.$store.commit('setLastRow', { 'crud': _this.crud, 'id': false });
				}

				_this.hideDeleteModal();

				var _id = data[_this.listConfig['column_id']];
				if (!_id) {
					_this.localErrorMessage = 'main/object_id';
					return;
				}

				if (_this.deleteRecordIdInProcess && Array.isArray(_this.deleteRecordIdInProcess) && _this.deleteRecordIdInProcess.indexOf(_id) > -1) return;

				_this.deleteRecordIdInProcess.push(_id);

				var _url = _this.APIServerUrl + '/' + _this.getRealCrud(_this.crud) + '/delete/' + _id;

				_this.$http.get(_url).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

					if (_dt && _dt['_csrf']) {
						var _post = {
							'_csrf': _dt['_csrf']
						};

						_this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
							_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

							setTimeout(function () {
								if (_this && _this.deleteRecordIdInProcess && Array.isArray(_this.deleteRecordIdInProcess)) {
									var _pos = _this.deleteRecordIdInProcess.indexOf(_id);
									if (_pos > -1) _this.deleteRecordIdInProcess.splice(_pos, 1);
								}
							}, 500);

							if (_dt && _dt['status'] === 'ok') {
								_this.requestListData();

								return;
							}

							_this.localErrorMessage = _this.formatRequestError(resPost);
						}, function (resPost) {
							_this.deleteRecordIdInProcess = false;

							_this.localErrorMessage = _this.formatRequestError(resPost);
						});

						return;
					}

					_this.deleteRecordIdInProcess = false;

					_this.localErrorMessage = _this.formatRequestError(resGet);
				}, function (resGet) {
					_this.deleteRecordIdInProcess = false;

					_this.localErrorMessage = _this.formatRequestError(resGet);
				});
			};
		},
		GoToVds: function GoToVds(data, what) {
			var _idFld = this.listConfig['column_id'];
			var _id = data[_idFld];
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			if (data['service_status_text'] || data['service_status'] !== 'active') {
				this.localErrorMessage = 'operation/not_found';
				return;
			}

			this.$store.commit('setVdsCommand', {
				'id': _id,
				'command': what
			});

			this.$router.push('/vds/view/' + _id);
		},
		clientToOperationHistory: function clientToOperationHistory() {
			if (this.$store.state.user_type !== 'client') return;

			if (!this.clientPartnerData || !('total' in this.clientPartnerData) || this.clientPartnerData.total === 0) return;

			var _obj = {
				'crud': 'operationClientPurse',
				'object': 'partner'
			};

			this.$store.commit('setCrudFilter', _obj);

			this.$router.push('/operation/list');
		},
		GoTo: function GoTo(data, where, object, field) {
			var _idFld = this.listConfig['column_id'];

			if (this.crud === 'user' && where === 'operation' && field === 'account_id') {
				if (this.accountGlobalFilter) return this.$router.push('/operation/list');

				_idFld = 'account_id';
			}
			if (this.crud === 'request' && where === 'request' && field === 'service_id') _idFld = 'service_id';
			if (this.crud === 'partner' && where === 'partneractions' && field === 'program_id') _idFld = 'program_id';
			if (this.crud === 'partnerprogram' && where === 'partner' && field === 'program_id') _idFld = 'program_id';
			if (this.crud === 'rackdevice' && where === 'rackdevice' && field === 'rack_id') _idFld = 'rack_id';

			var _id = data[_idFld];

			if (this.crud === 'ticket' && where === 'ticket' && field === 'has_user_id') _id = data['id'];

			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			var _obj = {
				'crud': where,
				'object': object && object !== '' ? object + '/' + _id : _id,
				'field': field
			};

			this.$store.commit('setCrudFilter', _obj);

			if (this.crud === 'request' && where === 'request' || this.crud === 'ticket' && where === 'ticket' || this.crud === 'rackdevice' && where === 'rackdevice') {
				this.initData(this.$route.path);

				this.listData = false;

				this.renderRows = false;
				this.initRows = false;

				this.setFastSearchValue('');

				this.sortedColumn = false;

				this.initFilters();

				this.getLocalStorage();

				this.getDataFromVuex();

				this.lastWorkedRowID = false;

				this.requestListData();
			} else {
				this.$router.push('/' + where + '/list');
			}
		},
		RebootDomain: function RebootDomain(data) {
			var _this27 = this;

			if (!data) return;

			var _id = data[this.listConfig['column_id']];
			if (!_id) return;

			if (this.domainRebootProcessing === _id) return;

			if (data['service_status'] !== 'active' || data['service_status_text'] || data['can_reboot'] !== true) return;

			this.confirmModalDialogTitle = 'service/reboot';

			this.confirmModalDialogText = this.localeFtc('service/reboot_domain');

			if (data['service_name']) this.confirmModalDialogText = this.confirmModalDialogText.replace('{domain}', data['service_name']);

			this.confirmModalDialogCallback = function () {
				return _this27.rebootDomainStart(_id);
			};

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModalDialog = true;
		},
		rebootDomainStart: function rebootDomainStart(ID) {
			var _this28 = this;

			var _serviceID = parseInt(ID);
			if (isNaN(_serviceID) || _serviceID <= 0) return;

			if (this.domainRebootProcessing === _serviceID) return;

			this.localErrorMessage = '';
			this.hideConfirmModalDialog();

			var _url = this.APIServerUrl + '/service/update/' + _serviceID + '?additional=setReboot';

			this.domainRebootProcessing = _serviceID;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this28.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this28.domainRebootProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this28.setLocalSuccessMessage('service/reboot_queued');
							return;
						}

						_this28.localErrorMessage = _this28.formatRequestError(resPost);
					}, function (resPost) {
						_this28.domainRebootProcessing = false;
						_this28.localErrorMessage = _this28.formatRequestError(resPost);
					});

					return;
				}

				_this28.domainRebootProcessing = false;
				_this28.localErrorMessage = _this28.formatRequestError(resGet);
			}, function (resGet) {
				_this28.domainRebootProcessing = false;
				_this28.localErrorMessage = _this28.formatRequestError(resGet);
			});
		},
		prolongService: function prolongService(row) {
			var _this29 = this;

			if (!row || !row['service_id']) return;

			var _serviceID = parseInt(row['service_id']);
			if (isNaN(_serviceID) || _serviceID <= 0) return;

			if (this.canProlongProcessing) return;

			this.canProlongProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + _serviceID + '?additional=setProlong';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this29.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this29.canProlongProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							return;
						}

						_this29.localErrorMessage = _this29.formatRequestError(resPost);
					}, function (resPost) {
						_this29.canProlongProcessing = false;

						_this29.localErrorMessage = _this29.formatRequestError(resPost);
					});

					return;
				}

				_this29.canProlongProcessing = false;

				_this29.localErrorMessage = _this29.formatRequestError(resGet);
			}, function (resGet) {
				_this29.canProlongProcessing = false;

				_this29.localErrorMessage = _this29.formatRequestError(resGet);
			});
		},
		clearCrudFilter: function clearCrudFilter() {
			this.$set(this, 'crudFilter', false);
			this.$store.commit('setCrudFilter', false);

			this.setLocalStorage();
			this.requestListData();
		},
		clearHttpCrudFilter: function clearHttpCrudFilter() {
			this.$set(this, 'crudHttpGetFilter', false);

			this.setLocalStorage();
			this.requestListData();
		},
		getDataFromVuex: function getDataFromVuex() {
			if (this.$store.state.crudFilter) {
				if (this.$store.state.crudFilter['crud'] === 'operationClientPurse') {
					var _filterValue = this.$store.state.crudFilter['object'];

					this.$set(this, 'crudFilter', false);
					this.$store.commit('setCrudFilter', false);

					if (this.filters && this.filters.radio && Array.isArray(this.filters.radio) && this.filters.radio.length) {
						this.filters.radio.some(function (item, index, arr) {
							if (item['field'] === 'operation_purse') {
								item['value'] = _filterValue;
								item['visible'] = true;
								return true;
							}
						});
					}
				} else {
						if (this.$store.state.accountGlobalFilter === true && this.$store.state.crudFilter.field === 'account_id') {} else {
								this.crudFilter = this.$store.state.crudFilter;
								this.setLocalStorage();
							}

						this.$store.commit('setCrudFilter', false);
					}
			}

			this.lastWorkedRowID = false;
			if (this.crud in this.$store.state.lastWorkedRowID && this.$store.state.lastWorkedRowID[this.crud]) {
				this.lastWorkedRowID = this.$store.state.lastWorkedRowID[this.crud];

				this.$store.commit('setLastRow', { 'crud': this.crud, 'id': false });
			}
		},
		getDataFromUrl: function getDataFromUrl() {
			if ((this.$route.path === '/text/list' || this.$route.path === '/text/list/') && this.$route.fullPath.indexOf('TextSearch') > -1) {
				var _match = /TextSearch%5Bid%5D=(\w+)$/i.exec(this.$route.fullPath);
				if (!_match || !_match[1]) return;

				var _id = parseInt(_match[1]);
				if (!_id || isNaN(_id)) return;

				var _obj = {
					'crud': 'text',
					'object': _id
				};

				this.crudFilter = _obj;
			}

			if (this.httpGetFilter) {
				this.crudHttpGetFilter = {};

				this.crudHttpGetFilter['__crud'] = this.crud;

				for (var _prop in this.httpGetFilter) {
					if (this.httpGetFilter.hasOwnProperty(_prop)) {
						var _found = false;
						if (this.listConfig && this.listConfig.filters) {
							if (this.listConfig.filters.period && this.listConfig.filters.period.begin_field && this.listConfig.filters.period.begin_field === _prop) {
								_found = true;
								this.filters.period.visible = true;
								this.filters.period.valueBegin = this.httpGetFilter[_prop];
							}

							if (this.listConfig.filters.period && this.listConfig.filters.period.end_field && this.listConfig.filters.period.end_field === _prop) {
								_found = true;
								this.filters.period.visible = true;
								this.filters.period.valueEnd = this.httpGetFilter[_prop];
							}

							if (this.listConfig.filters.select && _prop in this.listConfig.filters.select && this.listConfig.filters.select[_prop]) {
								_found = true;
								for (var _fIdx in this.filters.select) {
									if (this.filters.select[_fIdx]['field'] === _prop) {
										this.filters.select[_fIdx]['visible'] = true;
										this.filters.select[_fIdx]['value'] = {
											id: this.httpGetFilter[_prop]
										};
										break;
									}
								}
							}

							if (this.listConfig.filters.radio && _prop in this.listConfig.filters.radio && this.listConfig.filters.radio[_prop]) {
								_found = true;
								for (var _fIdx2 in this.filters.radio) {
									if (this.filters.radio[_fIdx2]['field'] === _prop) {
										this.filters.radio[_fIdx2]['visible'] = true;
										this.filters.radio[_fIdx2]['value'] = this.httpGetFilter[_prop];
										break;
									}
								}
							}

							if (this.listConfig.filters.bool && this.listConfig.filters.bool.field === _prop) {
								_found = true;
								this.filters.bool.value = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].normalizeBooleanValue(this.httpGetFilter[_prop]);
							}
						}

						if (!_found) this.crudHttpGetFilter[_prop] = this.httpGetFilter[_prop];
					}
				}
				if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.crudHttpGetFilter).length <= 1) this.crudHttpGetFilter = false;

				this.httpGetFilter = false;

				if (this.crudHttpGetFilter) this.setLocalStorage();
			}
		},
		getFilterFromUrl: function getFilterFromUrl() {
			this.httpGetFilter = false;

			if (this.$route.fullPath.indexOf('?') > -1 && this.$route.fullPath.indexOf('Search') > -1 && this.$route.query && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.$route.query) === 'object' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$route.query).length) {
				this.httpGetFilter = {};
				for (var _prop in this.$route.query) {
					if (this.$route.query.hasOwnProperty(_prop)) {
						var _result = _prop.match(/Search\[(.*?)\]/i);
						if (_result && _result[1]) this.httpGetFilter[_result[1]] = this.$route.query[_prop];
					}
				}
			}
		},
		crudFilterField: function crudFilterField() {
			if (this.crud === 'logs') return 'log_sub';else if (this.crud === 'notes') return 'note_object';else if (this.crud === 'request' || this.crud === 'serviceRequest') return 'service_id';else if (this.crud === 'operation') return 'account_id';else if (this.crud === 'user') return 'account_id';else if (this.crud === 'partneractions' || this.crud === 'partnerprogram' || this.crud === 'partner') return 'program_id';else if (this.crud === 'text') return 'id';

			return false;
		},
		createNoteFromMenu: function createNoteFromMenu(row) {
			if (!row) {
				if (this.$store.state.isDebug) window.DEBUG.error('Lcnfm0: не заданы данные строки');
				return;
			}

			if (!this.listConfig['column_id']) {
				if (this.$store.state.isDebug) window.DEBUG.error('Lcnfm1: в конфигурации отсутствует column_id');
				return;
			}

			var _obj = {};

			_obj['type'] = this.crud;

			if (this.crud === 'vds' || this.crud === 'iso' || this.crud === 'additional-services' || this.crud === 'backups' || this.crud === 'certificate' || this.crud === 'dns' || this.crud === 'domains' || this.crud === 'disks') _obj['type'] = 'service';

			_obj['id'] = row[this.listConfig['column_id']];

			var _nameField = this.getRealCrud(this.crud) + '_name_full';

			if (!(_nameField in row)) _nameField = this.getRealCrud(this.crud) + '_name';

			if (!(_nameField in row)) {
				if ((this.crud === 'user' || this.crud === 'admin') && 'user_email' in row) _nameField = 'user_email';else {
					if (this.$store.state.isDebug) {
						window.DEBUG.error('Lcnfm2: отсутствует наименование объекта в данных');
						return;
					}
				}
			}

			_obj['name'] = row[_nameField];

			if (!_obj['type'] || !_obj['id'] || !_obj['name']) {
				window.DEBUG.error('Lcnfm3: отсутствуют необходимые поля объекта в данных');
				return;
			}

			this.$store.commit('createNoteData', _obj);

			this.$router.push('/notes/create');
		},
		bonusActivateFromMenu: function bonusActivateFromMenu(row) {
			if (!row) {
				if (this.$store.state.isDebug) window.DEBUG.error('Lbafm0: не заданы данные строки');
				return;
			}

			var bonus = 'bonus_id' in row && row['bonus_id'] ? row['bonus_id'] : null;
			var account = 'account_id' in row && 'account_name' in row ? { id: String(row['account_id']), name: row['account_name'] } : null;

			this.$store.commit('bonusActivateData', { bonus: bonus, account: account });

			this.$router.push('/bonus/activate');
		},
		ticketMergeFromMenu: function ticketMergeFromMenu(row) {
			this.$set(this, 'mergeTicketsOldId', null);

			if (!row) {
				if (this.$store.state.isDebug) window.DEBUG.error('Tmfm0: не заданы данные строки');
				return;
			}

			if (row['ticket_id'] === undefined || row['ticket_id'] === null || String(row['ticket_id']).trim() === '') return;

			if (row['can_merge'] !== true) return;

			this.$set(this, 'mergeTicketsOldId', row['ticket_id']);

			this.$set(this.mergeTicketsField, 'url', '/ticket/update/' + row['ticket_id'] + '?search=ticket&q=');

			this.$set(this.mergeTicketsField, 'value', null);

			this.$set(this.mergeTicketsField, '_errMsg', '');

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showMergeTicketsDialog = true;
		},
		mergeTicketsStart: function mergeTicketsStart() {
			var _this30 = this;

			if (this.mergeTicketsOldId === undefined || this.mergeTicketsOldId === null || String(this.mergeTicketsOldId).trim() === '') return;

			if (this.mergeTicketsField.value === undefined || this.mergeTicketsField.value === null || String(this.mergeTicketsField.value).trim() === '') {
				this.mergeTicketsField._errMsg = 'ticket/not_found';
				return;
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showMergeTicketsDialog = false;

			var _url = this.APIServerUrl + '/ticket/update/' + this.mergeTicketsOldId + '?additional=setMerge&ticket_id=' + this.mergeTicketsField.value;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this30.$store.commit('ItIsMe', true);

					var _post = { '_csrf': _dt['_csrf'] };

					_this30.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this30.setLocalSuccessMessage(_this30.localeFtc('ticket/ticket_merged').replace('{ticket_from}', _this30.this.mergeTicketsOldId));

							_this30.requestListData();

							return;
						}

						_this30.localErrorMessage = _this30.formatRequestError(resPost);
					}, function (resPost) {
						_this30.localErrorMessage = _this30.formatRequestError(resPost);
					});

					return;
				}

				_this30.localErrorMessage = _this30.formatRequestError(resGet);
			}, function (resGet) {
				_this30.localErrorMessage = _this30.formatRequestError(resGet);
			});
		},
		goPdfLink: function goPdfLink(row) {
			if (!row || !row.pdf) return;
			var win = window.open(row.pdf, '_blank');
			win.focus();
		},
		goXmlLink: function goXmlLink(row) {
			if (!row || !row.xml) return;
			var win = window.open(row.xml, '_blank');
			win.focus();
		},
		goOperLink: function goOperLink(row) {
			if (!row || !row.operation_id) return;
			this.$router.push('/operation/view/' + row.operation_id);
		},
		goMailDocument: function goMailDocument(row) {
			var _this31 = this;

			if (!row || !row.document_id) return;

			this.setLocalSuccessMessage('document/mail_started');

			if (!this.isAccess('document/mail')) return;

			var _url = this.APIServerUrl + '/document/mail/' + row.document_id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this31.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-push', 'update document ' + row.document_id);

							var _msg = 'document/mailed';
							if (_dt.title) _msg = _dt.title;
							_this31.setLocalSuccessMessage(_msg);

							return;
						}

						_this31.localErrorMessage = _this31.formatRequestError(resPost);
					}, function (resPost) {
						_this31.localErrorMessage = _this31.formatRequestError(resPost);
					});

					return;
				}

				_this31.localErrorMessage = _this31.formatRequestError(resGet);
			}, function (resGet) {
				_this31.localErrorMessage = _this31.formatRequestError(resGet);
			});
		},
		showPaymentLink: function showPaymentLink(row) {
			if (!row || !row.external_hash) return;

			this.paymentLinkUrl = this.CpServerUrl + '/operation/select/' + row.external_hash;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPaymentLinkDialog = true;
		},
		hidePaymentLinkDialog: function hidePaymentLinkDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPaymentLinkDialog = false;
		},
		copyPaymentLink: function copyPaymentLink() {
			var el = this.$refs['paymentLinkUrl'];

			if (document.body.createTextRange) {
				var textRange = document.body.createTextRange();
				textRange.moveToElementText(el);
				textRange.select();
				textRange.execCommand('Copy');
			} else if (window.getSelection && document.createRange) {
				var range = document.createRange();
				range.selectNodeContents(el);
				var sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range);
				try {
					document.execCommand('copy');
				} catch (err) {}
			}
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(data) {
			var column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'account_name';

			this.filterListByAccount(data, column);
		},
		filterListByAccount: function filterListByAccount(data) {
			var _this32 = this;

			var column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'account_name';

			if (this.$store.state.user_type !== 'admin') return;

			var _aid = false;

			if (column === 'owner_account_name') {
				if (!('owner_account_id' in data) || !data['owner_account_id'] || !/\d+/.test(data['owner_account_id'])) return;else _aid = data['owner_account_id'];
			} else if (column === 'account_name') {
				if (!('account_id' in data) || !data['account_id'] || !/\d+/.test(data['account_id'])) return;else _aid = data['account_id'];
			}
			if (!_aid) return;

			var _accountID = parseInt(_aid);
			if (isNaN(_accountID) || _accountID < 1) return;

			var _url = this.APIServerUrl + '/admin/index';
			var _params = {
				'additional': 'addGlobalFilter',
				'type': 'account',
				'object_id': _accountID
			};

			if (this.crud) {
				this.lastWorkedRowID = false;
				this.$store.commit('setLastRow', { 'crud': this.crud, 'id': false });
			}

			this.$store.commit('accountGlobalFilter', false);

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok') {
					_this32.$store.commit('accountGlobalFilter', true);

					if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

					_this32.$store.dispatch('getTicketCounters');
					_this32.$store.dispatch('getRequestCounter');

					_this32.requestListData();

					return;
				}

				_this32.localErrorMessage = 'error/api_incorrect';
			}, function (resGet) {
				_this32.localErrorMessage = 'error/api_incorrect';
			});
		},
		clearAccountGlobalFilter: function clearAccountGlobalFilter() {
			var _this33 = this;

			if (this.$store.state.user_type !== 'admin') return;

			var _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok') {
					_this33.$store.commit('accountGlobalFilter', false);

					if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

					if (_this33.crud === 'document' && _this33.filters.select && _this33.filters.select.length) {
						var _fltrIndex = -1;
						_this33.filters.select.some(function (item, idx) {
							if (item.field === 'payer_id') {
								_fltrIndex = idx;
								return true;
							}
						});

						if (_fltrIndex > -1) {
							_this33.filters.select[_fltrIndex].value = { id: -1, name: 'main/list_all' };
							_this33.filters.select[_fltrIndex].visible = false;
							_this33.setLocalStorage(true);
						}
					}

					_this33.$store.dispatch('getTicketCounters');
					_this33.$store.dispatch('getRequestCounter');

					_this33.requestListData();

					return;
				}

				_this33.localErrorMessage = 'error/api_incorrect';
			}, function (resGet) {
				_this33.localErrorMessage = 'error/api_incorrect';
			});
		},
		keyDownHandler: function keyDownHandler(e) {
			if (!e || !e.keyCode) return;

			if (e.keyCode === 27) {
				this.hideDeleteModal();
				this.hideConfirmModalDialog();
				this.hideBlockModal();
				this.hideRegisterModal();
				this.hideRemoveFilterModal();
				this.hideMigrateModal();
				this.hideServiceMoveModal();
				this.hideServiceBulkDelModal();
				this.hideTicketMoveModal();
				this.hideTicketBlockModal();
				this.hideISOModal();
				this.hideViewModal();
				this.hidePaymentModal();
				this.hideCalcModal();
				this.hideRackGraphicModal();
				this.hideBalancePopup();
				this.hideTicketLabelBlock();
				this.showMarkTicketsAsReadedDialog = false;
				this.showMergeTicketsDialog = false;
				this.hidePaymentLinkDialog();
				this.hideDocumentModalDialog();
				this.hideBackupDialog();
				this.hideConnectOuterDiskDialog();
				this.hideCopyToDcModal();
				this.hideVdsCloneModal();
				this.hideVdsCloneProcessInfoModal();
				this.hideDownloadBackupModal();
				this.hideRenameBackupDialog();
				this.hideRestoreBackupOuterDiskDialog();
				this.hideBackupScheduleModal();
			}
		},
		clickHandler: function clickHandler(e) {
			if (this.showChoiceTicketLabelBlock) {
				var _el = this.$refs['ticketChoiceLabelBlock'];
				if (_el !== e.target && !_el.contains(e.target)) this.hideTicketLabelBlock();
			}
		},
		hideBlockModal: function hideBlockModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBlockModal = false;
			this.hideModalMask();
		},
		hideRegisterModal: function hideRegisterModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRegisterModal = false;
			this.hideModalMask();
		},
		hideRemoveFilterModal: function hideRemoveFilterModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRemoveFilterModal = false;
			this.hideModalMask();
		},
		hideCopyToDcModal: function hideCopyToDcModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showCopyToDcModal = false;
			this.hideModalMask();
		},
		hideVdsCloneModal: function hideVdsCloneModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showVdsCloneModal = false;
			this.hideModalMask();
		},
		hideVdsCloneProcessInfoModal: function hideVdsCloneProcessInfoModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.vdsCloneShowProcessDataValue = false;
			this.hideModalMask();
		},
		hideDownloadBackupModal: function hideDownloadBackupModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDownloadBackupModal = false;
			this.hideModalMask();
		},
		hideMigrateModal: function hideMigrateModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showMigrateModal = false;
			this.hideModalMask();
		},
		hideServiceMoveModal: function hideServiceMoveModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showServiceMoveModal = false;
			this.hideModalMask();
		},
		hideServiceBulkDelModal: function hideServiceBulkDelModal() {
			if (this.serviceBulkDelModalButtonHandler) {
				clearInterval(this.serviceBulkDelModalButtonHandler);
				this.serviceBulkDelModalButtonHandler = null;
				this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete') + ' - 10';
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showServiceBulkDelModal = false;
			this.hideModalMask();
		},
		hideTicketMoveModal: function hideTicketMoveModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showTicketMoveModal = false;
			this.hideModalMask();
		},
		hideTicketBlockModal: function hideTicketBlockModal() {
			if (this.ticketBlockModalTimerHandle) {
				clearInterval(this.ticketBlockModalTimerHandle);
				this.ticketBlockModalTimerHandle = null;
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showTicketBlockModal = false;
			this.hideModalMask();
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			var _this34 = this;

			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || !_parts.length) return;

			if (msg.indexOf(' ticket ') > 0) {
				if (_parts.length < 3) return;
			} else if (_parts.length < 3) return;

			if (_parts[0] === 'view') return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			var _id = _parts[2];

			if (!_id) return;

			if (_id === 'refresh') {
				if (this.silenceRequestTimer) {
					clearTimeout(this.silenceRequestTimer);
					this.silenceRequestTimer = null;
				}

				this.silenceRequestTimer = setTimeout(function () {
					_this34.silenceRequestTimer = null;

					_this34.requestListData(true);
				}, 500);

				return;
			}

			if (msg === 'reload operation list') {
				this.initData(this.$route.path);

				this.listData = false;

				this.renderRows = false;
				this.initRows = false;

				this.fastSearchValue = null;

				this.sortedColumn = false;

				this.initFilters();

				this.getLocalStorage();

				this.getDataFromVuex();

				this.lastWorkedRowID = false;

				this.requestListData();
				return;
			}

			this.pushFindRecord(_id);
		},
		pushFindRecord: function pushFindRecord(ID) {
			var _this35 = this;

			if (!this.initRows || !this.initRows.length) {
				var _found = void 0;

				if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) {
					_found = false;
				} else {
					_found = this.renderRows.some(function (item, idx, arr) {
						if (String(item[_this35.listConfig['column_id']]) === String(ID)) {
							return true;
						}
					});

					if (_found) {
						var _url = this.APIServerUrl + '/' + this.getRealCrud(this.crud) + '/list';
						var _reqData = {};
						_reqData[this.model] = {};
						_reqData[this.model][this.listConfig['column_id']] = ID;

						if (this.crud === 'ticket') {
							_reqData[this.model]['show_closed'] = true;
						}

						this.$http.get(_url, _reqData ? { 'params': _reqData } : null).then(function (response) {
							var _dt = response && response.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(response.data) === 'object' ? response.data : false;
							if (!_dt || _dt['status'] !== 'ok' || !_dt['rows'] || !_dt['rows'][0]) {
								if (_this35.silenceRequestTimer) {
									clearTimeout(_this35.silenceRequestTimer);
									_this35.silenceRequestTimer = null;
								}

								_this35.silenceRequestTimer = setTimeout(function () {
									_this35.silenceRequestTimer = null;

									_this35.requestListData(true);
								}, 1000);

								return;
							}

							if (!_this35.renderRows || !_this35.renderRows.length) _this35.renderRows = [];
							_this35.renderRows.some(function (item, idx, arr) {
								if (String(item[_this35.listConfig['column_id']]) === String(ID)) {
									_this35.$set(arr, idx, _dt['rows'][0]);

									if (item['w5-row-selected'] === true) _this35.$nextTick(function () {
										return _this35.buttonsForSelectedRow();
									});

									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-update-row', {
										'column_id': _this35.listConfig['column_id'],
										'row': arr[idx]
									});

									return true;
								}
							});
						});
					}
				}

				if (!_found) {
					if (this.silenceRequestTimer) {
						clearTimeout(this.silenceRequestTimer);
						this.silenceRequestTimer = null;
					}

					this.silenceRequestTimer = setTimeout(function () {
						_this35.silenceRequestTimerCounter = 0;

						_this35.silenceRequestTimer = null;

						_this35.requestListData(true);
					}, 3000);

					if (this.silenceRequestTimerCounter > 1000) {
						this.silenceRequestTimerCounter = 0;
						this.requestListData(true);
					}
				}

				return;
			}

			setTimeout(function () {
				_this35.pushFindRecord(ID);
			}, 1000);
		},
		FromViewToList: function FromViewToList(rowView, rowList) {
			for (var p in rowList) {
				if (rowList.hasOwnProperty(p)) {
					if (p in rowView) {
						rowList[p] = rowView[p];
					} else {
						if (p !== 'w5-row-selected') delete rowList[p];
					}
				}
			}
			for (var v in rowView) {
				if (rowView.hasOwnProperty(v)) {
					if (!(v in rowList)) rowList[v] = rowView[v];
				}
			}return rowList;
		},
		isColumnInData: function isColumnInData(columnName) {
			if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false;

			if (columnName === 'account_id' || columnName === 'account_name') {
				if (this.accountGlobalFilter) {
					if (this.crud !== 'account' && this.crud !== 'partneractions') return false;else return true;
				} else return true;
			}

			if (columnName === 'owner_account_id' || columnName === 'owner_account_name') {
				if (this.accountGlobalFilter) return false;else return true;
			}

			if (this.crud === 'rackdevice') {
				if (columnName === 'rack_name') {
					if (this.crudFilter && this.crudFilter.crud === 'rackdevice' && this.crudFilter.field === 'rack_id') return false;else return true;
				}

				if (columnName === 'device_unit') {
					return 'device_unit' in this.renderRows[0];
				}
			}

			if (this.crud === 'rack' && columnName === 'datacenter_name') {
				return 'datacenter_name' in this.renderRows[0];
			}

			return true;
		},
		verifyForGlobalFilter: function verifyForGlobalFilter(columnName) {
			if (columnName === 'account_id' || columnName === 'account_name') {
				if (this.accountGlobalFilter) {
					if (this.crud !== 'account' && this.crud !== 'partneractions') return false;else return true;
				} else return true;
			}

			if (columnName === 'owner_account_id' || columnName === 'owner_account_name') {
				if (this.accountGlobalFilter) return false;else return true;
			}

			if (this.crud === 'rackdevice') {
				if (columnName === 'rack_name') {
					if (this.crudFilter && this.crudFilter.crud === 'rackdevice' && this.crudFilter.field === 'rack_id') return false;else return true;
				}

				if (columnName === 'device_unit') {
					if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false;
					return 'device_unit' in this.renderRows[0];
				}
			}

			if (this.crud === 'rack' && columnName === 'datacenter_name') {
				if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false;
				return 'datacenter_name' in this.renderRows[0];
			}

			return true;
		},
		ejectISOOper: function ejectISOOper(data) {
			if (!data) return;
			this.ejectISO(data);
		},
		ejectISO: function ejectISO(row, e) {
			var _this36 = this;

			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return;

			if (row && row['service_status_text'] && String(row['service_status_text']).length) return;

			if (!this.isAccess('service/update')) return;

			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}

			this.localErrorMessage = '';

			this.isoID = row['service_id'];
			this.isoParentID = row['parent_id'];

			this.isoModalTitle = 'service/iso';
			this.isoModalText = this.localeFtc('service/iso_ejecting_confirm').replace('{iso}', row['service_name']);

			this.blockModalTimer = 5;
			this.isoBlockModalButtonTitle = '5 - ' + this.localeFtc('main/detach');

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showISOModal = true;

			this.blockModalTimerHandler = setInterval(function () {
				_this36.blockModalTimer--;
				_this36.isoBlockModalButtonTitle = _this36.blockModalTimer + ' - ' + _this36.localeFtc('main/detach');
				if (_this36.blockModalTimer <= 0) {
					_this36.isoBlockModalButtonTitle = _this36.localeFtc('main/detach');
					clearInterval(_this36.blockModalTimerHandler);
					_this36.blockModalTimerHandler = null;
				}
			}, 1000);
		},
		hideISOModal: function hideISOModal() {
			if (this.blockModalTimerHandler) {
				clearInterval(this.blockModalTimerHandler);
				this.blockModalTimerHandler = null;
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showISOModal = false;
			this.hideModalMask();
		},
		detachIsoBegin: function detachIsoBegin(e) {
			var _this37 = this;

			if (this.blockModalTimer > 0) {
				if (e) e.preventDefault();
				return;
			}

			if (!this.isoID || !this.isoParentID) return;

			if (!this.isAccess('service/update')) return;

			if (this.isoModalTitle === 'service/extdisk') {
				this.detachOuterDiskBegin();
				return;
			}

			this.hideISOModal();

			var _url = this.APIServerUrl + '/service/update/' + this.isoID + '?additional=setDetach';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this37.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this37.setLocalSuccessMessage(_dt['title'] || 'main/process_started');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							if (_dt['fields'] && _dt['fields']['iso_id']) {
								if (Array.isArray(_dt['fields']['iso_id'])) {
									if (_dt['fields']['iso_id'].length) _this37.localErrorMessage = _this37.localeFtc(_dt['fields']['iso_id'][0]);
								} else {
									_this37.localErrorMessage = _this37.localeFtc(_dt['fields']['iso_id']);
								}
							}
							return;
						}

						_this37.localErrorMessage = _this37.formatRequestError(resPost);
					}, function (resPost) {
						_this37.localErrorMessage = _this37.formatRequestError(resPost);
					});

					return;
				}

				_this37.localErrorMessage = _this37.formatRequestError(resGet);
			}, function (resGet) {
				_this37.localErrorMessage = _this37.formatRequestError(resGet);
			});
		},
		backupOuterDisk: function backupOuterDisk(data) {
			var _this38 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var _id, _accountID, _cost, _size, _sizeFor, _rez, _rez2;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (data) {
									_context4.next = 2;
									break;
								}

								return _context4.abrupt('return');

							case 2:
								if (_this38.isAccess('service/create')) {
									_context4.next = 4;
									break;
								}

								return _context4.abrupt('return');

							case 4:
								_id = data[_this38.listConfig['column_id']];

								if (_id) {
									_context4.next = 7;
									break;
								}

								return _context4.abrupt('return');

							case 7:
								if (!(data['service_status'] !== 'active' || data['service_status_text'])) {
									_context4.next = 9;
									break;
								}

								return _context4.abrupt('return');

							case 9:
								_this38.confirmModalDialogTitle = 'service/backup_create';

								_accountID = null;

								if (data && 'account_id' in data) _accountID = data['account_id'];

								_cost = null;
								_size = null;
								_sizeFor = null;
								_context4.prev = 15;
								_context4.next = 18;
								return _this38.$http.get(_this38.APIServerUrl + '/service/view/' + _id);

							case 18:
								_rez = _context4.sent;

								if (_rez && _rez.data && _rez.data.status === 'ok' && _rez.data.service.service_quantity && 'value' in _rez.data.service.service_quantity) {
									_size = parseInt(_rez.data.service.service_quantity.value, 10);
									_sizeFor = _rez.data.service.service_quantity.for;
								}

								if (!_accountID && _rez && _rez.data && _rez.data.status === 'ok' && _rez.data.account && _rez.data.account.account_id && 'value' in _rez.data.account.account_id) {
									_accountID = _rez.data.account.account_id.value;
								}
								_context4.next = 25;
								break;

							case 23:
								_context4.prev = 23;
								_context4.t0 = _context4['catch'](15);

							case 25:

								if (!_accountID) {
									if (_this38.$store.state.user_account) {
										_accountID = String(_this38.$store.state.user_account).replace(/[a-z]/ig, '');
									}
								}

								if (_accountID) {
									_context4.next = 28;
									break;
								}

								return _context4.abrupt('return');

							case 28:
								_context4.prev = 28;
								_context4.next = 31;
								return _this38.$http.get(_this38.APIServerUrl + '/service/create?search=service_backup&account_id=' + _accountID);

							case 31:
								_rez2 = _context4.sent;

								if (_rez2 && _rez2.data && _rez2.data.status === 'ok' && _rez2.data.result && _rez2.data.result.length) {
									_rez2.data.result.some(function (item) {
										if (item && String(item.id) === String(_id)) {
											_cost = parseFloat(item.cost);
											return true;
										}
									});
								}
								_context4.next = 37;
								break;

							case 35:
								_context4.prev = 35;
								_context4.t1 = _context4['catch'](28);

							case 37:
								if (!(_cost === null || _size === null)) {
									_context4.next = 39;
									break;
								}

								return _context4.abrupt('return');

							case 39:
								_this38.confirmModalDialogText = _this38.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{size}</b>').replace('{cost}', __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].FormatMoney2(_cost, 2)).replace('{size}', _size + ' ' + _this38.localeFtc(_sizeFor));

								_this38.confirmModalDialogCallback = function () {
									return _this38.backupOuterDiskStart(_id, _accountID);
								};

								__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this38.showConfirmModalDialog = true;

							case 43:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this38, [[15, 23], [28, 35]]);
			}))();
		},
		backupOuterDiskStart: function backupOuterDiskStart(serviceId, accountId) {
			var _this39 = this;

			if (!serviceId || !accountId || !this.isAccess('service/create')) return;

			this.localErrorMessage = '';
			this.hideConfirmModalDialog();

			var _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['status']) {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'service_id': serviceId,
						'account_id': accountId,
						'reinstall': 0
					};

					_this39.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this39.setLocalSuccessMessage('service/creating_backup_begin_process');

							return;
						}

						_this39.localErrorMessage = _this39.formatRequestError(resPost);
					}, function (resPost) {
						_this39.localErrorMessage = _this39.formatRequestError(resPost);
					});

					return;
				}

				_this39.localErrorMessage = _this39.formatRequestError(resGet);
			}, function (resGet) {
				_this39.localErrorMessage = _this39.formatRequestError(resGet);
			});
		},
		cloneOuterDisk: function cloneOuterDisk(data) {
			var _this40 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _id, _cost, _size, _sizeFor, _rez, _type;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								if (data) {
									_context5.next = 2;
									break;
								}

								return _context5.abrupt('return');

							case 2:
								if (_this40.isAccess('service/clone')) {
									_context5.next = 4;
									break;
								}

								return _context5.abrupt('return');

							case 4:
								_id = data[_this40.listConfig['column_id']];

								if (_id) {
									_context5.next = 7;
									break;
								}

								return _context5.abrupt('return');

							case 7:
								if (!_this40.outerDiskCloneProcessing[_id]) {
									_context5.next = 9;
									break;
								}

								return _context5.abrupt('return');

							case 9:
								if (!(data['service_status'] !== 'active' || data['service_status_text'])) {
									_context5.next = 11;
									break;
								}

								return _context5.abrupt('return');

							case 11:
								_this40.confirmModalDialogTitle = 'main/clone';

								_cost = null;
								_size = null;
								_sizeFor = null;
								_context5.prev = 15;
								_context5.next = 18;
								return _this40.$http.get(_this40.APIServerUrl + '/service/view/' + _id);

							case 18:
								_rez = _context5.sent;

								if (_rez && _rez.data && _rez.data.status === 'ok' && _rez.data.service.service_quantity && 'value' in _rez.data.service.service_quantity) {
									_size = parseInt(_rez.data.service.service_quantity.value, 10);
									_sizeFor = _rez.data.service.service_quantity.for;
								}

								if (!(_rez && _rez.data && _rez.data.status === 'ok' && _rez.data.service_type && _rez.data.service_type.service_type_id && _rez.data.service_type.service_type_id.value)) {
									_context5.next = 26;
									break;
								}

								_type = _rez.data.service_type.service_type_id.value;
								_context5.next = 24;
								return _this40.$http.get(_this40.APIServerUrl + '/service/create/' + _type);

							case 24:
								_rez = _context5.sent;

								if (_rez && _rez.data && _rez.data.info && _rez.data.info.for) {
									_cost = parseFloat(_rez.data.info.cost);
								}

							case 26:
								_context5.next = 30;
								break;

							case 28:
								_context5.prev = 28;
								_context5.t0 = _context5['catch'](15);

							case 30:
								if (!(_cost === null || _size === null)) {
									_context5.next = 32;
									break;
								}

								return _context5.abrupt('return');

							case 32:
								_this40.confirmModalDialogText = _this40.localeFtc('service/extdisk_clone_confirm').replace('{name}', data['service_name_full']).replace('{price}', __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].FormatMoney2(_cost * _size, 2) + ' ' + _this40.localeFtc('main/ruble')).replace('{size}', _size + ' ' + _sizeFor);

								_this40.confirmModalDialogCallback = function () {
									return _this40.cloneOuterDiskStart(_id);
								};

								__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this40.showConfirmModalDialog = true;

							case 36:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this40, [[15, 28]]);
			}))();
		},
		cloneOuterDiskStart: function cloneOuterDiskStart(id) {
			var _this41 = this;

			if (this.outerDiskCloneProcessing[id]) return;
			if (!this.isAccess('service/clone')) return;

			this.localErrorMessage = '';
			this.hideConfirmModalDialog();

			var _url = this.APIServerUrl + '/service/clone/' + id;

			this.outerDiskCloneProcessing[id] = true;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this41.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						delete _this41.outerDiskCloneProcessing[id];

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this41.setLocalSuccessMessage('main/vds_clone_process_started');
							return;
						}

						_this41.localErrorMessage = _this41.formatRequestError(resPost);
					}, function (resPost) {
						delete _this41.outerDiskCloneProcessing[id];
						_this41.localErrorMessage = _this41.formatRequestError(resPost);
					});

					return;
				}

				delete _this41.outerDiskCloneProcessing[id];
				_this41.localErrorMessage = _this41.formatRequestError(resGet);
			}, function (resGet) {
				delete _this41.outerDiskCloneProcessing[id];
				_this41.localErrorMessage = _this41.formatRequestError(resGet);
			});
		},
		ejectOuterDisk: function ejectOuterDisk(data) {
			if (!data) return;
			this.ejectOuterDiskFromTable(data);
		},
		ejectOuterDiskFromTable: function ejectOuterDiskFromTable(row, e) {
			var _this42 = this;

			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return;

			if (row && row['service_status_text'] && String(row['service_status_text']).length) return;

			if (!this.isAccess('service/update')) return;

			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}

			this.localErrorMessage = '';

			this.isoID = row['service_id'];
			this.isoParentID = row['parent_id'];

			this.isoModalTitle = 'service/extdisk';
			this.isoModalText = this.localeFtc('service/extdisk_ejecting_confirm').replace('{disk}', row['service_name']);

			this.blockModalTimer = 5;
			this.isoBlockModalButtonTitle = '5 - ' + this.localeFtc('main/detach');

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showISOModal = true;

			this.blockModalTimerHandler = setInterval(function () {
				_this42.blockModalTimer--;
				_this42.isoBlockModalButtonTitle = _this42.blockModalTimer + ' - ' + _this42.localeFtc('main/detach');
				if (_this42.blockModalTimer <= 0) {
					_this42.isoBlockModalButtonTitle = _this42.localeFtc('main/detach');
					clearInterval(_this42.blockModalTimerHandler);
					_this42.blockModalTimerHandler = null;
				}
			}, 1000);
		},
		detachOuterDiskBegin: function detachOuterDiskBegin(e) {
			var _this43 = this;

			if (this.blockModalTimer > 0) {
				if (e) e.preventDefault();
				return;
			}

			if (!this.isoID || !this.isoParentID) return;

			if (!this.isAccess('service/update')) return;

			this.hideISOModal();

			var _url = this.APIServerUrl + '/service/update/' + this.isoID + '?additional=setDetach';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this43.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this43.setLocalSuccessMessage(_dt['title'] || 'main/process_started');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							if (_dt['fields'] && _dt['fields']['iso_id']) {
								if (Array.isArray(_dt['fields']['iso_id'])) {
									if (_dt['fields']['iso_id'].length) _this43.localErrorMessage = _this43.localeFtc(_dt['fields']['iso_id'][0]);
								} else {
									_this43.localErrorMessage = _this43.localeFtc(_dt['fields']['iso_id']);
								}
							}
							return;
						}

						_this43.localErrorMessage = _this43.formatRequestError(resPost);
					}, function (resPost) {
						_this43.localErrorMessage = _this43.formatRequestError(resPost);
					});

					return;
				}

				_this43.localErrorMessage = _this43.formatRequestError(resGet);
			}, function (resGet) {
				_this43.localErrorMessage = _this43.formatRequestError(resGet);
			});
		},
		hideCalcModal: function hideCalcModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showCalcModal = false;
			this.hideModalMask();
		},
		hidePaymentModal: function hidePaymentModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPaymentModal = false;
			this.hideModalMask();
		},
		paymentConvertBegin: function paymentConvertBegin() {
			var _this44 = this;

			this.localErrorMessage = '';

			if (this.isPaymentModalButtonDisabled) return;

			var _isErr = this.paymentFields.fields.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true) {
							if (fld.value === undefined || fld.value === null) {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});
			if (_isErr) return;

			var _url = this.APIServerUrl + '/operation/convert';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					_this44.paymentFields.fields.forEach(function (row) {
						if (row && Array.isArray(row) && row.length) {
							row.forEach(function (fld) {
								var _value = fld['value'];
								if (fld['type'] === 'boolean') {
									_value = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].normalizeBooleanValue(fld['value']) ? 1 : 0;
								}
								_post[_dt['model']][fld['_field_name']] = _value;
							});
						}
					});

					_this44.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-push', 'update partner 0');

							_this44.setLocalSuccessMessage('operation/converted');

							_this44.hidePaymentModal();

							return;
						}

						if (_dt && _dt['status'] === 'error' && _dt['fields'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_dt['fields']) === 'object') {
							for (var f in _dt['fields']) {
								if (_dt['fields'].hasOwnProperty(f)) {
									var _fld = _this44.findField(f);
									if (_fld) {
										_fld['_errMsg'] = _this44.localeFtc('main/error_desc').replace(':', '');

										if (Array.isArray(_dt['fields'][f])) {
											if (_dt['fields'][f].length) _fld['_errMsg'] = _this44.localeFtc(_dt['fields'][f][0]);
										} else _fld['_errMsg'] = _this44.localeFtc(_dt['fields'][f]);
									}
								}
							}return;
						}

						_this44.hidePaymentModal();

						_this44.localErrorMessage = _this44.formatRequestError(resPost);
					}, function (resPost) {
						_this44.hidePaymentModal();

						_this44.localErrorMessage = _this44.formatRequestError(resPost);
					});

					return;
				}

				_this44.hidePaymentModal();

				_this44.localErrorMessage = _this44.formatRequestError(resGet);
			}, function (resGet) {
				_this44.hidePaymentModal();

				_this44.localErrorMessage = _this44.formatRequestError(resGet);
			});
		},
		onBlurPayment: function onBlurPayment(field) {
			this.verifyFieldPayment(field);
		},
		onFocusPayment: function onFocusPayment(field) {
			if (field) field['_errMsg'] = '';
		},
		onEnterKeyDownPayment: function onEnterKeyDownPayment() {
			this.paymentConvertBegin();
		},
		verifyFieldPayment: function verifyFieldPayment(field) {},
		isVisiblePaymentField: function isVisiblePaymentField(row) {
			if (!row || !Array.isArray(row) || !row.length) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden') {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		fieldChangedPayment: function fieldChangedPayment(field) {
			if (!field) return;

			if (field['_field_name'] === 'type' && field['listValue']) {
				this.paymentMax = field['listValue']['max'];
				this.paymentMin = field['listValue']['min'];

				if (this.paymentMax > 0) {
					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
						'type': 'money',
						'name': 'summa',
						'value': this.paymentMax
					});
				}
			}

			this.isPaymentModalButtonDisabled = false;
			this.PaymentWarrningAdditional = false;
			if (!this.clientPartnerData || !('total' in this.clientPartnerData) || !this.clientPartnerData.total || this.clientPartnerData.total <= 1) {
				var _f = this.findField('type');
				if (_f && _f.listValue) {
					var _name = String(_f.listValue.name);
					if (_name.toLowerCase().indexOf('webmoney') > -1) {
						this.isPaymentModalButtonDisabled = true;
						this.PaymentWarrningAdditional = 'payment/partner_limits';
					}
				}
			}

			this.showifPayment();
		},
		fieldPaymentInput: function fieldPaymentInput(field) {
			this.PaymentWarrning = false;
			if (!field) return;

			if (field['_field_name'] === 'summa') {
				var _val = field.value;
				if (_val < this.paymentMin) this.PaymentWarrning = 'payment/not_available';
			}
		},
		showifPayment: function showifPayment() {
			var _rows = this.paymentFields.fields;
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf('in') !== -1) {
									var reg = new RegExp(/(\w+) in (\[[0-9,\s]+\])/gi);
									_expr = _expr.replace(reg, '$.inArray($1, $2) !== -1');
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		findField: function findField(name) {
			var _rows = this.paymentFields.fields;
			if (!_rows || !Array.isArray(_rows)) return;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		hideBalancePopup: function hideBalancePopup() {
			var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (!forceClose) {
				if (!this.maskModalFlag) return;
			}

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBalancePopup = false;
			this.hideModalMask();
		},
		onBalanceSubmit: function onBalanceSubmit() {
			if (this.balanceValue <= 0) {
				this.balanceField['_errMsg'] = 'error/required_field';
				return;
			}

			this.$store.commit('setOperationSumNew', this.balanceValue);

			this.$router.push('/operation/create');
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		changeTicketLabel: function changeTicketLabel(row) {
			this.hideTicketLabelBlock();

			this.ticketLabelId = null;

			if (this.$store.state.user_type !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			this.ticketLabelId = row['ticket_id'];
			if (!this.ticketLabelId) return;

			this.ticketLabelItems = {};
			if (this.listData && this.listData['filters'] && this.listData['filters']['ticket_label'] && this.listData['filters']['ticket_label']['list'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.listData['filters']['ticket_label']['list']) === 'object' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.listData['filters']['ticket_label']['list']).length) {
				var _old = row['ticket_label'] === undefined || row['ticket_label'] === null || row['ticket_label'] === '' || row['ticket_label'] === false ? null : row['ticket_label'];
				var _list = this.listData['filters']['ticket_label']['list'];
				for (var _val in _list) {
					if (_list.hasOwnProperty(_val)) {
						var _new = _val === undefined || _val === null || _val === '' || _val === false ? null : _val;

						if (_old === _new) continue;

						if (_new === null) this.ticketLabelItems[''] = null;else this.ticketLabelItems[_new] = _new;
					}
				}
			}

			var _cellEl = this.$refs['ticket-label-' + row['ticket_id']];
			var _coord = this.getElementOffset(_cellEl[0]);
			this.ticketLabelBlockStyle = 'top: ' + (_coord.top - 59) + 'px; left: 12px;';

			this.showChoiceTicketLabelBlock = true;
		},
		hideTicketLabelBlock: function hideTicketLabelBlock() {
			this.showChoiceTicketLabelBlock = false;
		},
		onChangeTicketLabel: function onChangeTicketLabel(value) {
			var _this45 = this;

			this.hideTicketLabelBlock();

			if (this.$store.state.user_type !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.ticketLabelId) return;

			var _index = -1;
			if (!this.renderRows || !this.renderRows.length) this.renderRows = [];
			this.renderRows.some(function (item, idx, arr) {
				if (String(item['ticket_id']) === String(_this45.ticketLabelId)) {
					_index = idx;
					return true;
				}
			});

			if (_index === -1) return;

			var _oldLabel = this.renderRows[_index]['ticket_label'];
			this.renderRows[_index]['ticket_label'] = 'loading';

			var _label = value === undefined || value === null || value === '' || value === false ? '' : value;

			var _url = this.APIServerUrl + '/ticket/update/' + this.ticketLabelId + '?additional=setLabel&label=' + _label;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this45.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-push', 'update ticket ' + _this45.ticketLabelId);

							return;
						}

						_this45.renderRows[_index]['ticket_label'] = _oldLabel;
					}, function (resPost) {
						_this45.renderRows[_index]['ticket_label'] = _oldLabel;
					});

					return;
				}

				_this45.renderRows[_index]['ticket_label'] = _oldLabel;
			}, function (resGet) {
				_this45.renderRows[_index]['ticket_label'] = _oldLabel;
			});
		},
		markTicketsAsReaded: function markTicketsAsReaded() {
			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' || !this.isUnreadedTickets || !this.isAccess('ticket/update')) return;

			this.showMarkTicketsAsReadedDialog = true;
		},
		markTicketsAsReadedStart: function markTicketsAsReadedStart() {
			var _this46 = this;

			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' || !this.isUnreadedTickets || !this.isAccess('ticket/update')) return;

			this.showMarkTicketsAsReadedDialog = false;

			var _url = this.APIServerUrl + '/ticket/update';

			var _params = {
				additional: 'setRead'
			};

			this.$store.commit('ItIsMe', true);

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this46.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							return;
						}
					});
				}
			});
		},
		totalSummFormat: function totalSummFormat(sum) {
			var _str = String(sum);
			_str = _str.replace(',', '.');
			var _params = _str.split('.');
			var digs = 2;
			if (_params.length > 1 && _params[1].length > 2) digs = _params[1].length;
			return __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].FormatMoney2(sum, digs);
		},
		safeTagsReplace: function safeTagsReplace(str) {
			return __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].safe_tags_replace(str);
		},
		recountDigitsForString: function recountDigitsForString(value) {
			var _str = String(parseFloat(value));
			_str = _str.replace(',', '.');
			var _params = _str.split('.');

			if (_params.length > 1 && _params[1].length > 2) this.countDigits = Math.max(_params[1].length, this.countDigits);
		},
		setFastSearchValue: function setFastSearchValue(value) {
			this.fastSearchValue = value;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-text-field-value', {
					'name': 'fastSearch',
					'value': value
				});
			}, 100);
		},
		ticketLastCommentatorShow: function ticketLastCommentatorShow(Row, event) {
			if (!Row || !event || !event.target) {
				this.ticketLastCommentator = '';
				this.ticketLastCommentatorStyle = { display: 'none', top: 0, left: 0 };
				return;
			}

			var _coor = this.getElementOffset(event.target, true);
			this.$set(this, 'ticketLastCommentatorStyle', {
				display: 'block',
				top: _coor.top - 7 + 'px',
				left: _coor.left + 30 + 'px'
			});

			var _text = '';
			if (Row && Row['ticket_last_user_name']) _text += Row['ticket_last_user_name'];

			this.ticketLastCommentator = _text;
		},
		ticketLastCommentatorHide: function ticketLastCommentatorHide() {
			this.ticketLastCommentator = '';
			this.ticketLastCommentatorStyle = { display: 'none', top: 0, left: 0 };
		},
		hideConnectOuterDiskDialog: function hideConnectOuterDiskDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConnectOuterDiskDialog = false;
			this.hideModalMask();
		},
		connectOuterDisk: function connectOuterDisk(data) {
			var _this47 = this;

			if (!data) return;

			var _id = data[this.listConfig['column_id']];
			if (!_id) return;

			if (data['service_status'] !== 'active' || data['service_status_text']) return;

			this.connectOuterDiskDialogMode = 'disk';
			this.connectOuterDiskDialogId = _id;

			this.localErrorMessage = '';

			this.$store.commit('needShowLoader', false);
			this.$http.get(this.APIServerUrl + '/service/update/' + _id + '?search=server_disk').then(function (resGet) {
				_this47.$store.commit('needShowLoader', true);

				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result'])) {
					if (_dt['result'].length) {
						_this47.$set(_this47.connectOuterDiskField, 'list', _dt['result'].map(function (el) {
							return {
								id: el.id,
								name: _this47.localeFtc(el.name),
								active: el.active === true && el.enable === true
							};
						}));

						_dt['result'].some(function (_srv) {
							if (_srv && _srv['id'] && _srv['active'] === true && _srv['enable'] === true) {
								var _newValue = {
									id: _srv['id'],
									name: _this47.localeFtc(_srv['name']),
									active: _srv['active'] === true && _srv['enable'] === true
								};

								_this47.$set(_this47.connectOuterDiskField, 'listValue', _newValue);
								_this47.$set(_this47, 'connectOuterDiskValue', _srv['id']);

								_this47.$nextTick(function () {
									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
										name: 'vdsId',
										value: _newValue
									});
								});
								return true;
							}
						});

						__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
						_this47.showConnectOuterDiskDialog = true;
					} else _this47.localErrorMessage = 'main/data_not_found';

					return;
				}

				_this47.localErrorMessage = _this47.formatRequestError(resGet);
			}, function (resGet) {
				_this47.$store.commit('needShowLoader', true);

				_this47.localErrorMessage = _this47.formatRequestError(resGet);
			});
		},
		connectOuterDiskDialogStartProcess: function connectOuterDiskDialogStartProcess() {
			var _this48 = this;

			if (!this.connectOuterDiskDialogId || !this.connectOuterDiskValue) {
				return;
			}
			if (!this.isAccess('service/update')) return;

			this.hideConnectOuterDiskDialog();

			this.localErrorMessage = '';

			var _url = this.APIServerUrl + '/service/update/' + this.connectOuterDiskDialogId + '?additional=setAttach&service_id=' + this.connectOuterDiskValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this48.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this48.setLocalSuccessMessage(_dt['title'] || 'main/process_started');

							return;
						}

						_this48.localErrorMessage = _this48.formatRequestError(resPost);
					}, function (resPost) {
						_this48.localErrorMessage = _this48.formatRequestError(resPost);
					});

					return;
				}

				_this48.localErrorMessage = _this48.formatRequestError(resGet);
			}, function (resGet) {
				_this48.localErrorMessage = _this48.formatRequestError(resGet);
			});
		},
		connectISOOper: function connectISOOper(data) {
			var _this49 = this;

			if (!data) return;

			var _id = data[this.listConfig['column_id']];
			if (!_id) return;

			if (data['service_status'] !== 'active' || data['service_status_text']) return;

			this.connectOuterDiskDialogMode = 'iso';
			this.connectOuterDiskDialogId = _id;

			this.localErrorMessage = '';

			this.$store.commit('needShowLoader', false);
			this.$http.get(this.APIServerUrl + '/service/update/' + _id + '?search=server_iso').then(function (resGet) {
				_this49.$store.commit('needShowLoader', true);

				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result'])) {
					if (_dt['result'].length) {
						_this49.$set(_this49.connectOuterDiskField, 'list', _dt['result'].map(function (el) {
							return {
								id: el.id,
								name: el.name,
								active: el.active === true && el.enable === true
							};
						}));

						_dt['result'].some(function (_srv) {
							if (_srv && _srv['id'] && _srv['active'] === true && _srv['enable'] === true) {
								var _newValue = {
									id: _srv['id'],
									name: _srv['name'],
									active: _srv['active'] === true && _srv['enable'] === true
								};

								_this49.$set(_this49.connectOuterDiskField, 'listValue', _newValue);
								_this49.$set(_this49, 'connectOuterDiskValue', _srv['id']);

								_this49.$nextTick(function () {
									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
										name: 'vdsId',
										value: _newValue
									});
								});
								return true;
							}
						});

						__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
						_this49.showConnectOuterDiskDialog = true;
					} else _this49.localErrorMessage = 'main/data_not_found';

					return;
				}

				_this49.localErrorMessage = _this49.formatRequestError(resGet);
			}, function (resGet) {
				_this49.$store.commit('needShowLoader', true);

				_this49.localErrorMessage = _this49.formatRequestError(resGet);
			});
		},
		connectISOOperDialogStartProcess: function connectISOOperDialogStartProcess() {
			var _this50 = this;

			if (!this.connectOuterDiskDialogId || !this.connectOuterDiskValue) {
				return;
			}
			if (!this.isAccess('service/update')) return;

			this.hideConnectOuterDiskDialog();

			this.localErrorMessage = '';

			var _url = this.APIServerUrl + '/service/update/' + this.connectOuterDiskDialogId + '?additional=setAttach&service_id=' + this.connectOuterDiskValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this50.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this50.setLocalSuccessMessage(_dt['title'] || 'main/process_started');

							return;
						}

						_this50.localErrorMessage = _this50.formatRequestError(resPost);
					}, function (resPost) {
						_this50.localErrorMessage = _this50.formatRequestError(resPost);
					});

					return;
				}

				_this50.localErrorMessage = _this50.formatRequestError(resGet);
			}, function (resGet) {
				_this50.localErrorMessage = _this50.formatRequestError(resGet);
			});
		},
		hideBackupDialog: function hideBackupDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBackupDialog = false;
			this.hideModalMask();
		},
		restoreBackup: function restoreBackup(data) {
			if (!data) return;

			var _id = data[this.listConfig['column_id']];
			if (!_id) return;

			if (data['service_status'] !== 'active' || data['service_status_text']) return;

			this.backupDialogId = _id;
			this.backupDialogName = data['service_name'];
			this.backupDialogType = 'restore-backup';

			if (this.$store.state.user_type === 'admin') {
				if (this.accountGlobalFilter && this.accountGlobalFilter.text) {
					var _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '');
					var _num = parseInt(_numStr);
					if (!isNaN(_num)) this.backupDialogAccount = _num;
				} else {
						if (data.account_id) this.backupDialogAccount = data.account_id;else return;
					}
			}

			if (this.$store.state.user_type !== 'admin') this.backupDialogAccount = true;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showBackupDialog = true;
		},
		backupDialogStartProcess: function backupDialogStartProcess(data) {
			var _this51 = this;

			if (!data || !data.service) return;

			this.hideBackupDialog();

			this.localErrorMessage = '';

			var _url = null;
			if (this.backupDialogType === 'create-backup') {
				if (!this.isAccess('service/create')) return;

				_url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS;
			} else {
				if (!this.isAccess('service/update')) return;

				_url = this.APIServerUrl + '/service/update/' + data.service + '?additional=setRestore&service_id=' + this.backupDialogId;
			}

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['status']) {
					var _post = { '_csrf': _dt['_csrf'] };

					if (_this51.backupDialogType === 'create-backup') {
						var _account = data.account;
						if (!_account) {
							if (_dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value']) {
								_account = _dt['fields']['account_id']['value'];
							} else {
								if (_this51.$store.state.user_account) {
									_account = String(_this51.$store.state.user_account).replace(/[a-z]/ig, '');
								}
							}
						}

						_post[_dt['model']] = {
							'service_id': data.service,
							'account_id': _account,
							'reinstall': 0
						};
					} else {}

					_this51.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this51.setLocalSuccessMessage(_this51.backupDialogType === 'create-backup' ? 'service/creating_backup_begin_process' : 'service/restore_queued');

							_this51.requestListData();

							return;
						}

						_this51.localErrorMessage = _this51.formatRequestError(resPost);
					}, function (resPost) {
						_this51.localErrorMessage = _this51.formatRequestError(resPost);
					});

					return;
				}

				_this51.localErrorMessage = _this51.formatRequestError(resGet);
			}, function (resGet) {
				_this51.localErrorMessage = _this51.formatRequestError(resGet);
			});
		},
		hideBackupScheduleModal: function hideBackupScheduleModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBackupScheduleModal = false;
			this.hideModalMask();
		},
		isVisibleScheduleField: function isVisibleScheduleField(row) {
			if (!row) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		fieldScheduleChanged: function fieldScheduleChanged(field) {
			this.showIfForSchedule();
		},
		findScheduleField: function findScheduleField(name) {
			if (!this.backupScheduleForm.fields) return null;

			var _field = null;
			this.backupScheduleForm.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		showIfForSchedule: function showIfForSchedule() {
			var _rows = this.backupScheduleForm['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg.exec(_expr) !== null) {
												_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
											} else {
												_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop2 = function _loop2(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop2(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findScheduleField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		localScheduleValidation: function localScheduleValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					return false;
				}

				if (v === String(r)) return true;

				field['_errMsg'] = 'validators/error_int';
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v2 = String(field.value).trim();

				_v2 = _v2.replace(/ /g, '');

				var _r = parseFloat(_v2);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				return false;
			}

			return true;
		},
		scheduleOuterDiskUpdate: function scheduleOuterDiskUpdate(data) {
			this.scheduleOuterDisk(data);
		},
		scheduleOuterDisk: function scheduleOuterDisk(data) {
			if (!data || !data.service_id || !data.service_data) return;

			this.backupScheduleId = data.service_id;
			this.backupScheduleMode = data.service_data && data.service_data.has_schedule === true ? 'update' : 'create';

			if (this.backupScheduleMode === 'create') this.createBackupSchedule();else this.updateBackupSchedule();
		},
		createBackupSchedule: function createBackupSchedule() {
			var _this52 = this;

			if (!this.backupScheduleId) return;
			if (!this.isAccess('backupschedule/create')) return;

			this.backupScheduleForm = null;
			var _url = this.APIServerUrl + '/backupschedule/create/' + this.backupScheduleId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this52.backupScheduleForm = _this52.parseFormData(_dt);
					_this52.$nextTick(function () {
						_this52.showIfForSchedule();
					});

					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this52.showBackupScheduleModal = true;
				}
			}, function (resGet) {
				_this52.localErrorMessage = _this52.formatRequestError(resGet);
			});
		},
		updateBackupSchedule: function updateBackupSchedule() {
			var _this53 = this;

			if (!this.backupScheduleId) return;
			if (!this.isAccess('backupschedule/update')) return;

			this.backupScheduleForm = null;
			var _url = this.APIServerUrl + '/backupschedule/update/' + this.backupScheduleId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this53.backupScheduleForm = _this53.parseFormData(_dt);
					_this53.$nextTick(function () {
						_this53.showIfForSchedule();
					});

					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this53.showBackupScheduleModal = true;
				}
			}, function (resGet) {
				_this53.localErrorMessage = _this53.formatRequestError(resGet);
			});
		},
		createBackupScheduleBegin: function createBackupScheduleBegin() {
			var _this54 = this;

			if (this.createScheduleEmpty) return;

			this.localErrorMessage = '';

			if (!this.backupScheduleId) {
				this.localErrorMessage = 'error/app_internal';
				this.hideBackupScheduleModal();
				return;
			}

			var _access = true;
			if (this.backupScheduleMode === 'create') _access = this.isAccess('backupschedule/create');else _access = this.isAccess('backupschedule/update');

			if (!_access) {
				this.localErrorMessage = 'main/access_denied';
				this.hideBackupScheduleModal();
				return;
			}

			var _rows = this.backupScheduleForm['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				this.localErrorMessage = 'error/app_internal';
				this.hideBackupScheduleModal();
				return;
			}

			var _data = this.collectFormData(_rows, this.localScheduleValidation);

			if (_data === false) return;

			this.hideBackupScheduleModal();

			var _url = '/backupschedule/' + this.backupScheduleMode + '/' + this.backupScheduleId;
			this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) return { csrf: _dt['_csrf'], model: _dt['model'] };

				throw new Error(_dt);
			}).then(function (getDate) {
				_data = _this54.FormDataRePack(_data);

				var _post = {
					'_csrf': getDate.csrf
				};
				_post[getDate.model] = _data;

				_this54.FD = new FormData();
				_this54.FD_count = 0;
				_this54.FD_prepare(_post);

				_this54.$http.post(_this54.APIServerUrl + _url, _this54.FD_count > 0 ? _this54.FD : null).then(function (resPost) {
					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok') {
						_this54.setLocalSuccessMessage(_this54.backupScheduleMode === 'create' ? 'schedule/created' : 'schedule/updated');

						_this54.requestListData();

						return;
					}

					_this54.localErrorMessage = _this54.formatRequestError(resPost);
				}, function (resPost) {
					_this54.localErrorMessage = _this54.formatRequestError(resPost);
				});
			}).catch(function (error) {
				_this54.localErrorMessage = _this54.formatRequestError(error);
			});
		},
		hideRestoreBackupOuterDiskDialog: function hideRestoreBackupOuterDiskDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRestoreBackupOuterDiskDialog = false;
			this.hideModalMask();
		},
		restoreBackupOuterDisk: function restoreBackupOuterDisk(data) {
			var _this55 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var _id, _url, resGet, _dt;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this55.restoreBackupOuterDiskData = null;
								_this55.restoreBackupOuterDiskWarning = '';
								_this55.restoreBackupOuterDiskNotice = '';

								if (data) {
									_context6.next = 5;
									break;
								}

								return _context6.abrupt('return');

							case 5:
								if (_this55.isAccess('service/create')) {
									_context6.next = 7;
									break;
								}

								return _context6.abrupt('return');

							case 7:
								_id = data[_this55.listConfig['column_id']];

								if (_id) {
									_context6.next = 10;
									break;
								}

								return _context6.abrupt('return');

							case 10:
								if (!(data['service_status'] !== 'active' || data['service_status_text'])) {
									_context6.next = 12;
									break;
								}

								return _context6.abrupt('return');

							case 12:
								_url = _this55.APIServerUrl + '/service/update/' + _id + '?search=backup';
								resGet = null;
								_context6.prev = 14;
								_context6.next = 17;
								return _this55.$http.get(_url);

							case 17:
								resGet = _context6.sent;
								_context6.next = 24;
								break;

							case 20:
								_context6.prev = 20;
								_context6.t0 = _context6['catch'](14);

								_this55.localErrorMessage = _this55.formatRequestError(_context6.t0);
								return _context6.abrupt('return');

							case 24:
								_dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

								if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length) {
									_this55.$set(_this55.restoreBackupOuterDiskField, 'list', _dt['result'].map(function (el) {
										return {
											id: el.id,
											name: el.name,
											active: el.active,
											enable: el.enable
										};
									}));

									_dt['result'].some(function (el) {
										if (el && el['id'] && el['active'] === true && el['enable'] === true) {
											var _newValue = {
												id: el['id'],
												name: el['name'],
												active: true,
												enable: true
											};

											_this55.$set(_this55.restoreBackupOuterDiskField, 'listValue', _newValue);
											_this55.$set(_this55, 'restoreBackupOuterDiskValue', el['id']);
											_this55.restoreBackupOuterDiskWarning = _this55.localeFtc('service/extdisk_restore_warning');

											_this55.$nextTick(function () {
												__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
													name: 'backup_id_for_outer_disk',
													value: _newValue
												});
											});
											return true;
										}
									});
								}

								_this55.restoreBackupOuterDiskData = data;

								if (data && data.service_data && data.service_data.extdisk && data.service_data.extdisk.attached === true) {
									if (_this55.restoreBackupOuterDiskWarning) _this55.restoreBackupOuterDiskWarning += '<br><br>' + _this55.localeFtc('service/reboot_warning');else _this55.restoreBackupOuterDiskWarning = _this55.localeFtc('service/reboot_warning');
								}

								__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this55.showRestoreBackupOuterDiskDialog = true;

							case 30:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this55, [[14, 20]]);
			}))();
		},
		restoreBackupOuterDiskStart: function restoreBackupOuterDiskStart() {
			var _this56 = this;

			if (!this.restoreBackupOuterDiskData || !this.restoreBackupOuterDiskData.service_id) return;
			if (!this.isAccess('service/update')) return;

			if (!this.restoreBackupOuterDiskValue) {
				this.restoreBackupOuterDiskField._errMsg = 'error/required_field';
				return;
			}

			var _isSmall = false;
			this.restoreBackupOuterDiskField.list.some(function (item) {
				if (String(item.id) === String(_this56.restoreBackupOuterDiskValue)) {
					if (!item.active || !item.enable) {
						_isSmall = true;
					}

					return true;
				}
			});

			if (_isSmall) return;

			this.hideRestoreBackupOuterDiskDialog();

			this.localErrorMessage = '';

			var _url = this.APIServerUrl + '/service/update/' + this.restoreBackupOuterDiskData.service_id + '?additional=setRestore&service_id=' + this.restoreBackupOuterDiskValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['status']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this56.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this56.setLocalSuccessMessage('service/restore_queued');

							_this56.requestListData();

							return;
						}

						_this56.localErrorMessage = _this56.formatRequestError(resPost);
					}, function (resPost) {
						_this56.localErrorMessage = _this56.formatRequestError(resPost);
					});

					return;
				}

				_this56.localErrorMessage = _this56.formatRequestError(resGet);
			}, function (resGet) {
				_this56.localErrorMessage = _this56.formatRequestError(resGet);
			});
		},
		restoreBackupOuterDiskFieldChanged: function restoreBackupOuterDiskFieldChanged(value) {
			var _this57 = this;

			if (!value || !this.restoreBackupOuterDiskField.list || !this.restoreBackupOuterDiskField.list.length) return;

			this.restoreBackupOuterDiskField.list.some(function (item) {
				if (String(item.id) === String(value)) {
					_this57.restoreBackupOuterDiskWarning = _this57.localeFtc('service/extdisk_restore_warning');

					if (!item.active || !item.enable) {
						_this57.restoreBackupOuterDiskWarning = _this57.localeFtc('service/backup_error');
						return true;
					}

					var data = _this57.restoreBackupOuterDiskData;

					if (data && data.service_data && data.service_data.extdisk && data.service_data.extdisk.attached === true) {
						if (_this57.restoreBackupOuterDiskWarning) _this57.restoreBackupOuterDiskWarning += '<br><br>' + _this57.localeFtc('service/reboot_warning');else _this57.restoreBackupOuterDiskWarning = _this57.localeFtc('service/reboot_warning');
					}

					return true;
				}
			});
		},
		hideRenameBackupDialog: function hideRenameBackupDialog() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRenameBackupDialog = false;
			this.hideModalMask();
		},
		renameBackupKeyDown: function renameBackupKeyDown(e) {
			if (e) e.preventDefault();
			this.renameBackupStart();
		},
		renameBackup: function renameBackup(data) {
			if (!data) return;

			var _id = data[this.listConfig['column_id']];
			if (!_id) return;

			if (data['service_status'] !== 'active' || data['service_status_text']) return;

			this.renameBackupId = _id;
			this.renameBackupValue = data['service_name'];

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRenameBackupDialog = true;
		},
		renameBackupStart: function renameBackupStart() {
			var _this58 = this;

			if (!this.renameBackupId) return;
			if (!this.isAccess('service/update')) return;

			if (!this.renameBackupValue) {
				this.renameBackupField._errMsg = 'error/required_field';
				return;
			}

			this.hideRenameBackupDialog();

			this.localErrorMessage = '';

			var _url = this.APIServerUrl + '/service/update/' + this.renameBackupId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'name': _this58.renameBackupValue
					};

					_this58.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this58.setLocalSuccessMessage('forget/success');

							_this58.requestListData(true);

							return;
						}

						_this58.localErrorMessage = _this58.formatRequestError(resPost);
					}, function (resPost) {
						_this58.localErrorMessage = _this58.formatRequestError(resPost);
					});

					return;
				}

				_this58.localErrorMessage = _this58.formatRequestError(resGet);
			}, function (resGet) {
				_this58.localErrorMessage = _this58.formatRequestError(resGet);
			});
		},
		createFromBackup: function createFromBackup(data) {
			if (!window || !window.sessionStorage || !data || !data.service_id) return;

			var _store = {
				service_id: data.service_id
			};
			if (data.account_id) _store.account_id = data.account_id;

			window.sessionStorage.setItem('create-vds-from-backup', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_store));

			this.$router.push('/vds/create');
		},
		createFromBackupOuterDisk: function createFromBackupOuterDisk(data) {
			if (!window || !window.sessionStorage || !data || !data.service_id) return;

			var _store = {
				service_id: data.service_id
			};
			if (data.account_id) _store.account_id = data.account_id;

			window.sessionStorage.setItem('create-outer-disk-from-backup', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_store));

			this.$router.push('/disks/create');
		},
		accountReport: function accountReport(data) {
			if (!data || !data.account_id || !data.w) return;
			if (!this.isAccess('account/report')) return;

			this.localErrorMessage = '';

			var _url = this.APIServerUrl + '/account/report/' + data.account_id;

			data.w.location.href = _url;
			data.w.focus();
		},
		clientTicket: function clientTicket(data) {
			if (!window || !window.sessionStorage) return;

			var _acc = null;
			if (data && data.account_id) _acc = data.account_id;else {
				if (this.accountGlobalFilter && this.accountGlobalFilter.text) {
					var _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '');
					var _num = parseInt(_numStr);
					if (!isNaN(_num)) _acc = _num;
				}
			}

			if (!_acc) return;

			var _store = {
				account_id: _acc
			};

			window.sessionStorage.setItem('create-ticket-for-account', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_store));

			this.$router.push('/ticket/create');
		},
		removeFilter: function removeFilter(row) {
			if (this.removeFilterProcess) return;

			if (!row || !row['service_id']) return;

			if (row['service_status'] !== 'active' || row['service_status_text']) return;

			if (!this.isAccess('service/update')) return;

			var _serviceID = parseInt(row['service_id']);
			if (isNaN(_serviceID) || _serviceID <= 0) return;
			this.removeFilterID = _serviceID;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRemoveFilterModal = true;
		},
		removeFilterProcessStart: function removeFilterProcessStart(data) {
			var _this59 = this;

			if (this.removeFilterProcess) return;

			if (!this.removeFilterID) return;

			if (!this.removeFilterValue) return;

			if (!this.isAccess('service/update')) return;

			this.hideRemoveFilterModal();

			this.removeFilterProcess = true;

			var _url = this.APIServerUrl + '/service/update/' + this.removeFilterID + '?additional=setRemoveFilter&filter=' + this.removeFilterValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this59.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this59.removeFilterProcess = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							return;
						}

						_this59.localErrorMessage = _this59.formatRequestError(resPost);
					}, function (resPost) {
						_this59.removeFilterProcess = false;

						_this59.localErrorMessage = _this59.formatRequestError(resPost);
					});

					return;
				}

				_this59.removeFilterProcess = false;

				_this59.localErrorMessage = _this59.formatRequestError(resGet);
			}, function (resGet) {
				_this59.removeFilterProcess = false;

				_this59.localErrorMessage = _this59.formatRequestError(resGet);
			});
		},
		redirectUrl: function redirectUrl(row, url, idField) {
			if (!row || !url) return;
			var _url = url;
			if (idField && row[idField]) _url += '/' + String(row[idField]);

			if (!this.isAccess(url)) return;

			this.$router.push(_url);
		},
		showRackGraphic: function showRackGraphic(row) {
			if (!row || !row.rack_id) return;

			this.rackGraphicModalData = row;
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRackGraphicModal = true;
		},
		hideRackGraphicModal: function hideRackGraphicModal() {
			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRackGraphicModal = false;
			this.hideModalMask();
		},
		vdsCloneFindProcessById: function vdsCloneFindProcessById(id) {
			if (!this.vdsCloneProcessData || !this.vdsCloneProcessData.length) {
				return null;
			}

			var _answer = null;
			this.vdsCloneProcessData.some(function (p, i) {
				if (p && String(p.id) === String(id)) {
					_answer = {
						data: p,
						index: i
					};
					return true;
				}
			});

			return _answer;
		},
		deleteVdsCloneProcess: function deleteVdsCloneProcess(id) {
			var _result = this.vdsCloneFindProcessById(id);
			if (!_result || !_result.data) return;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-cron-task-start', {
				id: id,
				task: 'remove-task'
			});

			var _idx = _result.index;
			var _key = 'vds_clone_process_' + id;

			this.vdsCloneProcessData.splice(_idx, 1);

			window.localStorage.removeItem(_key);

			this.hideVdsCloneProcessInfoModal();
			this.vdsCloneShowProcessDataInfo = null;
		},
		vdsCloneShowProcessData: function vdsCloneShowProcessData(id) {
			var _result = this.vdsCloneFindProcessById(id);
			if (!_result || !_result.data) return;
			this.vdsCloneShowProcessDataInfo = _result.data;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.vdsCloneShowProcessDataValue = true;
		},
		vdsCloneProcessDataSave: function vdsCloneProcessDataSave(data) {
			if (!data || !data.id) return;

			if (window.localStorage) {
				var _key = 'vds_clone_process_' + data.id;

				try {
					var _str = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data);

					window.localStorage.setItem(_key, _str);
				} catch (_err) {}
			}

			var _find = -1;
			if (this.vdsCloneProcessData && this.vdsCloneProcessData.length) {
				this.vdsCloneProcessData.some(function (p, i) {
					if (p && p.id === data.id) {
						_find = i;
						return true;
					}
				});
			}

			if (_find < 0) {
				this.vdsCloneProcessData.push(data);
			} else {
				this.$set(this.vdsCloneProcessData, _find, data);
			}
		},
		vdsCloneProcessDataGet: function vdsCloneProcessDataGet() {
			var _this60 = this;

			this.vdsCloneProcessData = [];

			var _keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(window.localStorage);
			for (var i = 0; i < _keys.length; i++) {
				var _key = _keys[i];

				if (!_key || !_key.length || _key.indexOf('vds_clone_process_') !== 0) {
					continue;
				}

				try {
					(function () {
						var _str = window.localStorage.getItem(_key);
						var _obj = JSON.parse(_str);
						if (_obj && _obj.id) {
							var _found = false;
							if (_this60.vdsCloneProcessData && _this60.vdsCloneProcessData.length) {
								_this60.vdsCloneProcessData.some(function (p) {
									if (p && String(p.id) === String(_obj.id)) {
										_found = true;
										return true;
									}
								});
							}

							if (!_found) {
								_this60.vdsCloneProcessData.push(_obj);

								if (!_obj.error && !_obj.finish) {
									__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-cron-task-start', _obj);
								}
							}
						}
					})();
				} catch (e) {}
			}
		},
		vdsClone: function vdsClone(row) {
			var _this61 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var _serviceID, _process, _plandId, _planParams, _planGroupId, _accountID, _acc, _rez, _data, _limitVds, _limitBck, _valueVds, _valueBck, _l, _v, _l2, _v3, _datacenterId;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								if (!(!row || !row['service_id'])) {
									_context7.next = 2;
									break;
								}

								return _context7.abrupt('return');

							case 2:
								if (!(row['service_status'] !== 'active' || row['service_status_text'] || !row['service_name'])) {
									_context7.next = 4;
									break;
								}

								return _context7.abrupt('return');

							case 4:
								if (!(row['service_data'] && row['service_data']['plan'])) {
									_context7.next = 9;
									break;
								}

								if (!(String(row['service_data']['plan']['status']) !== 'active')) {
									_context7.next = 7;
									break;
								}

								return _context7.abrupt('return');

							case 7:
								if (!(String(row['service_data']['plan']['name']).toLowerCase().indexOf('архивный') > -1)) {
									_context7.next = 9;
									break;
								}

								return _context7.abrupt('return');

							case 9:
								if (_this61.isAccess('service/copy')) {
									_context7.next = 11;
									break;
								}

								return _context7.abrupt('return');

							case 11:
								_serviceID = parseInt(row['service_id']);

								if (!(isNaN(_serviceID) || _serviceID <= 0)) {
									_context7.next = 14;
									break;
								}

								return _context7.abrupt('return');

							case 14:
								_this61.vdsCloneID = _serviceID;
								_this61.vdsCloneName = row['service_name'];

								_process = _this61.vdsCloneFindProcessById(_serviceID);

								if (!(_process && _process.data)) {
									_context7.next = 20;
									break;
								}

								_this61.localErrorMessage = 'service/already_queued';
								return _context7.abrupt('return');

							case 20:
								if (!(row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['plan_status'] === 'deleted')) {
									_context7.next = 23;
									break;
								}

								_this61.localErrorMessage = 'plan/archive_title';
								return _context7.abrupt('return');

							case 23:
								_plandId = null;

								if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['id']) {
									_plandId = row['service_data']['plan']['id'];
								}

								_planParams = null;

								if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['data'] && row['service_data']['plan']['data']['cpu'] && row['service_data']['plan']['data']['ram'] && row['service_data']['plan']['data']['disk']) {
									_planParams = {
										cpu: 'total' in row['service_data']['plan']['data']['cpu'] ? row['service_data']['plan']['data']['cpu']['total'] : row['service_data']['plan']['data']['cpu']['value'],

										ram: 'total' in row['service_data']['plan']['data']['ram'] ? row['service_data']['plan']['data']['ram']['total'] : row['service_data']['plan']['data']['ram']['value'],

										disk: 'total' in row['service_data']['plan']['data']['disk'] ? row['service_data']['plan']['data']['disk']['total'] : row['service_data']['plan']['data']['disk']['value'],

										ip4: 0
									};
								}

								if (_planParams && row['service_data'] && row['service_data']['ip'] && row['service_data']['ip']['type'] === '4') {
									_planParams['ip4'] = 1;
								}

								_planGroupId = null;

								if (row['service_data'] && row['service_data']['plangroup'] && row['service_data']['plangroup']['id']) {
									_planGroupId = row['service_data']['plangroup']['id'];
								}

								_accountID = null;

								if (row['account_id']) {
									_accountID = row['account_id'];
								}

								if (!(_accountID || _this61.$store.state.user_account)) {
									_context7.next = 56;
									break;
								}

								_acc = String(_accountID || _this61.$store.state.user_account).replace(/[a-z]/ig, '');
								_context7.next = 36;
								return _this61.$http.get(_this61.APIServerUrl + ('/account/view' + (_this61.$store.state.user_type === 'client' ? '' : '/' + _acc)));

							case 36:
								_rez = _context7.sent;

								if (!(_acc && _rez && _rez.data && _rez.data.limits && _rez.data.limits.servicetype)) {
									_context7.next = 56;
									break;
								}

								_accountID = _acc;
								_data = _rez.data.limits.servicetype;
								_limitVds = _data['limit_max_count[' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS + ']'];
								_limitBck = _data['limit_max_count[' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS + ']'];
								_valueVds = _data['ordered[' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS + ']'];
								_valueBck = _data['ordered[' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS + ']'];

								if (!(_limitVds && 'value' in _limitVds && _valueVds && 'value' in _valueVds)) {
									_context7.next = 50;
									break;
								}

								_l = parseInt(_limitVds.value, 10);
								_v = parseInt(_valueVds.value, 10);

								if (!(!isNaN(_v) && !isNaN(_l) && _v >= _l)) {
									_context7.next = 50;
									break;
								}

								_this61.localErrorMessage = _this61.localeFtc('service/limit_is_exceeded').replace('{service}', 'server/title');
								return _context7.abrupt('return');

							case 50:
								if (!(_limitBck && 'value' in _limitBck && _valueBck && 'value' in _valueBck)) {
									_context7.next = 56;
									break;
								}

								_l2 = parseInt(_limitBck.value, 10);
								_v3 = parseInt(_valueBck.value, 10);

								if (!(!isNaN(_v3) && !isNaN(_l2) && _v3 >= _l2)) {
									_context7.next = 56;
									break;
								}

								_this61.localErrorMessage = _this61.localeFtc('service/limit_is_exceeded').replace('{service}', 'service/backups');
								return _context7.abrupt('return');

							case 56:
								_datacenterId = null;

								if (row['service_data'] && row['service_data']['datacenter'] && row['service_data']['datacenter']['id']) {
									_datacenterId = row['service_data']['datacenter']['id'];
								}

								if (!(!_plandId || !_planGroupId || !_datacenterId || !_accountID)) {
									_context7.next = 60;
									break;
								}

								return _context7.abrupt('return');

							case 60:
								_this61.localErrorMessage = '';

								_this61.$set(_this61.vdsCloneModalFieldList, '__oldAccValue', _accountID);
								_this61.$set(_this61.vdsCloneModalFieldList, '__oldDcValue', _datacenterId);
								_this61.$set(_this61.vdsCloneModalFieldList, '__oldPlgrpValue', _planGroupId);
								_this61.$set(_this61.vdsCloneModalFieldList, '__oldPlValue', _plandId);
								_this61.$set(_this61.vdsCloneModalFieldList, '__oldPlPrmsValue', _planParams);

								_this61.$http.get(_this61.APIServerUrl + '/service/create?search=plan_datacenter&plan_id=' + _plandId).then(function (resGet) {
									var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

									if (_dt && _dt.result && Array.isArray(_dt.result) && _dt.result.length) {
										var _dcList = _dt.result.filter(function (dc) {
											return dc && dc.active;
										}).map(function (dc) {
											return {
												id: dc.id,
												name: _this61.localeFtc(dc.name),
												country: dc.country
											};
										});

										_this61.$set(_this61.vdsCloneModalFieldList, 'list', _dcList);

										if (!_dcList.length) {
											_this61.localErrorMessage = 'main/vds_clone_no_active_datacenters';
											return;
										}

										_dcList.some(function (dc) {
											if (dc && String(dc.id) === String(_datacenterId)) {
												_this61.$set(_this61.vdsCloneModalFieldList, 'value', _datacenterId);
												_this61.$set(_this61, 'vdsCloneModalFieldListValue', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, dc));
												return true;
											}
										});

										__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
										_this61.showVdsCloneModal = true;

										return;
									}

									_this61.localErrorMessage = _this61.formatRequestError(resGet);
								}).catch(function (res) {
									_this61.localErrorMessage = _this61.formatRequestError(res);
								});

							case 67:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this61);
			}))();
		},
		vdsCloneProcessStep2: function vdsCloneProcessStep2() {
			var _this62 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var _obj, _dcValue, _cronTask, _url, resGet, _dt, _plan;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_this62.localErrorMessage = '';

								_this62.hideVdsCloneModal();

								if (_this62.vdsCloneID) {
									_context8.next = 5;
									break;
								}

								_this62.localErrorMessage = _this62.localeFtc('server/choice');
								return _context8.abrupt('return');

							case 5:
								_obj = {
									id: _this62.vdsCloneID,
									nm: _this62.vdsCloneName,
									hl: _this62.vdsCloneModalFieldBooleanValue,
									dc: _this62.vdsCloneModalFieldList.__oldDcValue,
									plgrp: _this62.vdsCloneModalFieldList.__oldPlgrpValue,
									pl: _this62.vdsCloneModalFieldList.__oldPlValue,
									plPrms: _this62.vdsCloneModalFieldList.__oldPlPrmsValue,
									acc: _this62.vdsCloneModalFieldList.__oldAccValue
								};
								_dcValue = _this62.vdsCloneModalFieldListValue && _this62.vdsCloneModalFieldListValue.id ? _this62.vdsCloneModalFieldListValue.id : _this62.vdsCloneModalFieldListValue;

								if (String(_this62.vdsCloneModalFieldList.__oldDcValue) !== String(_dcValue)) {
									_obj.dcToMove = _dcValue;
								}

								_cronTask = {
									id: _obj.id,
									task: 'clone-vds',
									apiUrl: _this62.APIServerUrl,
									step: 'service/creating_backup',
									status: 'request/type_unblock',
									params: _obj
								};
								_url = _this62.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS;
								resGet = null;
								_context8.prev = 11;
								_context8.next = 14;
								return _this62.$http.get(_url + '?search=plan&plan_group_id=' + _obj.plgrp);

							case 14:
								resGet = _context8.sent;
								_context8.next = 21;
								break;

							case 17:
								_context8.prev = 17;
								_context8.t0 = _context8['catch'](11);

								_this62.localErrorMessage = _this62.formatRequestError(_context8.t0);
								return _context8.abrupt('return');

							case 21:
								_dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

								if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length) {
									_plan = _dt['result'].find(function (item) {
										if (item && String(item.id) === String(_obj.pl)) {
											return true;
										}
									});

									if (_plan && _plan.has_params) {
										_obj.vdsPlanParams = true;
									}
								}

								_this62.vdsCloneProcessDataSave(_cronTask);

								__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-cron-task-start', _cronTask);

							case 25:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this62, [[11, 17]]);
			}))();
		},
		copyToDc: function copyToDc(row) {
			var _this63 = this;

			if (!row || !row['service_id']) return;

			if (row['service_status'] !== 'active' || row['service_status_text']) return;

			if (!this.isAccess('service/copy')) return;

			var _serviceID = parseInt(row['service_id']);
			if (isNaN(_serviceID) || _serviceID <= 0) return;
			this.copyToDcID = _serviceID;

			this.copyToDcForm = null;
			this.copyToDcFields = null;
			this.copyToDcCostInfo = '';
			this.localErrorMessage = '';
			this.copyToDcErrorMessage = '';

			this.$http.get(this.APIServerUrl + '/service/copy/' + this.copyToDcID).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['fields'] && _dt['info']) {
					_this63.copyToDcForm = _dt;

					_this63.copyToDcFields = _this63.parseFormData(_dt);

					if (_this63.copyToDcForm['info']['cost'] > 0) {
						_this63.copyToDcCostInfo = _this63.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>').replace('{cost}', _this63.copyToDcForm['info']['cost']).replace('{period}', _this63.localeFtc(_this63.copyToDcForm['info']['period'])).replace('{size}', _this63.localeFtc(_this63.copyToDcForm['info']['for']));
					}

					__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this63.showCopyToDcModal = true;

					return;
				}

				_this63.localErrorMessage = _this63.formatRequestError(resGet);
			}).catch(function (res) {
				_this63.localErrorMessage = _this63.formatRequestError(res);
			});
		},
		copyToDcProcessStart: function copyToDcProcessStart(data) {
			var _this64 = this;

			this.copyToDcErrorMessage = '';

			if (!this.copyToDcID) return;

			if (!this.copyToDcFields || !this.copyToDcFields.fields || !this.copyToDcFields.fields.length) {
				return;
			}

			if (!this.isAccess('service/copy')) return;

			var _data = this.collectFormData(this.copyToDcFields.fields);
			if (!_data) return;

			_data = this.FD_rePack(_data);

			var _post = {
				'_csrf': this.copyToDcForm['_csrf']
			};
			_post[this.copyToDcForm['model']] = _data;

			this.FD = new FormData();
			this.FD_count = 0;
			this.FD_prepare(_post);

			this.$http.post(this.APIServerUrl + '/service/copy/' + this.copyToDcID, this.FD_count > 0 ? this.FD : null).then(function (resPost) {
				var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['service'] && _dt['service']['service_id']) {
					_this64.hideCopyToDcModal();

					_this64.requestListData();
					return;
				}

				throw _dt;
			}).catch(function (resPost) {
				var msg = 'error/api_incorrect';

				if (resPost && resPost.status === 'error' && resPost.title) msg = resPost.title;

				if (resPost && resPost.status === 'error' && resPost.fields && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.fields) === 'object' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(resPost.fields).length) {
					msg = '';
					for (var prop in resPost.fields) {
						if (resPost.fields.hasOwnProperty(prop)) {
							var _errField = resPost.fields[prop];

							if (_errField) {
								var _txt = '';
								if (Array.isArray(_errField) && _errField.length) _txt = _errField[0];else if ((typeof _errField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_errField)) === 'object') _txt = 'error/unknown';else _txt = String(_errField);

								var _formField = _this64.findFormField(prop, _this64.copyToDcFields.fields);

								if (_formField) {
									_formField['_errMsg'] = _txt;
								} else {
									if (msg) msg += '<br> ' + _txt;else msg = _txt;
								}
							}
						}
					}
				}

				_this64.copyToDcErrorMessage = msg;
			});
		},
		downloadBackup: function downloadBackup(row) {
			this.localErrorMessage = '';

			if (!row || !row['service_id']) return;

			if (row['service_status'] !== 'active' || row['service_status_text']) return;

			if (!this.isAccess('service/update')) return;

			var _serviceID = parseInt(row['service_id']);
			if (isNaN(_serviceID) || _serviceID <= 0) return;
			this.downloadBackupID = _serviceID;

			__WEBPACK_IMPORTED_MODULE_28__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDownloadBackupModal = true;
		},
		downloadBackupProcessStart: function downloadBackupProcessStart() {
			var _this65 = this;

			this.localErrorMessage = '';

			if (!this.downloadBackupID) return;

			if (!this.isAccess('service/update')) return;

			this.hideDownloadBackupModal();

			var _url = this.APIServerUrl + '/service/update/' + this.downloadBackupID + '?additional=setDownload';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this65.$http.post(_url, __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this65.setLocalSuccessMessage('service/download_queued');
							return;
						}

						_this65.localErrorMessage = _this65.formatRequestError(resPost);
					}, function (resPost) {
						_this65.localErrorMessage = _this65.formatRequestError(resPost);
					});

					return;
				}

				_this65.localErrorMessage = _this65.formatRequestError(resGet);
			}, function (resGet) {
				_this65.localErrorMessage = _this65.formatRequestError(resGet);
			});
		},
		isVisibleField: function isVisibleField(row) {
			if (!row || !Array.isArray(row) || !row.length) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden') {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		onEnterKeyDownForm: function onEnterKeyDownForm(func) {
			if (func && func in this && typeof this[func] === 'function') this[func]();
		},
		onChangedField: function onChangedField(field) {},
		onBlurField: function onBlurField(field) {
			this.verifyFormField(field);
		},
		onFocusField: function onFocusField(field) {
			if (field) field['_errMsg'] = '';
		},
		verifyFormField: function verifyFormField(field) {},
		findFormField: function findFormField(name, fields) {
			var _rows = fields;
			if (!_rows || !Array.isArray(_rows)) return null;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		collectFormData: function collectFormData(rows) {
			var data = {};

			for (var idx in rows) {
				if (!rows[idx] || !Array.isArray(rows[idx])) continue;

				var row = rows[idx];

				var _loop3 = function _loop3(k) {
					var field = row[k];

					if (!field['_field_name']) return 'continue';

					if (field['_errMsg'] && field['_visible']) return {
							v: false
						};

					var _val = field['value'];

					if (field['type'] === 'file' || field['type'] === 'image') {
						if (field['_deleteFile'] === true) {
							data[field['_field_name'] + '_delete'] = 1;
						}

						if (field['multifile'] !== true) {
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null;
						}
					}

					if (Array.isArray(field['value'])) {
						if (!field['value'].length) _val = null;else {
							_val = [];

							field['value'].forEach(function (item) {
								if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) === 'object' && item['id']) {
									_val.push(item['id']);
								} else _val.push(item);
							});
						}
					}

					if (field['required'] === true && field['_visible']) {
						if (_val === undefined || _val === null) {
							field['_errMsg'] = 'error/required_field';
							return {
								v: false
							};
						}

						if (Array.isArray(_val) && _val.length === 0) {
							field['_errMsg'] = 'error/required_field';
							return {
								v: false
							};
						}
					}

					if (_val === undefined || _val === null) {
						if (/^\w+\[\w+\]/i.test(field['_field_name'])) data[field['_field_name']] = '';

						return 'continue';
					}

					if (field['type'] === 'boolean') _val = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].normalizeBooleanValue(_val) ? 1 : 0;

					if (field['type'] === 'date' && field['format']) {
						_val = String(_val);
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val)) _val = __WEBPACK_IMPORTED_MODULE_8__helper_helper__["a" /* default */].FormatDateTime(_val, field['format']);
					}

					data[field['_field_name']] = _val;
				};

				for (var k in row) {
					var _ret4 = _loop3(k);

					switch (_ret4) {
						case 'continue':
							continue;

						default:
							if ((typeof _ret4 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_ret4)) === "object") return _ret4.v;
					}
				}
			}

			return data;
		},
		FD_rePack: function FD_rePack(data) {
			var k = void 0;
			var n1 = void 0;
			var n2 = void 0;
			var key1 = void 0;
			var key2 = void 0;

			for (k in data) {
				if (data.hasOwnProperty(k)) {
					n1 = k.indexOf('[');
					if (n1 < 0) continue;

					n2 = k.indexOf(']', n1);
					if (n2 < 0) continue;

					key1 = k.substr(0, n1);
					key2 = k.substring(n1 + 1, n2);

					if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

					if (!data[key1]) data[key1] = {};

					data[key1][key2] = data[k];

					delete data[k];

					data[key1] = this.FD_rePack(data[key1]);
				}
			}return data;
		},
		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		windowScroll: function windowScroll(event) {
			var doc = document.documentElement;
			var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
			this.curWindowY = top;

			if (this.$refs && this.$refs['buttonBalance'] && this.$refs['buttonBalance'][0]) {
				var _coord = this.getElementOffset(this.$refs['buttonBalance'][0]);
				this.balanceContainerStyle = 'left:' + _coord.left + 'px; top:' + (_coord.top + 50 - this.curWindowY) + 'px;';
			}
		},
		windowResize: function windowResize() {
			if (!document || !document.documentElement) return;
			var height = document.documentElement.clientHeight - 200;
			var frame = document.getElementById('documentFrame');
			if (frame && frame.style) frame.style.height = height + 'px';
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestListData();
			}
		},
		cronTaskAnswer: function cronTaskAnswer(data) {
			if (!data || !data.id) return;
			var _result = this.vdsCloneFindProcessById(data.id);
			if (!_result || !_result.data || !_result.data.id) return;

			var _data = _result.data;

			if (data.step) _data.step = data.step;
			if (data.status) _data.status = data.status;
			if (data.error) _data.error = typeof data.error === 'string' ? data.error : this.formatRequestError({ data: data.error });

			if (data.BackupId) _data.BackupId = data.BackupId;
			if (data.CopyBackupId) _data.CopyBackupId = data.CopyBackupId;
			if (data.CreateVdsId) _data.CreateVdsId = data.CreateVdsId;

			this.vdsCloneProcessDataSave(_data);

			if (data.finish) {
				_data.finish = data.finish;
				this.deleteVdsCloneProcess(data.id);
			}
		},
		functionToString: function functionToString(func) {
			var _fn = func.toString();
			return _fn.substring(_fn.indexOf('{') + 1, _fn.lastIndexOf('}'));
		},
		afterRequestListData: function afterRequestListData() {
			if (!this.afterRequestDataCallbacks || !this.afterRequestDataCallbacks.length) {
				return;
			}

			while (this.afterRequestDataCallbacks.length) {
				var callback = this.afterRequestDataCallbacks.pop();
				if (callback && typeof callback === 'function') {
					callback();
				}
			}
		},
		getAllQueryParams: function getAllQueryParams() {
			if (this.crud !== 'ipptrpool' && this.crud !== 'iphistory') {
				return '';
			}

			var str = '';
			if (this.$route.query && this.$route.query.id) {
				str += '?id=' + this.$route.query.id;
			}

			return str;
		}
	},

	components: {
		filterPeriod: __WEBPACK_IMPORTED_MODULE_9__components_widgets_filterPeriod___default.a,
		filterRadio: __WEBPACK_IMPORTED_MODULE_10__components_widgets_filterRadio___default.a,
		filterBool: __WEBPACK_IMPORTED_MODULE_11__components_widgets_filterBool___default.a,
		filterSelect: __WEBPACK_IMPORTED_MODULE_12__components_widgets_filterSelect___default.a,
		filterLogs: __WEBPACK_IMPORTED_MODULE_13__components_widgets_filterLogs___default.a,
		filterLabel: __WEBPACK_IMPORTED_MODULE_14__components_widgets_filterLabel___default.a,
		filterDisk: __WEBPACK_IMPORTED_MODULE_15__components_widgets_filterDisk___default.a,
		filterParams: __WEBPACK_IMPORTED_MODULE_16__components_widgets_filterParams___default.a,
		paginator: __WEBPACK_IMPORTED_MODULE_17__components_widgets_paginator___default.a,
		dropDownButton: __WEBPACK_IMPORTED_MODULE_18__components_elements_btndropdown___default.a,
		oneOperButton: __WEBPACK_IMPORTED_MODULE_19__components_elements_oneoper___default.a,
		Field: __WEBPACK_IMPORTED_MODULE_20__components_elements_formfield___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_21__components_elements_money___default.a,
		backupDialog: __WEBPACK_IMPORTED_MODULE_22__components_elements_backupdialog___default.a,
		calculator: __WEBPACK_IMPORTED_MODULE_23__components_elements_calc___default.a,
		rackGraphic: __WEBPACK_IMPORTED_MODULE_24__components_elements_rack___default.a,
		radioListComponent: __WEBPACK_IMPORTED_MODULE_25__components_elements_radio___default.a,
		viewComponent: __WEBPACK_IMPORTED_MODULE_26__components_elements_view___default.a,
		notice: __WEBPACK_IMPORTED_MODULE_30__components_elements_notice___default.a
	}

});

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterPeriod',

	props: ['valueBegin', 'valueEnd', 'clearButton', 'notClose'],
	data: function data() {
		return {
			clearBtn: true,
			begin: null,
			end: null,
			disabledForBegin: {
				'from': null
			},
			disabledForEnd: {
				'to': null
			},
			highlightRange: {},
			labels: {
				'ru': {
					'today': 'сегодня',
					'yesterday': 'вчера',
					'week': 'неделя',
					'month': 'месяц',
					'year': 'год'
				},
				'en': {
					'today': 'today',
					'yesterday': 'yesterday',
					'week': 'week',
					'month': 'month',
					'year': 'year'
				}
			}
		};
	},

	components: {
		Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
	},
	created: function created() {
		if (this.clearButton !== undefined && this.clearButton !== null) this.clearBtn = this.clearButton;

		if (this.valueBegin) {
			this.begin = this.formater_StrDate2Date(this.valueBegin);
		}

		this.disabledForEnd['to'] = this.begin;

		if (this.valueEnd) {
			this.end = this.formater_StrDate2Date(this.valueEnd);
		}

		this.disabledForBegin['from'] = this.end;

		if (this.begin && this.end) this.highlightRange = {
			'from': this.begin,
			'to': this.end
		};else this.highlightRange = {};
	},

	watch: {
		'valueBegin': function valueBegin(value) {
			this.updateBegin(value);
		},
		'valueEnd': function valueEnd(value) {
			this.updateEnd(value);
		}
	},

	methods: {
		beginSelected: function beginSelected(date) {
			this.begin = date;

			this.disabledForEnd['to'] = this.begin;

			if (this.begin && this.end) this.highlightRange = {
				'from': this.begin,
				'to': this.end
			};else this.highlightRange = {};

			this.$emit('input', {
				'begin': this.begin,
				'end': this.end
			});
		},
		endSelected: function endSelected(date) {
			this.end = date;

			this.disabledForBegin['from'] = this.end;

			if (this.begin && this.end) this.highlightRange = {
				'from': this.begin,
				'to': this.end
			};else this.highlightRange = {};

			this.$emit('input', {
				'begin': this.begin,
				'end': this.end
			});
		},
		updateBegin: function updateBegin(value) {
			if (value) this.begin = this.formater_StrDate2Date(value);else this.begin = null;

			this.disabledForEnd['to'] = this.begin;

			if (this.begin && this.end) this.highlightRange = {
				'from': this.begin,
				'to': this.end
			};else this.highlightRange = {};
		},
		updateEnd: function updateEnd(value) {
			if (value) this.end = this.formater_StrDate2Date(value);else this.end = null;

			this.disabledForBegin['from'] = this.end;

			if (this.begin && this.end) this.highlightRange = {
				'from': this.begin,
				'to': this.end
			};else this.highlightRange = {};
		},
		setPeriod: function setPeriod(whatPeriod) {
			var d = void 0;
			var dd = void 0;

			switch (whatPeriod) {
				case 0:
					d = new Date();
					d.setDate(d.getDate() - 1);

					this.updateBegin(this.formatDate(d));
					this.updateEnd(this.formatDate(d, 'end'));

					this.$emit('input', {
						'begin': this.begin,
						'end': this.end
					});
					break;

				case 1:
					d = new Date();

					this.updateBegin(this.formatDate(d));
					this.updateEnd(this.formatDate(d, 'end'));

					this.$emit('input', {
						'begin': this.begin,
						'end': this.end
					});
					break;

				case 2:
					d = new Date();
					dd = new Date();
					d.setDate(d.getDate() - 30);

					this.updateBegin(this.formatDate(d));
					this.updateEnd(this.formatDate(dd, 'end'));

					this.$emit('input', {
						'begin': this.begin,
						'end': this.end
					});
					break;

				case 3:
					d = new Date();
					dd = new Date();
					d.setDate(d.getDate() - 365);

					this.updateBegin(this.formatDate(d));
					this.updateEnd(this.formatDate(dd, 'end'));

					this.$emit('input', {
						'begin': this.begin,
						'end': this.end
					});
					break;

				case 4:
					d = new Date();
					dd = new Date();
					d.setDate(d.getDate() - 7);

					this.updateBegin(this.formatDate(d));
					this.updateEnd(this.formatDate(dd, 'end'));

					this.$emit('input', {
						'begin': this.begin,
						'end': this.end
					});
					break;
			}
		},
		formatDate: function formatDate(date, what) {
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var day = date.getDate();

			if (what === 'end') return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day + ' 23:59:59';else return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day + ' 00:00:00';
		}
	}

});

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block period-filter"
  }, [_c('span', [_vm._v(_vm._s(_vm.localeFtc('main/from')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "disabled": _vm.disabledForBegin,
      "highlighted": _vm.highlightRange,
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "filter-period-wrapper",
      "input-class": "filter-period-input",
      "monday-first": true,
      "clear-button": _vm.clearBtn,
      "name": "dateBeginField"
    },
    on: {
      "selected": _vm.beginSelected
    },
    model: {
      value: (_vm.begin),
      callback: function($$v) {
        _vm.begin = $$v
      },
      expression: "begin"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.localeFtc('main/to')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "disabled": _vm.disabledForEnd,
      "highlighted": _vm.highlightRange,
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "filter-period-wrapper",
      "input-class": "filter-period-input",
      "monday-first": true,
      "clear-button": _vm.clearBtn,
      "name": "dateEndField"
    },
    on: {
      "selected": _vm.endSelected
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('span', {
    staticClass: "navigation-target",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPeriod(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.$store.state.lang]['today']))]), _vm._v(" "), _c('span', {
    staticClass: "navigation-target",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPeriod(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.$store.state.lang]['yesterday']))]), _vm._v(" "), _c('span', {
    staticClass: "navigation-target",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPeriod(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.$store.state.lang]['week']))]), _vm._v(" "), _c('span', {
    staticClass: "navigation-target",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPeriod(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.$store.state.lang]['month']))]), _vm._v(" "), _c('span', {
    staticClass: "navigation-target",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPeriod(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.$store.state.lang]['year']))])]), _vm._v(" "), (!_vm.notClose) ? _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-6d9cdb2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterRadio',
	props: ['list', 'name', 'value', 'crud'],
	data: function data() {
		return {
			curValue: null,
			curList: false
		};
	},
	created: function created() {
		this.update(this.value);
		this.makeList();
	},

	watch: {
		'value': function value(newValue) {
			this.update(newValue);
		}
	},
	methods: {
		onSelect: function onSelect(id) {
			this.update(id);
			this.$emit('input', this.curValue);
		},
		makeList: function makeList() {
			this.curList = false;

			if (this.list && this.list['list'] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.list['list']) === 'object') {
				if (!Array.isArray(this.list['list'])) {
					this.curList = [];
					for (var key in this.list['list']) {
						var item = this.list['list'][key];
						if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && item.id && item.name) this.curList.push(item);else this.curList.push({ id: key, name: item });
					}
				} else {
					this.curList = this.list['list'].slice();
				}
			}
		},
		update: function update(value) {
			this.curValue = value;
		}
	}
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_vm._l((_vm.curList), function(el, k) {
    return _c('label', {
      key: k,
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.curValue),
        expression: "curValue"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.name
      },
      domProps: {
        "value": el.id,
        "checked": _vm._q(_vm.curValue, el.id)
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(el.id)
        },
        "change": function($event) {
          _vm.curValue = el.id
        }
      }
    }), _vm._v(" " + _vm._s(_vm._f("ftc")(el.name)) + "\n\t")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")])], 2)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterBool',
	props: ['name', 'value', 'titleTrue', 'titleFalse'],
	data: function data() {
		return {
			curValue: null
		};
	},

	computed: {
		valueText: function valueText() {
			return this.curValue ? this.titleTrue : this.titleFalse;
		}
	},
	created: function created() {
		this.curValue = this.value;
	},

	watch: {
		'value': function value(newValue) {
			this.curValue = newValue;
		}
	},
	methods: {
		onClick: function onClick(e) {
			this.curValue = !this.curValue;
			this.$emit('input', this.curValue);
		}
	}
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-link",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.valueText)))])
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_additional_services_filters__ = __webpack_require__(126);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterSelect',

	props: ['name', 'value', 'list', 'needAllValue', 'notClose', 'startVisible', 'multiselect', 'crud'],
	data: function data() {
		return {
			curValue: { id: '-1', name: this.localeFtc('main/list_all') },
			curList: [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}],

			$ulBlock: null
		};
	},
	created: function created() {
		this.initList();
	},
	mounted: function mounted() {
		var _this = this;

		if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove();

		var $component = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);
		if (!$component.length) return;

		this.$ulBlock = $component.find('ul:first').parent();
		if (!this.$ulBlock.length) return;

		var _css = {
			'position': 'absolute',
			'display': 'none',
			'width': 'calc(100% - 24px)',
			'z-index': 99
		};

		var hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight;
		if (!hasEnoughSpace) {
			$component.addClass('multiselect--above');
			_css['margin-bottom'] = '-10px';
		}

		this.$ulBlock.css(_css);

		this.$ulBlock.detach().appendTo($component);

		if (this.multiselect) {
			this.curValue = null;
		}

		if (this.value !== null && this.value !== undefined) {
			if (this.multiselect) {
				if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value) === 'object' && Array.isArray(this.value) && this.value.length) {
					this.curValue = [];
					this.value.forEach(function (item) {
						if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && 'id' in item && 'name' in item) {
							item.name = _this.localeFtc(item.name);
							_this.curValue.push(item);
						} else if (typeof item === 'string' || typeof item === 'number') {
							var _newVal = {
								id: item,
								name: item
							};

							if (_this.list && _this.list['list'] && Array.isArray(_this.list['list'])) {
								_this.list['list'].some(function (nm) {
									if (String(nm['id']) === String(item)) {
										_newVal.name = _this.localeFtc(nm['name']);
										return true;
									}
								});
							}

							_this.curValue.push(_newVal);
						}
					});

					if (this.startVisible) {
						this.$ulBlock.data('start-position', true);
					}
				}
			} else {
				if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value) === 'object' && 'id' in this.value && this.value['id'] && 'name' in this.value && this.value['name']) {
					this.curValue = {
						id: String(this.value['id']),
						name: this.localeFtc(this.value['name'])
					};

					if (this.startVisible) {
						this.$ulBlock.data('start-position', true);
					}
				}
			}
		}
	},

	methods: {
		initList: function initList() {
			var _this2 = this;

			this.curList = [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}];

			if (this.needAllValue === false || this.multiselect) {
				this.curList = [];
			}

			if (this.list && this.list['list']) {
				var list = this.list['list'];
				if (this.crud === 'additional-services' && this.name === 'service_type_id' && Array.isArray(this.list['list'])) {
					list = __WEBPACK_IMPORTED_MODULE_3__helper_additional_services_filters__["a" /* default */].list(this.list['list']);
				}

				if (Array.isArray(this.list['list'])) {
					list.forEach(function (item) {
						_this2.curList.push({
							'id': String(item.id),
							'name': _this2.localeFtc(item.name)
						});
					});
				} else {
						if ('-1' in this.list['list']) {
							this.curList = [{
								'id': '-1',
								'name': this.localeFtc('main/list_all')
							}];
						}

						for (var _id in this.list['list']) {
							if (String(_id) === '-1') continue;

							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(this.list['list'][_id])
							});
						}
					}
			}
		},
		OnSelect: function OnSelect(e) {
			if (this.multiselect) {} else {
				this.curValue = {
					id: String(e.id),
					name: this.localeFtc(e.name)
				};
			}

			this.$emit('input', this.curValue);
		},
		OnOpen: function OnOpen() {
			var _this3 = this;

			if (!this.$ulBlock.data('start-position')) return;
			this.$ulBlock.data('start-position', false);

			this.$nextTick(function () {
				setTimeout(function () {
					var sp = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('span.multiselect__option--selected:first');
					if (!sp.length) return;

					var li = sp.parent();
					if (!li.length) return;

					var h = li.height();
					var top = li.position().top - h;

					if (top < 0) top = 0;else {
						if (top - h >= 0) top -= h;
						if (top - h >= 0) top -= h;
						if (top - h >= 0) top -= h;
					}
					_this3.$ulBlock.scrollTop(top);
				}, 100);
			});
		}
	},

	watch: {
		'value': function value(newValue) {
			if (this.multiselect) {
				if (newValue === null || newValue === undefined) {
					this.curValue = null;
				} else if (newValue && Array.isArray(newValue)) {
					if (newValue.some(function (el) {
						return el && String(el.id) === '-1';
					})) {
						this.curValue = null;
					} else {
						this.curValue = newValue;
					}
				}
			} else {
				this.curValue = { id: String(newValue['id']), name: this.localeFtc(newValue['name']) };
			}
		},
		'list': function list() {
			this.initList();
		}
	},

	components: { Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a }

});

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block",
    class: {
      'not-close': _vm.notClose, 'mult': _vm.multiselect === true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.curList && _vm.curList.length > 15,
      "multiple": _vm.multiselect === true,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "open": _vm.OnOpen,
      "input": _vm.OnSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm.name === 'server_view_type' && props.option.id) ? _c('span', {
          class: 'color-type-' + String(props.option.id),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(props.option.name) + "\n\t\t")]
      }
    }]),
    model: {
      value: (_vm.curValue),
      callback: function($$v) {
        _vm.curValue = $$v
      },
      expression: "curValue"
    }
  }), _vm._v(" "), (!_vm.notClose) ? _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(483)
__webpack_require__(484)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-02895fd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterLogs',

	props: ['name', 'value', 'list'],
	data: function data() {
		return {
			category: { id: 'all', name: this.localeFtc('main/list_all') },
			categoryList: [{
				'id': 'all',
				'name': this.localeFtc('main/list_all')
			}],
			valueList: {
				'all': []
			},
			curValue: null,

			$ulBlock1: null,
			$ulBlock2: null
		};
	},
	created: function created() {
		var _cat = false;

		if (this.list && this.list['list'] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.list['list']) === 'object' && !Array.isArray(this.list['list'])) {
			for (var _id in this.list['list']) {
				_cat = _id.split('/')[0];
				if (!this.valueList[_cat]) {
					this.categoryList.push({
						'id': _cat,
						'name': __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].localeFtc(_cat + '/title')
					});

					this.valueList[_cat] = [];
					this.valueList[_cat].push({
						'id': _id,
						'name': this.localeFtc(this.list['list'][_id])
					});
				} else {
					this.valueList[_cat].push({
						'id': _id,
						'name': this.localeFtc(this.list['list'][_id])
					});
				}
			}
		}

		if (this.value) {
			this.curValue = {
				'id': this.value,
				'name': this.localeFtc(this.list['list'][this.value])
			};

			_cat = this.value.split('/')[0];
			if (_cat !== null && _cat !== undefined && _cat !== '') {
				this.category = { id: _cat, name: __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].localeFtc(_cat + '/title') };
			}
		}
	},
	mounted: function mounted() {
		if (this.$ulBlock1 && this.$ulBlock1.length) this.$ulBlock1.remove();
		if (this.$ulBlock2 && this.$ulBlock2.length) this.$ulBlock2.remove();

		var $component = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);
		if (!$component.length) return;

		this.$ulBlock1 = $component.find('ul:first').parent();
		this.$ulBlock2 = $component.find('ul:last').parent();

		var _css = {
			'position': 'absolute',
			'top': '40px',
			'display': 'none',
			'width': 'calc(100% - 26px)',
			'z-index': 99
		};

		if (this.$ulBlock1.length) {
			this.$ulBlock1.css(_css);

			this.$ulBlock1.detach().appendTo($component);
		}

		if (this.$ulBlock2.length) {
			this.$ulBlock2.css(_css);

			this.$ulBlock2.detach().appendTo($component);
		}
	},

	watch: {
		'value': function value(newValue) {
			var _this = this;

			if (!newValue) {
				this.$nextTick(function () {
					_this.category = { id: 'all', name: _this.localeFtc('main/list_all') };

					_this.curValue = null;
				});

				return;
			}

			this.curValue = { id: newValue, name: this.localeFtc(this.list['list'][newValue]) };

			var _cat = newValue.split('/')[0];
			if (_cat !== null && _cat !== undefined && _cat !== '') {
				this.category = { id: _cat, name: __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].localeFtc(_cat + '/title') };
			}
		}
	},

	methods: {
		OnSelectCategory: function OnSelectCategory(e) {
			this.category = { id: e.id, name: e.name };

			this.curValue = null;
			if (e.id !== 'all') {
				this.curValue = { id: this.valueList[e.id][0]['id'], name: this.localeFtc(this.valueList[e.id][0]['name']) };
			}

			this.$emit('input', this.curValue ? this.curValue['id'] : false);
		},
		OnSelectValue: function OnSelectValue(e) {
			this.curValue = { id: e.id, name: e.name };

			this.$emit('input', e.id);
		}
	},

	components: { Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a }

});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block widget-block-logs"
  }, [_c('div', {
    staticClass: "category"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categoryList,
      "showLabels": false,
      "allowEmpty": false,
      "maxHeight": 200,
      "searchable": false,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "input": _vm.OnSelectCategory
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1), _vm._v(" "), (_vm.valueList[_vm.category['id']]) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category['id'] !== 'all'),
      expression: "category['id'] !== 'all'"
    }],
    staticClass: "value"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.valueList[_vm.category['id']],
      "showLabels": false,
      "allowEmpty": false,
      "maxHeight": 200,
      "searchable": false,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "input": _vm.OnSelectValue
    },
    model: {
      value: (_vm.curValue),
      callback: function($$v) {
        _vm.curValue = $$v
      },
      expression: "curValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)
__webpack_require__(489)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  "data-v-f98fbcba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterLabel',

	props: ['name', 'value', 'items'],
	data: function data() {
		return {
			curValue: null,

			showChoice: false
		};
	},
	created: function created() {
		this.curValue = this.value;
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	watch: {
		'value': function value(newValue) {
			this.curValue = newValue;
		}
	},

	methods: {
		onClick: function onClick(e, value) {
			this.hideChoiceBlock();

			this.curValue = value === undefined || value === null || value === '' || value === false ? null : value;

			this.$emit('input', this.curValue);
		},
		clearFilter: function clearFilter() {
			this.hideChoiceBlock();

			this.curValue = null;

			this.$emit('input', this.curValue);
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.hideChoiceBlock();
			}
		},
		toggleChoiceBlock: function toggleChoiceBlock() {
			this.showChoice = !this.showChoice;
		},
		hideChoiceBlock: function hideChoiceBlock() {
			this.showChoice = false;
		}
	}

});

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_c('div', {
    staticClass: "widget-filter-ticket-label-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleChoiceBlock($event)
      }
    }
  }, [(_vm.curValue === undefined || _vm.curValue === null || _vm.curValue === '' || _vm.curValue === false) ? [_vm._v(_vm._s(_vm._f("ftc")('main/list_all')))] : _c('div', {
    staticClass: "w5-list-ticket-label",
    class: 'ticket-label-color-' + String(_vm.curValue).toLowerCase(),
    style: ('margin-top: 5px; margin-left: 1px; background-color: ' + String(_vm.curValue).toLowerCase())
  })], 2)]), _vm._v(" "), (_vm.items && typeof _vm.items === 'object' && Object.keys(_vm.items).length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoice === true),
      expression: "showChoice === true"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideChoiceBlock),
      expression: "hideChoiceBlock"
    }],
    staticClass: "widget-filter-ticket-label-choice",
    staticStyle: {
      "top": "4px",
      "left": "10px"
    }
  }, [_vm._l((_vm.items), function(val, idx) {
    return (String(val) !== '') ? _c('div', {
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      style: ('background-color: ' + String(val).toLowerCase()),
      on: {
        "click": function($event) {
          return _vm.onClick($event, val)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.curValue !== undefined && _vm.curValue !== null && _vm.curValue !== '' && _vm.curValue !== false) ? _c('span', {
    staticClass: "ticket-label-all",
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_all')))]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-cbb7fe84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterDisk',

	props: ['value', 'items'],
	data: function data() {
		return {
			curValue: { id: '-1', name: this.localeFtc('main/list_all') },
			curList: [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}],
			validTypes: ['16', '17'],

			$ulBlock: null
		};
	},
	created: function created() {
		this.initList();
	},
	mounted: function mounted() {
		if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove();

		var $component = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);
		if (!$component.length) return;

		this.$ulBlock = $component.find('ul:first').parent();
		if (!this.$ulBlock.length) return;

		var _css = {
			'position': 'absolute',
			'display': 'none',
			'width': 'calc(100% - 24px)',
			'z-index': 99
		};

		var hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight;
		if (!hasEnoughSpace) {
			$component.addClass('multiselect--above');
			_css['margin-bottom'] = '-10px';
		}

		this.$ulBlock.css(_css);

		this.$ulBlock.detach().appendTo($component);

		this.setValue(this.value);
	},

	methods: {
		setValue: function setValue(value) {
			var _this = this;

			this.curValue = { id: '-1', name: this.localeFtc('main/list_all') };

			if (value) {
				if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && 'id' in value) {
					this.curValue = { id: String(value.id), name: '' };
				} else if (typeof value === 'string') {
					this.curValue = { id: value, name: '' };
				}

				if (this.curValue.id !== '-1') {
					if (this.items && this.items.length) {
						this.items.some(function (v) {
							if (v && String(v.id) === _this.curValue.id) {
								_this.curValue.name = _this.localeFtc(v.name);
								return true;
							}
						});
					}
				}
			}
		},
		initList: function initList() {
			var _this2 = this;

			this.curList = [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}];

			if (this.items) {
				if (Array.isArray(this.items)) {
					this.items.forEach(function (item) {
						if (item && item.id && _this2.validTypes.indexOf(String(item.id)) > -1) {
							_this2.curList.push({
								'id': String(item.id),
								'name': _this2.localeFtc(item.name)
							});
						}
					});
				} else {
					for (var _id in this.items) {
						if (_id && this.validTypes.indexOf(String(_id)) > -1) {
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(this.items[_id])
							});
						}
					}
				}
			}
		},
		OnSelect: function OnSelect(e) {
			this.curValue = {
				id: String(e.id),
				name: this.localeFtc(e.name)
			};
			this.$emit('input', this.curValue.id);
		},
		OnOpen: function OnOpen() {
			var _this3 = this;

			if (!this.$ulBlock.data('start-position')) return;
			this.$ulBlock.data('start-position', false);

			this.$nextTick(function () {
				setTimeout(function () {
					var sp = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('span.multiselect__option--selected:first');
					if (!sp.length) return;

					var li = sp.parent();
					if (!li.length) return;

					var h = li.height();
					var top = li.position().top - h;

					if (top < 0) top = 0;else {
						if (top - h >= 0) top -= h;
						if (top - h >= 0) top -= h;
						if (top - h >= 0) top -= h;
					}
					_this3.$ulBlock.scrollTop(top);
				}, 100);
			});
		},
		closeFilter: function closeFilter() {
			this.$emit('closeFilter');
		}
	},

	watch: {
		'value': function value(newValue) {
			this.setValue(newValue);
		},
		'items': function items() {
			this.initList();
		}
	},

	components: { Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a }

});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": false,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "open": _vm.OnOpen,
      "input": _vm.OnSelect
    },
    model: {
      value: (_vm.curValue),
      callback: function($$v) {
        _vm.curValue = $$v
      },
      expression: "curValue"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeFilter($event)
      }
    }
  }, [_vm._v("×")])], 1)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  "data-v-64cc31e7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_number__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterParams',

	props: ['name', 'value', 'params', 'visible'],

	computed: {
		isCpuEmpty: function isCpuEmpty() {
			return this.valueCpu[0] === null || this.valueCpu[1] === null;
		},
		isRamEmpty: function isRamEmpty() {
			return this.valueRam[0] === null || this.valueRam[1] === null;
		},
		isDiskEmpty: function isDiskEmpty() {
			return this.valueDisk[0] === null || this.valueDisk[1] === null;
		},
		showFilter: function showFilter() {
			if (this.showChoicer) {
				return !this.isCpuEmpty && !this.isRamEmpty && !this.isDiskEmpty;
			} else {
				return !this.isCpuEmpty && !this.isRamEmpty && !this.isDiskEmpty;
			}
		}
	},
	data: function data() {
		return {
			valueCpu: [null, null],
			valueRam: [null, null],
			valueDisk: [null, null],

			choicerTitle: '',

			sliderValueCpu: [null, null],
			sliderValueRam: [null, null],
			sliderValueDisk: [null, null],

			showChoicer: false
		};
	},
	created: function created() {
		this.valueCpu = [this.value.cpu_min, this.value.cpu_max];
		this.valueRam = [this.value.ram_min, this.value.ram_max];
		this.valueDisk = [this.value.disk_min, this.value.disk_max];
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickDocumentHandler);

		this.initField('cpu', 0);
		this.initField('cpu', 1);

		this.initField('ram', 0);
		this.initField('ram', 1);

		this.initField('disk', 0);
		this.initField('disk', 1);

		if (this.isCpuEmpty || this.isRamEmpty || this.isDiskEmpty) {
			this.showChoiceBlock();
		}
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickDocumentHandler);

		this.deinitField('cpu', 0);
		this.deinitField('cpu', 1);

		this.deinitField('ram', 0);
		this.deinitField('ram', 1);

		this.deinitField('disk', 0);
		this.deinitField('disk', 1);
	},

	methods: {
		initField: function initField(what, idx) {
			var _this = this;

			var name = what + idx;
			if (!this.$refs[name]) return;

			var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs[name]);
			if (!$el || !$el.length) return;

			$el.data('what', what);
			$el.data('idx', idx);
			$el.autoNumeric('init', { aSep: '', mDec: 0 });

			$el.off('change paste keyup').on('change paste keyup', function (e) {
				var $e = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
				if (!$e || !$e.length) return;

				var w = $e.data('what');
				var i = $e.data('idx');

				_this.onInput(w, i, $e.autoNumeric('get'), $e);
			});
		},
		deinitField: function deinitField(what, idx) {
			var name = what + idx;
			if (!this.$refs[name]) return;

			var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs[name]);
			if (!$el || !$el.length) return;

			$el.off('change paste keyup');
			$el.autoNumeric('destroy');
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.hideChoiceBlock();
			}
		},
		clickDocumentHandler: function clickDocumentHandler(e) {
			if (!this.visible || !this.showChoicer) return;

			if (!(this.$refs.choicer === e.target || this.$refs.choicer.contains(e.target))) {
				this.hideChoiceBlock();
			}
		},
		showChoiceBlock: function showChoiceBlock() {
			if (this.valueCpu[0] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueCpu, 0, parseInt(this.params.cpu_min.min, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueCpu, 0, this.valueCpu[0]);

			if (this.valueCpu[1] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueCpu, 1, parseInt(this.params.cpu_max.max, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueCpu, 1, this.valueCpu[1]);

			if (this.valueRam[0] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueRam, 0, parseInt(this.params.ram_min.min, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueRam, 0, this.valueRam[0]);

			if (this.valueRam[1] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueRam, 1, parseInt(this.params.ram_max.max, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueRam, 1, this.valueRam[1]);

			if (this.valueDisk[0] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueDisk, 0, parseInt(this.params.disk_min.min, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueDisk, 0, this.valueDisk[0]);

			if (this.valueDisk[1] === null) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueDisk, 1, parseInt(this.params.disk_max.max, 10));else __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.sliderValueDisk, 1, this.valueDisk[1]);

			this.showChoicer = true;
		},
		hideChoiceBlock: function hideChoiceBlock() {
			var _this2 = this;

			this.showChoicer = false;

			this.$nextTick(function () {
				if (_this2.isCpuEmpty || _this2.isRamEmpty || _this2.isDiskEmpty) {
					_this2.$emit('closeDirectlyFilter');
				}
			});
		},
		submit: function submit() {
			this.hideChoiceBlock();

			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueCpu, 0, this.sliderValueCpu[0]);
			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueCpu, 1, this.sliderValueCpu[1]);

			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueRam, 0, this.sliderValueRam[0]);
			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueRam, 1, this.sliderValueRam[1]);

			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueDisk, 0, this.sliderValueDisk[0]);
			__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.valueDisk, 1, this.sliderValueDisk[1]);

			this.$emit('input', {
				cpu_min: this.valueCpu[0],
				cpu_max: this.valueCpu[1],
				ram_min: this.valueRam[0],
				ram_max: this.valueRam[1],
				disk_min: this.valueDisk[0],
				disk_max: this.valueDisk[1]
			});
		},
		getFormValueLink: function getFormValueLink(what) {
			if (what !== 'cpu' && what !== 'ram' && what !== 'disk') return null;

			var fieldName = '';
			if (what === 'cpu') fieldName = 'sliderValueCpu';
			if (what === 'ram') fieldName = 'sliderValueRam';
			if (what === 'disk') fieldName = 'sliderValueDisk';

			return this[fieldName];
		},
		onBlur: function onBlur(what, idx) {
			var name = what + idx;
			if (!this.$refs[name]) return;
			this.$refs[name].value = this.getFormValueLink(what)[idx];
		},
		onInput: function onInput(what, idx, value, $el) {
			if (!what) {
				return;
			}

			var _minParam = this.params[what + '_min'];
			var _maxParam = this.params[what + '_max'];
			if (!_minParam || !_minParam.title || !_maxParam || !_maxParam.title) {
				return;
			}

			var _link = this.getFormValueLink(what);
			if (!_link) return;

			var _min = _minParam.min;
			var _max = _maxParam.max;

			var _value = parseInt(value, 10);
			if (isNaN(_value) || _value < _min) _value = _min;
			if (_value > _max) _value = _max;

			if (idx === 0 && _value > _link[1]) _value = _link[1];
			if (idx === 1 && _value < _link[0]) _value = _link[0];

			_link[idx] = _value;

			var _slider = this.$refs['slider_' + what];
			if (_slider && _slider.setValue) {
				_slider.setValue(_link);
			}
		}
	},

	watch: {
		'value': function value() {
			this.valueCpu = [this.value.cpu_min, this.value.cpu_max];
			this.valueRam = [this.value.ram_min, this.value.ram_max];
			this.valueDisk = [this.value.disk_min, this.value.disk_max];
		},

		visible: function visible(value) {
			if (!value) this.showChoicer = false;else {
				if (this.isCpuEmpty || this.isRamEmpty || this.isDiskEmpty) {
					this.showChoiceBlock();
				}
			}
		}
	},

	components: {
		VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a,
		numberInput: __WEBPACK_IMPORTED_MODULE_2__components_elements_number___default.a
	}

});

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilter),
      expression: "showFilter"
    }],
    staticClass: "alert alert-info widget-block"
  }, [_c('div', {
    staticClass: "widget-filter-wrapper"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showChoiceBlock($event)
      }
    }
  }, [_c('span', {
    staticClass: "param-title"
  }, [_vm._v("CPU:")]), _vm._v(" "), (_vm.isCpuEmpty) ? _c('span', {
    staticClass: "param-value"
  }, [_vm._v("-")]) : _c('span', {
    staticClass: "param-value"
  }, [(_vm.valueCpu[0] != _vm.valueCpu[1]) ? [_vm._v(_vm._s(_vm.valueCpu[0]) + " - " + _vm._s(_vm.valueCpu[1]) + " " + _vm._s(_vm._f("ftc")(_vm.params.cpu_min.for)))] : [_vm._v(_vm._s(_vm.valueCpu[0]) + " " + _vm._s(_vm._f("ftc")(_vm.params.cpu_min.for)))]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showChoiceBlock($event)
      }
    }
  }, [_c('span', {
    staticClass: "param-title"
  }, [_vm._v("RAM:")]), _vm._v(" "), (_vm.isRamEmpty) ? _c('span', {
    staticClass: "param-value"
  }, [_vm._v("-")]) : _c('span', {
    staticClass: "param-value"
  }, [(_vm.valueRam[0] != _vm.valueRam[1]) ? [_vm._v(_vm._s(_vm.valueRam[0]) + " - " + _vm._s(_vm.valueRam[1]) + " " + _vm._s(_vm._f("ftc")(_vm.params.ram_min.for)))] : [_vm._v(_vm._s(_vm.valueRam[0]) + " " + _vm._s(_vm._f("ftc")(_vm.params.ram_min.for)))]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showChoiceBlock($event)
      }
    }
  }, [_c('span', {
    staticClass: "param-title"
  }, [_vm._v("DISK:")]), _vm._v(" "), (_vm.isDiskEmpty) ? _c('span', {
    staticClass: "param-value"
  }, [_vm._v("-")]) : _c('span', {
    staticClass: "param-value"
  }, [(_vm.valueDisk[0] != _vm.valueDisk[1]) ? [_vm._v(_vm._s(_vm.valueDisk[0]) + " - " + _vm._s(_vm.valueDisk[1]) + " " + _vm._s(_vm._f("ftc")(_vm.params.disk_min.for)))] : [_vm._v(_vm._s(_vm.valueDisk[0]) + " " + _vm._s(_vm._f("ftc")(_vm.params.disk_min.for)))]], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeDirectlyFilter')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoicer),
      expression: "showChoicer"
    }],
    ref: "choicer",
    staticClass: "widget-filter-choicer"
  }, [_c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideChoiceBlock($event)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("CPU")]), _vm._v(" "), _c('div', {
    staticClass: "fields-block"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    ref: "cpu0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.sliderValueCpu[0]
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('cpu', 0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', {
    ref: "slider_cpu",
    attrs: {
      "tooltip": "none",
      "enable-cross": false,
      "min": _vm.params.cpu_min.min,
      "max": _vm.params.cpu_max.max,
      "width": "100%"
    },
    model: {
      value: (_vm.sliderValueCpu),
      callback: function($$v) {
        _vm.sliderValueCpu = $$v
      },
      expression: "sliderValueCpu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    ref: "cpu1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.sliderValueCpu[1]
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('cpu', 1)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("RAM")]), _vm._v(" "), _c('div', {
    staticClass: "fields-block"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValueRam[0]),
      expression: "sliderValueRam[0]"
    }],
    ref: "ram0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sliderValueRam[0])
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('ram', 0)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sliderValueRam, 0, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', {
    ref: "slider_ram",
    attrs: {
      "tooltip": "none",
      "enable-cross": false,
      "min": _vm.params.ram_min.min,
      "max": _vm.params.ram_max.max,
      "width": "100%"
    },
    model: {
      value: (_vm.sliderValueRam),
      callback: function($$v) {
        _vm.sliderValueRam = $$v
      },
      expression: "sliderValueRam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValueRam[1]),
      expression: "sliderValueRam[1]"
    }],
    ref: "ram1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sliderValueRam[1])
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('ram', 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sliderValueRam, 1, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("DISK")]), _vm._v(" "), _c('div', {
    staticClass: "fields-block"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValueDisk[0]),
      expression: "sliderValueDisk[0]"
    }],
    ref: "disk0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sliderValueDisk[0])
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('disk', 0)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sliderValueDisk, 0, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', {
    ref: "slider_disk",
    attrs: {
      "tooltip": "none",
      "enable-cross": false,
      "min": _vm.params.disk_min.min,
      "max": _vm.params.disk_max.max,
      "width": "100%"
    },
    model: {
      value: (_vm.sliderValueDisk),
      callback: function($$v) {
        _vm.sliderValueDisk = $$v
      },
      expression: "sliderValueDisk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValueDisk[1]),
      expression: "sliderValueDisk[1]"
    }],
    ref: "disk1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sliderValueDisk[1])
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('disk', 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sliderValueDisk, 1, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submut-small btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n\t\t\tOK\n\t\t")])])])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'paginator',

	props: ['baseUrl', 'pages', 'curPage', 'lastPage', 'queryString'],

	computed: {
		query: function query() {
			if (this.queryString) {
				return this.queryString;
			}
			return '';
		},
		showFirst: function showFirst() {
			return !this.pages.some(function (i) {
				if (i === 1) return true;
			});
		},
		showMobileFirst: function showMobileFirst() {
			return this.curPage > 1;
		},
		showLast: function showLast() {
			var _this = this;

			return !this.pages.some(function (i) {
				if (i === _this.lastPage) return true;
			});
		},
		showMobileLast: function showMobileLast() {
			return this.curPage < this.lastPage;
		},
		showPrev: function showPrev() {
			return this.curPage > 1;
		},
		showNext: function showNext() {
			return this.curPage < this.lastPage;
		}
	},

	methods: {
		whatClass: function whatClass(idx) {
			if (!this.showFirst && idx === 0) return 'l-rnd';
			if (!this.showLast && idx === this.pages.length - 1) return 'r-rnd';

			return false;
		}
	}
});

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginator-wrapper"
  }, [_c('div', {
    staticClass: "paginator hidden-xs"
  }, [(_vm.showFirst) ? _c('router-link', {
    staticClass: "l-rnd",
    attrs: {
      "to": _vm.baseUrl + _vm.query
    }
  }, [_vm._v("«")]) : _vm._e(), _vm._l((_vm.pages), function(page, idx) {
    return [(page !== _vm.curPage) ? _c('router-link', {
      key: 'page-num-' + idx,
      class: _vm.whatClass(idx),
      attrs: {
        "to": _vm.baseUrl + (page !== 1 ? '/' + page : '') + _vm.query
      }
    }, [_vm._v(_vm._s(page))]) : _c('span', {
      key: 'page-num-active-' + idx,
      class: _vm.whatClass(idx)
    }, [_vm._v(_vm._s(page))])]
  }), (_vm.showLast) ? _c('router-link', {
    staticClass: "r-rnd arr-last",
    attrs: {
      "to": _vm.baseUrl + '/' + _vm.lastPage + _vm.query
    }
  }, [_vm._v("»")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "paginator visible-xs-inline"
  }, [(_vm.showMobileFirst) ? _c('router-link', {
    staticClass: "l-rnd",
    attrs: {
      "to": _vm.baseUrl + _vm.query
    }
  }, [_vm._v("«")]) : _vm._e(), (_vm.showPrev) ? _c('router-link', {
    attrs: {
      "to": _vm.baseUrl + '/' + (_vm.curPage - 1) + _vm.query
    }
  }, [_vm._v("←")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.curPage))]), (_vm.showNext) ? _c('router-link', {
    attrs: {
      "to": _vm.baseUrl + '/' + (_vm.curPage + 1) + _vm.query
    }
  }, [_vm._v("→")]) : _vm._e(), (_vm.showMobileLast) ? _c('router-link', {
    staticClass: "r-rnd arr-last",
    attrs: {
      "to": _vm.baseUrl + '/' + _vm.lastPage + _vm.query
    }
  }, [_vm._v("»")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus_js__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'listDropDownOpersButtonComponent',

	props: ['dataConfig', 'row', 'index', 'crud'],
	data: function data() {
		return {
			show: false,

			data: {},

			Row: null,

			cssUl: false
		};
	},
	created: function created() {
		this.Row = this.row;
		this.initButtons();
	},

	computed: {
		isCrudOpers: function isCrudOpers() {
			return 'create' in this.data || 'update' in this.data || 'delete' in this.data || 'clone' in this.data;
		},
		isOtherOpers: function isOtherOpers() {
			for (var i in this.data) {
				if (i !== 'create' && i !== 'update' && i !== 'delete' && i !== 'clone') {
					if (this.isOperButtonVisible(i)) return true;
				}
			}

			return false;
		},
		statusTextField: function statusTextField() {
			if (!this.Row) return false;

			var _statusField = false;

			for (var _s in this.Row) {
				if (/_status_text$/ig.test(_s)) {
					_statusField = _s;
					break;
				}
			}

			return _statusField;
		},
		canShowCrudButton: function canShowCrudButton() {
			if (!this.Row) return false;

			var _text = this.statusTextField;

			if (!_text || this.crud === 'user') return true;

			if (this.Row[_text]) {
				if (this.crud === 'vds') {
					if (this.Row['service_status'] !== 'active') return false;
				} else return false;
			}

			return true;
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('keydown.dropdownmenu.' + this.index, this.KeyDownHandler);
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('toggleDropDownOperMenu.' + this.index, this.handleToggle);
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click.dropdownmenu.' + this.index, this.ClickOnDocument);
		__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$on('w5-update-row', this.updateRowHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('keydown.dropdownmenu.' + this.index, this.KeyDownHandler);
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('toggleDropDownOperMenu.' + this.index, this.handleToggle);
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('click.dropdownmenu.' + this.index, this.ClickOnDocument);
		__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$off('w5-update-row', this.updateRowHandler);
	},

	methods: {
		toggleMenu: function toggleMenu(e) {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).trigger('toggleDropDownOperMenu', [this.index]);

			this.show = !this.show;

			this.UpOrDown();
		},
		handleToggle: function handleToggle(e, idx) {
			if (idx !== this.index) this.hideMenu();
		},
		hideMenu: function hideMenu() {
			this.show = false;
		},
		clickOper: function clickOper(action) {
			this.hideMenu();

			var _action = this.data[action];
			if (this.crud === 'user' && this.$store.state.user_type !== 'admin') {
				if (action === 'update' && this.Row['user_id'] === this.$store.state.user_id) _action = { 'action': 'url:/options' };
			}

			if (action === 'accountReport') {
				var _w = window.open();

				_action.w = _w;
			}

			this.$emit('action', {
				'action': action,
				'data': _action,
				'row': this.Row
			});
		},
		classOper: function classOper(action) {
			if (action === 'log' || action === 'logOver') return ['list'];else if (action === 'filter') return ['filter'];else if (action === 'note') return ['thumbtack'];else if (action === 'createNote') return ['plus', 'thumbtack'];else if (action === 'request' || action === 'serviceRequest') return ['exclamation-circle'];else if (action === 'operation' || action === 'paymentLink') return this.AppName === 'vdsina.com' ? ['dollar-sign'] : ['ruble-sign'];else if (action === 'user') return ['users'];else if (action === 'partnerAction') return ['list-ul'];else if (action === 'partner') return ['handshake'];else if (action === 'server') return ['server'];else if (action === 'plan') return ['search-dollar'];else if (action === 'vdsReboot' || action === 'domainReboot') return ['power-off'];else if (action === 'vdsPlan') return ['tasks'];else if (action === 'vdsReinstall') return ['history'];else if (action === 'vdsChangePassword') return ['random'];else if (action === 'prolong') return ['play-circle'];else if (action === 'ticketMerge') return ['compress-alt'];else if (action === 'account') return ['user-circle'];else if (action === 'bonusActivate') return ['trophy'];else if (action === 'pdfLink' || action === 'xmlLink') return ['file-download'];else if (action === 'operLink') return ['file-invoice'];else if (action === 'mailDocument') return ['envelope'];else if (action === 'restoreBackup' || action === 'connectOuterDisk' || action === 'restoreBackupOuterDisk') return ['hdd'];else if (action === 'scheduleOuterDisk' || action === 'scheduleOuterDiskUpdate') return ['clock'];else if (action === 'ejectOuterDisk' || action === 'ejectISOOper') return ['eject'];else if (action === 'renameBackup') return ['pencil-alt'];else if (action === 'createFromBackup' || action === 'createFromBackupOuterDisk' || action === 'createDevice' || action === 'backupOuterDisk') return ['plus'];else if (action === 'clientTicket') return ['envelope'];else if (action === 'accountReport') return ['clipboard'];else if (action === 'rackGraphic') return ['grip-vertical'];else if (action === 'removeFilter') return ['ban'];else if (action === 'copyToDc') return ['hdd', 'share'];else if (action === 'downloadBackup') return ['cloud-download-alt'];else if (action === 'deviceLinks') return ['link'];else if (action === 'ipptrpool') return ['network-wired'];else if (action === 'ipHistory') return ['history'];else if (action === 'vdsClone') return ['server', 'clone'];else if (action === 'connectISOOper') return ['compact-disc'];else if (action === 'cloneOuterDisk') return ['clone'];

			return ['sun'];
		},
		classOperClasses: function classOperClasses(key) {
			var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			if (key === 'createNote') {
				return !idx ? 'w5-oper-menu-icon-plus' : 'w5-oper-menu-icon-note';
			} else if (key === 'copyToDc') {
				return !idx ? 'w5-oper-menu-icon-hdd' : 'w5-oper-menu-icon-share';
			} else if (key === 'vdsClone') {
				return !idx ? 'w5-oper-menu-icon-vds-clone-server' : 'w5-oper-menu-icon-vds-clone-clone';
			}

			return null;
		},
		KeyDownHandler: function KeyDownHandler(e) {
			if (this.show && e.keyCode === 27) this.hideMenu();
		},
		ClickOnDocument: function ClickOnDocument(e) {
			if (this.show) this.hideMenu();
		},
		isOperButtonVisible: function isOperButtonVisible(key) {
			if (key !== 'create' && key !== 'update' && key !== 'delete' && key !== 'clone') {
				if (key === 'vdsReboot' || key === 'vdsPlan' || key === 'vdsReinstall' || key === 'vdsChangePassword' || key === 'vdsClone') {
					if (key === 'vdsClone') {
						if (this.Row['service_data'] && this.Row['service_data']['plan']) {
							if (String(this.Row['service_data']['plan']['status']) !== 'active') return false;
							if (String(this.Row['service_data']['plan']['name']).toLowerCase().indexOf('архивный') > -1) return false;
						}
					}

					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else return true;
				} else if (key === 'prolong') {
						if (this.Row['can_prolong'] !== true || this.Row['service_status_text']) return false;else return true;
					} else if (key === 'ticketMerge') {
							if (this.Row['can_merge'] !== true) return false;else return true;
						} else if (key === 'paymentLink') {
								if (!this.Row['external_hash']) return false;else return true;
							} else if (key === 'pdfLink') {
									if (!this.Row['pdf']) return false;else return true;
								} else if (key === 'xmlLink') {
										if (!this.Row['xml']) return false;else return true;
									} else if (key === 'operLink') {
											if (!this.Row['operation_id']) return false;else return true;
										} else if (key === 'mailDocument') {
												if (this.Row['can_mail'] !== true) return false;else return true;
											} else if (key === 'bonusActivate') {
													if (this.crud === 'bonus') {
														if (this.Row['bonus_status'] !== 'active') return false;else return true;
													} else return true;
												} else if (key === 'domainReboot') {
														if (this.Row['service_status'] !== 'active' || this.Row['service_status_text'] || this.Row['can_reboot'] !== true) return false;else return true;
													} else if (key === 'restoreBackup' || key === 'renameBackup') {
															if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else return true;
														} else if (key === 'createFromBackup' || key === 'createFromBackupOuterDisk') {
																if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else return true;
															} else if (key === 'copyToDc') {
																	if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																	return this.isAccess('service/copy');
																} else if (key === 'accountReport') {
																		return this.isAccess('account/report');
																	} else if (key === 'downloadBackup') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text'] || this.Row['can_download'] !== true) return false;
																			return this.isAccess('service/update');
																		} else if (key === 'connectOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else {
																				if (this.Row['service_data'] && this.Row['service_data']['extdisk'] && this.Row['service_data']['extdisk']['attached'] === true) return false;
																				return true;
																			}
																		} else if (key === 'ejectOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else {
																				if (this.Row['service_data'] && this.Row['service_data']['extdisk'] && this.Row['service_data']['extdisk']['attached'] === true) return true;
																				return false;
																			}
																		} else if (key === 'cloneOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																			return this.isAccess('service/clone');
																		} else if (key === 'backupOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																			return this.isAccess('service/create');
																		} else if (key === 'restoreBackupOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																			return this.isAccess('service/update');
																		} else if (key === 'scheduleOuterDisk') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																			if (!this.isAccess('backupschedule/create')) return false;

																			if (this.Row['service_data'] && this.Row['service_data']['has_schedule'] === true) return false;

																			return true;
																		} else if (key === 'scheduleOuterDiskUpdate') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;
																			if (!this.isAccess('backupschedule/update')) return false;

																			if (!this.Row['service_data'] || !this.Row['service_data']['has_schedule']) return false;

																			return true;
																		} else if (key === 'connectISOOper') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else {
																				if (this.Row['service_data'] && this.Row['service_data']['iso'] && this.Row['service_data']['iso']['attached'] === true) return false;
																				return true;
																			}
																		} else if (key === 'ejectISOOper') {
																			if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false;else {
																				if (this.Row['service_data'] && this.Row['service_data']['iso'] && this.Row['service_data']['iso']['attached'] === true) return true;
																				return false;
																			}
																		} else if (key === 'deviceLinks') {
																				return this.isAccess('rackdevice/links');
																			} else return true;
			}

			return false;
		},
		UpOrDown: function UpOrDown() {
			this.cssUl = false;

			var _div = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('div[data-index="' + this.index + '"]');
			if (!_div.length) return;

			var _ul = _div.find('ul:first');
			if (!_ul.length) return;

			var _rect = _div.offset();
			var _heightDiv = _div.height();
			var _heightUl = _ul.height();

			var _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scrollTop();

			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px';
		},
		initButtons: function initButtons() {
			this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.dataConfig);

			if ('delete' in this.data) {
				var _canDel = false;

				if ('can_delete' in this.Row) {
					_canDel = __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].normalizeBooleanValue(this.Row['can_delete']);
				} else {
					_canDel = true;

					if (this.crud === 'operation') _canDel = false;

					for (var nm in this.Row) {
						if (this.Row.hasOwnProperty(nm)) {
							if (nm.indexOf('_status') >= 0 && String(this.Row[nm]).indexOf('delete') >= 0) {
								_canDel = false;
								break;
							}
						}
					}
				}

				if (this.crud === 'vds' && this.Row['service_status_text']) _canDel = false;

				if (!this.isAccess(this.crud + '/delete')) _canDel = false;

				if (this.crud === 'ticket') _canDel = false;

				if (_canDel === false) this.$delete(this.data, 'delete');
			}

			if ('update' in this.data) {
				var _canUpd = false;
				if (this.crud === 'operation' && this.$store.state.user_type !== 'admin') _canUpd = false;else if (this.crud === 'user' && this.$store.state.user_type !== 'admin') {
					if (this.Row['user_id'] === this.$store.state.user_id) _canUpd = true;else {
						if ('can_update' in this.Row && !this.Row['can_update']) {
							_canUpd = false;
						} else {
							_canUpd = true;

							if (!this.isAccess(this.crud + '/update')) _canUpd = false;
						}
					}
				} else {
					if ('can_update' in this.Row && !this.Row['can_update'] || this.crud === 'vds' || this.crud === 'additional-services' || this.crud === 'request' && this.$store.state.user_type !== 'admin') {
						_canUpd = false;
					} else {
						_canUpd = true;

						if (!this.isAccess(this.crud + '/update')) _canUpd = false;
					}
				}

				if (_canUpd === false) this.$delete(this.data, 'update');
			}

			if ('create' in this.data) {
				var _canCrt = true;

				var _crud = this.crud;
				if (this.crud === 'servicetype') _crud = 'plan';
				if (!this.isAccess(_crud + '/create')) _canCrt = false;

				if (_canCrt && this.crud === 'servicetype') if (!('can_create_plan' in this.Row) || this.Row['can_create_plan'] !== true) _canCrt = false;

				if (_canCrt === false) this.$delete(this.data, 'create');
			}

			if ('clone' in this.data) {}

			if ('vdsClone' in this.data) {
				var _canClone = false;

				if (this.$store.state.user_type === 'admin') {
					_canClone = true;
				} else {
					if ('accountOnly' in this.data.vdsClone) {
						_canClone = this.data.vdsClone.accountOnly === this.$store.state.user_account;
					} else {
						_canClone = true;
					}
				}

				if (_canClone === false) this.$delete(this.data, 'vdsClone');
			}
		},
		updateRowHandler: function updateRowHandler(data) {
			if (!data || !data['column_id'] || !data['row']) return;

			if (this.Row[data['column_id']] !== data['row'][data['column_id']]) return;

			this.Row = data['row'];
			this.initButtons();
		}
	},

	watch: {
		'row': function row(_row) {
			this.Row = _row;
			this.initButtons();
		}
	}

});

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.data).length > 0 && ((_vm.isCrudOpers && _vm.canShowCrudButton) || _vm.isOtherOpers) && _vm.$store.state.windowWidth <= 767) ? _c('div', {
    staticClass: "w5-opers-button-for-mobile"
  }, [('create' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('create')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('update' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('clone' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('clone')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(oper, key) {
    return _c('div', {
      key: 'other-opers-' + key,
      staticClass: "w5-opers-button-curd-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clickOper(key)
        }
      }
    }, [(_vm.isOperButtonVisible(key)) ? [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, _vm._l((_vm.classOper(key)), function(cls, idx) {
      return _c('font-awesome-icon', {
        key: 'icon-' + cls,
        class: _vm.classOperClasses(key, idx),
        attrs: {
          "icon": cls
        }
      })
    }), 1)] : _vm._e()], 2)
  }), _vm._v(" "), ('delete' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()], 2) : (Object.keys(_vm.data).length > 0 && ((_vm.isCrudOpers && _vm.canShowCrudButton) || _vm.isOtherOpers) && _vm.$store.state.windowWidth > 767) ? _c('div', {
    staticClass: "btn-group w5-opers-button",
    class: {
      'w5-opers-button-opened': _vm.show
    },
    attrs: {
      "data-index": _vm.index
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "dropdown-toggle"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bars"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropdown-menu",
    style: (_vm.cssUl),
    attrs: {
      "role": "menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.isCrudOpers && _vm.canShowCrudButton) ? [('create' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('create')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['create']['title'] ? _vm.data['create']['title'] : this.crud + '/create_title')) + "\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), ('update' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['update']['title'] ? _vm.data['update']['title'] : 'main/redact')) + "\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), ('clone' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('clone')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['clone']['title'] ? _vm.data['clone']['title'] : 'main/clone')) + "\n\t\t\t\t")], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (('create' in _vm.data || 'update' in _vm.data || 'clone' in _vm.data) && _vm.isOtherOpers) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(oper, key) {
    return _c('li', {
      key: 'other-opers-' + key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clickOper(key)
        }
      }
    }, [(_vm.isOperButtonVisible(key)) ? [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_vm._l((_vm.classOper(key)), function(cls, idx) {
      return _c('font-awesome-icon', {
        key: 'icon-' + cls,
        class: _vm.classOperClasses(key, idx),
        attrs: {
          "icon": cls
        }
      })
    }), _vm._v(" "), (key === 'ipptrpool') ? [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(oper['title'] ? oper['title'] : '')) + "\n\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(oper['title'] ? oper['title'] : ''))) + "\n\t\t\t\t\t")]], 2)] : _vm._e()], 2)
  }), _vm._v(" "), (_vm.isCrudOpers && _vm.canShowCrudButton && 'delete' in _vm.data) ? [(('create' in _vm.data || 'update' in _vm.data || 'clone' in _vm.data) || _vm.isOtherOpers) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['delete']['title'] ? _vm.data['delete']['title'] : 'main/delete')) + "\n\t\t\t\t")], 1)])] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'listOneOperButtonComponent',

	props: ['dataConfig', 'row', 'index', 'crud'],
	data: function data() {
		return {
			data: {},

			Row: null
		};
	},

	computed: {
		statusTextField: function statusTextField() {
			if (!this.Row) return false;

			var _statusField = false;

			for (var _s in this.Row) {
				if (/_status_text$/ig.test(_s)) {
					_statusField = _s;
					break;
				}
			}

			return _statusField;
		},
		canShowCrudButton: function canShowCrudButton() {
			if (!this.Row) return false;

			var _text = this.statusTextField;

			if (!_text || this.crud === 'user') return true;

			if (this.Row[_text]) return false;

			return true;
		}
	},
	created: function created() {
		this.Row = this.row;
		this.initButtons();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-update-row', this.updateRowHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-update-row', this.updateRowHandler);
	},

	methods: {
		clickOper: function clickOper(action) {
			var _action = this.data[action];
			if (this.crud === 'user' && this.$store.state.user_type !== 'admin') {
				if (action === 'update' && this.Row['user_id'] === this.$store.state.user_id) _action = { 'action': 'url:/options' };
			}

			this.$emit('action', {
				'action': action,
				'data': _action,
				'row': this.Row
			});
		},
		initButtons: function initButtons() {
			this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.dataConfig);

			if ('delete' in this.data) {
				var _canDel = false;

				if ('can_delete' in this.Row) {
					_canDel = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].normalizeBooleanValue(this.Row['can_delete']);
				} else {
					_canDel = true;

					if (this.crud === 'operation') _canDel = false;

					for (var nm in this.Row) {
						if (this.Row.hasOwnProperty(nm)) {
							if (nm.indexOf('_status') >= 0 && String(this.Row[nm]).indexOf('delete') >= 0) {
								_canDel = false;
								break;
							}
						}
					}
				}

				if (!this.isAccess(this.crud + '/delete')) _canDel = false;

				if (_canDel === false) this.$delete(this.data, 'delete');
			}

			if ('update' in this.data) {
				var _canUpd = false;
				if (this.crud === 'operation' && this.$store.state.user_type !== 'admin') _canUpd = false;else if (this.crud === 'user' && this.$store.state.user_type !== 'admin') {
					if (this.Row['user_id'] === this.$store.state.user_id) _canUpd = true;else {
						if ('can_update' in this.Row && !this.Row['can_update']) {
							_canUpd = false;
						} else {
							_canUpd = true;

							if (!this.isAccess(this.crud + '/update')) _canUpd = false;
						}
					}
				} else {
					if ('can_update' in this.Row && !this.Row['can_update'] || this.crud === 'vds' || this.crud === 'additional-services' || this.crud === 'request' && this.$store.state.user_type !== 'admin') {
						_canUpd = false;
					} else {
						_canUpd = true;

						if (!this.isAccess(this.crud + '/update')) _canUpd = false;
					}
				}

				if (_canUpd === false) this.$delete(this.data, 'update');
			}

			if ('create' in this.data) {
				var _canCrt = true;

				var _crud = this.crud;
				if (this.crud === 'servicetype') _crud = 'plan';
				if (!this.isAccess(_crud + '/create')) _canCrt = false;

				if (_canCrt && this.crud === 'servicetype') if (!('can_create_plan' in this.Row) || this.Row['can_create_plan'] !== true) _canCrt = false;

				if (_canCrt === false) this.$delete(this.data, 'create');
			}
		},
		updateRowHandler: function updateRowHandler(data) {
			if (!data || !data['column_id'] || !data['row']) return;

			if (this.Row[data['column_id']] !== data['row'][data['column_id']]) return;

			this.Row = data['row'];
			this.initButtons();
		}
	},

	watch: {
		'row': function row(_row) {
			this.Row = _row;
			this.initButtons();
		}
	}

});

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.data).length > 0 && _vm.$store.state.windowWidth <= 767) ? _c('div', {
    staticClass: "w5-opers-button-for-mobile"
  }, [('update' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('delete' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()]) : (Object.keys(_vm.data).length > 0 && _vm.$store.state.windowWidth > 767) ? _c('div', {
    attrs: {
      "data-index": _vm.index
    }
  }, [(_vm.canShowCrudButton && 'update' in _vm.data) ? _c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-one-btn",
    attrs: {
      "title": _vm._f("ftc")(_vm.data['update']['title'] ? _vm.data['update']['title'] : 'main/update')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canShowCrudButton && 'delete' in _vm.data) ? _c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-one-btn",
    attrs: {
      "title": _vm._f("ftc")(_vm.data['delete']['title'] ? _vm.data['delete']['title'] : 'main/delete')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'moneyComponent',
	props: ['value'],
	data: function data() {
		return {
			Parts: null
		};
	},
	created: function created() {
		this.Parts = String(this.value).split('.');
	},

	computed: {
		Rub: function Rub() {
			if (this.Parts[0]) return this.Parts[0];
			return '';
		},
		Kop: function Kop() {
			if (this.Parts[1]) return this.Parts[1];
			return '';
		}
	},
	watch: {
		value: function value(val) {
			this.Parts = String(val).split('.');
		}
	}
});

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.Rub)), (_vm.Kop.length) ? [_vm._v("."), _c('span', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v(_vm._s(_vm.Kop))])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  "data-v-4223bf89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'dialogBackup',

	props: {
		type: String,
		accountId: [Boolean, Number],
		backupId: [Boolean, Number],
		backupName: {
			type: String
		},
		userType: {
			type: String,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		}
	},

	data: function data() {
		return {
			dialogVisible: this.visible,

			accountValue: false,
			serviceValue: false,

			createBackupText: '',
			notPossibleText: '',
			restoreBackupText: '',

			accountField: {
				_field_name: 'account_id',
				_visible: true,
				_is_modal: true,
				_storeValue: null,
				required: true,
				title: 'account/account',
				type: 'list',
				url: '/service/create?search=account&q='
			},
			serviceField: {
				_field_name: 'service_id',
				_visible: true,
				_is_modal: true,
				required: true,
				title: 'service/vds',
				type: 'list',
				list: []
			}
		};
	},
	created: function created() {
		this.accountField._visible = this.userType === 'admin' && this.type === 'create-backup' && !this.accountId;
		if (this.accountId) this.getServiceList();
	},

	methods: {
		hideDialog: function hideDialog() {
			this.$emit('onClose');
		},
		dialogAction: function dialogAction() {
			if (!this.serviceValue || this.notPossibleText) return;

			this.$emit('onAction', {
				'account': this.accountValue,
				'service': this.serviceValue
			});
		},
		getServiceList: function getServiceList() {
			var _this = this;

			this.serviceField.list = [];
			this.serviceValue = false;
			this.createBackupText = '';
			this.notPossibleText = '';

			var _paramsGet = {};

			if (this.type === 'create-backup') {
				_paramsGet.search = 'service_backup';

				if (this.accountId && this.accountId !== true) _paramsGet.account_id = this.accountId;
				if (this.accountValue) _paramsGet.account_id = this.accountValue;
			} else {
				_paramsGet.search = 'service_restore';
				_paramsGet.backup_id = this.backupId;
			}

			this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + '/service/create', { 'params': _paramsGet }).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt.status === 'ok' && _dt.result) {
					_this.serviceField.list = _dt.result;
					return;
				}
				throw new Error(res);
			}).catch(function (error) {
				return _this.$emit('onError', error);
			});
		},
		accountChanged: function accountChanged(value) {
			if (this.serviceField._visible) this.getServiceList();
		},
		serviceChanged: function serviceChanged(value) {
			var _this2 = this;

			if (!value || !this.serviceField.list || !this.serviceField.list.length) return;

			this.restoreBackupText = '';

			this.serviceField.list.some(function (item) {
				if (String(item.id) === String(value)) {
					if (item.name && _this2.backupName) {
						_this2.restoreBackupText = _this2.localeFtc('service/restore_backup_info').replace('{server}', item.name).replace('{backup}', _this2.backupName);
					}

					if (item.data && item.data.extdisk && item.data.extdisk.attached === true) {
						if (_this2.restoreBackupText) _this2.restoreBackupText += '<br><br>' + _this2.localeFtc('service/reboot_warning');else _this2.restoreBackupText = _this2.localeFtc('service/reboot_warning');
					}

					if (!item.active || !item.enable) {
						var _errorMessage = _this2.type === 'create-backup' ? _this2.localeFtc('service/creating_backup_vds_not_possible') : _this2.localeFtc('service/backup_error');

						_this2.createBackupText = '';
						_this2.notPossibleText = _errorMessage;
					} else {
						_this2.notPossibleText = '';
						_this2.createBackupText = '';

						if (_this2.type === 'create-backup') {
							var _size = 0;
							var _for = '';
							var _wholeCost = item.cost;

							if (item && item.data && item.data.plan && item.data.plan.data && item.data.plan.data.disk) {
								_for = item.data.plan.data.disk.for;

								if ('total' in item.data.plan.data.disk) _size = parseFloat(item.data.plan.data.disk.total);else if ('value' in item.data.plan.data.disk) _size = parseFloat(item.data.plan.data.disk.value);
							}

							if ('cost' in item) {
								var _val = parseFloat(item.cost);
								if (!isNaN(_val) && !isNaN(_size)) {
									_wholeCost = _val;
								}
							}

							_this2.createBackupText = _size ? _this2.localeFtc('service/creating_backup_cost <b>main/ruble</b>' + ' / <b>{period}</b> / <b>{size}</b>').replace('{cost}', __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].FormatMoney2(_wholeCost, 2))).replace('{period}', _this2.localeFtc(item.period)).replace('{size}', _size + ' ' + _this2.localeFtc(_for)) : _this2.localeFtc('service/creating_backup_cost <b>main/ruble</b>' + ' / <b>{period}</b>').replace('{cost}', item.cost).replace('{period}', _this2.localeFtc(item.period));
						}
					}
					return true;
				}
			});
		}
	},

	watch: {
		type: {
			handler: function handler(type) {
				this.accountField._visible = this.userType === 'admin' && type === 'create-backup' && !this.accountId;
			},
			immediate: true
		},
		accountId: {
			handler: function handler(account) {
				this.accountField._visible = this.userType === 'admin' && this.type === 'create-backup' && !account;
			},
			immediate: true
		},
		visible: {
			handler: function handler(visible) {
				this.accountValue = false;
				this.serviceValue = false;
				this.createBackupText = '';
				this.notPossibleText = '';
				this.restoreBackupText = '';

				if (visible && this.accountId) this.getServiceList();

				if (visible && this.type === 'create-backup') {
					var _accData = window && window.sessionStorage ? window.sessionStorage.getItem('create-backup') : null;
					if (_accData) {
						window.sessionStorage.removeItem('create-backup');
						var _json = null;
						try {
							_json = JSON.parse(_accData);
						} catch (err) {}
						if (_json && _json.account_id) {
							this.$nextTick(function () {
								__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
									name: 'account_id',
									value: {
										id: _json.account_id,
										name: 'a' + _json.account_id
									}
								});
							});
						}
					}
				}

				this.dialogVisible = visible;
			},
			immediate: true
		}
	},

	components: { Field: __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default.a }
});

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.type === 'create-backup' ? 'service/creating_backup' : 'service/restore')) + "\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "listBlockToOut": true,
      "Field": _vm.accountField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "action": _vm.type,
      "crud": "backupModalDialog"
    },
    on: {
      "input": _vm.accountChanged
    },
    model: {
      value: (_vm.accountValue),
      callback: function($$v) {
        _vm.accountValue = $$v
      },
      expression: "accountValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    staticClass: "display-grid",
    attrs: {
      "isVisibleRow": true,
      "Field": _vm.serviceField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "listBlockToOut": 1,
      "action": _vm.type,
      "crud": "backupModalDialog"
    },
    on: {
      "input": _vm.serviceChanged
    },
    model: {
      value: (_vm.serviceValue),
      callback: function($$v) {
        _vm.serviceValue = $$v
      },
      expression: "serviceValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createBackupText),
      expression: "createBackupText"
    }],
    staticClass: "w5-form-row"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.createBackupText)),
      expression: "localeFtc(createBackupText)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notPossibleText),
      expression: "notPossibleText"
    }],
    staticClass: "w5-form-row"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.notPossibleText)),
      expression: "localeFtc(notPossibleText)"
    }],
    staticClass: "warrning"
  })]), _vm._v(" "), (_vm.type === 'restore-backup' && _vm.restoreBackupText && (!_vm.notPossibleText && !_vm.createBackupText)) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.restoreBackupText)),
      expression: "localeFtc(restoreBackupText)"
    }],
    staticClass: "warrning"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.dialogAction
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.type === 'create-backup' ? 'service/backup_create' : 'service/backup_restore')) + "\n\t\t\t\t")])])])])])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  "data-v-7ea4cc58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bus_js__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'dialogCalc',
	mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],

	props: {
		visible: {
			type: Boolean,
			required: true
		}
	},

	computed: {
		showServicesCount: function showServicesCount() {
			return 3;
		}
	},

	data: function data() {
		var _groupNames;

		return {
			dialogVisible: this.visible,
			calcValue: '0.00',
			errorMessage: '',
			periodField: null,
			serviceField: null,
			model: '',
			csrf: '',
			showList: false,

			groupNames: (_groupNames = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS, 'menu/vds'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_IP4, 'service/ip4_count'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_IP6, 'service/ip6_count'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_RAM, 'service/ram'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_SSD, 'service/ssd'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_CPU, 'CPU'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_TRAFF, 'TRAFF'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_LOAD, 'server/load_min'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_VDS_SNAPSHOT, 'SNAPSHOT'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_ISO, 'service/iso'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_SSL, 'menu/certificate_ssl'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_DOMAIN, 'main/domains'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_DOMAIN_PRIVACY, 'PRIVACY'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_DNS, 'menu/dns'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_groupNames, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS, 'service/backups'), _groupNames)
		};
	},
	beforeCreate: function beforeCreate() {
		var _this = this;

		this.$http.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].APIServerUrl + '/servicetype/get').then(function (res) {
			var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
			if (_dt && _dt.status === 'ok' && _dt.result && _dt.result.length) {
				_dt.result.forEach(function (item) {
					if (item && item.id) _this.groupNames[item.id] = item.name;
				});
			}
		}).catch(function () {});
	},

	methods: {
		rounding: function rounding(val) {
			var r = parseFloat(val);
			if (isNaN(r)) return val;
			return r.toFixed(2);
		},
		hideDialog: function hideDialog() {
			this.$emit('onClose');
		},
		requestFields: function requestFields() {
			var _this2 = this;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].APIServerUrl + '/service/calc').then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt.status === 'form' && _dt.model && _dt.fields && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_dt.fields) === 'object') {
					_this2.model = _dt.model;
					_this2.csrf = _dt._csrf;

					for (var prop in _dt.fields) {
						if (prop === 'period' && _dt.fields[prop] && _dt.fields[prop].list) {
							_this2.periodField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ value: null, _visible: true, _field_name: prop }, _dt.fields[prop], { list: [] });
							for (var id in _dt.fields[prop].list) {
								_this2.periodField.list.push({ id: id, name: _this2.localeFtc(_dt.fields[prop].list[id]) });
								if (_dt.fields[prop].value === id) {
									_this2.periodField.value = id;
									__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
										name: 'period',
										value: { id: id, name: _this2.localeFtc(_dt.fields[prop].list[id]) }
									});
								}
							}

							if (!_this2.periodField.value) {
								_this2.periodField.value = _this2.periodField.list[0].id;
								__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
									name: 'period',
									value: _this2.periodField.list[0]
								});
							}
						} else if (prop === 'service_id' && _dt.fields[prop] && _dt.fields[prop].list) {
							_this2.serviceField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _dt.fields[prop]);
							_this2.compileServices();
						}
					}

					_this2.fieldChanged();
				}
			});
		},
		fieldChanged: function fieldChanged() {
			var _this3 = this;

			this.errorMessage = '';

			if (!this.periodField) return;

			var _post = { '_csrf': '' };
			_post[this.model] = {
				'period': this.periodField.value
			};

			var _url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].APIServerUrl + '/service/calc';
			this.setLoader(true);

			if (this.csrf) {
				_post._csrf = this.csrf;
				this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
					_this3.setLoader(false);
					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok' && _dt.result && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_dt.result) === 'object' && 'summa' in _dt.result) {
						_this3.calcValue = _dt.result.summa.toFixed(2);

						return;
					}

					throw resPost;
				}).catch(function (error) {
					_this3.calcValue = '0.00';
					_this3.setLoader(false);

					_this3.errorMessage = _this3.localeFtc('main/error_desc').replace(':', '');
					if (error && error.message) _this3.errorMessage = error.message;
					if (error && error.content) _this3.errorMessage = error.content;
				});

				return;
			}

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt.status === 'form' && _dt._csrf) {
					_post._csrf = _dt._csrf;
					_this3.$http.post(_url, __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this3.setLoader(false);
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt.result && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_dt.result) === 'object' && 'summa' in _dt.result) {
							_this3.calcValue = _dt.result.summa.toFixed(2);

							return;
						}

						throw resPost;
					}).catch(function (error) {
						_this3.calcValue = '0.00';
						_this3.setLoader(false);

						_this3.errorMessage = _this3.localeFtc('main/error_desc').replace(':', '');
						if (error && error.message) _this3.errorMessage = error.message;
						if (error && error.content) _this3.errorMessage = error.content;
					});

					return;
				}

				throw _dt;
			}).catch(function (error) {
				_this3.calcValue = '0.00';
				_this3.setLoader(false);

				_this3.errorMessage = _this3.localeFtc('main/error_desc').replace(':', '');
				if (error && error.message) _this3.errorMessage = error.message;
				if (error && error.content) _this3.errorMessage = error.content;
			});
		},
		compileServices: function compileServices() {
			var _this4 = this;

			if (!this.serviceField || !this.serviceField.list || !this.serviceField.list.length) return;

			var groupsMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
			this.serviceField.list.forEach(function (service) {
				if (service && service.id && service.st_id) {
					var services = groupsMap.get(service.st_id);
					if (services && services.list) {
						services.selected = _this4.serviceField.value && _this4.serviceField.value.length ? _this4.serviceField.value.indexOf(service.id) > -1 : false;
						services.list.push(service);
					} else {
						services = {
							selected: _this4.serviceField.value && _this4.serviceField.value.length ? _this4.serviceField.value.indexOf(service.id) > -1 : false,
							list: [service]
						};
						groupsMap.set(service.st_id, services);
					}
				}
			});

			this.serviceField.groupsMap = groupsMap;
		},
		serviceClick: function serviceClick(id) {
			if (!this.serviceField || !this.serviceField.list || !this.serviceField.groupsMap) return;

			var services = this.serviceField.groupsMap.get(id);
			services.selected = !services.selected;
			this.$forceUpdate();
			this.fieldChanged();
		},
		topupBalance: function topupBalance() {
			if (this.errorMessage || this.calcValue === '0.00' || !this.calcValue) return;

			this.$store.commit('setOperationSumNew', this.calcValue);
			this.$router.push('/operation/create');
		},
		showCutted: function showCutted(n, name, list) {
			if (!list || !list.length) return;

			this.showList = { n: n, name: name, list: list };
		}
	},

	watch: {
		visible: {
			handler: function handler(visible) {
				var _this5 = this;

				if (visible) this.requestFields();

				this.dialogVisible = visible;
				if (this.periodField && this.periodField.list && this.periodField.list.length) {
					if (this.periodField.value === null || this.periodField.value === undefined || this.periodField.value && !this.periodField.list.find(function (item) {
						return item.id === _this5.periodField.value;
					})) {
						this.periodField.value = this.periodField.list[0].id;
						__WEBPACK_IMPORTED_MODULE_9__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
							name: 'period',
							value: this.periodField.list[0]
						});
					}
				}
				this.errorMessage = '';
				this.calcValue = '0.00';
			},
			immediate: true
		}
	},

	components: {
		notice: __WEBPACK_IMPORTED_MODULE_8__components_elements_notice___default.a,
		Field: __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield___default.a
	}

});

/***/ }),
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Notice',

	props: ['text', 'small', 'index'],
	data: function data() {
		return {
			answerVisible: false,
			Index: 'first',
			answerBlock: null
		};
	},
	created: function created() {
		if (this.index) this.Index = this.index;
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('scroll', this.scrollHandler);
		document.addEventListener('mousedown', this.clickHandler);

		this.answerBlock = document.createElement('div');
		this.answerBlock.className = 'w5-question-answer';
		this.answerBlock.innerHTML = this.text;

		var _close = document.createElement('span');
		_close.className = 'close';
		_close.title = this.localeFtc('main/close');
		_close.innerHTML = '×';

		this.answerBlock.insertBefore(_close, this.answerBlock.firstChild);
		document.body.appendChild(this.answerBlock);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('scroll', this.scrollHandler);
		document.removeEventListener('mousedown', this.clickHandler);
		document.body.removeChild(this.answerBlock);
	},

	methods: {
		ShowAnswer: function ShowAnswer() {
			var _el = this.$refs['w5-question-block-' + this.Index];
			var _coord = this.getElementOffset(_el, true);
			var _left = _coord.left - 150;

			if (_left < 20) _left = 20;
			if (_left > this.$store.state.windowWidth - 300 - 20) _left = this.$store.state.windowWidth - 300 - 20;

			this.setStyle({
				'top': _coord.top - 20 + 'px',
				'left': _left + 'px',
				'display': 'inline-block'
			});
			this.answerVisible = true;
		},
		Hide: function Hide() {
			if (!this.answerVisible) return;
			this.setStyle({
				'display': 'none'
			});
			this.answerVisible = false;
		},
		clickHandler: function clickHandler(e) {
			this.Hide();
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) this.Hide();
		},
		scrollHandler: function scrollHandler(e) {
			this.Hide();
		},
		setStyle: function setStyle(props) {
			for (var _prop in props) {
				this.answerBlock.style[_prop] = props[_prop];
			}
		}
	}

});

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "w5-question-block",
    class: {
      'small': _vm.small
    }
  }, [_c('span', {
    ref: 'w5-question-block-' + _vm.Index,
    staticClass: "w5-question",
    on: {
      "click": _vm.ShowAnswer
    }
  }, [_vm._v("?")])])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showList),
      expression: "!showList"
    }],
    staticClass: "modal-container calc-form",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/calculator')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body for-calc"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    staticClass: "position-relative"
  }, [(_vm.serviceField) ? _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.serviceField.list && _vm.serviceField.list.length) ? _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/calculator_description')),
      expression: "localeFtc('service/calculator_description')"
    }],
    staticClass: "description"
  }) : _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])]) : _vm._e(), _vm._v(" "), (_vm.serviceField && _vm.serviceField.list && _vm.serviceField.list.length && _vm.serviceField.groupsMap && _vm.serviceField.groupsMap.size) ? _c('div', {
    staticClass: "w5-form-row services"
  }, _vm._l((_vm.serviceField.groupsMap.entries()), function(service, idx) {
    return _c('div', {
      key: idx,
      staticClass: "service-item"
    }, [_c('div', {
      staticClass: "step-number"
    }, [_c('span', {
      staticClass: "step-number-block"
    }, [_vm._v(_vm._s(idx + 1))]), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.groupNames[service[0]])))])]), _vm._v(" "), _c('div', {
      staticClass: "services-list"
    }, [(service && service[1] && service[1].list && service[1].list.length <= _vm.showServicesCount) ? _vm._l((service[1].list), function(item, idx) {
      return _c('div', {
        key: idx,
        staticClass: "services-list-item",
        class: {
          noprolong: !item.autoprolong
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(item.name)) + " → " + _vm._s(_vm.rounding(item.cost)) + " "), _c('span', {
        directives: [{
          name: "withSafeTags",
          rawName: "v-withSafeTags",
          value: (_vm.localeFtc('main/ruble')),
          expression: "localeFtc('main/ruble')"
        }]
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\n\t\t\t\t\t\t\t\t\t\t\t"), (!item.autoprolong) ? _c('notice', {
        staticStyle: {
          "margin-left": "5px"
        },
        attrs: {
          "text": _vm._f("ftc")('service/calculator_notice'),
          "small": true
        }
      }) : _vm._e()], 1)
    }) : [_vm._l((service[1].list), function(item, idx) {
      return (idx <= (_vm.showServicesCount - 1)) ? _c('div', {
        key: idx,
        staticClass: "services-list-item",
        class: {
          noprolong: !item.autoprolong
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(item.name)) + " → " + _vm._s(_vm.rounding(item.cost)) + " "), _c('span', {
        directives: [{
          name: "withSafeTags",
          rawName: "v-withSafeTags",
          value: (_vm.localeFtc('main/ruble')),
          expression: "localeFtc('main/ruble')"
        }]
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\n\t\t\t\t\t\t\t\t\t\t\t"), (!item.autoprolong) ? _c('notice', {
        staticStyle: {
          "margin-left": "5px"
        },
        attrs: {
          "text": _vm._f("ftc")('service/calculator_notice'),
          "small": true
        }
      }) : _vm._e()], 1) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "cutter",
      on: {
        "click": function($event) {
          return _vm.showCutted(idx, _vm.groupNames[service[0]], service[1].list)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")('calc/and_more')) + " " + _vm._s(service[1].list.length - _vm.showServicesCount) + "...")])]], 2)])
  }), 0) : _vm._e()])])]), _vm._v(" "), (_vm.serviceField && _vm.serviceField.list && _vm.serviceField.list.length) ? _c('div', {
    staticClass: "modal-footer calculator"
  }, [_c('div', {
    staticClass: "w5-form-row calc-value"
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  }) : (_vm.errorMessage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.errorMessage)))]) : _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('plan/cost')) + ": " + _vm._s(_vm.rounding(_vm.calcValue)) + " "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row period"
  }, [_c('Field', {
    attrs: {
      "crud": "service",
      "action": "calc",
      "isVisibleRow": true,
      "Field": _vm.periodField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "valueChanged": _vm.fieldChanged
    },
    model: {
      value: (_vm.periodField.value),
      callback: function($$v) {
        _vm.$set(_vm.periodField, "value", $$v)
      },
      expression: "periodField.value"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    attrs: {
      "disabled": _vm.errorMessage || _vm.calcValue === '0.00' || !_vm.calcValue ? 'disabled' : false
    },
    on: {
      "click": _vm.topupBalance
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('bonus/rule_replenishment')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "modal-container calc-form",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/calculator')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showList = false
      }
    }
  }, [_vm._v("←")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body show-list"
  }, [_c('div', {
    staticClass: "services-list shown"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_c('span', {
    staticClass: "step-number-block"
  }, [_vm._v(_vm._s(_vm.showList.n + 1))]), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.showList.name)))])]), _vm._v(" "), _vm._l((_vm.showList.list), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "services-list-item",
      class: {
        noprolong: !item.autoprolong
      }
    }, [_c('strong', [_vm._v("•")]), _vm._v(" " + _vm._s(_vm._f("ftc")(item.name)) + " → "), _c('strong', [_vm._v(_vm._s(_vm.rounding(item.cost)) + " "), _c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('main/ruble')),
        expression: "localeFtc('main/ruble')"
      }]
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)))])])
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-70174d54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__(130);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'rackGraphic',

	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],

	props: {
		visible: {
			type: Boolean,
			required: true
		},
		rack: {
			type: Object,
			required: false
		},
		filters: {
			type: Object
		}
	},

	data: function data() {
		return {
			dialogVisible: this.visible,
			Data: null,
			Devices: null,
			ZeroDevices: null,
			deviceNameStyle: { display: 'none', top: 0, left: 0 },
			deviceNameText: ''
		};
	},

	computed: {
		unitsCount: function unitsCount() {
			if (!this.rack || !this.rack.rack_units) return 0;

			var tmp = this.rack.rack_units.split('/');
			if (!tmp || !tmp.length || tmp.length !== 2) return 0;

			return parseInt(tmp[1], 10);
		},
		rackPlace: function rackPlace() {
			if (!this.rack) return null;

			return {
				id: this.rack.datacenter_id,
				name: this.rack.datacenter_name,
				country: this.rack.datacenter_country
			};
		}
	},

	methods: {
		hideDialog: function hideDialog() {
			this.$emit('onClose');
		},
		requestData: function requestData() {
			var _this = this;

			if (!this.rack || !this.rack.rack_id) return;

			this.$http.get(this.APIServerUrl + '/rack/view/' + this.rack.rack_id).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt.status === 'ok' && _dt.rack) {
					_this.Data = _dt;
					_this.generateTable();
				}
			});
		},
		deviceStyle: function deviceStyle(device) {
			if (!device || !device.__top) return false;
			return 'left: ' + device.__left + '; top: ' + device.__top + '; width: ' + device.__width + '; height: ' + device.__height + '; z-index: ' + device.__zIndex + ';';
		},
		unitY: function unitY(unitNo) {
			return (this.unitsCount - unitNo) * 24;
		},
		generateTable: function generateTable() {
			var _this2 = this;

			this.Devices = null;
			this.ZeroDevices = null;

			if (!this.unitsCount) return;
			if (!this.Data || !this.Data.rackdevice || !this.Data.rackdevice.length) return;

			this.Devices = [];
			this.ZeroDevices = [];
			var crossed = {};

			this.Data.rackdevice.forEach(function (d, z, a) {
				var device = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, d);

				var unitTop = d.device_unit + d.device_units - 1;
				var unitBottom = d.device_unit;

				if (unitTop > 0 && unitBottom > 0) {
					if (!(z in crossed)) crossed[z] = [];
					crossed[z].push(d.device_id);

					var count = 1;
					a.forEach(function (_d) {
						if (d.device_id !== _d.device_id) {
							var _unitTop = _d.device_unit + _d.device_units - 1;
							var _unitBottom = _d.device_unit;

							var isCross = false;

							if (unitTop >= _unitTop && _unitTop >= unitBottom) isCross = true;

							if (_unitTop >= unitTop && unitTop >= _unitBottom) isCross = true;

							if (_unitTop <= 0 || _unitBottom <= 0) isCross = false;

							if (isCross) {
								count++;
								crossed[z].push(_d.device_id);
							}
						}
					});

					device.__top = _this2.unitY(unitTop) + 1 + 'px';
					device.__left = '30px';
					device.__height = d.device_units * 24 - 2 + 'px';
					device.__width = count <= 1 ? 'calc(100% - 30px)' : 'calc(' + 100 / count + '% - ' + 30 / count + 'px - 2px)';
					device.__zIndex = 1;
					device.__count = count;

					_this2.Devices.push(device);
				} else {
					_this2.ZeroDevices.push(device);
				}
			});

			if (this.ZeroDevices && this.ZeroDevices.length) {
				this.ZeroDevices.forEach(function (z, i, a) {
					var count = a.length;

					z.__top = _this2.unitY(0) + 1 + 'px';
					z.__left = 'calc(31px + ' + i + ' * (' + 100 / count + '% - ' + 30 / count + 'px))';
					z.__height = '22px';
					z.__width = count <= 1 ? 'calc(100% - 30px)' : 'calc(' + 100 / count + '% - ' + 30 / count + 'px - 2px)';
					z.__zIndex = 1;
					z.__count = count;
				});
			}

			for (var c in crossed) {
				if (!crossed[c] || crossed[c].length <= 1) delete crossed[c];else crossed[c].sort();
			}

			var groups = null;
			if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(crossed).length) {
				groups = [];

				var _loop = function _loop(_c) {
					if (!groups.length) groups.push(crossed[_c]);else {
						var found = groups.some(function (arr) {
							if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(crossed[_c])) {
								return true;
							}
						});
						if (!found) groups.push(crossed[_c]);
					}
				};

				for (var _c in crossed) {
					_loop(_c);
				}
			}

			if (groups && groups.length) {
				groups.forEach(function (g, i) {
					g.sort(function (deviceId1, deviceId2) {
						var units1 = 0;
						var units2 = 0;

						_this2.Data.rackdevice.forEach(function (d) {
							if (d.device_id === deviceId1) {
								units1 = d.device_units;
							}
							if (d.device_id === deviceId2) {
								units2 = d.device_units;
							}
						});

						if (units1 > units2) return -1;
						if (units1 < units2) return 1;
						return 0;
					});

					g.forEach(function (id, ii) {
						_this2.Devices.some(function (dev) {
							if (dev.device_id === id) {
								if (ii > 0) {
									var count = dev.__count;
									dev.__left = 'calc(31px + ' + ii + ' * (' + 100 / count + '% - ' + 30 / count + 'px))';
								}

								return true;
							}
						});
					});
				});
			}
		},
		deviceNameShow: function deviceNameShow(device, event) {
			if (!device || !event || !event.currentTarget) {
				this.deviceNameText = '';
				this.deviceNameStyle = { display: 'none', top: 0, left: 0 };
				return;
			}

			var _coor = this.getElementOffset(event.currentTarget, true);
			var _width = event.currentTarget.offsetWidth;
			this.$set(this, 'deviceNameStyle', {
				display: 'block',
				top: _coor.top - 4 + 'px',
				left: _coor.left + 10 + (_width && !isNaN(_width) ? _width / 2 : 30) + 'px'
			});

			var arr = [];
			this.deviceNameText = '';

			if (device.device_name) arr.push('<b>' + device.device_name + '</b>');
			if (device.device_server_type) arr.push(this.localeFtc(device.device_server_type));
			if (device.device_spec) arr.push(device.device_spec);

			if (arr.length) this.deviceNameText = arr.join('<br>');
		},
		deviceNameHide: function deviceNameHide() {
			this.deviceNameText = '';
			this.deviceNameStyle = { display: 'none', top: 0, left: 0 };
		}
	},

	watch: {
		visible: {
			handler: function handler(visible) {
				if (visible) this.requestData();else {
					this.Data = null;
					this.Devices = null;
					this.ZeroDevices = null;
				}

				this.dialogVisible = visible;
			},
			immediate: true
		}
	}

});

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container rack",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('rack/rack')) + ":  \n\t\t\t\t\t"), (_vm.rack && _vm.rack.rack_id && _vm.rack.rack_name) ? _c('linkComponent', {
    attrs: {
      "url": '/rack/view/' + _vm.rack.rack_id,
      "text": _vm.rack.rack_name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.unitsCount > 0) ? _c('div', {
    staticClass: "rack-wrapper",
    style: (("height: calc(" + (_vm.unitsCount + (_vm.ZeroDevices && _vm.ZeroDevices.length ? 1 : 0)) + " * 24px)"))
  }, [_vm._l((_vm.unitsCount), function(idx) {
    return _c('div', {
      key: idx,
      staticClass: "rack-unit-no",
      style: ('left: 0; top: ' + (idx - 1) * 24 + 'px')
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.unitsCount - idx + 1) + "\n\t\t\t\t\t")])
  }), _vm._v(" "), (_vm.Devices && _vm.Devices.length) ? [_vm._l((_vm.Devices), function(dev, jdx) {
    return _c('a', {
      key: 'dev-' + jdx,
      staticClass: "rack-unit-dev",
      class: {
        sr: dev.device_type === 'rackdevice/server', sw: dev.device_type === 'rackdevice/switch'
      },
      style: (_vm.deviceStyle(dev)),
      attrs: {
        "target": "_blank",
        "href": '/rackdevice/view/' + dev.device_id
      },
      on: {
        "mouseenter": function($event) {
          return _vm.deviceNameShow(dev, $event)
        },
        "mouseleave": _vm.deviceNameHide
      }
    }, [_c('span', {
      staticClass: "online-status-before",
      class: {
        active: dev.device_ports_active === true
      }
    }, [_vm._v("●")]), _vm._v(" "), (dev.__count <= 3) ? _c('span', [_vm._v(" " + _vm._s(dev.device_name))]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deviceNameText),
      expression: "deviceNameText"
    }],
    staticClass: "device-name",
    style: (_vm.deviceNameStyle)
  })] : _vm._e(), _vm._v(" "), (_vm.ZeroDevices && _vm.ZeroDevices.length) ? [_c('div', {
    staticClass: "rack-unit-no",
    style: ('left: 0; top: ' + _vm.unitsCount * 24 + 'px')
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.ZeroDevices), function(zDev, zdx) {
    return _c('a', {
      key: 'zdev-' + zdx,
      staticClass: "rack-unit-dev zero",
      style: (_vm.deviceStyle(zDev)),
      attrs: {
        "target": "_blank",
        "href": '/rackdevice/view/' + zDev.device_id
      },
      on: {
        "mouseenter": function($event) {
          return _vm.deviceNameShow(zDev, $event)
        },
        "mouseleave": _vm.deviceNameHide
      }
    }, [_c('span', {
      staticClass: "online-status-before",
      class: {
        active: zDev.device_ports_active === true
      }
    }, [_vm._v("●")]), _vm._v(" "), (zDev.__count <= 3) ? _c('span', [_vm._v(" " + _vm._s(zDev.device_name))]) : _vm._e()])
  })] : _vm._e(), _vm._v(" "), (_vm.Devices && _vm.Devices.length) ? _c('div', {
    staticClass: "legend"
  }, [_c('span', {
    staticClass: "sr"
  }, [_vm._v(_vm._s(_vm._f("ftc")('rackdevice/server')))]), _vm._v(" "), _c('span', {
    staticClass: "sw"
  }, [_vm._v(_vm._s(_vm._f("ftc")('rackdevice/switch')))]), _vm._v(" "), (_vm.ZeroDevices && _vm.ZeroDevices.length) ? _c('span', {
    staticClass: "zero"
  }, [_vm._v("zero unit")]) : _vm._e()]) : _vm._e()], 2) : _c('div', {
    staticClass: "rack-wrapper empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  })])]), _vm._v(" "), (_vm.rackPlace && _vm.rackPlace.id && _vm.rackPlace.name) ? _c('div', {
    staticClass: "modal-footer rack"
  }, [(_vm.rack && _vm.rack.rack_type) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")((_vm.filters && _vm.filters.rack_type && _vm.filters.rack_type.list && _vm.filters.rack_type.list[_vm.rack.rack_type]) || _vm.rack.rack_type)))]) : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/datacenter/view/' + _vm.rackPlace.id,
      "text": _vm.rackPlace.name,
      "flagicon": 'flag-icon-' + _vm.rackPlace.country
    }
  }), _vm._v(" "), (_vm.rack && _vm.rack.rack_units) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_units))]) : _vm._e(), _vm._v(" "), (_vm.rack && _vm.rack.rack_power) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_power))]) : _vm._e(), _vm._v(" "), (_vm.rack && _vm.rack.rack_price) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_price))]) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_previewimg__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_previewimg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_previewimg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_money__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_linkifyjs_html__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'viewComponent',
	data: function data() {
		return {
			isValid: false,

			Obj: false,

			Link: {
				name: false,
				title: false,
				url: false,
				text: false,
				flag: null,
				online: false,
				image: null,
				access: false
			},

			viewType: false,

			showTokenUpdateModal: false,
			tokenUpdateModalTimer: 0,
			tokenUpdateModalTimerHandle: null
		};
	},

	props: ['crud', 'realCrudName', 'data', 'rowCount', 'y', 'x', 'field', 'firstElement', 'objectId'],

	computed: {
		styleParent: function styleParent() {
			var style = [];

			var w = 'width: ' + 100 / (this.rowCount ? this.rowCount : 1) + '%';

			if (this.viewType === 'image') {
				w = 'width: 110px';
				style.push('top: 1px');
			} else {
				if (this.viewHasImage && this.$store.state.windowWidth > 767) {
					if (this.crud === 'admin') {
						if (this.y === '1') w = 'width: calc(33.33% - 36.67px)';
						if (this.y === '2') {
							w = this.rowCount === 1 ? 'width: calc(100% - 110px)' : 'width: calc(50% - 55px)';
							if (this.x === 0) {
								style.push('margin-left: 110px');
								style.push('margin-top: -55px');
							} else if (this.x >= 1) {
								style.push('margin-top: -55px');
							}
						}
					}

					if (this.crud === 'user') {
						if (this.y === '1') w = 'width: calc(50% - 55px)';
						if (this.y === '2') {
							style.push('margin-top: -55px');
							if (this.rowCount > 1) {
								if (this.x === 0) {
									w = 'width: calc(50% - 110px)';
									style.push('margin-left: 110px');
								} else {
									w = 'width: 50%';
								}
							} else {
								style.push('margin-left: 110px');
							}
						}
					}

					if (this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup' || this.crud === 'templategroup') {
						if (+this.y <= 2) w = 'width: calc(50% - 55px)';
						if (this.y === '2') {
							if (this.x === 0) {
								style.push('margin-left: 110px');
								style.push('margin-top: -55px');
							} else if (this.x >= 1) {
								style.push('margin-top: -55px');
							}
						}
					}

					if (this.crud === 'paymentsaved') {
						if (this.y === '1') w = 'width: calc(50% - 55px)';
						if (this.y === '2') {
							style.push('margin-top: -55px');
							if (this.rowCount > 1) {
								if (this.x === 0) {
									w = 'width: calc(50% - 110px)';
									style.push('margin-left: 110px');
								} else {
									w = 'width: 50%';
								}
							} else {
								style.push('margin-left: 110px');
							}
						}
					}
				}
			}

			style.push(w);

			return style.join(';');
		},
		styleWrapper: function styleWrapper() {
			if (this.viewType === 'image') {
				if (this.crud === 'paymentsaved') {
					return 'padding: 0; background-color: transparent; text-align: center; display: flex; align-items: center; justify-content: center; min-height: 102px;';
				}

				return 'padding: 0; background-color: transparent; text-align: center;';
			}

			return false;
		},
		viewHasImage: function viewHasImage() {
			if (this.crud === 'admin' || this.crud === 'user' || this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup' || this.crud === 'paymentsaved') {
				var _field = this.firstElement;
				if (_field.indexOf('avatar_path') >= 0 || _field.indexOf('image_path') >= 0 || _field.indexOf('saved_image') >= 0) return true;
			}

			return false;
		},
		srcImage: function srcImage() {
			return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + this.Obj['value'];
		},
		isBoolField: function isBoolField() {
			if (this.crud === 'certificate' && this.field === 'service_autoprolong') return true;

			return false;
		},
		tokenUpdateModalButtonTitle: function tokenUpdateModalButtonTitle() {
			if (this.tokenUpdateModalTimer > 0) return this.localeFtc('user/token_update_timer').replace('{count}', this.tokenUpdateModalTimer);else return this.localeFtc('main/edit');
		},
		arrayViewTitle: function arrayViewTitle() {
			var _el = this.Obj[0];

			if (_el && (typeof _el === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_el)) === 'object') {
				for (var prop in _el) {
					if (_el[prop] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_el[prop]) === 'object' && _el[prop].title) {
						return _el[prop].title;
					}
				}
			}

			return this.field;
		}
	},
	created: function created() {
		this.Obj = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].findObj(this.field, this.data, this.crud);
		if (!this.Obj || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.Obj) !== 'object') return;

		if ('title' in this.Obj || 'value' in this.Obj) {
			this.isValid = 1;

			if ('type' in this.Obj) {
				if (this.Obj['type'] === 'text' || this.Obj['type'] === 'integer') this.viewType = 'text';else if (this.Obj['type'] === 'list' && 'list' in this.Obj && this.Obj['list']) this.viewType = 'list';else if (this.Obj['type'] === 'list' && !('list' in this.Obj) && 'value' in this.Obj && Array.isArray(this.Obj['value'])) this.viewType = 'array';else if (this.Obj['type'] === 'textarea') this.viewType = 'textarea';else if (this.Obj['type'] === 'datetime') this.viewType = 'datetime';else if (this.Obj['type'] === 'date') this.viewType = 'date';else if (this.Obj['type'] === 'boolean') this.viewType = 'bool';else if (this.Obj['type'] === 'image') this.viewType = 'image';else if (this.Obj['type'] === 'money') this.viewType = 'money';else if (this.Obj['type'] === 'email') this.viewType = 'email';else if (this.Obj['type'] === 'skype') this.viewType = 'skype';else if (this.Obj['type'] === 'file') {
					if (this.crud === 'notes' && this.field === 'note_file') {
						this.viewType = 'note_file';
					} else console.log('1++++++++++++++++++++++++++++ ' + this.field);
				}

				if (this.crud === 'rackdevice' && this.Obj['type'] === 'text' && (this.field === 'device_ip' || this.field === 'device_host')) {
					this.viewType = 'externalUrl';
				}

				if (this.crud === 'user' && this.Obj['type'] === 'text' && this.field === 'user_access_token') {
					this.isValid = 5;
					this.viewType = 'userToken';
				}

				if (this.crud === 'logsIpBlackList' && this.Obj['type'] === 'text' && this.field === 'status') {
					this.isValid = 6;
					this.viewType = 'status';
					this.Obj.status_color = this.data && this.data.__ip && this.data.__ip.status_color ? this.data.__ip.status_color : false;
				}
			} else if (this.field === 'service_data') {
					this.isValid = 4;
					this.viewType = 'serviceData';
				}
		} else if (this.isLink()) {
			this.isValid = this.makeLink();
		} else {
			if (this.field === 'permissions') {
				this.isValid = 3;
				this.viewType = 'permissions';
			} else if (Array.isArray(this.Obj)) {
				this.isValid = 7;
				this.viewType = 'arrayObjects';
				console.log('!!!!!!!');
			} else {
				console.log('2++++++++++++++++++++++++++++ ' + this.field);
			}
		}
	},
	mounted: function mounted() {
		window.addEventListener('storage', this.onLocalStorageEvent);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('storage', this.onLocalStorageEvent);

		if (this.tokenUpdateModalTimerHandle) {
			clearInterval(this.tokenUpdateModalTimerHandle);
			this.tokenUpdateModalTimerHandle = null;
		}
	},

	methods: {
		isLink: function isLink() {
			var _isLink = 0;
			var nm = '';
			var p = void 0;
			var obj = this.Obj;

			if (obj === null || obj === undefined || obj === false || obj === '') return false;

			for (p in obj) {
				if (obj.hasOwnProperty(p)) if (/_name$/i.test(p) || /_id$/i.test(p) || /_login$/i.test(p)) {
					nm = p.match(/(.*?)_name$/);
					if (nm === null) {
						nm = p.match(/(.*?)_id$/);
						if (nm === null) {
							nm = p.match(/(.*?)_login$/);
							if (nm === null) {
								if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле');
								return false;
							} else nm = nm[1];
						} else nm = nm[1];
					} else nm = nm[1];
					_isLink++;
				}
			}
			if (_isLink === 2 && this.field !== this.realCrudName) {
				this.Link.name = nm;
				_isLink = true;
			} else _isLink = false;

			return _isLink;
		},
		makeLink: function makeLink() {
			var _id = -1;
			if (this.Link.name + '_id' in this.Obj && 'value' in this.Obj[this.Link.name + '_id']) _id = this.Obj[this.Link.name + '_id']['value'];

			var _newName = this.Link.name;
			if (this.Link.name === 'program') _newName = 'partnerprogram';
			if (this.Link.name === 'group') {
				_newName = 'servergroup';
				if (this.Obj && this.Obj.group_id && String(this.Obj.group_id.title).indexOf('templategroup') > -1) {
					_newName = 'templategroup';
				}
			}
			if (this.Link.name === 'service_type') _newName = 'servicetype';
			if (this.Link.name === 'key') _newName = 'sshkey';
			if (this.Link.name === 'device') _newName = 'rackdevice';

			var _nm = _newName;

			if ('user_type' in this.Obj) {
				_nm = this.Obj['user_type'];
			} else if ('object_type' in this.Obj && 'value' in this.Obj['object_type']) {
				_nm = this.Obj['object_type']['value'];
			}

			if ('datacenter_country' in this.Obj && 'value' in this.Obj['datacenter_country']) {
				this.Link.flag = 'flag-icon-' + this.Obj['datacenter_country']['value'];
			}

			if ('user_online' in this.Obj && this.Obj['user_online'] === true && this.$store.state.user_type === 'admin') {
				this.Link.online = true;
			}

			if ('template_image' in this.Obj && 'value' in this.Obj['template_image']) {
				this.Link.image = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + this.Obj['template_image']['value'];
			}

			if ('user_avatar_path' in this.Obj && 'value' in this.Obj['user_avatar_path']) {
				this.Link.image = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + this.Obj['user_avatar_path']['value'];
			}

			if (_id !== null && _id !== undefined && _id !== -1) {
				this.Link.url = '/' + _nm + '/view/' + _id;
			}

			var _value = '';
			if (this.Link.name + '_name' in this.Obj && 'value' in this.Obj[this.Link.name + '_name']) _value = this.Obj[this.Link.name + '_name']['value'];
			if (this.Link.name + '_login' in this.Obj && 'value' in this.Obj[this.Link.name + '_login']) _value = this.Obj[this.Link.name + '_login']['value'];
			this.Link.text = _value;

			if (this.Link.name === 'payment' && 'payment_type' in this.Obj && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.Obj['payment_type']) === 'object' && 'text' in this.Obj['payment_type'] && this.Obj['payment_type']['text']) {
				this.Link.text += ' / ' + String(this.Obj['payment_type']['text']);
			}

			this.Link.title = this.Obj[this.Link.name + '_id']['title'];

			if (this.$store.state.user_type === 'client') {
				var _crudValid = ['servicetype', 'account', 'template', 'plan', 'user', 'admin'];
				this.Link.access = _crudValid.indexOf(_nm) === -1;
			} else this.Link.access = true;

			return 2;
		},
		arrayUrl: function arrayUrl(idx) {
			var o = this.Obj['value'][idx];
			if ((typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(o)) !== 'object') {
				if (this.field === 'user_role' || this.field === 'roles') return '/role/view/' + o;
			}

			var link = '#';
			var id = false;
			var nm = false;

			for (var i in o) {
				if (/_id$/i.test(i)) {
					id = o[i];
					nm = i.match(/(.*?)_id$/);
					if (nm !== null) nm = nm[1];
				}
			}

			if (id && nm) {
				if (this.field === 'plans') link = '/plan/view/' + id;else if (this.field === 'groups') link = '/servergroup/view/' + id;else if (this.field === 'templates') link = '/template/view/' + id;else link = '/' + this.field + '/view/' + id;
			}

			return link;
		},
		arrayText: function arrayText(idx) {
			var o = this.Obj['value'][idx];
			if ((typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(o)) !== 'object') return o;

			var text = '';
			for (var i in o) {
				if (!/_id$/i.test(i)) {
					text = o[i];
					break;
				}
			}

			return text;
		},
		valueFromMultiselect: function valueFromMultiselect(list, val) {
			var _ans = '';
			list.some(function (item) {
				if (item && item.id && String(item.id) === String(val)) {
					_ans = item.name ? item.name : val;
					return true;
				}
			});

			return _ans;
		},
		normalizeBooleanValue: function normalizeBooleanValue(value) {
			return __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(value);
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(account) {
			var _this = this;

			if (this.$store.state.user_type !== 'admin') return;

			if (account) {
				if (!/\d+/.test(account)) return;
				var _accountID = parseInt(account);
				if (isNaN(_accountID) || _accountID < 1) return;

				var _url = this.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				this.$store.commit('accountGlobalFilter', false);

				this.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this.$store.commit('accountGlobalFilter', true);

						if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

						_this.$store.dispatch('getTicketCounters');
						_this.$store.dispatch('getRequestCounter');

						__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
							'title': ' ',
							'message': 'main/set_filter ' + _this.Obj['account_name']['value'],
							'class': 'success',
							'type': 'nourl',
							'id': 'success-message',
							'timeout': 3000
						});

						_this.$emit('needRefresh');

						return;
					}

					_this.$emit('errorFilter', _this.formatRequestError(resGet));
				}, function (resGet) {
					_this.$emit('errorFilter', _this.formatRequestError(resGet));
				});
			} else {
					var _url2 = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

					this.$http.get(_url2).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this.$store.commit('accountGlobalFilter', false);

							if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

							_this.$store.dispatch('getTicketCounters');
							_this.$store.dispatch('getRequestCounter');

							__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': _this.localeFtc('main/filter') + ' ' + _this.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							_this.$emit('needRefresh');

							return;
						}

						_this.$emit('errorFilter', _this.formatRequestError(resGet));
					}, function (resGet) {
						_this.$emit('errorFilter', _this.formatRequestError(resGet));
					});
				}
		},
		linkifyText: function linkifyText(text) {
			if (this.field !== 'note_text') return text;

			return __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html___default()(text, {
				defaultProtocol: 'https',
				validate: {
					url: function url(value) {
						return (/^(http|ftp)s?:\/\//.test(value)
						);
					}
				}
			});
		},
		makeExternalUrl: function makeExternalUrl(value) {
			if (!value) return '';

			var str = String(value);

			if (str.indexOf('https://') === 0) return str;

			if (str.indexOf('http://') === 0) return 'https://' + str.substr(7);

			return 'https://' + str;
		},
		openTokenUpdateModal: function openTokenUpdateModal() {
			var _this2 = this;

			if (!this.isAccess('user/update')) return;
			if (!this.objectId) return;

			__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showTokenUpdateModal = true;
			this.tokenUpdateModalTimer = 5;

			this.tokenUpdateModalTimerHandle = setInterval(function () {
				_this2.tokenUpdateModalTimer--;
				if (_this2.tokenUpdateModalTimer <= 0) {
					clearInterval(_this2.tokenUpdateModalTimerHandle);
					_this2.tokenUpdateModalTimerHandle = null;
				}
			}, 1000);
		},
		hideTokenUpdateModal: function hideTokenUpdateModal() {
			if (this.tokenUpdateModalTimerHandle) {
				clearInterval(this.tokenUpdateModalTimerHandle);
				this.tokenUpdateModalTimerHandle = null;
			}

			__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showTokenUpdateModal = false;
			this.hideModalMask();
		},
		tokenUpdateModalCallback: function tokenUpdateModalCallback() {
			var _this3 = this;

			if (this.tokenUpdateModalTimer > 0) return;
			if (!this.isAccess('user/update')) return;
			if (!this.objectId) return;

			this.hideTokenUpdateModal();

			this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].APIServerUrl + '/user/update/' + this.objectId + '?additional=setNewToken').then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this3.$http.post(res.url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;
						if (_dt && _dt['status'] === 'ok') {
							__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'forget/success',
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 2000
							});

							_this3.$emit('needRefresh');

							return;
						}

						_this3.$emit('errorFilter', _this3.formatRequestError(resPost));
					}, function (resPost) {
						_this3.$emit('errorFilter', _this3.formatRequestError(resPost));
					});

					return;
				}

				_this3.$emit('errorFilter', _this3.formatRequestError(res));
			}, function (res) {
				_this3.$emit('errorFilter', _this3.formatRequestError(res));
			});
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.$emit('needRefresh');
			}
		}
	},

	watch: {
		'data': function data(value) {
			this.Obj = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].findObj(this.field, this.data);
		}
	},

	components: {
		previewImageComponent: __WEBPACK_IMPORTED_MODULE_4__components_elements_previewimg___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_5__components_elements_money___default.a
	}

});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-3093b23a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'previewImageComponent',

	props: ['url', 'title', 'text', 'size', 'noPreview'],
	data: function data() {
		return {
			currentUrl: '/static/img/loading32.gif',
			imageReady: false,
			imageWidth: 0,
			imageHeight: 0,
			modalWidth: 0,

			showModal: false
		};
	},
	created: function created() {
		var _this = this;

		var image = new Image();
		image.src = this.url;

		image.onload = function () {
			_this.$refs['image'].src = image.src;
			_this.$refs['imageInDialog'].src = image.src;

			_this.imageWidth = image.naturalWidth;
			_this.imageHeight = image.naturalHeight;

			var windowWidth = _this.$store.state.windowWidth;
			var windowHeight = _this.$store.state.windowHeight;

			var _delta = 40;

			if (windowWidth <= 420) {
				_delta = 20;
			}
			if (windowWidth > 420 && windowWidth <= 767) {
				_delta = 30;
			}
			if (windowWidth > 767 && windowWidth <= 900) {
				_delta = 40;
			} else _delta = 60;

			var maxWidth = windowWidth - _delta;
			var maxHeight = windowHeight - 190;
			if (maxWidth < 100) maxWidth = 100;
			if (maxHeight < 100) maxHeight = 100;

			if (_this.imageWidth > maxWidth || _this.imageHeight > maxHeight) {
				var _k = 1;
				if (_this.imageWidth > _this.imageHeight) _k = maxWidth / _this.imageWidth;else _k = maxHeight / _this.imageHeight;

				_this.imageWidth = parseInt(_this.imageWidth * _k);
				_this.imageHeight = parseInt(_this.imageHeight * _k);

				if (_this.imageHeight > maxHeight) {
					_k = maxHeight / _this.imageHeight;
					_this.imageWidth = parseInt(_this.imageWidth * _k);
					_this.imageHeight = parseInt(_this.imageHeight * _k);
				}
			}

			_this.modalWidth = _this.imageWidth + 30;
			if (_this.modalWidth < 200) _this.modalWidth = 200;

			_this.imageReady = true;
		};
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			document.addEventListener('keydown', this.keyDownHandler);
		});
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	methods: {
		keyDownHandler: function keyDownHandler(e) {
			if (this.showModal && e.keyCode === 27) {
				this.hideModalDialog();
			}
		},
		showPreviewDialog: function showPreviewDialog() {
			if (this.noPreview) return;
			__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showModal = true;
		},
		hideModalDialog: function hideModalDialog() {
			__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showModal = false;
			this.hideModalMask();
		}
	}

});

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.url !== undefined && _vm.url !== null && _vm.url !== false && _vm.url !== '') ? _c('div', {
    staticClass: "w5-preview-image-wrapper"
  }, [_c('img', {
    ref: "image",
    staticClass: "w5-view-field-preview-image",
    class: {
      'ready-image': _vm.imageReady, 'cursor-pointer-default': _vm.noPreview
    },
    attrs: {
      "src": _vm.currentUrl,
      "title": _vm._f("ftc")(_vm.text ? _vm.text : '')
    },
    on: {
      "click": _vm.showPreviewDialog
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.text ? _vm.text : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "imageInDialog",
    style: ('width:' + _vm.imageWidth + 'px; height:' + _vm.imageHeight + 'px;')
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "w5-preview-in-dialog-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.title ? _vm.title : '')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.size ? '(' + _vm.size + ')' : '')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-submit w5-file-uploader-load-button pull-right",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-view-field",
    style: (_vm.styleParent)
  }, [(_vm.isValid === 1) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [(_vm.viewType !== 'image' && !_vm.isBoolField) ? _c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]) : _vm._e(), _vm._v(" "), (_vm.viewType === 'text') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e()]) : (_vm.viewType === 'list') ? _c('div', {
    staticClass: "w5-view-field-value",
    class: _vm.field === 'data[services]' || _vm.field.indexOf('params[') > -1 ? false : 'w5-status-color-' + _vm.Obj.value
  }, [(_vm.crud === 'ticketrule' && _vm.field === 'rule_set_label') ? [_c('div', {
    staticClass: "w5-list-ticket-label",
    class: 'ticket-label-color-' + (_vm.Obj.value ? String(_vm.Obj.value).toLowerCase() : ''),
    style: ((_vm.Obj.value ? 'background-color: ' + String(_vm.Obj.value).toLowerCase() : ''))
  })] : [(_vm.Obj.multiselect === true && Array.isArray(_vm.Obj.value) && _vm.Obj.value.length) ? _vm._l((_vm.Obj.value), function(idx, i) {
    return _c('span', {
      key: 'span-' + i
    }, [(i > 0) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("ftc")(_vm.valueFromMultiselect(_vm.Obj.list, idx))))])
  }) : [(_vm.field === 'server_view_type') ? _c('span', {
    class: 'color-type-' + String(_vm.Obj.value),
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.Obj.list[_vm.Obj.value]), (!/_status$/i.test(_vm.field) && !/_register$/i.test(_vm.field) && _vm.field !== 'server_view_type') || (_vm.Obj.value === 'rkn' || _vm.Obj.value === 'infra')))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e(), _vm._v(" "), (/_status$/i.test(_vm.field) && _vm.Obj.text) ? _c('span', [_vm._v("  (" + _vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.Obj.text))) + ")")]) : _vm._e()]]], 2) : (_vm.viewType === 'money') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.Obj.value)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" "), (_vm.Obj.for && _vm.Obj.for !== 'main/ruble') ? _c('span', [_vm._v("/ "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Obj.for))
    }
  })]) : _vm._e()], 1) : (_vm.viewType === 'country') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('span', {
    staticClass: "flag-icon",
    class: 'flag-icon-' + _vm.Obj.value,
    staticStyle: {
      "top": "-1px"
    },
    attrs: {
      "title": _vm.Obj['list'][_vm.Obj.value]
    }
  }), _vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj['list'][_vm.Obj.value])) + "\n\t\t")]) : (_vm.viewType === 'textarea') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [(_vm.Obj.translate === false) ? _c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.linkifyText(_vm.Obj.value)),
      expression: "linkifyText(Obj.value)"
    }],
    staticClass: "w5-view-field-pre"
  }) : _c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.linkifyText(_vm.Obj.value))),
      expression: "localeFtc(linkifyText(Obj.value))"
    }],
    staticClass: "w5-view-field-pre"
  })]) : (_vm.viewType === 'email') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    staticClass: "linkified",
    attrs: {
      "href": 'mailto:' + _vm.Obj.value
    }
  }, [_vm._v(_vm._s(_vm.Obj.value))])]) : (_vm.viewType === 'skype') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    staticClass: "linkified",
    attrs: {
      "href": 'skype:' + _vm.Obj.value + '?call'
    }
  }, [_vm._v(_vm._s(_vm.Obj.value))])]) : (_vm.viewType === 'datetime') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formater_StrDateFormat(_vm.Obj.value, 'd.m.y H:M:S')) + "\n\t\t")]) : (_vm.viewType === 'date') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formater_StrDateFormat(_vm.Obj.value, 'd.m.Y')) + "\n\t\t")]) : (_vm.viewType === 'bool') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [(_vm.isBoolField) ? [_c('input', {
    staticClass: "w5-checkbox-field",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "view-field"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))])] : [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.normalizeBooleanValue(_vm.Obj.value) ? 'main/yes' : 'main/no')) + "\n\t\t\t")]], 2) : (_vm.viewType === 'image') ? _c('img', {
    staticClass: "w5-view-field-image",
    class: {
      'real-height': _vm.crud === 'paymentsaved'
    },
    attrs: {
      "src": _vm.srcImage
    }
  }) : (_vm.viewType === 'array') ? _c('div', {
    staticClass: "w5-view-field-value",
    staticStyle: {
      "white-space": "normal"
    }
  }, [_vm._l((_vm.Obj['value']), function(o, idx) {
    return [_c('linkComponent', {
      key: idx,
      attrs: {
        "url": _vm.arrayUrl(idx),
        "text": _vm.arrayText(idx)
      }
    }), (idx < _vm.Obj['value'].length - 1) ? _c('span', {
      key: 'sepor-' + idx
    }, [_vm._v(", ")]) : _vm._e()]
  })], 2) : (_vm.viewType === 'note_file') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('previewImageComponent', {
    attrs: {
      "url": _vm.APIServerUrl + _vm.Obj['value'],
      "title": _vm._f("ftc")(_vm.Obj['title']),
      "text": _vm._f("ftc")(_vm.Obj['text']),
      "size": _vm.Obj['size']
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "w5-view-field-download-link",
    attrs: {
      "href": _vm.APIServerUrl + _vm.Obj['value']
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "file-download"
    }
  })], 1), _vm._v(" "), (_vm.Obj && _vm.Obj['size']) ? _c('span', [_vm._v(_vm._s(_vm.Obj['size']))]) : _vm._e(), _vm._v(" "), (_vm.Obj && _vm.Obj['text']) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj['text'])))]) : _vm._e()], 1) : (_vm.viewType === 'externalUrl') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    attrs: {
      "href": _vm.makeExternalUrl(_vm.Obj.value),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.value)))])]) : _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isValid === 2 && _vm.Link && _vm.Link.url) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.Link && _vm.Link.url && String(_vm.Link.url).indexOf('/servergroup/') == 0 ? 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap;' : null)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Link.title)))]), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && _vm.Obj['account_id'] && _vm.Obj['account_name']) ? [(!_vm.Obj['global_filter'] || _vm.Obj['global_filter']['value'] != _vm.Obj['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Obj['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Obj['global_filter'] && _vm.Obj['global_filter']['value'] == _vm.Obj['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Obj.server_view_type && ('value' in _vm.Obj.server_view_type)) ? _c('span', {
    class: 'color-type-' + String(_vm.Obj.server_view_type.value),
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), (_vm.Link.access) ? _c('linkComponent', {
    staticClass: "w5-view-field-value",
    attrs: {
      "url": _vm.Link.url,
      "text": _vm.Link.text,
      "flagicon": _vm.Link.flag,
      "imageBefore": _vm.Link.image
    }
  }) : _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Link.text)))]), _vm._v(" "), (_vm.Link.online) ? _c('span', {
    staticClass: "online-status-is-on"
  }, [_vm._v(" ●")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isValid === 3) ? _c('div', {
    style: (_vm.styleWrapper)
  }, [(_vm.viewType === 'permissions') ? _c('table', {
    staticClass: "w5-view-field-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/permissions')))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/object')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("ftc")('main/actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.Obj), function(role, key) {
    return _c('tr', {
      key: 'role-' + key
    }, [_c('td', [_vm._v(_vm._s(_vm._f("ftc")(role.name)))]), _vm._v(" "), _c('td', [_vm._l((role.actions), function(R, k, i) {
      return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(R))), (i < Object.keys(role.actions).length - 1) ? _c('span', {
        key: 'sepor-for-' + i
      }, [_vm._v(", ")]) : _vm._e()]
    })], 2)])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === 4 && _vm.viewType === 'serviceData' && _vm.Obj && _vm.Obj.value && typeof _vm.Obj.value === 'object' && Object.keys(_vm.Obj.value).length) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), _vm._l((_vm.Obj.value), function(val, key) {
    return _c('div', {
      key: 'srv-data-' + key,
      staticClass: "w5-view-field-service-data"
    }, [(Array.isArray(val)) ? [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((val), function(arr, idx) {
      return [(idx > 0) ? _c('br', {
        key: 'br-srv-data-' + idx
      }) : _vm._e(), _vm._v(" "), (typeof arr === 'object') ? [_c('span', {
        key: 'val-srv-data-obj-' + idx,
        staticClass: "w5-view-field-value"
      }, [_vm._v("   " + _vm._s(_vm._f("ftc")(idx)))]), _vm._v(" "), _c('br', {
        key: 'br-srv-data-second-' + idx
      }), _vm._v(" "), _vm._l((arr), function(prop, nm, ix) {
        return [_c('span', {
          key: 's1' + idx + '_' + nm
        }, [_vm._v("       " + _vm._s(_vm._f("ftc")(nm)) + ":")]), _vm._v(" "), _c('span', {
          key: 's2' + idx + '_' + nm
        }, [_vm._v(_vm._s(_vm._f("ftc")(prop)))]), (ix < Object.keys(arr).length - 1) ? _c('br', {
          key: 'spbr' + idx + '_' + nm
        }) : _vm._e()]
      })] : [_c('span', {
        key: 'val-srv-data-str-' + idx
      }, [_vm._v("   " + _vm._s(_vm._f("ftc")(idx)) + ": ")]), _vm._v(" "), _c('span', {
        key: 's3' + idx
      }, [_vm._v(_vm._s(arr))])]]
    })] : (typeof val === 'object') ? [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((val), function(prop, nm, idx) {
      return _c('span', {
        key: 'spp1' + nm
      }, [(typeof prop === 'object') ? [_c('span', [_vm._v("   " + _vm._s(_vm._f("ftc")(nm)) + ":"), _c('br')]), _vm._v(" "), _vm._l((prop), function(prop1, nm1, idx1) {
        return _c('span', {
          key: 'sppp1' + nm1
        }, [(typeof prop1 === 'object') ? [_c('span', [_vm._v("       " + _vm._s(_vm._f("ftc")(nm1)) + ":"), _c('br')]), _vm._v(" "), _vm._l((prop1), function(prop2, nm2, idx2) {
          return _c('span', {
            key: 'spppp1' + nm2
          }, [_c('span', [_vm._v("           " + _vm._s(_vm._f("ftc")(nm2)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop2)))]), _vm._v(" "), (idx2 <= Object.keys(prop1).length - 1) ? _c('br') : _vm._e()])
        })] : [_c('span', [_vm._v("       " + _vm._s(_vm._f("ftc")(nm1)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop1)))]), _vm._v(" "), (idx1 <= Object.keys(prop).length - 1) ? _c('br') : _vm._e()]], 2)
      })] : [_c('span', [_vm._v("   " + _vm._s(_vm._f("ftc")(nm)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop)))]), _vm._v(" "), (idx <= Object.keys(val).length - 1) ? _c('br') : _vm._e()]], 2)
    })] : [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t   " + _vm._s(val) + "\n\t\t\t")]], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isValid === 5 && _vm.Obj && _vm.Obj.value) ? _c('div', {
    staticClass: "w5-view-field-wrapper user-token",
    style: (_vm.styleWrapper)
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('user/token_description')),
      expression: "localeFtc('user/token_description')"
    }],
    staticClass: "note"
  }), _vm._v(" "), (_vm.viewType === 'userToken') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value)) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    attrs: {
      "disabled": !_vm.isAccess('user/update')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openTokenUpdateModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/edit')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTokenUpdateModal),
      expression: "showTokenUpdateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTokenUpdateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/edit')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTokenUpdateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("ftc")('user/token_update_confirm')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tokenUpdateModalTimer >= 0),
      expression: "tokenUpdateModalTimer >= 0"
    }],
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.tokenUpdateModalTimer && _vm.tokenUpdateModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.tokenUpdateModalCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.tokenUpdateModalButtonTitle)))])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isValid === 6) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), (_vm.viewType === 'status') ? _c('div', {
    staticClass: "w5-view-field-value",
    class: _vm.Obj.status_color ? 'w5-status-color-' + String(_vm.Obj.status_color).toLowerCase() : null
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value)) + "\n\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === 7) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.arrayViewTitle)))]), _vm._v(" "), (_vm.viewType == 'arrayObjects') ? _vm._l((_vm.Obj), function(element, idx) {
    return _c('div', {
      key: idx
    }, [(element &&
      element['service_id'] && element['service_id']['value'] &&
      element['service_name'] && element['service_name']['value']) ? [(_vm.isAccess('service/view')) ? _c('linkComponent', {
      staticClass: "w5-view-field-value",
      attrs: {
        "url": ("/service/view/" + (element['service_id']['value'])),
        "text": element['service_name']['value']
      }
    }) : _c('div', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(element['service_name']['value'])))])] : _vm._e()], 2)
  }) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.listData && _vm.listData.title && (_vm.crud === 'ipptrpool' || _vm.crud === 'iphistory')) ? _c('h4', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.listData.title)))]) : _vm._e(), _vm._v(" "), (_vm.listConfig) ? _c('div', {
    key: "mainBlock"
  }, [_c('div', {
    staticClass: "search-and-filters"
  }, [(_vm.listConfig['fast_search'] !== false) ? _c('div', {
    staticClass: "form-inline fast-search"
  }, [_c('Field', {
    ref: "fastSearch",
    staticClass: "fast-search-input",
    class: {
      'logs': _vm.$store.state.user_type === 'admin' && _vm.crud === 'logs'
    },
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "fastSearch",
      "Field": {
        _field_name: 'fastSearch',
        type: 'text',
        title: 'main/all_fields_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true
    },
    on: {
      "event_ClearButtonClicked": _vm.fastSearchClear,
      "fastSearchInput": _vm.fastSearchEvent
    },
    model: {
      value: (_vm.fastSearchValue),
      callback: function($$v) {
        _vm.fastSearchValue = $$v
      },
      expression: "fastSearchValue"
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && _vm.crud === 'logs') ? _c('Field', {
    ref: "ipBlackList",
    staticClass: "ip-list-input",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "ipBlackList",
      "Field": {
        _field_name: 'ipBlackList',
        type: 'text',
        title: 'main/ip',
        '_visible': true
      },
      "removeRightPadding": true,
      "searchButton": true
    },
    on: {
      "event_SearchButtonClicked": _vm.ipBlackListClick,
      "enterKeyDown": _vm.ipBlackListClick
    },
    model: {
      value: (_vm.ipBlackListValue),
      callback: function($$v) {
        _vm.ipBlackListValue = $$v
      },
      expression: "ipBlackListValue"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-inline filter-links-block"
  }, [(_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['period'] && _vm.filters['period']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['period']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('period')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('filter/period')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['radio'] && _vm.filters.radio) ? [_vm._l((_vm.filters.radio), function(radio, idx) {
    return [(radio.visible !== -1) ? _c('span', {
      key: 'radio-filter' + idx,
      staticClass: "widget-link",
      class: {
        'widget-link-grayed': _vm.filters['radio'][idx]['visible'] === true
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter('radio', idx)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(radio.title))) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]
  })] : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['select'] && _vm.filters.select) ? [_vm._l((_vm.filters.select), function(select, idx) {
    return [(select.visible !== -1) ? _c('span', {
      key: 'select-filter' + idx,
      staticClass: "widget-link",
      class: {
        'widget-link-grayed': _vm.filters['select'][idx]['visible'] === true, 'hidden': _vm.crud === 'document' && _vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter('select', idx)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(select.title))) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]
  })] : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['ticketLabel'] && _vm.filters['ticketLabel']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['ticketLabel']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('ticketLabel')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/label')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['diskType'] && _vm.filters['diskType']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['diskType']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('diskType')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/type')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['myTickets'] && !_vm.isCrudFilterOnMyTicket) ? _c('span', {
    staticClass: "widget-link",
    on: {
      "click": _vm.myTicketsActivate
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/mine_tickets')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['planParams'] && _vm.filters['planParams']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['planParams']['visible'] === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleFilter('planParams')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/parameters')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['bool'] && _vm.filters.bool.visible !== -1) ? _c('filterBool', {
    attrs: {
      "name": "switcher",
      "titleTrue": _vm.listConfig['filters']['bool']['title_true'],
      "titleFalse": _vm.listConfig['filters']['bool']['title_false'],
      "value": _vm.filters.bool.value
    },
    on: {
      "input": _vm.filterBoolEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['logs'] && _vm.filters['logs']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['logs']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('logs')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('logs/action')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.crud === 'ticket' && _vm.$store.state.user_type === 'client' && _vm.isUnreadedTickets && _vm.isAccess('ticket/update')) ? _c('span', {
    staticClass: "widget-link",
    attrs: {
      "title": _vm._f("ftc")('ticket/mark_all_as_readed_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.markTicketsAsReaded($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/mark_all_as_readed')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.crud === 'operation' && _vm.$store.state.user_type === 'admin') ? _c('span', {
    staticClass: "widget-link",
    attrs: {
      "title": _vm._f("ftc")('operation/convert_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.operationTripleFilter($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/convert_title')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.countActiveFilters > 1) ? _c('font-awesome-icon', {
    staticClass: "remove-all-filters",
    attrs: {
      "icon": "times-circle",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": _vm.closeAllFilters
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "widgets-filters-wrapper"
  }, [(_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['period'] && _vm.listData && _vm.listData['filters']) ? _c('filterPeriod', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.period.visible),
      expression: "filters.period.visible"
    }],
    key: "filterPeriod",
    attrs: {
      "valueBegin": _vm.filters.period.valueBegin,
      "valueEnd": _vm.filters.period.valueEnd
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('period')
      },
      "input": _vm.filterPeriodEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['radio'] && _vm.filters.radio && _vm.listData && _vm.listData['filters']) ? _vm._l((_vm.filters.radio), function(radio, idx) {
    return _c('filterRadio', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filters.radio[idx].visible),
        expression: "filters.radio[idx].visible"
      }],
      key: 'radio_filter_' + idx,
      attrs: {
        "list": _vm.listData['filters'][radio.field],
        "crud": _vm.crud,
        "name": _vm.filters.radio[idx].field
      },
      on: {
        "closeFilter": function($event) {
          return _vm.toggleFilter('radio', idx)
        },
        "input": function($event) {
          return _vm.PreRequestListDataRadioFilter(_vm.filters.radio[idx])
        }
      },
      model: {
        value: (_vm.filters.radio[idx].value),
        callback: function($$v) {
          _vm.$set(_vm.filters.radio[idx], "value", $$v)
        },
        expression: "filters.radio[idx].value"
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['select'] && _vm.filters.select && _vm.listData && _vm.listData['filters']) ? _vm._l((_vm.filters.select), function(select, idx) {
    return _c('filterSelect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filters.select[idx].visible),
        expression: "filters.select[idx].visible"
      }],
      key: 'select_filter_' + idx,
      attrs: {
        "list": _vm.listData['filters'][select.field],
        "name": _vm.filters.select[idx].field,
        "startVisible": _vm.filters.select[idx].visible,
        "multiselect": _vm.filters.select[idx].multiselect,
        "crud": _vm.crud
      },
      on: {
        "closeFilter": function($event) {
          return _vm.toggleFilter('select', idx)
        },
        "input": function($event) {
          return _vm.PreRequestListDataSelectFilter(_vm.filters.select[idx])
        }
      },
      model: {
        value: (_vm.filters.select[idx].value),
        callback: function($$v) {
          _vm.$set(_vm.filters.select[idx], "value", $$v)
        },
        expression: "filters.select[idx].value"
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['logs'] && _vm.filters.logs && _vm.listData && _vm.listData['filters']) ? _c('filterLogs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.logs.visible),
      expression: "filters.logs.visible"
    }],
    key: "filterLogs",
    attrs: {
      "list": _vm.listData['filters'][_vm.listConfig['filters']['logs']['field']]
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('logs')
      },
      "input": _vm.filterLogsEvent
    },
    model: {
      value: (_vm.filters.logs.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.logs, "value", $$v)
      },
      expression: "filters.logs.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['ticketLabel'] && _vm.filters.ticketLabel && _vm.listData && _vm.listData['filters'] && _vm.listData['filters']['ticket_label'] && _vm.listData['filters']['ticket_label']['list']) ? _c('filterLabel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.ticketLabel.visible),
      expression: "filters.ticketLabel.visible"
    }],
    key: "filterLabel",
    attrs: {
      "items": _vm.listData['filters']['ticket_label']['list']
    },
    on: {
      "input": _vm.filterTicketLabelEvent
    },
    model: {
      value: (_vm.filters.ticketLabel.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.ticketLabel, "value", $$v)
      },
      expression: "filters.ticketLabel.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['diskType'] && _vm.listData && _vm.listData['filters'] && _vm.listData['filters']['service_type_id'] && _vm.listData['filters']['service_type_id']['list']) ? _c('filterDisk', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.diskType.visible),
      expression: "filters.diskType.visible"
    }],
    key: "filterDisk",
    attrs: {
      "items": _vm.listData['filters']['service_type_id']['list'],
      "value": _vm.filters.diskType.value
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('diskType')
      },
      "input": _vm.filterDiskTypeEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig &&
    _vm.listConfig['filters'] &&
    _vm.listConfig['filters']['planParams'] &&
    _vm.filters.planParams &&
    _vm.listData &&
    _vm.listData['filters'] &&
    _vm.listData['filters']['cpu_min'] &&
    _vm.listData['filters']['cpu_max'] &&
    _vm.listData['filters']['ram_min'] &&
    _vm.listData['filters']['ram_max'] &&
    _vm.listData['filters']['disk_min'] &&
    _vm.listData['filters']['disk_max']) ? _c('filterParams', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.planParams.visible),
      expression: "filters.planParams.visible"
    }],
    key: "filterParams",
    attrs: {
      "params": {
        cpu_min: _vm.listData['filters']['cpu_min'],
        cpu_max: _vm.listData['filters']['cpu_max'],
        ram_min: _vm.listData['filters']['ram_min'],
        ram_max: _vm.listData['filters']['ram_max'],
        disk_min: _vm.listData['filters']['disk_min'],
        disk_max: _vm.listData['filters']['disk_max']
      },
      "visible": _vm.filters.planParams.visible
    },
    on: {
      "closeDirectlyFilter": function($event) {
        return _vm.closeDirectlyFilter('planParams')
      },
      "input": _vm.filterParamsEvent
    },
    model: {
      value: (_vm.filters.planParams.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.planParams, "value", $$v)
      },
      expression: "filters.planParams.value"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "other-filters"
  }, [(_vm.crudFilter && _vm.crud === _vm.crudFilter['crud']) ? _c('div', {
    staticClass: "alert alert-info w5-crud-filter-object"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/set_filter')) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.crudFilter['text'])))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearCrudFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.accountGlobalFilter && (_vm.crud !== 'iphistory' && _vm.crud !== 'ipptrpool')) ? _c('div', {
    staticClass: "alert alert-success w5-account-global-filter"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.accountGlobalFilter.title) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.accountGlobalFilter.text))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAccountGlobalFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.crudHttpGetFilter && _vm.crud === _vm.crudHttpGetFilter['__crud']) ? _c('div', {
    staticClass: "alert alert-info w5-crud-filter-object"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/set_filter')) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.crudHttpFilterTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearHttpCrudFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.listConfig && _vm.listConfig['buttons'] && Object.keys(_vm.listConfig['buttons']).length > 0) ? _c('div', {
    staticClass: "w5-list-buttons-block"
  }, [_vm._l((_vm.listConfig['buttons']), function(button, btn) {
    return [(btn === 'create' && _vm.buttonCreateVisibe === true) ? [(_vm.crud === 'vds' && _vm.isAccess('service/create')) ? _c('span', {
      key: 'button-' + btn,
      ref: "buttonVdsCreate",
      refInFor: true,
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1) : (_vm.crud === 'backups' && _vm.isAccess('service/create')) ? _c('span', {
      key: 'button-for-backups-' + btn,
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1) : _c('router-link', {
      key: 'button-in-upper-block' + btn,
      class: _vm.buttonsClass(btn),
      attrs: {
        "to": _vm.buttonsUrl(btn)
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1)] : (btn === 'balance' && _vm.isAccess('operation/create')) ? _c('span', {
      key: 'button-' + btn,
      ref: "buttonBalance",
      refInFor: true,
      staticClass: "btn-client-balance",
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t")], 1) : (btn === 'calculator') ? _c('span', {
      key: 'button-calc-' + btn,
      ref: "buttonCalculator",
      refInFor: true,
      staticClass: "btn-calc",
      class: _vm.buttonsClass(btn),
      attrs: {
        "title": _vm._f("ftc")('service/calculator')
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/calculator')) + "\n\t\t\t\t\t")]) : (btn === 'transfer') ? [(_vm.crud === 'partner' && _vm.$store.state.user_balance) ? _c('div', {
      key: 'button-in-upper-block' + btn,
      staticClass: "w5-transfer-wrapper"
    }, [(_vm.crud === 'partner' && _vm.$store.state.user_balance) ? _c('span', {
      staticClass: "w5-partner-balance"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/partner_balance')) + ": "), _c('Money', {
      staticClass: "font-weight-500",
      attrs: {
        "value": _vm.formater_FormatMoney(_vm.$store.state.user_balance.partner)
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('main/ruble')),
        expression: "localeFtc('main/ruble')"
      }],
      staticClass: "font-weight-500"
    })], 1), _vm._v(" "), (_vm.clientPartnerData && 'total' in _vm.clientPartnerData && 'active' in _vm.clientPartnerData) ? _c('span', [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('partner/additional_info').replace('{total}', _vm.clientPartnerData.total).replace('{active}', _vm.clientPartnerData.active) + (_vm.clientPartnerData && 'last_year' in _vm.clientPartnerData ? (" (" + (_vm.clientPartnerData.last_year) + ")") : '')),
        expression: "localeFtc('partner/additional_info').replace('{total}', clientPartnerData.total).replace('{active}', clientPartnerData.active) + (clientPartnerData && 'last_year' in clientPartnerData ? ` (${clientPartnerData.last_year})` : '')"
      }]
    }), _vm._v(" "), _c('notice', {
      attrs: {
        "text": _vm._f("ftc")('partner/additional_info_notice'),
        "small": true
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_balance && _vm.isAccess('operation/convert')) ? _c('span', [_c('span', {
      staticClass: "margin-right-10",
      class: _vm.buttonsClass(btn),
      attrs: {
        "disabled": !_vm.clientPartnerData || !('total' in _vm.clientPartnerData) || _vm.clientPartnerData.total == 0
      },
      on: {
        "click": _vm.clientToOperationHistory
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "dollar-sign"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/operations')) + "\n\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('span', {
      key: 'button-' + btn,
      class: _vm.buttonsClass(btn),
      attrs: {
        "disabled": _vm.$store.state.user_balance.partner == 0
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "exchange-alt"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]) : _vm._e()] : [(_vm.buttons[btn] && _vm.buttons[btn]['visible'] && (btn === 'r_on' || btn === 'r_off')) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && (btn === 'ip_on' || btn === 'ip_off')) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-for-ip-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && btn === 'blockTicket') ? _c('font-awesome-layers', {
      key: 'button-in-upper-block-for-tickets-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "circle",
        "fixed-width": "",
        "transform": "grow-1"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "times",
        "fixed-width": "",
        "transform": "shrink-6"
      }
    })], 1) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && btn === 'closeTicket') ? _c('font-awesome-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCloseTicketButton),
        expression: "showCloseTicketButton"
      }],
      key: 'button-in-upper-block-for-tickets-close-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) + '!!!' : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible']) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-other-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : _vm._e()]]
  }), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.linkHint && _vm.linkHint.position === 'before-list') ? _c('div', {
    staticClass: "w5-info-link"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))]), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.listData) ? _c('div', {
    class: _vm.table_Loading ? 'w5-table-wrapper-loading' : 'w5-table-wrapper'
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buildTableSpiner),
      expression: "buildTableSpiner"
    }],
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/table_rendering')))])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_vm._l((_vm.listConfig['columns']), function(col, c) {
    return [(_vm.verifyForGlobalFilter(c)) ? _c('th', {
      key: 'col-' + c,
      class: col['class-col'] ? col['class-col'] : false,
      style: (col['style-col'] ? col['style-col'] : false)
    }, [(_vm.isColumnInData(c) && c !== 'ticket_label') ? _c('span', {
      class: {
        'w5-column-sort': col['sort'] === true
      },
      on: {
        "click": function($event) {
          return _vm.sortTable(c, col)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(col['title'] ? col['title'] : _vm.listData.columns[c])) + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), (_vm.listConfig['opers'] || _vm.listConfig['oneOper']) ? _c('th', {
    staticClass: "w5-column-opers",
    style: (_vm.listConfig['oneOper'] ? ('width: ' + (_vm.listConfig['oneOper']['columnWidth'] ? _vm.listConfig['oneOper']['columnWidth'] : '26px')) : '')
  }, [_vm._v(" ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    attrs: {
      "data-crud": _vm.crud,
      "data-user": this.$store.state.user_type
    }
  }, [_vm._l((_vm.renderRows), function(row, index) {
    return _c('tr', {
      key: 'row-' + row[_vm.listConfig['column_id']],
      class: {
        'w5-list-selected-row': row['w5-row-selected'] === true, 'w5-table-last-worked-record': row[_vm.listConfig['column_id']] == _vm.lastWorkedRowID
      },
      on: {
        "click": function($event) {
          return _vm.selectRowInTable($event, row[_vm.listConfig['column_id']])
        }
      }
    }, [_vm._l((_vm.listConfig['columns']), function(col, c) {
      return [(_vm.isColumnInData(c)) ? _c('td', {
        key: 'cell-' + row[_vm.listConfig['column_id']] + '_' + c,
        class: _vm.cellClass(c, col),
        style: (col['style-row'] ? col['style-row'] : false),
        attrs: {
          "aria-label": _vm.localeFtc(col['title'] ? col['title'] : _vm.listData.columns[c])
        }
      }, [_c('span', {
        staticClass: "w5-table-cell"
      }, [(('server_view_type' in row) && (c === 'server' || c === 'server_name')) ? _c('span', {
        class: 'color-type-' + String(row['server_view_type']),
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), (col['online-status-before']) ? _c('span', {
        staticClass: "online-status-before",
        class: {
          active: row[col['online-status-before']] === true
        }
      }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (col['component-row'] === 'linkComponent') ? [(_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && (c === 'account_name' || c === 'owner_account_name') && row[c] && (row['account_id'] || row['owner_account_id']) && String(row[c]).trim() !== '' && _vm.crud !== 'iphistory') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row, c)
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && _vm.crud === 'logs' && c === 'user_email' && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row)
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.crud == 'rackdevice' && (!_vm.crudFilter || !_vm.crudFilter.crud != 'rackdevice' || !_vm.crudFilter.field != 'rack_id') && c === 'rack_name' && row[c] && String(row[c]).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.GoTo(row, 'rackdevice', '', 'rack_id')
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        attrs: {
          "url": col['component-param-url'](row, _vm.listData),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "fontawesomeicon": col['component-param-icon'] ? col['component-param-icon'](row) : null,
          "flagicon": col['component-param-flagicon'] ? col['component-param-flagicon'](row) : null,
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false,
          "srcData": row
        }
      })] : (col['component-row'] === 'image') ? _c('img', {
        class: /vds$/.test(_vm.crud) ? 'vds' : _vm.crud,
        attrs: {
          "alt": row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? String(row['service_data']['template']['name']) : false,
          "title": row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? _vm.localeFtc(String(row['service_data']['template']['name'])) : false,
          "src": col['component-param-url'](row, _vm.listData)
        }
      }) : (col['component-row'] === 'imageGroupVds') ? _c('img', {
        staticClass: "vds-group",
        attrs: {
          "title": _vm.localeFtc(col['component-param-title'](row, _vm.listData)),
          "src": col['component-param-url'](row)
        }
      }) : (col['component-row'] === 'vds_info') ? _c('span', {
        staticClass: "w5-list-vds"
      }, [_c('span', {
        staticClass: "flag-icon",
        class: 'flag-icon-' + col['component-param-flag'](row, _vm.listData),
        attrs: {
          "alt": col['component-param-flag-name'](row, _vm.listData),
          "title": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData))
        }
      }), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        staticClass: "w5-vds-view-link linkified",
        attrs: {
          "url": col['component-param-url'](row),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "w5-vds-data-info"
      }, [_vm._v(_vm._s(col['component-param-data'](row)))])], 1) : (col['component-row'] === 'backup_name') ? _c('span', {
        staticClass: "w5-list-backup"
      }, [_c('span', {
        staticClass: "flag-icon",
        class: 'flag-icon-' + col['component-param-flag'](row, _vm.listData),
        attrs: {
          "alt": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData)),
          "title": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData))
        }
      }), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        staticClass: "w5-backup-view-link linkified",
        attrs: {
          "url": col['component-param-url'](row),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false
        }
      })], 1) : (col['component-row'] === 'iso_info') ? _c('div', {
        staticClass: "w5-list-iso"
      }, [(row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
        staticClass: "btn btn-default w5-eject-iso-button",
        attrs: {
          "title": _vm._f("ftc")('service/iso_eject')
        },
        on: {
          "click": function($event) {
            return _vm.ejectISO(row, $event)
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "eject"
        }
      })], 1) : _vm._e(), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
        staticClass: "hidden-ellipsis"
      }, [_c('linkComponent', {
        attrs: {
          "url": '/vds/view/' + row['parent_id'],
          "text": row['parent_name']
        }
      })], 1)] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2) : (col['component-row'] === 'outer_disk_info') ? _c('div', {
        staticClass: "w5-list-iso"
      }, [(row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
        staticClass: "btn btn-default w5-eject-iso-button",
        attrs: {
          "title": _vm._f("ftc")('main/detach')
        },
        on: {
          "click": function($event) {
            return _vm.ejectOuterDiskFromTable(row, $event)
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "eject"
        }
      })], 1) : _vm._e(), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
        staticClass: "hidden-ellipsis"
      }, [_c('linkComponent', {
        attrs: {
          "url": '/vds/view/' + row['parent_id'],
          "text": row['parent_name']
        }
      })], 1)] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2) : (col['component-row'] === 'note_info') ? _c('span', {
        staticClass: "w5-list-note"
      }, [_c('span', [_vm._v(_vm._s(col['component-param-date'](row)))]), _vm._v(" "), (row['account_name']) ? [_c('br'), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": col['component-param-url1'](row),
          "text": col['component-param-text1'] ? col['component-param-text1'](row, _vm.listData) : row[c]
        }
      })] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": col['component-param-url2'](row),
          "text": col['component-param-text2'] ? col['component-param-text2'](row, _vm.listData) : row[c]
        }
      })], 2) : (col['component-row'] === 'partner_code' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-list-p2a"
      }, [(row['status'] === false) ? _c('span', {
        staticClass: "btn btn-submit btn-submut-extra-small",
        on: {
          "click": function($event) {
            return _vm.partnerActivate(row)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/activate')) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _c('a', {
        staticClass: "linkified",
        attrs: {
          "href": _vm.AppServerUrl + '/?partner=' + row[c],
          "target": "_blank"
        }
      }, [_c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }]
      }, [_vm._v(_vm._s(_vm.AppServerUrl + '/?partner=' + row[c]))])])]) : (col['component-row'] === 'http_referer' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-http-referer"
      }, [_c('a', {
        attrs: {
          "href": row[c],
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(row[c]))])]) : (col['component-row'] === 'document_html') ? [(row['html'] !== null && row['html'] !== undefined) ? _c('span', {
        staticClass: "w5-http-referer",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('span', {
        staticClass: "w5-modal-link",
        staticStyle: {
          "font-weight": "500"
        },
        on: {
          "click": function($event) {
            return _vm.openDocumentModalDialog(row['html'], row['pdf'], row['xml'])
          }
        }
      }, [_vm._v(_vm._s(row[c]))]), _vm._v(" "), (row['payer_id'] && row['payer_name']) ? [_c('br'), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/payer/view/' + row['payer_id'],
          "text": row['payer_name']
        }
      })] : _vm._e()], 2) : _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/document/view/' + row['document_id'],
          "text": row[c]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      })] : (col['component-row'] === 'formated_number' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-format-number",
        class: col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false
      }, [_c('Money', {
        attrs: {
          "value": col['component-param-cell'](row, _vm.countDigits)
        }
      })], 1) : (col['component-row'] === 'status_info') ? _c('span', {
        staticClass: "w5-list-status",
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false
      }, [(col['function-row'](row, _vm.listData)['loader']) ? [_c('div', [_c('span', {
        staticStyle: {
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), _c('img', {
        staticStyle: {
          "margin-left": "6px"
        },
        attrs: {
          "src": __webpack_require__(14)
        }
      })])] : (col['function-row'](row, _vm.listData)['timer']) ? [_c('div', [_c('span', {
        staticStyle: {
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), _c('font-awesome-icon', {
        staticStyle: {
          "margin-left": "6px"
        },
        attrs: {
          "icon": "clock"
        }
      })], 1)] : _c('span', {
        staticStyle: {
          "white-space": "normal",
          "word-break": "break-word"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), (_vm.vdsCloneVdsInProcess(row['service_id'])) ? _c('div', {
        staticClass: "vds-clone-status-in-table"
      }, [_c('font-awesome-layers', {
        staticClass: "vds-clone-status",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.vdsCloneShowProcessData(row['service_id'])
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "server"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "clone"
        }
      })], 1), _vm._v(" "), (_vm.vdsCloneVdsInProcess(row['service_id']).error) ? _c('font-awesome-icon', {
        staticClass: "error",
        attrs: {
          "icon": "exclamation-circle"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.vdsCloneShowProcessData(row['service_id'])
          }
        }
      }) : _c('img', {
        attrs: {
          "src": __webpack_require__(14)
        }
      })], 1) : _vm._e()], 2) : (col['component-row'] === 'CrudListFilter' && col['component-param-src-field'] && col['component-param-crud'] && col['component-param-filter-field']) ? _c('span', {
        staticClass: "w5-link",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.GoTo(row, col['component-param-crud'], col['component-param-object'], col['component-param-filter-field'])
          }
        }
      }, [(col['function-row']) ? [_vm._v(_vm._s(col['function-row'](row, _vm.listData)))] : [_vm._v(_vm._s(row[col['component-param-src-field']]))]], 2) : (col['component-row'] === 'ticket_label') ? [(row['ticket_label'] === 'loading') ? _c('div', {
        staticStyle: {
          "height": "23px"
        }
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(14)
        }
      })]) : _c('div', {
        ref: 'ticket-label-' + row['ticket_id'],
        refInFor: true,
        staticClass: "w5-list-ticket-label",
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeTicketLabel(row)
          }
        }
      })] : (col['component-row'] === 'ticket_read') ? [('message_unread_count' in row && row['message_unread_count'] > 0) ? _c('font-awesome-layers', {
        staticClass: "ticket-read"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "envelope"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "asterisk"
        }
      })], 1) : _c('font-awesome-layers', {
        staticClass: "ticket-read"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "envelope"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "check"
        }
      })], 1)] : (col['component-row'] === 'service_type_cost') ? [(col['function-row'](row, _vm.listData)['cost']) ? _c('span', [_c('Money', {
        attrs: {
          "value": col['function-row'](row, _vm.listData)['cost']
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })], 1) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['cost'] && col['function-row'](row, _vm.listData)['for']) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['for']) ? _c('span', [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['for']))]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['for'] && col['function-row'](row, _vm.listData)['period']) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['period']) ? _c('span', [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['period']))]) : _vm._e()] : (col['component-row'] === 'plan_cost') ? [_c('Money', {
        attrs: {
          "value": col['function-row'](row, _vm.listData)['cost']
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(col['function-row'](row, _vm.listData)['period']) + "\n\t\t\t\t\t\t\t\t\t")] : (col['component-row'] === 'ticket_subject') ? [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/ticket/view/' + row['ticket_id'],
          "text": row['ticket_subject']
        }
      }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && row['message_count'] > 0) ? _c('span', {
        staticClass: "badge ticket-message-count-badge admin margin-left-6",
        on: {
          "mouseover": function($event) {
            return _vm.ticketLastCommentatorShow(row, $event)
          },
          "mouseleave": function($event) {
            return _vm.ticketLastCommentatorHide()
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(row['message_count']) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_type === 'client' && row['message_unread_count'] > 0) ? _c('span', {
        staticClass: "badge ticket-message-count-badge margin-left-6"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(row['message_unread_count']) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()] : (col['component-row'] === 'server_groups' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_vm._l((row[c]), function(server, s) {
        return [(s > 0) ? _c('span', {
          key: 'del-grp-' + s
        }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('linkComponent', {
          directives: [{
            name: "highlightFastSearch",
            rawName: "v-highlightFastSearch",
            value: (_vm.fastSearchValue),
            expression: "fastSearchValue"
          }],
          key: 'server_group_' + s,
          attrs: {
            "url": '/servergroup/view/' + server['group_id'],
            "text": server['group_name']
          }
        })]
      })], 2) : (col['component-row'] === 'server_groups_view' && row[c] !== null && row[c] !== undefined && row['server_group_id'] && row['server_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/servergroup/view/' + row['server_group_id'],
          "text": row['server_group_name']
        }
      })], 1) : (col['component-row'] === 'plan_groups_view' && row[c] !== null && row[c] !== undefined && row['plan_group_id'] && row['plan_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/plangroup/view/' + row['plan_group_id'],
          "text": row['plan_group_name']
        }
      })], 1) : (col['component-row'] === 'template_groups_view' && row[c] !== null && row[c] !== undefined && row['template_group_id'] && row['template_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/templategroup/view/' + row['template_group_id'],
          "text": row['template_group_name']
        }
      })], 1) : (col['component-row'] === 'admin_roles' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])) ? _c('span', {
        staticClass: "w5-list-roles"
      }, _vm._l((row[c]), function(role, r) {
        return _c('span', {
          directives: [{
            name: "highlightFastSearch",
            rawName: "v-highlightFastSearch",
            value: (_vm.fastSearchValue),
            expression: "fastSearchValue"
          }],
          key: 'admin_roles_' + r
        }, [(r > 0) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("ftc")(role)))])
      }), 0) : (col['component-row'] === 'operation_status') ? [(_vm.$store.state.user_type === 'client' && row['operation_status'] === 0 && row['can_pay'] === true) ? _c('linkComponent', {
        staticClass: "btn btn-submit btn-submut-extra-small",
        attrs: {
          "url": '/operation/select/' + row['operation_id'],
          "text": _vm._f("lower")(_vm._f("ftc")('operation/pay'))
        }
      }) : _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false
      }, [_vm._v(_vm._s(col['component-param-data'](row, _vm.listData)))])] : (col['function-row']) ? _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false
      }, [(col['function-flagicon']) ? _c('span', {
        staticClass: "flag-icon",
        class: col['function-flagicon'](row)
      }) : _vm._e(), _vm._v(_vm._s(col['function-row'](row, _vm.listData, _vm.localeFtc)))]) : (col['formater-row']) ? _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false)
      }, [_vm._v(_vm._s(_vm.formater(col['formater-row'], row[c])))]) : _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false)
      }, [_vm._v(_vm._s(_vm._f("ftc")(row[c])))]), _vm._v(" "), (col['user-online-status'] && row[col['user-online-status']] === true) ? _c('span', {
        staticClass: "online-status-is-on"
      }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (col['domain-online-status'] && col['domain-online-status'](row)) ? _c('span', {
        staticClass: "online-status-is-on"
      }, [_vm._v(" ●")]) : _vm._e()], 2)]) : _vm._e()]
    }), _vm._v(" "), (_vm.listConfig['opers']) ? _c('td', {
      staticClass: "w5-column-opers"
    }, [_c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.listConfig['opers'],
        "row": row,
        "index": index,
        "crud": _vm.crud
      },
      on: {
        "action": _vm.actionOperButton
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.listConfig['oneOper']) ? _c('td', {
      staticClass: "w5-column-opers"
    }, [_c('oneOperButton', {
      attrs: {
        "dataConfig": _vm.listConfig['oneOper'],
        "row": row,
        "index": index,
        "crud": _vm.crud
      },
      on: {
        "action": _vm.actionOperButton
      }
    })], 1) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.crud === 'operation' && 'totalSumm' in _vm.listData) ? _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/total_summ')) + ":  \n\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm.totalSummFormat(_vm.listData.totalSumm)
    }
  })], 1)]), _vm._v(" "), _c('td', {
    staticClass: "padding-left-0 font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": this.$store.state.user_type !== 'client' ? (_vm.$store.state.accountGlobalFilter ? 3 : 4) : 2
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.crud === 'partneractions' && 'totalSumm' in _vm.listData) ? _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": _vm.$store.state.accountGlobalFilter ? 6 : 7
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/total_summ')) + ":  \n\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm.totalSummFormat(_vm.listData.totalSumm)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listData && _vm.listData.rows && _vm.listData.rows.length === 0),
      expression: "listData && listData.rows && listData.rows.length === 0"
    }]
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": Object.keys(_vm.listConfig['columns']).length + (_vm.listConfig['opers'] ? 1 : 0)
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('div', {
    staticClass: "margin-15-0"
  }, [(_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('span', {
    staticClass: "font-size-80 font-weight-500 list-total"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/list_total')) + ":\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('span', {
    staticClass: "font-size-80 list-total"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.listData.totalCount) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalSelectedRowsCount && _vm.totalSelectedRowsCount > 0),
      expression: "totalSelectedRowsCount && totalSelectedRowsCount > 0"
    }]
  }, [_vm._v("\n\t\t\t\t\t, "), _c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/selected')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80"
  }, [_vm._v(_vm._s(_vm.totalSelectedRowsCount))])]), _vm._v(" "), _c('span', {
    staticClass: "widget-page-size"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_size')) + ": ")]), _vm._v(" "), _vm._l((_vm.Config.pageSizes), function(size) {
    return _c('span', {
      key: 'page-size-' + size,
      staticClass: "font-size-80",
      class: {
        'w5-link': size !== _vm.listData.pageSize, 'font-weight-500': size === _vm.listData.pageSize
      },
      on: {
        "click": function($event) {
          return _vm.setPageSize(size)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t " + _vm._s(size) + " \n\t\t\t\t\t")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.paginationPages.length > 0) ? _c('div', [(_vm.crud === 'vds') ? _c('paginator', {
    attrs: {
      "baseUrl": '/vds/' + _vm.action,
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage
    }
  }) : _c('paginator', {
    attrs: {
      "baseUrl": '/' + _vm.crud + '/' + _vm.action + (_vm.crud === 'ticket' && _vm.action === 'department' ? '/' + _vm.ticketDepartmentId : ''),
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage,
      "queryString": _vm.getAllQueryParams()
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.linkHint && _vm.linkHint.position === 'bottom') ? _c('div', {
    staticClass: "w5-info-link margin-top-20"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))]), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.deleteModalTitle ? _vm.deleteModalTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    class: {
      'flbx': _vm.reserveIpLocalData >= 1, 'r': _vm.reserveIpLocalData && typeof _vm.reserveIpLocalData === 'object'
    }
  }, [(_vm.reserveIpLocalData && typeof _vm.reserveIpLocalData === 'object') ? _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin": "0 0 15px",
      "padding": "5px 10px 10px 10px",
      "text-align": "initial"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': _vm.reserveIpProcessing || (_vm.deleteModalTimer && _vm.deleteModalTimer > 0)
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/save ippool/ippool')) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "0",
      "font-size": "90%"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.reserveIpLocalData === 1) ? _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlockModal),
      expression: "showBlockModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBlockModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.blockModalTitle ? _vm.blockModalTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBlockModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.blockModalText)),
      expression: "localeFtc(blockModalText)"
    }],
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.blockModalNoteRequired !== false),
      expression: "blockModalNoteRequired !== false"
    }],
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "blockModalSelectNote",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "blockModalSelectNote",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": {
        _field_name: 'blockModalSelectNote',
        type: 'list',
        title: 'notes/choice_note',
        '_visible': true,
        '_is_modal': true,
        url: '/text/list?search=template&category=notes&q='
      },
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.blockModalValueChanged
    },
    model: {
      value: (_vm.blockModalSelectNoteValue),
      callback: function($$v) {
        _vm.blockModalSelectNoteValue = $$v
      },
      expression: "blockModalSelectNoteValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "blockModalTextNote",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "blockModalTextNote",
      "Field": _vm.blockModalTextField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.blockModalTextFieldFocus
    },
    model: {
      value: (_vm.blockModalTextNoteValue),
      callback: function($$v) {
        _vm.blockModalTextNoteValue = $$v
      },
      expression: "blockModalTextNoteValue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.blockRowsInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.blockModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRegisterModal),
      expression: "showRegisterModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRegisterModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      'wide': _vm.registerModalWhat === 'ip_off'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.registerModalTitle ? _vm.registerModalTitle : 'server/register')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRegisterModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.registerModalText)),
      expression: "localeFtc(registerModalText)"
    }],
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), (_vm.registerModalWhat === 'ip_off') ? [_c('radioListComponent', {
    attrs: {
      "placeholder": "",
      "title": 'main/status',
      "required": true,
      "items": _vm.ippoolBlockStatuses
    },
    model: {
      value: (_vm.ippoolBlockValue),
      callback: function($$v) {
        _vm.ippoolBlockValue = $$v
      },
      expression: "ippoolBlockValue"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.registerRowsInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.registerModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRemoveFilterModal),
      expression: "showRemoveFilterModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRemoveFilterModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/remove_filter')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRemoveFilterModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('radioListComponent', {
    attrs: {
      "placeholder": "",
      "title": 'main/status',
      "required": true,
      "items": [{
          id: 'no-spamming',
          name: 'service/remove_filter_spam'
        },
        {
          id: 'block-services',
          name: 'service/remove_filter_service'
        },
        {
          id: 'no-dns',
          name: 'menu/dns'
        } ]
    },
    model: {
      value: (_vm.removeFilterValue),
      callback: function($$v) {
        _vm.removeFilterValue = $$v
      },
      expression: "removeFilterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.removeFilterProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/detach')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCopyToDcModal),
      expression: "showCopyToDcModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideCopyToDcModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('backup/copy')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideCopyToDcModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.copyToDcErrorMessage !== ''),
      expression: "copyToDcErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "5px 0 10px 0"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.copyToDcErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.copyToDcErrorMessage)),
      expression: "localeFtc(copyToDcErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.copyToDcFields && _vm.copyToDcFields.fields) ? _vm._l((_vm.copyToDcFields.fields), function(row, index) {
    return _c('div', {
      key: 'copy_to_dc_field_' + index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: 'field_' + field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "crud": "backups",
          "action": "copy",
          "Field": field,
          "listBlockToOut": field.type === 'list' ? 1 : false,
          "removeRightPadding": true,
          "fieldInModal": true
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onChangedField(field)
          },
          "blur": function($event) {
            return _vm.onBlurField(field)
          },
          "focus": function($event) {
            return _vm.onFocusField(field)
          },
          "enterKeyDown": function($event) {
            return _vm.onEnterKeyDownForm('copyToDcProcessStart')
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.copyToDcCostInfo) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyToDcCostInfo)
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.copyToDcProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/copy')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVdsCloneModal),
      expression: "showVdsCloneModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideVdsCloneModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/clone')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideVdsCloneModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_note')),
      expression: "localeFtc('main/vds_clone_note')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning margin-top-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_warning')),
      expression: "localeFtc('main/vds_clone_warning')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "vdsCloneModalFieldBoolean",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "vdsCloneModalFieldBoolean",
      "Field": _vm.vdsCloneModalFieldBoolean,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    model: {
      value: (_vm.vdsCloneModalFieldBooleanValue),
      callback: function($$v) {
        _vm.vdsCloneModalFieldBooleanValue = $$v
      },
      expression: "vdsCloneModalFieldBooleanValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "vdsCloneModalFieldList",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "vdsCloneModalFieldList",
      "listBlockToOut": 1,
      "Field": _vm.vdsCloneModalFieldList,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.vdsCloneModalFieldList._errMsg = ''
      }
    },
    model: {
      value: (_vm.vdsCloneModalFieldListValue),
      callback: function($$v) {
        _vm.vdsCloneModalFieldListValue = $$v
      },
      expression: "vdsCloneModalFieldListValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.vdsCloneProcessStep2
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/begin')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vdsCloneShowProcessDataValue),
      expression: "vdsCloneShowProcessDataValue"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideVdsCloneProcessInfoModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/clone')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideVdsCloneProcessInfoModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.vdsCloneShowProcessDataInfo && _vm.vdsCloneShowProcessDataInfo.id) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.vdsCloneShowProcessDataInfo.error) ? [_c('div', {
    staticClass: "alert alert-warning margin-top-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_process_warning')),
      expression: "localeFtc('main/vds_clone_process_warning')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.step))))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('service/status_error')))]), _vm._v(": "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.vdsCloneShowProcessDataInfo.error)),
      expression: "localeFtc(vdsCloneShowProcessDataInfo.error)"
    }],
    staticStyle: {
      "color": "red"
    }
  })])] : (_vm.vdsCloneShowProcessDataInfo.finish) ? [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/converted')))])] : [_c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('server/server')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm.vdsCloneShowProcessDataInfo.params.nm))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.step))))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/state')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.status))))])])]], 2) : _vm._e(), _vm._v(" "), (_vm.vdsCloneShowProcessDataInfo && _vm.vdsCloneShowProcessDataInfo.id && _vm.vdsCloneShowProcessDataInfo.error) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function($event) {
        return _vm.deleteVdsCloneProcess(_vm.vdsCloneShowProcessDataInfo.id)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/vds_clone_process_terminate')))])]) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMigrateModal),
      expression: "showMigrateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideMigrateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/migrate')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideMigrateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-migrate-wrapper"
  }, [_c('div', {
    staticClass: "w5-migrate-vds-list scrollable"
  }, _vm._l((_vm.migrateRows), function(vds, indx) {
    return _c('div', {
      key: 'migrate-row-' + indx,
      staticClass: "w5-migrate-vds-list-item scrollable",
      class: {
        'w5-migrate-vds-list-item-selected': vds['migrate_active'] === true
      },
      style: (_vm.migrateRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(vds[_vm.listConfig['buttons']['migrate']]) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-server-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "migrateModalSelectServer",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "migrateModalSelectServer",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.migrateModalServerField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.migrateModalValueChanged
    },
    model: {
      value: (_vm.migrateModalSelectServerValue),
      callback: function($$v) {
        _vm.migrateModalSelectServerValue = $$v
      },
      expression: "migrateModalSelectServerValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.migrateModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.migrateInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/migrate')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showServiceMoveModal),
      expression: "showServiceMoveModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideServiceMoveModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideServiceMoveModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-migrate-wrapper"
  }, [_c('div', {
    staticClass: "w5-migrate-vds-list scrollable"
  }, _vm._l((_vm.serviceMoveRows), function(service, indx) {
    return _c('div', {
      key: 'service-move-row-' + indx,
      staticClass: "w5-migrate-vds-list-item scrollable",
      class: {
        'w5-migrate-vds-list-item-selected': service['move_active'] === true
      },
      style: (_vm.serviceMoveRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(service[_vm.listConfig['buttons']['serviceMove']]) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-server-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "serviceMoveModalSelectServer",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "serviceMoveModalSelectServer",
      "Field": _vm.serviceMoveModalAccountField,
      "listBlockToOut": 1,
      "fieldInModal": true,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.serviceMoveModalValueChanged
    },
    model: {
      value: (_vm.serviceMoveModalSelectAccountValue),
      callback: function($$v) {
        _vm.serviceMoveModalSelectAccountValue = $$v
      },
      expression: "serviceMoveModalSelectAccountValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.serviceMoveModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.serviceMoveInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceMoveModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showServiceBulkDelModal),
      expression: "showServiceBulkDelModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideServiceBulkDelModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideServiceBulkDelModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete_selected_records')) + "?\n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete_selected_records_note')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.serviceBulkDelModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.serviceBulkDelInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceBulkDelModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTicketMoveModal),
      expression: "showTicketMoveModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTicketMoveModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTicketMoveModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-ticket-move-wrapper"
  }, [_c('div', {
    staticClass: "w5-ticket-move-tickets-list"
  }, _vm._l((_vm.ticketRows), function(ticket, indx) {
    return _c('div', {
      key: 'ticket-move-row-' + indx,
      staticClass: "w5-ticket-move-tickets-list-item",
      class: {
        'w5-ticket-move-tickets-list-item-selected': ticket['ticket_move_active'] === true
      },
      style: (_vm.ticketRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(ticket['ticket_subject']) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-move-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-move-departments-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketMoveModalSelectDepartment",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "ticketMoveModalSelectDepartment",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.ticketMoveModalDepartmentField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.ticketMoveModalValueChanged
    },
    model: {
      value: (_vm.ticketMoveModalSelectDepartmentValue),
      callback: function($$v) {
        _vm.ticketMoveModalSelectDepartmentValue = $$v
      },
      expression: "ticketMoveModalSelectDepartmentValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.ticketMoveModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketMoveInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTicketBlockModal),
      expression: "showTicketBlockModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTicketBlockModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container blacklist",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/blacklist')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTicketBlockModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ticketBlockModalBody) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.ticketBlockModalTimer && _vm.ticketBlockModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketBlockInModalDialog
    }
  }, [_vm._v(_vm._s(_vm.ticketBlockModalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showISOModal),
      expression: "showISOModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideISOModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.isoModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideISOModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isoModalText)),
      expression: "localeFtc(isoModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.blockModalTimer && _vm.blockModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.detachIsoBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.isoBlockModalButtonTitle)))])])])])])]), _vm._v(" "), (_vm.crud === 'backups') ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownloadBackupModal),
      expression: "showDownloadBackupModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('backup/download_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('backup/download_info')),
      expression: "localeFtc('backup/download_info')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.downloadBackupProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaymentModal),
      expression: "showPaymentModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePaymentModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/convert_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePaymentModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.paymentFields && _vm.paymentFields.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.paymentFields.fields), function(row, index) {
    return _c('div', {
      key: 'payment_field_' + index,
      class: {
        'w5-form-row': _vm.isVisiblePaymentField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: 'field_' + field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisiblePaymentField(row),
          "crud": "operation",
          "action": "convert",
          "Field": field,
          "listBlockToOut": field.type === 'list' ? 1 : false,
          "removeRightPadding": true,
          "fieldInModal": true
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChangedPayment(field)
          },
          "input": function($event) {
            return _vm.fieldPaymentInput(field)
          },
          "blur": function($event) {
            return _vm.onBlurPayment(field)
          },
          "focus": function($event) {
            return _vm.onFocusPayment(field)
          },
          "enterKeyDown": _vm.onEnterKeyDownPayment
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "pull-left text-left"
  }, [_c('span', {
    style: (_vm.PaymentWarrning ? 'color: red' : false)
  }, [_vm._v(_vm._s(_vm._f("ftc")('payment/min')) + ": "), _c('strong', [_c('Money', {
    attrs: {
      "value": _vm.paymentMin
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  })], 1)]), _vm._v(" "), (_vm.PaymentWarrningAdditional) ? [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "payment-warrning-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.PaymentWarrningAdditional)))])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('payment/max')) + ": "), _c('strong', [_c('Money', {
    attrs: {
      "value": _vm.paymentMax
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  })], 1)])], 2), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.isPaymentModalButtonDisabled
    },
    on: {
      "click": _vm.paymentConvertBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/convert')))])])])])])]), _vm._v(" "), (_vm.crud == 'operation') ? _c('calculator', {
    attrs: {
      "visible": _vm.showCalcModal
    },
    on: {
      "onClose": _vm.hideCalcModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.crud == 'rack') ? _c('rackGraphic', {
    attrs: {
      "visible": _vm.showRackGraphicModal,
      "rack": _vm.rackGraphicModalData,
      "filters": _vm.listData && _vm.listData.filters && _vm.listData.filters.rack_type ? _vm.listData.filters : null
    },
    on: {
      "onClose": _vm.hideRackGraphicModal
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showBalancePopup) ? _c('div', {
    staticClass: "popup-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideBalancePopup(false); }
    }
  }, [_c('div', {
    staticClass: "popup-wrapper"
  }, [_c('div', {
    staticClass: "popup-container",
    style: (_vm.balanceContainerStyle),
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('Field', {
    ref: "clientBalance",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "clientBalance",
      "needButtonSubmit": true,
      "Field": _vm.balanceField,
      "fieldInModal": true
    },
    on: {
      "enterKeyDown": _vm.onBalanceSubmit,
      "onSubmit": _vm.onBalanceSubmit,
      "focus": function($event) {
        _vm.balanceField._errMsg = ''
      }
    },
    model: {
      value: (_vm.balanceValue),
      callback: function($$v) {
        _vm.balanceValue = $$v
      },
      expression: "balanceValue"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.crud === 'ticket') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoiceTicketLabelBlock === true),
      expression: "showChoiceTicketLabelBlock === true"
    }],
    ref: "ticketChoiceLabelBlock",
    staticClass: "widget-filter-ticket-label-choice",
    style: (_vm.ticketLabelBlockStyle)
  }, [_vm._l((_vm.ticketLabelItems), function(val, idx) {
    return [(String(val) !== '') ? _c('div', {
      key: 'label-change-block-' + idx,
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      style: ('background-color: ' + String(val).toLowerCase()),
      on: {
        "click": function($event) {
          return _vm.onChangeTicketLabel(val)
        }
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMarkTicketsAsReadedDialog),
      expression: "showMarkTicketsAsReadedDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.showMarkTicketsAsReadedDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/mark_all_as_readed')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMarkTicketsAsReadedDialog = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/mark_all_as_readed_warning')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.markTicketsAsReadedStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModalDialog),
      expression: "showConfirmModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalDialogTitle ? _vm.confirmModalDialogTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalDialogText)),
      expression: "localeFtc(confirmModalDialogText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.confirmModalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMergeTicketsDialog),
      expression: "showMergeTicketsDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.showMergeTicketsDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/merge')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMergeTicketsDialog = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "mergeTicketsSelectTicket",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "mergeTicketsSelectTicket",
      "listBlockToOut": 1,
      "Field": _vm.mergeTicketsField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.mergeTicketsField._errMsg = ''
      }
    },
    model: {
      value: (_vm.mergeTicketsField.value),
      callback: function($$v) {
        _vm.$set(_vm.mergeTicketsField, "value", $$v)
      },
      expression: "mergeTicketsField.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.mergeTicketsStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/continue')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaymentLinkDialog),
      expression: "showPaymentLinkDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePaymentLinkDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container not-so-wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePaymentLinkDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('p', {
    staticClass: "payment-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.copyPaymentLink
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/copy_to_clipboard')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDocumentModalDialog),
      expression: "showDocumentModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container for-document",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('document/document')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "document-wrapper"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "frameborder": "0",
      "id": "documentFrame",
      "name": "documentFrame",
      "seamless": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tВаш браузер не поддерживает показ документа\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.isPrintReady) ? _c('span', {
    staticClass: "btn btn-submit pull-left",
    on: {
      "click": _vm.documentPrint
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/print')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLinkXml) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLinkXml,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download XML')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLinkPdf) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLinkPdf,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download PDF')))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.crud === 'backups') ? _c('backupDialog', {
    attrs: {
      "visible": _vm.showBackupDialog,
      "type": _vm.backupDialogType,
      "user-type": _vm.$store.state.user_type,
      "account-id": _vm.backupDialogAccount,
      "backup-id": _vm.backupDialogId,
      "backup-name": _vm.backupDialogName
    },
    on: {
      "onClose": _vm.hideBackupDialog,
      "onAction": _vm.backupDialogStartProcess
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRenameBackupDialog),
      expression: "showRenameBackupDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/name')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.renameBackupField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "enterKeyDown": _vm.renameBackupKeyDown,
      "focus": function($event) {
        _vm.renameBackupField._errMsg = ''
      }
    },
    model: {
      value: (_vm.renameBackupValue),
      callback: function($$v) {
        _vm.renameBackupValue = $$v
      },
      expression: "renameBackupValue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.renameBackupStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/rename_action')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRestoreBackupOuterDiskDialog),
      expression: "showRestoreBackupOuterDiskDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRestoreBackupOuterDiskDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/restore')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRestoreBackupOuterDiskDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.restoreBackupOuterDiskField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "listBlockToOut": 1
    },
    on: {
      "focus": function($event) {
        _vm.restoreBackupOuterDiskField._errMsg = ''
      },
      "input": _vm.restoreBackupOuterDiskFieldChanged
    },
    model: {
      value: (_vm.restoreBackupOuterDiskValue),
      callback: function($$v) {
        _vm.restoreBackupOuterDiskValue = $$v
      },
      expression: "restoreBackupOuterDiskValue"
    }
  })], 1), _vm._v(" "), (_vm.restoreBackupOuterDiskWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.restoreBackupOuterDiskWarning)),
      expression: "localeFtc(restoreBackupOuterDiskWarning)"
    }]
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.restoreBackupOuterDiskStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/restore')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackupScheduleModal),
      expression: "showBackupScheduleModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-form",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.backupScheduleForm && _vm.backupScheduleForm.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, _vm._l((_vm.backupScheduleForm.fields), function(row, index) {
    return _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleScheduleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleScheduleField(row),
          "fieldInModal": true,
          "action": _vm.backupScheduleMode,
          "Field": field,
          "listBlockToOut": 1,
          "crud": "backupschedule"
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldScheduleChanged(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.createScheduleEmpty
    },
    on: {
      "click": _vm.createBackupScheduleBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConnectOuterDiskDialog),
      expression: "showConnectOuterDiskDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConnectOuterDiskDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.connectOuterDiskDialogMode == 'disk' ? 'main/attach main/disk' : 'service/iso_insert')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConnectOuterDiskDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.connectOuterDiskField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "listBlockToOut": 1
    },
    on: {
      "focus": function($event) {
        _vm.connectOuterDiskField._errMsg = ''
      }
    },
    model: {
      value: (_vm.connectOuterDiskValue),
      callback: function($$v) {
        _vm.connectOuterDiskValue = $$v
      },
      expression: "connectOuterDiskValue"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-15 margin-bottom-10 margin-right-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/iso_operation_warning')),
      expression: "localeFtc('service/iso_operation_warning')"
    }]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function () { return _vm.connectOuterDiskDialogMode == 'disk' ? _vm.connectOuterDiskDialogStartProcess() : _vm.connectISOOperDialogStartProcess(); }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/attach')))])])])])])]), _vm._v(" "), (_vm.crud === 'logs' && _vm.$store.state.user_type === 'admin') ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showViewModal),
      expression: "showViewModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideViewModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData && _vm.viewData.title ? _vm.viewData.title : 'ippool/ippool')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideViewModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.viewKeys && _vm.viewKeys.length) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.viewKeys), function(row) {
    return _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.viewSortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.viewSortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": "logsIpBlackList",
          "realCrudName": "logsIpBlackList",
          "firstElement": _vm.viewSortDATA && _vm.viewSortDATA['1'] && _vm.viewSortDATA['1'][0] ? _vm.viewSortDATA['1'][0] : null
        }
      })
    }), 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.viewData && _vm.viewData.__ip && _vm.viewData.__ip.can_flush === true) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.viewButtonProcedure
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))])]) : _c('div', {
    staticClass: "padding-top-10"
  })])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])]), _vm._v(" "), _c('span', {
    staticClass: "ticket-last-commentator",
    style: (_vm.ticketLastCommentatorStyle)
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ticket/last_message_from: ')))]), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketLastCommentator)))])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_view__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ViewComponent',
	data: function data() {
		return {
			crud: null,

			id: null,

			localErrorMessage: '',

			sortDATA: {},

			Keys: false,

			viewData: {}
		};
	},

	computed: {
		UserType: function UserType() {
			return this.$store.state.user_type;
		},
		AppServerUrl: function AppServerUrl() {
			return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppServerUrl;
		},
		realCrudName: function realCrudName() {
			return this.__realCrudName(this.crud);
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.initData(this.$route.path);

		if (this.crud) this.requestViewData();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
	},

	watch: {
		'$route': function $route(to, from) {
			this.initData(to.path);

			if (this.crud) this.requestViewData();
		}
	},

	methods: {
		initData: function initData(path) {
			this.crud = null;
			this.id = null;
			this.sortDATA = {};
			this.Keys = false;
			this.localErrorMessage = '';

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 3 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length || _urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'view') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.crud = _urlParts[0];

			this.id = _urlParts[2];
		},
		requestViewData: function requestViewData() {
			var _this = this;

			var _url = '/';
			if (this.crud === 'planarchive') _url += 'plan';else if (this.crud === 'iso' || this.crud === 'additional-services' || this.crud === 'backups' || this.crud === 'certificate' || this.crud === 'dns' || this.crud === 'domains' || this.crud === 'disks') _url += 'service';else _url += this.crud;

			if (!this.isAccess(_url + '/view')) {
				this.localErrorMessage = 'main/user_forbidden ' + _url.replace('/', '') + '/title';
				return;
			}

			_url += '/view/';

			if (this.id) _url += this.id;

			this.forms_Get(_url, false, function (data) {
				if (!data || data['status'] !== 'ok' || data[_this.realCrudName] === undefined || data[_this.realCrudName] === null) {
					_this.form_ErrorMessage = _this.localeFtc('error/api_incorrect');
				} else {
					_this.sortDATA = _this._order();

					_this.Keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.sortDATA).sort(function (a, b) {
						return a - b;
					});

					_this.viewData = _this.form_GetData;
				}
			});
		},
		backButton: function backButton() {
			this.$router.go(-1);
		},
		_order: function _order() {
			var obj = void 0;
			var __obj = void 0;
			var ____obj = void 0;
			var tmp = void 0;
			var order = void 0;
			var isLink = 0;
			var nm = '';
			var sortDATA = {};

			for (var idx in this.form_GetData) {
				if (this.form_GetData.hasOwnProperty(idx)) {
					obj = this.form_GetData[idx];

					if (idx === 'logs' && this.crud !== 'logs') continue;

					if (idx === 'data' && this.crud === 'service') continue;

					if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
						if ('order' in obj && obj['type'] !== 'hidden') {
							tmp = parseInt(obj['order']);
							order = isNaN(tmp) ? 0 : tmp;

							if (!sortDATA[order]) {
								sortDATA[order] = [];
								sortDATA[order].push(idx);
							} else sortDATA[order].push(idx);
						} else {
								isLink = 0;
								nm = '';

								for (var i in obj) {
									if (obj.hasOwnProperty(i)) if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i)) {
										nm = i.match(/(.*?)_name$/);
										if (nm === null) {
											nm = i.match(/(.*?)_id$/);
											if (nm === null) {
												nm = i.match(/(.*?)_login$/);
												if (nm == null) {
													if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле');
												} else nm = nm[1];
											} else nm = nm[1];
										} else nm = nm[1];

										isLink++;
									}
								}
								if (isLink === 2 && idx !== this.realCrudName) isLink = true;else isLink = false;

								if (isLink) {
									tmp = parseInt(obj[nm + '_id']['order']);
									order = isNaN(tmp) ? 0 : tmp;

									if (!sortDATA[order]) {
										sortDATA[order] = [];
										sortDATA[order].push(idx);
									} else sortDATA[order].push(idx);
								} else {
										if (Array.isArray(obj)) {
											if (obj.length) {
												__obj = obj[0];
												if (__obj && (typeof __obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(__obj)) === 'object') {
													for (var _i in __obj) {
														if (__obj.hasOwnProperty(_i)) {
															____obj = __obj[_i];

															if (____obj && (typeof ____obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(____obj)) === 'object' && 'order' in ____obj) {
																tmp = parseInt(____obj['order']);
																order = isNaN(tmp) ? 0 : tmp;

																if (!sortDATA[order]) {
																	sortDATA[order] = [];
																	sortDATA[order].push(idx);
																} else sortDATA[order].push(idx);

																break;
															}
														}
													}
												}
											}

											continue;
										}

										for (var _i2 in obj) {
											if (obj.hasOwnProperty(_i2)) {
												__obj = obj[_i2];

												if (__obj && (typeof __obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(__obj)) === 'object' && 'order' in __obj && 'title' in __obj && 'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined && 'type' in __obj && __obj['type'] !== 'hidden') {
													tmp = parseInt(__obj['order']);
													order = isNaN(tmp) ? 0 : tmp;

													if (!sortDATA[order]) {
														sortDATA[order] = [];
														sortDATA[order].push(_i2);
													} else sortDATA[order].push(_i2);
												} else {
													if (idx === 'role' && _i2 === 'permissions') sortDATA[9999] = [_i2];else if (idx === 'service' && _i2 === 'service_data' && this.$store.state.user_type === 'admin') {
															tmp = parseInt(__obj['order']);
															order = isNaN(tmp) ? 0 : tmp;

															if (!sortDATA[order]) {
																sortDATA[order] = [];
																sortDATA[order].push(_i2);
															} else sortDATA[order].push(_i2);
														} else {
																for (var w in __obj) {
																	if (__obj.hasOwnProperty(w)) {
																		____obj = __obj[w];

																		if (____obj && (typeof ____obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(____obj)) === 'object' && 'order' in ____obj && 'title' in ____obj && 'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined && 'type' in ____obj && ____obj['type'] !== 'hidden') {
																			tmp = parseInt(____obj['order']);
																			order = isNaN(tmp) ? 0 : tmp;

																			if (!sortDATA[order]) {
																				sortDATA[order] = [];
																				sortDATA[order].push(w);
																			} else sortDATA[order].push(w);
																		}
																	}
																}
															}
												}
											}
										}
									}
							}
					}
				}
			}
			if (this.crud === 'user' || this.crud === 'admin') {
				if ('1' in sortDATA) {
					var arr = sortDATA['1'];
					var newArr = [];

					for (var _i3 = 0; _i3 < arr.length; _i3++) {
						if (arr[_i3].indexOf('avatar_path') !== -1) {
							newArr.push(arr[_i3]);
							break;
						}
					}
					for (var _i4 = 0; _i4 < arr.length; _i4++) {
						if (arr[_i4].indexOf('avatar_path') === -1) newArr.push(arr[_i4]);
					}sortDATA['1'] = newArr;
				}
			}

			if (this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup') {
				if ('1' in sortDATA) {
					var _arr = sortDATA['1'];
					var _newArr = [];

					for (var _i5 = 0; _i5 < _arr.length; _i5++) {
						if (_arr[_i5].indexOf('image_path') !== -1) {
							_newArr.push(_arr[_i5]);
							break;
						}
					}
					for (var _i6 = 0; _i6 < _arr.length; _i6++) {
						if (_arr[_i6].indexOf('image_path') === -1) _newArr.push(_arr[_i6]);
					}sortDATA['1'] = _newArr;
				}
			}

			if (this.crud === 'paymentsaved') {
				if ('1' in sortDATA) {
					var _arr2 = sortDATA['1'];
					var _newArr2 = [];

					for (var _i7 = 0; _i7 < _arr2.length; _i7++) {
						if (_arr2[_i7].indexOf('saved_image') !== -1) {
							_newArr2.push(_arr2[_i7]);
							break;
						}
					}
					for (var _i8 = 0; _i8 < _arr2.length; _i8++) {
						if (_arr2[_i8].indexOf('saved_image') === -1) _newArr2.push(_arr2[_i8]);
					}sortDATA['1'] = _newArr2;
				}
			}

			return sortDATA;
		},
		needRefresh: function needRefresh() {
			this.requestViewData();
		},
		errorFilter: function errorFilter(msg) {
			this.localErrorMessage = msg;
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			var _id = _parts[2];

			if (!_id) return;

			if (String(_id) !== String(this.id)) return;

			this.requestViewData();
		}
	},

	components: {
		viewComponent: __WEBPACK_IMPORTED_MODULE_3__components_elements_view___default.a
	}

});

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData.title)))]), _vm._v(" "), _vm._l((_vm.Keys), function(row) {
    return (_vm.Keys.length) ? _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.sortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.sortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": _vm.crud,
          "realCrudName": _vm.realCrudName,
          "firstElement": _vm.sortDATA && _vm.sortDATA['1'] && _vm.sortDATA['1'][0] ? _vm.sortDATA['1'][0] : null,
          "objectId": _vm.id
        },
        on: {
          "needRefresh": _vm.needRefresh,
          "errorFilter": _vm.errorFilter
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.viewData && 'logs' in _vm.viewData && _vm.viewData['logs'] && Array.isArray(_vm.viewData['logs']) && _vm.viewData['logs'].length) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-view-field",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('logs/title')))]), _vm._v(" "), _c('table', {
    staticClass: "w5-view-field-table w5-view-field-table-logs"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("ftc")('operation/comment')))]), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('th', [_vm._v(_vm._s(_vm._f("ftc")('main/data')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewData['logs']), function(log, idx) {
    return _c('tr', {
      key: 'tr-' + idx
    }, [_c('td', {
      attrs: {
        "align": "center",
        "aria-label": _vm._f("ftc")('main/created')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(log.log_date && log.log_date.value ? _vm.formater_StrDateFormat(log.log_date.value) : '') + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('operation/comment')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(log.log_comment && log.log_comment.value ? log.log_comment.value : '')) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('main/data')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [(log.log_data && log.log_data.value && String(log.log_data.value).trim() !== '') ? _c('pre', [_vm._v(_vm._s(log.log_data.value))]) : _vm._e()])]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    class: {
      hidden: _vm.form_Loading
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.backButton($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/back')))]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vds_command__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vds_command___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_vds_command__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vds_access__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vds_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_vds_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vds_plan__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vds_plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_vds_plan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vds_reinstall__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vds_reinstall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_vds_reinstall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vds_ip__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vds_ip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_vds_ip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vds_localIp__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vds_localIp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_vds_localIp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vds_backup__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vds_backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_vds_backup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_vds_disk__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_vds_disk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_vds_disk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_vds_stat__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_vds_stat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_vds_stat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_debounce__);


















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'vdsView',
	data: function data() {
		return {
			crud: 'vds',

			id: null,

			localErrorMessage: '',
			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			vdsData: {},

			planData: null,

			templateData: null,

			hostData: null,

			sshkeyData: null,

			snapshotData: null,

			backupData: null,

			reisoData: null,

			isoList: null,
			isoFieldFirst: null,
			isoFieldSecond: null,

			isoFieldsTitles: null,

			ipData: null,

			ipLocalData: null,

			passwordType: null,

			reserveIpData: null,

			reserveIPv4List: null,

			tabs: [{ 'id': 'command', 'title': 'service/vds_control' }, { 'id': 'access', 'title': 'main/access' }, { 'id': 'plan', 'title': 'plan/plan' }, { 'id': 'reinstall', 'title': 'service/reinstall' }, { 'id': 'ip', 'title': 'service/ip_count' }, { 'id': 'localIp', 'title': 'datacenter/local_net' }, { 'id': 'backup', 'title': 'service/backups' }, { 'id': 'disks', 'title': 'service/extdisks' }, { 'id': 'stat', 'title': 'service/stat' }],

			curTab: 'command',

			showNameModal: false,
			nameValue: '',
			nameField: {
				required: true,
				type: 'text',
				title: 'main/name',
				_field_name: 'serviceName',
				_visible: true,
				_errMsg: ''
			},

			isConstructPlanChanged: false,

			notCloseModals: false
		};
	},

	computed: {
		localErrorMessageClear: function localErrorMessageClear() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return '';
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1);
			return this.localErrorMessage;
		},
		localErrorMessageButton: function localErrorMessageButton() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return false;
			if (this.localErrorMessage.charAt(0) === 'x') return false;
			return true;
		},
		isDataReady: function isDataReady() {
			return this.isCorrectData(this.vdsData);
		},
		Access: function Access() {
			if (this.vdsData['service']['service_status']['text'] && String(this.vdsData['service']['service_status']['text']).length) {
				if (this.vdsData['service']['service_status']['value'] !== 'active') return false;
			}

			if (this.serviceStatus && (this.serviceStatus.loader || this.serviceStatus.timer)) {
				return false;
			}

			return this.isAccess('service/update');
		},
		serviceName: function serviceName() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_name'] && 'value' in this.vdsData['service']['service_name']) return this.vdsData['service']['service_name']['value'];

			return null;
		},
		serviceFullName: function serviceFullName() {
			var _fullName = this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_name'] && 'value' in this.vdsData['service']['service_name'] ? this.vdsData['service']['service_name']['value'] : '';
			if (this.vdsData && this.vdsData['title']) {
				var _search = this.vdsData['title'].match(/«(.*)»/i);
				if (_search !== null && _search.length) _fullName = this.localeFtc(_search[1]);
			}

			return _fullName;
		},
		dataCenter: function dataCenter() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['datacenter']) return this.vdsData['service']['service_data']['value']['datacenter'];

			return null;
		},
		serviceIP: function serviceIP() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['ip'] && this.vdsData['service']['service_data']['value']['ip']['ip']) return this.vdsData['service']['service_data']['value']['ip']['ip'];

			return '';
		},
		serviceIPActive: function serviceIPActive() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['ip'] && 'active' in this.vdsData['service']['service_data']['value']['ip']) return Boolean(this.vdsData['service']['service_data']['value']['ip']['active']);

			return true;
		},
		serviceStatus: function serviceStatus() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_status']) return __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].cellStatusInView(this.vdsData['service']['service_status']);

			return null;
		},
		serviceStatusClear: function serviceStatusClear() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_status'] && 'value' in this.vdsData['service']['service_status']) return this.vdsData['service']['service_status']['value'];

			return null;
		},
		serviceTemplate: function serviceTemplate() {
			if (this.vdsData && this.vdsData['template']) return this.vdsData['template'];

			return null;
		},
		templateName: function templateName() {
			if (this.vdsData && this.vdsData['template'] && this.vdsData['template']['template_name'] && 'value' in this.vdsData['template']['template_name']) return this.vdsData['template']['template_name']['value'];

			return null;
		},
		templateInstruction: function templateInstruction() {
			if (this.vdsData && this.vdsData['template'] && this.vdsData['template']['template_instruction']) return this.vdsData['template']['template_instruction'];

			return null;
		},
		templateInfo: function templateInfo() {
			if (this.templateData) return this.templateData;
			return null;
		},
		reisoInfo: function reisoInfo() {
			if (this.reisoData) return this.reisoData;
			return null;
		},
		serviceTemplateId: function serviceTemplateId() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['template'] && this.vdsData['service']['service_data']['value']['template']['id']) return this.vdsData['service']['service_data']['value']['template']['id'];

			return null;
		},
		servicePlanInfo: function servicePlanInfo() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['plan'] && this.vdsData['service']['service_data']['value']['plan']['data']) return this.vdsData['service']['service_data']['value']['plan']['data'];

			return null;
		},
		planInfo: function planInfo() {
			if (this.planData) return this.planData;
			return null;
		},
		servicePlanId: function servicePlanId() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['plan'] && this.vdsData['service']['service_data']['value']['plan']['id']) return this.vdsData['service']['service_data']['value']['plan']['id'];

			return null;
		},
		serviceProlong: function serviceProlong() {
			return this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_autoprolong'] && 'value' in this.vdsData['service']['service_autoprolong'] ? this.vdsData['service']['service_autoprolong']['value'] : null;
		},
		serviceCanProlong: function serviceCanProlong() {
			return this.vdsData && this.vdsData['service'] && this.vdsData['service']['can_prolong'] === true;
		},
		serviceCanDelete: function serviceCanDelete() {
			var _canDel = false;

			if (this.vdsData && this.vdsData['service'] && 'can_delete' in this.vdsData['service']) {
				_canDel = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(this.vdsData['service']['can_delete']);
			} else {
				_canDel = true;

				if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_status'] && 'value' in this.vdsData['service']['service_status'] && String(this.vdsData['service']['service_status']['value']).indexOf('delete') >= 0) {
					_canDel = false;
				}
			}

			return _canDel;
		},
		account: function account() {
			return this.vdsData && this.vdsData['account'] ? this.vdsData['account'] : null;
		},
		hostInfo: function hostInfo() {
			if (this.hostData) return this.hostData;
			return null;
		},
		sshkey: function sshkey() {
			return this.vdsData && this.vdsData['sshkey'] ? this.vdsData['sshkey'] : null;
		},
		sshkeyInfo: function sshkeyInfo() {
			if (this.sshkeyData) return this.sshkeyData;
			return null;
		},
		canReboot: function canReboot() {
			return this.vdsData && this.vdsData['service'] && 'can_reboot' in this.vdsData['service'] ? this.vdsData['service']['can_reboot'] : false;
		},
		canIpLocal: function canIpLocal() {
			return this.vdsData && this.vdsData['service'] && 'can_ip_local' in this.vdsData['service'] ? this.vdsData['service']['can_ip_local'] : false;
		},
		canBackup: function canBackup() {
			return this.vdsData && this.vdsData['service'] && 'can_backup' in this.vdsData['service'] ? this.vdsData['service']['can_backup'] : false;
		},
		canDisks: function canDisks() {
			return this.vdsData && this.vdsData['service'] && 'can_extdisk' in this.vdsData['service'] ? this.vdsData['service']['can_extdisk'] : false;
		},
		trafInfo: function trafInfo() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_traff']) return this.vdsData['service']['service_traff'];

			return null;
		},
		snapshotInfo: function snapshotInfo() {
			if (this.snapshotData) return this.snapshotData;
			return null;
		},
		backupInfo: function backupInfo() {
			if (this.backupData) return this.backupData;
			return null;
		},
		isoInfo: function isoInfo() {
			return this.vdsData && this.vdsData['iso'] ? this.vdsData['iso'] : null;
		},
		isoData: function isoData() {
			return this.isoList;
		},
		serviceIPData: function serviceIPData() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['ip']) return this.vdsData['service']['service_data']['value']['ip'];

			return null;
		},
		serviceLocalIPData: function serviceLocalIPData() {
			if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_data'] && this.vdsData['service']['service_data']['value'] && this.vdsData['service']['service_data']['value']['local_ip']) return this.vdsData['service']['service_data']['value']['local_ip'];

			return '';
		},
		ipInfo: function ipInfo() {
			return this.ipData;
		},
		isAccountBlockVisible: function isAccountBlockVisible() {
			if (this.$store.state.user_type === 'admin') return true;

			if (this.sshkey && this.sshkey['key_id'] && this.sshkey['key_id']['value'] && this.sshkey['key_name'] && this.sshkey['key_name']['value']) return true;

			return false;
		}
	},
	created: function created() {
		var _this = this;

		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.$store.dispatch('getTemplateGroupCache');

		this.maskModalFlag = false;

		this.refreshVDSData = __WEBPACK_IMPORTED_MODULE_15_debounce___default()(this.refreshVDSData, 500);
		this.makeRequestForUpdateDataDebounce = __WEBPACK_IMPORTED_MODULE_15_debounce___default()(this.makeRequestForUpdateDataDebounce, 1500, false);

		this.id = this.$route.params['id'];
		if (this.id) {
			this.requestVDSData();
		} else {
			this.localErrorMessage = this.localeFtc('main/unknown_page');
		}

		if (this.$store.state.vdsCommand && String(this.$store.state.vdsCommand['id']) === String(this.id) && (this.$store.state.vdsCommand['command'] === 'plan' || this.$store.state.vdsCommand['command'] === 'reinstall' || this.$store.state.vdsCommand['command'] === 'password')) {
			var _command = this.$store.state.vdsCommand['command'];
			var callFunction = null;
			if (_command === 'password') {
				_command = 'access';
				callFunction = 'changePassword';
			}

			this.$nextTick(function () {
				if (callFunction) window.sessionStorage.setItem('callFunction', callFunction);

				_this.choiceTab(_command);
			});

			this.$store.commit('setVdsCommand', false);
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		document.addEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged);

		window.onbeforeunload = this.onBeforeUnload;

		window.addEventListener('storage', this.onLocalStorageEvent);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
		document.removeEventListener('keydown', this.keyDownHandler);
		__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged);
		window.removeEventListener('storage', this.onLocalStorageEvent);
		window.onbeforeunload = null;
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState());
	},

	methods: {
		requestVDSData: function requestVDSData(refreshCache) {
			var _this2 = this;

			if (!this.id) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(function (respons) {
				var _dt = respons && respons.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(respons.data) === 'object' ? respons.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['service'] && _dt['service']['service_status'] && _dt['service']['service_status']['value'] === 'deleted') {
					_this2.localErrorMessage = 'x<b>service/status_error:</b><br> service/deleted';
					return;
				}

				if (_dt && _dt['status'] === 'ok' && _dt['service'] && _dt['service']['service_status'] && _dt['service']['service_status']['value'] === 'error') {
					_this2.localErrorMessage = 'x<b>service/status_error:</b><br> error/api_incorrect';
					return;
				}

				if (_this2.isCorrectData(_dt)) {
					_this2.vdsData = _dt;

					if (_this2.vdsData['group'] && _this2.vdsData['group']['group_id'] && _this2.vdsData['group']['group_id']['value']) _this2.$store.commit('setVdsGroupId', _this2.vdsData['group']['group_id']['value']);

					if (!_this2.tabVisible(_this2.curTab)) _this2.curTab = 'command';

					if (refreshCache) {
						_this2.planData = null;
						_this2.templateData = null;
						_this2.reisoData = null;
						_this2.snapshotData = null;
						_this2.backupData = null;
						_this2.ipData = null;
						_this2.passwordType = null;

						_this2.requestUpdateData(false, true);
					}

					return;
				}

				_this2.form_ErrorMessage = _this2.localeFtc('error/api_incorrect');
			}, function (respons) {
				_this2.form_ErrorMessage = _this2.localeFtc('error/api_incorrect');
			});
		},
		isCorrectData: function isCorrectData(data) {
			if (this.$store.state.user_type === 'admin') return this.isCorrectDataForAdmin(data);
			if (this.$store.state.user_type === 'client') return this.isCorrectDataForClient(data);
			return false;
		},
		isCorrectDataForAdmin: function isCorrectDataForAdmin(data) {
			if (!data || data['status'] !== 'ok' || !data['account'] || !data['plan'] || !data['server'] || !data['service'] || !data['service_type'] || !data['template']) return false;

			if (!data['service']['service_name'] || !data['service']['service_name']['value']) return false;

			if (!data['service']['service_status'] || !data['service']['service_status']['value']) return false;

			if (!data['service']['service_data'] || !data['service']['service_data']['value'] || !data['service']['service_data']['value']['datacenter'] || !data['service']['service_data']['value']['datacenter']['country']) return false;

			if (!data['account']['account_id'] || !data['account']['account_id']['value'] || !data['account']['account_name'] || !data['account']['account_name']['value']) return false;

			if (!data['template']['template_id'] || !data['template']['template_id']['value'] || !data['template']['template_image'] || !data['template']['template_image']['value'] || !data['template']['template_name'] || !data['template']['template_name']['value']) return false;

			if (!data['service']['service_data'] || !data['service']['service_data']['value'] || !data['service']['service_data']['value']['plan'] || !data['service']['service_data']['value']['plan']['data']) return false;

			return true;
		},
		isCorrectDataForClient: function isCorrectDataForClient(data) {
			if (!data || data['status'] !== 'ok' || !data['plan'] || !data['service'] || !data['service_type'] || !data['template']) return false;

			if (!data['service']['service_name'] || !data['service']['service_name']['value']) return false;

			if (!data['service']['service_status'] || !data['service']['service_status']['value']) return false;

			if (!data['service']['service_data'] || !data['service']['service_data']['value'] || !data['service']['service_data']['value']['datacenter'] || !data['service']['service_data']['value']['datacenter']['country']) return false;

			if (!data['template']['template_id'] || !data['template']['template_id']['value'] || !data['template']['template_image'] || !data['template']['template_image']['value'] || !data['template']['template_name'] || !data['template']['template_name']['value']) return false;

			if (!data['service']['service_data'] || !data['service']['service_data']['value'] || !data['service']['service_data']['value']['plan'] || !data['service']['service_data']['value']['plan']['data']) return false;

			return true;
		},
		choiceTab: function choiceTab(id) {
			if (this.curTab === 'plan') {
				if (!this.onBeforePopState()) return;
			}

			if ((!this.planData || !this.templateData || !this.snapshotData || !this.backupData || !this.reisoData || !this.ipData || !this.ipLocalData || !this.isoList || !this.passwordType || !this.reserveIpData || !this.reserveIPv4List) && (id === 'plan' || id === 'reinstall' || id === 'snapshot' || id === 'backup' || id === 'ip' || id === 'localIp' || id === 'command' || id === 'access')) {
				this.requestUpdateData();
			}

			if (id === 'reinstall') this.requestTemplatesList();

			this.curTab = id;
		},
		requestUpdateData: function requestUpdateData(data) {
			var withDebounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (data) {
				this.saveToCache(data);
				return;
			}

			if (withDebounce) this.makeRequestForUpdateDataDebounce();else this.makeRequestForUpdateData();
		},
		makeRequestForUpdateData: function makeRequestForUpdateData() {
			var _this3 = this;

			if (this.serviceStatusClear === 'block' || this.serviceStatusClear === 'deleted' || this.serviceStatusClear === 'new') {
				return;
			}

			if (this.vdsData['service'] && this.vdsData['service']['service_status'] && this.vdsData['service']['service_status']['text'] && String(this.vdsData['service']['service_status']['text']).length && String(this.vdsData['service']['service_status']['text']).indexOf('type_delete') > 0) {
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/update/' + this.id).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
				if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['plan_id'] && _dt['fields']['template_id']) {
					_this3.saveToCache(_dt);
				}
			}).catch(function () {
				if (_this3.$store.state.isDebug) window.DEBUG.error('vdsView (rud01): запрос вернул ошибку');
			});
		},
		makeRequestForUpdateDataDebounce: function makeRequestForUpdateDataDebounce() {
			var _this4 = this;

			this.$http.get(this.APIServerUrl + '/service/update/' + this.id).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
				if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['plan_id'] && _dt['fields']['template_id']) {
					_this4.saveToCache(_dt);
				}
			}).catch(function () {
				if (_this4.$store.state.isDebug) window.DEBUG.error('vdsView (rud01): запрос вернул ошибку');
			});
		},
		saveToCache: function saveToCache(data) {
			var _this5 = this;

			var _dt = data;
			if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['plan_id'] && _dt['fields']['template_id']) {
				this.planData = _dt['fields']['plan_id'];
				this.templateData = _dt['fields']['template_id'];
				this.hostData = _dt['fields']['hostname'];
				this.sshkeyData = _dt['fields']['sshkey_id'];
				this.snapshotData = _dt['fields']['snapshot_create'];
				this.isoList = this.makeIsoList(_dt);
				this.isoFieldFirst = _dt['fields']['iso_id'] ? _dt['fields']['iso_id'] : null;
				this.isoFieldSecond = _dt['fields']['iso_secondary_id'] ? _dt['fields']['iso_secondary_id'] : null;
				this.reisoData = _dt['fields']['reiso_id'];
				this.ipLocalData = _dt['fields']['ip_local'] ? _dt['fields']['ip_local'] : null;
				this.reserveIpData = _dt['fields']['reserve_ip'] ? _dt['fields']['reserve_ip'] : null;
				this.reserveIPv4List = _dt['fields']['use_reserve_ip'] ? _dt['fields']['use_reserve_ip'] : null;

				this.isoFieldsTitles = {};
				if (_dt['fields']['iso_id'] && _dt['fields']['iso_id']['title']) {
					this.isoFieldsTitles['iso_id'] = _dt['fields']['iso_id']['title'];
				}
				if (_dt['fields']['iso_secondary_id'] && _dt['fields']['iso_secondary_id']['title']) {
					this.isoFieldsTitles['iso_secondary_id'] = _dt['fields']['iso_secondary_id']['title'];
				}

				this.ipData = null;
				if (_dt['fields']['ip4_count']) {
					this.ipData = {
						'ip4': {
							'title': _dt['fields']['ip4_count']['title'],
							'cost': _dt['fields']['ip4_count']['cost'],
							'full_cost': _dt['fields']['ip4_count']['full_cost'],
							'for': _dt['fields']['ip4_count']['for'],
							'max': _dt['fields']['ip4_count']['max'],
							'period': _dt['fields']['ip4_count']['period'],
							'count': _dt['fields']['ip4_count']['value']
						}
					};
				}

				if (_dt['fields']['ip6_count']) {
					if (!this.ipData) this.ipData = {};
					this.ipData['ip6'] = {
						'title': _dt['fields']['ip6_count']['title'],
						'cost': _dt['fields']['ip6_count']['cost'],
						'full_cost': _dt['fields']['ip6_count']['full_cost'],
						'for': _dt['fields']['ip6_count']['for'],
						'max': _dt['fields']['ip6_count']['max'],
						'period': _dt['fields']['ip6_count']['period'],
						'count': _dt['fields']['ip6_count']['value']
					};
				}

				this.backupData = null;
				if (_dt['fields']['backup_create']) {
					this.backupData = {
						'create': _dt['fields']['backup_create']
					};
				}

				if (_dt['fields']['backup_id']) {
					if (!this.backupData) this.backupData = {};
					this.backupData['backup_id'] = _dt['fields']['backup_id'];
				}

				this.passwordType = null;
				if (_dt['fields']['password_type'] && _dt['fields']['password_type']['list']) {
					this.passwordType = _dt['fields']['password_type']['list'];
				}

				this.planData['_visible'] = true;
				this.planData['_field_name'] = 'plan_id';
				this.planData['_errMsg'] = '';

				this.templateData['_visible'] = true;
				this.templateData['_field_name'] = 'template_id';
				this.templateData['_errMsg'] = '';

				if (this.curTab === 'reinstall') this.requestTemplatesList();

				this.hostData['_visible'] = true;
				this.hostData['_field_name'] = 'hostname';
				this.hostData['_errMsg'] = '';

				this.sshkeyData['_visible'] = true;
				this.sshkeyData['_field_name'] = 'sshkey_id';
				this.sshkeyData['_errMsg'] = '';

				var _found = this.sshkeyData['list'].some(function (obj) {
					return obj && String(obj.id) === '-1000';
				});

				if (!_found) {
					this.sshkeyData['list'].unshift({
						'id': -1000,
						'name': this.localeFtc('sshkey/not_use')
					});
				}

				if (this.planData && this.planData['list'] && Array.isArray(this.planData['list']) && this.planData['list'].length) {
					this.planData['list'].some(function (item, index, arr) {
						if (String(item.id) === String(_this5.servicePlanId)) {
							arr[index]['enable'] = false;
							return true;
						}
					});
				}
			}
		},
		updateData: function updateData(data) {
			if (this.serviceStatusClear !== 'active' || !this.Access) {
				this.reserveIpData = false;
				return;
			}

			var isDebounce = this.curTab !== 'command' && this.curTab !== 'ip';
			this.requestUpdateData(data, isDebounce);
		},
		requestTemplatesList: function requestTemplatesList() {
			var _this6 = this;

			if (!this.templateData || !this.templateData['url'] || !this.servicePlanId) return;

			var _url = this.APIServerUrl + this.templateData['url'] + this.servicePlanId;

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
				if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']) && _dt['result'].length) {
					_this6.$set(_this6.templateData, 'list', _dt['result']);
				}
			});
		},
		requestExtDisks: function requestExtDisks() {},
		tabVisible: function tabVisible(id) {
			if (this.serviceStatusClear !== 'active') {
				if (id === 'plan' || id === 'reinstall' || id === 'snapshot' || id === 'backup' || id === 'disks' || id === 'access' || id === 'ip' || id === 'localIp') return false;
			}

			if (id === 'localIp' && !this.canIpLocal) return false;
			if (id === 'backup' && !this.canBackup) return false;
			if (id === 'disks' && !this.canDisks) return false;

			if (id === 'stat') return this.isAccess('service/stat');
			if (id === 'snapshot' || id === 'backup' || id === 'disks' || id === 'ip' || id === 'localIp') return this.isAccess('service/update');

			return true;
		},
		changeServiceName: function changeServiceName() {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var result, _dt;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (_this7.Access) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								if (!(_this7.serviceStatus['loader'] === true || _this7.serviceStatus['timer'] === true)) {
									_context.next = 4;
									break;
								}

								return _context.abrupt('return');

							case 4:
								if (!(_this7.serviceStatusClear !== 'active')) {
									_context.next = 6;
									break;
								}

								return _context.abrupt('return');

							case 6:
								_this7.nameValue = _this7.serviceName;
								_this7.nameField._errMsg = '';
								_this7.localErrorMessage = '';
								_this7.localSuccessMessage = '';

								_context.next = 12;
								return _this7.$http.get(_this7.APIServerUrl + '/service/update/' + _this7.id);

							case 12:
								result = _context.sent;
								_dt = result && result.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(result.data) === 'object' ? result.data : false;

								if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form' && _dt['fields'] && 'name' in _dt['fields'] && _dt['fields']['name'] && 'value' in _dt['fields']['name'] && _dt['fields']['name']['value']) {
									_this7.nameValue = _dt['fields']['name']['value'];
								}

								__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this7.showNameModal = true;

							case 17:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this7);
			}))();
		},
		hideNameModal: function hideNameModal() {
			var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (!forceClose) {
				if (!this.maskModalFlag) return;
			}

			__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showNameModal = false;
			this.hideModalMask();
		},
		onFocusName: function onFocusName() {
			this.nameField['_errMsg'] = '';
		},
		nameChangeStart: function nameChangeStart() {
			var _this8 = this;

			if (!this.Access) return;

			if (this.nameField['_errMsg'] !== '') return;

			if (!this.nameValue || this.nameValue.trim() === '') {
				this.nameField['_errMsg'] = 'validators/error_req';
				return;
			}

			var _url = this.APIServerUrl + '/service/update/' + this.id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'name': _this8.nameValue.trim(),
						'reinstall': 0
					};

					if ('fields' in _dt && _dt['fields'] && 'name' in _dt['fields'] && _dt['fields']['name'] && 'value' in _dt['fields']['name'] && _dt['fields']['name']['value'] === _this8.nameValue.trim()) {
						_this8.hideNameModal();

						return;
					}

					_this8.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this8.hideNameModal();

							_this8.setLocalSuccessMessage('main/updated');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							_this8.nameField['_errMsg'] = _this8.localeFtc('main/validation_error');

							if (_dt['fields'] && _dt['fields']['name']) {
								if (Array.isArray(_dt['fields']['name'])) {
									if (_dt['fields']['name'].length) _this8.nameField['_errMsg'] = _this8.localeFtc(_dt['fields']['name'][0]);
								} else {
									_this8.nameField['_errMsg'] = _this8.localeFtc(_dt['fields']['name']);
								}
							}
							return;
						}

						_this8.hideNameModal();

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					}, function (resPost) {
						_this8.hideNameModal();

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					});

					return;
				}

				_this8.hideNameModal();

				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			}, function (resGet) {
				_this8.hideNameModal();

				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			});
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				e.preventDefault();

				if (this.notCloseModals) return;

				this.hideNameModal();
			}
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			var _id = _parts[2];

			if (!_id) return;

			var _isVDS = String(_id) === String(this.id);

			var _isISO = this.isoInfo && this.isoInfo['service_id'] && this.isoInfo['service_id']['value'] && String(this.isoInfo['service_id']['value']) === String(_id);

			var _isSSH = this.sshkey && this.sshkey['key_id'] && this.sshkey['key_id']['value'] && String(this.sshkey['key_id']['value']) === String(_id);

			if (_isVDS || _isISO || _isSSH) this.requestVDSData(true);
		},
		refreshVDSData: function refreshVDSData() {
			this.requestVDSData(true);
		},
		onSuccessMessage: function onSuccessMessage(msg) {
			this.setLocalSuccessMessage(msg);
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_13__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(account) {
			var _this9 = this;

			if (this.$store.state.user_type !== 'admin') return;

			if (account) {
				if (!/\d+/.test(account)) return;
				var _accountID = parseInt(account);
				if (isNaN(_accountID) || _accountID < 1) return;

				var _url = this.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				this.$store.commit('accountGlobalFilter', false);

				this.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this9.$store.commit('accountGlobalFilter', true);

						if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

						_this9.$store.dispatch('getTicketCounters');
						_this9.$store.dispatch('getRequestCounter');

						_this9.setLocalSuccessMessage('main/set_filter ' + _this9.account['account_name']['value']);

						_this9.requestVDSData();

						return;
					}

					_this9.localErrorMessage = _this9.formatRequestError(resGet);
				}, function (resGet) {
					_this9.localErrorMessage = _this9.formatRequestError(resGet);
				});
			} else {
					var _url2 = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

					this.$http.get(_url2).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this9.$store.commit('accountGlobalFilter', false);

							if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

							_this9.$store.dispatch('getTicketCounters');
							_this9.$store.dispatch('getRequestCounter');

							_this9.setLocalSuccessMessage(_this9.localeFtc('main/filter') + ' ' + _this9.localeFtc('main/deleted').toLowerCase());

							_this9.requestVDSData();

							return;
						}

						_this9.localErrorMessage = _this9.formatRequestError(resGet);
					}, function (resGet) {
						_this9.localErrorMessage = _this9.formatRequestError(resGet);
					});
				}
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestVDSData();
			}
		},
		onBeforePopState: function onBeforePopState() {
			if (!this.$store.state.is_auth) return true;

			if (this.$store.state.isInitFormsValue > 0) return true;

			if (this.$store.state.applicationBlocked) {
				return false;
			}

			if (this.planData && this.planData.has_params && this.isConstructPlanChanged) {
				if (confirm(this.localeFtc('application/leave_page_confirm'))) {
					return true;
				} else {
					return false;
				}
			}

			return true;
		},
		onBeforeUnload: function onBeforeUnload() {
			if (this.planData && this.planData.has_params && this.isConstructPlanChanged && !this.$store.state.applicationBlocked) {
				return 'Возможно, внесенные изменения не сохранятся.';
			}
		},
		handlePlanConstructorChanged: function handlePlanConstructorChanged(value) {
			if (this.planData && this.planData.has_params) {
				this.isConstructPlanChanged = value;
			}
		},
		onDropPlanConstructorChanged: function onDropPlanConstructorChanged() {
			this.isConstructPlanChanged = false;
		},
		makeIsoList: function makeIsoList(data) {
			if (!data || !data['fields']) return [];

			var _answer = [];

			if (data['fields']['iso_id'] && data['fields']['iso_id']['list'] && data['fields']['iso_id']['list'].length) {
				data['fields']['iso_id']['list'].forEach(function (val) {
					if (val && val.id && val.name) {
						_answer.push(val);
					}
				});
			}

			if (data['fields']['iso_secondary_id'] && data['fields']['iso_secondary_id']['list'] && data['fields']['iso_secondary_id']['list'].length) {
				data['fields']['iso_secondary_id']['list'].forEach(function (val) {
					if (val && val.id && val.name) {
						var _found = _answer.some(function (o) {
							if (o && o.id === val.id) return true;
						});

						if (!_found) _answer.push(val);
					}
				});
			}

			if (_answer.length) {
				_answer.sort(function (a, b) {
					return a.id - b.id;
				});
			}

			return _answer;
		}
	},

	components: {
		tabCommand: __WEBPACK_IMPORTED_MODULE_4__components_vds_command___default.a,
		tabAccess: __WEBPACK_IMPORTED_MODULE_5__components_vds_access___default.a,
		tabPlan: __WEBPACK_IMPORTED_MODULE_6__components_vds_plan___default.a,
		tabReinstall: __WEBPACK_IMPORTED_MODULE_7__components_vds_reinstall___default.a,
		tabIp: __WEBPACK_IMPORTED_MODULE_8__components_vds_ip___default.a,
		tabLocalIp: __WEBPACK_IMPORTED_MODULE_9__components_vds_localIp___default.a,
		tabBackup: __WEBPACK_IMPORTED_MODULE_10__components_vds_backup___default.a,
		tabDisks: __WEBPACK_IMPORTED_MODULE_11__components_vds_disk___default.a,
		tabStat: __WEBPACK_IMPORTED_MODULE_12__components_vds_stat___default.a,
		Field: __WEBPACK_IMPORTED_MODULE_14__components_elements_formfield___default.a
	}

});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_urlbtn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_urlbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_urlbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_linkifyjs_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus_js__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabCommand',

	props: ['vdsId', 'access', 'status', 'serviceStatus', 'canReboot', 'serviceName', 'serviceFullName', 'templateName', 'templateInstruction', 'iso', 'active', 'serviceProlong', 'serviceCanProlong', 'serviceCanDelete', 'parentError', 'reserveIpData'],

	computed: {
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		},
		modalConfirmButtonTitle: function modalConfirmButtonTitle() {
			if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc(this.modalConfirmButtonTitleText);
			return this.confirmModalTimer + ' - ' + this.localeFtc(this.modalConfirmButtonTitleText);
		},
		isISOProcessActive: function isISOProcessActive() {
			if (!this.ISO || !this.ISO.length) return false;

			return this.ISO.some(function (iso) {
				if (iso && iso['service_status'] && iso['service_status']['text']) {
					return true;
				}
			});
		},
		reserveIpCost: function reserveIpCost() {
			if (!this.reserveIpData || !('cost' in this.reserveIpData)) return '';
			if (this.reserveIpData['cost'] <= 0) return '';

			return this.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>').replace('{cost}', this.reserveIpData['cost']).replace('{period}', this.localeFtc(this.reserveIpData['period'])).replace('{for}', this.localeFtc(this.reserveIpData['for']));
		}
	},
	data: function data() {
		return {
			Access: false,
			Status: null,
			Reboot: false,
			Template: '',
			fullName: '',
			ISO: null,
			validOsAndIso: false,
			Error: '',

			localErrorMessage: '',

			showRebootModal: false,
			rebootModalText: '',
			rebootHardValue: false,

			autoProlongValue: false,
			autoProlongProcessing: false,

			reserveIpLocalData: null,
			reserveIpValue: false,
			reserveIpProcessing: false,

			canDelete: true,

			canProlong: false,
			canProlongProcessing: false,

			showPasswordModal: false,
			passwordWarning: '',
			rebootWarning: '',
			passwordValue: '',
			passwordField: {
				'required': true,
				'type': 'password',
				'title': 'main/new_password',
				'_field_name': 'newPassword',
				'_visible': true,
				'generator': true,
				'_errMsg': ''
			},

			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,

			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalText: '',
			modalConfirmButtonTitleText: '',
			confirmStart: function confirmStart() {},

			confirmModalTimer: false,
			confirmModalTimerHandle: false,

			showOperISOModal: false,
			operisoModalText: '',
			operisoModalButton: '',
			isoValue1: null,
			isoField1: {
				required: true,
				type: 'list',
				list: [],
				title: 'service/iso',
				_field_name: 'iso_id1',
				_visible: true,
				_errMsg: ''
			},
			isoValue2: null,
			isoField2: {
				required: true,
				type: 'list',
				list: [],
				title: 'service/iso',
				readonly: false,
				_field_name: 'iso_id2',
				_visible: true,
				_errMsg: ''
			},

			isoIdForPush1: null,
			isoIdForPush2: null,

			isoOldValues: {}
		};
	},
	created: function created() {
		var _this2 = this;

		this.Access = this.access;
		this.Status = this.status;
		this.Reboot = this.canReboot;
		this.Template = this.templateName;
		this.fullName = this.serviceFullName;
		this.ISO = this.iso;
		this.autoProlongValue = this.serviceProlong;
		this.canProlong = this.serviceCanProlong;
		this.canDelete = this.serviceCanDelete;
		this.Error = this.parentError;

		this.passwordWarning = this.localeFtc('service/reboot_warning');

		this.rebootWarning = 'service/change_password_for_vnc';

		if (this.Template.toLowerCase().indexOf('centos') >= 0 || this.Template.toLowerCase().indexOf('ubuntu') >= 0 || this.Template.toLowerCase().indexOf('debian') >= 0) this.rebootWarning = 'service/change_password_for_vnc_linux';

		if (this.Template.toLowerCase().indexOf('windows') > -1 || this.Template.toLowerCase().indexOf('freebsd') > -1 || this.ISO) this.validOsAndIso = false;else this.validOsAndIso = true;

		this.reserveIpLocalData = this.reserveIpData;

		this.reserveIpValue = this.reserveIpData && 'value' in this.reserveIpData ? this.reserveIpData.value : false;

		if (this.$store.state.vdsCommand && String(this.$store.state.vdsCommand['id']) === String(this.vdsId) && this.$store.state.vdsCommand['command'] === 'reboot') {
			this.$nextTick(function () {
				return _this2.reboot();
			});

			this.$store.commit('setVdsCommand', false);
		}
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		if (this.deleteModalTimerHandle) {
			clearInterval(this.deleteModalTimerHandle);
			this.deleteModalTimerHandle = false;
		}

		if (this.confirmModalTimerHandle) {
			clearInterval(this.confirmModalTimerHandle);
			this.confirmModalTimerHandle = false;
		}
	},

	methods: {
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) {
				e.preventDefault();

				this.hideRebootModal();
				this.hidePasswordModal();
				this.hideDeleteModal();
				this.hideConfirmModal();
			}
		},
		linkifyText: function linkifyText(text) {
			return __WEBPACK_IMPORTED_MODULE_6_linkifyjs_html___default()(text, {
				defaultProtocol: 'https',
				validate: {
					url: function url(value) {
						return (/^(http|ftp)s?:\/\//.test(value)
						);
					}
				}
			});
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			if (!this.active) return;

			if (!this.isoIdForPush1 && !this.isoIdForPush2) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== 'service') return;

			var _id = _parts[2];

			if (!_id) return;

			var _isVds = String(this.vdsId) === String(_id);

			var _foundIso = String(this.isoIdForPush1) === String(_id) || String(this.isoIdForPush2) === String(_id);

			if (_isVds || _foundIso) this.$emit('requestData');
		},
		autoProlongClick: function autoProlongClick() {
			var _this3 = this;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.autoProlongProcessing) return;

			if (!this.autoProlongValue) {
				this.confirmModalTimer = 0;
				this.autoProlongStart();
				return;
			}

			this.confirmModalTitle = 'service/autoprolong';
			this.confirmModalText = this.localeFtc('service/autoprolong_off');
			this.modalConfirmButtonTitleText = 'main/detach';
			this.confirmStart = this.autoProlongStart;

			this.confirmModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModal = true;

			this.confirmModalTimerHandle = setInterval(function () {
				_this3.confirmModalTimer--;
				if (_this3.confirmModalTimer <= 0) {
					clearInterval(_this3.confirmModalTimerHandle);
					_this3.confirmModalTimerHandle = false;
				}
			}, 1000);
		},
		autoProlongStart: function autoProlongStart() {
			var _this4 = this;

			if (this.confirmModalTimer && this.confirmModalTimer > 0) return;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.autoProlongProcessing) return;

			this.autoProlongProcessing = true;

			this.hideConfirmModal();

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'autoprolong': !_this4.autoProlongValue ? 1 : 0
					};

					_this4.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this4.autoProlongProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this4.autoProlongValue = !_this4.autoProlongValue;

							_this4.$emit('successMessage', 'main/updated');
							return;
						}

						_this4.localErrorMessage = _this4.formatRequestError(resPost);
					}, function (resPost) {
						_this4.autoProlongProcessing = false;

						_this4.localErrorMessage = _this4.formatRequestError(resPost);
					});

					return;
				}

				_this4.autoProlongProcessing = false;

				_this4.localErrorMessage = _this4.formatRequestError(resGet);
			}, function (resGet) {
				_this4.autoProlongProcessing = false;

				_this4.localErrorMessage = _this4.formatRequestError(resGet);
			});
		},
		prolongVds: function prolongVds() {
			var _this5 = this;

			if (!this.vdsId) return;

			if (!this.canProlong) return;

			if (this.canProlongProcessing) return;

			this.canProlongProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=setProlong';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this5.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this5.canProlongProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this5.$emit('requestData');

							return;
						}

						_this5.localErrorMessage = _this5.formatRequestError(resPost);
					}, function (resPost) {
						_this5.canProlongProcessing = false;

						_this5.localErrorMessage = _this5.formatRequestError(resPost);
					});

					return;
				}

				_this5.canProlongProcessing = false;

				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			}, function (resGet) {
				_this5.canProlongProcessing = false;

				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			});
		},
		reboot: function reboot() {
			if (!this.Access || this.Status !== 'active' || !this.Reboot || this.Error) return;
			this.localErrorMessage = '';
			this.rebootHardValue = false;

			this.rebootModalText = this.localeFtc('service/reboot_vds_confirm').replace('{name}', '<b>' + this.serviceName + '</b>');
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRebootModal = true;
		},
		hideRebootModal: function hideRebootModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRebootModal = false;
			this.hideModalMask();
		},
		rebootHardClick: function rebootHardClick() {
			this.rebootHardValue = !this.rebootHardValue;
		},
		rebootStart: function rebootStart() {
			var _this6 = this;

			if (!this.Access || this.Status !== 'active' || !this.Reboot || this.Error) return;

			this.localErrorMessage = '';
			this.hideRebootModal();

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=setReboot';
			if (this.rebootHardValue) _url += '&type=hard';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this6.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this6.$emit('successMessage', 'service/reboot_queued');
							return;
						}

						_this6.localErrorMessage = _this6.formatRequestError(resPost);
					}, function (resPost) {
						_this6.localErrorMessage = _this6.formatRequestError(resPost);
					});

					return;
				}

				_this6.localErrorMessage = _this6.formatRequestError(resGet);
			}, function (resGet) {
				_this6.localErrorMessage = _this6.formatRequestError(resGet);
			});
		},
		vnc: function vnc(e) {
			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			this.localErrorMessage = '';

			if (!this.vdsId || !this.serviceFullName) {
				this.localErrorMessage = 'VNC: service/not_found';
				return;
			}

			var _this = this;
			window.getW5 = function () {
				return {
					getData: function getData(_Success, _Error) {
						_this.$http.get(_this.APIServerUrl + '/service/vnc/' + _this.vdsId).then(function (resGet) {
							var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

							if (_dt && _dt['status'] === 'ok' && _dt['vnc'] && _dt['vnc']['host'] && _dt['vnc']['port'] && _dt['vnc']['password']) {
								_Success(_dt['vnc']['host'], _dt['vnc']['port'], _dt['vnc']['password'], _this.serviceFullName);
								return true;
							}

							if (_dt && _dt['status'] === 'error') {
								var _err = 'VNC: ' + _this.localeFtc('main/no_data');

								if ('title' in _dt) _err = _this.localeFtc(_dt['title']);

								if ('content' in _dt) _err = _this.localeFtc(_dt['content']);

								_Error(_err);
								return false;
							}

							_Error('VNC: ' + _this.localeFtc('main/no_data'));
							return false;
						}, function (resGet) {
							var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

							var _err = 'VNC: ' + _this.localeFtc('main/no_data');

							if (_dt && 'title' in _dt) _err = _this.localeFtc(_dt['title']);

							if (_dt && 'content' in _dt) _err = _this.localeFtc(_dt['content']);

							_Error(_err);
							return false;
						});
					} };
			};
			if (e.shiftKey) {
				window.open('/static/novnc/vnc.html?2', '_blank');
			} else {
				window.open('/static/novnc/start.html?2', '_blank');
			}
		},
		changePassword: function changePassword() {
			if (!this.Access || this.Status !== 'active') return;
			if (this.Error) return;
			this.localErrorMessage = '';
			this.passwordValue = '';
			this.passwordField['_errMsg'] = '';
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPasswordModal = true;
		},
		hidePasswordModal: function hidePasswordModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPasswordModal = false;
			this.hideModalMask();
		},
		onFocusPassword: function onFocusPassword() {
			this.passwordField['_errMsg'] = '';
		},
		passwordChange: function passwordChange() {
			var _this7 = this;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.passwordField['_errMsg'] !== '') return;

			if (this.passwordValue.trim().length === 0) {
				this.passwordField['_errMsg'] = 'validators/error_req';
				return;
			}

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'password': _this7.passwordValue.trim(),
						'reinstall': 0
					};

					_this7.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this7.hidePasswordModal();

							_this7.$emit('successMessage', 'service/password запущено...');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							_this7.passwordField['_errMsg'] = _this7.localeFtc('service/password_error');

							if (_dt['fields'] && _dt['fields']['password']) {
								if (Array.isArray(_dt['fields']['password'])) {
									if (_dt['fields']['password'].length) _this7.passwordField['_errMsg'] = _this7.localeFtc(_dt['fields']['password'][0]);
								} else {
									_this7.passwordField['_errMsg'] = _this7.localeFtc(_dt['fields']['password']);
								}
							}
							return;
						}

						_this7.hidePasswordModal();

						_this7.localErrorMessage = _this7.formatRequestError(resPost);
					}, function (resPost) {
						_this7.hidePasswordModal();

						_this7.localErrorMessage = _this7.formatRequestError(resPost);
					});

					return;
				}

				_this7.hidePasswordModal();

				_this7.localErrorMessage = _this7.formatRequestError(resGet);
			}, function (resGet) {
				_this7.hidePasswordModal();

				_this7.localErrorMessage = _this7.formatRequestError(resGet);
			});
		},
		hideConfirmModal: function hideConfirmModal() {
			if (this.confirmModalTimerHandle) {
				clearInterval(this.confirmModalTimerHandle);
				this.confirmModalTimerHandle = false;
			}

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModal = false;
			this.hideModalMask();
		},
		reserveIpStart: function reserveIpStart() {
			var _this8 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.reserveIpProcessing) return;

			this.reserveIpProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'reserve_ip': _this8.reserveIpValue ? 0 : 1
					};

					_this8.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this8.reserveIpProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this8.reserveIpValue = !_this8.reserveIpValue;

							setTimeout(function () {
								_this8.$emit('requestData');
							}, 1000);

							_this8.$emit('successMessage', 'main/updated');
							return;
						}

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					}, function (resPost) {
						_this8.reserveIpProcessing = false;

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					});

					return;
				}

				_this8.reserveIpProcessing = false;

				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			}, function (resGet) {
				_this8.reserveIpProcessing = false;

				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			});
		},
		deleteVds: function deleteVds() {
			var _this9 = this;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			this.reserveIpLocalData = null;

			this.$emit('updateData');

			this.localErrorMessage = '';

			this.deleteModalText = this.localeFtc('service/vds_delete_confirm').replace('{name}', this.serviceName);

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this9.deleteModalTimer--;
				if (_this9.deleteModalTimer <= 0) {
					clearInterval(_this9.deleteModalTimerHandle);
					_this9.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		hideDeleteModal: function hideDeleteModal() {
			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteStart: function deleteStart() {
			var _this10 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			this.localErrorMessage = '';

			this.hideDeleteModal();

			var _url = this.APIServerUrl + '/service/delete/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this10.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this10.$router.push('/vds/list');
							return;
						}

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					}, function (resPost) {
						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					});

					return;
				}

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			}, function (resGet) {
				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			});
		},
		hideOperISOModal: function hideOperISOModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showOperISOModal = false;
			this.hideModalMask();
			this.onFocusIso();
		},
		operIso: function operIso() {
			var _this11 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var res, _dt;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(!_this11.Access || _this11.Status !== 'active' || _this11.isISOProcessActive)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								if (!_this11.Error) {
									_context.next = 4;
									break;
								}

								return _context.abrupt('return');

							case 4:
								_this11.localErrorMessage = '';

								_this11.isoOldValues = {};

								_this11.operisoModalText = _this11.localeFtc('service/iso_operation_warning');

								_this11.operisoModalButton = 'main/save';

								_context.prev = 8;
								_context.next = 11;
								return _this11.$http.get(_this11.APIServerUrl + '/service/update/' + _this11.vdsId);

							case 11:
								res = _context.sent;
								_dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;


								if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['iso_id'] && _dt['fields']['iso_secondary_id']) {
									_this11.makeISOListForField(_dt['fields']);
								}
								_context.next = 18;
								break;

							case 16:
								_context.prev = 16;
								_context.t0 = _context['catch'](8);

							case 18:
								__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
								_this11.showOperISOModal = true;

							case 20:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this11, [[8, 16]]);
			}))();
		},
		operIsoBegin: function operIsoBegin() {
			var _this12 = this;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			this.localErrorMessage = '';

			var _id1 = null;
			var _oldId1 = null;
			var _id2 = null;
			var _oldId2 = null;
			var _successMessageEject = '';
			var _successMessageInsert = '';

			this.isoIdForPush1 = null;
			this.isoIdForPush2 = null;

			if (this.ISO && this.ISO.length) {
				if (this.isoOldValues.iso_id) {
					_oldId1 = this.isoOldValues.iso_id;

					_id1 = this.isoValue1 == null || this.isoValue1 <= 0 ? 0 : String(this.isoValue1) === String(this.isoOldValues.iso_id) ? null : this.isoValue1;
				} else {
					_oldId1 = null;
					_id1 = this.isoValue1 == null || this.isoValue1 <= 0 ? null : this.isoValue1;
				}

				if (this.isoOldValues.iso_secondary_id) {
					_oldId2 = this.isoOldValues.iso_secondary_id;

					_id2 = this.isoValue2 == null || this.isoValue2 <= 0 ? 0 : String(this.isoValue2) === String(this.isoOldValues.iso_secondary_id) ? null : this.isoValue2;
				} else {
					_oldId2 = null;
					_id2 = this.isoValue2 == null || this.isoValue2 <= 0 ? null : this.isoValue2;
				}

				var _resultSame = false;

				if (_oldId1 !== null && _oldId2 === null) {
					if (_id2 > 0) {
						_resultSame = String(_oldId1) === String(_id2);
					} else if (_id1 > 0 && _id2 > 0) {
							_resultSame = String(_id1) === String(_id2);
						}
				}

				if (_oldId1 === null && _oldId2 !== null) {
					if (_id1 > 0) {
						_resultSame = String(_id1) === String(_oldId2);
					} else if (_id1 > 0 && _id2 > 0) {
							_resultSame = String(_id1) === String(_id2);
						}
				}

				if (_oldId1 !== null && _oldId2 !== null) {
					if (_id1 > 0) {
						_resultSame = String(_id1) === String(_oldId2) || String(_id1) === String(_id2);
					} else if (_id2 > 0) {
							_resultSame = String(_id1) === String(_id2) || String(_oldId1) === String(_id2);
						}
				}

				if (_resultSame) {
					if (_id2 !== null && _id2 > 0) {
						this.isoField2['_errMsg'] = 'service/service_iso_same_error';
					} else {
						this.isoField1['_errMsg'] = 'service/service_iso_same_error';
					}

					return;
				}
			} else {
					if (!this.isoValue1 || this.isoValue1 < 0) {
						this.isoField1['_errMsg'] = 'error/required_field';
						return;
					}

					if (!this.isoValue1 && !this.isoValue2 || this.isoValue1 <= 0 && this.isoValue2 <= 0) {
						this.isoField1['_errMsg'] = 'error/required_field';
						return;
					}

					if (this.isoValue1 !== null && this.isoValue1 > 0) _id1 = this.isoValue1;
					if (this.isoValue2 !== null && this.isoValue2 > 0) _id2 = this.isoValue2;

					if (_id1 !== 0 || _id2 !== 0) {
						if ((_id1 !== null || _id2 !== null) && _id1 === _id2) {
							if (_id2 !== null && _id2 > 0) {
								this.isoField2['_errMsg'] = 'service/service_iso_same_error';
							} else {
								this.isoField1['_errMsg'] = 'service/service_iso_same_error';
							}

							return;
						}
					}
				}

			this.isoIdForPush1 = _id1;
			this.isoIdForPush2 = _id2;

			if (_id1 === 0 || _id2 === 0) {
				_successMessageEject = 'service/iso_ejecting_begin_process';
			}
			if (_id1 > 0 || _id2 > 0) {
				_successMessageInsert = 'service/iso_inserting_begin_process';
			}

			this.hideOperISOModal();

			if (_id1 === null && _id2 === null) {
				return;
			}

			if ('iso_id' in this.isoOldValues && String(this.isoOldValues.iso_id) === String(_id1) && 'iso_secondary_id' in this.isoOldValues && String(this.isoOldValues.iso_secondary_id) === String(_id2)) {
				return;
			}

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'reinstall': 0
					};

					if (_id1 !== null && _id1 >= 0) _post[_dt['model']]['iso_id'] = _id1;
					if (_id2 !== null && _id2 >= 0) _post[_dt['model']]['iso_secondary_id'] = _id2;

					_this12.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							if (_successMessageEject) {
								_this12.$emit('successMessage', _successMessageEject);
							}
							if (_successMessageInsert) {
								_this12.$emit('successMessage', _successMessageInsert);
							}

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							if (_dt['fields'] && _dt['fields']['iso_id']) {
								if (Array.isArray(_dt['fields']['iso_id'])) {
									if (_dt['fields']['iso_id'].length) _this12.localErrorMessage = _this12.localeFtc(_dt['fields']['iso_id'][0]);
								} else {
									_this12.localErrorMessage = _this12.localeFtc(_dt['fields']['iso_id']);
								}
							}
							if (_dt['fields'] && _dt['fields']['iso_secondary_id']) {
								if (Array.isArray(_dt['fields']['iso_secondary_id'])) {
									if (_dt['fields']['iso_secondary_id'].length) _this12.localErrorMessage = _this12.localeFtc(_dt['fields']['iso_secondary_id'][0]);
								} else {
									_this12.localErrorMessage = _this12.localeFtc(_dt['fields']['iso_secondary_id']);
								}
							}
							return;
						}

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					}, function (resPost) {
						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					});

					return;
				}

				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			}, function (resGet) {
				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			});
		},
		onFocusIso: function onFocusIso() {
			this.isoField1['_errMsg'] = '';
			this.isoField2['_errMsg'] = '';
		},
		makeISOListForField: function makeISOListForField(isoFields) {
			var _this13 = this;

			if (!isoFields) return;

			var isoField = isoFields['iso_id'];

			if (isoField && isoField.title) {
				this.isoField1.title = isoField.title;

				if ('value' in isoField && isoField.value !== null && isoField.value > 0) {
					this.isoField1.list = isoField.list && isoField.list.length ? isoField.list : [];

					var _idx = -1;
					if (this.ISO && this.ISO.length) {
						this.ISO.some(function (i, x) {
							if (i && i['service_id'] && String(i['service_id']['value']) === String(isoField.value)) {
								_idx = x;
								return true;
							}
						});
					}

					if (_idx >= 0) {
						this.isoOldValues.iso_id = this.ISO[_idx]['service_id']['value'];
						this.$set(this, 'isoValue1', this.ISO[_idx]['service_id']['value']);
						this.$nextTick(function () {
							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
								name: 'iso_id1',
								value: {
									id: _this13.ISO[_idx]['service_id']['value'],
									name: _this13.ISO[_idx]['service_name']['value']
								}
							});
						});
					}
				} else {
					this.isoField1.list = [{ id: -1, name: 'main/not_chosen' }].concat(isoField.list && isoField.list.length ? isoField.list : []);

					this.isoOldValues.iso_id = -1;
					this.$set(this, 'isoValue1', -1);
					this.$nextTick(function () {
						__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
							name: 'iso_id1',
							value: {
								id: -1,
								name: _this13.localeFtc('main/not_chosen')
							}
						});
					});
				}
			}

			isoField = isoFields['iso_secondary_id'];

			if (isoField && isoField.title) {
				this.isoField2.title = isoField.title;

				if ('value' in isoField && isoField.value !== null && isoField.value > 0) {
					this.isoField2.list = isoField.list && isoField.list.length ? isoField.list : [];

					var _idx2 = -1;
					if (this.ISO && this.ISO.length) {
						this.ISO.some(function (i, x) {
							if (i && i['service_id'] && String(i['service_id']['value']) === String(isoField.value)) {
								_idx2 = x;
								return true;
							}
						});
					}

					if (_idx2 >= 0) {
						this.isoOldValues.iso_secondary_id = this.ISO[_idx2]['service_id']['value'];
						this.$set(this, 'isoValue2', this.ISO[_idx2]['service_id']['value']);
						this.$nextTick(function () {
							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
								name: 'iso_id2',
								value: {
									id: _this13.ISO[_idx2]['service_id']['value'],
									name: _this13.ISO[_idx2]['service_name']['value']
								}
							});
						});
					}
				} else {
					this.isoField2.list = [{ id: -1, name: 'main/not_chosen' }].concat(isoField.list && isoField.list.length ? isoField.list : []);

					this.isoOldValues.iso_secondary_id = -1;
					this.$set(this, 'isoValue2', -1);
					this.$nextTick(function () {
						__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
							name: 'iso_id2',
							value: {
								id: -1,
								name: _this13.localeFtc('main/not_chosen')
							}
						});
					});
				}
			}
		}
	},

	watch: {
		'access': function access(_access) {
			this.Access = _access;
		},
		'status': function status(_status) {
			this.Status = _status;
		},
		'canReboot': function canReboot(_canReboot) {
			this.Reboot = _canReboot;
		},
		'templateName': function templateName(_templateName) {
			this.Template = _templateName;

			this.passwordWarning = this.localeFtc('service/reboot_warning');

			this.rebootWarning = 'service/change_password_for_vnc';

			if (this.Template.toLowerCase().indexOf('centos') >= 0 || this.Template.toLowerCase().indexOf('ubuntu') >= 0 || this.Template.toLowerCase().indexOf('debian') >= 0) this.rebootWarning = 'service/change_password_for_vnc_linux';
		},
		'serviceFullName': function serviceFullName(_serviceFullName) {
			this.fullName = _serviceFullName;
		},
		'iso': function iso(_iso) {
			this.ISO = _iso;
		},
		'serviceProlong': function serviceProlong(value) {
			this.autoProlongValue = value;
		},
		'serviceCanProlong': function serviceCanProlong(value) {
			this.canProlong = value;
		},
		'serviceCanDelete': function serviceCanDelete(value) {
			this.canDelete = value;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		},
		'reserveIpData': function reserveIpData(data) {
			this.reserveIpLocalData = data;
			this.reserveIpValue = data && 'value' in data ? data.value : false;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default.a,
		urlButtonComponent: __WEBPACK_IMPORTED_MODULE_5__components_elements_urlbtn___default.a
	}
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.templateInstruction && _vm.templateInstruction.value && false) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.linkifyText(_vm.templateInstruction.value))),
      expression: "localeFtc(linkifyText(templateInstruction.value))"
    }],
    staticClass: "w5-normal-pre"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/reboot_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reboot_button_description')),
      expression: "localeFtc('service/reboot_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.Reboot
    },
    on: {
      "click": _vm.reboot
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "power-off"
    }
  }), _vm._v("\r\n\t\t\t" + _vm._s(_vm._f("ftc")('service/reboot')) + "\r\n\t\t")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/iso_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/iso_button_description')),
      expression: "localeFtc('service/iso_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.isISOProcessActive
    },
    on: {
      "click": _vm.operIso
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "compact-disc"
    }
  }), _vm._v(" "), (_vm.ISO && _vm.ISO.length) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/iso')))]) : _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/iso_insert')))])], 1), _vm._v(" "), (_vm.iso && _vm.iso.length) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "line-height": "1.2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.iso[0] && _vm.iso[0]['service_name'] && _vm.iso[0]['service_name']['title'] ? _vm.iso[0]['service_name']['title'] : 'service/iso')) + ":")]), _vm._v(" "), _vm._l((_vm.iso), function(_iso, _idx) {
    return _c('span', {
      key: _iso && _iso.service_id && _iso.service_id.value ? _iso.service_id.value : _idx
    }, [(_idx > 0) ? _c('span', [_vm._v(",  ")]) : _vm._e(), _vm._v(" "), (_iso && _iso['service_status'] && _iso['service_status']['text']) ? _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [(_iso && _iso['service_name'] && _iso['service_name']['value']) ? _c('span', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(_iso['service_name']['value']) + " ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": __webpack_require__(22)
      }
    }), _vm._v(" " + _vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['text']))) + "\r\n\t\t\t\t")]) : (_iso && _iso['service_status'] && _iso['service_status']['value'] && _iso['service_status']['value'] !== 'active') ? _c('span', {
      class: 'w5-status-color-' + _iso['service_status']['value']
    }, [(_iso['service_status']['list'] && _iso['service_status']['list'][_iso['service_status']['value']]) ? [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['list'][_iso['service_status']['value']]))))] : [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['value']))))]], 2) : _c('linkComponent', {
      attrs: {
        "url": '/service/view/' + _iso['service_id']['value'],
        "text": _iso['service_name']['value']
      }
    })], 1)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.canProlong) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/prolong_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/prolong_button_description')),
      expression: "localeFtc('service/prolong_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    on: {
      "click": _vm.prolongVds
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "play-circle"
    }
  }), _vm._v("\r\n\t\t\t" + _vm._s(_vm._f("ftc")('service/prolong')) + "\r\n\t\t")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoProlongValue),
      expression: "autoProlongValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoProlongValue) ? _vm._i(_vm.autoProlongValue, null) > -1 : (_vm.autoProlongValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoProlongValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoProlongValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoProlongValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoProlongValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.autoProlongProcessing
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.autoProlongClick
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/autoprolong')) + "\r\n\t\t\t")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/autoprolong_off')),
      expression: "localeFtc('service/autoprolong_off')"
    }],
    staticClass: "warning-message"
  })]), _vm._v(" "), (_vm.canDelete) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('div', {
    staticClass: "del-button-wrapper"
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('div', {
    staticClass: "btn btn-submit-danger tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    on: {
      "click": _vm.deleteVds
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/delete_vds')) + "\r\n\t\t\t\t")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "warning-message"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/attention')) + "!")]), _vm._v(" " + _vm._s(_vm._f("ftc")('service/vds_delete_warning')) + "!")])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRebootModal),
      expression: "showRebootModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRebootModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/reboot')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRebootModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.rebootModalText)),
      expression: "localeFtc(rebootModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rebootHardValue),
      expression: "rebootHardValue"
    }],
    staticClass: "w5-checkbox-field",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rebootHardValue) ? _vm._i(_vm.rebootHardValue, null) > -1 : (_vm.rebootHardValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rebootHardValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rebootHardValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rebootHardValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rebootHardValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.rebootHardClick
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/reboot_hard')) + "\r\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.rebootStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/reboot')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPasswordModal),
      expression: "showPasswordModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-300 font-size-85 color-black"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.rebootWarning)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.passwordWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.passwordWarning),
      expression: "passwordWarning"
    }],
    staticClass: "alert alert-warning font-size-90 margin-0 full-width"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.passwordField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusPassword,
      "enterKeyDown": _vm.passwordChange
    },
    model: {
      value: (_vm.passwordValue),
      callback: function($$v) {
        _vm.passwordValue = $$v
      },
      expression: "passwordValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.passwordChange
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    class: {
      'flbx': _vm.Access && _vm.Status === 'active', 'r': _vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active'
    }
  }, [(_vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active') ? _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin": "0 0 15px",
      "padding": "5px 10px 10px 10px",
      "text-align": "initial"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.reserveIpProcessing || (_vm.deleteModalTimer && _vm.deleteModalTimer > 0)
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/save ippool/ippool')) + "\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "0",
      "font-size": "90%"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active') ? _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteStart
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalText)),
      expression: "localeFtc(confirmModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.confirmModalTimer && _vm.confirmModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmStart
    }
  }, [_vm._v(_vm._s(_vm.modalConfirmButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOperISOModal),
      expression: "showOperISOModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideOperISOModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideOperISOModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [
    [_c('div', {
      staticClass: "w5-form-row"
    }, [_c('Field', {
      attrs: {
        "isVisibleRow": true,
        "crud": "vds",
        "action": "view",
        "Field": _vm.isoField1,
        "removeRightPadding": true,
        "fieldInModal": true,
        "listBlockToOut": 1
      },
      on: {
        "focus": _vm.onFocusIso,
        "enterKeyDown": _vm.operIsoBegin
      },
      model: {
        value: (_vm.isoValue1),
        callback: function($$v) {
          _vm.isoValue1 = $$v
        },
        expression: "isoValue1"
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.ISO && _vm.ISO.length) || (_vm.isoValue1 !== null && _vm.isoValue1 > 0)),
        expression: "(ISO && ISO.length) || (isoValue1 !== null && isoValue1 > 0)"
      }],
      staticClass: "w5-form-row"
    }, [_c('Field', {
      attrs: {
        "isVisibleRow": true,
        "crud": "vds",
        "action": "view",
        "Field": _vm.isoField2,
        "removeRightPadding": true,
        "listBlockToOut": 1
      },
      on: {
        "focus": _vm.onFocusIso,
        "enterKeyDown": _vm.operIsoBegin
      },
      model: {
        value: (_vm.isoValue2),
        callback: function($$v) {
          _vm.isoValue2 = $$v
        },
        expression: "isoValue2"
      }
    })], 1)], _vm._v(" "), (_vm.operisoModalText) ? _c('p', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc(_vm.operisoModalText)),
        expression: "localeFtc(operisoModalText)"
      }],
      staticClass: "padding-0-5"
    }) : _vm._e()
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('urlButtonComponent', {
    staticClass: "pull-left",
    attrs: {
      "crud": "vds",
      "name": "create_iso",
      "url": '/iso/create',
      "text": 'service/iso_create'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.operisoModalButton === 'main/detach'
    },
    on: {
      "click": _vm.operIsoBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.operisoModalButton)))])], 1)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bus_js__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabAccess',

	props: ['access', 'status', 'serviceStatus', 'vdsId', 'active', 'serviceFullName', 'templateName', 'vdsInfo', 'parentError', 'templateInstruction', 'passwordType'],
	data: function data() {
		return {
			Access: false,
			Status: null,
			Error: '',

			Template: '',

			localErrorMessage: '',

			showPasswordModal: false,
			passwordWarning: '',
			rebootWarning: '',
			passwordValue: '',
			passwordField: {
				'required': true,
				'type': 'password',
				'title': 'main/new_password',
				'_field_name': 'newPassword',
				'_visible': true,
				'generator': true,
				'_errMsg': ''
			},

			passwordForShow: '●●●●●●●●●●',
			hostForShow: '●●●●●●●●●●',
			portForShow: '●●●●●',

			passwordForInstruction: '●●●●●●●●●●',

			dataVNC: false,

			passwordTypeSelected: null
		};
	},

	computed: {
		isDataShown: function isDataShown() {
			return this.portForShow !== '●●●●●';
		},
		isDataShownForInstruction: function isDataShownForInstruction() {
			return this.passwordForInstruction !== '●●●●●●●●●●';
		},
		serviceInfo: function serviceInfo() {
			if (this.vdsInfo && this.vdsInfo.service && this.vdsInfo.service.service_data && this.vdsInfo.service.service_data.value) return this.vdsInfo.service.service_data.value;
			return null;
		}
	},
	created: function created() {
		var _this2 = this;

		this.Access = this.access;
		this.Status = this.status;
		this.Template = this.templateName;
		this.Error = this.parentError;

		this.maskModalFlag = false;

		this.passwordWarning = this.localeFtc('service/reboot_warning');

		this.rebootWarning = 'service/change_password_for_vnc';

		if (this.Template.toLowerCase().indexOf('centos') >= 0 || this.Template.toLowerCase().indexOf('ubuntu') >= 0 || this.Template.toLowerCase().indexOf('debian') >= 0) this.rebootWarning = 'service/change_password_for_vnc_linux';

		if (window && window.sessionStorage) {
			var func = window.sessionStorage.getItem('callFunction');
			window.sessionStorage.removeItem('callFunction');
			if (func && func in this) this.$nextTick(function () {
				return _this2[func]();
			});
		}
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);

		this.setUpHandlers();
	},
	updated: function updated() {
		this.setUpHandlers();
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	methods: {
		setUpHandlers: function setUpHandlers() {
			var _this3 = this;

			var btnShow = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn-inst-show');
			if (btnShow && btnShow.length) {
				var svgShow = btnShow.find('svg.fa-eye').first();
				if (svgShow && svgShow.length) {
					svgShow.off('click').on('click', function () {
						if (_this3.Access && _this3.Status === 'active') {
							_this3.showPasswordForInstruction();
						}
					});
				}
			}

			var btnCopy = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn-inst-copy');
			if (btnCopy && btnCopy.length) {
				var svgCopy = btnCopy.find('svg.fa-copy').first();
				if (svgCopy && svgCopy.length) {
					svgCopy.off('click').on('click', function () {
						if (_this3.Access && _this3.Status === 'active') {
							_this3.copyPassword(true);
						}
					});
				}
			}
		},
		linkifyText: function linkifyText(text) {
			var textBr = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].nl2br(text);
			var parts = textBr.split('<br>');
			var answer = '';
			if (!parts || !parts.length) return text;

			for (var i = 0; i < parts.length; i++) {
				if (i > 0) answer += '\n';

				answer += __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html___default()(parts[i], {
					defaultProtocol: 'https',
					validate: {
						url: function url(value) {
							return (/^(http|ftp)s?:\/\//.test(value)
							);
						}
					}
				});
			}

			answer = answer.replace(/\{password\}/ig, '<pswdr>' + this.passwordForInstruction + '</pswdr>');

			return answer;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) {
				e.preventDefault();
				this.hidePasswordModal();
			}
		},
		vnc: function vnc(e) {
			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			this.localErrorMessage = '';

			if (!this.vdsId || !this.serviceFullName) {
				this.localErrorMessage = 'VNC: service/not_found';
				return;
			}

			var _this = this;
			window.getW5 = function () {
				return {
					getData: function getData(_Success, _Error) {
						if (_this.dataVNC) {
							_Success(_this.dataVNC['vnc']['host'], _this.dataVNC['vnc']['port'], _this.dataVNC['vnc']['password'], _this.serviceFullName, _this.serviceInfo);
							return true;
						}

						_this.$http.get(_this.APIServerUrl + '/service/vnc/' + _this.vdsId).then(function (resGet) {
							var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

							if (_dt && _dt['status'] === 'ok' && _dt['vnc'] && _dt['vnc']['host'] && _dt['vnc']['port'] && _dt['vnc']['password']) {
								_this.dataVNC = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _dt);
								_Success(_dt['vnc']['host'], _dt['vnc']['port'], _dt['vnc']['password'], _this.serviceFullName, _this.serviceInfo);
								return true;
							}

							if (_dt && _dt['status'] === 'error') {
								var _err = 'VNC: ' + _this.localeFtc('main/no_data');

								if ('title' in _dt) _err = _this.localeFtc(_dt['title']);

								if ('content' in _dt) _err = _this.localeFtc(_dt['content']);

								_Error(_err);
								return false;
							}

							_Error('VNC: ' + _this.localeFtc('main/no_data'));
							return false;
						}, function (resGet) {
							var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

							var _err = 'VNC: ' + _this.localeFtc('main/no_data');

							if (_dt && 'title' in _dt) _err = _this.localeFtc(_dt['title']);

							if (_dt && 'content' in _dt) _err = _this.localeFtc(_dt['content']);

							_Error(_err);
							return false;
						});
					} };
			};
			window.open('/static/novnc/start.html?v=05', '_blank');
		},
		changePassword: function changePassword(type) {
			if (!this.Access || this.Status !== 'active' || !this.passwordType || !this.passwordType[type] || this.Error) return;
			this.localErrorMessage = '';
			this.passwordValue = '';
			this.passwordField['_errMsg'] = '';
			this.passwordTypeSelected = type;
			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPasswordModal = true;
		},
		hidePasswordModal: function hidePasswordModal() {
			var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (!forceClose) {
				if (!this.maskModalFlag) return;
			}

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPasswordModal = false;
			this.hideModalMask();
		},
		onFocusPassword: function onFocusPassword() {
			this.passwordField['_errMsg'] = '';
		},
		passwordChange: function passwordChange() {
			var _this4 = this;

			if (!this.Access || this.Status !== 'active' || !this.passwordTypeSelected || !this.passwordType || !this.passwordType[this.passwordTypeSelected] || this.Error) return;

			if (this.passwordField['_errMsg'] !== '') return;

			if (this.passwordValue.trim().length === 0) {
				this.passwordField['_errMsg'] = 'validators/error_req';
				return;
			}

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'password': _this4.passwordValue.trim(),
						'password_type': _this4.passwordTypeSelected,
						'reinstall': 0
					};

					_this4.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this4.hidePasswordModal();

							_this4.$emit('successMessage', 'service/password запущено...');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							_this4.passwordField['_errMsg'] = _this4.localeFtc('service/password_error');

							if (_dt['fields'] && _dt['fields']['password']) {
								if (Array.isArray(_dt['fields']['password'])) {
									if (_dt['fields']['password'].length) _this4.passwordField['_errMsg'] = _this4.localeFtc(_dt['fields']['password'][0]);
								} else {
									_this4.passwordField['_errMsg'] = _this4.localeFtc(_dt['fields']['password']);
								}
							}
							return;
						}

						_this4.hidePasswordModal();

						_this4.localErrorMessage = _this4.formatRequestError(resPost);
					}, function (resPost) {
						_this4.hidePasswordModal();

						_this4.localErrorMessage = _this4.formatRequestError(resPost);
					});

					return;
				}

				_this4.hidePasswordModal();

				_this4.localErrorMessage = _this4.formatRequestError(resGet);
			}, function (resGet) {
				_this4.hidePasswordModal();

				_this4.localErrorMessage = _this4.formatRequestError(resGet);
			});
		},
		copyPassword: function copyPassword() {
			var inInstruction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (!this.Access || this.Status !== 'active' || !this.vdsId) return;

			if (this.Error) return;

			if (this.dataVNC) {
				var el = inInstruction === true ? document.getElementById('instruction-password-value') : this.$refs['passwordRef'];
				var ok = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].copyToClipboard(el);
				if (ok) this.$emit('successMessage', 'main/copied_to_clipboard');
			}
		},
		showPassword: function showPassword() {
			var _this5 = this;

			if (!this.Access || this.Status !== 'active' || !this.vdsId) return;

			if (this.Error) return;

			if (this.dataVNC) {
				this.passwordForShow = this.dataVNC['vnc']['password'];
				this.hostForShow = this.dataVNC['vnc']['host'];
				this.portForShow = this.dataVNC['vnc']['client_port'];
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/vnc/' + this.vdsId).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['vnc'] && _dt['vnc']['host'] && _dt['vnc']['client_port'] && _dt['vnc']['password']) {
					_this5.passwordForShow = _dt['vnc']['password'];
					_this5.hostForShow = _dt['vnc']['host'];
					_this5.portForShow = _dt['vnc']['client_port'];

					_this5.dataVNC = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _dt);
					return;
				}

				if (_dt && _dt['status'] === 'error') {
					var _err = _this5.localeFtc('main/no_data');

					if ('title' in _dt) _err = _this5.localeFtc(_dt['title']);

					if ('content' in _dt) _err = _this5.localeFtc(_dt['content']);

					_this5.localErrorMessage = _err;
					return;
				}

				_this5.localErrorMessage = _this5.localeFtc('main/no_data');
				return;
			}, function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				var _err = _this5.localeFtc('main/no_data');

				if (_dt && 'title' in _dt) _err = _this5.localeFtc(_dt['title']);

				if (_dt && 'content' in _dt) _err = _this5.localeFtc(_dt['content']);

				_this5.localErrorMessage = _err;
				return;
			});
		},
		showPasswordForInstruction: function showPasswordForInstruction() {
			var _this6 = this;

			if (!this.Access || this.Status !== 'active' || !this.vdsId) return;

			if (this.Error) return;

			if (this.dataVNC) {
				this.passwordForInstruction = this.dataVNC['vnc']['password'];
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/vnc/' + this.vdsId).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['vnc'] && _dt['vnc']['host'] && _dt['vnc']['client_port'] && _dt['vnc']['password']) {
					_this6.passwordForInstruction = _dt['vnc']['password'];

					_this6.dataVNC = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _dt);
					return;
				}

				if (_dt && _dt['status'] === 'error') {
					var _err = _this6.localeFtc('main/no_data');

					if ('title' in _dt) _err = _this6.localeFtc(_dt['title']);

					if ('content' in _dt) _err = _this6.localeFtc(_dt['content']);

					_this6.localErrorMessage = _err;
					return;
				}

				_this6.localErrorMessage = _this6.localeFtc('main/no_data');
				return;
			}, function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				var _err = _this6.localeFtc('main/no_data');

				if (_dt && 'title' in _dt) _err = _this6.localeFtc(_dt['title']);

				if (_dt && 'content' in _dt) _err = _this6.localeFtc(_dt['content']);

				_this6.localErrorMessage = _err;
				return;
			});
		},
		dropData: function dropData() {
			this.dataVNC = false;
			this.passwordForShow = '●●●●●●●●●●';
			this.hostForShow = '●●●●●●●●●●';
			this.portForShow = '●●●●●';
			this.passwordForInstruction = '●●●●●●●●●●';
		}
	},

	watch: {
		'access': function access(_access) {
			this.Access = _access;
			this.dropData();
		},
		'status': function status(_status) {
			this.Status = _status;
			this.dropData();
		},
		'templateName': function templateName(_templateName) {
			this.Template = _templateName;

			this.passwordWarning = this.localeFtc('service/reboot_warning');

			this.rebootWarning = 'service/change_password_for_vnc';

			if (this.Template.toLowerCase().indexOf('centos') >= 0 || this.Template.toLowerCase().indexOf('ubuntu') >= 0 || this.Template.toLowerCase().indexOf('debian') >= 0) this.rebootWarning = 'service/change_password_for_vnc_linux';

			this.dropData();
		},
		'serviceFullName': function serviceFullName(_serviceFullName) {
			this.fullName = _serviceFullName;
			this.dropData();
		},
		'active': function active(value) {
			this.dropData();
		},
		'parentError': function parentError(value) {
			this.Error = value;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default.a
	}
});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-pane-plan-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (!_vm.Access) ? [_c('div', {
    staticClass: "text-center margin-top-5"
  }, [(_vm.serviceStatus && (_vm.serviceStatus.loader || _vm.serviceStatus.timer)) ? _c('div', {
    staticStyle: {
      "margin": "80px auto"
    }
  }, [(_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))])]) : [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]], 2)] : [_c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/vnc_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/vnc_button_description')),
      expression: "localeFtc('service/vnc_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/password')) + ": ")]), _vm._v(" "), _c('div', {
    ref: "passwordRef",
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownPassword"
    }
  }, [_vm._v(_vm._s(_vm.passwordForShow))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataShown),
      expression: "!isDataShown"
    }],
    staticClass: "w5-access-tab-button"
  }, [_c('font-awesome-icon', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    attrs: {
      "icon": "eye",
      "title": _vm._f("ftc")('main/show_data')
    },
    on: {
      "click": _vm.showPassword
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown && _vm.passwordForShow),
      expression: "isDataShown && passwordForShow"
    }],
    staticClass: "w5-access-tab-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPassword
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown),
      expression: "isDataShown"
    }],
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('server/server')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownHost"
    }
  }, [_vm._v(_vm._s(_vm.hostForShow))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown),
      expression: "isDataShown"
    }],
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/port VNC')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownPort"
    }
  }, [_vm._v(_vm._s(_vm.portForShow))])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs margin-top-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    on: {
      "click": _vm.vnc
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "terminal"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/vnc')) + "\r\n\t\t\t\t")], 1)]), _vm._v(" "), (_vm.templateInstruction && _vm.templateInstruction.value) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")(_vm.templateInstruction.title || 'template/instruction')))]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.linkifyText(_vm.templateInstruction.value))),
      expression: "localeFtc(linkifyText(templateInstruction.value))"
    }],
    staticClass: "w5-normal-pre instruction-password",
    class: {
      'shown': _vm.isDataShownForInstruction
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/password_change_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/password_change_button_description')),
      expression: "localeFtc('service/password_change_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btns-block"
  }, [_c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.passwordType || !_vm.passwordType.vnc
    },
    on: {
      "click": function($event) {
        return _vm.changePassword('vnc')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "random"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/password_change')) + " VNC\r\n\t\t\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.passwordType || !_vm.passwordType.root
    },
    on: {
      "click": function($event) {
        return _vm.changePassword('root')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "random"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/password_change')) + " root\r\n\t\t\t\t\t")], 1)])])]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPasswordModal),
      expression: "showPasswordModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hidePasswordModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')) + " " + _vm._s(String(_vm.passwordTypeSelected).toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.passwordWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.passwordWarning)),
      expression: "localeFtc(passwordWarning)"
    }],
    staticClass: "alert alert-warning font-size-90 margin-0 full-width"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.passwordField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusPassword,
      "enterKeyDown": _vm.passwordChange
    },
    model: {
      value: (_vm.passwordValue),
      callback: function($$v) {
        _vm.passwordValue = $$v
      },
      expression: "passwordValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.passwordChange
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bus_js__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabPlan',

	props: ['plan', 'value', 'access', 'status', 'serviceStatus', 'vdsId', 'parentError', 'templateData', 'ipInfo'],
	data: function data() {
		return {
			planValue: null,

			planField: null,

			isDisabledPlan: false,

			Access: false,
			Status: null,
			Error: '',

			canShowButton: true,

			isPlanChanged: true,

			localErrorMessage: '',

			showConfirmModal: false,
			confirmModalText: '',

			params: null
		};
	},
	created: function created() {
		var _this = this;

		this.planValue = this.value;
		this.planField = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.plan);
		this.Access = this.access;
		this.Status = this.status;
		this.Error = this.parentError;

		this.isDisabledPlan = false;
		if (this.plan && this.plan.list && Array.isArray(this.plan.list)) {
			this.isDisabledPlan = this.plan.list.some(function (p) {
				if (p['enable'] === false && String(_this.value) !== String(p['id'])) return true;
			});
		}

		if (this.plan && this.plan.params && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.plan.params) === 'object') {
			this.isDisabledPlan = false;
			this.planField.type = 'list';
			this.planField.list = [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
				id: this.value,
				active: true,
				enable: true,
				selected: true
			}, this.plan)];
		}

		if (this.plan === null) this.planField = null;
	},

	computed: {
		groupField: function groupField() {
			var _this2 = this;

			var _answer = null;
			if (!this.planField || !this.planField['list']) return _answer;

			var _list = this.planField['list'];
			_list.some(function (item) {
				if (String(item.id) === String(_this2.value)) {
					_answer = {
						value: item.plan_group
					};

					return true;
				}
			});

			return _answer;
		},
		isButtonEnabled: function isButtonEnabled() {
			var _this3 = this;

			var _answer = false;
			if (!this.planField || !this.planField['list']) return _answer;

			var _list = this.planField['list'];
			_list.some(function (item) {
				if (String(item.id) === String(_this3.planValue)) {
					_answer = item.enable !== false;
					return true;
				}
			});

			return _answer;
		},
		planWasChanged: function planWasChanged() {
			var _this4 = this;

			var _answer = false;
			if (!this.planField || !this.planField['list']) return _answer;

			var _list = this.planField['list'];
			_list.some(function (item) {
				if (String(item.id) === String(_this4.planValue)) {
					if (!item.has_params) {
						_answer = true;
					} else {
							_answer = _this4.isPlanChanged;
						}

					return true;
				}
			});

			return _answer;
		}
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged);
	},

	methods: {
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) this.hideConfirmModal();
		},
		handlePlanConstructorChanged: function handlePlanConstructorChanged(value) {
			if (this.plan && this.plan.has_params) {
				this.isPlanChanged = value;
			}
		},
		changePlan: function changePlan() {
			var _this5 = this;

			if (!this.isButtonEnabled || !this.Access || this.Status !== 'active' || this.Error || !this.planWasChanged) return;

			if (this.planValue === undefined || this.planValue === null) {
				this.localErrorMessage = 'plan/not_selected';
				return;
			}

			this.localErrorMessage = '';
			this.confirmModalText = '';

			var _params = '';
			if (this.plan && this.plan.has_params && this.params && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params).length) {
				var _paramsArr = [];
				for (var p in this.params) {
					_paramsArr.push(p + '=' + this.params[p]);
				}
				if (_paramsArr.length) _params = '&' + _paramsArr.join('&');
			}

			this.$http.get(this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=getPlanCost&plan_id=' + this.planValue + _params).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok' && 'cost' in _dt && !isNaN(parseFloat(_dt['cost']))) {
					var _cost = parseFloat(_dt['cost']);
					var _real = _dt['balance'] && _dt['balance']['real'] && _dt['balance']['real']['value'] ? parseFloat(_dt['balance']['real']['value']) : 0;
					if (isNaN(_real)) _real = 0;
					var _bonus = _dt['balance'] && _dt['balance']['bonus'] && _dt['balance']['bonus']['value'] ? parseFloat(_dt['balance']['bonus']['value']) : 0;
					if (isNaN(_bonus)) _bonus = 0;
					var _min = 'min' in _dt ? parseFloat(_dt['min']) : 0;
					if (isNaN(_min)) _min = 0;

					var _costStr = _cost.toFixed(2);
					if (_cost > 0 && _cost < 1) _costStr = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].FormatMoney2(_cost, -1);

					_this5.confirmModalText = _this5.localeFtc('plan/confirm_change').replace('{cost}', '<b>' + _costStr + ' ' + _this5.localeFtc('main/ruble') + '</b>');
					if (_cost <= 0) _this5.confirmModalText = _this5.localeFtc('plan/confirm_change_without_cost');

					if (_this5.plan) {
						var _newDiskSize = -1;
						var _oldDiskSize = -1;

						if (_this5.plan.has_params && _this5.plan.params) {
							_oldDiskSize = _this5.plan.params.disk.min;
							_newDiskSize = _this5.plan.data.disk.value;
						} else if (_this5.plan.type === 'list' && _this5.plan.list && _this5.plan.list.length) {
							_this5.plan.list.forEach(function (p) {
								if (p && p.data && p.data.disk && String(p.id) === String(_this5.plan.value)) {
									_oldDiskSize = p.data.disk.value;
								}

								if (p && p.data && p.data.disk && String(p.id) === String(_this5.planValue)) {
									_newDiskSize = p.data.disk.value;
								}
							});
						}

						if (_oldDiskSize > -1 && _newDiskSize > -1 && _newDiskSize > _oldDiskSize) {
							_this5.confirmModalText += ' <br><br> ' + _this5.localeFtc('plan/increase_disk_size');
							if (_this5.AppName === 'macloud') {
								_this5.confirmModalText = _this5.confirmModalText.replace('kak-rasshirit-diskovoe-prostranstvo-posle-smeny-tarifa', 'rasshirenie-diskovogo-prostranstva-posle-smeny-tarifa');
							}
						}
					}

					__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this5.showConfirmModal = true;

					return;
				} else if (_dt && _dt['status'] === 'error' && 'title' in _dt && _dt['title']) {
					_this5.localErrorMessage = _this5.localeFtc(_dt['title']);

					var _real2 = _dt['balance'] && _dt['balance']['real'] && _dt['balance']['real']['value'] ? parseFloat(_dt['balance']['real']['value']) : 0;
					if (isNaN(_real2)) _real2 = 0;
					var _bonus2 = _dt['balance'] && _dt['balance']['bonus'] && _dt['balance']['bonus']['value'] ? parseFloat(_dt['balance']['bonus']['value']) : 0;
					if (isNaN(_bonus2)) _bonus2 = 0;
					var _min2 = 'min' in _dt ? parseFloat(_dt['min']) : 0;
					if (isNaN(_min2)) _min2 = 0;
					var _canBonus = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(_dt['can_bonus']);

					var _rest = _real2;

					if (_canBonus) _rest += _bonus2;

					if (_min2 > _rest) _this5.localErrorMessage = _this5.localErrorMessage + ' <br/>' + _this5.localeFtc('service/creating_min_money_1').replace('{sum}', __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].FormatMoney2(_min2, 2)).replace('{val}', _this5.localeFtc('main/ruble'));

					return;
				}

				var msg = _this5.localeFtc('plan/change_cost_unknown');
				if ('title' in _dt && _dt['title']) msg = _this5.localeFtc(_dt['title']);
				if ('cost' in _dt && _dt['cost'] > 0) msg += '<br>' + _this5.localeFtc('plan/required_sum') + ' <b>' + _dt['cost'] + ' ' + _this5.localeFtc('main/ruble') + '</b>';
				_this5.localErrorMessage = msg;
			}, function (resGet) {
				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			});
		},
		hideConfirmModal: function hideConfirmModal() {
			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModal = false;
			this.hideModalMask();
		},
		changePlanStart: function changePlanStart() {
			var _this6 = this;

			if (!this.isButtonEnabled || !this.Access || this.Status !== 'active' || this.Error || !this.planWasChanged) return;

			if (this.planValue === undefined || this.planValue === null) {
				this.localErrorMessage = 'plan/not_selected';
				return;
			}

			this.localErrorMessage = '';

			this.canShowButton = false;

			this.hideConfirmModal();

			this.$emit('dropPlanConstructorChanged');

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'plan_id': _this6.planValue,
						'reinstall': 0
					};

					if (_this6.params && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.params).length) {
						_post[_dt['model']]['params'] = {};
						for (var p in _this6.params) {
							var pp = p.match(/^params\[(.*)\]$/i);
							if (pp && pp.length && pp[1]) {
								_post[_dt['model']]['params'][pp[1]] = _this6.params[p];
							}
						}
					}

					_this6.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this6.$emit('successMessage', 'service/plan_change_process_start');

							return;
						}

						_this6.canShowButton = true;

						_this6.localErrorMessage = _this6.formatRequestError(resPost);
					}, function (resPost) {
						_this6.canShowButton = true;

						_this6.localErrorMessage = _this6.formatRequestError(resPost);
					});

					return;
				}

				_this6.canShowButton = true;

				_this6.localErrorMessage = _this6.formatRequestError(resGet);
			}, function (resGet) {
				_this6.canShowButton = true;

				_this6.localErrorMessage = _this6.formatRequestError(resGet);
			});
		},
		onParams: function onParams(params) {
			this.params = params;
		}
	},

	watch: {
		'plan': function plan(_plan, old) {
			var _this7 = this;

			this.planField = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _plan);
			this.planValue = this.value;

			if (old) this.canShowButton = true;

			this.isDisabledPlan = false;
			if (_plan && _plan.list && Array.isArray(_plan.list)) {
				this.isDisabledPlan = _plan.list.some(function (p) {
					if (p['enable'] === false && String(_this7.value) !== String(p['id'])) return true;
				});
			}

			if (_plan && _plan.params && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_plan.params) === 'object') {
				this.isDisabledPlan = false;
				this.planField.type = 'list';
				this.planField.list = [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
					id: this.value,
					active: true,
					enable: true,
					selected: true
				}, this.plan)];
			}

			if (_plan === null) this.planField = null;
		},
		'access': function access(_access) {
			this.Access = _access;
		},
		'status': function status(_status) {
			this.Status = _status;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default.a
	}
});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-pane-plan-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (!_vm.Access) ? [_c('div', {
    staticClass: "text-center margin-top-5"
  }, [(_vm.serviceStatus && (_vm.serviceStatus.loader || _vm.serviceStatus.timer)) ? _c('div', {
    staticStyle: {
      "margin": "80px auto"
    }
  }, [(_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))])]) : [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]], 2)] : [(_vm.isDisabledPlan) ? _c('div', {
    staticClass: "alert alert-warning font-size-85 margin-top-15 margin-bottom-10"
  }, [_vm._v(_vm._s(_vm._f("ftc")('plan/change_note')))]) : _c('div', {
    staticClass: "margin-top-5"
  }), _vm._v(" "), (_vm.planField && _vm.Access) ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.planField,
      "groupField": _vm.groupField,
      "removeRightPadding": true,
      "templateField": _vm.templateData,
      "ipInfo": _vm.ipInfo
    },
    on: {
      "params": _vm.onParams
    },
    model: {
      value: (_vm.planValue),
      callback: function($$v) {
        _vm.planValue = $$v
      },
      expression: "planValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canShowButton === true) ? _c('div', {
    staticClass: "btn btn-submit margin-top-15 font-weight-300",
    class: {
      'disable': !_vm.isButtonEnabled || !_vm.Access || _vm.Status !== 'active' || !_vm.planWasChanged
    },
    on: {
      "click": _vm.changePlan
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")('plan/change_button')) + "\r\n\t\t\t")]) : _vm._e()]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('plan/change_button')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalText)),
      expression: "localeFtc(confirmModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.changePlanStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/continue')))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabReinstall',

	props: ['planId', 'planData', 'access', 'status', 'serviceStatus', 'vdsId', 'value', 'parentError', 'vdsName', 'template', 'host', 'sshkey', 'account', 'backup', 'reiso', 'dc'],
	data: function data() {
		return {
			templateValue: null,
			templateField: null,

			hostValue: null,
			hostField: null,

			sshkeyValue: null,
			sshkeyField: null,

			backupValue: null,
			backupField: null,

			reisoValue: null,
			reisoField: null,

			localErrorMessage: '',

			showConfirmModal: false,
			confirmModalTimer: false,
			confirmModalTimerHandle: false,
			confirmModalTitle: '',
			confirmModalBodyText: '',

			Access: false,
			Status: null,
			Error: '',

			isReinstallStrated: false,

			currentTab: ''
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		linkHint: function linkHint() {
			if (this.Config && this.Config['vds'] && this.Config['vds']['hint-link'] && this.Config['vds']['hint-link']['create'] && this.Config['vds']['hint-link']['create'].length) {
				var _result = false;
				this.Config['vds']['hint-link']['create'].some(function (item) {
					if (item.showIfField === 'sshkey_id') {
						_result = item;
						return true;
					}
				});

				return _result;
			}

			return false;
		},
		linkHintShowIf: function linkHintShowIf() {
			if (!this.sshkeyField) return false;
			if (this.currentTab === 'backup' || this.currentTab === 'iso') return false;

			return this.sshkeyField['_visible'];
		},
		modalConfirmButtonTitle: function modalConfirmButtonTitle() {
			if (this.confirmModalTitle === 'service/reinstall') {
				if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc('service/reinstall');
				return this.localeFtc('service/reinstall') + ' - ' + this.confirmModalTimer;
			}

			if (this.confirmModalTitle === 'service/restore') {
				if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc('service/restore');
				return this.localeFtc('service/restore') + ' - ' + this.confirmModalTimer;
			}

			return '';
		},
		isDisbledReinstallButton: function isDisbledReinstallButton() {
			var _this = this;

			if (!this.Access || this.Status !== 'active' || this.isReinstallStrated) return true;

			if (!this.planId) return true;

			if (!this.templateField && !this.backupField && !this.reisoField) return true;

			if (!this.templateValue && !this.backupValue && !this.reisoValue) return true;

			if (this.currentTab !== 'backup' && this.currentTab !== 'iso' && this.templateValue && this.templateField && this.templateField.list && this.templateField.list.length) {
				var temp = null;
				this.templateField.list.some(function (t) {
					if (String(t.id) === String(_this.templateValue)) {
						temp = t;
						return true;
					}
				});

				if (!temp || !temp.plans || !temp.plans.length) return true;

				return !temp.plans.some(function (p) {
					if (String(p) === String(_this.planId)) {
						return true;
					}
				});
			} else if (this.currentTab === 'backup' && this.backupValue && this.backupField && this.backupField.list && this.backupField.list.length) {
					var _temp = null;
					this.backupField.list.some(function (t) {
						if (String(t.id) === String(_this.backupValue)) {
							_temp = t;
							return true;
						}
					});

					if (!_temp && !_temp.plans && !_temp.plans.length) return true;

					return !_temp.plans.some(function (p) {
						if (String(p) === String(_this.planId)) {
							return true;
						}
					});
				} else if (this.currentTab === 'iso' && this.reisoValue && this.reisoField && this.reisoField.list && this.reisoField.list.length) {
						var _temp2 = null;
						this.reisoField.list.some(function (t) {
							if (String(t.id) === String(_this.reisoValue)) {
								_temp2 = t;
								return true;
							}
						});

						if (!_temp2) return true;

						return false;
					}

			return true;
		},
		formFields: function formFields() {
			var answer = [];

			if (this.account && this.account.account_id) answer.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ _field_name: 'account_id' }, this.account.account_id));

			if (this.templateField) answer.push(this.templateField);

			if (this.backupField) answer.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ _field_name: 'backup_id' }, this.backupField));

			if (this.reisoField) answer.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ _field_name: 'iso_id' }, this.reisoField));

			return [answer];
		}
	},
	created: function created() {
		var _this2 = this;

		this.templateField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.template);
		this.templateValue = this.value;

		this.hostField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.host);
		if (this.hostField && this.hostField['value']) this.hostValue = this.hostField['value'];

		this.sshkeyField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.sshkey);
		if (this.sshkeyField && 'value' in this.sshkeyField) {
			if (this.sshkeyField['value']) this.sshkeyValue = this.sshkeyField['value'];else {
				this.sshkeyValue = -1000;
				this.$nextTick(function () {
					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
						name: 'sshkey_id',
						value: {
							'id': -1000,
							'name': _this2.localeFtc('sshkey/not_use')
						}
					});
				});
			}
		}

		this.backupField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.backup);
		this.reisoField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.reiso);

		this.Access = this.access;
		this.Status = this.status;
		this.Error = this.parentError;

		this.showif();
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	methods: {
		linkHintHtml: function linkHintHtml(data) {
			if (!data || !data.link || !data.title) return '';

			var title = this.localeFtc(data.title);
			var begin = title.indexOf('[URL]');
			var end = title.indexOf('[/URL]');
			var answer = __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].escapeHtml(title);

			if (begin > -1 && end > -1) {
				answer = answer.replace('[URL]', '<a href="' + data.link + '" target="_blank" style="margin: 0">').replace('[/URL]', '</a>');
			}

			return answer;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) this.hideConfirmModal();
		},
		onFocus: function onFocus(field) {
			field['_errMsg'] = '';
		},
		fieldChanged: function fieldChanged() {
			this.showif();
		},
		onTemplateTab: function onTemplateTab(tab) {
			this.currentTab = tab;
		},
		onBackupList: function onBackupList(list) {
			if (!this.backupField) this.backupField = {};
			this.backupField.list = list;
		},
		onTemplateInput: function onTemplateInput(data) {
			if (!data || !data.tab) return;

			if (data.tab !== 'backup' && data.tab !== 'iso') {
				this.templateValue = data.value;
				this.backupValue = null;
				this.reisoValue = null;
			} else if (data.tab === 'backup') {
				this.templateValue = null;
				this.backupValue = data.value;
				this.reisoValue = null;
			} else if (data.tab === 'iso') {
				this.templateValue = null;
				this.backupValue = null;
				this.reisoValue = data.value;
			}

			this.fieldChanged();
		},
		reInstall: function reInstall() {
			var _this3 = this;

			if (!this.Access || this.Status !== 'active' || this.Error) return;

			if (this.isReinstallStrated) return;

			if (!this.validate()) return;

			this.hideConfirmModal();

			this.localErrorMessage = '';

			this.confirmModalTitle = 'service/reinstall';
			this.confirmModalBodyText = 'service/reinstall_confirm';

			if (this.currentTab === 'backup' && this.backupValue && this.backupField && this.backupField.list && this.backupField.list.length) {
				var _backupName = '#' + this.backupValue;
				this.backupField.list.some(function (b) {
					if (b && String(b.id) === String(_this3.backupValue)) {
						_backupName = b.name;
						return true;
					}
				});

				this.confirmModalTitle = 'service/restore';
				this.confirmModalBodyText = this.localeFtc('service/restore_backup_info').replace('{server}', this.vdsName).replace('{backup}', _backupName);
			}

			this.confirmModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModal = true;

			this.$emit('flagCloseModals', true);

			this.confirmModalTimerHandle = setInterval(function () {
				_this3.confirmModalTimer--;
				if (_this3.confirmModalTimer <= 0) {
					clearInterval(_this3.confirmModalTimerHandle);
					_this3.confirmModalTimerHandle = false;
				}
			}, 1000);
		},
		validate: function validate() {
			if (this.currentTab !== 'backup' && this.currentTab !== 'iso' && !__WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].validateHostnameForFQDN(this.hostValue)) {
				this.hostField['_errMsg'] = 'ippool/host_error';
				return false;
			}

			if (!this.templateField && !this.backupField && !this.reisoField) {
				this.templateField['_errMsg'] = 'template/not_selected';
				return false;
			}

			if (!this.templateValue && !this.backupValue && !this.reisoValue) {
				var _errText = '';
				if (this.currentTab === 'backup') {
					_errText = 'backup/not_selected';
				} else if (this.currentTab === 'iso') {
					_errText = 'iso/not_selected';
				} else {
					_errText = 'template/not_selected';
				}

				this.templateField['_errMsg'] = _errText;
				return false;
			}

			return true;
		},
		showif: function showif() {
			var _this4 = this;

			if (!this.hostField || !this.hostField['_field_name'] || !this.templateField || !this.templateField['_field_name'] || !this.sshkeyField || !this.sshkeyField['_field_name']) return;

			var fields = [this.hostField, this.templateField, this.sshkeyField];

			var _values = {
				reinstall: 1
			};
			var _expressions = {};

			fields.forEach(function (field) {
				var _fieldName = field['_field_name'];
				var _val = null;

				if (_fieldName === 'hostname') _val = _this4.hostValue;else if (_fieldName === 'template_id') _val = _this4.templateValue;else if (_fieldName === 'sshkey_id') _val = _this4.sshkeyValue;

				_values[_fieldName.replace(/\[/g, '__').replace(/]/g, '__')] = _val;

				if (field['showif']) {
					var _expr = field['showif'];

					if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
						var reg = new RegExp(/(\w+) in (\[[0-9,\s-]+\])/gi);

						if (reg.exec(_expr) !== null) {
							_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1');
						} else {
							reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
							var _mtch = null;
							if ((_mtch = reg.exec(_expr)) !== null) {
								_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') !== -1');
							}
						}
					} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
					_expressions[_fieldName] = _expr;
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = null;
				if (e === 'hostname') _field = this.hostField;else if (e === 'template_id') _field = this.templateField;else if (e === 'sshkey_id') _field = this.sshkeyField;

				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		hideConfirmModal: function hideConfirmModal() {
			if (this.confirmModalTimerHandle) {
				clearInterval(this.confirmModalTimerHandle);
				this.confirmModalTimerHandle = false;
			}

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModal = false;
			this.hideModalMask();
		},
		changeTemplateStart: function changeTemplateStart() {
			var _this5 = this;

			if (this.confirmModalTimer && this.confirmModalTimer > 0) return;

			if (!this.Access || this.Status !== 'active' || this.Error) return;

			if (this.hostField['_errMsg'] !== '' || this.templateField['_errMsg'] !== '') return;

			if (this.isReinstallStrated) return;

			this.localErrorMessage = '';

			this.isReinstallStrated = true;

			this.hostField._visible = false;
			this.templateField._visible = false;
			this.sshkeyField._visible = false;

			this.hideConfirmModal();

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			if (this.backupValue) {
				_url = this.APIServerUrl + '/service/update/' + this.vdsId + ('?additional=setRestore&service_id=' + this.backupValue);
			}

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					if (_this5.templateValue) {
						_post[_dt['model']]['reinstall'] = 1;
						_post[_dt['model']]['template_id'] = _this5.templateValue;
						_post[_dt['model']]['hostname'] = _this5.hostValue;

						if (_this5.sshkeyValue && String(_this5.sshkeyValue).trim() !== '' && parseInt(_this5.sshkeyValue, 10) !== -1000) _post[_dt['model']]['sshkey_id'] = _this5.sshkeyValue;
					}

					if (_this5.backupValue) {
						delete _post[_dt['model']];
					}

					if (_this5.reisoValue) {
						_post[_dt['model']]['reiso_id'] = _this5.reisoValue;
					}

					_this5.$http.post(_url, __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this5.$emit('successMessage', 'service/reinstall_process_start');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							_this5.localErrorMessage = _this5.formatRequestError(resPost);

							if (_dt['fields'] && _dt['fields']['hostname']) {
								if (Array.isArray(_dt['fields']['hostname'])) {
									if (_dt['fields']['hostname'].length) _this5.hostField['_errMsg'] = _this5.localeFtc(_dt['fields']['hostname'][0]);
								} else _this5.hostField['_errMsg'] = _this5.localeFtc(_dt['fields']['hostname']);
							}

							if (_dt['fields'] && _dt['fields']['template_id']) {
								if (Array.isArray(_dt['fields']['template_id'])) {
									if (_dt['fields']['template_id'].length) _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['template_id'][0]);
								} else _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['template_id']);
							}

							if (_dt['fields'] && _dt['fields']['backup_id']) {
								if (Array.isArray(_dt['fields']['backup_id'])) {
									if (_dt['fields']['backup_id'].length) _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['backup_id'][0]);
								} else _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['backup_id']);
							}

							if (_dt['fields'] && _dt['fields']['reiso_id']) {
								if (Array.isArray(_dt['fields']['reiso_id'])) {
									if (_dt['fields']['reiso_id'].length) _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['reiso_id'][0]);
								} else _this5.templateField['_errMsg'] = _this5.localeFtc(_dt['fields']['reiso_id']);
							}

							if (_dt['fields'] && _dt['fields']['sshkey_id']) {
								if (Array.isArray(_dt['fields']['sshkey_id'])) {
									if (_dt['fields']['sshkey_id'].length) _this5.sshkeyField['_errMsg'] = _this5.localeFtc(_dt['fields']['sshkey_id'][0]);
								} else _this5.sshkeyField['_errMsg'] = _this5.localeFtc(_dt['fields']['sshkey_id']);
							}

							_this5.isReinstallStrated = false;

							_this5.hostField._visible = true;
							_this5.templateField._visible = true;
							_this5.sshkeyField._visible = true;

							return;
						}
					}, function (resPost) {
						_this5.isReinstallStrated = false;

						_this5.hostField._visible = true;
						_this5.templateField._visible = true;
						_this5.sshkeyField._visible = true;

						_this5.localErrorMessage = _this5.formatRequestError(resPost);
					});

					return;
				}

				_this5.isReinstallStrated = false;

				_this5.hostField._visible = true;
				_this5.templateField._visible = true;
				_this5.sshkeyField._visible = true;

				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			}, function (resGet) {
				_this5.isReinstallStrated = false;

				_this5.hostField._visible = true;
				_this5.templateField._visible = true;
				_this5.sshkeyField._visible = true;

				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			});
		}
	},

	watch: {
		'value': function value(_value) {
			this.templateValue = this.value;
		},
		'template': function template(_template, old) {
			if (_template) this.isReinstallStrated = false;

			this.templateField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _template);
		},
		'host': function host(_host, old) {
			if (old) this.isReinstallStrated = false;

			this.hostField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _host);
			if (this.hostField && this.hostField['value']) this.hostValue = this.hostField['value'];
		},
		'sshkey': function sshkey(_sshkey) {
			var _this6 = this;

			this.sshkeyField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _sshkey);
			if (this.sshkeyField && 'value' in this.sshkeyField) {
				if (this.sshkeyField['value']) {
					this.sshkeyValue = this.sshkeyField['value'];
					this.$nextTick(function () {
						_this6.showif();
					});
				} else {
					this.sshkeyValue = -1000;
					this.$nextTick(function () {
						__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
							name: 'sshkey_id',
							value: {
								'id': -1000,
								'name': _this6.localeFtc('sshkey/not_use')
							}
						});
						_this6.showif();
					});
				}
			}
		},
		'backup': function backup(_backup) {
			this.backupField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _backup);
		},
		'reiso': function reiso(_reiso) {
			this.reisoField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _reiso);
		},
		'access': function access(_access, old) {
			if (_access && !old) this.isReinstallStrated = false;

			this.Access = _access;
		},
		'status': function status(_status) {
			this.Status = _status;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_3__components_elements_formfield___default.a
	}

});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-reinstall-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (!_vm.Access) ? [_c('div', {
    staticClass: "text-center margin-top-5"
  }, [(_vm.serviceStatus && (_vm.serviceStatus.loader || _vm.serviceStatus.timer)) ? _c('div', {
    staticStyle: {
      "margin": "80px auto"
    }
  }, [(_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))])]) : [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]], 2)] : [_c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.templateField && _vm.Access) ? _c('Field', {
    attrs: {
      "crud": "vds",
      "action": "view",
      "isVisibleRow": true,
      "removeRightPadding": true,
      "Field": _vm.templateField,
      "formFields": _vm.formFields,
      "planField": _vm.planData,
      "dc": _vm.dc && 'id' in _vm.dc ? _vm.dc.id : null
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus(_vm.templateField)
      },
      "templateTab": _vm.onTemplateTab,
      "templateInput": _vm.onTemplateInput,
      "backupList": _vm.onBackupList
    },
    model: {
      value: (_vm.templateValue),
      callback: function($$v) {
        _vm.templateValue = $$v
      },
      expression: "templateValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.hostField && _vm.Access && _vm.templateValue && _vm.currentTab !== 'backup' && _vm.currentTab !== 'iso') ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.hostField,
      "removeRightPadding": true
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus(_vm.hostField)
      },
      "valueChanged": _vm.fieldChanged
    },
    model: {
      value: (_vm.hostValue),
      callback: function($$v) {
        _vm.hostValue = $$v
      },
      expression: "hostValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.sshkeyField && _vm.Access && _vm.templateValue && _vm.currentTab !== 'backup' && _vm.currentTab !== 'iso') ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.sshkeyField,
      "removeRightPadding": true
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus(_vm.sshkeyField)
      },
      "valueChanged": _vm.fieldChanged
    },
    model: {
      value: (_vm.sshkeyValue),
      callback: function($$v) {
        _vm.sshkeyValue = $$v
      },
      expression: "sshkeyValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.linkHint && _vm.linkHintShowIf) ? _c('div', {
    staticClass: "w5-info-link"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.linkHintHtml(_vm.linkHint)),
      expression: "linkHintHtml(linkHint)"
    }]
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "btn btn-submit-danger margin-top-10 font-weight-300",
    class: {
      'disable': _vm.isDisbledReinstallButton
    },
    on: {
      "click": _vm.reInstall
    }
  }, [(_vm.currentTab === 'backup') ? [_vm._v(_vm._s(_vm._f("ftc")('service/backup_restore')))] : [_vm._v(_vm._s(_vm._f("ftc")('service/reinstall')))]], 2)])], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalBodyText)),
      expression: "localeFtc(confirmModalBodyText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.confirmModalTimer && _vm.confirmModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.changeTemplateStart
    }
  }, [_vm._v(_vm._s(_vm.modalConfirmButtonTitle))])])])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_table__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_btndropdown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_btndropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_btndropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bus_js__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabIp',

	props: ['mainIP', 'vdsId', 'access', 'active', 'ipInfo', 'status', 'serviceStatus', 'parentError', 'reserveIpData', 'reserveIPv4List'],

	computed: {
		countIP4: function countIP4() {
			if (!this.ip4) return '';
			if (this.ip4['count'] > 0) {
				return this.localeFtc('service/ip_count_ordered_available').replace('{v}', '4').replace('{ordered}', this.ip4['count'] < 0 ? 0 : this.ip4['count']).replace('{available}', this.ip4['max'] < 0 ? 0 : this.ip4['max']);
			} else {
				return this.localeFtc('service/ip_count_not_ordered').replace('{v}', '4').replace('{available}', this.ip4['max'] < 0 ? 0 : this.ip4['max']);
			}
		},
		costIP4: function costIP4() {
			if (!this.ip4) return '';
			if (this.ip4['cost'] <= 0) return '';
			return this.localeFtc('service/cost_ip_title: <b>' + this.ip4['cost'] + '</b> main/ruble / ' + this.ip4['period']);
		},
		countIP6: function countIP6() {
			if (!this.ip6) return '';
			if (this.ip6['count'] > 0) {
				return this.localeFtc('service/ip_count_ordered_available').replace('{v}', '6').replace('{ordered}', this.ip6['count'] < 0 ? 0 : this.ip6['count']).replace('{available}', this.ip6['max'] < 0 ? 0 : this.ip6['max']);
			} else {
				return this.localeFtc('service/ip_count_not_ordered').replace('{v}', '6').replace('{available}', this.ip6['max'] < 0 ? 0 : this.ip6['max']);
			}
		},
		costIP6: function costIP6() {
			if (!this.ip6) return '';
			if (this.ip6['cost'] <= 0) return '';
			return this.localeFtc('service/cost_ip_title_ipv6: <b>' + this.ip6['cost'] + '</b> main/ruble / ' + this.ip6['period']);
		},
		reserveIpCost: function reserveIpCost() {
			if (!this.reserveIpData || !('cost' in this.reserveIpData)) return '';
			if (this.reserveIpData['cost'] <= 0) return '';

			return this.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>').replace('{cost}', this.reserveIpData['cost']).replace('{period}', this.localeFtc(this.reserveIpData['period'])).replace('{for}', this.localeFtc(this.reserveIpData['for']));
		},
		hasSelectedRowsIp4: function hasSelectedRowsIp4() {
			var _found = false;

			if (this.ip4 && this.ip4['rows'] && this.ip4['rows'].length) {
				_found = this.ip4['rows'].some(function (item) {
					if (item['selected'] === true) return true;
				});
				if (_found) return true;
			}

			return false;
		},
		hasSelectedRowsIp6: function hasSelectedRowsIp6() {
			var _found = false;

			if (this.ip6 && this.ip6['rows'] && this.ip6['rows'].length) {
				_found = this.ip6['rows'].some(function (item) {
					if (item['selected'] === true) return true;
				});
				if (_found) return true;
			}

			return false;
		},
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		},
		tableUrlList: function tableUrlList() {
			return this.selectedIpId ? '/ipptrpool/list?ip_id=' + this.selectedIpId : null;
		},
		tableUrlCreate: function tableUrlCreate() {
			return this.selectedIpId ? '/ipptrpool/create/' + this.selectedIpId : null;
		},
		tableUrlUpdate: function tableUrlUpdate() {
			return this.selectedIpId ? '/ipptrpool/update/' : null;
		},
		modalConfirmButtonTitle: function modalConfirmButtonTitle() {
			if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc(this.modalConfirmButtonTitleText);
			return this.confirmModalTimer + ' - ' + this.localeFtc(this.modalConfirmButtonTitleText);
		}
	},
	data: function data() {
		var _this = this;

		return {
			Access: false,
			Status: null,
			Error: '',
			mainIPData: null,
			localErrorMessage: '',
			activeProcess: false,

			rawData: null,

			ip4: {
				rows: null,
				cost: 0,
				for: '',
				max: 0,
				period: '',
				count: 0
			},
			ip6: {
				rows: null,
				cost: 0,
				for: '',
				max: 0,
				period: '',
				count: 0
			},

			showDeleteModal: false,
			deleteModalTitle: 'ippool/delete_selected_title',
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteAddressType: null,
			deleteModalId: null,

			deletedIp4: {},
			deletedIp6: {},

			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalText: '',
			modalConfirmButtonTitleText: '',
			confirmStart: function confirmStart() {},

			confirmModalTimer: false,
			confirmModalTimerHandle: false,
			confirmModalDangerButton: false,

			showHostModal: false,
			hostValue: null,
			hostField: {
				'required': true,
				'title': 'ippool/host',
				'type': 'text',
				'_field_name': 'host',
				'_visible': true,
				'_errMsg': ''
			},
			hostRow: null,
			hostModalTitle: 'ippool/host',
			hostModalContainerClass: 'wide',
			hostModalCurrentMode: '',

			showBuyModal: false,
			buyType: '4',
			buyValue: null,
			buyField: {
				'required': true,
				'title': 'main/count',
				'type': 'integer',
				'_field_name': 'buyCount',
				'_visible': true,
				'_errMsg': ''
			},

			reserveIpField: {
				required: true,
				type: 'list',
				list: [{
					'id': -1000,
					'name': this.localeFtc('main/not_use')
				}],
				title: 'server/server',
				_field_name: 'useReserveIpModalValue',
				_visible: true,
				_errMsg: ''
			},
			reserveIpFieldValue: null,

			refreshQueueHandler: null,

			updateQueueHandler: null,

			selectedIpId: null,

			tableColumns: {
				'ptr_address': {},
				'ptr_host': {},
				'ptr_timestamp': {
					style: 'width: 105px',
					formatter: function formatter(value) {
						return _this.formater_StrDateFormat(value);
					}
				}
			},

			reserveIpValue: false,
			reserveIpProcessing: false,

			configOpersIp4: {
				'delete': {
					'action': 'func:delOneIP4'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'func:changeHost'
				}
			},
			configOpersIp6: {
				'delete': {
					'action': 'func:delOneIP6'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'func:changeHost'
				}
			}
		};
	},
	created: function created() {
		this.Access = this.access;
		this.Status = this.status;
		this.Error = this.parentError;
		this.mainIPData = this.mainIP;

		if (this.ipInfo && this.ipInfo['ip4']) {
			this.ip4['cost'] = this.ipInfo['ip4']['cost'];
			this.ip4['for'] = this.ipInfo['ip4']['for'];
			this.ip4['max'] = this.ipInfo['ip4']['max'];
			this.ip4['period'] = this.ipInfo['ip4']['period'];
			this.ip4['count'] = this.ipInfo['ip4']['count'];
		}

		if (this.ipInfo && this.ipInfo['ip6']) {
			this.ip6['cost'] = this.ipInfo['ip6']['cost'];
			this.ip6['for'] = this.ipInfo['ip6']['for'];
			this.ip6['max'] = this.ipInfo['ip6']['max'];
			this.ip6['period'] = this.ipInfo['ip6']['period'];
			this.ip6['count'] = this.ipInfo['ip6']['count'];
		}

		this.reserveIpValue = this.reserveIpData && 'value' in this.reserveIpData ? this.reserveIpData.value : false;

		if (this.active) this.requestData();
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		if (this.updateQueueHandler) {
			clearTimeout(this.updateQueueHandler);
			this.updateQueueHandler = null;
		}

		if (this.refreshQueueHandler) {
			clearTimeout(this.refreshQueueHandler);
			this.refreshQueueHandler = null;
		}

		if (this.confirmModalTimerHandle) {
			clearInterval(this.confirmModalTimerHandle);
			this.confirmModalTimerHandle = false;
		}
	},

	methods: {
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) {
				e.preventDefault();

				if (this.showHostModal) {
					this.hideHostModal();
					return;
				}

				this.hideDeleteModal();
				this.hideHostModal();
				this.hideBuyModal();
				this.hideConfirmModal();
			}
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			var _this2 = this;

			if (!msg) return;

			if (!this.active) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== 'service') return;

			var _id = _parts[2];

			if (!_id) return;

			var _isVds = String(this.vdsId) === String(_id);

			var _found = false;
			if (this.ip4 && this.ip4['rows']) {
				_found = this.ip4['rows'].some(function (item) {
					if (String(item['service_id']) === String(_id) || String(item['parent_id']) === String(_id)) return true;
				});
			}

			if (!_found) {
				if (this.ip6 && this.ip6['rows']) {
					_found = this.ip6['rows'].some(function (item) {
						if (String(item['service_id']) === String(_id) || String(item['parent_id']) === String(_id)) return true;
					});
				}
			}

			if (_isVds || _found) {
				if (this.refreshQueueHandler) clearTimeout(this.refreshQueueHandler);

				this.refreshQueueHandler = setTimeout(function () {
					_this2.$emit('updateData');

					_this2.requestData();
				}, 1500);
			}
		},
		clearRows: function clearRows() {
			this.ip4['rows'] = null;
			this.ip6['rows'] = null;

			var _mainIP = this.getMainIP();
			if (_mainIP && _mainIP['type']) {
				if (_mainIP['type'] === '4') {
					this.ip4['rows'] = [];
					this.ip4['rows'].push(_mainIP);
				} else if (_mainIP['type'] === '6') {
					this.ip6['rows'] = [];
					this.ip6['rows'].push(_mainIP);
				}
			}
		},
		requestData: function requestData() {
			var _this3 = this;

			this.localErrorMessage = '';

			var _selectedRowsIp4 = {};
			if (this.ip4['rows'] && this.ip4['rows'].length) this.ip4['rows'].forEach(function (row) {
				if (row && row['selected'] === true) _selectedRowsIp4[String(row['id'])] = 1;
			});

			var _selectedRowsIp6 = {};
			if (this.ip6['rows'] && this.ip6['rows'].length) this.ip6['rows'].forEach(function (row) {
				if (row && row['selected'] === true) _selectedRowsIp6[String(row['id'])] = 1;
			});

			var _url = this.APIServerUrl + '/service/list';

			var _params = {
				'ServiceSearch': {
					'parent_id': this.vdsId
				}
			};

			this.$http.get(_url, { 'params': _params }).then(function (res) {
				_this3.clearRows();

				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this3.rawData = _dt;

					if (_dt['rows'] && Array.isArray(_dt['rows']) && _dt['rows'].length) {
						var _loop = function _loop(i) {
							var _row = _dt['rows'][i];

							if (!_row['service_data'] || !_row['service_data']['ip'] || !Array.isArray(_row['service_data']['ip']) || !_row['service_data']['ip'].length) return 'continue';

							_row['service_data']['ip'].forEach(function (ip) {
								if ('id' in ip && ip['id']) {
									var _x = {
										'id': ip['id'],
										'parent_id': _row['parent_id'],
										'service_id': _row['service_id'],
										'address': ip['ip'],
										'host': ip['host'],
										'gateway': ip['gateway'],
										'netmask': ip['netmask'],
										'status': _row['service_status'],
										'status_text': _row['service_status_text'],
										'can_delete': true,
										'selected': false
									};

									if (ip['type'] === '4') {
										if (_selectedRowsIp4[String(_x['id'])]) _x['selected'] = true;

										if (_this3.ip4['rows'] === null) _this3.ip4['rows'] = [];

										_this3.ip4['rows'].push(_x);
									} else if (ip['type'] === '6') {
										if (_selectedRowsIp6[String(_x['id'])]) _x['selected'] = true;

										if (_this3.ip6['rows'] === null) _this3.ip6['rows'] = [];

										_this3.ip6['rows'].push(_x);
									}
								}
							});
						};

						for (var i = 0; i < _dt['rows'].length; i++) {
							var _ret = _loop(i);

							if (_ret === 'continue') continue;
						}
					}

					return;
				}

				_this3.localErrorMessage = _this3.formatRequestError(res);
			}, function (res) {
				_this3.clearRows();

				_this3.localErrorMessage = _this3.formatRequestError(res);
			});
		},
		getMainIP: function getMainIP() {
			if (!this.mainIPData || !this.mainIPData['id'] || !this.mainIPData['system']) {
				return false;
			}

			return {
				'id': this.mainIPData['id'],
				'parent_id': this.vdsId,
				'service_id': this.vdsId,
				'address': this.mainIPData['ip'],
				'host': this.mainIPData['host'],
				'gateway': this.mainIPData['gateway'],
				'netmask': this.mainIPData['netmask'],
				'status': 'active',
				'status_text': null,
				'can_delete': false,
				'system': this.mainIPData['system'],
				'type': this.mainIPData['type'],
				'selected': false
			};
		},
		buyIP: function buyIP(addressType) {
			if (this.activeProcess !== false) return;

			if (addressType !== '4' && addressType !== '6') return;

			if (!this.Access || !this.ipInfo || this.Error) return;

			this.localErrorMessage = '';

			this.buyValue = 1;
			this.buyField['_errMsg'] = '';

			this.buyType = addressType;

			this.reserveIpField.list = [{
				'id': -1000,
				'name': this.localeFtc('main/not_use')
			}];

			this.activeProcess = 1;

			if (addressType === '6') {
					this.buyBegin();
					return;
				}

			if (addressType === '4') {
				this.buyIP4();
				return;
			}

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showBuyModal = true;
		},
		buyIP4: function buyIP4() {
			this.reserveIpFieldValue = -1000;

			if (this.reserveIPv4List && this.reserveIPv4List.list && this.reserveIPv4List.list.length) {
				this.reserveIpField.list = this.reserveIpField.list.concat(this.reserveIPv4List.list);
			}

			if (this.reserveIpField.list.length <= 1) {
				this.buyBegin();
				return;
			}

			this.reserveIpField.title = this.reserveIPv4List.title;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showBuyModal = true;
		},
		hideBuyModal: function hideBuyModal() {
			var withActiveProcessFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (withActiveProcessFlag) {
				this.activeProcess = false;
			}

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBuyModal = false;
			this.hideModalMask();
		},
		onEnterKeyDownBuy: function onEnterKeyDownBuy() {
			this.buyBegin();
		},
		buyBegin: function buyBegin() {
			this.hideBuyModal(true);

			this.confirmModalTimer = false;
			this.confirmModalTimerHandle = false;
			this.confirmModalDangerButton = false;

			this.confirmModalTitle = this.buyType === '4' ? 'main/order service/ip4_count' : 'main/order service/ip6_count';

			this.modalConfirmButtonTitleText = 'main/confirm';

			this.confirmModalText = this.buyType === '4' ? this.costIP4 : this.costIP6;
			if (!this.confirmModalText) {
				var _txt = this.buyType === '4' ? 'service/cost_ip_title' : 'service/cost_ip_title_ipv6';
				this.confirmModalText = this.localeFtc(_txt + ': <b>0</b> main/ruble');
			}

			this.confirmStart = this.buyBeginStart;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModal = true;
		},
		buyBeginStart: function buyBeginStart() {
			var _this4 = this;

			if (this.activeProcess !== false && this.activeProcess > 1) return;

			if (!this.Access || !this.ipInfo || this.Error) return;

			this.localErrorMessage = '';

			var _count = parseInt(this.buyValue);

			if (isNaN(_count)) {
				this.buyField['_errMsg'] = 'validators/error_int';
				return;
			}
			if (_count <= 0) {
				this.buyField['_errMsg'] = 'error/required_field';
				return;
			}

			if (this.buyType === '4') {
				if (_count > this.ip4['max']) {
					this.buyField['_errMsg'] = 'service/ip_count_max ' + this.ip4['max'];
					return;
				}
			} else {
				if (_count > this.ip6['max']) {
					this.buyField['_errMsg'] = 'service/ip_count_max_ipv6 ' + this.ip6['max'];
					return;
				}
			}

			this.activeProcess = 2;

			this.$http.get(this.APIServerUrl + '/service/update/' + this.vdsId).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;
				if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['model'] && _dt['fields']['ip4_count'] && _dt['fields']['ip6_count'] && _dt['_csrf']) {
					var _data = {
						'reinstall': 0,

						'ip4_count': _dt['fields']['ip4_count']['value'] + (_this4.buyType === '4' ? _count : 0),
						'ip6_count': _dt['fields']['ip6_count']['value'] + (_this4.buyType === '6' ? _count : 0)
					};
					if (_this4.reserveIpFieldValue && _this4.reserveIpFieldValue > 0) {
						_data['use_reserve_ip'] = _this4.reserveIpFieldValue;
					}

					_this4.requestBuy(_data, _dt['_csrf'], _dt['model']);

					return;
				}

				_this4.hideBuyModal();

				_this4.localErrorMessage = _this4.formatRequestError(res);
			}, function (res) {
				_this4.hideBuyModal();

				_this4.localErrorMessage = _this4.formatRequestError(res);
			});
		},
		requestBuy: function requestBuy(postData, csrf, model) {
			var _this5 = this;

			this.localErrorMessage = '';

			this.hideBuyModal(false);

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			var _post = {
				'_csrf': csrf
			};
			_post[model] = postData;

			this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
				var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this5.$emit('successMessage', 'service/ip_request_success');

					_this5.activeProcess = false;

					return;
				}

				_this5.localErrorMessage = _this5.formatRequestError(resPost);

				_this5.activeProcess = false;
			}, function (resPost) {
				_this5.localErrorMessage = _this5.formatRequestError(resPost);

				_this5.activeProcess = false;
			});
		},
		delIP: function delIP(addressType) {
			var _this6 = this;

			if (this.activeProcess !== false) return;

			if (!this.Access || this.Error) return;

			if (addressType !== '4' && addressType !== '6') return;

			this.localErrorMessage = '';
			this.deleteModalText = '';
			this.deleteAddressType = null;
			this.deleteModalTitle = 'ippool/delete_selected_title';
			this.deleteModalId = null;

			var _ip4 = [];
			var _ip6 = [];

			if (addressType === '4') {
				if (this.ip4 && this.ip4['rows']) {
					this.ip4['rows'].forEach(function (item) {
						if (item['selected'] === true) {
							_ip4.push(item['address']);
						}
					});
				}
			}

			if (addressType === '6') {
				if (this.ip6 && this.ip6['rows']) {
					this.ip6['rows'].forEach(function (item) {
						if (item['selected'] === true) {
							_ip6.push(item['address']);
						}
					});
				}
			}

			if (!_ip4.length && !_ip6.length) return;

			this.deleteAddressType = addressType;

			var _tmp4 = '';
			var _tmp6 = '';

			if (_ip4.length) {
				_tmp4 = _ip4.join(', ');
				_tmp4 += '<br>ippool/selected_records';
				_tmp4 = this.localeFtc(_tmp4).replace('{v}', '4').replace('{count}', _ip4.length);
			}

			if (_ip6.length) {
				_tmp6 = _ip6.join(', ');
				_tmp6 += '<br>ippool/selected_records';
				_tmp6 = this.localeFtc(_tmp6).replace('{v}', '6').replace('{count}', _ip6.length);
			}

			if (_ip4.length) this.deleteModalText = _tmp4;
			if (_ip6.length) {
				if (this.deleteModalText !== '') this.deleteModalText += '<br><br>';
				this.deleteModalText += _tmp6;
			}

			this.activeProcess = 1;

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this6.deleteModalTimer--;
				if (_this6.deleteModalTimer <= 0) {
					clearInterval(_this6.deleteModalTimerHandle);
					_this6.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		actionOperButton: function actionOperButton(data) {
			if (!data || !data.row || !data.action) return;

			if (data.action === 'ipptrpool') {
				this.changeHost(data.row);
				return;
			}

			if (data.action === 'delete' && data.data.action) {
				var _parts = data.data.action.split(':');
				if (_parts[0] === 'func' && _parts[1] && this[_parts[1]]) {
					this[_parts[1]](data.row);
				}
				return;
			}
		},
		delOneIP4: function delOneIP4(row) {
			this.delOneIP('4', row);
		},
		delOneIP6: function delOneIP6(row) {
			this.delOneIP('6', row);
		},
		delOneIP: function delOneIP(addressType, row) {
			var _this7 = this;

			if (this.activeProcess !== false) return;

			if (!this.Access || this.Error) return;

			if (addressType !== '4' && addressType !== '6') return;

			this.localErrorMessage = '';
			this.deleteModalText = '';
			this.deleteAddressType = null;
			this.deleteModalTitle = 'main/deleting';

			if (!row || !row['address']) return;
			this.deleteModalId = row['id'];

			this.deleteAddressType = addressType;

			var _tmp = this.localeFtc('ippool/delete_title') + ': ' + row['address'];
			this.deleteModalText = _tmp;

			this.activeProcess = 1;

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this7.deleteModalTimer--;
				if (_this7.deleteModalTimer <= 0) {
					clearInterval(_this7.deleteModalTimerHandle);
					_this7.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		hideDeleteModal: function hideDeleteModal() {
			var withActiveProcessFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (withActiveProcessFlag) {
				this.activeProcess = false;
			}

			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}
			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteBegin: function deleteBegin() {
			var _this8 = this;

			if (this.activeProcess !== false && this.activeProcess > 1) return;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';

			var _ip4 = [];
			var _ip6 = [];

			if (this.deleteAddressType === '4') {
				if (this.deleteModalId && !this.deletedIp4[this.deleteModalId]) _ip4.push(this.deleteModalId);else if (this.ip4 && this.ip4['rows']) {
						this.ip4['rows'].forEach(function (item) {
							if (item['selected'] === true) {
								if (!_this8.deletedIp4[item['id']]) _ip4.push(item['id']);
								item['selected'] = false;
							}
						});
					}
			}

			if (this.deleteAddressType === '6') {
				if (this.deleteModalId && !this.deletedIp6[this.deleteModalId]) _ip6.push(this.deleteModalId);else if (this.ip6 && this.ip6['rows']) {
						this.ip6['rows'].forEach(function (item) {
							if (item['selected'] === true) {
								if (!_this8.deletedIp6[item['id']]) _ip6.push(item['id']);
								item['selected'] = false;
							}
						});
					}
			}

			if (!_ip4.length && !_ip6.length) return;

			this.hideDeleteModal(false);

			this.activeProcess = 2;

			if (_ip4.length) {
				_ip4.forEach(function (a) {
					_this8.deletedIp4[a] = true;
				});
			}

			if (_ip6.length) {
				_ip6.forEach(function (a) {
					_this8.deletedIp6[a] = true;
				});
			}

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					_this8.ip4['count'] = _dt['fields']['ip4_count']['value'];
					_this8.ip6['count'] = _dt['fields']['ip6_count']['value'];

					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};
					_post[_dt['model']]['ip4_delete_list'] = _ip4;
					_post[_dt['model']]['ip4_count'] = _this8.ip4['count'] - _ip4.length;
					_post[_dt['model']]['ip6_delete_list'] = _ip6;
					_post[_dt['model']]['ip6_count'] = _this8.ip6['count'] - _ip6.length;
					_post[_dt['model']]['reinstall'] = 0;

					_this8.$http.post(_url, __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this8.$emit('successMessage', 'service/ip_remove_process');

							_this8.activeProcess = false;

							return;
						}

						_this8.localErrorMessage = _this8.formatRequestError(resPost);

						_this8.activeProcess = false;
					}, function (resPost) {
						_this8.localErrorMessage = _this8.formatRequestError(resPost);

						_this8.activeProcess = false;
					});

					_this8.activeProcess = false;

					return;
				}

				_this8.localErrorMessage = _this8.formatRequestError(resGet);

				_this8.activeProcess = false;
			}, function (resGet) {
				_this8.localErrorMessage = _this8.formatRequestError(resGet);

				_this8.activeProcess = false;
			});
		},
		changeHost: function changeHost(row, type) {
			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';

			this.selectedIpId = row['id'];
			this.hostValue = row['host'];
			this.hostField['_errMsg'] = '';

			this.hostRow = row;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showHostModal = true;
		},
		hideHostModal: function hideHostModal() {
			var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (!forceClose) {
				if (!this.maskModalFlag) return;
			}

			if (this.hostModalCurrentMode !== 'list') {
				__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-host-modal-close-event');
				return;
			}

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showHostModal = false;
			this.hideModalMask();
		},
		onEnterKeyDown: function onEnterKeyDown() {
			this.changeHostBegin();
		},
		changeHostBegin: function changeHostBegin() {
			var _this9 = this;

			if (!this.Access || this.Error) return;

			if (!this.hostRow) return;

			this.localErrorMessage = '';

			if (!this.hostValue.trim()) {
				this.hostField['_errMsg'] = 'error/required_field';
				return;
			}

			var _ipID = this.hostRow['id'];
			var _ipHost = this.hostValue;

			if (_ipID === null || _ipID === undefined || _ipID === '' || _ipID < 1) {
				this.hostField['_errMsg'] = 'main/error_desc ID IP not found!';
				return;
			}

			var _url = this.APIServerUrl + '/ippool/update/' + _ipID;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'host': _ipHost
					};

					_this9.$http.post(_url, __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this9.hostRow['host'] = _ipHost;

							if (_this9.hostRow['can_delete'] === false) _this9.mainIPData['host'] = _ipHost;

							setTimeout(function () {
								_this9.requestData();
							}, 1000);

							_this9.hideHostModal();

							_this9.$emit('successMessage', 'ippool/updated');

							return;
						}

						if (_dt && _dt['status'] === 'error') {
							if (_dt['fields'] && _dt['fields']['host']) {
								if (Array.isArray(_dt['fields']['host'])) {
									if (_dt['fields']['host'].length) _this9.hostField['_errMsg'] = _this9.localeFtc(_dt['fields']['host'][0]);
								} else _this9.hostField['_errMsg'] = _this9.localeFtc(_dt['fields']['host']);
							}

							return;
						}

						_this9.hideHostModal();

						_this9.localErrorMessage = _this9.formatRequestError(resPost);
					}, function (resPost) {
						_this9.hideHostModal();

						_this9.localErrorMessage = _this9.formatRequestError(resPost);
					});

					return;
				}

				_this9.hideHostModal();

				_this9.localErrorMessage = _this9.formatRequestError(resGet);
			}, function (resGet) {
				_this9.hideHostModal();

				_this9.localErrorMessage = _this9.formatRequestError(resGet);
			});
		},
		onFocus: function onFocus(field) {
			field['_errMsg'] = '';
		},
		selectRowInTable: function selectRowInTable(e, row) {
			if (row['can_delete'] === false) return;

			var _foundIndex = -1;
			var _rows = void 0;

			if (this.ip4 && this.ip4['rows'] && this.ip4['rows'].length) {
				this.ip4['rows'].some(function (item, index, arr) {
					if (item['id'] && item['id'] === row['id']) {
						_foundIndex = index;

						_rows = arr;

						if (item['selected'] === true) item['selected'] = false;else item['selected'] = true;

						return true;
					}
				});
			}

			if (_foundIndex < 0) {
				this.ip6['rows'].some(function (item, index, arr) {
					if (item['id'] && item['id'] === row['id']) {
						_foundIndex = index;

						_rows = arr;

						if (item['selected'] === true) item['selected'] = false;else item['selected'] = true;

						return true;
					}
				});
			}

			if (_foundIndex >= 0) {
				var k = 0;
				var _startIndex = -1;
				var _len = _rows.length;

				if (e.shiftKey) {
					for (k = _foundIndex - 1; k >= 0; k--) {
						if (_rows[k]['selected'] === true) {
							_startIndex = k;
							break;
						}
					}

					if (_startIndex < 0) {
						for (k = _foundIndex + 1; k < _len; k++) {
							if (_rows[k]['selected'] === true) {
								_startIndex = k;
								break;
							}
						}
					}
				}

				if (_startIndex >= 0) {
					var _start = _startIndex <= _foundIndex ? _startIndex : _foundIndex;
					var _end = _startIndex <= _foundIndex ? _foundIndex : _startIndex;

					for (k = 0; k < _len; k++) {
						if (k >= _start && k <= _end && k !== _foundIndex) _rows[k]['selected'] = true;
					}
				}
			}
		},
		getError: function getError(msg) {
			this.localErrorMessage = msg;
		},
		reserveIpStart: function reserveIpStart() {
			var _this10 = this;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.reserveIpProcessing) return;

			this.reserveIpProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'reserve_ip': _this10.reserveIpValue ? 0 : 1
					};

					_this10.$http.post(_url, __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this10.reserveIpProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this10.reserveIpValue = !_this10.reserveIpValue;

							setTimeout(function () {
								_this10.requestData();
							}, 1000);

							_this10.$emit('successMessage', 'main/updated');
							return;
						}

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					}, function (resPost) {
						_this10.reserveIpProcessing = false;

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					});

					return;
				}

				_this10.reserveIpProcessing = false;

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			}, function (resGet) {
				_this10.reserveIpProcessing = false;

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			});
		},
		hideConfirmModal: function hideConfirmModal() {
			if (this.confirmModalTimerHandle) {
				clearInterval(this.confirmModalTimerHandle);
				this.confirmModalTimerHandle = false;
			}

			this.activeProcess = false;

			__WEBPACK_IMPORTED_MODULE_5__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModal = false;
			this.hideModalMask();
		}
	},

	watch: {
		'access': function access(_access) {
			this.Access = _access;
		},
		'active': function active(value) {
			if (this.active) this.requestData();
		},
		'status': function status(_status) {
			this.Status = _status;
		},
		'mainIP': function mainIP(ip) {
			this.mainIPData = ip;
		},
		'ipInfo': function ipInfo(info) {
			if (info && info['ip4']) {
				this.ip4['cost'] = info['ip4']['cost'];
				this.ip4['for'] = info['ip4']['for'];
				this.ip4['max'] = info['ip4']['max'];
				this.ip4['period'] = info['ip4']['period'];
				this.ip4['count'] = info['ip4']['count'];
			}

			if (info && info['ip6']) {
				this.ip6['cost'] = info['ip6']['cost'];
				this.ip6['for'] = info['ip6']['for'];
				this.ip6['max'] = info['ip6']['max'];
				this.ip6['period'] = info['ip6']['period'];
				this.ip6['count'] = info['ip6']['count'];
			}
		},
		'parentError': function parentError(value) {
			this.Error = value;
		},
		'hostModalCurrentMode': function hostModalCurrentMode(value) {
			this.$emit('flagCloseModals', value !== 'list');
		},
		'reserveIpData': function reserveIpData(data) {
			this.reserveIpValue = data && 'value' in data ? data.value : false;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default.a,
		dropDownButton: __WEBPACK_IMPORTED_MODULE_4__components_elements_btndropdown___default.a,
		Table: __WEBPACK_IMPORTED_MODULE_3__components_elements_table___default.a
	}
});

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_formfield__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Table',

	props: ['crud', 'access', 'url-list', 'url-create', 'url-update', 'columns', 'id-columns', 'create-button-title', 'inner-forms', 'in-modal', 'crud-search-model'],
	data: function data() {
		return {
			isInnerForms: false,

			innerFormData: null,

			innerFormTitleForList: '',

			innerFormErrorMessage: '',

			isFormSubmited: false,

			verifyRequestsHandlers: [],

			buttonBlock: 0,

			FD: false,
			FD_count: 0,

			updatedRowId: '',

			currentMode: '',

			Access: false,

			Data: null,

			errorGotData: null,

			fastSearchValue: '',

			sortedColumn: false,

			canShowButton: true,

			showDeleteModal: false,
			deleteId: null,
			deleteModalText: '',

			page: 1,

			paginationPages: [],

			lastPage: 1,

			Rows: []
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		IDColumn: function IDColumn() {
			return this.idColumns ? this.idColumns : this.crud + '_id';
		},
		ColumnsHeaders: function ColumnsHeaders() {
			return this.Data && this.Data.columns ? this.Data.columns : null;
		},
		isFormWithDivider: function isFormWithDivider() {
			if (!this.innerFormData.fields) return false;

			var _found = false;
			this.innerFormData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj.type === 'header' && obj._visible) {
							_found = true;
							return true;
						}
					});

					if (_found) return true;
				}
			});

			return _found;
		}
	},
	created: function created() {
		this.currentMode = 'list';

		this.isInnerForms = this.innerForms;

		this.Access = this.access;

		this.page = this.$store.state.tableCurrentPage;
		if (!this.page || this.page < 0) this.page = 1;

		this.fastSearchEvent = __WEBPACK_IMPORTED_MODULE_2_debounce___default()(this.fastSearchEvent, 500);

		this.requestData();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		if (this.inModal) {
			__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$on('w5-host-modal-close-event', this.closeParentModal);
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		if (this.inModal) {
			__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$off('w5-host-modal-close-event', this.closeParentModal);
		}
	},

	methods: {
		requestData: function requestData(callbackAfter) {
			var _this = this;

			if (!this.urlList) return;

			var _getParams = {};
			var _model = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toUpperCaseFirstSymbol(this.crud) + 'Search';
			if (this.crudSearchModel) _model = this.crudSearchModel;
			_getParams[_model] = {};

			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '') _getParams[_model]['fast_search'] = this.fastSearchValue;

			if (this.sortedColumn !== false) _getParams['sort'] = this.sortedColumn.charAt(0) === '+' ? this.sortedColumn.substr(1) : this.sortedColumn;

			var _url = this.urlList;
			if (this.page > 1) {
				if (_url.indexOf('?')) _url = _url.replace('?', '/' + this.page + '?');else _url += '/' + this.page;
			}

			this.$http.get(this.APIServerUrl + _url, { params: _getParams }).then(function (respons) {
				var _dt = respons && respons.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(respons.data) === 'object' ? respons.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this.Data = _dt;

					if (_this.Data && _this.Data.title) {
						_this.innerFormTitleForList = _this.Data.title;
						_this.$emit('title', _this.innerFormTitleForList);
					}

					_this.Rows = [];

					_this.$nextTick(function () {
						_this.Rows = _this.Data.rows.slice();
					});

					_this.paginationPages = [];
					_this.lastPage = 1;
					var _total = parseInt(_dt['totalCount']);
					var _size = parseInt(_dt['pageSize']);

					if (_total > _size) {
						var _pagesCount = Math.ceil(_total / _size);
						if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1;

						if (_pagesCount > 1) {
							_this.lastPage = _pagesCount;

							var _begin = _this.page - 3;
							if (_begin < 1) _begin = 1;
							var _end = _this.page + 3;
							if (_end > _pagesCount) _end = _pagesCount;

							for (var k = _begin; k <= _pagesCount; k++) {
								if (k > _end) break;
								_this.paginationPages.push(k);
							}
						}
					}

					if (callbackAfter) callbackAfter();

					return;
				}

				_this.Data = null;

				_this.errorGotData = _this.formatRequestError(respons);

				if (callbackAfter) callbackAfter();
			}, function (respons) {
				_this.Data = null;

				_this.errorGotData = _this.formatRequestError(respons);

				if (callbackAfter) callbackAfter();
			});
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			this.requestData();
		},
		closeParentModal: function closeParentModal() {
			if (this.currentMode !== 'list') {
				if (this.innerFormTitleForList) {
					this.$emit('title', this.innerFormTitleForList);
				}

				this.currentMode = 'list';
				this.$emit('containerClass', 'wide');
			}
		},
		cellValue: function cellValue(columnName, columnData, Row) {
			var _value = Row[columnName];
			if (columnData && columnData.formatter && typeof columnData.formatter === 'function') _value = columnData.formatter(_value);

			return _value;
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		askForDelete: function askForDelete(Row) {
			if (!Row || !(this.idColumns in Row)) return;
			if (!this.canAction('delete', Row)) return;

			this.deleteId = Row[this.idColumns];
			var _name = this.deleteId;

			if (this.crud === 'dns-records') {
				_name = 'main/record «' + Row['dns_type'] + '»:<br>';
				if (Row['dns_value'].length > 100) _name += Row['dns_value'].substr(0, 100) + '...';else _name += Row['dns_value'];
			}

			if (this.crud === 'ipptrpool') {
				_name = 'main/for «' + Row['ptr_address'] + '» main/record:<br>';
				if (Row['ptr_host'].length > 100) _name += Row['ptr_host'].substr(0, 100) + '...';else _name += Row['ptr_host'];
			}

			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', this.localeFtc(_name));

			if (this.isInnerForms) {
				this.$emit('title', 'ipptrpool/delete');
				this.$emit('containerClass', '');
				this.canShowButton = true;
				this.innerFormErrorMessage = '';
				this.currentMode = 'delete';
				return;
			}

			this.showDeleteModal = true;
		},
		hideDeleteModal: function hideDeleteModal() {
			__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteModalStart: function deleteModalStart() {
			var _this2 = this;

			this.hideDeleteModal();

			if (!this.Access) {
				this.$emit('error', 'main/access_denied');
				return;
			}
			if (!this.isAccess(this.crud + '/delete')) {
				this.$emit('error', 'main/access_denied');
				return;
			}

			var _id = this.deleteId;
			if (!_id) {
				this.$emit('error', 'main/object_id');
				return;
			}

			this.canShowButton = false;

			var _url = this.APIServerUrl + '/';
			if (this.crud === 'dns-records') _url += 'dns';else _url += this.crud;
			_url += '/delete/' + _id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this2.$store.commit('ItIsMe', true);

					_this2.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this2.canShowButton = true;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this2.requestData();

							return;
						}

						_this2.$emit('error', _this2.formatRequestError(resPost));
					}, function (resPost) {
						_this2.canShowButton = true;

						_this2.$emit('error', _this2.formatRequestError(resPost));
					});

					return;
				}

				_this2.canShowButton = true;

				_this2.$emit('error', _this2.formatRequestError(resGet));
			}, function (resGet) {
				_this2.canShowButton = true;
				_this2.$emit('error', _this2.formatRequestError(resGet));
			});
		},
		deleteInnerForms: function deleteInnerForms() {
			var _this3 = this;

			if (!this.isInnerForms) return;
			if (!this.canShowButton) return;

			this.innerFormErrorMessage = '';

			if (!this.Access) {
				this.innerFormErrorMessage = 'main/access_denied';
				return;
			}
			if (!this.isAccess(this.crud + '/delete')) {
				this.innerFormErrorMessage = 'main/access_denied';
				return;
			}

			var _id = this.deleteId;
			if (!_id) {
				this.innerFormErrorMessage = 'main/object_id';
				return;
			}

			this.canShowButton = false;

			var _url = this.APIServerUrl + '/';
			if (this.crud === 'dns-records') _url += 'dns';else _url += this.crud;
			_url += '/delete/' + _id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this3.$store.commit('ItIsMe', true);

					_this3.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this3.canShowButton = true;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this3.requestData(function () {
								_this3.$emit('containerClass', 'wide');
								_this3.currentMode = 'list';
								_this3.$emit('refresh');
							});

							return;
						}

						_this3.innerFormErrorMessage = _this3.formatRequestError(resPost);
					}, function (resPost) {
						_this3.canShowButton = true;

						_this3.innerFormErrorMessage = _this3.formatRequestError(resPost);
					});

					return;
				}

				_this3.canShowButton = true;

				_this3.innerFormErrorMessage = _this3.formatRequestError(resGet);
			}, function (resGet) {
				_this3.canShowButton = true;
				_this3.innerFormErrorMessage = _this3.formatRequestError(resGet);
			});
		},
		canAction: function canAction(action, row) {
			if (!this.Access) return false;

			if (!this.isAccess(this.crud + '/' + action)) return false;

			var _act = 'can_' + action;
			if (!(_act in row)) return true;

			return row[_act];
		},
		buttonClicked: function buttonClicked(e) {
			this.$store.commit('tableCurrentPage', this.page);

			if (this.canShowButton) return;

			e.preventDefault();
		},
		setPageSize: function setPageSize(size) {
			var _this4 = this;

			if (size === this.Data.pageSize) return;

			if (this.Config.pageSizes.indexOf(size) === -1) return;

			var _params = {
				'additional': 'setPageSize',
				'size': size,
				'dontAbort': true
			};
			this.forms_Get('/user/index', _params, function (data) {
				if (!data || data['status'] !== 'ok') _this4.$emit('error', _this4.localeFtc('register/error'));
				_this4.requestData();
			}, function () {
				return _this4.requestData();
			});
		},
		setCurrentPage: function setCurrentPage(page) {
			if (!page || !this.page || page === this.page) return;
			if (page > this.lastPage) return;
			if (this.paginationPages.length <= 1) return;

			this.page = page;
			this.requestData();
		},
		setFastSearchValue: function setFastSearchValue(value) {
			this.fastSearchValue = value;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-set-text-field-value', {
					'name': 'fastSearch',
					'value': value
				});
			}, 100);
		},
		fastSearchEvent: function fastSearchEvent(text) {
			if (text === undefined || text === null || text === '') {
				this.setFastSearchValue('');
				this.requestData();
				return;
			}

			this.setFastSearchValue(text);

			var _canRequest = false;

			if (this.$store.state.accountGlobalFilter === true) {
				_canRequest = true;
			} else {
				if (this.$store.state.user_type !== 'admin') {
					if (String(text).length >= 2) _canRequest = true;
				} else {
					if (String(text).length >= 3) _canRequest = true;
				}
			}

			if (_canRequest) this.requestData();
		},
		sortTable: function sortTable(field) {
			if (this.sortedColumn === false) this.sortedColumn = '-' + field;else if (this.sortedColumn === '+' + field || this.sortedColumn === field) this.sortedColumn = '-' + field;else if (this.sortedColumn === '-' + field) this.sortedColumn = '+' + field;else this.sortedColumn = '-' + field;

			this.requestData();
		},
		cellClass: function cellClass(field) {
			var _class = '';
			var _sortedCell = false;

			if (this.sortedColumn) {
				_sortedCell = this.sortedColumn.indexOf(field) >= 0;
			} else {
					if (this.Data && this.Data.defaultSort) _sortedCell = this.Data.defaultSort.indexOf(field) >= 0;
				}

			if (_sortedCell) _class = 'w5-table-cell-sorted';

			return _class;
		},
		isVisibleField: function isVisibleField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		countVisibleFieldsInRow: function countVisibleFieldsInRow(row) {
			var _answer = 0;

			row.forEach(function (item) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer++;
				}
			});

			return _answer;
		},
		fieldChanged: function fieldChanged(field) {
			this.showif();
		},
		showif: function showif() {
			var _rows = this.innerFormData['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg.exec(_expr) !== null) {
												_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
											} else {
												_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		onFocus: function onFocus(field) {
			field['_errMsg'] = '';
		},
		onBlur: function onBlur(field) {
			if (this.isFormSubmited) return;

			this.verifyField(field);
		},
		onEnterKeyDown: function onEnterKeyDown(e) {
			if (e) e.preventDefault();
			this.submitInnerForm(e);
		},
		verifyField: function verifyField(field) {
			var _this5 = this;

			field['_errMsg'] = '';

			if (field.value === undefined || field.value === null || String(field.value) === '') return;

			if (field.fake === true) return;

			if (!this.localValidation(field)) return;

			var _obj = {};
			var o = void 0;
			if (field.validate_with) {
				var _v = field.validate_with;

				if ((typeof _v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_v)) === 'object' && Array.isArray(_v) && _v.length) {
					for (var _i in _v) {
						o = this.findField(_v[_i]);

						if (o && (o.value === undefined || o.value === null || String(o.value) === '')) {
							if (o.type === 'boolean') _obj[_v[_i]] = 0;else return;
						}
						if (o && o.value) _obj[_v[_i]] = o.value;
						if (o && o.type === 'boolean') _obj[_v[_i]] = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
					}
				} else if ((typeof _v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_v)) === 'object') {
					for (var _i2 in _v) {
						if (_v.hasOwnProperty(_i2)) {
							o = this.findField(_v[_i2]);

							if (o && (o.value === undefined || o.value === null || String(o.value) === '')) {
								if (o.type === 'boolean') _obj[_v[_i2]] = 0;else return;
							}
							if (o && o.value) _obj[_v[_i2]] = o.value;
							if (o && o.type === 'boolean') _obj[_v[_i2]] = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
						}
					}
				} else {
					o = this.findField(_v);

					if (o && (o.value === undefined || o.value === null || String(o.value) === '')) return;
					if (o && o.value) _obj[_v] = o.value;
					if (o && o.type === 'boolean') _obj[_v] = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
				}
			}

			var _url = this.APIServerUrl + (this.currentMode === 'create' ? this.urlCreate : this.urlUpdate + this.updatedRowId);

			this.verifyRequestsHandlers = [];

			this.forms_verifyRequest(_url, {
				'field': field['_field_name'],
				'value': field['value'],
				'data': _obj
			}, function (data) {
				if (data && data['fields'] && data['fields'][field['_field_name']]) {
					var _msg = data['fields'][field['_field_name']];
					if (typeof _msg === 'string') {
						field['_errMsg'] = _msg;
						__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
					} else if ((typeof _msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_msg)) === 'object') {
						var _txt = '';
						for (var k in _msg) {
							if (_txt === '') _txt = _msg[k];else _txt += ' <br> ' + _msg[k];
						}field['_errMsg'] = _txt;
						__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
					}
				}
			}, function (request) {
				_this5.verifyRequestsHandlers.push(request);
			});
		},
		localValidation: function localValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					return false;
				}

				if (v === String(r)) return true;

				field['_errMsg'] = 'validators/error_int';
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v2 = String(field.value).trim();

				_v2 = _v2.replace(/ /g, '');

				var _r = parseFloat(_v2);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				return false;
			}

			return true;
		},
		blockFormButton: function blockFormButton() {
			if (this.buttonBlock > 0) return;
			this.buttonBlock++;
		},
		unblockFormButton: function unblockFormButton() {
			this.buttonBlock--;
			if (this.buttonBlock < 0) this.buttonBlock = 0;
		},
		isDividerField: function isDividerField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type === 'header' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		findField: function findField(name) {
			if (!this.innerFormData || !this.innerFormData.fields) return null;

			var _field = null;
			this.innerFormData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		collectData: function collectData(rows) {
			var _this6 = this;

			var data = {};

			for (var idx in rows) {
				if (!rows[idx] || !Array.isArray(rows[idx])) continue;

				var row = rows[idx];

				var _loop2 = function _loop2(k) {
					var field = row[k];

					if (!field['_field_name']) return 'continue';

					if (field['fake'] === true) return 'continue';

					if (field['_errMsg'] && field['_visible']) {
						_this6.buttonBlock = 0;
						return {
							v: false
						};
					}

					var _val = field['value'];

					if (field['type'] === 'file' || field['type'] === 'image') {
						if (field['_deleteFile'] === true) {
							data[field['_field_name'] + '_delete'] = 1;
						}

						if (field['multifile'] !== true) {
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null;
						}
					}

					if (Array.isArray(field['value'])) {
						if (!field['value'].length) _val = null;else {
							_val = [];

							field['value'].forEach(function (item) {
								if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && item['id']) {
									_val.push(item['id']);
								} else _val.push(item);
							});
						}
					}

					if (field['required'] === true && field['_visible']) {
						if (_val === undefined || _val === null) {
							field['_errMsg'] = 'error/required_field';
							_this6.buttonBlock = 0;
							return {
								v: false
							};
						}

						if (Array.isArray(_val) && _val.length === 0) {
							field['_errMsg'] = 'error/required_field';
							_this6.buttonBlock = 0;
							return {
								v: false
							};
						}
					}

					if (!_this6.localValidation(field)) {
						_this6.buttonBlock = 0;
						return {
							v: false
						};
					}

					if (_val === undefined || _val === null) {
						if (/^\w+\[\w+\]/i.test(field['_field_name'])) data[field['_field_name']] = '';

						return 'continue';
					}

					if (field['type'] === 'boolean') _val = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(_val) ? 1 : 0;

					if (field['type'] === 'text' && (field['_field_name'].indexOf('phone') > -1 || field['_field_name'].indexOf('[fax]') > -1)) {
						if (field['validator'] === 'phone') {
							_val = String(_val).replace(/_/g, '');

							if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1) {
								_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '');
							} else {
								_val = _val.replace('-', ' ');
								_val = _val.replace('-', ' ');

								_val = _val.replace(/-/g, '');
							}
						} else {
							_val = String(_val).replace(/[()\s]/g, '');
						}
					}

					if (field['type'] === 'date' && field['format']) {
						_val = String(_val);
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val)) _val = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].FormatDateTime(_val, field['format']);
					}

					data[field['_field_name']] = _val;
				};

				for (var k in row) {
					var _ret2 = _loop2(k);

					switch (_ret2) {
						case 'continue':
							continue;

						default:
							if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
					}
				}
			}

			return data;
		},
		FD_rePack: function FD_rePack(data) {
			var k = void 0;
			var n1 = void 0;
			var n2 = void 0;
			var key1 = void 0;
			var key2 = void 0;

			for (k in data) {
				if (data.hasOwnProperty(k)) {
					n1 = k.indexOf('[');
					if (n1 < 0) continue;

					n2 = k.indexOf(']', n1);
					if (n2 < 0) continue;

					key1 = k.substr(0, n1);
					key2 = k.substring(n1 + 1, n2);

					if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

					if (!data[key1]) data[key1] = {};

					data[key1][key2] = data[k];

					delete data[k];

					data[key1] = this.FD_rePack(data[key1]);
				}
			}return data;
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		showInnerForm: function showInnerForm(type, row) {
			var _this7 = this;

			this.currentMode = type;
			this.innerFormErrorMessage = '';
			this.updatedRowId = '';

			if (type === 'update' && (!row || !row[this.idColumns])) return;

			var _url = '';
			if (type === 'create') _url = this.urlCreate;else if (type === 'update') {
				this.updatedRowId = row[this.idColumns];
				_url = this.urlUpdate + this.updatedRowId;
			}

			this.$store.commit('needShowLoader', true);

			this.forms_Get(_url, false, function (data) {
				_this7.innerFormData = _this7.parseFormData(data);
				if (_this7.innerFormData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this7.innerFormData) === 'object') {
					if (_this7.inModal && _this7.innerFormData.title) {
						_this7.$emit('title', _this7.innerFormData.title);
					}

					_this7.innerFormData.csrf = data._csrf;
				}
			}, function () {
				_this7.$store.commit('needShowLoader', true);

				var _errMsg = _this7.localeFtc('error/http_error');
				if (_this7.form_ErrorMessage) _errMsg = _this7.form_ErrorMessage;

				_this7.innerFormErrorMessage = _errMsg;
			});
		},
		submitInnerForm: function submitInnerForm(e) {
			var _this8 = this;

			this.innerFormErrorMessage = '';

			var _rows = this.innerFormData['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				this.innerFormErrorMessage = 'error/app_internal';
				this.buttonBlock = 0;
				return;
			}

			var _data = this.collectData(_rows);

			if (_data === false) {
				return;
			}

			this.$store.commit('needShowLoader', true);

			if (this.buttonBlock <= 0) this.buttonBlock = 1;

			var _url = '';
			if (this.currentMode === 'create') _url = this.urlCreate;else if (this.currentMode === 'update') {
				_url = this.urlUpdate + this.updatedRowId;
			}

			_data = this.FD_rePack(_data);

			var _post = {
				'_csrf': this.innerFormData.csrf
			};
			_post[this.innerFormData.model] = _data;

			this.FD = new FormData();
			this.FD_count = 0;
			this.FD_prepare(_post);

			if (this.verifyRequestsHandlers && this.verifyRequestsHandlers.length) {
				this.verifyRequestsHandlers.forEach(function (item) {
					if (item && item.abort) item.abort();
				});

				this.verifyRequestsHandlers = [];
			}

			this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(function (resPost) {
				_this8.$store.commit('needShowLoader', false);

				var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this8.requestData(function () {
						_this8.buttonBlock = 0;
						_this8.currentMode = 'list';
						_this8.$emit('refresh');
					});
					return;
				}

				if (_dt && _dt['status'] === 'error' && _dt['fields']) {
					var _txtError = '';

					for (var k in _dt['fields']) {
						if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
							var _fld = _this8.findField(k);

							if (_fld) {
								_fld['_errMsg'] = _this8.localeFtc(_dt['fields'][k].join(' <br> '));
								__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
							} else {
								var _m = k.match(/^params\[(.*)\]$/i);
								if (_m && _m.length && _m[1]) {
									_txtError += String(_m[1]).toUpperCase() + ': ' + _this8.localeFtc(_dt['fields'][k].join(' <br> '));
								} else _txtError += _this8.localeFtc(_dt['fields'][k].join(' <br> '));
							}
						}
					}
					if (_txtError) _this8.innerFormErrorMessage = _txtError;

					_this8.buttonBlock = 0;
					return;
				}

				_this8.innerFormErrorMessage = _this8.formatRequestError(resPost);
				_this8.buttonBlock = 0;
			}, function (resPost) {
				_this8.$store.commit('needShowLoader', false);

				_this8.innerFormErrorMessage = _this8.formatRequestError(resPost);
				_this8.buttonBlock = 0;
			});
		}
	},

	watch: {
		'access': function access(value) {
			this.Access = value;
		},
		'currentMode': function currentMode(value) {
			this.$emit('currentMode', value);
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_4__components_elements_formfield___default.a
	}

});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentMode == 'list') ? _c('div', {
    staticClass: "table-component-root"
  }, [(_vm.Data) ? _c('div', {
    staticClass: "table-wrapper",
    class: {
      'inner-forms': _vm.isInnerForms
    }
  }, [(!_vm.isInnerForms) ? _c('h4', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Data.title)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('Field', {
    ref: "fastSearch",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "fastSearch",
      "Field": {
        _field_name: 'fastSearch',
        type: 'text',
        title: 'main/all_fields_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true,
      "fieldInModal": _vm.inModal
    },
    on: {
      "event_ClearButtonClicked": _vm.fastSearchEvent,
      "fastSearchInput": _vm.fastSearchEvent
    },
    model: {
      value: (_vm.fastSearchValue),
      callback: function($$v) {
        _vm.fastSearchValue = $$v
      },
      expression: "fastSearchValue"
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "!click": function($event) {
        return _vm.buttonClicked($event)
      }
    }
  }, [(_vm.isInnerForms && _vm.urlCreate) ? [_c('button', {
    staticClass: "btn btn-submit",
    attrs: {
      "title": _vm._f("ftc")('main/create')
    },
    on: {
      "click": function($event) {
        return _vm.showInnerForm('create')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v(" "), (_vm.createButtonTitle) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.createButtonTitle)))] : [_vm._v(_vm._s(_vm._f("ftc")('dns/create_title')))]], 2)] : [(_vm.urlCreate) ? _c('router-link', {
    staticClass: "btn btn-submit font-weight-400",
    attrs: {
      "disabled": !_vm.canShowButton,
      "title": _vm._f("ftc")('main/create'),
      "to": _vm.urlCreate
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v(" "), (_vm.createButtonTitle) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.createButtonTitle)))] : [_vm._v(_vm._s(_vm._f("ftc")('dns/create_title')))]], 2) : _vm._e()]], 2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.Data.order) ? _c('table', {
    staticClass: "table-component"
  }, [_c('thead', [(_vm.Rows && _vm.Rows.length) ? _c('tr', [_vm._l((_vm.Data.order), function(column, cIdx) {
    return (_vm.columns[column]) ? _c('th', {
      key: cIdx,
      style: (_vm.columns[column] && _vm.columns[column].style ? _vm.columns[column].style : null)
    }, [_c('span', {
      staticClass: "w5-column-sort",
      on: {
        "click": function($event) {
          return _vm.sortTable(column)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(column === 'dns_priority' ? '' : _vm.ColumnsHeaders[column])))])]) : _vm._e()
  }), _vm._v(" "), _c('th', {
    staticClass: "column-oper"
  })], 2) : _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": Object.keys(_vm.columns).length + 1
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.Rows), function(row) {
    return _c('tr', {
      key: 'row-' + row[_vm.idColumns]
    }, [_vm._l((_vm.Data.order), function(column, cIdx) {
      return (_vm.columns[column]) ? _c('td', {
        key: cIdx,
        class: _vm.cellClass(column),
        attrs: {
          "aria-label": _vm._f("ftc")(_vm.ColumnsHeaders[column])
        }
      }, [_c('span', {
        staticClass: "w5-table-cell"
      }, [_c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }]
      }, [_vm._v(_vm._s(_vm.cellValue(column, _vm.columns[column], row)))])])]) : _vm._e()
    }), _vm._v(" "), _c('td', [_c('span', {
      on: {
        "!click": function($event) {
          return _vm.buttonClicked($event)
        }
      }
    }, [(_vm.isInnerForms && _vm.urlUpdate) ? [(_vm.canAction('update', row) && _vm.canShowButton) ? _c('span', {
      attrs: {
        "title": _vm._f("ftc")('main/edit')
      },
      on: {
        "click": function($event) {
          return _vm.showInnerForm('update', row)
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "pencil-alt"
      }
    })], 1) : _vm._e()] : [(_vm.canAction('update', row) && _vm.canShowButton) ? _c('router-link', {
      attrs: {
        "title": _vm._f("ftc")('main/edit'),
        "to": '/' + _vm.crud + '/update/' + row[_vm.idColumns]
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "pencil-alt"
      }
    })], 1) : _vm._e()]], 2), _vm._v(" "), (_vm.canAction('delete', row) && _vm.canShowButton) ? _c('font-awesome-icon', {
      attrs: {
        "title": _vm._f("ftc")('main/delete'),
        "icon": "trash-alt"
      },
      on: {
        "click": function () { return _vm.askForDelete(row); }
      }
    }) : _vm._e()], 1)], 2)
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Rows && _vm.Rows.length === 0),
      expression: "Rows && Rows.length === 0"
    }]
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": Object.keys(_vm.columns).length + 1
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.Rows && _vm.Rows.length) ? _c('div', {
    staticClass: "margin-15-0"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_total')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80"
  }, [_vm._v(_vm._s(_vm.Data.totalCount))]), _vm._v(" "), _c('span', {
    staticClass: "widget-page-size"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_size')) + ": ")]), _vm._v(" "), _vm._l((_vm.Config.pageSizes), function(size, sIdx) {
    return _c('span', {
      key: sIdx,
      staticClass: "font-size-80",
      class: {
        'w5-link': size !== _vm.Data.pageSize, 'font-weight-500': size === _vm.Data.pageSize
      },
      on: {
        "click": function($event) {
          return _vm.setPageSize(size)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t " + _vm._s(size) + " \n\t\t\t\t")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.Rows && _vm.Rows.length && _vm.paginationPages.length > 0) ? _c('div', [_c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.paginationPages), function(pg, idx) {
    return _c('li', {
      key: 'li-' + idx
    }, [_c('span', {
      class: {
        'first': idx === 0, 'active': pg == _vm.page, 'last': idx === _vm.paginationPages.length - 1
      },
      on: {
        "click": function () { return _vm.setCurrentPage(pg); }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(pg) + "\n\t\t\t\t\t")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.deleteModalStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))])])])])])])], 1) : _c('div', [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorGotData),
      expression: "errorGotData"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.errorGotData = null
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorGotData)),
      expression: "localeFtc(errorGotData)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])])], 1)]) : (_vm.currentMode == 'create' || _vm.currentMode == 'update') ? _c('div', {
    staticClass: "table-component-root"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.innerFormErrorMessage !== ''),
      expression: "innerFormErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.innerFormErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.innerFormErrorMessage)),
      expression: "localeFtc(innerFormErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.innerFormData && _vm.innerFormData.fields) ? _c('form', {
    staticClass: "w5-from",
    class: {
      'form-with-divider': _vm.isFormWithDivider
    },
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.innerFormData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row),
          'divider-field': _vm.isDividerField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "countVisibleFieldsInRow": _vm.countVisibleFieldsInRow(row),
          "objID": _vm.IDColumn,
          "crud": _vm.crud,
          "action": _vm.currentMode,
          "Field": field,
          "fieldInModal": _vm.inModal
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          },
          "blur": function($event) {
            return _vm.onBlur(field)
          },
          "focus": function($event) {
            return _vm.onFocus(field)
          },
          "blockFormButton": _vm.blockFormButton,
          "unblockFormButton": _vm.unblockFormButton,
          "enterKeyDown": _vm.onEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field form-button",
    class: {
      'margin-top-30': _vm.isFormWithDivider
    }
  }, [_c('button', {
    ref: "cancel_button",
    staticClass: "btn btn-default",
    class: {
      hidden: _vm.form_Loading
    },
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.closeParentModal
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/cancel')) + "\n\t\t\t")]), _vm._v(" "), _c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-primary",
    class: {
      hidden: _vm.form_Loading
    },
    staticStyle: {
      "width": "30%",
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.submitInnerForm
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.currentMode === 'update' ? 'main/save' : 'main/create')) + "\n\t\t\t")])])], 2)]) : _vm._e()], 1) : (_vm.currentMode == 'delete') ? _c('div', [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.innerFormErrorMessage !== ''),
      expression: "innerFormErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.innerFormErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.innerFormErrorMessage)),
      expression: "localeFtc(innerFormErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-del-row"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": !_vm.canShowButton
    },
    on: {
      "click": _vm.deleteInnerForms
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-ip-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.reserveIpProcessing
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/reserve_ip')) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "5px"
    }
  })])]), _vm._v(" "), [_c('h4', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/ip4_count')))]), _vm._v(" "), (_vm.Status === 'active') ? _c('div', {
    staticClass: "ip-count-info"
  }, [_c('div', {
    staticClass: "ip-count-info-ip"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.countIP4),
      expression: "countIP4"
    }],
    staticClass: "ip-count-info-ip-item"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.costIP4),
      expression: "costIP4"
    }],
    staticClass: "ip-count-info-ip-item"
  })])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w5-ip-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-ip-table-th-0"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/ippool')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/host')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-2"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/gateway')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-3"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/netmask')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-4"
  })])]), _vm._v(" "), (_vm.ip4 && _vm.ip4['rows'] && _vm.ip4['rows'].length) ? _c('tbody', _vm._l((_vm.ip4['rows']), function(ip4, idx) {
    return _c('tr', {
      key: 'ip4-' + ip4['id'],
      class: {
        'w5-list-selected-row': ip4['selected'] === true
      }
    }, [_c('td', {
      class: {
        'color-red': ip4['status'] !== 'active' || ip4['status_text']
      },
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/ippool')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['address']))])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/host')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_c('span', {
      staticClass: "w5-modal-link",
      on: {
        "click": function($event) {
          return _vm.changeHost(ip4, '4')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(ip4['host'] ? ip4['host'] : 'main/create ipptrpool/ipptrpool')))])])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/gateway')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['gateway']))])]), _vm._v(" "), _c('td', {
      style: (ip4['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/netmask')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip4['netmask']))])]), _vm._v(" "), _c('td', [(_vm.Status === 'active' && !ip4['status_text'] && ip4['status'] === 'active') ? _c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.configOpersIp4,
        "row": ip4,
        "index": idx,
        "crud": "service"
      },
      on: {
        "action": _vm.actionOperButton
      }
    }) : _vm._e()], 1)])
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ip4['max'] && _vm.ip4['max'] > 0),
      expression: "ip4['max'] && ip4['max'] > 0"
    }],
    staticClass: "btn btn-submit margin-top-15 font-weight-300",
    attrs: {
      "disabled": !_vm.Access || !_vm.ipInfo || _vm.activeProcess ? 'disabled' : false
    },
    on: {
      "click": function($event) {
        return _vm.buyIP('4')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order service/ip4_count')))])], _vm._v(" "), [_c('div', {
    staticStyle: {
      "height": "60px"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/ip6_count')))]), _vm._v(" "), (_vm.Status === 'active') ? _c('div', {
    staticClass: "ip-count-info"
  }, [_c('div', {
    staticClass: "ip-count-info-ip"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.countIP6),
      expression: "countIP6"
    }],
    staticClass: "ip-count-info-ip-item"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.costIP6),
      expression: "costIP6"
    }],
    staticClass: "ip-count-info-ip-item"
  })])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w5-ip-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-ip-table-th-0"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/ippool')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/host')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-2"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/gateway')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-3"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ippool/netmask')))])]), _vm._v(" "), _c('th', {
    staticClass: "w5-ip-table-th-4"
  })])]), _vm._v(" "), (_vm.ip6 && _vm.ip6['rows'] && _vm.ip6['rows'].length) ? _c('tbody', _vm._l((_vm.ip6['rows']), function(ip6, idx) {
    return _c('tr', {
      key: 'ip6-' + ip6['id'],
      class: {
        'w5-list-selected-row': ip6['selected'] === true
      }
    }, [_c('td', {
      class: {
        'color-red': ip6['status'] !== 'active' || ip6['status_text']
      },
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/ippool')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['address']))])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/host')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_c('span', {
      staticClass: "w5-modal-link",
      on: {
        "click": function($event) {
          return _vm.changeHost(ip6, '6')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(ip6['host'] ? ip6['host'] : 'main/create ipptrpool/ipptrpool')))])])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/gateway')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['gateway']))])]), _vm._v(" "), _c('td', {
      style: (ip6['can_delete'] === false ? 'font-weight: 500' : false),
      attrs: {
        "aria-label": _vm._f("ftc")('ippool/netmask')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v(_vm._s(ip6['netmask']))])]), _vm._v(" "), _c('td', [(_vm.Status === 'active' && !ip6['status_text'] && ip6['status'] === 'active') ? _c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.configOpersIp6,
        "row": ip6,
        "index": idx,
        "crud": "service"
      },
      on: {
        "action": _vm.actionOperButton
      }
    }) : _vm._e()], 1)])
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ip6['max'] && _vm.ip6['max'] > 0),
      expression: "ip6['max'] && ip6['max'] > 0"
    }],
    staticClass: "btn btn-submit margin-top-15 font-weight-300",
    attrs: {
      "disabled": !_vm.Access || !_vm.ipInfo || _vm.activeProcess ? 'disabled' : false
    },
    on: {
      "click": function($event) {
        return _vm.buyIP('6')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order service/ip6_count')))])], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.deleteModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteBegin
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showHostModal) ? _c('div', {
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideHostModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: _vm.hostModalContainerClass,
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.hostModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideHostModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding-top": "0"
    }
  }, [(_vm.selectedIpId) ? _c('Table', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "crud": "ipptrpool",
      "crud-search-model": "IpPtrPoolSearch",
      "access": _vm.Access,
      "url-list": _vm.tableUrlList,
      "url-create": _vm.tableUrlCreate,
      "url-update": _vm.tableUrlUpdate,
      "columns": _vm.tableColumns,
      "inner-forms": true,
      "in-modal": true,
      "create-button-title": "ipptrpool/create_title",
      "id-columns": "ptr_id"
    },
    on: {
      "error": _vm.getError,
      "title": function (value) { return _vm.hostModalTitle = value; },
      "refresh": _vm.requestData,
      "containerClass": function (value) { return _vm.hostModalContainerClass = value; },
      "currentMode": function (value) { return _vm.hostModalCurrentMode = value; }
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBuyModal),
      expression: "showBuyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBuyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ippool/buy_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBuyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.reserveIpField,
      "removeRightPadding": true,
      "listBlockToOut": 1,
      "fieldInModal": true
    },
    model: {
      value: (_vm.reserveIpFieldValue),
      callback: function($$v) {
        _vm.reserveIpFieldValue = $$v
      },
      expression: "reserveIpFieldValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.buyBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/order ' + (_vm.buyType === '4' ? 'service/ip4_count' : 'service/ip6_count'))))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalText)),
      expression: "localeFtc(confirmModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.confirmModalDangerButton
    },
    attrs: {
      "disabled": _vm.confirmModalTimer && _vm.confirmModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmStart
    }
  }, [_vm._v(_vm._s(_vm.modalConfirmButtonTitle) + "\n\t\t\t\t\t\t")])])])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  "data-v-4087090f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabLocalIp',

	props: ['ipLocalData', 'data', 'vdsId', 'access', 'status', 'serviceStatus', 'parentError'],
	data: function data() {
		return {
			IpData: null,

			Access: false,
			Status: null,
			Error: '',
			localErrorMessage: '',

			localSwitcher: false,
			localSwitcherProcessing: false
		};
	},
	created: function created() {
		this.IpData = this.data;
		this.Access = this.access;
		this.Status = this.status;
		this.Error = this.parentError;

		this.localSwitcher = false;
		if (this.ipLocalData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.ipLocalData) === 'object' && 'value' in this.ipLocalData) this.localSwitcher = this.ipLocalData.value;
	},

	methods: {
		onSwitcherClick: function onSwitcherClick() {
			var _this = this;

			if (!this.vdsId) return;

			if (!this.Access || this.Status !== 'active') return;

			if (this.Error) return;

			if (this.localSwitcherProcessing) return;

			this.localSwitcherProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'ip_local': !_this.localSwitcher ? 1 : 0
					};

					_this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this.localSwitcherProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this.localSwitcher = !_this.localSwitcher;

							_this.$emit('successMessage', 'main/updated');
							return;
						}

						_this.localErrorMessage = _this.formatRequestError(resPost);
					}, function (resPost) {
						_this.localSwitcherProcessing = false;

						_this.localErrorMessage = _this.formatRequestError(resPost);
					});

					return;
				}

				_this.localSwitcherProcessing = false;

				_this.localErrorMessage = _this.formatRequestError(resGet);
			}, function (resGet) {
				_this.localSwitcherProcessing = false;

				_this.localErrorMessage = _this.formatRequestError(resGet);
			});
		}
	},

	watch: {
		'data': function data(_data) {
			this.IpData = _data;
		},
		'access': function access(_access) {
			this.Access = _access;
		},
		'status': function status(_status) {
			this.Status = _status;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		},
		'ipLocalData': function ipLocalData(data, oldData) {
			this.localSwitcher = false;
			if (this.ipLocalData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.ipLocalData) === 'object' && 'value' in this.ipLocalData) this.localSwitcher = this.ipLocalData.value;
		}
	}

});

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-pane-plan-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (!_vm.Access) ? [_c('div', {
    staticClass: "text-center margin-top-5"
  }, [(_vm.serviceStatus && (_vm.serviceStatus.loader || _vm.serviceStatus.timer)) ? _c('div', {
    staticStyle: {
      "margin": "80px auto"
    }
  }, [(_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))])]) : [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]], 2)] : [(_vm.ipLocalData && 'value' in _vm.ipLocalData) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSwitcher),
      expression: "localSwitcher"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localSwitcher) ? _vm._i(_vm.localSwitcher, null) > -1 : (_vm.localSwitcher)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localSwitcher,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localSwitcher = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.localSwitcher = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.localSwitcher = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.onSwitcherClick
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('datacenter/local_net')) + "\r\n\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (_vm.IpData && _vm.IpData.ip) ? _c('div', {
    staticClass: "tab-pane-local-net"
  }, [(_vm.IpData.ip) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('ippool/ippool')) + ": ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.IpData.ip))])]) : _vm._e(), _vm._v(" "), (_vm.IpData.netmask) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('ippool/netmask')) + ": ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.IpData.netmask))])]) : _vm._e(), _vm._v(" "), (_vm.IpData.mac) ? _c('span', [_c('strong', [_vm._v("MAC: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.IpData.mac))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('datacenter/local_net')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/local_net_description')),
      expression: "localeFtc('service/local_net_description')"
    }]
  })])]], 2)])
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(584),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_formfield__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabBackup',

	props: ['active', 'vdsId', 'vdsName', 'vdsInfo', 'account', 'backup', 'backupList', 'access', 'planInfo', 'serviceStatus', 'parentError', 'dc'],

	computed: {
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		},
		costInfo: function costInfo() {
			if (!this.vdsBackupData || !this.planInfo || !('cost' in this.vdsBackupData) || !('period' in this.vdsBackupData) || !('disk' in this.planInfo)) return '';

			var _wholeCost = this.vdsBackupData['cost'];
			var _diskSize = '';
			if ('total' in this.planInfo.disk) {
				_diskSize = ' / <b>' + this.planInfo.disk.total + ' ' + this.localeFtc(this.planInfo.disk.for) + '</b>';
				_wholeCost = this.vdsBackupData['cost'];
			} else if ('value' in this.planInfo.disk) {
				_diskSize = ' / <b>' + this.planInfo.disk.value + ' ' + this.localeFtc(this.planInfo.disk.for) + '</b>';
				_wholeCost = this.vdsBackupData['cost'];
			}

			return this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b>{size}').replace('{cost}', __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].String2Money(__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(_wholeCost, 2))).replace('{period}', this.localeFtc(this.vdsBackupData['period'])).replace('{size}', _diskSize);
		},
		createScheduleEmpty: function createScheduleEmpty() {
			if (this.backupScheduleMode !== 'create') return false;

			if (!this.backupScheduleForm || !this.backupScheduleForm.fields || !this.backupScheduleForm.fields.length) return false;

			var _result = true;
			this.backupScheduleForm.fields.some(function (row) {
				if (row && row.length) {
					var _found = row.some(function (field) {
						if (field && field.type === 'boolean' && field.value) {
							return true;
						}
					});

					if (_found) {
						_result = false;
						return true;
					}
				}
			});

			return _result;
		}
	},
	data: function data() {
		return {
			localErrorMessage: '',

			rawData: null,

			cacheData: null,

			Access: false,
			Error: '',

			showCreateModal: false,
			createModalText: '',

			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteID: null,

			showRestoreModal: false,
			restoreID: null,
			restoreBodyTextModal: '',

			showRenameBackupDialog: false,
			renameBackupId: false,
			renameBackupValue: '',
			renameBackupField: {
				required: true,
				type: 'text',
				title: 'service/backup',
				_field_name: 'backupName',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},

			showDownloadBackupModal: false,
			downloadBackupID: null,

			createTimer: null,

			FD: false,
			FD_count: 0,

			backupScheduleTableTitle: '',
			backupScheduleRows: [],
			backupScheduleMode: 'create',
			showBackupScheduleModal: false,
			backupScheduleForm: null,
			backupScheduleHas: null,

			cssUl: false,

			vdsBackupData: null
		};
	},
	created: function created() {
		this.Access = this.access;
		this.Error = this.parentError;
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);

		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		if (this.createTimer) {
			clearTimeout(this.createTimer);
			this.createTimer = null;
		}

		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);

		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
	},

	methods: {
		thereAreItems: function thereAreItems(row) {
			var _isRestore = this.Access && !row['Status']['loader'] && !row['Status']['timer'] && this.isInField(row['id']);
			var _isRemove = this.Access && !row['Status']['loader'] && !row['Status']['timer'];

			return _isRestore || _isRemove;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) {
				e.preventDefault();

				this.hideCreateModal();
				this.hideBackupScheduleModal();
				this.hideDeleteModal();
				this.hideRestoreModal();
				this.hideRenameBackupDialog();
				this.hideDownloadBackupModal();

				this.clickHandler();
			}
		},
		clickHandler: function clickHandler(e) {
			if (this.cacheData && this.cacheData.length) this.cacheData.forEach(function (item) {
				return item['__btnShow'] = false;
			});
		},
		requestData: function requestData() {
			this.requestBackupList();

			this.$emit('updateData', false);
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			if (!this.active) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== 'service') return;

			var _id = _parts[2];

			if (!_id) return;

			var _isVds = String(this.vdsId) === String(_id);

			var _found = false;
			if (this.cacheData && Array.isArray(this.cacheData) && this.cacheData.length) {
				_found = this.cacheData.some(function (item) {
					if (String(item['id']) === String(_id)) return true;
				});
			}

			if (_isVds || _found) this.requestData();
		},
		Status: function Status(row) {
			var _field = 'status';
			var _extField = 'status_text';

			var _answer = {
				'loader': false,
				'timer': false,
				'status': ''
			};

			if (row[_extField]) {
				var _extValue = row[_extField].replace('request/status_processing', '').trim();

				_answer['status'] = this.localeFtc(_extValue).toLowerCase();
				_answer['loader'] = true;

				if (_extValue.indexOf('request/status_queue') > -1) {
					_extValue = _extValue.replace('request/status_queue', '').trim();
					_answer['status'] = this.localeFtc(_extValue).toLowerCase();
					_answer['loader'] = false;
					_answer['timer'] = true;
				}

				return _answer;
			}

			if (row[_field] === null || row[_field] === undefined) {
				_answer['status'] = 'unknown';
				return _answer;
			}

			var _status = row[_field];
			if (_status.indexOf('service/status_') !== 0) _status = 'service/status_' + _status;

			_answer['status'] = this.localeFtc(_status).toLowerCase();

			if (row[_field] === 'processing') _answer['loader'] = true;

			return _answer;
		},
		isInField: function isInField(id) {
			if (!this.cacheData || !this.cacheData.length) return false;


			return this.cacheData.some(function (item) {
				return Boolean(String(item['id']) === String(id) && item.active);
			});
		},
		isVisibleField: function isVisibleField(row) {
			if (!row) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		fieldChanged: function fieldChanged(field) {
			this.showif();
		},
		findField: function findField(name) {
			if (!this.backupScheduleForm.fields) return null;

			var _field = null;
			this.backupScheduleForm.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		showif: function showif() {
			var _rows = this.backupScheduleForm['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg.exec(_expr) !== null) {
												_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
											} else {
												_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		localValidation: function localValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					return false;
				}

				if (v === String(r)) return true;

				field['_errMsg'] = 'validators/error_int';
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v = String(field.value).trim();

				_v = _v.replace(/ /g, '');

				var _r = parseFloat(_v);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				return false;
			}

			return true;
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		getVdsBackupData: function getVdsBackupData() {
			var _this = this;

			this.vdsBackupData = null;
			if (!this.vdsId) return;

			if (this.vdsInfo && this.vdsInfo.service && this.vdsInfo.service.backup && 'cost' in this.vdsInfo.service.backup) {
				this.vdsBackupData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.vdsInfo.service.backup);
				return;
			}

			var _url = this.APIServerUrl + '/service/create?search=service_backup';
			if (this.$store.state.user_type === 'admin' && this.account && this.account.account_id && 'value' in this.account.account_id) {
				_url += '&account_id=' + this.account.account_id.value;
			}

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length) {
					for (var i = 0; i < _dt['result'].length; i++) {
						if (String(_dt['result'][i]['id']) === String(_this.vdsId)) {
							_this.vdsBackupData = _dt['result'][i];
							break;
						}
					}
				}
			}).catch(function () {});
		},
		requestBackupList: function requestBackupList() {
			var _this2 = this;

			if (!this.vdsId) return;

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?search=backup';

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this2.cacheData = [];

					if (_this2.active && _dt['result'] && _dt['result'].length) {
						var newList = _dt['result'];
						for (var i = 0; i < newList.length; i++) {
							if (!newList[i] || newList[i].enable !== true) {
								continue;
							}

							var _row = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, newList[i]);

							_row['Status'] = _this2.Status(newList[i]);

							_row['__btnShow'] = false;

							_this2.cacheData.push(_row);
						}

						_this2.cacheData.sort(__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].naturalCompareObjectField('created', 0));
					}
				}
			}).catch(function () {});
		},
		refreshBackupSchedule: function refreshBackupSchedule() {
			if (!this.vdsId) return;

			if (this.vdsInfo && this.vdsInfo.service && this.vdsInfo.service.service_data && this.vdsInfo.service.service_data.value && 'has_schedule' in this.vdsInfo.service.service_data.value) {
				this.backupScheduleHas = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].normalizeBooleanValue(this.vdsInfo.service.service_data.value.has_schedule);
			}
		},
		requestBackupSchedule: function requestBackupSchedule() {
			this.$emit('requestData');
		},
		deleteBackupSchedule: function deleteBackupSchedule() {
			var _this3 = this;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';
			this.deleteModalText = '';
			this.deleteID = null;

			if (!this.vdsId) {
				this.localErrorMessage = 'error/app_internal';
				return;
			}

			if (!this.isAccess('backupschedule/delete')) {
				this.localErrorMessage = 'main/access_denied';
				return;
			}

			this.deleteModalText = this.localeFtc('main/delete') + ' ' + this.localeFtc('schedule/backup').toLowerCase() + '?';

			this.deleteID = 'schedule';

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this3.deleteModalTimer--;
				if (_this3.deleteModalTimer <= 0) {
					clearInterval(_this3.deleteModalTimerHandle);
					_this3.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		deleteBackupScheduleBegin: function deleteBackupScheduleBegin() {
			var _this4 = this;

			var _url = '/backupschedule/delete/' + this.vdsId;
			this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) return _dt['_csrf'];

				throw new Error(_dt);
			}).then(function (csrf) {
				_this4.$http.post(_this4.APIServerUrl + _url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ _csrf: csrf })).then(function (resPost) {
					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok') {
						_this4.requestBackupSchedule();
						return;
					}

					_this4.localErrorMessage = _this4.formatRequestError(resPost);
				}, function (resPost) {
					_this4.localErrorMessage = _this4.formatRequestError(resPost);
				});
			}).catch(function (error) {
				_this4.localErrorMessage = _this4.formatRequestError(error);
			});
		},
		hideBackupScheduleModal: function hideBackupScheduleModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBackupScheduleModal = false;
			this.hideModalMask();
		},
		updateBackupSchedule: function updateBackupSchedule() {
			var _this5 = this;

			if (!this.Access || this.Error) return;
			if (!this.vdsId || !this.isAccess('backupschedule/update')) return;

			this.backupScheduleMode = 'update';
			this.backupScheduleForm = null;
			var _url = this.APIServerUrl + '/backupschedule/update/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this5.backupScheduleForm = _this5.parseFormData(_dt);
					_this5.$nextTick(function () {
						_this5.showif();
					});

					__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this5.showBackupScheduleModal = true;
				}
			}, function (resGet) {
				_this5.localErrorMessage = _this5.formatRequestError(resGet);
			});
		},
		createBackupSchedule: function createBackupSchedule() {
			var _this6 = this;

			if (!this.Access || this.Error) return;
			if (!this.vdsId || !this.isAccess('backupschedule/create')) return;

			this.backupScheduleForm = null;
			this.backupScheduleMode = 'create';
			var _url = this.APIServerUrl + '/backupschedule/create/' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this6.backupScheduleForm = _this6.parseFormData(_dt);
					_this6.$nextTick(function () {
						_this6.showif();
					});

					__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this6.showBackupScheduleModal = true;
				}
			}, function (resGet) {
				_this6.localErrorMessage = _this6.formatRequestError(resGet);
			});
		},
		createBackupScheduleBegin: function createBackupScheduleBegin() {
			var _this7 = this;

			if (!this.Access || this.Error) return;

			if (this.createScheduleEmpty) return;

			this.localErrorMessage = '';

			if (!this.vdsId) {
				this.localErrorMessage = 'error/app_internal';
				this.hideBackupScheduleModal();
				return;
			}

			var _access = true;
			if (this.backupScheduleMode === 'create') _access = this.isAccess('backupschedule/create');else _access = this.isAccess('backupschedule/update');

			if (!_access) {
				this.localErrorMessage = 'main/access_denied';
				this.hideBackupScheduleModal();
				return;
			}

			var _rows = this.backupScheduleForm['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				this.localErrorMessage = 'error/app_internal';
				this.hideBackupScheduleModal();
				return;
			}

			var _data = this.collectFormData(_rows, this.localValidation);

			if (_data === false) return;

			this.hideBackupScheduleModal();

			var _url = '/backupschedule/' + this.backupScheduleMode + '/' + this.vdsId;
			this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) {
					return { csrf: _dt['_csrf'], model: _dt['model'] };
				}

				throw new Error(_dt);
			}).then(function (getDate) {
				_data = _this7.FormDataRePack(_data);

				var _post = {
					'_csrf': getDate.csrf
				};
				_post[getDate.model] = _data;

				_this7.FD = new FormData();
				_this7.FD_count = 0;
				_this7.FD_prepare(_post);

				_this7.$http.post(_this7.APIServerUrl + _url, _this7.FD_count > 0 ? _this7.FD : null).then(function (resPost) {
					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok') {
						_this7.$emit('successMessage', _this7.backupScheduleMode === 'create' ? 'schedule/created' : 'schedule/updated');
						_this7.backupScheduleHas = null;
						_this7.requestBackupSchedule();
						return;
					}

					_this7.localErrorMessage = _this7.formatRequestError(resPost);
				}, function (resPost) {
					_this7.localErrorMessage = _this7.formatRequestError(resPost);
				});
			}).catch(function (error) {
				_this7.localErrorMessage = _this7.formatRequestError(error);
			});
		},
		createBackup: function createBackup() {
			if (!this.Access || !this.vdsBackupData || this.Error) return;

			this.localErrorMessage = '';
			this.createModalText = this.localeFtc('service/creating_backup_confirm');

			if (this.vdsBackupData && this.vdsBackupData['cost'] > 0) {
				var _wholeCost = this.vdsBackupData['cost'];
				var _diskSize = '';
				if (this.planInfo && this.planInfo.disk && 'total' in this.planInfo.disk) {
					_diskSize = ' / <b>' + this.planInfo.disk.total + ' ' + this.localeFtc(this.planInfo.disk.for) + '</b>';
					_wholeCost = this.vdsBackupData['cost'];
				} else if (this.planInfo && this.planInfo.disk && 'value' in this.planInfo.disk) {
					_diskSize = ' / <b>' + this.planInfo.disk.value + ' ' + this.localeFtc(this.planInfo.disk.for) + '</b>';
					_wholeCost = this.vdsBackupData['cost'];
				}

				this.createModalText = this.localeFtc('service/creating_backup_confirm <br> service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b>{size}').replace('{cost}', this.moneyOnlyNumbers(_wholeCost)).replace('{period}', this.localeFtc(this.vdsBackupData['period'])).replace('{size}', _diskSize);
			}

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showCreateModal = true;
		},
		createBackupBegin: function createBackupBegin() {
			var _this8 = this;

			if (!this.Access || !this.vdsBackupData || this.Error) return;

			this.localErrorMessage = '';

			this.hideCreateModal();

			var _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_4_vue__["default"].Constants.SERVICE_TYPE_BACKUP_VDS;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };

					var _account = null;
					if (_this8.account && _this8.account.account_id && 'value' in _this8.account.account_id) {
						_account = _this8.account.account_id.value;
					}
					if (!_account) {
						if (_dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value']) {
							_account = _dt['fields']['account_id']['value'];
						}
					}
					if (!_account && _this8.$store.state.user_account) {
						_account = String(_this8.$store.state.user_account).replace(/[a-z]/ig, '');
					}

					_post[_dt['model']] = {
						'service_id': _this8.vdsId,
						'account_id': _account,
						'reinstall': 0
					};

					_this8.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this8.$emit('successMessage', 'service/creating_backup_begin_process');

							if (_this8.createTimer) {
								clearTimeout(_this8.createTimer);
								_this8.createTimer = null;
							}

							_this8.createTimer = setTimeout(function () {
								return _this8.requestData();
							}, 2000);

							return;
						}

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					}, function (resPost) {
						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					});

					return;
				}

				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			}, function (resGet) {
				_this8.localErrorMessage = _this8.formatRequestError(resGet);
			});
		},
		deleteBackup: function deleteBackup(id) {
			var _this9 = this;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';
			this.deleteModalText = '';
			this.deleteID = null;

			var _name = false;
			this.cacheData.some(function (item) {
				if (String(item['id']) === String(id)) {
					_name = _this9.localeFtc(item['full_name']);
					return true;
				}
			});

			if (!_name) return;

			this.deleteModalText = this.localeFtc('service/deleting_backup_confirm').replace('{name}', _name);

			this.toggleMenu('off');

			this.deleteID = id;

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this9.deleteModalTimer--;
				if (_this9.deleteModalTimer <= 0) {
					clearInterval(_this9.deleteModalTimerHandle);
					_this9.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		restoreStatus: function restoreStatus(id, status) {
			this.cacheData.some(function (item, idx, arr) {
				if (String(item['id']) === String(id)) {
					arr[idx]['Status'] = status;
					return true;
				}
			});
		},
		deleteBackupBegin: function deleteBackupBegin() {
			var _this10 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';

			if (!this.deleteID) return;

			this.hideDeleteModal();

			if (this.deleteID === 'schedule') {
				this.deleteBackupScheduleBegin();
				return;
			}

			var _oldStatus = null;

			this.cacheData.some(function (item, idx, arr) {
				if (String(item['id']) === String(_this10.deleteID)) {
					_oldStatus = item['Status'];
					arr[idx]['Status'] = { loader: true, status: _this10.localeFtc('main/deleting') };
					return true;
				}
			});

			var _url = this.APIServerUrl + '/service/delete/' + this.deleteID;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this10.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this10.$emit('successMessage', 'service/deleting_backup_begin_process');

							return;
						}

						if (_oldStatus) _this10.restoreStatus(_this10.deleteID, _oldStatus);

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					}, function (resPost) {
						if (_oldStatus) _this10.restoreStatus(_this10.deleteID, _oldStatus);

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					});

					return;
				}

				if (_oldStatus) _this10.restoreStatus(_this10.deleteID, _oldStatus);

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			}, function (resGet) {
				if (_oldStatus) _this10.restoreStatus(_this10.deleteID, _oldStatus);

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			});
		},
		restoreBackup: function restoreBackup(id) {
			var _this11 = this;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';
			this.restoreID = null;

			var backupName = '';

			this.cacheData.some(function (item) {
				if (String(item['id']) === String(id)) {
					_this11.restoreID = item['id'];
					backupName = item['full_name'];
					return true;
				}
			});

			if (!this.restoreID) return;

			this.toggleMenu('off');

			this.restoreBodyTextModal = this.localeFtc('service/restore_backup_info').replace('{server}', this.vdsName).replace('{backup}', backupName);

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRestoreModal = true;
		},
		hideRestoreModal: function hideRestoreModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRestoreModal = false;
			this.hideModalMask();
		},
		restoreBackupBegin: function restoreBackupBegin() {
			var _this12 = this;

			if (!this.Access || this.Error) return;

			if (!this.restoreID) return;

			this.localErrorMessage = '';

			this.hideRestoreModal();

			var _oldStatus = null;

			this.cacheData.some(function (item, idx, arr) {
				if (String(item['id']) === String(_this12.restoreID)) {
					_oldStatus = item['Status'];
					arr[idx]['Status'] = { loader: true, status: _this12.localeFtc('service/restore') };
					return true;
				}
			});

			var _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=setRestore&service_id=' + this.restoreID;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['status']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this12.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this12.$emit('successMessage', 'service/restore_queued');

							return;
						}

						if (_oldStatus) _this12.restoreStatus(_this12.restoreID, _oldStatus);

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					}, function (resPost) {
						if (_oldStatus) _this12.restoreStatus(_this12.restoreID, _oldStatus);

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					});

					return;
				}

				if (_oldStatus) _this12.restoreStatus(_this12.restoreID, _oldStatus);

				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			}, function (resGet) {
				if (_oldStatus) _this12.restoreStatus(_this12.restoreID, _oldStatus);

				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			});
		},
		createFromBackup: function createFromBackup(data) {
			if (!window || !window.sessionStorage || !data || !data.id) return;

			var _store = {
				service_id: data.id
			};
			if (data.account_id) _store.account_id = data.account_id;

			window.sessionStorage.setItem('create-vds-from-backup', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_store));

			this.$router.push('/vds/create');
		},
		hideDownloadBackupModal: function hideDownloadBackupModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDownloadBackupModal = false;
			this.hideModalMask();
		},
		downloadBackup: function downloadBackup(row) {
			if (row) return;

			this.localErrorMessage = '';

			var _id = row['id'];
			if (!_id) return;

			if (row['status'] !== 'active' || row['status_text']) return;

			if (!this.isAccess('service/update')) return;

			var _serviceID = parseInt(_id);
			if (isNaN(_serviceID) || _serviceID <= 0) return;
			this.downloadBackupID = _serviceID;

			this.toggleMenu('off');

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDownloadBackupModal = true;
		},
		downloadBackupProcessStart: function downloadBackupProcessStart() {
			var _this13 = this;

			this.localErrorMessage = '';

			if (!this.downloadBackupID) return;

			if (!this.isAccess('service/update')) return;

			this.hideDownloadBackupModal();

			var _url = this.APIServerUrl + '/service/update/' + this.downloadBackupID + '?additional=setDownload';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this13.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this13.$emit('successMessage', 'service/download_queued');

							_this13.requestData();
							return;
						}

						_this13.localErrorMessage = _this13.formatRequestError(resPost);
					}, function (resPost) {
						_this13.localErrorMessage = _this13.formatRequestError(resPost);
					});

					return;
				}

				_this13.localErrorMessage = _this13.formatRequestError(resGet);
			}, function (resGet) {
				_this13.localErrorMessage = _this13.formatRequestError(resGet);
			});
		},
		hideRenameBackupDialog: function hideRenameBackupDialog() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showRenameBackupDialog = false;
			this.hideModalMask();
		},
		renameBackupKeyDown: function renameBackupKeyDown(e) {
			if (e) e.preventDefault();
			this.renameBackupStart();
		},
		renameBackup: function renameBackup(data) {
			if (data) return;

			if (!data) return;

			var _id = data['id'];
			if (!_id) return;

			if (data['status'] !== 'active' || data['status_text']) return;

			this.renameBackupId = _id;
			this.renameBackupValue = data['name'];

			this.toggleMenu('off');

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showRenameBackupDialog = true;
		},
		renameBackupStart: function renameBackupStart() {
			var _this14 = this;

			if (!this.renameBackupId) return;
			if (!this.isAccess('service/update')) return;

			if (!this.renameBackupValue) {
				this.renameBackupField._errMsg = 'error/required_field';
				return;
			}

			this.hideRenameBackupDialog();

			this.localErrorMessage = '';

			var _oldStatus = null;

			this.cacheData.some(function (item, idx, arr) {
				if (String(item['id']) === String(_this14.restoreID)) {
					_oldStatus = item['Status'];
					arr[idx]['Status'] = { loader: true, status: _this14.localeFtc('service/rename_action') };
					return true;
				}
			});

			var _url = this.APIServerUrl + '/service/update/' + this.renameBackupId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'name': _this14.renameBackupValue
					};

					_this14.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this14.$emit('successMessage', 'forget/success');

							_this14.requestData();

							return;
						}

						if (_oldStatus) _this14.restoreStatus(_this14.renameBackupId, _oldStatus);

						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					}, function (resPost) {
						if (_oldStatus) _this14.restoreStatus(_this14.renameBackupId, _oldStatus);

						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					});

					return;
				}

				if (_oldStatus) _this14.restoreStatus(_this14.renameBackupId, _oldStatus);

				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			}, function (resGet) {
				if (_oldStatus) _this14.restoreStatus(_this14.renameBackupId, _oldStatus);

				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			});
		},
		hideCreateModal: function hideCreateModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showCreateModal = false;
			this.hideModalMask();
		},
		hideDeleteModal: function hideDeleteModal() {
			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		toggleMenu: function toggleMenu(row) {
			if (row === 'off') {
				this.cacheData.forEach(function (item) {
					item['__btnShow'] = false;
				});
				return;
			}

			this.cacheData.forEach(function (item) {
				if (String(item.id) === String(row.id)) item['__btnShow'] = !item['__btnShow'];else item['__btnShow'] = false;
			});

			this.UpOrDown(row['id']);
		},
		UpOrDown: function UpOrDown(id) {
			this.cssUl = false;

			var _div = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('div[data-id="' + id + '"]');
			if (!_div.length) return;

			var _ul = _div.find('ul:first');
			if (!_ul.length) return;

			var _rect = _div.offset();
			var _heightDiv = _div.height();
			var _heightUl = _ul.height();

			var _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - __WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).scrollTop();

			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px';
		}
	},

	watch: {
		'vdsInfo': {
			handler: function handler() {
				this.refreshBackupSchedule();
			},
			deep: true
		},
		'active': function active(value) {
			if (this.active) {
				__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.refreshBackupSchedule(), this.requestBackupList(), this.getVdsBackupData()]);
			}
		},
		'access': function access(_access2) {
			this.Access = _access2;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		} },

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield___default.a
	}

});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-snapshot-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-additional-info",
    staticStyle: {
      "margin-right": "0",
      "margin-top": "15px"
    }
  }, [(_vm.vdsBackupData && typeof _vm.vdsBackupData === 'object' && Object.keys(_vm.vdsBackupData).length && !Array.isArray(_vm.vdsBackupData)) ? [('max' in _vm.vdsBackupData) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/available_to_order')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.vdsBackupData.max))])]) : _vm._e(), _vm._v(" "), ('cost' in _vm.vdsBackupData) ? _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.costInfo)),
      expression: "localeFtc(costInfo)"
    }],
    staticClass: "pull-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row btn-wrapper",
    class: {
      'with-table': _vm.cacheData && _vm.cacheData.length
    }
  }, [(_vm.backupScheduleHas === true && _vm.isAccess('backupschedule/update')) ? _c('div', {
    staticClass: "btn btn-submit font-weight-300 top-btn",
    attrs: {
      "disabled": !_vm.Access || _vm.Error ? 'disabled' : false
    },
    on: {
      "click": _vm.updateBackupSchedule
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('schedule/update_title')))]) : (_vm.backupScheduleHas === false && _vm.isAccess('backupschedule/create')) ? _c('div', {
    staticClass: "btn btn-submit font-weight-300 top-btn",
    attrs: {
      "disabled": !_vm.Access || !_vm.vdsBackupData ? 'disabled' : false
    },
    on: {
      "click": _vm.createBackupSchedule
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('schedule/create_title')))]) : _c('div', {
    staticClass: "btn btn-submit font-weight-300 top-btn",
    attrs: {
      "disabled": _vm.backupScheduleHas === null ? 'disabled' : false
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit font-weight-300 top-btn",
    attrs: {
      "disabled": !_vm.Access || !_vm.vdsBackupData ? 'disabled' : false
    },
    on: {
      "click": _vm.createBackup
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/backup_create')))])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "w5-snapshot-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-snapshot-table-th--1"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('template/os')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-snapshot-table-th-0"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/backup')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-snapshot-table-th-2"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-snapshot-table-th-1"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/created')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-column-opers",
    staticStyle: {
      "width": "45px"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', [(_vm.cacheData && _vm.cacheData.length) ? _vm._l((_vm.cacheData), function(row, rowIdx) {
    return _c('tr', {
      key: rowIdx
    }, [_c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('template/os')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell text-center"
    }, [(row && row['image']) ? _c('img', {
      staticClass: "backups-small",
      attrs: {
        "src": _vm.APIServerUrl + row['image']
      }
    }) : _c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('service/service')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell",
      style: (!(_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? 'opacity: 0.5' : null)
    }, [(row['datacenter_country']) ? _c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + String(row['datacenter_country']).toLowerCase(),
      staticStyle: {
        "margin-right": "10px",
        "top": "-1px"
      }
    }) : _vm._e(), _vm._v(_vm._s(_vm._f("ftc")(row['full_name'])) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('main/status')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [(row['Status']['loader']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('img', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "src": __webpack_require__(14)
      }
    })]) : (row['Status']['timer']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('font-awesome-icon', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "icon": "clock"
      }
    })], 1) : _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "aria-label": _vm._f("ftc")('main/created')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formater_StrDateFormat(row['created'])) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [(_vm.$store.state.windowWidth <= 767) ? _c('div', {
      staticClass: "w5-opers-button-for-mobile"
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? _c('div', {
      staticClass: "w5-opers-button-curd-btn",
      attrs: {
        "title": _vm.localeFtc('main/restore server/server')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.restoreBackup(row['id'])
        }
      }
    }, [_c('font-awesome-icon', {
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "icon": "hdd"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? _c('div', {
      staticClass: "w5-opers-button-curd-btn",
      attrs: {
        "title": _vm.localeFtc('main/create server/server')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.createFromBackup(row)
        }
      }
    }, [_c('font-awesome-icon', {
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "icon": "plus"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('div', {
      staticClass: "w5-opers-button-curd-btn",
      attrs: {
        "title": _vm.localeFtc('main/delete')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteBackup(row['id'])
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "icon": "trash-alt"
      }
    })], 1) : _vm._e()]) : (_vm.$store.state.windowWidth > 767 && _vm.thereAreItems(row)) ? _c('div', {
      staticClass: "btn-group w5-opers-button",
      class: {
        'w5-opers-button-opened': row['__btnShow']
      },
      attrs: {
        "data-id": row['id']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(row)
        }
      }
    }, [_c('span', {
      staticClass: "dropdown-toggle"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "bars"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "caret"
    })], 1), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row['__btnShow']),
        expression: "row['__btnShow']"
      }],
      staticClass: "dropdown-menu",
      style: (_vm.cssUl),
      attrs: {
        "role": "menu"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.restoreBackup(row['id'])
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/restore server/server'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.createFromBackup(row)
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/create server/server'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.isInField(row['id'])) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteBackup(row['id'])
        }
      }
    }, [_c('span', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      attrs: {
        "icon": "trash-alt"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete')) + "\n\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()])]) : _vm._e()])])
  }) : _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCreateModal),
      expression: "showCreateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideCreateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/creating_backup')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideCreateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.createModalText)),
      expression: "localeFtc(createModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.createBackupBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/backup_create')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.deleteID === 'schedule' ? 'schedule/deleting' : 'service/deleting_backup')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteBackupBegin
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRestoreModal),
      expression: "showRestoreModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRestoreModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/restore')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRestoreModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.restoreBodyTextModal)),
      expression: "localeFtc(restoreBodyTextModal)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.restoreBackupBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/restore')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRenameBackupDialog),
      expression: "showRenameBackupDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/name')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "backup",
      "action": "list",
      "Field": _vm.renameBackupField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "enterKeyDown": _vm.renameBackupKeyDown,
      "focus": function($event) {
        _vm.renameBackupField._errMsg = ''
      }
    },
    model: {
      value: (_vm.renameBackupValue),
      callback: function($$v) {
        _vm.renameBackupValue = $$v
      },
      expression: "renameBackupValue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.renameBackupStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/rename_action')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownloadBackupModal),
      expression: "showDownloadBackupModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('backup/download_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('backup/download_info')),
      expression: "localeFtc('backup/download_info')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.downloadBackupProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackupScheduleModal),
      expression: "showBackupScheduleModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-form",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.backupScheduleForm && _vm.backupScheduleForm.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, _vm._l((_vm.backupScheduleForm.fields), function(row, index) {
    return _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "action": _vm.backupScheduleMode,
          "Field": field,
          "listBlockToOut": 1,
          "crud": "backupschedule"
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.createScheduleEmpty
    },
    on: {
      "click": _vm.createBackupScheduleBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_formfield__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabDisks',

	props: ['active', 'vdsId', 'vdsName', 'account', 'dc', 'access', 'serviceStatus', 'parentError'],

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		linkHint: function linkHint() {
			if (this.Config && this.Config['disks'] && this.Config['disks']['hint-link'] && this.Config['disks']['hint-link']['create']) return this.Config['disks']['hint-link']['create'];

			return false;
		},
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		},
		formModalTitle: function formModalTitle() {
			if (this.form && this.form.title) return this.form.title;
			return this.formMode === 'create' ? 'service/create_title' : 'service/update_title';
		},
		showAdditionalInfo: function showAdditionalInfo() {
			if (this.$store.state.user_type !== 'client') return false;

			if (!this.formInfo || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.formInfo) !== 'object' || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.formInfo).length) return false;

			if (Array.isArray(this.formInfo)) return false;

			if (!('max' in this.formInfo) && !('cost' in this.formInfo.max)) return false;

			if (this.formInfo.max >= 100000) return false;

			return true;
		}
	},
	data: function data() {
		return {
			localErrorMessage: '',

			cacheData: null,

			Access: false,
			Error: '',

			showFormModal: false,
			formMode: 'create',
			form: null,
			formId: null,
			formParentID: null,
			formSavedFields: null,
			formInfo: null,
			formConfirmText: '',
			diskType: '17',

			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteID: null,

			FD: false,
			FD_count: 0,

			cssUl: false,

			isSliderDraging: false,

			showModal: false,
			modalTitle: 'service/extdisk',
			modalText: '',
			modalTimer: 0,
			modalTimerHandler: null,
			modalButtonTitle: '',

			reloadifRequests: {}
		};
	},
	created: function created() {
		this.Access = this.access;
		this.Error = this.parentError;

		this.maskModalFlag = false;
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);

		__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);

		__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		if (this.deleteModalTimerHandle) {
			clearInterval(this.deleteModalTimerHandle);
			this.deleteModalTimerHandle = false;
		}

		if (this.modalTimerHandler) {
			clearInterval(this.modalTimerHandler);
			this.modalTimerHandler = null;
		}
	},

	methods: {
		LinkHintForField: function LinkHintForField(field, links) {
			if (!field || !links) return null;
			if ((typeof links === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(links)) === 'object' && !Array.isArray(links)) {
				if (links.showIfField === field._field_name) return links;
			} else if ((typeof links === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(links)) === 'object' && Array.isArray(links)) {
				var _result = null;
				links.some(function (item) {
					if (item.showIfField === field._field_name) {
						_result = item;
						return true;
					}
				});

				return _result;
			}

			return null;
		},
		thereAreItems: function thereAreItems(row) {
			var _isRestore = this.Access && !row['Status']['loader'] && !row['Status']['timer'];
			var _isRemove = this.Access && !row['Status']['loader'] && !row['Status']['timer'];

			return _isRestore || _isRemove;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.active) {
				e.preventDefault();

				this.hideFormModal();
				this.hideDeleteModal();
				this.hideModal();

				this.clickHandler();
			}
		},
		clickHandler: function clickHandler(e) {
			if (this.cacheData && this.cacheData.length) this.cacheData.forEach(function (item) {
				return item['__btnShow'] = false;
			});
		},
		requestData: function requestData() {
			var _this = this;

			if (!this.dc || !this.dc.id) return;

			var _url = '/service/list';
			var _getParams = {
				ServiceSearch: {
					service_type_id: '16,17',
					datacenter_id: this.dc.id
				}
			};

			if (this.$store.state.user_type === 'admin') {
				if (this.account && this.account.account_id) {
					_getParams['ServiceSearch']['account_id'] = this.account.account_id.value;
				}
			}

			this.forms_Get(_url, _getParams, function (data) {
				if (!data || data['status'] !== 'ok' || !data['columns'] || !data['rows'] || !data['rows'].length) {
					_this.cacheData = null;
					return;
				}

				_this.cacheData = [];
				for (var i = 0; i < data['rows'].length; i++) {
					if (data['rows'][i]['service_data'] && data['rows'][i]['service_data']['extdisk'] && data['rows'][i]['service_data']['extdisk']['attached']) {
						if (String(data['rows'][i]['parent_id']) !== String(_this.vdsId)) {
							continue;
						}
					}

					var _row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data['rows'][i]);

					_row['Status'] = _this.Status(data['rows'][i]);

					_row['__btnShow'] = false;

					_this.cacheData.push(_row);
				}
			}, function () {
				_this.cacheData = null;
			});
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			if (!this.active) return;

			if (!this.cacheData || !Array.isArray(this.cacheData) || !this.cacheData.length) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== 'service') return;

			var _id = _parts[2];

			if (!_id) return;

			var _isVds = String(this.vdsId) === String(_id);

			var _found = this.cacheData.some(function (item) {
				if (String(item['service_id']) === String(_id)) return true;
			});

			if (_isVds || _found) this.requestData();
		},
		Status: function Status(row) {
			var _field = 'service_status';
			var _extField = 'service_status_text';

			var _answer = {
				'loader': false,
				'timer': false,
				'status': ''
			};

			if (row[_extField]) {
				var _extValue = row[_extField].replace('request/status_processing', '').trim();

				_answer['status'] = this.localeFtc(_extValue).toLowerCase();
				_answer['loader'] = true;

				if (_extValue.indexOf('request/status_queue') > -1) {
					_extValue = _extValue.replace('request/status_queue', '').trim();
					_answer['status'] = this.localeFtc(_extValue).toLowerCase();
					_answer['loader'] = false;
					_answer['timer'] = true;
				}

				return _answer;
			}

			if (row[_field] === null || row[_field] === undefined) {
				_answer['status'] = 'unknown';
				return _answer;
			}

			var _status = row[_field];
			if (_status.indexOf('service/status_') !== 0) _status = 'service/status_' + _status;

			_answer['status'] = this.localeFtc(_status).toLowerCase();

			if (row[_field] === 'processing') _answer['loader'] = true;

			return _answer;
		},
		isVisibleField: function isVisibleField(row) {
			if (!row) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		fieldChanged: function fieldChanged(field) {
			this.showif();
			this.reloadif(field['_field_name']);
		},
		findField: function findField(name) {
			if (!this.form || !this.form.fields || !this.form.fields.length) {
				return null;
			}

			var _field = null;
			this.form.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		findFieldByTitleAndType: function findFieldByTitleAndType(title, type) {
			if (!this.form || !this.form.fields || !this.form.fields.length) {
				return null;
			}

			var _field = null;
			this.form.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['title'] === title && obj['type'] === type) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		reloadif: function reloadif(changedFieldName) {
			var _this2 = this;

			var _rows = this.form['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (!field['reload']) return;

						if (field['reload'] === changedFieldName || field['reload'].length && field['reload'].indexOf(changedFieldName) !== -1) {
							var _url = field['url'];

							if (Array.isArray(field['reload'])) {
								var _isEmptyValue = false;
								for (var i = 0; i < field['reload'].length; i++) {
									var _ff = _this2.findField(field['reload'][i]);

									if (_ff) {
										if (_ff['value'] !== undefined && _ff['value'] !== null && _ff['value'] !== '') {
											_url = _url.replace(field['reload'][i] + '=', field['reload'][i] + '=' + _ff['value']);
										} else _isEmptyValue = true;
									} else _isEmptyValue = true;
								}

								if (_isEmptyValue) return;

								_url = _this2.APIServerUrl + _url;
							} else {
								var _values = [];
								var _field = _this2.findField(field['reload']);
								if (_field && 'value' in _field) {
									if (Array.isArray(_field['value'])) _field['value'].forEach(function (i) {
										_values.push(i);
									});else _values.push(_field['value']);
								}
								_url = _this2.APIServerUrl + _url + _values.join(',');
							}

							if (_url) {
								if (_this2.reloadifRequests[_url]) return;

								_this2.reloadifRequests[_url] = true;
								_this2.$http.get(_url).then(function (res) {
									delete _this2.reloadifRequests[_url];

									var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

									if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result'])) {
										if (field['type'] === 'list') {
											_this2.$set(field, 'list', _dt['result']);
										}
									}
								}, function () {
									delete _this2.reloadifRequests[_url];
								});
							}
						}
					});
				}
			});
		},
		showif: function showif() {
			var _rows = this.form['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg.exec(_expr) !== null) {
												_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
											} else {
												_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		localValidation: function localValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					return false;
				}

				if (v === String(r)) return true;

				field['_errMsg'] = 'validators/error_int';
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v = String(field.value).trim();

				_v = _v.replace(/ /g, '');

				var _r = parseFloat(_v);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				return false;
			}

			return true;
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		hideFormModal: function hideFormModal() {
			var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (!forceClose) {
				if (!this.maskModalFlag) return;else if (this.isSliderDraging) return;
			}

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showFormModal = false;
			this.hideModalMask();
		},
		updateForm: function updateForm(id, row) {
			var _this3 = this;

			if (!this.Access || this.Error) return;
			if (!this.vdsId || !id || !this.isAccess('service/update')) return;

			if (row) {
				if (row['Status']['loader'] || row['Status']['timer']) return;
			}

			this.formMode = 'update';
			this.form = null;
			this.formInfo = null;
			this.formConfirmText = '';
			this.formId = id;
			var _url = this.APIServerUrl + '/service/update/' + id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this3.form = _this3.parseFormData(_dt);
					_this3.$nextTick(function () {
						_this3.showif();

						_this3.form['fields'].forEach(function (row) {
							if (row) row.forEach(function (fld) {
								_this3.reloadif(fld['_field_name']);
							});
						});
					});

					__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this3.showFormModal = true;
				}
			}, function (resGet) {
				_this3.localErrorMessage = _this3.formatRequestError(resGet);
			});
		},
		fillFieldsByValues: function fillFieldsByValues() {
			if (!this.dc || !this.dc.id) return false;

			var _dcField = this.findField('datacenter_id');
			if (!_dcField) return false;

			_dcField.readonly = true;
			_dcField._visible = false;
			_dcField.value = String(this.dc.id);

			var _newValue = {
				id: String(this.dc.id),
				name: String(this.dc.name)
			};

			this.$set(_dcField, 'value', String(this.dc.id));
			this.$set(_dcField, 'listValue', _newValue);

			this.$nextTick(function () {
				__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
					name: 'datacenter_id',
					value: _newValue
				});
			});

			var _dcHeader = this.findFieldByTitleAndType('service/extdisk_location', 'header');
			if (_dcHeader) {
				_dcHeader._visible = false;
			}

			if (this.$store.state.user_type === 'admin') {
				if (!this.account || !this.account.account_id || !this.account.account_id.value) return false;

				var _accField = this.findField('account_id');
				if (!_accField) return false;

				_accField.readonly = true;
				_accField._visible = false;
				_accField.value = String(this.account.account_id.value);

				var _newValue2 = {
					id: String(this.account.account_id.value),
					name: String(this.account.account_name.value)
				};

				this.$set(_accField, 'value', String(this.account.account_id.value));
				this.$set(_accField, 'listValue', _newValue2);

				this.$nextTick(function () {
					__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
						name: 'account_id',
						value: _newValue2
					});
				});

				var _dcHeader2 = this.findFieldByTitleAndType('account/account', 'header');
				if (_dcHeader2) {
					_dcHeader2._visible = false;
				}
			}

			return true;
		},
		createForm: function createForm() {
			if (!this.Access || this.Error) return;
			if (!this.vdsId || !this.dc || !this.isAccess('service/create')) return;

			if (!window || !window.sessionStorage) return;
			if (!this.dc.id || !this.dc.name) return;

			var _key = 'w5_' + this.$store.state.user_id + '_outer_disk_create_dc';
			window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ id: this.dc.id, name: this.dc.name }));

			this.$router.push('/disks/create');
		},
		onDiskTypeChanged: function onDiskTypeChanged(value) {
			var _this4 = this;

			if (this.form && this.form.fields && this.form.fields.length) {
				this.formSavedFields = null;
				var _changedFields = {};
				var _isNeedToSave = false;

				for (var _idx in this.form.fields) {
					var _row = this.form.fields[_idx];
					if (!_row || !_row.length) continue;

					for (var _jdx in _row) {
						var _field = _row[_jdx];
						if (!_field || !('value' in _field) || _field.type === 'header') {
							continue;
						}

						_changedFields[_field._field_name] = _field.value;
						_isNeedToSave = true;
					}
				}

				if (_isNeedToSave) {
					this.formSavedFields = _changedFields;
				}
			}

			this.diskType = value;

			var _url = this.APIServerUrl + '/service/create/' + this.diskType;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form') {
					_this4.formInfo = null;
					if (_dt['info']) {
						_this4.formInfo = _dt['info'];
					}

					_this4.form = _this4.parseFormData(_dt);

					var _quantityField = _this4.findField('quantity');
					if (_quantityField) {
						if ('min' in _quantityField) {
							_quantityField['value'] = _quantityField.min;
						}

						if (_this4.formInfo && 'cost' in _this4.formInfo && !('cost' in _quantityField)) {
							_quantityField['cost'] = _this4.formInfo.cost;
							_quantityField['full_cost'] = _this4.formInfo.full_cost;
							_quantityField['period'] = _this4.formInfo.period;
						}
					}

					_this4.fillFieldsByValues();

					if (_this4.formSavedFields) {
						for (var _key in _this4.formSavedFields) {
							var _form = _this4.findField(_key);
							if (_form) {
								_form['value'] = _this4.formSavedFields[_key];
							}
						}

						_this4.formSavedFields = null;
					}

					_this4.$nextTick(function () {
						_this4.showif();

						_this4.form['fields'].forEach(function (row) {
							if (row) row.forEach(function (fld) {
								_this4.reloadif(fld['_field_name']);
							});
						});
					});

					__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this4.showFormModal = true;
				}
			}, function (resGet) {
				_this4.localErrorMessage = _this4.formatRequestError(resGet);
			});
		},
		formModalBegin: function formModalBegin() {
			var _this5 = this;

			if (!this.Access || this.Error) return;

			if (this.form_Loading) return;

			if (this.formMode === 'update') {
				if (!this.formId) return;

				var _quantityField = this.findField('quantity');

				if (_quantityField && '_oldValue' in _quantityField && 'value' in _quantityField && 'cost' in _quantityField) {
					var _old = parseFloat(_quantityField._oldValue);
					var _new = parseFloat(_quantityField.value);
					var _cost = parseFloat(_quantityField.cost);
					var _attached = __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].normalizeBooleanValue(_quantityField.attached);

					if (!isNaN(_old) && !isNaN(_new) && !isNaN(_cost) && _old < _new) {
						var _sum = parseFloat((_new - _old).toFixed(2)) * _cost;
						var _text = this.localeFtc('service/extdisk_increase_note').replace('{cost}', __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].FormatMoney2(_sum, 2)).replace('{val}', this.localeFtc('main/ruble'));

						if (_attached) {
							_text += '<br><br>\n\n' + this.localeFtc('service/iso_operation_warning');
						}

						this.formConfirmText = _text;
						this.formMode = 'updateConfirm';
						return;
					}
				}
			}

			this.localErrorMessage = '';

			if (!this.vdsId) {
				this.localErrorMessage = 'error/app_internal';
				this.hideFormModal();
				return;
			}

			var _access = true;
			if (this.formMode === 'create') _access = this.isAccess('service/create');else _access = this.isAccess('service/update');

			if (!_access) {
				this.localErrorMessage = 'main/access_denied';
				this.hideFormModal();
				return;
			}

			var _dcField = this.findField('datacenter_id');
			if (_dcField) _dcField['_errMsg'] = '';

			var _accField = this.findField('account_id');
			if (_accField) _accField['_errMsg'] = '';

			var _rows = this.form['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				this.localErrorMessage = 'error/app_internal';
				this.hideFormModal();
				return;
			}

			var _data = this.collectFormData(_rows, this.localValidation, 'disks');

			if (_data === false) return;

			var _mode = this.formMode === 'create' ? 'create' : 'update';
			var _url = '/service/' + _mode + '/' + (_mode === 'create' ? this.diskType : this.formId);
			this.form_Loading = true;

			this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) return { csrf: _dt['_csrf'], model: _dt['model'] };

				throw new Error(_dt);
			}).then(function (getDate) {
				_data = _this5.FormDataRePack(_data);

				var _post = {
					'_csrf': getDate.csrf
				};
				_post[getDate.model] = _data;

				_this5.FD = new FormData();
				_this5.FD_count = 0;
				_this5.FD_prepare(_post);

				_this5.$http.post(_this5.APIServerUrl + _url, _this5.FD_count > 0 ? _this5.FD : null).then(function (resPost) {
					_this5.form_Loading = false;

					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok') {
						var _msg = _mode === 'create' ? 'service/created' : 'service/updated';
						if (_dt.title) _msg = _this5.localeFtc(_dt.title);

						_this5.hideFormModal();
						_this5.$emit('successMessage', _msg);
						_this5.requestData();
						return;
					}

					if (_dt && _dt['status'] === 'error' && _dt['fields']) {
						var _isFieldError = false;

						for (var k in _dt['fields']) {
							if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
								var _fn = k === 'datacenter_id' || 'account_id' ? 'quantity' : k;
								var _fld = _this5.findField(_fn);

								if (_fld) {
									_isFieldError = true;
									_fld['_errMsg'] = _this5.localeFtc(_dt['fields'][k].join(' <br> '));
									__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
								}
							}
						}
						if (_isFieldError) return;
					}

					_this5.localErrorMessage = _this5.formatRequestError(resPost);
					_this5.hideFormModal();
				}, function (resPost) {
					_this5.localErrorMessage = _this5.formatRequestError(resPost);
					_this5.hideFormModal();
					_this5.form_Loading = false;
				});
			}).catch(function (error) {
				_this5.localErrorMessage = _this5.formatRequestError(error);
				_this5.hideFormModal();
				_this5.form_Loading = false;
			});
		},
		deleteAction: function deleteAction(id, row) {
			var _this6 = this;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';
			this.deleteModalText = '';
			this.deleteID = null;

			var _name = false;
			this.cacheData.some(function (item) {
				if (String(item['service_id']) === String(id)) {
					_name = _this6.localeFtc(item['service_name_full']);
					return true;
				}
			});

			if (!_name) return;

			this.deleteModalText = this.localeFtc('service/deleting_backup_confirm').replace('{name}', _name);

			if (row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) {
				this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning');
			}

			this.toggleMenu('off');

			this.deleteID = id;

			this.deleteModalTimer = 5;

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this6.deleteModalTimer--;
				if (_this6.deleteModalTimer <= 0) {
					clearInterval(_this6.deleteModalTimerHandle);
					_this6.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		restoreStatus: function restoreStatus(id, status) {
			this.cacheData.some(function (item, idx, arr) {
				if (String(item['service_id']) === String(id)) {
					arr[idx]['Status'] = status;
					return true;
				}
			});
		},
		deleteBackupBegin: function deleteBackupBegin() {
			var _this7 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.Access || this.Error) return;

			this.localErrorMessage = '';

			if (!this.deleteID) return;

			this.hideDeleteModal();

			var _oldStatus = null;

			this.cacheData.some(function (item, idx, arr) {
				if (String(item['service_id']) === String(_this7.deleteID)) {
					_oldStatus = item['Status'];
					arr[idx]['Status'] = { loader: true, status: _this7.localeFtc('main/deleting') };
					return true;
				}
			});

			var _url = this.APIServerUrl + '/service/delete/' + this.deleteID;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this7.$http.post(_url, __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this7.$emit('successMessage', 'service/extdisk_deleting_begin_process');

							return;
						}

						if (_oldStatus) _this7.restoreStatus(_this7.deleteID, _oldStatus);

						_this7.localErrorMessage = _this7.formatRequestError(resPost);
					}, function (resPost) {
						if (_oldStatus) _this7.restoreStatus(_this7.deleteID, _oldStatus);

						_this7.localErrorMessage = _this7.formatRequestError(resPost);
					});

					return;
				}

				if (_oldStatus) _this7.restoreStatus(_this7.deleteID, _oldStatus);

				_this7.localErrorMessage = _this7.formatRequestError(resGet);
			}, function (resGet) {
				if (_oldStatus) _this7.restoreStatus(_this7.deleteID, _oldStatus);

				_this7.localErrorMessage = _this7.formatRequestError(resGet);
			});
		},
		hideDeleteModal: function hideDeleteModal() {
			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}
			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		hideModal: function hideModal() {
			if (this.modalTimerHandler) {
				clearInterval(this.modalTimerHandler);
				this.modalTimerHandler = null;
			}

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showModal = false;
			this.hideModalMask();
		},
		ejectOuterDisk: function ejectOuterDisk(row, e) {
			var _this8 = this;

			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return;

			if (row && row['service_status_text'] && String(row['service_status_text']).length) return;

			if (!this.isAccess('service/update')) return;

			if (e) e.preventDefault();
			if (e) e.stopPropagation();

			this.toggleMenu('off');

			this.localErrorMessage = '';

			this.formId = row['service_id'];
			this.formParentId = row['parent_id'];

			this.modalTitle = 'service/extdisk';
			this.modalText = this.localeFtc('service/extdisk_ejecting_confirm').replace('{disk}', row['service_name']);

			this.modalTimer = 5;
			this.modalButtonTitle = '5 - ' + this.localeFtc('main/detach');

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showModal = true;

			this.modalTimerHandler = setInterval(function () {
				_this8.modalTimer--;
				_this8.modalButtonTitle = _this8.modalTimer + ' - ' + _this8.localeFtc('main/detach');
				if (_this8.modalTimer <= 0) {
					_this8.modalButtonTitle = _this8.localeFtc('main/detach');
					clearInterval(_this8.modalTimerHandler);
					_this8.modalTimerHandler = null;
				}
			}, 1000);
		},
		insertDisk: function insertDisk(row, e) {
			if (!this.vdsId || !row || !row['service_id'] || !row['service_name']) return;

			if (row && row['service_status_text'] && String(row['service_status_text']).length) return;

			if (!this.isAccess('service/update')) return;

			if (e) e.preventDefault();
			if (e) e.stopPropagation();

			this.toggleMenu('off');

			this.localErrorMessage = '';

			this.formId = row['service_id'];

			this.modalTitle = 'service/extdisk';
			this.modalText = this.localeFtc('service/extdisk_inserting_confirm <br><br> service/iso_operation_warning');

			this.modalTimer = 0;
			this.modalTimerHandler = null;
			this.modalButtonTitle = this.localeFtc('main/attach');

			__WEBPACK_IMPORTED_MODULE_6__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showModal = true;
		},
		diskProcessBegin: function diskProcessBegin(e) {
			if (this.modalButtonTitle === this.localeFtc('main/detach')) {
				this.detachOuterDiskBegin(e);
			} else if (this.modalButtonTitle === this.localeFtc('main/attach')) {
				this.attachOuterDiskBegin(e);
			}
		},
		detachOuterDiskBegin: function detachOuterDiskBegin(e) {
			var _this9 = this;

			if (this.modalTimer > 0) {
				if (e) e.preventDefault();
				return;
			}

			if (!this.formId || !this.formParentId) return;

			if (!this.isAccess('service/update')) return;

			this.hideModal();

			var _url = this.APIServerUrl + '/service/update/' + this.formId + '?additional=setDetach';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this9.$http.post(_url, __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this9.$emit('successMessage', _dt['title'] || 'main/process_started');

							_this9.requestData();

							return;
						}

						_this9.localErrorMessage = _this9.formatRequestError(resPost);
					}, function (resPost) {
						_this9.localErrorMessage = _this9.formatRequestError(resPost);
					});

					return;
				}

				_this9.localErrorMessage = _this9.formatRequestError(resGet);
			}, function (resGet) {
				_this9.localErrorMessage = _this9.formatRequestError(resGet);
			});
		},
		attachOuterDiskBegin: function attachOuterDiskBegin(e) {
			var _this10 = this;

			if (!this.formId || !this.vdsId) return;

			if (!this.isAccess('service/update')) return;

			this.hideModal();

			var _url = this.APIServerUrl + '/service/update/' + this.formId + '?additional=setAttach&service_id=' + this.vdsId;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this10.$http.post(_url, __WEBPACK_IMPORTED_MODULE_5__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this10.$emit('successMessage', _dt['title'] || 'main/process_started');

							_this10.requestData();

							return;
						}

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					}, function (resPost) {
						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					});

					return;
				}

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			}, function (resGet) {
				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			});
		},
		toggleMenu: function toggleMenu(row) {
			if (row === 'off') {
				this.cacheData.forEach(function (item) {
					item['__btnShow'] = false;
				});
				return;
			}

			this.cacheData.forEach(function (item) {
				if (String(item.service_id) === String(row.service_id)) item['__btnShow'] = !item['__btnShow'];else item['__btnShow'] = false;
			});

			this.UpOrDown(row['service_id']);
		},
		UpOrDown: function UpOrDown(id) {
			this.cssUl = false;

			var _div = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('div[data-id="' + id + '"]');
			if (!_div.length) return;

			var _ul = _div.find('ul:first');
			if (!_ul.length) return;

			var _rect = _div.offset();
			var _heightDiv = _div.height();
			var _heightUl = _ul.height();

			var _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - __WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).scrollTop();

			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px';
		},
		onDragStart: function onDragStart() {
			this.isSliderDraging = true;
		},
		onDragEnd: function onDragEnd() {
			this.isSliderDraging = false;
		},
		onModalMouse: function onModalMouse(e) {
			var $form = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#modal-form');
			if (__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.contains($form.get(0), e.target)) {
				this.maskModalFlag = false;
				return;
			}

			if (!this.isSliderDraging) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.maskModalFlag = false;
		},
		canConnectDisk: function canConnectDisk(row) {
			if (row && row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) return false;
			return true;
		}
	},

	watch: {
		'active': function active() {
			if (this.active) this.requestData();
		},
		'access': function access(_access2) {
			this.Access = _access2;
		},
		'parentError': function parentError(value) {
			this.Error = value;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_7__components_elements_formfield___default.a
	}

});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-snapshot-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-additional-info",
    staticStyle: {
      "margin-right": "0",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "w5-form-row js-end",
    class: {
      'with-table': _vm.cacheData && _vm.cacheData.length
    }
  }, [_c('div', {
    staticClass: "btn btn-submit font-weight-300",
    attrs: {
      "disabled": !_vm.Access ? 'disabled' : false
    },
    on: {
      "click": _vm.createForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk_create')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "w5-snapshot-table margin-top-5"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w5-tab-table-th-0"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-1"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk_attached')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-2"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-tab-table-th-3"
  }, [(_vm.cacheData) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/created')))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "w5-column-opers",
    staticStyle: {
      "width": "45px"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', [(_vm.cacheData && _vm.cacheData.length) ? _vm._l((_vm.cacheData), function(row) {
    return _c('tr', {
      key: row['service_id']
    }, [_c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('service/extdisk')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell",
      class: {
        'w5-link': _vm.Access && !row['Status']['loader'] && !row['Status']['timer']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.updateForm(row['service_id'], row)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(row['service_name_full'])) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('service/extdisk_attached')
      }
    }, [_c('div', {
      staticClass: "w5-list-iso"
    }, [(row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
      staticClass: "btn btn-default w5-eject-iso-button",
      attrs: {
        "title": _vm._f("ftc")('main/detach')
      },
      on: {
        "click": function($event) {
          return _vm.ejectOuterDisk(row, $event)
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "eject"
      }
    })], 1) : _vm._e(), _vm._v(" "), (String(row['parent_id']) !== _vm.vdsId) ? _c('div', {
      staticClass: "hidden-ellipsis",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_c('linkComponent', {
      attrs: {
        "url": '/vds/view/' + row['parent_id'],
        "text": row['parent_name']
      }
    })], 1) : _c('div', {
      staticClass: "hidden-ellipsis",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(row['service_data']['extdisk']['device']) ? _c('span', [_vm._v(_vm._s(row['service_data']['extdisk']['device']))]) : _c('span', [_vm._v(_vm._s(row['parent_name']))])])] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('main/status')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [(row['Status']['loader']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('img', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "src": __webpack_require__(14)
      }
    })]) : (row['Status']['timer']) ? _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])) + " "), _c('font-awesome-icon', {
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "icon": "clock"
      }
    })], 1) : _c('span', {
      staticClass: "margin-right-10",
      class: 'w5-status-color-' + row['service_status'],
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(_vm._f("lower")(row['Status']['status'])))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "aria-label": _vm._f("ftc")('main/created')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formater_StrDateFormat(row['service_created'], 'd.m.Y')) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [(_vm.$store.state.windowWidth <= 767) ? _c('div', {
      staticClass: "w5-opers-button-for-mobile"
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('div', {
      staticClass: "w5-opers-button-curd-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAction(row['service_id'], row)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "icon": "trash-alt"
      }
    })], 1) : _vm._e()]) : (_vm.$store.state.windowWidth > 767 && _vm.thereAreItems(row)) ? _c('div', {
      staticClass: "btn-group w5-opers-button",
      class: {
        'w5-opers-button-opened': row['__btnShow']
      },
      attrs: {
        "data-id": row['id']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(row)
        }
      }
    }, [_c('span', {
      staticClass: "dropdown-toggle"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "bars"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "caret"
    })], 1), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row['__btnShow']),
        expression: "row['__btnShow']"
      }],
      staticClass: "dropdown-menu",
      style: (_vm.cssUl),
      attrs: {
        "role": "menu"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && _vm.canConnectDisk(row)) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.insertDisk(row)
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/attach main/disk'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer'] && !_vm.canConnectDisk(row)) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.ejectOuterDisk(row, $event)
        }
      }
    }, [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "eject"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")('main/detach main/disk'))) + "\n\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.Access && !row['Status']['loader'] && !row['Status']['timer']) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAction(row['service_id'], row)
        }
      }
    }, [_c('span', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_c('font-awesome-icon', {
      staticClass: "color-red",
      attrs: {
        "icon": "trash-alt"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete')) + "\n\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()])]) : _vm._e()])])
  }) : _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormModal),
      expression: "showFormModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideFormModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-form",
    attrs: {
      "id": "modal-form"
    },
    on: {
      "mousedown": _vm.onModalMouse,
      "mouseup": _vm.onModalMouse
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideFormModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.formMode === 'updateConfirm') ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.formConfirmText)),
      expression: "localeFtc(formConfirmText)"
    }],
    staticClass: "padding-0-5"
  })])] : [(_vm.form && _vm.form.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.showAdditionalInfo) ? _c('div', {
    staticClass: "w5-form-additional-info"
  }, [(_vm.formInfo.max) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/available_to_order')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.max))]), (_vm.formInfo.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formInfo.cost) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.cost))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  }), (_vm.formInfo.period) ? _c('span', [_vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.formInfo.period)))]) : _vm._e(), (_vm.formInfo.for) ? _c('span', [_vm._v(" / 1 " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, _vm._l((_vm.form.fields), function(row, index) {
    return _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "action": _vm.formMode,
          "Field": field,
          "listBlockToOut": 1,
          "diskTypeValue": field._field_name === 'quantity' ? _vm.diskType : null,
          "linkHint": _vm.LinkHintForField(field, _vm.linkHint),
          "diskQuantity": field._field_name === 'backup_auto' ? _vm.findField('quantity') : null,
          "crud": "disks"
        },
        on: {
          "dragStart": _vm.onDragStart,
          "dragEnd": _vm.onDragEnd,
          "outerDiskTypeChanged": _vm.onDiskTypeChanged,
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0)])]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.form_Loading
    },
    on: {
      "click": _vm.formModalBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formMode === 'create' ? 'main/create' : _vm.formMode === 'update' ? 'main/save' : 'main/continue')))])])], 2)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/extdisk')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteBackupBegin
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.modalText)),
      expression: "localeFtc(modalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.modalButtonTitle.indexOf(_vm.localeFtc('main/detach')) > -1
    },
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.diskProcessBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalButtonTitle)))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_bar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_line__ = __webpack_require__(266);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabStat',

	props: ['active', 'vdsId', 'planInfo', 'trafInfo', 'localIpInfo'],
	data: function data() {
		return {
			trafValue: '1',

			trafField: {
				type: 'list',
				list: [{ 'id': 1, 'name': this.localeFtc('main/current_month') }, { 'id': 2, 'name': this.localeFtc('main/last_month') }],
				title: 'filter/period',
				_field_name: 'trafPeriod',
				_visible: true,
				_errMsg: ''
			},

			monValue: '1',

			monField: {
				type: 'list',
				list: [{ 'id': 1, 'name': this.localeFtc('main/today') }, { 'id': 2, 'name': this.localeFtc('main/yesterday') }, { 'id': 3, 'name': this.localeFtc('filter/period_last_week') }, { 'id': 4, 'name': this.localeFtc('main/current_month') }, { 'id': 5, 'name': this.localeFtc('main/last_month') }],
				title: 'filter/period',
				_field_name: 'monPeriod',
				_visible: true,
				_errMsg: ''
			},

			localErrorMessage: '',

			cacheData: {
				traf: {
					'usage': null,
					'rx': null,
					'tx': null,
					'unit': this.localeFtc('main/traffic_mb'),
					'data': null
				},
				mon: {
					'cpu': null,
					'disk': null,
					'traf': null,
					'trafLocal': null
				}
			},

			Colors: ['9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333', '999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666', 'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633', 'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC', '9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333', '999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666', 'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633', 'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC'],

			barChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			},

			lineChartOptionsCpu: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						title: function title(items, data) {
							return data['labelsForToolTip'][items[0]['index']];
						},

						label: function label(item, data) {
							var _label = data['datasets'][item.datasetIndex]['label'];
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + '%';
						}
					}
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								var _val = value.toFixed(1);
								var _parts = _val.split('.');
								if (+(_parts && _parts[1])) return _val + '%';
								return _parts[0] + '%';
							}
						}
					}]
				}
			},

			lineChartOptionsDisk: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						title: function title(items, data) {
							return data['labelsForToolTip'][items[0]['index']];
						},

						label: function label(item, data) {
							var _label = data['datasets'][item.datasetIndex]['label'];
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' iops';
						}
					}
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								var _val = value.toFixed(1);
								var _parts = _val.split('.');
								if (+(_parts && _parts[1])) return _val + ' iops';
								return _parts[0] + ' iops';
							}
						}
					}]
				}
			},

			lineChartOptionsTraf: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						title: function title(items, data) {
							return data['labelsForToolTip'][items[0]['index']];
						},

						label: function label(item, data) {
							var _label = data['datasets'][item.datasetIndex]['label'];
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' Мб';
						}
					}
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								var _val = value.toFixed(1);
								var _parts = _val.split('.');
								if (+(_parts && _parts[1])) return _val + ' Мб';
								return _parts[0] + ' Мб';
							}
						}
					}]
				}
			},

			lineChartOptionsTrafLocal: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						title: function title(items, data) {
							return data['labelsForToolTip'][items[0]['index']];
						},

						label: function label(item, data) {
							var _label = data['datasets'][item.datasetIndex]['label'];
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' Мб';
						}
					}
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								var _val = value.toFixed(1);
								var _parts = _val.split('.');
								if (+(_parts && _parts[1])) return _val + ' Мб';
								return _parts[0] + ' Мб';
							}
						}
					}]
				}
			}
		};
	},
	created: function created() {
		if (this.active) {
			this.trafFieldChanged();
			this.monFieldChanged();
		}
	},

	methods: {
		trafFieldChanged: function trafFieldChanged() {
			var dt = {
				'ServiceStatSearch': {}
			};
			var today = new Date();
			var _year = today.getFullYear();
			var _month = today.getMonth();
			var start = void 0;
			var end = void 0;

			if (this.trafValue === '1') {
				start = new Date(_year, _month, 1, 0, 0, 0, 0);
				end = new Date(_year, _month, today.getDate(), 23, 59, 59, 0);

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
			} else {
					end = new Date(_year, _month, 0, 23, 59, 59, 0);

					_month--;

					if (_month < 0) {
						_month = 11;
						_year--;
					}
					start = new Date(_year, _month, 1, 0, 0, 0, 0);

					dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
					dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
				}

			this.getTrafData(dt);
		},
		getTrafData: function getTrafData(dates) {
			var _this = this;

			this.cacheData['traf']['usage'] = false;
			this.cacheData['traf']['rx'] = false;
			this.cacheData['traf']['tx'] = false;
			this.cacheData['traf']['data'] = false;

			this.$store.commit('needShowLoader', false);

			var _url = this.APIServerUrl + '/service/stat/' + this.vdsId;
			this.$http.get(_url, { 'params': dates }).then(function (res) {
				_this.$store.commit('needShowLoader', true);

				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['rows']) {
					_this.compileTrafData(_dt);
					return;
				}

				_this.cacheData['traf']['usage'] = null;
				_this.cacheData['traf']['rx'] = null;
				_this.cacheData['traf']['tx'] = null;
				_this.cacheData['traf']['data'] = null;

				_this.localErrorMessage = _this.formatRequestError(res);
			}, function (res) {
				_this.$store.commit('needShowLoader', true);

				_this.cacheData['traf']['usage'] = null;
				_this.cacheData['traf']['rx'] = null;
				_this.cacheData['traf']['tx'] = null;
				_this.cacheData['traf']['data'] = null;

				_this.localErrorMessage = _this.formatRequestError(res);
			});
		},
		compileTrafData: function compileTrafData(data) {
			var i = void 0;
			var Y = void 0;
			var X = void 0;
			var maxBandWidth = 0;
			var unit = this.localeFtc('main/traffic_mb');
			var rows = data.rows;
			var vnetRX = 0.0;
			var vnetTX = 0.0;

			for (i = 0; i < rows.length; i++) {
				Y = rows[i]['stat_value'];

				if (Y['vnet_rx'] > maxBandWidth) maxBandWidth = Y['vnet_rx'];
				if (Y['vnet_tx'] > maxBandWidth) maxBandWidth = Y['vnet_tx'];

				vnetRX += Y['vnet_rx'] / 1048576.0;
				vnetTX += Y['vnet_tx'] / 1048576.0;
			}

			if (maxBandWidth >= 1073741824.0) {
				unit = this.localeFtc('main/traffic_gb');
				vnetRX /= 1024.0;
				vnetTX /= 1024.0;
			}

			this.cacheData['traf']['rx'] = vnetRX.toFixed(2) + ' ' + unit;
			this.cacheData['traf']['tx'] = vnetTX.toFixed(2) + ' ' + unit;

			this.cacheData['traf']['usage'] = null;
			if (this.planInfo && this.planInfo['traff']) {
				var _trfTxt = this.planInfo['traff']['value'];
				var _trfNum = parseInt(_trfTxt, 10);
				_trfTxt += ' ' + this.planInfo['traff']['for'];

				if (this.trafInfo && this.trafInfo['current'] && this.trafInfo['last']) {
					var _trafikMonth = false;
					if (this.trafValue === '1') _trafikMonth = this.trafInfo['current'];else _trafikMonth = this.trafInfo['last'];

					if (_trafikMonth && _trafikMonth['value'] && _trafikMonth['text']) this.cacheData['traf']['usage'] = _trafikMonth['value'] + ' ' + this.localeFtc('main/out_of') + ' ' + _trfTxt + ' (' + _trafikMonth['text'] + ')';else this.cacheData['traf']['usage'] = null;
				} else {
					if (unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb') _trfNum *= 1000000.0;else _trfNum *= 1000.0;
					var _prc = vnetTX * 100.0 / _trfNum;
					this.cacheData['traf']['usage'] = (vnetTX + vnetTX).toFixed(2) + ' ' + unit + ' ' + this.localeFtc('main/out_of') + ' ' + _trfTxt + ' (' + _prc.toFixed(2) + '%)';
				}
			}

			this.cacheData['traf']['data'] = null;
			var _rxData = {};
			var _txData = {};
			var _tmp = void 0;
			for (i = 0; i < rows.length; i++) {
				_tmp = rows[i]['stat_date'];
				if (rows.length <= 24) X = _tmp;else X = _tmp.substr(0, 10);

				Y = rows[i]['stat_value'];

				if (_rxData[X]) _rxData[X] += parseFloat(Y['vnet_rx']) / 1048576.0;else _rxData[X] = parseFloat(Y['vnet_rx']) / 1048576.0;

				if (_txData[X]) _txData[X] += parseFloat(Y['vnet_tx']) / 1048576.0;else _txData[X] = parseFloat(Y['vnet_tx']) / 1048576.0;
			}

			var _rxArr = [];
			var _txArr = [];
			var _labels = [];
			var _labelToolTip = [];
			for (X in _rxData) {
				_labels.push(rows.length <= 24 ? this.formater_StrDateFormat(X) : this.formater_StrDateFormat(X, this.trafValue === '1' ? 'd' : 'd.m'));
				_labelToolTip.push(rows.length <= 24 ? this.formater_StrDateFormat(X) : this.formater_StrDateFormat(X, 'd.m.Y'));
				_rxArr.push((unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb' ? _rxData[X] : _rxData[X] / 1024.0).toFixed(2));
				_txArr.push((unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb' ? _txData[X] : _txData[X] / 1024.0).toFixed(2));
			}

			this.cacheData['traf']['data'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [{
					'borderColor': '#' + this.Colors[0],
					'backgroundColor': '#' + this.Colors[0],
					'data': _rxArr,
					'label': this.localeFtc('service/stat_vnet_rx')
				}, {
					'borderColor': '#' + this.Colors[1],
					'backgroundColor': '#' + this.Colors[1],
					'data': _txArr,
					'label': this.localeFtc('service/stat_vnet_tx')
				}]
			};

			this.barChartOptions['scales']['yAxes'][0]['ticks']['callback'] = function (value) {
				var _val = value.toFixed(1);
				var _parts = _val.split('.');
				if (+(_parts && _parts[1])) return _val + ' ' + unit;
				return _parts[0] + ' ' + unit;
			};
			this.barChartOptions['tooltips']['callbacks'] = {
				title: function title(items, data) {
					return data['labelsForToolTip'][items[0]['index']];
				},

				label: function label(item, data) {
					var _label = data['datasets'][item.datasetIndex]['label'];

					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unit;
				}
			};
		},
		monFieldChanged: function monFieldChanged() {
			var dt = {
				'ServiceStatSearch': {}
			};
			var today = new Date();
			var start = void 0;
			var end = void 0;

			if (this.monValue === '1') {
				dt = null;
			} else if (this.monValue === '2') {
					start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0, 0);
					end = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 23, 59, 59, 0);

					dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
					dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
				} else if (this.monValue === '3') {
						start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6, 0, 0, 0, 0);
						end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0);

						dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
						dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
					} else if (this.monValue === '4') {
							start = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
							end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0);

							dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
							dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
						} else if (this.monValue === '5') {
								var _m = today.getMonth() - 1;
								var _y = today.getFullYear();
								if (_m < 0) {
									_m = 11;
									_y--;
								}
								start = new Date(_y, _m, 1, 0, 0, 0, 0);
								end = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 0);

								dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start);
								dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end);
							}

			this.getMonData(dt);
		},
		getMonData: function getMonData(dates) {
			var _this2 = this;

			this.cacheData['mon']['cpu'] = false;
			this.cacheData['mon']['disk'] = false;
			this.cacheData['mon']['traf'] = false;
			this.cacheData['mon']['trafLocal'] = false;

			this.$store.commit('needShowLoader', false);

			var _url = this.APIServerUrl + '/service/stat/' + this.vdsId;
			this.$http.get(_url, { 'params': dates }).then(function (res) {
				_this2.$store.commit('needShowLoader', true);

				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['rows']) {
					_this2.compileMonData(_dt);
					return;
				}

				_this2.cacheData['mon']['cpu'] = null;
				_this2.cacheData['mon']['disk'] = null;
				_this2.cacheData['mon']['traf'] = null;
				_this2.cacheData['mon']['trafLocal'] = null;

				_this2.localErrorMessage = _this2.formatRequestError(res);
			}, function (res) {
				_this2.$store.commit('needShowLoader', true);

				_this2.cacheData['mon']['cpu'] = null;
				_this2.cacheData['mon']['disk'] = null;
				_this2.cacheData['mon']['traf'] = null;
				_this2.cacheData['mon']['trafLocal'] = null;

				_this2.localErrorMessage = _this2.formatRequestError(res);
			});
		},
		compileMonData: function compileMonData(data) {
			var i = void 0;
			var Y = void 0;
			var X = void 0;
			var maxBandWidth = 0;
			var maxBandWidthLocal = 0;
			var unit = 'Kbps';
			var unitLocal = 'Kbps';
			var rows = data.rows;

			for (i = 0; i < rows.length; i++) {
				Y = rows[i]['stat_value'];

				if (Y['vnet_rx'] > maxBandWidth) maxBandWidth = Y['vnet_rx'];
				if (Y['vnet_tx'] > maxBandWidth) maxBandWidth = Y['vnet_tx'];

				if (Y['lnet_rx'] > maxBandWidthLocal) maxBandWidthLocal = Y['lnet_rx'];
				if (Y['lnet_tx'] > maxBandWidthLocal) maxBandWidthLocal = Y['lnet_tx'];
			}

			var _normTraf = function _normTraf(n) {
				return n * 8 / 1024.0 / 3600.0;
			};
			var _normTrafLocal = function _normTrafLocal(n) {
				return n * 8 / 1024.0 / 3600.0;
			};
			if (maxBandWidth >= 1073741824.0) {
				unit = 'Мbps';
				_normTraf = function _normTraf(n) {
					return n * 8 / 1048576.0 / 3600.0;
				};
			}

			if (maxBandWidthLocal / 1024.0 >= 1073741824.0) {
				unitLocal = 'Gbps';
				_normTrafLocal = function _normTrafLocal(n) {
					return n * 8 / 1073741824.0 / 3600.0;
				};
			} else if (maxBandWidthLocal >= 1073741824.0) {
				unitLocal = 'Мbps';
				_normTrafLocal = function _normTrafLocal(n) {
					return n * 8 / 1048576.0 / 3600.0;
				};
			}

			this.cacheData['mon']['cpu'] = null;
			this.cacheData['mon']['disk'] = null;
			this.cacheData['mon']['traf'] = null;
			this.cacheData['mon']['trafLocal'] = null;

			var _cpuData = {};
			var _diskR = {};
			var _diskW = {};
			var _rxData = {};
			var _txData = {};
			var _rxDataLocal = {};
			var _txDataLocal = {};
			var _tmp = void 0;
			for (i = 0; i < rows.length; i++) {
				X = rows[i]['stat_date'];

				Y = rows[i]['stat_value'];

				_cpuData[X] = parseFloat(Y['cpu']);

				_diskR[X] = parseFloat(Y['disk_reads']) / 3600.0;
				_diskW[X] = parseFloat(Y['disk_writes']) / 3600.0;

				_rxData[X] = _normTraf(parseFloat(Y['vnet_rx']));
				_txData[X] = _normTraf(parseFloat(Y['vnet_tx']));

				_rxDataLocal[X] = _normTrafLocal(parseFloat(Y['lnet_rx']));
				_txDataLocal[X] = _normTrafLocal(parseFloat(Y['lnet_tx']));
			}

			var _cpuArr = [];
			var _diskRArr = [];
			var _diskWArr = [];
			var _rxArr = [];
			var _txArr = [];
			var _rxArrLocal = [];
			var _txArrLocal = [];
			var _labels = [];
			var _labelToolTip = [];
			for (X in _cpuData) {
				if (this.monValue === '1' || this.monValue === '2') _tmp = this.formater_StrDateFormat(X, 'H:M');else _tmp = this.formater_StrDateFormat(X, 'd.m');
				_labels.push(_tmp);

				_labelToolTip.push(this.formater_StrDateFormat(X));

				_cpuArr.push(_cpuData[X].toFixed(2));

				_diskRArr.push(_diskR[X].toFixed(2));
				_diskWArr.push(_diskW[X].toFixed(2));

				_rxArr.push(_rxData[X].toFixed(2));
				_txArr.push(_txData[X].toFixed(2));

				_rxArrLocal.push(_rxDataLocal[X].toFixed(2));
				_txArrLocal.push(_txDataLocal[X].toFixed(2));
			}

			this.cacheData['mon']['cpu'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [{
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[0],
					'backgroundColor': '#' + this.Colors[0],
					'pointBackgroundColor': '#' + this.Colors[0],
					'data': _cpuArr,
					'label': this.localeFtc('service/stat_cpu')
				}]
			};

			this.cacheData['mon']['disk'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [{
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[0],
					'backgroundColor': '#' + this.Colors[0],
					'pointBackgroundColor': '#' + this.Colors[0],
					'data': _diskRArr,
					'label': this.localeFtc('service/stat_disk_reads')
				}, {
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[1],
					'backgroundColor': '#' + this.Colors[1],
					'pointBackgroundColor': '#' + this.Colors[1],
					'data': _diskWArr,
					'label': this.localeFtc('service/stat_disk_writes')
				}]
			};

			this.cacheData['mon']['traf'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [{
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[0],
					'backgroundColor': '#' + this.Colors[0],
					'pointBackgroundColor': '#' + this.Colors[0],
					'data': _rxArr,
					'label': this.localeFtc('service/stat_vnet_rx')
				}, {
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[1],
					'backgroundColor': '#' + this.Colors[1],
					'pointBackgroundColor': '#' + this.Colors[1],
					'data': _txArr,
					'label': this.localeFtc('service/stat_vnet_tx')
				}]
			};

			this.cacheData['mon']['trafLocal'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [{
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[0],
					'backgroundColor': '#' + this.Colors[0],
					'pointBackgroundColor': '#' + this.Colors[0],
					'data': _rxArrLocal,
					'label': this.localeFtc('service/stat_lnet_rx')
				}, {
					'fill': false,
					'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
					'lineTension': 0.05,
					'borderWidth': 1,
					'borderColor': '#' + this.Colors[1],
					'backgroundColor': '#' + this.Colors[1],
					'pointBackgroundColor': '#' + this.Colors[1],
					'data': _txArrLocal,
					'label': this.localeFtc('service/stat_lnet_tx')
				}]
			};

			this.lineChartOptionsTraf['scales']['yAxes'][0]['ticks']['callback'] = function (value) {
				var _val = value.toFixed(1);
				var _parts = _val.split('.');
				if (+(_parts && _parts[1])) return _val + ' ' + unit;
				return _parts[0] + ' ' + unit;
			};
			this.lineChartOptionsTraf['tooltips']['callbacks'] = {
				title: function title(items, data) {
					return data['labelsForToolTip'][items[0]['index']];
				},

				label: function label(item, data) {
					var _label = data['datasets'][item.datasetIndex]['label'];
					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unit;
				}
			};

			this.lineChartOptionsTrafLocal['scales']['yAxes'][0]['ticks']['callback'] = function (value) {
				var _val = value.toFixed(1);
				var _parts = _val.split('.');
				if (+(_parts && _parts[1])) return _val + ' ' + unitLocal;
				return _parts[0] + ' ' + unitLocal;
			};
			this.lineChartOptionsTrafLocal['tooltips']['callbacks'] = {
				title: function title(items, data) {
					return data['labelsForToolTip'][items[0]['index']];
				},

				label: function label(item, data) {
					var _label = data['datasets'][item.datasetIndex]['label'];
					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unitLocal;
				}
			};
		}
	},

	watch: {
		'active': function active(value) {
			if (this.active) {
				this.trafFieldChanged();
				this.monFieldChanged();
			}
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default.a,
		chartBar: __WEBPACK_IMPORTED_MODULE_2__components_charts_bar__["a" /* default */],
		chartLine: __WEBPACK_IMPORTED_MODULE_3__components_charts_line__["a" /* default */]
	}

});

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 142,
	"./af.js": 142,
	"./ar": 143,
	"./ar-dz": 144,
	"./ar-dz.js": 144,
	"./ar-kw": 145,
	"./ar-kw.js": 145,
	"./ar-ly": 146,
	"./ar-ly.js": 146,
	"./ar-ma": 147,
	"./ar-ma.js": 147,
	"./ar-sa": 148,
	"./ar-sa.js": 148,
	"./ar-tn": 149,
	"./ar-tn.js": 149,
	"./ar.js": 143,
	"./az": 150,
	"./az.js": 150,
	"./be": 151,
	"./be.js": 151,
	"./bg": 152,
	"./bg.js": 152,
	"./bm": 153,
	"./bm.js": 153,
	"./bn": 154,
	"./bn.js": 154,
	"./bo": 155,
	"./bo.js": 155,
	"./br": 156,
	"./br.js": 156,
	"./bs": 157,
	"./bs.js": 157,
	"./ca": 158,
	"./ca.js": 158,
	"./cs": 159,
	"./cs.js": 159,
	"./cv": 160,
	"./cv.js": 160,
	"./cy": 161,
	"./cy.js": 161,
	"./da": 162,
	"./da.js": 162,
	"./de": 163,
	"./de-at": 164,
	"./de-at.js": 164,
	"./de-ch": 165,
	"./de-ch.js": 165,
	"./de.js": 163,
	"./dv": 166,
	"./dv.js": 166,
	"./el": 167,
	"./el.js": 167,
	"./en-au": 168,
	"./en-au.js": 168,
	"./en-ca": 169,
	"./en-ca.js": 169,
	"./en-gb": 170,
	"./en-gb.js": 170,
	"./en-ie": 171,
	"./en-ie.js": 171,
	"./en-il": 172,
	"./en-il.js": 172,
	"./en-nz": 173,
	"./en-nz.js": 173,
	"./eo": 174,
	"./eo.js": 174,
	"./es": 175,
	"./es-do": 176,
	"./es-do.js": 176,
	"./es-us": 177,
	"./es-us.js": 177,
	"./es.js": 175,
	"./et": 178,
	"./et.js": 178,
	"./eu": 179,
	"./eu.js": 179,
	"./fa": 180,
	"./fa.js": 180,
	"./fi": 181,
	"./fi.js": 181,
	"./fo": 182,
	"./fo.js": 182,
	"./fr": 183,
	"./fr-ca": 184,
	"./fr-ca.js": 184,
	"./fr-ch": 185,
	"./fr-ch.js": 185,
	"./fr.js": 183,
	"./fy": 186,
	"./fy.js": 186,
	"./gd": 187,
	"./gd.js": 187,
	"./gl": 188,
	"./gl.js": 188,
	"./gom-latn": 189,
	"./gom-latn.js": 189,
	"./gu": 190,
	"./gu.js": 190,
	"./he": 191,
	"./he.js": 191,
	"./hi": 192,
	"./hi.js": 192,
	"./hr": 193,
	"./hr.js": 193,
	"./hu": 194,
	"./hu.js": 194,
	"./hy-am": 195,
	"./hy-am.js": 195,
	"./id": 196,
	"./id.js": 196,
	"./is": 197,
	"./is.js": 197,
	"./it": 198,
	"./it.js": 198,
	"./ja": 199,
	"./ja.js": 199,
	"./jv": 200,
	"./jv.js": 200,
	"./ka": 201,
	"./ka.js": 201,
	"./kk": 202,
	"./kk.js": 202,
	"./km": 203,
	"./km.js": 203,
	"./kn": 204,
	"./kn.js": 204,
	"./ko": 205,
	"./ko.js": 205,
	"./ku": 206,
	"./ku.js": 206,
	"./ky": 207,
	"./ky.js": 207,
	"./lb": 208,
	"./lb.js": 208,
	"./lo": 209,
	"./lo.js": 209,
	"./lt": 210,
	"./lt.js": 210,
	"./lv": 211,
	"./lv.js": 211,
	"./me": 212,
	"./me.js": 212,
	"./mi": 213,
	"./mi.js": 213,
	"./mk": 214,
	"./mk.js": 214,
	"./ml": 215,
	"./ml.js": 215,
	"./mn": 216,
	"./mn.js": 216,
	"./mr": 217,
	"./mr.js": 217,
	"./ms": 218,
	"./ms-my": 219,
	"./ms-my.js": 219,
	"./ms.js": 218,
	"./mt": 220,
	"./mt.js": 220,
	"./my": 221,
	"./my.js": 221,
	"./nb": 222,
	"./nb.js": 222,
	"./ne": 223,
	"./ne.js": 223,
	"./nl": 224,
	"./nl-be": 225,
	"./nl-be.js": 225,
	"./nl.js": 224,
	"./nn": 226,
	"./nn.js": 226,
	"./pa-in": 227,
	"./pa-in.js": 227,
	"./pl": 228,
	"./pl.js": 228,
	"./pt": 229,
	"./pt-br": 230,
	"./pt-br.js": 230,
	"./pt.js": 229,
	"./ro": 231,
	"./ro.js": 231,
	"./ru": 232,
	"./ru.js": 232,
	"./sd": 233,
	"./sd.js": 233,
	"./se": 234,
	"./se.js": 234,
	"./si": 235,
	"./si.js": 235,
	"./sk": 236,
	"./sk.js": 236,
	"./sl": 237,
	"./sl.js": 237,
	"./sq": 238,
	"./sq.js": 238,
	"./sr": 239,
	"./sr-cyrl": 240,
	"./sr-cyrl.js": 240,
	"./sr.js": 239,
	"./ss": 241,
	"./ss.js": 241,
	"./sv": 242,
	"./sv.js": 242,
	"./sw": 243,
	"./sw.js": 243,
	"./ta": 244,
	"./ta.js": 244,
	"./te": 245,
	"./te.js": 245,
	"./tet": 246,
	"./tet.js": 246,
	"./tg": 247,
	"./tg.js": 247,
	"./th": 248,
	"./th.js": 248,
	"./tl-ph": 249,
	"./tl-ph.js": 249,
	"./tlh": 250,
	"./tlh.js": 250,
	"./tr": 251,
	"./tr.js": 251,
	"./tzl": 252,
	"./tzl.js": 252,
	"./tzm": 253,
	"./tzm-latn": 254,
	"./tzm-latn.js": 254,
	"./tzm.js": 253,
	"./ug-cn": 255,
	"./ug-cn.js": 255,
	"./uk": 256,
	"./uk.js": 256,
	"./ur": 257,
	"./ur.js": 257,
	"./uz": 258,
	"./uz-latn": 259,
	"./uz-latn.js": 259,
	"./uz.js": 258,
	"./vi": 260,
	"./vi.js": 260,
	"./x-pseudo": 261,
	"./x-pseudo.js": 261,
	"./yo": 262,
	"./yo.js": 262,
	"./zh-cn": 263,
	"./zh-cn.js": 263,
	"./zh-hk": 264,
	"./zh-hk.js": 264,
	"./zh-tw": 265,
	"./zh-tw.js": 265
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/home/user/work/ANTON/panel.test"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/home/user/work/ANTON/panel.test","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-stat-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/monitoring')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.monField) ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.monField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.monFieldChanged
    },
    model: {
      value: (_vm.monValue),
      callback: function($$v) {
        _vm.monValue = $$v
      },
      expression: "monValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_cpu')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['cpu']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['cpu'],
      "options": _vm.lineChartOptionsCpu
    }
  }) : (_vm.cacheData['mon']['cpu'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['mon']['cpu'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_disk')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['disk']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['disk'],
      "options": _vm.lineChartOptionsDisk
    }
  }) : (_vm.cacheData['mon']['disk'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['mon']['disk'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_vnet')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['traf']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['traf'],
      "options": _vm.lineChartOptionsTraf
    }
  }) : (_vm.cacheData['mon']['traf'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['mon']['traf'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.localIpInfo && typeof _vm.localIpInfo === 'object' && _vm.localIpInfo.ip) ? _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_lnet')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['trafLocal']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['trafLocal'],
      "options": _vm.lineChartOptionsTrafLocal
    }
  }) : (_vm.cacheData['mon']['trafLocal'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['mon']['trafLocal'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "0",
      "margin-top": "60px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_monthly_bandwidth')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.trafField) ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.trafField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.trafFieldChanged
    },
    model: {
      value: (_vm.trafValue),
      callback: function($$v) {
        _vm.trafValue = $$v
      },
      expression: "trafValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/usage')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['usage']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['usage']))]) : (_vm.cacheData['traf']['usage'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['traf']['usage'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_vnet_rx')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['rx']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['rx']))]) : (_vm.cacheData['traf']['rx'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['traf']['rx'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_vnet_tx')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['tx']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['tx']))]) : (_vm.cacheData['traf']['tx'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['traf']['tx'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['traf']['data']) ? _c('chartBar', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['traf']['data'],
      "options": _vm.barChartOptions
    }
  }) : (_vm.cacheData['traf']['data'] === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }) : (_vm.cacheData['traf']['data'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessageButton),
      expression: "localErrorMessageButton"
    }],
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessageClear)),
      expression: "localeFtc(localErrorMessageClear)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.isDataReady) ? _c('div', {
    staticClass: "w5-vds-view-wrapper"
  }, [_c('div', {
    staticClass: "font-size-120 name-in-vds"
  }, [_c('span', {
    class: 'flag-icon flag-icon-' + _vm.dataCenter.country
  }), _vm._v(" "), (_vm.Access) ? _c('span', {
    staticClass: "font-weight-500 w5-modal-link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.changeServiceName($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceName)))]) : _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceName)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10 font-size-95"
  }, [_c('span', {
    staticClass: "margin-right-10",
    class: {
      'text-strike': !_vm.serviceIPActive
    }
  }, [_vm._v(_vm._s(_vm.serviceIP))]), _vm._v(" "), (_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))]), _vm._v(" "), _c('span', {
    staticClass: "margin-right-10"
  }, [_c('img', {
    attrs: {
      "src": _vm.APIServerUrl + _vm.serviceTemplate['template_image']['value'],
      "width": "18",
      "height": "18"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.serviceTemplate['template_name']['value']))])]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['cpu']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['cpu']['total'] ? _vm.servicePlanInfo['cpu']['total'] : _vm.servicePlanInfo['cpu']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['cpu']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['ram']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['ram']['total'] ? _vm.servicePlanInfo['ram']['total'] : _vm.servicePlanInfo['ram']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['ram']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t"), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), (_vm.servicePlanInfo['gpu'] && _vm.servicePlanInfo['gpu']['title'] && _vm.servicePlanInfo['gpu']['for']) ? [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['gpu']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['gpu']['total'] ? _vm.servicePlanInfo['gpu']['total'] : _vm.servicePlanInfo['gpu']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['gpu']['for'])))]), _vm._v("\n\t\t\t\t\t\t  \n\t\t\t\t\t")] : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['disk']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['disk']['total'] ? _vm.servicePlanInfo['disk']['total'] : _vm.servicePlanInfo['disk']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['disk']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['traff']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['traff']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['traff']['for'])))])], 2), _vm._v(" "), (_vm.isAccountBlockVisible) ? _c('div', {
    staticClass: "margin-top-10"
  }, [(_vm.$store.state.user_type === 'admin') ? _c('span', {
    staticClass: "margin-right-10"
  }, [_vm._v(_vm._s(_vm._f("ftc")('account/account')) + ":\n\t\t\t\t\t\t"), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? [(!_vm.account['global_filter'] || _vm.account['global_filter']['value'] != _vm.account['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.account['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.account['global_filter'] && _vm.account['global_filter']['value'] == _vm.account['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/account/view/' + _vm.account['account_id']['value'],
      "text": _vm.account['account_name']['value']
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.sshkey && _vm.sshkey['key_id'] && _vm.sshkey['key_id']['value'] && _vm.sshkey['key_name'] && _vm.sshkey['key_name']['value']) ? _c('span', {
    staticClass: "margin-right-10"
  }, [_c('br', {
    staticClass: "visible-xs"
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('sshkey/sshkey')) + ": "), _c('linkComponent', {
    attrs: {
      "url": '/sshkey/view/' + _vm.sshkey['key_id']['value'],
      "text": _vm.sshkey['key_name']['value']
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs margin-top-20 view-vds-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.tabVisible(tab.id)) ? _c('li', {
      key: tab.id,
      class: {
        active: tab.id === _vm.curTab
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.choiceTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(tab.title)))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.tabVisible('command')) ? _c('tabCommand', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'command'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "templateName": _vm.templateName,
      "vdsId": _vm.id,
      "canReboot": _vm.canReboot,
      "serviceName": _vm.serviceName,
      "iso": _vm.isoInfo,
      "serviceFullName": _vm.serviceFullName,
      "active": _vm.curTab === 'command',
      "serviceProlong": _vm.serviceProlong,
      "serviceCanProlong": _vm.serviceCanProlong,
      "serviceCanDelete": _vm.serviceCanDelete,
      "templateInstruction": _vm.templateInstruction,
      "parentError": _vm.localErrorMessage,
      "reserveIpData": _vm.reserveIpData
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData,
      "requestData": _vm.refreshVDSData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('access')) ? _c('tabAccess', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'access'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "vdsInfo": _vm.vdsData,
      "serviceFullName": _vm.serviceFullName,
      "templateName": _vm.templateName,
      "active": _vm.curTab === 'access',
      "parentError": _vm.localErrorMessage,
      "passwordType": _vm.passwordType,
      "templateInstruction": _vm.templateInstruction
    },
    on: {
      "successMessage": _vm.onSuccessMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('plan')) ? _c('tabPlan', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'plan'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "plan": _vm.planInfo,
      "ipInfo": _vm.ipInfo,
      "templateData": _vm.templateInfo,
      "value": _vm.servicePlanId,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "dropPlanConstructorChanged": _vm.onDropPlanConstructorChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('reinstall')) ? _c('tabReinstall', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'reinstall'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "template": _vm.templateInfo,
      "host": _vm.hostInfo,
      "sshkey": _vm.sshkeyInfo,
      "account": _vm.account,
      "backup": _vm.backupInfo && _vm.backupInfo['backup_id'] ? _vm.backupInfo['backup_id'] : null,
      "reiso": _vm.reisoInfo,
      "dc": _vm.dataCenter,
      "planId": _vm.servicePlanId,
      "planData": _vm.planInfo,
      "value": _vm.serviceTemplateId,
      "parentError": _vm.localErrorMessage,
      "vdsName": _vm.serviceName
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "flagCloseModals": function (value) { return _vm.notCloseModals = value; }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('ip')) ? _c('tabIp', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'ip'
    },
    attrs: {
      "active": _vm.curTab === 'ip',
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "mainIP": _vm.serviceIPData,
      "ipInfo": _vm.ipInfo,
      "vdsId": _vm.id,
      "reserveIpData": _vm.reserveIpData,
      "reserveIPv4List": _vm.reserveIPv4List,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData,
      "flagCloseModals": function (value) { return _vm.notCloseModals = value; }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('localIp')) ? _c('tabLocalIp', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'localIp'
    },
    attrs: {
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "data": _vm.serviceLocalIPData,
      "vdsId": _vm.id,
      "ipLocalData": _vm.ipLocalData,
      "parentError": _vm.localErrorMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('backup')) ? _c('tabBackup', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'backup'
    },
    attrs: {
      "active": _vm.curTab === 'backup',
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "backup": _vm.backupInfo && _vm.backupInfo['create'] ? _vm.backupInfo['create'] : null,
      "backupList": _vm.backupInfo && _vm.backupInfo['backup_id'] ? _vm.backupInfo['backup_id'] : null,
      "vdsId": _vm.id,
      "vdsName": _vm.serviceName,
      "account": _vm.account,
      "dc": _vm.dataCenter,
      "vdsInfo": _vm.vdsData,
      "planInfo": _vm.servicePlanInfo,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData,
      "requestData": _vm.refreshVDSData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('disks')) ? _c('tabDisks', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'disks'
    },
    attrs: {
      "active": _vm.curTab === 'disks',
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "vdsId": _vm.id,
      "vdsName": _vm.serviceName,
      "account": _vm.account,
      "dc": _vm.dataCenter,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('stat') && !_vm.localErrorMessage) ? _c('tabStat', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'stat'
    },
    attrs: {
      "active": _vm.curTab === 'stat',
      "planInfo": _vm.servicePlanInfo,
      "trafInfo": _vm.trafInfo,
      "localIpInfo": _vm.serviceLocalIPData,
      "vdsId": _vm.id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNameModal),
      expression: "showNameModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideNameModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/name')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideNameModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.nameField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusName,
      "enterKeyDown": _vm.nameChangeStart
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.nameChangeStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/rename_action')))])])])])])])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'sslView',
	data: function data() {
		return {
			crud: 'certificate',

			id: null,

			localErrorMessage: '',

			sslData: null,

			autoProlongValue: false,
			autoProlongProcessing: false,

			curTab: false
		};
	},

	computed: {
		Access: function Access() {
			if (this.sslData && this.sslData.service && this.sslData['service']['service_status'] && this.sslData['service']['service_status']['text'] && String(this.sslData['service']['service_status']['text']).length) return false;

			return this.isAccess('service/update');
		},
		localErrorMessageClear: function localErrorMessageClear() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return '';
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1);
			return this.localErrorMessage;
		},
		localErrorMessageButton: function localErrorMessageButton() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return false;
			if (this.localErrorMessage.charAt(0) === 'x') return false;
			return true;
		},
		Account: function Account() {
			if (this.sslData && this.sslData.account && this.sslData.account.account_id && this.sslData.account.account_name) return this.sslData.account;

			return null;
		},
		SSL: function SSL() {
			if (this.sslData && this.sslData.service && this.sslData.service.service_data && this.sslData.service.service_data.value && this.sslData.service.service_data.value.cert) return this.sslData.service.service_data.value.cert;

			return null;
		},
		Plan: function Plan() {
			if (this.sslData && this.sslData.plan && this.sslData.plan.plan_id && this.sslData.plan.plan_name) return this.sslData.plan;

			return null;
		},
		sslStatus: function sslStatus() {
			if (this.sslData && this.sslData.service && this.sslData.service.service_status) return __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].cellStatusInView(this.sslData['service']['service_status']);

			return null;
		},
		clearStatus: function clearStatus() {
			if (this.sslData && this.sslData.service && this.sslData.service.service_status && this.sslData.service.service_status.value) return this.sslData.service.service_status.value;

			return null;
		},
		objCSR: function objCSR() {
			if (this.sslData && this.sslData.service && this.sslData.service.certificate_csr && this.sslData.service.certificate_csr.value) return this.sslData.service.certificate_csr;

			return null;
		},
		objPKEY: function objPKEY() {
			if (this.sslData && this.sslData.service && this.sslData.service.certificate_pkey && this.sslData.service.certificate_pkey.value) return this.sslData.service.certificate_pkey;

			return null;
		},
		objCRT: function objCRT() {
			if (this.sslData && this.sslData.service && this.sslData.service.certificate_crt && this.sslData.service.certificate_crt.value) return this.sslData.service.certificate_crt;

			return null;
		},
		objCA: function objCA() {
			if (this.sslData && this.sslData.service && this.sslData.service.certificate_ca && this.sslData.service.certificate_ca.value) return this.sslData.service.certificate_ca;

			return null;
		},
		Address: function Address() {
			if (!this.sslData || !this.sslData.service || !this.sslData.service.service_data || !this.sslData.service.service_data.value || !this.sslData.service.service_data.value.cert) return '';

			var _tmp = [];

			if (this.sslData.service.service_data.value.cert.country) _tmp.push(this.sslData.service.service_data.value.cert.country);
			if (this.sslData.service.service_data.value.cert.province) _tmp.push(this.sslData.service.service_data.value.cert.province);
			if (this.sslData.service.service_data.value.cert.city) _tmp.push(this.sslData.service.service_data.value.cert.city);

			if (this.sslData.service.service_data.value.cert.org_postcode) _tmp.push(this.sslData.service.service_data.value.cert.org_postcode);
			if (this.sslData.service.service_data.value.cert.org_address) _tmp.push(this.sslData.service.service_data.value.cert.org_address);
			if (this.sslData.service.service_data.value.cert.org_phone) _tmp.push(this.sslData.service.service_data.value.cert.org_phone);

			return _tmp.join(', ');
		},
		Owner: function Owner() {
			if (this.sslData && this.sslData.service && this.sslData.service.service_data && this.sslData.service.service_data.value && this.sslData.service.service_data.value.cert && this.sslData.service.service_data.value.cert.owner) return '«' + this.sslData.service.service_data.value.cert.owner + '»';

			return '';
		},
		autoProlongHint: function autoProlongHint() {
			if (this.sslData && this.sslData.service && this.sslData.service.service_autoprolong && this.sslData.service.service_autoprolong.hint) return this.sslData.service.service_autoprolong.hint;

			return null;
		},
		Data: function Data() {
			if (this.sslData && this.sslData.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sslData.data).length) {
				var _data = [];
				for (var _prop in this.sslData.data) {
					if (this.sslData.data.hasOwnProperty(_prop)) {
						var _val = this.sslData.data[_prop];
						var _idx = parseInt(_val.order);
						if ('order' in _val && 'title' in _val && 'value' in _val) {
							if (_data[_idx]) {
								var _obj = _data[_idx];
								_data[_idx] = [];
								_data[_idx].push(_obj);
								_data[_idx].push({
									title: _val.title,
									value: _val.value,
									list: _val.list
								});
							} else {
								_data[_idx] = {
									title: _val.title,
									value: _val.value,
									list: _val.list
								};
							}
						}
					}
				}if (_data.length) return _data;
			}

			return null;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.id = this.$route.params['id'];
		if (this.id) {
			this.requestSSLData();
		} else {
			this.localErrorMessage = this.localeFtc('main/unknown_page');
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
		window.addEventListener('storage', this.onLocalStorageEvent);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
		window.removeEventListener('storage', this.onLocalStorageEvent);
	},

	methods: {
		requestSSLData: function requestSSLData() {
			var _this = this;

			if (!this.id) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(function (respons) {
				var _dt = respons && respons.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(respons.data) === 'object' ? respons.data : false;

				if (_dt && _dt['status'] === 'ok' && _dt['plan'] && _dt['plan']['plan_id'] && _dt['plan']['plan_id']['value']) {
					_this.sslData = _dt;

					_this.autoProlongValue = _this.sslData && _this.sslData.service && _this.sslData.service.service_autoprolong && _this.sslData.service.service_autoprolong.value === true;

					if (_this.objCSR) _this.curTab = 'csr';else if (_this.objPKEY) _this.curTab = 'pkey';else if (_this.objCRT) _this.curTab = 'crt';else if (_this.objCA) _this.curTab = 'ca';

					return _dt;
				}

				_this.localErrorMessage = _this.formatRequestError(respons);
			}, function (respons) {
				_this.localErrorMessage = _this.formatRequestError(respons);
			});
		},
		autoProlongClick: function autoProlongClick() {
			var _this2 = this;

			if (!this.id) return;

			if (!this.Access || this.clearStatus !== 'active') return;

			if (this.autoProlongProcessing) return;

			this.autoProlongProcessing = true;

			var _url = this.APIServerUrl + '/service/update/' + this.id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model']) {
					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = {
						'autoprolong': !_this2.autoProlongValue ? 1 : 0
					};

					_this2.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this2.autoProlongProcessing = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id']) {
							_this2.autoProlongValue = !_this2.autoProlongValue;

							_this2.setLocalSuccessMessage('main/updated');
							return;
						}

						_this2.localErrorMessage = _this2.formatRequestError(resPost);
					}, function (resPost) {
						_this2.autoProlongProcessing = false;

						_this2.localErrorMessage = _this2.formatRequestError(resPost);
					});

					return;
				}

				_this2.autoProlongProcessing = false;

				_this2.localErrorMessage = _this2.formatRequestError(resGet);
			}, function (resGet) {
				_this2.autoProlongProcessing = false;

				_this2.localErrorMessage = _this2.formatRequestError(resGet);
			});
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			var _id = _parts[2];

			if (!_id) return;

			if (String(_id) === String(this.id)) this.requestSSLData();
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(account) {
			var _this3 = this;

			if (this.$store.state.user_type !== 'admin') return;

			if (account) {
				if (!/\d+/.test(account)) return;
				var _accountID = parseInt(account);
				if (isNaN(_accountID) || _accountID < 1) return;

				var _url = this.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				this.$store.commit('accountGlobalFilter', false);

				this.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this3.$store.commit('accountGlobalFilter', true);

						if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

						_this3.$store.dispatch('getTicketCounters');
						_this3.$store.dispatch('getRequestCounter');

						_this3.setLocalSuccessMessage('main/set_filter ' + _this3.Account['account_name']['value']);

						_this3.requestSSLData();

						return;
					}

					_this3.localErrorMessage = _this3.formatRequestError(resGet);
				}, function (resGet) {
					_this3.localErrorMessage = _this3.formatRequestError(resGet);
				});
			} else {
					var _url2 = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

					this.$http.get(_url2).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this3.$store.commit('accountGlobalFilter', false);

							if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

							_this3.$store.dispatch('getTicketCounters');
							_this3.$store.dispatch('getRequestCounter');

							_this3.setLocalSuccessMessage(_this3.localeFtc('main/filter') + ' ' + _this3.localeFtc('main/deleted').toLowerCase());

							_this3.requestSSLData();

							return;
						}

						_this3.localErrorMessage = _this3.formatRequestError(resGet);
					}, function (resGet) {
						_this3.localErrorMessage = _this3.formatRequestError(resGet);
					});
				}
		},
		joinProps: function joinProps(arr, field) {
			var _d = [];
			arr.forEach(function (i) {
				return _d.push(i[field]);
			});

			return _d.join(', ');
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestSSLData();
			}
		}
	}

});

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessageButton),
      expression: "localErrorMessageButton"
    }],
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessageClear)),
      expression: "localeFtc(localErrorMessageClear)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.sslData) ? _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.sslData.title)))]) : _vm._e(), _vm._v(" "), (_vm.sslData) ? _c('div', {
    staticClass: "ssl-info-block"
  }, [(_vm.sslStatus) ? [(_vm.sslStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.clearStatus
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.sslStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : (_vm.sslStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.clearStatus
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.sslStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.clearStatus
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.sslStatus['status'])))])] : _vm._e(), _vm._v(" "), (_vm.sslData && _vm.sslData.service && _vm.sslData.service.service_end) ? [_c('span', {
    staticClass: "font-weight-300"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.sslData.service.service_end.title)) + ":")]), _vm._v("  "), _c('span', {
    staticClass: "ssl-info-span"
  }, [_vm._v(_vm._s(_vm.formater_StrDateFormat(_vm.sslData.service.service_end.value, 'd.m.Y')))])] : _vm._e(), _vm._v(" "), (_vm.Account) ? [_c('br'), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Account.account_id.title)) + ":\n\t\t\t\t\t"), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? [(!_vm.Account['global_filter'] || _vm.Account['global_filter']['value'] != _vm.Account['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Account['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Account['global_filter'] && _vm.Account['global_filter']['value'] == _vm.Account['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/account/view/' + _vm.Account.account_id.value,
      "text": _vm.Account.account_name.value
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Data) ? _c('div', {
    staticClass: "ssl-info-table"
  }, _vm._l((_vm.Data), function(d) {
    return (d) ? _c('div', {
      staticClass: "ssl-info-table-row"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(_vm._f("ftc")(Array.isArray(d) ? _vm.joinProps(d, 'title') : d.title)) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [(!Array.isArray(d) && d.list) ? [_vm._v(_vm._s(_vm._f("ftc")(d.list[d.value])))] : [_vm._v(_vm._s(_vm._f("ftc")(Array.isArray(d) ? _vm.joinProps(d, 'value') : d.value)))]], 2)]) : _vm._e()
  }), 0) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.sslData) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [(_vm.autoProlongHint) ? _c('div', {
    staticClass: "upper-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.autoProlongHint)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoProlongValue),
      expression: "autoProlongValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoProlongValue) ? _vm._i(_vm.autoProlongValue, null) > -1 : (_vm.autoProlongValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoProlongValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoProlongValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoProlongValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoProlongValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.clearStatus !== 'active'
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.autoProlongClick
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/autoprolong')) + "\n\t\t\t\t")])]), _vm._v(" "), (!_vm.autoProlongValue) ? _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/autoprolong_off')),
      expression: "localeFtc('service/autoprolong_off')"
    }],
    staticClass: "warning-message"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.objCSR || _vm.objPKEY || _vm.objCRT || _vm.objCA) ? _c('ul', {
    staticClass: "nav nav-tabs margin-top-20"
  }, [(_vm.objCSR) ? _c('li', {
    class: {
      active: _vm.curTab === 'csr'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.curTab = 'csr'
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.objCSR.title)))])]) : _vm._e(), _vm._v(" "), (_vm.objPKEY) ? _c('li', {
    class: {
      active: _vm.curTab === 'pkey'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.curTab = 'pkey'
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.objPKEY.title)))])]) : _vm._e(), _vm._v(" "), (_vm.objCRT) ? _c('li', {
    class: {
      active: _vm.curTab === 'crt'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.curTab = 'crt'
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.objCRT.title)))])]) : _vm._e(), _vm._v(" "), (_vm.objCA) ? _c('li', {
    class: {
      active: _vm.curTab === 'ca'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.curTab = 'ca'
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.objCA.title)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane certificate-add-info-block",
    class: {
      'active': _vm.curTab === 'csr'
    }
  }, [(_vm.objCSR && _vm.objCSR.value) ? _c('pre', [_vm._v(_vm._s(_vm.objCSR.value))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane certificate-add-info-block",
    class: {
      'active': _vm.curTab === 'pkey'
    }
  }, [(_vm.objPKEY && _vm.objPKEY.value) ? _c('pre', [_vm._v(_vm._s(_vm.objPKEY.value))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane certificate-add-info-block",
    class: {
      'active': _vm.curTab === 'crt'
    }
  }, [(_vm.objCRT && _vm.objCRT.value) ? _c('pre', [_vm._v(_vm._s(_vm.objCRT.value))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane certificate-add-info-block",
    class: {
      'active': _vm.curTab === 'ca'
    }
  }, [(_vm.objCA && _vm.objCA.value) ? _c('pre', [_vm._v(_vm._s(_vm.objCA.value))]) : _vm._e()])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_table__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'domainView',
	data: function data() {
		var _this = this;

		return {
			crud: 'dns',

			id: null,

			localErrorMessage: '',

			Data: null,

			tableColumns: {
				'dns_host': {
					style: 'width: 220px'
				},
				'dns_type': {
					style: 'width: 60px'
				},
				'dns_priority': {
					style: 'width: 30px'
				},
				'dns_value': {},
				'dns_timestamp': {
					style: 'width: 105px',
					formatter: function formatter(value) {
						return _this.formater_StrDateFormat(value);
					}
				}
			}
		};
	},

	computed: {
		Access: function Access() {
			if (this.Data && this.Data.service && this.Data['service']['service_status'] && this.Data['service']['service_status']['text'] && String(this.Data['service']['service_status']['text']).length) return false;

			return this.isAccess('service/update');
		},
		localErrorMessageClear: function localErrorMessageClear() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return '';
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1);
			return this.localErrorMessage;
		},
		localErrorMessageButton: function localErrorMessageButton() {
			if (this.localErrorMessage === undefined || this.localErrorMessage === null || this.localErrorMessage === '') return false;
			if (this.localErrorMessage.charAt(0) === 'x') return false;
			return true;
		},
		tableUrlList: function tableUrlList() {
			return this.id ? '/dns/list?service_id=' + this.id : null;
		},
		tableUrlCreate: function tableUrlCreate() {
			return this.id ? '/dns-records/create/' + this.id : null;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.id = this.$route.params['id'];
		if (this.id) {
			this.$store.commit('domainRecordId', this.id);

			this.requestData();
		} else {
			this.localErrorMessage = this.localeFtc('main/unknown_page');

			this.$store.commit('domainRecordId', null);
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
	},

	methods: {
		requestData: function requestData() {
			var _this2 = this;

			if (!this.id) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(function (respons) {
				var _dt = respons && respons.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(respons.data) === 'object' ? respons.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this2.Data = _dt;

					return;
				}

				_this2.localErrorMessage = _this2.formatRequestError(respons);
			}, function (respons) {
				_this2.localErrorMessage = _this2.formatRequestError(respons);
			});
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[1] !== this.getRealCrud(this.crud)) return;

			var _id = _parts[2];

			if (!_id) return;

			if (String(_id) === String(this.id)) this.requestData();
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		getError: function getError(msg) {
			this.localErrorMessage = msg;
		}
	},

	components: {
		Table: __WEBPACK_IMPORTED_MODULE_2__components_elements_table___default.a
	}

});

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessageButton),
      expression: "localErrorMessageButton"
    }],
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessageClear)),
      expression: "localeFtc(localErrorMessageClear)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('Table', {
    attrs: {
      "crud": "dns-records",
      "access": _vm.Access,
      "url-list": _vm.tableUrlList,
      "url-create": _vm.tableUrlCreate,
      "columns": _vm.tableColumns,
      "id-columns": "dns_id"
    },
    on: {
      "error": _vm.getError
    }
  })] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus_js__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Bonus',
	data: function data() {
		return {
			formData: false,

			curBonuses: null,

			crud: 'bonus',

			localErrorMessage: '',

			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			showBonusModal: false,
			bonusValue: '',
			bonusField: {
				'required': true,
				'type': 'text',
				'title': 'bonus/code',
				'_field_name': 'bonusCode',
				'_visible': true,
				'_errMsg': ''
			},

			accountId: false
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		model: function model() {
			return this.Config[this.crud]['model'] ? this.Config[this.crud]['model'] : this.formater_capitalizeFirstChar(this.crud) + 'Search';
		},
		UserType: function UserType() {
			return this.$store.state.user_type;
		},
		Bonus: function Bonus() {
			if (this.curBonuses && this.curBonuses['value']) return this.curBonuses;else return false;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.currentBonuses();
		this.requestForm();
	},
	mounted: function mounted() {
		document.addEventListener('keydown', this.keyDownHandler);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	methods: {
		currentBonuses: function currentBonuses() {
			var _this = this;

			this.$http.get(this.APIServerUrl + '/bonus/index').then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok' && 'bonus' in _dt && _dt['bonus'] && _dt['bonus']) {
					_this.curBonuses = _dt['bonus'];
					return;
				}

				_this.localErrorMessage = _this.formatRequestError(res);
			}, function (res) {
				_this.localErrorMessage = _this.formatRequestError(res);
			});
		},
		requestForm: function requestForm() {
			var _this2 = this;

			this.accountId = false;

			this.$http.get(this.APIServerUrl + '/bonus/convert').then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value']) {
					_this2.accountId = _dt['fields']['account_id']['value'];
					return;
				}

				_this2.localErrorMessage = _this2.formatRequestError(res);
			}, function (res) {
				_this2.localErrorMessage = _this2.formatRequestError(res);
			});
		},
		activateBonus: function activateBonus() {
			this.localErrorMessage = '';
			this.localSuccessMessage = '';
			this.bonusValue = '';
			this.bonusField['_errMsg'] = '';

			if (!this.accountId) {
				this.localErrorMessage = 'account/not_found';
				return;
			}

			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showBonusModal = true;
		},
		hideBonusModal: function hideBonusModal() {
			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showBonusModal = false;
			this.hideModalMask();
		},
		onFocus: function onFocus() {
			this.bonusField['_errMsg'] = '';
		},
		activateBonusStart: function activateBonusStart() {
			var _this3 = this;

			this.localErrorMessage = '';
			this.localSuccessMessage = '';

			if (!this.accountId) {
				this.localErrorMessage = 'account/not_found';
				this.hideBonusModal();
				return;
			}

			if (!this.bonusValue || this.bonusValue === '') {
				this.bonusField['_errMsg'] = 'error/required_field';
				return;
			}

			var _url = this.APIServerUrl + '/bonus/convert';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {
						'account_id': _this3.accountId,
						'code': _this3.bonusValue
					};

					_this3.$http.post(_url, __WEBPACK_IMPORTED_MODULE_2__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this3.hideBonusModal();

							_this3.setLocalSuccessMessage('bonus/converted');

							_this3.currentBonuses();

							return;
						}

						_this3.bonusField['_errMsg'] = _this3.formatRequestError(resPost);

						if (_dt && _dt['status'] === 'error') {
							if (_dt['fields'] && _dt['fields']['code']) {
								if (Array.isArray(_dt['fields']['code'])) {
									if (_dt['fields']['code'].length) _this3.bonusField['_errMsg'] = _this3.localeFtc(_dt['fields']['code'][0]);
								} else _this3.bonusField['_errMsg'] = _this3.localeFtc(_dt['fields']['code']);
							}
						}
					}, function (resPost) {
						_this3.hideBonusModal();
						_this3.localErrorMessage = _this3.formatRequestError(resPost);
					});

					return;
				}

				_this3.hideBonusModal();

				_this3.localErrorMessage = _this3.formatRequestError(resGet);
			}, function (resGet) {
				_this3.hideBonusModal();
				_this3.localErrorMessage = _this3.formatRequestError(resGet);
			});
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.hideBonusModal();
			}
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_3__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default.a
	}

});

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "w5-block-bordered"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('bonus/description_header')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('bonus/description_text')),
      expression: "localeFtc('bonus/description_text')"
    }]
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit-green font-weight-400 margin-15-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.activateBonus
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/activate')))])]), _vm._v(" "), (_vm.Bonus && _vm.Bonus['value'] && Array.isArray(_vm.Bonus['value']) && _vm.Bonus['value'].length) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [_c('div', {
    staticClass: "info-box for-bonus"
  }, [_c('div', {
    staticClass: "info-box-content margin-0 bonus-item"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Bonus['title'])))]), _vm._v(" "), _c('ul', {
    staticClass: "info-box-list"
  }, _vm._l((_vm.Bonus['value']), function(b, i) {
    return _c('li', [_c('linkComponent', {
      class: !b['active'] ? 'not-active-bonus' : '',
      attrs: {
        "url": '/bonus/view/' + b['bonus_id'],
        "text": b['bonus_name']
      }
    })], 1)
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBonusModal),
      expression: "showBonusModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBonusModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('bonus/convert')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBonusModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.bonusField,
      "fieldInModal": true,
      "removeRightPadding": true
    },
    on: {
      "focus": _vm.onFocus,
      "enterKeyDown": _vm.activateBonusStart
    },
    model: {
      value: (_vm.bonusValue),
      callback: function($$v) {
        _vm.bonusValue = $$v
      },
      expression: "bonusValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit-green pull-right",
    on: {
      "click": _vm.activateBonusStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/activate')))])])])])])]), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])])] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_outerdisktype__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_outerdisktype___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_elements_outerdisktype__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validators_array__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_text__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_elements_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_elements_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_elements_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_cached_request__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_jquery__);



















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Update',

	mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_cached_request__["a" /* default */]],
	data: function data() {
		return {
			crud: null,

			action: null,

			id: null,

			localErrorMessage: '',

			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			formData: {
				title: ' '
			},

			formInfo: null,

			buttonBlock: 0,

			refreshMiniAvatar: false,

			isFormSubmited: false,

			showMoneyModal: false,
			moneyModalTitle: '',
			moneyModalText: '',
			moneyModalAddButton: '',

			showTemplateModal: false,
			templateField: {
				required: true,
				type: 'list',
				list: [],
				title: 'mails/templates',
				_field_name: 'ticketTemplateModalValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/text/list?search=template&category=notice&q='
			},

			showSshKeyModal: false,
			sshKeyFields: null,

			showPayerDialogModal: false,

			clearSettings: false,

			FD: false,
			FD_count: 0,

			listKeyDownTimer: null,

			trackNo: 0,

			audio: null,
			canPlay: false,

			whatVolume: true,

			dataCenterRequestCache: {},

			verifyRequestsHandlers: [],

			activeCreateVdsTemplateTab: '',
			createVdsTemplateTabCache: {
				tab: null,
				account_id: null,
				datacenter_id: null
			},

			showDeleteModal: false,
			deleteModalValue: null,
			deleteModalText: '',
			deleteButtonTitle: '',
			deleteModalTimer: null,
			deleteModalTimerHandler: null,

			show2FADialogModal: false,
			fields2FA: null,

			isoFormTimer: null,
			isoFormFileHost: '',
			isoFormFileToken: null,
			isoFormFileProgress: '',

			params: null,

			isConstructPlanChanged: false,

			outerDiskTypeValue: 17,
			outerDiskSavedFields: null,
			outerDiskRequestType: false,
			outerDiskFormsCache: {},

			showGeneralDialog: false,
			generalDialogTitle: '',
			generalDialogText: '',
			generalDialogButtonStyle: 0,
			generalDialogCallback: function generalDialogCallback() {},
			generalDialogButtonTitle: '',
			generalDialogTimer: 0,
			generalDialogTimerHandler: null,

			intersectionObserver: null,
			isFormButtonFixed: false
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		linkHint: function linkHint() {
			if (this.crud && this.action && this.Config && this.Config[this.crud] && this.Config[this.crud]['hint-link'] && this.Config[this.crud]['hint-link'][this.action]) return this.Config[this.crud]['hint-link'][this.action];

			return false;
		},
		linkHintShowIf: function linkHintShowIf() {
			var _this = this;

			if (!this.linkHint) return false;

			if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.linkHint) === 'object' && !Array.isArray(this.linkHint)) {
				if (this.linkHint.showIfField) {
					var _field = this.findField(this.linkHint.showIfField);
					if (!_field) return false;

					return _field['_visible'];
				}
			} else if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.linkHint) === 'object' && Array.isArray(this.linkHint)) {
				var _result = false;
				this.linkHint.some(function (item) {
					if (item.showIfField) {
						var _field2 = _this.findField(item.showIfField);
						if (_field2) {
							_result = _field2['_visible'];
							return true;
						}
					}
				});

				return _result;
			}

			return true;
		},
		showAdditionalInfo: function showAdditionalInfo() {
			if (this.$store.state.user_type !== 'client') return false;

			if (!this.formInfo || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.formInfo) !== 'object' || !__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.formInfo).length) return false;

			if (Array.isArray(this.formInfo)) return false;

			if (!('max' in this.formInfo) && !('cost' in this.formInfo.max)) return false;

			if (this.formInfo.max >= 100000) return false;

			return true;
		},
		showPayButton: function showPayButton() {
			return this.$store.state.user_type !== 'admin' && this.crud === 'operation' && this.action === 'create';
		},
		showAutoPaymentButton: function showAutoPaymentButton() {
			if (!this.showPayButton) return false;

			var _savedField = this.findField('saved');
			if (_savedField && _savedField.list && _savedField.list.length) {
				return true;
			}

			return false;
		},
		isSubmitButtonEnabled: function isSubmitButtonEnabled() {
			if (this.crud !== 'operation' || this.action !== 'create') return true;

			if (this.$store.state.user_type === 'admin') return true;

			var _savedField = this.findField('saved');
			var _paymentField = this.findField('payment');

			if (_savedField && _savedField.value) return true;
			if (_paymentField && _paymentField.value) return true;

			return false;
		},
		isFormLocked: function isFormLocked() {
			if (this.crud === 'paymentauto') {
				var _savedField = this.findField('saved_id');

				if (this.$store.state.user_type === 'client') {
					if (_savedField && (!_savedField.list || !_savedField.list.length)) {
						return true;
					}
				}
			}

			return false;
		},
		isFormWithDivider: function isFormWithDivider() {
			if (!this.formData.fields) return false;

			var _found = false;
			this.formData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj.type === 'header' && obj._visible) {
							_found = true;
							return true;
						}
					});

					if (_found) return true;
				}
			});

			return _found;
		},
		isFormWithNumberDivider: function isFormWithNumberDivider() {
			if (!this.formData.fields) return false;

			var _found = false;
			this.formData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj.type === 'header' && obj._visible && obj.number) {
							_found = true;
							return true;
						}
					});

					if (_found) return true;
				}
			});

			return _found;
		}
	},
	created: function created() {
		var _this2 = this;

		this.$store.commit('changedForm', false);

		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.initData(this.$route.path);

		if (this.crud === 'ticket') {
			__WEBPACK_IMPORTED_MODULE_16_jquery___default.a.fn.setCursorPosition = function (pos) {
				this.each(function (index, elem) {
					if (elem.setSelectionRange) {
						elem.setSelectionRange(pos, pos);
					} else if (elem.createTextRange) {
						var range = elem.createTextRange();
						range.collapse(true);
						range.moveEnd('character', pos);
						range.moveStart('character', pos);
						range.select();
					}
				});

				return this;
			};
		}

		this.firstTimeRequestData().then(function () {
			if (_this2.crud) _this2.requestData();
		});
	},
	mounted: function mounted() {
		this.dataCenterRequestCache = {};

		document.addEventListener('keydown', this.keyDownHandler);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-block-application', this.blockApplicationHandler);

		window.onbeforeunload = this.onBeforeUnload;

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-user-options-on-server', this.optionHandler);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-goto-url', this.gotoUrl);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-payment-bank-legal', this.bankLegalPaySubmit);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-show-payer-dialog', this.showPayerDialog);

		window.addEventListener('storage', this.onLocalStorageEvent);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$on('w5-vds-create-field-reloaded', this.handleCreateFieldReloaded);

		if (this.crud === 'options') {
			this.whatVolume = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification);

			if (!('play_audio_on_notification' in this.$store.state.userServerOptions)) this.whatVolume = true;

			var _name = 'audioNotif_';
			if (['00', '01', '02', '03', '04', '05'].indexOf(this.$store.state.userServerOptions.audio_track_on_notification) > -1) {
				this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10);
				_name += this.$store.state.userServerOptions.audio_track_on_notification;
			} else {
				this.trackNo = 0;
				_name += '00';
			}

			this.audio = this.$refs[_name];
			if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay);
		}

		if (this.$refs['button_wrapper']) {
			this.intersectionObserver = new IntersectionObserver(this.handleObserver, { threshold: 0 });
			this.intersectionObserver.observe(this.$refs['button_wrapper']);
		}
	},
	updated: function updated() {
		var _this3 = this;

		this.$nextTick(function () {
			if (_this3.localErrorMessage || _this3.form_ErrorMessage) {
				__WEBPACK_IMPORTED_MODULE_16_jquery___default()('body, html').animate({ scrollTop: 0 }, 500);
			}
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.dataCenterRequestCache = {};

		document.removeEventListener('keydown', this.keyDownHandler);
		window.onbeforeunload = null;
		window.removeEventListener('storage', this.onLocalStorageEvent);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-block-application', this.blockApplicationHandler);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-user-options-on-server', this.optionHandler);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-goto-url', this.gotoUrl);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-payment-bank-legal', this.bankLegalPaySubmit);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-show-payer-dialog', this.showPayerDialog);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged);
		__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$off('w5-vds-create-field-reloaded', this.handleCreateFieldReloaded);

		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

		if (this.isoFormTimer) {
			clearInterval(this.isoFormTimer);
			this.isoFormTimer = null;
		}

		if (this.generalDialogTimerHandler) {
			clearInterval(this.generalDialogTimerHandler);
			this.generalDialogTimerHandler = null;
		}

		if (this.deleteModalTimerHandler) {
			clearInterval(this.deleteModalTimerHandler);
			this.deleteModalTimerHandler = null;
		}

		if (this.intersectionObserver && this.$refs['button_wrapper']) {
			this.intersectionObserver.unobserve(this.$refs['button_wrapper']);
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState());
	},

	methods: {
		firstTimeRequestData: function firstTimeRequestData() {
			var _this4 = this;

			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
				var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
					return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									if (!(_this4.crud === 'vds' && _this4.action === 'create')) {
										_context.next = 4;
										break;
									}

									if (_this4.$store.state.isLastTemplateGroupCacheLoaded) {
										_context.next = 4;
										break;
									}

									_context.next = 4;
									return _this4.$store.dispatch('getTemplateGroupCache');

								case 4:
									resolve();

								case 5:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this4);
				}));

				return function (_x) {
					return _ref2.apply(this, arguments);
				};
			}());
		},
		LinkHintForField: function LinkHintForField(field, links) {
			if (!field || !links) return null;
			if ((typeof links === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(links)) === 'object' && !Array.isArray(links)) {
				if (links.showIfField === field._field_name) return links;
			} else if ((typeof links === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(links)) === 'object' && Array.isArray(links)) {
				var _result = null;
				links.some(function (item) {
					if (item.showIfField === field._field_name) {
						_result = item;
						return true;
					}
				});

				return _result;
			}

			return null;
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.hideMoneyModal();
				this.hideTemplateModal();
				this.hideSshKeyModal();
				this.hidePayerDialogModal();
				this.hideDeleteModal();
				this.hide2FADialogModal();
				this.hideGeneralDialog();
			}
		},
		MoveToFieldWithError: function MoveToFieldWithError() {
			var _this5 = this;

			this.$nextTick(function () {
				if (!_this5.formData || !_this5.formData.fields) return;

				var _isError = false;
				_this5.formData.fields.some(function (item) {
					if (item && Array.isArray(item)) {
						item.some(function (obj) {
							if (obj && obj['_errMsg']) {
								_isError = obj['_field_name'];
								return true;
							}
						});

						if (_isError) return true;
					}
				});

				if (_isError) {
					var _ref = _this5.$refs[_isError];
					if (_ref && _ref[0] && _ref[0].$el) {
						var _$el = __WEBPACK_IMPORTED_MODULE_16_jquery___default()(_ref[0].$el);
						if (_$el.length) __WEBPACK_IMPORTED_MODULE_16_jquery___default()('html, body').animate({ scrollTop: _$el.offset().top - 45 }, 400);
					}
				}
			});
		},
		submitForm: function submitForm(e) {
			var _this6 = this;

			if (this.crud === 'iso' && this.action === 'create' && e !== 'submit-iso-form') {
				this.submitIsoForm();
				return;
			}

			this.localErrorMessage = '';
			this.localSuccessMessage = '';

			this.outerDiskRequestType = false;

			var _rows = this.formData['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				this.localErrorMessage = 'error/app_internal';
				this.buttonBlock = 0;
				return;
			}

			var _arrayFieldError = __WEBPACK_IMPORTED_MODULE_11__validators_array__["a" /* default */].validatorArray(this.form_GetData.fields, this.crud);

			if (_arrayFieldError) {
				if (_arrayFieldError === true) {
					this.localErrorMessage = 'main/validation_error';
					this.buttonBlock = 0;
					return;
				} else {
						for (var _fieldName in _arrayFieldError) {
							var _fld = this.findField(_fieldName);
							if (_fld) {
								_fld['_errMsg'] = _arrayFieldError[_fieldName];
								__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
							}
						}
					}

				this.buttonBlock = 0;
				this.MoveToFieldWithError();
				return;
			}

			var _data = this.collectData(_rows);

			if (_data === false) {
				this.buttonBlock = 0;
				this.MoveToFieldWithError();
				return;
			}

			if (this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client' && this.isAccess('operation/create')) {
				if (e !== 'nextStep' && e !== 'nextStep2') return;

				if (e === 'nextStep') {
					var _paymentCase = null;
					var _isSaved = false;

					var _savedField = this.findField('saved');
					if (_savedField && _savedField.list && _savedField.list.length && 'value' in _savedField && _savedField['value'] !== null && _savedField['value'] !== undefined && _savedField._visible === true) {
						_savedField.list.some(function (f) {
							if (String(f.id) === String(_savedField.value)) {
								_paymentCase = f;
								_isSaved = true;
								return true;
							}
						});
					}

					if (!_paymentCase) {
						var _paymentField = this.findField('payment');
						if (_paymentField && _paymentField.list && _paymentField.list.length && 'value' in _paymentField && _paymentField['value'] !== null && _paymentField['value'] !== undefined && _paymentField._visible === true) {
							_paymentField.list.some(function (f) {
								if (String(f.id) === String(_paymentField.value)) {
									_paymentCase = f;
									_isSaved = false;
									return true;
								}
							});
						}
					}

					if (_paymentCase) {
						this.buttonBlock = 0;

						var _curSumma = 0;
						var _smField = this.findField('summa');
						if (_smField && 'value' in _smField) _curSumma = parseFloat(_smField.value);
						if (isNaN(_curSumma) || _curSumma < 0) _curSumma = 0;

						var _com = _paymentCase['comission'];
						if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0;
						_com = parseFloat(_com);
						var _price = (_curSumma + _com * _curSumma / 100.0).toFixed(2);
						_price = parseFloat(_price);

						var _text = this.localeFtc('operation/payment_info').replace('{saved}', _isSaved ? this.localeFtc(' (payment/saved_title)') : '').replace('{name}', _paymentCase['name'] ? this.localeFtc(_paymentCase['name']) : this.localeFtc('payment/usual_title')).replace('{com}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_com, 2)).replace('{sum}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_price, 2)).replace('{val}', this.localeFtc('main/ruble')) + '<br><br>' + '<w>' + this.localeFtc('operation/payment_warning') + '</w>';

						this.generalDialogShow('main/refresh_screen', _text, this.localeFtc('main/continue'), function () {
							_this6.hideGeneralDialog();
							_this6.submitForm('nextStep2');
						});

						return;
					}
				}
			}

			if (this.crud === 'vds' && this.action === 'create') {
				var tempField = this.findField('template_id');
				var backField = this.findField('backup_id');
				var isoField = this.findField('iso_id');

				if (!tempField && !backField && !isoField) {
					this.localErrorMessage = 'template/not_selected';
					this.buttonBlock = 0;
					return;
				}

				if (!tempField.value && !backField.value && !isoField.value) {
					var _errText = '';
					if (this.activeCreateVdsTemplateTab === 'backup') {
						_errText = 'backup/not_selected';
					} else if (this.activeCreateVdsTemplateTab === 'iso') {
						_errText = 'iso/not_selected';
					} else {
						_errText = 'template/not_selected';
					}

					if (tempField) tempField._errMsg = _errText;else this.localErrorMessage = _errText;

					this.buttonBlock = 0;
					this.MoveToFieldWithError();
					return;
				}
			}

			if ((this.crud === 'vds' || this.crud === 'certificate') && this.$store.state.user_type === 'client' && this.moneyModalAddButton !== 'continue') {
				var _fieldPlan = this.findField('plan_id');
				if (!_fieldPlan || !('value' in _fieldPlan) || !_fieldPlan['list'] || !Array.isArray(_fieldPlan['list'])) {
					this.localErrorMessage = 'plan/not_found';
					this.buttonBlock = 0;
					return;
				}

				var _plan = false;
				_fieldPlan['list'].some(function (item) {
					if (String(item['id']) === String(_fieldPlan['value'])) {
						_plan = item;
						return true;
					}
				});

				if (!_plan) {
					this.localErrorMessage = 'plan/not_found';
					this.buttonBlock = 0;
					return;
				}

				if (!this.$store.state.user_balance || this.$store.state.user_balance.real === undefined || this.$store.state.user_balance.real === null) {
					this.localErrorMessage = this.localeFtc('operation/purse_real: error/unknown');
					this.buttonBlock = 0;
					return;
				}

				var _cost = parseFloat(_plan['cost']);
				var _minMoney = parseFloat(_plan['min_money']);
				var _canBonus = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(_plan['can_bonus']);
				var _period = _plan['period_name'] ? this.localeFtc(_plan['period_name']) : this.localeFtc(_plan['period']);
				var _realBalance = parseFloat(this.$store.state.user_balance.real);
				var _bonusBalance = parseFloat(this.$store.state.user_balance.bonus);
				var _text2 = '';
				var _newSum = 0.0;
				this.moneyModalAddButton = '';

				if (_plan.has_params && _plan.params && _plan.data) {
					if (_plan.data.cpu && _plan.data.cpu.value) {
						var _v = parseFloat(_plan.data.cpu.value) - parseFloat(_plan.params && _plan.params.cpu && _plan.params.cpu.min ? _plan.params.cpu.min : 0);
						var _c = _plan.params && _plan.params.cpu && (_plan.params.cpu.cost || _plan.params.cpu.full_cost) ? Math.min(parseFloat(_plan.params.cpu.cost), parseFloat(_plan.params.cpu.full_cost)) : 0;
						_cost += _v * _c;
					}

					if (_plan.data.ram && _plan.data.ram.value) {
						var _v2 = parseFloat(_plan.data.ram.value) - parseFloat(_plan.params && _plan.params.ram && _plan.params.ram.min ? _plan.params.ram.min : 0);
						var _c2 = _plan.params && _plan.params.ram && (_plan.params.ram.cost || _plan.params.ram.full_cost) ? Math.min(parseFloat(_plan.params.ram.cost), parseFloat(_plan.params.ram.full_cost)) : 0;
						_cost += _v2 * _c2;
					}

					if (_plan.data.disk && _plan.data.disk.value) {
						var _v3 = parseFloat(_plan.data.disk.value) - parseFloat(_plan.params && _plan.params.disk && _plan.params.disk.min ? _plan.params.disk.min : 0);
						var _c3 = _plan.params && _plan.params.disk && (_plan.params.disk.cost || _plan.params.disk.full_cost) ? Math.min(parseFloat(_plan.params.disk.cost), parseFloat(_plan.params.disk.full_cost)) : 0;
						_cost += _v3 * _c3;
					}

					if (this.params && this.params['params[ip4]']) {
						var _c4 = _plan.params && _plan.params.ip4 && (_plan.params.ip4.cost || _plan.params.ip4.full_cost) ? Math.min(parseFloat(_plan.params.ip4.cost), parseFloat(_plan.params.ip4.full_cost)) : 0;
						_cost += _c4;
					}

					_cost = parseFloat(_cost.toFixed(2));
				}

				this.moneyModalTitle = 'service/create_title';
				if (this.crud === 'vds') this.moneyModalTitle = 'service/creating_vds';

				if (_realBalance < _minMoney) {
					if (_minMoney <= 0) {
						_newSum = Math.abs(_realBalance);

						_text2 = this.localeFtc('service/creating_min_money_0').replace('{sum}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_newSum, 2)).replace('{val}', this.localeFtc('main/ruble'));
					} else {
							_text2 = this.localeFtc('service/creating_min_money_1').replace('{sum}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_minMoney, 2)).replace('{val}', this.localeFtc('main/ruble'));

							_newSum = parseFloat((_minMoney - _realBalance).toFixed(2));
						}

					var _limit = this.AppName === 'vdsina.com' ? 100 : 10000;
					this.$store.commit('setOperationSumNew', _newSum > _limit ? _newSum : _limit);

					this.moneyModalText = _text2;
					__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					this.showMoneyModal = true;

					return;
				} else {
						var _showModal = false;

						if (_realBalance < _cost) {
							if (_canBonus) {
								if (_bonusBalance < _cost) _showModal = true;
							} else _showModal = true;
						}

						if (_showModal) {
							_text2 = this.localeFtc('service/creating_not_enough').replace('{sum1}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_cost, 2)).replace('{val}', this.localeFtc('main/ruble')).replace('{period}', _period).replace('{sum2}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_realBalance, 2)).replace('{val}', this.localeFtc('main/ruble'));

							_newSum = parseFloat((_cost - _realBalance).toFixed(2));

							var _limit2 = this.AppName === 'vdsina.com' ? 100 : 10000;
							this.$store.commit('setOperationSumNew', _newSum > _limit2 ? _newSum : _limit2);

							this.moneyModalText = _text2;

							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
							this.showMoneyModal = true;

							return;
						}
					}
			}

			if (this.crud === 'disks' && this.action === 'update') {
				if (e !== 'nextStep') {
					var _quantityField = this.findField('quantity');

					if (_quantityField && '_oldValue' in _quantityField && 'value' in _quantityField && 'cost' in _quantityField) {
						var _old = parseFloat(_quantityField._oldValue);
						var _new = parseFloat(_quantityField.value);
						var _cost2 = parseFloat(_quantityField.cost);
						var _attached = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(_quantityField.attached);

						if (!isNaN(_old) && !isNaN(_new) && !isNaN(_cost2) && _old < _new) {
							var _sum = parseFloat((_new - _old).toFixed(2)) * _cost2;
							var _text3 = this.localeFtc('service/extdisk_increase_note').replace('{cost}', __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatMoney2(_sum, 2)).replace('{val}', this.localeFtc('main/ruble'));

							if (_attached) {
								_text3 += '<br><br>\n\n' + this.localeFtc('service/iso_operation_warning');
							}

							this.buttonBlock = 0;

							this.generalDialogShow('main/refresh_screen', _text3, this.localeFtc('main/continue'), function () {
								_this6.hideGeneralDialog();
								_this6.submitForm('nextStep');
							});

							return;
						}
					}
				}
			}

			if (this.moneyModalAddButton === 'continue') this.moneyModalAddButton = '';

			if (this.buttonBlock <= 0) this.buttonBlock = 1;

			var _url = this.$route.path;

			if (_url === '/options') _url = this.$store.state.user_type === 'admin' ? '/admin/options' : '/user/options';else if (_url === '/iso/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_ISO;else if (_url === '/vds/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS;else if (_url === '/certificate/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_SSL;else if (_url === '/domains/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DOMAIN;else if (_url.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/');else if (_url === '/dns/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DNS;else if (_url.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/');else if (_url === '/bonus/activate') _url = '/bonus/convert';else if (_url === '/ipptrpool/create') _url += '/' + this.id;else if (_url === '/disks/create') _url = '/service/create/' + this.outerDiskTypeValue;else if (_url.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/');

			_data = this.FD_rePack(_data);

			var _post = {
				'_csrf': this.form_GetData._csrf
			};
			_post[this.form_GetData.model] = _data;

			this.FD = new FormData();
			this.FD_count = 0;
			this.FD_prepare(_post);

			if (this.crud === 'ticket') this.$store.commit('ItIsMe', true);

			if (this.verifyRequestsHandlers && this.verifyRequestsHandlers.length) {
				this.verifyRequestsHandlers.forEach(function (item) {
					if (item && item.abort) item.abort();
				});

				this.verifyRequestsHandlers = [];
			}

			this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(function (resPost) {
				var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

				if (_dt && _dt['status'] === 'ok') {
					if (_this6.$route.path === '/options') {
						_this6.buttonBlock = 0;

						_this6.setLocalSuccessMessage('main/save_success');

						if (_this6.clearSettings) _this6.clearSettingsStart();

						_this6.refreshMiniAvatar = true;

						_this6.requestData(true);
					} else if (_this6.$route.path.indexOf('/user/alerts') === 0) {
						_this6.buttonBlock = 0;

						_this6.setLocalSuccessMessage('main/save_success');

						_this6.requestData(true);
					} else if (_this6.crud === 'operation' && _this6.action === 'create' && _this6.$store.state.user_type === 'client' && e === 'nextStep' && _dt['operation'] && _dt['operation']['operation_id']) {
							_this6.isFormSubmited = true;

							_this6.$router.push('/operation/pay/' + _dt['operation']['operation_id']);
						} else if (_this6.crud === 'ticketmessage' && _this6.action === 'update' && _this6.$store.state.ticketData.ticketUpdateId) {
								_this6.isFormSubmited = true;

								_this6.$router.push('/ticket/view/' + _this6.$store.state.ticketData.ticketUpdateId);
							} else if (_this6.crud === 'user' && _this6.action === 'alerts') {
									_this6.isFormSubmited = true;

									_this6.buttonBlock = 0;
									_this6.$router.go(-1);
								} else if (_this6.crud === 'dns-records' || _this6.crud === 'bonus' && _this6.action === 'activate') {
										_this6.isFormSubmited = true;

										_this6.buttonBlock = 0;
										_this6.$router.go(-1);
									} else if (_this6.crud === 'payer' && _this6.action === 'create') {
											_this6.isFormSubmited = true;

											_this6.buttonBlock = 0;
											_this6.$router.go(-1);
										} else if (_this6.crud === 'ipptrpool') {
												_this6.isFormSubmited = true;

												_this6.buttonBlock = 0;
												_this6.$router.go(-1);
											} else if (_this6.crud === 'disks') {
													_this6.isFormSubmited = true;

													_this6.buttonBlock = 0;
													_this6.$router.push('/disks/list');
												} else if (_this6.crud === 'vds') {
														_this6.isFormSubmited = true;

														var _backUrl = '/vds/list';
														if (_this6.$store.state.lastWorkedPage[_this6.crud] && _this6.$store.state.lastWorkedPage[_this6.crud] > 1) _backUrl = _backUrl + '/' + _this6.$store.state.lastWorkedPage[_this6.crud];
														_this6.$router.push(_backUrl);
													} else {
														if (_this6.crud === 'ticket' && _this6.action === 'create') {
															if (_dt.ticket && _dt.ticket.ticket_id) {
																if (_this6.$store.state.user_type === 'client') {
																	_this6.isFormSubmited = true;

																	_this6.$router.push('/ticket/view/' + _dt.ticket.ticket_id);

																	return;
																} else {
																	_this6.$store.commit('setLastRow', { 'crud': _this6.crud, 'id': _dt.ticket.ticket_id });
																	_this6.setLocalSuccessMessage(_dt.title);
																}
															}
														}

														_this6.isFormSubmited = true;

														var _backUrl2 = '/' + _this6.crud + '/list';
														if (_this6.$store.state.lastWorkedPage[_this6.crud] && _this6.$store.state.lastWorkedPage[_this6.crud] > 1) _backUrl2 = _backUrl2 + '/' + _this6.$store.state.lastWorkedPage[_this6.crud];
														_this6.$router.push(_backUrl2);
													}

					return;
				}

				if (_dt && _dt['status'] === 'redirect' && _dt['url'] && String(_dt['url']).length) {
					_this6.isFormSubmited = true;

					var url = _dt['url'];
					if (url[0] !== '/') url = '/' + url;
					_this6.$router.push(url);
					return;
				}

				if (_dt && _dt['status'] === 'error' && _dt['fields']) {
					var _txtError = '';
					var _isFieldError = false;

					for (var k in _dt['fields']) {
						if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
							var _fld2 = _this6.findField(k);

							if (_fld2) {
								_isFieldError = true;
								_fld2['_errMsg'] = _this6.localeFtc(_dt['fields'][k].join(' <br> '));
								__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
							} else {
								var _m = k.match(/^params\[(.*)\]$/i);
								if (_m && _m.length && _m[1]) {
									_txtError += String(_m[1]).toUpperCase() + ': ' + _this6.localeFtc(_dt['fields'][k].join(' <br> '));
								} else _txtError += _this6.localeFtc(_dt['fields'][k].join(' <br> '));
							}
						}
					}
					if (_txtError) _this6.localErrorMessage = _txtError;
					if (_isFieldError) _this6.MoveToFieldWithError();

					_this6.buttonBlock = 0;
					return;
				}

				_this6.localErrorMessage = _this6.formatRequestError(resPost);
				_this6.buttonBlock = 0;
			}, function (resPost) {
				_this6.localErrorMessage = _this6.formatRequestError(resPost);
				_this6.buttonBlock = 0;
			});
		},
		submitIsoForm: function submitIsoForm() {
			var _this7 = this;

			this.localErrorMessage = '';
			this.localSuccessMessage = '';

			var _fieldAccount = this.findField('account_id');
			if (!_fieldAccount || !_fieldAccount.value) {
				if (this.$store.state.user_type === 'admin') _fieldAccount._errMsg = 'error/required_field';else this.localErrorMessage = 'error/app_internal';
				return;
			}

			var _fieldFile = this.findField('file');
			if (!_fieldFile || !_fieldFile.value || !_fieldFile.host) {
				this.localErrorMessage = 'error/app_internal';
				return;
			}

			this.isoFormFileHost = _fieldFile.host;
			this.isoFormFileToken = _fieldFile.value;

			this.isoFormFileProgress = '';

			var _fieldType = this.findField('load_type');
			if (!_fieldType || !_fieldType.value) {
				this.localErrorMessage = 'error/app_internal';
				this.buttonBlock = 0;
				return;
			}
			if (_fieldType.value !== 'download' && _fieldType.value !== 'library' && _fieldType.value !== 'upload') {
				_fieldType._errMsg = 'upload/incorrect_filetype';
				this.buttonBlock = 0;
				this.MoveToFieldWithError();
				return;
			}

			var _postData = {};

			var _field = this.findField(_fieldType.value);
			if (!_field) {
				this.localErrorMessage = 'error/app_internal';
				this.buttonBlock = 0;
				return;
			}
			if (!_field.value) {
				_field._errMsg = 'person/error_required';
				this.buttonBlock = 0;
				this.MoveToFieldWithError();
				return;
			}

			if (_fieldType.value === 'upload') {
				_postData.file = _field.value;
			}

			if (_fieldType.value === 'download') {
				_postData.url = _field.value;
			}

			if (_fieldType.value === 'library') {
				_postData.name = _field.value;
			}

			if (this.buttonBlock <= 0) this.buttonBlock = 1;
			this.$set(_fieldAccount, 'readonly', true);
			this.$set(_fieldType, 'readonly', true);
			this.$set(_field, 'readonly', true);

			var _url = _fieldFile.host + '/' + _fieldType.value + '/' + _fieldFile.value;

			if (_fieldType.value === 'upload') {
				__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-iso-form-upload', _url);

				return;
			}

			__WEBPACK_IMPORTED_MODULE_16_jquery___default.a.post(_url, _postData).done(function (answer, x, z) {
				if (answer && answer.status === 'ok') {
					var status = 0;
					if (z && z.status) status = z.status;

					if (status === 200) {
						_this7.submitForm('submit-iso-form');
						return;
					}

					if (status === 201 || status === 202) {
						_this7.isoFormFileProgress = '...';
						_this7.isoFormTimer = setInterval(_this7.isoFormTimerFunc, 3000);
						return;
					}
				}

				_this7.$set(_fieldAccount, 'readonly', false);
				_this7.$set(_fieldType, 'readonly', false);
				_this7.$set(_field, 'readonly', false);

				var msg = 'error/app_internal';
				if (z && z.responseJSON && z.responseJSON.text) msg = _this7.localeFtc(z.responseJSON.text);

				_this7.localErrorMessage = msg;

				_this7.isoFormUpdateOnError();
			}).fail(function (error, x, z) {
				_this7.$set(_fieldAccount, 'readonly', false);
				_this7.$set(_fieldType, 'readonly', false);
				_this7.$set(_field, 'readonly', false);

				var msg = 'error/app_internal';
				if (error && error.responseJSON && error.responseJSON.text) msg = _this7.localeFtc(error.responseJSON.text);

				_this7.localErrorMessage = msg;

				_this7.isoFormUpdateOnError();
			});
		},
		isoFormUpdateOnError: function isoFormUpdateOnError() {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _key;

				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (_this8.isoFormTimer) {
									clearInterval(_this8.isoFormTimer);
									_this8.isoFormTimer = null;
								}

								if (!(_this8.isoFormFileHost && _this8.isoFormFileToken)) {
									_context2.next = 4;
									break;
								}

								_context2.next = 4;
								return __WEBPACK_IMPORTED_MODULE_16_jquery___default.a.get(_this8.isoFormFileHost + '/delete/' + _this8.isoFormFileToken);

							case 4:
								_this8.isoFormFileHost = '';
								_this8.isoFormFileToken = null;
								_this8.isoFormFileProgress = '';

								_key = 'formStorage_' + _this8.$route.path.replace(/\//g, '_');

								window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this8.formData));

								_this8.requestData(true);

							case 10:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this8);
			}))();
		},
		isoFormTimerFunc: function isoFormTimerFunc() {
			var _this9 = this;

			if (!this.isoFormFileHost || !this.isoFormFileToken) {
				this.localErrorMessage = 'error/app_internal';
				this.isoFormUpdateOnError();
				return;
			}

			var _url = this.isoFormFileHost + '/status/' + this.isoFormFileToken;
			__WEBPACK_IMPORTED_MODULE_16_jquery___default.a.get(_url).done(function (answer, x, z) {
				if (answer) {
					var status = answer.status;

					if (status === 'upload' || status === 'download' || status === 'library') {
						return;
					}

					if (status === 'new') {
						return;
					}

					if (status === 'processing') {
						var str = String(answer.status_msg);
						var m = str.match(/(\d+%)/g);
						if (m && m[0]) _this9.isoFormFileProgress = m[0];
						return;
					}

					if (status === 'done') {
						clearInterval(_this9.isoFormTimer);
						_this9.isoFormTimer = null;

						_this9.submitForm('submit-iso-form');
						return;
					}
				}

				clearInterval(_this9.isoFormTimer);
				_this9.isoFormTimer = null;

				var msg = 'error/app_internal';
				if (z && z.responseJSON && z.responseJSON.text) msg = _this9.localeFtc(z.responseJSON.text);

				_this9.localErrorMessage = msg;

				_this9.isoFormUpdateOnError();
			}).fail(function (error, x, z) {
				clearInterval(_this9.isoFormTimer);
				_this9.isoFormTimer = null;

				var msg = 'error/app_internal';
				if (error && error.responseJSON && error.responseJSON.text) msg = _this9.localeFtc(error.responseJSON.text);

				_this9.localErrorMessage = msg;

				_this9.isoFormUpdateOnError();
			});
		},
		initData: function initData(path) {
			this.crud = null;
			this.action = null;
			this.id = null;
			this.localErrorMessage = '';
			this.localSuccessMessage = '';
			this.isFormSubmited = false;
			this.clearSettings = false;
			this.formInfo = null;
			this.outerDiskFormsCache = {};

			this.$store.commit('changedForm', false);

			this.hideMoneyModal();
			this.hideTemplateModal();
			this.hideSshKeyModal();
			this.hidePayerDialogModal();
			this.hideDeleteModal();
			this.hide2FADialogModal();
			this.hideGeneralDialog();

			if (path === '/options') {
				this.crud = 'options';
				this.action = 'update';
			} else {
				var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

				if (_urlParts.length < 2 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length) {
					this.localErrorMessage = 'main/unknown_page';
					return;
				}

				if (_urlParts[1] !== 'create' && _urlParts[1] !== 'update' && _urlParts[1] !== 'alerts' && _urlParts[1] !== 'clone' && _urlParts[1] !== 'activate' && _urlParts[1] !== 'links') {
					this.localErrorMessage = 'main/unknown_page';
					return;
				}

				if ((_urlParts[1] === 'update' || _urlParts[1] === 'clone' || _urlParts[1] === 'links') && (_urlParts[2] === undefined || _urlParts[2] === null || _urlParts[2] === '')) {
					this.localErrorMessage = 'main/unknown_page';
					return;
				}

				this.crud = _urlParts[0];
				this.action = _urlParts[1];

				if (_urlParts[2]) this.id = _urlParts[2];

				if (this.crud === 'ipptrpool' && this.action === 'create') {
					if (!this.id) {
						this.localErrorMessage = 'main/unknown_page';
						return;
					}
				}

				if (this.$route.path === '/notes/create') {
					var _key = 'w5_' + this.$store.state.user_id + '_notes_create';

					if (!this.$store.state.createNoteData) {
						var _objNote = false;
						if (window.sessionStorage) _objNote = window.sessionStorage.getItem(_key);
						if (!_objNote) {
							this.localErrorMessage = 'Не задан объект для заметки';
						} else {
							var _data = JSON.parse(_objNote);
							if (!_data) {
								this.localErrorMessage = 'Не задан объект для заметки';
							} else {
								this.$store.commit('createNoteData', _data);
							}
						}
					} else {
						if (window.sessionStorage) {
							try {
								window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.createNoteData));
							} catch (_err) {
								if (this.$store.state.isDebug) window.DEBUG.error('Uid0: ' + _err.message);
							}
						}
					}
				}
			}
		},
		requestData: function requestData(isSilence) {
			var _this10 = this;

			var _url = this.$route.path;

			if (this.crud === 'vds' && this.$route && this.$route.params && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.$route.params) === 'object' && 'groupId' in this.$route.params && 'planId' in this.$route.params) {
				__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].setCookie('crtvdsplan', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ group: this.$route.params['groupId'], plan: this.$route.params['planId'] }), { 'expires': 60 * 60 * 24, 'domain': __WEBPACK_IMPORTED_MODULE_7_vue__["default"].CookieDomain, 'path': '/' });

				this.$router.replace('/vds/create');
				return;
			}

			if (_url === '/options') _url = this.$store.state.user_type === 'admin' ? '/admin/options' : '/user/options';else if (_url === '/iso/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_ISO;else if (_url === '/vds/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS;else if (_url === '/certificate/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_SSL;else if (_url === '/domains/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DOMAIN;else if (_url.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/');else if (_url === '/dns/create') _url = '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DNS;else if (_url.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/');else if (_url === '/bonus/activate') _url = '/bonus/convert';else if (_url === '/ipptrpool/create') _url += '/' + this.id;else if (_url === '/disks/create') {
				if (this.outerDiskFormsCache[this.outerDiskTypeValue]) {
					try {
						var _data = JSON.parse(this.outerDiskFormsCache[this.outerDiskTypeValue]);

						this.formData = this.parseFormData(_data);

						if ('info' in _data && _data['info']) this.formInfo = _data['info'];

						var _quantityField = this.findField('quantity');
						if (_quantityField) {
							if (this.action === 'create') {
								if ('min' in _quantityField) {
									_quantityField['value'] = _quantityField.min;
								}

								if (this.formInfo && 'cost' in this.formInfo && !('cost' in _quantityField)) {
									_quantityField['cost'] = this.formInfo.cost;
									_quantityField['full_cost'] = this.formInfo.full_cost;
									_quantityField['period'] = this.formInfo.period;
								}

								if (this.formInfo && 'backup' in this.formInfo && !('backup' in _quantityField)) {
									_quantityField['backup'] = this.formInfo.backup;
								}
							}
						}

						if (this.outerDiskSavedFields) {
							this.$nextTick(function () {
								for (var _key in _this10.outerDiskSavedFields) {
									var _formOuterDiskForm = _this10.findField(_key);
									if (_formOuterDiskForm) {
										_this10.$set(_formOuterDiskForm, 'value', _this10.outerDiskSavedFields[_key]['value']);
										_this10.$set(_formOuterDiskForm, '_visible', _this10.outerDiskSavedFields[_key]['visible']);
									}
								}

								_this10.outerDiskSavedFields = null;
							});
						}

						this.outerDiskRequestType = false;

						return;
					} catch (e) {
						this.outerDiskFormsCache[this.outerDiskTypeValue] = null;
					}
				}
				_url = '/service/create/' + this.outerDiskTypeValue;
			} else if (_url.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/');

			if (isSilence === true) this.$store.commit('needShowLoader', false);

			this.forms_Get(_url, false, function (data) {
				if (data && data.status === 'redirect' && data.url) {
					window.location.replace(data.url);
					return;
				}

				_this10.outerDiskRequestType = false;

				_this10.$store.commit('needShowLoader', true);

				_this10.formData = _this10.parseFormData(data);

				if ('info' in data && data['info']) _this10.formInfo = data['info'];

				if (_url === '/service/create/' + _this10.outerDiskTypeValue) {
					_this10.outerDiskFormsCache[_this10.outerDiskTypeValue] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
				}

				if (_this10.crud === 'notes' && _this10.$store.state.createNoteData && _this10.$store.state.createNoteData['type'] && _this10.$store.state.createNoteData['id'] && _this10.$store.state.createNoteData['name']) {
					var _fieldType = _this10.findField('object_type');
					if (_fieldType) _fieldType['value'] = _this10.$store.state.createNoteData['type'];

					var _fieldId = _this10.findField('object_id');
					if (_fieldId) _fieldId['value'] = _this10.$store.state.createNoteData['id'];

					var _fieldName = _this10.findField('object_name');
					if (_fieldName) _fieldName['value'] = _this10.$store.state.createNoteData['name'];

					_this10.$store.commit('createNoteData', false);
				}

				if (_this10.crud === 'bonus' && _this10.action === 'activate' && _this10.$store.state.bonusActivateData) {
					if (_this10.$store.state.bonusActivateData['bonus']) {
						var _fieldBonus = _this10.findField('bonus_id');
						if (_fieldBonus) _fieldBonus['value'] = _this10.$store.state.bonusActivateData['bonus'];
					}

					if (_this10.$store.state.bonusActivateData['account'] && _this10.$store.state.bonusActivateData['account']['id'] && _this10.$store.state.bonusActivateData['account']['name']) {
						var _fieldAcc = _this10.findField('account_id');
						if (_fieldAcc) {
							_fieldAcc['value'] = _this10.$store.state.bonusActivateData['account']['id'];
							_fieldAcc['__valueName'] = _this10.$store.state.bonusActivateData['account']['name'];
						}
					}

					_this10.$store.commit('bonusActivateData', false);
				}

				if (_this10.crud === 'vds' || _this10.crud === 'certificate') {
					var _groupField = _this10.findField('plan_group_id');
					if (_this10.crud !== 'vds' && _groupField) _groupField['_visible'] = false;

					if (_this10.$store.state.vdsGroup && _this10.$store.state.vdsGroup.currentGroupId) _groupField['value'] = _this10.$store.state.vdsGroup.currentGroupId;
				}

				if (_this10.crud === 'disks') {
					var _quantityField2 = _this10.findField('quantity');
					if (_quantityField2) {
						if (_this10.action === 'create') {
							if ('min' in _quantityField2) {
								_quantityField2['value'] = _quantityField2.min;
							}

							if (_this10.formInfo && 'cost' in _this10.formInfo && !('cost' in _quantityField2)) {
								_quantityField2['cost'] = _this10.formInfo.cost;
								_quantityField2['full_cost'] = _this10.formInfo.full_cost;
								_quantityField2['period'] = _this10.formInfo.period;
							}

							if (_this10.formInfo && 'backup' in _this10.formInfo && !('backup' in _quantityField2)) {
								_quantityField2['backup'] = _this10.formInfo.backup;
							}
						}
					}

					if (window && window.sessionStorage) {
						if (_this10.action === 'create') {
							var _key2 = 'w5_' + _this10.$store.state.user_id + '_outer_disk_create_dc';
							var _dcObj = window.sessionStorage.getItem(_key2);
							window.sessionStorage.removeItem(_key2);

							var _dcId = null;
							var _dcName = null;

							try {
								var _dcData = JSON.parse(_dcObj);
								if (_dcData && 'id' in _dcData && 'name' in _dcData) {
									_dcId = parseInt(_dcData.id, 10);
									_dcName = String(_dcData.name);
								}
							} catch (err) {}

							if (_dcName && !isNaN(_dcId) && _dcId > 0) {
								var _dcField = _this10.findField('datacenter_id');
								if (_dcField) {
									_this10.$set(_dcField, '_storeValue', {
										field: 'datacenter_id',
										value: _dcId,
										name: _dcName
									});
								}
							}
						}

						var _crtFromBackup = window.sessionStorage.getItem('create-outer-disk-from-backup');
						if (_crtFromBackup) {
							var _crtStore = null;
							try {
								_crtStore = JSON.parse(_crtFromBackup);
							} catch (e) {
								_crtStore = null;
							}

							if (_crtStore && _crtStore.account_id) {
								var _accField = _this10.findField('account_id');
								if (_accField) {
									_this10.$set(_accField, '_storeValue', {
										field: 'account_id',
										value: _crtStore.account_id,
										name: 'a' + _crtStore.account_id
									});
								}
							}

							if (_crtStore) {
								var _optionsField = _this10.findField('options');
								if (_optionsField) {
									_this10.$set(_optionsField, '_storeValue', {
										field: 'options',
										value: true
									});
								}
							}
						}
					}

					if (_this10.outerDiskSavedFields) {
						_this10.$nextTick(function () {
							for (var _key3 in _this10.outerDiskSavedFields) {
								var _formOuterDiskForm = _this10.findField(_key3);
								if (_formOuterDiskForm) {
									_this10.$set(_formOuterDiskForm, 'value', _this10.outerDiskSavedFields[_key3]['value']);
									_this10.$set(_formOuterDiskForm, '_visible', _this10.outerDiskSavedFields[_key3]['visible']);
								}
							}

							_this10.outerDiskSavedFields = null;
						});
					}
				}

				if (_this10.crud === 'vds') {
					var _Cookie = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].getCookie('crtvdsplan');

					__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].deleteCookie('crtvdsplan');

					if (_Cookie) {
						var _planCookie = null;
						try {
							_planCookie = JSON.parse(_Cookie);
						} catch (e) {
							_planCookie = null;
						}

						if (_planCookie && (typeof _planCookie === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_planCookie)) === 'object' && 'plan' in _planCookie && 'group' in _planCookie) {
							var _planId = parseInt(_planCookie['plan']);
							var _groupId = parseInt(_planCookie['group']);

							var _templateId = null;
							if ('template' in _planCookie) {
								_templateId = parseInt(_planCookie['template']);
							}

							if (!isNaN(_planId) && _planId >= 0 && !isNaN(_groupId) && _groupId >= 0) {
								var _planField = _this10.findField('plan_id');
								if (_planField) _this10.$set(_planField, 'cookieValue', _planId);

								if (!isNaN(_templateId) && _templateId >= 0) {
									var _templateField = _this10.findField('template_id');
									if (_templateField) _this10.$set(_templateField, 'cookieValue', _templateId);
								}

								var _groupField2 = _this10.findField('plan_group_id');
								if (_groupField2 && _groupField2.list && _groupField2.list.length) {
									var fnd = _groupField2.list.some(function (item) {
										if (String(item.id) === String(_groupId)) {
											_this10.$store.commit('setVdsGroupId', _groupId);

											_groupField2['_oldValue'] = String(_groupId);
											_groupField2['_emptyValue'] = String(_groupId);
											_groupField2['value'] = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].apiGroupFromOneGroup(_groupId);
											return true;
										}
									});

									if (fnd) {
										_this10.$nextTick(function () {
											var _grf = _this10.findField('plan_group_id');
											if (_grf) _this10.fieldChanged(_grf);
										});
									}
								}
							}
						}
					}

					var _reserveIpField = _this10.findField('reserve_ip');
					if (_reserveIpField && _reserveIpField['list'] && Array.isArray(_reserveIpField['list'])) {
						var _found = _reserveIpField['list'].some(function (obj) {
							return obj && String(obj.id) === '-1000';
						});

						if (!_found) {
							_reserveIpField['list'].unshift({
								'id': -1000,
								'name': _this10.localeFtc('main/not_use')
							});
						}
					}

					var _sshField = _this10.findField('sshkey_id');

					if (_sshField && _sshField['list'] && _sshField['list'].length) {
						var _found2 = _sshField['list'].some(function (obj) {
							return obj && String(obj.id) === '-1000';
						});

						if (!_found2) {
							_sshField['list'].unshift({
								'id': -1000,
								'name': _this10.localeFtc('sshkey/not_use')
							});
						}
					} else {
						if (_this10.$store.state.user_type === 'client' && _this10.isAccess('sshkey/create')) {
							_sshField['type'] = 'simpleButton';
							_sshField['buttonFunction'] = function () {
								if (!_this10.sshKeyFields) {
									_this10.$http.get(_this10.APIServerUrl + '/sshkey/create').then(function (res) {
										var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

										if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
											var _flds = _this10.parseFormData(_dt);
											_this10.sshKeyFields = _flds;

											__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
											_this10.showSshKeyModal = true;

											return;
										}

										_this10.localErrorMessage = _this10.formatRequestError(res);
									}, function (res) {
										_this10.localErrorMessage = _this10.formatRequestError(res);
									});
								} else {
									var _rows = _this10.sshKeyFields.fields;
									if (!_rows || !Array.isArray(_rows)) return;

									_rows.forEach(function (item) {
										if (item && Array.isArray(item)) {
											item.forEach(function (field, idx, arr) {
												if (field['_field_name']) delete field.value;
											});
										}
									});

									__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
									_this10.showSshKeyModal = true;
								}
							};
							_sshField['buttonText'] = 'sshkey/create_button';
						}
					}

					if (_this10.action === 'create') {
						var _backupField = _this10.findField('backup_id');
						if (_backupField) _backupField._visible = false;

						var _isoField = _this10.findField('iso_id');
						if (_isoField) _isoField._visible = false;
					}

					if (window && window.sessionStorage) {
						var _crtFromBackup2 = window.sessionStorage.getItem('create-vds-from-backup');
						if (_crtFromBackup2) {
							var _crtStore2 = null;
							try {
								_crtStore2 = JSON.parse(_crtFromBackup2);
							} catch (e) {
								_crtStore2 = null;
							}

							if (_crtStore2 && _crtStore2.account_id) {
								var _accField2 = _this10.findField('account_id');
								if (_accField2) _this10.$set(_accField2, '_storeValue', {
									field: 'account_id',
									value: _crtStore2.account_id,
									name: 'a' + _crtStore2.account_id
								});
							}
						}
					}
				}

				if (_this10.crud === 'certificate' && _this10.action === 'create') {
					var _Cookie2 = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].getCookie('crtsslplan');

					__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].deleteCookie('crtsslplan');

					if (_Cookie2) {
						var _planId2 = parseInt(_Cookie2, 10);
						if (isNaN(_planId2)) _planId2 = -1;

						if (_planId2 >= 0) {
							var _planField2 = _this10.findField('plan_id');
							if (_planField2) _this10.$set(_planField2, 'cookieValue', _planId2);
						}
					}
				}

				if (_this10.crud === 'operation' && _this10.action === 'create' && _this10.$store.state.user_type === 'client' || _this10.crud === 'paymentauto') {
					var _sumField = _this10.findField('summa');

					if (_sumField) {
						if (_this10.crud === 'operation' && _this10.action === 'create' && _this10.$store.state.user_type === 'client' && _this10.$store.state.operationSumNew) _sumField['value'] = _this10.$store.state.operationSumNew;

						_this10.$nextTick(function () {
							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-client-operation-create', _sumField['value']);
							_this10.onBlur(_this10.findField('summa'));
						});
					}

					var _saved = _this10.crud === 'operation' ? _this10.findField('saved') : _this10.findField('saved_id');

					if (_saved) _saved.type = 'savedPayments';
				}

				if (_this10.crud === 'options' && _this10.action === 'update' && _this10.refreshMiniAvatar === true) {
					_this10.refreshMiniAvatar = false;

					var _avatarField = _this10.findField('file');

					if (_avatarField && _avatarField['value']) {
						_this10.$store.commit('setAvatarPath', _avatarField['value']);
					}

					_this10.formData.fields.forEach(function (row) {
						if (row && Array.isArray(row)) {
							row.forEach(function (f) {
								if (f.value !== null && f.value !== undefined) f['_oldValue'] = f.value;
							});
						}
					});

					_this10.$store.commit('changedForm', false);
				}

				if (_this10.crud === 'rackdevice' && _this10.action === 'links') {
					_this10.formData.fields.forEach(function (row) {
						if (row && Array.isArray(row)) {
							row.forEach(function (f) {
								if (f && f._field_name && f._field_name.indexOf('device_id') === 0 && f.type === 'list' && f.list) {
									f['list'].unshift({
										'id': 'emptyValue',
										'name': _this10.localeFtc('main/free')
									});
								}

								if (f && f._field_name && f._field_name.indexOf('from') === 0 && f.type === 'text' && f.readonly) {
									f.type = 'clearText';

									f.__subtype = 'rackdevice-from';

									var m = f._field_name.match(/^from\[(\d+)\]$/);
									if (m && m.length && m[1]) {
										var _portField = _this10.findField('port_id[' + m[1] + ']');
										if (_portField) _this10.$set(f, '__isPortActive', Boolean(_portField.value));
									}
								}
							});
						}
					});
				}

				if (_this10.crud === 'user' && _this10.action === 'alerts') {
					_this10.formData.fields.forEach(function (row) {
						if (row && Array.isArray(row)) {
							row.forEach(function (f) {
								if (f.type === 'boolean') {
									if (f.value !== null && f.value !== undefined && f.value !== false) f['_oldValue'] = true;else f['_oldValue'] = false;
								} else if (f.value !== null && f.value !== undefined) f['_oldValue'] = f.value;
							});
						}
					});

					_this10.$store.commit('changedForm', false);
				}

				if (_this10.crud === 'ticket' && _this10.action === 'create') {
					if (_this10.$store.state.ticketData.currentDepartmentId) {
						var _depField = _this10.findField('department_id');
						_depField['value'] = _this10.$store.state.ticketData.currentDepartmentId;
					}

					if (_this10.$store.state.createTicketEmail && _this10.$store.state.createTicketEmail.email) {
						var _whomField = _this10.findField('whom');
						_whomField['value'] = 'email';

						var _emailField = _this10.findField('email');
						_emailField['value'] = _this10.$store.state.createTicketEmail.email;
					}

					if (window && window.sessionStorage) {
						var _crtFrom = window.sessionStorage.getItem('create-ticket-for-account');
						if (_crtFrom) {
							window.sessionStorage.removeItem('create-ticket-for-account');

							var _crtStore3 = null;
							try {
								_crtStore3 = JSON.parse(_crtFrom);
							} catch (e) {
								_crtStore3 = null;
							}

							if (_crtStore3 && _crtStore3.account_id) {
								var _accField3 = _this10.findField('account_id');
								if (_accField3) _this10.$set(_accField3, '_storeValue', {
									field: 'account_id',
									value: _crtStore3.account_id,
									name: 'a' + _crtStore3.account_id
								});
							}
						}
					}
				}

				_this10.formData.fields.forEach(function (row) {
					if (row && Array.isArray(row)) {
						row.forEach(function (f) {
							if (f['validator'] === 'passport') f.type = 'passport';

							if (f['validator'] === 'address_post_russian' || f['validator'] === 'address_russian') f.type = 'address';
						});
					}
				});

				var _fromBlock = false;
				var _key = 'formSaver_' + _this10.$route.path.replace(/\//g, '_');
				var _oldData = false;
				if (window.sessionStorage) _oldData = window.sessionStorage.getItem(_key);
				if (_oldData) {
					window.sessionStorage.removeItem(_key);

					try {
						var _data2 = JSON.parse(_oldData);

						if (_data2) _this10.formData = _data2;
						_fromBlock = true;
						_this10.$nextTick(function () {
							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-field-data-from-block');
						});

						_this10.$store.commit('changedForm', _this10.$route.path);
					} catch (_err) {
						if (_this10.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message);
						return false;
					}
				} else {
					_key = 'formStorage_' + _this10.$route.path.replace(/\//g, '_');
					_oldData = false;
					if (window.sessionStorage) _oldData = window.sessionStorage.getItem(_key);
					if (_oldData) {
						window.sessionStorage.removeItem(_key);

						try {
							var _data3 = JSON.parse(_oldData);

							if (_data3 && _data3.fields && _data3.fields.length) {
								for (var x in _data3.fields) {
									var arr = _data3.fields[x];
									if (!arr || !arr.length) continue;

									for (var y in arr) {
										var f = arr[y];
										if (!f || !f._field_name) continue;

										if (_this10.crud === 'iso' && _this10.action === 'create' && f._field_name === 'file') {
											continue;
										}

										var ff = _this10.findField(f._field_name);
										if (!ff) continue;

										if ('value' in f) ff.value = f.value;

										if ('listValue' in f) ff.listValue = f.listValue;

										if ('_storeValue' in f) ff._storeValue = f._storeValue;

										if (f._field_name === 'account_id') {
											ff.listValue = {
												id: f.value,
												name: 'a' + f.value
											};
										}
									}
								}
							}

							_this10.buttonBlock = 0;
						} catch (_err) {}
					}
				}

				_this10.$nextTick(function () {
					_this10.showif();

					_this10.formData.fields.forEach(function (row) {
						if (row) row.forEach(function (fld) {
							_this10.reloadif(fld['_field_name']);
						});
					});

					_this10.fillNumberFields();

					if (_fromBlock) return;

					_this10.$nextTick(function () {
						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-init-form-data');
					});
				});
			}, function () {
				_this10.$store.commit('needShowLoader', true);

				_this10.outerDiskRequestType = false;
			});
		},
		isVisibleField: function isVisibleField(row) {
			var _this11 = this;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && _this11.crud === 'vds' && _this11.action === 'create') {
					if (item['_field_name'] === 'backup_auto') {
						_answer = true;
						return true;
					}
				}

				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		isDividerField: function isDividerField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type === 'header' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		countVisibleFieldsInRow: function countVisibleFieldsInRow(row) {
			var _answer = 0;

			row.forEach(function (item) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer++;
				}
			});

			return _answer;
		},
		blockFormButton: function blockFormButton() {
			if (this.buttonBlock > 0) return;
			this.buttonBlock++;
		},
		unblockFormButton: function unblockFormButton() {
			if (this.crud === 'iso' && this.action === 'create') return;
			this.buttonBlock--;
			if (this.buttonBlock < 0) this.buttonBlock = 0;
		},
		cropCoords: function cropCoords(data) {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-crop-data', data);
		},
		onParams: function onParams(params) {
			this.params = params;
		},
		onIsoUploadError: function onIsoUploadError(text) {
			this.localErrorMessage = text;
			this.isoFormUpdateOnError();
		},
		onIsoUploadCanceled: function onIsoUploadCanceled() {
			this.isoFormUpdateOnError();
		},
		onIsoUploadFinished: function onIsoUploadFinished() {
			this.submitForm('submit-iso-form');
		},
		onGroupChanged: function onGroupChanged(newGroup) {
			var _groupField = this.findField('plan_group_id');
			if (_groupField) _groupField['value'] = newGroup;
			this.fieldChanged(_groupField);
		},
		onDomainName: function onDomainName(nameValue) {
			var _field = this.findField('name');
			if (_field) _field['value'] = nameValue;
			this.fieldChanged(_field);
		},
		onUploadFinished: function onUploadFinished() {
			if (this.crud === 'iso') {
				this.blockFormButton();

				this.submitForm();
			}
		},
		deleteFileValue: function deleteFileValue(data) {
			if (!data || !data['field'] || !('value' in data)) return;
			var _field = this.findField(data['field']);

			if (!_field || _field.type !== 'file' && _field.type !== 'image') return;

			_field['_errMsg'] = '';

			_field['_deleteFile'] = data['value'];

			if (data['value'] === true) _field['value'] = null;
		},
		findField: function findField(name) {
			if (!this.formData.fields) return null;

			var _field = null;
			this.formData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		onFocus: function onFocus(field) {
			field['_errMsg'] = '';

			if (this.crud === 'domains' && field['_field_name'] === 'plan_id') {
				var _field = this.findField('name');
				if (_field) _field['_errMsg'] = '';
				return;
			}

			if (this.crud === 'vds' && field['_field_name'] === 'template_id') {
				var _bf = this.findField('backup_id');
				if (_bf) _bf['_errMsg'] = '';

				var _if = this.findField('iso_id');
				if (_if) _if['_errMsg'] = '';

				return;
			}

			if (this.crud === 'vds' && field['_field_name'] === 'plan_id') {
				var _df = this.findField('datacenter_id');
				if (_df) _df['_errMsg'] = '';
			}

			if (this.crud === 'vds' && field['_field_name'] === 'datacenter_id') {
				var _df2 = this.findField('plan_id');
				if (_df2) _df2['_errMsg'] = '';
			}
		},
		onBlur: function onBlur(field) {
			if (this.isFormSubmited) return;

			if (this.crud === 'person' && field['_field_name'] && field.value) {
				if (String(field['_field_name']).indexOf('[person_r]') > 0) __WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-transliterate', {
					field: String(field['_field_name']).replace('_r]', ']'),
					value: field.value,
					what: 'fio'
				});

				if (String(field['_field_name']).indexOf('[org_r]') > 0) __WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-transliterate', {
					field: String(field['_field_name']).replace('_r]', ']'),
					value: field.value,
					what: 'org'
				});
			}

			if (/^\w+\[\w+\]/i.test(field['_field_name'])) {
				var _validator = __WEBPACK_IMPORTED_MODULE_11__validators_array__["a" /* default */].validators[this.crud] ? __WEBPACK_IMPORTED_MODULE_11__validators_array__["a" /* default */].validators[this.crud] : __WEBPACK_IMPORTED_MODULE_11__validators_array__["a" /* default */].personValidators;

				if (field['value'] !== undefined && field['value'] !== null && field['value'] !== '' && field['validator'] && _validator[field['validator']]) {
					var _err = '';
					if (field['validator'] === 'date') _err = _validator[field['validator']](field['value'], field['format'], field['_field_name']);else if (field['validator'] === 'bank_account' || field['validator'] === 'user_account') _err = _validator[field['validator']](field['value'], this.form_GetData.fields);else _err = _validator[field['validator']](field['value']);

					if (_err) {
						field['_errMsg'] = _err;
						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
					}
				}

				return;
			}

			if ((this.crud === 'operation' || this.crud === 'paymentauto') && (this.action === 'select' || this.action === 'create') && field['_field_name'] === 'summa') {
				var _min = 999999999;
				var _val = parseFloat(field['value']);

				if (!isNaN(_val)) {
					var _savedField = this.findField(this.crud === 'operation' ? 'saved' : 'saved_id');
					if (_savedField && _savedField.list && _savedField.list.length) {
						_savedField.list.forEach(function (ff) {
							if (ff && 'min' in ff) {
								var _minVal = parseFloat(ff['min']);
								if (!isNaN(_minVal) && _minVal < _min) _min = _minVal;
							}
						});
					}

					var _paymentField = this.findField('payment');
					if (_paymentField && _paymentField.list && _paymentField.list.length) {
						_paymentField.list.forEach(function (ff) {
							if (ff && 'min' in ff) {
								var _minVal = parseFloat(ff['min']);
								if (!isNaN(_minVal) && _minVal < _min) _min = _minVal;
							}
						});
					}

					if (_min < 999999999 && _val < _min) {
						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
							'type': field['type'],
							'name': field['_field_name'],
							'value': _min,
							'animation': true
						});
					}
				}
			}

			this.verifyField(field);
		},
		onEnterKeyDown: function onEnterKeyDown(e) {
			if (e) e.preventDefault();

			if (this.crud === 'operation' && this.action === 'create') {
				if (!this.isSubmitButtonEnabled) return;
			}

			this.submitForm(e);
		},
		onTextEvent: function onTextEvent(txt) {
			if (this.crud === 'ticket' && this.action === 'create' && this.$store.state.user_type === 'client') {
				if (!txt || String(txt).length < 3) {
					__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
					return;
				}

				var _url = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].QAUrl + '/api2panel/search';

				this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].toFormData({ search: txt })).then(function (res) {
					if (res && (typeof res === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res)) === 'object' && res.ok === true && res.body && res.body.status) __WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', res.body.answer);else __WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
				}, function (res) {
					__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
				});
			}
		},
		verifyField: function verifyField(field) {
			var _this12 = this;

			field['_errMsg'] = '';

			this.outerDiskRequestType = false;

			if (field.value === undefined || field.value === null || String(field.value) === '') return;

			if (field.fake === true) return;

			if (!this.localValidation(field)) return;

			var _obj = {};
			var o = void 0;
			if (field.validate_with) {
				var _v = field.validate_with;

				if ((typeof _v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_v)) === 'object' && Array.isArray(_v) && _v.length) {
					for (var _i in _v) {
						o = this.findField(_v[_i]);

						if (o && (o.value === undefined || o.value === null || String(o.value) === '')) {
							if (o.type === 'boolean') _obj[_v[_i]] = 0;else return;
						}
						if (o && o.value) _obj[_v[_i]] = o.value;
						if (o && o.type === 'boolean') _obj[_v[_i]] = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
					}
				} else if ((typeof _v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_v)) === 'object') {
					for (var _i2 in _v) {
						if (_v.hasOwnProperty(_i2)) {
							o = this.findField(_v[_i2]);

							if (o && (o.value === undefined || o.value === null || String(o.value) === '')) {
								if (o.type === 'boolean') _obj[_v[_i2]] = 0;else return;
							}
							if (o && o.value) _obj[_v[_i2]] = o.value;
							if (o && o.type === 'boolean') _obj[_v[_i2]] = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
						}
					}
				} else {
					o = this.findField(_v);

					if (o && (o.value === undefined || o.value === null || String(o.value) === '')) return;
					if (o && o.value) _obj[_v] = o.value;
					if (o && o.type === 'boolean') _obj[_v] = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(o.value) ? 1 : 0;
				}
			}

			var _url = this.APIServerUrl + this.$route.path;

			if (this.$route.path === '/options') _url = this.APIServerUrl + '/' + (this.$store.state.user_type === 'client' ? 'user' : 'admin') + '/options';else if (this.$route.path === '/iso/create') _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_ISO;else if (this.$route.path === '/vds/create') _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_VDS;else if (this.$route.path === '/certificate/create') _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_SSL;else if (this.$route.path === '/domains/create') _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DOMAIN;else if (this.$route.path.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/');else if (this.$route.path === '/dns/create') _url = this.APIServerUrl + '/service/create/' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].Constants.SERVICE_TYPE_DNS;else if (this.$route.path.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/');else if (this.$route.path === '/disks/create') _url = this.APIServerUrl + '/service/create/' + this.outerDiskTypeValue;else if (this.$route.path.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/');

			this.verifyRequestsHandlers = [];

			this.forms_verifyRequest(_url, {
				'field': field['_field_name'],
				'value': field['value'],
				'data': _obj
			}, function (data) {
				if (data && data['fields'] && data['fields'][field['_field_name']]) {
					var _msg = data['fields'][field['_field_name']];
					if (typeof _msg === 'string') {
						field['_errMsg'] = _msg;
						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
					} else if ((typeof _msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_msg)) === 'object') {
						var _txt = '';
						for (var k in _msg) {
							if (_txt === '') _txt = _msg[k];else _txt += ' <br> ' + _msg[k];
						}field['_errMsg'] = _txt;
						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
					}
				}
			}, function (request) {
				_this12.verifyRequestsHandlers.push(request);
			});
		},
		localValidation: function localValidation(field) {
			if (!field['_visible']) return true;

			if (field['value'] === undefined || field['value'] === null) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					return false;
				}

				if (v === String(r)) return true;

				field['_errMsg'] = 'validators/error_int';
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v4 = String(field.value).trim();

				_v4 = _v4.replace(/ /g, '');

				var _r = parseFloat(_v4);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				return false;
			}

			if (this.crud === 'paymentauto' && field._field_name === 'summa') {
				var _savedField = this.findField('saved_id');
				if (_savedField && _savedField.value !== undefined && _savedField.value !== null && !isNaN(_savedField.value) && _savedField.list && _savedField.list.length) {
					var saved = null;
					_savedField.list.some(function (i) {
						if (i && i.id === _savedField.value) {
							saved = i;
							return true;
						}
					});
					if (saved) {
						var _v5 = String(field.value).trim();

						_v5 = _v5.replace(/ /g, '');

						var _r2 = parseFloat(_v5);

						var _min = saved['min'];
						if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0;
						_min = parseFloat(_min);

						var _max = saved['max'];
						if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0;
						_max = parseFloat(_max);

						if (_r2 <= 0 || _r2 < _min) {
							field['_errMsg'] = this.formater_capitalizeFirstChar(this.localeFtc('request/status_error: payment/min'));
							return false;
						}

						if (_max && _r2 > _max) {
							field['_errMsg'] = this.formater_capitalizeFirstChar(this.localeFtc('request/status_error: payment/max'));
							return false;
						}
					}
				}
			}

			return true;
		},
		fieldChanged: function fieldChanged(field) {
			var _this13 = this;

			this.$store.commit('changedForm', false);

			if (this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client' || this.crud === 'paymentauto') {
				if (field['_field_name'] === 'summa') {
					field['_errMsg'] = '';
					__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('form-client-operation-create', field['value']);
				}

				if (field['unselect']) {
					__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-clear-list-field', field['unselect']);
				}

				if (field['_field_name'] === 'saved' && field['value']) {
					if (this._computedWatchers && this._computedWatchers.isSubmitButtonEnabled && this._computedWatchers.isSubmitButtonEnabled.run) {
						this._computedWatchers.isSubmitButtonEnabled.run();
						this.$forceUpdate();
					}
				}
			}

			if (this.crud === 'rackdevice' && this.action === 'links' && field._field_name && field._field_name.indexOf('port_id') === 0) {
				var m = field._field_name.match(/^port_id\[(\d+)\]$/);
				if (m && m.length && m[1]) {
					var deviceField = this.findField('device_id[' + m[1] + ']');
					if (deviceField) {
						var deviceValue = deviceField.value;

						var _found = false;
						this.formData.fields.some(function (item) {
							if (item && Array.isArray(item)) {
								item.some(function (obj) {
									if (obj && obj._field_name && obj._field_name.indexOf('device_id') === 0 && obj._field_name !== deviceField._field_name && obj.value === deviceValue) {
										var n = obj._field_name.match(/^device_id\[(\d+)\]$/);
										if (n && n.length && n[1]) {
											var portField = _this13.findField('port_id[' + n[1] + ']');
											if (portField && portField.value === field.value) {
												_found = true;
												return true;
											}
										}
									}
								});

								if (_found) return true;
							}
						});

						if (_found) {
							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
								name: field._field_name,
								value: field.perviousValues && field.perviousValues.obj ? field.perviousValues.obj : null
							});

							return;
						}
					}

					var fromField = this.findField('from[' + m[1] + ']');
					if (fromField) {
						fromField.__isPortActive = Boolean(field.value);
					}
				}
			}

			this.showif();

			this.reloadif(field['_field_name']);
		},
		reloadifFieldNameEqual: function reloadifFieldNameEqual(reloadValue, fieldName) {
			if (!reloadValue || !fieldName) return false;

			if ((typeof reloadValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(reloadValue)) === 'object') {
				if (Array.isArray(reloadValue)) {
					return reloadValue.some(function (name) {
						if (name === fieldName) return true;
					});
				} else {
						for (var _key in reloadValue) {
							if (reloadValue.hasOwnProperty(_key)) {
								if (_key === fieldName) return true;
							}
						}return false;
					}
			}

			return reloadValue === fieldName;
		},
		reloadifLoading: function reloadifLoading(changedFieldName, Field, forceValue) {
			var _this14 = this;

			var _field = this.findField(changedFieldName);
			if (!_field && this.$store.state.isDebug) return window.DEBUG.error('Ureloadif0: поле указанное в "reload" не найдено');

			var _url = Field['url'];
			if (!_url && this.$store.state.isDebug) return window.DEBUG.error('Ureloadif1: в поле с признаком "reload" не задан URL');

			var _values = [];
			if (_field && 'value' in _field) {
				if (Array.isArray(_field['value'])) _field['value'].forEach(function (i) {
					if (i !== undefined && i !== null && i !== '') _values.push(i);
				});else {
					if (_field['value'] !== undefined && _field['value'] !== null && _field['value'] !== '') _values.push(_field['value']);
				}
			}

			if (forceValue) {
				_values.push(forceValue);
			}

			if (!_values.length) return;

			if (Array.isArray(Field['reload'])) {
				var _isEmptyValue = false;

				Field['reload'].forEach(function (_f) {
					var _ff = _this14.findField(_f);

					if (_ff) {
						if (_ff['value'] !== undefined && _ff['value'] !== null && _ff['value'] !== '') {
							_url = _url.replace(_f + '=', _f + '=' + _ff['value']);
						} else _isEmptyValue = true;
					} else _isEmptyValue = true;
				});

				if (_isEmptyValue) return;

				_url = this.APIServerUrl + _url;
			} else _url = this.APIServerUrl + _url + _values.join(',');

			if (this.crud === 'document' && Field._field_name === 'operation_id' && _url.indexOf('type=&') > 0) {
				var _typeField = this.findField('type');
				if (_typeField) {
					var _val = _typeField.value;
					if (_val) _url = _url.replace('type=&', 'type=' + _val + '&');
				}
			}

			this.cachedRequestGet(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok') {
					var resultList = _dt['result'] && Array.isArray(_dt['result']) ? _dt['result'] : [];

					if (Field['type'] === 'list' || Field['type'] === 'urlButton' && Field['_field_name'] === 'person_id' || Field['type'] === 'savedPayments' && Field['_field_name'] === 'saved_id') {
						if (_this14.crud === 'vds' && Field['_field_name'] === 'sshkey_id') {
							var _found = resultList.some(function (obj) {
								return obj && String(obj.id) === '-1000';
							});

							if (!_found) {
								resultList.unshift({
									'id': -1000,
									'name': _this14.localeFtc('sshkey/not_use')
								});
							}
						}
						if (_this14.crud === 'vds' && Field['_field_name'] === 'reserve_ip') {
							var _found3 = resultList.some(function (obj) {
								return obj && String(obj.id) === '-1000';
							});

							if (!_found3) {
								resultList.unshift({
									'id': -1000,
									'name': _this14.localeFtc('main/not_use')
								});
							}

							var _reserveIpField = _this14.findField('reserve_ip');
							if (_reserveIpField && 'value' in _reserveIpField) {
								_found3 = resultList.some(function (obj) {
									return obj && String(obj.id) === String(_reserveIpField.value);
								});

								if (!_found3) {
									_reserveIpField.value = -1000;
									_this14.$nextTick(function () {
										__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-list-field-value', {
											name: 'reserve_ip',
											value: {
												'id': -1000,
												'name': _this14.localeFtc('main/not_use')
											}
										});
									});
								}
							}
						}

						if (_this14.crud === 'server' && Field['_field_name'] === 'groups') {}

						_this14.$set(Field, 'list', resultList);

						__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-vds-create-field-reloaded', Field._field_name);

						if (_this14.crud === 'vds' && _this14.action === 'create' && Field._field_name === 'template_id' && window && window.sessionStorage) {
							var _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup');
							if (_crtFromBackup) {
								_this14.$nextTick(function () {
									__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-change-active-tab', 'backup');
								});
							}
						}
					}
				}
			});
		},
		reloadif: function reloadif(changedFieldName) {
			var _this15 = this;

			var _rows = this.formData['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (_this15.reloadifFieldNameEqual(field['reload'], changedFieldName)) {
							if (field['_visible'] === true) {
								_this15.reloadifLoading(changedFieldName, field);
							} else {
									if (_this15.crud === 'domains' && field['_field_name'] === 'person_id' || _this15.crud === 'vds' && field['_field_name'] === 'reserve_ip' || _this15.crud === 'vds' && field['_field_name'] === 'sshkey_id' && _this15.$store.state.user_type === 'admin') {
										_this15.reloadifLoading(changedFieldName, field);
									} else if (_this15.crud === 'vds' || _this15.crud === 'disks') {
										if (field['_field_name'] === 'backup_id' || field['_field_name'] === 'iso_id') _this15.reloadifLoading(changedFieldName, field);
									}
								}
						}
					});
				}
			});
		},
		showif: function showif() {
			var _rows = this.formData['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg2 = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg2.exec(_expr) !== null) {
												_expr = _expr.replace(_reg2, 'w5InArray($1, $2) !== -1');
											} else {
												_reg2 = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg2.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		fillNumberFields: function fillNumberFields() {
			var _rows = this.formData['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name'] && (field['type'] === 'int' || field['type'] === 'integer' || field['type'] === 'money' || field['type'] === 'float') && field['value'] !== undefined && field['value'] !== null) {
							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
								'type': field['type'],
								'name': field['_field_name'],
								'value': field['value']
							});
						} else if (field['_field_name'] && field['type'] === 'date' && field['value'] !== undefined && field['value'] !== null && String(field['value']).trim() !== '') {
								__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-date-field-value', {
									'name': field['_field_name'],
									'value': field['value']
								});
							}
					});
				}
			});
		},
		setLocalSuccessMessage: function setLocalSuccessMessage(msg) {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			});
		},
		prepareTemplateList: function prepareTemplateList(field) {
			__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].prepareTemplateList(field);
		},
		hideMoneyModal: function hideMoneyModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showMoneyModal = false;
			this.hideModalMask();
		},
		goToMoney: function goToMoney() {
			this.hideMoneyModal();

			this.isFormSubmited = true;

			this.$router.push('/operation/create');
		},
		continueSubmit: function continueSubmit() {
			this.hideMoneyModal();

			this.moneyModalAddButton = 'continue';
			this.submitForm();
		},
		hidePayerDialogModal: function hidePayerDialogModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPayerDialogModal = false;
			this.hideModalMask();
		},
		goToCreatePayer: function goToCreatePayer() {
			this.hidePayerDialogModal();

			this.$router.push('/payer/create');
		},
		showPayerDialog: function showPayerDialog() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPayerDialogModal = true;
		},
		onFreePort: function onFreePort(fromField) {
			var from = this.findField(fromField);
			if (from) from.__isPortActive = false;
		},
		onDeleteSavedPayment: function onDeleteSavedPayment(id) {
			var _this16 = this;

			if (!id) return;

			if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler);
			this.deleteModalTimer = 5;
			this.deleteModalText = '';
			this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);

			var _savedIdField = this.findField('saved');
			if (!_savedIdField || (typeof _savedIdField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_savedIdField)) !== 'object' || !_savedIdField.list || !_savedIdField.list.length) return;

			this.deleteModalValue = id;

			var showValue = id;
			_savedIdField.list.some(function (item) {
				if (item && item.id === showValue) {
					showValue = item.name;
					return true;
				}
			});
			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', showValue);

			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandler = setInterval(function () {
				_this16.deleteModalTimer--;
				_this16.deleteButtonTitle = _this16.localeFtc('main/delete_timer').replace('{count}', _this16.deleteModalTimer);

				if (_this16.deleteModalTimer <= 0) {
					_this16.deleteButtonTitle = _this16.localeFtc('main/delete');
					clearInterval(_this16.deleteModalTimerHandler);
					_this16.deleteModalTimerHandler = null;
				}
			}, 1000);
		},
		hideDeleteModal: function hideDeleteModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteModalCallback: function deleteModalCallback() {
			var _this17 = this;

			if (this.deleteModalTimer > 0) return;

			if (this.deleteModalValue === undefined || this.deleteModalValue === null || this.deleteModalValue <= 0) return;

			this.localErrorMessage = '';

			this.hideDeleteModal();

			var _savedIdField = this.findField('saved');
			if (!_savedIdField || (typeof _savedIdField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_savedIdField)) !== 'object' || !_savedIdField.list || !_savedIdField.list.length) {
				this.localErrorMessage = 'error/required_field';
				return;
			}

			var _url = this.APIServerUrl + '/operation/delete?additional=setDeleteSaved&saved_id=' + this.deleteModalValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this17.$http.post(_url, __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							var msg = 'payment/deleted';
							if (_dt['title']) msg = _dt['title'];

							__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': msg,
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							if (_savedIdField.list && _savedIdField.list.length) {
								_savedIdField.list.some(function (item, idx) {
									if (item && item.id === _this17.deleteModalValue) {
										_savedIdField.list.splice(idx, 1);
										return true;
									}
								});

								_this17.hideHeaderFieldForSavedPayments();
							}

							return;
						}

						_this17.localErrorMessage = _this17.formatRequestError(resPost);
					}, function (resPost) {
						_this17.localErrorMessage = _this17.formatRequestError(resPost);
					});

					return;
				}

				_this17.localErrorMessage = _this17.formatRequestError(resGet);
			}, function (resGet) {
				_this17.localErrorMessage = _this17.formatRequestError(resGet);
			});
		},
		hideHeaderFieldForSavedPayments: function hideHeaderFieldForSavedPayments() {
			if (!this.formData.fields || !this.formData.fields.length) return;

			var _len = this.formData.fields.length;
			var seek = false;
			var found = false;
			for (var i = _len - 1; i >= 0; i--) {
				var row = this.formData.fields[i];
				if (row && Array.isArray(row)) {
					if (!seek) {
						row.some(function (obj) {
							if (obj && obj['_field_name'] === 'saved') {
								seek = true;
								return true;
							}
						});
					} else {
							row.some(function (obj) {
								if (obj && obj['type'] === 'header') {
									obj._visible = false;
									found = true;
									return true;
								}
							});

							if (found) break;
						}
				}
			}
		},
		hide2FADialogModal: function hide2FADialogModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.show2FADialogModal = false;
			this.hideModalMask();
		},
		show2FADialog: function show2FADialog() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.show2FADialogModal = true;
		},
		find2FAField: function find2FAField(name) {
			var _rows = this.fields2FA.fields;
			if (!_rows || !Array.isArray(_rows)) return null;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		submit2FAForm: function submit2FAForm() {
			var _this18 = this;

			var _field = this.find2FAField('code');
			if (!_field) return;
			if (!_field.value) {
				_field['_errMsg'] = 'error/required_field';
				return;
			}

			this.localErrorMessage = '';

			var _isErr = this.fields2FA.fields.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true) {
							if (fld.value === undefined || fld.value === null) {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});
			if (_isErr) return;

			var _url = this.APIServerUrl + '/twofa/create';
			if (this.fields2FA.__value === true) _url = this.APIServerUrl + '/twofa/delete';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					_this18.fields2FA.fields.forEach(function (row) {
						if (row && Array.isArray(row) && row.length) {
							row.forEach(function (fld) {
								var _value = fld['value'];
								if (fld['type'] === 'boolean') {
									_value = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(fld['value']) ? 1 : 0;
								}
								_post[_dt['model']][fld['_field_name']] = _value;
							});
						}
					});

					_this18.$http.post(_url, __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							var _msg = _this18.fields2FA.__value ? 'twofa/deleted' : 'twofa/created';
							if (_dt['title']) _msg = _dt['title'];
							_this18.setLocalSuccessMessage(_msg);

							var _field3 = _this18.findField('twofa');
							if (_field3) {
								_field3['value'] = !_this18.fields2FA.__value;

								_field3['_oldValue'] = _field3['value'];
							}

							_this18.hide2FADialogModal();

							return;
						}

						if (_dt && _dt['status'] === 'error' && _dt['fields'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_dt['fields']) === 'object') {
							for (var f in _dt['fields']) {
								if (_dt['fields'].hasOwnProperty(f)) {
									var _fld = _this18.find2FAField(f);
									if (_fld) {
										_fld['_errMsg'] = _this18.localeFtc('main/error_desc').replace(':', '');
										__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');

										if (Array.isArray(_dt['fields'][f])) {
											if (_dt['fields'][f].length) _fld['_errMsg'] = _this18.localeFtc(_dt['fields'][f][0]);
										} else _fld['_errMsg'] = _this18.localeFtc(_dt['fields'][f]);
									}
								}
							}return;
						}

						_this18.hide2FADialogModal();

						_this18.localErrorMessage = _this18.formatRequestError(resPost);
					}, function (resPost) {
						_this18.hide2FADialogModal();

						_this18.localErrorMessage = _this18.formatRequestError(resPost);
					});

					return;
				}

				_this18.hide2FADialogModal();

				_this18.localErrorMessage = _this18.formatRequestError(resGet);
			}, function (resGet) {
				_this18.hide2FADialogModal();

				_this18.localErrorMessage = _this18.formatRequestError(resGet);
			});
		},
		on2FAValue: function on2FAValue(curValue) {
			var _this19 = this;

			this.localErrorMessage = '';

			if (!curValue) {
				this.$http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/twofa/create').then(function (res) {
					var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
						_this19.fields2FA = _this19.parseFormData(_dt);

						_this19.fields2FA.__value = curValue;

						_this19.show2FADialog();
						return;
					}

					throw res;
				}).catch(function (err) {
					var _msg = 'register/error';
					if (err) _msg = _this19.formatRequestError(err);
					_this19.localErrorMessage = _msg;
				});
			} else {
					this.$http.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].APIServerUrl + '/twofa/delete').then(function (res) {
						var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

						if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
							_this19.fields2FA = _this19.parseFormData(_dt);

							_this19.fields2FA.__value = curValue;

							_this19.show2FADialog();
							return;
						}

						throw res;
					}).catch(function (err) {
						var _msg = 'register/error';
						if (err) _msg = _this19.formatRequestError(err);
						_this19.localErrorMessage = _msg;
					});
				}
		},
		onClientCreateOperation: function onClientCreateOperation(id) {
			this.submitForm('nextStep');
		},
		bankLegalPaySubmit: function bankLegalPaySubmit(id) {
			var _payerField = this.findField('payer');

			if (_payerField && _payerField._visible && (!_payerField.list || !_payerField.list.length)) {
				__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-show-payer-dialog');
				return;
			}

			if (_payerField && _payerField._visible && _payerField.value !== undefined && _payerField.value !== null && _payerField.value !== '') {} else {
				var _payField = this.findField('payment');
				_payField.value = parseInt(id);
				this.fieldChanged(_payField);
			}
		},
		showTemplateDialog: function showTemplateDialog() {
			var _this20 = this;

			if (this.crud !== 'ticket' && this.crud !== 'ticketmessage') return;

			this.localErrorMessage = '';

			var _type = 'mails';
			var _typeField = this.findField('type');
			if (_typeField && _typeField['value'] === 'notice') _type = 'notice';

			this.$set(this.templateField, 'title', _type === 'notice' ? 'notes/templates' : 'mails/templates');

			this.$set(this.templateField, 'url', '/text/list?search=template&category=' + _type + '&q=');

			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showTemplateModal = true;

			this.$nextTick(function () {
				if (_this20.$refs && _this20.$refs['textSearchTemplateDialog'] && _this20.$refs['textSearchTemplateDialog'].$el && _this20.$refs['textSearchTemplateDialog'].$el.querySelector('input')) _this20.$refs['textSearchTemplateDialog'].$el.querySelector('input').focus();
			});
		},
		hideTemplateModal: function hideTemplateModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showTemplateModal = false;
			this.hideModalMask();
		},
		templateChoiced: function templateChoiced(text) {
			this.hideTemplateModal();

			if (this.crud !== 'ticket' && this.crud !== 'ticketmessage') return;

			if (text === undefined || text === null || text === '') return;

			var _textarea = __WEBPACK_IMPORTED_MODULE_16_jquery___default()('textarea[name="content"]:first');
			if (!_textarea || !_textarea.length) return;

			var _cursorPosition = _textarea.prop('selectionStart');

			this.insertTextAtCursor(_textarea[0], '\n' + text);

			var _field = this.findField('content');
			if (!_field) return;
			this.$set(_field, 'value', _textarea.val());
			this.fieldChanged(_field);

			this.$nextTick(function () {
				_textarea.setCursorPosition(_cursorPosition);
				_textarea.focus();
			});
		},
		insertTextAtCursor: function insertTextAtCursor(el, text) {
			var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

			var val = el.value;
			var endIndex = void 0;
			var range = void 0;
			var doc = el.ownerDocument;

			if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
				endIndex = el.selectionEnd;
				el.value = val.slice(0, endIndex) + text + val.slice(endIndex);
				el.selectionStart = el.selectionEnd = endIndex + text.length + offset;
			} else if (doc.selection !== 'undefined' && doc.selection.createRange) {
				el.focus();
				range = doc.selection.createRange();
				range.collapse(false);
				range.text = text;
				range.select();
			}
		},
		filterModalContainers: function filterModalContainers(e) {
			if (!e || !e.target || !e.target.className) return;
			if (e.target.className.indexOf('modal') > -1 || e.target.className === 'input-text') {
				__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}

			if (!e.target.parentNode || !e.target.parentNode.className) return;
			if (e.target.parentNode.className.indexOf('modal') > -1 || e.target.className === 'input-text') {
				__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}
		},
		hideSshKeyModal: function hideSshKeyModal() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showSshKeyModal = false;
			this.hideModalMask();
		},
		onBlurSshKey: function onBlurSshKey(field) {
			this.verifyFieldSshKey(field);
		},
		onFocusSshKey: function onFocusSshKey(field) {
			if (field) field['_errMsg'] = '';
		},
		onEnterKeyDownSshKey: function onEnterKeyDownSshKey() {
			this.sshKeyCreateBegin();
		},
		verifyFieldSshKey: function verifyFieldSshKey(field) {},
		isVisibleSshKeyField: function isVisibleSshKeyField(row) {
			if (!row || !Array.isArray(row) || !row.length) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden') {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		findSshKeyField: function findSshKeyField(name) {
			var _rows = this.sshKeyFields.fields;
			if (!_rows || !Array.isArray(_rows)) return;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		sshKeyCreateBegin: function sshKeyCreateBegin() {
			var _this21 = this;

			var _field = this.findSshKeyField('name');
			if (!_field) return;
			if (!_field.value) {
				_field['_errMsg'] = 'error/required_field';
				return;
			}
			var _keyName = _field.value;

			_field = this.findSshKeyField('data');
			if (!_field) return;
			if (!_field.value) {
				_field['_errMsg'] = 'error/required_field';
				return;
			}

			this.localErrorMessage = '';

			var _isErr = this.sshKeyFields.fields.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true) {
							if (fld.value === undefined || fld.value === null) {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});
			if (_isErr) return;

			var _url = this.APIServerUrl + '/sshkey/create';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					_this21.sshKeyFields.fields.forEach(function (row) {
						if (row && Array.isArray(row) && row.length) {
							row.forEach(function (fld) {
								var _value = fld['value'];
								if (fld['type'] === 'boolean') {
									_value = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(fld['value']) ? 1 : 0;
								}
								_post[_dt['model']][fld['_field_name']] = _value;
							});
						}
					});

					_this21.$http.post(_url, __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['sshkey'] && _dt['sshkey']['key_id']) {
							_this21.setLocalSuccessMessage('sshkey/created');

							var _field4 = _this21.findField('sshkey_id');
							if (_field4) {
								_field4.type = 'list';
								delete _field4.buttonFunction;
								delete _field4.buttonText;

								var _found = _field4['list'].some(function (obj) {
									return obj && String(obj.id) === '-1000';
								});

								if (!_found) {
									_field4['list'].push({
										'id': -1000,
										'name': _this21.localeFtc('sshkey/not_use')
									});
								}

								_field4['list'].push({
									'id': _dt['sshkey']['key_id'],
									'name': _keyName
								});

								_field4['value'] = String(_dt['sshkey']['key_id']);
							} else _this21.requestData();

							_this21.hideSshKeyModal();

							return;
						}

						if (_dt && _dt['status'] === 'error' && _dt['fields'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_dt['fields']) === 'object') {
							for (var f in _dt['fields']) {
								if (_dt['fields'].hasOwnProperty(f)) {
									var _fld = _this21.findSshKeyField(f);
									if (_fld) {
										_fld['_errMsg'] = _this21.localeFtc('main/error_desc').replace(':', '');
										__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');

										if (Array.isArray(_dt['fields'][f])) {
											if (_dt['fields'][f].length) _fld['_errMsg'] = _this21.localeFtc(_dt['fields'][f][0]);
										} else _fld['_errMsg'] = _this21.localeFtc(_dt['fields'][f]);
									}
								}
							}return;
						}

						_this21.hideSshKeyModal();

						_this21.localErrorMessage = _this21.formatRequestError(resPost);
					}, function (resPost) {
						_this21.hideSshKeyModal();

						_this21.localErrorMessage = _this21.formatRequestError(resPost);
					});

					return;
				}

				_this21.hideSshKeyModal();

				_this21.localErrorMessage = _this21.formatRequestError(resGet);
			}, function (resGet) {
				_this21.hideSshKeyModal();

				_this21.localErrorMessage = _this21.formatRequestError(resGet);
			});
		},
		clearSettingsStart: function clearSettingsStart() {
			this.$store.commit('clearUserOptionsOnServer');

			var _reg = new RegExp('^w5_' + this.$store.state.user_id, 'i');
			var _keys = [];

			for (var i = 0; i < localStorage.length; i++) {
				var _key = localStorage.key(i);

				if (_reg.test(_key) || String(_key).indexOf('vds_clone_process_') === 0) {
					_keys.push(_key);
				}
			}

			_keys.forEach(function (k) {
				localStorage.removeItem(k);
			});

			_keys = [];

			for (var _i3 = 0; _i3 < sessionStorage.length; _i3++) {
				var _key4 = sessionStorage.key(_i3);

				if (_reg.test(_key4)) _keys.push(_key4);
			}

			_keys.forEach(function (k) {
				sessionStorage.removeItem(k);
			});

			this.clearSettings = false;
		},
		blockApplicationHandler: function blockApplicationHandler() {
			if (!window.sessionStorage) return;

			if (!__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].isFormChanged(this.formData, this.crud, this.action, this.$store)) return;

			var _key = 'formSaver_' + this.$route.path.replace(/\//g, '_');
			window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.formData));
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		collectData: function collectData(rows) {
			var _this22 = this;

			var data = {};

			for (var idx in rows) {
				if (!rows[idx] || !Array.isArray(rows[idx])) continue;

				var row = rows[idx];

				var _loop2 = function _loop2(k) {
					var field = row[k];

					if (!field['_field_name']) return 'continue';

					if (field['fake'] === true) return 'continue';

					if (field['_errMsg'] && field['_visible']) {
						_this22.buttonBlock = 0;
						return {
							v: false
						};
					}

					var _val = field['value'];

					if (field['type'] === 'file' || field['type'] === 'image') {
						if (field['_deleteFile'] === true) {
							data[field['_field_name'] + '_delete'] = 1;
						}

						if (field['multifile'] !== true) {
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null;
						}
					}

					if (Array.isArray(field['value'])) {
						if (!field['value'].length) _val = null;else {
							_val = [];

							field['value'].forEach(function (item) {
								if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) === 'object' && item['id']) {
									_val.push(item['id']);
								} else _val.push(item);
							});
						}
					}

					if (field['required'] === true && field['_visible']) {
						if (_val === undefined || _val === null) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}

						if (Array.isArray(_val) && _val.length === 0) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}
					}

					if (!_this22.localValidation(field)) {
						_this22.buttonBlock = 0;
						return {
							v: false
						};
					}

					if (_val === undefined || _val === null) {
						if (_this22.crud === 'rackdevice' && field['type'] === 'boolean') {
							data[field['_field_name']] = 0;
							return 'continue';
						}

						if (/^\w+\[\w+\]/i.test(field['_field_name'])) data[field['_field_name']] = '';

						return 'continue';
					}

					if (parseInt(_val, 10) === -1000 && (field['_field_name'] === 'sshkey_id' || field['_field_name'] === 'reserve_ip')) {
						return 'continue';
					}

					if (field['type'] === 'boolean') _val = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(_val) ? 1 : 0;

					if (field['type'] === 'text' && (field['_field_name'].indexOf('phone') > -1 || field['_field_name'].indexOf('[fax]') > -1)) {
						if (field['validator'] === 'phone') {
							_val = String(_val).replace(/_/g, '');

							if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1) {
								_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '');
							} else {
								_val = _val.replace('-', ' ');
								_val = _val.replace('-', ' ');

								_val = _val.replace(/-/g, '');
							}
						} else {
							_val = String(_val).replace(/[()\s]/g, '');
						}
					}

					if (field['type'] === 'date' && field['format']) {
						_val = String(_val);
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val)) _val = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].FormatDateTime(_val, field['format']);
					}

					if (field['_field_name'] === 'plan_group_id' && field['type'] === 'list' && !field['multiselect'] && field['value'] && Array.isArray(field['value']) && field['value'].length) {
						var planField = _this22.findField('plan_id');
						if (!planField || !planField.list || !planField.list.length || !planField.value) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}

						_val = null;
						planField.list.some(function (plan) {
							if (String(plan.id) === String(planField.value)) {
								_val = plan.group;
								return true;
							}
						});

						if (!_val) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}
					}

					if (_this22.crud === 'disks') {
						if (field['_field_name'] === 'options' && !field['required'] && !_val) {
							return 'continue';
						}
						if (!field['_visible'] && !field['required']) {
							return 'continue';
						}
					}

					data[field['_field_name']] = _val;

					if (_this22.crud === 'vds' && field['_field_name'] === 'plan_id') {
						if (!field.list || !field.list.length || !field.value) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}

						var _plan = null;
						field.list.some(function (plan) {
							if (String(plan.id) === String(field.value)) {
								_plan = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, plan);
								return true;
							}
						});

						if (!_plan) {
							field['_errMsg'] = 'error/required_field';
							_this22.buttonBlock = 0;
							return {
								v: false
							};
						}

						if (_plan.has_params && _plan.params && _this22.params) {
							for (var p in _this22.params) {
								data[p] = _this22.params[p];
							}
						}
					}
				};

				for (var k in row) {
					var _ret2 = _loop2(k);

					switch (_ret2) {
						case 'continue':
							continue;

						default:
							if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
					}
				}
			}

			return data;
		},
		FD_rePack: function FD_rePack(data) {
			var k = void 0;
			var n1 = void 0;
			var n2 = void 0;
			var key1 = void 0;
			var key2 = void 0;

			for (k in data) {
				if (data.hasOwnProperty(k)) {
					n1 = k.indexOf('[');
					if (n1 < 0) continue;

					n2 = k.indexOf(']', n1);
					if (n2 < 0) continue;

					key1 = k.substr(0, n1);
					key2 = k.substring(n1 + 1, n2);

					if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

					if (!data[key1]) data[key1] = {};

					data[key1][key2] = data[k];

					delete data[k];

					data[key1] = this.FD_rePack(data[key1]);
				}
			}return data;
		},
		onBeforePopState: function onBeforePopState() {
			if (this.isFormSubmited) return true;

			if (!this.$store.state.is_auth) return true;

			if (this.$store.state.isInitFormsValue > 0) return true;

			if (this.$store.state.applicationBlocked) {
				return false;
			}

			if (__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].isFormChanged(this.formData, this.crud, this.action, this.$store) || this.isConstructPlanChanged) {
				var _question = 'application/leave_page_confirm';

				if (this.$store.state.uploadFileCounter > 0) _question = this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?';

				if (confirm(this.localeFtc(_question))) {
					return true;
				} else {
					return false;
				}
			}

			return true;
		},
		onBeforeUnload: function onBeforeUnload() {
			if ((__WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].isFormChanged(this.formData, this.crud, this.action, this.$store) || this.isConstructPlanChanged) && !this.$store.state.applicationBlocked) {
				if (this.$store.state.uploadFileCounter > 0) return this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?';

				return 'Возможно, внесенные изменения не сохранятся.';
			}
		},
		getCurrentVdsGroup: function getCurrentVdsGroup() {
			if (this.$route.params['groupId']) return this.$route.params['groupId'];
			if (this.$store.state.vdsGroup.currentGroupId) return this.$store.state.vdsGroup.currentGroupId;
			if (this.$store.state.vdsGroup.firstGroupId) return this.$store.state.vdsGroup.firstGroupId;
			return '';
		},
		setVolume: function setVolume() {
			this.$store.commit('toggleAudioNitificationOption');
		},
		setTrack: function setTrack(value) {
			if (this.trackNo === value) return;

			var _name = 'audioNotif_0' + String(value);

			if (this.$refs[_name]) {
				this.trackNo = value;

				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

				this.audio = this.$refs[_name];

				this.audio.addEventListener('canplay', this.audioCanPlay);

				if (this.whatVolume) {
					this.audio.currentTime = 0;
					try {
						this.audio.play().catch(function () {});
					} catch (e) {}
				}

				this.$store.commit('setAudioTrackNitificationOption', value);
			}
		},
		audioCanPlay: function audioCanPlay() {
			this.canPlay = true;
		},
		optionHandler: function optionHandler() {
			this.whatVolume = __WEBPACK_IMPORTED_MODULE_10__helper_helper__["a" /* default */].normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification);

			if (!('play_audio_on_notification' in this.$store.state.userServerOptions)) this.whatVolume = true;

			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10);
			if (isNaN(this.trackNo) || this.trackNo < 0 || this.trackNo > 5) this.trackNo = 0;

			var _name = 'audioNotif_0' + this.trackNo;
			if (this.$refs[_name]) {
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

				this.audio = this.$refs[_name];

				this.audio.addEventListener('canplay', this.audioCanPlay);
			}
		},
		gotoUrl: function gotoUrl(url) {
			if (window && window.sessionStorage) {
				var _key = 'formSaver_' + this.$route.path.replace(/\//g, '_');
				window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.formData));
			}

			this.$router.push(url);
		},
		onTemplateTab: function onTemplateTab(tab) {
			var _this23 = this;

			this.activeCreateVdsTemplateTab = tab;

			if (this.crud !== 'vds') return;
			if (tab !== 'backup' && tab !== 'iso') return;

			var _acc = null;
			var _data = null;

			var _field = this.findField('account_id');
			if (_field && _field.value) _acc = _field.value;

			_field = this.findField('datacenter_id');
			if (_field && _field.value) _data = _field.value;

			if (this.createVdsTemplateTabCache.tab !== tab || this.createVdsTemplateTabCache.account_id !== _acc || this.createVdsTemplateTabCache.datacenter_id !== _data) {
				this.createVdsTemplateTabCache.tab = tab;
				this.createVdsTemplateTabCache.account_id = _acc;
				this.createVdsTemplateTabCache.datacenter_id = _data;

				this.$nextTick(function () {
					return _this23.reloadif('account_id');
				});
			}
		},
		createBackup: function createBackup() {
			if (window && window.sessionStorage) {
				var _data = {
					type: 'create'
				};

				var _accField = this.findField('account_id');
				if (_accField && _accField.value) _data['account_id'] = _accField.value;

				window.sessionStorage.setItem('create-backup', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_data));
			}

			this.$router.push('/backups/list');
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			var _parts = msg.split(' ');

			if (_parts && _parts[0] === 'update' && _parts[1] === 'email' && _parts[2] && _parts[2].indexOf('@') > 0 && this.crud === 'certificate' && this.action === 'create') {
				var _email = _parts[2];

				var _domain = _email.substring(_parts[2].indexOf('@') + 1);

				var _field = this.findField('name');
				if (!_field) return;

				if (_field['value'] === _domain) {
					_field['_errMsg'] = '';

					this.submitForm();
				}
			}
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				var _key = 'formStorage_' + this.$route.path.replace(/\//g, '_');
				window.sessionStorage.setItem(_key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.formData));

				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestData();
			}
		},
		handlePlanConstructorChanged: function handlePlanConstructorChanged(value) {
			this.isConstructPlanChanged = value;
		},
		handleCreateFieldReloaded: function handleCreateFieldReloaded(name) {
			var _this24 = this;

			if (this.crud === 'vds' && this.action === 'create') {
				if (name === 'plan_id') {
					this.$nextTick(function () {
						var plan = _this24.findField('plan_id');
						if (plan && plan.list && plan.list.length) {
							if (!plan.value && _this24.activeCreateVdsTemplateTab === 'backup') {
								var firstValue = plan.list[0]['id'];
								var dc = _this24.findField('datacenter_id');
								if (dc) _this24.reloadifLoading('plan_id', dc, firstValue);
							}
						}
					});
				}
			}
		},
		onOuterDiskTypeChanged: function onOuterDiskTypeChanged(value) {
			if (this.formData && this.formData.fields && this.formData.fields.length) {
				this.outerDiskSavedFields = null;
				var _changedFields = {};
				var _isNeedToSave = false;

				for (var _idx in this.formData.fields) {
					var _row = this.formData.fields[_idx];
					if (!_row || !_row.length) continue;

					for (var _jdx in _row) {
						var _field = _row[_jdx];
						if (!_field || !('value' in _field) || _field.type === 'header') {
							if (_field._field_name !== 'name' && _field._field_name !== 'backup_id') {
								continue;
							}
						}

						_changedFields[_field._field_name] = {
							value: _field.value,
							visible: _field._visible
						};
						_isNeedToSave = true;
					}
				}

				if (_isNeedToSave) {
					this.outerDiskSavedFields = _changedFields;
				}
			}

			this.outerDiskTypeValue = value;

			this.outerDiskRequestType = true;

			this.requestData();
		},
		onAutoprolongWarning: function onAutoprolongWarning() {
			var _this25 = this;

			this.generalDialogShow('service/autoprolong', this.localeFtc('service/autoprolong_off'), this.localeFtc('main/detach'), function () {
				_this25.hideGeneralDialog();
				__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-set-bool-field-value', {
					name: 'autoprolong',
					value: false
				});
			}, 1, true);
		},
		hideGeneralDialog: function hideGeneralDialog() {
			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showGeneralDialog = false;
			this.hideModalMask();
		},
		generalDialogShow: function generalDialogShow(title, text, buttonTitle) {
			var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var _this26 = this;

			var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
			var buttonCounter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

			this.generalDialogTitle = title;
			this.generalDialogText = text;
			this.generalDialogButtonStyle = style;
			this.generalDialogCallback = function () {
				if (_this26.generalDialogTimer > 0) return;
				callback();
			};
			this.generalDialogButtonTitle = buttonTitle;

			if (buttonCounter) {
				if (this.generalDialogTimerHandler) clearInterval(this.generalDialogTimerHandler);
				this.generalDialogTimer = 5;
				this.generalDialogButtonTitle = '5 - ' + buttonTitle;
			}

			__WEBPACK_IMPORTED_MODULE_12__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showGeneralDialog = true;

			if (buttonCounter) {
				this.generalDialogTimerHandler = setInterval(function () {
					_this26.generalDialogTimer--;
					_this26.generalDialogButtonTitle = _this26.generalDialogTimer + ' - ' + buttonTitle;

					if (_this26.generalDialogTimer <= 0) {
						_this26.generalDialogButtonTitle = buttonTitle;
						clearInterval(_this26.generalDialogTimerHandler);
						_this26.generalDialogTimerHandler = null;
					}
				}, 1000);
			}
		},
		handleObserver: function handleObserver(entries) {
			var _this27 = this;

			if (!entries || !entries.length) return;
			if (this.$store.state.windowWidth <= 0 || this.$store.state.windowWidth > 768) {
				return;
			}

			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					_this27.isFormButtonFixed = false;
				} else {
					_this27.isFormButtonFixed = true;
				}
			});
		}
	},

	watch: {
		'$route': function $route(to, from) {
			var _oldCrud = this.crud;
			var _oldAction = this.action;

			this.initData(to.path);

			if (_oldCrud !== this.crud || _oldAction !== this.action) {
				this.formData = {
					title: ' '
				};
			}

			if (this.crud) this.requestData();
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_8__components_elements_formfield___default.a,
		textSearch: __WEBPACK_IMPORTED_MODULE_13__components_elements_text___default.a,
		notice: __WEBPACK_IMPORTED_MODULE_14__components_elements_notice___default.a,
		OuterDiskType: __WEBPACK_IMPORTED_MODULE_9__components_elements_outerdisktype___default.a
	}

});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);




var errorsDic = {
	'person': {
		'required': 'person/error_required',
		'list': 'person/error_list',
		'max': 'person/error_max_length'
	},
	'payer': {
		'required': 'payer/error_required',
		'list': 'payer/error_list',
		'max': 'payer/error_max_length'
	}
};

var arrayFields = function arrayFields(Data) {
	var _names = {};

	for (var _fieldName in Data) {
		if (Data.hasOwnProperty(_fieldName)) {
			var _match = _fieldName.match(/^(\w+)\[(.*)$/i);

			if (!_match || !_match[1]) continue;

			_names[String(_match[1])] = true;
		}
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_names);
};

var getFieldValue = function getFieldValue(fieldName, Data) {
	for (var _fieldName in Data) {
		if (Data.hasOwnProperty(_fieldName)) {
			if (_fieldName !== fieldName) continue;else return Data[_fieldName].value;
		}
	}
	return null;
};

var personValidators = {
	'low_name_russian': function low_name_russian(value) {
		if (value.length > 254) return 'person/error_lnr_max';else if (value.match(/(«|»)/g)) return 'person/error_lnr_quotes';else if (value.match(/(\\|\/)/g)) return 'person/error_lnr_slashes';else if (!/^[0-9а-яё\-",. ]*$/i.test(value)) return 'person/error_lnr_reg';
		return '';
	},
	'low_name_english': function low_name_english(value) {
		if (value.length > 254) return 'person/error_lne_max';else if (value.match(/(«|»)/g)) return 'person/error_lne_quotes';else if (value.match(/(\\|\/)/g)) return 'person/error_lne_slashes';else if (!/^[0-9a-z\-",. ]*$/i.test(value)) return 'person/error_lne_reg';
		return '';
	},
	'inn_10': function inn_10(value) {
		if (value.length !== 10) return 'person/error_inn10';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkINN(value)) return 'person/error_inn10cc';
		return '';
	},
	'inn_12': function inn_12(value) {
		if (value.length !== 12) return 'person/error_inn12';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkINN(value)) return 'person/error_inn12cc';
		return '';
	},
	'kpp': function kpp(value) {
		if (!/^\d{9}$/.test(value)) return 'person/error_kpp';
		return '';
	},
	'ogrn': function ogrn(value) {
		if (value.length !== 13) return 'person/error_ogrn';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkOGRN(value)) return 'person/error_ogrncc';
		return '';
	},
	'email': function email(value) {
		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].validateEmail(value)) return 'person/error_email';
		return '';
	},
	'phone': function phone(value) {
		var _val = String(value).replace(/_/g, '');
		if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1) {
			_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '');
		} else {
			_val = _val.replace('-', ' ');
			_val = _val.replace('-', ' ');
			_val = _val.replace(/-/g, '');
		}
		var _clearVal = _val.replace(/ /g, '');

		var _test = /^\+\d+ ?\d+ ?\d+$/.test(_val) && _clearVal.length <= 15;
		if (!_test) return 'person/error_phone';

		return '';
	},
	'address_russian': function address_russian(value) {
		if (value.length > 254) return 'person/error_ar_max';else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'person/error_ar_reg';
		return '';
	},
	'address_post_russian': function address_post_russian(value) {
		if (value.length > 254) return 'person/error_apr_max';else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'person/error_apr_reg';else if (!/[а-яё. ]{3,}$/i.test(value)) return 'person/error_apr_to';
		return '';
	},
	'phis_name_russian': function phis_name_russian(value) {
		if (value.length > 64) return 'person/error_pnr_max';else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value)) return 'person/error_pnr_reg';
		return '';
	},
	'phis_name_russian_plus': function phis_name_russian_plus(value) {
		if (value.length > 96) return 'person/error_pnr_max';else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value)) return 'person/error_pnr_reg';
		return '';
	},
	'phis_name_english': function phis_name_english(value) {
		if (value.length > 64) return 'person/error_pne_max';else if (!/^([A-Z]{1}[A-Za-z\-]+ [A-Z]{1} [A-Z]{1}[A-Za-z\-]+|[A-Z]{1}[A-Za-z\-]+ [A-Z]{1}[A-Za-z\-]+)$/.test(value)) return 'person/error_pne_reg';
		return '';
	},
	'phis_name_english_2': function phis_name_english_2(value) {
		if (value.length > 64) return 'person/error_pne2_max';else if (!/^[A-Z]{1}[A-Za-z\-]+ [A-Z]{1}[A-Za-z\-]+$/.test(value)) return 'person/error_pne2_reg';
		return '';
	},
	'date': function date(value, format, fieldName) {
		var _val = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].FormatDateTime(value, format);
		var _exp = '^' + format.replace('d', '\\d{2}').replace('m', '\\d{2}').replace('y', '\\d{2}').replace('Y', '\\d{4}') + '$';
		var _reg = new RegExp(_exp);

		if (!_reg.test(_val)) return 'person/error_date';else {
			if (fieldName.indexOf('[birth_date]') > 0) {
				var _dt = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].FormatedStrDate2Date(value, format);
				var _years = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].calculateAge(_dt);
				if (_years >= 100) return 'person/too_high_age';
			}
		}

		return '';
	},
	'passport': function passport(value) {
		if (value.length > 254) return 'person/error_passport_max';else if (!/^[0-9 a-zA-Z\-а-яёА-ЯЁ]+ выдан .{4,}, \d{2}\.\d{2}\.\d{4}$/.test(value)) return 'person/error_passport_reg';
		return '';
	},
	'zip': function zip(value) {
		if (!/^[A-Z \-\d]{4,16}$/.test(value)) return 'person/error_zip';
		return '';
	},
	'text_english': function text_english(value) {
		if (!/^[A-Z]{1}[A-Za-z\- ,\.0-9\/]+/.test(value)) return 'person/error_te';
		return '';
	}
};

var payerValidators = {
	'low_name_russian': function low_name_russian(value) {
		if (value.length > 230) return 'payer/error_lnr_max';else if (!/[0-9а-яё\-"«»,. #№]/i.test(value)) return 'payer/error_lnr_reg';
		return '';
	},
	'inn_10': function inn_10(value) {
		if (value.length !== 10) return 'payer/error_inn10';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkINN(value)) return 'payer/error_inn10cc';
		return '';
	},
	'inn_12': function inn_12(value) {
		if (value.length !== 12) return 'person/error_inn12';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkINN(value)) return 'person/error_inn12cc';
		return '';
	},
	'inn': function inn(value) {
		if (value.length !== 10 && value.length !== 12) return 'payer/error_inn10cc';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkINN(value)) return 'payer/error_inn10cc';
		return '';
	},
	'kpp': function kpp(value) {
		if (!/^\d{9}$/.test(value)) return 'payer/error_kpp';
		return '';
	},
	'ogrn': function ogrn(value) {
		if (value.length !== 13 && value.length !== 15) return 'payer/error_ogrn';else if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkOGRN(value)) return 'payer/error_ogrncc';
		return '';
	},
	'email': function email(value) {
		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].validateEmail(value)) return 'payer/error_email';
		return '';
	},
	'phone': function phone(value) {
		var _val = String(value).replace(/_/g, '');
		if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1) {
			_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '');
		} else {
			_val = _val.replace('-', ' ');
			_val = _val.replace('-', ' ');
			_val = _val.replace(/-/g, '');
		}
		var _clearVal = _val.replace(/ /g, '');

		var _test = /^\+\d+ ?\d+ ?\d+$/.test(_val) && _clearVal.length <= 15;
		if (!_test) return 'payer/error_phone';

		return '';
	},
	'address_russian': function address_russian(value) {
		if (value.length > 250) return 'payer/error_ar_max';else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'payer/error_ar_reg';
		return '';
	},
	'phis_name_russian': function phis_name_russian(value) {
		if (value.length > 64) return 'payer/error_pnr_max';else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value)) return 'payer/error_pnr_reg';
		return '';
	},
	'phis_name_russian_plus': function phis_name_russian_plus(value) {
		if (value.length > 96) return 'payer/error_pnrp_max';else if (!/^[А-ЯЁа-яё ]+ ([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value)) return 'payer/error_pnrp_reg';
		return '';
	},
	'text_russian': function text_russian(value) {
		if (!/^[А-ЯЁа-яё\- ,.0-9/#№]+/.test(value)) return 'payer/error_tr';
		return '';
	},
	'bank_bic': function bank_bic(value) {
		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkBIC(value)) return 'payer/error_bic';
		return '';
	},
	'bank_account': function bank_account(value, Data) {
		var bic = getFieldValue('data[bic]', Data);

		if (!bic || !String(bic).trim().length) return '';

		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkBIC(bic)) return '';

		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkKS(value, bic)) return 'payer/error_ks';
		return '';
	},
	'user_account': function user_account(value, Data) {
		var bic = getFieldValue('data[bic]', Data);

		if (!bic || !String(bic).trim().length) return '';

		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkBIC(bic)) return '';

		if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].checkRS(value, bic)) return 'payer/error_rs';
		return '';
	}
};

var validators = {
	'person': personValidators,
	'payer': payerValidators
};

var validatorArray = function validatorArray(Data, crud) {
	if (!Data || !crud) return false;

	var _result = {};

	var _arrayFields = arrayFields(Data);

	if (!_arrayFields || !_arrayFields.length) return false;

	_arrayFields.forEach(function (arrayName) {
		for (var _fieldName in Data) {
			if (Data.hasOwnProperty(_fieldName)) {
				var _reg = new RegExp('^' + arrayName + '\\[\\w+\\](.*)$', 'i');
				if (!_reg.test(_fieldName)) continue;

				var _field = Data[_fieldName];

				if (_field['_errMsg']) continue;

				if (!_field['_visible']) continue;

				if (_field['required'] === true && (_field['value'] === undefined || _field['value'] === null || _field['value'] === '')) {
					_result[_fieldName] = errorsDic[crud]['required'];

					continue;
				}

				if (_field['type'] === 'list' && _field['list']) {
					if (!__WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].valueInList(_field['value'], _field['list'])) {
						if (_field['required'] === true) {
							_result[_fieldName] = errorsDic[crud]['list'];

							continue;
						}
					}
				}

				if ('max' in _field && _field['max'] > 0 && String(_field['value']).length > _field['max']) {
					_result[_fieldName] = errorsDic[crud]['max'] + ' ' + _field['max'];

					continue;
				}

				if (!_field['validator']) continue;

				var _value = _field['value'] !== undefined && _field['value'] !== null && _field['value'] !== '' ? String(_field['value']) : null;

				if (!_value) continue;

				var _validator = validators[crud] ? validators[crud] : personValidators;

				if (_validator[_field['validator']]) {
					var _err = '';
					if (_field['validator'] === 'date') _err = _validator[_field['validator']](_value, _field['format'], _fieldName);else if (_field['validator'] === 'bank_account' || _field['validator'] === 'user_account') _err = _validator[_field['validator']](_value, Data);else _err = _validator[_field['validator']](_value);

					if (_err) _result[_fieldName] = _err;
				}
			}
		}
	});

	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_result).length ? _result : false;
};

/* harmony default export */ __webpack_exports__["a"] = ({ validators: validators, personValidators: personValidators, validatorArray: validatorArray });

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'textSearch',

	props: ['Field'],
	data: function data() {
		return {
			isRequest: false,
			fieldAnimated: false,
			Focused: false,
			currentValue: '',
			timer: null,
			foundItems: [],
			$listItems: null
		};
	},

	computed: {
		Empty: function Empty() {
			return this.currentValue === undefined || this.currentValue === null || this.currentValue === '';
		},
		Title: function Title() {
			return this.Field.title;
		},
		Url: function Url() {
			return this.Field.url;
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$on('w5-click-on-modal', this.clickHandler);
		document.addEventListener('keydown', this.keyDownHandler);

		if (this.$listItems && this.$listItems.length) this.$listItems.remove();

		this.$listItems = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$refs.listItems);
		if (this.$listItems.length) {
			this.$listItems.detach().appendTo(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body'));
		} else this.$listItems = null;
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* EventBus */].$off('w5-click-on-modal', this.clickHandler);
		document.removeEventListener('keydown', this.keyDownHandler);

		if (this.$listItems && this.$listItems.length) this.$listItems.remove();
	},

	methods: {
		init: function init() {
			this.currentValue = '';
			this.foundItems = [];
			this.isRequest = false;
		},
		setFocus: function setFocus(value) {
			if (value) {
				this.fieldAnimated = true;
			}
			this.$set(this, 'Focused', value);
			this.recountBlock();
			this.$forceUpdate();
		},
		searchTextStart: function searchTextStart() {
			var _this = this;

			if (this.timer) clearTimeout(this.timer);
			this.timer = setTimeout(function () {
				_this.searchText();
			}, 300);
		},
		searchText: function searchText() {
			var _this2 = this;

			if (this.currentValue === undefined || this.currentValue === null || this.currentValue === '') {
				this.init();
				return;
			}

			this.isRequest = true;
			this.foundItems = [];

			this.$http.get(this.APIServerUrl + this.Url + this.currentValue, {
				before: function before(request) {
					if (this.previousRequest) this.previousRequest.abort();

					this.previousRequest = request;
				}
			}).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['result'] && Array.isArray(_dt['result']) && _dt['result'].length) {
					_this2.foundItems = _dt['result'].slice();
				}
			}).catch(function () {
				_this2.isRequest = false;
			}).finally(function () {
				_this2.isRequest = false;
			});
		},
		selectText: function selectText(text) {
			this.init();
			this.$emit('textSelected', text);
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27 && this.foundItems.length) {
				this.init();
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		},
		clickHandler: function clickHandler() {
			this.init();
		},
		recountBlock: function recountBlock() {
			if (!this.$listItems || !this.$listItems.length) return;

			var $component = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);
			if (!$component || !$component.length) return;

			var _elHeight = $component.height();
			var _elOffset = $component.offset();
			var _elWidth = $component.width();
			if (_elWidth <= 0) _elWidth = '100%';

			var _css = {
				top: _elOffset.top + _elHeight + 10,
				left: _elOffset.left,
				maxWidth: _elWidth,
				zIndex: 9998
			};
			if (this.$store.state.windowWidth <= 767) _css.width = _elWidth;

			this.$listItems.css(_css);
		}
	}

});

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-field text-search"
  }, [_c('span', {
    staticClass: "al",
    class: {
      'animated': _vm.fieldAnimated, 'focused': _vm.Focused || !_vm.Empty, 'unfocused': !_vm.Focused && _vm.Empty
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Title))), _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "inputComponent",
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": _vm._f("ftc")('mails/templates')
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }, _vm.searchText],
      "focus": function($event) {
        return _vm.setFocus(true)
      },
      "blur": function($event) {
        return _vm.setFocus(false)
      },
      "click": _vm.init
    }
  }), _vm._v(" "), _c('div', {
    ref: "listItems",
    staticClass: "items-wrapper scrollable"
  }, [_vm._l((_vm.foundItems), function(item) {
    return _c('div', {
      staticClass: "found-item scrollable",
      on: {
        "click": function($event) {
          return _vm.selectText(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRequest),
      expression: "isRequest"
    }],
    staticClass: "found-item"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))])], 2)])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


function MakeQuerablePromise(promise) {
	if (promise.isResolved) return promise;

	var isPending = true;
	var isRejected = false;
	var isFulfilled = false;

	var result = promise.then(function (v) {
		isFulfilled = true;
		isPending = false;
		return v;
	}, function (e) {
		isRejected = true;
		isPending = false;
		throw e;
	});

	result.isFulfilled = function () {
		return isFulfilled;
	};
	result.isPending = function () {
		return isPending;
	};
	result.isRejected = function () {
		return isRejected;
	};

	return result;
}

var Mixin = {
	data: function data() {
		return {
			cachedRequestPull: {},
			cachedRequestData: {}
		};
	},


	methods: {
		_setRequestCachedData: function _setRequestCachedData(url, value) {
			var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60000;

			var now = new Date().getTime();
			this.cachedRequestData[url] = {
				ttl: now + ttl,
				val: value
			};
		},
		_getRequestCachedData: function _getRequestCachedData(url) {
			if (!this.cachedRequestData[url] || !this.cachedRequestData[url].ttl || !this.cachedRequestData[url].val) {
				return null;
			}

			var now = new Date().getTime();
			if (this.cachedRequestData[url].ttl < now) {
				delete this.cachedRequestData[url];
				return null;
			}

			return this.cachedRequestData[url].val;
		},
		cachedRequestGet: function cachedRequestGet(url) {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var answer = _this._getRequestCachedData(url);

				if (answer) return resolve(answer);

				if (!_this.cachedRequestPull[url] || !_this.cachedRequestPull[url].isPending()) {
					_this.cachedRequestPull[url] = MakeQuerablePromise(_this.$http.get(url));
				}

				_this.cachedRequestPull[url].then(function (answer) {
					_this._setRequestCachedData(url, answer);
					resolve(answer);
				}).catch(reject);
			});
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (Mixin);

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', {
    staticClass: "w5-form-wrapper"
  }, [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData.title)))]), _vm._v(" "), (_vm.crud === 'operation' && _vm.action === 'create' && _vm.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "w5-block-bordered"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('operation/bonus_information')),
      expression: "localeFtc('operation/bonus_information')"
    }],
    staticClass: "w5-block-bordered-text"
  })]) : _vm._e(), _vm._v(" "), (_vm.showAdditionalInfo) ? _c('div', {
    staticClass: "w5-form-additional-info"
  }, [(_vm.formInfo.max) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/available_to_order')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.max))]), (_vm.formInfo.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formInfo.cost) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.cost))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  }), (_vm.formInfo.period) ? _c('span', [_vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.formInfo.period)))]) : _vm._e(), (_vm.crud === 'disks' && _vm.formInfo.for) ? _c('span', [_vm._v(" / 1 " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "w5-from",
    class: {
      'form-with-divider': _vm.isFormWithDivider
    },
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": (_vm.form_Loading || _vm.isFormLocked) && !_vm.outerDiskRequestType
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row),
          'with-number-divider': _vm.isFormWithNumberDivider,
          'divider-field': _vm.isDividerField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "countVisibleFieldsInRow": _vm.countVisibleFieldsInRow(row),
          "objID": _vm.id,
          "crud": _vm.crud,
          "action": _vm.action,
          "Field": field,
          "listBlockToOut": _vm.crud === 'domains' && field._field_name === 'plan_id' ? false : true,
          "linkHint": _vm.LinkHintForField(field, _vm.linkHint),
          "groupField": (_vm.crud === 'vds' || _vm.crud === 'certificate' || _vm.crud === 'domains') && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('plan_group_id') : null,
          "backupField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'template_id' ? _vm.findField('backup_id') : null,
          "accountField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'template_id' ? _vm.findField('account_id') : null,
          "nameField": _vm.crud === 'domains' && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('name') : null,
          "actionField": _vm.crud === 'domains' && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('set_action') : null,
          "planField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'backup_auto' ? _vm.findField('plan_id') : null,
          "planParams": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'backup_auto' ? _vm.params : null,
          "diskQuantity": _vm.crud === 'disks' && _vm.action === 'create' && field._field_name === 'backup_auto' ? _vm.findField('quantity') : null,
          "bigButton": _vm.showPayButton && field._field_name === 'fake_1_1',
          "bigButtonTitle": _vm.showPayButton && field._field_name === 'fake_1_1' ? 'operation/pay' : null,
          "bigButtonHandler": _vm.showPayButton && field._field_name === 'fake_1_1' ? _vm.onClientCreateOperation : null,
          "bigButtonEnabled": _vm.showPayButton && field._field_name === 'fake_1_1' && _vm.isSubmitButtonEnabled,
          "linkButton": _vm.showPayButton && field._field_name === 'fake_1_2',
          "linkButtonTitle": _vm.showPayButton && field._field_name === 'fake_1_2' ? 'paymentauto/update_title' : null,
          "linkButtonUrl": '/paymentauto/create',
          "linkButtonVisible": _vm.showAutoPaymentButton,
          "formFields": _vm.crud === 'vds' && _vm.action === 'create' ? _vm.formData.fields : null,
          "progress": _vm.crud === 'iso' && _vm.action === 'create' && (field._field_name === 'download' || field._field_name === 'library') ? _vm.isoFormFileProgress : null,
          "diskTypeValue": _vm.crud === 'disks' && field._field_name === 'quantity' ? _vm.outerDiskTypeValue : null
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          },
          "abortUpload": function($event) {
            return _vm.fieldChanged(field)
          },
          "uploadFinished": _vm.onUploadFinished,
          "blur": function($event) {
            return _vm.onBlur(field)
          },
          "focus": function($event) {
            return _vm.onFocus(field)
          },
          "blockFormButton": _vm.blockFormButton,
          "unblockFormButton": _vm.unblockFormButton,
          "cropCoords": _vm.cropCoords,
          "enterKeyDown": _vm.onEnterKeyDown,
          "deleteFileValue": _vm.deleteFileValue,
          "operationNextStep": _vm.onClientCreateOperation,
          "answerTemplateDialog": _vm.showTemplateDialog,
          "event_Input": _vm.onTextEvent,
          "groupChanged": _vm.onGroupChanged,
          "domainName": _vm.onDomainName,
          "templateTab": _vm.onTemplateTab,
          "createBackup": _vm.createBackup,
          "deleteSavedPayment": _vm.onDeleteSavedPayment,
          "freePort": _vm.onFreePort,
          "value2FA": _vm.on2FAValue,
          "isoUploadError": _vm.onIsoUploadError,
          "isoUploadCanceled": _vm.onIsoUploadCanceled,
          "isoUploadFinished": _vm.onIsoUploadFinished,
          "outerDiskTypeChanged": _vm.onOuterDiskTypeChanged,
          "autoprolongWarning": _vm.onAutoprolongWarning,
          "params": _vm.onParams
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.crud === 'options') ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearSettings),
      expression: "clearSettings"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": "clearSettings"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearSettings) ? _vm._i(_vm.clearSettings, null) > -1 : (_vm.clearSettings)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearSettings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clearSettings = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clearSettings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clearSettings = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline-flex",
      "height": "3em",
      "line-height": "1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.clearSettings = !_vm.clearSettings
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/clear_settings')) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t \n\t\t\t\t\t"), _c('notice', {
    attrs: {
      "text": _vm._f("ftc")('main/clear_settingst_notice'),
      "index": _vm.clearSettings
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.crud === 'options') ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-field"
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "400",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('notifier/choose_track')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "notifier-track-wrapper"
  }, [_c('span', {
    staticClass: "notifier-track switcher"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.whatVolume ? 'volume-up' : 'volume-mute',
      "fixed-width": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setVolume($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 0 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(0)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 1 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(1)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 2 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(2)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 3 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(3)
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 4 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(4)
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 5 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(5)
      }
    }
  }, [_vm._v("6")])])])]) : _vm._e(), _vm._v(" "), (_vm.crud === 'vds' && _vm.action === 'create' && _vm.formData && _vm.formData.fields && _vm.linkHint && !_vm.linkHintShowIf && _vm.activeCreateVdsTemplateTab !== 'backup') ? _c('div', {
    staticClass: "w5-info-link vds-create"
  }, [_c('font-awesome-icon', {
    staticClass: "margin-right-6",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : (_vm.linkHint && _vm.linkHint.length && _vm.linkHint[0].afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint[0].afterText)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.crud !== 'operation' || _vm.action !== 'create' || _vm.$store.state.user_type !== 'client') ? _c('div', {
    ref: "button_wrapper",
    staticClass: "w5-field form-button",
    class: {
      'margin-top-30': _vm.isFormWithDivider
    }
  }, [_c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-primary w5-button-save",
    class: {
      hidden: _vm.form_Loading && !_vm.outerDiskRequestType, fxd: _vm.isFormButtonFixed
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 && !_vm.outerDiskRequestType ? 'disabled' : false
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.action === 'update' || _vm.action === 'alerts' || _vm.action === 'links' ? 'main/save' : 'main/create')) + "\n\t\t\t\t")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.formData && _vm.formData.fields && _vm.linkHint && _vm.linkHint.position === 'bottom') ? _c('div', {
    staticClass: "w5-info-link margin-right-10 margin-top-20"
  }, [(_vm.linkHintShowIf) ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))])] : _c('font-awesome-icon', {
    staticClass: "margin-right-6",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoneyModal),
      expression: "showMoneyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideMoneyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.moneyModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideMoneyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-danger font-size-90 margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.moneyModalText),
      expression: "moneyModalText"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.moneyModalAddButton !== '') ? _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.continueSubmit
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.moneyModalAddButton)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToMoney
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/replenishment')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateModal),
      expression: "showTemplateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textSearch', {
    ref: "textSearchTemplateDialog",
    attrs: {
      "Field": _vm.templateField
    },
    on: {
      "textSelected": _vm.templateChoiced
    }
  })], 1)])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSshKeyModal),
      expression: "showSshKeyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideSshKeyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('sshkey/create_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideSshKeyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.sshKeyFields && _vm.sshKeyFields.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.sshKeyFields.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleSshKeyField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleSshKeyField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "sshkey",
          "action": "create",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurSshKey(field)
          },
          "focus": function($event) {
            return _vm.onFocusSshKey(field)
          },
          "enterKeyDown": _vm.onEnterKeyDownSshKey
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.sshKeyCreateBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('sshkey/create_button')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPayerDialogModal),
      expression: "showPayerDialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/payer')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('payer/new_alert')),
      expression: "localeFtc('payer/new_alert')"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToCreatePayer
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/create_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.deleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGeneralDialog),
      expression: "showGeneralDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.generalDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.generalDialogText),
      expression: "generalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.generalDialogButtonStyle === 1
    },
    attrs: {
      "disabled": _vm.generalDialogTimer && _vm.generalDialogTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.generalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm.generalDialogButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2FADialogModal),
      expression: "show2FADialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.fields2FA && _vm.fields2FA.__value ? 'twofa/delete_title' : 'twofa/create_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fields2FA && _vm.fields2FA.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.fields2FA.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row v-center': _vm.isVisibleField(row)
      }
    }, [_vm._l((row), function(field) {
      return [(field.type !== 'image') ? _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "twofa",
          "action": "create",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurSshKey(field)
          },
          "focus": function($event) {
            return _vm.onFocusSshKey(field)
          },
          "enterKeyDown": _vm.submit2FAForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _c('img', {
        staticClass: "qr",
        attrs: {
          "src": field.value,
          "title": field.title
        }
      })]
    })], 2) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(!_vm.fields2FA || !_vm.fields2FA.__value) ? _c('div', {
    staticClass: "hidden-xs pull-left"
  }, [_c('a', {
    staticClass: "app-link google-play",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("Google Play")]), _vm._v(" "), _c('a', {
    staticClass: "app-link app-store",
    attrs: {
      "href": "https://apps.apple.com/ru/app/google-authenticator/id388497605",
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("App Store")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.submit2FAForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check')))])])])])])]), _vm._v(" "), _c('audio', {
    ref: "audioNotif_00",
    attrs: {
      "src": "/static/snd/notif.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_01",
    attrs: {
      "src": "/static/snd/notif01.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_02",
    attrs: {
      "src": "/static/snd/notif02.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_03",
    attrs: {
      "src": "/static/snd/notif03.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_04",
    attrs: {
      "src": "/static/snd/notif04.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_05",
    attrs: {
      "src": "/static/snd/notif05.mp3"
    }
  })] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_filterPeriod__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_filterPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_filterPeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_filterDate__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_filterDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_filterDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_filterSelect__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_filterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_filterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_line__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_pie__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_bar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_charts_horbar__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_node_modules_chart_piecelabel_js_build_Chart_PieceLabel_min__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_node_modules_chart_piecelabel_js_build_Chart_PieceLabel_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_node_modules_chart_piecelabel_js_build_Chart_PieceLabel_min__);















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Report',
	data: function data() {
		return {
			reportData: {
				'title': ' '
			},

			id: null,

			model: false,

			localErrorMessage: false,

			filtersData: {
				'period': {
					'active': false,
					'begin': false,
					'end': false,
					'init': false
				},
				'date': {
					'active': false,
					'value': false,
					'init': false
				},
				'select': []
			},

			tableHeader: [[], []],

			tableColumns: {},

			tableRows: [],

			tableItog: {},

			tableGraphColumns: [],

			sortHeaderIndex: {
				colName: '',
				value: 0
			},

			Colors: ['9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333', '999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666', 'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633', 'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC', '9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333', '999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666', 'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633', 'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC'],

			lineChartData: false,
			lineChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index'
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						gridLines: {
							display: true,
							zeroLineColor: '#999'
						},
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								if (value % 1 === 0) return value;
							}
						}
					}]
				}
			},

			pieChartData: false,
			pieChartOptions: {
				cutoutPercentage: 30,
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: true,
					callbacks: {
						label: function label(tooltipItems, data) {
							return ' ' + data['labels'][tooltipItems.index] + ' (' + data['datasets'][0]['data'][tooltipItems.index] + '%)';
						}
					}
				},
				'pieceLabel': {
					fontSize: 11,
					fontFamily: 'Roboto',
					mode: 'percentage',
					precision: 2
				}
			},

			barChartData: false,
			barChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								if (value % 1 === 0) return value;
							}
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			},
			horBarChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function callback(value) {
								if (value % 1 === 0) return value;
							}
						}
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			}
		};
	},

	computed: {
		UserType: function UserType() {
			return this.$store.state.user_type;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.initData(this.$route.path);

		this.requestReportData();
	},

	watch: {
		'$route': function $route(to, from) {
			this.initData(to.path);

			this.requestReportData();
		}
	},

	methods: {
		initData: function initData(path) {
			this.id = null;
			this.localErrorMessage = false;

			this.hideFilters();

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 3 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length || _urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[0] !== 'chart') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'view') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.id = _urlParts[2];
		},
		hideFilters: function hideFilters() {
			this.filtersData.period.active = false;
			this.filtersData.date.active = false;

			if (this.filtersData.select && this.filtersData.select.length) {
				this.filtersData.select.forEach(function (s) {
					s.active = false;
				});
			}
		},
		initFiltersByData: function initFiltersByData(data, storageKey) {
			var _this = this;

			if (!data['filters'] || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data['filters']) !== 'object') return;

			var _loop = function _loop(filterName) {
				var filter = data['filters'][filterName];

				if (filter['type'] === 'date') {
					var _val = String(filter['value']);

					if (filterName === 'date') {
						_this.filtersData.date.active = filter['showif'] === undefined || filter['showif'] === null;
						_this.filtersData.date.showif = filter['showif'];
						_this.filtersData.date.value = null;
						_this.filtersData.date.name = filterName;
						_this.filtersData.date.init = true;

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val)) {
							_this.filtersData.date.value = _val;
						}
					} else if (filterName.indexOf('_start') > -1) {
						_this.filtersData.period.active = filter['showif'] === undefined || filter['showif'] === null;
						if (!_this.filtersData.period.showif) {
							_this.filtersData.period.showif = {};
						}
						_this.filtersData.period.showif.start = filter['showif'];
						_this.filtersData.period.begin = false;
						_this.filtersData.period.name = filterName.replace('_start', '');
						_this.filtersData.period.init = true;

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val)) {
							_this.filtersData.period.begin = _val + ' 00:00:00';
						} else if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val)) {
							_this.filtersData.period.begin = _val;
						}
					} else if (filterName.indexOf('_end') > -1) {
						_this.filtersData.period.active = filter['showif'] === undefined || filter['showif'] === null;
						if (!_this.filtersData.period.showif) {
							_this.filtersData.period.showif = {};
						}
						_this.filtersData.period.showif.end = filter['showif'];
						_this.filtersData.period.end = false;
						_this.filtersData.period.name = filterName.replace('_end', '');
						_this.filtersData.period.init = true;

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val)) {
							_this.filtersData.period.end = _val + ' 23:59:59';
						} else if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val)) {
							_this.filtersData.period.end = _val;
						}
					}
				} else if (filter['type'] === 'list' && filter['list']) {
						var _foundFilter = null;
						if (_this.filtersData.select && _this.filtersData.select.length) {
							_this.filtersData.select.some(function (select) {
								if (select && select.name === filterName) {
									_foundFilter = select;
									return true;
								}
							});
						}

						if (!_foundFilter) {
							_foundFilter = {
								'active': filter['showif'] === undefined || filter['showif'] === null,

								'list': filter['list'],
								'name': filterName,
								'showif': filter['showif'],
								'default': filter['default'],
								'value': false
							};

							if (!_this.filtersData.select || !_this.filtersData.select.length) {
								_this.filtersData.select = [];
							}
							_this.filtersData.select.push(_foundFilter);
						}

						var _val2 = filter['value'];
						var _isNeedAllRecord = false;

						if ('default' in filter) {
							if (_val2 === undefined || _val2 === null || _val2 === '') {
								if (Array.isArray(filter['list'])) {
									var _found = filter['list'].some(function (item) {
										if (item && String(item.id) === String(filter['default'])) {
											_val2 = item.id;
											return true;
										}
									});

									if (!_found) {
										_isNeedAllRecord = true;
										_val2 = -1;
									}
								} else {
									var _found2 = false;
									for (var l in filter['list']) {
										if (String(l) === String(filter['default'])) {
											_val2 = l;
											_found2 = true;
											break;
										}
									}

									if (!_found2) {
										_isNeedAllRecord = true;
										_val2 = -1;
									}
								}
							}
						} else {
							_isNeedAllRecord = true;
						}

						if (_isNeedAllRecord) {
							if (Array.isArray(_foundFilter.list)) {
								var _all = _foundFilter.list.some(function (item) {
									if (String(item.id) === '-1') {
										return true;
									}
								});

								if (!_all) {
									_foundFilter.list.unshift({ 'id': -1, 'name': _this.localeFtc('main/list_all') });
								}
							} else {
								if (!_foundFilter.list['-1']) {
									_foundFilter.list['-1'] = _this.localeFtc('main/list_all');
								}
							}

							if (_val2 === undefined || _val2 === null || _val2 === '') {
								_val2 = -1;
							}
						}

						if (Array.isArray(_foundFilter.list)) {
							_foundFilter.list.some(function (item) {
								if (item && String(item['id']) === String(_val2)) {
									_foundFilter.value = {
										'id': String(item['id']),
										'name': _this.localeFtc(item['name'])
									};
									return true;
								}
							});
						} else {
							for (var _l in _foundFilter.list) {
								if (String(_l) === String(_val2)) {
									_foundFilter.value = {
										'id': _l,
										'name': _this.localeFtc(_foundFilter.list[_l])
									};
									break;
								}
							}
						}
					}
			};

			for (var filterName in data['filters']) {
				_loop(filterName);
			}

			if (window.sessionStorage) {
				window.sessionStorage.setItem(storageKey, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
					'model': this.model,
					'filters': this.filtersData
				}));
			}

			this.showifFilters();
		},
		makeExpression: function makeExpression(showif) {
			var _expr = showif;

			if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
				if (_expr.indexOf(' not in ') !== -1) {
					var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

					if (reg.exec(_expr) !== null) {
						_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
					} else {
						reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
						var _mtch = null;
						if ((_mtch = reg.exec(_expr)) !== null) {
							_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
						}
					}
				} else {
						var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

						if (_reg.exec(_expr) !== null) {
							_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
						} else {
							_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
							var _mtch2 = null;
							if ((_mtch2 = _reg.exec(_expr)) !== null) {
								_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
							}
						}
					}
			} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');

			return _expr;
		},
		findFilter: function findFilter(filterName) {
			if (this.filtersData.date.name === filterName) {
				return this.filtersData.date;
			}

			if (String(this.filtersData.period.name) + '_start' === filterName || String(this.filtersData.period.name) + '_end' === filterName) {
				return this.filtersData.period;
			}

			if (this.filtersData.select && this.filtersData.select.length) {
				var _answer = null;
				this.filtersData.select.some(function (select) {
					if (select.name === filterName) {
						_answer = select;
						return true;
					}
				});

				if (_answer) return _answer;
			}

			return null;
		},
		showifFilters: function showifFilters() {
			var _this2 = this;

			var _values = {};
			var _expressions = {};
			var _yes = false;

			if (this.filtersData.date.init) {
				_values[String(this.filtersData.date.name).replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.date.value;

				if (this.filtersData.date.showif) {
					_yes = true;
					_expressions[this.filtersData.date.name] = this.makeExpression(this.filtersData.date.showif);
				}
			}

			if (this.filtersData.period.init) {
				_values[(String(this.filtersData.period.name) + '_start').replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.period.begin ? this.formater_Date2StrDate(this.filtersData.period.begin) : null;
				_values[(String(this.filtersData.period.name) + '_end').replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.period.end ? this.formater_Date2StrDate(this.filtersData.period.end) : null;

				if (this.filtersData.period.showif && this.filtersData.period.showif.start) {
					_yes = true;
					_expressions[String(this.filtersData.period.name) + '_start'] = this.makeExpression(this.filtersData.period.showif.start);
				}

				if (this.filtersData.period.showif && this.filtersData.period.showif.end) {
					_yes = true;
					_expressions[String(this.filtersData.period.name) + '_end'] = this.makeExpression(this.filtersData.period.showif.end);
				}
			}

			if (this.filtersData.select && this.filtersData.select.length) {
				this.filtersData.select.forEach(function (select) {
					var _val = null;
					if (select.value && 'id' in select.value) {
						_val = select.value['id'];
					}

					_values[String(select.name).replace(/\[/g, '__').replace(/]/g, '__')] = _val;

					if (select.showif) {
						_yes = true;
						_expressions[select.name] = _this2.makeExpression(select.showif);
					}
				});
			}

			if (!_yes) return;

			for (var filterName in _expressions) {
				var _exp = _expressions[filterName];

				var _loop2 = function _loop2(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop2(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _filter = this.findFilter(filterName);
				if (_filter) {
					this.$set(_filter, 'active', _func(_values));
				}
			}
		},
		setFiltersForRequest: function setFiltersForRequest() {
			var _this3 = this;

			if (!this.id || !this.model) return null;

			var _yes = false;
			var _filter = {};
			_filter[this.model] = {};

			if (this.filtersData.date.active) {
				_yes = true;
				_filter[this.model]['date'] = this.filtersData.date.value ? this.formater_Date2StrDate(this.filtersData.date.value) : null;
			}

			if (this.filtersData.period.active) {
				_yes = true;
				_filter[this.model]['date_start'] = this.filtersData.period.begin ? this.formater_Date2StrDate(this.filtersData.period.begin) : null;
				_filter[this.model]['date_end'] = this.filtersData.period.end ? this.formater_Date2StrDate(this.filtersData.period.end) : null;
			}

			if (this.filtersData.select && this.filtersData.select.length) {
				this.filtersData.select.forEach(function (select) {
					if (select && select.name && select.active && select.value && select.value['id'] !== '-1') {
						_yes = true;
						_filter[_this3.model][select.name] = select.value['id'];
					}
				});
			}

			return _yes ? _filter : null;
		},
		keyOfSessionStoreage: function keyOfSessionStoreage() {
			return 'w5_chart_' + (this.id ? this.id : '') + '_' + this.$store.state.user_id;
		},
		getFromSessionStorage: function getFromSessionStorage() {
			var key = this.keyOfSessionStoreage();
			var data = window.sessionStorage ? window.sessionStorage.getItem(key) : false;

			return {
				key: key,
				data: data
			};
		},
		delFromSessionStoreage: function delFromSessionStoreage() {
			var key = this.keyOfSessionStoreage();
			if (window.sessionStorage) {
				window.sessionStorage.removeItem(key);
			}
		},
		requestReportData: function requestReportData() {
			var _this4 = this;

			var _url = '/chart/view/';

			if (this.id) _url += this.id;

			var _storage = this.getFromSessionStorage();
			if (_storage.data) {
				var _storageData = JSON.parse(_storage.data);

				this.filtersData = _storageData['filters'];
				this.model = _storageData['model'];

				window.sessionStorage.removeItem(_storage.key);
			}

			var _filter = false;
			if (this.model) {
				_filter = this.setFiltersForRequest();
			}

			this.sortHeaderIndex = {
				colName: '',
				value: 0
			};

			this.forms_Get(_url, _filter, function (data) {
				if (!data || data['status'] !== 'ok' || !data['rows'] || !data['type']) {
					_this4.form_ErrorMessage = _this4.localeFtc('error/api_incorrect');
				} else {
					_this4.reportData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);

					_this4.model = data['model'];

					_this4.getTableHeader(data['order'], data['columns']);

					_this4.tableRows = [];
					_this4.tableItog = {};
					_this4.tableGraphColumns = [];

					_this4.lineChartData = false;
					_this4.pieChartData = false;
					_this4.barChartData = false;

					_this4.$nextTick(function () {
						_this4.tableRows = _this4.reportData['rows'];

						for (var i in _this4.tableRows) {
							_this4.tableRows[i]['__rowNo'] = parseInt(i, 10);
						}_this4.tableItog = _this4.reportData['totalRow'];
						_this4.tableGraphColumns = _this4.reportData['type']['columns'];

						if (_this4.reportData && _this4.reportData['rows'] && _this4.reportData['type'] && _this4.reportData['type']['abscissa'] && _this4.reportData['type']['view'] === 'graph') _this4.getLineChartData();

						if (_this4.reportData && _this4.reportData['rows'] && _this4.reportData['type'] && _this4.reportData['type']['columns'] && _this4.reportData['type']['view'] === 'pie') _this4.getPieChartData();

						if (_this4.reportData && _this4.reportData['rows'] && _this4.reportData['type'] && _this4.reportData['type']['abscissa'] && _this4.reportData['type']['view'] === 'bar') _this4.getBarChartData();
					});

					if (data['filters']) {
						_this4.initFiltersByData(data, _storage.key);
					}
				}
			});
		},
		getTableHeader: function getTableHeader(order, columns) {
			this.tableHeader = [[], []];
			this.tableColumns = {};

			var idx0 = 0;

			if (!order || !Array.isArray(order) || !columns || (typeof columns === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(columns)) !== 'object') {
				if (this.$store.state.isDebug) window.DEBUG.error('Rgth0: неверный формат колонок таблицы');
				return;
			}

			for (var o in order) {
				var _col = columns[order[o]];
				if (!_col) {
					if (this.$store.state.isDebug) window.DEBUG.error('Rgth1: колонка есть в порядке, но нет в данных о колонках');
					continue;
				}

				var _info = {
					'title': _col['name'] ? this.localeFtc(_col['name']) : this.localeFtc(_col['title']),
					'type': _col['type'],
					'field': order[o]
				};

				if ('from' in _col && 'link' in _col) {
					_info['value'] = _col['value'];
					_info['from'] = _col['from'];
					_info['link'] = _col['link'];
					if ('NAME' in _col['from']) _info['field'] = _col['from']['NAME'];
				}

				if (this.id === 'ip' && _col['link'] && !_info['link']) {
					_info['link'] = _col['link'];
				}

				if (_info['type'] !== 'colspan') this.tableColumns[order[o]] = _info;
				this.tableHeader[0][idx0] = {
					'title': _info['title'],
					'rowspan': 2,
					'colspan': 1,
					'field': _info['field']
				};

				if ('columns' in _col) {
					this.tableHeader[0][idx0]['rowspan'] = 1;
					this.tableHeader[0][idx0]['colspan'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_col['columns']).length;

					for (var oo in _col['columns']) {
						var __col = _col['columns'][oo];
						if (!__col) {
							if (this.$store.state.isDebug) window.DEBUG.error('Rgth2: нет в данных о подколонке');
							continue;
						}

						_info = {
							'title': this.localeFtc(__col['title']),
							'type': __col['type'],
							'colspan': 1,
							'field': oo
						};

						if ('from' in __col && 'link' in __col) {
							_info['value'] = __col['value'];
							_info['from'] = __col['from'];
							_info['link'] = __col['link'];
						}

						if (this.id === 'ip' && __col['link'] && !_info['link']) {
							_info['link'] = __col['link'];
						}

						this.tableColumns[oo] = _info;
						this.tableHeader[1].push({ title: _info['title'], field: _info['field'] });
					}
				}

				idx0++;
			}
		},
		getTableValue: function getTableValue(row, colName, colData) {
			if (!(colName in row)) return '';

			if (colData['type'] === 'integer') {
				var _v = parseInt(row[colName]);
				if (isNaN(_v)) return '-';
				return _v;
			}

			if (colData['type'] === 'float') {
				var _v2 = parseFloat(row[colName]);
				if (isNaN(_v2)) return '-';
				return _v2.toFixed(2);
			}

			if (colData['type'] === 'money') {
				var _v3 = parseFloat(row[colName]);
				if (isNaN(_v3)) return '-';
				return __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].Money2String(_v3, 2, '.', ' ');
			}

			return this.localeFtc(row[colName]);
		},
		linkURL: function linkURL(row, colName, colData) {
			if (this.id === 'ip') {
				if (colData.link && !colData.from) return colData.link;
			}

			if (!('from' in colData) || !('link' in colData) || !('value' in colData)) return '';

			var _href = this.clientRoutePath(colData['link'], row, colName);
			var _hrefField = _href.match(/%(.*?)%/i);
			var _paramName = false;
			if (_hrefField !== null && _hrefField.length > 1) {
				_hrefField = _hrefField[1];
				_paramName = _hrefField;
			}

			if (_hrefField in colData['from']) _hrefField = colData['from'][_hrefField];

			var _hrefValue = _hrefField in row && row[_hrefField] ? row[_hrefField] : false;

			return _href.replace('%' + _paramName + '%', _hrefValue);
		},
		clientRoutePath: function clientRoutePath(path, row, colName) {
			var _mask = {
				'additional-services': '/service/list?ServiceSearch[service_type_id]=15',
				'dns': '/service/list?ServiceSearch[service_type_id]=14',
				'certificate': '/service/list?ServiceSearch[service_type_id]=11',
				'vds': '/service/list?ServiceSearch[service_type_id]=1'
			};

			if (this.id === 'cephresource' && colName === 'services_server') {
				if (row && String(row['server_type']).indexOf('extdisk_') === 0) {
					return path.replace('/service/list', '/disks/list');
				}
				if (row && String(row['server_type']) === 'backup') {
					return path.replace('/service/list', '/backups/list');
				}
			}

			for (var realPath in _mask) {
				if (path.indexOf(_mask[realPath]) === 0) {
					var _realPath = realPath;

					if (this.id === 'cephresource' && realPath === 'additional-services') _realPath = 'backups';

					path = path.replace(_mask[realPath], '');

					if (path) {
						if (path[0] === '&') path = '/' + _realPath + '/list?' + path.substring(1);else path = '/' + _realPath + '/list?' + path;
					} else path = '/' + _realPath + '/list';
					return path;
				}
			}

			return path;
		},
		linkText: function linkText(row, colName, colData) {
			if (this.id === 'ip' && colData['link'] && !colData['from']) {
				return row[colName];
			}

			if (!('from' in colData) || !('link' in colData) || !('value' in colData)) return '';

			var _textValue = null;
			var _text = colData['value'];

			if (_text) {
				var _textField = _text.match(/%(.*?)%/i);
				if (_textField !== null && _textField.length > 1) _textField = _textField[1];

				if (_textField in colData['from']) _textField = colData['from'][_textField];

				_textValue = _textField in row ? row[_textField] : null;
			} else {
				_textValue = colName in row ? row[colName] : null;
			}

			return _textValue;
		},
		cellStyle: function cellStyle(row, colName, colData, rowNo) {
			var _style = 'font-size: 80%; word-wrap: break-word;';
			if (this.id === 'serverresource') _style = 'font-size: 72%; word-wrap: break-word;';

			if (colData['type'] === 'integer' || colData['type'] === 'float' || colData['type'] === 'money') _style += 'text-align: right; overflow: auto; white-space: nowrap;';else if (colData['type'] === 'boolean' || colData['type'] === 'date' || colData['type'] === 'datetime') _style += 'text-align: center;';

			if (rowNo !== 'itog') {
				if (this.reportData['type']['view'] !== 'pie') {
					var _idx = -1;
					for (var r in this.tableGraphColumns) {
						if (this.tableGraphColumns[r] === colName) {
							_idx = r;
							break;
						}
					}

					if (_idx > -1 && this.Colors[_idx]) _style += 'color: #' + this.Colors[_idx] + ';';
				} else if (this.tableGraphColumns[0] === colName) {
					if ('__rowNo' in row) _style += 'color: #' + this.Colors[row['__rowNo']] + ';';else _style += 'color: #' + this.Colors[rowNo] + ';';
				}
			}

			return _style;
		},
		booleanValue: function booleanValue(value) {
			return __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].normalizeBooleanValue(value);
		},
		backButton: function backButton() {
			this.$router.go(-1);
		},
		filterPeriodEvent: function filterPeriodEvent(value) {
			this.delFromSessionStoreage();

			this.filtersData.period.begin = value['begin'] ? this.formater_Date2StrDate(value['begin']) + ' 00:00:00' : false;
			this.filtersData.period.end = value['end'] ? this.formater_Date2StrDate(value['end']) + ' 23:59:59' : false;

			this.showifFilters();

			this.requestReportData();
		},
		filterCommonEvent: function filterCommonEvent() {
			this.delFromSessionStoreage();

			this.showifFilters();

			this.requestReportData();
		},
		getLineChartData: function getLineChartData() {
			var _fieldAbscissa = this.reportData['type']['abscissa'];
			var _rows = this.reportData['rows'];
			var _labels = [];
			var _tmp = '';

			var _columns = this.reportData['type']['columns'];
			var _sets = [];

			for (var i in _rows) {
				_tmp = _rows[i][_fieldAbscissa];

				_labels.push(_tmp);
			}

			for (var c in _columns) {
				var _obj = {
					fill: false,
					lineTension: 0.05,
					borderWidth: 1
				};

				_obj['label'] = this.localeFtc(this.tableColumns[_columns[c]] && this.tableColumns[_columns[c]]['title'] ? this.tableColumns[_columns[c]]['title'] : _columns[c]);

				_obj['borderColor'] = '#' + this.Colors[c];
				_obj['backgroundColor'] = '#' + this.Colors[c];
				_obj['pointBackgroundColor'] = '#' + this.Colors[c];

				_obj['data'] = [];
				for (var _i in _rows) {
					_tmp = _rows[_i][_columns[c]];

					if (this.tableColumns && this.tableColumns[_columns[c]]) {
						if (this.tableColumns[_columns[c]]['type'] === 'integer') _tmp = parseInt(_tmp);else if (this.tableColumns[_columns[c]]['type'] === 'float' || this.tableColumns[_columns[c]]['type'] === 'money') _tmp = parseFloat(_tmp);
					}

					_obj['data'].push(_tmp);
				}

				_sets.push(_obj);
			}

			this.lineChartData = {
				'labels': _labels
			};
			this.lineChartData['datasets'] = _sets;
		},
		getPieChartData: function getPieChartData() {
			var _field = this.reportData['type']['columns'][0];

			var _rows = this.reportData['rows'];
			var _labels = [];
			var _tmp = '';
			var _obj = {
				'data': [],
				'backgroundColor': []
			};

			for (var i in _rows) {
				_tmp = _rows[i][_field];

				if (this.tableColumns && this.tableColumns[_field]) {
					if (this.tableColumns[_field]['type'] === 'integer') _tmp = parseInt(_tmp);else if (this.tableColumns[_field]['type'] === 'float' || this.tableColumns[_field]['type'] === 'money') _tmp = parseFloat(parseFloat(_tmp).toFixed(2));
				}

				_obj['data'].push(_tmp);

				_obj['backgroundColor'].push('#' + this.Colors[i]);

				for (var r in _rows[i]) {
					_tmp = r;

					if (r.indexOf('_name') > -1) break;
				}

				_labels.push(this.localeFtc(_rows[i][_tmp]));
			}

			this.pieChartData = {
				'labels': _labels
			};
			this.pieChartData['datasets'] = [_obj];
		},
		getBarChartData: function getBarChartData() {
			var _fieldAbscissa = this.reportData['type']['abscissa'];
			var _rows = this.reportData['rows'];
			var _labels = [];
			var _tmp = '';

			var _columns = this.reportData['type']['columns'];
			var _sets = [];

			for (var i in _rows) {
				_tmp = _rows[i][_fieldAbscissa];

				_labels.push(_tmp);
			}

			for (var c in _columns) {
				var _obj = {};

				_obj['label'] = this.localeFtc(this.tableColumns[_columns[c]] && this.tableColumns[_columns[c]]['title'] ? this.tableColumns[_columns[c]]['title'] : _columns[c]);

				_obj['borderColor'] = '#' + this.Colors[c];
				_obj['backgroundColor'] = '#' + this.Colors[c];

				_obj['data'] = [];
				for (var _i2 in _rows) {
					_tmp = _rows[_i2][_columns[c]];

					if (this.tableColumns && this.tableColumns[_columns[c]]) {
						if (this.tableColumns[_columns[c]]['type'] === 'integer') _tmp = parseInt(_tmp);else if (this.tableColumns[_columns[c]]['type'] === 'float' || this.tableColumns[_columns[c]]['type'] === 'money') _tmp = parseFloat(_tmp);
					}

					_obj['data'].push(_tmp);
				}

				_sets.push(_obj);
			}

			this.barChartData = {
				'labels': _labels
			};
			this.barChartData['datasets'] = _sets;
		},
		sortLocal: function sortLocal(row, header, idx) {
			if (!header) return;
			if (!this.tableRows || !this.tableRows.length) return;

			var _field = null;

			if (row === 0) {
				if ('colspan' in header && header['colspan'] > 1) return;

				_field = header.field;
				if (!_field) return;
			}

			if (row === 1) {
				_field = header.field;
				if (!_field) return;
			}

			var _sortValue = 0;
			if (this.sortHeaderIndex.colName === _field) _sortValue = this.sortHeaderIndex.value;

			_sortValue++;
			if (_sortValue > 2) _sortValue = 0;

			var _rows = this.tableRows.slice();

			if (_sortValue) {
				this.sortHeaderIndex = {
					colName: _field,
					value: _sortValue
				};

				var _type = 'text';
				for (var _prop in this.tableColumns) {
					if (this.tableColumns.hasOwnProperty(_prop)) {
						var _col = this.tableColumns[_prop];
						if (_col && _col.field === _field) {
							_type = _col.type;
							break;
						}
					}
				}var _compareFunc = null;

				if (_type === 'integer') {
					_compareFunc = function _compareFunc(a, b) {
						var _A = parseInt(a[_field], 10);
						var _B = parseInt(b[_field], 10);
						if (isNaN(_A)) _A = 0;
						if (isNaN(_B)) _B = 0;
						if (_sortValue === 1) {
							if (_A < _B) return -1;
							if (_A > _B) return 1;
						} else {
							if (_A < _B) return 1;
							if (_A > _B) return -1;
						}

						return 0;
					};
				} else if (_type === 'float' || _type === 'money') {
					_compareFunc = function _compareFunc(a, b) {
						var _A = parseFloat(a[_field]);
						var _B = parseFloat(b[_field]);
						if (isNaN(_A)) _A = 0;
						if (isNaN(_B)) _B = 0;
						if (_sortValue === 1) {
							if (_A < _B) return -1;
							if (_A > _B) return 1;
						} else {
							if (_A < _B) return 1;
							if (_A > _B) return -1;
						}

						return 0;
					};
				} else if (_type === 'date' || _type === 'datetime') {
					_compareFunc = function _compareFunc(a, b) {
						var _A = a[_field];
						var _B = b[_field];
						if (_type === 'date') {
							_A = _A.split('.').reverse().join('.');
							_B = _B.split('.').reverse().join('.');
						} else {
							if (/^\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}$/.test(_A)) {
								_A = new Date(_A.substr(6, 4), _A.substr(3, 2) - 1, _A.substr(0, 2), _A.substr(11, 2), _A.substr(14, 2));
								_B = new Date(_B.substr(6, 4), _B.substr(3, 2) - 1, _B.substr(0, 2), _B.substr(11, 2), _B.substr(14, 2));
							} else if (/^\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}:\d{2}$/.test(_A)) {
								_A = new Date(_A.substr(6, 4), _A.substr(3, 2) - 1, _A.substr(0, 2), _A.substr(11, 2), _A.substr(14, 2), _A.substr(17, 2));
								_B = new Date(_B.substr(6, 4), _B.substr(3, 2) - 1, _B.substr(0, 2), _B.substr(11, 2), _B.substr(14, 2), _B.substr(17, 2));
							}
						}

						if (_sortValue === 1) {
							if (_A < _B) return -1;
							if (_A > _B) return 1;
						} else {
							if (_A < _B) return 1;
							if (_A > _B) return -1;
						}

						return 0;
					};
				} else if (_type === 'boolean') {
					_compareFunc = function _compareFunc(a, b) {
						var _A = __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].normalizeBooleanValue(a[_field]);
						var _B = __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].normalizeBooleanValue(b[_field]);
						if (_sortValue === 1) {
							if (_A < _B) return -1;
							if (_A > _B) return 1;
						} else {
							if (_A < _B) return 1;
							if (_A > _B) return -1;
						}

						return 0;
					};
				} else {
					if (this.id === 'serverresource') _compareFunc = __WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* default */].naturalCompareObjectField(_field, _sortValue);else _compareFunc = function _compareFunc(a, b) {
						if (_sortValue === 1) {
							if (a[_field] < b[_field]) return -1;
							if (a[_field] > b[_field]) return 1;
						} else {
							if (a[_field] < b[_field]) return 1;
							if (a[_field] > b[_field]) return -1;
						}

						return 0;
					};
				}

				_rows.sort(_compareFunc);

				this.$set(this, 'tableRows', _rows);
			} else {
				this.sortHeaderIndex = {
					colName: '',
					value: 0
				};

				_rows.sort(function (a, b) {
					if (a['__rowNo'] < b['__rowNo']) return -1;
					if (a['__rowNo'] > b['__rowNo']) return 1;

					return 0;
				});

				this.$set(this, 'tableRows', _rows);
			}
		},
		headerStyle0: function headerStyle0(idx) {
			if (this.id === 'account') {
				if (idx > 0) return 'width: 85px';
				return false;
			}

			if (this.id === 'payment') {
				if (idx > 0) return 'width: 285px';
				return false;
			}

			if (this.id === 'server') {
				if (idx === 1) return 'width: 75px';else if (idx > 1) return 'width: 240px';
				return false;
			}

			if (this.id === 'servergroup') {
				if (idx > 0) return 'width: 240px';
				return false;
			}

			if (this.id === 'plangroup') {
				if (idx > 0) return 'width: 240px';
				return false;
			}

			if (this.id === 'tariff') {
				if (idx === 1) return 'width: 60px';else if (idx > 1) return 'width: 230px';
				return false;
			}

			if (this.id === 'template') {
				if (idx === 1) return 'width: 250px';else if (idx > 1) return 'width: 50px';
				return false;
			}

			if (this.id === 'ticket') {
				if (idx === 1) return 'width: 70px';else if (idx === 2) return 'width: 250px';else if (idx === 3) return 'width: 80px';
				return false;
			}

			if (this.id === 'serverresource') {
				if (idx === 1) return 'width: 36px';else if (idx === 2) return 'width: 120px';else if (idx === 3) return 'width: 180px';else if (idx === 4 || idx === 5) return 'width: 156px';else if (idx === 6) return 'width: 75px';else if (idx === 7) return 'width: 280px';else if (idx === 8) return 'width: 85px';
			}

			if (this.id === 'vdstop') {
				if (this.tableHeader[0].length === 8) {
					if (idx === 1) return 'width: 55px';
					if (idx === 3) return 'width: 70px';
					if (idx === 4 || idx === 5 || idx === 6 || idx === 7) return 'width: 140px';
				} else {
					if (idx === 1) return 'width: 55px';
					if (idx === 2) return 'width: 70px';
					if (idx === 3 || idx === 4 || idx === 5 || idx === 6) return 'width: 140px';
				}
			}

			if (this.id === 'trafftop') {
				if (this.tableHeader[0].length === 4) {
					if (idx === 1) return 'width: 75px';else if (idx === 3) return 'width: 285px';
				} else {
					if (idx === 1) return 'width: 75px';else if (idx === 2) return 'width: 285px';
				}
			}

			if (this.id === 'partnerprogram') {
				if (idx === 1) return 'width: 140px';else if (idx === 2) return 'width: 90px';
			}

			if (this.id === 'partneraccount') {
				if (idx === 0) return 'width: 70px';else if (idx === 1) return 'width: 80px';else if (idx === 2 || idx === 3) return 'min-width: 150px';
				return false;
			}

			if (this.id === 'cephresource') {
				if (idx === 1) return 'width: 80px';else if (idx === 2) return 'width: 180px';else if (idx === 3) return 'width: 270px';else if (idx === 4) return 'width: 95px';
				return false;
			}

			if (this.id === 'bonus') {
				if (idx === 1) return 'width: 140px';else if (idx === 2) return 'width: 80px';
				return false;
			}

			if (this.id === 'iso') {
				if (idx === 1) return 'width: 300px';else if (idx === 2) return 'width: 150px';else if (idx === 3) return 'width: 150px';else if (idx === 4) return 'width: 110px';
				return false;
			}

			if (this.id === 'partnertop') {
				if (idx === 1) return 'width: 100px';else if (idx === 2 || idx === 3) return 'width: 120px';
				return false;
			}
		},
		headerStyle1: function headerStyle1(idx) {
			if (this.id === 'partneraccount') {
				if (idx === 0) return 'width: 70px';else if (idx === 1) return 'width: 100px';
			}

			if (this.id === 'ip') {
				if (idx === 0 || idx === 6) return 'width: 70px';else return 'width: 50px';
			}
		}
	},

	components: {
		filterPeriod: __WEBPACK_IMPORTED_MODULE_5__components_widgets_filterPeriod___default.a,
		filterDate: __WEBPACK_IMPORTED_MODULE_6__components_widgets_filterDate___default.a,
		filterSelect: __WEBPACK_IMPORTED_MODULE_7__components_widgets_filterSelect___default.a,
		chartLine: __WEBPACK_IMPORTED_MODULE_8__components_charts_line__["a" /* default */],
		chartPie: __WEBPACK_IMPORTED_MODULE_9__components_charts_pie__["a" /* default */],
		chartBar: __WEBPACK_IMPORTED_MODULE_10__components_charts_bar__["a" /* default */],
		chartHorBar: __WEBPACK_IMPORTED_MODULE_11__components_charts_horbar__["a" /* default */]
	}

});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterDate',

	props: ['value', 'clearButton', 'notClose'],
	data: function data() {
		return {
			clearBtn: true,
			Value: null
		};
	},

	components: {
		Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
	},
	created: function created() {
		if (this.clearButton !== undefined && this.clearButton !== null) this.clearBtn = this.clearButton;

		this.updateValue(this.value);
	},

	watch: {
		'value': function value(_value) {
			this.updateValue(_value);
		}
	},

	methods: {
		valueSelected: function valueSelected(date) {
			this.Value = date;

			this.$emit('input', this.formater_Date2StrDate(this.Value));
		},
		updateValue: function updateValue(value) {
			this.Value = null;

			if (value) this.Value = this.formater_StrDate2Date(value);
		}
	}

});

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block date-filter"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "filter-period-wrapper",
      "input-class": "filter-period-input filter-for-date",
      "monday-first": true,
      "clear-button": _vm.clearBtn,
      "name": "filterDateField"
    },
    on: {
      "selected": _vm.valueSelected
    },
    model: {
      value: (_vm.Value),
      callback: function($$v) {
        _vm.Value = $$v
      },
      expression: "Value"
    }
  }), _vm._v(" "), (!_vm.notClose) ? _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
	props: ['data', 'options'],
	mounted: function mounted() {
		this.renderChart(this.data, this.options);
	}
}));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["HorizontalBar"].extend({
	props: ['data', 'options'],
	mounted: function mounted() {
		this.renderChart(this.data, this.options);
	}
}));

/***/ }),
/* 680 */,
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== false),
      expression: "localErrorMessage !== false"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = false
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.reportData.title)))]), _vm._v(" "), (_vm.lineChartData) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "data": _vm.lineChartData,
      "options": _vm.lineChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pieChartData) ? _c('chartPie', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "data": _vm.pieChartData,
      "options": _vm.pieChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableRows && _vm.tableRows.length <= 10 && _vm.barChartData) ? _c('chartBar', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "data": _vm.barChartData,
      "options": _vm.barChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableRows && _vm.tableRows.length > 10 && _vm.barChartData) ? _c('chartHorBar', {
    staticClass: "w5-chart-graph",
    attrs: {
      "data": _vm.barChartData,
      "options": _vm.horBarChartOptions
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0 0"
    }
  }, [(_vm.filtersData.period.active) ? _c('filterPeriod', {
    key: "filterPeriod",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "clearButton": false,
      "valueBegin": _vm.filtersData.period.begin,
      "valueEnd": _vm.filtersData.period.end,
      "notClose": true
    },
    on: {
      "input": _vm.filterPeriodEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filtersData.date.active) ? _c('filterDate', {
    key: "filterDate",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "clearButton": false,
      "notClose": true
    },
    on: {
      "input": _vm.filterCommonEvent
    },
    model: {
      value: (_vm.filtersData.date.value),
      callback: function($$v) {
        _vm.$set(_vm.filtersData.date, "value", $$v)
      },
      expression: "filtersData.date.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filtersData.select && _vm.filtersData.select.length) ? _vm._l((_vm.filtersData.select), function(select, idx) {
    return _c('filterSelect', {
      key: 'select_filter_' + idx,
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "list": select,
        "needAllValue": false,
        "notClose": true,
        "name": select.name
      },
      on: {
        "input": _vm.filterCommonEvent
      },
      model: {
        value: (select.value),
        callback: function($$v) {
          _vm.$set(select, "value", $$v)
        },
        expression: "select.value"
      }
    })
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "report-table-wrapper margin-10-0",
    style: (_vm.id === 'ip' ? 'width: 100%' : false)
  }, [(_vm.tableHeader && Array.isArray(_vm.tableHeader) && _vm.tableHeader[0] && Array.isArray(_vm.tableHeader[0]) && _vm.tableHeader[0].length) ? _c('table', {
    staticClass: "w5-view-field-table report-table",
    class: {
      'auto-layout': _vm.id === 'partneraccount' || _vm.id === 'ip', 'small-font': _vm.id === 'serverresource'
    }
  }, [(_vm.id === 'serverresource') ? _c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('thead', [(_vm.tableHeader && Array.isArray(_vm.tableHeader) && _vm.tableHeader[0] && Array.isArray(_vm.tableHeader[0]) && _vm.tableHeader[0].length) ? _c('tr', _vm._l((_vm.tableHeader[0]), function(h, idx) {
    return _c('th', {
      key: 'header-0-' + idx,
      staticClass: "report-header",
      class: h.rowspan > 1 ? ' sort' : '',
      style: (_vm.headerStyle0(idx)),
      attrs: {
        "rowspan": h.rowspan > 1 ? h.rowspan : false,
        "colspan": h.colspan > 1 ? h.colspan : false
      },
      on: {
        "click": function($event) {
          return _vm.sortLocal(0, h, idx)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("rub")(_vm._f("ftc")(h.title))))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.tableHeader && Array.isArray(_vm.tableHeader) && _vm.tableHeader[1] && Array.isArray(_vm.tableHeader[1]) && _vm.tableHeader[1].length) ? _c('tr', _vm._l((_vm.tableHeader[1]), function(h, idx) {
    return _c('th', {
      key: 'header-1-' + idx,
      staticClass: "report-header sort",
      style: (_vm.headerStyle1(idx)),
      on: {
        "click": function($event) {
          return _vm.sortLocal(1, h, idx)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("rub")(_vm._f("ftc")(h.title))))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.tableRows && _vm.tableRows.length) ? [_vm._l((_vm.tableRows), function(row, idx) {
    return _c('tr', {
      key: idx,
      class: row.alert === true ? 'alert-record' : false
    }, _vm._l((_vm.tableColumns), function(col, nm) {
      return _c('td', {
        key: 'cell-' + idx + '_' + nm,
        class: (_vm.sortHeaderIndex.colName === nm || _vm.sortHeaderIndex.colName === col.field) && _vm.sortHeaderIndex.value ? 'w5-table-cell-sorted' : '',
        style: (_vm.cellStyle(row, nm, col, idx))
      }, [(('server_view_type' in row) && (nm === 'server' || nm === 'server_name')) ? _c('span', {
        class: 'color-type-' + String(row['server_view_type']),
        staticStyle: {
          "font-size": "13px",
          "line-height": "1"
        }
      }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), ('link' in col) ? _c('linkComponent', {
        attrs: {
          "url": _vm.linkURL(row, nm, col),
          "text": _vm.linkText(row, nm, col),
          "valueType": col.type
        }
      }) : [(col['type'] === 'boolean') ? [(_vm.booleanValue(row[nm])) ? _c('font-awesome-icon', {
        staticStyle: {
          "color": "green"
        },
        attrs: {
          "icon": "check"
        }
      }) : _c('font-awesome-icon', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "icon": "times"
        }
      })] : [_vm._v(_vm._s(_vm.getTableValue(row, nm, col)))]]], 2)
    }), 0)
  }), _vm._v(" "), (_vm.tableItog && Object.keys(_vm.tableItog).length) ? _c('tr', {
    staticClass: "w5-chart-table-total"
  }, _vm._l((_vm.tableColumns), function(col, nm) {
    return _c('td', {
      key: 'itog-' + nm,
      style: (_vm.cellStyle(_vm.tableItog, nm, col, 'itog'))
    }, [(col['type'] === 'boolean') ? void 0 : [_vm._v(_vm._s(_vm.getTableValue(_vm.tableItog, nm, col)))]], 2)
  }), 0) : _vm._e()] : [_c('tr', {
    staticClass: "empty-table-tr"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": Object.keys(_vm.tableColumns).length
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": __webpack_require__(18)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])]], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-field",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    class: {
      disabled: _vm.form_Loading
    },
    attrs: {
      "type": "button",
      "disable": _vm.form_Loading ? 'disabled' : false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.backButton($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/back')))]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  "data-v-1f744bac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(131);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ReportList',

	mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
	data: function data() {
		return {
			crud: 'chart',

			category: []
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		listConfig: function listConfig() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['list']) return this.Config[this.crud]['list'];
			return false;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.requestData();
	},

	methods: {
		handleOpen: function handleOpen(groupId) {
			var _this = this;

			this.category.some(function (item) {
				if (item.group_id === groupId) {
					item.isOpen = !item.isOpen;
					_this.setLocalStorage();
					return true;
				}
			});
		},
		requestData: function requestData() {
			var _this2 = this;

			this.forms_Get('/' + this.crud + '/list', {}, function (data) {
				_this2.category = [];

				if (data && data.status === 'ok' && data.filters && data.filters.chart_group && data.rows && data.title && data.filters.chart_group.list && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.filters.chart_group.list) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.filters.chart_group.list).length) {
					for (var groupId in data.filters.chart_group.list) {
						_this2.category.push({
							group_id: groupId,
							group_name: data.filters.chart_group.list[groupId],
							isOpen: false,
							reports: []
						});
					}

					var _loop = function _loop(idx) {
						var groupId = _this2.category[idx]['group_id'];
						data.rows.forEach(function (item) {
							if (item['chart_group'] === groupId) {
								_this2.category[idx]['reports'].push({
									chart_id: item['chart_id'],
									chart_name: item['chart_name']
								});
							}
						});
					};

					for (var idx in _this2.category) {
						_loop(idx);
					}

					_this2.getLocalStorage();
				}
			});
		},
		getLocalStorage: function getLocalStorage() {
			var _key = 'w5_' + this.$store.state.user_id + '_reportlist';

			var data = this.$store.state.userServerOptions && this.$store.state.userServerOptions[_key] ? this.$store.state.userServerOptions[_key] : '';

			if (!data && !window.localStorage) {
				if (this.$store.state.isDebug) window.DEBUG.error('localStorage недоступен');
				return false;
			}

			if (!this.$store.state.user_id) {
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован');
				return false;
			}

			var _json = null;
			if (data) {
				_json = data;
			} else {
				_json = window.localStorage.getItem(_key);
				if (!_json) return true;
			}

			try {
				var _data = JSON.parse(_json);

				if (_data && (typeof _data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_data)) === 'object' && Array.isArray(_data)) {
					this.category.forEach(function (item) {
						if (_data.indexOf(item.group_id) > -1) item.isOpen = true;else item.isOpen = false;
					});
				}
			} catch (_err) {
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message);
				return false;
			}

			return true;
		},
		setLocalStorage: function setLocalStorage() {
			if (!window.localStorage) {
				if (this.$store.state.isDebug) window.DEBUG.error('localStorage недоступен');
				return false;
			}

			if (!this.$store.state.user_id) {
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован');
				return false;
			}

			var open = [];
			this.category.forEach(function (item) {
				if (item.isOpen) open.push(item.group_id);
			});

			var _key = 'w5_' + this.$store.state.user_id + '_reportlist';

			var _modelString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(open);

			try {
				this.remoteStorageSet(_key, _modelString);

				this.$store.commit('updateUserOptionsOnServer', {
					key: _key,
					value: _modelString
				});

				window.localStorage.setItem(_key, _modelString);
			} catch (_err) {
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message);
				return false;
			}

			return true;
		}
	}

});

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? _vm._l((_vm.category), function(obj, idx) {
    return _c('div', {
      staticClass: "report-list-category",
      class: {
        'first': idx === 0
      }
    }, [(obj.reports && obj.reports.length) ? [(!obj.isOpen) ? _c('font-awesome-icon', {
      attrs: {
        "icon": "chevron-right"
      }
    }) : _c('font-awesome-icon', {
      attrs: {
        "icon": "chevron-down"
      }
    })] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "w5-link menu",
      on: {
        "click": function($event) {
          return _vm.handleOpen(obj.group_id)
        }
      }
    }, [_vm._v("  " + _vm._s(_vm._f("ftc")(obj.group_name)))]), _vm._v(" "), (obj.isOpen && obj.reports && obj.reports.length) ? _c('div', {
      staticClass: "report-list-subcategory-list"
    }, [_vm._l((obj.reports), function(rep, i) {
      return [_c('linkComponent', {
        staticClass: "report",
        class: {
          'last': i === obj.reports.length - 1
        },
        attrs: {
          "url": '/' + _vm.crud + '/view/' + rep.chart_id,
          "text": rep.chart_name
        }
      }), _vm._v(" "), (i >= 0) ? _c('br') : _vm._e()]
    })], 2) : _vm._e()], 2)
  }) : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_formfield__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Role',
	data: function data() {
		return {
			crud: 'role',

			action: null,

			id: null,

			localErrorMessage: false,

			nameField: {
				type: '',
				title: '',
				required: false,
				_field_name: 'name',
				_visible: true,
				_errMsg: ''
			},
			nameValue: '',

			checkValues: [],

			buttonBlock: 0,

			FD: false,
			FD_count: 0
		};
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.initData(this.$route.path);

		if (this.crud) this.requestData();
	},

	methods: {
		selectStatus: function selectStatus(name, role) {
			var _isValue = false;
			if (role && role['actions']) {
				for (var action in role['actions']) {
					var _value = name + '/' + action;

					if (this.checkValues.indexOf(_value) > -1) {
						_isValue = true;
						break;
					}
				}
			}

			return _isValue ? 'main/deselect_all' : 'main/select_all';
		},
		selectDeselect: function selectDeselect(e, name, role) {
			if (role && role['actions']) {
				var _status = this.selectStatus(name, role);

				for (var action in role['actions']) {
					var _value = name + '/' + action;

					var _idx = this.checkValues.indexOf(_value);

					if (_status === 'main/deselect_all') {
						if (_idx > -1) this.checkValues.splice(_idx, 1);
					} else if (_status === 'main/select_all') {
							if (_idx < 0) this.checkValues.push(_value);
						}
				}
			}
		},
		submitForm: function submitForm(e) {
			var _this = this;

			this.localErrorMessage = false;

			if (!this.nameValue.trim().length) {
				this.nameField['_errMsg'] = this.localeFtc('error/required_field');

				window.scrollTo(0, 0);

				return;
			}

			if (!this.checkValues.length) {
				this.localErrorMessage = 'role/item_error';

				window.scrollTo(0, 0);

				return;
			}

			if (this.buttonBlock <= 0) this.buttonBlock = 1;

			var _data = {
				'name': this.nameValue,
				'items': []
			};

			this.checkValues.forEach(function (item) {
				_data['items'].push(item);
			});

			var _url = this.APIServerUrl + this.$route.path;
			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) {
					_data = _this.FD_rePack(_data);

					var _post = {
						'_csrf': _dt['_csrf']
					};
					_post[_dt['model']] = _data;

					_this.FD = new FormData();
					_this.FD_count = 0;
					_this.FD_prepare(_post);

					_this.$http.post(_url, _this.FD_count > 0 ? _this.FD : null).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this.$router.push('/' + _this.crud + '/list' + (_this.$store.state.lastWorkedPage[_this.crud] ? '/' + _this.$store.state.lastWorkedPage[_this.crud] : ''));
							return;
						}

						if (_dt && _dt['status'] === 'error' && _dt['fields']) {
							for (var k in _dt['fields']) {
								if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
									if (k === 'name') _this.nameField['_errMsg'] = _this.localeFtc(_dt['fields'][k][0]);else _this.localErrorMessage = 'role/item_error';
								}
							}

							_this.buttonBlock = 0;

							window.scrollTo(0, 0);

							return;
						}

						_this.localErrorMessage = 'error/api_incorrect';
						_this.buttonBlock = 0;
					}, function (resPost) {
						_this.localErrorMessage = 'error/api_incorrect';
						_this.buttonBlock = 0;
					});

					return;
				}

				_this.localErrorMessage = 'error/api_incorrect';
				_this.buttonBlock = 0;
			}, function (resGet) {
				_this.localErrorMessage = 'error/api_incorrect';
				_this.buttonBlock = 0;
			});
		},
		onFocusName: function onFocusName() {
			this.nameField['_errMsg'] = '';
		},
		initData: function initData(path) {
			this.action = null;
			this.id = null;
			this.localErrorMessage = false;

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 2 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[0] !== this.crud) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'create' && _urlParts[1] !== 'update') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] === 'update' && (_urlParts[2] === undefined || _urlParts[2] === null || _urlParts[2] === '')) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.action = _urlParts[1];

			if (_urlParts[2]) this.id = _urlParts[2];
		},
		requestData: function requestData() {
			var _this2 = this;

			var _url = '/' + this.crud + '/' + this.action + (this.id ? '/' + this.id : '');

			this.forms_Get(_url, false, function (data) {
				if (data && data['status'] === 'form') {
					_this2.nameField['type'] = _this2.form_GetData['fields']['name']['type'];
					_this2.nameField['title'] = _this2.form_GetData['fields']['name']['title'];
					_this2.nameField['required'] = _this2.form_GetData['fields']['name']['required'];
					_this2.nameField['_visible'] = _this2.form_GetData['fields']['name']['type'] === 'text';

					if (_this2.form_GetData['fields']['name']['value']) _this2.nameValue = _this2.form_GetData['fields']['name']['value'];

					if (_this2.form_GetData['fields']['items']['value']) _this2.checkValues = _this2.form_GetData['fields']['items']['value'];

					return;
				}

				_this2.localErrorMessage = 'error/api_incorrect';
			}, function () {
				_this2.localErrorMessage = 'error/api_incorrect';
			});
		},
		FD_rePack: function FD_rePack(data) {
			var k = void 0;
			var n1 = void 0;
			var n2 = void 0;
			var key1 = void 0;
			var key2 = void 0;

			for (k in data) {
				if (data.hasOwnProperty(k)) {
					n1 = k.indexOf('[');
					if (n1 < 0) continue;

					n2 = k.indexOf(']', n1);
					if (n2 < 0) continue;

					key1 = k.substr(0, n1);
					key2 = k.substring(n1 + 1, n2);

					if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

					if (!data[key1]) data[key1] = {};

					data[key1][key2] = data[k];

					delete data[k];

					data[key1] = this.FD_rePack(data[key1]);
				}
			}return data;
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		}

	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_1__components_elements_formfield___default.a
	}

});

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== false),
      expression: "localErrorMessage !== false"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = false
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("ftc")(_vm.form_GetData.title)))]), _vm._v(" "), _c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [(_vm.form_GetData && _vm.form_GetData['fields'] && _vm.form_GetData['fields']['name']) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": _vm.form_GetData['fields']['name']['type'] === 'text',
      "crud": _vm.crud,
      "action": _vm.action,
      "Field": _vm.nameField,
      "removeRightPadding": true
    },
    on: {
      "focus": _vm.onFocusName
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData['fields'] && _vm.form_GetData['fields']['items'] && _vm.form_GetData['fields']['items']['list_description']) ? _vm._l((_vm.form_GetData['fields']['items']['list_description']), function(role, key) {
    return _c('div', {
      staticClass: "w5-role-wrapper"
    }, [_c('div', {
      staticClass: "w5-role-item-name"
    }, [_c('span', {
      attrs: {
        "title": _vm._f("ftc")(_vm.selectStatus(key, role))
      },
      on: {
        "click": function($event) {
          return _vm.selectDeselect($event, key, role)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(role.name)))])]), _vm._v(" "), _c('div', {
      staticClass: "w5-role-item-value"
    }, _vm._l((role.actions), function(item, idx) {
      return _c('div', {
        staticClass: "w5-checkbox"
      }, [_c('label', {
        staticClass: "checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkValues),
          expression: "checkValues"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": key + '/' + idx,
          "checked": Array.isArray(_vm.checkValues) ? _vm._i(_vm.checkValues, key + '/' + idx) > -1 : (_vm.checkValues)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.checkValues,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = key + '/' + idx,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.checkValues = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.checkValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkValues = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(_vm._f("ftc")(item)) + "\n\t\t\t\t\t\t\t")])])
    }), 0)])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [_c('button', {
    ref: "submut_button",
    staticClass: "btn btn-submit btn-primary w5-button-save",
    class: {
      hidden: _vm.form_Loading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.action === 'update' ? 'main/save' : 'main/create')) + "\n\t\t\t\t")])])], 2)])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(691)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clientPayComponent',

	props: ['items', 'value'],
	data: function data() {
		return {
			crud: null,

			action: null,

			id: null,

			formData: {
				title: ' '
			},

			buttonBlock: 0,

			localErrorMessage: '',

			FD: false,
			FD_count: 0,

			paymentLinkUrl: '',

			qrCode: null,

			showDocumentModalDialog: false,
			documentModalDialogLink: null,

			showPayerDialogModal: false,

			showDeleteModal: false,
			deleteModalValue: null,
			deleteModalText: '',
			deleteButtonTitle: '',
			deleteModalTimer: null,
			deleteModalTimerHandler: null,

			showGeneralDialog: false,
			generalDialogTitle: '',
			generalDialogText: '',
			generalDialogButtonStyle: 0,
			generalDialogCallback: function generalDialogCallback() {},
			generalDialogButtonTitle: '',
			generalDialogTimer: 0,
			generalDialogTimerHandler: null
		};
	},

	computed: {
		isPrintReady: function isPrintReady() {
			return window && window.print;
		},
		isExternalForm: function isExternalForm() {
			var _id = this.$route.params.id;
			if (!_id) return false;

			if (/^[a-z0-9]+$/.test(_id) && _id.length > 12) return true;

			return false;
		},
		isHashField: function isHashField() {
			if (this.formData && this.formData.fields && Array.isArray(this.formData.fields) && this.formData.fields.length) {
				return this.formData.fields.some(function (item) {
					if (item && item._field_name === 'external_hash' && item.value) return true;else if (item && Array.isArray(item) && item.length) {
						var _found = item.some(function (fld) {
							if (fld && fld._field_name === 'external_hash' && fld.value) return true;
						});
						if (_found) return true;
					}
				});
			}

			return false;
		},
		isSubmitButtonEnabled: function isSubmitButtonEnabled() {
			if (this.action !== 'select') return true;

			var _savedField = this.findField('saved');
			var _paymentField = this.findField('payment');

			if (_savedField && _savedField.value) return true;
			if (_paymentField && _paymentField.value) return true;

			return false;
		},
		showAutoPaymentButton: function showAutoPaymentButton() {
			var _savedField = this.findField('saved');
			if (_savedField && _savedField.list && _savedField.list.length) {
				return true;
			}

			return false;
		},
		isPayLocked: function isPayLocked() {
			if (this.action !== 'pay') return false;

			if (this.form_GetData && this.form_GetData['paylock'] === true) return true;

			return false;
		}
	},
	created: function created() {
		if (!this.$route || !this.$route.params || !this.$route.params.id) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', false);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		var _id = this.$route.params.id;

		if (/^[a-z0-9]+$/.test(_id) && _id.length > 12) {
			window.sessionStorage.setItem('operation_hash', _id);
		} else {}

		this.initData(this.$route.path);

		if (this.crud) this.requestData();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-payment-bank-legal', this.bankLegalPaySubmit);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-show-payer-dialog', this.showPayerDialog);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-redirect', this.redirectHandler);
		document.addEventListener('keydown', this.keyDownHandler);
		window.addEventListener('resize', this.windowResize);

		this.windowResize();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-payment-bank-legal', this.bankLegalPaySubmit);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-show-payer-dialog', this.showPayerDialog);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-redirect', this.redirectHandler);
		document.removeEventListener('keydown', this.keyDownHandler);
		window.removeEventListener('resize', this.windowResize);

		if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler);
	},

	methods: {
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.hideDocumentModalDialog();
				this.hidePayerDialogModal();
				this.hideDeleteModal();
			}
		},
		printData: function printData(e) {
			e.preventDefault();

			var html = this.form_GetData['template'] ? this.form_GetData['template'] : '';

			for (var k in this.form_GetData['fields']) {
				if (this.form_GetData['fields'].hasOwnProperty(k)) {
					var _val = this.form_GetData['fields'][k].value ? this.localeFtc(this.form_GetData['fields'][k].value) : '';

					if (this.form_GetData['fields'][k].type === 'money') _val = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].MoneyForPrint(_val);

					html = html.replace(new RegExp('{' + k + '}', 'g'), _val);
				}
			}
			var _w = window.open();
			_w.document.open();
			_w.document.write(html);
			_w.document.close();
		},
		onDeleteSavedPayment: function onDeleteSavedPayment(id) {
			var _this = this;

			if (!id) return;

			if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler);
			this.deleteModalTimer = 5;
			this.deleteModalText = '';
			this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);

			var _savedIdField = this.findField('saved');
			if (!_savedIdField || (typeof _savedIdField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_savedIdField)) !== 'object' || !_savedIdField.list || !_savedIdField.list.length) return;

			this.deleteModalValue = id;

			var showValue = id;
			_savedIdField.list.some(function (item) {
				if (item && item.id === showValue) {
					showValue = item.name;
					return true;
				}
			});
			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', showValue);

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandler = setInterval(function () {
				_this.deleteModalTimer--;
				_this.deleteButtonTitle = _this.localeFtc('main/delete_timer').replace('{count}', _this.deleteModalTimer);

				if (_this.deleteModalTimer <= 0) {
					_this.deleteButtonTitle = _this.localeFtc('main/delete');
					clearInterval(_this.deleteModalTimerHandler);
					_this.deleteModalTimerHandler = null;
				}
			}, 1000);
		},
		hideDeleteModal: function hideDeleteModal() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteModalCallback: function deleteModalCallback() {
			var _this2 = this;

			if (this.deleteModalTimer > 0) return;

			if (this.deleteModalValue === undefined || this.deleteModalValue === null || this.deleteModalValue <= 0) return;

			this.localErrorMessage = '';

			this.hideDeleteModal();

			var _savedIdField = this.findField('saved');
			if (!_savedIdField || (typeof _savedIdField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_savedIdField)) !== 'object' || !_savedIdField.list || !_savedIdField.list.length) {
				this.localErrorMessage = 'error/required_field';
				return;
			}

			var _url = this.APIServerUrl + '/operation/delete?additional=setDeleteSaved&saved_id=' + this.deleteModalValue;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this2.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							var msg = 'payment/deleted';
							if (_dt['title']) msg = _dt['title'];

							__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': msg,
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							if (_savedIdField.list && _savedIdField.list.length) {
								_savedIdField.list.some(function (item, idx) {
									if (item && item.id === _this2.deleteModalValue) {
										_savedIdField.list.splice(idx, 1);
										return true;
									}
								});
							}

							return;
						}

						_this2.localErrorMessage = _this2.formatRequestError(resPost);
					}, function (resPost) {
						_this2.localErrorMessage = _this2.formatRequestError(resPost);
					});

					return;
				}

				_this2.localErrorMessage = _this2.formatRequestError(resGet);
			}, function (resGet) {
				_this2.localErrorMessage = _this2.formatRequestError(resGet);
			});
		},
		hidePayerDialogModal: function hidePayerDialogModal() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showPayerDialogModal = false;
			this.hideModalMask();
		},
		goToCreatePayer: function goToCreatePayer() {
			this.hidePayerDialogModal();

			this.$router.push('/payer/create');
		},
		showPayerDialog: function showPayerDialog() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPayerDialogModal = true;
		},
		submitForm: function submitForm(e) {
			var _this3 = this;

			if (this.buttonBlock > 0) return;

			if (this.buttonBlock <= 0) this.buttonBlock = 1;

			if (this.action === 'select') {
				var _rows = this.formData['fields'];

				if (!_rows || !Array.isArray(_rows)) {
					this.localErrorMessage = 'error/app_internal';
					this.buttonBlock = 0;
					return;
				}

				var _data = this.collectData(_rows);

				if (_data === false) {
					this.buttonBlock = 0;
					return;
				}

				if (e !== 'nextStep2') {
					var _paymentCase = null;
					var _isSaved = false;

					var _savedField = this.findField('saved');
					if (_savedField && _savedField.list && _savedField.list.length && 'value' in _savedField && _savedField['value'] !== null && _savedField['value'] !== undefined && _savedField._visible === true) {
						_savedField.list.some(function (f) {
							if (String(f.id) === String(_savedField.value)) {
								_paymentCase = f;
								_isSaved = true;
								return true;
							}
						});
					}

					if (!_paymentCase) {
						var _paymentField = this.findField('payment');
						if (_paymentField && _paymentField.list && _paymentField.list.length && 'value' in _paymentField && _paymentField['value'] !== null && _paymentField['value'] !== undefined && _paymentField._visible === true) {
							_paymentField.list.some(function (f) {
								if (String(f.id) === String(_paymentField.value)) {
									_paymentCase = f;
									_isSaved = false;
									return true;
								}
							});
						}
					}

					if (_paymentCase) {
						this.buttonBlock = 0;

						var _curSumma = 0;
						var _smField = this.findField('summa');
						if (_smField && 'value' in _smField) _curSumma = parseFloat(_smField.value);
						if (isNaN(_curSumma) || _curSumma < 0) _curSumma = 0;

						var _com = _paymentCase['comission'];
						if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0;
						_com = parseFloat(_com);
						var _price = (_curSumma + _com * _curSumma / 100.0).toFixed(2);
						_price = parseFloat(_price);

						var _text = this.localeFtc('operation/payment_info').replace('{saved}', _isSaved ? this.localeFtc(' (payment/saved_title)') : '').replace('{name}', _paymentCase['name'] ? this.localeFtc(_paymentCase['name']) : this.localeFtc('payment/usual_title')).replace('{com}', __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].FormatMoney2(_com, 2)).replace('{sum}', __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].FormatMoney2(_price, 2)).replace('{val}', this.localeFtc('main/ruble')) + '<br><br>' + '<w>' + this.localeFtc('operation/payment_warning') + '</w>';

						this.generalDialogShow('main/refresh_screen', _text, this.localeFtc('main/continue'), function () {
							_this3.hideGeneralDialog();
							_this3.submitForm('nextStep2');
						});

						return;
					}
				}

				var _url = this.$route.path;

				this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) {
						_data = _this3.FD_rePack(_data);

						var _post = {
							'_csrf': _dt['_csrf']
						};
						_post[_dt['model']] = _data;

						_this3.FD = new FormData();
						_this3.FD_count = 0;
						_this3.FD_prepare(_post);

						_this3.$http.post(_this3.APIServerUrl + _url, _this3.FD_count > 0 ? _this3.FD : null).then(function (resPost) {
							_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

							if (_dt && (_dt['status'] === 'ok' || _dt['status'] === 'redirect')) {
								if ('title' in _dt && _dt.title === 'operation/already_paid') {
									if (_this3.$store.state.is_auth) {
										return _this3.$router.push('/operation/list');
									} else {
											var hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null;

											if (hash) {
												return _this3.$router.push('/operation/view/' + hash);
											} else {
													return _this3.$router.push('/login');
												}
										}
								}

								if (_dt.status === 'redirect' && 'url' in _dt && String(_dt.url).length) {
									var url = _dt.url;
									if (url[0] !== '/') url = '/' + url;
									return _this3.$router.push(url);
								}

								_this3.buttonBlock = 0;
								return;
							}

							if (_dt && _dt['status'] === 'error') {
								if (_dt['fields']) {
									for (var k in _dt['fields']) {
										if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
											var _field = _this3.findField(k);
											if (_field) _field['_errMsg'] = _this3.localeFtc(_dt['fields'][k].join(' <br> '));
										}
									}
								}

								_this3.buttonBlock = 0;
								return;
							}

							_this3.localErrorMessage = 'error/api_incorrect';
							_this3.buttonBlock = 0;
						}, function (resPost) {
							_this3.localErrorMessage = 'error/api_incorrect';
							_this3.buttonBlock = 0;
						});

						return;
					}

					_this3.localErrorMessage = 'error/api_incorrect';
					_this3.buttonBlock = 0;
				}, function (resGet) {
					_this3.localErrorMessage = 'error/api_incorrect';
					_this3.buttonBlock = 0;
				});
			} else if (this.action === 'pay') {
					if (this.form_GetData['status'] === 'form' && this.form_GetData['method'] && this.form_GetData['action'] && !this.form_GetData['model']) {
						var _rows2 = this.formData['fields'];

						if (!_rows2 || !Array.isArray(_rows2)) {
							this.localErrorMessage = 'error/app_internal';
							this.buttonBlock = 0;
							return;
						}

						var _data2 = this.collectData(_rows2);

						if (_data2 === false) return;

						setTimeout(function () {
							var $form = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this3.$refs['mainFormForPay']);

							if ($form.length) {
								$form.find(':disabled').each(function (e) {
									var _type = false;
									var _span = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).parent().children('span[data-input-type]:first');
									if (_span.length) _type = _span.data('input-type');
									if (_type === 'money' || _type === 'float') __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].Str2Float(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val()));else if (_type === 'int' || _type === 'integer') __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].Str2Int(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val()));

									__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('readonly', 'readonly').removeAttr('disabled');
								});

								$form.css({ 'left': '-2000px' });

								var _url2 = _this3.APIServerUrl + ('/operation/pay/' + _this3.id + '?additional=setPayLock');
								_this3.$http.get(_url2).then(function (resGet) {
									var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
									if (_dt && _dt['_csrf']) {
										var _post = {
											'_csrf': _dt['_csrf']
										};

										_this3.$http.post(_url2, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
											_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

											if (_dt && _dt['status'] === 'ok') {
												$form.submit();

												_this3.buttonBlock = 0;
												return;
											}

											_this3.localErrorMessage = 'error/api_incorrect';
											_this3.buttonBlock = 0;
										}, function () {
											_this3.localErrorMessage = 'error/api_incorrect';
											_this3.buttonBlock = 0;
										});

										return;
									}

									_this3.localErrorMessage = 'error/api_incorrect';
									_this3.buttonBlock = 0;
								}, function () {
									_this3.localErrorMessage = 'error/api_incorrect';
									_this3.buttonBlock = 0;
								});
							}
						}, 500);
					} else if (this.form_GetData['status'] === 'form' && !this.form_GetData['method'] && !this.form_GetData['action'] && this.form_GetData['model'] && this.form_GetData['_csrf']) {
							var _rows3 = this.formData['fields'];

							if (!_rows3 || !Array.isArray(_rows3)) {
								this.localErrorMessage = 'error/app_internal';
								this.buttonBlock = 0;
								return;
							}

							var _data3 = this.collectData(_rows3);

							if (_data3 === false) return;

							_data3 = this.FD_rePack(_data3);

							var _url3 = this.$route.path;

							var _post = {
								'_csrf': this.form_GetData['_csrf']
							};
							_post[this.form_GetData['model']] = _data3;

							this.FD = new FormData();
							this.FD_count = 0;
							this.FD_prepare(_post);

							this.$http.post(this.APIServerUrl + _url3, this.FD_count > 0 ? this.FD : null).then(function (resPost) {
								var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

								if (_dt && (_dt['status'] === 'ok' || _dt['status'] === 'redirect')) {
									if ('title' in _dt && _dt.title === 'operation/already_paid') {
										if (_this3.$store.state.is_auth) {
											return _this3.$router.push('/operation/list');
										} else {
												var hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null;

												if (hash) {
													return _this3.$router.push('/operation/view/' + hash);
												} else {
														return _this3.$router.push('/login');
													}
											}
									}

									if (_dt.status === 'redirect' && 'url' in _dt) {
										return _this3.$router.push('/' + _dt.url);
									}

									_this3.buttonBlock = 0;
									return;
								}

								if (_dt && _dt['status'] === 'error') {
									if (_dt['fields']) {
										for (var k in _dt['fields']) {
											if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
												var _field = _this3.findField(k);
												if (_field) _field['_errMsg'] = _this3.localeFtc(_dt['fields'][k].join(' <br> '));
											}
										}
									}

									_this3.buttonBlock = 0;
									return;
								}

								_this3.localErrorMessage = _this3.formatRequestError(resPost);
								_this3.buttonBlock = 0;
							}, function (resPost) {
								_this3.localErrorMessage = _this3.formatRequestError(resPost);
								_this3.buttonBlock = 0;
							});
						} else if (this.form_GetData['status'] === 'error') {
							var _msg = 'error/api_incorrect';
							if ('title' in this.form_GetData && this.form_GetData['title']) _msg = this.form_GetData['title'];
							if ('content' in this.form_GetData && this.form_GetData['content']) _msg = this.form_GetData['content'];
							this.localErrorMessage = _msg;
							this.buttonBlock = 0;
						}
				}
		},
		initData: function initData(path) {
			this.crud = null;
			this.action = null;
			this.id = null;
			this.localErrorMessage = '';
			this.buttonBlock = 0;
			this.paymentLinkUrl = '';

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length !== 3 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length || !_urlParts[2] || !_urlParts[2].length) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[0] !== 'operation') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'pay' && _urlParts[1] !== 'select') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.crud = _urlParts[0];
			this.action = _urlParts[1];

			if (_urlParts[2]) this.id = _urlParts[2];
		},
		requestData: function requestData() {
			var _this4 = this;

			this.$store.commit('needShowLoader', true);

			var _url = this.$route.path;

			this.forms_Get(_url, false, function (data) {
				if (data && data.status === 'redirect' && data.url) {
					window.location.replace(data.url);
					return;
				}

				_this4.formData = _this4.parseThisFormData(data);

				_this4.qrCode = null;
				var _qr = _this4.findField('image');
				if (_qr && _qr.type === 'image' && _qr.value) _this4.qrCode = _qr.value;

				if ('title' in _this4.formData && _this4.formData.title === 'operation/already_paid') {
					if (_this4.$store.state.is_auth) {
						return _this4.$router.push('/operation/list');
					} else {
							var hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null;

							if (hash) {
								return _this4.$router.push('/operation/view/' + hash);
							} else {
									return _this4.$router.push('/login');
								}
						}
				}

				if ('status' in _this4.formData && _this4.formData.status === 'redirect' && 'url' in _this4.formData) {
					return _this4.$router.push('/' + _this4.formData.url);
				}

				if (_this4.action === 'select') {
					var _sumField = _this4.findField('summa');
					if (_sumField && _sumField['value']) _this4.$nextTick(function () {
						return __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-client-operation-create', _sumField['value']);
					});

					var _saved = _this4.findField('saved');
					if (_saved) _saved.type = 'savedPayments';
				}

				if (_this4.action === 'pay') {
					var _savedIdField = _this4.findField('saved_id');
					if (_savedIdField) _savedIdField.fontawesomeButton = 'trash-alt';
				}

				_this4.$nextTick(function () {
					_this4.showif();
				});
			}, function () {
				_this4.localErrorMessage = _this4.form_ErrorMessage;
				_this4.form_ErrorMessage = false;
			});
		},
		goToSelect: function goToSelect() {
			if (this.$route && this.$route.params && this.$route.params.id) this.$router.push('/operation/select/' + this.$route.params.id);
		},
		copyPaymentLink: function copyPaymentLink() {
			var el = this.$refs['paymentLinkUrl'];
			var ok = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].copyToClipboard(el);
			if (ok) {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
					'title': ' ',
					'message': 'main/copied_to_clipboard',
					'class': 'success',
					'type': 'nourl',
					'id': 'success-message',
					'timeout': 3000
				});
			}
		},
		onFocus: function onFocus(field) {
			var _this5 = this;

			field['_errMsg'] = '';

			var fieldsNames = ['summa', 'saved', 'payment'];

			fieldsNames.forEach(function (name) {
				var _field = _this5.findField(name);
				if (_field) {
					_field['_errMsg'] = '';
				}
			});
		},
		onBlur: function onBlur(field) {
			var _min = 999999999;
			var _val = parseFloat(field['value']);

			if (!isNaN(_val)) {
				var _savedField = this.findField('saved');
				if (_savedField && _savedField.list && _savedField.list.length) {
					_savedField.list.forEach(function (ff) {
						if (ff && 'min' in ff) {
							var _minVal = parseFloat(ff['min']);
							if (!isNaN(_minVal) && _minVal < _min) _min = _minVal;
						}
					});
				}

				var _paymentField = this.findField('payment');
				if (_paymentField && _paymentField.list && _paymentField.list.length) {
					_paymentField.list.forEach(function (ff) {
						if (ff && 'min' in ff) {
							var _minVal = parseFloat(ff['min']);
							if (!isNaN(_minVal) && _minVal < _min) _min = _minVal;
						}
					});
				}

				if (_min < 999999999 && _val < _min) {
					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
						'type': field['type'],
						'name': field['_field_name'],
						'value': _min,
						'animation': true
					});
				}
			}
		},
		onEnterKeyDown: function onEnterKeyDown(e) {
			if (e) e.preventDefault();
			if (!this.isSubmitButtonEnabled) return;
			this.submitForm(e);
		},
		fieldChanged: function fieldChanged(field) {
			if (field['_field_name'] === 'summa') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-client-operation-create', field['value']);
			}

			if (this.action === 'select' && field['unselect']) {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-clear-list-field', field['unselect']);
			}

			if (field['_field_name'] === 'saved' && field['value']) {
				if (this._computedWatchers && this._computedWatchers.isSubmitButtonEnabled && this._computedWatchers.isSubmitButtonEnabled.run) {
					this._computedWatchers.isSubmitButtonEnabled.run();
					this.$forceUpdate();
				}
			}

			this.showif();
		},
		showif: function showif() {
			var _rows = this.formData['fields'];
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1) {
									if (_expr.indexOf(' not in ') !== -1) {
										var reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi);

										if (reg.exec(_expr) !== null) {
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0');
										} else {
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i);
											var _mtch = null;
											if ((_mtch = reg.exec(_expr)) !== null) {
												_expr = _expr.replace(_mtch[0], 'w5InArray(' + _mtch[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch[2] + ') < 0');
											}
										}
									} else {
											var _reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi);

											if (_reg.exec(_expr) !== null) {
												_expr = _expr.replace(_reg, 'w5InArray($1, $2) !== -1');
											} else {
												_reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i);
												var _mtch2 = null;
												if ((_mtch2 = _reg.exec(_expr)) !== null) {
													_expr = _expr.replace(_mtch2[0], 'w5InArray(' + _mtch2[1].replace(/\[/g, '__').replace(/]/g, '__') + ', ' + _mtch2[2] + ') !== -1');
												}
											}
										}
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		isVisibleField: function isVisibleField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden') {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		isDividerField: function isDividerField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type === 'header' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},

		parseThisFormData: function parseThisFormData(data) {
			var formData = {};

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length) return formData;

			if (!('status' in data)) return formData;

			if (data['status'] !== 'form' && data['status'] !== 'ok' && data['status'] !== 'redirect') return formData;

			if ('title' in data) formData['title'] = data['title'];else formData['title'] = false;

			if ('fields' in data && data['fields'] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data['fields']).length) {
				if ('external_hash' in data['fields'] && data['fields']['external_hash'] && 'value' in data['fields']['external_hash'] && data['fields']['external_hash']['value']) {
					this.paymentLinkUrl = this.CpServerUrl + '/operation/select/' + data['fields']['external_hash']['value'];
				}

				if (this.action === 'select') formData['fields'] = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].sortByProp(data['fields'], 'order');else formData['fields'] = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].sortByProp(data['fields'], 'order', true);
			} else formData['fields'] = false;

			return formData;
		},
		findField: function findField(name) {
			if (!this.formData.fields) return null;

			var _field = null;
			this.formData.fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		onClientCreateOperation: function onClientCreateOperation(id) {
			this.submitForm(id);
		},
		bankLegalPaySubmit: function bankLegalPaySubmit(id) {
			var _payerField = this.findField('payer');

			if (_payerField && _payerField._visible && (!_payerField.list || !_payerField.list.length)) {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-show-payer-dialog');
				return;
			}

			if (_payerField && _payerField._visible && _payerField.value !== undefined && _payerField.value !== null && _payerField.value !== '') {} else {
				var _payField = this.findField('payment');
				_payField.value = parseInt(id);
				this.fieldChanged(_payField);
			}
		},
		openDocumentModalDialog: function openDocumentModalDialog(linkHtml, linkPdf) {
			if (!linkHtml) return;

			var _frm = document ? document.getElementById('documentFrame') : null;
			if (!_frm) return;

			_frm.srcdoc = '<html><body></body></html>';

			this.windowResize();

			this.documentModalDialogLink = linkPdf;

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDocumentModalDialog = true;

			this.$http.get(linkHtml).then(function (resGet) {
				var _dt = resGet && resGet.data ? resGet.data : false;
				if (!_dt || !_frm) throw new Error();
				_frm.srcdoc = _dt;
			}).catch(function () {
				_frm.srcdoc = '<html><body>Не удалось получить документ...</body></html>';
			});
		},
		hideDocumentModalDialog: function hideDocumentModalDialog() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDocumentModalDialog = false;
			this.documentModalDialogLink = null;
			this.hideModalMask();

			var _frm = document ? document.getElementById('documentFrame') : null;
			if (!_frm) return;
			_frm.srcdoc = '<html><body></body></html>';
		},
		documentPrint: function documentPrint() {
			if (window && window.print) {
				var frm = document.getElementById('documentFrame').contentWindow;
				frm.focus();
				frm.print();
			}
		},
		windowResize: function windowResize() {
			if (!document || !document.documentElement) return;
			var height = document.documentElement.clientHeight - 200;
			var frame = document.getElementById('documentFrame');
			if (frame && frame.style) frame.style.height = height + 'px';
		},

		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		collectData: function collectData(rows) {
			var _this6 = this;

			var data = {};

			for (var idx in rows) {
				if (!rows[idx] || !Array.isArray(rows[idx])) continue;

				var row = rows[idx];

				var _loop2 = function _loop2(k) {
					var field = row[k];

					if (!field['_field_name']) return 'continue';

					if (field['_errMsg']) {
						_this6.buttonBlock = 0;
						return {
							v: false
						};
					}

					var _val = field['value'];

					if (field['type'] === 'file' || field['type'] === 'image') {
						if (field['_deleteFile'] === true) {
							data[field['_field_name'] + '_delete'] = 1;
						}
					}

					if (Array.isArray(field['value'])) {
						if (!field['value'].length) _val = null;else {
							_val = [];

							field['value'].forEach(function (item) {
								if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) === 'object' && item['id']) {
									_val.push(item['id']);
								} else _val.push(item);
							});
						}
					}

					if (field['required'] === true) {
						if (_val === undefined || _val === null || String(_val).trim() === '') {
							field['_errMsg'] = 'error/required_field';
							_this6.buttonBlock = 0;
							return {
								v: false
							};
						}

						if (Array.isArray(_val) && _val.length === 0) {
							field['_errMsg'] = 'error/required_field';
							_this6.buttonBlock = 0;
							return {
								v: false
							};
						}
					}

					if (field['type'] === 'email') {
						if (!__WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].validateEmail(_val)) {
							field['_errMsg'] = 'validators/error_email';
							_this6.buttonBlock = 0;
							return {
								v: false
							};
						}
					}

					if (_val === undefined || _val === null) return 'continue';

					if (field['type'] === 'boolean') _val = __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].normalizeBooleanValue(_val) ? 1 : 0;

					data[field['_field_name']] = _val;
				};

				for (var k in row) {
					var _ret2 = _loop2(k);

					switch (_ret2) {
						case 'continue':
							continue;

						default:
							if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
					}
				}
			}

			return data;
		},
		FD_rePack: function FD_rePack(data) {
			var k = void 0;
			var n1 = void 0;
			var n2 = void 0;
			var key1 = void 0;
			var key2 = void 0;

			for (k in data) {
				if (data.hasOwnProperty(k)) {
					n1 = k.indexOf('[');
					if (n1 < 0) continue;

					n2 = k.indexOf(']', n1);
					if (n2 < 0) continue;

					key1 = k.substr(0, n1);
					key2 = k.substring(n1 + 1, n2);

					if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

					if (!data[key1]) data[key1] = {};

					data[key1][key2] = data[k];

					delete data[k];

					data[key1] = this.FD_rePack(data[key1]);
				}
			}return data;
		},
		redirectHandler: function redirectHandler(data) {
			if (!data || !data.id || !data.url) return;

			if (this.id === String(data.id)) {
				this.$router.push(data.url);
			}
		},
		hideGeneralDialog: function hideGeneralDialog() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showGeneralDialog = false;
			this.hideModalMask();
		},
		generalDialogShow: function generalDialogShow(title, text, buttonTitle) {
			var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			var _this7 = this;

			var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
			var buttonCounter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

			this.generalDialogTitle = title;
			this.generalDialogText = text;
			this.generalDialogButtonStyle = style;
			this.generalDialogCallback = function () {
				if (_this7.generalDialogTimer > 0) return;
				callback();
			};
			this.generalDialogButtonTitle = buttonTitle;

			if (buttonCounter) {
				if (this.generalDialogTimerHandler) clearInterval(this.generalDialogTimerHandler);
				this.generalDialogTimer = 5;
				this.generalDialogButtonTitle = '5 - ' + buttonTitle;
			}

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showGeneralDialog = true;

			if (buttonCounter) {
				this.generalDialogTimerHandler = setInterval(function () {
					_this7.generalDialogTimer--;
					_this7.generalDialogButtonTitle = _this7.generalDialogTimer + ' - ' + buttonTitle;

					if (_this7.generalDialogTimer <= 0) {
						_this7.generalDialogButtonTitle = buttonTitle;
						clearInterval(_this7.generalDialogTimerHandler);
						_this7.generalDialogTimerHandler = null;
					}
				}, 1000);
			}
		}
	},

	watch: {
		'$route': function $route(to, from) {
			this.initData(to.path);

			if (this.crud) this.requestData();
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default.a
	}

});

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.form_ErrorMessage) ? [_c('h3', {
    class: {
      'form-title': _vm.qrCode
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData.title)))]), _vm._v(" "), (_vm.action === 'select') ? _c('div', {
    staticClass: "w5-block-bordered cp"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('operation/bonus_information')),
      expression: "localeFtc('operation/bonus_information')"
    }],
    staticClass: "w5-block-bordered-text"
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\r\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.form_GetData['status'] === 'form') ? [(_vm.form_GetData['template']) ? _c('div', {
    staticStyle: {
      "margin": "20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.form_GetData['template'])
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "mainFormForPay",
    staticClass: "w5-from outer-form",
    attrs: {
      "action": _vm.form_GetData['action'] ? _vm.form_GetData['action'] : null,
      "method": _vm.form_GetData['method'] ? _vm.form_GetData['method'] : null
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row),
          'divider-field': _vm.isDividerField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "objID": _vm.id,
          "crud": _vm.crud,
          "action": _vm.action,
          "Field": field,
          "listBlockToOut": true,
          "bigButton": field._field_name === 'fake_2_1',
          "bigButtonTitle": field._field_name === 'fake_2_1' ? 'operation/pay' : null,
          "bigButtonHandler": field._field_name === 'fake_2_1' ? _vm.onEnterKeyDown : null,
          "bigButtonEnabled": field._field_name === 'fake_2_1' && _vm.isSubmitButtonEnabled,
          "linkButton": field._field_name === 'fake_2_2',
          "linkButtonTitle": field._field_name === 'fake_2_2' ? 'paymentauto/update_title' : null,
          "linkButtonUrl": '/paymentauto/create',
          "linkButtonVisible": _vm.showAutoPaymentButton
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          },
          "blur": function($event) {
            return _vm.onBlur(field)
          },
          "focus": function($event) {
            return _vm.onFocus(field)
          },
          "enterKeyDown": _vm.onEnterKeyDown,
          "operationNextStep": _vm.onClientCreateOperation,
          "deleteSavedPayment": _vm.onDeleteSavedPayment
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [(_vm.action === 'pay') ? _c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-primary w5-button-save",
    class: {
      hidden: _vm.form_Loading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/pay')) + "\r\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.action === 'pay' && !_vm.isPayLocked) ? _c('div', {
    staticClass: "select-pay1"
  }, [_c('span', {
    staticClass: "w5-link linkified",
    class: {
      hidden: _vm.form_Loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToSelect($event)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/select_title')) + "\r\n\t\t\t\t\t")], 1)]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.isExternalForm && _vm.isHashField) ? _c('div', {
    staticClass: "payment-link-wrapper"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0"
    }
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))]), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPaymentLink
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPayerDialogModal),
      expression: "showPayerDialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/payer')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('payer/new_alert')),
      expression: "localeFtc('payer/new_alert')"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToCreatePayer
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/create_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.deleteButtonTitle))])])])])])])] : (_vm.form_GetData['status'] === 'ok') ? [_c('div', {
    staticStyle: {
      "padding": "5px 0",
      "border-bottom": "1px solid #eee"
    }
  }), _vm._v(" "), (_vm.qrCode) ? _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.qrCode) ? _c('img', {
    staticClass: "qr-image",
    class: {
      'ext': !_vm.$store.state.is_auth
    },
    attrs: {
      "src": _vm.qrCode
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, _vm._l((row), function(field) {
      return (field.type !== 'hidden' && field.type !== 'fake' && field.type !== 'image') ? _c('div', {
        key: field._field_name,
        staticStyle: {
          "padding": "5px 0",
          "border-bottom": "1px solid #eee",
          "width": "100%"
        }
      }, [(field.type !== 'fake') ? _c('span', {
        staticStyle: {
          "width": "100px",
          "font-weight": "500"
        }
      }, [_vm._v(_vm._s(_vm._f("ftc")(field.title)) + ":")]) : _vm._e(), _vm._v(" "), _c('br'), (field._field_name !== 'summ') ? _c('span', {
        directives: [{
          name: "withSafeTags",
          rawName: "v-withSafeTags",
          value: (_vm.localeFtc(field.value)),
          expression: "localeFtc(field.value)"
        }]
      }) : _c('span', [_vm._v(_vm._s(_vm._f("money")(parseFloat(field.value).toFixed(2))) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })])]) : _vm._e()
    }), 0) : _vm._e()
  }), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.html) ? _c('span', {
    staticClass: "w5-modal-link order-link",
    on: {
      "click": function($event) {
        return _vm.openDocumentModalDialog(_vm.form_GetData.html, _vm.form_GetData.pdf)
      }
    }
  }, [_c('div', {
    staticClass: "attach-no-image-preview"
  }, [_vm._v("HTML")]), _vm._v(_vm._s(_vm.localeFtc('main/open') + ' ' + _vm.localeFtc('document/document').toLowerCase()) + "\r\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.pdf) ? _c('a', {
    staticClass: "order-link",
    attrs: {
      "href": _vm.form_GetData.pdf,
      "download": "download"
    }
  }, [_c('div', {
    staticClass: "attach-no-image-preview"
  }, [_vm._v("PDF")]), _vm._v(_vm._s(_vm._f("ftc")('operation/bill_pdf')) + "\r\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form_GetData && _vm.form_GetData.link) ? _c('a', {
    staticClass: "order-link fas",
    attrs: {
      "href": _vm.form_GetData.link,
      "download": "download"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "comment-dollar"
    }
  }), _vm._v(" " + _vm._s(_vm._f("ftc")('operation/pay')) + "\r\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDocumentModalDialog),
      expression: "showDocumentModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container for-document",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('document/document')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.isPrintReady) ? _c('span', {
    staticClass: "btn btn-submit pull-left",
    on: {
      "click": _vm.documentPrint
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/print')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLink) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLink,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.action === 'pay') ? _c('div', {
    staticClass: "select-pay2",
    class: {
      'back-without-links': !_vm.form_GetData || (!_vm.form_GetData.html && !_vm.form_GetData.pdf)
    }
  }, [_c('span', {
    staticClass: "w5-link linkified",
    class: {
      hidden: _vm.form_Loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToSelect($event)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/select_title')) + "\r\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isExternalForm && _vm.isHashField) ? _c('div', {
    staticClass: "payment-link-wrapper"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2px 0"
    }
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))]), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPaymentLink
    }
  })], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGeneralDialog),
      expression: "showGeneralDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.generalDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.generalDialogText),
      expression: "generalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.generalDialogButtonStyle === 1
    },
    attrs: {
      "disabled": _vm.generalDialogTimer && _vm.generalDialogTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.generalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm.generalDialogButtonTitle))])])])])])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "document-wrapper"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "frameborder": "0",
      "id": "documentFrame",
      "name": "documentFrame",
      "seamless": ""
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tВаш браузер не поддерживает показ документа\r\n\t\t\t\t\t\t\t\t")])])])
}]}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(695)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_ticketmsgopers__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_ticketmsgopers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_ticketmsgopers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_paginator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_elements_ticketattaches__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_elements_ticketattaches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_elements_ticketattaches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_text__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_elements_text__);
















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TicketView',
	data: function data() {
		var _this = this;

		return {
			ticketId: false,

			localErrorMessage: '',

			viewData: null,

			timerView: null,

			timerWriter: null,

			timersRead: {},

			messagesData: null,

			msgSort: 0,
			msgSortFields: [{ 'title': 'main/by_des', 'field': null }, { 'title': 'main/by_asc', 'field': 'message_id' }],

			msgFilter: 0,
			msgFilterFields: [{ 'title': function title() {
					return 'main/list_all';
				}, 'field': null }, {
				'title': function title() {
					if (!_this.messagesFilterData) return 'тип = заметка для сотрудников';
					return _this.messagesFilterData['message_type']['title'] + ' = ' + _this.messagesFilterData['message_type']['list']['notice'];
				},
				'field': 'message_type',
				'value': 'notice'
			}],

			page: 1,

			paginationPages: [],

			lastPage: 1,

			fastSearchValue: '',

			blockButtons: false,

			answerFormVisibility: true,
			answerFormData: null,
			blockAnswerForm: false,

			modalTimer: false,
			modalTimerHandle: false,
			modalButtonTextCallback: null,

			showDeleteModal: false,
			deleteModalText: '',

			showDeleteMessageModal: false,
			deleteTicketMessageId: null,

			showEmailModal: false,
			emailModalText: '',

			showReplaceModal: false,
			replaceValue: false,
			replaceField: {
				required: true,
				type: 'list',
				list: [],
				title: 'department/department',
				_field_name: 'ticketMoveModalDepartmentValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			showAttachModal: false,
			attachValue: false,
			attachField: {
				required: true,
				type: 'list',
				list: [],
				title: 'account/account',
				_field_name: 'ticketAttachModalAccountValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/ticket/create?search=account&q='
			},

			showSendModal: false,

			showChoiceTicketLabelBlock: false,
			ticketLabelBlockStyle: '',
			ticketLabelItems: {},
			ticketLabelId: null,

			$quoteBlock: null,
			oldSelectedTextOnTicketMessage: false,

			showPreviewModal: false,
			modalPreviewWidth: 0,
			modalPreviewText: '',
			modalPreviewStyle: false,
			modalPreviewTitle: '',
			modalPreviewSize: '',
			modalPreviewUrl: '',
			modalPreviewIsGallery: null,

			showTemplateModal: false,
			templateField: {
				required: true,
				type: 'list',
				list: [],
				title: 'mails/templates',
				_field_name: 'ticketTemplateModalValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/text/list?search=template&category=notice&q='
			},

			showMergeTicketsDialog: false,
			mergeTicketsField: {
				required: true,
				_field_name: 'mergeTicketsSelectTicket',
				type: 'list',
				title: 'ticket/ticket',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				url: '/ticket/update/%ID%?search=ticket&q=',
				value: null
			},

			startSelection: false,

			canChangeTicketState: true,

			reviewBlockShow: false,

			timerDropPost: null,

			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalContent: '',
			confirmModalFunc: function confirmModalFunc() {}
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return false;
		},
		UserType: function UserType() {
			return this.$store.state.user_type;
		},
		UserId: function UserId() {
			return this.$store.state.user_id;
		},
		Window: function Window() {
			return window;
		},
		modalButtonTitle: function modalButtonTitle() {
			if (this.modalButtonTextCallback && typeof this.modalButtonTextCallback === 'function') return this.modalButtonTextCallback();else return '';
		},
		Ticket: function Ticket() {
			return this.viewData && this.viewData['ticket'] ? this.viewData['ticket'] : false;
		},
		Account: function Account() {
			if (this.viewData && this.viewData['account'] && 'account_name' in this.viewData['account'] && this.viewData['account']['account_name'] && 'account_id' in this.viewData['account'] && this.viewData['account']['account_id'] && 'value' in this.viewData['account']['account_name'] && 'value' in this.viewData['account']['account_id'] && this.viewData['account']['account_name']['value'] && this.viewData['account']['account_id']['value']) {
				return {
					'type': 'account',
					'id': this.viewData['account']['account_id'],
					'name': this.viewData['account']['account_name'],
					'access': this.isAccess('account/view'),
					'filter': this.viewData['account']['global_filter']
				};
			} else {
				if (this.Ticket && 'ticket_email' in this.Ticket && this.Ticket['ticket_email'] && 'value' in this.Ticket['ticket_email'] && this.Ticket['ticket_email']['value']) {
					return {
						'type': 'email',
						'value': this.Ticket['ticket_email']['value'],
						'title': this.Ticket['ticket_email']['title'],
						'access': this.isAccess('ticket/create')
					};
				}

				if (this.Ticket && 'ticket_multi_info' in this.Ticket && this.Ticket['ticket_multi_info'] && 'value' in this.Ticket['ticket_multi_info'] && this.Ticket['ticket_multi_info']['value']) {
					return {
						'type': 'multi_info',
						'title': this.Ticket['ticket_multi_info']['title'],
						'value': this.Ticket['ticket_multi_info']['value']
					};
				}
			}

			return false;
		},
		Department: function Department() {
			if (this.viewData && this.viewData['department'] && 'department_name' in this.viewData['department'] && this.viewData['department']['department_name'] && 'department_id' in this.viewData['department'] && this.viewData['department']['department_id'] && 'value' in this.viewData['department']['department_name'] && 'value' in this.viewData['department']['department_id'] && this.viewData['department']['department_name']['value'] && this.viewData['department']['department_id']['value']) {
				return {
					'id': this.viewData['department']['department_id'],
					'name': this.viewData['department']['department_name'],
					'type': this.viewData['department']['department_type'],
					'access': this.isAccess('department/view')
				};
			}

			return false;
		},
		MultiType: function MultiType() {
			if (this.Ticket && 'ticket_multi_type' in this.Ticket && this.Ticket['ticket_multi_type'] && 'value' in this.Ticket['ticket_multi_type'] && this.Ticket['ticket_multi_type']['value']) {
				return {
					'title': this.Ticket['ticket_multi_type']['title'],
					'value': this.Ticket['ticket_multi_type']['value']
				};
			}

			return false;
		},
		MultiTextValue: function MultiTextValue() {
			var _this2 = this;

			if (this.Ticket && 'ticket_multi_value' in this.Ticket && this.Ticket['ticket_multi_value'] && 'value' in this.Ticket['ticket_multi_value'] && this.Ticket['ticket_multi_value']['value'] && Array.isArray(this.Ticket['ticket_multi_value']['value'])) {
				var _val = this.Ticket['ticket_multi_value'];
				var _link = 'link' in _val && String(_val['link']).length ? _val['link'] : false;
				var _l = '';
				var _list = [];

				_val['value'].forEach(function (item) {
					if (_link) {
						_l = _link.replace('%ID%', item['id']);
						var _crud = _link.match(/\/(\w+)\/view\/%ID%/i);
						var _access = false;
						if (_crud && _crud[1]) _access = _this2.isAccess(_crud[1] + '/view');
						_list.push({
							'link': _l,
							'text': item['name'],
							'access': _access
						});
					} else {
						_list.push({
							'link': false,
							'text': item['name'],
							'access': false
						});
					}
				});

				return _list;
			}

			return false;
		},
		ticketLabelClass: function ticketLabelClass() {
			if (!this.viewData || !this.viewData['ticket']) return false;

			var _class = '';

			if (this.viewData['ticket'] && this.viewData['ticket']['ticket_status'] && 'value' in this.viewData['ticket']['ticket_status']) _class = 'cursor-pointer';

			_class += ' ticket-label-color-' + String(this.viewData['ticket']['ticket_label']['value']).toLowerCase();

			return _class;
		},
		ticketLabelStyle: function ticketLabelStyle() {
			if (!this.viewData || !this.viewData['ticket']) return false;

			var _style = '';

			if (this.viewData['ticket'] && this.viewData['ticket']['ticket_status'] && 'value' in this.viewData['ticket']['ticket_status']) _style = 'cursor: pointer;';

			_style += 'background-color: ' + String(this.viewData['ticket']['ticket_label']['value']).toLowerCase();

			return _style;
		},
		statusText: function statusText() {
			if (!this.viewData || !this.viewData['ticket'] || !this.viewData['ticket']['ticket_status'] || !this.viewData['ticket']['ticket_status']['list']) return false;
			return this.viewData['ticket']['ticket_status']['list'][this.viewData['ticket']['ticket_status']['value']];
		},
		canBlock: function canBlock() {

			if (this.UserType !== 'admin') return false;

			if (this.viewData && this.viewData['ticket'] && 'can_blacklist' in this.viewData['ticket'] && this.viewData['ticket']['can_blacklist'] && 'value' in this.viewData['ticket']['can_blacklist']) return this.viewData['ticket']['can_blacklist']['value'];

			return false;
		},
		canDelete: function canDelete() {

			if (this.viewData && this.viewData['ticket'] && 'can_delete' in this.viewData['ticket'] && 'value' in this.viewData['ticket']['can_delete'] && this.viewData['ticket']['can_delete']['value'] === true && this.viewData['ticket']['ticket_status']['value'] !== 'deleted') return true;

			return false;
		},
		canClose: function canClose() {
			if (this.viewData && this.viewData['ticket'] && 'can_close' in this.viewData['ticket'] && 'value' in this.viewData['ticket']['can_close'] && this.viewData['ticket']['can_close']['value'] === false) return false;

			return true;
		},
		canReplace: function canReplace() {
			if (this.UserType !== 'admin') return false;

			if (this.viewData && this.viewData['ticket'] && this.Department && this.Department.type && this.Department.type.value !== 'alerts' && this.viewData['ticket']['ticket_status']['value'] !== 'deleted') return true;

			return false;
		},
		canAttach: function canAttach() {
			if (this.UserType !== 'admin') return false;

			if (this.viewData && this.viewData['account'] && this.viewData['account']['account_id'] && this.viewData['account']['account_id']['value']) return false;

			if (this.viewData && this.viewData['ticket'] && this.Department && this.Department.type && this.Department.type.value !== 'multiuser' && this.viewData['ticket']['ticket_status']['value'] !== 'closed' && this.viewData['ticket']['ticket_status']['value'] !== 'deleted') return true;

			return false;
		},
		canSend: function canSend() {
			if (this.UserType !== 'admin') return false;

			if (this.viewData && this.viewData['ticket'] && this.Department && this.Department.type && this.Department.type.value === 'multiuser' && this.viewData['ticket']['ticket_status']['value'] !== 'closed' && this.viewData['ticket']['ticket_status']['value'] !== 'deleted' && this.viewData['ticket']['can_start'] && this.viewData['ticket']['can_start']['value'] === true) return true;

			return false;
		},
		canMerge: function canMerge() {
			if (this.UserType !== 'admin') return false;

			if (this.viewData && this.viewData['ticket'] && 'can_merge' in this.viewData['ticket'] && 'value' in this.viewData['ticket']['can_merge'] && this.viewData['ticket']['can_merge']['value'] === true) return true;

			return false;
		},
		canAnswer: function canAnswer() {
			if (this.viewData && this.viewData['ticket'] && this.viewData['ticket']['can_reply'] && this.viewData['ticket']['can_reply']['value'] === true && this.viewData['ticket']['ticket_status']['value'] !== 'deleted') return true;

			return false;
		},
		messagesFilterData: function messagesFilterData() {
			return this.messagesData && this.messagesData['filters'] ? this.messagesData['filters'] : false;
		},
		messageTypeField: function messageTypeField() {
			return this.findField('type');
		},
		needPadding: function needPadding() {
			var _field = this.findField('hold');
			if (!_field || !_field._visible) return false;
			return true;
		},
		postPonseDepartmentId: function postPonseDepartmentId() {
			return __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].postPonseDepartmentId();
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.fn.setCursorPosition = function (pos) {
			this.each(function (index, elem) {
				if (elem.setSelectionRange) {
					elem.setSelectionRange(pos, pos);
				} else if (elem.createTextRange) {
					var range = elem.createTextRange();
					range.collapse(true);
					range.moveEnd('character', pos);
					range.moveStart('character', pos);
					range.select();
				}
			});

			return this;
		};

		this.onTextInput = __WEBPACK_IMPORTED_MODULE_11_debounce___default()(this.onTextInput, 3000, true);

		this.initData(this.$route.path);

		if (this.ticketId) this.requestViewData();
	},
	mounted: function mounted() {
		var _this3 = this;

		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		document.addEventListener('keydown', this.keyDownHandler);
		document.addEventListener('click', this.clickHandler);
		window.addEventListener('storage', this.onLocalStorageEvent);

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).on('mousedown.quote', 'div.ticket-message-wrapper', this.startSelectionOnTicketMessages);
		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).on('mouseup.quote', 'div.ticket-message-wrapper', this.prepareSelectedTextToQuote);

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).on('keyup.quoteBlock scroll.quoteBlock mousedown.quoteBlock', this.hideQuoteBlock);

		if (this.UserType !== 'admin') {
			window.addEventListener('resize', this.readingMessages);
			window.addEventListener('scroll', this.readingMessages);
		}

		window.onbeforeunload = this.onBeforeUnload;

		this.timerView = setInterval(function () {
			return _this3.sendStatus('view');
		}, 60000);

		this.sendStatus('view');

		this.$quoteBlock = __WEBPACK_IMPORTED_MODULE_10_jquery___default()('span#quoteBlockWrapper');

		var _textOn = this.localeFtc('main/show_quote');
		var _textOff = this.localeFtc('main/hide_quote');
		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).on('click.toggle-quote-block', 'div.toggle-quote-block', function (e) {
			var _block = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).next().next();
			if (_block.is(':visible')) {
				__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).text(_textOn);
				_block.slideUp('fast');
			} else {
				__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).text(_textOff);
				_block.slideDown('fast');
			}
			return false;
		});

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).on('keydown.textContent', 'textarea[name="content"]', this.handlerKeyDownContent);
	},
	updated: function updated() {
		if (this.UserType !== 'admin') this.readingMessages();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);

		document.removeEventListener('keydown', this.keyDownHandler);
		document.removeEventListener('click', this.clickHandler);
		window.removeEventListener('storage', this.onLocalStorageEvent);

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).off('mousedown.quote');
		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).off('mouseup.quote');

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).off('keyup.quoteBlock scroll.quoteBlock mousedown.quoteBlock');

		if (this.UserType !== 'admin') {
			window.removeEventListener('resize', this.readingMessages);
			window.removeEventListener('scroll', this.readingMessages);
		}

		window.onbeforeunload = null;

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).off('click.toggle-quote-block');

		this.timersOff();

		if (this.$store.state.ticketData.ticketViewId) {
			this.$store.commit('setTicketViewId', false);

			if (this.canChangeTicketState) {
				this.sendStatus('done-post');
				this.sendStatus('done-view');
			}
		}

		__WEBPACK_IMPORTED_MODULE_10_jquery___default()(document).off('keydown.textContent');
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState());
	},

	watch: {
		'$route': function $route(to, from) {
			var _oldId = this.ticketId;

			this.initData(to.path);

			if (_oldId && _oldId !== this.ticketId) {
				this.sendStatus('done-post', _oldId);
				this.sendStatus('done-view', _oldId);
			}

			if (this.ticketId) this.requestViewData();
		}
	},

	methods: {
		initData: function initData(path) {
			this.ticketId = false;
			this.localErrorMessage = '';

			this.fastSearchValue = '';

			this.closeAllModalDialogs();

			this.$store.commit('setTicketUpdateId', false);

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 3 || !_urlParts[0] || !_urlParts[0].length || !_urlParts[1] || !_urlParts[1].length || _urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[0] !== 'ticket') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			if (_urlParts[1] !== 'view') {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.ticketId = this.$route.params['id'] && this.$route.params['id'].length ? parseInt(this.$route.params['id']) : null;
			if (isNaN(this.ticketId) || this.ticketId <= 0) this.ticketId = false;

			if (!this.ticketId || isNaN(this.ticketId)) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.$store.commit('setTicketViewId', this.ticketId);
			this.$store.commit('getTicketState', this.ticketId);

			this.page = this.$route.params['page'] && this.$route.params['page'].length ? parseInt(this.$route.params['page']) : 1;
			if (isNaN(this.page)) this.page = 1;

			if (this.page <= 1) {
				this.page = 1;

				this.$router.replace('/ticket/view/' + this.ticketId);
			}

			this.getMsgParamsData();
		},
		requestViewData: function requestViewData(isSilence) {
			var _this4 = this;

			var _url = '/ticket/view/' + this.ticketId;

			if (isSilence === true) this.$store.commit('needShowLoader', false);

			this.requestMessagesData();

			this.forms_Get(_url, false, function (data) {
				_this4.$store.commit('needShowLoader', true);

				if (!data || data['status'] !== 'ok' || data['ticket'] === undefined || data['ticket'] === null) {
					_this4.form_ErrorMessage = _this4.localeFtc('error/api_incorrect');
				} else {
					_this4.viewData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this4.form_GetData);

					if (_this4.$store.state.ticketData.currentDepartmentId === false && _this4.viewData['department'] && _this4.viewData['department']['department_id'] && _this4.viewData['department']['department_id']['value']) {
						_this4.$store.commit('setTicketDepartmentId', _this4.viewData['department']['department_id']['value']);
					}

					if (_this4.canAnswer && !_this4.answerFormData) {
						_this4.$http.get(_this4.APIServerUrl + '/ticketmessage/create/' + _this4.ticketId).then(function (resGet) {
							var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
							if (_dt && _dt['status'] === 'form' && _dt['fields']) {
								_this4.answerFormData = _this4.parseFormData(_dt);

								_this4.changeTypeMessage();
								_this4.$nextTick(function () {
									__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-init-form-data');
								});
							}
						});
					}
				}
			}, function () {
				return _this4.$store.commit('needShowLoader', true);
			});
		},
		requestMessagesData: function requestMessagesData(isSilence) {
			var _this5 = this;

			var _url = '/ticketmessage/list/' + this.page;

			this.setMsgParamsData();

			var _modelName = 'TicketMessageSearch';
			var _params = {
				'ticket_id': this.ticketId,

				'dontAbort': true
			};
			_params[_modelName] = {};

			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '') _params[_modelName]['fast_search'] = this.fastSearchValue;

			if (this.msgSortFields[this.msgSort] && this.msgSortFields[this.msgSort]['field']) _params['sort'] = this.msgSortFields[this.msgSort]['field'];

			if (this.msgFilterFields[this.msgFilter] && this.msgFilterFields[this.msgFilter]['field']) _params[_modelName][this.msgFilterFields[this.msgFilter]['field']] = this.msgFilterFields[this.msgFilter]['value'];

			if (isSilence === true) this.$store.commit('needShowLoader', false);

			this.forms_Get(_url, _params, function (data) {
				_this5.$store.commit('needShowLoader', true);

				if (!data || data['status'] !== 'ok' || data['rows'] === undefined || data['rows'] === null) {
					_this5.form_ErrorMessage = _this5.localeFtc('error/api_incorrect');
				} else {
					_this5.messagesData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this5.form_GetData);

					_this5.paginationPages = [];
					_this5.lastPage = 1;
					var _total = parseInt(data['totalCount']);
					var _size = parseInt(data['pageSize']);

					if (_total > _size) {
						var _pagesCount = Math.ceil(_total / _size);
						if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1;

						if (_this5.page > _pagesCount) {
							_this5.page = _pagesCount;
							_this5.$router.replace('/ticket/view/' + _this5.ticketId + '/' + _this5.page);
						}

						if (_pagesCount > 1) {
							_this5.lastPage = _pagesCount;

							var _count = 0;
							var _begin = _this5.page - 5;
							if (_begin < 1) _begin = 1;
							for (var k = _begin; k <= _pagesCount; k++) {
								_count++;
								if (_count > 10) break;
								_this5.paginationPages.push(k);
							}
						}
					} else {
						_this5.$router.replace('/ticket/view/' + _this5.ticketId);
					}
				}
			}, function () {
				return _this5.$store.commit('needShowLoader', true);
			});
		},
		msgSortChange: function msgSortChange() {
			this.msgSort++;
			if (!this.msgSortFields[this.msgSort]) this.msgSort = 0;
			this.requestMessagesData();
		},
		msgFilterChange: function msgFilterChange() {
			this.msgFilter++;
			if (!this.msgFilterFields[this.msgFilter]) this.msgFilter = 0;
			this.requestMessagesData();
		},
		hideModalDialog: function hideModalDialog(showModal) {
			this.clearModalTimer();
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.$set(this, showModal, false);
			this.hideModalMask();
		},
		closeAllModalDialogs: function closeAllModalDialogs() {
			this.hideModalDialog('showDeleteModal');
			this.hideModalDialog('showEmailModal');
			this.hideModalDialog('showReplaceModal');
			this.hideModalDialog('showAttachModal');
			this.hideModalDialog('showSendModal');
			this.hideModalDialog('showChoiceTicketLabelBlock');
			this.hideModalDialog('showDeleteMessageModal');
			this.hideModalDialog('showPreviewModal');
			this.hideModalDialog('showMergeTicketsDialog');
			this.hideModalDialog('showConfirmModal');
			this.hideTemplateModal();
		},
		startModalTimer: function startModalTimer() {
			var _this6 = this;

			var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

			this.clearModalTimer();

			this.modalTimer = seconds;

			this.modalTimerHandle = setInterval(function () {
				_this6.modalTimer--;
				if (_this6.modalTimer <= 0) {
					clearInterval(_this6.modalTimerHandle);
					_this6.modalTimerHandle = false;
				}
			}, 1000);
		},
		clearModalTimer: function clearModalTimer() {
			if (this.modalTimerHandle) {
				clearInterval(this.modalTimerHandle);
				this.modalTimerHandle = false;
			}
		},
		backButton: function backButton() {
			this.$router.go(-1);
		},
		toTicketList: function toTicketList() {
			this.$router.push('/ticket/list');
		},
		changeTicketLabel: function changeTicketLabel() {
			this.localErrorMessage = '';

			this.hideTicketLabelBlock();

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			this.ticketLabelItems = {};
			if (this.Ticket && this.Ticket['ticket_label'] && this.Ticket['ticket_label']['list'] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.Ticket['ticket_label']['list']) === 'object' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.Ticket['ticket_label']['list']).length) {
				var _old = this.Ticket['ticket_label']['value'] === undefined || this.Ticket['ticket_label']['value'] === null || this.Ticket['ticket_label']['value'] === '' || this.Ticket['ticket_label']['value'] === false ? null : this.Ticket['ticket_label']['value'];
				var _list = this.Ticket['ticket_label']['list'];
				for (var _val in _list) {
					if (_list.hasOwnProperty(_val)) {
						var _new = _val === undefined || _val === null || _val === '' || _val === false ? null : _val;

						if (_old === _new) continue;

						if (_new === null) this.ticketLabelItems[''] = null;else this.ticketLabelItems[_new] = _new;
					}
				}
			}

			var _cellEl = this.$refs['ticketLabel'];
			var _coord = this.getElementOffset(_cellEl);
			this.ticketLabelBlockStyle = 'top: ' + (_coord.top - 59) + 'px; left: 12px;';

			this.showChoiceTicketLabelBlock = true;
		},
		hideTicketLabelBlock: function hideTicketLabelBlock() {
			this.showChoiceTicketLabelBlock = false;
		},
		onChangeTicketLabel: function onChangeTicketLabel(value) {
			var _this7 = this;

			this.hideTicketLabelBlock();

			if (this.$store.state.user_type !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.ticketId) return;

			var _oldLabel = this.viewData['ticket']['ticket_label']['value'];
			this.viewData['ticket']['ticket_label']['value'] = 'loading';

			var _label = value === undefined || value === null || value === '' || value === false ? '' : value;

			var _url = this.APIServerUrl + '/ticket/update/' + this.ticketId + '?additional=setLabel&label=' + _label;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this7.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this7.viewData['ticket']['ticket_label']['value'] = _label;

							return;
						}

						_this7.viewData['ticket']['ticket_label']['value'] = _oldLabel;
					}, function (resPost) {
						_this7.viewData['ticket']['ticket_label']['value'] = _oldLabel;
					});

					return;
				}

				_this7.viewData['ticket']['ticket_label']['value'] = _oldLabel;
			}, function (resGet) {
				_this7.viewData['ticket']['ticket_label']['value'] = _oldLabel;
			});
		},
		closeTicket: function closeTicket() {},
		oldcloseTicket: function oldcloseTicket() {
			var _this8 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (!this.Ticket['ticket_status'] || !this.Ticket['ticket_status']['value'] || this.Ticket['ticket_status']['value'] === 'closed' || this.Ticket['ticket_status']['value'] === 'deleted') return;

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/close/' + this.ticketId;

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['_csrf']) {
					_this8.$store.commit('ItIsMe', true);

					_this8.$http.post(res.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this8.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;
						if (_dt && _dt['status'] === 'ok') {
							if (_this8.$store.state.user_type === 'admin' && _this8.$store.state.ticketData.currentDepartmentId) _this8.$router.push('/ticket/department/' + _this8.$store.state.ticketData.currentDepartmentId);else _this8.$router.push('/ticket/list');

							return;
						}

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					}, function (resPost) {
						_this8.blockButtons = false;

						_this8.localErrorMessage = _this8.formatRequestError(resPost);
					});

					return;
				}

				_this8.blockButtons = false;

				_this8.localErrorMessage = _this8.formatRequestError(res);
			}, function (res) {
				_this8.blockButtons = false;

				_this8.localErrorMessage = _this8.formatRequestError(res);
			});
		},
		blockTicket: function blockTicket() {
			var _this9 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticketrule/create')) return;

			if (!this.canBlock) return;

			this.emailModalText = this.localeFtc('ticketrule/blacklist_prompt');
			this.emailModalText = this.emailModalText.replace('{email}', this.Ticket['ticket_email']['value']);

			this.modalButtonTextCallback = function () {
				if (!_this9.modalTimer || _this9.modalTimer <= 0) return _this9.localeFtc('main/block_action');
				return _this9.localeFtc('ticketrule/block_timer').replace('{count}', _this9.modalTimer);
			};

			this.startModalTimer();

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showEmailModal = true;
		},
		blockEmailTicketStart: function blockEmailTicketStart() {
			var _this10 = this;

			if (this.modalTimer && this.modalTimer > 0) return;

			this.localErrorMessage = '';

			this.hideModalDialog('showEmailModal');

			if (!this.canBlock) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update?additional=setBlacklist';

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this10.$store.commit('ItIsMe', true);

					var _tickets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _id, 1);
					var _post = { '_csrf': _dt['_csrf'], tickets: _tickets };

					_this10.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							if (_this10.$store.state.user_type === 'admin' && _this10.$store.state.ticketData.currentDepartmentId) _this10.$router.push('/ticket/department/' + _this10.$store.state.ticketData.currentDepartmentId);else _this10.$router.push('/ticket/list');

							return;
						}

						_this10.blockButtons = false;

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					}, function (resPost) {
						_this10.blockButtons = false;

						_this10.localErrorMessage = _this10.formatRequestError(resPost);
					});

					return;
				}

				_this10.blockButtons = false;

				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			}, function (resGet) {
				_this10.blockButtons = false;
				_this10.localErrorMessage = _this10.formatRequestError(resGet);
			});
		},
		deleteTicket: function deleteTicket() {
			var _this11 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (!this.isAccess('ticket/delete')) return;

			if (!this.canDelete) return;

			this.deleteModalText = this.localeFtc('main/delete_msg');
			this.deleteModalText = this.deleteModalText.replace('{name}', this.localeFtc('ticket/ticket').toLowerCase() + ' ' + this.Ticket['ticket_code']['value']);

			this.modalButtonTextCallback = function () {
				if (!_this11.modalTimer || _this11.modalTimer <= 0) return _this11.localeFtc('main/delete');
				return _this11.localeFtc('main/delete_timer').replace('{count}', _this11.modalTimer);
			};

			this.startModalTimer();

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;
		},
		deleteTicketStart: function deleteTicketStart() {
			var _this12 = this;

			if (this.modalTimer && this.modalTimer > 0) return;

			this.localErrorMessage = '';

			this.hideModalDialog('showDeleteModal');

			if (!this.canDelete) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/delete/' + _id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this12.$store.commit('ItIsMe', true);

					_this12.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this12.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							if (_this12.$store.state.user_type === 'admin' && _this12.$store.state.ticketData.currentDepartmentId) _this12.$router.push('/ticket/department/' + _this12.$store.state.ticketData.currentDepartmentId);else _this12.$router.push('/ticket/list');

							return;
						}

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					}, function (resPost) {
						_this12.blockButtons = false;

						_this12.localErrorMessage = _this12.formatRequestError(resPost);
					});

					return;
				}

				_this12.blockButtons = false;

				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			}, function (resGet) {
				_this12.blockButtons = false;
				_this12.localErrorMessage = _this12.formatRequestError(resGet);
			});
		},
		replaceTicket: function replaceTicket() {
			var _this13 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.canReplace) return;

			var _depId = this.Department ? this.Department.id.value : false;
			var _depType = this.Department ? this.Department.type.value : false;
			if (!_depId || !_depType) return;

			if (!this.$store.state.ticketData.departments || !Array.isArray(this.$store.state.ticketData.departments) || !this.$store.state.ticketData.departments.length) {
				this.$store.commit('getTicketDepartments');
				return;
			}

			this.replaceField['list'] = [];
			this.$store.state.ticketData.departments.forEach(function (item) {
				var _flag = false;

				if (String(item['id']) !== String(_depId)) {
					if (item['type'] === _depType) _flag = true;else {
						if ((item['type'] === 'normal' || item['type'] === 'silent') && (_depType === 'normal' || _depType === 'silent')) _flag = true;
					}
				}

				if (_flag) _this13.replaceField['list'].push({
					'id': item['id'],
					'name': item['name'],
					'type': item['type']
				});
			});

			if (!this.replaceField['list'].length) {
				this.localErrorMessage = 'ticket/no_move_departents';
				return;
			}

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showReplaceModal = true;
		},
		replaceTicketStart: function replaceTicketStart() {
			var _this14 = this;

			var gotoList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			this.localErrorMessage = '';

			this.hideModalDialog('showReplaceModal');

			if (!this.canReplace) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			var _depId = this.replaceValue;
			if (!_depId) {
				this.localErrorMessage = 'department/not_found';
				return;
			}

			var _depType = null;
			if (this.replaceField['list'] && this.replaceField['list'].length) this.replaceField['list'].some(function (dep) {
				if (String(dep.id) === String(_depId)) {
					_depType = dep.type;
					return true;
				}
			});

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update';

			var _params = {
				additional: 'setMove',
				department_id: _depId
			};

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this14.$store.commit('ItIsMe', true);

					_this14.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'], tickets: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _id, 1) })).then(function (resPost) {
						_this14.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'][_id]) {
							if (_depType === 'silent') _this14.$store.dispatch('getTicketCounters');

							var _yes = _this14.$store.state.ticketData.departments.some(function (dep) {
								if (String(dep['id']) === String(_depId) && dep['access'] === true) return true;
							});

							if (_yes) {
								_this14.$store.commit('setTicketDepartmentId', _depId);

								_this14.requestViewData(true);
							} else {
								_this14.$router.push('/ticket/list');
								_this14.canChangeTicketState = false;
							}

							return;
						}

						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					}, function (resPost) {
						_this14.blockButtons = false;

						_this14.localErrorMessage = _this14.formatRequestError(resPost);
					});

					return;
				}

				_this14.blockButtons = false;

				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			}, function (resGet) {
				_this14.blockButtons = false;
				_this14.localErrorMessage = _this14.formatRequestError(resGet);
			});
		},
		replaceTicketPendingConfirm: function replaceTicketPendingConfirm() {
			if (!this.canReplace) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			var _depId = this.postPonseDepartmentId;
			if (_depId < 0) {
				this.localErrorMessage = 'department/not_found';
				return;
			}

			this.confirmDialog('main/postpone', this.localeFtc('ticket/postpone_confirm').replace('{ticket_code}', this.Ticket && this.Ticket['ticket_code'] && this.Ticket['ticket_code']['value'] ? this.Ticket['ticket_code']['value'] : ''), this.replaceTicketPending, 'main/postpone', 5);
		},
		replaceTicketPending: function replaceTicketPending() {
			var _this15 = this;

			if (this.modalTimer && this.modalTimer > 0) return;

			this.hideModalDialog('showConfirmModal');

			this.localErrorMessage = '';

			if (!this.canReplace) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			var _depId = this.postPonseDepartmentId;
			if (_depId < 0) {
				this.localErrorMessage = 'department/not_found';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update';

			var _params = {
				additional: 'setMove',
				department_id: _depId
			};

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this15.$store.commit('ItIsMe', true);

					_this15.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'], tickets: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _id, 1) })).then(function (resPost) {
						_this15.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this15.$store.dispatch('getTicketCounters');

							_this15.$store.commit('setTicketDepartmentId', _depId);

							_this15.requestViewData(true);

							return;
						}

						_this15.localErrorMessage = _this15.formatRequestError(resPost);
					}, function (resPost) {
						_this15.blockButtons = false;

						_this15.localErrorMessage = _this15.formatRequestError(resPost);
					});

					return;
				}

				_this15.blockButtons = false;

				_this15.localErrorMessage = _this15.formatRequestError(resGet);
			}, function (resGet) {
				_this15.blockButtons = false;
				_this15.localErrorMessage = _this15.formatRequestError(resGet);
			});
		},
		attachTicket: function attachTicket() {
			var _this16 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.canAttach) return;

			var _depType = this.Department ? this.Department.type.value : false;
			if (!_depType || _depType === 'multiuser') return;

			if (this.Ticket['ticket_status']['value'] === 'closed' || this.Ticket['ticket_status']['value'] === 'deleted') return;

			this.modalButtonTextCallback = function () {
				if (!_this16.modalTimer || _this16.modalTimer <= 0) return _this16.localeFtc('ticket/assing_account');
				return _this16.localeFtc('ticket/assing_account_timer').replace('{count}', _this16.modalTimer);
			};

			this.startModalTimer();

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showAttachModal = true;
		},
		attachTicketStart: function attachTicketStart() {
			var _this17 = this;

			var gotoList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (this.modalTimer && this.modalTimer > 0) return;

			this.localErrorMessage = '';

			var _acc = this.attachValue;
			if (!_acc) {
				this.attachField['_errMsg'] = 'account/not_found';
				return;
			}

			this.hideModalDialog('showAttachModal');

			if (!this.canAttach) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update/' + _id;

			var _params = {
				additional: 'setAssign',
				account_id: _acc
			};

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this17.$store.commit('ItIsMe', true);

					_this17.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this17.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this17.requestViewData(true);

							return;
						}

						_this17.localErrorMessage = _this17.formatRequestError(resPost);
					}, function (resPost) {
						_this17.blockButtons = false;

						_this17.localErrorMessage = _this17.formatRequestError(resPost);
					});

					return;
				}

				_this17.blockButtons = false;

				_this17.localErrorMessage = _this17.formatRequestError(resGet);
			}, function (resGet) {
				_this17.blockButtons = false;
				_this17.localErrorMessage = _this17.formatRequestError(resGet);
			});
		},
		sendTicket: function sendTicket() {
			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.canSend) return;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showSendModal = true;
		},
		sendTicketStart: function sendTicketStart() {
			var _this18 = this;

			var gotoList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			this.localErrorMessage = '';

			this.hideModalDialog('showSendModal');

			if (!this.canSend) return;

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update/' + _id;

			var _params = {
				additional: 'setStart'
			};

			this.$http.get(_url, { 'params': _params }).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this18.$store.commit('ItIsMe', true);

					_this18.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this18.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this18.requestViewData(true);

							return;
						}

						_this18.localErrorMessage = _this18.formatRequestError(resPost);
					}, function (resPost) {
						_this18.blockButtons = false;

						_this18.localErrorMessage = _this18.formatRequestError(resPost);
					});

					return;
				}

				_this18.blockButtons = false;

				_this18.localErrorMessage = _this18.formatRequestError(resGet);
			}, function (resGet) {
				_this18.blockButtons = false;
				_this18.localErrorMessage = _this18.formatRequestError(resGet);
			});
		},
		ticketMerge: function ticketMerge(row) {
			this.localErrorMessage = '';

			if (!this.ticketId) return;

			if (this.UserType !== 'admin') return;

			if (!this.isAccess('ticket/update')) return;

			if (!this.canMerge) return;

			this.$set(this.mergeTicketsField, 'url', '/ticket/update/' + this.ticketId + '?search=ticket&q=');

			this.$set(this.mergeTicketsField, 'value', null);

			this.$set(this.mergeTicketsField, '_errMsg', '');

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showMergeTicketsDialog = true;
		},
		mergeTicketsStart: function mergeTicketsStart() {
			var _this19 = this;

			this.localErrorMessage = '';

			if (!this.canMerge) return;

			if (this.mergeTicketsField.value === undefined || this.mergeTicketsField.value === null || String(this.mergeTicketsField.value).trim() === '') {
				this.mergeTicketsField._errMsg = 'ticket/not_found';
				return;
			}

			this.hideModalDialog('showMergeTicketsDialog');

			var _id = this.ticketId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticket/update/' + _id + '?additional=setMerge&ticket_id=' + this.mergeTicketsField.value;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this19.$store.commit('ItIsMe', true);

					var _post = { '_csrf': _dt['_csrf'] };

					_this19.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this19.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this19.$router.push('/ticket/view/' + _this19.mergeTicketsField.value);

							return;
						}

						_this19.localErrorMessage = _this19.formatRequestError(resPost);
					}, function (resPost) {
						_this19.blockButtons = false;

						_this19.localErrorMessage = _this19.formatRequestError(resPost);
					});

					return;
				}

				_this19.blockButtons = false;

				_this19.localErrorMessage = _this19.formatRequestError(resGet);
			}, function (resGet) {
				_this19.blockButtons = false;

				_this19.localErrorMessage = _this19.formatRequestError(resGet);
			});
		},
		showAnswerForm: function showAnswerForm() {
			this.answerFormVisibility = true;
		},
		hideAnswerForm: function hideAnswerForm() {
			this.answerFormVisibility = false;
		},
		submitAnswerForm: function submitAnswerForm() {
			var _this20 = this;

			this.localErrorMessage = '';

			if (!this.ticketId) return;

			var _status = this.Ticket['ticket_status']['value'];
			if (!_status) return;

			var _id = this.ticketId;
			if (!_id) return;

			var _isErr = this.answerFormData.fields.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true) {
							if (fld.value === undefined || fld.value === null) {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});

			if (_isErr) return;

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticketmessage/create/' + _id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form') {
					var _post = { '_csrf': _dt['_csrf'] };
					_post[_dt['model']] = {};

					_this20.answerFormData.fields.forEach(function (row) {
						if (row && Array.isArray(row) && row.length) {
							row.forEach(function (fld) {
								var _value = fld['value'];
								if (fld['type'] === 'boolean') {
									_value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].normalizeBooleanValue(fld['value']) ? 1 : 0;
								}
								_post[_dt['model']][fld['_field_name']] = _value;
							});
						}
					});

					_this20.$store.commit('ItIsMe', true);

					_this20.$http.post(resGet.url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						_this20.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok' && _dt['ticketmessage'] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_dt['ticketmessage']) === 'object' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_dt['ticketmessage']).length) {
							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'ticketmessage/sent',
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							var _field = _this20.findField('content');
							if (_field) delete _field.value;
							_field = _this20.findField('files');
							if (_field) delete _field.value;
							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-set-money-field-value', {
								'type': 'integer',
								'name': 'time',
								'value': undefined
							});

							_this20.requestViewData(true);

							return;
						}

						if (_dt && _dt['status'] === 'ok' && _dt['ticket'] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_dt['ticket']) === 'object' && 'ticket_id' in _dt['ticket'] && _dt['ticket']['ticket_id']) {
							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'ticketmessage/sent',
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							_this20.ticketId = false;

							_this20.$router.replace('/ticket/view/' + _dt['ticket']['ticket_id']);

							return;
						}

						_this20.localErrorMessage = _this20.formatRequestError(resPost);
					}, function (resPost) {
						_this20.blockButtons = false;

						_this20.localErrorMessage = _this20.formatRequestError(resPost);
					});

					return;
				}

				_this20.blockButtons = false;

				_this20.localErrorMessage = _this20.formatRequestError(resGet);
			}, function (resGet) {
				_this20.blockButtons = false;
				_this20.localErrorMessage = _this20.formatRequestError(resGet);
			});
		},
		isVisibleAnswerField: function isVisibleAnswerField(row) {
			if (!row || !Array.isArray(row) || !row.length) return false;

			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden') {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		onFocusAnswer: function onFocusAnswer(field) {
			if (field) field['_errMsg'] = '';
		},
		answerFieldChanged: function answerFieldChanged(field) {
			this.$store.commit('changedForm', false);

			this.showifAnswerForm();
		},
		onTextInput: function onTextInput() {
			var _this21 = this;

			if (this.timerWriter) clearTimeout(this.timerWriter);

			if (this.timerDropPost) clearTimeout(this.timerDropPost);

			this.timerWriter = setTimeout(function () {
				if (_this21.$store.state.user_type !== 'admin') {
					_this21.sendStatus('done-post');
					return;
				}

				var _field = _this21.findField('content');

				if (!_field.value || !_field.value.length) {
					_this21.sendStatus('done-post');
					return;
				}

				_this21.timerDropPost = setTimeout(function () {
					_this21.sendStatus('done-post');
				}, 10 * 60 * 1000);
			}, 25000);

			this.sendStatus('post');
		},
		showifAnswerForm: function showifAnswerForm() {
			var _rows = this.answerFormData.fields;
			if (!_rows || !Array.isArray(_rows)) return;

			var _values = {};
			var _expressions = {};

			_rows.forEach(function (item) {
				if (item && Array.isArray(item)) {
					item.forEach(function (field, idx, arr) {
						if (field['_field_name']) {
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value'];

							if (field['showif']) {
								var _expr = field['showif'];

								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf('in') !== -1) {
									var reg = new RegExp(/(\w+) in (\[[0-9,\s]+\])/gi);
									_expr = _expr.replace(reg, '$.inArray($1, $2) !== -1');
								} else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__');
								_expressions[field['_field_name']] = _expr;
							}
						}
					});
				}
			});

			for (var e in _expressions) {
				var _exp = _expressions[e];

				var _loop = function _loop(v) {
					var reg = new RegExp('\\b' + v + '\\b', 'gi');
					_exp = _exp.replace(reg, function (str, offset, src) {
						if (offset <= 0) return 'obj.' + v;else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v;

						return 'obj.' + v;
					});
				};

				for (var v in _values) {
					_loop(v);
				}

				var _func = new Function('obj', ' return ' + _exp);

				var _field = this.findField(e);
				if (_field) {
					this.$set(_field, '_errMsg', '');

					this.$set(_field, '_visible', _func(_values));
				}
			}
		},
		findField: function findField(name) {
			var _rows = this.answerFormData.fields;
			if (!_rows || !Array.isArray(_rows)) return;

			var _field = null;
			_rows.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		handlerKeyDownContent: function handlerKeyDownContent(e) {
			if (e.keyCode === 13 && e.ctrlKey) {
				this.submitAnswerForm();
				e.preventDefault();
			}
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				this.closeAllModalDialogs();
			}

			if (this.showPreviewModal && this.modalPreviewIsGallery) {
				if (e.keyCode === 37) {
					this.galleryMove(-1);
					e.preventDefault();
					return;
				}

				if (e.keyCode === 39) {
					this.galleryMove(+1);
					e.preventDefault();
					return;
				}
			}
		},
		clickHandler: function clickHandler(e) {
			if (this.showChoiceTicketLabelBlock) {
				var _el = this.$refs['ticketChoiceLabelBlock'];
				if (_el !== e.target && !_el.contains(e.target)) this.hideTicketLabelBlock();
			}
		},
		fastSearchEvent: function fastSearchEvent(text) {
			this.fastSearchValue = text;
			this.requestViewData();
		},
		setPageSize: function setPageSize(size) {
			var _this22 = this;

			if (size === this.messagesData.pageSize) return;

			if (this.Config.pageSizes.indexOf(size) === -1) return;

			var _params = {
				'additional': 'setPageSize',
				'size': size
			};
			this.forms_Get('/user/index', _params, function (data) {
				if (!data || data['status'] !== 'ok') _this22.localErrorMessage = _this22.localeFtc('register/error');
				_this22.requestMessagesData(true);
			}, function () {
				return _this22.requestMessagesData(true);
			});
		},
		setMsgParamsData: function setMsgParamsData() {
			var _data = {
				fast: this.fastSearchValue,

				filter: this.msgFilter,

				sort: this.msgSort
			};

			try {
				localStorage.setItem('w5_' + this.UserId + '_ticketview', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_data));
				return true;
			} catch (err) {
				return false;
			}
		},
		getMsgParamsData: function getMsgParamsData() {
			try {
				if (localStorage.getItem('w5_' + this.UserId + '_ticketview')) {
					var _str = localStorage.getItem('w5_' + this.UserId + '_ticketview');
					var _data = JSON.parse(_str);

					if ('fast' in _data) this.fastSearchValue = _data['fast'];
					if ('filter' in _data) this.msgFilter = _data['filter'];
					if ('sort' in _data) this.msgSort = _data['sort'];

					return true;
				} else return false;
			} catch (err) {
				return false;
			}
		},
		setMark: function setMark(msg, mark) {
			var _this23 = this;

			if (this.UserType === 'admin') return;

			if (!msg || !mark || !msg['message_id']) return;

			var _mark = 'good';
			if (mark !== 'good') _mark = 'bad';

			this.$store.commit('needShowLoader', false);

			this.$http.get(this.APIServerUrl + '/ticketmessage/update/' + msg['message_id'] + '?additional=setMark&mark=' + _mark).then(function (resGet) {
				_this23.$store.commit('needShowLoader', true);

				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok') {
					_this23.messagesData.rows.some(function (item) {
						if (String(item['message_id']) === String(msg['message_id'])) {
							item['message_mark'] = _mark;
							return true;
						}
					});

					if (_mark === 'good') _this23.reviewBlockShow = true;
				}
			}, function () {
				return _this23.$store.commit('needShowLoader', true);
			});
		},
		setRead: function setRead(messageId) {
			var _this24 = this;

			if (!messageId) return;

			this.$store.commit('needShowLoader', false);

			this.$store.commit('ItIsMe', true);

			this.$http.get(this.APIServerUrl + '/ticketmessage/update/' + messageId + '?additional=setRead').then(function (resGet) {
				_this24.$store.commit('needShowLoader', true);

				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
				if (_dt && _dt['status'] === 'ok') {
					_this24.messagesData.rows.some(function (item) {
						if (String(item['message_id']) === String(messageId)) {
							item['message_read'] = true;
							return true;
						}
					});

					return;
				}

				_this24.messagesData.rows.some(function (item) {
					if (String(item['message_id']) === String(messageId)) {
						item['message_read'] = false;
						return true;
					}
				});
			}, function () {
				_this24.$store.commit('needShowLoader', true);

				_this24.messagesData.rows.some(function (item) {
					if (String(item['message_id']) === String(messageId)) {
						item['message_read'] = false;
						return true;
					}
				});
			});
		},
		readingMessages: function readingMessages(e) {
			var _this25 = this;

			if (!this.messagesData || !this.messagesData.rows || !this.messagesData.rows.length) return;

			this.messagesData.rows.forEach(function (item) {
				if (item['message_read'] === false) {
					var _el = _this25.$refs['unread-message-' + item['message_id']];
					if (_el && Array.isArray(_el) && _el.length) _el = _el[0];

					if (_el && _this25.isElementInViewport(_el)) {
						item['message_read'] = 'send';

						var _id = item['message_id'];

						if (_this25.timersRead[_id]) clearTimeout(_this25.timersRead[_id]);
						_this25.timersRead[_id] = setTimeout(function () {
							_this25.setRead(_id);
						}, 1000);
					}
				}
			});
		},
		isElementInViewport: function isElementInViewport(el) {
			if (!el || (typeof el === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(el)) !== 'object' || !('getBoundingClientRect' in el)) return false;
			var rect = el.getBoundingClientRect();
			return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
		},
		buttonMessageAction: function buttonMessageAction(data) {
			if (!data || !data['action'] || !data['id']) return;

			if (data['action'] === 'quote') {
				this.quoteMessage(data['message']);
			} else if (data['action'] === 'view') {
				this.$router.push('/ticketmessage/view/' + data['id']);
			} else if (data['action'] === 'update') {
				this.$store.commit('setTicketUpdateId', this.ticketId);

				this.$router.push('/ticketmessage/update/' + data['id']);
			} else if (data['action'] === 'delete') {
				this.ticketMessageDelete(data['id']);
			}
		},
		quoteMessage: function quoteMessage(msg) {
			if (!msg) return;
			if (!this.canAnswer) return;

			var _txt = msg['message_content'];
			if (_txt === undefined || _txt === null || _txt === '') return;

			_txt = this.addQuoteSymbol(_txt);

			this.answerFormVisibility = true;

			var _form = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs['answerForm']);
			if (!_form || !_form.length) return;
			var _textarea = _form.find('textarea:first');
			if (!_textarea || !_textarea.length) return;

			var _cursorPosition = _textarea.prop('selectionStart');

			this.insertTextAtCursor(_textarea[0], '\n' + _txt);

			var _field = this.findField('content');
			if (!_field) return;
			this.$set(_field, 'value', _textarea.val());
			this.answerFieldChanged(_field);

			this.$nextTick(function () {
				__WEBPACK_IMPORTED_MODULE_10_jquery___default()(window).scrollTop(0);
				_textarea.setCursorPosition(_cursorPosition);
				_textarea.focus();
			});
		},
		addQuoteSymbol: function addQuoteSymbol(text, symbol) {
			var _sym = symbol || '> ';
			var _txt1 = text.replace(/\r/g, '');
			var _strings = _txt1.split('\n');

			for (var _i = 0; _i < _strings.length; _i++) {
				_strings[_i] = _sym + _strings[_i];
			}

			return _strings.join('\n');
		},
		insertTextAtCursor: function insertTextAtCursor(el, text) {
			var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

			var val = el.value;
			var endIndex = void 0;
			var range = void 0;
			var doc = el.ownerDocument;

			if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
				endIndex = el.selectionEnd;
				el.value = val.slice(0, endIndex) + text + val.slice(endIndex);
				el.selectionStart = el.selectionEnd = endIndex + text.length + offset;
			} else if (doc.selection !== 'undefined' && doc.selection.createRange) {
				el.focus();
				range = doc.selection.createRange();
				range.collapse(false);
				range.text = text;
				range.select();
			}
		},
		ticketMessageDelete: function ticketMessageDelete(id) {
			this.localErrorMessage = '';

			if (!id) return;

			if (this.UserType !== 'admin' || !this.isAccess('ticketmessage/delete')) return;

			this.deleteTicketMessageId = id;

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteMessageModal = true;
		},
		deleteTicketMessageStart: function deleteTicketMessageStart() {
			var _this26 = this;

			this.localErrorMessage = '';

			this.hideModalDialog('showDeleteMessageModal');

			var _id = this.deleteTicketMessageId;
			if (!_id) {
				this.localErrorMessage = 'main/object_id';
				return;
			}

			this.blockButtons = true;

			var _url = this.APIServerUrl + '/ticketmessage/delete/' + _id;

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					_this26.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
						_this26.blockButtons = false;

						_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

						if (_dt && _dt['status'] === 'ok') {
							_this26.requestMessagesData(true);

							return;
						}

						_this26.localErrorMessage = _this26.formatRequestError(resPost);
					}, function (resPost) {
						_this26.blockButtons = false;

						_this26.localErrorMessage = _this26.formatRequestError(resPost);
					});

					return;
				}

				_this26.blockButtons = false;

				_this26.localErrorMessage = _this26.formatRequestError(resGet);
			}, function (resGet) {
				_this26.blockButtons = false;
				_this26.localErrorMessage = _this26.formatRequestError(resGet);
			});
		},
		fromWhoClass: function fromWhoClass(msg) {
			if (msg['message_type'] === 'notice') return 'ticket-message-from-notice';
			if (msg['user_type'] === 'admin') return 'ticket-message-from-admin';
			if (msg['user_type'] === 'user' || msg['user_type'] === 'unknown') return 'ticket-message-from-client';
			return false;
		},

		MinutesToCountWord: function MinutesToCountWord(_count) {
			var count = parseInt(_count);

			if (count === 0 || isNaN(count)) return 'ни сколько';
			if (count >= 10 && count <= 20) return count + ' минут';

			var sCount = String(_count);
			var ch = sCount.length === 1 ? count : parseInt(sCount.substr(-1));

			if (ch === 1) return count + ' минута';

			if (ch >= 2 && ch <= 4) return count + ' минуты';

			if (ch === 0 || ch >= 5 && ch < 10) return count + ' минут';

			return count + ' минут';
		},
		showTemplateDialog: function showTemplateDialog() {
			var _this27 = this;

			this.localErrorMessage = '';

			var _type = 'mails';
			var _typeField = this.findField('type');
			if (_typeField && _typeField['value'] === 'notice') _type = 'notice';

			this.$set(this.templateField, 'title', _type === 'notice' ? 'notes/templates' : 'mails/templates');

			this.$set(this.templateField, 'url', '/text/list?search=template&category=' + _type + '&q=');

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showTemplateModal = true;

			this.$nextTick(function () {
				if (_this27.$refs && _this27.$refs['textSearchTemplateDialog'] && _this27.$refs['textSearchTemplateDialog'].$el && _this27.$refs['textSearchTemplateDialog'].$el.querySelector('input')) _this27.$refs['textSearchTemplateDialog'].$el.querySelector('input').focus();
			});
		},
		hideTemplateModal: function hideTemplateModal() {
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showTemplateModal = false;
			this.hideModalMask();
		},
		templateChoiced: function templateChoiced(text) {
			this.hideTemplateModal();

			if (text === undefined || text === null || text === '') return;

			var _form = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs['answerForm']);
			if (!_form || !_form.length) return;
			var _textarea = _form.find('textarea:first');
			if (!_textarea || !_textarea.length) return;

			var _cursorPosition = _textarea.prop('selectionStart');

			this.insertTextAtCursor(_textarea[0], '\n' + text);

			var _field = this.findField('content');
			if (!_field) return;
			this.$set(_field, 'value', _textarea.val());
			this.answerFieldChanged(_field);

			this.$nextTick(function () {
				_textarea.setCursorPosition(_cursorPosition);
				_textarea.focus();
			});
		},
		previewImage: function previewImage(allData) {
			var _this28 = this;

			if (!allData || (typeof allData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(allData)) !== 'object' || !allData.img) return;

			var data = allData.img;
			var list = allData.list;

			if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !data['attach_file']) return;

			this.modalPreviewIsGallery = null;
			if (list && (typeof list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(list)) === 'object' && Array.isArray(list) && list.length > 1) {
				this.modalPreviewIsGallery = {
					id: data['attach_id'],
					list: list
				};
			}

			this.modalPreviewUrl = this.APIServerUrl + data['attach_file'];
			this.modalPreviewText = data['attach_text'];
			this.modalPreviewTitle = data['attach_name'];
			this.modalPreviewSize = data['attach_size'];

			this.modalPreviewWidth = 200;
			this.modalPreviewStyle = 'width: 32px; height: 32px;';
			this.$refs['previewImageInDialog'].src = '/static/img/loading32.gif';

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showPreviewModal = true;

			this.$nextTick(function () {
				var image = new Image();
				image.src = _this28.modalPreviewUrl;

				image.onload = function () {
					_this28.$refs['previewImageInDialog'].src = image.src;

					var imageWidth = image.naturalWidth;
					var imageHeight = image.naturalHeight;

					var windowWidth = _this28.$store.state.windowWidth;
					var windowHeight = _this28.$store.state.windowHeight;

					var _delta = 40;

					if (windowWidth <= 420) {
						_delta = 20;
					}
					if (windowWidth > 420 && windowWidth <= 767) {
						_delta = 30;
					}
					if (windowWidth > 767 && windowWidth <= 900) {
						_delta = 40;
					} else _delta = 60;

					var maxWidth = windowWidth - _delta;
					var maxHeight = windowHeight - 190;
					if (maxWidth < 100) maxWidth = 100;
					if (maxHeight < 100) maxHeight = 100;

					if (imageWidth > maxWidth || imageHeight > maxHeight) {
						var _k = 1;
						if (imageWidth > imageHeight) _k = maxWidth / imageWidth;else _k = maxHeight / imageHeight;

						imageWidth = parseInt(imageWidth * _k);
						imageHeight = parseInt(imageHeight * _k);

						if (imageHeight > maxHeight) {
							_k = maxHeight / imageHeight;
							imageWidth = parseInt(imageWidth * _k);
							imageHeight = parseInt(imageHeight * _k);
						}
					}

					_this28.modalPreviewWidth = imageWidth + 30;
					if (_this28.modalPreviewWidth < 200) _this28.modalPreviewWidth = 200;

					_this28.modalPreviewStyle = 'width: ' + imageWidth + 'px; height: ' + imageHeight + 'px;';
				};
			});
		},
		galleryMove: function galleryMove(direct) {
			if (!this.modalPreviewIsGallery || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.modalPreviewIsGallery) !== 'object' || !('id' in this.modalPreviewIsGallery) || !('list' in this.modalPreviewIsGallery)) return;

			var curId = this.modalPreviewIsGallery.id;
			var list = this.modalPreviewIsGallery.list;

			if (curId === undefined || curId === null) return;
			if (!list || (typeof list === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(list)) !== 'object' || !Array.isArray(list) || list.length <= 1) return;

			for (var idx = 0; idx < list.length; idx++) {
				if (list[idx] && list[idx]['attach_id'] === curId) {
					if (direct < 0 && idx <= 0) idx = list.length;
					if (direct > 0 && idx >= list.length - 1) idx = -1;

					this.previewImage({
						img: list[idx + direct],
						list: list
					});

					return;
				}
			}
		},
		getSelectionCoords: function getSelectionCoords() {
			var sel = document.selection;
			var range = void 0;
			var x = 0;
			var y = 0;

			if (sel) {
				if (sel.type !== 'Control') {
					range = sel.createRange();
					range.collapse(true);
					x = range.boundingLeft;
					y = range.boundingTop;
				}
			} else if (window.getSelection) {
				sel = window.getSelection();
				if (sel.rangeCount) {
					range = sel.getRangeAt(0).cloneRange();
					if (range.getClientRects) {
						range.collapse(true);
						var rect = range.getClientRects()[0];
						x = rect.left;
						y = rect.top;
					}
				}
			}

			return { x: x, y: y };
		},
		startSelectionOnTicketMessages: function startSelectionOnTicketMessages(e) {
			this.$quoteBlock.hide();

			if (e.which === 3) return;

			this.startSelection = true;
		},
		prepareSelectedTextToQuote: function prepareSelectedTextToQuote(e) {
			var _this29 = this;

			if (e.which === 3) return;

			if (!this.startSelection) return;

			this.startSelection = false;

			if (!this.canAnswer) return;

			if (e.target === this.$refs['quoteBlock'] || e.target === this.$refs['quoteBlock'][0]) return;

			var _selectedText = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].getSelectedTextDocument();

			if (_selectedText === null || _selectedText === undefined || __WEBPACK_IMPORTED_MODULE_10_jquery___default.a.trim(_selectedText) === '') {
				this.$quoteBlock.hide();
				return;
			}

			if (__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.trim(this.oldSelectedTextOnTicketMessage) === __WEBPACK_IMPORTED_MODULE_10_jquery___default.a.trim(_selectedText)) {
				this.$quoteBlock.hide();
				__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].removeBrowserSelectionText();
				this.oldSelectedTextOnTicketMessage = '';
				return;
			}

			this.oldSelectedTextOnTicketMessage = _selectedText;

			this.$nextTick(function () {
				var $block = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(e.currentTarget);

				var _str = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].getSelectedTextWithin($block[0]);

				if (_str === undefined || _str === null || __WEBPACK_IMPORTED_MODULE_10_jquery___default.a.trim(_str) === '') {
					var $prev = $block.prev('.ticket-message-wrapper');
					if ($prev.length) $block = $prev;
				}

				var _offset = $block.position();
				var _top = _offset.top + 5;
				var _left = _offset.left;

				_this29.$quoteBlock.css({ top: parseInt(_top) + 'px', left: parseInt(_left) + 'px' }).show();
			});
		},
		hideQuoteBlock: function hideQuoteBlock(e) {
			if (e.target.id === 'quoteBlock') return;

			this.$quoteBlock.hide();
		},
		selectedTextToQuote: function selectedTextToQuote(e) {
			this.$quoteBlock.hide();

			__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].removeBrowserSelectionText();

			var _txt = this.oldSelectedTextOnTicketMessage;

			this.oldSelectedTextOnTicketMessage = false;

			if (_txt === undefined || _txt === null || _txt === '') return;

			if (!this.canAnswer) return;

			_txt = this.addQuoteSymbol(_txt);

			this.answerFormVisibility = true;

			var _form = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs['answerForm']);
			if (!_form || !_form.length) return;
			var _textarea = _form.find('textarea:first');
			if (!_textarea || !_textarea.length) return;

			var _cursorPosition = _textarea.prop('selectionStart');

			this.insertTextAtCursor(_textarea[0], '\n' + _txt);

			var _field = this.findField('content');
			if (!_field) return;
			this.$set(_field, 'value', _textarea.val());
			this.answerFieldChanged(_field);

			this.$nextTick(function () {
				__WEBPACK_IMPORTED_MODULE_10_jquery___default()(window).scrollTop(0);
				_textarea.setCursorPosition(_cursorPosition);
				_textarea.focus();
			});
		},
		sendStatus: function sendStatus() {
			var _this30 = this;

			var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'post';
			var ticketId = arguments[1];

			ticketId = ticketId || this.ticketId;
			if (!ticketId) return;
			if (!this.$store.state.is_auth) return;

			var _url = this.APIServerUrl + '/ticket/view/' + ticketId + '?additional=setState&state=' + status;

			this.$store.commit('needShowLoader', false);

			this.$http.get(_url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['_csrf']) {
					var _post = { '_csrf': _dt['_csrf'] };

					_this30.$http.post(_url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_post)).then(function (resPost) {
						return _this30.$store.commit('needShowLoader', true);
					}, function (resPost) {
						return _this30.$store.commit('needShowLoader', true);
					});

					return;
				}

				_this30.$store.commit('needShowLoader', true);
			}, function (resGet) {
				return _this30.$store.commit('needShowLoader', true);
			});
		},
		changeTypeMessage: function changeTypeMessage() {
			var _field = this.findField('type');
			if (!_field || !_field.list) return;

			var _value = _field.value;

			var _nextValue = false;
			var _keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_field.list);

			if (!_value) {
				_nextValue = _keys[0];

				_field['_oldValue'] = _nextValue;
			} else {
					var _idx = _keys.indexOf(_value);
					if (_idx < 0) _idx = 0;
					_idx++;
					if (_idx >= _keys.length) _idx = 0;
					_nextValue = _keys[_idx];
				}

			if (_nextValue) _field.value = _nextValue;

			this.answerFieldChanged(_field);
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(account) {
			var _this31 = this;

			if (this.$store.state.user_type !== 'admin') return;

			if (account) {
				if (!/\d+/.test(account)) return;
				var _accountID = parseInt(account);
				if (isNaN(_accountID) || _accountID < 1) return;

				var _url = this.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				this.$store.commit('accountGlobalFilter', false);

				this.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this31.$store.commit('accountGlobalFilter', true);

						if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

						_this31.$store.dispatch('getTicketCounters');
						_this31.$store.dispatch('getRequestCounter');

						__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
							'title': ' ',
							'message': 'main/set_filter ' + _this31.Account['name']['value'],
							'class': 'success',
							'type': 'nourl',
							'id': 'success-message',
							'timeout': 3000
						});

						_this31.requestViewData(true);

						return;
					}

					_this31.localErrorMessage = _this31.formatRequestError(resGet);
				}, function (resGet) {
					_this31.localErrorMessage = _this31.formatRequestError(resGet);
				});
			} else {
					var _url2 = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

					this.$http.get(_url2).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this31.$store.commit('accountGlobalFilter', false);

							if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

							_this31.$store.dispatch('getTicketCounters');
							_this31.$store.dispatch('getRequestCounter');

							__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': _this31.localeFtc('main/filter') + ' ' + _this31.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							_this31.requestViewData(true);

							return;
						}

						_this31.localErrorMessage = _this31.formatRequestError(resGet);
					}, function (resGet) {
						_this31.localErrorMessage = _this31.formatRequestError(resGet);
					});
				}
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length < 3) return;

			if (_parts[0] !== 'update' || _parts[1] !== 'ticket' || String(_parts[2]) !== String(this.ticketId)) return;

			if (!this.$store.state.ItIsMe) this.requestViewData(true);
		},
		toCreateTicket: function toCreateTicket(e) {
			e.preventDefault();
			if (!this.Account || !this.Account.value || this.Account.access !== true) return;

			var _match = this.Account.value.match(/([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,4})+/i);
			if (_match && _match[0]) {
				var _email = _match[0];
				if (__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].validateEmail(_email)) {
					this.$store.commit('createTicketEmail', {
						email: _email,
						depId: this.Department.id.value
					});
				} else this.$store.commit('createTicketEmail', null);
			} else this.$store.commit('createTicketEmail', null);

			this.$router.push('/ticket/create');
		},
		filterModalContainers: function filterModalContainers(e) {
			if (!e || !e.target || !e.target.className) return;
			if (e.target.className.indexOf('modal') > -1 || e.target.className === 'input-text') {
				__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}

			if (!e.target.parentNode || !e.target.parentNode.className) return;
			if (e.target.parentNode.className.indexOf('modal') > -1 || e.target.className === 'input-text') {
				__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-click-on-modal');
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}
		},
		onBeforePopState: function onBeforePopState() {
			if (!this.$store.state.is_auth) return true;

			if (this.$store.state.applicationBlocked) {
				return false;
			}

			if (__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].isFormChanged(this.answerFormData, this.crud, this.action, this.$store)) {
				var _question = 'application/leave_page_confirm';

				if (this.$store.state.uploadFileCounter > 0) _question = this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?';

				if (confirm(this.localeFtc(_question))) {
					this.timersOff();
					return true;
				} else {
					return false;
				}
			}

			return true;
		},
		onBeforeUnload: function onBeforeUnload() {
			if (__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].isFormChanged(this.answerFormData, this.crud, this.action, this.$store) && !this.$store.state.applicationBlocked) {
				if (this.$store.state.uploadFileCounter > 0) return this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?';

				return 'Возможно, внесенные изменения не сохранятся.';
			}
		},
		timersOff: function timersOff() {
			if (this.modalTimerHandle) clearInterval(this.modalTimerHandle);

			if (this.timerView) clearInterval(this.timerView);

			if (this.timerWriter) clearTimeout(this.timerWriter);

			if (this.timerDropPost) clearTimeout(this.timerDropPost);

			for (var k in this.timersRead) {
				if (this.timersRead.hasOwnProperty(k)) clearTimeout(this.timersRead[k]);
			}
		},
		reviewBlockText: function reviewBlockText(part) {
			var txt = this.localeFtc('main/review_title');
			var sub = '?';
			var pos = txt.toLowerCase().indexOf(sub);

			if (part === 1) {
				if (pos > -1) return txt.substring(0, pos + sub.length);else return '';
			}

			if (part === 2) {
				if (pos > -1) return txt.substr(pos + sub.length).trim();else return '';
			}
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestViewData(true);
			}
		},
		confirmDialog: function confirmDialog(title, content, func, btnTitle) {
			var _this32 = this;

			var timerSeconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

			this.confirmModalTitle = title;
			this.confirmModalContent = content;
			this.confirmModalFunc = func;

			if (timerSeconds) {
				this.modalButtonTextCallback = function () {
					if (!_this32.modalTimer || _this32.modalTimer <= 0) return _this32.localeFtc(btnTitle);
					return _this32.localeFtc(btnTitle) + ' - ' + _this32.modalTimer;
				};

				this.startModalTimer(timerSeconds);
			}

			__WEBPACK_IMPORTED_MODULE_7__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModal = true;
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_5__components_elements_formfield___default.a,
		OpersButton: __WEBPACK_IMPORTED_MODULE_8__components_elements_ticketmsgopers___default.a,
		paginator: __WEBPACK_IMPORTED_MODULE_9__components_widgets_paginator___default.a,
		Attach: __WEBPACK_IMPORTED_MODULE_12__components_elements_ticketattaches___default.a,
		textSearch: __WEBPACK_IMPORTED_MODULE_13__components_elements_text___default.a
	}

});

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(698)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ticketMessageOpersButtonComponent',

	props: ['message', 'status', 'toLeft'],
	data: function data() {
		return {
			show: false,

			Message: null,

			cssUl: false
		};
	},
	created: function created() {
		this.Message = this.message;
	},

	computed: {
		id: function id() {
			return this.Message && this.Message['message_id'] ? this.Message['message_id'] : false;
		},
		isUpdateButtonVisible: function isUpdateButtonVisible() {
			return this.status !== 'closed' && this.status !== 'deleted' && this.isAccess('ticketmessage/update');
		},
		isQuoteButtonVisible: function isQuoteButtonVisible() {
			return this.Message && this.Message['message_content'];
		},
		isViewButtonVisible: function isViewButtonVisible() {
			return this.isAccess('ticketmessage/view');
		},
		isDeleteButtonVisible: function isDeleteButtonVisible() {
			return this.status !== 'closed' && this.status !== 'deleted' && this.isAccess('ticketmessage/delete');
		}
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.ticketmessagedropdownmenu.' + this.id, this.KeyDownHandler);
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('toggleDropDownTicketMessageOperMenu.' + this.id, this.handleToggle);
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.ticketmessagedropdownmenu.' + this.id, this.ClickOnDocument);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.ticketmessagedropdownmenu.' + this.id, this.KeyDownHandler);
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('toggleDropDownTicketMessageOperMenu.' + this.id, this.handleToggle);
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.ticketmessagedropdownmenu.' + this.id, this.ClickOnDocument);
	},

	methods: {
		toggleMenu: function toggleMenu(e) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('toggleDropDownTicketMessageOperMenu', [this.id]);

			this.show = !this.show;

			this.UpOrDown();
		},
		handleToggle: function handleToggle(e, idx) {
			if (idx !== this.id) this.hideMenu();
		},
		hideMenu: function hideMenu() {
			this.show = false;
		},
		clickOper: function clickOper(action) {
			this.hideMenu();
			this.$emit('action', {
				'action': action,
				'id': this.id,
				'message': this.Message
			});
		},
		KeyDownHandler: function KeyDownHandler(e) {
			if (this.show && e.keyCode === 27) this.hideMenu();
		},
		ClickOnDocument: function ClickOnDocument(e) {
			if (this.show) this.hideMenu();
		},
		UpOrDown: function UpOrDown() {
			this.cssUl = this.toLeft ? 'right: auto !important; left: 0;' : false;

			var _div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('div[data-index="' + this.id + '"]');
			if (!_div.length) return;

			var _ul = _div.find('ul:first');
			if (!_ul.length) return;

			var _rect = _div.offset();
			var _heightDiv = _div.height();
			var _heightUl = _ul.height();

			var _bottomUl = _rect.top + _heightDiv + _heightUl + 20 - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();

			if (_bottomUl > window.innerHeight) if (this.cssUl) this.cssUl += 'top: -' + (_heightDiv + _heightUl) + 'px';else this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px';
		}
	},

	watch: {
		'message': function message(_message) {
			this.Message = _message;
		}
	}

});

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.id) ? _c('div', {
    staticClass: "btn-group w5-opers-button",
    class: {
      'w5-opers-button-opened': _vm.show, 'pull-left-ticket-message-opers-button': _vm.toLeft, 'pull-right': !_vm.toLeft
    },
    staticStyle: {
      "top": "-2px"
    },
    attrs: {
      "data-index": _vm.id
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "dropdown-toggle"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bars"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropdown-menu",
    style: (_vm.cssUl),
    attrs: {
      "role": "menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.isUpdateButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/redact')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUpdateButtonVisible && (_vm.isQuoteButtonVisible || _vm.isViewButtonVisible || _vm.isDeleteButtonVisible)) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.isQuoteButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('quote')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "#2c8ad8"
    },
    attrs: {
      "icon": "quote-right"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/quote')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isViewButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('view')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "#2c8ad8"
    },
    attrs: {
      "icon": "eye"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('main/view')) + "\n\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.isUpdateButtonVisible || _vm.isQuoteButtonVisible || _vm.isViewButtonVisible) && _vm.isDeleteButtonVisible) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.isDeleteButtonVisible) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketrule/action_delete')) + "\n\t\t\t")], 1)], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(702)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ticketAttachesComponent',

	props: ['attach', 'type'],
	data: function data() {
		return {
			data: false,
			Images: [],
			noImages: []
		};
	},

	computed: {
		tableClass: function tableClass() {
			return 'ticket-message-attaches-wrapper attache-in-' + this.type;
		}
	},
	created: function created() {
		this.initData();
	},

	methods: {
		initData: function initData(data) {
			var _this = this;

			data = data || this.attach;

			if (!data || !Array.isArray(data) || !data.length) return;

			this.Images = [];
			this.noImages = [];

			data.forEach(function (item, idx, arr) {
				if ('attach_type' in item && item['attach_type'] && String(item['attach_type']).substr(0, 5) === 'image' && 'attach_file' in item && item['attach_file']) {
					var _ext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
						'src': '/static/img/loading32.gif',
						'title': false,
						'style': false,
						'img': null
					}, item);

					_ext['img'] = new Image();
					_ext['img'].onload = function () {
						var _w = _ext['img'].naturalWidth;
						var _h = _ext['img'].naturalHeight;

						var _k = 1;
						if (_w > _h) _k = 56 / _w;else _k = 56 / _h;

						_w = parseInt(_k * _w);
						_h = parseInt(_k * _h);

						_ext['style'] = 'width: ' + _w + 'px; height: ' + _h + 'px;';

						_ext['src'] = _ext['img'].src;
					};
					_ext['img'].src = _this.imageUrl(item);

					_this.Images.push(_ext);
				} else _this.noImages.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item));
			});

			this.data = this.Images.length || this.noImages.length;
		},
		imageUrl: function imageUrl(img) {
			var _url = this.APIServerUrl + img['attach_file'];
			if ('attach_preview' in img && img['attach_preview'] && img['attach_preview'] != null) _url = this.APIServerUrl + img['attach_preview'];
			return _url;
		},
		previewImage: function previewImage(img) {
			this.$emit('preview', { img: img, list: this.Images });
		},
		getExt: function getExt(file) {
			var _ext = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].getFileExt(file['attach_name']);
			_ext = _ext.toUpperCase().substr(0, 4);
			return _ext;
		}
	},

	watch: {
		'attach': function attach(data) {
			this.initData(data);
		}
	}

});

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    class: _vm.tableClass
  }, [_c('div', {
    staticClass: "clip"
  }), _vm._v(" "), (_vm.Images && _vm.Images.length) ? _c('div', {
    staticClass: "ticket-messahe-images-wrapper"
  }, _vm._l((_vm.Images), function(img, idx) {
    return _c('div', {
      staticClass: "attach-small-preview cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.previewImage(img)
        }
      }
    }, [(img['attach_preview'] || img['attach_file']) ? _c('img', {
      style: (img['style'] ? img['style'] : false),
      attrs: {
        "src": img['src'],
        "title": img['title']
      }
    }) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.noImages && _vm.noImages.length) ? _c('ul', {
    staticClass: "attach-list-no-image"
  }, _vm._l((_vm.noImages), function(file, i) {
    return _c('li', [_c('div', {
      staticClass: "attach-no-image-preview"
    }, [_vm._v(_vm._s(_vm.getExt(file)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(file['attach_text'] && String(file['attach_text']).length ? file['attach_text'] + ' - ' : '')))]), _vm._v(" "), _c('a', {
      staticClass: "attach-download",
      attrs: {
        "href": _vm.APIServerUrl + file['attach_file']
      }
    }, [_vm._v(_vm._s(file['attach_name']))]), _vm._v(" "), _c('span', [_vm._v(" (" + _vm._s(file['attach_size']) + ")")])])
  }), 0) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', {
    attrs: {
      "id": "w5-ticket-view-block"
    }
  }, [(!_vm.form_ErrorMessage) ? [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-top-10",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.viewData && typeof _vm.viewData === 'object' && _vm.viewData['ticket']) ? _c('div', {
    staticClass: "w5-ticket-view-wrapper"
  }, [(_vm.UserType === 'admin') ? [(_vm.Ticket && _vm.Ticket['ticket_label']['value'] === 'loading') ? _c('div', {
    staticClass: "pull-left margin-top-5",
    staticStyle: {
      "height": "18px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })]) : _c('div', {
    ref: "ticketLabel",
    staticClass: "pull-left margin-top-5 w5-list-ticket-label",
    class: _vm.ticketLabelClass,
    style: (_vm.ticketLabelStyle),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTicketLabel($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "w5-ticket-view-subject",
    class: _vm.UserType === 'admin' ? 'margin-left-6' : false
  }, [_vm._v(_vm._s(_vm.Ticket['ticket_subject']['value']))]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.UserType === 'client') ? _c('table', {
    staticClass: "w5-ticket-view-table"
  }, [_c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_code']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Ticket['ticket_code']['value']))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_status']['title'])) + ":")]), _vm._v(" "), _c('span', {
    style: ('color: ' + _vm.Ticket['ticket_status']['color'])
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.statusText))))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_created']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_created']['value'], 'd.m.y H:M')))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_updated']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_updated']['value'], 'd.m.y H:M')))])])])]) : _c('table', {
    staticClass: "w5-ticket-view-table"
  }, [_c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_code']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.Ticket['ticket_code']['value']))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_created']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_created']['value'], 'd.m.y H:M')))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_status']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [_c('span', {
    style: ('color: ' + _vm.Ticket['ticket_status']['color'])
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.statusText))))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_updated']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_updated']['value'], 'd.m.y H:M')))])])]), _vm._v(" "), _c('tr', [(_vm.Department) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Department['name']['title'])) + ":")])]) : _vm._e(), _vm._v(" "), (_vm.Department) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [(_vm.Department.access === true) ? _c('linkComponent', {
    staticClass: "can-select",
    attrs: {
      "url": '/department/view/' + _vm.Department['id']['value'],
      "text": _vm.Department['name']['value']
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.Department['name']['value']))])], 1) : _vm._e(), _vm._v(" "), (_vm.Account) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [(_vm.Account.type === 'account') ? _c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['name']['title'])) + ":")]) : _vm._e(), _vm._v(" "), (_vm.Account.type === 'email' || _vm.Account.type === 'multi_info') ? _c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['title'])) + ":")]) : _vm._e()]) : _c('td'), _vm._v(" "), (_vm.Account) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [(_vm.Account.type === 'account') ? [(!_vm.Account['filter'] || _vm.Account['filter']['value'] != _vm.Account['id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Account['id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Account['filter'] && _vm.Account['filter']['value'] == _vm.Account['id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Account.access === true) ? _c('linkComponent', {
    staticClass: "can-select",
    attrs: {
      "url": '/account/view/' + _vm.Account['id']['value'],
      "text": _vm.Account['name']['value']
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.Account['name']['value']))])] : _vm._e(), _vm._v(" "), (_vm.Account.type === 'email') ? [_c('span', {
    staticClass: "can-select",
    class: {
      'w5-link': _vm.Account.access === true
    },
    on: {
      "click": _vm.toCreateTicket
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.Account['value']) + "\n\t\t\t\t\t\t\t")])] : _vm._e(), _vm._v(" "), (_vm.Account.type === 'multi_info') ? [_c('span', {
    staticClass: "can-select"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Account['value'])) + "\n\t\t\t\t\t\t\t")])] : _vm._e()], 2) : _c('td')]), _vm._v(" "), (_vm.MultiType) ? _c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['title'])) + ":")])]), _vm._v(" "), (_vm.MultiTextValue && Array.isArray(_vm.MultiTextValue)) ? _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['value'])) + " - ")]), _vm._v(" "), _vm._l((_vm.MultiTextValue), function(value, idx) {
    return [(idx > 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(" "), (value['link'] === false || value['access'] === false) ? _c('span', {
      key: 'link-number-' + idx
    }, [_vm._v(_vm._s(_vm._f("ftc")(value['text'])))]) : _c('linkComponent', {
      key: 'link-number-' + idx,
      staticClass: "can-select",
      attrs: {
        "url": value['link'],
        "text": value['text']
      }
    })]
  })], 2) : _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['value'])))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [(_vm.Window && _vm.Window.history && _vm.Window.history.length > 1) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backButton
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/back')))]) : _c('button', {
    staticClass: "w5-ticket-view-button btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toTicketList
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/to_list')))]), _vm._v(" "), (_vm.canReplace && _vm.postPonseDepartmentId > 0 && (_vm.Department && _vm.Department.id && _vm.Department.id.value && _vm.Department.id.value != _vm.postPonseDepartmentId)) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-danger pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.replaceTicketPendingConfirm
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "hourglass-half"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/postpone')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canBlock) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-black pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.blockTicket
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/blacklist')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-black pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteTicket
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canReplace) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.replaceTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('department/department')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canAttach) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.attachTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "download"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('account/account')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canSend) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.sendTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "caret-square-right"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/sending')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canMerge) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketMerge
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "compress-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/merge')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [(_vm.canAnswer) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.answerFormVisibility),
      expression: "answerFormVisibility"
    }]
  }, [(_vm.answerFormData && _vm.answerFormData.fields) ? _c('div', {
    ref: "answerForm",
    staticClass: "w5-form ticket-answer-form"
  }, [(_vm.$store.state.user_type === 'admin' && _vm.messageTypeField.list) ? _c('div', [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.messageTypeField.title)) + ":   ")]), _vm._v(" "), _c('span', {
    staticClass: "widget-link can-select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTypeMessage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.messageTypeField.list[_vm.messageTypeField.value]))))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.answerFormData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleAnswerField(row)
      },
      style: (row[0]._field_name === 'files' ? 'width: 80%; float: left;' : false)
    }, [_vm._l((row), function(field) {
      return [(field.type === 'textarea') ? _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleAnswerField(row),
          "crud": "ticketmessage",
          "action": "create",
          "Field": field,
          "removeRightPadding": true
        },
        on: {
          "input": _vm.onTextInput,
          "valueChanged": function($event) {
            return _vm.answerFieldChanged(field)
          },
          "focus": function($event) {
            return _vm.onFocusAnswer(field)
          },
          "answerTemplateDialog": _vm.showTemplateDialog
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _c('Field', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (field._field_name !== 'type'),
          expression: "field._field_name !== 'type'"
        }],
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleAnswerField(row),
          "crud": "ticketmessage",
          "action": "create",
          "Field": field,
          "removeRightPadding": field._field_name === 'files' || !_vm.needPadding
        },
        on: {
          "valueChanged": function($event) {
            return _vm.answerFieldChanged(field)
          },
          "focus": function($event) {
            return _vm.onFocusAnswer(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-submit-green pull-right",
    class: {
      hidden: _vm.form_Loading
    },
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.blockAnswerForm === true || _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.submitAnswerForm
    }
  }, [_vm._v("\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/send')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.messagesData && typeof _vm.messagesData === 'object' && _vm.messagesData['title']) ? _c('div', {
    staticClass: "w5-ticket-view-wrapper"
  }, [_c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-view-subject",
    class: {
      'margin-top-10': !_vm.answerFormVisibility
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.messagesData['title'])))]), _vm._v(" "), _c('div', [(_vm.UserType === 'admin') ? _c('div', {
    staticClass: "form-inline"
  }, [_c('Field', {
    ref: "fastSearch",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "fastSearch",
      "Field": {
        _field_name: 'fastSearch',
        type: 'text',
        title: 'main/all_fields_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true
    },
    on: {
      "event_ClearButtonClicked": _vm.fastSearchEvent,
      "fastSearchInput": _vm.fastSearchEvent
    },
    model: {
      value: (_vm.fastSearchValue),
      callback: function($$v) {
        _vm.fastSearchValue = $$v
      },
      expression: "fastSearchValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_total')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80"
  }, [_vm._v(_vm._s(_vm.messagesData.totalCount ? _vm.messagesData.totalCount : 0))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 font-weight-500 w5-ticket-view-widget"
  }, [_vm._v(_vm._s(_vm.localeFtc('main/sort_by').replace('{what}', _vm.$store.state.lang === 'en' ? 'date' : 'дате')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 widget-link margin-right-0 can-select",
    on: {
      "click": _vm.msgSortChange
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.msgSortFields[_vm.msgSort]['title']))))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), (_vm.UserType === 'admin') ? [_c('span', {
    staticClass: "font-size-80 font-weight-500 w5-ticket-view-widget"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/filter')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 widget-link margin-right-0 can-select",
    on: {
      "click": _vm.msgFilterChange
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.msgFilterFields[_vm.msgFilter]['title']()))))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "widget-page-size"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_size')) + ": ")]), _vm._v(" "), _vm._l((_vm.Config.pageSizes), function(size) {
    return _c('span', {
      key: 'page-size-id' + size,
      staticClass: "font-size-80 can-select",
      class: {
        'w5-link': size !== _vm.messagesData.pageSize, 'font-weight-500': size === _vm.messagesData.pageSize
      },
      on: {
        "click": function($event) {
          return _vm.setPageSize(size)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(size) + " \n\t\t\t\t\t\t")])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.Ticket && _vm.messagesData && _vm.messagesData.rows && _vm.messagesData.rows.length) ? _c('div', {
    attrs: {
      "id": "w5-ticket-message-list"
    }
  }, [_vm._l((_vm.messagesData.rows), function(msg, idx) {
    return _c('div', {
      key: 'message-row-id-' + idx,
      staticClass: "ticket-message-wrapper",
      class: _vm.fromWhoClass(msg)
    }, [_c('div', {
      staticClass: "ticket-message-table-wrapper"
    }, [(msg['message_type'] === 'notice') ? _c('table', {
      staticClass: "w5-ticket-message-table",
      class: 'ticket-message-' + msg['message_type']
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-notice-td-title font-weight-500"
    }, [_c('span', {
      staticClass: "margin-right-10"
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))]), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), ('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value']
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-content-text"
    })])]), _vm._v(" "), ((msg['message_time'] && _vm.UserType === 'admin') || (msg['message_mark'] || msg['can_mark'])) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time-notice"
    }, [(msg['message_time'] && _vm.UserType === 'admin') ? _c('div', {
      staticClass: "time pull-left"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1) : _vm._e(), _vm._v(" "), (msg['message_mark']) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketmessage/mark')) + ": \n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": 'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')
      }
    })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-notice"
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "notice"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()])]) : (msg['message_type'] === 'normal' || msg['message_type'] === 'email') ? _c('table', {
      staticClass: "w5-ticket-message-table ticket-message-normal"
    }, [(msg['user_type'] === 'admin') ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-img",
      attrs: {
        "width": _vm.$store.state.windowWidth > 767 ? '80px' : '40px',
        "rowspan": "2",
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + msg['user_avatar_path']
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "ticket-message-td-title"
    }, [('message_read' in msg && msg['message_read'] === true) ? _c('font-awesome-layers', {
      staticClass: "ticket-read margin-right-10"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "envelope"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "check"
      }
    })], 1) : _c('font-awesome-layers', {
      ref: 'unread-message-' + msg['message_id'],
      refInFor: true,
      staticClass: "ticket-read margin-right-10"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "envelope"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "asterisk"
      }
    })], 1), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), ('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value']
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e(), _vm._v(" "), (_vm.UserType === 'client') ? _c('font-awesome-icon', {
      staticClass: "pull-right client-oper-button",
      attrs: {
        "title": _vm._f("ftc")('main/quote'),
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.quoteMessage(msg)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "margin-right-6 pull-right font-weight-500"
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "ticket-message-td-message"
    }, [(msg['message_content_type'] === 'html') ? _c('p', {
      staticClass: "ticket-message-pre pre-admin ticket-message-content-text",
      domProps: {
        "innerHTML": _vm._s(msg['message_content'])
      }
    }) : _c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-pre pre-admin ticket-message-content-text"
    })])]), _vm._v(" "), ((msg['message_time'] && _vm.UserType === 'admin') || msg['message_mark'] || (_vm.UserType !== 'admin' && msg['can_mark'] === true)) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time",
      attrs: {
        "colspan": "2"
      }
    }, [(msg['message_time'] && _vm.UserType === 'admin') ? _c('div', {
      staticClass: "time pull-left"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1) : _vm._e(), _vm._v(" "), (msg['message_mark']) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketmessage/mark')) + ": \n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": 'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')
      }
    })], 1)]) : (_vm.UserType !== 'admin' && msg['can_mark'] === true) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_c('span', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("ftc")('ticketmessage/get_mark')))]), _vm._v(" "), _c('span', {
      staticClass: "mark-button-bad",
      on: {
        "click": function($event) {
          return _vm.setMark(msg, 'bad')
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-down"
      }
    }), _vm._v("   " + _vm._s(_vm._f("ftc")('main/bad')))], 1), _vm._v(" "), _c('span', {
      staticClass: "mark-button-good",
      on: {
        "click": function($event) {
          return _vm.setMark(msg, 'good')
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v("   " + _vm._s(_vm._f("ftc")('main/good')))], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-admin",
      attrs: {
        "colspan": "2"
      }
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "admin"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()]) : (msg['user_type'] === 'user' || msg['user_type'] === 'unknown') ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-client-td-title"
    }, [('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on pull-right"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value'],
        "toLeft": true
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e(), _vm._v(" "), (_vm.UserType === 'client') ? _c('font-awesome-icon', {
      staticClass: "pull-left client-oper-button",
      attrs: {
        "title": _vm._f("ftc")('main/quote'),
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.quoteMessage(msg)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-left font-weight-500",
      style: (_vm.UserType === 'admin' ? 'margin-left: 6px' : 'margin-left: 11px')
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))])], 1), _vm._v(" "), _c('td', {
      staticClass: "ticket-message-img",
      attrs: {
        "width": _vm.$store.state.windowWidth > 767 ? '80px' : '40px',
        "rowspan": "3",
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + msg['user_avatar_path']
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "ticket-message-client-td-message"
    }, [_c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-pre pre-client ticket-message-content-text"
    })])]), _vm._v(" "), (msg['message_time']) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "time pull-right"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1)])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-client",
      attrs: {
        "colspan": "2"
      }
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "client"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), (_vm.Ticket && _vm.paginationPages.length > 0) ? _c('div', [_c('paginator', {
    attrs: {
      "baseUrl": '/ticket/view/' + _vm.ticketId,
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage
    }
  })], 1) : _vm._e()], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteMessageModal),
      expression: "showDeleteMessageModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteMessageModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_delete')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteMessageModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketmessage/delete_request')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.deleteTicketMessageStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_delete')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailModal),
      expression: "showEmailModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showEmailModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/blacklist')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showEmailModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.emailModalText)),
      expression: "localeFtc(emailModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.blockEmailTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReplaceModal),
      expression: "showReplaceModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showReplaceModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showReplaceModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketMoveModalSelectDepartment",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "ticketMoveModalSelectDepartment",
      "listInModal": true,
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.replaceField,
      "removeRightPadding": true
    },
    model: {
      value: (_vm.replaceValue),
      callback: function($$v) {
        _vm.replaceValue = $$v
      },
      expression: "replaceValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.replaceTicketStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAttachModal),
      expression: "showAttachModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showAttachModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/assing_account')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showAttachModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketAttachModalSelectAccount",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "ticketAttachModalSelectAccount",
      "Field": _vm.attachField,
      "removeRightPadding": true,
      "listInModal": true,
      "listBlockToOut": 1,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.attachField['_errMsg'] = ''
      }
    },
    model: {
      value: (_vm.attachValue),
      callback: function($$v) {
        _vm.attachValue = $$v
      },
      expression: "attachValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.attachTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSendModal),
      expression: "showSendModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showSendModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showSendModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start_confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.sendTicketStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPreviewModal),
      expression: "showPreviewModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showPreviewModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalPreviewWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalPreviewText)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showPreviewModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "previewImageInDialog",
    style: (_vm.modalPreviewStyle)
  }), _vm._v(" "), (_vm.modalPreviewIsGallery) ? _c('div', {
    staticClass: "image-arrow prev",
    on: {
      "click": function($event) {
        return _vm.galleryMove(-1)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modalPreviewIsGallery) ? _c('div', {
    staticClass: "image-arrow next",
    on: {
      "click": function($event) {
        return _vm.galleryMove(+1)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "w5-preview-in-dialog-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalPreviewTitle)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(" (" + _vm._s(_vm.modalPreviewSize) + ")")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-submit w5-file-uploader-load-button pull-right",
    attrs: {
      "href": _vm.modalPreviewUrl
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateModal),
      expression: "showTemplateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container ticket-template",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textSearch', {
    ref: "textSearchTemplateDialog",
    attrs: {
      "Field": _vm.templateField
    },
    on: {
      "textSelected": _vm.templateChoiced
    }
  })], 1)])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMergeTicketsDialog),
      expression: "showMergeTicketsDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showMergeTicketsDialog')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/merge')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showMergeTicketsDialog')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "mergeTicketsSelectTicket",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "list",
      "name": "mergeTicketsSelectTicket",
      "listBlockToOut": 1,
      "listInModal": true,
      "fieldInModal": true,
      "Field": _vm.mergeTicketsField,
      "removeRightPadding": true
    },
    on: {
      "focus": function($event) {
        _vm.mergeTicketsField._errMsg = ''
      }
    },
    model: {
      value: (_vm.mergeTicketsField.value),
      callback: function($$v) {
        _vm.$set(_vm.mergeTicketsField, "value", $$v)
      },
      expression: "mergeTicketsField.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.mergeTicketsStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/continue')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoiceTicketLabelBlock),
      expression: "showChoiceTicketLabelBlock"
    }],
    ref: "ticketChoiceLabelBlock",
    staticClass: "widget-filter-ticket-label-choice",
    style: (_vm.ticketLabelBlockStyle)
  }, _vm._l((_vm.ticketLabelItems), function(val, idx) {
    return (String(val) !== '') ? _c('div', {
      key: 'label-choice-id-' + idx,
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      style: ('background-color: ' + String(val).toLowerCase()),
      on: {
        "click": function($event) {
          return _vm.onChangeTicketLabel(val)
        }
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', {
    ref: "quoteBlockWrapper",
    staticClass: "quote-selected-text-menu",
    attrs: {
      "id": "quoteBlockWrapper"
    },
    on: {
      "click": _vm.selectedTextToQuote
    }
  }, [_c('span', {
    ref: "quoteBlock",
    attrs: {
      "id": "quoteBlock"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/quote')))])]), _vm._v(" "), (_vm.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "review-block",
    class: {
      'active': _vm.reviewBlockShow
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        _vm.reviewBlockShow = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "review-block-link"
  }, [_c('span', [_vm._v(_vm._s(_vm.reviewBlockText(1)))]), _vm._v(" "), (_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinaru",
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": _vm.$store.state.lang === 'en' ? 'https://www.vdsina.com/qa/q/where-can-i-leave-a-review-about-vdsinacom' : 'https://www.vdsina.com/ru/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinacom',
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/gde-mozhno-ostavit-otzyv-o-macloudru",
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showConfirmModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container ticket-template",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showConfirmModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalContent)),
      expression: "localeFtc(confirmModalContent)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmModalFunc
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'QA',

	data: function data() {
		return {
			popList: null,
			newList: null,
			tagList: null,
			qaSearchValue: ''
		};
	},

	computed: {
		currentLang: function currentLang() {
			return this.$store.state.lang;
		},
		QAURL: function QAURL() {
			if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].AppName === 'vdsina.com') {
				return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].AppServerUrl + (this.$store.state.lang === 'en' ? '/' : '/ru/') + 'qa';
			}

			return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].QAUrl;
		}
	},
	created: function created() {
		if (this.$store.state.user_type !== 'client') {
			return this.$router.push('/404');
		}

		this.requestData();
	},

	methods: {
		requestData: function requestData() {
			var _this = this;

			if (this.$store.state.qaCache.time && this.$store.state.qaCache.time > __WEBPACK_IMPORTED_MODULE_3__helper_helper_js__["a" /* default */].unixTime()) {
				this.popList = this.$store.state.qaCache.popList;
				this.newList = this.$store.state.qaCache.newList;
				this.tagList = this.$store.state.qaCache.tagList;
				return;
			}

			var _url = this.QAURL + '/api2panel/list';

			this.$http.get(_url).then(function (res) {
				if (res && (typeof res === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res)) === 'object' && res.ok === true && res.body && res.body.pop && res.body.new) {
					_this.$set(_this, 'popList', res.body.pop);
					_this.$set(_this, 'newList', res.body.new);
					_this.$set(_this, 'tagList', res.body.tag);

					_this.$store.commit('setQACache', {
						popList: _this.popList,
						newList: _this.newList,
						tagList: _this.tagList
					});
				}
			});
		},
		qaSearchEvent: function qaSearchEvent() {
			this.qaSearchValue = '';

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
		},
		qaSearchStart: function qaSearchStart() {
			if (!this.qaSearchValue || this.qaSearchValue.trim() === '') return;

			var _str = this.qaSearchValue;

			this.qaSearchEvent();

			var _win = window.open(this.QAURL + '/search?search=' + encodeURIComponent(_str), '_blank');
			_win.focus();
		},
		onTextEvent: function onTextEvent(txt) {
			if (this.$store.state.user_type === 'client') {
				if (!txt || String(txt).length < 3) {
					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
					return;
				}

				var _url = this.QAURL + '/api2panel/search';

				this.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper_js__["a" /* default */].toFormData({ search: txt })).then(function (res) {
					if (res && (typeof res === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res)) === 'object' && res.ok === true && res.body && res.body.status) __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', res.body.answer);else __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
				}, function (res) {
					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('form-ticket-serach-result', false);
				});
			}
		},
		handleLang: function handleLang() {
			this.qaSearchEvent();

			this.$store.commit('setQACache', null);
		}
	},

	watch: {
		'currentLang': function currentLang() {
			this.handleLang();
		}
	},

	components: {
		Field: __WEBPACK_IMPORTED_MODULE_2__components_elements_formfield___default.a
	}

});

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('h4', {
    staticClass: "qa-search-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/any_questions')))]), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper search"
  }, [_c('Field', {
    ref: "qaSearch",
    attrs: {
      "isVisibleRow": true,
      "crud": "qa",
      "action": "list",
      "name": "qaSearch",
      "Field": {
        _field_name: 'qaSearch',
        type: 'text',
        title: 'main/qa_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true,
      "bigButton": true,
      "bigButtonTitle": 'main/ask'
    },
    on: {
      "event_ClearButtonClicked": _vm.qaSearchEvent,
      "enterKeyDown": _vm.qaSearchStart,
      "event_Input": _vm.onTextEvent
    },
    model: {
      value: (_vm.qaSearchValue),
      callback: function($$v) {
        _vm.qaSearchValue = $$v
      },
      expression: "qaSearchValue"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "qa-tags-cloud-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/popular_topics')))]), _vm._v(" "), (_vm.tagList) ? _c('div', {
    staticClass: "support-tag-cloud"
  }, _vm._l((_vm.tagList), function(tag) {
    return _c('div', {
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/tags/' + encodeURIComponent(tag.tag),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(tag.tag))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper"
  }, [(_vm.popList) ? _c('div', {
    staticClass: "support-block-questions first"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('qa/pop_questions')))]), _vm._v(" "), _c('ul', _vm._l((_vm.popList), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.cap))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.newList) ? _c('div', {
    staticClass: "support-block-questions"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('qa/new_questions')))]), _vm._v(" "), _c('ul', _vm._l((_vm.newList), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.cap))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper"
  }, [_c('router-link', {
    staticClass: "w5-support-link",
    attrs: {
      "to": "/ticket/create"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "question-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/ticket_question')))]), _vm._v(" "), _c('span', {
    staticClass: "link-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/create_ticket')))])], 1)], 1)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_view__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_limits__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_limits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_limits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_money__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_money__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Info',
	data: function data() {
		return {
			dataInfo: false,

			crud: 'info',

			sortDATA: {},

			Keys: false,

			localErrorMessage: '',

			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteModalNumber: 0
		};
	},

	computed: {
		Config: function Config() {
			return this.$store.state.clientConfig;
		},
		Account: function Account() {
			if (this.dataInfo && this.dataInfo['account']) return this.dataInfo['account'];else return false;
		},
		Balance: function Balance() {
			if (this.$store.state.user_type === 'admin') {
				return {
					'digits': this.countBalanceDigits(),
					'real': {
						'value': this.Account['balance']['real']['value'],
						'title': 'operation/purse_real'
					},
					'bonus': {
						'value': this.Account['balance']['bonus']['value'],
						'title': 'operation/bonus_balance'
					},
					'partner': {
						'value': this.Account['balance']['partner']['value'],
						'title': 'operation/partner_balance'
					}
				};
			} else {
				if (this.$store.state.user_balance && 'real' in this.$store.state.user_balance) {
					return {
						'digits': this.countBalanceDigits(),
						'real': {
							'value': this.$store.state.user_balance['real'],
							'title': 'operation/purse_real'
						},
						'bonus': {
							'value': this.$store.state.user_balance['bonus'],
							'title': 'operation/bonus_balance'
						},
						'partner': {
							'value': this.$store.state.user_balance['partner'],
							'title': 'operation/partner_balance'
						}
					};
				} else return false;
			}
		},
		Globals: function Globals() {
			if (this.dataInfo && this.dataInfo['globals']) return this.dataInfo['globals'];else return false;
		},
		Bonus: function Bonus() {
			if (this.dataInfo && this.dataInfo['bonus']) return this.dataInfo['bonus'];else return false;
		},
		Partner: function Partner() {
			if (this.$store.state.user_type !== 'admin') return false;
			if (this.dataInfo && this.dataInfo['partner']) return this.dataInfo['partner'];else return false;
		},
		Program: function Program() {
			if (this.$store.state.user_type !== 'admin') return false;
			if (this.dataInfo && this.dataInfo['program']) return this.dataInfo['program'];else return false;
		},
		Limits: function Limits() {
			if (this.dataInfo && this.dataInfo['limits']) return this.dataInfo['limits'];else return false;
		},
		realCrudName: function realCrudName() {
			if (this.crud === 'admin') return 'user';
			if (this.crud === 'partnerprogram') return 'program';
			if (this.crud === 'servicetype') return 'service_type';
			if (this.crud === 'planarchive') return 'plan';
			if (this.crud === 'iso') return 'service';
			if (this.crud === 'additional-services') return 'service';

			return this.crud;
		},
		canDeleteAccount: function canDeleteAccount() {
			return this.isAccess('account/delete');
		},
		modalDeleteButtonTitle: function modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('account/delete');
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer);
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.requestInfo();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
		window.addEventListener('storage', this.onLocalStorageEvent);
		document.addEventListener('keydown', this.keyDownHandler);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
		window.removeEventListener('storage', this.onLocalStorageEvent);
		document.removeEventListener('keydown', this.keyDownHandler);
	},

	watch: {
		'$route': function $route(to, from) {
			this.requestInfo();
		}
	},

	methods: {
		requestInfo: function requestInfo() {
			var _this = this;

			var _url = this.APIServerUrl + '/account/view';
			if (this.$store.state.user_type === 'admin') _url = this.APIServerUrl + this.$route.path;

			this.$http.get(_url).then(function (res) {
				var _dt = res && res.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res.data) === 'object' ? res.data : false;

				if (_dt && _dt['status'] === 'ok') {
					_this.dataInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _dt);

					_this.sortDATA = _this._order();

					_this.Keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.sortDATA).sort(function (a, b) {
						return a - b;
					});

					if (_this.$store.state.user_type !== 'admin') {
						if (_dt['account'] && _dt['account']['balance']) {
							_this.$store.commit('updateUserBalance', _dt['account']);
						}
					}

					return;
				}

				_this.localErrorMessage = _this.formatRequestError(res);
			}, function (res) {
				_this.localErrorMessage = _this.formatRequestError(res);
			});
		},
		recountClass: function recountClass(what) {
			if (what === 'Account') {
				var _cnt = 0;
				if (this.Account['account_name']['value']) _cnt++;
				if (this.Account['account_created']['value']) _cnt++;
				if (this.Account['forecast']['value']) _cnt++;
				return 'info-box-width-' + _cnt;
			}

			if (what === 'Balance') {
				return 'info-box-width-3';
			}

			if (what === 'Globals') {
				var _cnt2 = 0;
				if (this.Globals['can_add_service']) _cnt2++;
				if (this.Globals['can_add_user']) _cnt2++;
				if (this.Globals['can_convert_to_cash']) _cnt2++;
				return 'info-box-width-' + _cnt2;
			}

			if (what === 'Partner') {
				var _cnt3 = 0;
				if (this.Partner && this.Partner['account_id'] && this.Partner['account_id']['value']) _cnt3++;
				if (this.Program && this.Program['program_id'] && this.Program['program_id']['value']) _cnt3++;
				return 'info-box-width-' + _cnt3;
			}

			return false;
		},
		countBalanceDigits: function countBalanceDigits() {
			var _r = String(this.Account['balance']['real']['value']).split('.');
			var _b = String(this.Account['balance']['bonus']['value']).split('.');
			var _p = String(this.Account['balance']['partner']['value']).split('.');

			_r = _r[1] ? _r[1].length : 0;
			_b = _b[1] ? _b[1].length : 0;
			_p = _p[1] ? _p[1].length : 0;

			_r = Math.max(_r, _b, _p);
			if (_r > 2) return 4;
			return 2;
		},
		_order: function _order() {
			var obj = void 0;
			var __obj = void 0;
			var tmp = void 0;
			var order = void 0;
			var sortDATA = {};

			for (var idx in this.Limits) {
				if (this.Limits.hasOwnProperty(idx)) {
					obj = this.Limits[idx];

					if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
						if ('order' in obj && obj['type'] !== 'hidden') {
							tmp = parseInt(obj['order']);
							order = isNaN(tmp) ? 0 : tmp;

							if (!sortDATA[order]) {
								sortDATA[order] = [];
								sortDATA[order].push(idx);
							} else sortDATA[order].push(idx);
						} else {
								for (var i in obj) {
									if (obj.hasOwnProperty(i)) {
										__obj = obj[i];

										if (__obj && (typeof __obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(__obj)) === 'object' && 'order' in __obj && 'title' in __obj && 'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined && 'type' in __obj && __obj['type'] !== 'hidden') {
											tmp = parseInt(__obj['order']);
											order = isNaN(tmp) ? 0 : tmp;

											if (!sortDATA[order]) {
												sortDATA[order] = [];
												sortDATA[order].push(i);
											} else sortDATA[order].push(i);
										}
									}
								}
							}
					}
				}
			}
			return sortDATA;
		},
		setAccountGlobalFilter: function setAccountGlobalFilter(account, isPartner) {
			var _this2 = this;

			if (this.$store.state.user_type !== 'admin') return;

			if (account) {
				if (!/\d+/.test(account)) return;
				var _accountID = parseInt(account);
				if (isNaN(_accountID) || _accountID < 1) return;

				var _url = this.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				this.$store.commit('accountGlobalFilter', false);

				this.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this2.$store.commit('accountGlobalFilter', true);

						if (window && window.localStorage) window.localStorage.setItem('__event', 'agf1' + new Date().getTime() + '_' + _accountID);

						_this2.$store.dispatch('getTicketCounters');
						_this2.$store.dispatch('getRequestCounter');

						__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
							'title': ' ',
							'message': 'main/set_filter ' + (isPartner === true ? _this2.Partner['account_name']['value'] : _this2.Account['account_name']['value']),
							'class': 'success',
							'type': 'nourl',
							'id': 'success-message',
							'timeout': 3000
						});

						_this2.requestInfo();

						return;
					}

					_this2.localErrorMessage = _this2.formatRequestError(resGet);
				}, function (resGet) {
					_this2.localErrorMessage = _this2.formatRequestError(resGet);
				});
			} else {
					var _url2 = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter';

					this.$http.get(_url2).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
						if (_dt && _dt['status'] === 'ok') {
							_this2.$store.commit('accountGlobalFilter', false);

							if (window && window.localStorage) window.localStorage.setItem('__event', 'agf0' + new Date().getTime());

							_this2.$store.dispatch('getTicketCounters');
							_this2.$store.dispatch('getRequestCounter');

							__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
								'title': ' ',
								'message': _this2.localeFtc('main/filter') + ' ' + _this2.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							});

							_this2.requestInfo();

							return;
						}

						_this2.localErrorMessage = _this2.formatRequestError(resGet);
					}, function (resGet) {
						_this2.localErrorMessage = _this2.formatRequestError(resGet);
					});
				}
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg) return;

			if (!this.Account || !this.Account['account_id'] || !this.Account['account_id']['value']) return;

			var _parts = msg.split(' ');

			if (!_parts || _parts.length !== 4) return;

			if (_parts[0] !== 'update' || _parts[1] !== 'operation' || !_parts[2]) return;

			if (String(this.Account['account_id']['value']) === _parts[3]) {
				this.requestInfo();
			}
		},
		onLocalStorageEvent: function onLocalStorageEvent(event) {
			if (this.$store.state.user_type !== 'admin') return;

			if (!event || event.key !== '__event' || !event.newValue) return;

			if (event.newValue.indexOf('agf1') === 0 || event.newValue.indexOf('agf0') === 0) {
				if (event.newValue.indexOf('agf1') === 0) {
					var _curAcc = this.$route && this.$route.params && this.$route.params.id ? this.$route.params.id : null;

					var _fltAcc = event.newValue.split('_')[1];

					if (_curAcc && _fltAcc && String(_curAcc) !== String(_fltAcc)) {
						this.$router.replace('/account/view/' + _fltAcc);

						return;
					}
				}

				this.$store.dispatch('getTicketCounters');
				this.$store.dispatch('getRequestCounter');

				this.requestInfo();
			}
		},
		keyDownHandler: function keyDownHandler(e) {
			if (e.keyCode === 27) {
				e.preventDefault();
				this.hideDeleteModal(true);
			}
		},
		deleteAccount: function deleteAccount() {
			var _this3 = this;

			if (!this.canDeleteAccount) return;

			this.localErrorMessage = '';

			this.deleteModalNumber = 1;

			this.deleteModalText = this.localeFtc('account/delete_text_1') + '<br><br>' + this.localeFtc('account/delete_text_2');

			this.deleteModalTimer = 10;

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showDeleteModal = true;

			this.deleteModalTimerHandle = setInterval(function () {
				_this3.deleteModalTimer--;
				if (_this3.deleteModalTimer <= 0) {
					clearInterval(_this3.deleteModalTimerHandle);
					_this3.deleteModalTimerHandle = false;
				}
			}, 1000);
		},
		hideDeleteModal: function hideDeleteModal() {
			var withDropCounter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (withDropCounter) {
				this.deleteModalNumber = 0;
			}

			if (this.deleteModalTimerHandle) {
				clearInterval(this.deleteModalTimerHandle);
				this.deleteModalTimerHandle = false;
			}

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showDeleteModal = false;
			this.hideModalMask();
		},
		deleteAccountStart: function deleteAccountStart() {
			var _this4 = this;

			if (this.deleteModalTimer && this.deleteModalTimer > 0) return;

			if (!this.canDeleteAccount) return;

			this.localErrorMessage = '';

			this.hideDeleteModal();

			if (this.deleteModalNumber === 1) {
				setTimeout(function () {
					_this4.deleteModalNumber = 2;

					_this4.deleteModalText = _this4.localeFtc('main/delete_msg').replace('{name}', 'account/account ' + _this4.Account['account_name']['value']) + '<br><br>' + _this4.localeFtc('account/delete_text_2');

					_this4.deleteModalTimer = 20;

					__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
					_this4.showDeleteModal = true;

					_this4.deleteModalTimerHandle = setInterval(function () {
						_this4.deleteModalTimer--;
						if (_this4.deleteModalTimer <= 0) {
							clearInterval(_this4.deleteModalTimerHandle);
							_this4.deleteModalTimerHandle = false;
						}
					}, 1000);
				}, 100);
			} else if (this.deleteModalNumber === 2) {
					var _url = this.APIServerUrl + '/account/delete';

					this.$http.get(_url).then(function (resGet) {
						var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

						if (_dt && _dt['_csrf']) {
							_this4.$http.post(_url, __WEBPACK_IMPORTED_MODULE_3__helper_helper__["a" /* default */].toFormData({ '_csrf': _dt['_csrf'] })).then(function (resPost) {
								_dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

								if (_dt && _dt['status'] === 'ok') {
									_this4.$store.commit('dropAuth');

									_this4.$store.commit('pushStop');

									_this4.$router.push('/login');

									return;
								}

								_this4.localErrorMessage = _this4.formatRequestError(resPost);

								window.scrollTo(0, 0);
							}, function (resPost) {
								_this4.localErrorMessage = _this4.formatRequestError(resPost);

								window.scrollTo(0, 0);
							});

							return;
						}

						_this4.localErrorMessage = _this4.formatRequestError(resGet);

						window.scrollTo(0, 0);
					}, function (resGet) {
						_this4.localErrorMessage = _this4.formatRequestError(resGet);

						window.scrollTo(0, 0);
					});
				}
		}
	},

	components: {
		viewComponent: __WEBPACK_IMPORTED_MODULE_5__components_elements_view___default.a,
		limits: __WEBPACK_IMPORTED_MODULE_6__components_elements_limits___default.a,
		notice: __WEBPACK_IMPORTED_MODULE_7__components_elements_notice___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_8__components_elements_money___default.a
	}

});

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Limits',

	props: ['data'],
	data: function data() {
		return {
			Data: false,
			Names: {
				1: 'VDS',
				2: 'IPv4',
				3: 'RAM',
				4: 'NVMe',
				5: 'vCPU',
				6: 'Трафик',
				7: 'IPv6',
				8: 'Нагрузка',
				9: 'Снимок',
				10: 'ISO',
				11: 'SSL-сертификат',
				12: 'Домены',
				14: 'DNS'
			}
		};
	},

	computed: {
		Count: function Count() {
			return 1;
		}
	},
	created: function created() {
		this.init();
	},

	methods: {
		init: function init() {
			this.Data = false;

			if (!this.data || !this.data['servicetype']) return;

			for (var k in __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants) {
				if (k.indexOf('SERVICE_TYPE') !== 0) continue;

				var _index = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].Constants[k];

				var _str = '';
				var _num = 0;
				var _obj = false;
				var _name = false;

				for (var l in this.data['servicetype']) {
					_str = '[' + _index + ']';
					_num = l.indexOf(_str);

					if (_num > -1) {
						if (!_obj) _obj = {};
						_obj[l.substr(0, _num)] = this.data['servicetype'][l]['value'];

						var _title = this.data['servicetype'][l]['title'];
						_num = _title.indexOf(':');
						if (_num > -1) _name = _title.substr(0, _num);
					}
				}

				if (_obj) {
					if (!this.Data) this.Data = {};
					this.Data[_index] = {
						'name': _name !== false ? _name : this.Names[_index] ? this.Names[_index] : k.substr(13).replace('VDS_', ''),
						'data': _obj
					};
				}
			}
		},
		percents: function percents(idx) {
			var _idx = parseInt(idx, 10);
			if (isNaN(_idx)) return 0;

			if (!this.Data || !this.Data[idx]) return 0;

			var _max = parseInt(this.Data[idx]['data']['limit_max_count'], 10);
			var _ordered = parseInt(this.Data[idx]['data']['ordered'], 10);

			if (isNaN(_max) || isNaN(_ordered)) return 0;
			if (_max < 0 || _ordered < 0) return 0;

			if (_max === 0) {
				if (_ordered > 0) return 100;else return 0;
			}

			var _proc = parseInt(_ordered * 100.0 / _max);
			if (_proc <= 0) _proc = 0;
			if (_proc >= 100) _proc = 100;

			return _proc;
		}
	},

	watch: {
		'data': function data(_data) {
			this.init();
		}
	}

});

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Data) ? _c('div', {
    staticClass: "limits-block-wrapper"
  }, [_c('div', {
    staticClass: "progress-layer"
  }, [_vm._l((_vm.Data), function(type, i) {
    return [_c('div', {
      key: 'pt-' + i,
      staticClass: "progress-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")(type.name)) + ": "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(type.data['ordered'])), (type.data['limit_max_count'] < 100000) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")('main/out_of')) + " " + _vm._s(type.data['limit_max_count']))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      key: 'pw-' + i,
      staticClass: "progress progress-striped progress-wrapper"
    }, [_c('div', {
      staticClass: "progress-bar",
      class: _vm.percents(i) < 99.99 ? 'progress-bar-info' : 'progress-bar-danger',
      style: ('width: ' + _vm.percents(i) + '%')
    })]), _vm._v(" "), _c('div', {
      key: 'ptu-' + i,
      staticClass: "progress-underline-text"
    }, [(type.data['limit_child_count']) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('account/limit_not_greater')) + " " + _vm._s(type.data['limit_child_count']) + " " + _vm._s(_vm._f("ftc")('account/limit_in_service')))]) : _vm._e()])]
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.dataInfo && 'title' in _vm.dataInfo) ? _c('div', {
    staticClass: "w5-info"
  }, [(_vm.Account) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [(_vm.Account['account_name'] && _vm.Account['account_name']['value']) ? _c('div', {
    staticClass: "info-box brd-gray",
    class: _vm.recountClass('Account')
  }, [_c('span', {
    staticClass: "info-box-icon bg-gray"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "list-alt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['account_name']['title'])))]), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? [(!_vm.Account['global_filter'] || _vm.Account['global_filter']['value'] != _vm.Account['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Account['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Account['global_filter'] && _vm.Account['global_filter']['value'] == _vm.Account['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['account_name']['value'])))])], 2)]) : _vm._e(), _vm._v(" "), (_vm.Account['account_created'] && _vm.Account['account_created']['value']) ? _c('div', {
    staticClass: "info-box brd-gray",
    class: _vm.recountClass('Account')
  }, [_c('span', {
    staticClass: "info-box-icon bg-gray"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "calendar-alt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['account_created']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.Account['account_created']['value'], 'd.m.Y')))])])]) : _vm._e(), _vm._v(" "), (_vm.Account['forecast'] && _vm.Account['forecast']['value']) ? _c('div', {
    staticClass: "info-box brd-gray",
    class: _vm.recountClass('Account')
  }, [_c('span', {
    staticClass: "info-box-icon bg-gray"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "exclamation-circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['forecast']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.Account['forecast']['value'], 'd.m.Y')))]), _vm._v("   "), _c('notice', {
    attrs: {
      "text": _vm._f("ftc")('main/forecast_notice'),
      "index": 'infoForeCast',
      "small": true
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Balance) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [_c('div', {
    staticClass: "info-box brd-aqua",
    class: _vm.recountClass('Balance')
  }, [_c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Balance['real']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value",
    class: {
      'color-red': _vm.Balance['real']['value'] < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money_1")(_vm.Balance['real']['value'], _vm.Balance['digits'])
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "info-box brd-aqua",
    class: _vm.recountClass('Balance')
  }, [_c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "piggy-bank"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Balance['bonus']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value",
    class: {
      'color-red': _vm.Balance['bonus']['value'] < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money_1")(_vm.Balance['bonus']['value'], _vm.Balance['digits'])
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "info-box brd-aqua",
    class: _vm.recountClass('Balance')
  }, [_c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "briefcase"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Balance['partner']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value",
    class: {
      'color-red': _vm.Balance['partner']['value'] < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money_1")(_vm.Balance['partner']['value'], _vm.Balance['digits'])
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.Globals) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [('can_add_service' in _vm.Globals && typeof _vm.Globals['can_add_service'] === 'object' && 'value' in _vm.Globals['can_add_service']) ? _c('div', {
    staticClass: "info-box brd-yellow",
    class: _vm.recountClass('Globals')
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_add_service']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_add_service']['value'])))])])]) : _vm._e(), _vm._v(" "), ('can_add_user' in _vm.Globals && typeof _vm.Globals['can_add_user'] === 'object' && 'value' in _vm.Globals['can_add_user']) ? _c('div', {
    staticClass: "info-box brd-yellow",
    class: _vm.recountClass('Globals')
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "users"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_add_user']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_add_user']['value'])))])])]) : _vm._e(), _vm._v(" "), ('can_convert_to_cash' in _vm.Globals && typeof _vm.Globals['can_convert_to_cash'] === 'object' && 'value' in _vm.Globals['can_convert_to_cash']) ? _c('div', {
    staticClass: "info-box brd-yellow",
    class: _vm.recountClass('Globals')
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "exchange-alt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_convert_to_cash']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Globals['can_convert_to_cash']['value'])))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Bonus) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [(_vm.Bonus['value'] && Array.isArray(_vm.Bonus['value']) && _vm.Bonus['value'].length) ? _c('div', {
    staticClass: "info-box for-bonus brd-green"
  }, [_c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "gift"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Bonus['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value-bonuses"
  }, [_vm._l((_vm.Bonus['value']), function(b, i) {
    return [(i > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _c('linkComponent', {
      class: !b['active'] ? 'not-active-bonus' : '',
      attrs: {
        "url": '/bonus/view/' + b['bonus_id'],
        "text": b['bonus_name']
      }
    })]
  })], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Partner || _vm.Program) ? _c('div', {
    staticClass: "info-block with-flex"
  }, [(_vm.Partner['account_id'] && _vm.Partner['account_id']['value'] && _vm.Partner['account_name'] && _vm.Partner['account_name']['value']) ? _c('div', {
    staticClass: "info-box brd-dark-blue",
    class: _vm.recountClass('Partner')
  }, [_c('span', {
    staticClass: "info-box-icon bg-dark-blue"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user-graduate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Partner['account_id']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value-bonuses"
  }, [(_vm.$store.state.user_type === 'admin') ? [(!_vm.Account['global_filter'] || _vm.Account['global_filter']['value'] != _vm.Partner['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Partner['account_id']['value'], true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Account['global_filter'] && _vm.Account['global_filter']['value'] == _vm.Partner['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/account/view/' + _vm.Partner['account_id']['value'],
      "text": _vm.Partner['account_name']['value']
    }
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.Program['program_id'] && _vm.Program['program_id']['value'] && _vm.Program['program_name'] && _vm.Program['program_name']['value']) ? _c('div', {
    staticClass: "info-box brd-dark-blue",
    class: _vm.recountClass('Partner')
  }, [_c('span', {
    staticClass: "info-box-icon bg-dark-blue"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "handshake"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Program['program_id']['title'])))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-value-bonuses"
  }, [_c('linkComponent', {
    attrs: {
      "url": '/partnerprogram/view/' + _vm.Program['program_id']['value'],
      "text": _vm.Program['program_name']['value']
    }
  })], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('limits', {
    attrs: {
      "data": _vm.Limits
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('page/account_delete')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('account/delete_text_2')),
      expression: "localeFtc('account/delete_text_2')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btns-block"
  }, [_c('div', {
    staticClass: "btn btn-submit-danger tab-command-button",
    class: {
      'disable': !_vm.canDeleteAccount
    },
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "exclamation-circle"
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('account/delete')) + "\n\t\t\t\t\t")], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('account/delete')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteAccountStart
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])])], 1) : _vm._e()] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Users',
	data: function data() {
		return {
			dataUsers: false,

			crud: 'users',

			localErrorMessage: ''
		};
	},

	computed: {
		Config: function Config() {
			return this.$store.state.clientConfig;
		}
	},
	created: function created() {
		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('setReturnURL', this.$route.path);

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		this.requestInfo();
	},

	methods: {
		requestInfo: function requestInfo() {}
	}

});

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth && this.$store.state.user_type === 'client') ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('h3', [_vm._v("Пользователи аккаунта")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n\t\t\t\tLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ultrices sollicitudin metus, non finibus nisi pellentesque rhoncus. Fusce et erat laoreet, elementum erat non, tincidunt risus. Aliquam et condimentum sem. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis dolor justo, blandit ac purus non, convallis porttitor mauris. Nulla cursus, nulla ac hendrerit mollis, turpis magna eleifend diam, et luctus nisi ligula quis ipsum. Integer ut interdum tortor.\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tSed ut est in orci interdum dapibus a eu arcu. Sed eget tortor velit. Fusce vitae justo at tortor posuere finibus id et massa. Cras lacinia risus euismod, consectetur eros blandit, vehicula sem. Suspendisse ipsum neque, faucibus ac hendrerit consequat, tempor eu justo. Suspendisse est orci, porttitor id risus at, mattis varius diam. Aenean malesuada eros accumsan sem efficitur imperdiet id et lorem. Aliquam erat volutpat. Suspendisse et eros eu erat tincidunt aliquam consequat quis mi. Sed nulla augue, ultricies nec odio ac, pretium ornare eros. Suspendisse potenti. Praesent iaculis, orci vitae lacinia venenatis, metus leo egestas libero, ut congue velit lorem aliquam ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Maecenas ultrices tellus ut nibh fringilla, ac finibus velit euismod. Proin rutrum dictum augue eget sodales. Nam ultrices nulla sed massa lacinia feugiat in nec nulla.\n\t\t\t")])])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_notFound__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_notFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_notFound__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'error500',

	props: ['response'],
	data: function data() {
		return {
			errorCode: 0
		};
	},

	computed: {
		Text: function Text() {
			if (this.errorCode === 400) return 'error/cookie';

			var _txt = void 0;
			_txt = this.formatRequestError(this.response);
			if (_txt === undefined || _txt === null || String(_txt).trim() === '' || _txt === 'error/http_error') _txt = 'При выполнении запроса возникла ошибка.<br>Пожалуйста, обратитесь в службу технической поддержки.';
			return _txt;
		}
	},
	created: function created() {
		var _code = this.$store.state.errorHttpCode;

		this.$store.commit('errorHttpCode', 0);

		if (this.response || _code) {
			this.errorCode = _code > 0 ? _code : this.response.status;
		} else {
			this.$router.push('/');
		}
	},

	components: {
		notFoundPage: __WEBPACK_IMPORTED_MODULE_0__components_notFound___default.a
	}

});

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$store.state.is_auth) ? _c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.errorCode === 404) ? _c('notFoundPage') : (_vm.errorCode === 403) ? _c('div', {
    staticClass: "alert alert-danger text-center error-block",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/access_denied')))])]) : _c('div', {
    staticClass: "alert alert-danger text-center error-block",
    class: {
      'outer': !_vm.$store.state.is_auth
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Text)),
      expression: "localeFtc(Text)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_clock__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_clock__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'error503',

	props: ['response'],
	data: function data() {
		return {
			errorCode: 0
		};
	},
	created: function created() {
		var _code = this.$store.state.errorHttpCode;

		this.$store.commit('errorHttpCode', 0);

		if (this.response || _code) {
			this.errorCode = _code > 0 ? _code : this.response.status;
		} else {
			this.$router.push('/');
		}
	},

	components: {
		Clock: __WEBPACK_IMPORTED_MODULE_0__components_elements_clock___default.a
	}

});

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  "data-v-6da0251f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clockComponent',
	data: function data() {
		return {
			digitsStyle: ['', '', '', '', '', '', '', '', '', '', '', '', ''],
			hhStyle: ['', '', '', ''],
			mmStyle: ['', '', '', '', '', ''],
			ssStyle: ['', '', '', '', '', '', '', ''],
			cosHH: {},
			sinHH: {},
			cosMM: {},
			sinMM: {},
			cosSS: {},
			sinSS: {}
		};
	},
	created: function created() {
		this.init_clock();
		this.start_clock();
	},

	methods: {
		init_clock: function init_clock() {
			var X = 60;
			var Y = 60;
			var Rad = 45;

			for (var i = 1; i < 13; i++) {
				this.digitsStyle[i] = 'top: ' + (Y - 15 + Rad * Math.sin(-1.51 + i * Math.PI / 6)) + 'px; left: ' + (X - 15 + Rad * Math.cos(-1.51 + i * Math.PI / 6)) + 'px;';
			}
		},
		start_clock: function start_clock() {
			var _this = this;

			var X = 60;
			var Y = 60;
			var Rad = 45;
			var time = new Date();
			var sec = -1.57 + Math.PI * time.getSeconds() / 30;
			var min = -1.57 + Math.PI * time.getMinutes() / 30;
			var hr = -1.57 + Math.PI * time.getHours() / 6 + Math.PI * parseInt(time.getMinutes()) / 360;
			var i = void 0;

			if (this.cosHH[hr] === undefined) this.cosHH[hr] = Math.cos(hr);
			if (this.sinHH[hr] === undefined) this.sinHH[hr] = Math.sin(hr);

			if (this.cosMM[min] === undefined) this.cosMM[min] = Math.cos(min);
			if (this.sinMM[min] === undefined) this.sinMM[min] = Math.sin(min);

			if (this.cosSS[sec] === undefined) this.cosSS[sec] = Math.cos(sec);
			if (this.sinSS[sec] === undefined) this.sinSS[sec] = Math.sin(sec);

			for (i = 0; i < 4; i++) {
				this.$set(this.hhStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinHH[hr]) + 'px; left: ' + (X + i * Rad / 9 * this.cosHH[hr]) + 'px;');
			}for (i = 0; i < 6; i++) {
				this.$set(this.mmStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinMM[min]) + 'px; left: ' + (X + i * Rad / 9 * this.cosMM[min]) + 'px;');
			}for (i = 0; i < 8; i++) {
				this.$set(this.ssStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinSS[sec]) + 'px; left: ' + (X + i * Rad / 9 * this.cosSS[sec]) + 'px;');
			}setTimeout(function () {
				return _this.start_clock();
			}, 500);
		}
	}
});

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-wrapper"
  }, [_c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[1])
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[2])
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[3])
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[4])
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[5])
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[6])
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[7])
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[8])
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[9])
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[10])
  }, [_vm._v("10")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[11])
  }, [_vm._v("11")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock_style digits",
    style: (_vm.digitsStyle[12])
  }, [_vm._v("12")]), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-hh",
    style: (_vm.hhStyle[0])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-hh",
    style: (_vm.hhStyle[1])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-hh",
    style: (_vm.hhStyle[2])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-hh",
    style: (_vm.hhStyle[3])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[0])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[1])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[2])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[3])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[4])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-mm",
    style: (_vm.mmStyle[5])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[0])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[1])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[2])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[3])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[4])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[5])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[6])
  }), _vm._v(" "), _c('div', {
    staticClass: "clock clock2 arr-ss",
    style: (_vm.ssStyle[7])
  })])
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "w5-error-page"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("ftc")('error/under_construction_title')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('Clock')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('error/under_construction')),
      expression: "localeFtc('error/under_construction')"
    }]
  })])])])
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filterUser',
	data: function data() {
		return {
			userId: null,
			accountId: null
		};
	},
	created: function created() {
		var _this = this;

		if (!this.$store.state.is_auth) {
			this.$store.commit('dropAuth');

			this.$store.commit('pushStop');

			return this.$router.push('/login');
		}

		if (this.$store.state.user_type !== 'admin') return this.$router.push('/404');

		if (this.$route && this.$route.params && this.$route.params.id) this.userId = this.$route.params.id;

		if (!this.userId) return this.$router.push('/404');

		this.getUserAccount().then(this.setAccountFilter, this.errorHandler).then(function () {
			_this.$router.push('/user/view/' + _this.userId);
		}, this.errorHandler);
	},

	methods: {
		getUserAccount: function getUserAccount() {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var _url = _this2.APIServerUrl + '/user/view/' + _this2.userId;

				_this2.$http.get(_url).then(function (resGet) {
					if (resGet && (typeof resGet === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet)) === 'object' && resGet['status'] === 200 && resGet['body'] && resGet['body']['status'] === 'ok' && resGet['body']['account'] && resGet['body']['account']['account_id'] && resGet['body']['account']['account_id']['value']) {
						_this2.accountId = resGet['body']['account']['account_id']['value'];
						resolve();
					} else reject('error/api_incorrect');
				}, function (resGet) {
					reject('error/api_incorrect');
				});
			});
		},
		setAccountFilter: function setAccountFilter() {
			var _this3 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var _accountID = parseInt(_this3.accountId);
				if (isNaN(_accountID) || _accountID < 1) return reject('main/data_not_found');

				var _url = _this3.APIServerUrl + '/admin/index';
				var _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				};

				_this3.$store.commit('accountGlobalFilter', false);

				_this3.$http.get(_url, { 'params': _params }).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;
					if (_dt && _dt['status'] === 'ok') {
						_this3.$store.commit('accountGlobalFilter', true);

						_this3.$store.dispatch('getTicketCounters');
						_this3.$store.dispatch('getRequestCounter');

						return resolve();
					}

					reject('error/api_incorrect');
				}, function (resGet) {
					reject('error/api_incorrect');
				});
			});
		},
		errorHandler: function errorHandler() {
			this.$router.push('/404');
		}
	}
});

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'oldRoutes',
	created: function created() {
		if (this.$route && this.$route.params && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.$route.params) === 'object' && 'vdsGroupId' in this.$route.params) {
			this.getVdsGroups(String(this.$route.params.vdsGroupId));
		}
	},

	methods: {
		getVdsGroups: function getVdsGroups(groupId) {
			var _this = this;

			this.$store.commit('setFilteredGroupId', null);

			var _url = this.APIServerUrl + '/service/list?search=group&type=vds';

			this.$http.get(_url).then(function (resGet) {
				if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body'] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resGet['body']) === 'object' && resGet['body']['status'] === 'ok' && resGet['body']['result'] && resGet['body']['result'].length) {
					var groups = resGet['body']['result'];
					var found = false;
					groups.some(function (item) {
						if (String(item.id) === groupId) {
							found = true;
							return true;
						}
					});

					if (found) {
						_this.$store.commit('setFilteredGroupId', groupId);
						_this.$router.replace('/vds/list');
						return;
					}
				}

				throw new Error();
			}).catch(function () {
				_this.$router.replace('/vds/list');
			});
		}
	}
});

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_crud_View__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_crud_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_crud_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_view__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_view__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'operationView',
	data: function data() {
		return {
			id: null,

			localErrorMessage: '',

			sortDATA: {},

			Keys: false,

			viewData: {},

			timerRefresh: null,
			timerCounter: 0
		};
	},
	created: function created() {
		this.timerRefresh = null;
		this.timerCounter = 0;

		this.initData(this.$route.path);

		this.requestViewData();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.timerRefresh) {
			clearTimeout(this.timerRefresh);
			this.timerCounter = 0;
		}
	},

	watch: {
		'$route': function $route(to, from) {
			this.initData(to.path);

			this.requestViewData();
		}
	},

	methods: {
		canShow: function canShow(fieldName) {
			return ['operation_status', 'operation_summa', 'payment', 'operation_created', 'operation_updated'].indexOf(fieldName) > -1;
		},
		initData: function initData(path) {
			this.id = null;
			this.sortDATA = {};
			this.Keys = false;
			this.localErrorMessage = '';

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length !== 3 || !_urlParts[0] || !_urlParts[0].length || _urlParts[0] !== 'operation' || !_urlParts[1] || !_urlParts[1].length || _urlParts[1] !== 'view' || !_urlParts[2] || !_urlParts[2].length) {
				this.localErrorMessage = this.localeFtc('main/unknown_page');
				return;
			}

			this.id = _urlParts[2];
		},
		requestViewData: function requestViewData(isSilence) {
			var _this = this;

			if (this.timerRefresh) clearTimeout(this.timerRefresh);

			if (isSilence === true) this.$store.commit('needShowLoader', false);

			var _url = '/operation/view/' + this.id;

			this.forms_Get(_url, false, function (data) {
				_this.$store.commit('needShowLoader', true);

				if (!data || data['status'] !== 'ok' || !data['operation']) {
					_this.form_ErrorMessage = _this.localeFtc('error/api_incorrect');
				} else {
					_this.sortDATA = _this._order();

					_this.Keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.sortDATA).sort(function (a, b) {
						return a - b;
					});

					_this.viewData = _this.form_GetData;

					if (!_this.$store.state.is_auth && _this.$route.path.indexOf('/operation/view/') === 0 && /^[a-z0-9]+$/.test(_this.id) && _this.id.length > 12) {
						var _status = -1;
						if (_this.viewData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.viewData) === 'object' && 'operation' in _this.viewData && _this.viewData['operation'] && 'operation_status' in _this.viewData['operation'] && _this.viewData['operation']['operation_status'] && 'value' in _this.viewData['operation']['operation_status']) _status = _this.viewData['operation']['operation_status']['value'];

						if (_status <= 0) _this.timerRefresh = setTimeout(_this.timerFunction, 10000);
					}
				}
			}, function () {
				return _this.$store.commit('needShowLoader', true);
			});
		},
		timerFunction: function timerFunction() {
			this.timerCounter++;

			if (this.timerCounter >= 18) return;

			this.requestViewData(true);
		},
		_order: function _order() {
			var obj = void 0;
			var __obj = void 0;
			var ____obj = void 0;
			var tmp = void 0;
			var order = void 0;
			var isLink = 0;
			var nm = '';
			var sortDATA = {};

			for (var idx in this.form_GetData) {
				if (this.form_GetData.hasOwnProperty(idx)) {
					if (idx === 'logs') continue;

					obj = this.form_GetData[idx];

					if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
						if ('order' in obj && obj['type'] !== 'hidden' && this.canShow(idx)) {
							tmp = parseInt(obj['order']);
							order = isNaN(tmp) ? 0 : tmp;

							if (!sortDATA[order]) {
								sortDATA[order] = [];
								sortDATA[order].push(idx);
							} else sortDATA[order].push(idx);
						} else {
								isLink = 0;
								nm = '';

								for (var i in obj) {
									if (obj.hasOwnProperty(i)) if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i)) {
										nm = i.match(/(.*?)_name$/);
										if (nm === null) {
											nm = i.match(/(.*?)_id$/);
											if (nm === null) {
												nm = i.match(/(.*?)_login$/);
												if (nm == null) {
													if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле');
												} else nm = nm[1];
											} else nm = nm[1];
										} else nm = nm[1];

										isLink++;
									}
								}
								if (isLink === 2 && idx !== this.realCrudName) isLink = true;else isLink = false;

								if (isLink) {
									tmp = parseInt(obj[nm + '_id']['order']);
									order = isNaN(tmp) ? 0 : tmp;

									if (!sortDATA[order]) {
										sortDATA[order] = [];
										sortDATA[order].push(idx);
									} else sortDATA[order].push(idx);
								} else {
										for (var _i in obj) {
											if (obj.hasOwnProperty(_i)) {
												if (!this.canShow(_i)) continue;

												__obj = obj[_i];

												if (__obj && (typeof __obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(__obj)) === 'object' && 'order' in __obj && 'title' in __obj && 'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined && 'type' in __obj && __obj['type'] !== 'hidden') {
													tmp = parseInt(__obj['order']);
													order = isNaN(tmp) ? 0 : tmp;

													if (!sortDATA[order]) {
														sortDATA[order] = [];
														sortDATA[order].push(_i);
													} else sortDATA[order].push(_i);
												} else {
													if (idx === 'role' && _i === 'permissions') sortDATA[9999] = [_i];else if (idx === 'service' && _i === 'service_data') {
															tmp = parseInt(__obj['order']);
															order = isNaN(tmp) ? 0 : tmp;

															if (!sortDATA[order]) {
																sortDATA[order] = [];
																sortDATA[order].push(_i);
															} else sortDATA[order].push(_i);
														} else {
																for (var w in __obj) {
																	if (__obj.hasOwnProperty(w)) {
																		____obj = __obj[w];

																		if (____obj && (typeof ____obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(____obj)) === 'object' && 'order' in ____obj && 'title' in ____obj && 'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined && 'type' in ____obj && ____obj['type'] !== 'hidden') {
																			tmp = parseInt(____obj['order']);
																			order = isNaN(tmp) ? 0 : tmp;

																			if (!sortDATA[order]) {
																				sortDATA[order] = [];
																				sortDATA[order].push(w);
																			} else sortDATA[order].push(w);
																		}
																	}
																}
															}
												}
											}
										}
									}
							}
					}
				}
			}
			return sortDATA;
		}
	},

	components: {
		crudView: __WEBPACK_IMPORTED_MODULE_2__components_crud_View___default.a,
		viewComponent: __WEBPACK_IMPORTED_MODULE_3__components_elements_view___default.a
	}

});

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$store.state.is_auth && _vm.$route.path.indexOf('/operation/view/') === 0) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData.title)))]), _vm._v(" "), _vm._l((_vm.Keys), function(row) {
    return (_vm.Keys.length) ? _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.sortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.sortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": "operation",
          "realCrudName": "operation",
          "firstElement": _vm.sortDATA && _vm.sortDATA['1'] && _vm.sortDATA['1'][0] ? _vm.sortDATA['1'][0] : null
        }
      })
    }), 1) : _vm._e()
  })], 2) : _c('crudView')
},staticRenderFns: []}

/***/ }),
/* 740 */,
/* 741 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 742 */,
/* 743 */,
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var localePlugin = {
	install: function install(Vue, options) {
		Vue.localeBase = {
			'error/under_construction_title': 'ТЕХНИЧЕСКИЕ РАБОТЫ',
			'error/under_construction': 'В данный момент мы работаем над тем, чтобы наше приложение стало лучше!<br>Осталось совсем немножко...',
			'error/html5': 'Ваш браузер не поддерживает работу с <b>HTML5</b>.<br>Пожалуйста, обновите браузер.<br>Дальнейшая работа приложения невозможна...',
			'error/app_internal': 'Произошла внутренняя ошибка панели.<br>Пожалуйста, обратитесь в техническую поддержку.',
			'error/request_terminated': 'Во время загрузки страницы соединение было прервано.<br>Обновите страницу.',
			'main/loading': 'Идет загрузка данных...',
			'main/refresh_screen': 'Внимание!',
			'main/user_idle_state_text': 'Вы не работали с панелью управления продолжительное время. Чтобы продолжить работу, необходимо обновить данную страницу. Вся ваша работа сохранена и будет доступна после обновления.',
			'main/update': 'Обновить',
			'main/enter': 'Войти',
			'login/forgot': 'Забыли пароль?',
			'login/logout': 'Выйти',
			'main/interface_new_version': 'Доступна новая версия панели. Пожалуйста, {link}обновите вкладку{/link}.',
			'login/blacklisted': 'Ваш IP-адрес находится в чёрном списке!<br>Попробуйте повторить запрос через некоторое время.',
			'login/already_registered': 'Уже зарегистрированы?',
			'login/password_reminder': 'Напоминание пароля',
			'login/remind': 'Напомнить',
			'login/remembered': 'Вспомнили?',
			'login/return_to_main_page1': 'Вернуться на',
			'login/return_to_main_page2': 'главную страницу',
			'main/unsubscribe': 'Отказ от подписки'
		};

		Vue.setLocaleBase = function (locale) {
			var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';

			if (locale && (typeof locale === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(locale)) === 'object') Vue.localeBase = locale;

			if (lang === 'ru') {
				if (!Vue.localeBase['main/vds_clone_note']) Vue.localeBase['main/vds_clone_note'] = 'Внимание: для клонирования будет создана резервная копия!';
				if (!Vue.localeBase['main/vds_clone_warning']) Vue.localeBase['main/vds_clone_warning'] = 'Внимание: не закрывайте окно браузера пока операция не завершится!';
				if (!Vue.localeBase['main/vds_clone_field_boolean_title']) Vue.localeBase['main/vds_clone_field_boolean_title'] = 'Оставить резервную копию после клонирования?';
				if (!Vue.localeBase['main/vds_clone_process_started']) Vue.localeBase['main/vds_clone_process_started'] = 'Процесс клонирования успешно стартован!';
				if (!Vue.localeBase['main/vds_clone_process_terminate']) Vue.localeBase['main/vds_clone_process_terminate'] = 'Завершить процесс';
				if (!Vue.localeBase['main/vds_clone_process_warning']) Vue.localeBase['main/vds_clone_process_warning'] = 'Внимание: проверьте созданные резервные копии!';
				if (!Vue.localeBase['main/vds_clone_no_active_datacenters']) Vue.localeBase['main/vds_clone_no_active_datacenters'] = 'Отсутствуют свободные дата-центры для клонирования данного сервера!';

				if (!Vue.localeBase['service/extdisk_deleting_begin_process']) Vue.localeBase['service/extdisk_deleting_begin_process'] = 'Процесс удаления внешнего диска запущен';
				if (!Vue.localeBase['service/extdisk_inserting_confirm']) Vue.localeBase['service/extdisk_inserting_confirm'] = 'Подключить внешний диск к текущему серверу?';
				if (!Vue.localeBase['main/show']) Vue.localeBase['main/show'] = 'Показать';
				if (!Vue.localeBase['main/hide']) Vue.localeBase['main/hide'] = 'Скрыть';
				if (!Vue.localeBase['main/postpone']) Vue.localeBase['main/postpone'] = 'Отложить';
				if (!Vue.localeBase['main/not_chosen']) Vue.localeBase['main/not_chosen'] = 'Не выбрано';
				if (!Vue.localeBase['service/service_iso_same_error']) Vue.localeBase['service/service_iso_same_error'] = 'ISO-образы должны быть разными!';
				if (!Vue.localeBase['ticket/postpone_confirm']) Vue.localeBase['ticket/postpone_confirm'] = 'Вы уверены, что желаете отложить тикет <b>{ticket_code}</b>?';
				if (!Vue.localeBase['service/limit_is_exceeded']) Vue.localeBase['service/limit_is_exceeded'] = 'Достигнут лимит по услуге <b>{service}</b>';
				if (!Vue.localeBase['partner/additional_info_notice']) Vue.localeBase['partner/additional_info_notice'] = 'Клиенты с активными услугами (клиенты с пополнениями за последние 365 дней)';
				if (!Vue.localeBase['main/text_report']) Vue.localeBase['main/text_report'] = 'Текстовый отчёт';
				if (!Vue.localeBase['main/export']) Vue.localeBase['main/export'] = 'Экспорт';
				if (!Vue.localeBase['operation/payment_info']) Vue.localeBase['operation/payment_info'] = '<b>Проверьте, пожалуйста, данные по платежу:</b><br><br>Способ оплаты{saved}:<br><b>{name}</b><br><br>Комиссия:<br><b>{com}%</b><br><br>Сумма к списанию:<br><b>{sum} {val}</b>';
				if (!Vue.localeBase['operation/payment_warning']) Vue.localeBase['operation/payment_warning'] = '<p><b>Внимание!</b> Платёжные системы могут взимать дополнительную комиссию за проведение платежа!</p>';
				if (!Vue.localeBase['service/extdisk_clone_confirm']) Vue.localeBase['service/extdisk_clone_confirm'] = 'Вы уверены, что желаете клонировать <b>{name}</b><br>Стоимость составит <b>{price} за {size}</b>?';
				if (!Vue.localeBase['service/extdisk_restore_warning']) Vue.localeBase['service/extdisk_restore_warning'] = '<b>Внимание!</b> Все данные с внешнего диска будут удалены и заменены данными из этой копии!';
				if (!Vue.localeBase['service/backup_outer_disk_error']) Vue.localeBase['service/backup_outer_disk_error'] = 'Выбранная резервная копия не может быть восстановлена на этом диске!';
				if (!Vue.localeBase['main/traffic_b']) Vue.localeBase['main/traffic_b'] = 'б';
				if (!Vue.localeBase['main/traffic_kb']) Vue.localeBase['main/traffic_kb'] = 'КБ';
				if (!Vue.localeBase['main/traffic_mb']) Vue.localeBase['main/traffic_mb'] = 'МБ';
				if (!Vue.localeBase['main/traffic_gb']) Vue.localeBase['main/traffic_gb'] = 'ГБ';
				if (!Vue.localeBase['main/traffic_tb']) Vue.localeBase['main/traffic_tb'] = 'ТБ';
				if (!Vue.localeBase['main/traffic_pb']) Vue.localeBase['main/traffic_pb'] = 'ПБ';
				if (!Vue.localeBase['main/traffic_eb']) Vue.localeBase['main/traffic_eb'] = 'ЕБ';
				if (!Vue.localeBase['payment/saved_title']) Vue.localeBase['payment/saved_title'] = 'сохранённый';
				if (!Vue.localeBase['payment/usual_title']) Vue.localeBase['payment/usual_title'] = 'обычный';
				if (!Vue.localeBase['main/yes']) Vue.localeBase['main/yes'] = 'Да';
				if (!Vue.localeBase['main/no']) Vue.localeBase['main/no'] = 'Нет';
				if (!Vue.localeBase['main/in']) Vue.localeBase['main/in'] = 'в';
				if (!Vue.localeBase['account/limit_not_greater']) Vue.localeBase['account/limit_not_greater'] = 'не более';
				if (!Vue.localeBase['account/limit_in_service']) Vue.localeBase['account/limit_in_service'] = 'в одной услуге';
				if (!Vue.localeBase['main/sht']) Vue.localeBase['main/sht'] = 'шт';
				if (!Vue.localeBase['main/month']) Vue.localeBase['main/month'] = 'месяц';
				if (!Vue.localeBase['main/record']) Vue.localeBase['main/record'] = 'Запись';
				if (!Vue.localeBase['passport/series']) Vue.localeBase['passport/series'] = 'Серия';
				if (!Vue.localeBase['passport/number']) Vue.localeBase['passport/number'] = 'Номер';
				if (!Vue.localeBase['passport/who']) Vue.localeBase['passport/who'] = 'Кем выдан паспорт';
				if (!Vue.localeBase['passport/when']) Vue.localeBase['passport/when'] = 'Дата выдачи';
				if (!Vue.localeBase['mail/postcode']) Vue.localeBase['mail/postcode'] = 'Индекс';
				if (!Vue.localeBase['mail/address']) Vue.localeBase['mail/address'] = 'Адрес';
				if (!Vue.localeBase['main/attention']) Vue.localeBase['main/attention'] = 'Внимание';
				if (!Vue.localeBase['field/hint_backup_auto']) Vue.localeBase['field/hint_backup_auto'] = 'Создание еженедельной резервной копии. Изменить настройки расписания и количество создаваемых копий можно в [URL]настройках услуги.[/URL]';
				if (!Vue.localeBase['field/hint_ssh_key_before']) Vue.localeBase['field/hint_ssh_key_before'] = '[URL]Аутентификация с помощью SSH-ключей и отключение доступа по паролю.[/URL]';
				if (!Vue.localeBase['field/hint_ssh_key_before_client']) Vue.localeBase['field/hint_ssh_key_before_client'] = 'Аутентификация с помощью SSH-ключей и отключение доступа по паролю.';
				if (!Vue.localeBase['field/hint_ssh_key_after']) Vue.localeBase['field/hint_ssh_key_after'] = 'Пароль суперпользователя ОС отправляется на email.';
				if (!Vue.localeBase['field/hint_ns_servers']) Vue.localeBase['field/hint_ns_servers'] = 'Какие NS-серверы использовать?';
				if (!Vue.localeBase['backup/hint_how_to_make']) Vue.localeBase['backup/hint_how_to_make'] = 'Как сделать резервную копию сервера?';
				if (!Vue.localeBase['iso/hint_how_to_use']) Vue.localeBase['iso/hint_how_to_use'] = 'Как использовать свой образ ISO на сервере?';
				if (!Vue.localeBase['qa/any_questions']) Vue.localeBase['qa/any_questions'] = 'Есть вопросы?';
				if (!Vue.localeBase['qa/popular_topics']) Vue.localeBase['qa/popular_topics'] = 'Популярные темы';
				if (!Vue.localeBase['calc/and_more']) Vue.localeBase['calc/and_more'] = 'и ещё';
				if (!Vue.localeBase['main/table_rendering']) Vue.localeBase['main/table_rendering'] = 'Формирование списка...';
				if (!Vue.localeBase['s/gpu_memory']) Vue.localeBase['s/gpu_memory'] = 'память GPU';
				if (!Vue.localeBase['plan/choose_plan']) Vue.localeBase['plan/choose_plan'] = 'Выберите тарифный план';
				if (!Vue.localeBase['plan/confirm_change_without_cost']) Vue.localeBase['plan/confirm_change_without_cost'] = 'Продолжить?<br><br>\n\n<b>Внимание!</b> Сервер будет перезагружен';

				if (!Vue.localeBase['error/under_construction']) Vue.localeBase['error/under_construction'] = 'В данный момент мы работаем над тем, чтобы наше приложение стало лучше!<br>Осталось совсем немножко...';
				if (!Vue.localeBase['error/html5']) Vue.localeBase['error/html5'] = 'Ваш браузер не поддерживает работу с <b>HTML5</b>, либо эта возможность заблокирована.<br>Пожалуйста, проверьте свой браузер.<br>Дальнейшая работа приложения невозможна!<br><br>Обратите внимание, что для корректной работы панели требуется возможность работы с файлами cookie, localStorage/sessionStorage и другими функциями HTML5.';
				if (!Vue.localeBase['error/cookie']) Vue.localeBase['error/cookie'] = 'Ваш браузер не поддерживает работу с <b>файлами cookie</b>, либо эта возможность заблокирована.<br>Пожалуйста, проверьте свой браузер.<br>Дальнейшая работа приложения невозможна!<br><br>Обратите внимание, что для корректной работы панели требуется возможность работы с файлами cookie, localStorage/sessionStorage и другими функциями HTML5.';
				if (!Vue.localeBase['error/request_terminated']) Vue.localeBase['error/request_terminated'] = 'Во время загрузки страницы соединение было прервано.<br>Обновите страницу.';
				if (!Vue.localeBase['login/blacklisted']) Vue.localeBase['login/blacklisted'] = 'Ваш IP-адрес находится в чёрном списке!<br>Попробуйте повторить запрос через некоторое время.';
				if (!Vue.localeBase['main/enter']) Vue.localeBase['main/enter'] = 'Войти';
				if (!Vue.localeBase['login/forgot']) Vue.localeBase['login/forgot'] = 'Забыли пароль?';
				if (!Vue.localeBase['login/logout']) Vue.localeBase['login/logout'] = 'Выйти';
				if (!Vue.localeBase['login/already_registered']) Vue.localeBase['login/already_registered'] = 'Уже зарегистрированы?';
				if (!Vue.localeBase['login/password_reminder']) Vue.localeBase['login/password_reminder'] = 'Напоминание пароля';
				if (!Vue.localeBase['login/remind']) Vue.localeBase['login/remind'] = 'Напомнить';
				if (!Vue.localeBase['login/remembered']) Vue.localeBase['login/remembered'] = 'Вспомнили?';
				if (!Vue.localeBase['login/return_to_main_page1']) Vue.localeBase['login/return_to_main_page1'] = 'Вернуться на';
				if (!Vue.localeBase['login/return_to_main_page2']) Vue.localeBase['login/return_to_main_page2'] = 'главную страницу';
				if (!Vue.localeBase['main/unsubscribe']) Vue.localeBase['main/unsubscribe'] = 'Отказ от подписки';
			}

			if (lang === 'en') {
				if (!Vue.localeBase['main/vds_clone_note']) Vue.localeBase['main/vds_clone_note'] = 'Attention: a backup copy will be created for cloning!';
				if (!Vue.localeBase['main/vds_clone_warning']) Vue.localeBase['main/vds_clone_warning'] = 'Attention: do not close the browser window until the operation is completed!';
				if (!Vue.localeBase['main/vds_clone_field_boolean_title']) Vue.localeBase['main/vds_clone_field_boolean_title'] = 'Leave a backup after cloning?';
				if (!Vue.localeBase['main/vds_clone_process_started']) Vue.localeBase['main/vds_clone_process_started'] = 'The cloning process has started successfully!';
				if (!Vue.localeBase['main/vds_clone_process_terminate']) Vue.localeBase['main/vds_clone_process_terminate'] = 'End the process';
				if (!Vue.localeBase['main/vds_clone_process_warning']) Vue.localeBase['main/vds_clone_process_warning'] = 'Attention: check your backups!';
				if (!Vue.localeBase['main/vds_clone_no_active_datacenters']) Vue.localeBase['main/vds_clone_no_active_datacenters'] = 'There are no free data centers for cloning this server!';

				if (!Vue.localeBase['service/extdisk_deleting_begin_process']) Vue.localeBase['service/extdisk_deleting_begin_process'] = 'The external disk removal process has started';
				if (!Vue.localeBase['service/extdisk_inserting_confirm']) Vue.localeBase['service/extdisk_inserting_confirm'] = 'Connect an external disk to the current server?';
				if (!Vue.localeBase['main/show']) Vue.localeBase['main/show'] = 'Show';
				if (!Vue.localeBase['main/hide']) Vue.localeBase['main/hide'] = 'Hide';
				if (!Vue.localeBase['main/postpone']) Vue.localeBase['main/postpone'] = 'Postpone';
				if (!Vue.localeBase['main/not_chosen']) Vue.localeBase['main/not_chosen'] = 'Not chosen';
				if (!Vue.localeBase['service/service_iso_same_error']) Vue.localeBase['service/service_iso_same_error'] = 'ISO images must be different!';
				if (!Vue.localeBase['ticket/postpone_confirm']) Vue.localeBase['ticket/postpone_confirm'] = 'Are you sure you want to postpone ticket <b>{ticket_code}</b>?';
				if (!Vue.localeBase['service/limit_is_exceeded']) Vue.localeBase['service/limit_is_exceeded'] = '<b>{service}</b> service limit reached';
				if (!Vue.localeBase['partner/additional_info_notice']) Vue.localeBase['partner/additional_info_notice'] = 'Clients with active services (customers with top-ups in the last 365 days)';
				if (!Vue.localeBase['main/text_report']) Vue.localeBase['main/text_report'] = 'Text report';
				if (!Vue.localeBase['main/export']) Vue.localeBase['main/export'] = 'Export';
				if (!Vue.localeBase['operation/payment_info']) Vue.localeBase['operation/payment_info'] = '<b>Please check your payment details:</b><br><br>Payment method{saved}:<br><b>{name}</b><br><br>Commission:<br><b>{com}%</b><br><br>Amount to be written off:<br><b>{sum} {val}</b>';
				if (!Vue.localeBase['operation/payment_warning']) Vue.localeBase['operation/payment_warning'] = '<p><b>Attention!</b> Payment systems may charge an additional commission for making a payment!</p>';
				if (!Vue.localeBase['service/extdisk_clone_confirm']) Vue.localeBase['service/extdisk_clone_confirm'] = 'Are you sure you want to clone <b>{name}</b><br>The cost will be <b>{price} per {size}</b>?';
				if (!Vue.localeBase['service/extdisk_restore_warning']) Vue.localeBase['service/extdisk_restore_warning'] = '<b>Attention!</b> All data from the external disk will be deleted and replaced with data from this copy!';
				if (!Vue.localeBase['service/backup_outer_disk_error']) Vue.localeBase['service/backup_outer_disk_error'] = 'The selected backup cannot be restored to this disk!';
				if (!Vue.localeBase['main/traffic_b']) Vue.localeBase['main/traffic_b'] = 'b';
				if (!Vue.localeBase['main/traffic_kb']) Vue.localeBase['main/traffic_kb'] = 'Kb';
				if (!Vue.localeBase['main/traffic_mb']) Vue.localeBase['main/traffic_mb'] = 'Mb';
				if (!Vue.localeBase['main/traffic_gb']) Vue.localeBase['main/traffic_gb'] = 'Gb';
				if (!Vue.localeBase['main/traffic_tb']) Vue.localeBase['main/traffic_tb'] = 'Tb';
				if (!Vue.localeBase['main/traffic_pb']) Vue.localeBase['main/traffic_pb'] = 'Pb';
				if (!Vue.localeBase['main/traffic_eb']) Vue.localeBase['main/traffic_eb'] = 'Eb';
				if (!Vue.localeBase['payment/saved_title']) Vue.localeBase['payment/saved_title'] = 'saved';
				if (!Vue.localeBase['payment/usual_title']) Vue.localeBase['payment/usual_title'] = 'usual';
				if (!Vue.localeBase['main/yes']) Vue.localeBase['main/yes'] = 'Yes';
				if (!Vue.localeBase['main/no']) Vue.localeBase['main/no'] = 'No';
				if (!Vue.localeBase['main/in']) Vue.localeBase['main/in'] = 'in';
				if (!Vue.localeBase['account/limit_not_greater']) Vue.localeBase['account/limit_not_greater'] = 'not greater than';
				if (!Vue.localeBase['account/limit_in_service']) Vue.localeBase['account/limit_in_service'] = 'in one service';
				if (!Vue.localeBase['main/sht']) Vue.localeBase['main/sht'] = 'pcs';
				if (!Vue.localeBase['main/month']) Vue.localeBase['main/month'] = 'month';
				if (!Vue.localeBase['main/record']) Vue.localeBase['main/record'] = 'Record';
				if (!Vue.localeBase['passport/series']) Vue.localeBase['passport/series'] = 'Series';
				if (!Vue.localeBase['passport/number']) Vue.localeBase['passport/number'] = 'Passport ID';
				if (!Vue.localeBase['passport/who']) Vue.localeBase['passport/who'] = 'Passport issued by';
				if (!Vue.localeBase['passport/when']) Vue.localeBase['passport/when'] = 'Date of issue';
				if (!Vue.localeBase['mail/postcode']) Vue.localeBase['mail/postcode'] = 'Zip code';
				if (!Vue.localeBase['mail/address']) Vue.localeBase['mail/address'] = 'Address';
				if (!Vue.localeBase['main/attention']) Vue.localeBase['main/attention'] = 'Attention';
				if (!Vue.localeBase['field/hint_backup_auto']) Vue.localeBase['field/hint_backup_auto'] = 'Create a weekly backup. You can change the schedule settings and the number of copies created in [URL]service settings.[/URL]';
				if (!Vue.localeBase['field/hint_ssh_key_before']) Vue.localeBase['field/hint_ssh_key_before'] = '[URL]Authentication using SSH keys and disabling password access.[/URL]';
				if (!Vue.localeBase['field/hint_ssh_key_before_client']) Vue.localeBase['field/hint_ssh_key_before_client'] = 'Authentication using SSH keys and disabling password access.';
				if (!Vue.localeBase['field/hint_ssh_key_after']) Vue.localeBase['field/hint_ssh_key_after'] = 'The OS superuser password will be sent by email.';
				if (!Vue.localeBase['field/hint_ns_servers']) Vue.localeBase['field/hint_ns_servers'] = 'Which NS servers should I use?';
				if (!Vue.localeBase['backup/hint_how_to_make']) Vue.localeBase['backup/hint_how_to_make'] = 'How to make a server backup?';
				if (!Vue.localeBase['iso/hint_how_to_use']) Vue.localeBase['iso/hint_how_to_use'] = 'How to use your ISO image on the server?';
				if (!Vue.localeBase['qa/any_questions']) Vue.localeBase['qa/any_questions'] = 'Any questions?';
				if (!Vue.localeBase['qa/popular_topics']) Vue.localeBase['qa/popular_topics'] = 'Popular topics';
				if (!Vue.localeBase['calc/and_more']) Vue.localeBase['calc/and_more'] = 'and further';
				if (!Vue.localeBase['main/table_rendering']) Vue.localeBase['main/table_rendering'] = 'List Generation...';
				if (!Vue.localeBase['s/gpu_memory']) Vue.localeBase['s/gpu_memory'] = 'GPU memory';
				if (!Vue.localeBase['plan/choose_plan']) Vue.localeBase['plan/choose_plan'] = 'Choose a plan';
				if (!Vue.localeBase['plan/confirm_change_without_cost']) Vue.localeBase['plan/confirm_change_without_cost'] = 'Continue?<br><br>\n\n<b>Attention!</b> The server will be restarted';

				if (!Vue.localeBase['error/under_construction_title']) Vue.localeBase['error/under_construction_title'] = 'TECHNICAL WORKS';
				if (!Vue.localeBase['error/under_construction']) Vue.localeBase['error/under_construction'] = 'We are currently working to make our application better!<br>Just a little bit left...';
				if (!Vue.localeBase['error/html5']) Vue.localeBase['error/html5'] = 'Your browser does not support working with <b>HTML5</b>, or this feature is blocked.<br>Please check your browser.<br>Further operation of the application is impossible!<br><br>Please note that for correct operation The panel requires the ability to work with cookies, localStorage/sessionStorage and other HTML5 features.';
				if (!Vue.localeBase['error/cookie']) Vue.localeBase['error/cookie'] = 'Your browser does not support working with <b>cookies</b>, or this feature is blocked.<br>Please check your browser.<br>Further operation of the application is impossible!<br><br>Please note that for correct operation The panel requires the ability to work with cookies, localStorage/sessionStorage and other HTML5 features.';
				if (!Vue.localeBase['error/request_terminated']) Vue.localeBase['error/request_terminated'] = 'The connection was interrupted while the page was loading.<br>Refresh the page.';
				if (!Vue.localeBase['login/blacklisted']) Vue.localeBase['login/blacklisted'] = 'Your IP address is blacklisted!<br>Try the request again after a while.';
				if (!Vue.localeBase['main/enter']) Vue.localeBase['main/enter'] = 'Log in';
				if (!Vue.localeBase['login/forgot']) Vue.localeBase['login/forgot'] = 'Forgot the password?';
				if (!Vue.localeBase['login/logout']) Vue.localeBase['login/logout'] = 'Log out';
				if (!Vue.localeBase['login/already_registered']) Vue.localeBase['login/already_registered'] = 'Already registered?';
				if (!Vue.localeBase['login/password_reminder']) Vue.localeBase['login/password_reminder'] = 'Remind password';
				if (!Vue.localeBase['login/remind']) Vue.localeBase['login/remind'] = 'Remind';
				if (!Vue.localeBase['login/remembered']) Vue.localeBase['login/remembered'] = 'Remembered?';
				if (!Vue.localeBase['login/return_to_main_page1']) Vue.localeBase['login/return_to_main_page1'] = 'Return to';
				if (!Vue.localeBase['login/return_to_main_page2']) Vue.localeBase['login/return_to_main_page2'] = 'main page';
				if (!Vue.localeBase['main/unsubscribe']) Vue.localeBase['main/unsubscribe'] = 'Unsubscribe';
				if (!Vue.localeBase['main/interface_new_version']) Vue.localeBase['main/interface_new_version'] = 'A new version of the panel is available. Please {link}update the tab{/link}.';
			}
		};

		Vue.mixin({
			methods: {
				localeFtc: function localeFtc(str) {
					if (str === null || str === undefined || str === '') return '';

					return String(str).split(' ').map(function (s) {
						var m = s.match(/[a-z\-]+\/\w+/);

						if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s;

						m = s.match(/\w+\/\w+/);

						if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s;

						return s in Vue.localeBase && Vue.localeBase[s] ? Vue.localeBase[s] : s;
					}).join(' ');
				}
			}
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (localePlugin);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_errorAlert__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_errorAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_errorAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_link__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(96);














var formsPlugin = {
	install: function install(Vue, options) {
		Vue.stylePathToLogo = Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).LOGO_PATH;
		Vue.stylePathToLogoText = Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).LOGO_TEXT_PATH;
		Vue.stylePathToLoader = Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).LOADER_PATH;

		Vue.APIServerUrl = "https://api2.vdsina.ru";
		Vue.PushUrl = "https://push.vdsina.ru" + '/sub';
		Vue.AppServerUrl = "https://vdsina.ru";
		Vue.QAUrl = "https://vdsina.ru/qa";

		Vue.CookieDomain = Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).COOKIE_DOMAIN || '.vdsina.ru';

		Vue.AppName = Object({"NODE_ENV":"production","API_SERVER":"https://api2.vdsina.ru","PUSH_SERVER":"https://push.vdsina.ru","WEB_SERVER":"https://vdsina.ru","QA_SERVER":"https://vdsina.ru/qa","YA_METRIKA":"25376711","GOOGLE_GTAG":"UA-31804196-2"}).APP_NAME || 'vdsina';

		__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].SmallAmounts = false;
		if (Vue.AppName === 'vdsina.com' || Vue.AppName === 'macloud' && "production" === 'development') {
			__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].SmallAmounts = true;
		}

		__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('debugMode', "production" === 'development');

		Vue.CpServerUrl = window.location.protocol + '//' + window.location.host;

		Vue.AppVersion = '198';

		Vue.TypeBackupDialog_create = 'create-backup';

		Vue.Constants = {
			SERVICE_TYPE_VDS: 1,
			SERVICE_TYPE_VDS_IP4: 2,
			SERVICE_TYPE_VDS_IP6: 7,
			SERVICE_TYPE_VDS_RAM: 3,
			SERVICE_TYPE_VDS_SSD: 4,
			SERVICE_TYPE_VDS_CPU: 5,
			SERVICE_TYPE_VDS_TRAFF: 6,
			SERVICE_TYPE_VDS_LOAD: 8,
			SERVICE_TYPE_VDS_SNAPSHOT: 9,
			SERVICE_TYPE_ISO: 10,
			SERVICE_TYPE_SSL: 11,
			SERVICE_TYPE_DOMAIN: 12,
			SERVICE_TYPE_DOMAIN_PRIVACY: 13,
			SERVICE_TYPE_DNS: 14,
			SERVICE_TYPE_BACKUP_VDS: 15,
			SERVICE_TYPE_EXTDISK_HDD: 16,
			SERVICE_TYPE_EXTDISK_NVME: 17,
			SERVICE_TYPE_RESERVE_IP: 18,
			SERVICE_TYPE_GPU: 19,
			VALID_IMAGE_EXT: {
				'gif': true,
				'jpg': true,
				'jpeg': true,
				'png': true,
				'bmp': true
			},
			VDS_GROUP: {
				'vds': 1,
				'hi-cpu-vds': 12
			}
		};

		Vue.http.interceptors.push(function (request, next) {
			if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.applicationBlocked) return;

			request.credentials = true;

			__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('operateAjaxRequestsCounter', 1);

			if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.showLongLoader) {
				setTimeout(function () {
					if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.longRequest) return;

					if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.ajaxRequestsCounter > 0) __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('hideLongRequestLoader', true);
				}, 400);
			}

			next(function (response) {
				__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('operateAjaxRequestsCounter', -1);

				if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.ajaxRequestsCounter <= 0) {
					setTimeout(function () {
						__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('hideLongRequestLoader', false);
					}, 400);
				}

				if (response.status === 400) {
					__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('setReturnURL', window.location.pathname);

					__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('errorHttpCode', 400);

					__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/500');
				} else if (response.status === 401) {
						__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('dropAuth');

						__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('setReturnURL', window.location.pathname);

						__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('pushStop');

						__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/login');
					} else if (response.status === 403) {
							if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.is_auth) {
								if (response.data && response.data.content && String(response.data.content).indexOf('user_forbidden') > 0 || !__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].verifyPermissions(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.user_role, __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].currentRoute)) {
									return;
								}

								__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('errorHttpCode', response.status);

								__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/500');
							} else {
								__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('dropAuth');

								__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('pushStop');

								if (response.data && response.data.content === 'Blacklisted') {
									return;
								}

								__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/login');
							}
						} else if (response.status === 404) {
								__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('errorHttpCode', response.status);

								__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/404');
							} else if (response.status >= 400) {
									if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.is_auth) {
										if (response.status === 503) {
											__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('setReturnURL', window.location.pathname);

											__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('errorHttpCode', 503);

											__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/503');
										} else {}
									} else {
											if (response.status === 511 && response.data && response.data.content === 'Need 2FA Verify') return;

											__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('setReturnURL', window.location.pathname);

											__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('errorHttpCode', 503);

											__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/503');
										}
								} else if (response.status <= 0) {}
			});
		});

		Vue.mixin({
			data: function data() {
				return {
					AppName: Vue.AppName,

					form_ErrorMessage: false,
					form_Loading: false,
					form_GetData: false,
					form_PostData: false,

					sideMenuVisible: false,

					APIServerUrl: Vue.APIServerUrl,

					itIsOurAbort: false,

					CpServerUrl: Vue.CpServerUrl,

					maskModalFlag: false,

					stylePathToLogo: Vue.stylePathToLogo,
					stylePathToLogoText: Vue.stylePathToLogoText,
					stylePathToLoader: Vue.stylePathToLoader,

					form_ErrorCaptchaMessage: false
				};
			},

			components: {
				errorAlert: __WEBPACK_IMPORTED_MODULE_7__components_errorAlert___default.a,
				linkComponent: __WEBPACK_IMPORTED_MODULE_8__components_elements_link___default.a
			},

			methods: {
				softReloadApp: function softReloadApp() {
					location.reload();
				},
				getFormFromCache: function getFormFromCache(formUrl) {
					var _this = this;

					return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function () {
						var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
							var needRequest, cache, ttl, response, _dt;

							return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
								while (1) {
									switch (_context.prev = _context.next) {
										case 0:
											needRequest = false;
											cache = _this.$store.state.lastFormCache;

											if (!cache || !cache[formUrl] || !cache[formUrl]['data'] || !cache[formUrl]['ttl']) {
												needRequest = true;
											}

											if (!needRequest) {
												ttl = cache[formUrl]['ttl'];

												if (ttl < new Date().getTime()) {
													_this.$store.commit('clearFormCache', formUrl);

													needRequest = true;
												}
											}

											if (needRequest) {
												_context.next = 6;
												break;
											}

											return _context.abrupt('return', resolve(cache[formUrl]['data']));

										case 6:
											_context.prev = 6;
											_context.next = 9;
											return _this.$http.get(Vue.APIServerUrl + formUrl);

										case 9:
											response = _context.sent;
											_dt = response && response.body && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.body) === 'object' ? response.body : false;

											if (!(_dt && _dt['status'] === 'form' && _dt['fields'])) {
												_context.next = 14;
												break;
											}

											_this.$store.commit('saveFormCache', {
												formName: formUrl,
												data: _dt
											});

											return _context.abrupt('return', resolve(_dt));

										case 14:
											_context.next = 21;
											break;

										case 16:
											_context.prev = 16;
											_context.t0 = _context['catch'](6);

											if (!(_context.t0 && _context.t0.status === 403 && _context.t0.body && _context.t0.body.content === 'Blacklisted')) {
												_context.next = 20;
												break;
											}

											return _context.abrupt('return', resolve({ status: 'error', message: 'login/blacklisted' }));

										case 20:
											return _context.abrupt('return', resolve(_context.t0));

										case 21:
											resolve(null);

										case 22:
										case 'end':
											return _context.stop();
									}
								}
							}, _callee, _this, [[6, 16]]);
						}));

						return function (_x) {
							return _ref.apply(this, arguments);
						};
					}());
				},
				__realCrudName: function __realCrudName(crud) {
					if (crud === 'admin') return 'user';
					if (crud === 'partnerprogram') return 'program';
					if (crud === 'servicetype') return 'service_type';
					if (crud === 'planarchive') return 'plan';
					if (crud === 'additional-services' || crud === 'iso' || crud === 'certificate' || crud === 'domains' || crud === 'dns' || crud === 'backups' || crud === 'disks') return 'service';

					return crud;
				},
				addClass: function addClass(el, className) {
					if (!className) return;
					if (el && el.className && el.className.indexOf(className) === -1) {
						el.className += ' ' + className;
					}
				},
				removeClass: function removeClass(el, className) {
					if (!className) return;
					if (el && el.className && el.className.indexOf(className) !== -1) {
						el.className = el.className.replace(new RegExp('\\s*' + className + '\\s*', 'gi'), '');
					}
				},
				enterOnInput: function enterOnInput(e) {
					if (e && e.keyCode === 13) {
						this.$refs['button'].click();
					}
				},
				removeErrorBorder_OnFocus: function removeErrorBorder_OnFocus(e) {
					var _parent = e && e.target ? e.target.parentNode : null;
					if (_parent) this.removeClass(_parent, 'has-error');
				},
				hideModalMask: function hideModalMask() {
					var _masks = document.querySelectorAll('div.modal-mask');
					for (var i = 0; i < _masks.length; i++) {
						var _style = window.getComputedStyle(_masks[i]);
						if (_style.display !== 'none' && _style.visibility !== 'hidden') {
							_masks[i].style.display = 'none';
							return true;
						}
					}

					return false;
				},
				getWindowWidth: function getWindowWidth(event) {
					var windowWidth = document.documentElement.clientWidth;
					var windowHeight = document.documentElement.clientHeight;
					__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('setWindowSize', { 'width': windowWidth, 'height': windowHeight });

					if (windowWidth <= 767) this.sideMenuVisible = false;else this.sideMenuVisible = true;
				},
				getElementOffset: function getElementOffset(el) {
					var elementOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

					var rect = el.getBoundingClientRect();
					if (elementOnly) return { top: rect.top, left: rect.left };

					var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
					var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

					return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
				},
				getRealCrud: function getRealCrud(crud) {
					if (crud === 'vds' || crud === 'hi-cpu-vds' || crud === 'iso' || crud === 'additional-services' || crud === 'domains' || crud === 'backups' || crud === 'certificate' || crud === 'dns' || crud === 'disks') return 'service';
					if (crud === 'planarchive') return 'plan';
					if (crud === 'dns-records') return 'dns';

					return crud;
				},
				formatRequestError: function formatRequestError(res) {
					var _errMsg = 'error/http_error';

					if (res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' && 'fields' in res.data && res.data['fields'] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data['fields']) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.data['fields']).length && res.data.status !== 'form') {
						_errMsg = '';
						for (var prop in res.data['fields']) {
							if (res.data['fields'].hasOwnProperty(prop)) {
								var _field = res.data['fields'][prop];

								if (_field) {
									var _txt = '';
									if (Array.isArray(_field) && _field.length) _txt = _field[0];else if ((typeof _field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_field)) === 'object') _txt = 'error/unknown';else _txt = String(_field);

									if (_txt && _txt !== '') {
										if (_errMsg === '') _errMsg = _txt;else _errMsg += ' <br> ' + _txt;
									}
								}
							}
						}
						if (_errMsg !== '') return _errMsg;
					}

					if (res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' && 'title' in res.data && res.data['title'] && res.data['title'].length) _errMsg = 'main/error_desc ' + res.data['title'];

					if (res && res.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res.data) === 'object' && 'content' in res.data && res.data['content'] && res.data['content'].length) _errMsg = 'main/error_desc ' + res.data['content'];

					return _errMsg;
				},

				forms_verifyRequest: function forms_verifyRequest(url, params, callback, beforeFunc) {
					var _this2 = this;

					__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('needShowLoader', false);

					this.$http.get(url, {
						before: function before(reqGet) {
							if (beforeFunc && typeof beforeFunc === 'function') beforeFunc(reqGet);
						}
					}).then(function (response) {
						var _data = response.data;
						if (_data && _data['status'] === 'form' && _data['model'] && _data['_csrf']) {
							var _sendData = {};
							_sendData['_csrf'] = _data['_csrf'];
							_sendData['_validate'] = params['field'];
							_sendData[_data['model']] = {};
							_sendData[_data['model']][params['field']] = params['value'];
							if (params['data'] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params['data']).length) _sendData[_data['model']] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _sendData[_data['model']], params['data']);

							_this2.$http.post(url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_sendData), {
								before: function before(reqPost) {
									if (beforeFunc && typeof beforeFunc === 'function') beforeFunc(reqPost);
								}
							}).then(function (res) {
								__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('needShowLoader', true);

								var _data = res.data;
								if (_data && _data['status'] === 'error' && callback && typeof callback === 'function') callback(_data);
							}, function () {
								return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('needShowLoader', true);
							});
						}
					}, function () {
						return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('needShowLoader', true);
					});
				},

				forms_Get: function forms_Get(url, data, callbackSuccess, callbackFail) {
					var _this3 = this;

					this.form_Loading = true;
					this.form_ErrorMessage = false;

					this.form_GetData = false;
					this.form_PostData = false;

					this.$http.get(this.APIServerUrl + url, {
						'params': data,
						before: function before(request) {
							this.itIsOurAbort = false;

							if (data && data['dontAbort'] === true) {
								delete data['dontAbort'];
								return;
							}

							if (this.previousRequest) {
								this.itIsOurAbort = true;
								this.previousRequest.abort();
							}

							this.previousRequest = request;
						}
					}).then(function (response) {
						if (url.indexOf('/partner/list') === 0 && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.user_type === 'client') {
							var _listId = {};
							for (var l = 0; l < response.data.rows.length; l++) {
								response.data.rows[l]['status'] = true;
								_listId[response.data.rows[l].program_id] = true;
							}

							var _curPage = _this3.$route && _this3.$route.params && _this3.$route.params.page ? _this3.$route && _this3.$route.params && _this3.$route.params.page : 1;
							_curPage = parseInt(_curPage);
							if (isNaN(_curPage)) _curPage = 1;

							var _pageCount = 1;
							var _total = 0;
							var _size = 0;
							if (response && response.data && response.data.totalCount && response.data.pageSize) {
								_total = parseInt(response.data.totalCount);
								_size = parseInt(response.data.pageSize);
								if (!isNaN(_total) && !isNaN(_size) && _size > 0) _pageCount = Math.ceil(_total / _size);
							}

							if (_curPage === _pageCount) {
								_this3.$http.get(_this3.APIServerUrl + '/partner/create').then(function (response2) {
									if (response2 && response2.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response2.data) === 'object' && response2.data.fields && response2.data.status === 'form') {
										var programs = response2.data.fields.program_id.list;
										var accountId = parseInt(response2.data.fields.account_id.value);
										var _addCount = 0;

										for (var programId in programs) {
											if (programs.hasOwnProperty(programId)) {
												if (programId in _listId) continue;

												_addCount++;

												response.data.rows.push({
													program_id: parseInt(programId),
													program_name: programs[programId],
													p2a_code: '',
													p2a_id: 10000000 + _total + _addCount,
													account_id: accountId,
													status: false,
													can_delete: false
												});
											}
										}
										response.data.additionalTotalCount = _addCount;
									}

									_this3.form_Loading = false;

									_this3.form_GetData = response.data;

									if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data);
								});

								return;
							}
						}

						_this3.form_Loading = false;

						_this3.form_GetData = response.data;

						if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data);
					}, function (response) {
						if (_this3.itIsOurAbort && response.status === 0) return;

						var _errMsg = _this3.localeFtc('error/http_error');
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'title' in response.data && response.data['title'] && response.data['title'].length) _errMsg = _this3.localeFtc('main/error_desc') + ' ' + _this3.localeFtc(response.data['title']);
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'content' in response.data && response.data['content'] && response.data['content'].length) _errMsg = _this3.localeFtc('main/error_desc') + ' ' + _this3.localeFtc(response.data['content']);

						_this3.form_Loading = false;
						_this3.form_ErrorMessage = _errMsg;
						if (callbackFail && typeof callbackFail === 'function') callbackFail(response);
					});
				},

				forms_GetThenPost: function forms_GetThenPost(url, data, callbackSuccess, callbackFail) {
					var _this4 = this;

					this.form_Loading = true;
					this.form_ErrorMessage = false;

					this.form_GetData = false;
					this.form_PostData = false;

					this.$http.get(Vue.APIServerUrl + url).then(function (response) {
						_this4.form_GetData = response.data;

						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'status' in response.data && response.data['status'] === 'ok') {
							_this4.form_Loading = false;

							if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data);
							return;
						}

						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && '_csrf' in response.data && response.data._csrf) {
							var _sendData = {};

							if (data) {
								if ('model' in response.data && response.data.model) _sendData[response.data.model] = data;else _sendData = data;
							}

							_sendData['_csrf'] = response.data._csrf;

							_this4.$http.post(Vue.APIServerUrl + url, __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].toFormData(_sendData)).then(function (postData) {
								var _postData = postData && postData.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(postData.data) === 'object' ? postData.data : false;

								if (_postData && 'status' in _postData && _postData.status === 'ok') {
									_this4.form_PostData = _postData;

									_this4.form_Loading = false;

									if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(_postData);
									return;
								} else if (_postData && 'status' in _postData && _postData.status === 'error' && 'fields' in _postData && _postData.fields) {
										_this4.form_Loading = false;
										if (callbackFail && typeof callbackFail === 'function') callbackFail(_postData.fields);
										return;
									}

								var _errMsg = _this4.localeFtc('error/http_error');
								if (_postData && (typeof _postData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_postData)) === 'object' && 'title' in _postData && _postData['title'] && _postData['title'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(_postData['title']);
								if (_postData && (typeof _postData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_postData)) === 'object' && 'content' in _postData && _postData['content'] && _postData['content'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(_postData['content']);

								_this4.form_Loading = false;
								_this4.form_ErrorMessage = _errMsg;
								if (callbackFail && typeof callbackFail === 'function') callbackFail(postData);
							}, function (postData) {
								var _postData = postData && postData.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(postData.data) === 'object' ? postData.data : false;

								var _errMsg = _this4.localeFtc('error/http_error');
								if (_postData && (typeof _postData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_postData)) === 'object' && 'title' in _postData && _postData['title'] && _postData['title'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(_postData['title']);
								if (_postData && (typeof _postData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_postData)) === 'object' && 'content' in _postData && _postData['content'] && _postData['content'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(_postData['content']);

								_this4.form_Loading = false;
								_this4.form_ErrorMessage = _errMsg;
								if (callbackFail && typeof callbackFail === 'function') callbackFail(postData);
							});
							return;
						}

						var _errMsg = _this4.localeFtc('error/http_error');
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'title' in response.data && response.data['title'] && response.data['title'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(response.data['title']);
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'content' in response.data && response.data['content'] && response.data['content'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(response.data['content']);

						_this4.form_Loading = false;
						_this4.form_ErrorMessage = _errMsg;
						if (callbackFail && typeof callbackFail === 'function') callbackFail(response);
					}, function (response) {
						var _errMsg = _this4.localeFtc('error/http_error');
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'title' in response.data && response.data['title'] && response.data['title'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(response.data['title']);
						if (response.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(response.data) === 'object' && 'content' in response.data && response.data['content'] && response.data['content'].length) _errMsg = _this4.localeFtc('main/error_desc') + ' ' + _this4.localeFtc(response.data['content']);

						_this4.form_Loading = false;
						_this4.form_ErrorMessage = _errMsg;
						if (callbackFail && typeof callbackFail === 'function') callbackFail(response);
					});
				},

				onFormFieldChanged: function onFormFieldChanged(field, formData) {
					if (field && (typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(field)) === 'object') field['_errMsg'] = '';
					this.form_ErrorMessage = false;
				},
				onFormFocus: function onFormFocus(field, formData) {
					this.form_ErrorMessage = false;

					if (field && (typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(field)) === 'object') field['_errMsg'] = '';

					if (formData && formData.fields && Array.isArray(formData.fields) && formData.fields.length) {
						formData.fields.forEach(function (item) {
							if (item && Array.isArray(item) && item.length) {
								item.forEach(function (obj) {
									if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) === 'object' && obj['_field_name']) {
										obj['_errMsg'] = '';
									}
								});
							}
						});
					}
				},
				onFormBlur: function onFormBlur(field, formData) {
					this.form_ErrorMessage = false;
				},
				onFormEnterKeyDown: function onFormEnterKeyDown(e) {
					if (e) e.preventDefault();

					this.form_ErrorMessage = false;
					this.enterOnInput(e);
				},

				parseFormData: function parseFormData(data, oldData) {
					var formData = {};

					if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) !== 'object' || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).length) return formData;

					if (!('status' in data) || data['status'] !== 'form') return formData;

					if ('title' in data) formData['title'] = data['title'];else formData['title'] = false;

					if ('model' in data) formData['model'] = data['model'];else formData['model'] = false;

					if ('fields' in data && data['fields'] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data['fields']).length) formData['fields'] = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].sortByProp(data['fields'], 'order', false, data['model']);else formData['fields'] = false;

					if (oldData && (typeof oldData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldData)) === 'object' && 'fields' in oldData && oldData['fields']) {
						if (formData['fields'] && Array.isArray(formData['fields']) && formData['fields'].length) {
							formData['fields'].forEach(function (row) {
								if (row && Array.isArray(row) && row.length) {
									row.forEach(function (field) {
										if (field && (typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(field)) === 'object' && '_field_name' in field) {
											if (oldData['fields'] && Array.isArray(oldData['fields']) && oldData['fields'].length) {
												oldData['fields'].forEach(function (oldRow) {
													if (oldRow && Array.isArray(oldRow) && oldRow.length) {
														oldRow.forEach(function (oldField) {
															if (oldField && (typeof oldField === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldField)) === 'object' && '_field_name' in oldField && oldField['_field_name'] === field['_field_name']) {
																if ('value' in oldField) {
																	field['value'] = oldField['value'];
																}

																if ('_errMsg' in oldField) {
																	field['_errMsg'] = oldField['_errMsg'];
																}
															}
														});
													}
												});
											}
										}
									});
								}
							});
						}
					}

					if ('_csrf' in data && data['_csrf']) formData['_csrf'] = data['_csrf'];else formData['_csrf'] = false;

					return formData;
				},

				findFormField: function findFormField(name, fields) {
					if (!fields || !fields.length) return null;

					var _field = null;
					fields.some(function (item) {
						if (item && Array.isArray(item) && item.length) {
							item.some(function (obj) {
								if (obj && obj['_field_name'] === name) {
									_field = obj;
									return true;
								}
							});

							if (_field) return true;
						}
					});

					return _field;
				},
				localFormValidation: function localFormValidation(field) {
					if (!field['_visible']) return true;

					if (field['value'] === undefined || field['value'] === null) return true;

					if (field.type === 'integer' || field.type === 'int') {
						var v = String(field.value).trim();

						v = v.replace(/ /g, '');

						var r = parseInt(v);

						if (isNaN(r)) {
							field['_errMsg'] = 'validators/error_int';
							return false;
						}

						if (v === String(r)) return true;

						field['_errMsg'] = 'validators/error_int';
						return false;
					}

					if (field.type === 'float' || field.type === 'money') {
						var _v = String(field.value).trim();

						_v = _v.replace(/ /g, '');

						var _r = parseFloat(_v);

						if (isNaN(_r)) {
							field['_errMsg'] = 'validators/error_float';
							return false;
						}

						if (!__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].isNumeric(String(_r))) {
							field['_errMsg'] = 'validators/error_float';
							return false;
						}
					}

					if (field.type === 'email') {
						if (__WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

						field['_errMsg'] = 'validators/error_email';
						return false;
					}

					return true;
				},
				collectFormData: function collectFormData(rows, localValidationFunc, crud) {
					var data = {};

					for (var idx in rows) {
						if (!rows[idx] || !Array.isArray(rows[idx])) continue;

						var row = rows[idx];

						var _loop = function _loop(k) {
							var field = row[k];

							if (!field['_field_name']) return 'continue';

							if (field['_errMsg'] && field['_visible']) {
								return {
									v: false
								};
							}

							var _val = field['value'];

							if (field['type'] === 'file' || field['type'] === 'image') {
								if (field['_deleteFile'] === true) {
									data[field['_field_name'] + '_delete'] = 1;
								}

								if (field['multifile'] !== true) {
									if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null;
								}
							}

							if (Array.isArray(field['value'])) {
								if (!field['value'].length) _val = null;else {
									_val = [];

									field['value'].forEach(function (item) {
										if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(item)) === 'object' && item['id']) {
											_val.push(item['id']);
										} else _val.push(item);
									});
								}
							}

							if (field['required'] === true && field['_visible']) {
								if (_val === undefined || _val === null) {
									field['_errMsg'] = 'error/required_field';
									return {
										v: false
									};
								}

								if (Array.isArray(_val) && _val.length === 0) {
									field['_errMsg'] = 'error/required_field';
									return {
										v: false
									};
								}
							}

							if (!localValidationFunc(field)) {
								return {
									v: false
								};
							}

							if (_val === undefined || _val === null) {
								if (/^\w+\[\w+\]/i.test(field['_field_name'])) data[field['_field_name']] = '';

								return 'continue';
							}

							if (field['type'] === 'list' && String(_val) === '-1000') {
								return 'continue';
							}

							if (crud === 'disks') {
								if (field['_field_name'] === 'options' && !field['required'] && !_val) {
									return 'continue';
								}
								if (!field['_visible'] && !field['required']) {
									return 'continue';
								}
							}

							if (field['type'] === 'boolean') _val = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].normalizeBooleanValue(_val) ? 1 : 0;

							data[field['_field_name']] = _val;
						};

						for (var k in row) {
							var _ret = _loop(k);

							switch (_ret) {
								case 'continue':
									continue;

								default:
									if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
							}
						}
					}

					return data;
				},
				FormDataRePack: function FormDataRePack(data) {
					var k = void 0;
					var n1 = void 0;
					var n2 = void 0;
					var key1 = void 0;
					var key2 = void 0;

					for (k in data) {
						if (data.hasOwnProperty(k)) {
							n1 = k.indexOf('[');
							if (n1 < 0) continue;

							n2 = k.indexOf(']', n1);
							if (n2 < 0) continue;

							key1 = k.substr(0, n1);
							key2 = k.substring(n1 + 1, n2);

							if (n2 + 1 < k.length) key2 += k.substr(n2 + 1);

							if (!data[key1]) data[key1] = {};

							data[key1][key2] = data[k];

							delete data[k];

							data[key1] = this.FormDataRePack(data[key1]);
						}
					}return data;
				},

				isAccess: function isAccess(url) {
					if (!url) return false;
					if (url === '/404' || url === '/500' || url === '/503' || url === '/user/check' || url === '/email/check') return true;

					if (url === 'options' || url === '/options') return true;

					if (url.indexOf('/email/') === 0) return true;

					if (/vds\/\d+\/list/.test(url)) return true;

					if (url.indexOf('ticket/department') !== -1 && this.$store.state.user_type === 'admin') return true;

					var _access = false;

					var _parts = url.split('/');
					var _crud = '';
					var _action = '';
					var _param = '';

					if (url.charAt(0) === '/') {
						_crud = _parts[1];
						_action = _parts[2];
						_param = _parts[3] ? _parts[3] : '';
					} else {
							_crud = _parts[0];
							_action = _parts[1];
							_param = _parts[2] ? _parts[2] : '';
						}

					if (_crud === 'vds' && /^\d+$/.test(_action) && /^\w+$/.test(_param)) {
						var _temp = _action;
						_action = _param;
						_param = _temp;
					}

					if (_action.indexOf('?') > -1) _action = _action.substring(0, _action.indexOf('?'));

					if (this.$store.state.user_type === 'client') {
						if (_crud === 'ticketmessage') return false;

						if (_crud === 'ippool') return false;

						if (_crud === 'template') return false;

						if (_crud === 'plan') return false;
					}

					_crud = this.getRealCrud(_crud);

					if (_crud === 'user' && _action === 'alerts') return true;
					if (_crud === 'dashboard' && _action === 'info') {
						_crud = 'account';
						_action = 'view';
					}
					if (_crud === 'qa' && _action === 'list') {
						return true;
					}

					if (_crud === 'chart') {
						if (_param !== '') {
							if (this.$store.state.user_role && this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) && this.$store.state.user_role.permissions.indexOf(_crud + '/' + _param) !== -1) return true;
						} else {
							if (this.$store.state.user_role && this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) && this.$store.state.user_role.permissions.indexOf(_crud + '/list') !== -1) return true;
						}

						return false;
					}

					if (this.$store.state.user_role && this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) && this.$store.state.user_role.permissions.indexOf(_crud + '/' + _action) !== -1) _access = true;

					return _access;
				},

				getReferrer: function getReferrer() {
					this.Referrer = false;
					var r = document.referrer;
					if (r && r !== '') {
						r = new URL(r).hostname.split('.');
						if (r.length >= 2) this.Referrer = r[r.length - 2] + '.' + r[r.length - 1];else this.Referrer = r[0];
					}
				},
				isPublicUrl: function isPublicUrl(Url) {
					var urls = ['/login', '/register', '/forget', '/user/forget', '/user/check', '/email/check', '/unsubscribe*', '/503', '/operation/select/*', '/operation/pay/*', '/operation/view/*', '/operation/list'];

					return urls.some(function (item) {
						if (item.indexOf('*')) {
							var path = item.replace(/\*/g, '');
							if (Url.indexOf(path) === 0) return true;
						} else {
								if (item === Url) return true;
							}
					});
				},
				moneyOnlyNumbers: function moneyOnlyNumbers(value) {
					if (value === null || value === undefined) return '0';
					value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(value, 2);
					return __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].String2Money(value);
				}
			}

		});

		Vue.directive('click-outside', {
			bind: function bind(el, binding, vnode) {
				el.__eventClickOutSide__ = function (event) {
					if (!(el === event.target || el.contains(event.target))) {
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', el.__eventClickOutSide__);
			},
			unbind: function unbind(el) {
				document.body.removeEventListener('click', el.__eventClickOutSide__);
			}
		});

		Vue.directive('highlightFastSearch', {
			inserted: function inserted(el, binding) {
				var searchString = binding.value;
				if (searchString === null || searchString === undefined || searchString === '') return;

				var Text = el.innerHTML;
				var text = String(Text);

				var before = '<strong class="w5-selected-text">';
				var after = '</strong>';

				var findString = window.findStringEscape(searchString);

				el.innerHTML = text.replace(new RegExp(findString, 'ig'), function (str, offset, s) {
					var isNeedBorders = true;
					for (var i = offset + findString.length; i < s.length; i++) {
						if (s[i] === '>') {
							isNeedBorders = false;
							break;
						}
					}

					return isNeedBorders ? before + str + after : str;
				});
			}
		});

		Vue.directive('withSafeTags', {
			inserted: function inserted(el, binding) {
				var text = String(binding.value);
				var className = String(el.className);

				el.innerHTML = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].safe_tags_replace(text).replace(/&lt;b&gt;/ig, '<strong>').replace(/&lt;\/b&gt;/ig, '</strong>').replace(/&lt;p&gt;/ig, '<p>').replace(/&lt;\/p&gt;/ig, '</p>').replace(/&lt;w&gt;/ig, '<span style="color: red">').replace(/&lt;\/w&gt;/ig, '</span>').replace(/&lt;pswdr&gt;/ig, '<span id="instruction-password-value" style="font-size: 14px;' + (className.indexOf('instruction-password shown') > 0 ? '' : 'color: #ccc') + '">').replace(/&lt;\/pswdr&gt;/ig, '</span>' + __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].htmlInstructionPasswordButton(className)).replace(/&lt;i&gt;/ig, '<i>').replace(/&lt;\/i&gt;/ig, '</i>').replace(/&lt;u&gt;/ig, '<u>').replace(/&lt;\/u&gt;/ig, '</u>').replace(/&lt;ul&gt;/ig, '<ul>').replace(/&lt;\/ul&gt;/ig, '</ul>').replace(/&lt;li&gt;/ig, '<li>').replace(/&lt;\/li&gt;/ig, '</li>').replace(/&lt;a(.*)&gt;(.*)&lt;\/a&gt;/ig, function (str, p1, p2, offset, s) {
					return '<a ' + p1.replace(/&quot;/ig, '"').replace(/&#39;/ig, '\'') + '>' + p2 + '</a>';
				}).replace(/&lt;br&gt;/ig, '<br>').replace(/&lt;br\/&gt;/ig, '<br/>').replace(/&amp;#8381;/ig, '₽').replace(/&amp;nbsp;/ig, '&nbsp;');
			},
			update: function update(el, binding) {
				var text = String(binding.value);
				var className = String(el.className);
				var old = String(binding.oldValue);
				if (old === text) return;

				el.innerHTML = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].safe_tags_replace(text).replace(/&lt;b&gt;/ig, '<strong>').replace(/&lt;\/b&gt;/ig, '</strong>').replace(/&lt;p&gt;/ig, '<p>').replace(/&lt;\/p&gt;/ig, '</p>').replace(/&lt;w&gt;/ig, '<span style="color: red">').replace(/&lt;\/w&gt;/ig, '</span>').replace(/&lt;pswdr&gt;/ig, '<span id="instruction-password-value" style="font-size: 14px;' + (className.indexOf('instruction-password shown') > 0 ? '' : 'color: #ccc') + '">').replace(/&lt;\/pswdr&gt;/ig, '</span>' + __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].htmlInstructionPasswordButton(className)).replace(/&lt;i&gt;/ig, '<i>').replace(/&lt;\/i&gt;/ig, '</i>').replace(/&lt;u&gt;/ig, '<u>').replace(/&lt;\/u&gt;/ig, '</u>').replace(/&lt;ul&gt;/ig, '<ul>').replace(/&lt;\/ul&gt;/ig, '</ul>').replace(/&lt;li&gt;/ig, '<li>').replace(/&lt;\/li&gt;/ig, '</li>').replace(/&lt;a(.*)&gt;(.*)&lt;\/a&gt;/ig, function (str, p1, p2, offset, s) {
					return '<a ' + p1.replace(/&quot;/ig, '"').replace(/&#39;/ig, '\'') + '>' + p2 + '</a>';
				}).replace(/&lt;br&gt;/ig, '<br>').replace(/&lt;br\/&gt;/ig, '<br/>').replace(/&amp;#8381;/ig, '₽').replace(/&amp;nbsp;/ig, '&nbsp;');
			}
		});

		Vue.directive('formatTicketMessage', {
			inserted: function inserted(el, binding) {
				var _obj = binding.value;

				if (!_obj || (typeof _obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_obj)) !== 'object' || !_obj['message']) return;

				var _msg = _obj['message'];

				if (!_msg || (typeof _msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_msg)) !== 'object' || _msg['message_content_type'] !== 'plain' || !_msg['message_content']) return;

				var _txt = '';
				try {
					_txt = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].formatTicketMessage(_msg['message_content'], _obj['fastSearchValue'], _msg['message_type'] === 'notice');
				} catch (err) {
					_txt = null;
				}

				if (_txt === null) {
					try {
						_txt = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].escapeHtml(_msg['message_content']);
						_txt = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].nl2br(_txt);
					} catch (eerr) {
						_txt = '';
					}
				}
				el.innerHTML = _txt;
			},
			update: function update(el, binding) {
				var _obj = binding.value;

				if (!_obj || (typeof _obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_obj)) !== 'object' || !_obj['message']) return;

				var _msg = _obj['message'];

				if (!_msg || (typeof _msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_msg)) !== 'object' || _msg['message_content_type'] !== 'plain' || !_msg['message_content']) return;

				var _old = el.innerHTML;
				var _new = '';
				try {
					_new = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].formatTicketMessage(_msg['message_content'], _obj['fastSearchValue'], _msg['message_type'] === 'notice');
				} catch (err) {
					_new = null;
				}

				if (_new === null) {
					try {
						_new = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].escapeHtml(_msg['message_content']);
						_new = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].nl2br(_new);
					} catch (eerr) {
						_new = '';
					}
				}

				if (_old !== _new) el.innerHTML = _new;
			}
		});

		Vue.filter('capitalize', function (value) {
			if (!value) return '';

			var _words = String(value).split(' ');
			var _cap = _words.map(function (word, index) {
				if (word === word.toLocaleUpperCase()) return word;

				var _str = word.toLowerCase();

				if (index === 0) return _str.charAt(0).toUpperCase() + _str.slice(1);

				return _str;
			});

			return _cap.join(' ');
		});

		Vue.filter('lower', function (value, needIgnore) {
			if (needIgnore) return value;
			if (!value) return '';
			value = value.toString();
			return value.toLowerCase();
		});

		Vue.filter('upper', function (value, needIgnore) {
			if (needIgnore) return value;
			if (!value) return '';
			value = value.toString();
			return value.toUpperCase();
		});

		Vue.filter('trim', function (value) {
			if (!value) return '';
			value = value.toString();
			return value.trim();
		});

		Vue.filter('money', function (value) {
			if (value === null || value === undefined) return '0';
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney(value);
			return value;
		});

		Vue.filter('money2', function (value) {
			if (value === null || value === undefined) return '0';
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(value, __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.user_type === 'admin' ? -1 : 2);
			return value;
		});

		Vue.filter('money_1', function (value) {
			var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

			if (value === null || value === undefined) return '0';
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(value, digits);
			return value;
		});

		Vue.filter('money02', function (value) {
			if (value === null || value === undefined) return '0';
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(value, 2);
			return value;
		});

		Vue.filter('moneyOnlyNumbers', function (value) {
			if (value === null || value === undefined) return '0';
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatMoney2(value, 2);
			return __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].String2Money(value);
		});

		Vue.filter('bytes', function (value) {
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatBytes(value);
			return value;
		});

		Vue.filter('date', function (value, format) {
			value = __WEBPACK_IMPORTED_MODULE_6__helper_helper__["a" /* default */].FormatDateTime(value, format);
			return value;
		});

		Vue.filter('ftc', function (str) {
			if (str === null || str === undefined || str === '') return '';
			if (str === true || str === 'true') return Vue.localeBase['main/yes'];
			if (str === false || str === 'false') return Vue.localeBase['main/no'];

			return String(str).split(' ').map(function (s) {
				var m = s.match(/[a-z\-]+\/\w+/);

				if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s;

				m = s.match(/\w+\/\w+/);

				if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s;

				return s in Vue.localeBase && Vue.localeBase[s] ? Vue.localeBase[s] : s;
			}).join(' ');
		});

		Vue.filter('rub', function (str) {
			if (str === null || str === undefined || str === '') return '';

			return str.replace(/&#8381;/ig, '₽');
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (formsPlugin);

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  "data-v-ee4cf446",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'errorAlert',
	props: ['message']
});

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-error-alert"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.message)),
      expression: "localeFtc(message)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  "data-v-12a474f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'linkComponent',

	props: ['url', 'text', 'fontawesomeicon', 'flagicon', 'imageBefore', 'status', 'statusText', 'valueType', 'srcData'],
	data: function data() {
		return {
			access: false,

			curText: [],

			curLink: '#',

			serviceStatus: null,
			serviceStatusText: null
		};
	},
	beforeMount: function beforeMount() {
		this.curLink = this.url;

		this.serviceStatus = this.status;
		this.serviceStatusText = this.statusText;

		this.getText();

		this.whatStatus();
	},

	methods: {
		getText: function getText(txt) {
			this.curText = [];

			var _text = txt;
			if (_text === undefined || _text === null) _text = this.text;

			if (this.valueType === 'money') {
				var _v = parseFloat(_text);
				if (isNaN(_v)) this.curText.push('-');else this.curText.push(__WEBPACK_IMPORTED_MODULE_0__helper_helper__["a" /* default */].Money2String(_v, 2, '.', ' '));
				return;
			}

			if (_text && String(_text).indexOf('<br>') >= 0) {
				var _arr = String(_text).split('<br>');
				for (var k = 0; k < _arr.length; k++) {
					if (k > 0 && k < _arr.length) this.curText.push('<br>');
					this.curText.push(_arr[k]);
				}
			} else this.curText.push(_text);
		},
		whatStatus: function whatStatus() {
			this.access = this.isAccess(this.url);

			if (this.serviceStatus || this.serviceStatusText) {
				if (this.serviceStatusText) {
					if (this.url.indexOf('/vds/view') === 0) this.access = true;else this.access = false;
				} else {
					if (this.serviceStatus === 'deleted') {
						if (this.url.indexOf('/dns/view/') === 0) {
							this.access = false;
							return;
						}

						if (this.url.indexOf('/person/update/') === 0 || this.url.indexOf('/domains/update/') === 0) {
							this.curLink = this.curLink.replace('/update/', '/view/');
							return;
						}

						this.curLink = this.curLink.replace('/vds/', '/service/').replace('/iso/', '/service/').replace('/additional-services/', '/service/');
					} else {
						if (this.serviceStatus !== 'active' && this.serviceStatus !== 'block' && this.serviceStatus !== 'notpaid') {
							this.access = false;
						} else {
							if (this.url.indexOf('/domains/update/') === 0) {
								this.access = this.serviceStatus === 'active';
							}
						}
					}
				}
			}

			if (this.srcData && this.url.indexOf('/dns/view/') === 0) {
				if (this.srcData.can_update === false) {
					this.access = false;
				}
			}
		}
	},

	watch: {
		'status': function status(_status) {
			this.serviceStatus = _status;

			this.whatStatus();
		},
		'statusText': function statusText(_statusText) {
			this.serviceStatusText = _statusText;

			this.whatStatus();
		},
		'url': function url(newUrl) {
			this.curLink = newUrl;
		},
		'text': function text(newText) {
			this.getText(newText);
		}
	}

});

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.access) ? _c('router-link', {
    attrs: {
      "to": _vm.curLink
    }
  }, [(_vm.fontawesomeicon) ? _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.fontawesomeicon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.flagicon !== null && _vm.flagicon !== undefined && _vm.flagicon !== false) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagicon
  }) : _vm._e(), _vm._v(" "), (_vm.imageBefore !== null && _vm.imageBefore !== undefined && _vm.imageBefore !== false) ? _c('img', {
    staticClass: "link-image",
    attrs: {
      "src": _vm.imageBefore
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curText.length === 1) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.curText[0])))] : _vm._l((_vm.curText), function(t, ix) {
    return [(t === '<br>') ? _c('br', {
      key: ix
    }) : [_vm._v(_vm._s(_vm._f("ftc")(t)))]]
  })], 2) : _c('span', [(_vm.fontawesomeicon) ? _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.fontawesomeicon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.flagicon !== null && _vm.flagicon !== undefined && _vm.flagicon !== false) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagicon
  }) : _vm._e(), _vm._v(" "), (_vm.imageBefore !== null && _vm.imageBefore !== undefined && _vm.imageBefore !== false) ? _c('img', {
    staticClass: "link-image",
    attrs: {
      "src": _vm.imageBefore
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curText.length === 1) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.curText[0])))] : _vm._l((_vm.curText), function(t, ix) {
    return [(t === '<br>') ? _c('br', {
      key: ix
    }) : [_vm._v(_vm._s(_vm._f("ftc")(t)))]]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(47);




var formaterPlugin = {
	install: function install(Vue, options) {
		Vue.mixin({
			methods: {
				formater_capitalizeFirstChar: function formater_capitalizeFirstChar(string) {
					if (!string || string === '') return string;
					return string.charAt(0).toUpperCase() + string.slice(1);
				},
				formater_StrDateFormat: function formater_StrDateFormat(date) {
					var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'd.m.y H:M:S';

					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date)) {
						if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
							date = date + ' 00:00:00';
						} else return date;
					}

					var _parts = date.split(/\s/);
					var _date = _parts[0].split('-');
					var _time = _parts[1].split(':');

					return format.replace('d', _date[2]).replace('m', _date[1]).replace('Y', _date[0]).replace('y', _date[0].substr(2, 2)).replace('H', _time[0]).replace('M', _time[1]).replace('S', _time[2]);
				},
				formater_StrDateOnly: function formater_StrDateOnly(date) {
					return this.formater_StrDateFormat(date, 'd.m.Y');
				},
				formater_StrDateHM: function formater_StrDateHM(date) {
					return this.formater_StrDateFormat(date, 'd.m.y H:M');
				},
				formater_StrDate2Date: function formater_StrDate2Date(date) {
					if (/^\d{4}-\d{2}-\d{2}$/.test(date)) date = date + ' 00:00:00';

					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date)) return null;

					var _parts = date.split(/\s/);
					var _date = _parts[0].split('-');
					var _time = _parts[1].split(':');

					return new Date(parseInt(_date[0]), parseInt(_date[1]) - 1, parseInt(_date[2]), parseInt(_time[0]), parseInt(_time[1]), parseInt(_time[2]));
				},
				formater_FormatedStrDate2Date: function formater_FormatedStrDate2Date(date, format) {
					var _str = date;

					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date) && !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
						var _delimeter = '';
						var _expDelimeter = null;
						if (format.indexOf('.') > 0) {
							_delimeter = '.';
							_expDelimeter = '\\.';
						} else if (format.indexOf('-') > 0) {
							_delimeter = '-';
							_expDelimeter = '-';
						} else if (format.indexOf('/') > 0) {
							_delimeter = '/';
							_expDelimeter = '\\/';
						}

						var _formatParts = format.split(_delimeter);
						var _exp = '';
						var _index = {};

						_formatParts.forEach(function (_key, _idx) {
							if (_exp) _exp += _expDelimeter;

							if (_key === 'd' || _key === 'm' || _key === 'y') _exp += '(\\d{2})';else if (_key === 'Y') _exp += '(\\d{4})';

							_index[_key] = _idx + 1;
						});

						var _match = null;
						try {
							var _reg = new RegExp(_exp);
							_match = date.match(_reg);
							if (!_match) return null;
						} catch (e) {
							return null;
						}

						if (!_index['d'] || !_index['m']) return null;
						if (!_index['Y'] && !_index['y']) return null;

						_str = '';

						if (_index['Y']) _str += _match[_index['Y']];
						if (_index['y']) _str += String(1900 + _match[_index['y']]);

						if (_str) _str += '-';

						if (_index['m']) _str += _match[_index['m']];

						if (_str) _str += '-';

						if (_index['d']) _str += _match[_index['d']];
					}

					if (/^\d{4}-\d{2}-\d{2}$/.test(_str)) _str = _str + ' 00:00:00';

					if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_str)) return null;

					var _parts = _str.split(/\s/);
					var _date = _parts[0].split('-');
					var _time = _parts[1].split(':');

					return new Date(parseInt(_date[0]), parseInt(_date[1]) - 1, parseInt(_date[2]), parseInt(_time[0]), parseInt(_time[1]), parseInt(_time[2]));
				},
				formater_Date2StrDate: function formater_Date2StrDate(date) {
					var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

					if (!date) return date;

					if (typeof date === 'string') {
						var _dt = this.formater_StrDate2Date(date);
						if (_dt === null) return date;
						date = _dt;
					}

					var year = date.getFullYear();
					var month = date.getMonth() + 1;
					var day = date.getDate();
					var hour = date.getHours();
					var min = date.getMinutes();
					var sec = date.getSeconds();

					return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day + (withTime !== true ? '' : ' ' + (hour < 10 ? '0' : '') + hour + ':' + (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec);
				},
				formater_Date2StrDateTime: function formater_Date2StrDateTime(date) {
					if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date)) !== 'object') return date;

					return date.toISOString().replace('T', ' ').substr(0, 19);
				},
				formater_Date2StrDateTimeAsIs: function formater_Date2StrDateTimeAsIs(date) {
					if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date)) !== 'object') return date;

					var year = date.getFullYear();
					var month = date.getMonth() + 1;
					var day = date.getDate();
					var hour = date.getHours();
					var min = date.getMinutes();
					var sec = date.getSeconds();

					return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day + ' ' + (hour < 10 ? '0' : '') + hour + ':' + (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
				},
				formater_ParseToDate: function formater_ParseToDate(date) {
					var ms = Date.parse(date);
					if (isNaN(ms)) return null;
					var dt = new Date();
					dt.setTime(ms);
					return dt;
				},
				formater_FormatMoney: function formater_FormatMoney(money) {
					return __WEBPACK_IMPORTED_MODULE_1__helper_helper__["a" /* default */].FormatMoney2(money, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user_type === 'admin' ? -1 : 2);
				},
				formater_StrToInt: function formater_StrToInt(str) {
					var ifNan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

					var ans = parseInt(str, 10);
					if (isNaN(ans)) return ifNan;
					return ans;
				}
			}

		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (formaterPlugin);

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)
__webpack_require__(757)
__webpack_require__(758)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_workBoard__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_workBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_workBoard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_unauthPage__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_unauthPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_unauthPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_operationPage__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_operationPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_operationPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_errorPage__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_errorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_errorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_notificator__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_notificator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_notificator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper_helper__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_formfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_elements_formfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_elements_formfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_elements_lang__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_elements_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_elements_lang__);



















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',

	data: function data() {
		return {
			loading: true,
			errorMessage: false,
			errorCode: 0,
			workerVersion: false,
			workerPush: false,
			workerCron: false,
			showUpdatePanelButton: false,
			showUpdatePanelMessageBlock: false,

			messagesForUpdateBlock: [],

			idleTimer: null,
			idleEventsCount: 0,

			Referrer: false,

			appKey: 0,

			audio: null,
			canPlay: false,

			keys: {
				32: 'spacebar',
				33: 'pageup',
				34: 'pagedown',
				35: 'end',
				36: 'home',
				37: 'left',
				38: 'up',
				39: 'right',
				40: 'down'
			},
			keysText: {
				33: 'pageup',
				34: 'pagedown'
			},

			clientWarningsCloseValue: false,
			clientWarnings: [],

			showUserNeedDialogModal: false,
			userNeedDialogMode: 'password',
			userNeedDialogTitle: '',
			fieldsUserNeed: null,
			fieldEmailError: '',

			FD: false,
			FD_count: 0,

			vdsinaRecallLinkShown: true,

			activeModalFindTimer: null,

			activeModalFindCounter: 0,

			windowScrollTop: false
		};
	},

	components: {
		workBoard: __WEBPACK_IMPORTED_MODULE_8__components_workBoard___default.a,
		unauthPage: __WEBPACK_IMPORTED_MODULE_9__components_unauthPage___default.a,
		errorPage: __WEBPACK_IMPORTED_MODULE_11__components_errorPage___default.a,
		Notificator: __WEBPACK_IMPORTED_MODULE_12__components_widgets_notificator___default.a,
		operationPage: __WEBPACK_IMPORTED_MODULE_10__components_operationPage___default.a,
		Field: __WEBPACK_IMPORTED_MODULE_15__components_elements_formfield___default.a,
		Lang: __WEBPACK_IMPORTED_MODULE_16__components_elements_lang___default.a
	},

	computed: {
		clVersion: function clVersion() {
			return 'cl ' + __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion + (this.$store.state.isDebug ? ' dev' : ' prod');
		},
		pageTitle: function pageTitle() {
			return this.$store.state.pageTitle;
		}
	},

	methods: {
		onErrorInitApp: function onErrorInitApp(data) {
			this.loading = false;

			this.errorCode = 0;

			if (!data || !data['what'] || !data['data']) {
				this.errorMessage = 'error/app_internal';
				return;
			}

			if (data['what'] === 'locale') {
				var _dataError = data['data'];

				if (_dataError && 'status' in _dataError && 'ok' in _dataError && 'url' in _dataError) {
					if (_dataError.status === 0 && String(data['ok']) === 'false') {
						this.errorMessage = 'error/request_terminated';
						return;
					}
					if (_dataError.status === 400) {
						this.$store.commit('setReturnURL', this.$route.path);
						this.errorMessage = 'error/cookie';
						this.errorCode = 400;
						return;
					} else if (_dataError.status === 401 || _dataError.status === 403) {
							this.$store.commit('dropAuth');

							this.$store.commit('setReturnURL', this.$route.path);

							this.$store.commit('pushStop');

							this.$router.push('/login');
							return;
						} else if (_dataError.status >= 400) {
								this.$store.commit('setReturnURL', this.$route.path);
								this.errorMessage = this.formatRequestError(_dataError['body']);
								this.errorCode = _dataError['status'];
								return;
							}
				}

				this.errorMessage = 'error/app_internal';
				return;
			}

			if (data['what'] === 'workers' || data['what'] === 'storage') {
				this.errorMessage = data['data'];
				return;
			}

			if (data['what'] === 'auth') {
				if (data['data'] === '1') {
					this.$store.commit('dropAuth');

					if (!this.isPublicUrl(this.$route.path)) {
						this.$store.commit('setReturnURL', this.$route.path);

						this.$router.push('/login');
					}

					return;
				} else if (data['data'] === '2') {
					var _dataError2 = data['dataError'];

					if (_dataError2 && 'status' in _dataError2 && 'ok' in _dataError2 && 'url' in _dataError2) {
						if (_dataError2['status'] === 0 && String(_dataError2['ok']) === 'false') {
							this.errorMessage = 'error/request_terminated';
							return;
						}

						if (_dataError2['status'] === 200 && _dataError2['ok'] === true && 'data' in _dataError2 && _dataError2['data'] && 'status' in _dataError2['data'] && _dataError2['data']['status'] === 'form') {
							if (!this.isPublicUrl(this.$route.path)) {
								this.$store.commit('dropAuth');

								this.$store.commit('setReturnURL', this.$route.path);

								this.$store.commit('pushStop');

								this.$router.push('/login');
							}

							return;
						} else if (_dataError2.status === 401) {
								this.$store.commit('dropAuth');

								this.$store.commit('setReturnURL', this.$route.path);

								this.$store.commit('pushStop');

								this.$router.push('/login');
								return;
							} else if (_dataError2.status === 403) {
									if (_dataError2.data && _dataError2.data.content && String(_dataError2.data.content).indexOf('forbidden') > 0 || !__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].verifyPermissions(this.$store.state.user_role, this.$router.currentRoute)) {
										return;
									}

									this.$store.commit('dropAuth');

									if (!this.isPublicUrl(this.$route.path)) {
										this.$store.commit('setReturnURL', this.$route.path);
									}

									this.$router.push('/login');

									return;
								} else if (_dataError2.status === 503) {
										this.$store.commit('setReturnURL', window.location.pathname);

										this.$store.commit('errorHttpCode', 503);

										this.$router.push('/503');
										return;
									}
					}
				}
			}

			this.errorMessage = 'error/app_internal';
			return;
		},
		handleLang: function handleLang(newLang) {
			var _this2 = this;

			if (this.$store.state.lang === newLang) return;

			if (this.$store.state.is_auth === true) {
				this.$http.post(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].APIServerUrl + '/option/set/locale', __WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].toFormData({ value: newLang })).then(function () {
					__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].setCookie('ln', newLang, { 'expires': 60 * 60 * 24 * 365, 'domain': __WEBPACK_IMPORTED_MODULE_5_vue__["default"].CookieDomain, 'path': '/' });

					_this2.getLocale(newLang);
				}).catch(function () {});
			} else {
					__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].setCookie('ln', newLang, { 'expires': 60 * 60 * 24 * 365, 'domain': __WEBPACK_IMPORTED_MODULE_5_vue__["default"].CookieDomain, 'path': '/' });

					this.getLocale(newLang);
				}
		},
		getTemplateGroups: function getTemplateGroups() {
			this.$store.dispatch('getTemplateGroupCache');
		},
		getLocale: function getLocale(lang) {
			var _this3 = this;

			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (lang && lang !== _this3.$store.state.lang) {
					_this3.$store.commit('setLang', lang);

					__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].setCookie('ln', lang, { 'expires': 60 * 60 * 24 * 365, 'domain': __WEBPACK_IMPORTED_MODULE_5_vue__["default"].CookieDomain, 'path': '/' });
				}

				var _url = _this3.APIServerUrl + '/text/all/' + _this3.$store.state.lang + '.js?_=' + __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion;

				_this3.$http.get(_url).then(function (resGet) {
					if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body']) {
						var _js = document.createElement('script');
						_js.type = 'text/javascript';
						_js.innerHTML = resGet['body'];
						document.body.appendChild(_js);

						var _locale = window.locale();
						if (_locale) {
							__WEBPACK_IMPORTED_MODULE_5_vue__["default"].setLocaleBase(_locale, _this3.$store.state.lang);

							var _answer = _this3.localeFtc('main/interface_new_version').split('{link}');
							if (_answer[1]) _answer[1] = _answer[1].replace('{/link}', '');
							_this3.messagesForUpdateBlock = _answer;

							document.title = _this3.localeFtc(_this3.pageTitle);

							_this3.appKey++;
						}

						resolve(true);
					} else {
						reject({
							'what': 'locale',
							'data': resGet
						});
					}
				}, function (resGet) {
					reject({
						'what': 'locale',
						'data': resGet
					});
				});
			});
		},
		startWorkers: function startWorkers() {
			var _this4 = this;

			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (!window.Worker) {
					return reject({
						'what': 'workers',
						'data': 'error/html5'
					});
				}

				_this4.workerVersion = new Worker('/static/js/worker-version.js?_=' + __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion);

				_this4.workerVersion.onmessage = function (e) {
					if (!e || !e.data) return;

					if (e && e.data === 'applicationBlock') {
						if (_this4.$store.state.uploadFileCounter > 0) {
							if (_this4.workerVersion) _this4.workerVersion.postMessage('dropBlockerX2');

							var _url = _this4.APIServerUrl + (_this4.$store.state.user_type === 'admin' ? '/admin/index' : '');
							_this4.$http.get(_url);
						} else {
							_this4.blockApp();
						}

						return;
					}

					if (_this4.showUpdatePanelMessageBlock) return;

					_this4.showUpdatePanelButton = e.data !== __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion;
				};

				_this4.workerVersion.postMessage('start');

				_this4.workerCron = new Worker('/static/js/worker-cron.js?_=' + __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion + '_0');

				_this4.workerCron.onmessage = function (e) {
					if (!e || !e.data) return;

					__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-cron-task-answer', e.data);
				};

				_this4.workerCron.postMessage('start');

				resolve(true);
			});
		},
		initStorage: function initStorage() {
			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				try {
					if (!window || !window.localStorage || !window.sessionStorage) {
						return reject({
							'what': 'storage',
							'data': 'error/html5'
						});
					}
				} catch (e) {
					return reject({
						'what': 'storage',
						'data': 'error/html5'
					});
				}

				resolve(true);
			});
		},
		authUser: function authUser() {
			var _this5 = this;

			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.ajax({
					url: __WEBPACK_IMPORTED_MODULE_5_vue__["default"].APIServerUrl + '/login',
					cache: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					}
				}).done(function () {
					var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data) {
						var _dt;

						return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										_dt = data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object' && 'status' in data ? data : false;

										if (_dt && _dt['status'] === 'form' && _dt['fields']) {
											_this5.$store.commit('saveFormCache', {
												formName: '/login',
												data: _dt
											});
										}

										if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['captcha'] && _dt['fields']['captcha']['image']) {
											window.sessionStorage.setItem('captcha', _dt['fields']['captcha']['image']);
										}

										if (!(_dt && _dt['status'] === 'ok' && _dt['user'])) {
											_context.next = 7;
											break;
										}

										_context.next = 6;
										return _this5.getLocale(_dt['locale']);

									case 6:
										return _context.abrupt('return', resolve(_dt));

									case 7:
										_context.next = 9;
										return _this5.getLocale();

									case 9:
										return _context.abrupt('return', reject({
											'what': 'auth',
											'data': '2',
											'dataError': {
												'url': _this5.$route.path,
												'status': 200,
												'ok': true,
												'data': _dt
											}
										}));

									case 10:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this5);
					}));

					return function (_x) {
						return _ref.apply(this, arguments);
					};
				}()).fail(function () {
					var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(jqXHR, textStatus, errorThrown) {
						return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
							while (1) {
								switch (_context2.prev = _context2.next) {
									case 0:
										_context2.next = 2;
										return _this5.getLocale();

									case 2:
										return _context2.abrupt('return', reject({
											'what': 'auth',
											'data': '2',
											'dataError': {
												'url': _this5.$route.path,
												'status': jqXHR.status,
												'ok': false,
												'data': false
											}
										}));

									case 3:
									case 'end':
										return _context2.stop();
								}
							}
						}, _callee2, _this5);
					}));

					return function (_x2, _x3, _x4) {
						return _ref2.apply(this, arguments);
					};
				}());
			});
		},
		getDictionaries: function getDictionaries() {
			var _this6 = this;

			return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var _url = _this6.APIServerUrl + '/service/list?search=group&type=vds';

				_this6.$http.get(_url).then(function (resGet) {
					if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body'] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet['body']) === 'object' && resGet['body']['status'] === 'ok') {
						resolve(resGet['body']);
					} else {
						reject({
							'what': 'auth',
							'data': '2',
							'dataError': resGet
						});
					}
				}, function (resGet) {
					reject({
						'what': 'auth',
						'data': '2',
						'dataError': resGet
					});
				});
			});
		},
		successLogin: function successLogin(data) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _userId, _clientVersion, _url, _ru;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return _this7.$store.commit('setAuth', data);

							case 2:
								if (data['user']['user_type'] === 'admin') {
									_this7.workerVersion.postMessage('adminTimeout');

									_this7.$store.commit('getTicketDepartments');

									_this7.$store.dispatch('getApiVersion');
								} else {
										_this7.getClientWarnings();
									}

								_this7.setGAUid();

								if (_this7.$store.state.user_need && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this7.$store.state.user_need) === 'object') {
									if (_this7.$store.state.user_need.password_change) {
										_this7.userNeedDialogMode = 'password';
										_this7.showUserNeedDialog();
									} else if (_this7.$store.state.user_need.email_confirm) {
											_this7.userNeedDialogMode = 'email';
											_this7.showUserNeedDialog();
										}
								}

								_this7.loading = false;

								_userId = data['user']['user_id'];
								_clientVersion = window.localStorage.getItem('w5_api_version_' + _userId);

								if (!_clientVersion || _clientVersion !== __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion) {
									_this7.clearSettings(_userId);

									window.localStorage.setItem('w5_api_version_' + _userId, __WEBPACK_IMPORTED_MODULE_5_vue__["default"].AppVersion);
								}

								if (!(_this7.$route.path === '/login' || _this7.$route.path === '/register' || _this7.$route.path === '/forget' || _this7.$route.path === '/user/forget')) {
									_context3.next = 22;
									break;
								}

								if (!_this7.$store.state.returnURL) {
									_context3.next = 16;
									break;
								}

								_url = _this7.$store.state.returnURL;

								_this7.$store.commit('setReturnURL', false);

								_this7.$router.push(_url);
								_context3.next = 22;
								break;

							case 16:
								_ru = window.sessionStorage.getItem('_ru');

								if (!_ru) {
									_context3.next = 21;
									break;
								}

								window.sessionStorage.removeItem('_ru');

								if (!(_ru !== '/login' && _ru !== '/register' && _ru !== '/forget' && _ru !== '/user/forget')) {
									_context3.next = 21;
									break;
								}

								return _context3.abrupt('return', _this7.$router.push(_ru));

							case 21:
								_this7.$router.push('/');

							case 22:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this7);
			}))();
		},
		getClientWarnings: function getClientWarnings() {
			var _this8 = this;

			this.clientWarnings = [];

			this.clientWarningsCloseValue = false;

			var _url = this.APIServerUrl + '/ticket/list?additional=getWarnings';
			this.$http.get(_url).then(function (res) {
				if (res && res['ok'] === true && res['status'] === 200 && res['body'] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(res['body']) === 'object' && res['body']['status'] === 'ok' && res['body']['result'] && res['body']['result'].length) {
					_this8.clientWarnings = res['body']['result'].filter(function (item) {
						return !item.read;
					});

					_this8.activeModalFindCounter = 0;
					_this8.$nextTick(function () {
						return _this8.findActiveModal();
					});
				}
			}).catch(function () {});
		},
		closeWarning: function closeWarning() {
			var messageId = null;
			if (this.clientWarnings && this.clientWarnings.length && this.clientWarnings[0].message_id) messageId = this.clientWarnings[0].message_id;

			var isRequest = this.clientWarningsCloseValue;

			this.clientWarnings.shift();

			this.clientWarningsCloseValue = false;

			__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-scroll-arrow').hide();

			if (isRequest && messageId) {
				var _url = this.APIServerUrl + '/ticketmessage/update/' + messageId + '?additional=setRead';
				this.$http.get(_url).catch(function () {});
			}
		},
		gotoWarningTicket: function gotoWarningTicket() {
			__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-scroll-arrow').hide();

			var _ticket = this.clientWarnings[0];
			this.clientWarnings = [];
			if (_ticket && _ticket.ticket_id) this.$router.push('/ticket/view/' + _ticket.ticket_id);
		},
		setGAUid: function setGAUid() {
			if (window && window.ga) {
				var _this = this;
				window.ga(function () {
					var trackers = window.ga.getAll();
					if (trackers && trackers.length) {
						var tracker = trackers[0];
						if (tracker && tracker.get) {
							var clientId = tracker.get('clientId');
							if (clientId) _this.$http.post(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].APIServerUrl + '/option/set/ga_uid', __WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].toFormData({ value: clientId })).catch(function () {});
						}
					}
				});
			}
		},
		showUpdateBlock: function showUpdateBlock() {
			this.showUpdatePanelButton = !this.showUpdatePanelButton;
			this.showUpdatePanelMessageBlock = !this.showUpdatePanelMessageBlock;

			var _answer = this.localeFtc('main/interface_new_version').split('{link}');
			if (_answer[1]) _answer[1] = _answer[1].replace('{/link}', '');
			this.messagesForUpdateBlock = _answer;
		},
		reloadApp: function reloadApp() {
			location.reload(true);
		},
		blockApp: function blockApp() {
			document.removeEventListener('mousemove', this.dropBlocker);
			document.removeEventListener('keydown', this.dropBlocker);
			document.removeEventListener('scroll', this.dropBlocker);

			if (this.idleTimer) clearTimeout(this.idleTimer);
			this.idleEventsCount = 0;

			__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-notificator-remove-all');

			__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-block-application', true);

			this.$store.commit('pushStop');

			this.workerVersion.postMessage('stop');
			this.workerVersion.postMessage('stopBlocker');
			this.workerCron.postMessage('stop');

			this.$store.commit('blockApplication');

			if (this.$store.state.user_type === 'admin' && this.canPlay) this.audio.play();
		},
		dropBlocker: function dropBlocker(e) {
			var _this9 = this;

			if (this.$store.state.applicationBlocked) return;

			if (e && e.type === 'keydown') {
				if (e.keyCode === 27 && this.showUserNeedDialogModal) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
				}

				if (this.idleTimer) clearTimeout(this.idleTimer);

				this.idleTimer = setTimeout(function () {
					_this9.idleEventsCount = 0;
					if (_this9.workerVersion) _this9.workerVersion.postMessage('dropBlocker');
				}, 1000);

				return;
			}

			this.idleEventsCount++;

			if (this.idleTimer) {
				if (this.idleEventsCount > 50) {
					clearTimeout(this.idleTimer);
					this.idleEventsCount = 0;

					if (this.workerVersion) this.workerVersion.postMessage('dropBlocker');

					this.idleTimer = setTimeout(function () {
						_this9.idleEventsCount = 0;
						if (_this9.workerVersion) _this9.workerVersion.postMessage('dropBlocker');
					}, 1000);
				}
			} else {
				this.idleTimer = setTimeout(function () {
					_this9.idleEventsCount = 0;
					if (_this9.workerVersion) _this9.workerVersion.postMessage('dropBlocker');
				}, 1000);
			}
		},
		_preventDefault: function _preventDefault(e) {
			e = e || window.event;

			if (e && e.target && e.target.className && (e.target.className.indexOf('scrollable') > -1 || e.target.className.indexOf('multiselect__') > -1)) {
				return true;
			}
			if (e && e.target && e.target.tagName.toLowerCase() === 'span') {
				if (e.target.parentNode && (e.target.parentNode.className.indexOf('scrollable') > -1 || e.target.parentNode.className.indexOf('multiselect__') > -1)) {
					return true;
				}
			}

			if (e.preventDefault) e.preventDefault();
			e.returnValue = false;
		},
		_preventDefaultForScrollKeys: function _preventDefaultForScrollKeys(e) {
			if (e.target.type === 'textarea' || e.target.type === 'text') {
				if (this.keysText[e.keyCode]) {
					this._preventDefault(e);
					return false;
				}
			} else if (this.keys[e.keyCode]) {
				this._preventDefault(e);
				return false;
			}
		},
		disableScroll: function disableScroll() {
			var _this10 = this;

			if (!__WEBPACK_IMPORTED_MODULE_6_jquery___default()('body').hasClass('with-active-modal')) this.windowScrollTop = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).scrollTop();

			var _nav = document.querySelector('nav.navbar-fixed-top');
			if (_nav) _nav.style.width = _nav.offsetWidth + 'px';
			document.body.style.width = document.body.offsetWidth + 'px';

			this.addClass(document.body, 'with-active-modal');

			this.activeModalFindCounter = 0;
			this.$nextTick(function () {
				return _this10.findActiveModal();
			});
		},
		enableScroll: function enableScroll() {
			__WEBPACK_IMPORTED_MODULE_6_jquery___default()('div.w5-alert-valid').hide();

			__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-scroll-arrow').hide();

			this.removeClass(document.body, 'with-active-modal');

			var _nav = document.querySelector('nav.navbar-fixed-top');
			if (_nav) _nav.style.width = 'auto';
			document.body.style.width = 'auto';

			if (this.windowScrollTop !== false) {
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).scrollTop(this.windowScrollTop);
				this.windowScrollTop = false;
			}
		},
		findActiveModal: function findActiveModal() {
			var _this11 = this;

			if (this.activeModalFindTimer) clearTimeout(this.activeModalFindTimer);

			if (this.activeModalFindCounter++ > 6) return;

			var $mask = __WEBPACK_IMPORTED_MODULE_6_jquery___default()('div.modal-mask:visible');
			if (!$mask.length) {
				this.activeModalFindTimer = setTimeout(function () {
					return _this11.findActiveModal();
				}, 500);
				return;
			}

			__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-recount-field-blocks');

			if (this.$store.state.windowWidth > 767) return;

			var vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', vh + 'px');

			var $body = $mask.find('div.modal-body:first');
			if (!$body.length) {
				this.activeModalFindTimer = setTimeout(function () {
					return _this11.findActiveModal();
				}, 500);
				return;
			}

			var arrows = 0;

			if ($body[0].scrollHeight > $body[0].clientHeight) {
				var delta = $body[0].scrollHeight - $body[0].clientHeight;
				if ($body[0].scrollTop <= 0) arrows = 2;else if ($body[0].scrollTop > 0 && $body[0].scrollTop < delta) arrows = 3;else if ($body[0].scrollTop >= delta) arrows = 1;

				var w = $body.width();
				var h = $body.height();
				var l = $body.offset().left;
				var t = $body.offset().top;

				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-up').css({ left: l + w + 15 + 'px', top: t + 3 + 'px' });
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-down').css({ left: l + w + 15 + 'px', top: t + h + 30 - 15 + 'px' });

				$body.off('scroll').on('scroll', this.onModalBodyScroll);
			}

			if (arrows > 0) {
				if (arrows === 3 || arrows === 1) __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-up').show();

				if (arrows === 3 || arrows === 2) __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-down').show();
			}
		},
		clearSettings: function clearSettings(userId) {
			var _userId = userId;
			if (!_userId) _userId = this.$store.state.user_id;

			var _reg = new RegExp('^w5_' + _userId, 'i');
			var _keys = [];

			for (var i = 0; i < localStorage.length; i++) {
				var _key = localStorage.key(i);

				if (_reg.test(_key)) _keys.push(_key);
			}

			_keys.forEach(function (k) {
				localStorage.removeItem(k);
			});

			_keys = [];

			for (var _i = 0; _i < sessionStorage.length; _i++) {
				var _key2 = sessionStorage.key(_i);

				if (_reg.test(_key2)) _keys.push(_key2);
			}

			_keys.forEach(function (k) {
				sessionStorage.removeItem(k);
			});
		},
		audioCanPlay: function audioCanPlay() {
			this.canPlay = true;
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			if (!msg || this.$store.state.user_type === 'admin') return;

			var _parts = msg.split(' ');

			if (!_parts || !_parts.length || _parts[1] !== 'ticket') return;

			if (_parts[0] === 'update') {
				this.getClientWarnings();
			}
		},
		optionHandler: function optionHandler() {},
		onModalBodyScroll: function onModalBodyScroll(e) {
			if (!e || !e.target) return;

			var $body = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(e.target);
			if (!$body.length) return;

			if ($body[0].scrollHeight <= $body[0].clientHeight) return;

			var delta = $body[0].scrollHeight - $body[0].clientHeight;
			if ($body[0].scrollTop <= 0) {
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-up').hide();
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-down').show();
			} else if ($body[0].scrollTop > 0 && $body[0].scrollTop < delta) {
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-up').show();
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-down').show();
			} else if ($body[0].scrollTop >= delta) {
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-up').show();
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#modal-scroll-arrow-down').hide();
			}
		},
		onWindowResize: function onWindowResize() {
			var _this12 = this;

			var vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', vh + 'px');

			this.activeModalFindCounter = 0;
			this.$nextTick(function () {
				return _this12.findActiveModal();
			});
		},
		showUserNeedDialog: function showUserNeedDialog() {
			var _this13 = this;

			var _url = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].APIServerUrl;

			if (this.userNeedDialogMode === 'password') {
				if (this.$store.state.user_type === 'admin') _url += '/admin/password';else _url += '/user/password';
			} else _url += '/email/create';

			this.$http.get(_url).then(function (ans) {
				var _dt = ans && ans.body && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(ans.body) === 'object' ? ans.body : false;

				if (_dt && _dt['status'] === 'form' && _dt['fields']) {
					_this13.userNeedDialogTitle = _dt['title'];
					_this13.fieldsUserNeed = _this13.parseFormData(_dt);
					_this13.$nextTick(function () {
						__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
						_this13.showUserNeedDialogModal = true;
						_this13.$forceUpdate();
					});
				}
			}).catch(function () {});
		},
		hideUserNeedDialogModal: function hideUserNeedDialogModal() {
			__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showUserNeedDialogModal = false;
			this.hideModalMask();
		},
		userNeedLastField: function userNeedLastField() {
			if (!this.fieldsUserNeed || !this.fieldsUserNeed.fields || !this.fieldsUserNeed.fields.length) return null;

			var lastRow = null;
			for (var i = this.fieldsUserNeed.fields.length - 1; i >= 0; i--) {
				lastRow = this.fieldsUserNeed.fields[i];
				if (lastRow && lastRow.length) break;
			}
			if (!lastRow || !lastRow.length) return null;

			return lastRow[lastRow.length - 1];
		},
		findField: function findField(name, fields) {
			if (!fields || !fields.length) return null;

			var _field = null;
			fields.some(function (item) {
				if (item && Array.isArray(item)) {
					item.some(function (obj) {
						if (obj && obj['_field_name'] === name) {
							_field = obj;
							return true;
						}
					});

					if (_field) return true;
				}
			});

			return _field;
		},
		submitUserNeedForm: function submitUserNeedForm() {
			var _this14 = this;

			this.fieldEmailError = '';

			var lastField = this.userNeedLastField();
			if (!lastField) return;

			var _access = true;
			if (this.userNeedDialogMode === 'password') {
				if (this.$store.state.user_type === 'admin') _access = this.isAccess('admin/options');else _access = this.isAccess('user/options');
			} else {
				_access = true;
				lastField.required = false;
			}

			if (!_access) {
				lastField['_errMsg'] = 'main/access_denied';
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg'];
				return;
			}

			var _rows = this.fieldsUserNeed['fields'];

			if (!_rows || !Array.isArray(_rows)) {
				lastField['_errMsg'] = 'error/app_internal';
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg'];
				return;
			}

			var _isErr = _rows.some(function (row) {
				var _found = false;
				if (row && Array.isArray(row) && row.length) {
					_found = row.some(function (fld) {
						if (!fld['_visible']) return false;

						if (fld['required'] === true && fld['type'] !== 'email') {
							if (fld.value === undefined || fld.value === null || String(fld.value) === '') {
								fld['_errMsg'] = 'error/required_field';
								return true;
							}
						}
					});
				}

				if (_found) return true;
			});
			if (_isErr) return;

			lastField['_errMsg'] = '';
			var _data = this.collectFormData(_rows, this.verifyField);

			if (_data === false) return;

			var _url = void 0;
			if (this.userNeedDialogMode === 'password') {
				if (this.$store.state.user_type === 'admin') _url = '/admin/password';else _url = '/user/password';
			} else _url = '/email/create';

			this.$http.get(this.APIServerUrl + _url).then(function (resGet) {
				var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model']) return { csrf: _dt['_csrf'], model: _dt['model'] };

				throw new Error(_dt);
			}).then(function (getDate) {
				_data = _this14.FormDataRePack(_data);

				var _post = {
					'_csrf': getDate.csrf
				};
				_post[getDate.model] = _data;

				_this14.FD = new FormData();
				_this14.FD_count = 0;
				_this14.FD_prepare(_post);

				_this14.$http.post(_this14.APIServerUrl + _url, _this14.FD_count > 0 ? _this14.FD : null).then(function (resPost) {
					var _dt = resPost && resPost.data && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resPost.data) === 'object' ? resPost.data : false;

					if (_dt && _dt['status'] === 'ok') {
						_this14.hideUserNeedDialogModal();

						__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
							'title': ' ',
							'message': _dt['title'],
							'class': 'success',
							'type': 'nourl',
							'id': 'success-message',
							'timeout': 3000
						});
						return;
					}

					if (_dt && _dt['status'] === 'error' && _dt['fields']) {
						var _txtError = '';

						for (var k in _dt['fields']) {
							if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length) {
								var _fld = _this14.findField(k, _rows);

								if (_fld) {
									_fld['_errMsg'] = _this14.localeFtc(_dt['fields'][k].join(' <br> '));
									if (_this14.userNeedDialogMode !== 'password' && _fld['_field_name'] === 'email') _this14.fieldEmailError = _fld['_errMsg'];
									__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$emit('w5-set-field-error');
								} else _txtError += _this14.localeFtc(_dt['fields'][k].join(' <br> '));
							}
						}
						if (_txtError) {
							lastField['_errMsg'] = _txtError;
							if (_this14.userNeedDialogMode !== 'password') _this14.fieldEmailError = lastField['_errMsg'];
						}

						return;
					}

					lastField['_errMsg'] = _this14.formatRequestError(resPost);
					if (_this14.userNeedDialogMode !== 'password') _this14.fieldEmailError = lastField['_errMsg'];
				}, function (resPost) {
					lastField['_errMsg'] = _this14.formatRequestError(resPost);
					if (_this14.userNeedDialogMode !== 'password') _this14.fieldEmailError = lastField['_errMsg'];
				});
			}).catch(function (error) {
				lastField['_errMsg'] = _this14.formatRequestError(error);
				if (_this14.userNeedDialogMode !== 'password') _this14.fieldEmailError = lastField['_errMsg'];
			});
		},
		isVisibleField: function isVisibleField(row) {
			var _answer = false;

			row.some(function (item, idx, arr) {
				if (item && item.type !== 'hidden' && item['_visible'] === true) {
					_answer = true;
					return true;
				}
			});

			return _answer;
		},
		onBlurInput: function onBlurInput(field) {
			this.verifyField(field);
		},
		onFocusInput: function onFocusInput(field) {
			field['_errMsg'] = '';
			if (this.userNeedDialogMode !== 'password') this.fieldEmailError = '';
		},
		verifyField: function verifyField(field) {
			field['_errMsg'] = '';
			this.fieldEmailError = '';

			if (field.value === undefined || field.value === null || String(field.value) === '') return true;

			if (!field['_visible']) return true;

			if (field.type === 'integer' || field.type === 'int') {
				var v = String(field.value).trim();

				v = v.replace(/ /g, '');

				var r = parseInt(v);

				if (isNaN(r)) {
					field['_errMsg'] = 'validators/error_int';
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg'];
					return false;
				}

				if (v === String(r)) return;

				field['_errMsg'] = 'validators/error_int';
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg'];
				return false;
			}

			if (field.type === 'float' || field.type === 'money') {
				var _v = String(field.value).trim();

				_v = _v.replace(/ /g, '');

				var _r = parseFloat(_v);

				if (isNaN(_r)) {
					field['_errMsg'] = 'validators/error_float';
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg'];
					return false;
				}

				if (!__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].isNumeric(String(_r))) {
					field['_errMsg'] = 'validators/error_float';
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg'];
					return false;
				}
			}

			if (field.type === 'email') {
				if (__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* default */].validateEmail(field.value)) return true;

				field['_errMsg'] = 'validators/error_email';
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg'];
				return false;
			}

			return true;
		},
		FD_prepare: function FD_prepare(d, key) {
			var k = void 0;

			for (k in d) {
				if (d.hasOwnProperty(k)) {
					if (d[k] && key && k === 'file' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && 'name' in d[k] && 'size' in d[k] && 'type' in d[k]) {
						this.FD.append(key + '[' + k + ']', d[k]);
						this.FD_count++;
						continue;
					}

					if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(d[k]) === 'object' && d[k] && !('lastModifiedDate' in d[k])) {
						if (key) {
							this.FD_prepare(d[k], key + '[' + k + ']');
						} else {
							this.FD_prepare(d[k], k);
						}
					} else {
						if (key) {
							this.FD.append(key + '[' + k + ']', d[k]);
						} else {
							this.FD.append(k, d[k]);
						}

						this.FD_count++;
					}
				}
			}
		},
		startCronTask: function startCronTask(inputData) {
			this.workerCron.postMessage(inputData);
		}
	},
	created: function created() {
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-user-options-on-server', this.optionHandler);

		this.$store.commit('currentAppId');

		var _limit = this.AppName === 'vdsina.com' ? 100 : 10000;
		this.$store.commit('setOperationSumNew', _limit);

		if (!window.w5InArray) window.w5InArray = function (variable, array) {
			var _answer = -1;
			array.some(function (item, idx) {
				if (String(item) === String(variable)) {
					_answer = idx;
					return true;
				}
			});
			return _answer;
		};

		if (!window.ObjDeepClone) window.ObjDeepClone = function (src) {
			return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(src));
		};

		this.startWorkers().then(this.initStorage).then(this.authUser).then(this.successLogin).catch(this.onErrorInitApp);

		this.onModalBodyScroll = __WEBPACK_IMPORTED_MODULE_7_debounce___default()(this.onModalBodyScroll, 500);
	},
	mounted: function mounted() {
		document.addEventListener('mousemove', this.dropBlocker);
		document.addEventListener('keydown', this.dropBlocker);
		document.addEventListener('scroll', this.dropBlocker);
		window.addEventListener('resize', this.onWindowResize);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-body-scroll-disable', this.disableScroll);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-body-scroll-enable', this.enableScroll);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-cron-task-start', this.startCronTask);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$on('w5-on-lang', this.handleLang);

		this.audio = this.$refs['audioBlock'];
		if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('mousemove', this.dropBlocker);
		document.removeEventListener('keydown', this.dropBlocker);
		document.removeEventListener('scroll', this.dropBlocker);
		window.removeEventListener('resize', this.onWindowResize);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-body-scroll-disable', this.disableScroll);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-body-scroll-enable', this.enableScroll);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-user-options-on-server', this.optionHandler);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-cron-task-start', this.startCronTask);
		__WEBPACK_IMPORTED_MODULE_14__bus_js__["a" /* EventBus */].$off('w5-on-lang', this.handleLang);

		delete window.w5InArray;
		window.w5InArray = null;

		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

		if (this.activeModalFindTimer) clearTimeout(this.activeModalFindTimer);
	},

	watch: {
		'$store.state.is_auth': function $storeStateIs_auth(value) {
			if (value) {
				this.$store.commit('pushStart');

				if (this.workerVersion) this.workerVersion.postMessage('startBlocker');

				this.$store.dispatch('getTicketCounters');

				this.$store.dispatch('getRequestCounter');
			} else {
				this.$store.commit('pushStop');

				if (this.workerVersion) this.workerVersion.postMessage('stopBlocker');
				if (this.workerCron) this.workerCron.postMessage('stop');
			}
		},
		'$route': function $route(to, from) {
			var _path = null;
			if (to && to.path) _path = String(to.path);

			if (this.$store.state.is_auth && this.$store.state.user_type === 'client' && _path && _path.length && (_path.indexOf('/operation/create') === 0 || _path.indexOf('/operation/select') === 0 || _path.indexOf('/operation/pay') === 0)) {
				if (window && window.gtag) window.gtag('config', 'UA-31804196-2');
			}

			this.$store.commit('changedForm', false);
		},
		'pageTitle': function pageTitle() {
			document.title = this.localeFtc(this.pageTitle);
		}
	}

});

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_money__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_lang__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_lang__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'workBoard',

	data: function data() {
		return {
			crud: null,

			mobileTabsMenuShow: false,

			tabs: {},
			showBalanceData: false,

			showConfirmModalDialog: false,
			confirmModalDialogTitle: '',
			confirmModalDialogText: '',
			confirmModalDialogCallback: function confirmModalDialogCallback() {}
		};
	},

	computed: {
		Config: function Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig;else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig;else return {};
		},
		ActiveTab: function ActiveTab() {
			if (this.crud === 'ticket' && this.$store.state.ticketData.currentDepartmentId) {
				return 'ticket/department/' + this.$store.state.ticketData.currentDepartmentId;
			}

			if (this.crud === 'user' && this.$route.path.indexOf('/user/alerts') === 0 && this.$store.state.user_type !== 'admin') {
				return 'alerts';
			}

			if (this.crud === 'ipptrpool') {
				if (this.$store.state.user_type === 'admin') {
					if (this.$store.state.menuSelectingPreset === 'admin_view_ipptrpool') return 'ipptrpool';else return 'ippool';
				}
			}

			if (this.crud === 'iphistory') {
				return 'ippool';
			}

			return this.crud;
		},
		mobileShowUpperTab: function mobileShowUpperTab() {
			if (this.crud === 'ticket') {
				if (this.ActiveTab && this.ActiveTab in this.tabs && this.tabs[this.ActiveTab]) return this.tabs[this.ActiveTab];
			}

			return this.tabs[this.crud];
		}
	},

	methods: {
		clickOnSideMenu: function clickOnSideMenu(e) {
			this.getWindowWidth(e);
		},
		toggleSideMenu: function toggleSideMenu() {
			this.sideMenuVisible = !this.sideMenuVisible;
		},
		exitFromApp: function exitFromApp() {
			var _this = this;

			this.confirmModalDialogTitle = 'main/logout';

			this.confirmModalDialogText = this.localeFtc('main/logout_request');

			this.confirmModalDialogCallback = function () {
				return _this.exitFromAppProcess();
			};

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-disable');
			this.showConfirmModalDialog = true;
		},
		exitFromAppProcess: function exitFromAppProcess() {
			var _this2 = this;

			if (this.crud === 'ticket' && this.$store.state.ticketData.ticketViewId) {
				__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.setTicketStatus('done-post'), this.setTicketStatus('done-view')]).then(function () {
					return _this2.clearAndGotoLogin();
				}, function () {
					return _this2.clearAndGotoLogin();
				});
			} else this.clearAndGotoLogin();
		},
		setTicketStatus: function setTicketStatus(status) {
			var _this3 = this;

			if (!this.$store.state.ticketData.ticketViewId) return;

			var _url = this.APIServerUrl + '/ticket/view/' + this.$store.state.ticketData.ticketViewId + '?additional=setState&state=' + status;

			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this3.$http.get(_url).then(function (resGet) {
					var _dt = resGet && resGet.data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(resGet.data) === 'object' ? resGet.data : false;

					if (_dt && _dt['status'] === 'ok') resolve('yes');else if (_dt && _dt['_csrf']) resolve('csrf');else reject(resGet);
				}, function (resGet) {
					return reject(resGet);
				});
			});
		},
		clearAndGotoLogin: function clearAndGotoLogin() {
			var _this4 = this;

			this.$store.commit('setTicketViewId', false);

			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-remove-all');

			this.$store.commit('changedForm', false);

			this.forms_GetThenPost('/logout', false, function (data) {
				_this4.$store.commit('dropAuth');
				_this4.$router.push('/login');
			}, function (data) {
				_this4.$router.push('/');
			});
		},
		isTabActive: function isTabActive(idx) {
			if (this.crud === 'ticket') {
				if (idx === 'ticket') {
					if (this.$store.state.ticketData.currentDepartmentId) return false;else return true;
				}

				if (idx === 'ticket/department/' + this.$store.state.ticketData.currentDepartmentId) return true;

				return false;
			}

			return this.crud === idx;
		},
		counterTicketTab: function counterTicketTab(idx) {
			if (this.crud !== 'ticket' && this.crud !== 'qa') return false;

			if (idx === 'ticket') return this.$store.state.ticketData && this.$store.state.ticketData.counters && this.$store.state.ticketData.counters.all ? this.$store.state.ticketData.counters.all : false;

			var _match = idx.match(/ticket\/department\/(\d+)/i);
			if (!_match || !_match[1]) return false;
			var _id = parseInt(_match[1]);
			if (!_id || isNaN(_id)) return false;

			return this.$store.state.ticketData && this.$store.state.ticketData.counters && this.$store.state.ticketData.counters[_id] ? this.$store.state.ticketData.counters[_id] : false;
		},
		markActiveLeftMenu: function markActiveLeftMenu(path) {
			var _this5 = this;

			if (this.$refs) {
				for (var r in this.$refs) {
					if (this.$refs[r] && this.$refs[r][0] && this.$refs[r][0].$el) this.$refs[r][0].$el.className = '';
				}
			}

			var _urlParts = path.substr(path.charAt(0) === '/' ? 1 : 0).split('/');

			if (_urlParts.length < 2 || !_urlParts[0] || !_urlParts[0].length) {
				if (_urlParts[0] !== 'options' && _urlParts[0] !== '404' && _urlParts[0] !== '500' && _urlParts[0] !== '503' && _urlParts[0] !== 'unsubscribe') {
					if (this.$store.state.isDebug) window.DEBUG.error('задан некорректный путь');
					return;
				}
			}

			var _ref = _urlParts[0];

			this.crud = _ref;

			if (this.crud !== 'ticket' || _urlParts[1] !== 'list' && _urlParts[1] !== 'department') __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-remove-all');

			if (this.crud !== 'ticket' || _urlParts[1] !== 'view') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-del-special', 'view');
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-del-special', 'post');
			}

			for (var m in this.Config.leftMenu) {
				var menu = this.Config.leftMenu[m];

				if (menu && menu['tabs'] && menu['tabs'][_ref]) {
					var _ret = function () {
						_this5.tabs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, menu['tabs']);

						var _find = '_' + m + '_list';

						if (path === '/bonus/convert') _find = '_bonus_convert';
						if (path === '/dashboard/info') _find = '_dashboard_info';
						if (_this5.$store.state.user_type !== 'admin' && (path.indexOf('/user/list') === 0 || path.indexOf('/logs/list') === 0 || path.indexOf('/request/list') === 0 || path === '/options' || path.indexOf('/user/alerts') === 0)) _find = '_dashboard_info';
						if (_this5.crud === 'ticket') _find = 'ticket';
						if (path === '/qa/list') _find = 'ticket';
						if (path.indexOf('/dns/list') === 0 || path.indexOf('/dns/view') === 0 || path.indexOf('/person/list') === 0) _find = '_domains_list';
						if ((path.indexOf('/dns/list') === 0 || path.indexOf('/dns/view') === 0) && (_this5.AppName === 'macloud' || _this5.AppName === 'vdsina.com')) _find = '_dns_list';

						_this5.$nextTick(function () {
							for (var _r in _this5.$refs) {
								if (_this5.$refs[_r] && _this5.$refs[_r][0] && _this5.$refs[_r][0].$el) {
									if (_r === _find) _this5.$refs[_r][0].$el.className = 'w5-left-menu-active';else _this5.$refs[_r][0].$el.className = '';
								}
							}
						});

						return {
							v: void 0
						};
					}();

					if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
				}

				if (m === 'domains' && _ref === 'dns-records' || m === 'template' && _ref === 'iphistory' || m === 'template' && _ref === 'ipptrpool' || m === 'logs' && _ref === 'ipptrpool' || m === 'dashboard' && _ref === 'ipptrpool') {
					var _ret2 = function () {
						var _find = '_domains_list';
						if (m === 'template') _find = '_template_list';
						if (m === 'dashboard') _find = '_dashboard_info';
						if (m === 'logs') {
							if (_this5.$store.state.menuSelectingPreset === 'admin_view_ipptrpool') _find = '_logs_list';else _find = '_template_list';
						}

						_this5.$nextTick(function () {
							for (var _r2 in _this5.$refs) {
								if (_this5.$refs[_r2] && _this5.$refs[_r2][0] && _this5.$refs[_r2][0].$el) {
									if (_r2 === _find) _this5.$refs[_r2][0].$el.className = 'w5-left-menu-active';else _this5.$refs[_r2][0].$el.className = '';
								}
							}
						});

						return 'break';
					}();

					if (_ret2 === 'break') break;
				}
			}

			this.tabs = {};

			if (/\/user\/alerts\/\d+/i.test(path)) {
				this.tabs[this.crud] = 'main/email_subs_mini';
			} else if (path === '/404' || path === '/500' || path === '/503') {
				this.tabs[this.crud] = 'menu/cp';
			} else if ((_ref === 'ipptrpool' || _ref === 'iphistory') && this.$store.state.user_type === 'admin' && this.Config.leftMenu && this.Config.leftMenu['template'] && this.Config.leftMenu['template']['tabs']) {
					if (this.$store.state.menuSelectingPreset === 'admin_view_ipptrpool') {
						this.tabs[this.crud] = this.crud + '/title';
					} else {
						this.tabs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.Config.leftMenu['template']['tabs']);
					}
				} else this.tabs[this.crud] = this.crud + '/title';
		},
		openMibileTabsMenu: function openMibileTabsMenu() {
			if (!this.tabs || this.tabs.length <= 1) return;
			this.mobileTabsMenuShow = true;
		},
		hideMibileTabsMenu: function hideMibileTabsMenu() {
			this.mobileTabsMenuShow = false;
		},
		addTicketNotification: function addTicketNotification(parts) {
			if (!parts || !Array.isArray(parts) || parts[1] !== 'ticket' || !parts[2]) return;

			var _id = parseInt(parts[2]);
			if (!_id || isNaN(_id) || _id <= 0) return;

			var _title = parts.slice(3).join(' ');

			if (parts[0] === 'update') {
				__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-notificator-add', {
					'title': 'ticket/updated',
					'message': _title,
					'class': 'info',
					'type': 'ticket',
					'id': _id
				});
			}
		},
		pushMessageHandler: function pushMessageHandler(msg) {
			var _this6 = this;

			var _parts = msg.split(' ');

			if (_parts && _parts[1] === 'ticket') {
				var _ticketId = _parts[2];

				if (_parts[0] === 'update' && _ticketId) {
					this.$store.dispatch('getTicketCounters', true);

					if (!this.$store.state.ItIsMe) this.addTicketNotification(_parts);

					this.$nextTick(function () {
						_this6.$store.commit('ItIsMe', false);
					});
				}

				if ((_parts[0] === 'view' || _parts[0] === 'post') && _parts.length === 3 && _ticketId) {
					if (this.$route.path.indexOf('/ticket/view/' + _ticketId) >= 0) {
						this.$store.commit('getTicketState', _ticketId);
					}
				}

				return;
			}

			if (_parts && _parts[1] === 'request') this.$store.dispatch('getRequestCounter', true);

			if (!_parts || _parts.length < 3) return;

			if (this.$store.state.user_type !== 'client') return;

			if (_parts[0] !== 'update' || _parts[1] !== 'operation') return;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].APIServerUrl + '/operation/view/' + _parts[2]).then(function (response) {
				if (response.data && response.data.status === 'ok') {
					_this6.$store.commit('getUserData');

					if (response.data.operation && response.data.operation.operation_status && 'value' in response.data.operation.operation_status && response.data.operation.operation_status.list && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(response.data.operation.operation_status.list) === 'object') {
						if (response.data.operation.operation_status.list[response.data.operation.operation_status.value] === 'operation/status_paid') {
							__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-redirect', {
								id: _parts[2],
								url: '/operation/list'
							});
						}
					}
				}
			});
		},
		makeTabUrl: function makeTabUrl(idx, tab) {
			if (idx === 'alerts' && tab === 'main/email_subs_mini' && this.$store.state.user_type !== 'admin') return '/user/alerts';
			if (idx === 'service' || idx === 'ticketmessage') return this.$route.path;
			if (/^ticket\/department\/\d+$/i.test(idx)) return '/' + idx;
			if (idx === 'bonus' && this.$store.state.user_type !== 'admin') return '/bonus/convert';
			if (idx === 'unsubscribe' && tab === 'unsubscribe/title') return this.$route.path;
			if (idx === 'dashboard' && tab === 'main/my_account_info' && this.$store.state.user_type !== 'admin') return '/dashboard/info';
			if (idx === 'dns-records' && tab === 'dns-records/title') {
				if (this.$store.state.domainRecordId) return '/dns/view/' + this.$store.state.domainRecordId;else return '/dns/list';
			}
			if (idx === 'email' && tab === 'email/title') return this.$route.path;
			if (idx === 'ipptrpool' && tab === 'ipptrpool/title') return this.$route.fullPath;

			if (this.$store.state.user_type === 'admin') {
				if (idx === 'dashboard' && tab === 'main/my_account_info') return this.$route.path;
			}

			return '/' + idx + (idx === 'options' || idx === '404' || idx === '500' || idx === '503' ? '' : '/list');
		},
		GoToOperation: function GoToOperation(where) {
			if (this.$store.state.user_type !== 'client') return;

			this.showBalanceData = false;
			this.clickOnSideMenu();

			var _obj = {
				'crud': 'operationClientPurse',
				'object': where
			};

			this.$store.commit('setCrudFilter', _obj);

			if (this.$route.path !== '/operation/list') this.$router.push('/operation/list');else __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-push', 'reload operation list');
		},
		ticketDepartmentsHandler: function ticketDepartmentsHandler() {
			if (this.$store.state.user_type !== 'admin' || this.crud !== 'ticket') return;

			this.tabs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.adminConfig.leftMenu.ticket.tabs);
		},
		createVdsByClient: function createVdsByClient(e) {
			this.clickOnSideMenu(e);
			this.$router.push('/vds/create');
		},
		documentKeyDown: function documentKeyDown(e) {
			if (!e || !e.keyCode) return;
			if (e.keyCode === 27) {
				if (this.showBalanceData) this.showBalanceData = false;
				if (this.showConfirmModalDialog) this.hideConfirmModalDialog();
			}
		},
		documentScroll: function documentScroll() {
			this.showBalanceData = false;
		},
		documentClick: function documentClick() {
			this.showBalanceData = false;
		},
		hideConfirmModalDialog: function hideConfirmModalDialog() {
			__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$emit('w5-body-scroll-enable');
			this.showConfirmModalDialog = false;
			this.hideModalMask();
		}
	},
	created: function created() {},
	mounted: function mounted() {
		this.$nextTick(function () {
			this.markActiveLeftMenu(this.$route.path);

			window.addEventListener('resize', this.getWindowWidth);

			this.getWindowWidth();
		});

		document.addEventListener('keydown', this.documentKeyDown);
		document.addEventListener('scroll', this.documentScroll);
		document.addEventListener('click', this.documentClick);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-push', this.pushMessageHandler);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-ticket-departments', this.ticketDepartmentsHandler);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$on('w5-logout', this.exitFromApp);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keydown', this.documentKeyDown);
		document.removeEventListener('scroll', this.documentScroll);
		document.removeEventListener('click', this.documentClick);
		window.removeEventListener('resize', this.getWindowWidth);

		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-push', this.pushMessageHandler);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-ticket-departments', this.ticketDepartmentsHandler);
		__WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* EventBus */].$off('w5-logout', this.exitFromApp);
	},

	watch: {
		'$route': function $route(to, from) {
			this.crud = null;

			this.markActiveLeftMenu(to.path);
		}
	},

	components: {
		notice: __WEBPACK_IMPORTED_MODULE_5__components_elements_notice___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_6__components_elements_money___default.a,
		Lang: __WEBPACK_IMPORTED_MODULE_7__components_elements_lang___default.a
	}

});

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'LanguageComponent',

	props: {
		fixed: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	created: function created() {
		this.onLangClickDebounce = __WEBPACK_IMPORTED_MODULE_1_debounce___default()(this.onLangClick, 500, true);
	},


	computed: {
		lang: function lang() {
			return this.$store.state.lang;
		}
	},

	methods: {
		onLangClick: function onLangClick(lang, event) {
			event.preventDefault();
			__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$emit('w5-on-lang', lang);
		}
	}

});

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang === 'ru' || _vm.lang === 'en') ? _c('div', {
    staticClass: "lang-block",
    class: {
      'fixed': _vm.fixed
    }
  }, [(_vm.lang === 'ru') ? [_c('span', [_vm._v("RU")]), _vm._v("   |   "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function (e) { return _vm.onLangClickDebounce('en', e); }
    }
  }, [_vm._v("EN")])] : _vm._e(), _vm._v(" "), (_vm.lang === 'en') ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function (e) { return _vm.onLangClickDebounce('ru', e); }
    }
  }, [_vm._v("RU")]), _vm._v("   |   "), _c('span', [_vm._v("EN")])] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_auth === true) ? _c('div', [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    staticStyle: {
      "right": "-15px"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('div', {
    staticClass: "navbar-header pull-left"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    class: {
      'taped': _vm.sideMenuVisible
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSideMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-logo-link hidden-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "w5-navbar-logo-img visible-xs",
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w5-navbar-logo-img hidden-xs",
    attrs: {
      "src": _vm.stylePathToLogoText || '/static/img/logo/logo-text.png'
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-header pull-right"
  }, [_c('Lang'), _vm._v(" "), (_vm.$store.state.user_account) ? _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link linkified",
    attrs: {
      "to": "/dashboard/info"
    }
  }, [_c('span', {
    staticClass: "w5-account-info"
  }, [_vm._v(_vm._s(this.$store.state.user_account) + " ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link linkified",
    attrs: {
      "to": "/options"
    }
  }, [_c('img', {
    staticClass: "user-mini-avatar",
    attrs: {
      "src": _vm.APIServerUrl + this.$store.state.user_avatar
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(" " + _vm._s(this.$store.state.user_login))])]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link last-right",
    attrs: {
      "to": "/logout"
    }
  }, [_c('font-awesome-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    attrs: {
      "icon": "lock"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_Loading),
      expression: "form_Loading"
    }],
    staticClass: "pull-left",
    attrs: {
      "src": "/static/img/loading16.gif"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(" " + _vm._s(_vm.localeFtc('main/logout')))])], 1)], 1)])]), _vm._v(" "), (this.$store.state.user_type === 'client') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBalanceData),
      expression: "showBalanceData"
    }],
    staticClass: "mobile-client-balance",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBalanceData = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/real_balance_short')) + ":")]), _vm._v(" "), (_vm.$store.state.user_balance.real !== '') ? _c('span', {
    staticClass: "font-weight-500"
  }, [_c('a', {
    class: {
      'color-red': this.$store.state.user_balance.real < 0
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(this.$store.state.user_balance.real)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/purse_bonus')) + ":")]), _vm._v(" "), (_vm.$store.state.user_balance.bonus !== '') ? _c('span', {
    staticClass: "font-weight-500"
  }, [_c('a', {
    class: {
      'color-red': this.$store.state.user_balance.bonus < 0
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(this.$store.state.user_balance.bonus)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sideMenuVisible),
      expression: "sideMenuVisible"
    }],
    staticClass: "col-sm-2 sidebar"
  }, [(this.$store.state.user_type === 'client' && _vm.isAccess('service/create')) ? _c('span', {
    staticClass: "w5-create-vds-button btn btn-submit full-width font-weight-400 margin-bottom-15 padding-0",
    on: {
      "click": _vm.createVdsByClient
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/create')) + " ")]), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('server/server')))])], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sidebar"
  }, _vm._l((_vm.Config.leftMenu), function(item, what) {
    return (_vm.isAccess(item.link)) ? _c('li', {
      key: what,
      on: {
        "click": _vm.clickOnSideMenu
      }
    }, [_c('router-link', {
      ref: what === 'ticket' ? 'ticket' : item.link.replace(/\//g, '_'),
      refInFor: true,
      attrs: {
        "to": item.link
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t \t" + _vm._s(_vm._f("ftc")(item.title)) + "\n\t\t\t\t\t\t\t \t"), _vm._v(" "), (what === 'ticket' && _vm.$store.state.ticketData && _vm.$store.state.ticketData.counters && _vm.$store.state.ticketData.counters.all && _vm.$store.state.ticketData.counters.all > 0) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v("\n\t\t\t\t\t\t\t \t\t\t" + _vm._s(_vm.$store.state.ticketData.counters.all) + "\n\t\t\t\t\t\t\t \t")]) : _vm._e(), _vm._v(" "), (what === 'request' && _vm.$store.state.requestCounter && _vm.$store.state.requestCounter.all && _vm.$store.state.requestCounter.all > 0) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v("\n\t\t\t\t\t\t\t \t\t\t" + _vm._s(_vm.$store.state.requestCounter.all) + "\n\t\t\t\t\t\t\t \t")]) : _vm._e()])], 1) : _vm._e()
  }), 0), _vm._v(" "), (this.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "w5-client-balance"
  }, [(_vm.$store.state.user_balance.real !== '') ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-aqua",
    on: {
      "click": function($event) {
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": _vm.AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content real-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/real_balance_short')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value for-balance",
    class: {
      'color-red': _vm.$store.state.user_balance.real < 0
    },
    on: {
      "click": function($event) {
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.$store.state.user_balance.real)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "for-balance-currency",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_balance.bonus !== '') ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-aqua",
    on: {
      "click": function($event) {
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": "piggy-bank"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content bonus-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/purse_bonus')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value for-balance",
    class: {
      'color-red': _vm.$store.state.user_balance.bonus < 0
    },
    on: {
      "click": function($event) {
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.$store.state.user_balance.bonus)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "for-balance-currency",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_forecast) ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-gray"
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": "exclamation-circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/forecast')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.$store.state.user_forecast, 'd.m.Y')))]), _vm._v(" "), _c('notice', {
    attrs: {
      "text": _vm._f("ftc")('main/forecast_notice'),
      "small": true
    }
  })], 1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    class: _vm.$store.state.user_type === 'admin' ? 'main-for-admin' : 'main-for-client'
  }, [_c('div', {
    staticClass: "mobile-tabs-button margin-10-0 visible-xs"
  }, [_c('span', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMibileTabsMenu($event)
      }
    }
  }, [(Object.keys(_vm.tabs).length > 1) ? _c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-down"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "h4"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.mobileShowUpperTab)))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [(Object.keys(_vm.tabs).length > 1) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileTabsMenuShow),
      expression: "mobileTabsMenuShow"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideMibileTabsMenu),
      expression: "hideMibileTabsMenu"
    }],
    staticClass: "mobile-tabs-menu"
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return (_vm.isAccess(_vm.makeTabUrl(idx, tab))) ? _c('li', {
      key: idx,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.hideMibileTabsMenu($event)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.makeTabUrl(idx, tab)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(tab))), (_vm.counterTicketTab(idx)) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v(_vm._s(_vm.counterTicketTab(idx)))]) : _vm._e()])], 1) : _vm._e()
  }), 0) : _vm._e()])], 1), _vm._v(" "), (_vm.tabs) ? _c('ul', {
    staticClass: "nav nav-tabs hidden-xs"
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return (_vm.isAccess(_vm.makeTabUrl(idx, tab))) ? _c('li', {
      key: idx,
      class: {
        active: _vm.ActiveTab === idx
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.makeTabUrl(idx, tab)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(tab))), (_vm.counterTicketTab(idx)) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v(_vm._s(_vm.counterTicketTab(idx)))]) : _vm._e()])], 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModalDialog),
      expression: "showConfirmModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalDialogTitle ? _vm.confirmModalDialogTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.confirmModalDialogText),
      expression: "confirmModalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.confirmModalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'unauthPage'
});

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_auth !== true || _vm.$route.path.indexOf('/unsubscribe') === 0 || _vm.$route.path === '/503' || _vm.$route.path === '/user/check' || _vm.$route.path === '/email/check') ? _c('router-view') : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'operationPage',

	data: function data() {
		return {
			topMenuVisible: false
		};
	},

	computed: {
		MainSite: function MainSite() {
			return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].AppServerUrl;
		}
	},
	mounted: function mounted() {
		document.addEventListener('click', this.documentClick);
		window.addEventListener('resize', this.documentClick);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('click', this.documentClick);
		window.removeEventListener('resize', this.documentClick);
	},

	methods: {
		toggleSideMenu: function toggleSideMenu() {
			this.topMenuVisible = !this.topMenuVisible;
		},
		documentClick: function documentClick(e) {
			this.topMenuVisible = false;
		}
	}

});

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$store.state.is_auth && (_vm.$route.path.indexOf('/operation/select/') === 0 || _vm.$route.path.indexOf('/operation/pay/') === 0 || _vm.$route.path.indexOf('/operation/view/') === 0 || _vm.$route.path === '/operation/list')) ? _c('div', [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    staticStyle: {
      "right": "-15px"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand w5-navbar-logo-link",
    attrs: {
      "href": _vm.MainSite
    }
  }, [_c('img', {
    staticClass: "w5-navbar-logo-img visible-xs",
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w5-navbar-logo-img hidden-xs",
    attrs: {
      "src": _vm.stylePathToLogoText || '/static/img/logo/logo-text.png'
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
  }, [_c('router-view')], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-82f686c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_notFound__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_notFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_notFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_crud_error503__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_crud_error503___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_crud_error503__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'errorPage',

	props: ['message', 'code'],
	data: function data() {
		return {
			'Response': false
		};
	},
	created: function created() {
		if (this.code && this.code > 0) this.Response = {
			'status': this.code
		};
	},

	components: {
		notFoundPage: __WEBPACK_IMPORTED_MODULE_0__components_notFound___default.a,
		error503: __WEBPACK_IMPORTED_MODULE_1__components_crud_error503___default.a
	}
});

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.code || _vm.code <= 0) ? _c('div', {
    staticClass: "w5-error-page"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.message)),
      expression: "localeFtc(message)"
    }]
  })])]) : (_vm.code === 404) ? _c('notFoundPage') : _c('error503', {
    attrs: {
      "response": _vm.Response
    }
  })
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-5271b432",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Notificator',

	props: {
		timeout: {
			type: Number,
			default: 60000
		}
	},

	computed: {
		itemsCount: function itemsCount() {
			var count = this.items && this.items.length ? this.items.length : 0;
			if (this.ticketView) count++;
			if (this.ticketPost) count++;

			return count;
		}
	},
	data: function data() {
		return {
			items: [],

			ticketView: false,

			ticketPost: false,

			specialTimers: {
				'view': null,
				'post': null
			},

			audio: null,
			canPlay: false,

			trackNo: 0,

			whatVolume: true
		};
	},
	mounted: function mounted() {
		this.whatVolume = __WEBPACK_IMPORTED_MODULE_1__helper_helper_js__["a" /* default */].normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification);

		if (!('play_audio_on_notification' in this.$store.state.userServerOptions)) this.whatVolume = true;

		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-notificator-add-special', this.addSpecialNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-notificator-del-special', this.delSpecialNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-notificator-add', this.addNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-notificator-remove-all', this.removeAllNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$on('w5-user-options-on-server', this.optionHandler);

		var _name = 'audioNotif_';
		if (['00', '01', '02', '03', '04', '05'].indexOf(this.$store.state.userServerOptions.audio_track_on_notification) > -1) {
			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10);
			_name += this.$store.state.userServerOptions.audio_track_on_notification;
		} else {
			this.trackNo = 0;
			_name += '00';
		}

		this.audio = this.$refs[_name];
		if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-notificator-add-special', this.addSpecialNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-notificator-del-special', this.delSpecialNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-notificator-add', this.addNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-notificator-remove-all', this.removeAllNotificationHandler);
		__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* EventBus */].$off('w5-user-options-on-server', this.optionHandler);

		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);
	},

	methods: {
		remove: function remove(item) {
			var i = this.items.indexOf(item);
			if (i >= 0) this.items.splice(i, 1);
		},
		removeAll: function removeAll() {
			this.ticketView = false;
			this.ticketPost = false;
			this.items = [];
		},
		goTo: function goTo(item, e) {
			if (!item) return;

			if (e.target.id === 'notif-close-button') return;

			if (item['type'] === 'nourl') return;

			var _url = '/' + item['type'] + '/view/' + item['id'];
			if (item['type'] === 'ticket') this.$store.commit('needUpperTab', item['id']);

			this.$router.push(_url);
		},
		closeSpecialNotification: function closeSpecialNotification(what) {
			if (what === 'view') this.ticketView = false;
			if (what === 'post') this.ticketPost = false;
		},
		setVolume: function setVolume() {
			this.$store.commit('toggleAudioNitificationOption');
		},
		setTrack: function setTrack(value) {
			if (this.trackNo === value) return;

			var _name = 'audioNotif_0' + String(value);

			if (this.$refs[_name]) {
				this.trackNo = value;

				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

				this.audio = this.$refs[_name];

				this.audio.addEventListener('canplay', this.audioCanPlay);

				this.audio.currentTime = 0;
				try {
					this.audio.play().catch(function () {});
				} catch (e) {}

				this.$store.commit('setAudioTrackNitificationOption', value);
			}
		},
		addNotificationHandler: function addNotificationHandler(data) {
			var _this = this;

			if (!data || !data.title || data.title === '' || !data.message || data.message === '' || !data.type || !data.id || !data.class) return;

			var item = {
				'title': data.title,
				'message': data.message,
				'class': data.class,
				'type': data.type,
				'id': data.id,
				'timeout': data.timeout,
				'key': Date.now() + '-' + Math.random()
			};

			var _exists = -1;
			this.items.some(function (n, i) {
				if (n['type'] === item['type'] && n['id'] === item['id'] && n['class'] === item['class'] && n['message'] === item['message']) {
					_exists = i;
					return true;
				}
			});

			if (_exists >= 0) this.items.splice(_exists, 1);

			if (this.items.length > 15) {
				this.items.splice(0, 1);
			}

			if (!this.items.length && this.canPlay && item.id !== 'success-message' && this.whatVolume) {
				this.audio.currentTime = 0;
				try {
					this.audio.play().catch(function () {});
				} catch (e) {}
			}

			if (item.id === 'success-message') this.items.unshift(item);else this.items.push(item);

			setTimeout(function () {
				return _this.remove(item);
			}, item.timeout ? item.timeout : this.timeout);
		},
		addSpecialNotificationHandler: function addSpecialNotificationHandler(data) {
			var _this2 = this;

			if (!data || !data.special || data.special === '' || !data.title || data.title === '' || !data.message || data.message === '' || !data.type || !data.class) return;

			var item = {
				'title': data.title,
				'message': data.message,
				'class': data.class,
				'type': data.type,
				'key': Date.now() + '-' + Math.random()
			};

			if (data.special === 'view') this.ticketView = item;else if (data.special === 'post') this.ticketPost = item;

			var _timeout = data.timeout && data.timeout > 0 ? data.timeout : this.timeout;

			if (this.specialTimers[data.special]) clearTimeout(this.specialTimers[data.special]);

			this.specialTimers[data.special] = setTimeout(function () {
				_this2.specialTimers[data.special] = null;
				_this2.closeSpecialNotification(data.special);
			}, _timeout);
		},
		delSpecialNotificationHandler: function delSpecialNotificationHandler(data) {
			this.closeSpecialNotification(data);
		},
		removeAllNotificationHandler: function removeAllNotificationHandler() {
			this.removeAll();
		},
		audioCanPlay: function audioCanPlay() {
			this.canPlay = true;
		},
		optionHandler: function optionHandler() {
			this.whatVolume = __WEBPACK_IMPORTED_MODULE_1__helper_helper_js__["a" /* default */].normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification);

			if (!('play_audio_on_notification' in this.$store.state.userServerOptions)) this.whatVolume = true;

			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10);
			if (isNaN(this.trackNo) || this.trackNo < 0 || this.trackNo > 5) this.trackNo = 0;

			var _name = 'audioNotif_0' + this.trackNo;
			if (this.$refs[_name]) {
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay);

				this.audio = this.$refs[_name];

				this.audio.addEventListener('canplay', this.audioCanPlay);
			}
		},
		normalizeBooleanValue: function normalizeBooleanValue(value) {
			return __WEBPACK_IMPORTED_MODULE_1__helper_helper_js__["a" /* default */].normalizeBooleanValue(value);
		}
	}

});

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-notificator-wrapper"
  }, [(_vm.itemsCount > 1) ? _c('font-awesome-icon', {
    staticClass: "w5-notification-close-all-button",
    attrs: {
      "icon": "times-circle"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeAll($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "w5-notificator"
    }
  }, [(_vm.ticketView) ? _c('div', {
    key: "ticketView",
    staticClass: "w5-notification cursor-pointer-default",
    class: _vm.ticketView.class ? _vm.ticketView.class : false
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "notif-close-button",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeSpecialNotification('view')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketView.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.ticketView.message),
      expression: "ticketView.message"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ticketPost) ? _c('div', {
    key: "ticketPost",
    staticClass: "w5-notification cursor-pointer-default ticket-post",
    class: _vm.ticketPost.class ? _vm.ticketPost.class : false
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "notif-close-button",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeSpecialNotification('post')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketPost.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.ticketPost.message),
      expression: "ticketPost.message"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(notification, idx) {
    return _c('div', {
      key: notification.key,
      staticClass: "w5-notification",
      class: notification.class ? notification.class : false,
      style: (notification.id === 'success-message' ? 'cursor: default' : false),
      on: {
        "click": function($event) {
          return _vm.goTo(notification, $event)
        }
      }
    }, [_c('button', {
      staticClass: "close",
      attrs: {
        "id": "notif-close-button",
        "title": _vm._f("ftc")('main/close')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(notification)
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(notification.title)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(notification.message)))]), _vm._v(" "), (idx === 0 && notification.id !== 'success-message') ? [_c('font-awesome-icon', {
      staticClass: "w5-notification-volume-button pull-right",
      attrs: {
        "id": "notif-volume-button",
        "icon": _vm.whatVolume ? 'volume-up' : 'volume-mute'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setVolume($event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('audio', {
    ref: "audioNotif_00",
    attrs: {
      "src": "/static/snd/notif.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_01",
    attrs: {
      "src": "/static/snd/notif01.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_02",
    attrs: {
      "src": "/static/snd/notif02.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_03",
    attrs: {
      "src": "/static/snd/notif03.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_04",
    attrs: {
      "src": "/static/snd/notif04.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_05",
    attrs: {
      "src": "/static/snd/notif05.mp3"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.appKey,
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? [_c('div', {
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$store.state.lang === 'en' ? 'Authentication check...' : 'Проверка аутентификации...'))])])] : [(_vm.errorMessage !== false) ? _c('errorPage', {
    attrs: {
      "message": _vm.errorMessage,
      "code": _vm.errorCode
    }
  }) : [(_vm.$store.state.is_auth === true && _vm.$route.path.indexOf('/unsubscribe') !== 0 && _vm.$route.path !== '/503' && _vm.$route.path !== '/user/check' && _vm.$route.path !== '/email/check') ? _c('workBoard') : (!_vm.$store.state.is_auth && (_vm.$route.path.indexOf('/operation/select/') === 0 || _vm.$route.path.indexOf('/operation/pay/') === 0 || _vm.$route.path.indexOf('/operation/view/') === 0 || _vm.$route.path === '/operation/list')) ? _c('operationPage') : _c('unauthPage'), _vm._v(" "), (_vm.$store.state.is_auth !== true &&
    (
      _vm.$route.path.indexOf('/unsubscribe') === 0 ||
      _vm.$route.path === '/503' ||
      _vm.$route.path === '/user/check' ||
      _vm.$route.path === '/email/check' ||
      _vm.$route.path === '/operation/list' ||
      _vm.$route.path === '/login' ||
      _vm.$route.path === '/register' ||
      _vm.$route.path === '/forget' ||
      _vm.$route.path.indexOf('/operation/select/') === 0 ||
      _vm.$route.path.indexOf('/operation/pay/') === 0 ||
      _vm.$route.path.indexOf('/operation/view/') === 0
    )) ? _c('Lang', {
    attrs: {
      "fixed": true
    }
  }) : _vm._e()]], _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.longRequest),
      expression: "this.$store.state.longRequest"
    }],
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/loading')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpdatePanelButton),
      expression: "showUpdatePanelButton"
    }],
    staticClass: "w5-cp-update-button"
  }, [_c('div', {
    staticClass: "w5-pulse-inner",
    on: {
      "click": _vm.showUpdateBlock
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-pulse-outter"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpdatePanelMessageBlock),
      expression: "showUpdatePanelMessageBlock"
    }],
    staticClass: "w5-cp-update-warning alert alert-warning"
  }, [_vm._v("\n\t" + _vm._s(_vm.messagesForUpdateBlock[0]) + "\n\t"), _c('span', {
    on: {
      "click": _vm.reloadApp
    }
  }, [_vm._v(_vm._s(_vm.messagesForUpdateBlock[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.applicationBlocked),
      expression: "this.$store.state.applicationBlocked"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/refresh_screen')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.AppName === 'vdsina' || _vm.AppName === 'vdsina.com') ? _c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "src": __webpack_require__(783),
      "align": "left"
    }
  }) : (_vm.AppName === 'macloud') ? _c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "src": __webpack_require__(784),
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/user_idle_state_text')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-small pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])])])])]), _vm._v(" "), (_vm.clientWarnings && _vm.clientWarnings.length && _vm.clientWarnings[0].subject && _vm.clientWarnings[0].content) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper warnings"
  }, [_c('div', {
    staticClass: "modal-container warnings",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.clientWarnings[0].subject)))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.clientWarnings[0].content_type === 'html') ? _c('p', {
    staticStyle: {
      "margin": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.clientWarnings[0].content)
    }
  }) : _c('p', {
    directives: [{
      name: "formatTicketMessage",
      rawName: "v-formatTicketMessage",
      value: ({
        'message': {
          message_content_type: _vm.clientWarnings[0].content_type,
          message_content: _vm.clientWarnings[0].content
        },
        'fastSearchValue': null
      }),
      expression: "{\n\t\t\t\t\t\t'message': {\n\t\t\t\t\t\t\tmessage_content_type: clientWarnings[0].content_type,\n\t\t\t\t\t\t\tmessage_content: clientWarnings[0].content\n\t\t\t\t\t\t},\n\t\t\t\t\t\t'fastSearchValue': null\n\t\t\t\t\t}"
    }],
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "w5-field close-client-warning pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientWarningsCloseValue),
      expression: "clientWarningsCloseValue"
    }],
    staticClass: "w5-checkbox-field",
    attrs: {
      "id": "closeClientWarning",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clientWarningsCloseValue) ? _vm._i(_vm.clientWarningsCloseValue, null) > -1 : (_vm.clientWarningsCloseValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clientWarningsCloseValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clientWarningsCloseValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clientWarningsCloseValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clientWarningsCloseValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "closeClientWarning"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/never_show')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit-danger btn-submut pull-right btn-warn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeWarning($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/close')))]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submut pull-right btn-warn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.gotoWarningTicket($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/ticket')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.is_auth === true && _vm.$route.path.indexOf('/unsubscribe') !== 0 && _vm.$route.path !== '/503' && _vm.$route.path !== '/user/check' && _vm.$route.path !== '/email/check') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserNeedDialogModal),
      expression: "showUserNeedDialogModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideUserNeedDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fieldsUserNeed && _vm.fieldsUserNeed.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogMode === 'password' ? 'user/need_password_change' : 'user/need_email_confirm')))]), _vm._v(" "), (_vm.userNeedDialogMode === 'password') ? _vm._l((_vm.fieldsUserNeed.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row v-center': _vm.isVisibleField(row)
      }
    }, [_vm._l((row), function(field) {
      return [_c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "userneed",
          "action": "update",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurInput(field)
          },
          "focus": function($event) {
            return _vm.onFocusInput(field)
          },
          "enterKeyDown": _vm.submitUserNeedForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })], 2) : _vm._e()
  }) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldEmailError),
      expression: "fieldEmailError"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldEmailError)),
      expression: "localeFtc(fieldEmailError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid email-create",
    attrs: {
      "role": "alert"
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.submitUserNeedForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogMode === 'password' ? 'main/continue' : 'main/confirm')))])])])])]) : _vm._e(), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "modal-scroll-arrow",
    attrs: {
      "id": "modal-scroll-arrow-up",
      "icon": "long-arrow-alt-up"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "modal-scroll-arrow",
    attrs: {
      "id": "modal-scroll-arrow-down",
      "icon": "long-arrow-alt-down"
    }
  }), _vm._v(" "), _c('Notificator'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "for-retina-detection"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioBlock",
    attrs: {
      "src": "/static/snd/block.mp3"
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('div', {
    staticClass: "w5-version-info"
  }, [_vm._v("\n\t" + _vm._s(_vm.clVersion) + "\n\t"), _c('br'), _vm._v("\n\t" + _vm._s(this.$store.state.apiVersion) + "\n")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAIAAAAlC+aJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADQtJREFUeNrsWnlsHNUZn/fm2tnbu7Z3bWfj2HHi2I4dcpEUECEhRIAioCpHaVFbKCAB5Z8KlbZUbaB/lEoVQlRqQZFaFSgVlAYoqBUlNByJUnI7vnLZ8bXeXa/3PmbnfP1mN05sxxvvJk5IVUZjWdo53vf7zt/3vUGEEOp/+cDU//jxFYAv+2CKX9KHJjL7+0P+lDqe0WRNrzBzDlb32Ng2X1WNjXNahcstnKoqkbSsUogipNLC8hx3/j1otiAmu3qDr+8fPjSSjImanr8D/hCiMIKXUWaO8Vpxx4KKNT77+saqJo+NQvNoSTI8kT44GDniT3WPJYOJrEzRRNc9VuYHNzXd1rFgDgCSov7ivc6/dk6oOuFZTIPU569AKLiqGNAopwkvr7FuWlq5sbl6sdd5KXKfDMQ/Pznx8YmJE+OZ8YwKL6dpxGBQGkiIJE23sGj7N9uvb665EIAPDg898XYvz9Kzij6LnxFKUnVN110CvXqB/Y4O7/pGt7fCVrrcg6HE3tPRD7qCXcF0NKsxNOZoTM9m0bSk3d7ievmBtWiKbDNjYM9AlBBUovRGEkCUwMJqWFTJx/2JXaditQ5urc+xublydYO7xmmZ1bskWTkRjHeOJj85Ee4MpMNp8HMEcttMF4hJimdwXzAZS2VddktRAIRmSxZ+2kFjZMaIUDiU0XZ0T7zXHa5z8E1u05pFrnonV2kTQG2xTG4io3SNpfoCyYGYnFHAfiA3MsFfKcrCKKfoWUV3XSALIV29lAAEOViMWI4Gvwxl1JFkatdAAqQDV4ZrEDVw6pTh2SzIzdJo3tOok6PmhVqAZAwGQeE/Nl6YfylmKDZ/6SLDnFBgqhnWmumgy31uUM/80iNYENwS5VPwpagcrOcw8w4zdyEAjVU2M0NdnQQPvK/WKcwoZzMB1Ni5ahsHab6oHSmKfGkAqGY3PwcXclrNzdUWVdOL+oOmyJKUlrWcqusEXUkAsNjSGufcZG5Fnb2YjkVZe3ht9R8fWPHoGvc11TxHpIykZGVgSgbVuKzSa0bVRy1e29xkbuXCCp4+DfbC00WC9GdltDtWLVpSV7mh1Ud0rW8k3BNI7z4R6hkXh2KiRBhI9jzL0Gj+vQycwucWfC7L3AAWV1pqHSZ/QsbTE5asais8pgbPGSMiTLfWe1vrqXvWN8WTqYGJzO7jgSNj6WPBdELBOppnog5h2eYxm3hubgCVDktDBT8Uk6bXGaRq2o1NHoaZ5RGn3bYKzkYvRHjP6bFH3zgakjE7fxCI4etkVb2r1IamrdYxIxEB83SyZEtb7RyJQtNf2TM8lptP6Y3X6pSNwx119lIbmvY6O4dJoQc4m8JcJjQeT2ZzuQI0uAJcxiXgpnrf2YV+/f7hHd1RmwDJzshQBlElRGCZS8y9kPCWVpoWVTtKBdDoNlt4RlLJWVrKYGpcZr7/1nEyKT2kBVWRtt+zrKn+zFOvfdb3yhdBi2AqiCuq+tdq+Sor825vguM4Bl9SALRUWwSOLdWF6qvsUNG0mVpDiOEwa5yE4WSCf3Zb8y1rWwvXdvcO/WrnIMvzOC89PGvB2jO3t774rfXbttQLSAYWeSkBsHaRq4ymHpi3z8aeX4/PkhlRUh5b73l4Y0vh9/6xiaff6REJw5wxGMpKynfWeNvqqxHNPLhx+WvfXb2qmknlFL18VwKbWzh6mddazlQCYUiX0GfNejElKvctdz51W3vh8UQq/dTbR0ay2DTpJTlVa6/intjccq44Nnhff/i6x9Z5NEWSNFKu//ic3JIi/WpRxzSqGTo/9FAyp9y+xPLLb6xmWcMjZUV9Zsfh/QEFlHQ23HmkbdvaYhGmjS0sZuGZu1a/fF/7AguUFL0sAI0uQeDZ8gBUCphBM/0nLanXLTC/cP86wXSGVG3/6MhfDgWhAGcVTVR0EAxu42m8szew/6RfluUZr93cUf/2I+uaK7Bcmh3yvYS+xggAVN5cyOMws3Q+ICcfzKr6Mjf70v2rbGbT2ds2Lfc1+6qHotnOgVBIQsGUCo2YRDGv7Au/eiDU6hG2NLs3tdYtrXOf7cSPBRP+lEJjttRmFVE1NrbswRbQUprGqkE4jYUhhdQI1It3L69xTasmLQs9Zzx9QzNgffWT7p//axjMDVkYqkjnuPr50MhHPWN/fmyjYDJgD4WiT7/bl9IYni6thGmk2sa3LXCXPVo0KNmk8sFhWV169taGtnpPkURhWAro3a6TUQrTky5HQOn1drzt6ysL0qdF8Sc7Ov0ZYiq5GYalQftuK1+2BawcXWFmAkmgdPnsSbMvfTq4dyC6odmzttFjsZinFwhDoP5A7MBoimf4guuqhGKI8vydLR2LvAWYv/nH0c+GRZuJIyUXZpUQt4UTOFw2gPxUDJ0NX4JwX4zqHI++fniiwXH8hsUVG5ZWr1xUZbedS88fdvvjMrKaSD4XIVnKPbtl0S0rGgtX/7b3xJ8OhC0m01RaIeuGD9C4EB9kNhZElngdGDNlA8hIWjKnTW0JIE9yNAuL9KepvgOR1w6FG5zMDY0Vm9tqO3wuq4nbeXyiwFWJUcikx9fXfG9jW+HZg6fGnvuwn+Y4PCkl3MNQWoNZTyooLsqwFEUbaS8/mUNTvdNjZS9mOg2lFDIjOm/Khc4hQf0p0ncw+urB8WXVwrJK/mRE5hlYjEC2vaul4kdbVxRSmKZpv9vZE05LLI8VSLLG3NKgtyZaf+nedqsgjCfFwUh6IJwZiaROJ7QTMY2e1Bz8N9PkYgBEkhld11HxvgRiNI8Esg3bG9W7whnBIGwE2uV1Xua5Oztompn0Rvq5u9c+FE4dC8S7R2P7/LmwhAoeYxMEn9e90EutmXztH/7dve2jYYuJnYwuyi5clAWCCVHRdK4EXg9IjKJtqBUYKKm3Ui/ct9rlmEZd6iqdcF7f4iOqdMdvPw0Abcrr2B9LI4aBdtFu5l02syTLf+8K0dN6JuhR6YsBMJbWIPdz5ZAWuL9aQL//9up6T0Wxe949NNwVVkw8D7BFnXnynZNQaDLZ3PNbl9y5rvlAf6grJPK8qfT+oaiCByMZiipvzqupyl2tTq/dlMlmZ70BmMUb+0Yomi2QLPhLSHoorS12cTe3L4Qf3u8cVajpFIwQUVbLtgDR9cFwiilz9spz7BtdiTcPf1rr4BdWWn1WtKzWvcRjr7LxlXYzy3F7jvkPjmVNUxSMMeKI/MOb26xmwR+O/bMvolEs0CR+crABhQxIeNkAwP9Hkipd/qBd0YiMTMfjpDuSADXQOM4SFdrO2gpLowP3jYvQEk1VcFbWbm1y3LQc1E9Fk+llHqvJxEcz0vGwROc3OeBWUcNlAzgZjMFbaEyXCyA/wS1kJ3iWzkvARFQqFMwdGCOQpfgpMyMg3jZGf3LTEpxfqH2x783HF8ATP31zf2dQtJzZpUET2fJdqD8iZRVi4ahLPwAP1CdmsteZ4t1IUuQHr61ur3cTTUH5SwjjA6cCO7onBJabrAPomD+mayqmmTIAfDEwfmYcfjkPaBu6xpIPbd+jn0spZCguq4hl0bmNn0gWSqpupUu2ADRZgzGZwZd7cEswTe8NzGy885s303auwqLuj2aaa7lS0+ixQOJEKM3QV2ITH0JCYKadMyonqDGeVaCEl1EH9g9GUwqhr+jk/MJdJeqPiGUAODAcR1eN9PntKbT/dASSckkAgrH0UX+So6+ij0Cgno4klLFYpiQAR0bjwbRKY3QVAcAokJQgMksCAE2jcoV3jkrwIpVCB4fjcwPI5KROf5Khr7qPiKCc7RuMQWM0BwB/XDo1kWUxutoAgEgnI+JgODkHgM4h6Pv0i5Of5LkNNIpQmSTtzAncDn7RyaXuzIIFoEHvC6bmqMSjcVEvZy2SH1yqmvEFBIMID2WIpm08dpmN3hJCCRq08bSiaJqiEtlIgwjSA3gojTEup9uAOxWCDg5Gtl6z8EIAJK0k8UGj0G0Ca2exXmM3LXHxjVXW9jp7jY2rcpgrbWbBmCsY+zuyqgfjmWhKjGaV0aR8KpSETjWU0UFToqLLuoGHMSChOc0Ot/WGRGjT89iLADA2loozOJBb1nTQt5Wl2r2WVQts6xvdHXXOGpe12OSVZ6Ft56iaqR0mSYnycDg5mpCOjsR6gilgvkDdU7LxCugB2CJgAORYMhdPi1M/FqJmfLEViGfu3b5vOC6bp0zCVB30rYGT2Hnc4rHcuLjixqWe1hoHx7HzEqCxVHYomjk6mugcifeEsmCcpGzkcfB7KGHQVBU8DcRwcmTHo9f6qpxFAcDxn4GJH7/TNRSTIPiMT/wQrjbjFb6Ka32265qqmr32Yrx8Xg4xJw1Gs73+eE8g1RtKj0SzEZFIqvF1nqTqK2stbz2yfupsnJr1q8VoOrf7eCCcEq082+Bx1rvMHqeZoq50biW6Fk7lIAcMBKPjSWNzalNLTXPtzJ0y9NW3018B+D8H8F8BBgBzmPdvbwdkxAAAAABJRU5ErkJggg=="

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })
],[271]);


// WEBPACK FOOTER //
// static/js/app.5c83eb60b5c5452fdc47.js